var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop))
      __defNormalProp(a2, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop))
        __defNormalProp(a2, prop, b2[prop]);
    }
  return a2;
};
var __spreadProps = (a2, b2) => __defProps(a2, __getOwnPropDescs(b2));
var __objRest = (source2, exclude) => {
  var target = {};
  for (var prop in source2)
    if (__hasOwnProp.call(source2, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source2[prop];
  if (source2 != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source2)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source2, prop))
        target[prop] = source2[prop];
    }
  return target;
};
var _e;
import * as React$2 from "react";
import React__default, { forwardRef, createElement, useContext, useState, useRef, useEffect, useMemo, useLayoutEffect, createContext, useReducer, Fragment as Fragment$1, Component, useCallback, useImperativeHandle, memo } from "react";
var index$2 = "";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getAugmentedNamespace(n2) {
  if (n2.__esModule)
    return n2;
  var a2 = Object.defineProperty({}, "__esModule", { value: true });
  Object.keys(n2).forEach(function(k2) {
    var d2 = Object.getOwnPropertyDescriptor(n2, k2);
    Object.defineProperty(a2, k2, d2.get ? d2 : {
      enumerable: true,
      get: function() {
        return n2[k2];
      }
    });
  });
  return a2;
}
var classnames$1 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(module) {
  (function() {
    var hasOwn = {}.hasOwnProperty;
    function classNames2() {
      var classes2 = [];
      for (var i2 = 0; i2 < arguments.length; i2++) {
        var arg = arguments[i2];
        if (!arg)
          continue;
        var argType = typeof arg;
        if (argType === "string" || argType === "number") {
          classes2.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames2.apply(null, arg);
            if (inner) {
              classes2.push(inner);
            }
          }
        } else if (argType === "object") {
          if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
            classes2.push(arg.toString());
            continue;
          }
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes2.push(key);
            }
          }
        }
      }
      return classes2.join(" ");
    }
    if (module.exports) {
      classNames2.default = classNames2;
      module.exports = classNames2;
    } else {
      window.classNames = classNames2;
    }
  })();
})(classnames$1);
var classNames$1 = classnames$1.exports;
var IconName;
(function(IconName2) {
  IconName2["ARROW_LEFT"] = "ARROW_LEFT";
  IconName2["BACK"] = "BACK";
  IconName2["CHECK"] = "CHECK";
  IconName2["CIRCLE_CHECK"] = "CIRCLE_CHECK";
  IconName2["CIRCLE_CHECK_OUTLINE"] = "CIRCLE_CHECK_OUTLINE";
  IconName2["CIRCLE_EXCLAMATION"] = "CIRCLE_EXCLAMATION";
  IconName2["CIRCLE_EXCLAMTION_SOLID"] = "CIRCLE_EXCLAMTION_SOLID";
  IconName2["CIRCLE_PLAY"] = "CIRCLE_PLAY";
  IconName2["CLEAR"] = "CLEAR";
  IconName2["CLOSE_CIRCLE"] = "CLOSE_CIRCLE";
  IconName2["CLOSE"] = "CLOSE";
  IconName2["DELETE"] = "DELETE";
  IconName2["DISCORD"] = "DISCORD";
  IconName2["DOWN"] = "DOWN";
  IconName2["DOWNLOAD"] = "DOWNLOAD";
  IconName2["EDIT"] = "EDIT";
  IconName2["EYE"] = "EYE";
  IconName2["FACEBOOK"] = "FACEBOOK";
  IconName2["FILTER"] = "FILTER";
  IconName2["IMAGE"] = "IMAGE";
  IconName2["INFO"] = "INFO";
  IconName2["INFORMATION_CIRCLE"] = "INFORMATION_CIRCLE";
  IconName2["LOADING"] = "LOADING";
  IconName2["LOGOUT"] = "LOGOUT";
  IconName2["NEXT"] = "NEXT";
  IconName2["OPTIONS"] = "OPTIONS";
  IconName2["OUTLINE_CHECK_CIRCLE"] = "OUTLINE_CHECK_CIRCLE";
  IconName2["OUTLINE_X_CIRCLE"] = "OUTLINE_X_CIRCLE";
  IconName2["PHOTO"] = "PHOTO";
  IconName2["PLUS"] = "PLUS";
  IconName2["QUESTION_MARK"] = "QUESTION_MARK";
  IconName2["REFRESH"] = "REFRESH";
  IconName2["REMOVE_GALLERY"] = "REMOVE_GALLERY";
  IconName2["SEARCH"] = "SEARCH";
  IconName2["SETTING"] = "SETTING";
  IconName2["STORE"] = "STORE";
  IconName2["STORE_NFT"] = "STORE_NFT";
  IconName2["TELEGRAM"] = "TELEGRAM";
  IconName2["TRASH"] = "TRASH";
  IconName2["TWITTER"] = "TWITTER";
  IconName2["WALLET"] = "WALLET";
  IconName2["UP"] = "UP";
  IconName2["UPLOADER"] = "UPLOADER";
  IconName2["ADD_PHOTO"] = "ADD_PHOTO";
  IconName2["PENCIL_OUTLINE"] = "PENCIL_OUTLINE";
  IconName2["CHREVRON_UP_OUTLINE"] = "CHREVRON_UP_OUTLINE";
  IconName2["CHECK_CIRCLE_ICON"] = "CHECK_CIRCLE_ICON";
  IconName2["CREDIT_CARD_ICON"] = "CREDIT_CARD_ICON";
})(IconName || (IconName = {}));
var IconSize;
(function(IconSize2) {
  IconSize2["EXTRA_SMALL"] = "extra-small";
  IconSize2["SMALL"] = "small";
  IconSize2["DEFAULT"] = "default";
  IconSize2["MEDIUM"] = "medium";
  IconSize2["LARGE"] = "large";
  IconSize2["EXTRA_LARGE"] = "extra-large";
  IconSize2["CUSTOM"] = "custom";
})(IconSize || (IconSize = {}));
const ICON_STROKE_SIZE = {
  "extra-small": 10,
  small: 12,
  default: 16,
  medium: 20,
  large: 30,
  "extra-large": 100
};
var jsxRuntime$1 = { exports: {} };
var reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$e = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i2 = 0; i2 < 10; i2++) {
      test2["_" + String.fromCharCode(i2)] = i2;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
      return test2[n2];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function(letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function(target, source2) {
  var from2;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from2 = Object(arguments[s]);
    for (var key in from2) {
      if (hasOwnProperty$e.call(from2, key)) {
        to[key] = from2[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from2);
      for (var i2 = 0; i2 < symbols.length; i2++) {
        if (propIsEnumerable.call(from2, symbols[i2])) {
          to[symbols[i2]] = from2[symbols[i2]];
        }
      }
    }
  }
  return to;
};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f$1 = React__default, g$1 = 60103;
reactJsxRuntime_production_min.Fragment = 60107;
if (typeof Symbol === "function" && Symbol.for) {
  var h$1 = Symbol.for;
  g$1 = h$1("react.element");
  reactJsxRuntime_production_min.Fragment = h$1("react.fragment");
}
var m$2 = f$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n$1 = Object.prototype.hasOwnProperty, p$1 = { key: true, ref: true, __self: true, __source: true };
function q$1(c2, a2, k2) {
  var b2, d2 = {}, e2 = null, l2 = null;
  k2 !== void 0 && (e2 = "" + k2);
  a2.key !== void 0 && (e2 = "" + a2.key);
  a2.ref !== void 0 && (l2 = a2.ref);
  for (b2 in a2)
    n$1.call(a2, b2) && !p$1.hasOwnProperty(b2) && (d2[b2] = a2[b2]);
  if (c2 && c2.defaultProps)
    for (b2 in a2 = c2.defaultProps, a2)
      d2[b2] === void 0 && (d2[b2] = a2[b2]);
  return { $$typeof: g$1, type: c2, key: e2, ref: l2, props: d2, _owner: m$2.current };
}
reactJsxRuntime_production_min.jsx = q$1;
reactJsxRuntime_production_min.jsxs = q$1;
{
  jsxRuntime$1.exports = reactJsxRuntime_production_min;
}
const jsx$1 = jsxRuntime$1.exports.jsx;
const jsxs = jsxRuntime$1.exports.jsxs;
const Fragment = jsxRuntime$1.exports.Fragment;
var jsxRuntime = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  jsx: jsx$1,
  jsxs,
  Fragment
}, Symbol.toStringTag, { value: "Module" }));
function ArrowLeftIcon$2({
  style,
  className = "",
  viewBox = "0 0 21 18",
  height,
  width
}) {
  return /* @__PURE__ */ jsx$1("svg", {
    className,
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      d: "M19.6875 7.7152H4.12125L8.88563 2.10999C9.10841 1.84745 9.21559 1.50898 9.18359 1.16903C9.15159 0.829086 8.98303 0.515513 8.715 0.297298C8.44697 0.0790819 8.10141 -0.0259025 7.75435 0.00544001C7.40729 0.0367826 7.08716 0.201885 6.86437 0.464426L0.301875 8.17802C0.257723 8.23937 0.218242 8.30383 0.18375 8.37086C0.18375 8.43514 0.18375 8.47371 0.0918752 8.53799C0.0323842 8.68539 0.00123522 8.8423 0 9.0008C0.00123522 9.1593 0.0323842 9.31621 0.0918752 9.46362C0.0918752 9.5279 0.0918748 9.56647 0.18375 9.63075C0.218242 9.69778 0.257723 9.76223 0.301875 9.82359L6.86437 17.5372C6.98778 17.6823 7.14231 17.799 7.31699 17.879C7.49166 17.959 7.68218 18.0003 7.875 18C8.18167 18.0006 8.47887 17.896 8.715 17.7043C8.8479 17.5964 8.95776 17.4638 9.03829 17.3143C9.11881 17.1647 9.16842 17.001 9.18427 16.8326C9.20012 16.6643 9.1819 16.4945 9.13065 16.333C9.0794 16.1715 8.99614 16.0215 8.88563 15.8916L4.12125 10.2864H19.6875C20.0356 10.2864 20.3694 10.151 20.6156 9.90986C20.8617 9.66876 21 9.34177 21 9.0008C21 8.65984 20.8617 8.33284 20.6156 8.09175C20.3694 7.85065 20.0356 7.7152 19.6875 7.7152Z"
    })
  });
}
const BackIcon = (props) => {
  const {
    color = "transparent",
    style,
    className = "",
    viewBox = "0 0 24 24",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      d: "M15 19.6923L8 12.6923L15 5.69232",
      strokeWidth: "2",
      stroke: "#121419",
      fill: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
function CheckIcon({
  style,
  className = "",
  viewBox = "0 0 48 48",
  height,
  width
}) {
  return /* @__PURE__ */ jsx$1("svg", {
    className,
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M 34.480469 14.1875 C 35.515625 13.152344 37.191406 13.152344 38.226562 14.1875 C 39.257812 15.222656 39.257812 16.898438 38.226562 17.929688 L 22.34375 33.8125 C 21.308594 34.847656 19.632812 34.847656 18.597656 33.8125 L 9.773438 24.988281 C 8.742188 23.957031 8.742188 22.28125 9.773438 21.246094 C 10.808594 20.210938 12.484375 20.210938 13.519531 21.246094 L 20.46875 28.199219 Z M 34.480469 14.1875"
    })
  });
}
const CircleCheckIcon = (props) => {
  const {
    style,
    className = "",
    viewBox = "-5 -5 25 25",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(className, {
      "tw-fill-Black": !className.includes("tw-fill")
    }),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 0.5C5.71442 0.5 4.45772 0.881218 3.3888 1.59545C2.31988 2.30968 1.48676 3.32484 0.994786 4.51256C0.502816 5.70028 0.374095 7.00721 0.624899 8.26809C0.875703 9.52896 1.49477 10.6872 2.40381 11.5962C3.31285 12.5052 4.47104 13.1243 5.73192 13.3751C6.99279 13.6259 8.29973 13.4972 9.48744 13.0052C10.6752 12.5132 11.6903 11.6801 12.4046 10.6112C13.1188 9.54229 13.5 8.28558 13.5 7C13.498 5.2767 12.8126 3.62456 11.594 2.40601C10.3754 1.18745 8.7233 0.501992 7 0.5ZM10.0957 5.86182L6.42871 9.36182C6.33548 9.45053 6.21171 9.5 6.08301 9.5C5.95432 9.5 5.83054 9.45053 5.73731 9.36182L3.9043 7.61182C3.80854 7.52008 3.7531 7.39409 3.75016 7.26151C3.74723 7.12894 3.79704 7.00062 3.88865 6.90474C3.98026 6.80886 4.10618 6.75326 4.23875 6.75015C4.37132 6.74705 4.49971 6.7967 4.59571 6.88818L6.08301 8.30859L9.4043 5.13818C9.5003 5.0467 9.62868 4.99705 9.76126 5.00015C9.89383 5.00326 10.0198 5.05886 10.1114 5.15474C10.203 5.25062 10.2528 5.37894 10.2498 5.51152C10.2469 5.64409 10.1915 5.77008 10.0957 5.86182Z"
    })
  });
};
function CircleCheckOutlineIcon({
  style,
  className = "",
  viewBox = "0 0 48 48",
  height = 48,
  width = 48
}) {
  return /* @__PURE__ */ jsx$1("svg", {
    className,
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24 8C15.1634 8 8 15.1634 8 24C8 32.8366 15.1634 40 24 40C32.8366 40 40 32.8366 40 24C40 15.1634 32.8366 8 24 8ZM4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24ZM31.4142 18.5858C32.1953 19.3668 32.1953 20.6332 31.4142 21.4142L23.4142 29.4142C22.6332 30.1953 21.3668 30.1953 20.5858 29.4142L16.5858 25.4142C15.8047 24.6332 15.8047 23.3668 16.5858 22.5858C17.3668 21.8047 18.6332 21.8047 19.4142 22.5858L22 25.1716L28.5858 18.5858C29.3668 17.8047 30.6332 17.8047 31.4142 18.5858Z",
      fill: "currentColor"
    })
  });
}
const CirclePlayIcon = (props) => {
  const {
    color = "",
    style,
    className = "",
    viewBox = "-4 -4 24 24",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.498 6.2767 13.8126 4.62456 12.594 3.40601C11.3754 2.18745 9.7233 1.50199 8 1.5ZM10.2773 8.41602L7.27735 10.416C7.20206 10.4663 7.11454 10.4952 7.02411 10.4996C6.93369 10.504 6.84377 10.4838 6.76395 10.4411C6.68413 10.3983 6.61741 10.3348 6.57092 10.2571C6.52444 10.1794 6.49992 10.0905 6.5 10V6C6.49992 5.90947 6.52444 5.82062 6.57092 5.74293C6.61741 5.66525 6.68413 5.60165 6.76395 5.55894C6.84377 5.51622 6.93369 5.49598 7.02411 5.5004C7.11454 5.50481 7.20206 5.5337 7.27735 5.58398L10.2773 7.58398C10.3458 7.62964 10.402 7.6915 10.4408 7.76407C10.4797 7.83665 10.5 7.91769 10.5 8C10.5 8.08231 10.4797 8.16335 10.4408 8.23593C10.402 8.3085 10.3458 8.37036 10.2773 8.41602Z"
    })
  });
};
const ClearIcon = (props) => {
  const {
    style,
    className = "",
    viewBox = "0 0 16 17",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1("tw-fill-Gray-300", `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.7661 4.27301C11.454 3.96108 10.9482 3.96108 10.6362 4.27301L8.005 6.90422L5.37379 4.27301C5.06026 3.9702 4.5619 3.97453 4.25369 4.28274C3.94547 4.59096 3.94114 5.08932 4.24396 5.40284L6.87517 8.03406L4.24396 10.6653C4.03624 10.8659 3.95294 11.163 4.02606 11.4423C4.09919 11.7217 4.31736 11.9399 4.59672 12.013C4.87609 12.0861 5.17317 12.0028 5.37379 11.7951L8.005 9.16389L10.6362 11.7951C10.9497 12.0979 11.4481 12.0936 11.7563 11.7854C12.0645 11.4772 12.0689 10.9788 11.7661 10.6653L9.13484 8.03406L11.7661 5.40284C12.078 5.09082 12.078 4.58503 11.7661 4.27301Z"
    })
  });
};
const CloseCircleIcon = (props) => {
  const {
    style,
    viewBox = "0 0 24 24",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    fill: "none",
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      d: "M10 14.2308L12 12.2308M12 12.2308L14 10.2308M12 12.2308L10 10.2308M12 12.2308L14 14.2308M21 12.2308C21 17.2013 16.9706 21.2308 12 21.2308C7.02944 21.2308 3 17.2013 3 12.2308C3 7.26021 7.02944 3.23077 12 3.23077C16.9706 3.23077 21 7.26021 21 12.2308Z",
      stroke: "#121419",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
const STANDARD_COLORS$1 = {
  current: "current",
  transparent: "transparent",
  dark: "dark",
  white: "white",
  primary: {
    100: "primary-100",
    200: "primary-200",
    300: "primary-300",
    400: "primary-400",
    500: "primary-500",
    600: "primary-600"
  },
  grayscale: {
    100: "grayscale-100",
    200: "grayscale-200",
    300: "grayscale-300",
    400: "grayscale-400",
    500: "grayscale-500",
    600: "grayscale-600",
    700: "grayscale-700",
    800: "grayscale-800"
  },
  red: {
    100: "red-100",
    200: "red-200",
    300: "red-300",
    400: "red-400",
    500: "red-500",
    600: "red-600"
  },
  orange: {
    100: "orange-100",
    200: "orange-200",
    300: "orange-300",
    400: "orange-400",
    500: "orange-500",
    600: "orange-600"
  },
  yellow: {
    100: "yellow-100",
    200: "yellow-200",
    300: "yellow-300",
    400: "yellow-400",
    500: "yellow-500",
    600: "yellow-600"
  },
  green: {
    100: "green-100",
    200: "green-200",
    300: "green-300",
    400: "green-400",
    500: "green-500",
    600: "green-600"
  },
  darkblue: {
    100: "darkblue-100",
    200: "darkblue-200",
    300: "darkblue-300",
    400: "darkblue-400",
    500: "darkblue-500",
    600: "darkblue-600"
  },
  lightblue: {
    100: "lightblue-100",
    200: "lightblue-200",
    300: "lightblue-300",
    400: "lightblue-400",
    500: "lightblue-500",
    600: "lightblue-600"
  }
};
const LEGACY_COLORS$1 = {
  Accent: "Accent",
  AntiFlashWhite: "AntiFlashWhite",
  Black: "Black",
  DarkBlue: "DarkBlue",
  DarkLight: "DarkLight",
  DarkNudePrimary: "DarkNudePrimary",
  DarkPrimary: "DarkPrimary",
  LightBlue: "LightBlue",
  LightNudePrimary: "LightNudePrimary",
  LightPrimary: "LightPrimary",
  NudeDarkBlue: "NudeDarkBlue",
  NudeGreen: "NudeGreen",
  NudeLightBlue: "NudeLightBlue",
  NudeOrange: "NudeOrange",
  NudePrimary: "NudePrimary",
  NudeRed: "NudeRed",
  NudeYellow: "NudeYellow",
  Orange: "Orange",
  Red: "Red",
  Secondary: "Secondary",
  Tertiary: "Tertiary",
  Transparent: "Transparent",
  White: "White",
  Yellow: "Yellow",
  Gray: {
    0: "Gray-0",
    100: "Gray-100",
    200: "Gray-200",
    300: "Gray-300",
    400: "Gray-400",
    500: "Gray-500",
    600: "Gray-600",
    700: "Gray-700",
    800: "Gray-800"
  },
  Green: {
    100: "Green-100",
    200: "Green-200",
    300: "Green-300",
    400: "Green-400",
    500: "Green-500"
  },
  Primary: {
    100: "Primary-100",
    200: "Primary-200",
    300: "Primary-300",
    400: "Primary-400",
    500: "Primary-500",
    600: "Primary-600"
  }
};
const LEGACY_NFT_COLORS$1 = {
  NFTAliceBlue: "NFTAliceBlue",
  NFTAntiFlashWhite: "NFTAntiFlashWhite",
  NFTBrandeisBlue: "NFTBrandeisBlue",
  NFTFrenchSkyBlue: "NFTFrenchSkyBlue",
  NFTGhostWhite: "NFTGhostWhite",
  NFTMetallicSilver: "NFTMetallicSilver",
  NFTPastelRed: "NFTPastelRed"
};
const COLORS = __spreadValues(__spreadValues(__spreadValues({}, STANDARD_COLORS$1), LEGACY_COLORS$1), LEGACY_NFT_COLORS$1);
const CloseIcon = (props) => {
  const {
    color = COLORS.Black,
    style,
    className = "",
    viewBox = "0 0 48 48",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      id: "Fill",
      d: "M.66,47.34a2.25,2.25,0,0,1,0-3.18h0L20.82,24,.66,3.84A2.25,2.25,0,0,1,3.84.65L24,20.82,44.16.66a2.25,2.25,0,1,1,3.18,3.18L27.18,24,47.34,44.16a2.25,2.25,0,0,1-3.18,3.18L24,27.18,3.84,47.34a2.25,2.25,0,0,1-3.18,0Z",
      transform: "translate(0 0)"
    })
  });
};
const DeleteIcon = (props) => {
  const {
    color = COLORS.Black,
    style,
    className = "",
    viewBox = "0 0 16 16",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.1244 10.9024C10.1244 11.263 9.83225 11.5545 9.47225 11.5545C9.11225 11.5545 8.82008 11.263 8.82008 10.9024V7.17194C8.82008 6.81194 9.11225 6.51976 9.47225 6.51976C9.83225 6.51976 10.1244 6.81194 10.1244 7.17194V10.9024ZM10.1391 13.4136C11.2178 13.4136 12.0956 12.5358 12.0956 11.4571V4.97124H3.58738V11.4571C3.58738 12.5358 4.46521 13.4136 5.54391 13.4136H10.1391ZM7.41236 2.45643C6.90888 2.45643 6.49931 2.94817 6.49931 3.55209C6.49931 3.57867 6.49255 3.60299 6.48569 3.62766C6.48212 3.64051 6.47852 3.65346 6.47584 3.66687H9.2404C9.19866 2.99252 8.72714 2.45643 8.14736 2.45643H7.41236ZM12.7478 3.66688H13.595C13.955 3.66688 14.2471 3.9584 14.2471 4.31906C14.2471 4.67906 13.955 4.97123 13.595 4.97123H13.4V11.4571C13.4 13.2551 11.9371 14.718 10.1391 14.718H5.54389C3.74584 14.718 2.28302 13.2551 2.28302 11.4571V4.97123H2.15193C1.79193 4.97123 1.49976 4.67906 1.49976 4.31906C1.49976 3.9584 1.79193 3.66688 2.15193 3.66688H2.93519H5.21845C5.21577 3.65348 5.21217 3.64053 5.2086 3.62767C5.20174 3.60301 5.19497 3.57868 5.19497 3.5521C5.19497 2.22884 6.18954 1.1521 7.41236 1.1521H8.14736C9.44389 1.1521 10.4965 2.27253 10.5435 3.66688H12.7478ZM6.86321 10.9024C6.86321 11.263 6.57104 11.5545 6.21104 11.5545C5.85104 11.5545 5.55886 11.263 5.55886 10.9024V7.17194C5.55886 6.81194 5.85104 6.51976 6.21104 6.51976C6.57104 6.51976 6.86321 6.81194 6.86321 7.17194V10.9024Z"
    })
  });
};
const DiscordIcon = (props) => {
  const {
    color = COLORS.Black,
    style,
    className = "",
    viewBox = "0 0 20 20",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      d: "M16.9307 3.24404C15.6558 2.66908 14.2892 2.24411 12.86 2.00246C12.8473 2.00002 12.8341 2.00159 12.8223 2.00696C12.8105 2.01234 12.8007 2.02125 12.7942 2.03246C12.6192 2.33994 12.4242 2.74074 12.2875 3.05739C10.7718 2.83093 9.23089 2.83093 7.71518 3.05739C7.56296 2.70646 7.39131 2.36429 7.20103 2.03246C7.19458 2.02111 7.18482 2.012 7.17306 2.00634C7.16129 2.00068 7.14809 1.99875 7.13519 2.00079C5.7069 2.24244 4.34028 2.66741 3.06448 3.24321C3.0535 3.24781 3.0442 3.25566 3.03781 3.26571C0.444554 7.07796 -0.266258 10.796 0.0828981 14.4675C0.0838697 14.4765 0.086661 14.4852 0.091102 14.493C0.095543 14.5009 0.101541 14.5078 0.108731 14.5133C1.62235 15.6153 3.31059 16.4547 5.10275 16.9965C5.11525 17.0003 5.12861 17.0003 5.1411 16.9964C5.15358 16.9926 5.16461 16.985 5.17275 16.9748C5.5584 16.4591 5.90014 15.9119 6.19439 15.3391C6.19847 15.3313 6.20083 15.3226 6.20129 15.3138C6.20175 15.305 6.20032 15.2962 6.19708 15.288C6.19384 15.2797 6.18887 15.2723 6.18251 15.2662C6.17615 15.2601 6.16855 15.2554 6.16022 15.2524C5.62191 15.0497 5.10032 14.8051 4.60027 14.5208C4.59128 14.5157 4.58371 14.5084 4.57823 14.4996C4.57275 14.4908 4.56954 14.4808 4.56888 14.4705C4.56822 14.4602 4.57013 14.4499 4.57445 14.4405C4.57876 14.4311 4.58534 14.4229 4.5936 14.4166C4.6986 14.3391 4.80359 14.2583 4.90359 14.1775C4.91259 14.1702 4.92344 14.1656 4.93491 14.1641C4.94639 14.1627 4.95805 14.1644 4.96859 14.1692C8.241 15.6391 11.7851 15.6391 15.0191 14.1692C15.0297 14.1641 15.0415 14.1621 15.0531 14.1635C15.0648 14.1648 15.0758 14.1694 15.085 14.1767C15.185 14.2583 15.2891 14.3391 15.395 14.4166C15.4033 14.4227 15.41 14.4308 15.4144 14.4401C15.4189 14.4495 15.421 14.4597 15.4205 14.4701C15.42 14.4804 15.4169 14.4904 15.4116 14.4993C15.4063 14.5081 15.3988 14.5155 15.39 14.5208C14.8916 14.8075 14.3733 15.0499 13.8292 15.2516C13.8208 15.2546 13.8132 15.2594 13.8068 15.2656C13.8005 15.2718 13.7955 15.2793 13.7923 15.2876C13.789 15.2959 13.7876 15.3048 13.7881 15.3136C13.7886 15.3225 13.7909 15.3312 13.795 15.3391C14.095 15.9115 14.4383 16.4565 14.8158 16.974C14.8237 16.9846 14.8346 16.9925 14.8471 16.9967C14.8596 17.0009 14.8732 17.0011 14.8858 16.9973C16.681 16.457 18.372 15.6172 19.8873 14.5133C19.8947 14.5081 19.9009 14.5014 19.9055 14.4937C19.9101 14.4859 19.913 14.4773 19.914 14.4683C20.3306 10.2236 19.2157 6.53549 16.9566 3.26738C16.951 3.25675 16.9419 3.24848 16.9307 3.24404ZM6.68354 12.2318C5.69857 12.2318 4.88609 11.341 4.88609 10.2486C4.88609 9.15532 5.68274 8.26538 6.68354 8.26538C7.69184 8.26538 8.49682 9.16282 8.48099 10.2486C8.48099 11.3418 7.68435 12.2318 6.68354 12.2318ZM13.3292 12.2318C12.3434 12.2318 11.5317 11.341 11.5317 10.2486C11.5317 9.15532 12.3275 8.26538 13.3292 8.26538C14.3375 8.26538 15.1425 9.16282 15.1266 10.2486C15.1266 11.3418 14.3383 12.2318 13.3292 12.2318Z"
    })
  });
};
const DownIcon = (props) => {
  const {
    color = COLORS.Black,
    style,
    className = "",
    viewBox = "0 0 32 32",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsxs("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: [/* @__PURE__ */ jsx$1("defs", {
      children: /* @__PURE__ */ jsx$1("path", {
        id: "ic-arrow-down_svg__a",
        d: "M0 0h32v32H0z"
      })
    }), /* @__PURE__ */ jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/* @__PURE__ */ jsx$1("mask", {
        id: "ic-arrow-down_svg__b",
        fill: "#fff",
        children: /* @__PURE__ */ jsx$1("use", {
          xlinkHref: "#ic-arrow-down_svg__a"
        })
      }), /* @__PURE__ */ jsx$1("path", {
        fill: "currentColor",
        d: "M14.64 17.31l5.646 5.645a1.38 1.38 0 11-1.951 1.95l-6.62-6.62a1.38 1.38 0 010-1.95l6.62-6.621a1.38 1.38 0 011.95 1.95L14.64 17.31z",
        mask: "url(#ic-arrow-down_svg__b)",
        transform: "matrix(0 -1 -1 0 33.31 33.31)"
      })]
    })]
  });
};
const DownloadIcon = (props) => {
  const {
    style,
    className,
    viewBox = "0 0 24 24",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsxs("svg", {
    className,
    height,
    width,
    style,
    viewBox,
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M9.24852 12.3514C8.77989 11.8828 8.02009 11.8828 7.55147 12.3514C7.08284 12.8201 7.08284 13.5799 7.55147 14.0485L11.1515 17.6485C11.6201 18.1171 12.3799 18.1171 12.8485 17.6485L16.4485 14.0485C16.9171 13.5799 16.9171 12.8201 16.4485 12.3514C15.9799 11.8828 15.2201 11.8828 14.7515 12.3514L13.2 13.9029L13.2 7.19998H19.2C20.5255 7.19998 21.6 8.27449 21.6 9.59998V18C21.6 19.3255 20.5255 20.4 19.2 20.4H4.79999C3.47451 20.4 2.39999 19.3255 2.39999 18V9.59998C2.39999 8.27449 3.47451 7.19998 4.79999 7.19998H10.8V13.9029L9.24852 12.3514Z"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M10.8 4.79998C10.8 4.13723 11.3373 3.59998 12 3.59998C12.6627 3.59998 13.2 4.13723 13.2 4.79998L13.2 7.19998H10.8L10.8 4.79998Z"
    })]
  });
};
const EditIcon = (props) => {
  const {
    color = COLORS.Black,
    style,
    className = "",
    viewBox = "0 0 16 16",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.0031 6.96675L8.99313 4.956L10.4556 3.456L12.5031 5.50425L11.0031 6.96675ZM5.81329 12.171L3.56329 12.3818L3.76579 10.1318L8.00329 5.94676L10.0283 7.97176L5.81329 12.171ZM13.5531 4.46175L11.4981 2.40675C10.9424 1.8855 10.0851 1.86225 9.50311 2.35425L2.75311 9.10425C2.51086 9.34875 2.36011 9.669 2.32561 10.0117L2.00311 13.1385C1.98286 13.3612 2.06236 13.581 2.22061 13.7385C2.36236 13.8795 2.55361 13.9575 2.75311 13.956H2.82061L5.94811 13.671C6.29086 13.638 6.61111 13.4865 6.85561 13.2442L13.6056 6.49425C14.1509 5.91825 14.1276 5.00925 13.5531 4.46175Z"
    })
  });
};
function CircleExclamationSolidIcon({
  style,
  className = "",
  viewBox = "0 0 48 48",
  height,
  width
}) {
  return /* @__PURE__ */ jsx$1("svg", {
    className,
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M43.1998 23.9998C43.1998 34.6037 34.6037 43.1998 23.9998 43.1998C13.3959 43.1998 4.7998 34.6037 4.7998 23.9998C4.7998 13.3959 13.3959 4.7998 23.9998 4.7998C34.6037 4.7998 43.1998 13.3959 43.1998 23.9998ZM26.3998 33.5998C26.3998 34.9253 25.3253 35.9998 23.9998 35.9998C22.6743 35.9998 21.5998 34.9253 21.5998 33.5998C21.5998 32.2743 22.6743 31.1998 23.9998 31.1998C25.3253 31.1998 26.3998 32.2743 26.3998 33.5998ZM23.9998 11.9998C22.6743 11.9998 21.5998 13.0743 21.5998 14.3998V23.9998C21.5998 25.3253 22.6743 26.3998 23.9998 26.3998C25.3253 26.3998 26.3998 25.3253 26.3998 23.9998V14.3998C26.3998 13.0743 25.3253 11.9998 23.9998 11.9998Z",
      fill: "currentColor"
    })
  });
}
const EyeIcon = (props) => {
  const {
    color = COLORS.Black,
    style,
    className = "",
    viewBox = "0 0 25 25",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.9201 11.6C19.9001 6.91 16.1001 4 12.0001 4C7.90007 4 4.10007 6.91 2.08007 11.6C2.025 11.7262 1.99658 11.8623 1.99658 12C1.99658 12.1377 2.025 12.2738 2.08007 12.4C4.10007 17.09 7.90007 20 12.0001 20C16.1001 20 19.9001 17.09 21.9201 12.4C21.9751 12.2738 22.0036 12.1377 22.0036 12C22.0036 11.8623 21.9751 11.7262 21.9201 11.6ZM12.0001 18C8.82007 18 5.83007 15.71 4.10007 12C5.83007 8.29 8.82007 6 12.0001 6C15.1801 6 18.1701 8.29 19.9001 12C18.1701 15.71 15.1801 18 12.0001 18ZM12.0001 8C11.2089 8 10.4356 8.2346 9.77779 8.67412C9.11999 9.11365 8.6073 9.73836 8.30455 10.4693C8.0018 11.2002 7.92258 12.0044 8.07693 12.7804C8.23127 13.5563 8.61223 14.269 9.17164 14.8284C9.73105 15.3878 10.4438 15.7688 11.2197 15.9231C11.9956 16.0775 12.7999 15.9983 13.5308 15.6955C14.2617 15.3928 14.8864 14.8801 15.3259 14.2223C15.7655 13.5645 16.0001 12.7911 16.0001 12C16.0001 10.9391 15.5786 9.92172 14.8285 9.17157C14.0783 8.42143 13.0609 8 12.0001 8ZM12.0001 14C11.6045 14 11.2178 13.8827 10.8889 13.6629C10.56 13.4432 10.3037 13.1308 10.1523 12.7654C10.0009 12.3999 9.96133 11.9978 10.0385 11.6098C10.1157 11.2219 10.3061 10.8655 10.5859 10.5858C10.8656 10.3061 11.2219 10.1156 11.6099 10.0384C11.9978 9.96126 12.4 10.0009 12.7654 10.1522C13.1309 10.3036 13.4432 10.56 13.663 10.8889C13.8828 11.2178 14.0001 11.6044 14.0001 12C14.0001 12.5304 13.7894 13.0391 13.4143 13.4142C13.0392 13.7893 12.5305 14 12.0001 14Z",
      fill: "currentColor"
    })
  });
};
const FacebookIcon = (props) => {
  const {
    color = COLORS.Black,
    style,
    className = "",
    viewBox = "0 0 20 20",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 10.0558C0 15.0275 3.61083 19.1617 8.33333 20V12.7775H5.83333V10H8.33333V7.7775C8.33333 5.2775 9.94417 3.88917 12.2225 3.88917C12.9442 3.88917 13.7225 4 14.4442 4.11083V6.66667H13.1667C11.9442 6.66667 11.6667 7.2775 11.6667 8.05583V10H14.3333L13.8892 12.7775H11.6667V20C16.3892 19.1617 20 15.0283 20 10.0558C20 4.525 15.5 0 10 0C4.5 0 0 4.525 0 10.0558Z"
    })
  });
};
const FilterIcon = (props) => {
  const {
    color = "Gray-800",
    style,
    className = "",
    viewBox = "0 0 24 24",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsxs("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M6.00002 4.8C6.00002 4.13726 5.46277 3.6 4.80002 3.6C4.13728 3.6 3.60002 4.13726 3.60002 4.8V13.5211C2.88266 13.936 2.40002 14.7117 2.40002 15.6C2.40002 16.4883 2.88266 17.264 3.60002 17.6789V19.2C3.60002 19.8627 4.13728 20.4 4.80002 20.4C5.46277 20.4 6.00002 19.8627 6.00002 19.2V17.6789C6.71739 17.264 7.20002 16.4883 7.20002 15.6C7.20002 14.7117 6.71739 13.936 6.00002 13.5211V4.8Z",
      fill: "#121419"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M13.2 4.8C13.2 4.13726 12.6628 3.6 12 3.6C11.3373 3.6 10.8 4.13726 10.8 4.8V6.32108C10.0827 6.73605 9.60002 7.51166 9.60002 8.4C9.60002 9.28834 10.0827 10.064 10.8 10.4789V19.2C10.8 19.8627 11.3373 20.4 12 20.4C12.6628 20.4 13.2 19.8627 13.2 19.2V10.4789C13.9174 10.064 14.4 9.28834 14.4 8.4C14.4 7.51166 13.9174 6.73605 13.2 6.32108V4.8Z",
      fill: "#121419"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M19.2 3.6C19.8628 3.6 20.4 4.13726 20.4 4.8V13.5211C21.1174 13.936 21.6 14.7117 21.6 15.6C21.6 16.4883 21.1174 17.264 20.4 17.6789V19.2C20.4 19.8627 19.8628 20.4 19.2 20.4C18.5373 20.4 18 19.8627 18 19.2V17.6789C17.2827 17.264 16.8 16.4883 16.8 15.6C16.8 14.7117 17.2827 13.936 18 13.5211V4.8C18 4.13726 18.5373 3.6 19.2 3.6Z",
      fill: "#121419"
    })]
  });
};
const ImageIcon = (props) => {
  const {
    color = "",
    style,
    className = "",
    viewBox = "0 0 24 24",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.79999 3.60001C3.47451 3.60001 2.39999 4.67452 2.39999 6.00001V18C2.39999 19.3255 3.47451 20.4 4.79999 20.4H19.2C20.5255 20.4 21.6 19.3255 21.6 18V6.00001C21.6 4.67452 20.5255 3.60001 19.2 3.60001H4.79999ZM19.2 18H4.79999L9.59999 8.40001L13.2 15.6L15.6 10.8L19.2 18Z"
    })
  });
};
const InfoIcon = (props) => {
  const {
    color = "",
    style,
    className = "",
    viewBox = "-5 -7 48 48",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.0001 1.77772C8.14539 1.77772 1.77788 8.14523 1.77788 15.9999C1.77788 23.8547 8.14538 30.2222 16.0001 30.2222C23.8548 30.2222 30.2223 23.8547 30.2223 15.9999C30.2223 8.14523 23.8548 1.77772 16.0001 1.77772ZM14.1958 9.42727C14.1958 8.91732 14.3711 8.48705 14.7217 8.13646C15.0723 7.78587 15.4946 7.61058 15.9886 7.61058C16.4986 7.61058 16.9289 7.78587 17.2794 8.13646C17.63 8.48705 17.8053 8.91732 17.8053 9.42727C17.8053 9.93722 17.63 10.3635 17.2794 10.7061C16.9289 11.0488 16.4986 11.2201 15.9886 11.2201C15.4946 11.2201 15.0723 11.0488 14.7217 10.7061C14.3711 10.3635 14.1958 9.93722 14.1958 9.42727ZM14.626 24.3891L14.626 12.7479L17.375 12.7479L17.375 24.3891L14.626 24.3891Z"
    })
  });
};
function InformationCircleIcon(props) {
  const {
    style,
    className = "",
    viewBox = "0 0 20 20",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className,
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM11 6C11 6.55228 10.5523 7 10 7C9.44772 7 9 6.55228 9 6C9 5.44772 9.44772 5 10 5C10.5523 5 11 5.44772 11 6ZM9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11V14C9 14.5523 9.44772 15 10 15H11C11.5523 15 12 14.5523 12 14C12 13.4477 11.5523 13 11 13V10C11 9.44772 10.5523 9 10 9H9Z",
      fill: "currentColor"
    })
  });
}
const LogoutIcon = (props) => {
  const {
    color = "",
    style,
    className = "",
    viewBox = "0 0 32 32",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsxs("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: [/* @__PURE__ */ jsx$1("mask", {
      id: "mask0_391_8003",
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "32",
      height: "32",
      children: /* @__PURE__ */ jsx$1("rect", {
        width: "32",
        height: "32",
        fill: "white"
      })
    }), /* @__PURE__ */ jsx$1("g", {
      mask: "url(#mask0_391_8003)",
      children: /* @__PURE__ */ jsx$1("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.9999 17.9997C17.9999 17.4479 18.4469 16.9998 18.9999 16.9998C19.5528 16.9998 19.9998 17.4479 19.9998 17.9997V21.9998C19.9998 23.6538 18.6538 24.9998 16.9998 24.9998H13.9998V25.9997C13.9998 27.1027 13.103 27.9998 12 27.9998C11.7869 27.9998 11.584 27.9697 11.38 27.9068L5.36193 25.9007C4.544 25.6167 4 24.8537 4 23.9997V5.99986C4 4.89684 4.89703 4 6.00004 4C6.02759 4 6.05421 4.0057 6.08081 4.01139C6.10142 4.0158 6.12203 4.02021 6.14305 4.02197C6.15854 4.0199 6.17313 4.01571 6.18765 4.01154C6.20781 4.00575 6.22784 4 6.24998 4H16.9998C18.6538 4 19.9998 5.346 19.9998 6.99997V9.99994C19.9998 10.5518 19.5528 10.9999 18.9999 10.9999C18.4469 10.9999 17.9999 10.5518 17.9999 9.99994V6.99997C17.9999 6.44883 17.5519 5.99986 16.9998 5.99986H12.3418L12.6379 6.09892C13.4558 6.38291 13.9998 7.14591 13.9998 7.9999V22.9998H16.9998C17.5519 22.9998 17.9999 22.5508 17.9999 21.9998V17.9997ZM23.7067 9.29297L27.7068 13.2929C28.0977 13.6838 28.0977 14.3159 27.7068 14.7068L23.7067 18.7069C23.4209 18.9927 22.9908 19.0788 22.6169 18.9239C22.2439 18.7688 21.9998 18.4038 21.9998 17.9997V14.9998H17.9999C17.4478 14.9998 16.9998 14.5519 16.9998 13.9998C16.9998 13.4478 17.4478 12.9999 17.9999 12.9999H21.9998V9.99993C21.9998 9.59582 22.2439 9.2309 22.6169 9.07581C22.9908 8.9209 23.4209 9.00696 23.7067 9.29297Z"
      })
    })]
  });
};
const NextIcon = (props) => {
  const {
    color = "transparent",
    style,
    className = "",
    viewBox = "0 0 24 24",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      d: "M9 5.69232L16 12.6923L9 19.6923",
      strokeWidth: "2",
      fill: color,
      stroke: "#121419",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
const OptionsIcon = (props) => {
  const {
    className = "",
    color = COLORS.Black,
    height,
    style,
    viewBox = "0 0 35 35",
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 3C19 4.65685 17.6569 6 16 6C14.3431 6 13 4.65685 13 3C13 1.34315 14.3431 0 16 0C17.6569 0 19 1.34315 19 3ZM19 16C19 17.6569 17.6569 19 16 19C14.3431 19 13 17.6569 13 16C13 14.3431 14.3431 13 16 13C17.6569 13 19 14.3431 19 16ZM16 32C17.6569 32 19 30.6569 19 29C19 27.3431 17.6569 26 16 26C14.3431 26 13 27.3431 13 29C13 30.6569 14.3431 32 16 32Z"
    })
  });
};
const OutlineCheckCircle = (props) => {
  const {
    style = {},
    className,
    viewBox = "0 0 29 30",
    height = 24,
    width = 25
  } = props;
  return /* @__PURE__ */ jsxs("svg", {
    className: classNames$1(className),
    height,
    width,
    style: __spreadValues({
      strokeOpacity: 1,
      strokeMiterlimit: 1
    }, style),
    viewBox,
    children: [/* @__PURE__ */ jsx$1("circle", {
      cx: "14.5",
      cy: "15.0859",
      r: "11.7812",
      fill: "#00C566"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M14.5 3.30469C12.1699 3.30469 9.89211 3.99565 7.95469 5.29019C6.01728 6.58473 4.50724 8.42471 3.61555 10.5774C2.72385 12.7302 2.49055 15.099 2.94513 17.3843C3.39971 19.6697 4.52177 21.7689 6.1694 23.4165C7.81704 25.0642 9.91626 26.1862 12.2016 26.6408C14.4869 27.0954 16.8558 26.8621 19.0085 25.9704C21.1612 25.0787 23.0012 23.5687 24.2958 21.6312C25.5903 19.6938 26.2813 17.416 26.2813 15.0859C26.2776 11.9625 25.0352 8.96795 22.8266 6.75932C20.618 4.55069 17.6235 3.3083 14.5 3.30469ZM20.111 13.023L13.4645 19.3667C13.2956 19.5275 13.0712 19.6172 12.838 19.6172C12.6047 19.6172 12.3804 19.5275 12.2114 19.3667L8.88904 16.1949C8.71547 16.0286 8.61499 15.8002 8.60967 15.5599C8.60435 15.3196 8.69463 15.0871 8.86067 14.9133C9.02671 14.7395 9.25495 14.6387 9.49524 14.6331C9.73553 14.6275 9.96822 14.7174 10.1422 14.8833L12.838 17.4578L18.8578 11.7114C19.0318 11.5456 19.2645 11.4556 19.5048 11.4612C19.7451 11.4668 19.9733 11.5676 20.1393 11.7414C20.3054 11.9152 20.3957 12.1478 20.3903 12.3881C20.385 12.6284 20.2845 12.8567 20.111 13.023Z",
      fill: "#D9F7E8"
    })]
  });
};
const OutlineXCircle = (props) => {
  const {
    color = COLORS.Black,
    style = {},
    className = "",
    viewBox = "0 0 23 24",
    height = 24,
    width = 24
  } = props;
  return /* @__PURE__ */ jsxs("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    viewBox,
    fill: "none",
    style,
    children: [/* @__PURE__ */ jsx$1("circle", {
      cx: "11.5",
      cy: "12.0859",
      r: "11.5",
      fill: "#F5F7FB"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M15.6205 8.89353L15.6206 8.89342C15.7435 8.77033 15.8125 8.60345 15.8125 8.42947C15.8124 8.2555 15.7433 8.08867 15.6203 7.96565C15.4973 7.84263 15.3304 7.77349 15.1564 7.77344C14.9825 7.77338 14.8156 7.84241 14.6925 7.96536L14.6924 7.96547L11.5002 11.1577L8.30796 7.96547L8.30784 7.96536C8.18475 7.84241 8.01787 7.77338 7.8439 7.77344C7.66992 7.77349 7.50309 7.84263 7.38007 7.96565C7.25705 8.08867 7.18791 8.2555 7.18786 8.42947C7.18781 8.60345 7.25684 8.77033 7.37978 8.89342L7.37989 8.89353L10.5721 12.0857L7.38 15.2779C7.37996 15.2779 7.37993 15.2779 7.37989 15.278C7.31894 15.3389 7.27058 15.4112 7.23757 15.4908C7.20454 15.5704 7.18753 15.6558 7.1875 15.742C7.18747 15.8282 7.20443 15.9136 7.23741 15.9932C7.27039 16.0729 7.31875 16.1452 7.37971 16.2062C7.44067 16.2672 7.51305 16.3155 7.5927 16.3485C7.67236 16.3815 7.75773 16.3984 7.84395 16.3984C7.93016 16.3984 8.01553 16.3814 8.09516 16.3483C8.1748 16.3153 8.24714 16.2669 8.30807 16.2059L11.5002 13.0138L14.6924 16.206L14.6925 16.2061C14.8156 16.3291 14.9825 16.3981 15.1564 16.3981C15.3304 16.398 15.4973 16.3289 15.6203 16.2059C15.7433 16.0828 15.8124 15.916 15.8125 15.742C15.8125 15.568 15.7435 15.4012 15.6206 15.2781L15.6205 15.278L12.4282 12.0857L15.6205 8.89353Z",
      fill: "#D7D9E1",
      stroke: "#D7D9E1",
      strokeWidth: "0.5"
    })]
  });
};
const PhotoIcon = (props) => {
  const {
    color = COLORS.Black,
    style,
    className = "",
    viewBox = "0 0 28 24",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      d: "M25.4074 3.63462H21L19.95 0.687981C19.8775 0.486351 19.7445 0.312064 19.5693 0.188927C19.3942 0.065791 19.1853 -0.000189071 18.9713 4.06956e-07H9.0287C8.5912 4.06956e-07 8.19907 0.275842 8.05324 0.687981L7 3.63462H2.59259C1.16019 3.63462 0 4.79639 0 6.23077V21.0288C0 22.4632 1.16019 23.625 2.59259 23.625H25.4074C26.8398 23.625 28 22.4632 28 21.0288V6.23077C28 4.79639 26.8398 3.63462 25.4074 3.63462ZM14 18.4327C11.1352 18.4327 8.81481 16.1091 8.81481 13.2404C8.81481 10.3716 11.1352 8.04808 14 8.04808C16.8648 8.04808 19.1852 10.3716 19.1852 13.2404C19.1852 16.1091 16.8648 18.4327 14 18.4327ZM10.8889 13.2404C10.8889 14.0666 11.2167 14.859 11.8001 15.4433C12.3836 16.0275 13.1749 16.3558 14 16.3558C14.8251 16.3558 15.6164 16.0275 16.1999 15.4433C16.7833 14.859 17.1111 14.0666 17.1111 13.2404C17.1111 12.4141 16.7833 11.6217 16.1999 11.0375C15.6164 10.4532 14.8251 10.125 14 10.125C13.1749 10.125 12.3836 10.4532 11.8001 11.0375C11.2167 11.6217 10.8889 12.4141 10.8889 13.2404Z"
    })
  });
};
function PlusIcon({
  className = "tw-fill-dark",
  height,
  style,
  viewBox = "0 0 32 32",
  width
}) {
  return /* @__PURE__ */ jsx$1("svg", {
    className,
    width,
    height,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 8C15.1716 8 14.5 8.61242 14.5 9.36788V14.5H9.36788C8.61242 14.5 8 15.1716 8 16C8 16.8284 8.61242 17.5 9.36788 17.5H14.5V22.6321C14.5 23.3876 15.1716 24 16 24C16.8284 24 17.5 23.3876 17.5 22.6321V17.5H22.6321C23.3876 17.5 24 16.8284 24 16C24 15.1716 23.3876 14.5 22.6321 14.5H17.5V9.36788C17.5 8.61242 16.8284 8 16 8Z"
    })
  });
}
const QuestionMark = (props) => {
  const {
    color = COLORS.Gray[500],
    style,
    className = "",
    viewBox = "0 -4 18 18",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      d: "M7.5 1.39844C6.37512 1.39844 5.2755 1.732 4.3402 2.35695C3.40489 2.9819 2.67591 3.87017 2.24544 4.90943C1.81496 5.94868 1.70233 7.09225 1.92179 8.19551C2.14124 9.29878 2.68292 10.3122 3.47833 11.1076C4.27374 11.903 5.28716 12.4447 6.39043 12.6642C7.49369 12.8836 8.63726 12.771 9.67651 12.3405C10.7158 11.91 11.604 11.181 12.229 10.2457C12.8539 9.31044 13.1875 8.21082 13.1875 7.08594C13.1858 5.57804 12.586 4.1324 11.5198 3.06615C10.4535 1.99991 9.0079 1.40014 7.5 1.39844ZM7.50003 10.586C7.37024 10.586 7.24336 10.5475 7.13544 10.4754C7.02752 10.4032 6.94341 10.3008 6.89374 10.1808C6.84407 10.0609 6.83107 9.92898 6.85639 9.80168C6.88171 9.67438 6.94421 9.55745 7.03599 9.46567C7.12777 9.37389 7.2447 9.31139 7.372 9.28607C7.4993 9.26075 7.63125 9.27374 7.75117 9.32341C7.87108 9.37308 7.97357 9.4572 8.04568 9.56511C8.11779 9.67303 8.15628 9.79991 8.15628 9.92971C8.15628 10.1038 8.08714 10.2707 7.96407 10.3937C7.841 10.5168 7.67408 10.586 7.50003 10.586ZM7.9375 7.91223V7.9612C7.9375 8.07724 7.89141 8.18852 7.80936 8.27056C7.72732 8.35261 7.61604 8.3987 7.50001 8.3987C7.38397 8.3987 7.27269 8.35261 7.19065 8.27056C7.1086 8.18852 7.06251 8.07724 7.06251 7.9612V7.5237C7.06251 7.40767 7.10861 7.2964 7.19065 7.21435C7.2727 7.13231 7.38397 7.08621 7.50001 7.0862C7.71633 7.0862 7.92779 7.02206 8.10766 6.90187C8.28753 6.78169 8.42771 6.61087 8.5105 6.41101C8.59328 6.21116 8.61494 5.99124 8.57274 5.77907C8.53054 5.56691 8.42637 5.37202 8.2734 5.21906C8.12044 5.06609 7.92555 4.96192 7.71339 4.91972C7.50122 4.87752 7.2813 4.89918 7.08144 4.98196C6.88159 5.06474 6.71077 5.20493 6.59059 5.3848C6.4704 5.56467 6.40626 5.77613 6.40626 5.99245C6.40626 6.10849 6.36016 6.21977 6.27811 6.30181C6.19607 6.38386 6.08479 6.42995 5.96876 6.42995C5.85272 6.42995 5.74144 6.38386 5.6594 6.30181C5.57735 6.21977 5.53126 6.10849 5.53126 5.99245C5.5313 5.62185 5.63595 5.25879 5.83318 4.94502C6.0304 4.63125 6.31217 4.37952 6.6461 4.21878C6.98003 4.05804 7.35255 3.99481 7.72082 4.03638C8.08908 4.07795 8.43814 4.22261 8.72784 4.45374C9.01753 4.68487 9.23611 4.99308 9.35843 5.34292C9.48075 5.69275 9.50184 6.07001 9.41928 6.4313C9.33672 6.79259 9.15386 7.12324 8.89173 7.38522C8.62959 7.6472 8.29884 7.82987 7.9375 7.91223Z",
      fill: color
    })
  });
};
function WalletIcon$1({
  style,
  className = "",
  viewBox = "0 0 12 12",
  height = 12,
  width = 12
}) {
  return /* @__PURE__ */ jsx$1("svg", {
    className,
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.40005 1.2C2.73142 1.2 3.00005 1.46863 3.00005 1.8V3.06075C3.7621 2.28293 4.82436 1.8 6.00005 1.8C7.82969 1.8 9.38462 2.96959 9.96091 4.60005C10.0713 4.91248 9.90758 5.25527 9.59515 5.3657C9.28272 5.47613 8.93993 5.31237 8.8295 4.99994C8.41738 3.83394 7.30533 3 6.00005 3C5.01909 3 4.14727 3.47101 3.59966 4.2H5.40005C5.73142 4.2 6.00005 4.46863 6.00005 4.8C6.00005 5.13137 5.73142 5.4 5.40005 5.4H2.40005C2.06868 5.4 1.80005 5.13137 1.80005 4.8V1.8C1.80005 1.46863 2.06868 1.2 2.40005 1.2ZM2.40495 6.63429C2.71738 6.52386 3.06017 6.68762 3.1706 7.00005C3.58272 8.16605 4.69477 9 6.00005 9C6.98101 9 7.85283 8.52899 8.40044 7.8L6.60005 7.8C6.26868 7.8 6.00005 7.53137 6.00005 7.2C6.00005 6.86863 6.26868 6.6 6.60005 6.6H9.60005C9.75918 6.6 9.91179 6.66321 10.0243 6.77573C10.1368 6.88825 10.2 7.04087 10.2 7.2V10.2C10.2 10.5314 9.93142 10.8 9.60005 10.8C9.26868 10.8 9.00005 10.5314 9.00005 10.2V8.93924C8.23799 9.71706 7.17574 10.2 6.00005 10.2C4.17041 10.2 2.61548 9.0304 2.03919 7.39994C1.92876 7.08751 2.09252 6.74472 2.40495 6.63429Z",
      fill: "white"
    })
  });
}
const RemoveGalleryIcon = (props) => {
  const {
    style,
    className,
    viewBox = "0 0 24 24",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsxs("svg", {
    className,
    height,
    width,
    style,
    viewBox,
    children: [/* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 6.75C8.30964 6.75 7.75 7.30964 7.75 8C7.75 8.69036 8.30964 9.25 9 9.25C9.69036 9.25 10.25 8.69036 10.25 8C10.25 7.30964 9.69036 6.75 9 6.75ZM6.25 8C6.25 6.48122 7.48122 5.25 9 5.25C10.5188 5.25 11.75 6.48122 11.75 8C11.75 9.51878 10.5188 10.75 9 10.75C7.48122 10.75 6.25 9.51878 6.25 8Z"
    }), /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.09467 3.09467C4.42914 1.7602 6.42603 1.25 9 1.25H13C13.4142 1.25 13.75 1.58579 13.75 2C13.75 2.41421 13.4142 2.75 13 2.75H9C6.57397 2.75 5.07086 3.2398 4.15533 4.15533C3.2398 5.07086 2.75 6.57397 2.75 9V15C2.75 17.426 3.2398 18.9291 4.15533 19.8447C5.07086 20.7602 6.57397 21.25 9 21.25H15C17.426 21.25 18.9291 20.7602 19.8447 19.8447C20.7602 18.9291 21.25 17.426 21.25 15V10C21.25 9.58579 21.5858 9.25 22 9.25C22.4142 9.25 22.75 9.58579 22.75 10V15C22.75 17.574 22.2398 19.5709 20.9053 20.9053C19.5709 22.2398 17.574 22.75 15 22.75H9C6.42603 22.75 4.42914 22.2398 3.09467 20.9053C1.7602 19.5709 1.25 17.574 1.25 15V9C1.25 6.42603 1.7602 4.42914 3.09467 3.09467Z"
    }), /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.9703 2.52967C21.2632 2.82256 21.2632 3.29743 20.9703 3.59033L17.0903 7.47033C16.7974 7.76322 16.3226 7.76322 16.0297 7.47033C15.7368 7.17743 15.7368 6.70256 16.0297 6.40967L19.9097 2.52967C20.2026 2.23677 20.6774 2.23677 20.9703 2.52967Z"
    }), /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.0297 2.52967C16.3226 2.23677 16.7974 2.23677 17.0903 2.52967L20.9703 6.40967C21.2632 6.70256 21.2632 7.17743 20.9703 7.47033C20.6774 7.76322 20.2026 7.76322 19.9097 7.47033L16.0297 3.59033C15.7368 3.29743 15.7368 2.82256 16.0297 2.52967Z"
    }), /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.8813 13.0689C19.3824 12.6404 18.5376 12.6404 18.0387 13.0689L13.8787 16.6389C13.8786 16.639 13.8788 16.6389 13.8787 16.6389C12.8176 17.5501 11.1423 17.5503 10.0813 16.6389L10.0749 16.6334L9.74844 16.3465C9.30001 15.9638 8.53368 15.9168 8.01784 16.2628L3.08806 19.5727C2.74417 19.8036 2.27822 19.712 2.04733 19.3681C1.81644 19.0242 1.90804 18.5582 2.25194 18.3273L7.18194 15.0173C8.24502 14.3041 9.75679 14.3761 10.7288 15.2111L10.7351 15.2166L11.0615 15.5035C11.5608 15.9296 12.4033 15.9288 12.9013 15.5011L17.0613 11.9311C17.0614 11.931 17.0612 11.9312 17.0613 11.9311C18.1224 11.0199 19.7977 11.0197 20.8587 11.9311C20.8587 11.9311 20.8587 11.9311 20.8587 11.9311L22.4887 13.3311C22.8029 13.6009 22.8388 14.0745 22.5689 14.3887C22.2991 14.7029 21.8256 14.7388 21.5113 14.469L19.8813 13.0689Z"
    })]
  });
};
const SearchIcon = (props) => {
  const {
    style,
    className,
    viewBox = "0 0 24 24",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    fill: "none",
    className,
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      d: "M21 21.2308L15 15.2308M17 10.2308C17 14.0968 13.866 17.2308 10 17.2308C6.13401 17.2308 3 14.0968 3 10.2308C3 6.36478 6.13401 3.23077 10 3.23077C13.866 3.23077 17 6.36478 17 10.2308Z",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
const SettingIcon = (props) => {
  const {
    color = COLORS.Black,
    style,
    className = "",
    viewBox = "0 0 24 24",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.9838 2.54161C14.0711 2.71093 14.0928 2.92777 14.1361 3.36144C14.2182 4.1823 14.2593 4.59274 14.4311 4.81793C14.649 5.10358 15.0034 5.25038 15.3595 5.20248C15.6402 5.16472 15.9594 4.90352 16.5979 4.38113C16.9352 4.10515 17.1038 3.96716 17.2853 3.90918C17.5158 3.83555 17.7652 3.84798 17.9872 3.94419C18.162 4.01994 18.3161 4.17402 18.6243 4.4822L19.5178 5.37567C19.8259 5.68385 19.98 5.83794 20.0558 6.01275C20.152 6.23478 20.1644 6.48415 20.0908 6.71464C20.0328 6.89612 19.8948 7.06478 19.6188 7.4021C19.0964 8.0406 18.8352 8.35984 18.7975 8.64056C18.7496 8.99662 18.8964 9.35102 19.182 9.56893C19.4072 9.74072 19.8176 9.78176 20.6385 9.86385C21.0722 9.90722 21.2891 9.92891 21.4584 10.0162C21.6734 10.1272 21.841 10.3123 21.9299 10.5373C22 10.7145 22 10.9324 22 11.3682V12.6319C22 13.0676 22 13.2855 21.93 13.4626C21.841 13.6877 21.6734 13.8729 21.4583 13.9838C21.289 14.0711 21.0722 14.0928 20.6386 14.1361L20.6386 14.1361C19.818 14.2182 19.4077 14.2592 19.1825 14.4309C18.8967 14.6489 18.7499 15.0034 18.7979 15.3596C18.8357 15.6402 19.0968 15.9593 19.619 16.5976C19.8949 16.9348 20.0328 17.1034 20.0908 17.2848C20.1645 17.5154 20.152 17.7648 20.0558 17.9869C19.98 18.1617 19.826 18.3157 19.5179 18.6238L18.6243 19.5174C18.3162 19.8255 18.1621 19.9796 17.9873 20.0554C17.7652 20.1516 17.5159 20.164 17.2854 20.0904C17.1039 20.0324 16.9352 19.8944 16.5979 19.6184L16.5979 19.6184C15.9594 19.096 15.6402 18.8348 15.3595 18.7971C15.0034 18.7492 14.649 18.896 14.4311 19.1816C14.2593 19.4068 14.2183 19.8173 14.1362 20.6383C14.0928 21.0722 14.0711 21.2891 13.9837 21.4585C13.8728 21.6735 13.6877 21.8409 13.4628 21.9299C13.2856 22 13.0676 22 12.6316 22H11.3682C10.9324 22 10.7145 22 10.5373 21.9299C10.3123 21.841 10.1272 21.6734 10.0162 21.4584C9.92891 21.2891 9.90722 21.0722 9.86385 20.6385C9.78176 19.8176 9.74072 19.4072 9.56892 19.182C9.35101 18.8964 8.99663 18.7496 8.64057 18.7975C8.35985 18.8352 8.04059 19.0964 7.40208 19.6189L7.40206 19.6189C7.06473 19.8949 6.89607 20.0329 6.71458 20.0908C6.4841 20.1645 6.23474 20.152 6.01272 20.0558C5.8379 19.9801 5.6838 19.826 5.37561 19.5178L4.48217 18.6243C4.17398 18.3162 4.01988 18.1621 3.94414 17.9873C3.84794 17.7652 3.8355 17.5159 3.90913 17.2854C3.96711 17.1039 4.10511 16.9352 4.3811 16.5979C4.90351 15.9594 5.16471 15.6402 5.20247 15.3594C5.25037 15.0034 5.10357 14.649 4.81792 14.4311C4.59273 14.2593 4.1823 14.2182 3.36143 14.1361C2.92776 14.0928 2.71093 14.0711 2.54161 13.9838C2.32656 13.8728 2.15902 13.6877 2.07005 13.4627C2 13.2855 2 13.0676 2 12.6318V11.3683C2 10.9324 2 10.7144 2.07008 10.5372C2.15905 10.3123 2.32654 10.1272 2.54152 10.0163C2.71088 9.92891 2.92777 9.90722 3.36155 9.86384H3.36155H3.36156C4.18264 9.78173 4.59319 9.74068 4.81842 9.56881C5.10395 9.35092 5.2507 8.99664 5.20287 8.64066C5.16514 8.35987 4.90385 8.04052 4.38128 7.40182C4.10516 7.06435 3.96711 6.89561 3.90914 6.71405C3.83557 6.48364 3.848 6.23438 3.94413 6.01243C4.01988 5.83754 4.17403 5.68339 4.48233 5.37509L5.37565 4.48177L5.37566 4.48177C5.68385 4.17357 5.83795 4.01947 6.01277 3.94373C6.23478 3.84753 6.48414 3.8351 6.71463 3.90872C6.89612 3.9667 7.06481 4.10472 7.4022 4.38076C8.04061 4.9031 8.35982 5.16427 8.64044 5.20207C8.99661 5.25003 9.35113 5.10319 9.56907 4.81742C9.74077 4.59227 9.78181 4.18195 9.86387 3.36131C9.90722 2.92776 9.9289 2.71098 10.0162 2.5417C10.1271 2.32658 10.3123 2.15898 10.5374 2.07001C10.7145 2 10.9324 2 11.3681 2H12.6318C13.0676 2 13.2855 2 13.4627 2.07005C13.6877 2.15902 13.8728 2.32656 13.9838 2.54161ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
    })
  });
};
const StoreIcon = (props) => {
  const {
    color = COLORS.Black,
    style,
    className = "",
    viewBox = "0 0 28 24",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.2563 7.77778L9.42815 0H3.33333L0.786668 6.66667C0.708149 6.9037 0.666668 7.14963 0.666668 7.40741C0.666668 9.04296 2.37037 10.3704 4.47556 10.3704C6.4163 10.3704 8.02074 9.23852 8.2563 7.77778ZM14 10.3704C16.1037 10.3704 17.8089 9.04296 17.8089 7.40741C17.8089 7.34667 17.8044 7.28593 17.8015 7.22815L17.0474 0H10.9526L10.197 7.22222C10.1941 7.28296 10.1911 7.3437 10.1911 7.40741C10.1911 9.04296 11.8963 10.3704 14 10.3704ZM21.4074 11.92V17.7778H6.5926V11.9289C5.94371 12.163 5.22963 12.2963 4.47556 12.2963C4.18667 12.2963 3.90667 12.2622 3.62963 12.2237V21.6296C3.62963 22.7704 4.56149 23.7037 5.70074 23.7037H22.2963C23.437 23.7037 24.3704 22.7689 24.3704 21.6296V12.2252C22.2963 12.2963 21.4074 11.92 21.4074 11.92ZM27.2148 6.66667L24.6652 0H18.5719L19.7422 7.76593C19.9704 9.23259 21.5748 10.3704 23.5244 10.3704C25.6282 10.3704 27.3333 9.04296 27.3333 7.40741C27.3333 7.14963 27.2919 6.9037 27.2148 6.66667Z"
    })
  });
};
const StoreNFTIcon = (props) => {
  const {
    color = COLORS.Black,
    style,
    className = "",
    viewBox = "0 0 67 66",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M61.0002 21.5049C61.0135 21.331 61.0135 21.1563 61.0002 20.9824L55.5002 7.23241C55.2854 6.68889 54.9031 6.22794 54.4086 5.91641C53.9141 5.60489 53.3332 5.459 52.7502 5.49991H14.2502C13.6995 5.49938 13.1612 5.66424 12.7052 5.97313C12.2493 6.28203 11.8965 6.72073 11.6927 7.23241L6.19274 20.9824C6.17949 21.1563 6.17949 21.331 6.19274 21.5049C6.10136 21.658 6.0363 21.8253 6.00024 21.9999C6.03085 23.9008 6.55362 25.7614 7.51754 27.4C8.48147 29.0387 9.85365 30.3996 11.5002 31.3499V57.7499C11.5002 58.4793 11.79 59.1787 12.3057 59.6945C12.8214 60.2102 13.5209 60.4999 14.2502 60.4999H52.7502C53.4796 60.4999 54.1791 60.2102 54.6948 59.6945C55.2105 59.1787 55.5002 58.4793 55.5002 57.7499V31.4599C57.1628 30.5001 58.5451 29.1219 59.51 27.4623C60.4749 25.8028 60.9887 23.9196 61.0002 21.9999C61.026 21.8359 61.026 21.6689 61.0002 21.5049ZM36.2502 54.9999H30.7502V43.9999H36.2502V54.9999ZM50.0002 54.9999H41.7502V41.2499C41.7502 40.5206 41.4605 39.8211 40.9448 39.3054C40.4291 38.7896 39.7296 38.4999 39.0002 38.4999H28.0002C27.2709 38.4999 26.5714 38.7896 26.0557 39.3054C25.54 39.8211 25.2502 40.5206 25.2502 41.2499V54.9999H17.0002V32.9999C18.5663 32.9911 20.1124 32.6479 21.5351 31.9935C22.9579 31.339 24.2245 30.3883 25.2502 29.2049C26.2825 30.3754 27.552 31.3128 28.9744 31.9549C30.3968 32.597 31.9396 32.9291 33.5002 32.9291C35.0609 32.9291 36.6036 32.597 38.0261 31.9549C39.4485 31.3128 40.718 30.3754 41.7502 29.2049C42.776 30.3883 44.0426 31.339 45.4653 31.9935C46.8881 32.6479 48.4342 32.9911 50.0002 32.9999V54.9999ZM50.0002 27.4999C48.5415 27.4999 47.1426 26.9204 46.1112 25.889C45.0797 24.8575 44.5002 23.4586 44.5002 21.9999C44.5002 21.2706 44.2105 20.5711 43.6948 20.0554C43.1791 19.5396 42.4796 19.2499 41.7502 19.2499C41.0209 19.2499 40.3214 19.5396 39.8057 20.0554C39.29 20.5711 39.0002 21.2706 39.0002 21.9999C39.0002 23.4586 38.4208 24.8575 37.3893 25.889C36.3579 26.9204 34.9589 27.4999 33.5002 27.4999C32.0416 27.4999 30.6426 26.9204 29.6112 25.889C28.5797 24.8575 28.0002 23.4586 28.0002 21.9999C28.0002 21.2706 27.7105 20.5711 27.1948 20.0554C26.6791 19.5396 25.9796 19.2499 25.2502 19.2499C24.5209 19.2499 23.8214 19.5396 23.3057 20.0554C22.79 20.5711 22.5002 21.2706 22.5002 21.9999C22.5273 22.7222 22.4119 23.4427 22.1605 24.1204C21.9091 24.798 21.5267 25.4195 21.0352 25.9494C20.5436 26.4793 19.9525 26.9071 19.2956 27.2086C18.6386 27.51 17.9288 27.6791 17.2065 27.7062C15.7478 27.7609 14.3271 27.2339 13.257 26.2411C12.7271 25.7495 12.2993 25.1584 11.9978 24.5015C11.6964 23.8445 11.5273 23.1347 11.5002 22.4124L16.1202 10.9999H50.8802L55.5002 22.4124C55.396 23.7985 54.7708 25.0936 53.7505 26.0375C52.7301 26.9813 51.3902 27.5038 50.0002 27.4999Z"
    })
  });
};
const TelegramIcon = (props) => {
  const {
    color = COLORS.Black,
    style,
    className = "",
    viewBox = "0 0 20 20",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 10C20 15.5225 15.5225 20 10 20C4.4775 20 0 15.5225 0 10C0 4.4775 4.4775 0 10 0C15.5225 0 20 4.4775 20 10ZM10.3583 7.3825C9.38583 7.78667 7.44167 8.62417 4.52667 9.89417C4.05333 10.0825 3.805 10.2667 3.7825 10.4467C3.74417 10.7517 4.12583 10.8717 4.64417 11.0342C4.715 11.0567 4.78833 11.0792 4.86333 11.1042C5.37417 11.27 6.06083 11.4642 6.4175 11.4717C6.74167 11.4783 7.10333 11.345 7.5025 11.0717C10.2258 9.2325 11.6317 8.30333 11.72 8.28333C11.7825 8.26917 11.8692 8.25083 11.9275 8.30333C11.9858 8.355 11.98 8.45333 11.9742 8.48C11.9358 8.64083 10.4408 10.0317 9.66583 10.7517C9.42417 10.9758 9.25333 11.135 9.21833 11.1717C9.14 11.2525 9.06 11.33 8.98333 11.4042C8.50833 11.8608 8.15333 12.2042 9.00333 12.7642C9.41167 13.0333 9.73833 13.2558 10.0642 13.4775C10.42 13.72 10.775 13.9617 11.235 14.2633C11.3517 14.34 11.4633 14.4192 11.5725 14.4967C11.9867 14.7925 12.3592 15.0575 12.8192 15.0158C13.0858 14.9908 13.3625 14.74 13.5025 13.9908C13.8333 12.2192 14.485 8.3825 14.6358 6.80083C14.645 6.66951 14.6394 6.53757 14.6192 6.4075C14.607 6.30244 14.5559 6.20578 14.4758 6.13667C14.3567 6.03917 14.1717 6.01833 14.0883 6.02C13.7125 6.02667 13.1358 6.2275 10.3583 7.3825Z"
    })
  });
};
const TrashIcon = (props) => {
  const {
    color = COLORS.Black,
    style,
    className = "",
    viewBox = "-3 -2 38 38",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.2488 21.8047C20.2488 22.526 19.6645 23.1091 18.9445 23.1091C18.2245 23.1091 17.6401 22.526 17.6401 21.8047V14.3439C17.6401 13.6239 18.2245 13.0395 18.9445 13.0395C19.6645 13.0395 20.2488 13.6239 20.2488 14.3439V21.8047ZM20.2782 26.8273C22.4356 26.8273 24.1913 25.0716 24.1913 22.9142V9.94248H7.17477V22.9142C7.17477 25.0716 8.93042 26.8273 11.0878 26.8273H20.2782ZM14.8247 4.91287C13.8178 4.91287 12.9986 5.89635 12.9986 7.10417C12.9986 7.15733 12.9851 7.20599 12.9714 7.25532C12.9642 7.28103 12.957 7.30692 12.9517 7.33374H18.4808C18.3973 5.98504 17.4543 4.91287 16.2947 4.91287H14.8247ZM25.4956 7.33377H27.1899C27.9099 7.33377 28.4943 7.91681 28.4943 8.63811C28.4943 9.35811 27.9099 9.94246 27.1899 9.94246H26.7999V22.9142C26.7999 26.5103 23.8743 29.4359 20.2782 29.4359H11.0878C7.49169 29.4359 4.56603 26.5103 4.56603 22.9142V9.94246H4.30386C3.58386 9.94246 2.99951 9.35811 2.99951 8.63811C2.99951 7.91681 3.58386 7.33377 4.30386 7.33377H5.87038H10.4369C10.4315 7.30695 10.4243 7.28105 10.4172 7.25534C10.4035 7.20601 10.3899 7.15736 10.3899 7.1042C10.3899 4.45768 12.3791 2.3042 14.8247 2.3042H16.2947C18.8878 2.3042 20.993 4.54507 21.0869 7.33377H25.4956ZM13.7264 21.8047C13.7264 22.526 13.1421 23.1091 12.4221 23.1091C11.7021 23.1091 11.1177 22.526 11.1177 21.8047V14.3439C11.1177 13.6239 11.7021 13.0395 12.4221 13.0395C13.1421 13.0395 13.7264 13.6239 13.7264 14.3439V21.8047Z"
    })
  });
};
const TwitterIcon = (props) => {
  const {
    color = COLORS.Black,
    style,
    className = "",
    viewBox = "0 0 20 20",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      d: "M20 3.94103C19.2645 4.26903 18.4744 4.49066 17.6438 4.59084C18.5008 4.0747 19.142 3.26237 19.4477 2.30542C18.6425 2.78678 17.7612 3.12561 16.8422 3.30717C16.2242 2.64306 15.4057 2.20287 14.5136 2.05496C13.6216 1.90704 12.706 2.05967 11.909 2.48915C11.1119 2.91863 10.4781 3.60093 10.1058 4.43012C9.73358 5.2593 9.64374 6.18899 9.85026 7.07483C8.2187 6.99238 6.62259 6.56558 5.16553 5.82211C3.70847 5.07865 2.42301 4.03514 1.39258 2.75931C1.04025 3.371 0.837664 4.08021 0.837664 4.83551C0.837271 5.51546 1.00364 6.18499 1.32201 6.78471C1.64038 7.38442 2.10091 7.89577 2.66273 8.27339C2.01117 8.25253 1.37397 8.07533 0.804193 7.75656V7.80975C0.804127 8.7634 1.13189 9.68771 1.73186 10.4258C2.33184 11.164 3.16707 11.6704 4.09583 11.8593C3.4914 12.024 2.85769 12.0482 2.24258 11.9302C2.50462 12.7508 3.01506 13.4684 3.70243 13.9824C4.3898 14.4965 5.21969 14.7814 6.07593 14.7972C4.62242 15.9456 2.82735 16.5685 0.979477 16.5658C0.652146 16.5659 0.325091 16.5466 0 16.5082C1.87569 17.722 4.05914 18.3661 6.28909 18.3636C13.8378 18.3636 17.9644 12.0712 17.9644 6.61385C17.9644 6.43655 17.96 6.25747 17.9521 6.08017C18.7548 5.49594 19.4476 4.77248 19.9982 3.94369L20 3.94103Z"
    })
  });
};
const UpIcon = (props) => {
  const {
    className = "",
    color = COLORS.Black,
    height,
    style,
    viewBox = "-1 -1 18 18",
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 7.16497L5.17732 9.98766C4.90799 10.257 4.47132 10.257 4.202 9.98766C3.93267 9.71833 3.93267 9.28167 4.202 9.01234L7.51234 5.702C7.78167 5.43267 8.21833 5.43267 8.48766 5.702L11.798 9.01234C12.0673 9.28167 12.0673 9.71833 11.798 9.98766C11.5287 10.257 11.092 10.257 10.8227 9.98766L8 7.16497Z",
      fill: "currentColor"
    })
  });
};
const UploaderIcon = (props) => {
  const {
    color = COLORS.Black,
    style,
    className = "",
    viewBox = "0 0 25 25",
    height,
    width
  } = props;
  return /* @__PURE__ */ jsx$1("svg", {
    className: classNames$1(`tw-fill-${color}`, `${className}`),
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      d: "M19.7917 7.29168V10.4063C19.7917 10.4063 17.7188 10.4167 17.7083 10.4063V7.29168H14.5833C14.5833 7.29168 14.5938 5.21876 14.5833 5.20834H17.7083V2.08334H19.7917V5.20834H22.9167V7.29168H19.7917ZM16.6667 11.4583V8.33334H13.5417V5.20834H5.20833C4.0625 5.20834 3.125 6.14584 3.125 7.29168V19.7917C3.125 20.9375 4.0625 21.875 5.20833 21.875H17.7083C18.8542 21.875 19.7917 20.9375 19.7917 19.7917V11.4583H16.6667ZM5.20833 19.7917L8.33333 15.625L10.4167 18.75L13.5417 14.5833L17.7083 19.7917H5.20833Z",
      fill: "#7665FF"
    })
  });
};
function WalletIcon({
  style,
  className = "",
  viewBox = "0 0 20 20",
  height,
  width
}) {
  return /* @__PURE__ */ jsx$1("svg", {
    className,
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.9082 1.875H3.48475C2.88271 1.8801 2.39802 2.3699 2.39802 2.97194V2.99745H16.5154C17.6786 2.99745 18.6225 3.93622 18.6225 5.09949V7.23214L20.0001 5.45663V2.97194C19.995 2.3699 19.5103 1.8801 18.9082 1.875ZM17.3316 8.04852H14.3878C12.7857 8.04852 11.4847 9.34954 11.4847 10.9516C11.4847 12.5536 12.7857 13.8546 14.3878 13.8597H17.3265C17.4184 13.8546 17.5102 13.8444 17.5969 13.8342L17.602 16.7985C17.602 17.4006 17.1173 17.8904 16.5153 17.8955H1.09184C0.489796 17.8904 0.00510204 17.4006 0 16.7985V5.09954C0.00510204 4.5026 0.489796 4.01791 1.09184 4.01791H16.5153C17.1122 4.01791 17.602 4.4975 17.602 5.09954V8.01791C17.5102 8.03832 17.4184 8.04852 17.3316 8.04852ZM18.6224 13.4668C18.8418 13.3189 19.0408 13.1352 19.2092 12.9311L20 11.9107V14.6709C19.9949 15.2678 19.5102 15.7525 18.9082 15.7525H18.6224V13.4668ZM19.9948 7.12496L19.204 8.14537C18.9744 8.44129 18.6785 8.68109 18.3417 8.83925C18.0254 8.99231 17.6785 9.06884 17.3264 9.06884H14.3876C13.3468 9.07394 12.505 9.91578 12.505 10.9566C12.505 11.9974 13.3468 12.8392 14.3876 12.8444H17.3315C17.7499 12.8392 18.1478 12.6454 18.403 12.3137L19.9999 10.2423L19.9948 7.12496ZM15.5305 11.4669H14.3061C14.0254 11.4669 13.7958 11.2373 13.7958 10.9566C13.7958 10.676 14.0254 10.4464 14.3061 10.4464H15.5305C15.8112 10.4464 16.0407 10.676 16.0407 10.9566C16.0407 11.2373 15.8112 11.4669 15.5305 11.4669Z",
      fill: "currentColor"
    })
  });
}
function CircleExclamationIcon({
  style,
  className = "",
  viewBox = "0 0 48 48",
  height,
  width
}) {
  return /* @__PURE__ */ jsx$1("svg", {
    className,
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24 8C15.1634 8 8 15.1634 8 24C8 32.8366 15.1634 40 24 40C32.8366 40 40 32.8366 40 24C40 15.1634 32.8366 8 24 8ZM4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24ZM24 14C25.1046 14 26 14.8954 26 16V24C26 25.1046 25.1046 26 24 26C22.8954 26 22 25.1046 22 24V16C22 14.8954 22.8954 14 24 14ZM22 32C22 30.8954 22.8954 30 24 30H24.02C25.1246 30 26.02 30.8954 26.02 32C26.02 33.1046 25.1246 34 24.02 34H24C22.8954 34 22 33.1046 22 32Z",
      fill: "currentColor"
    })
  });
}
function LoadingIcon({
  style,
  className = "",
  viewBox = "0 0 24 24",
  height,
  width
}) {
  return /* @__PURE__ */ jsx$1("svg", {
    className,
    height,
    width,
    style,
    viewBox,
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.20799 15.4917C4.37363 15.8603 4.2091 16.2933 3.8405 16.459C3.4719 16.6246 3.03881 16.4601 2.87316 16.0915C2.30025 14.8166 2 13.4285 2 12C2 6.47726 6.47726 2 12 2C17.5227 2 22 6.47726 22 12C22 17.5227 17.5227 22 12 22C9.65339 22 7.42972 21.1881 5.65267 19.7281C5.34042 19.4715 5.29526 19.0105 5.55179 18.6982C5.80833 18.386 6.26941 18.3408 6.58166 18.5973C8.09934 19.8442 9.9955 20.5366 12 20.5366C16.7145 20.5366 20.5366 16.7145 20.5366 12C20.5366 7.28549 16.7145 3.46341 12 3.46341C7.28549 3.46341 3.46341 7.28549 3.46341 12C3.46341 13.2208 3.71947 14.4046 4.20799 15.4917Z"
    })
  });
}
function AddPhotoIcon({
  style,
  className = "",
  viewBox = "0 0 24 24",
  height = 24,
  width = 24
}) {
  return /* @__PURE__ */ jsx$1("svg", {
    style,
    className,
    width,
    height,
    viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.659 14.9084C21.9236 14.2162 20.9936 13.762 19.9771 13.6323V5.71624C19.9771 4.87273 19.631 4.11574 19.0903 3.55339C18.528 2.99105 17.771 2.66663 16.9275 2.66663H4.38293C3.53942 2.66663 2.78242 3.01268 2.22008 3.55339C1.65774 4.11574 1.33331 4.87273 1.33331 5.71624V15.687V16.617V18.6285C1.33331 19.472 1.67937 20.229 2.22008 20.7913C2.78242 21.3537 3.53942 21.6781 4.38293 21.6781H16.5165C17.3168 22.3269 18.3117 22.7379 19.4147 22.7379C20.6908 22.7379 21.8371 22.2188 22.659 21.3969C23.4809 20.575 24 19.4287 24 18.1526C24 16.8766 23.4809 15.7302 22.659 14.9084ZM2.47941 5.71625C2.47941 5.19717 2.6957 4.72134 3.04176 4.37528C3.38781 4.02923 3.86364 3.81294 4.38272 3.81294H16.9273C17.4463 3.81294 17.9222 4.02923 18.2682 4.37528C18.6143 4.72134 18.8306 5.19717 18.8306 5.71625V12.4643L15.6295 9.28495C15.4133 9.06867 15.0456 9.04704 14.8077 9.28495L9.9845 14.1297L6.7186 10.8422C6.50232 10.6259 6.13463 10.6043 5.89672 10.8422L2.47941 14.3028V5.71625ZM21.8153 20.575C21.188 21.2022 20.3445 21.5699 19.3929 21.5699C18.4845 21.5699 17.641 21.2022 17.0354 20.6183C16.9921 20.575 16.9488 20.5264 16.9056 20.4777C16.8623 20.429 16.8191 20.3804 16.7758 20.3371C16.7434 20.3047 16.7109 20.2668 16.6785 20.229C16.646 20.1911 16.6136 20.1533 16.5812 20.1208C16.4946 20.0127 16.4298 19.8829 16.3649 19.7531C16.3432 19.7099 16.3216 19.672 16.3 19.6342C16.2784 19.5963 16.2567 19.5585 16.2351 19.5152C16.1918 19.4071 16.1486 19.2773 16.127 19.1475C16.1161 19.1043 16.0999 19.0556 16.0837 19.007C16.0675 18.9583 16.0513 18.9096 16.0404 18.8664C15.9972 18.6501 15.9756 18.4122 15.9756 18.1743C15.9756 17.2226 16.3649 16.3791 16.9705 15.7519C17.5977 15.1246 18.4412 14.757 19.3929 14.757C20.3445 14.757 21.188 15.1463 21.8153 15.7519C22.4425 16.3575 22.8102 17.2226 22.8102 18.1743C22.8102 19.1043 22.4209 19.9478 21.8153 20.575ZM11.4337 9.17682C11.4337 10.0369 10.7365 10.7341 9.87643 10.7341C9.01638 10.7341 8.31917 10.0369 8.31917 9.17682C8.31917 8.31677 9.01638 7.61957 9.87643 7.61957C10.7365 7.61957 11.4337 8.31677 11.4337 9.17682ZM19.9554 17.5686H21.2747C21.5992 17.5686 21.8587 17.8282 21.8587 18.1526C21.8587 18.477 21.5992 18.7366 21.2747 18.7366H19.9554V20.0559C19.9554 20.3804 19.6959 20.6399 19.3714 20.6399C19.047 20.6399 18.7875 20.3804 18.7875 20.0559V18.7366H17.4681C17.1437 18.7366 16.8842 18.477 16.8842 18.1526C16.8842 17.8282 17.1437 17.5686 17.4681 17.5686H18.7875V16.2493C18.7875 15.9249 19.047 15.6653 19.3714 15.6653C19.6959 15.6653 19.9554 15.9249 19.9554 16.2493V17.5686Z"
    })
  });
}
function PencilOutlineIcon({
  style,
  className = "",
  viewBox = "0 0 24 24",
  height = 24,
  width = 24
}) {
  return /* @__PURE__ */ jsx$1("svg", {
    style,
    className,
    width,
    height,
    viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsx$1("path", {
      d: "M15.2322 5.23223L18.7678 8.76777M16.7322 3.73223C17.7085 2.75592 19.2915 2.75592 20.2678 3.73223C21.2441 4.70854 21.2441 6.29146 20.2678 7.26777L6.50005 21.0355H3.00005V17.4644L16.7322 3.73223Z",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
}
function ChrevronUpOutlineIcon({
  style,
  className = "",
  viewBox = "0 0 24 25",
  height = 24,
  width = 25
}) {
  return /* @__PURE__ */ jsx$1("svg", {
    style,
    className,
    width,
    height,
    viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsx$1("path", {
      d: "M5 15.6923L12 8.69232L19 15.6923",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
}
function CheckCircleIcon({
  style,
  className = "",
  viewBox = "0 0 24 24",
  height = 24,
  width = 24
}) {
  return /* @__PURE__ */ jsxs("svg", {
    style,
    className,
    width,
    height,
    viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx$1("circle", {
      cx: "12",
      cy: "12",
      r: "12",
      fill: "#00C566"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21508 0.913451 7.4078C0.00519941 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.807 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0865C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6934 24 14.3734 24 12C23.9963 8.81853 22.7309 5.76842 20.4812 3.51878C18.2316 1.26914 15.1815 0.00367709 12 0ZM17.7151 9.89874L14.3302 13.1295L10.9453 16.3603C10.7732 16.524 10.5447 16.6154 10.3071 16.6154C10.0695 16.6154 9.841 16.524 9.66887 16.3603L6.28486 13.1295C6.10807 12.9602 6.00572 12.7276 6.0003 12.4828C5.99488 12.238 6.08683 12.0011 6.25596 11.8241C6.42509 11.6471 6.65756 11.5445 6.90231 11.5387C7.14706 11.533 7.38408 11.6247 7.5613 11.7936L10.3071 14.4159L16.4387 8.5628C16.6159 8.3939 16.8529 8.30225 17.0977 8.30797C17.3425 8.3137 17.5749 8.41635 17.744 8.59336C17.9132 8.77037 18.0051 9.00727 17.9997 9.25203C17.9943 9.49679 17.8919 9.72938 17.7151 9.89874Z",
      fill: "#D9F7E8"
    })]
  });
}
function CreditCardIcon$2({
  style,
  className = "",
  viewBox = "0 0 24 24",
  height = 24,
  width = 24
}) {
  return /* @__PURE__ */ jsxs("svg", {
    className,
    height,
    width,
    style,
    viewBox,
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M4.79999 4.8C3.47451 4.8 2.39999 5.87452 2.39999 7.2V8.4H21.6V7.2C21.6 5.87452 20.5255 4.8 19.2 4.8H4.79999Z"
    }), /* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.6 10.8H2.39999V16.8C2.39999 18.1255 3.47451 19.2 4.79999 19.2H19.2C20.5255 19.2 21.6 18.1255 21.6 16.8V10.8ZM4.79999 15.6C4.79999 14.9373 5.33725 14.4 5.99999 14.4H7.19999C7.86274 14.4 8.39999 14.9373 8.39999 15.6C8.39999 16.2627 7.86274 16.8 7.19999 16.8H5.99999C5.33725 16.8 4.79999 16.2627 4.79999 15.6ZM10.8 14.4C10.1373 14.4 9.59999 14.9373 9.59999 15.6C9.59999 16.2627 10.1373 16.8 10.8 16.8H12C12.6627 16.8 13.2 16.2627 13.2 15.6C13.2 14.9373 12.6627 14.4 12 14.4H10.8Z"
    })]
  });
}
const Icon$1 = {
  ARROW_LEFT: ArrowLeftIcon$2,
  BACK: BackIcon,
  CHECK: CheckIcon,
  CIRCLE_CHECK: CircleCheckIcon,
  CIRCLE_PLAY: CirclePlayIcon,
  CLEAR: ClearIcon,
  CLOSE_CIRCLE: CloseCircleIcon,
  CLOSE: CloseIcon,
  DELETE: DeleteIcon,
  DISCORD: DiscordIcon,
  DOWN: DownIcon,
  DOWNLOAD: DownloadIcon,
  EDIT: EditIcon,
  EYE: EyeIcon,
  FACEBOOK: FacebookIcon,
  FILTER: FilterIcon,
  IMAGE: ImageIcon,
  INFO: InfoIcon,
  LOGOUT: LogoutIcon,
  NEXT: NextIcon,
  OPTIONS: OptionsIcon,
  OUTLINE_CHECK_CIRCLE: OutlineCheckCircle,
  OUTLINE_X_CIRCLE: OutlineXCircle,
  PHOTO: PhotoIcon,
  PLUS: PlusIcon,
  QUESTION_MARK: QuestionMark,
  REMOVE_GALLERY: RemoveGalleryIcon,
  SEARCH: SearchIcon,
  SETTING: SettingIcon,
  STORE: StoreIcon,
  STORE_NFT: StoreNFTIcon,
  TELEGRAM: TelegramIcon,
  TRASH: TrashIcon,
  TWITTER: TwitterIcon,
  UP: UpIcon,
  UPLOADER: UploaderIcon,
  [IconName.CIRCLE_EXCLAMATION]: CircleExclamationIcon,
  [IconName.INFORMATION_CIRCLE]: InformationCircleIcon,
  [IconName.WALLET]: WalletIcon,
  [IconName.REFRESH]: WalletIcon$1,
  [IconName.CIRCLE_CHECK_OUTLINE]: CircleCheckOutlineIcon,
  [IconName.CIRCLE_EXCLAMTION_SOLID]: CircleExclamationSolidIcon,
  [IconName.LOADING]: LoadingIcon,
  [IconName.ADD_PHOTO]: AddPhotoIcon,
  [IconName.PENCIL_OUTLINE]: PencilOutlineIcon,
  [IconName.CHREVRON_UP_OUTLINE]: ChrevronUpOutlineIcon,
  [IconName.CHECK_CIRCLE_ICON]: CheckCircleIcon,
  [IconName.CREDIT_CARD_ICON]: CreditCardIcon$2
};
const Icon = (_a2) => {
  var _b = _a2, {
    name,
    color,
    viewBox,
    size = IconSize.MEDIUM,
    width = ICON_STROKE_SIZE[IconSize.MEDIUM],
    height = ICON_STROKE_SIZE[IconSize.MEDIUM]
  } = _b, props = __objRest(_b, [
    "name",
    "color",
    "viewBox",
    "size",
    "width",
    "height"
  ]);
  const type = name;
  const NewIcon = Icon$1[type];
  return /* @__PURE__ */ jsx$1(NewIcon, __spreadValues({
    color,
    width: size === IconSize.CUSTOM ? width : ICON_STROKE_SIZE[size],
    height: size === IconSize.CUSTOM ? height : ICON_STROKE_SIZE[size],
    viewBox
  }, props));
};
Icon.displayName = "Icon";
function Button(_c) {
  var _d = _c, {
    children: children2,
    variant = "primary",
    size = "medium",
    isLoading = false,
    className = "",
    startIcon
  } = _d, rest = __objRest(_d, [
    "children",
    "variant",
    "size",
    "isLoading",
    "className",
    "startIcon"
  ]);
  const defaultButtonClass = "tw-rounded";
  const variantClass = () => {
    switch (variant) {
      case "primary":
        return `disabled:tw-bg-Gray-200 disabled:tw-text-Gray-400 hover:tw-bg-DarkPrimary tw-bg-Primary-600 tw-text-White ${defaultButtonClass} tw-fill-White`;
      case "secondary":
        return `disabled:tw-bg-Gray-200 disabled:tw-text-Gray-400 hover:tw-bg-Gray-300 tw-bg-Secondary tw-text-Gray-800 ${defaultButtonClass} tw-fill-Grey-800`;
      case "tertiary":
        return `disabled:tw-bg-LightNudePrimary disabled:tw-text-DarkNudePrimary hover:tw-bg-DarkNudePrimary tw-bg-Tertiary tw-text-DarkPrimary tw-border tw-border-solid tw-border-DarkNudePrimary tw-rounded ${defaultButtonClass} tw-fill-DarkPrimary`;
      case "text":
        return `hover:tw-bg-NudePrimary disabled:tw-bg-White disabled:tw-text-Gray-400 tw-text-Primary-600 tw-bg-transparent ${defaultButtonClass} tw-fill-Primary-600`;
      case "custom":
        return "";
      default:
        return "";
    }
  };
  const sizeClass = () => {
    switch (size) {
      case "large":
        return "tw-px-6 tw-py-3 tablet:tw-min-w-[160px]";
      case "medium":
        return "tw-px-4 tw-py-2 tw-min-w-[120px]";
      case "small":
        return "tw-px-4 tw-py-2 tw-min-w-[100px]";
      case "fullWidth":
        return "tw-px-6 tw-py-3 tw-w-full";
      default:
        return "";
    }
  };
  return /* @__PURE__ */ jsx$1("button", __spreadProps(__spreadValues({
    type: "button",
    className: classNames$1(`tw-border-none ${variantClass()} ${sizeClass()} ${defaultButtonClass} ${className}`, {
      "tw-cursor-not-allowed": isLoading
    })
  }, rest), {
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-relative tw-items-center tw-w-full",
      children: [startIcon && /* @__PURE__ */ jsx$1("div", {
        className: classNames$1("tw-mr-1", {
          "tw-invisible": isLoading
        }),
        children: startIcon
      }), isLoading && /* @__PURE__ */ jsx$1(Icon, {
        name: IconName.LOADING,
        className: "tw-absolute tw-left-[calc(50%-12px)] tw-mx-[auto] tw-animate-spin"
      }), /* @__PURE__ */ jsx$1("div", {
        className: classNames$1("tw-w-full tw-relative tw-flex tw-items-center tw-justify-center", {
          "tw-invisible": isLoading
        }),
        children: children2
      })]
    })
  }));
}
Button.displayName = "Button";
var reactDom = { exports: {} };
var reactDom_production_min = {};
var scheduler = { exports: {} };
var scheduler_production_min = {};
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function(exports) {
  var f2, g2, h2, k2;
  if (typeof performance === "object" && typeof performance.now === "function") {
    var l2 = performance;
    exports.unstable_now = function() {
      return l2.now();
    };
  } else {
    var p2 = Date, q2 = p2.now();
    exports.unstable_now = function() {
      return p2.now() - q2;
    };
  }
  if (typeof window === "undefined" || typeof MessageChannel !== "function") {
    var t2 = null, u = null, w2 = function() {
      if (t2 !== null)
        try {
          var a2 = exports.unstable_now();
          t2(true, a2);
          t2 = null;
        } catch (b2) {
          throw setTimeout(w2, 0), b2;
        }
    };
    f2 = function(a2) {
      t2 !== null ? setTimeout(f2, 0, a2) : (t2 = a2, setTimeout(w2, 0));
    };
    g2 = function(a2, b2) {
      u = setTimeout(a2, b2);
    };
    h2 = function() {
      clearTimeout(u);
    };
    exports.unstable_shouldYield = function() {
      return false;
    };
    k2 = exports.unstable_forceFrameRate = function() {
    };
  } else {
    var x2 = window.setTimeout, y2 = window.clearTimeout;
    if (typeof console !== "undefined") {
      var z2 = window.cancelAnimationFrame;
      typeof window.requestAnimationFrame !== "function" && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
      typeof z2 !== "function" && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var A2 = false, B2 = null, C = -1, D2 = 5, E = 0;
    exports.unstable_shouldYield = function() {
      return exports.unstable_now() >= E;
    };
    k2 = function() {
    };
    exports.unstable_forceFrameRate = function(a2) {
      0 > a2 || 125 < a2 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : D2 = 0 < a2 ? Math.floor(1e3 / a2) : 5;
    };
    var F2 = new MessageChannel(), G2 = F2.port2;
    F2.port1.onmessage = function() {
      if (B2 !== null) {
        var a2 = exports.unstable_now();
        E = a2 + D2;
        try {
          B2(true, a2) ? G2.postMessage(null) : (A2 = false, B2 = null);
        } catch (b2) {
          throw G2.postMessage(null), b2;
        }
      } else
        A2 = false;
    };
    f2 = function(a2) {
      B2 = a2;
      A2 || (A2 = true, G2.postMessage(null));
    };
    g2 = function(a2, b2) {
      C = x2(function() {
        a2(exports.unstable_now());
      }, b2);
    };
    h2 = function() {
      y2(C);
      C = -1;
    };
  }
  function H2(a2, b2) {
    var c2 = a2.length;
    a2.push(b2);
    a:
      for (; ; ) {
        var d2 = c2 - 1 >>> 1, e2 = a2[d2];
        if (e2 !== void 0 && 0 < I2(e2, b2))
          a2[d2] = b2, a2[c2] = e2, c2 = d2;
        else
          break a;
      }
  }
  function J(a2) {
    a2 = a2[0];
    return a2 === void 0 ? null : a2;
  }
  function K(a2) {
    var b2 = a2[0];
    if (b2 !== void 0) {
      var c2 = a2.pop();
      if (c2 !== b2) {
        a2[0] = c2;
        a:
          for (var d2 = 0, e2 = a2.length; d2 < e2; ) {
            var m2 = 2 * (d2 + 1) - 1, n2 = a2[m2], v2 = m2 + 1, r2 = a2[v2];
            if (n2 !== void 0 && 0 > I2(n2, c2))
              r2 !== void 0 && 0 > I2(r2, n2) ? (a2[d2] = r2, a2[v2] = c2, d2 = v2) : (a2[d2] = n2, a2[m2] = c2, d2 = m2);
            else if (r2 !== void 0 && 0 > I2(r2, c2))
              a2[d2] = r2, a2[v2] = c2, d2 = v2;
            else
              break a;
          }
      }
      return b2;
    }
    return null;
  }
  function I2(a2, b2) {
    var c2 = a2.sortIndex - b2.sortIndex;
    return c2 !== 0 ? c2 : a2.id - b2.id;
  }
  var L = [], M2 = [], N2 = 1, O2 = null, P2 = 3, Q = false, R2 = false, S2 = false;
  function T2(a2) {
    for (var b2 = J(M2); b2 !== null; ) {
      if (b2.callback === null)
        K(M2);
      else if (b2.startTime <= a2)
        K(M2), b2.sortIndex = b2.expirationTime, H2(L, b2);
      else
        break;
      b2 = J(M2);
    }
  }
  function U2(a2) {
    S2 = false;
    T2(a2);
    if (!R2)
      if (J(L) !== null)
        R2 = true, f2(V2);
      else {
        var b2 = J(M2);
        b2 !== null && g2(U2, b2.startTime - a2);
      }
  }
  function V2(a2, b2) {
    R2 = false;
    S2 && (S2 = false, h2());
    Q = true;
    var c2 = P2;
    try {
      T2(b2);
      for (O2 = J(L); O2 !== null && (!(O2.expirationTime > b2) || a2 && !exports.unstable_shouldYield()); ) {
        var d2 = O2.callback;
        if (typeof d2 === "function") {
          O2.callback = null;
          P2 = O2.priorityLevel;
          var e2 = d2(O2.expirationTime <= b2);
          b2 = exports.unstable_now();
          typeof e2 === "function" ? O2.callback = e2 : O2 === J(L) && K(L);
          T2(b2);
        } else
          K(L);
        O2 = J(L);
      }
      if (O2 !== null)
        var m2 = true;
      else {
        var n2 = J(M2);
        n2 !== null && g2(U2, n2.startTime - b2);
        m2 = false;
      }
      return m2;
    } finally {
      O2 = null, P2 = c2, Q = false;
    }
  }
  var W2 = k2;
  exports.unstable_IdlePriority = 5;
  exports.unstable_ImmediatePriority = 1;
  exports.unstable_LowPriority = 4;
  exports.unstable_NormalPriority = 3;
  exports.unstable_Profiling = null;
  exports.unstable_UserBlockingPriority = 2;
  exports.unstable_cancelCallback = function(a2) {
    a2.callback = null;
  };
  exports.unstable_continueExecution = function() {
    R2 || Q || (R2 = true, f2(V2));
  };
  exports.unstable_getCurrentPriorityLevel = function() {
    return P2;
  };
  exports.unstable_getFirstCallbackNode = function() {
    return J(L);
  };
  exports.unstable_next = function(a2) {
    switch (P2) {
      case 1:
      case 2:
      case 3:
        var b2 = 3;
        break;
      default:
        b2 = P2;
    }
    var c2 = P2;
    P2 = b2;
    try {
      return a2();
    } finally {
      P2 = c2;
    }
  };
  exports.unstable_pauseExecution = function() {
  };
  exports.unstable_requestPaint = W2;
  exports.unstable_runWithPriority = function(a2, b2) {
    switch (a2) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        a2 = 3;
    }
    var c2 = P2;
    P2 = a2;
    try {
      return b2();
    } finally {
      P2 = c2;
    }
  };
  exports.unstable_scheduleCallback = function(a2, b2, c2) {
    var d2 = exports.unstable_now();
    typeof c2 === "object" && c2 !== null ? (c2 = c2.delay, c2 = typeof c2 === "number" && 0 < c2 ? d2 + c2 : d2) : c2 = d2;
    switch (a2) {
      case 1:
        var e2 = -1;
        break;
      case 2:
        e2 = 250;
        break;
      case 5:
        e2 = 1073741823;
        break;
      case 4:
        e2 = 1e4;
        break;
      default:
        e2 = 5e3;
    }
    e2 = c2 + e2;
    a2 = { id: N2++, callback: b2, priorityLevel: a2, startTime: c2, expirationTime: e2, sortIndex: -1 };
    c2 > d2 ? (a2.sortIndex = c2, H2(M2, a2), J(L) === null && a2 === J(M2) && (S2 ? h2() : S2 = true, g2(U2, c2 - d2))) : (a2.sortIndex = e2, H2(L, a2), R2 || Q || (R2 = true, f2(V2)));
    return a2;
  };
  exports.unstable_wrapCallback = function(a2) {
    var b2 = P2;
    return function() {
      var c2 = P2;
      P2 = b2;
      try {
        return a2.apply(this, arguments);
      } finally {
        P2 = c2;
      }
    };
  };
})(scheduler_production_min);
{
  scheduler.exports = scheduler_production_min;
}
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aa = React__default, m$1 = objectAssign, r$1 = scheduler.exports;
function y$1(a2) {
  for (var b2 = "https://reactjs.org/docs/error-decoder.html?invariant=" + a2, c2 = 1; c2 < arguments.length; c2++)
    b2 += "&args[]=" + encodeURIComponent(arguments[c2]);
  return "Minified React error #" + a2 + "; visit " + b2 + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!aa)
  throw Error(y$1(227));
var ba = new Set(), ca = {};
function da(a2, b2) {
  ea(a2, b2);
  ea(a2 + "Capture", b2);
}
function ea(a2, b2) {
  ca[a2] = b2;
  for (a2 = 0; a2 < b2.length; a2++)
    ba.add(b2[a2]);
}
var fa = !(typeof window === "undefined" || typeof window.document === "undefined" || typeof window.document.createElement === "undefined"), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a2) {
  if (ia.call(ka, a2))
    return true;
  if (ia.call(ja, a2))
    return false;
  if (ha.test(a2))
    return ka[a2] = true;
  ja[a2] = true;
  return false;
}
function ma(a2, b2, c2, d2) {
  if (c2 !== null && c2.type === 0)
    return false;
  switch (typeof b2) {
    case "function":
    case "symbol":
      return true;
    case "boolean":
      if (d2)
        return false;
      if (c2 !== null)
        return !c2.acceptsBooleans;
      a2 = a2.toLowerCase().slice(0, 5);
      return a2 !== "data-" && a2 !== "aria-";
    default:
      return false;
  }
}
function na(a2, b2, c2, d2) {
  if (b2 === null || typeof b2 === "undefined" || ma(a2, b2, c2, d2))
    return true;
  if (d2)
    return false;
  if (c2 !== null)
    switch (c2.type) {
      case 3:
        return !b2;
      case 4:
        return b2 === false;
      case 5:
        return isNaN(b2);
      case 6:
        return isNaN(b2) || 1 > b2;
    }
  return false;
}
function B(a2, b2, c2, d2, e2, f2, g2) {
  this.acceptsBooleans = b2 === 2 || b2 === 3 || b2 === 4;
  this.attributeName = d2;
  this.attributeNamespace = e2;
  this.mustUseProperty = c2;
  this.propertyName = a2;
  this.type = b2;
  this.sanitizeURL = f2;
  this.removeEmptyString = g2;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a2) {
  D[a2] = new B(a2, 0, false, a2, null, false, false);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(a2) {
  var b2 = a2[0];
  D[b2] = new B(b2, 1, false, a2[1], null, false, false);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function(a2) {
  D[a2] = new B(a2, 2, false, a2.toLowerCase(), null, false, false);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(a2) {
  D[a2] = new B(a2, 2, false, a2, null, false, false);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a2) {
  D[a2] = new B(a2, 3, false, a2.toLowerCase(), null, false, false);
});
["checked", "multiple", "muted", "selected"].forEach(function(a2) {
  D[a2] = new B(a2, 3, true, a2, null, false, false);
});
["capture", "download"].forEach(function(a2) {
  D[a2] = new B(a2, 4, false, a2, null, false, false);
});
["cols", "rows", "size", "span"].forEach(function(a2) {
  D[a2] = new B(a2, 6, false, a2, null, false, false);
});
["rowSpan", "start"].forEach(function(a2) {
  D[a2] = new B(a2, 5, false, a2.toLowerCase(), null, false, false);
});
var oa = /[\-:]([a-z])/g;
function pa(a2) {
  return a2[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a2) {
  var b2 = a2.replace(oa, pa);
  D[b2] = new B(b2, 1, false, a2, null, false, false);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a2) {
  var b2 = a2.replace(oa, pa);
  D[b2] = new B(b2, 1, false, a2, "http://www.w3.org/1999/xlink", false, false);
});
["xml:base", "xml:lang", "xml:space"].forEach(function(a2) {
  var b2 = a2.replace(oa, pa);
  D[b2] = new B(b2, 1, false, a2, "http://www.w3.org/XML/1998/namespace", false, false);
});
["tabIndex", "crossOrigin"].forEach(function(a2) {
  D[a2] = new B(a2, 1, false, a2.toLowerCase(), null, false, false);
});
D.xlinkHref = new B("xlinkHref", 1, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
["src", "href", "action", "formAction"].forEach(function(a2) {
  D[a2] = new B(a2, 1, false, a2.toLowerCase(), null, true, true);
});
function qa(a2, b2, c2, d2) {
  var e2 = D.hasOwnProperty(b2) ? D[b2] : null;
  var f2 = e2 !== null ? e2.type === 0 : d2 ? false : !(2 < b2.length) || b2[0] !== "o" && b2[0] !== "O" || b2[1] !== "n" && b2[1] !== "N" ? false : true;
  f2 || (na(b2, c2, e2, d2) && (c2 = null), d2 || e2 === null ? la(b2) && (c2 === null ? a2.removeAttribute(b2) : a2.setAttribute(b2, "" + c2)) : e2.mustUseProperty ? a2[e2.propertyName] = c2 === null ? e2.type === 3 ? false : "" : c2 : (b2 = e2.attributeName, d2 = e2.attributeNamespace, c2 === null ? a2.removeAttribute(b2) : (e2 = e2.type, c2 = e2 === 3 || e2 === 4 && c2 === true ? "" : "" + c2, d2 ? a2.setAttributeNS(d2, b2, c2) : a2.setAttribute(b2, c2))));
}
var ra = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if (typeof Symbol === "function" && Symbol.for) {
  var E = Symbol.for;
  sa = E("react.element");
  ta = E("react.portal");
  ua = E("react.fragment");
  wa = E("react.strict_mode");
  xa = E("react.profiler");
  ya = E("react.provider");
  za = E("react.context");
  Aa = E("react.forward_ref");
  Ba = E("react.suspense");
  Ca = E("react.suspense_list");
  Da = E("react.memo");
  Ea = E("react.lazy");
  Fa = E("react.block");
  E("react.scope");
  Ga = E("react.opaque.id");
  Ha = E("react.debug_trace_mode");
  Ia = E("react.offscreen");
  Ja = E("react.legacy_hidden");
}
var Ka = typeof Symbol === "function" && Symbol.iterator;
function La(a2) {
  if (a2 === null || typeof a2 !== "object")
    return null;
  a2 = Ka && a2[Ka] || a2["@@iterator"];
  return typeof a2 === "function" ? a2 : null;
}
var Ma;
function Na(a2) {
  if (Ma === void 0)
    try {
      throw Error();
    } catch (c2) {
      var b2 = c2.stack.trim().match(/\n( *(at )?)/);
      Ma = b2 && b2[1] || "";
    }
  return "\n" + Ma + a2;
}
var Oa = false;
function Pa(a2, b2) {
  if (!a2 || Oa)
    return "";
  Oa = true;
  var c2 = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;
  try {
    if (b2)
      if (b2 = function() {
        throw Error();
      }, Object.defineProperty(b2.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect === "object" && Reflect.construct) {
        try {
          Reflect.construct(b2, []);
        } catch (k2) {
          var d2 = k2;
        }
        Reflect.construct(a2, [], b2);
      } else {
        try {
          b2.call();
        } catch (k2) {
          d2 = k2;
        }
        a2.call(b2.prototype);
      }
    else {
      try {
        throw Error();
      } catch (k2) {
        d2 = k2;
      }
      a2();
    }
  } catch (k2) {
    if (k2 && d2 && typeof k2.stack === "string") {
      for (var e2 = k2.stack.split("\n"), f2 = d2.stack.split("\n"), g2 = e2.length - 1, h2 = f2.length - 1; 1 <= g2 && 0 <= h2 && e2[g2] !== f2[h2]; )
        h2--;
      for (; 1 <= g2 && 0 <= h2; g2--, h2--)
        if (e2[g2] !== f2[h2]) {
          if (g2 !== 1 || h2 !== 1) {
            do
              if (g2--, h2--, 0 > h2 || e2[g2] !== f2[h2])
                return "\n" + e2[g2].replace(" at new ", " at ");
            while (1 <= g2 && 0 <= h2);
          }
          break;
        }
    }
  } finally {
    Oa = false, Error.prepareStackTrace = c2;
  }
  return (a2 = a2 ? a2.displayName || a2.name : "") ? Na(a2) : "";
}
function Qa(a2) {
  switch (a2.tag) {
    case 5:
      return Na(a2.type);
    case 16:
      return Na("Lazy");
    case 13:
      return Na("Suspense");
    case 19:
      return Na("SuspenseList");
    case 0:
    case 2:
    case 15:
      return a2 = Pa(a2.type, false), a2;
    case 11:
      return a2 = Pa(a2.type.render, false), a2;
    case 22:
      return a2 = Pa(a2.type._render, false), a2;
    case 1:
      return a2 = Pa(a2.type, true), a2;
    default:
      return "";
  }
}
function Ra(a2) {
  if (a2 == null)
    return null;
  if (typeof a2 === "function")
    return a2.displayName || a2.name || null;
  if (typeof a2 === "string")
    return a2;
  switch (a2) {
    case ua:
      return "Fragment";
    case ta:
      return "Portal";
    case xa:
      return "Profiler";
    case wa:
      return "StrictMode";
    case Ba:
      return "Suspense";
    case Ca:
      return "SuspenseList";
  }
  if (typeof a2 === "object")
    switch (a2.$$typeof) {
      case za:
        return (a2.displayName || "Context") + ".Consumer";
      case ya:
        return (a2._context.displayName || "Context") + ".Provider";
      case Aa:
        var b2 = a2.render;
        b2 = b2.displayName || b2.name || "";
        return a2.displayName || (b2 !== "" ? "ForwardRef(" + b2 + ")" : "ForwardRef");
      case Da:
        return Ra(a2.type);
      case Fa:
        return Ra(a2._render);
      case Ea:
        b2 = a2._payload;
        a2 = a2._init;
        try {
          return Ra(a2(b2));
        } catch (c2) {
        }
    }
  return null;
}
function Sa(a2) {
  switch (typeof a2) {
    case "boolean":
    case "number":
    case "object":
    case "string":
    case "undefined":
      return a2;
    default:
      return "";
  }
}
function Ta(a2) {
  var b2 = a2.type;
  return (a2 = a2.nodeName) && a2.toLowerCase() === "input" && (b2 === "checkbox" || b2 === "radio");
}
function Ua(a2) {
  var b2 = Ta(a2) ? "checked" : "value", c2 = Object.getOwnPropertyDescriptor(a2.constructor.prototype, b2), d2 = "" + a2[b2];
  if (!a2.hasOwnProperty(b2) && typeof c2 !== "undefined" && typeof c2.get === "function" && typeof c2.set === "function") {
    var e2 = c2.get, f2 = c2.set;
    Object.defineProperty(a2, b2, { configurable: true, get: function() {
      return e2.call(this);
    }, set: function(a3) {
      d2 = "" + a3;
      f2.call(this, a3);
    } });
    Object.defineProperty(a2, b2, { enumerable: c2.enumerable });
    return { getValue: function() {
      return d2;
    }, setValue: function(a3) {
      d2 = "" + a3;
    }, stopTracking: function() {
      a2._valueTracker = null;
      delete a2[b2];
    } };
  }
}
function Va(a2) {
  a2._valueTracker || (a2._valueTracker = Ua(a2));
}
function Wa(a2) {
  if (!a2)
    return false;
  var b2 = a2._valueTracker;
  if (!b2)
    return true;
  var c2 = b2.getValue();
  var d2 = "";
  a2 && (d2 = Ta(a2) ? a2.checked ? "true" : "false" : a2.value);
  a2 = d2;
  return a2 !== c2 ? (b2.setValue(a2), true) : false;
}
function Xa(a2) {
  a2 = a2 || (typeof document !== "undefined" ? document : void 0);
  if (typeof a2 === "undefined")
    return null;
  try {
    return a2.activeElement || a2.body;
  } catch (b2) {
    return a2.body;
  }
}
function Ya(a2, b2) {
  var c2 = b2.checked;
  return m$1({}, b2, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: c2 != null ? c2 : a2._wrapperState.initialChecked });
}
function Za(a2, b2) {
  var c2 = b2.defaultValue == null ? "" : b2.defaultValue, d2 = b2.checked != null ? b2.checked : b2.defaultChecked;
  c2 = Sa(b2.value != null ? b2.value : c2);
  a2._wrapperState = { initialChecked: d2, initialValue: c2, controlled: b2.type === "checkbox" || b2.type === "radio" ? b2.checked != null : b2.value != null };
}
function $a(a2, b2) {
  b2 = b2.checked;
  b2 != null && qa(a2, "checked", b2, false);
}
function ab(a2, b2) {
  $a(a2, b2);
  var c2 = Sa(b2.value), d2 = b2.type;
  if (c2 != null)
    if (d2 === "number") {
      if (c2 === 0 && a2.value === "" || a2.value != c2)
        a2.value = "" + c2;
    } else
      a2.value !== "" + c2 && (a2.value = "" + c2);
  else if (d2 === "submit" || d2 === "reset") {
    a2.removeAttribute("value");
    return;
  }
  b2.hasOwnProperty("value") ? bb(a2, b2.type, c2) : b2.hasOwnProperty("defaultValue") && bb(a2, b2.type, Sa(b2.defaultValue));
  b2.checked == null && b2.defaultChecked != null && (a2.defaultChecked = !!b2.defaultChecked);
}
function cb(a2, b2, c2) {
  if (b2.hasOwnProperty("value") || b2.hasOwnProperty("defaultValue")) {
    var d2 = b2.type;
    if (!(d2 !== "submit" && d2 !== "reset" || b2.value !== void 0 && b2.value !== null))
      return;
    b2 = "" + a2._wrapperState.initialValue;
    c2 || b2 === a2.value || (a2.value = b2);
    a2.defaultValue = b2;
  }
  c2 = a2.name;
  c2 !== "" && (a2.name = "");
  a2.defaultChecked = !!a2._wrapperState.initialChecked;
  c2 !== "" && (a2.name = c2);
}
function bb(a2, b2, c2) {
  if (b2 !== "number" || Xa(a2.ownerDocument) !== a2)
    c2 == null ? a2.defaultValue = "" + a2._wrapperState.initialValue : a2.defaultValue !== "" + c2 && (a2.defaultValue = "" + c2);
}
function db(a2) {
  var b2 = "";
  aa.Children.forEach(a2, function(a3) {
    a3 != null && (b2 += a3);
  });
  return b2;
}
function eb(a2, b2) {
  a2 = m$1({ children: void 0 }, b2);
  if (b2 = db(b2.children))
    a2.children = b2;
  return a2;
}
function fb(a2, b2, c2, d2) {
  a2 = a2.options;
  if (b2) {
    b2 = {};
    for (var e2 = 0; e2 < c2.length; e2++)
      b2["$" + c2[e2]] = true;
    for (c2 = 0; c2 < a2.length; c2++)
      e2 = b2.hasOwnProperty("$" + a2[c2].value), a2[c2].selected !== e2 && (a2[c2].selected = e2), e2 && d2 && (a2[c2].defaultSelected = true);
  } else {
    c2 = "" + Sa(c2);
    b2 = null;
    for (e2 = 0; e2 < a2.length; e2++) {
      if (a2[e2].value === c2) {
        a2[e2].selected = true;
        d2 && (a2[e2].defaultSelected = true);
        return;
      }
      b2 !== null || a2[e2].disabled || (b2 = a2[e2]);
    }
    b2 !== null && (b2.selected = true);
  }
}
function gb(a2, b2) {
  if (b2.dangerouslySetInnerHTML != null)
    throw Error(y$1(91));
  return m$1({}, b2, { value: void 0, defaultValue: void 0, children: "" + a2._wrapperState.initialValue });
}
function hb(a2, b2) {
  var c2 = b2.value;
  if (c2 == null) {
    c2 = b2.children;
    b2 = b2.defaultValue;
    if (c2 != null) {
      if (b2 != null)
        throw Error(y$1(92));
      if (Array.isArray(c2)) {
        if (!(1 >= c2.length))
          throw Error(y$1(93));
        c2 = c2[0];
      }
      b2 = c2;
    }
    b2 == null && (b2 = "");
    c2 = b2;
  }
  a2._wrapperState = { initialValue: Sa(c2) };
}
function ib(a2, b2) {
  var c2 = Sa(b2.value), d2 = Sa(b2.defaultValue);
  c2 != null && (c2 = "" + c2, c2 !== a2.value && (a2.value = c2), b2.defaultValue == null && a2.defaultValue !== c2 && (a2.defaultValue = c2));
  d2 != null && (a2.defaultValue = "" + d2);
}
function jb(a2) {
  var b2 = a2.textContent;
  b2 === a2._wrapperState.initialValue && b2 !== "" && b2 !== null && (a2.value = b2);
}
var kb = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
function lb(a2) {
  switch (a2) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
function mb(a2, b2) {
  return a2 == null || a2 === "http://www.w3.org/1999/xhtml" ? lb(b2) : a2 === "http://www.w3.org/2000/svg" && b2 === "foreignObject" ? "http://www.w3.org/1999/xhtml" : a2;
}
var nb, ob = function(a2) {
  return typeof MSApp !== "undefined" && MSApp.execUnsafeLocalFunction ? function(b2, c2, d2, e2) {
    MSApp.execUnsafeLocalFunction(function() {
      return a2(b2, c2, d2, e2);
    });
  } : a2;
}(function(a2, b2) {
  if (a2.namespaceURI !== kb.svg || "innerHTML" in a2)
    a2.innerHTML = b2;
  else {
    nb = nb || document.createElement("div");
    nb.innerHTML = "<svg>" + b2.valueOf().toString() + "</svg>";
    for (b2 = nb.firstChild; a2.firstChild; )
      a2.removeChild(a2.firstChild);
    for (; b2.firstChild; )
      a2.appendChild(b2.firstChild);
  }
});
function pb(a2, b2) {
  if (b2) {
    var c2 = a2.firstChild;
    if (c2 && c2 === a2.lastChild && c2.nodeType === 3) {
      c2.nodeValue = b2;
      return;
    }
  }
  a2.textContent = b2;
}
var qb = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridArea: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
}, rb = ["Webkit", "ms", "Moz", "O"];
Object.keys(qb).forEach(function(a2) {
  rb.forEach(function(b2) {
    b2 = b2 + a2.charAt(0).toUpperCase() + a2.substring(1);
    qb[b2] = qb[a2];
  });
});
function sb(a2, b2, c2) {
  return b2 == null || typeof b2 === "boolean" || b2 === "" ? "" : c2 || typeof b2 !== "number" || b2 === 0 || qb.hasOwnProperty(a2) && qb[a2] ? ("" + b2).trim() : b2 + "px";
}
function tb(a2, b2) {
  a2 = a2.style;
  for (var c2 in b2)
    if (b2.hasOwnProperty(c2)) {
      var d2 = c2.indexOf("--") === 0, e2 = sb(c2, b2[c2], d2);
      c2 === "float" && (c2 = "cssFloat");
      d2 ? a2.setProperty(c2, e2) : a2[c2] = e2;
    }
}
var ub = m$1({ menuitem: true }, { area: true, base: true, br: true, col: true, embed: true, hr: true, img: true, input: true, keygen: true, link: true, meta: true, param: true, source: true, track: true, wbr: true });
function vb(a2, b2) {
  if (b2) {
    if (ub[a2] && (b2.children != null || b2.dangerouslySetInnerHTML != null))
      throw Error(y$1(137, a2));
    if (b2.dangerouslySetInnerHTML != null) {
      if (b2.children != null)
        throw Error(y$1(60));
      if (!(typeof b2.dangerouslySetInnerHTML === "object" && "__html" in b2.dangerouslySetInnerHTML))
        throw Error(y$1(61));
    }
    if (b2.style != null && typeof b2.style !== "object")
      throw Error(y$1(62));
  }
}
function wb(a2, b2) {
  if (a2.indexOf("-") === -1)
    return typeof b2.is === "string";
  switch (a2) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return false;
    default:
      return true;
  }
}
function xb(a2) {
  a2 = a2.target || a2.srcElement || window;
  a2.correspondingUseElement && (a2 = a2.correspondingUseElement);
  return a2.nodeType === 3 ? a2.parentNode : a2;
}
var yb = null, zb = null, Ab = null;
function Bb(a2) {
  if (a2 = Cb(a2)) {
    if (typeof yb !== "function")
      throw Error(y$1(280));
    var b2 = a2.stateNode;
    b2 && (b2 = Db(b2), yb(a2.stateNode, a2.type, b2));
  }
}
function Eb(a2) {
  zb ? Ab ? Ab.push(a2) : Ab = [a2] : zb = a2;
}
function Fb() {
  if (zb) {
    var a2 = zb, b2 = Ab;
    Ab = zb = null;
    Bb(a2);
    if (b2)
      for (a2 = 0; a2 < b2.length; a2++)
        Bb(b2[a2]);
  }
}
function Gb(a2, b2) {
  return a2(b2);
}
function Hb(a2, b2, c2, d2, e2) {
  return a2(b2, c2, d2, e2);
}
function Ib() {
}
var Jb = Gb, Kb = false, Lb = false;
function Mb() {
  if (zb !== null || Ab !== null)
    Ib(), Fb();
}
function Nb(a2, b2, c2) {
  if (Lb)
    return a2(b2, c2);
  Lb = true;
  try {
    return Jb(a2, b2, c2);
  } finally {
    Lb = false, Mb();
  }
}
function Ob(a2, b2) {
  var c2 = a2.stateNode;
  if (c2 === null)
    return null;
  var d2 = Db(c2);
  if (d2 === null)
    return null;
  c2 = d2[b2];
  a:
    switch (b2) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (d2 = !d2.disabled) || (a2 = a2.type, d2 = !(a2 === "button" || a2 === "input" || a2 === "select" || a2 === "textarea"));
        a2 = !d2;
        break a;
      default:
        a2 = false;
    }
  if (a2)
    return null;
  if (c2 && typeof c2 !== "function")
    throw Error(y$1(231, b2, typeof c2));
  return c2;
}
var Pb = false;
if (fa)
  try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", { get: function() {
      Pb = true;
    } });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
  } catch (a2) {
    Pb = false;
  }
function Rb(a2, b2, c2, d2, e2, f2, g2, h2, k2) {
  var l2 = Array.prototype.slice.call(arguments, 3);
  try {
    b2.apply(c2, l2);
  } catch (n2) {
    this.onError(n2);
  }
}
var Sb = false, Tb = null, Ub = false, Vb = null, Wb = { onError: function(a2) {
  Sb = true;
  Tb = a2;
} };
function Xb(a2, b2, c2, d2, e2, f2, g2, h2, k2) {
  Sb = false;
  Tb = null;
  Rb.apply(Wb, arguments);
}
function Yb(a2, b2, c2, d2, e2, f2, g2, h2, k2) {
  Xb.apply(this, arguments);
  if (Sb) {
    if (Sb) {
      var l2 = Tb;
      Sb = false;
      Tb = null;
    } else
      throw Error(y$1(198));
    Ub || (Ub = true, Vb = l2);
  }
}
function Zb(a2) {
  var b2 = a2, c2 = a2;
  if (a2.alternate)
    for (; b2.return; )
      b2 = b2.return;
  else {
    a2 = b2;
    do
      b2 = a2, (b2.flags & 1026) !== 0 && (c2 = b2.return), a2 = b2.return;
    while (a2);
  }
  return b2.tag === 3 ? c2 : null;
}
function $b(a2) {
  if (a2.tag === 13) {
    var b2 = a2.memoizedState;
    b2 === null && (a2 = a2.alternate, a2 !== null && (b2 = a2.memoizedState));
    if (b2 !== null)
      return b2.dehydrated;
  }
  return null;
}
function ac(a2) {
  if (Zb(a2) !== a2)
    throw Error(y$1(188));
}
function bc(a2) {
  var b2 = a2.alternate;
  if (!b2) {
    b2 = Zb(a2);
    if (b2 === null)
      throw Error(y$1(188));
    return b2 !== a2 ? null : a2;
  }
  for (var c2 = a2, d2 = b2; ; ) {
    var e2 = c2.return;
    if (e2 === null)
      break;
    var f2 = e2.alternate;
    if (f2 === null) {
      d2 = e2.return;
      if (d2 !== null) {
        c2 = d2;
        continue;
      }
      break;
    }
    if (e2.child === f2.child) {
      for (f2 = e2.child; f2; ) {
        if (f2 === c2)
          return ac(e2), a2;
        if (f2 === d2)
          return ac(e2), b2;
        f2 = f2.sibling;
      }
      throw Error(y$1(188));
    }
    if (c2.return !== d2.return)
      c2 = e2, d2 = f2;
    else {
      for (var g2 = false, h2 = e2.child; h2; ) {
        if (h2 === c2) {
          g2 = true;
          c2 = e2;
          d2 = f2;
          break;
        }
        if (h2 === d2) {
          g2 = true;
          d2 = e2;
          c2 = f2;
          break;
        }
        h2 = h2.sibling;
      }
      if (!g2) {
        for (h2 = f2.child; h2; ) {
          if (h2 === c2) {
            g2 = true;
            c2 = f2;
            d2 = e2;
            break;
          }
          if (h2 === d2) {
            g2 = true;
            d2 = f2;
            c2 = e2;
            break;
          }
          h2 = h2.sibling;
        }
        if (!g2)
          throw Error(y$1(189));
      }
    }
    if (c2.alternate !== d2)
      throw Error(y$1(190));
  }
  if (c2.tag !== 3)
    throw Error(y$1(188));
  return c2.stateNode.current === c2 ? a2 : b2;
}
function cc(a2) {
  a2 = bc(a2);
  if (!a2)
    return null;
  for (var b2 = a2; ; ) {
    if (b2.tag === 5 || b2.tag === 6)
      return b2;
    if (b2.child)
      b2.child.return = b2, b2 = b2.child;
    else {
      if (b2 === a2)
        break;
      for (; !b2.sibling; ) {
        if (!b2.return || b2.return === a2)
          return null;
        b2 = b2.return;
      }
      b2.sibling.return = b2.return;
      b2 = b2.sibling;
    }
  }
  return null;
}
function dc(a2, b2) {
  for (var c2 = a2.alternate; b2 !== null; ) {
    if (b2 === a2 || b2 === c2)
      return true;
    b2 = b2.return;
  }
  return false;
}
var ec, fc, gc, hc, ic = false, jc = [], kc = null, lc = null, mc = null, nc = new Map(), oc = new Map(), pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a2, b2, c2, d2, e2) {
  return { blockedOn: a2, domEventName: b2, eventSystemFlags: c2 | 16, nativeEvent: e2, targetContainers: [d2] };
}
function sc(a2, b2) {
  switch (a2) {
    case "focusin":
    case "focusout":
      kc = null;
      break;
    case "dragenter":
    case "dragleave":
      lc = null;
      break;
    case "mouseover":
    case "mouseout":
      mc = null;
      break;
    case "pointerover":
    case "pointerout":
      nc.delete(b2.pointerId);
      break;
    case "gotpointercapture":
    case "lostpointercapture":
      oc.delete(b2.pointerId);
  }
}
function tc(a2, b2, c2, d2, e2, f2) {
  if (a2 === null || a2.nativeEvent !== f2)
    return a2 = rc(b2, c2, d2, e2, f2), b2 !== null && (b2 = Cb(b2), b2 !== null && fc(b2)), a2;
  a2.eventSystemFlags |= d2;
  b2 = a2.targetContainers;
  e2 !== null && b2.indexOf(e2) === -1 && b2.push(e2);
  return a2;
}
function uc(a2, b2, c2, d2, e2) {
  switch (b2) {
    case "focusin":
      return kc = tc(kc, a2, b2, c2, d2, e2), true;
    case "dragenter":
      return lc = tc(lc, a2, b2, c2, d2, e2), true;
    case "mouseover":
      return mc = tc(mc, a2, b2, c2, d2, e2), true;
    case "pointerover":
      var f2 = e2.pointerId;
      nc.set(f2, tc(nc.get(f2) || null, a2, b2, c2, d2, e2));
      return true;
    case "gotpointercapture":
      return f2 = e2.pointerId, oc.set(f2, tc(oc.get(f2) || null, a2, b2, c2, d2, e2)), true;
  }
  return false;
}
function vc(a2) {
  var b2 = wc(a2.target);
  if (b2 !== null) {
    var c2 = Zb(b2);
    if (c2 !== null) {
      if (b2 = c2.tag, b2 === 13) {
        if (b2 = $b(c2), b2 !== null) {
          a2.blockedOn = b2;
          hc(a2.lanePriority, function() {
            r$1.unstable_runWithPriority(a2.priority, function() {
              gc(c2);
            });
          });
          return;
        }
      } else if (b2 === 3 && c2.stateNode.hydrate) {
        a2.blockedOn = c2.tag === 3 ? c2.stateNode.containerInfo : null;
        return;
      }
    }
  }
  a2.blockedOn = null;
}
function xc(a2) {
  if (a2.blockedOn !== null)
    return false;
  for (var b2 = a2.targetContainers; 0 < b2.length; ) {
    var c2 = yc(a2.domEventName, a2.eventSystemFlags, b2[0], a2.nativeEvent);
    if (c2 !== null)
      return b2 = Cb(c2), b2 !== null && fc(b2), a2.blockedOn = c2, false;
    b2.shift();
  }
  return true;
}
function zc(a2, b2, c2) {
  xc(a2) && c2.delete(b2);
}
function Ac() {
  for (ic = false; 0 < jc.length; ) {
    var a2 = jc[0];
    if (a2.blockedOn !== null) {
      a2 = Cb(a2.blockedOn);
      a2 !== null && ec(a2);
      break;
    }
    for (var b2 = a2.targetContainers; 0 < b2.length; ) {
      var c2 = yc(a2.domEventName, a2.eventSystemFlags, b2[0], a2.nativeEvent);
      if (c2 !== null) {
        a2.blockedOn = c2;
        break;
      }
      b2.shift();
    }
    a2.blockedOn === null && jc.shift();
  }
  kc !== null && xc(kc) && (kc = null);
  lc !== null && xc(lc) && (lc = null);
  mc !== null && xc(mc) && (mc = null);
  nc.forEach(zc);
  oc.forEach(zc);
}
function Bc(a2, b2) {
  a2.blockedOn === b2 && (a2.blockedOn = null, ic || (ic = true, r$1.unstable_scheduleCallback(r$1.unstable_NormalPriority, Ac)));
}
function Cc(a2) {
  function b2(b3) {
    return Bc(b3, a2);
  }
  if (0 < jc.length) {
    Bc(jc[0], a2);
    for (var c2 = 1; c2 < jc.length; c2++) {
      var d2 = jc[c2];
      d2.blockedOn === a2 && (d2.blockedOn = null);
    }
  }
  kc !== null && Bc(kc, a2);
  lc !== null && Bc(lc, a2);
  mc !== null && Bc(mc, a2);
  nc.forEach(b2);
  oc.forEach(b2);
  for (c2 = 0; c2 < pc.length; c2++)
    d2 = pc[c2], d2.blockedOn === a2 && (d2.blockedOn = null);
  for (; 0 < pc.length && (c2 = pc[0], c2.blockedOn === null); )
    vc(c2), c2.blockedOn === null && pc.shift();
}
function Dc(a2, b2) {
  var c2 = {};
  c2[a2.toLowerCase()] = b2.toLowerCase();
  c2["Webkit" + a2] = "webkit" + b2;
  c2["Moz" + a2] = "moz" + b2;
  return c2;
}
var Ec = { animationend: Dc("Animation", "AnimationEnd"), animationiteration: Dc("Animation", "AnimationIteration"), animationstart: Dc("Animation", "AnimationStart"), transitionend: Dc("Transition", "TransitionEnd") }, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a2) {
  if (Fc[a2])
    return Fc[a2];
  if (!Ec[a2])
    return a2;
  var b2 = Ec[a2], c2;
  for (c2 in b2)
    if (b2.hasOwnProperty(c2) && c2 in Gc)
      return Fc[a2] = b2[c2];
  return a2;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map(), Nc = new Map(), Oc = [
  "abort",
  "abort",
  Ic,
  "animationEnd",
  Jc,
  "animationIteration",
  Kc,
  "animationStart",
  "canplay",
  "canPlay",
  "canplaythrough",
  "canPlayThrough",
  "durationchange",
  "durationChange",
  "emptied",
  "emptied",
  "encrypted",
  "encrypted",
  "ended",
  "ended",
  "error",
  "error",
  "gotpointercapture",
  "gotPointerCapture",
  "load",
  "load",
  "loadeddata",
  "loadedData",
  "loadedmetadata",
  "loadedMetadata",
  "loadstart",
  "loadStart",
  "lostpointercapture",
  "lostPointerCapture",
  "playing",
  "playing",
  "progress",
  "progress",
  "seeking",
  "seeking",
  "stalled",
  "stalled",
  "suspend",
  "suspend",
  "timeupdate",
  "timeUpdate",
  Lc,
  "transitionEnd",
  "waiting",
  "waiting"
];
function Pc(a2, b2) {
  for (var c2 = 0; c2 < a2.length; c2 += 2) {
    var d2 = a2[c2], e2 = a2[c2 + 1];
    e2 = "on" + (e2[0].toUpperCase() + e2.slice(1));
    Nc.set(d2, b2);
    Mc.set(d2, e2);
    da(e2, [d2]);
  }
}
var Qc = r$1.unstable_now;
Qc();
var F = 8;
function Rc(a2) {
  if ((1 & a2) !== 0)
    return F = 15, 1;
  if ((2 & a2) !== 0)
    return F = 14, 2;
  if ((4 & a2) !== 0)
    return F = 13, 4;
  var b2 = 24 & a2;
  if (b2 !== 0)
    return F = 12, b2;
  if ((a2 & 32) !== 0)
    return F = 11, 32;
  b2 = 192 & a2;
  if (b2 !== 0)
    return F = 10, b2;
  if ((a2 & 256) !== 0)
    return F = 9, 256;
  b2 = 3584 & a2;
  if (b2 !== 0)
    return F = 8, b2;
  if ((a2 & 4096) !== 0)
    return F = 7, 4096;
  b2 = 4186112 & a2;
  if (b2 !== 0)
    return F = 6, b2;
  b2 = 62914560 & a2;
  if (b2 !== 0)
    return F = 5, b2;
  if (a2 & 67108864)
    return F = 4, 67108864;
  if ((a2 & 134217728) !== 0)
    return F = 3, 134217728;
  b2 = 805306368 & a2;
  if (b2 !== 0)
    return F = 2, b2;
  if ((1073741824 & a2) !== 0)
    return F = 1, 1073741824;
  F = 8;
  return a2;
}
function Sc(a2) {
  switch (a2) {
    case 99:
      return 15;
    case 98:
      return 10;
    case 97:
    case 96:
      return 8;
    case 95:
      return 2;
    default:
      return 0;
  }
}
function Tc(a2) {
  switch (a2) {
    case 15:
    case 14:
      return 99;
    case 13:
    case 12:
    case 11:
    case 10:
      return 98;
    case 9:
    case 8:
    case 7:
    case 6:
    case 4:
    case 5:
      return 97;
    case 3:
    case 2:
    case 1:
      return 95;
    case 0:
      return 90;
    default:
      throw Error(y$1(358, a2));
  }
}
function Uc(a2, b2) {
  var c2 = a2.pendingLanes;
  if (c2 === 0)
    return F = 0;
  var d2 = 0, e2 = 0, f2 = a2.expiredLanes, g2 = a2.suspendedLanes, h2 = a2.pingedLanes;
  if (f2 !== 0)
    d2 = f2, e2 = F = 15;
  else if (f2 = c2 & 134217727, f2 !== 0) {
    var k2 = f2 & ~g2;
    k2 !== 0 ? (d2 = Rc(k2), e2 = F) : (h2 &= f2, h2 !== 0 && (d2 = Rc(h2), e2 = F));
  } else
    f2 = c2 & ~g2, f2 !== 0 ? (d2 = Rc(f2), e2 = F) : h2 !== 0 && (d2 = Rc(h2), e2 = F);
  if (d2 === 0)
    return 0;
  d2 = 31 - Vc(d2);
  d2 = c2 & ((0 > d2 ? 0 : 1 << d2) << 1) - 1;
  if (b2 !== 0 && b2 !== d2 && (b2 & g2) === 0) {
    Rc(b2);
    if (e2 <= F)
      return b2;
    F = e2;
  }
  b2 = a2.entangledLanes;
  if (b2 !== 0)
    for (a2 = a2.entanglements, b2 &= d2; 0 < b2; )
      c2 = 31 - Vc(b2), e2 = 1 << c2, d2 |= a2[c2], b2 &= ~e2;
  return d2;
}
function Wc(a2) {
  a2 = a2.pendingLanes & -1073741825;
  return a2 !== 0 ? a2 : a2 & 1073741824 ? 1073741824 : 0;
}
function Xc(a2, b2) {
  switch (a2) {
    case 15:
      return 1;
    case 14:
      return 2;
    case 12:
      return a2 = Yc(24 & ~b2), a2 === 0 ? Xc(10, b2) : a2;
    case 10:
      return a2 = Yc(192 & ~b2), a2 === 0 ? Xc(8, b2) : a2;
    case 8:
      return a2 = Yc(3584 & ~b2), a2 === 0 && (a2 = Yc(4186112 & ~b2), a2 === 0 && (a2 = 512)), a2;
    case 2:
      return b2 = Yc(805306368 & ~b2), b2 === 0 && (b2 = 268435456), b2;
  }
  throw Error(y$1(358, a2));
}
function Yc(a2) {
  return a2 & -a2;
}
function Zc(a2) {
  for (var b2 = [], c2 = 0; 31 > c2; c2++)
    b2.push(a2);
  return b2;
}
function $c(a2, b2, c2) {
  a2.pendingLanes |= b2;
  var d2 = b2 - 1;
  a2.suspendedLanes &= d2;
  a2.pingedLanes &= d2;
  a2 = a2.eventTimes;
  b2 = 31 - Vc(b2);
  a2[b2] = c2;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a2) {
  return a2 === 0 ? 32 : 31 - (bd(a2) / cd | 0) | 0;
}
var dd = r$1.unstable_UserBlockingPriority, ed = r$1.unstable_runWithPriority, fd = true;
function gd(a2, b2, c2, d2) {
  Kb || Ib();
  var e2 = hd, f2 = Kb;
  Kb = true;
  try {
    Hb(e2, a2, b2, c2, d2);
  } finally {
    (Kb = f2) || Mb();
  }
}
function id(a2, b2, c2, d2) {
  ed(dd, hd.bind(null, a2, b2, c2, d2));
}
function hd(a2, b2, c2, d2) {
  if (fd) {
    var e2;
    if ((e2 = (b2 & 4) === 0) && 0 < jc.length && -1 < qc.indexOf(a2))
      a2 = rc(null, a2, b2, c2, d2), jc.push(a2);
    else {
      var f2 = yc(a2, b2, c2, d2);
      if (f2 === null)
        e2 && sc(a2, d2);
      else {
        if (e2) {
          if (-1 < qc.indexOf(a2)) {
            a2 = rc(f2, a2, b2, c2, d2);
            jc.push(a2);
            return;
          }
          if (uc(f2, a2, b2, c2, d2))
            return;
          sc(a2, d2);
        }
        jd(a2, b2, d2, null, c2);
      }
    }
  }
}
function yc(a2, b2, c2, d2) {
  var e2 = xb(d2);
  e2 = wc(e2);
  if (e2 !== null) {
    var f2 = Zb(e2);
    if (f2 === null)
      e2 = null;
    else {
      var g2 = f2.tag;
      if (g2 === 13) {
        e2 = $b(f2);
        if (e2 !== null)
          return e2;
        e2 = null;
      } else if (g2 === 3) {
        if (f2.stateNode.hydrate)
          return f2.tag === 3 ? f2.stateNode.containerInfo : null;
        e2 = null;
      } else
        f2 !== e2 && (e2 = null);
    }
  }
  jd(a2, b2, d2, e2, c2);
  return null;
}
var kd = null, ld = null, md = null;
function nd() {
  if (md)
    return md;
  var a2, b2 = ld, c2 = b2.length, d2, e2 = "value" in kd ? kd.value : kd.textContent, f2 = e2.length;
  for (a2 = 0; a2 < c2 && b2[a2] === e2[a2]; a2++)
    ;
  var g2 = c2 - a2;
  for (d2 = 1; d2 <= g2 && b2[c2 - d2] === e2[f2 - d2]; d2++)
    ;
  return md = e2.slice(a2, 1 < d2 ? 1 - d2 : void 0);
}
function od(a2) {
  var b2 = a2.keyCode;
  "charCode" in a2 ? (a2 = a2.charCode, a2 === 0 && b2 === 13 && (a2 = 13)) : a2 = b2;
  a2 === 10 && (a2 = 13);
  return 32 <= a2 || a2 === 13 ? a2 : 0;
}
function pd() {
  return true;
}
function qd() {
  return false;
}
function rd(a2) {
  function b2(b3, d2, e2, f2, g2) {
    this._reactName = b3;
    this._targetInst = e2;
    this.type = d2;
    this.nativeEvent = f2;
    this.target = g2;
    this.currentTarget = null;
    for (var c2 in a2)
      a2.hasOwnProperty(c2) && (b3 = a2[c2], this[c2] = b3 ? b3(f2) : f2[c2]);
    this.isDefaultPrevented = (f2.defaultPrevented != null ? f2.defaultPrevented : f2.returnValue === false) ? pd : qd;
    this.isPropagationStopped = qd;
    return this;
  }
  m$1(b2.prototype, { preventDefault: function() {
    this.defaultPrevented = true;
    var a3 = this.nativeEvent;
    a3 && (a3.preventDefault ? a3.preventDefault() : typeof a3.returnValue !== "unknown" && (a3.returnValue = false), this.isDefaultPrevented = pd);
  }, stopPropagation: function() {
    var a3 = this.nativeEvent;
    a3 && (a3.stopPropagation ? a3.stopPropagation() : typeof a3.cancelBubble !== "unknown" && (a3.cancelBubble = true), this.isPropagationStopped = pd);
  }, persist: function() {
  }, isPersistent: pd });
  return b2;
}
var sd = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(a2) {
  return a2.timeStamp || Date.now();
}, defaultPrevented: 0, isTrusted: 0 }, td = rd(sd), ud = m$1({}, sd, { view: 0, detail: 0 }), vd = rd(ud), wd, xd, yd, Ad = m$1({}, ud, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: zd, button: 0, buttons: 0, relatedTarget: function(a2) {
  return a2.relatedTarget === void 0 ? a2.fromElement === a2.srcElement ? a2.toElement : a2.fromElement : a2.relatedTarget;
}, movementX: function(a2) {
  if ("movementX" in a2)
    return a2.movementX;
  a2 !== yd && (yd && a2.type === "mousemove" ? (wd = a2.screenX - yd.screenX, xd = a2.screenY - yd.screenY) : xd = wd = 0, yd = a2);
  return wd;
}, movementY: function(a2) {
  return "movementY" in a2 ? a2.movementY : xd;
} }), Bd = rd(Ad), Cd = m$1({}, Ad, { dataTransfer: 0 }), Dd = rd(Cd), Ed = m$1({}, ud, { relatedTarget: 0 }), Fd = rd(Ed), Gd = m$1({}, sd, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), Hd = rd(Gd), Id = m$1({}, sd, { clipboardData: function(a2) {
  return "clipboardData" in a2 ? a2.clipboardData : window.clipboardData;
} }), Jd = rd(Id), Kd = m$1({}, sd, { data: 0 }), Ld = rd(Kd), Md = {
  Esc: "Escape",
  Spacebar: " ",
  Left: "ArrowLeft",
  Up: "ArrowUp",
  Right: "ArrowRight",
  Down: "ArrowDown",
  Del: "Delete",
  Win: "OS",
  Menu: "ContextMenu",
  Apps: "ContextMenu",
  Scroll: "ScrollLock",
  MozPrintableKey: "Unidentified"
}, Nd = {
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  224: "Meta"
}, Od = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
function Pd(a2) {
  var b2 = this.nativeEvent;
  return b2.getModifierState ? b2.getModifierState(a2) : (a2 = Od[a2]) ? !!b2[a2] : false;
}
function zd() {
  return Pd;
}
var Qd = m$1({}, ud, { key: function(a2) {
  if (a2.key) {
    var b2 = Md[a2.key] || a2.key;
    if (b2 !== "Unidentified")
      return b2;
  }
  return a2.type === "keypress" ? (a2 = od(a2), a2 === 13 ? "Enter" : String.fromCharCode(a2)) : a2.type === "keydown" || a2.type === "keyup" ? Nd[a2.keyCode] || "Unidentified" : "";
}, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: zd, charCode: function(a2) {
  return a2.type === "keypress" ? od(a2) : 0;
}, keyCode: function(a2) {
  return a2.type === "keydown" || a2.type === "keyup" ? a2.keyCode : 0;
}, which: function(a2) {
  return a2.type === "keypress" ? od(a2) : a2.type === "keydown" || a2.type === "keyup" ? a2.keyCode : 0;
} }), Rd = rd(Qd), Sd = m$1({}, Ad, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Td = rd(Sd), Ud = m$1({}, ud, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: zd }), Vd = rd(Ud), Wd = m$1({}, sd, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Xd = rd(Wd), Yd = m$1({}, Ad, {
  deltaX: function(a2) {
    return "deltaX" in a2 ? a2.deltaX : "wheelDeltaX" in a2 ? -a2.wheelDeltaX : 0;
  },
  deltaY: function(a2) {
    return "deltaY" in a2 ? a2.deltaY : "wheelDeltaY" in a2 ? -a2.wheelDeltaY : "wheelDelta" in a2 ? -a2.wheelDelta : 0;
  },
  deltaZ: 0,
  deltaMode: 0
}), Zd = rd(Yd), $d = [9, 13, 27, 32], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = false;
function ge(a2, b2) {
  switch (a2) {
    case "keyup":
      return $d.indexOf(b2.keyCode) !== -1;
    case "keydown":
      return b2.keyCode !== 229;
    case "keypress":
    case "mousedown":
    case "focusout":
      return true;
    default:
      return false;
  }
}
function he(a2) {
  a2 = a2.detail;
  return typeof a2 === "object" && "data" in a2 ? a2.data : null;
}
var ie = false;
function je(a2, b2) {
  switch (a2) {
    case "compositionend":
      return he(b2);
    case "keypress":
      if (b2.which !== 32)
        return null;
      fe = true;
      return ee;
    case "textInput":
      return a2 = b2.data, a2 === ee && fe ? null : a2;
    default:
      return null;
  }
}
function ke(a2, b2) {
  if (ie)
    return a2 === "compositionend" || !ae && ge(a2, b2) ? (a2 = nd(), md = ld = kd = null, ie = false, a2) : null;
  switch (a2) {
    case "paste":
      return null;
    case "keypress":
      if (!(b2.ctrlKey || b2.altKey || b2.metaKey) || b2.ctrlKey && b2.altKey) {
        if (b2.char && 1 < b2.char.length)
          return b2.char;
        if (b2.which)
          return String.fromCharCode(b2.which);
      }
      return null;
    case "compositionend":
      return de && b2.locale !== "ko" ? null : b2.data;
    default:
      return null;
  }
}
var le = { color: true, date: true, datetime: true, "datetime-local": true, email: true, month: true, number: true, password: true, range: true, search: true, tel: true, text: true, time: true, url: true, week: true };
function me$1(a2) {
  var b2 = a2 && a2.nodeName && a2.nodeName.toLowerCase();
  return b2 === "input" ? !!le[a2.type] : b2 === "textarea" ? true : false;
}
function ne(a2, b2, c2, d2) {
  Eb(d2);
  b2 = oe(b2, "onChange");
  0 < b2.length && (c2 = new td("onChange", "change", null, c2, d2), a2.push({ event: c2, listeners: b2 }));
}
var pe = null, qe = null;
function re(a2) {
  se(a2, 0);
}
function te(a2) {
  var b2 = ue(a2);
  if (Wa(b2))
    return a2;
}
function ve(a2, b2) {
  if (a2 === "change")
    return b2;
}
var we = false;
if (fa) {
  var xe;
  if (fa) {
    var ye = "oninput" in document;
    if (!ye) {
      var ze = document.createElement("div");
      ze.setAttribute("oninput", "return;");
      ye = typeof ze.oninput === "function";
    }
    xe = ye;
  } else
    xe = false;
  we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
  pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a2) {
  if (a2.propertyName === "value" && te(qe)) {
    var b2 = [];
    ne(b2, qe, a2, xb(a2));
    a2 = re;
    if (Kb)
      a2(b2);
    else {
      Kb = true;
      try {
        Gb(a2, b2);
      } finally {
        Kb = false, Mb();
      }
    }
  }
}
function Ce(a2, b2, c2) {
  a2 === "focusin" ? (Ae(), pe = b2, qe = c2, pe.attachEvent("onpropertychange", Be)) : a2 === "focusout" && Ae();
}
function De(a2) {
  if (a2 === "selectionchange" || a2 === "keyup" || a2 === "keydown")
    return te(qe);
}
function Ee(a2, b2) {
  if (a2 === "click")
    return te(b2);
}
function Fe(a2, b2) {
  if (a2 === "input" || a2 === "change")
    return te(b2);
}
function Ge(a2, b2) {
  return a2 === b2 && (a2 !== 0 || 1 / a2 === 1 / b2) || a2 !== a2 && b2 !== b2;
}
var He = typeof Object.is === "function" ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a2, b2) {
  if (He(a2, b2))
    return true;
  if (typeof a2 !== "object" || a2 === null || typeof b2 !== "object" || b2 === null)
    return false;
  var c2 = Object.keys(a2), d2 = Object.keys(b2);
  if (c2.length !== d2.length)
    return false;
  for (d2 = 0; d2 < c2.length; d2++)
    if (!Ie.call(b2, c2[d2]) || !He(a2[c2[d2]], b2[c2[d2]]))
      return false;
  return true;
}
function Ke(a2) {
  for (; a2 && a2.firstChild; )
    a2 = a2.firstChild;
  return a2;
}
function Le(a2, b2) {
  var c2 = Ke(a2);
  a2 = 0;
  for (var d2; c2; ) {
    if (c2.nodeType === 3) {
      d2 = a2 + c2.textContent.length;
      if (a2 <= b2 && d2 >= b2)
        return { node: c2, offset: b2 - a2 };
      a2 = d2;
    }
    a: {
      for (; c2; ) {
        if (c2.nextSibling) {
          c2 = c2.nextSibling;
          break a;
        }
        c2 = c2.parentNode;
      }
      c2 = void 0;
    }
    c2 = Ke(c2);
  }
}
function Me(a2, b2) {
  return a2 && b2 ? a2 === b2 ? true : a2 && a2.nodeType === 3 ? false : b2 && b2.nodeType === 3 ? Me(a2, b2.parentNode) : "contains" in a2 ? a2.contains(b2) : a2.compareDocumentPosition ? !!(a2.compareDocumentPosition(b2) & 16) : false : false;
}
function Ne() {
  for (var a2 = window, b2 = Xa(); b2 instanceof a2.HTMLIFrameElement; ) {
    try {
      var c2 = typeof b2.contentWindow.location.href === "string";
    } catch (d2) {
      c2 = false;
    }
    if (c2)
      a2 = b2.contentWindow;
    else
      break;
    b2 = Xa(a2.document);
  }
  return b2;
}
function Oe(a2) {
  var b2 = a2 && a2.nodeName && a2.nodeName.toLowerCase();
  return b2 && (b2 === "input" && (a2.type === "text" || a2.type === "search" || a2.type === "tel" || a2.type === "url" || a2.type === "password") || b2 === "textarea" || a2.contentEditable === "true");
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = false;
function Ue(a2, b2, c2) {
  var d2 = c2.window === c2 ? c2.document : c2.nodeType === 9 ? c2 : c2.ownerDocument;
  Te || Qe == null || Qe !== Xa(d2) || (d2 = Qe, "selectionStart" in d2 && Oe(d2) ? d2 = { start: d2.selectionStart, end: d2.selectionEnd } : (d2 = (d2.ownerDocument && d2.ownerDocument.defaultView || window).getSelection(), d2 = { anchorNode: d2.anchorNode, anchorOffset: d2.anchorOffset, focusNode: d2.focusNode, focusOffset: d2.focusOffset }), Se && Je(Se, d2) || (Se = d2, d2 = oe(Re, "onSelect"), 0 < d2.length && (b2 = new td("onSelect", "select", null, b2, c2), a2.push({ event: b2, listeners: d2 }), b2.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for (var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)
  Nc.set(Ve[We], 0);
ea("onMouseEnter", ["mouseout", "mouseover"]);
ea("onMouseLeave", ["mouseout", "mouseover"]);
ea("onPointerEnter", ["pointerout", "pointerover"]);
ea("onPointerLeave", ["pointerout", "pointerover"]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a2, b2, c2) {
  var d2 = a2.type || "unknown-event";
  a2.currentTarget = c2;
  Yb(d2, b2, void 0, a2);
  a2.currentTarget = null;
}
function se(a2, b2) {
  b2 = (b2 & 4) !== 0;
  for (var c2 = 0; c2 < a2.length; c2++) {
    var d2 = a2[c2], e2 = d2.event;
    d2 = d2.listeners;
    a: {
      var f2 = void 0;
      if (b2)
        for (var g2 = d2.length - 1; 0 <= g2; g2--) {
          var h2 = d2[g2], k2 = h2.instance, l2 = h2.currentTarget;
          h2 = h2.listener;
          if (k2 !== f2 && e2.isPropagationStopped())
            break a;
          Ze(e2, h2, l2);
          f2 = k2;
        }
      else
        for (g2 = 0; g2 < d2.length; g2++) {
          h2 = d2[g2];
          k2 = h2.instance;
          l2 = h2.currentTarget;
          h2 = h2.listener;
          if (k2 !== f2 && e2.isPropagationStopped())
            break a;
          Ze(e2, h2, l2);
          f2 = k2;
        }
    }
  }
  if (Ub)
    throw a2 = Vb, Ub = false, Vb = null, a2;
}
function G(a2, b2) {
  var c2 = $e(b2), d2 = a2 + "__bubble";
  c2.has(d2) || (af(b2, a2, 2, false), c2.add(d2));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a2) {
  a2[bf] || (a2[bf] = true, ba.forEach(function(b2) {
    Ye.has(b2) || df(b2, false, a2, null);
    df(b2, true, a2, null);
  }));
}
function df(a2, b2, c2, d2) {
  var e2 = 4 < arguments.length && arguments[4] !== void 0 ? arguments[4] : 0, f2 = c2;
  a2 === "selectionchange" && c2.nodeType !== 9 && (f2 = c2.ownerDocument);
  if (d2 !== null && !b2 && Ye.has(a2)) {
    if (a2 !== "scroll")
      return;
    e2 |= 2;
    f2 = d2;
  }
  var g2 = $e(f2), h2 = a2 + "__" + (b2 ? "capture" : "bubble");
  g2.has(h2) || (b2 && (e2 |= 4), af(f2, a2, e2, b2), g2.add(h2));
}
function af(a2, b2, c2, d2) {
  var e2 = Nc.get(b2);
  switch (e2 === void 0 ? 2 : e2) {
    case 0:
      e2 = gd;
      break;
    case 1:
      e2 = id;
      break;
    default:
      e2 = hd;
  }
  c2 = e2.bind(null, b2, c2, a2);
  e2 = void 0;
  !Pb || b2 !== "touchstart" && b2 !== "touchmove" && b2 !== "wheel" || (e2 = true);
  d2 ? e2 !== void 0 ? a2.addEventListener(b2, c2, { capture: true, passive: e2 }) : a2.addEventListener(b2, c2, true) : e2 !== void 0 ? a2.addEventListener(b2, c2, { passive: e2 }) : a2.addEventListener(b2, c2, false);
}
function jd(a2, b2, c2, d2, e2) {
  var f2 = d2;
  if ((b2 & 1) === 0 && (b2 & 2) === 0 && d2 !== null)
    a:
      for (; ; ) {
        if (d2 === null)
          return;
        var g2 = d2.tag;
        if (g2 === 3 || g2 === 4) {
          var h2 = d2.stateNode.containerInfo;
          if (h2 === e2 || h2.nodeType === 8 && h2.parentNode === e2)
            break;
          if (g2 === 4)
            for (g2 = d2.return; g2 !== null; ) {
              var k2 = g2.tag;
              if (k2 === 3 || k2 === 4) {
                if (k2 = g2.stateNode.containerInfo, k2 === e2 || k2.nodeType === 8 && k2.parentNode === e2)
                  return;
              }
              g2 = g2.return;
            }
          for (; h2 !== null; ) {
            g2 = wc(h2);
            if (g2 === null)
              return;
            k2 = g2.tag;
            if (k2 === 5 || k2 === 6) {
              d2 = f2 = g2;
              continue a;
            }
            h2 = h2.parentNode;
          }
        }
        d2 = d2.return;
      }
  Nb(function() {
    var d3 = f2, e3 = xb(c2), g3 = [];
    a: {
      var h3 = Mc.get(a2);
      if (h3 !== void 0) {
        var k3 = td, x2 = a2;
        switch (a2) {
          case "keypress":
            if (od(c2) === 0)
              break a;
          case "keydown":
          case "keyup":
            k3 = Rd;
            break;
          case "focusin":
            x2 = "focus";
            k3 = Fd;
            break;
          case "focusout":
            x2 = "blur";
            k3 = Fd;
            break;
          case "beforeblur":
          case "afterblur":
            k3 = Fd;
            break;
          case "click":
            if (c2.button === 2)
              break a;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            k3 = Bd;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            k3 = Dd;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            k3 = Vd;
            break;
          case Ic:
          case Jc:
          case Kc:
            k3 = Hd;
            break;
          case Lc:
            k3 = Xd;
            break;
          case "scroll":
            k3 = vd;
            break;
          case "wheel":
            k3 = Zd;
            break;
          case "copy":
          case "cut":
          case "paste":
            k3 = Jd;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            k3 = Td;
        }
        var w2 = (b2 & 4) !== 0, z2 = !w2 && a2 === "scroll", u = w2 ? h3 !== null ? h3 + "Capture" : null : h3;
        w2 = [];
        for (var t2 = d3, q2; t2 !== null; ) {
          q2 = t2;
          var v2 = q2.stateNode;
          q2.tag === 5 && v2 !== null && (q2 = v2, u !== null && (v2 = Ob(t2, u), v2 != null && w2.push(ef(t2, v2, q2))));
          if (z2)
            break;
          t2 = t2.return;
        }
        0 < w2.length && (h3 = new k3(h3, x2, null, c2, e3), g3.push({ event: h3, listeners: w2 }));
      }
    }
    if ((b2 & 7) === 0) {
      a: {
        h3 = a2 === "mouseover" || a2 === "pointerover";
        k3 = a2 === "mouseout" || a2 === "pointerout";
        if (h3 && (b2 & 16) === 0 && (x2 = c2.relatedTarget || c2.fromElement) && (wc(x2) || x2[ff]))
          break a;
        if (k3 || h3) {
          h3 = e3.window === e3 ? e3 : (h3 = e3.ownerDocument) ? h3.defaultView || h3.parentWindow : window;
          if (k3) {
            if (x2 = c2.relatedTarget || c2.toElement, k3 = d3, x2 = x2 ? wc(x2) : null, x2 !== null && (z2 = Zb(x2), x2 !== z2 || x2.tag !== 5 && x2.tag !== 6))
              x2 = null;
          } else
            k3 = null, x2 = d3;
          if (k3 !== x2) {
            w2 = Bd;
            v2 = "onMouseLeave";
            u = "onMouseEnter";
            t2 = "mouse";
            if (a2 === "pointerout" || a2 === "pointerover")
              w2 = Td, v2 = "onPointerLeave", u = "onPointerEnter", t2 = "pointer";
            z2 = k3 == null ? h3 : ue(k3);
            q2 = x2 == null ? h3 : ue(x2);
            h3 = new w2(v2, t2 + "leave", k3, c2, e3);
            h3.target = z2;
            h3.relatedTarget = q2;
            v2 = null;
            wc(e3) === d3 && (w2 = new w2(u, t2 + "enter", x2, c2, e3), w2.target = q2, w2.relatedTarget = z2, v2 = w2);
            z2 = v2;
            if (k3 && x2)
              b: {
                w2 = k3;
                u = x2;
                t2 = 0;
                for (q2 = w2; q2; q2 = gf(q2))
                  t2++;
                q2 = 0;
                for (v2 = u; v2; v2 = gf(v2))
                  q2++;
                for (; 0 < t2 - q2; )
                  w2 = gf(w2), t2--;
                for (; 0 < q2 - t2; )
                  u = gf(u), q2--;
                for (; t2--; ) {
                  if (w2 === u || u !== null && w2 === u.alternate)
                    break b;
                  w2 = gf(w2);
                  u = gf(u);
                }
                w2 = null;
              }
            else
              w2 = null;
            k3 !== null && hf(g3, h3, k3, w2, false);
            x2 !== null && z2 !== null && hf(g3, z2, x2, w2, true);
          }
        }
      }
      a: {
        h3 = d3 ? ue(d3) : window;
        k3 = h3.nodeName && h3.nodeName.toLowerCase();
        if (k3 === "select" || k3 === "input" && h3.type === "file")
          var J = ve;
        else if (me$1(h3))
          if (we)
            J = Fe;
          else {
            J = De;
            var K = Ce;
          }
        else
          (k3 = h3.nodeName) && k3.toLowerCase() === "input" && (h3.type === "checkbox" || h3.type === "radio") && (J = Ee);
        if (J && (J = J(a2, d3))) {
          ne(g3, J, c2, e3);
          break a;
        }
        K && K(a2, h3, d3);
        a2 === "focusout" && (K = h3._wrapperState) && K.controlled && h3.type === "number" && bb(h3, "number", h3.value);
      }
      K = d3 ? ue(d3) : window;
      switch (a2) {
        case "focusin":
          if (me$1(K) || K.contentEditable === "true")
            Qe = K, Re = d3, Se = null;
          break;
        case "focusout":
          Se = Re = Qe = null;
          break;
        case "mousedown":
          Te = true;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          Te = false;
          Ue(g3, c2, e3);
          break;
        case "selectionchange":
          if (Pe)
            break;
        case "keydown":
        case "keyup":
          Ue(g3, c2, e3);
      }
      var Q;
      if (ae)
        b: {
          switch (a2) {
            case "compositionstart":
              var L = "onCompositionStart";
              break b;
            case "compositionend":
              L = "onCompositionEnd";
              break b;
            case "compositionupdate":
              L = "onCompositionUpdate";
              break b;
          }
          L = void 0;
        }
      else
        ie ? ge(a2, c2) && (L = "onCompositionEnd") : a2 === "keydown" && c2.keyCode === 229 && (L = "onCompositionStart");
      L && (de && c2.locale !== "ko" && (ie || L !== "onCompositionStart" ? L === "onCompositionEnd" && ie && (Q = nd()) : (kd = e3, ld = "value" in kd ? kd.value : kd.textContent, ie = true)), K = oe(d3, L), 0 < K.length && (L = new Ld(L, a2, null, c2, e3), g3.push({ event: L, listeners: K }), Q ? L.data = Q : (Q = he(c2), Q !== null && (L.data = Q))));
      if (Q = ce ? je(a2, c2) : ke(a2, c2))
        d3 = oe(d3, "onBeforeInput"), 0 < d3.length && (e3 = new Ld("onBeforeInput", "beforeinput", null, c2, e3), g3.push({ event: e3, listeners: d3 }), e3.data = Q);
    }
    se(g3, b2);
  });
}
function ef(a2, b2, c2) {
  return { instance: a2, listener: b2, currentTarget: c2 };
}
function oe(a2, b2) {
  for (var c2 = b2 + "Capture", d2 = []; a2 !== null; ) {
    var e2 = a2, f2 = e2.stateNode;
    e2.tag === 5 && f2 !== null && (e2 = f2, f2 = Ob(a2, c2), f2 != null && d2.unshift(ef(a2, f2, e2)), f2 = Ob(a2, b2), f2 != null && d2.push(ef(a2, f2, e2)));
    a2 = a2.return;
  }
  return d2;
}
function gf(a2) {
  if (a2 === null)
    return null;
  do
    a2 = a2.return;
  while (a2 && a2.tag !== 5);
  return a2 ? a2 : null;
}
function hf(a2, b2, c2, d2, e2) {
  for (var f2 = b2._reactName, g2 = []; c2 !== null && c2 !== d2; ) {
    var h2 = c2, k2 = h2.alternate, l2 = h2.stateNode;
    if (k2 !== null && k2 === d2)
      break;
    h2.tag === 5 && l2 !== null && (h2 = l2, e2 ? (k2 = Ob(c2, f2), k2 != null && g2.unshift(ef(c2, k2, h2))) : e2 || (k2 = Ob(c2, f2), k2 != null && g2.push(ef(c2, k2, h2))));
    c2 = c2.return;
  }
  g2.length !== 0 && a2.push({ event: b2, listeners: g2 });
}
function jf() {
}
var kf = null, lf = null;
function mf(a2, b2) {
  switch (a2) {
    case "button":
    case "input":
    case "select":
    case "textarea":
      return !!b2.autoFocus;
  }
  return false;
}
function nf(a2, b2) {
  return a2 === "textarea" || a2 === "option" || a2 === "noscript" || typeof b2.children === "string" || typeof b2.children === "number" || typeof b2.dangerouslySetInnerHTML === "object" && b2.dangerouslySetInnerHTML !== null && b2.dangerouslySetInnerHTML.__html != null;
}
var of = typeof setTimeout === "function" ? setTimeout : void 0, pf = typeof clearTimeout === "function" ? clearTimeout : void 0;
function qf(a2) {
  a2.nodeType === 1 ? a2.textContent = "" : a2.nodeType === 9 && (a2 = a2.body, a2 != null && (a2.textContent = ""));
}
function rf(a2) {
  for (; a2 != null; a2 = a2.nextSibling) {
    var b2 = a2.nodeType;
    if (b2 === 1 || b2 === 3)
      break;
  }
  return a2;
}
function sf(a2) {
  a2 = a2.previousSibling;
  for (var b2 = 0; a2; ) {
    if (a2.nodeType === 8) {
      var c2 = a2.data;
      if (c2 === "$" || c2 === "$!" || c2 === "$?") {
        if (b2 === 0)
          return a2;
        b2--;
      } else
        c2 === "/$" && b2++;
    }
    a2 = a2.previousSibling;
  }
  return null;
}
var tf = 0;
function uf(a2) {
  return { $$typeof: Ga, toString: a2, valueOf: a2 };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a2) {
  var b2 = a2[wf];
  if (b2)
    return b2;
  for (var c2 = a2.parentNode; c2; ) {
    if (b2 = c2[ff] || c2[wf]) {
      c2 = b2.alternate;
      if (b2.child !== null || c2 !== null && c2.child !== null)
        for (a2 = sf(a2); a2 !== null; ) {
          if (c2 = a2[wf])
            return c2;
          a2 = sf(a2);
        }
      return b2;
    }
    a2 = c2;
    c2 = a2.parentNode;
  }
  return null;
}
function Cb(a2) {
  a2 = a2[wf] || a2[ff];
  return !a2 || a2.tag !== 5 && a2.tag !== 6 && a2.tag !== 13 && a2.tag !== 3 ? null : a2;
}
function ue(a2) {
  if (a2.tag === 5 || a2.tag === 6)
    return a2.stateNode;
  throw Error(y$1(33));
}
function Db(a2) {
  return a2[xf] || null;
}
function $e(a2) {
  var b2 = a2[yf];
  b2 === void 0 && (b2 = a2[yf] = new Set());
  return b2;
}
var zf = [], Af = -1;
function Bf(a2) {
  return { current: a2 };
}
function H(a2) {
  0 > Af || (a2.current = zf[Af], zf[Af] = null, Af--);
}
function I(a2, b2) {
  Af++;
  zf[Af] = a2.current;
  a2.current = b2;
}
var Cf = {}, M = Bf(Cf), N = Bf(false), Df = Cf;
function Ef(a2, b2) {
  var c2 = a2.type.contextTypes;
  if (!c2)
    return Cf;
  var d2 = a2.stateNode;
  if (d2 && d2.__reactInternalMemoizedUnmaskedChildContext === b2)
    return d2.__reactInternalMemoizedMaskedChildContext;
  var e2 = {}, f2;
  for (f2 in c2)
    e2[f2] = b2[f2];
  d2 && (a2 = a2.stateNode, a2.__reactInternalMemoizedUnmaskedChildContext = b2, a2.__reactInternalMemoizedMaskedChildContext = e2);
  return e2;
}
function Ff(a2) {
  a2 = a2.childContextTypes;
  return a2 !== null && a2 !== void 0;
}
function Gf() {
  H(N);
  H(M);
}
function Hf(a2, b2, c2) {
  if (M.current !== Cf)
    throw Error(y$1(168));
  I(M, b2);
  I(N, c2);
}
function If(a2, b2, c2) {
  var d2 = a2.stateNode;
  a2 = b2.childContextTypes;
  if (typeof d2.getChildContext !== "function")
    return c2;
  d2 = d2.getChildContext();
  for (var e2 in d2)
    if (!(e2 in a2))
      throw Error(y$1(108, Ra(b2) || "Unknown", e2));
  return m$1({}, c2, d2);
}
function Jf(a2) {
  a2 = (a2 = a2.stateNode) && a2.__reactInternalMemoizedMergedChildContext || Cf;
  Df = M.current;
  I(M, a2);
  I(N, N.current);
  return true;
}
function Kf(a2, b2, c2) {
  var d2 = a2.stateNode;
  if (!d2)
    throw Error(y$1(169));
  c2 ? (a2 = If(a2, b2, Df), d2.__reactInternalMemoizedMergedChildContext = a2, H(N), H(M), I(M, a2)) : H(N);
  I(N, c2);
}
var Lf = null, Mf = null, Nf = r$1.unstable_runWithPriority, Of = r$1.unstable_scheduleCallback, Pf = r$1.unstable_cancelCallback, Qf = r$1.unstable_shouldYield, Rf = r$1.unstable_requestPaint, Sf = r$1.unstable_now, Tf = r$1.unstable_getCurrentPriorityLevel, Uf = r$1.unstable_ImmediatePriority, Vf = r$1.unstable_UserBlockingPriority, Wf = r$1.unstable_NormalPriority, Xf = r$1.unstable_LowPriority, Yf = r$1.unstable_IdlePriority, Zf = {}, $f = Rf !== void 0 ? Rf : function() {
}, ag = null, bg = null, cg = false, dg = Sf(), O = 1e4 > dg ? Sf : function() {
  return Sf() - dg;
};
function eg() {
  switch (Tf()) {
    case Uf:
      return 99;
    case Vf:
      return 98;
    case Wf:
      return 97;
    case Xf:
      return 96;
    case Yf:
      return 95;
    default:
      throw Error(y$1(332));
  }
}
function fg(a2) {
  switch (a2) {
    case 99:
      return Uf;
    case 98:
      return Vf;
    case 97:
      return Wf;
    case 96:
      return Xf;
    case 95:
      return Yf;
    default:
      throw Error(y$1(332));
  }
}
function gg(a2, b2) {
  a2 = fg(a2);
  return Nf(a2, b2);
}
function hg(a2, b2, c2) {
  a2 = fg(a2);
  return Of(a2, b2, c2);
}
function ig() {
  if (bg !== null) {
    var a2 = bg;
    bg = null;
    Pf(a2);
  }
  jg();
}
function jg() {
  if (!cg && ag !== null) {
    cg = true;
    var a2 = 0;
    try {
      var b2 = ag;
      gg(99, function() {
        for (; a2 < b2.length; a2++) {
          var c2 = b2[a2];
          do
            c2 = c2(true);
          while (c2 !== null);
        }
      });
      ag = null;
    } catch (c2) {
      throw ag !== null && (ag = ag.slice(a2 + 1)), Of(Uf, ig), c2;
    } finally {
      cg = false;
    }
  }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a2, b2) {
  if (a2 && a2.defaultProps) {
    b2 = m$1({}, b2);
    a2 = a2.defaultProps;
    for (var c2 in a2)
      b2[c2] === void 0 && (b2[c2] = a2[c2]);
    return b2;
  }
  return b2;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
  pg = og = ng = null;
}
function rg(a2) {
  var b2 = mg.current;
  H(mg);
  a2.type._context._currentValue = b2;
}
function sg(a2, b2) {
  for (; a2 !== null; ) {
    var c2 = a2.alternate;
    if ((a2.childLanes & b2) === b2)
      if (c2 === null || (c2.childLanes & b2) === b2)
        break;
      else
        c2.childLanes |= b2;
    else
      a2.childLanes |= b2, c2 !== null && (c2.childLanes |= b2);
    a2 = a2.return;
  }
}
function tg(a2, b2) {
  ng = a2;
  pg = og = null;
  a2 = a2.dependencies;
  a2 !== null && a2.firstContext !== null && ((a2.lanes & b2) !== 0 && (ug = true), a2.firstContext = null);
}
function vg(a2, b2) {
  if (pg !== a2 && b2 !== false && b2 !== 0) {
    if (typeof b2 !== "number" || b2 === 1073741823)
      pg = a2, b2 = 1073741823;
    b2 = { context: a2, observedBits: b2, next: null };
    if (og === null) {
      if (ng === null)
        throw Error(y$1(308));
      og = b2;
      ng.dependencies = { lanes: 0, firstContext: b2, responders: null };
    } else
      og = og.next = b2;
  }
  return a2._currentValue;
}
var wg = false;
function xg(a2) {
  a2.updateQueue = { baseState: a2.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null }, effects: null };
}
function yg(a2, b2) {
  a2 = a2.updateQueue;
  b2.updateQueue === a2 && (b2.updateQueue = { baseState: a2.baseState, firstBaseUpdate: a2.firstBaseUpdate, lastBaseUpdate: a2.lastBaseUpdate, shared: a2.shared, effects: a2.effects });
}
function zg(a2, b2) {
  return { eventTime: a2, lane: b2, tag: 0, payload: null, callback: null, next: null };
}
function Ag(a2, b2) {
  a2 = a2.updateQueue;
  if (a2 !== null) {
    a2 = a2.shared;
    var c2 = a2.pending;
    c2 === null ? b2.next = b2 : (b2.next = c2.next, c2.next = b2);
    a2.pending = b2;
  }
}
function Bg(a2, b2) {
  var c2 = a2.updateQueue, d2 = a2.alternate;
  if (d2 !== null && (d2 = d2.updateQueue, c2 === d2)) {
    var e2 = null, f2 = null;
    c2 = c2.firstBaseUpdate;
    if (c2 !== null) {
      do {
        var g2 = { eventTime: c2.eventTime, lane: c2.lane, tag: c2.tag, payload: c2.payload, callback: c2.callback, next: null };
        f2 === null ? e2 = f2 = g2 : f2 = f2.next = g2;
        c2 = c2.next;
      } while (c2 !== null);
      f2 === null ? e2 = f2 = b2 : f2 = f2.next = b2;
    } else
      e2 = f2 = b2;
    c2 = { baseState: d2.baseState, firstBaseUpdate: e2, lastBaseUpdate: f2, shared: d2.shared, effects: d2.effects };
    a2.updateQueue = c2;
    return;
  }
  a2 = c2.lastBaseUpdate;
  a2 === null ? c2.firstBaseUpdate = b2 : a2.next = b2;
  c2.lastBaseUpdate = b2;
}
function Cg(a2, b2, c2, d2) {
  var e2 = a2.updateQueue;
  wg = false;
  var f2 = e2.firstBaseUpdate, g2 = e2.lastBaseUpdate, h2 = e2.shared.pending;
  if (h2 !== null) {
    e2.shared.pending = null;
    var k2 = h2, l2 = k2.next;
    k2.next = null;
    g2 === null ? f2 = l2 : g2.next = l2;
    g2 = k2;
    var n2 = a2.alternate;
    if (n2 !== null) {
      n2 = n2.updateQueue;
      var A2 = n2.lastBaseUpdate;
      A2 !== g2 && (A2 === null ? n2.firstBaseUpdate = l2 : A2.next = l2, n2.lastBaseUpdate = k2);
    }
  }
  if (f2 !== null) {
    A2 = e2.baseState;
    g2 = 0;
    n2 = l2 = k2 = null;
    do {
      h2 = f2.lane;
      var p2 = f2.eventTime;
      if ((d2 & h2) === h2) {
        n2 !== null && (n2 = n2.next = {
          eventTime: p2,
          lane: 0,
          tag: f2.tag,
          payload: f2.payload,
          callback: f2.callback,
          next: null
        });
        a: {
          var C = a2, x2 = f2;
          h2 = b2;
          p2 = c2;
          switch (x2.tag) {
            case 1:
              C = x2.payload;
              if (typeof C === "function") {
                A2 = C.call(p2, A2, h2);
                break a;
              }
              A2 = C;
              break a;
            case 3:
              C.flags = C.flags & -4097 | 64;
            case 0:
              C = x2.payload;
              h2 = typeof C === "function" ? C.call(p2, A2, h2) : C;
              if (h2 === null || h2 === void 0)
                break a;
              A2 = m$1({}, A2, h2);
              break a;
            case 2:
              wg = true;
          }
        }
        f2.callback !== null && (a2.flags |= 32, h2 = e2.effects, h2 === null ? e2.effects = [f2] : h2.push(f2));
      } else
        p2 = { eventTime: p2, lane: h2, tag: f2.tag, payload: f2.payload, callback: f2.callback, next: null }, n2 === null ? (l2 = n2 = p2, k2 = A2) : n2 = n2.next = p2, g2 |= h2;
      f2 = f2.next;
      if (f2 === null)
        if (h2 = e2.shared.pending, h2 === null)
          break;
        else
          f2 = h2.next, h2.next = null, e2.lastBaseUpdate = h2, e2.shared.pending = null;
    } while (1);
    n2 === null && (k2 = A2);
    e2.baseState = k2;
    e2.firstBaseUpdate = l2;
    e2.lastBaseUpdate = n2;
    Dg |= g2;
    a2.lanes = g2;
    a2.memoizedState = A2;
  }
}
function Eg(a2, b2, c2) {
  a2 = b2.effects;
  b2.effects = null;
  if (a2 !== null)
    for (b2 = 0; b2 < a2.length; b2++) {
      var d2 = a2[b2], e2 = d2.callback;
      if (e2 !== null) {
        d2.callback = null;
        d2 = c2;
        if (typeof e2 !== "function")
          throw Error(y$1(191, e2));
        e2.call(d2);
      }
    }
}
var Fg = new aa.Component().refs;
function Gg(a2, b2, c2, d2) {
  b2 = a2.memoizedState;
  c2 = c2(d2, b2);
  c2 = c2 === null || c2 === void 0 ? b2 : m$1({}, b2, c2);
  a2.memoizedState = c2;
  a2.lanes === 0 && (a2.updateQueue.baseState = c2);
}
var Kg = { isMounted: function(a2) {
  return (a2 = a2._reactInternals) ? Zb(a2) === a2 : false;
}, enqueueSetState: function(a2, b2, c2) {
  a2 = a2._reactInternals;
  var d2 = Hg(), e2 = Ig(a2), f2 = zg(d2, e2);
  f2.payload = b2;
  c2 !== void 0 && c2 !== null && (f2.callback = c2);
  Ag(a2, f2);
  Jg(a2, e2, d2);
}, enqueueReplaceState: function(a2, b2, c2) {
  a2 = a2._reactInternals;
  var d2 = Hg(), e2 = Ig(a2), f2 = zg(d2, e2);
  f2.tag = 1;
  f2.payload = b2;
  c2 !== void 0 && c2 !== null && (f2.callback = c2);
  Ag(a2, f2);
  Jg(a2, e2, d2);
}, enqueueForceUpdate: function(a2, b2) {
  a2 = a2._reactInternals;
  var c2 = Hg(), d2 = Ig(a2), e2 = zg(c2, d2);
  e2.tag = 2;
  b2 !== void 0 && b2 !== null && (e2.callback = b2);
  Ag(a2, e2);
  Jg(a2, d2, c2);
} };
function Lg(a2, b2, c2, d2, e2, f2, g2) {
  a2 = a2.stateNode;
  return typeof a2.shouldComponentUpdate === "function" ? a2.shouldComponentUpdate(d2, f2, g2) : b2.prototype && b2.prototype.isPureReactComponent ? !Je(c2, d2) || !Je(e2, f2) : true;
}
function Mg(a2, b2, c2) {
  var d2 = false, e2 = Cf;
  var f2 = b2.contextType;
  typeof f2 === "object" && f2 !== null ? f2 = vg(f2) : (e2 = Ff(b2) ? Df : M.current, d2 = b2.contextTypes, f2 = (d2 = d2 !== null && d2 !== void 0) ? Ef(a2, e2) : Cf);
  b2 = new b2(c2, f2);
  a2.memoizedState = b2.state !== null && b2.state !== void 0 ? b2.state : null;
  b2.updater = Kg;
  a2.stateNode = b2;
  b2._reactInternals = a2;
  d2 && (a2 = a2.stateNode, a2.__reactInternalMemoizedUnmaskedChildContext = e2, a2.__reactInternalMemoizedMaskedChildContext = f2);
  return b2;
}
function Ng(a2, b2, c2, d2) {
  a2 = b2.state;
  typeof b2.componentWillReceiveProps === "function" && b2.componentWillReceiveProps(c2, d2);
  typeof b2.UNSAFE_componentWillReceiveProps === "function" && b2.UNSAFE_componentWillReceiveProps(c2, d2);
  b2.state !== a2 && Kg.enqueueReplaceState(b2, b2.state, null);
}
function Og(a2, b2, c2, d2) {
  var e2 = a2.stateNode;
  e2.props = c2;
  e2.state = a2.memoizedState;
  e2.refs = Fg;
  xg(a2);
  var f2 = b2.contextType;
  typeof f2 === "object" && f2 !== null ? e2.context = vg(f2) : (f2 = Ff(b2) ? Df : M.current, e2.context = Ef(a2, f2));
  Cg(a2, c2, e2, d2);
  e2.state = a2.memoizedState;
  f2 = b2.getDerivedStateFromProps;
  typeof f2 === "function" && (Gg(a2, b2, f2, c2), e2.state = a2.memoizedState);
  typeof b2.getDerivedStateFromProps === "function" || typeof e2.getSnapshotBeforeUpdate === "function" || typeof e2.UNSAFE_componentWillMount !== "function" && typeof e2.componentWillMount !== "function" || (b2 = e2.state, typeof e2.componentWillMount === "function" && e2.componentWillMount(), typeof e2.UNSAFE_componentWillMount === "function" && e2.UNSAFE_componentWillMount(), b2 !== e2.state && Kg.enqueueReplaceState(e2, e2.state, null), Cg(a2, c2, e2, d2), e2.state = a2.memoizedState);
  typeof e2.componentDidMount === "function" && (a2.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a2, b2, c2) {
  a2 = c2.ref;
  if (a2 !== null && typeof a2 !== "function" && typeof a2 !== "object") {
    if (c2._owner) {
      c2 = c2._owner;
      if (c2) {
        if (c2.tag !== 1)
          throw Error(y$1(309));
        var d2 = c2.stateNode;
      }
      if (!d2)
        throw Error(y$1(147, a2));
      var e2 = "" + a2;
      if (b2 !== null && b2.ref !== null && typeof b2.ref === "function" && b2.ref._stringRef === e2)
        return b2.ref;
      b2 = function(a3) {
        var b3 = d2.refs;
        b3 === Fg && (b3 = d2.refs = {});
        a3 === null ? delete b3[e2] : b3[e2] = a3;
      };
      b2._stringRef = e2;
      return b2;
    }
    if (typeof a2 !== "string")
      throw Error(y$1(284));
    if (!c2._owner)
      throw Error(y$1(290, a2));
  }
  return a2;
}
function Rg(a2, b2) {
  if (a2.type !== "textarea")
    throw Error(y$1(31, Object.prototype.toString.call(b2) === "[object Object]" ? "object with keys {" + Object.keys(b2).join(", ") + "}" : b2));
}
function Sg(a2) {
  function b2(b3, c3) {
    if (a2) {
      var d3 = b3.lastEffect;
      d3 !== null ? (d3.nextEffect = c3, b3.lastEffect = c3) : b3.firstEffect = b3.lastEffect = c3;
      c3.nextEffect = null;
      c3.flags = 8;
    }
  }
  function c2(c3, d3) {
    if (!a2)
      return null;
    for (; d3 !== null; )
      b2(c3, d3), d3 = d3.sibling;
    return null;
  }
  function d2(a3, b3) {
    for (a3 = new Map(); b3 !== null; )
      b3.key !== null ? a3.set(b3.key, b3) : a3.set(b3.index, b3), b3 = b3.sibling;
    return a3;
  }
  function e2(a3, b3) {
    a3 = Tg(a3, b3);
    a3.index = 0;
    a3.sibling = null;
    return a3;
  }
  function f2(b3, c3, d3) {
    b3.index = d3;
    if (!a2)
      return c3;
    d3 = b3.alternate;
    if (d3 !== null)
      return d3 = d3.index, d3 < c3 ? (b3.flags = 2, c3) : d3;
    b3.flags = 2;
    return c3;
  }
  function g2(b3) {
    a2 && b3.alternate === null && (b3.flags = 2);
    return b3;
  }
  function h2(a3, b3, c3, d3) {
    if (b3 === null || b3.tag !== 6)
      return b3 = Ug(c3, a3.mode, d3), b3.return = a3, b3;
    b3 = e2(b3, c3);
    b3.return = a3;
    return b3;
  }
  function k2(a3, b3, c3, d3) {
    if (b3 !== null && b3.elementType === c3.type)
      return d3 = e2(b3, c3.props), d3.ref = Qg(a3, b3, c3), d3.return = a3, d3;
    d3 = Vg(c3.type, c3.key, c3.props, null, a3.mode, d3);
    d3.ref = Qg(a3, b3, c3);
    d3.return = a3;
    return d3;
  }
  function l2(a3, b3, c3, d3) {
    if (b3 === null || b3.tag !== 4 || b3.stateNode.containerInfo !== c3.containerInfo || b3.stateNode.implementation !== c3.implementation)
      return b3 = Wg(c3, a3.mode, d3), b3.return = a3, b3;
    b3 = e2(b3, c3.children || []);
    b3.return = a3;
    return b3;
  }
  function n2(a3, b3, c3, d3, f3) {
    if (b3 === null || b3.tag !== 7)
      return b3 = Xg(c3, a3.mode, d3, f3), b3.return = a3, b3;
    b3 = e2(b3, c3);
    b3.return = a3;
    return b3;
  }
  function A2(a3, b3, c3) {
    if (typeof b3 === "string" || typeof b3 === "number")
      return b3 = Ug("" + b3, a3.mode, c3), b3.return = a3, b3;
    if (typeof b3 === "object" && b3 !== null) {
      switch (b3.$$typeof) {
        case sa:
          return c3 = Vg(b3.type, b3.key, b3.props, null, a3.mode, c3), c3.ref = Qg(a3, null, b3), c3.return = a3, c3;
        case ta:
          return b3 = Wg(b3, a3.mode, c3), b3.return = a3, b3;
      }
      if (Pg(b3) || La(b3))
        return b3 = Xg(b3, a3.mode, c3, null), b3.return = a3, b3;
      Rg(a3, b3);
    }
    return null;
  }
  function p2(a3, b3, c3, d3) {
    var e3 = b3 !== null ? b3.key : null;
    if (typeof c3 === "string" || typeof c3 === "number")
      return e3 !== null ? null : h2(a3, b3, "" + c3, d3);
    if (typeof c3 === "object" && c3 !== null) {
      switch (c3.$$typeof) {
        case sa:
          return c3.key === e3 ? c3.type === ua ? n2(a3, b3, c3.props.children, d3, e3) : k2(a3, b3, c3, d3) : null;
        case ta:
          return c3.key === e3 ? l2(a3, b3, c3, d3) : null;
      }
      if (Pg(c3) || La(c3))
        return e3 !== null ? null : n2(a3, b3, c3, d3, null);
      Rg(a3, c3);
    }
    return null;
  }
  function C(a3, b3, c3, d3, e3) {
    if (typeof d3 === "string" || typeof d3 === "number")
      return a3 = a3.get(c3) || null, h2(b3, a3, "" + d3, e3);
    if (typeof d3 === "object" && d3 !== null) {
      switch (d3.$$typeof) {
        case sa:
          return a3 = a3.get(d3.key === null ? c3 : d3.key) || null, d3.type === ua ? n2(b3, a3, d3.props.children, e3, d3.key) : k2(b3, a3, d3, e3);
        case ta:
          return a3 = a3.get(d3.key === null ? c3 : d3.key) || null, l2(b3, a3, d3, e3);
      }
      if (Pg(d3) || La(d3))
        return a3 = a3.get(c3) || null, n2(b3, a3, d3, e3, null);
      Rg(b3, d3);
    }
    return null;
  }
  function x2(e3, g3, h3, k3) {
    for (var l3 = null, t2 = null, u = g3, z2 = g3 = 0, q2 = null; u !== null && z2 < h3.length; z2++) {
      u.index > z2 ? (q2 = u, u = null) : q2 = u.sibling;
      var n3 = p2(e3, u, h3[z2], k3);
      if (n3 === null) {
        u === null && (u = q2);
        break;
      }
      a2 && u && n3.alternate === null && b2(e3, u);
      g3 = f2(n3, g3, z2);
      t2 === null ? l3 = n3 : t2.sibling = n3;
      t2 = n3;
      u = q2;
    }
    if (z2 === h3.length)
      return c2(e3, u), l3;
    if (u === null) {
      for (; z2 < h3.length; z2++)
        u = A2(e3, h3[z2], k3), u !== null && (g3 = f2(u, g3, z2), t2 === null ? l3 = u : t2.sibling = u, t2 = u);
      return l3;
    }
    for (u = d2(e3, u); z2 < h3.length; z2++)
      q2 = C(u, e3, z2, h3[z2], k3), q2 !== null && (a2 && q2.alternate !== null && u.delete(q2.key === null ? z2 : q2.key), g3 = f2(q2, g3, z2), t2 === null ? l3 = q2 : t2.sibling = q2, t2 = q2);
    a2 && u.forEach(function(a3) {
      return b2(e3, a3);
    });
    return l3;
  }
  function w2(e3, g3, h3, k3) {
    var l3 = La(h3);
    if (typeof l3 !== "function")
      throw Error(y$1(150));
    h3 = l3.call(h3);
    if (h3 == null)
      throw Error(y$1(151));
    for (var t2 = l3 = null, u = g3, z2 = g3 = 0, q2 = null, n3 = h3.next(); u !== null && !n3.done; z2++, n3 = h3.next()) {
      u.index > z2 ? (q2 = u, u = null) : q2 = u.sibling;
      var w3 = p2(e3, u, n3.value, k3);
      if (w3 === null) {
        u === null && (u = q2);
        break;
      }
      a2 && u && w3.alternate === null && b2(e3, u);
      g3 = f2(w3, g3, z2);
      t2 === null ? l3 = w3 : t2.sibling = w3;
      t2 = w3;
      u = q2;
    }
    if (n3.done)
      return c2(e3, u), l3;
    if (u === null) {
      for (; !n3.done; z2++, n3 = h3.next())
        n3 = A2(e3, n3.value, k3), n3 !== null && (g3 = f2(n3, g3, z2), t2 === null ? l3 = n3 : t2.sibling = n3, t2 = n3);
      return l3;
    }
    for (u = d2(e3, u); !n3.done; z2++, n3 = h3.next())
      n3 = C(u, e3, z2, n3.value, k3), n3 !== null && (a2 && n3.alternate !== null && u.delete(n3.key === null ? z2 : n3.key), g3 = f2(n3, g3, z2), t2 === null ? l3 = n3 : t2.sibling = n3, t2 = n3);
    a2 && u.forEach(function(a3) {
      return b2(e3, a3);
    });
    return l3;
  }
  return function(a3, d3, f3, h3) {
    var k3 = typeof f3 === "object" && f3 !== null && f3.type === ua && f3.key === null;
    k3 && (f3 = f3.props.children);
    var l3 = typeof f3 === "object" && f3 !== null;
    if (l3)
      switch (f3.$$typeof) {
        case sa:
          a: {
            l3 = f3.key;
            for (k3 = d3; k3 !== null; ) {
              if (k3.key === l3) {
                switch (k3.tag) {
                  case 7:
                    if (f3.type === ua) {
                      c2(a3, k3.sibling);
                      d3 = e2(k3, f3.props.children);
                      d3.return = a3;
                      a3 = d3;
                      break a;
                    }
                    break;
                  default:
                    if (k3.elementType === f3.type) {
                      c2(a3, k3.sibling);
                      d3 = e2(k3, f3.props);
                      d3.ref = Qg(a3, k3, f3);
                      d3.return = a3;
                      a3 = d3;
                      break a;
                    }
                }
                c2(a3, k3);
                break;
              } else
                b2(a3, k3);
              k3 = k3.sibling;
            }
            f3.type === ua ? (d3 = Xg(f3.props.children, a3.mode, h3, f3.key), d3.return = a3, a3 = d3) : (h3 = Vg(f3.type, f3.key, f3.props, null, a3.mode, h3), h3.ref = Qg(a3, d3, f3), h3.return = a3, a3 = h3);
          }
          return g2(a3);
        case ta:
          a: {
            for (k3 = f3.key; d3 !== null; ) {
              if (d3.key === k3)
                if (d3.tag === 4 && d3.stateNode.containerInfo === f3.containerInfo && d3.stateNode.implementation === f3.implementation) {
                  c2(a3, d3.sibling);
                  d3 = e2(d3, f3.children || []);
                  d3.return = a3;
                  a3 = d3;
                  break a;
                } else {
                  c2(a3, d3);
                  break;
                }
              else
                b2(a3, d3);
              d3 = d3.sibling;
            }
            d3 = Wg(f3, a3.mode, h3);
            d3.return = a3;
            a3 = d3;
          }
          return g2(a3);
      }
    if (typeof f3 === "string" || typeof f3 === "number")
      return f3 = "" + f3, d3 !== null && d3.tag === 6 ? (c2(a3, d3.sibling), d3 = e2(d3, f3), d3.return = a3, a3 = d3) : (c2(a3, d3), d3 = Ug(f3, a3.mode, h3), d3.return = a3, a3 = d3), g2(a3);
    if (Pg(f3))
      return x2(a3, d3, f3, h3);
    if (La(f3))
      return w2(a3, d3, f3, h3);
    l3 && Rg(a3, f3);
    if (typeof f3 === "undefined" && !k3)
      switch (a3.tag) {
        case 1:
        case 22:
        case 0:
        case 11:
        case 15:
          throw Error(y$1(152, Ra(a3.type) || "Component"));
      }
    return c2(a3, d3);
  };
}
var Yg = Sg(true), Zg = Sg(false), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a2) {
  if (a2 === $g)
    throw Error(y$1(174));
  return a2;
}
function eh(a2, b2) {
  I(ch, b2);
  I(bh, a2);
  I(ah, $g);
  a2 = b2.nodeType;
  switch (a2) {
    case 9:
    case 11:
      b2 = (b2 = b2.documentElement) ? b2.namespaceURI : mb(null, "");
      break;
    default:
      a2 = a2 === 8 ? b2.parentNode : b2, b2 = a2.namespaceURI || null, a2 = a2.tagName, b2 = mb(b2, a2);
  }
  H(ah);
  I(ah, b2);
}
function fh() {
  H(ah);
  H(bh);
  H(ch);
}
function gh(a2) {
  dh(ch.current);
  var b2 = dh(ah.current);
  var c2 = mb(b2, a2.type);
  b2 !== c2 && (I(bh, a2), I(ah, c2));
}
function hh(a2) {
  bh.current === a2 && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a2) {
  for (var b2 = a2; b2 !== null; ) {
    if (b2.tag === 13) {
      var c2 = b2.memoizedState;
      if (c2 !== null && (c2 = c2.dehydrated, c2 === null || c2.data === "$?" || c2.data === "$!"))
        return b2;
    } else if (b2.tag === 19 && b2.memoizedProps.revealOrder !== void 0) {
      if ((b2.flags & 64) !== 0)
        return b2;
    } else if (b2.child !== null) {
      b2.child.return = b2;
      b2 = b2.child;
      continue;
    }
    if (b2 === a2)
      break;
    for (; b2.sibling === null; ) {
      if (b2.return === null || b2.return === a2)
        return null;
      b2 = b2.return;
    }
    b2.sibling.return = b2.return;
    b2 = b2.sibling;
  }
  return null;
}
var jh = null, kh = null, lh = false;
function mh(a2, b2) {
  var c2 = nh(5, null, null, 0);
  c2.elementType = "DELETED";
  c2.type = "DELETED";
  c2.stateNode = b2;
  c2.return = a2;
  c2.flags = 8;
  a2.lastEffect !== null ? (a2.lastEffect.nextEffect = c2, a2.lastEffect = c2) : a2.firstEffect = a2.lastEffect = c2;
}
function oh(a2, b2) {
  switch (a2.tag) {
    case 5:
      var c2 = a2.type;
      b2 = b2.nodeType !== 1 || c2.toLowerCase() !== b2.nodeName.toLowerCase() ? null : b2;
      return b2 !== null ? (a2.stateNode = b2, true) : false;
    case 6:
      return b2 = a2.pendingProps === "" || b2.nodeType !== 3 ? null : b2, b2 !== null ? (a2.stateNode = b2, true) : false;
    case 13:
      return false;
    default:
      return false;
  }
}
function ph(a2) {
  if (lh) {
    var b2 = kh;
    if (b2) {
      var c2 = b2;
      if (!oh(a2, b2)) {
        b2 = rf(c2.nextSibling);
        if (!b2 || !oh(a2, b2)) {
          a2.flags = a2.flags & -1025 | 2;
          lh = false;
          jh = a2;
          return;
        }
        mh(jh, c2);
      }
      jh = a2;
      kh = rf(b2.firstChild);
    } else
      a2.flags = a2.flags & -1025 | 2, lh = false, jh = a2;
  }
}
function qh(a2) {
  for (a2 = a2.return; a2 !== null && a2.tag !== 5 && a2.tag !== 3 && a2.tag !== 13; )
    a2 = a2.return;
  jh = a2;
}
function rh(a2) {
  if (a2 !== jh)
    return false;
  if (!lh)
    return qh(a2), lh = true, false;
  var b2 = a2.type;
  if (a2.tag !== 5 || b2 !== "head" && b2 !== "body" && !nf(b2, a2.memoizedProps))
    for (b2 = kh; b2; )
      mh(a2, b2), b2 = rf(b2.nextSibling);
  qh(a2);
  if (a2.tag === 13) {
    a2 = a2.memoizedState;
    a2 = a2 !== null ? a2.dehydrated : null;
    if (!a2)
      throw Error(y$1(317));
    a: {
      a2 = a2.nextSibling;
      for (b2 = 0; a2; ) {
        if (a2.nodeType === 8) {
          var c2 = a2.data;
          if (c2 === "/$") {
            if (b2 === 0) {
              kh = rf(a2.nextSibling);
              break a;
            }
            b2--;
          } else
            c2 !== "$" && c2 !== "$!" && c2 !== "$?" || b2++;
        }
        a2 = a2.nextSibling;
      }
      kh = null;
    }
  } else
    kh = jh ? rf(a2.stateNode.nextSibling) : null;
  return true;
}
function sh() {
  kh = jh = null;
  lh = false;
}
var th$n = [];
function uh() {
  for (var a2 = 0; a2 < th$n.length; a2++)
    th$n[a2]._workInProgressVersionPrimary = null;
  th$n.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = false, zh = false;
function Ah() {
  throw Error(y$1(321));
}
function Bh(a2, b2) {
  if (b2 === null)
    return false;
  for (var c2 = 0; c2 < b2.length && c2 < a2.length; c2++)
    if (!He(a2[c2], b2[c2]))
      return false;
  return true;
}
function Ch(a2, b2, c2, d2, e2, f2) {
  xh = f2;
  R = b2;
  b2.memoizedState = null;
  b2.updateQueue = null;
  b2.lanes = 0;
  vh.current = a2 === null || a2.memoizedState === null ? Dh : Eh;
  a2 = c2(d2, e2);
  if (zh) {
    f2 = 0;
    do {
      zh = false;
      if (!(25 > f2))
        throw Error(y$1(301));
      f2 += 1;
      T = S = null;
      b2.updateQueue = null;
      vh.current = Fh;
      a2 = c2(d2, e2);
    } while (zh);
  }
  vh.current = Gh;
  b2 = S !== null && S.next !== null;
  xh = 0;
  T = S = R = null;
  yh = false;
  if (b2)
    throw Error(y$1(300));
  return a2;
}
function Hh() {
  var a2 = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
  T === null ? R.memoizedState = T = a2 : T = T.next = a2;
  return T;
}
function Ih() {
  if (S === null) {
    var a2 = R.alternate;
    a2 = a2 !== null ? a2.memoizedState : null;
  } else
    a2 = S.next;
  var b2 = T === null ? R.memoizedState : T.next;
  if (b2 !== null)
    T = b2, S = a2;
  else {
    if (a2 === null)
      throw Error(y$1(310));
    S = a2;
    a2 = { memoizedState: S.memoizedState, baseState: S.baseState, baseQueue: S.baseQueue, queue: S.queue, next: null };
    T === null ? R.memoizedState = T = a2 : T = T.next = a2;
  }
  return T;
}
function Jh(a2, b2) {
  return typeof b2 === "function" ? b2(a2) : b2;
}
function Kh(a2) {
  var b2 = Ih(), c2 = b2.queue;
  if (c2 === null)
    throw Error(y$1(311));
  c2.lastRenderedReducer = a2;
  var d2 = S, e2 = d2.baseQueue, f2 = c2.pending;
  if (f2 !== null) {
    if (e2 !== null) {
      var g2 = e2.next;
      e2.next = f2.next;
      f2.next = g2;
    }
    d2.baseQueue = e2 = f2;
    c2.pending = null;
  }
  if (e2 !== null) {
    e2 = e2.next;
    d2 = d2.baseState;
    var h2 = g2 = f2 = null, k2 = e2;
    do {
      var l2 = k2.lane;
      if ((xh & l2) === l2)
        h2 !== null && (h2 = h2.next = { lane: 0, action: k2.action, eagerReducer: k2.eagerReducer, eagerState: k2.eagerState, next: null }), d2 = k2.eagerReducer === a2 ? k2.eagerState : a2(d2, k2.action);
      else {
        var n2 = {
          lane: l2,
          action: k2.action,
          eagerReducer: k2.eagerReducer,
          eagerState: k2.eagerState,
          next: null
        };
        h2 === null ? (g2 = h2 = n2, f2 = d2) : h2 = h2.next = n2;
        R.lanes |= l2;
        Dg |= l2;
      }
      k2 = k2.next;
    } while (k2 !== null && k2 !== e2);
    h2 === null ? f2 = d2 : h2.next = g2;
    He(d2, b2.memoizedState) || (ug = true);
    b2.memoizedState = d2;
    b2.baseState = f2;
    b2.baseQueue = h2;
    c2.lastRenderedState = d2;
  }
  return [b2.memoizedState, c2.dispatch];
}
function Lh(a2) {
  var b2 = Ih(), c2 = b2.queue;
  if (c2 === null)
    throw Error(y$1(311));
  c2.lastRenderedReducer = a2;
  var d2 = c2.dispatch, e2 = c2.pending, f2 = b2.memoizedState;
  if (e2 !== null) {
    c2.pending = null;
    var g2 = e2 = e2.next;
    do
      f2 = a2(f2, g2.action), g2 = g2.next;
    while (g2 !== e2);
    He(f2, b2.memoizedState) || (ug = true);
    b2.memoizedState = f2;
    b2.baseQueue === null && (b2.baseState = f2);
    c2.lastRenderedState = f2;
  }
  return [f2, d2];
}
function Mh(a2, b2, c2) {
  var d2 = b2._getVersion;
  d2 = d2(b2._source);
  var e2 = b2._workInProgressVersionPrimary;
  if (e2 !== null)
    a2 = e2 === d2;
  else if (a2 = a2.mutableReadLanes, a2 = (xh & a2) === a2)
    b2._workInProgressVersionPrimary = d2, th$n.push(b2);
  if (a2)
    return c2(b2._source);
  th$n.push(b2);
  throw Error(y$1(350));
}
function Nh(a2, b2, c2, d2) {
  var e2 = U;
  if (e2 === null)
    throw Error(y$1(349));
  var f2 = b2._getVersion, g2 = f2(b2._source), h2 = vh.current, k2 = h2.useState(function() {
    return Mh(e2, b2, c2);
  }), l2 = k2[1], n2 = k2[0];
  k2 = T;
  var A2 = a2.memoizedState, p2 = A2.refs, C = p2.getSnapshot, x2 = A2.source;
  A2 = A2.subscribe;
  var w2 = R;
  a2.memoizedState = { refs: p2, source: b2, subscribe: d2 };
  h2.useEffect(function() {
    p2.getSnapshot = c2;
    p2.setSnapshot = l2;
    var a3 = f2(b2._source);
    if (!He(g2, a3)) {
      a3 = c2(b2._source);
      He(n2, a3) || (l2(a3), a3 = Ig(w2), e2.mutableReadLanes |= a3 & e2.pendingLanes);
      a3 = e2.mutableReadLanes;
      e2.entangledLanes |= a3;
      for (var d3 = e2.entanglements, h3 = a3; 0 < h3; ) {
        var k3 = 31 - Vc(h3), v2 = 1 << k3;
        d3[k3] |= a3;
        h3 &= ~v2;
      }
    }
  }, [c2, b2, d2]);
  h2.useEffect(function() {
    return d2(b2._source, function() {
      var a3 = p2.getSnapshot, c3 = p2.setSnapshot;
      try {
        c3(a3(b2._source));
        var d3 = Ig(w2);
        e2.mutableReadLanes |= d3 & e2.pendingLanes;
      } catch (q2) {
        c3(function() {
          throw q2;
        });
      }
    });
  }, [b2, d2]);
  He(C, c2) && He(x2, b2) && He(A2, d2) || (a2 = { pending: null, dispatch: null, lastRenderedReducer: Jh, lastRenderedState: n2 }, a2.dispatch = l2 = Oh.bind(null, R, a2), k2.queue = a2, k2.baseQueue = null, n2 = Mh(e2, b2, c2), k2.memoizedState = k2.baseState = n2);
  return n2;
}
function Ph(a2, b2, c2) {
  var d2 = Ih();
  return Nh(d2, a2, b2, c2);
}
function Qh(a2) {
  var b2 = Hh();
  typeof a2 === "function" && (a2 = a2());
  b2.memoizedState = b2.baseState = a2;
  a2 = b2.queue = { pending: null, dispatch: null, lastRenderedReducer: Jh, lastRenderedState: a2 };
  a2 = a2.dispatch = Oh.bind(null, R, a2);
  return [b2.memoizedState, a2];
}
function Rh(a2, b2, c2, d2) {
  a2 = { tag: a2, create: b2, destroy: c2, deps: d2, next: null };
  b2 = R.updateQueue;
  b2 === null ? (b2 = { lastEffect: null }, R.updateQueue = b2, b2.lastEffect = a2.next = a2) : (c2 = b2.lastEffect, c2 === null ? b2.lastEffect = a2.next = a2 : (d2 = c2.next, c2.next = a2, a2.next = d2, b2.lastEffect = a2));
  return a2;
}
function Sh(a2) {
  var b2 = Hh();
  a2 = { current: a2 };
  return b2.memoizedState = a2;
}
function Th() {
  return Ih().memoizedState;
}
function Uh(a2, b2, c2, d2) {
  var e2 = Hh();
  R.flags |= a2;
  e2.memoizedState = Rh(1 | b2, c2, void 0, d2 === void 0 ? null : d2);
}
function Vh(a2, b2, c2, d2) {
  var e2 = Ih();
  d2 = d2 === void 0 ? null : d2;
  var f2 = void 0;
  if (S !== null) {
    var g2 = S.memoizedState;
    f2 = g2.destroy;
    if (d2 !== null && Bh(d2, g2.deps)) {
      Rh(b2, c2, f2, d2);
      return;
    }
  }
  R.flags |= a2;
  e2.memoizedState = Rh(1 | b2, c2, f2, d2);
}
function Wh(a2, b2) {
  return Uh(516, 4, a2, b2);
}
function Xh(a2, b2) {
  return Vh(516, 4, a2, b2);
}
function Yh(a2, b2) {
  return Vh(4, 2, a2, b2);
}
function Zh(a2, b2) {
  if (typeof b2 === "function")
    return a2 = a2(), b2(a2), function() {
      b2(null);
    };
  if (b2 !== null && b2 !== void 0)
    return a2 = a2(), b2.current = a2, function() {
      b2.current = null;
    };
}
function $h(a2, b2, c2) {
  c2 = c2 !== null && c2 !== void 0 ? c2.concat([a2]) : null;
  return Vh(4, 2, Zh.bind(null, b2, a2), c2);
}
function ai() {
}
function bi(a2, b2) {
  var c2 = Ih();
  b2 = b2 === void 0 ? null : b2;
  var d2 = c2.memoizedState;
  if (d2 !== null && b2 !== null && Bh(b2, d2[1]))
    return d2[0];
  c2.memoizedState = [a2, b2];
  return a2;
}
function ci(a2, b2) {
  var c2 = Ih();
  b2 = b2 === void 0 ? null : b2;
  var d2 = c2.memoizedState;
  if (d2 !== null && b2 !== null && Bh(b2, d2[1]))
    return d2[0];
  a2 = a2();
  c2.memoizedState = [a2, b2];
  return a2;
}
function di(a2, b2) {
  var c2 = eg();
  gg(98 > c2 ? 98 : c2, function() {
    a2(true);
  });
  gg(97 < c2 ? 97 : c2, function() {
    var c3 = wh.transition;
    wh.transition = 1;
    try {
      a2(false), b2();
    } finally {
      wh.transition = c3;
    }
  });
}
function Oh(a2, b2, c2) {
  var d2 = Hg(), e2 = Ig(a2), f2 = { lane: e2, action: c2, eagerReducer: null, eagerState: null, next: null }, g2 = b2.pending;
  g2 === null ? f2.next = f2 : (f2.next = g2.next, g2.next = f2);
  b2.pending = f2;
  g2 = a2.alternate;
  if (a2 === R || g2 !== null && g2 === R)
    zh = yh = true;
  else {
    if (a2.lanes === 0 && (g2 === null || g2.lanes === 0) && (g2 = b2.lastRenderedReducer, g2 !== null))
      try {
        var h2 = b2.lastRenderedState, k2 = g2(h2, c2);
        f2.eagerReducer = g2;
        f2.eagerState = k2;
        if (He(k2, h2))
          return;
      } catch (l2) {
      } finally {
      }
    Jg(a2, e2, d2);
  }
}
var Gh = { readContext: vg, useCallback: Ah, useContext: Ah, useEffect: Ah, useImperativeHandle: Ah, useLayoutEffect: Ah, useMemo: Ah, useReducer: Ah, useRef: Ah, useState: Ah, useDebugValue: Ah, useDeferredValue: Ah, useTransition: Ah, useMutableSource: Ah, useOpaqueIdentifier: Ah, unstable_isNewReconciler: false }, Dh = { readContext: vg, useCallback: function(a2, b2) {
  Hh().memoizedState = [a2, b2 === void 0 ? null : b2];
  return a2;
}, useContext: vg, useEffect: Wh, useImperativeHandle: function(a2, b2, c2) {
  c2 = c2 !== null && c2 !== void 0 ? c2.concat([a2]) : null;
  return Uh(4, 2, Zh.bind(null, b2, a2), c2);
}, useLayoutEffect: function(a2, b2) {
  return Uh(4, 2, a2, b2);
}, useMemo: function(a2, b2) {
  var c2 = Hh();
  b2 = b2 === void 0 ? null : b2;
  a2 = a2();
  c2.memoizedState = [a2, b2];
  return a2;
}, useReducer: function(a2, b2, c2) {
  var d2 = Hh();
  b2 = c2 !== void 0 ? c2(b2) : b2;
  d2.memoizedState = d2.baseState = b2;
  a2 = d2.queue = { pending: null, dispatch: null, lastRenderedReducer: a2, lastRenderedState: b2 };
  a2 = a2.dispatch = Oh.bind(null, R, a2);
  return [d2.memoizedState, a2];
}, useRef: Sh, useState: Qh, useDebugValue: ai, useDeferredValue: function(a2) {
  var b2 = Qh(a2), c2 = b2[0], d2 = b2[1];
  Wh(function() {
    var b3 = wh.transition;
    wh.transition = 1;
    try {
      d2(a2);
    } finally {
      wh.transition = b3;
    }
  }, [a2]);
  return c2;
}, useTransition: function() {
  var a2 = Qh(false), b2 = a2[0];
  a2 = di.bind(null, a2[1]);
  Sh(a2);
  return [a2, b2];
}, useMutableSource: function(a2, b2, c2) {
  var d2 = Hh();
  d2.memoizedState = { refs: { getSnapshot: b2, setSnapshot: null }, source: a2, subscribe: c2 };
  return Nh(d2, a2, b2, c2);
}, useOpaqueIdentifier: function() {
  if (lh) {
    var a2 = false, b2 = uf(function() {
      a2 || (a2 = true, c2("r:" + (tf++).toString(36)));
      throw Error(y$1(355));
    }), c2 = Qh(b2)[1];
    (R.mode & 2) === 0 && (R.flags |= 516, Rh(5, function() {
      c2("r:" + (tf++).toString(36));
    }, void 0, null));
    return b2;
  }
  b2 = "r:" + (tf++).toString(36);
  Qh(b2);
  return b2;
}, unstable_isNewReconciler: false }, Eh = { readContext: vg, useCallback: bi, useContext: vg, useEffect: Xh, useImperativeHandle: $h, useLayoutEffect: Yh, useMemo: ci, useReducer: Kh, useRef: Th, useState: function() {
  return Kh(Jh);
}, useDebugValue: ai, useDeferredValue: function(a2) {
  var b2 = Kh(Jh), c2 = b2[0], d2 = b2[1];
  Xh(function() {
    var b3 = wh.transition;
    wh.transition = 1;
    try {
      d2(a2);
    } finally {
      wh.transition = b3;
    }
  }, [a2]);
  return c2;
}, useTransition: function() {
  var a2 = Kh(Jh)[0];
  return [
    Th().current,
    a2
  ];
}, useMutableSource: Ph, useOpaqueIdentifier: function() {
  return Kh(Jh)[0];
}, unstable_isNewReconciler: false }, Fh = { readContext: vg, useCallback: bi, useContext: vg, useEffect: Xh, useImperativeHandle: $h, useLayoutEffect: Yh, useMemo: ci, useReducer: Lh, useRef: Th, useState: function() {
  return Lh(Jh);
}, useDebugValue: ai, useDeferredValue: function(a2) {
  var b2 = Lh(Jh), c2 = b2[0], d2 = b2[1];
  Xh(function() {
    var b3 = wh.transition;
    wh.transition = 1;
    try {
      d2(a2);
    } finally {
      wh.transition = b3;
    }
  }, [a2]);
  return c2;
}, useTransition: function() {
  var a2 = Lh(Jh)[0];
  return [
    Th().current,
    a2
  ];
}, useMutableSource: Ph, useOpaqueIdentifier: function() {
  return Lh(Jh)[0];
}, unstable_isNewReconciler: false }, ei = ra.ReactCurrentOwner, ug = false;
function fi(a2, b2, c2, d2) {
  b2.child = a2 === null ? Zg(b2, null, c2, d2) : Yg(b2, a2.child, c2, d2);
}
function gi(a2, b2, c2, d2, e2) {
  c2 = c2.render;
  var f2 = b2.ref;
  tg(b2, e2);
  d2 = Ch(a2, b2, c2, d2, f2, e2);
  if (a2 !== null && !ug)
    return b2.updateQueue = a2.updateQueue, b2.flags &= -517, a2.lanes &= ~e2, hi(a2, b2, e2);
  b2.flags |= 1;
  fi(a2, b2, d2, e2);
  return b2.child;
}
function ii(a2, b2, c2, d2, e2, f2) {
  if (a2 === null) {
    var g2 = c2.type;
    if (typeof g2 === "function" && !ji(g2) && g2.defaultProps === void 0 && c2.compare === null && c2.defaultProps === void 0)
      return b2.tag = 15, b2.type = g2, ki(a2, b2, g2, d2, e2, f2);
    a2 = Vg(c2.type, null, d2, b2, b2.mode, f2);
    a2.ref = b2.ref;
    a2.return = b2;
    return b2.child = a2;
  }
  g2 = a2.child;
  if ((e2 & f2) === 0 && (e2 = g2.memoizedProps, c2 = c2.compare, c2 = c2 !== null ? c2 : Je, c2(e2, d2) && a2.ref === b2.ref))
    return hi(a2, b2, f2);
  b2.flags |= 1;
  a2 = Tg(g2, d2);
  a2.ref = b2.ref;
  a2.return = b2;
  return b2.child = a2;
}
function ki(a2, b2, c2, d2, e2, f2) {
  if (a2 !== null && Je(a2.memoizedProps, d2) && a2.ref === b2.ref)
    if (ug = false, (f2 & e2) !== 0)
      (a2.flags & 16384) !== 0 && (ug = true);
    else
      return b2.lanes = a2.lanes, hi(a2, b2, f2);
  return li(a2, b2, c2, d2, f2);
}
function mi(a2, b2, c2) {
  var d2 = b2.pendingProps, e2 = d2.children, f2 = a2 !== null ? a2.memoizedState : null;
  if (d2.mode === "hidden" || d2.mode === "unstable-defer-without-hiding")
    if ((b2.mode & 4) === 0)
      b2.memoizedState = { baseLanes: 0 }, ni(b2, c2);
    else if ((c2 & 1073741824) !== 0)
      b2.memoizedState = { baseLanes: 0 }, ni(b2, f2 !== null ? f2.baseLanes : c2);
    else
      return a2 = f2 !== null ? f2.baseLanes | c2 : c2, b2.lanes = b2.childLanes = 1073741824, b2.memoizedState = { baseLanes: a2 }, ni(b2, a2), null;
  else
    f2 !== null ? (d2 = f2.baseLanes | c2, b2.memoizedState = null) : d2 = c2, ni(b2, d2);
  fi(a2, b2, e2, c2);
  return b2.child;
}
function oi(a2, b2) {
  var c2 = b2.ref;
  if (a2 === null && c2 !== null || a2 !== null && a2.ref !== c2)
    b2.flags |= 128;
}
function li(a2, b2, c2, d2, e2) {
  var f2 = Ff(c2) ? Df : M.current;
  f2 = Ef(b2, f2);
  tg(b2, e2);
  c2 = Ch(a2, b2, c2, d2, f2, e2);
  if (a2 !== null && !ug)
    return b2.updateQueue = a2.updateQueue, b2.flags &= -517, a2.lanes &= ~e2, hi(a2, b2, e2);
  b2.flags |= 1;
  fi(a2, b2, c2, e2);
  return b2.child;
}
function pi(a2, b2, c2, d2, e2) {
  if (Ff(c2)) {
    var f2 = true;
    Jf(b2);
  } else
    f2 = false;
  tg(b2, e2);
  if (b2.stateNode === null)
    a2 !== null && (a2.alternate = null, b2.alternate = null, b2.flags |= 2), Mg(b2, c2, d2), Og(b2, c2, d2, e2), d2 = true;
  else if (a2 === null) {
    var g2 = b2.stateNode, h2 = b2.memoizedProps;
    g2.props = h2;
    var k2 = g2.context, l2 = c2.contextType;
    typeof l2 === "object" && l2 !== null ? l2 = vg(l2) : (l2 = Ff(c2) ? Df : M.current, l2 = Ef(b2, l2));
    var n2 = c2.getDerivedStateFromProps, A2 = typeof n2 === "function" || typeof g2.getSnapshotBeforeUpdate === "function";
    A2 || typeof g2.UNSAFE_componentWillReceiveProps !== "function" && typeof g2.componentWillReceiveProps !== "function" || (h2 !== d2 || k2 !== l2) && Ng(b2, g2, d2, l2);
    wg = false;
    var p2 = b2.memoizedState;
    g2.state = p2;
    Cg(b2, d2, g2, e2);
    k2 = b2.memoizedState;
    h2 !== d2 || p2 !== k2 || N.current || wg ? (typeof n2 === "function" && (Gg(b2, c2, n2, d2), k2 = b2.memoizedState), (h2 = wg || Lg(b2, c2, h2, d2, p2, k2, l2)) ? (A2 || typeof g2.UNSAFE_componentWillMount !== "function" && typeof g2.componentWillMount !== "function" || (typeof g2.componentWillMount === "function" && g2.componentWillMount(), typeof g2.UNSAFE_componentWillMount === "function" && g2.UNSAFE_componentWillMount()), typeof g2.componentDidMount === "function" && (b2.flags |= 4)) : (typeof g2.componentDidMount === "function" && (b2.flags |= 4), b2.memoizedProps = d2, b2.memoizedState = k2), g2.props = d2, g2.state = k2, g2.context = l2, d2 = h2) : (typeof g2.componentDidMount === "function" && (b2.flags |= 4), d2 = false);
  } else {
    g2 = b2.stateNode;
    yg(a2, b2);
    h2 = b2.memoizedProps;
    l2 = b2.type === b2.elementType ? h2 : lg(b2.type, h2);
    g2.props = l2;
    A2 = b2.pendingProps;
    p2 = g2.context;
    k2 = c2.contextType;
    typeof k2 === "object" && k2 !== null ? k2 = vg(k2) : (k2 = Ff(c2) ? Df : M.current, k2 = Ef(b2, k2));
    var C = c2.getDerivedStateFromProps;
    (n2 = typeof C === "function" || typeof g2.getSnapshotBeforeUpdate === "function") || typeof g2.UNSAFE_componentWillReceiveProps !== "function" && typeof g2.componentWillReceiveProps !== "function" || (h2 !== A2 || p2 !== k2) && Ng(b2, g2, d2, k2);
    wg = false;
    p2 = b2.memoizedState;
    g2.state = p2;
    Cg(b2, d2, g2, e2);
    var x2 = b2.memoizedState;
    h2 !== A2 || p2 !== x2 || N.current || wg ? (typeof C === "function" && (Gg(b2, c2, C, d2), x2 = b2.memoizedState), (l2 = wg || Lg(b2, c2, l2, d2, p2, x2, k2)) ? (n2 || typeof g2.UNSAFE_componentWillUpdate !== "function" && typeof g2.componentWillUpdate !== "function" || (typeof g2.componentWillUpdate === "function" && g2.componentWillUpdate(d2, x2, k2), typeof g2.UNSAFE_componentWillUpdate === "function" && g2.UNSAFE_componentWillUpdate(d2, x2, k2)), typeof g2.componentDidUpdate === "function" && (b2.flags |= 4), typeof g2.getSnapshotBeforeUpdate === "function" && (b2.flags |= 256)) : (typeof g2.componentDidUpdate !== "function" || h2 === a2.memoizedProps && p2 === a2.memoizedState || (b2.flags |= 4), typeof g2.getSnapshotBeforeUpdate !== "function" || h2 === a2.memoizedProps && p2 === a2.memoizedState || (b2.flags |= 256), b2.memoizedProps = d2, b2.memoizedState = x2), g2.props = d2, g2.state = x2, g2.context = k2, d2 = l2) : (typeof g2.componentDidUpdate !== "function" || h2 === a2.memoizedProps && p2 === a2.memoizedState || (b2.flags |= 4), typeof g2.getSnapshotBeforeUpdate !== "function" || h2 === a2.memoizedProps && p2 === a2.memoizedState || (b2.flags |= 256), d2 = false);
  }
  return qi(a2, b2, c2, d2, f2, e2);
}
function qi(a2, b2, c2, d2, e2, f2) {
  oi(a2, b2);
  var g2 = (b2.flags & 64) !== 0;
  if (!d2 && !g2)
    return e2 && Kf(b2, c2, false), hi(a2, b2, f2);
  d2 = b2.stateNode;
  ei.current = b2;
  var h2 = g2 && typeof c2.getDerivedStateFromError !== "function" ? null : d2.render();
  b2.flags |= 1;
  a2 !== null && g2 ? (b2.child = Yg(b2, a2.child, null, f2), b2.child = Yg(b2, null, h2, f2)) : fi(a2, b2, h2, f2);
  b2.memoizedState = d2.state;
  e2 && Kf(b2, c2, true);
  return b2.child;
}
function ri(a2) {
  var b2 = a2.stateNode;
  b2.pendingContext ? Hf(a2, b2.pendingContext, b2.pendingContext !== b2.context) : b2.context && Hf(a2, b2.context, false);
  eh(a2, b2.containerInfo);
}
var si = { dehydrated: null, retryLane: 0 };
function ti(a2, b2, c2) {
  var d2 = b2.pendingProps, e2 = P.current, f2 = false, g2;
  (g2 = (b2.flags & 64) !== 0) || (g2 = a2 !== null && a2.memoizedState === null ? false : (e2 & 2) !== 0);
  g2 ? (f2 = true, b2.flags &= -65) : a2 !== null && a2.memoizedState === null || d2.fallback === void 0 || d2.unstable_avoidThisFallback === true || (e2 |= 1);
  I(P, e2 & 1);
  if (a2 === null) {
    d2.fallback !== void 0 && ph(b2);
    a2 = d2.children;
    e2 = d2.fallback;
    if (f2)
      return a2 = ui(b2, a2, e2, c2), b2.child.memoizedState = { baseLanes: c2 }, b2.memoizedState = si, a2;
    if (typeof d2.unstable_expectedLoadTime === "number")
      return a2 = ui(b2, a2, e2, c2), b2.child.memoizedState = { baseLanes: c2 }, b2.memoizedState = si, b2.lanes = 33554432, a2;
    c2 = vi({ mode: "visible", children: a2 }, b2.mode, c2, null);
    c2.return = b2;
    return b2.child = c2;
  }
  if (a2.memoizedState !== null) {
    if (f2)
      return d2 = wi(a2, b2, d2.children, d2.fallback, c2), f2 = b2.child, e2 = a2.child.memoizedState, f2.memoizedState = e2 === null ? { baseLanes: c2 } : { baseLanes: e2.baseLanes | c2 }, f2.childLanes = a2.childLanes & ~c2, b2.memoizedState = si, d2;
    c2 = xi(a2, b2, d2.children, c2);
    b2.memoizedState = null;
    return c2;
  }
  if (f2)
    return d2 = wi(a2, b2, d2.children, d2.fallback, c2), f2 = b2.child, e2 = a2.child.memoizedState, f2.memoizedState = e2 === null ? { baseLanes: c2 } : { baseLanes: e2.baseLanes | c2 }, f2.childLanes = a2.childLanes & ~c2, b2.memoizedState = si, d2;
  c2 = xi(a2, b2, d2.children, c2);
  b2.memoizedState = null;
  return c2;
}
function ui(a2, b2, c2, d2) {
  var e2 = a2.mode, f2 = a2.child;
  b2 = { mode: "hidden", children: b2 };
  (e2 & 2) === 0 && f2 !== null ? (f2.childLanes = 0, f2.pendingProps = b2) : f2 = vi(b2, e2, 0, null);
  c2 = Xg(c2, e2, d2, null);
  f2.return = a2;
  c2.return = a2;
  f2.sibling = c2;
  a2.child = f2;
  return c2;
}
function xi(a2, b2, c2, d2) {
  var e2 = a2.child;
  a2 = e2.sibling;
  c2 = Tg(e2, { mode: "visible", children: c2 });
  (b2.mode & 2) === 0 && (c2.lanes = d2);
  c2.return = b2;
  c2.sibling = null;
  a2 !== null && (a2.nextEffect = null, a2.flags = 8, b2.firstEffect = b2.lastEffect = a2);
  return b2.child = c2;
}
function wi(a2, b2, c2, d2, e2) {
  var f2 = b2.mode, g2 = a2.child;
  a2 = g2.sibling;
  var h2 = { mode: "hidden", children: c2 };
  (f2 & 2) === 0 && b2.child !== g2 ? (c2 = b2.child, c2.childLanes = 0, c2.pendingProps = h2, g2 = c2.lastEffect, g2 !== null ? (b2.firstEffect = c2.firstEffect, b2.lastEffect = g2, g2.nextEffect = null) : b2.firstEffect = b2.lastEffect = null) : c2 = Tg(g2, h2);
  a2 !== null ? d2 = Tg(a2, d2) : (d2 = Xg(d2, f2, e2, null), d2.flags |= 2);
  d2.return = b2;
  c2.return = b2;
  c2.sibling = d2;
  b2.child = c2;
  return d2;
}
function yi(a2, b2) {
  a2.lanes |= b2;
  var c2 = a2.alternate;
  c2 !== null && (c2.lanes |= b2);
  sg(a2.return, b2);
}
function zi(a2, b2, c2, d2, e2, f2) {
  var g2 = a2.memoizedState;
  g2 === null ? a2.memoizedState = { isBackwards: b2, rendering: null, renderingStartTime: 0, last: d2, tail: c2, tailMode: e2, lastEffect: f2 } : (g2.isBackwards = b2, g2.rendering = null, g2.renderingStartTime = 0, g2.last = d2, g2.tail = c2, g2.tailMode = e2, g2.lastEffect = f2);
}
function Ai(a2, b2, c2) {
  var d2 = b2.pendingProps, e2 = d2.revealOrder, f2 = d2.tail;
  fi(a2, b2, d2.children, c2);
  d2 = P.current;
  if ((d2 & 2) !== 0)
    d2 = d2 & 1 | 2, b2.flags |= 64;
  else {
    if (a2 !== null && (a2.flags & 64) !== 0)
      a:
        for (a2 = b2.child; a2 !== null; ) {
          if (a2.tag === 13)
            a2.memoizedState !== null && yi(a2, c2);
          else if (a2.tag === 19)
            yi(a2, c2);
          else if (a2.child !== null) {
            a2.child.return = a2;
            a2 = a2.child;
            continue;
          }
          if (a2 === b2)
            break a;
          for (; a2.sibling === null; ) {
            if (a2.return === null || a2.return === b2)
              break a;
            a2 = a2.return;
          }
          a2.sibling.return = a2.return;
          a2 = a2.sibling;
        }
    d2 &= 1;
  }
  I(P, d2);
  if ((b2.mode & 2) === 0)
    b2.memoizedState = null;
  else
    switch (e2) {
      case "forwards":
        c2 = b2.child;
        for (e2 = null; c2 !== null; )
          a2 = c2.alternate, a2 !== null && ih(a2) === null && (e2 = c2), c2 = c2.sibling;
        c2 = e2;
        c2 === null ? (e2 = b2.child, b2.child = null) : (e2 = c2.sibling, c2.sibling = null);
        zi(b2, false, e2, c2, f2, b2.lastEffect);
        break;
      case "backwards":
        c2 = null;
        e2 = b2.child;
        for (b2.child = null; e2 !== null; ) {
          a2 = e2.alternate;
          if (a2 !== null && ih(a2) === null) {
            b2.child = e2;
            break;
          }
          a2 = e2.sibling;
          e2.sibling = c2;
          c2 = e2;
          e2 = a2;
        }
        zi(b2, true, c2, null, f2, b2.lastEffect);
        break;
      case "together":
        zi(b2, false, null, null, void 0, b2.lastEffect);
        break;
      default:
        b2.memoizedState = null;
    }
  return b2.child;
}
function hi(a2, b2, c2) {
  a2 !== null && (b2.dependencies = a2.dependencies);
  Dg |= b2.lanes;
  if ((c2 & b2.childLanes) !== 0) {
    if (a2 !== null && b2.child !== a2.child)
      throw Error(y$1(153));
    if (b2.child !== null) {
      a2 = b2.child;
      c2 = Tg(a2, a2.pendingProps);
      b2.child = c2;
      for (c2.return = b2; a2.sibling !== null; )
        a2 = a2.sibling, c2 = c2.sibling = Tg(a2, a2.pendingProps), c2.return = b2;
      c2.sibling = null;
    }
    return b2.child;
  }
  return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a2, b2) {
  for (var c2 = b2.child; c2 !== null; ) {
    if (c2.tag === 5 || c2.tag === 6)
      a2.appendChild(c2.stateNode);
    else if (c2.tag !== 4 && c2.child !== null) {
      c2.child.return = c2;
      c2 = c2.child;
      continue;
    }
    if (c2 === b2)
      break;
    for (; c2.sibling === null; ) {
      if (c2.return === null || c2.return === b2)
        return;
      c2 = c2.return;
    }
    c2.sibling.return = c2.return;
    c2 = c2.sibling;
  }
};
Ci = function() {
};
Di = function(a2, b2, c2, d2) {
  var e2 = a2.memoizedProps;
  if (e2 !== d2) {
    a2 = b2.stateNode;
    dh(ah.current);
    var f2 = null;
    switch (c2) {
      case "input":
        e2 = Ya(a2, e2);
        d2 = Ya(a2, d2);
        f2 = [];
        break;
      case "option":
        e2 = eb(a2, e2);
        d2 = eb(a2, d2);
        f2 = [];
        break;
      case "select":
        e2 = m$1({}, e2, { value: void 0 });
        d2 = m$1({}, d2, { value: void 0 });
        f2 = [];
        break;
      case "textarea":
        e2 = gb(a2, e2);
        d2 = gb(a2, d2);
        f2 = [];
        break;
      default:
        typeof e2.onClick !== "function" && typeof d2.onClick === "function" && (a2.onclick = jf);
    }
    vb(c2, d2);
    var g2;
    c2 = null;
    for (l2 in e2)
      if (!d2.hasOwnProperty(l2) && e2.hasOwnProperty(l2) && e2[l2] != null)
        if (l2 === "style") {
          var h2 = e2[l2];
          for (g2 in h2)
            h2.hasOwnProperty(g2) && (c2 || (c2 = {}), c2[g2] = "");
        } else
          l2 !== "dangerouslySetInnerHTML" && l2 !== "children" && l2 !== "suppressContentEditableWarning" && l2 !== "suppressHydrationWarning" && l2 !== "autoFocus" && (ca.hasOwnProperty(l2) ? f2 || (f2 = []) : (f2 = f2 || []).push(l2, null));
    for (l2 in d2) {
      var k2 = d2[l2];
      h2 = e2 != null ? e2[l2] : void 0;
      if (d2.hasOwnProperty(l2) && k2 !== h2 && (k2 != null || h2 != null))
        if (l2 === "style")
          if (h2) {
            for (g2 in h2)
              !h2.hasOwnProperty(g2) || k2 && k2.hasOwnProperty(g2) || (c2 || (c2 = {}), c2[g2] = "");
            for (g2 in k2)
              k2.hasOwnProperty(g2) && h2[g2] !== k2[g2] && (c2 || (c2 = {}), c2[g2] = k2[g2]);
          } else
            c2 || (f2 || (f2 = []), f2.push(l2, c2)), c2 = k2;
        else
          l2 === "dangerouslySetInnerHTML" ? (k2 = k2 ? k2.__html : void 0, h2 = h2 ? h2.__html : void 0, k2 != null && h2 !== k2 && (f2 = f2 || []).push(l2, k2)) : l2 === "children" ? typeof k2 !== "string" && typeof k2 !== "number" || (f2 = f2 || []).push(l2, "" + k2) : l2 !== "suppressContentEditableWarning" && l2 !== "suppressHydrationWarning" && (ca.hasOwnProperty(l2) ? (k2 != null && l2 === "onScroll" && G("scroll", a2), f2 || h2 === k2 || (f2 = [])) : typeof k2 === "object" && k2 !== null && k2.$$typeof === Ga ? k2.toString() : (f2 = f2 || []).push(l2, k2));
    }
    c2 && (f2 = f2 || []).push("style", c2);
    var l2 = f2;
    if (b2.updateQueue = l2)
      b2.flags |= 4;
  }
};
Ei = function(a2, b2, c2, d2) {
  c2 !== d2 && (b2.flags |= 4);
};
function Fi(a2, b2) {
  if (!lh)
    switch (a2.tailMode) {
      case "hidden":
        b2 = a2.tail;
        for (var c2 = null; b2 !== null; )
          b2.alternate !== null && (c2 = b2), b2 = b2.sibling;
        c2 === null ? a2.tail = null : c2.sibling = null;
        break;
      case "collapsed":
        c2 = a2.tail;
        for (var d2 = null; c2 !== null; )
          c2.alternate !== null && (d2 = c2), c2 = c2.sibling;
        d2 === null ? b2 || a2.tail === null ? a2.tail = null : a2.tail.sibling = null : d2.sibling = null;
    }
}
function Gi(a2, b2, c2) {
  var d2 = b2.pendingProps;
  switch (b2.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return null;
    case 1:
      return Ff(b2.type) && Gf(), null;
    case 3:
      fh();
      H(N);
      H(M);
      uh();
      d2 = b2.stateNode;
      d2.pendingContext && (d2.context = d2.pendingContext, d2.pendingContext = null);
      if (a2 === null || a2.child === null)
        rh(b2) ? b2.flags |= 4 : d2.hydrate || (b2.flags |= 256);
      Ci(b2);
      return null;
    case 5:
      hh(b2);
      var e2 = dh(ch.current);
      c2 = b2.type;
      if (a2 !== null && b2.stateNode != null)
        Di(a2, b2, c2, d2, e2), a2.ref !== b2.ref && (b2.flags |= 128);
      else {
        if (!d2) {
          if (b2.stateNode === null)
            throw Error(y$1(166));
          return null;
        }
        a2 = dh(ah.current);
        if (rh(b2)) {
          d2 = b2.stateNode;
          c2 = b2.type;
          var f2 = b2.memoizedProps;
          d2[wf] = b2;
          d2[xf] = f2;
          switch (c2) {
            case "dialog":
              G("cancel", d2);
              G("close", d2);
              break;
            case "iframe":
            case "object":
            case "embed":
              G("load", d2);
              break;
            case "video":
            case "audio":
              for (a2 = 0; a2 < Xe.length; a2++)
                G(Xe[a2], d2);
              break;
            case "source":
              G("error", d2);
              break;
            case "img":
            case "image":
            case "link":
              G("error", d2);
              G("load", d2);
              break;
            case "details":
              G("toggle", d2);
              break;
            case "input":
              Za(d2, f2);
              G("invalid", d2);
              break;
            case "select":
              d2._wrapperState = { wasMultiple: !!f2.multiple };
              G("invalid", d2);
              break;
            case "textarea":
              hb(d2, f2), G("invalid", d2);
          }
          vb(c2, f2);
          a2 = null;
          for (var g2 in f2)
            f2.hasOwnProperty(g2) && (e2 = f2[g2], g2 === "children" ? typeof e2 === "string" ? d2.textContent !== e2 && (a2 = ["children", e2]) : typeof e2 === "number" && d2.textContent !== "" + e2 && (a2 = ["children", "" + e2]) : ca.hasOwnProperty(g2) && e2 != null && g2 === "onScroll" && G("scroll", d2));
          switch (c2) {
            case "input":
              Va(d2);
              cb(d2, f2, true);
              break;
            case "textarea":
              Va(d2);
              jb(d2);
              break;
            case "select":
            case "option":
              break;
            default:
              typeof f2.onClick === "function" && (d2.onclick = jf);
          }
          d2 = a2;
          b2.updateQueue = d2;
          d2 !== null && (b2.flags |= 4);
        } else {
          g2 = e2.nodeType === 9 ? e2 : e2.ownerDocument;
          a2 === kb.html && (a2 = lb(c2));
          a2 === kb.html ? c2 === "script" ? (a2 = g2.createElement("div"), a2.innerHTML = "<script><\/script>", a2 = a2.removeChild(a2.firstChild)) : typeof d2.is === "string" ? a2 = g2.createElement(c2, { is: d2.is }) : (a2 = g2.createElement(c2), c2 === "select" && (g2 = a2, d2.multiple ? g2.multiple = true : d2.size && (g2.size = d2.size))) : a2 = g2.createElementNS(a2, c2);
          a2[wf] = b2;
          a2[xf] = d2;
          Bi(a2, b2, false, false);
          b2.stateNode = a2;
          g2 = wb(c2, d2);
          switch (c2) {
            case "dialog":
              G("cancel", a2);
              G("close", a2);
              e2 = d2;
              break;
            case "iframe":
            case "object":
            case "embed":
              G("load", a2);
              e2 = d2;
              break;
            case "video":
            case "audio":
              for (e2 = 0; e2 < Xe.length; e2++)
                G(Xe[e2], a2);
              e2 = d2;
              break;
            case "source":
              G("error", a2);
              e2 = d2;
              break;
            case "img":
            case "image":
            case "link":
              G("error", a2);
              G("load", a2);
              e2 = d2;
              break;
            case "details":
              G("toggle", a2);
              e2 = d2;
              break;
            case "input":
              Za(a2, d2);
              e2 = Ya(a2, d2);
              G("invalid", a2);
              break;
            case "option":
              e2 = eb(a2, d2);
              break;
            case "select":
              a2._wrapperState = { wasMultiple: !!d2.multiple };
              e2 = m$1({}, d2, { value: void 0 });
              G("invalid", a2);
              break;
            case "textarea":
              hb(a2, d2);
              e2 = gb(a2, d2);
              G("invalid", a2);
              break;
            default:
              e2 = d2;
          }
          vb(c2, e2);
          var h2 = e2;
          for (f2 in h2)
            if (h2.hasOwnProperty(f2)) {
              var k2 = h2[f2];
              f2 === "style" ? tb(a2, k2) : f2 === "dangerouslySetInnerHTML" ? (k2 = k2 ? k2.__html : void 0, k2 != null && ob(a2, k2)) : f2 === "children" ? typeof k2 === "string" ? (c2 !== "textarea" || k2 !== "") && pb(a2, k2) : typeof k2 === "number" && pb(a2, "" + k2) : f2 !== "suppressContentEditableWarning" && f2 !== "suppressHydrationWarning" && f2 !== "autoFocus" && (ca.hasOwnProperty(f2) ? k2 != null && f2 === "onScroll" && G("scroll", a2) : k2 != null && qa(a2, f2, k2, g2));
            }
          switch (c2) {
            case "input":
              Va(a2);
              cb(a2, d2, false);
              break;
            case "textarea":
              Va(a2);
              jb(a2);
              break;
            case "option":
              d2.value != null && a2.setAttribute("value", "" + Sa(d2.value));
              break;
            case "select":
              a2.multiple = !!d2.multiple;
              f2 = d2.value;
              f2 != null ? fb(a2, !!d2.multiple, f2, false) : d2.defaultValue != null && fb(a2, !!d2.multiple, d2.defaultValue, true);
              break;
            default:
              typeof e2.onClick === "function" && (a2.onclick = jf);
          }
          mf(c2, d2) && (b2.flags |= 4);
        }
        b2.ref !== null && (b2.flags |= 128);
      }
      return null;
    case 6:
      if (a2 && b2.stateNode != null)
        Ei(a2, b2, a2.memoizedProps, d2);
      else {
        if (typeof d2 !== "string" && b2.stateNode === null)
          throw Error(y$1(166));
        c2 = dh(ch.current);
        dh(ah.current);
        rh(b2) ? (d2 = b2.stateNode, c2 = b2.memoizedProps, d2[wf] = b2, d2.nodeValue !== c2 && (b2.flags |= 4)) : (d2 = (c2.nodeType === 9 ? c2 : c2.ownerDocument).createTextNode(d2), d2[wf] = b2, b2.stateNode = d2);
      }
      return null;
    case 13:
      H(P);
      d2 = b2.memoizedState;
      if ((b2.flags & 64) !== 0)
        return b2.lanes = c2, b2;
      d2 = d2 !== null;
      c2 = false;
      a2 === null ? b2.memoizedProps.fallback !== void 0 && rh(b2) : c2 = a2.memoizedState !== null;
      if (d2 && !c2 && (b2.mode & 2) !== 0)
        if (a2 === null && b2.memoizedProps.unstable_avoidThisFallback !== true || (P.current & 1) !== 0)
          V === 0 && (V = 3);
        else {
          if (V === 0 || V === 3)
            V = 4;
          U === null || (Dg & 134217727) === 0 && (Hi & 134217727) === 0 || Ii(U, W);
        }
      if (d2 || c2)
        b2.flags |= 4;
      return null;
    case 4:
      return fh(), Ci(b2), a2 === null && cf(b2.stateNode.containerInfo), null;
    case 10:
      return rg(b2), null;
    case 17:
      return Ff(b2.type) && Gf(), null;
    case 19:
      H(P);
      d2 = b2.memoizedState;
      if (d2 === null)
        return null;
      f2 = (b2.flags & 64) !== 0;
      g2 = d2.rendering;
      if (g2 === null)
        if (f2)
          Fi(d2, false);
        else {
          if (V !== 0 || a2 !== null && (a2.flags & 64) !== 0)
            for (a2 = b2.child; a2 !== null; ) {
              g2 = ih(a2);
              if (g2 !== null) {
                b2.flags |= 64;
                Fi(d2, false);
                f2 = g2.updateQueue;
                f2 !== null && (b2.updateQueue = f2, b2.flags |= 4);
                d2.lastEffect === null && (b2.firstEffect = null);
                b2.lastEffect = d2.lastEffect;
                d2 = c2;
                for (c2 = b2.child; c2 !== null; )
                  f2 = c2, a2 = d2, f2.flags &= 2, f2.nextEffect = null, f2.firstEffect = null, f2.lastEffect = null, g2 = f2.alternate, g2 === null ? (f2.childLanes = 0, f2.lanes = a2, f2.child = null, f2.memoizedProps = null, f2.memoizedState = null, f2.updateQueue = null, f2.dependencies = null, f2.stateNode = null) : (f2.childLanes = g2.childLanes, f2.lanes = g2.lanes, f2.child = g2.child, f2.memoizedProps = g2.memoizedProps, f2.memoizedState = g2.memoizedState, f2.updateQueue = g2.updateQueue, f2.type = g2.type, a2 = g2.dependencies, f2.dependencies = a2 === null ? null : { lanes: a2.lanes, firstContext: a2.firstContext }), c2 = c2.sibling;
                I(P, P.current & 1 | 2);
                return b2.child;
              }
              a2 = a2.sibling;
            }
          d2.tail !== null && O() > Ji && (b2.flags |= 64, f2 = true, Fi(d2, false), b2.lanes = 33554432);
        }
      else {
        if (!f2)
          if (a2 = ih(g2), a2 !== null) {
            if (b2.flags |= 64, f2 = true, c2 = a2.updateQueue, c2 !== null && (b2.updateQueue = c2, b2.flags |= 4), Fi(d2, true), d2.tail === null && d2.tailMode === "hidden" && !g2.alternate && !lh)
              return b2 = b2.lastEffect = d2.lastEffect, b2 !== null && (b2.nextEffect = null), null;
          } else
            2 * O() - d2.renderingStartTime > Ji && c2 !== 1073741824 && (b2.flags |= 64, f2 = true, Fi(d2, false), b2.lanes = 33554432);
        d2.isBackwards ? (g2.sibling = b2.child, b2.child = g2) : (c2 = d2.last, c2 !== null ? c2.sibling = g2 : b2.child = g2, d2.last = g2);
      }
      return d2.tail !== null ? (c2 = d2.tail, d2.rendering = c2, d2.tail = c2.sibling, d2.lastEffect = b2.lastEffect, d2.renderingStartTime = O(), c2.sibling = null, b2 = P.current, I(P, f2 ? b2 & 1 | 2 : b2 & 1), c2) : null;
    case 23:
    case 24:
      return Ki(), a2 !== null && a2.memoizedState !== null !== (b2.memoizedState !== null) && d2.mode !== "unstable-defer-without-hiding" && (b2.flags |= 4), null;
  }
  throw Error(y$1(156, b2.tag));
}
function Li(a2) {
  switch (a2.tag) {
    case 1:
      Ff(a2.type) && Gf();
      var b2 = a2.flags;
      return b2 & 4096 ? (a2.flags = b2 & -4097 | 64, a2) : null;
    case 3:
      fh();
      H(N);
      H(M);
      uh();
      b2 = a2.flags;
      if ((b2 & 64) !== 0)
        throw Error(y$1(285));
      a2.flags = b2 & -4097 | 64;
      return a2;
    case 5:
      return hh(a2), null;
    case 13:
      return H(P), b2 = a2.flags, b2 & 4096 ? (a2.flags = b2 & -4097 | 64, a2) : null;
    case 19:
      return H(P), null;
    case 4:
      return fh(), null;
    case 10:
      return rg(a2), null;
    case 23:
    case 24:
      return Ki(), null;
    default:
      return null;
  }
}
function Mi(a2, b2) {
  try {
    var c2 = "", d2 = b2;
    do
      c2 += Qa(d2), d2 = d2.return;
    while (d2);
    var e2 = c2;
  } catch (f2) {
    e2 = "\nError generating stack: " + f2.message + "\n" + f2.stack;
  }
  return { value: a2, source: b2, stack: e2 };
}
function Ni(a2, b2) {
  try {
    console.error(b2.value);
  } catch (c2) {
    setTimeout(function() {
      throw c2;
    });
  }
}
var Oi = typeof WeakMap === "function" ? WeakMap : Map;
function Pi(a2, b2, c2) {
  c2 = zg(-1, c2);
  c2.tag = 3;
  c2.payload = { element: null };
  var d2 = b2.value;
  c2.callback = function() {
    Qi || (Qi = true, Ri = d2);
    Ni(a2, b2);
  };
  return c2;
}
function Si(a2, b2, c2) {
  c2 = zg(-1, c2);
  c2.tag = 3;
  var d2 = a2.type.getDerivedStateFromError;
  if (typeof d2 === "function") {
    var e2 = b2.value;
    c2.payload = function() {
      Ni(a2, b2);
      return d2(e2);
    };
  }
  var f2 = a2.stateNode;
  f2 !== null && typeof f2.componentDidCatch === "function" && (c2.callback = function() {
    typeof d2 !== "function" && (Ti === null ? Ti = new Set([this]) : Ti.add(this), Ni(a2, b2));
    var c3 = b2.stack;
    this.componentDidCatch(b2.value, { componentStack: c3 !== null ? c3 : "" });
  });
  return c2;
}
var Ui = typeof WeakSet === "function" ? WeakSet : Set;
function Vi(a2) {
  var b2 = a2.ref;
  if (b2 !== null)
    if (typeof b2 === "function")
      try {
        b2(null);
      } catch (c2) {
        Wi(a2, c2);
      }
    else
      b2.current = null;
}
function Xi(a2, b2) {
  switch (b2.tag) {
    case 0:
    case 11:
    case 15:
    case 22:
      return;
    case 1:
      if (b2.flags & 256 && a2 !== null) {
        var c2 = a2.memoizedProps, d2 = a2.memoizedState;
        a2 = b2.stateNode;
        b2 = a2.getSnapshotBeforeUpdate(b2.elementType === b2.type ? c2 : lg(b2.type, c2), d2);
        a2.__reactInternalSnapshotBeforeUpdate = b2;
      }
      return;
    case 3:
      b2.flags & 256 && qf(b2.stateNode.containerInfo);
      return;
    case 5:
    case 6:
    case 4:
    case 17:
      return;
  }
  throw Error(y$1(163));
}
function Yi(a2, b2, c2) {
  switch (c2.tag) {
    case 0:
    case 11:
    case 15:
    case 22:
      b2 = c2.updateQueue;
      b2 = b2 !== null ? b2.lastEffect : null;
      if (b2 !== null) {
        a2 = b2 = b2.next;
        do {
          if ((a2.tag & 3) === 3) {
            var d2 = a2.create;
            a2.destroy = d2();
          }
          a2 = a2.next;
        } while (a2 !== b2);
      }
      b2 = c2.updateQueue;
      b2 = b2 !== null ? b2.lastEffect : null;
      if (b2 !== null) {
        a2 = b2 = b2.next;
        do {
          var e2 = a2;
          d2 = e2.next;
          e2 = e2.tag;
          (e2 & 4) !== 0 && (e2 & 1) !== 0 && (Zi(c2, a2), $i(c2, a2));
          a2 = d2;
        } while (a2 !== b2);
      }
      return;
    case 1:
      a2 = c2.stateNode;
      c2.flags & 4 && (b2 === null ? a2.componentDidMount() : (d2 = c2.elementType === c2.type ? b2.memoizedProps : lg(c2.type, b2.memoizedProps), a2.componentDidUpdate(d2, b2.memoizedState, a2.__reactInternalSnapshotBeforeUpdate)));
      b2 = c2.updateQueue;
      b2 !== null && Eg(c2, b2, a2);
      return;
    case 3:
      b2 = c2.updateQueue;
      if (b2 !== null) {
        a2 = null;
        if (c2.child !== null)
          switch (c2.child.tag) {
            case 5:
              a2 = c2.child.stateNode;
              break;
            case 1:
              a2 = c2.child.stateNode;
          }
        Eg(c2, b2, a2);
      }
      return;
    case 5:
      a2 = c2.stateNode;
      b2 === null && c2.flags & 4 && mf(c2.type, c2.memoizedProps) && a2.focus();
      return;
    case 6:
      return;
    case 4:
      return;
    case 12:
      return;
    case 13:
      c2.memoizedState === null && (c2 = c2.alternate, c2 !== null && (c2 = c2.memoizedState, c2 !== null && (c2 = c2.dehydrated, c2 !== null && Cc(c2))));
      return;
    case 19:
    case 17:
    case 20:
    case 21:
    case 23:
    case 24:
      return;
  }
  throw Error(y$1(163));
}
function aj(a2, b2) {
  for (var c2 = a2; ; ) {
    if (c2.tag === 5) {
      var d2 = c2.stateNode;
      if (b2)
        d2 = d2.style, typeof d2.setProperty === "function" ? d2.setProperty("display", "none", "important") : d2.display = "none";
      else {
        d2 = c2.stateNode;
        var e2 = c2.memoizedProps.style;
        e2 = e2 !== void 0 && e2 !== null && e2.hasOwnProperty("display") ? e2.display : null;
        d2.style.display = sb("display", e2);
      }
    } else if (c2.tag === 6)
      c2.stateNode.nodeValue = b2 ? "" : c2.memoizedProps;
    else if ((c2.tag !== 23 && c2.tag !== 24 || c2.memoizedState === null || c2 === a2) && c2.child !== null) {
      c2.child.return = c2;
      c2 = c2.child;
      continue;
    }
    if (c2 === a2)
      break;
    for (; c2.sibling === null; ) {
      if (c2.return === null || c2.return === a2)
        return;
      c2 = c2.return;
    }
    c2.sibling.return = c2.return;
    c2 = c2.sibling;
  }
}
function bj(a2, b2) {
  if (Mf && typeof Mf.onCommitFiberUnmount === "function")
    try {
      Mf.onCommitFiberUnmount(Lf, b2);
    } catch (f2) {
    }
  switch (b2.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
    case 22:
      a2 = b2.updateQueue;
      if (a2 !== null && (a2 = a2.lastEffect, a2 !== null)) {
        var c2 = a2 = a2.next;
        do {
          var d2 = c2, e2 = d2.destroy;
          d2 = d2.tag;
          if (e2 !== void 0)
            if ((d2 & 4) !== 0)
              Zi(b2, c2);
            else {
              d2 = b2;
              try {
                e2();
              } catch (f2) {
                Wi(d2, f2);
              }
            }
          c2 = c2.next;
        } while (c2 !== a2);
      }
      break;
    case 1:
      Vi(b2);
      a2 = b2.stateNode;
      if (typeof a2.componentWillUnmount === "function")
        try {
          a2.props = b2.memoizedProps, a2.state = b2.memoizedState, a2.componentWillUnmount();
        } catch (f2) {
          Wi(b2, f2);
        }
      break;
    case 5:
      Vi(b2);
      break;
    case 4:
      cj(a2, b2);
  }
}
function dj(a2) {
  a2.alternate = null;
  a2.child = null;
  a2.dependencies = null;
  a2.firstEffect = null;
  a2.lastEffect = null;
  a2.memoizedProps = null;
  a2.memoizedState = null;
  a2.pendingProps = null;
  a2.return = null;
  a2.updateQueue = null;
}
function ej(a2) {
  return a2.tag === 5 || a2.tag === 3 || a2.tag === 4;
}
function fj(a2) {
  a: {
    for (var b2 = a2.return; b2 !== null; ) {
      if (ej(b2))
        break a;
      b2 = b2.return;
    }
    throw Error(y$1(160));
  }
  var c2 = b2;
  b2 = c2.stateNode;
  switch (c2.tag) {
    case 5:
      var d2 = false;
      break;
    case 3:
      b2 = b2.containerInfo;
      d2 = true;
      break;
    case 4:
      b2 = b2.containerInfo;
      d2 = true;
      break;
    default:
      throw Error(y$1(161));
  }
  c2.flags & 16 && (pb(b2, ""), c2.flags &= -17);
  a:
    b:
      for (c2 = a2; ; ) {
        for (; c2.sibling === null; ) {
          if (c2.return === null || ej(c2.return)) {
            c2 = null;
            break a;
          }
          c2 = c2.return;
        }
        c2.sibling.return = c2.return;
        for (c2 = c2.sibling; c2.tag !== 5 && c2.tag !== 6 && c2.tag !== 18; ) {
          if (c2.flags & 2)
            continue b;
          if (c2.child === null || c2.tag === 4)
            continue b;
          else
            c2.child.return = c2, c2 = c2.child;
        }
        if (!(c2.flags & 2)) {
          c2 = c2.stateNode;
          break a;
        }
      }
  d2 ? gj(a2, c2, b2) : hj(a2, c2, b2);
}
function gj(a2, b2, c2) {
  var d2 = a2.tag, e2 = d2 === 5 || d2 === 6;
  if (e2)
    a2 = e2 ? a2.stateNode : a2.stateNode.instance, b2 ? c2.nodeType === 8 ? c2.parentNode.insertBefore(a2, b2) : c2.insertBefore(a2, b2) : (c2.nodeType === 8 ? (b2 = c2.parentNode, b2.insertBefore(a2, c2)) : (b2 = c2, b2.appendChild(a2)), c2 = c2._reactRootContainer, c2 !== null && c2 !== void 0 || b2.onclick !== null || (b2.onclick = jf));
  else if (d2 !== 4 && (a2 = a2.child, a2 !== null))
    for (gj(a2, b2, c2), a2 = a2.sibling; a2 !== null; )
      gj(a2, b2, c2), a2 = a2.sibling;
}
function hj(a2, b2, c2) {
  var d2 = a2.tag, e2 = d2 === 5 || d2 === 6;
  if (e2)
    a2 = e2 ? a2.stateNode : a2.stateNode.instance, b2 ? c2.insertBefore(a2, b2) : c2.appendChild(a2);
  else if (d2 !== 4 && (a2 = a2.child, a2 !== null))
    for (hj(a2, b2, c2), a2 = a2.sibling; a2 !== null; )
      hj(a2, b2, c2), a2 = a2.sibling;
}
function cj(a2, b2) {
  for (var c2 = b2, d2 = false, e2, f2; ; ) {
    if (!d2) {
      d2 = c2.return;
      a:
        for (; ; ) {
          if (d2 === null)
            throw Error(y$1(160));
          e2 = d2.stateNode;
          switch (d2.tag) {
            case 5:
              f2 = false;
              break a;
            case 3:
              e2 = e2.containerInfo;
              f2 = true;
              break a;
            case 4:
              e2 = e2.containerInfo;
              f2 = true;
              break a;
          }
          d2 = d2.return;
        }
      d2 = true;
    }
    if (c2.tag === 5 || c2.tag === 6) {
      a:
        for (var g2 = a2, h2 = c2, k2 = h2; ; )
          if (bj(g2, k2), k2.child !== null && k2.tag !== 4)
            k2.child.return = k2, k2 = k2.child;
          else {
            if (k2 === h2)
              break a;
            for (; k2.sibling === null; ) {
              if (k2.return === null || k2.return === h2)
                break a;
              k2 = k2.return;
            }
            k2.sibling.return = k2.return;
            k2 = k2.sibling;
          }
      f2 ? (g2 = e2, h2 = c2.stateNode, g2.nodeType === 8 ? g2.parentNode.removeChild(h2) : g2.removeChild(h2)) : e2.removeChild(c2.stateNode);
    } else if (c2.tag === 4) {
      if (c2.child !== null) {
        e2 = c2.stateNode.containerInfo;
        f2 = true;
        c2.child.return = c2;
        c2 = c2.child;
        continue;
      }
    } else if (bj(a2, c2), c2.child !== null) {
      c2.child.return = c2;
      c2 = c2.child;
      continue;
    }
    if (c2 === b2)
      break;
    for (; c2.sibling === null; ) {
      if (c2.return === null || c2.return === b2)
        return;
      c2 = c2.return;
      c2.tag === 4 && (d2 = false);
    }
    c2.sibling.return = c2.return;
    c2 = c2.sibling;
  }
}
function ij(a2, b2) {
  switch (b2.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
    case 22:
      var c2 = b2.updateQueue;
      c2 = c2 !== null ? c2.lastEffect : null;
      if (c2 !== null) {
        var d2 = c2 = c2.next;
        do
          (d2.tag & 3) === 3 && (a2 = d2.destroy, d2.destroy = void 0, a2 !== void 0 && a2()), d2 = d2.next;
        while (d2 !== c2);
      }
      return;
    case 1:
      return;
    case 5:
      c2 = b2.stateNode;
      if (c2 != null) {
        d2 = b2.memoizedProps;
        var e2 = a2 !== null ? a2.memoizedProps : d2;
        a2 = b2.type;
        var f2 = b2.updateQueue;
        b2.updateQueue = null;
        if (f2 !== null) {
          c2[xf] = d2;
          a2 === "input" && d2.type === "radio" && d2.name != null && $a(c2, d2);
          wb(a2, e2);
          b2 = wb(a2, d2);
          for (e2 = 0; e2 < f2.length; e2 += 2) {
            var g2 = f2[e2], h2 = f2[e2 + 1];
            g2 === "style" ? tb(c2, h2) : g2 === "dangerouslySetInnerHTML" ? ob(c2, h2) : g2 === "children" ? pb(c2, h2) : qa(c2, g2, h2, b2);
          }
          switch (a2) {
            case "input":
              ab(c2, d2);
              break;
            case "textarea":
              ib(c2, d2);
              break;
            case "select":
              a2 = c2._wrapperState.wasMultiple, c2._wrapperState.wasMultiple = !!d2.multiple, f2 = d2.value, f2 != null ? fb(c2, !!d2.multiple, f2, false) : a2 !== !!d2.multiple && (d2.defaultValue != null ? fb(c2, !!d2.multiple, d2.defaultValue, true) : fb(c2, !!d2.multiple, d2.multiple ? [] : "", false));
          }
        }
      }
      return;
    case 6:
      if (b2.stateNode === null)
        throw Error(y$1(162));
      b2.stateNode.nodeValue = b2.memoizedProps;
      return;
    case 3:
      c2 = b2.stateNode;
      c2.hydrate && (c2.hydrate = false, Cc(c2.containerInfo));
      return;
    case 12:
      return;
    case 13:
      b2.memoizedState !== null && (jj = O(), aj(b2.child, true));
      kj(b2);
      return;
    case 19:
      kj(b2);
      return;
    case 17:
      return;
    case 23:
    case 24:
      aj(b2, b2.memoizedState !== null);
      return;
  }
  throw Error(y$1(163));
}
function kj(a2) {
  var b2 = a2.updateQueue;
  if (b2 !== null) {
    a2.updateQueue = null;
    var c2 = a2.stateNode;
    c2 === null && (c2 = a2.stateNode = new Ui());
    b2.forEach(function(b3) {
      var d2 = lj.bind(null, a2, b3);
      c2.has(b3) || (c2.add(b3), b3.then(d2, d2));
    });
  }
}
function mj(a2, b2) {
  return a2 !== null && (a2 = a2.memoizedState, a2 === null || a2.dehydrated !== null) ? (b2 = b2.memoizedState, b2 !== null && b2.dehydrated === null) : false;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
  Ji = O() + 500;
}
var Z = null, Qi = false, Ri = null, Ti = null, xj = false, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = false;
function Hg() {
  return (X & 48) !== 0 ? O() : Fj !== -1 ? Fj : Fj = O();
}
function Ig(a2) {
  a2 = a2.mode;
  if ((a2 & 2) === 0)
    return 1;
  if ((a2 & 4) === 0)
    return eg() === 99 ? 1 : 2;
  Gj === 0 && (Gj = tj);
  if (kg.transition !== 0) {
    Hj !== 0 && (Hj = vj !== null ? vj.pendingLanes : 0);
    a2 = Gj;
    var b2 = 4186112 & ~Hj;
    b2 &= -b2;
    b2 === 0 && (a2 = 4186112 & ~a2, b2 = a2 & -a2, b2 === 0 && (b2 = 8192));
    return b2;
  }
  a2 = eg();
  (X & 4) !== 0 && a2 === 98 ? a2 = Xc(12, Gj) : (a2 = Sc(a2), a2 = Xc(a2, Gj));
  return a2;
}
function Jg(a2, b2, c2) {
  if (50 < Dj)
    throw Dj = 0, Ej = null, Error(y$1(185));
  a2 = Kj(a2, b2);
  if (a2 === null)
    return null;
  $c(a2, b2, c2);
  a2 === U && (Hi |= b2, V === 4 && Ii(a2, W));
  var d2 = eg();
  b2 === 1 ? (X & 8) !== 0 && (X & 48) === 0 ? Lj(a2) : (Mj(a2, c2), X === 0 && (wj(), ig())) : ((X & 4) === 0 || d2 !== 98 && d2 !== 99 || (Cj === null ? Cj = new Set([a2]) : Cj.add(a2)), Mj(a2, c2));
  vj = a2;
}
function Kj(a2, b2) {
  a2.lanes |= b2;
  var c2 = a2.alternate;
  c2 !== null && (c2.lanes |= b2);
  c2 = a2;
  for (a2 = a2.return; a2 !== null; )
    a2.childLanes |= b2, c2 = a2.alternate, c2 !== null && (c2.childLanes |= b2), c2 = a2, a2 = a2.return;
  return c2.tag === 3 ? c2.stateNode : null;
}
function Mj(a2, b2) {
  for (var c2 = a2.callbackNode, d2 = a2.suspendedLanes, e2 = a2.pingedLanes, f2 = a2.expirationTimes, g2 = a2.pendingLanes; 0 < g2; ) {
    var h2 = 31 - Vc(g2), k2 = 1 << h2, l2 = f2[h2];
    if (l2 === -1) {
      if ((k2 & d2) === 0 || (k2 & e2) !== 0) {
        l2 = b2;
        Rc(k2);
        var n2 = F;
        f2[h2] = 10 <= n2 ? l2 + 250 : 6 <= n2 ? l2 + 5e3 : -1;
      }
    } else
      l2 <= b2 && (a2.expiredLanes |= k2);
    g2 &= ~k2;
  }
  d2 = Uc(a2, a2 === U ? W : 0);
  b2 = F;
  if (d2 === 0)
    c2 !== null && (c2 !== Zf && Pf(c2), a2.callbackNode = null, a2.callbackPriority = 0);
  else {
    if (c2 !== null) {
      if (a2.callbackPriority === b2)
        return;
      c2 !== Zf && Pf(c2);
    }
    b2 === 15 ? (c2 = Lj.bind(null, a2), ag === null ? (ag = [c2], bg = Of(Uf, jg)) : ag.push(c2), c2 = Zf) : b2 === 14 ? c2 = hg(99, Lj.bind(null, a2)) : (c2 = Tc(b2), c2 = hg(c2, Nj.bind(null, a2)));
    a2.callbackPriority = b2;
    a2.callbackNode = c2;
  }
}
function Nj(a2) {
  Fj = -1;
  Hj = Gj = 0;
  if ((X & 48) !== 0)
    throw Error(y$1(327));
  var b2 = a2.callbackNode;
  if (Oj() && a2.callbackNode !== b2)
    return null;
  var c2 = Uc(a2, a2 === U ? W : 0);
  if (c2 === 0)
    return null;
  var d2 = c2;
  var e2 = X;
  X |= 16;
  var f2 = Pj();
  if (U !== a2 || W !== d2)
    wj(), Qj(a2, d2);
  do
    try {
      Rj();
      break;
    } catch (h2) {
      Sj(a2, h2);
    }
  while (1);
  qg();
  oj.current = f2;
  X = e2;
  Y !== null ? d2 = 0 : (U = null, W = 0, d2 = V);
  if ((tj & Hi) !== 0)
    Qj(a2, 0);
  else if (d2 !== 0) {
    d2 === 2 && (X |= 64, a2.hydrate && (a2.hydrate = false, qf(a2.containerInfo)), c2 = Wc(a2), c2 !== 0 && (d2 = Tj(a2, c2)));
    if (d2 === 1)
      throw b2 = sj, Qj(a2, 0), Ii(a2, c2), Mj(a2, O()), b2;
    a2.finishedWork = a2.current.alternate;
    a2.finishedLanes = c2;
    switch (d2) {
      case 0:
      case 1:
        throw Error(y$1(345));
      case 2:
        Uj(a2);
        break;
      case 3:
        Ii(a2, c2);
        if ((c2 & 62914560) === c2 && (d2 = jj + 500 - O(), 10 < d2)) {
          if (Uc(a2, 0) !== 0)
            break;
          e2 = a2.suspendedLanes;
          if ((e2 & c2) !== c2) {
            Hg();
            a2.pingedLanes |= a2.suspendedLanes & e2;
            break;
          }
          a2.timeoutHandle = of(Uj.bind(null, a2), d2);
          break;
        }
        Uj(a2);
        break;
      case 4:
        Ii(a2, c2);
        if ((c2 & 4186112) === c2)
          break;
        d2 = a2.eventTimes;
        for (e2 = -1; 0 < c2; ) {
          var g2 = 31 - Vc(c2);
          f2 = 1 << g2;
          g2 = d2[g2];
          g2 > e2 && (e2 = g2);
          c2 &= ~f2;
        }
        c2 = e2;
        c2 = O() - c2;
        c2 = (120 > c2 ? 120 : 480 > c2 ? 480 : 1080 > c2 ? 1080 : 1920 > c2 ? 1920 : 3e3 > c2 ? 3e3 : 4320 > c2 ? 4320 : 1960 * nj(c2 / 1960)) - c2;
        if (10 < c2) {
          a2.timeoutHandle = of(Uj.bind(null, a2), c2);
          break;
        }
        Uj(a2);
        break;
      case 5:
        Uj(a2);
        break;
      default:
        throw Error(y$1(329));
    }
  }
  Mj(a2, O());
  return a2.callbackNode === b2 ? Nj.bind(null, a2) : null;
}
function Ii(a2, b2) {
  b2 &= ~uj;
  b2 &= ~Hi;
  a2.suspendedLanes |= b2;
  a2.pingedLanes &= ~b2;
  for (a2 = a2.expirationTimes; 0 < b2; ) {
    var c2 = 31 - Vc(b2), d2 = 1 << c2;
    a2[c2] = -1;
    b2 &= ~d2;
  }
}
function Lj(a2) {
  if ((X & 48) !== 0)
    throw Error(y$1(327));
  Oj();
  if (a2 === U && (a2.expiredLanes & W) !== 0) {
    var b2 = W;
    var c2 = Tj(a2, b2);
    (tj & Hi) !== 0 && (b2 = Uc(a2, b2), c2 = Tj(a2, b2));
  } else
    b2 = Uc(a2, 0), c2 = Tj(a2, b2);
  a2.tag !== 0 && c2 === 2 && (X |= 64, a2.hydrate && (a2.hydrate = false, qf(a2.containerInfo)), b2 = Wc(a2), b2 !== 0 && (c2 = Tj(a2, b2)));
  if (c2 === 1)
    throw c2 = sj, Qj(a2, 0), Ii(a2, b2), Mj(a2, O()), c2;
  a2.finishedWork = a2.current.alternate;
  a2.finishedLanes = b2;
  Uj(a2);
  Mj(a2, O());
  return null;
}
function Vj() {
  if (Cj !== null) {
    var a2 = Cj;
    Cj = null;
    a2.forEach(function(a3) {
      a3.expiredLanes |= 24 & a3.pendingLanes;
      Mj(a3, O());
    });
  }
  ig();
}
function Wj(a2, b2) {
  var c2 = X;
  X |= 1;
  try {
    return a2(b2);
  } finally {
    X = c2, X === 0 && (wj(), ig());
  }
}
function Xj(a2, b2) {
  var c2 = X;
  X &= -2;
  X |= 8;
  try {
    return a2(b2);
  } finally {
    X = c2, X === 0 && (wj(), ig());
  }
}
function ni(a2, b2) {
  I(rj, qj);
  qj |= b2;
  tj |= b2;
}
function Ki() {
  qj = rj.current;
  H(rj);
}
function Qj(a2, b2) {
  a2.finishedWork = null;
  a2.finishedLanes = 0;
  var c2 = a2.timeoutHandle;
  c2 !== -1 && (a2.timeoutHandle = -1, pf(c2));
  if (Y !== null)
    for (c2 = Y.return; c2 !== null; ) {
      var d2 = c2;
      switch (d2.tag) {
        case 1:
          d2 = d2.type.childContextTypes;
          d2 !== null && d2 !== void 0 && Gf();
          break;
        case 3:
          fh();
          H(N);
          H(M);
          uh();
          break;
        case 5:
          hh(d2);
          break;
        case 4:
          fh();
          break;
        case 13:
          H(P);
          break;
        case 19:
          H(P);
          break;
        case 10:
          rg(d2);
          break;
        case 23:
        case 24:
          Ki();
      }
      c2 = c2.return;
    }
  U = a2;
  Y = Tg(a2.current, null);
  W = qj = tj = b2;
  V = 0;
  sj = null;
  uj = Hi = Dg = 0;
}
function Sj(a2, b2) {
  do {
    var c2 = Y;
    try {
      qg();
      vh.current = Gh;
      if (yh) {
        for (var d2 = R.memoizedState; d2 !== null; ) {
          var e2 = d2.queue;
          e2 !== null && (e2.pending = null);
          d2 = d2.next;
        }
        yh = false;
      }
      xh = 0;
      T = S = R = null;
      zh = false;
      pj.current = null;
      if (c2 === null || c2.return === null) {
        V = 1;
        sj = b2;
        Y = null;
        break;
      }
      a: {
        var f2 = a2, g2 = c2.return, h2 = c2, k2 = b2;
        b2 = W;
        h2.flags |= 2048;
        h2.firstEffect = h2.lastEffect = null;
        if (k2 !== null && typeof k2 === "object" && typeof k2.then === "function") {
          var l2 = k2;
          if ((h2.mode & 2) === 0) {
            var n2 = h2.alternate;
            n2 ? (h2.updateQueue = n2.updateQueue, h2.memoizedState = n2.memoizedState, h2.lanes = n2.lanes) : (h2.updateQueue = null, h2.memoizedState = null);
          }
          var A2 = (P.current & 1) !== 0, p2 = g2;
          do {
            var C;
            if (C = p2.tag === 13) {
              var x2 = p2.memoizedState;
              if (x2 !== null)
                C = x2.dehydrated !== null ? true : false;
              else {
                var w2 = p2.memoizedProps;
                C = w2.fallback === void 0 ? false : w2.unstable_avoidThisFallback !== true ? true : A2 ? false : true;
              }
            }
            if (C) {
              var z2 = p2.updateQueue;
              if (z2 === null) {
                var u = new Set();
                u.add(l2);
                p2.updateQueue = u;
              } else
                z2.add(l2);
              if ((p2.mode & 2) === 0) {
                p2.flags |= 64;
                h2.flags |= 16384;
                h2.flags &= -2981;
                if (h2.tag === 1)
                  if (h2.alternate === null)
                    h2.tag = 17;
                  else {
                    var t2 = zg(-1, 1);
                    t2.tag = 2;
                    Ag(h2, t2);
                  }
                h2.lanes |= 1;
                break a;
              }
              k2 = void 0;
              h2 = b2;
              var q2 = f2.pingCache;
              q2 === null ? (q2 = f2.pingCache = new Oi(), k2 = new Set(), q2.set(l2, k2)) : (k2 = q2.get(l2), k2 === void 0 && (k2 = new Set(), q2.set(l2, k2)));
              if (!k2.has(h2)) {
                k2.add(h2);
                var v2 = Yj.bind(null, f2, l2, h2);
                l2.then(v2, v2);
              }
              p2.flags |= 4096;
              p2.lanes = b2;
              break a;
            }
            p2 = p2.return;
          } while (p2 !== null);
          k2 = Error((Ra(h2.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
        }
        V !== 5 && (V = 2);
        k2 = Mi(k2, h2);
        p2 = g2;
        do {
          switch (p2.tag) {
            case 3:
              f2 = k2;
              p2.flags |= 4096;
              b2 &= -b2;
              p2.lanes |= b2;
              var J = Pi(p2, f2, b2);
              Bg(p2, J);
              break a;
            case 1:
              f2 = k2;
              var K = p2.type, Q = p2.stateNode;
              if ((p2.flags & 64) === 0 && (typeof K.getDerivedStateFromError === "function" || Q !== null && typeof Q.componentDidCatch === "function" && (Ti === null || !Ti.has(Q)))) {
                p2.flags |= 4096;
                b2 &= -b2;
                p2.lanes |= b2;
                var L = Si(p2, f2, b2);
                Bg(p2, L);
                break a;
              }
          }
          p2 = p2.return;
        } while (p2 !== null);
      }
      Zj(c2);
    } catch (va) {
      b2 = va;
      Y === c2 && c2 !== null && (Y = c2 = c2.return);
      continue;
    }
    break;
  } while (1);
}
function Pj() {
  var a2 = oj.current;
  oj.current = Gh;
  return a2 === null ? Gh : a2;
}
function Tj(a2, b2) {
  var c2 = X;
  X |= 16;
  var d2 = Pj();
  U === a2 && W === b2 || Qj(a2, b2);
  do
    try {
      ak();
      break;
    } catch (e2) {
      Sj(a2, e2);
    }
  while (1);
  qg();
  X = c2;
  oj.current = d2;
  if (Y !== null)
    throw Error(y$1(261));
  U = null;
  W = 0;
  return V;
}
function ak() {
  for (; Y !== null; )
    bk(Y);
}
function Rj() {
  for (; Y !== null && !Qf(); )
    bk(Y);
}
function bk(a2) {
  var b2 = ck(a2.alternate, a2, qj);
  a2.memoizedProps = a2.pendingProps;
  b2 === null ? Zj(a2) : Y = b2;
  pj.current = null;
}
function Zj(a2) {
  var b2 = a2;
  do {
    var c2 = b2.alternate;
    a2 = b2.return;
    if ((b2.flags & 2048) === 0) {
      c2 = Gi(c2, b2, qj);
      if (c2 !== null) {
        Y = c2;
        return;
      }
      c2 = b2;
      if (c2.tag !== 24 && c2.tag !== 23 || c2.memoizedState === null || (qj & 1073741824) !== 0 || (c2.mode & 4) === 0) {
        for (var d2 = 0, e2 = c2.child; e2 !== null; )
          d2 |= e2.lanes | e2.childLanes, e2 = e2.sibling;
        c2.childLanes = d2;
      }
      a2 !== null && (a2.flags & 2048) === 0 && (a2.firstEffect === null && (a2.firstEffect = b2.firstEffect), b2.lastEffect !== null && (a2.lastEffect !== null && (a2.lastEffect.nextEffect = b2.firstEffect), a2.lastEffect = b2.lastEffect), 1 < b2.flags && (a2.lastEffect !== null ? a2.lastEffect.nextEffect = b2 : a2.firstEffect = b2, a2.lastEffect = b2));
    } else {
      c2 = Li(b2);
      if (c2 !== null) {
        c2.flags &= 2047;
        Y = c2;
        return;
      }
      a2 !== null && (a2.firstEffect = a2.lastEffect = null, a2.flags |= 2048);
    }
    b2 = b2.sibling;
    if (b2 !== null) {
      Y = b2;
      return;
    }
    Y = b2 = a2;
  } while (b2 !== null);
  V === 0 && (V = 5);
}
function Uj(a2) {
  var b2 = eg();
  gg(99, dk.bind(null, a2, b2));
  return null;
}
function dk(a2, b2) {
  do
    Oj();
  while (yj !== null);
  if ((X & 48) !== 0)
    throw Error(y$1(327));
  var c2 = a2.finishedWork;
  if (c2 === null)
    return null;
  a2.finishedWork = null;
  a2.finishedLanes = 0;
  if (c2 === a2.current)
    throw Error(y$1(177));
  a2.callbackNode = null;
  var d2 = c2.lanes | c2.childLanes, e2 = d2, f2 = a2.pendingLanes & ~e2;
  a2.pendingLanes = e2;
  a2.suspendedLanes = 0;
  a2.pingedLanes = 0;
  a2.expiredLanes &= e2;
  a2.mutableReadLanes &= e2;
  a2.entangledLanes &= e2;
  e2 = a2.entanglements;
  for (var g2 = a2.eventTimes, h2 = a2.expirationTimes; 0 < f2; ) {
    var k2 = 31 - Vc(f2), l2 = 1 << k2;
    e2[k2] = 0;
    g2[k2] = -1;
    h2[k2] = -1;
    f2 &= ~l2;
  }
  Cj !== null && (d2 & 24) === 0 && Cj.has(a2) && Cj.delete(a2);
  a2 === U && (Y = U = null, W = 0);
  1 < c2.flags ? c2.lastEffect !== null ? (c2.lastEffect.nextEffect = c2, d2 = c2.firstEffect) : d2 = c2 : d2 = c2.firstEffect;
  if (d2 !== null) {
    e2 = X;
    X |= 32;
    pj.current = null;
    kf = fd;
    g2 = Ne();
    if (Oe(g2)) {
      if ("selectionStart" in g2)
        h2 = { start: g2.selectionStart, end: g2.selectionEnd };
      else
        a:
          if (h2 = (h2 = g2.ownerDocument) && h2.defaultView || window, (l2 = h2.getSelection && h2.getSelection()) && l2.rangeCount !== 0) {
            h2 = l2.anchorNode;
            f2 = l2.anchorOffset;
            k2 = l2.focusNode;
            l2 = l2.focusOffset;
            try {
              h2.nodeType, k2.nodeType;
            } catch (va) {
              h2 = null;
              break a;
            }
            var n2 = 0, A2 = -1, p2 = -1, C = 0, x2 = 0, w2 = g2, z2 = null;
            b:
              for (; ; ) {
                for (var u; ; ) {
                  w2 !== h2 || f2 !== 0 && w2.nodeType !== 3 || (A2 = n2 + f2);
                  w2 !== k2 || l2 !== 0 && w2.nodeType !== 3 || (p2 = n2 + l2);
                  w2.nodeType === 3 && (n2 += w2.nodeValue.length);
                  if ((u = w2.firstChild) === null)
                    break;
                  z2 = w2;
                  w2 = u;
                }
                for (; ; ) {
                  if (w2 === g2)
                    break b;
                  z2 === h2 && ++C === f2 && (A2 = n2);
                  z2 === k2 && ++x2 === l2 && (p2 = n2);
                  if ((u = w2.nextSibling) !== null)
                    break;
                  w2 = z2;
                  z2 = w2.parentNode;
                }
                w2 = u;
              }
            h2 = A2 === -1 || p2 === -1 ? null : { start: A2, end: p2 };
          } else
            h2 = null;
      h2 = h2 || { start: 0, end: 0 };
    } else
      h2 = null;
    lf = { focusedElem: g2, selectionRange: h2 };
    fd = false;
    Ij = null;
    Jj = false;
    Z = d2;
    do
      try {
        ek();
      } catch (va) {
        if (Z === null)
          throw Error(y$1(330));
        Wi(Z, va);
        Z = Z.nextEffect;
      }
    while (Z !== null);
    Ij = null;
    Z = d2;
    do
      try {
        for (g2 = a2; Z !== null; ) {
          var t2 = Z.flags;
          t2 & 16 && pb(Z.stateNode, "");
          if (t2 & 128) {
            var q2 = Z.alternate;
            if (q2 !== null) {
              var v2 = q2.ref;
              v2 !== null && (typeof v2 === "function" ? v2(null) : v2.current = null);
            }
          }
          switch (t2 & 1038) {
            case 2:
              fj(Z);
              Z.flags &= -3;
              break;
            case 6:
              fj(Z);
              Z.flags &= -3;
              ij(Z.alternate, Z);
              break;
            case 1024:
              Z.flags &= -1025;
              break;
            case 1028:
              Z.flags &= -1025;
              ij(Z.alternate, Z);
              break;
            case 4:
              ij(Z.alternate, Z);
              break;
            case 8:
              h2 = Z;
              cj(g2, h2);
              var J = h2.alternate;
              dj(h2);
              J !== null && dj(J);
          }
          Z = Z.nextEffect;
        }
      } catch (va) {
        if (Z === null)
          throw Error(y$1(330));
        Wi(Z, va);
        Z = Z.nextEffect;
      }
    while (Z !== null);
    v2 = lf;
    q2 = Ne();
    t2 = v2.focusedElem;
    g2 = v2.selectionRange;
    if (q2 !== t2 && t2 && t2.ownerDocument && Me(t2.ownerDocument.documentElement, t2)) {
      g2 !== null && Oe(t2) && (q2 = g2.start, v2 = g2.end, v2 === void 0 && (v2 = q2), "selectionStart" in t2 ? (t2.selectionStart = q2, t2.selectionEnd = Math.min(v2, t2.value.length)) : (v2 = (q2 = t2.ownerDocument || document) && q2.defaultView || window, v2.getSelection && (v2 = v2.getSelection(), h2 = t2.textContent.length, J = Math.min(g2.start, h2), g2 = g2.end === void 0 ? J : Math.min(g2.end, h2), !v2.extend && J > g2 && (h2 = g2, g2 = J, J = h2), h2 = Le(t2, J), f2 = Le(t2, g2), h2 && f2 && (v2.rangeCount !== 1 || v2.anchorNode !== h2.node || v2.anchorOffset !== h2.offset || v2.focusNode !== f2.node || v2.focusOffset !== f2.offset) && (q2 = q2.createRange(), q2.setStart(h2.node, h2.offset), v2.removeAllRanges(), J > g2 ? (v2.addRange(q2), v2.extend(f2.node, f2.offset)) : (q2.setEnd(f2.node, f2.offset), v2.addRange(q2))))));
      q2 = [];
      for (v2 = t2; v2 = v2.parentNode; )
        v2.nodeType === 1 && q2.push({ element: v2, left: v2.scrollLeft, top: v2.scrollTop });
      typeof t2.focus === "function" && t2.focus();
      for (t2 = 0; t2 < q2.length; t2++)
        v2 = q2[t2], v2.element.scrollLeft = v2.left, v2.element.scrollTop = v2.top;
    }
    fd = !!kf;
    lf = kf = null;
    a2.current = c2;
    Z = d2;
    do
      try {
        for (t2 = a2; Z !== null; ) {
          var K = Z.flags;
          K & 36 && Yi(t2, Z.alternate, Z);
          if (K & 128) {
            q2 = void 0;
            var Q = Z.ref;
            if (Q !== null) {
              var L = Z.stateNode;
              switch (Z.tag) {
                case 5:
                  q2 = L;
                  break;
                default:
                  q2 = L;
              }
              typeof Q === "function" ? Q(q2) : Q.current = q2;
            }
          }
          Z = Z.nextEffect;
        }
      } catch (va) {
        if (Z === null)
          throw Error(y$1(330));
        Wi(Z, va);
        Z = Z.nextEffect;
      }
    while (Z !== null);
    Z = null;
    $f();
    X = e2;
  } else
    a2.current = c2;
  if (xj)
    xj = false, yj = a2, zj = b2;
  else
    for (Z = d2; Z !== null; )
      b2 = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b2;
  d2 = a2.pendingLanes;
  d2 === 0 && (Ti = null);
  d2 === 1 ? a2 === Ej ? Dj++ : (Dj = 0, Ej = a2) : Dj = 0;
  c2 = c2.stateNode;
  if (Mf && typeof Mf.onCommitFiberRoot === "function")
    try {
      Mf.onCommitFiberRoot(Lf, c2, void 0, (c2.current.flags & 64) === 64);
    } catch (va) {
    }
  Mj(a2, O());
  if (Qi)
    throw Qi = false, a2 = Ri, Ri = null, a2;
  if ((X & 8) !== 0)
    return null;
  ig();
  return null;
}
function ek() {
  for (; Z !== null; ) {
    var a2 = Z.alternate;
    Jj || Ij === null || ((Z.flags & 8) !== 0 ? dc(Z, Ij) && (Jj = true) : Z.tag === 13 && mj(a2, Z) && dc(Z, Ij) && (Jj = true));
    var b2 = Z.flags;
    (b2 & 256) !== 0 && Xi(a2, Z);
    (b2 & 512) === 0 || xj || (xj = true, hg(97, function() {
      Oj();
      return null;
    }));
    Z = Z.nextEffect;
  }
}
function Oj() {
  if (zj !== 90) {
    var a2 = 97 < zj ? 97 : zj;
    zj = 90;
    return gg(a2, fk);
  }
  return false;
}
function $i(a2, b2) {
  Aj.push(b2, a2);
  xj || (xj = true, hg(97, function() {
    Oj();
    return null;
  }));
}
function Zi(a2, b2) {
  Bj.push(b2, a2);
  xj || (xj = true, hg(97, function() {
    Oj();
    return null;
  }));
}
function fk() {
  if (yj === null)
    return false;
  var a2 = yj;
  yj = null;
  if ((X & 48) !== 0)
    throw Error(y$1(331));
  var b2 = X;
  X |= 32;
  var c2 = Bj;
  Bj = [];
  for (var d2 = 0; d2 < c2.length; d2 += 2) {
    var e2 = c2[d2], f2 = c2[d2 + 1], g2 = e2.destroy;
    e2.destroy = void 0;
    if (typeof g2 === "function")
      try {
        g2();
      } catch (k2) {
        if (f2 === null)
          throw Error(y$1(330));
        Wi(f2, k2);
      }
  }
  c2 = Aj;
  Aj = [];
  for (d2 = 0; d2 < c2.length; d2 += 2) {
    e2 = c2[d2];
    f2 = c2[d2 + 1];
    try {
      var h2 = e2.create;
      e2.destroy = h2();
    } catch (k2) {
      if (f2 === null)
        throw Error(y$1(330));
      Wi(f2, k2);
    }
  }
  for (h2 = a2.current.firstEffect; h2 !== null; )
    a2 = h2.nextEffect, h2.nextEffect = null, h2.flags & 8 && (h2.sibling = null, h2.stateNode = null), h2 = a2;
  X = b2;
  ig();
  return true;
}
function gk(a2, b2, c2) {
  b2 = Mi(c2, b2);
  b2 = Pi(a2, b2, 1);
  Ag(a2, b2);
  b2 = Hg();
  a2 = Kj(a2, 1);
  a2 !== null && ($c(a2, 1, b2), Mj(a2, b2));
}
function Wi(a2, b2) {
  if (a2.tag === 3)
    gk(a2, a2, b2);
  else
    for (var c2 = a2.return; c2 !== null; ) {
      if (c2.tag === 3) {
        gk(c2, a2, b2);
        break;
      } else if (c2.tag === 1) {
        var d2 = c2.stateNode;
        if (typeof c2.type.getDerivedStateFromError === "function" || typeof d2.componentDidCatch === "function" && (Ti === null || !Ti.has(d2))) {
          a2 = Mi(b2, a2);
          var e2 = Si(c2, a2, 1);
          Ag(c2, e2);
          e2 = Hg();
          c2 = Kj(c2, 1);
          if (c2 !== null)
            $c(c2, 1, e2), Mj(c2, e2);
          else if (typeof d2.componentDidCatch === "function" && (Ti === null || !Ti.has(d2)))
            try {
              d2.componentDidCatch(b2, a2);
            } catch (f2) {
            }
          break;
        }
      }
      c2 = c2.return;
    }
}
function Yj(a2, b2, c2) {
  var d2 = a2.pingCache;
  d2 !== null && d2.delete(b2);
  b2 = Hg();
  a2.pingedLanes |= a2.suspendedLanes & c2;
  U === a2 && (W & c2) === c2 && (V === 4 || V === 3 && (W & 62914560) === W && 500 > O() - jj ? Qj(a2, 0) : uj |= c2);
  Mj(a2, b2);
}
function lj(a2, b2) {
  var c2 = a2.stateNode;
  c2 !== null && c2.delete(b2);
  b2 = 0;
  b2 === 0 && (b2 = a2.mode, (b2 & 2) === 0 ? b2 = 1 : (b2 & 4) === 0 ? b2 = eg() === 99 ? 1 : 2 : (Gj === 0 && (Gj = tj), b2 = Yc(62914560 & ~Gj), b2 === 0 && (b2 = 4194304)));
  c2 = Hg();
  a2 = Kj(a2, b2);
  a2 !== null && ($c(a2, b2, c2), Mj(a2, c2));
}
var ck;
ck = function(a2, b2, c2) {
  var d2 = b2.lanes;
  if (a2 !== null)
    if (a2.memoizedProps !== b2.pendingProps || N.current)
      ug = true;
    else if ((c2 & d2) !== 0)
      ug = (a2.flags & 16384) !== 0 ? true : false;
    else {
      ug = false;
      switch (b2.tag) {
        case 3:
          ri(b2);
          sh();
          break;
        case 5:
          gh(b2);
          break;
        case 1:
          Ff(b2.type) && Jf(b2);
          break;
        case 4:
          eh(b2, b2.stateNode.containerInfo);
          break;
        case 10:
          d2 = b2.memoizedProps.value;
          var e2 = b2.type._context;
          I(mg, e2._currentValue);
          e2._currentValue = d2;
          break;
        case 13:
          if (b2.memoizedState !== null) {
            if ((c2 & b2.child.childLanes) !== 0)
              return ti(a2, b2, c2);
            I(P, P.current & 1);
            b2 = hi(a2, b2, c2);
            return b2 !== null ? b2.sibling : null;
          }
          I(P, P.current & 1);
          break;
        case 19:
          d2 = (c2 & b2.childLanes) !== 0;
          if ((a2.flags & 64) !== 0) {
            if (d2)
              return Ai(a2, b2, c2);
            b2.flags |= 64;
          }
          e2 = b2.memoizedState;
          e2 !== null && (e2.rendering = null, e2.tail = null, e2.lastEffect = null);
          I(P, P.current);
          if (d2)
            break;
          else
            return null;
        case 23:
        case 24:
          return b2.lanes = 0, mi(a2, b2, c2);
      }
      return hi(a2, b2, c2);
    }
  else
    ug = false;
  b2.lanes = 0;
  switch (b2.tag) {
    case 2:
      d2 = b2.type;
      a2 !== null && (a2.alternate = null, b2.alternate = null, b2.flags |= 2);
      a2 = b2.pendingProps;
      e2 = Ef(b2, M.current);
      tg(b2, c2);
      e2 = Ch(null, b2, d2, a2, e2, c2);
      b2.flags |= 1;
      if (typeof e2 === "object" && e2 !== null && typeof e2.render === "function" && e2.$$typeof === void 0) {
        b2.tag = 1;
        b2.memoizedState = null;
        b2.updateQueue = null;
        if (Ff(d2)) {
          var f2 = true;
          Jf(b2);
        } else
          f2 = false;
        b2.memoizedState = e2.state !== null && e2.state !== void 0 ? e2.state : null;
        xg(b2);
        var g2 = d2.getDerivedStateFromProps;
        typeof g2 === "function" && Gg(b2, d2, g2, a2);
        e2.updater = Kg;
        b2.stateNode = e2;
        e2._reactInternals = b2;
        Og(b2, d2, a2, c2);
        b2 = qi(null, b2, d2, true, f2, c2);
      } else
        b2.tag = 0, fi(null, b2, e2, c2), b2 = b2.child;
      return b2;
    case 16:
      e2 = b2.elementType;
      a: {
        a2 !== null && (a2.alternate = null, b2.alternate = null, b2.flags |= 2);
        a2 = b2.pendingProps;
        f2 = e2._init;
        e2 = f2(e2._payload);
        b2.type = e2;
        f2 = b2.tag = hk(e2);
        a2 = lg(e2, a2);
        switch (f2) {
          case 0:
            b2 = li(null, b2, e2, a2, c2);
            break a;
          case 1:
            b2 = pi(null, b2, e2, a2, c2);
            break a;
          case 11:
            b2 = gi(null, b2, e2, a2, c2);
            break a;
          case 14:
            b2 = ii(null, b2, e2, lg(e2.type, a2), d2, c2);
            break a;
        }
        throw Error(y$1(306, e2, ""));
      }
      return b2;
    case 0:
      return d2 = b2.type, e2 = b2.pendingProps, e2 = b2.elementType === d2 ? e2 : lg(d2, e2), li(a2, b2, d2, e2, c2);
    case 1:
      return d2 = b2.type, e2 = b2.pendingProps, e2 = b2.elementType === d2 ? e2 : lg(d2, e2), pi(a2, b2, d2, e2, c2);
    case 3:
      ri(b2);
      d2 = b2.updateQueue;
      if (a2 === null || d2 === null)
        throw Error(y$1(282));
      d2 = b2.pendingProps;
      e2 = b2.memoizedState;
      e2 = e2 !== null ? e2.element : null;
      yg(a2, b2);
      Cg(b2, d2, null, c2);
      d2 = b2.memoizedState.element;
      if (d2 === e2)
        sh(), b2 = hi(a2, b2, c2);
      else {
        e2 = b2.stateNode;
        if (f2 = e2.hydrate)
          kh = rf(b2.stateNode.containerInfo.firstChild), jh = b2, f2 = lh = true;
        if (f2) {
          a2 = e2.mutableSourceEagerHydrationData;
          if (a2 != null)
            for (e2 = 0; e2 < a2.length; e2 += 2)
              f2 = a2[e2], f2._workInProgressVersionPrimary = a2[e2 + 1], th$n.push(f2);
          c2 = Zg(b2, null, d2, c2);
          for (b2.child = c2; c2; )
            c2.flags = c2.flags & -3 | 1024, c2 = c2.sibling;
        } else
          fi(a2, b2, d2, c2), sh();
        b2 = b2.child;
      }
      return b2;
    case 5:
      return gh(b2), a2 === null && ph(b2), d2 = b2.type, e2 = b2.pendingProps, f2 = a2 !== null ? a2.memoizedProps : null, g2 = e2.children, nf(d2, e2) ? g2 = null : f2 !== null && nf(d2, f2) && (b2.flags |= 16), oi(a2, b2), fi(a2, b2, g2, c2), b2.child;
    case 6:
      return a2 === null && ph(b2), null;
    case 13:
      return ti(a2, b2, c2);
    case 4:
      return eh(b2, b2.stateNode.containerInfo), d2 = b2.pendingProps, a2 === null ? b2.child = Yg(b2, null, d2, c2) : fi(a2, b2, d2, c2), b2.child;
    case 11:
      return d2 = b2.type, e2 = b2.pendingProps, e2 = b2.elementType === d2 ? e2 : lg(d2, e2), gi(a2, b2, d2, e2, c2);
    case 7:
      return fi(a2, b2, b2.pendingProps, c2), b2.child;
    case 8:
      return fi(a2, b2, b2.pendingProps.children, c2), b2.child;
    case 12:
      return fi(a2, b2, b2.pendingProps.children, c2), b2.child;
    case 10:
      a: {
        d2 = b2.type._context;
        e2 = b2.pendingProps;
        g2 = b2.memoizedProps;
        f2 = e2.value;
        var h2 = b2.type._context;
        I(mg, h2._currentValue);
        h2._currentValue = f2;
        if (g2 !== null)
          if (h2 = g2.value, f2 = He(h2, f2) ? 0 : (typeof d2._calculateChangedBits === "function" ? d2._calculateChangedBits(h2, f2) : 1073741823) | 0, f2 === 0) {
            if (g2.children === e2.children && !N.current) {
              b2 = hi(a2, b2, c2);
              break a;
            }
          } else
            for (h2 = b2.child, h2 !== null && (h2.return = b2); h2 !== null; ) {
              var k2 = h2.dependencies;
              if (k2 !== null) {
                g2 = h2.child;
                for (var l2 = k2.firstContext; l2 !== null; ) {
                  if (l2.context === d2 && (l2.observedBits & f2) !== 0) {
                    h2.tag === 1 && (l2 = zg(-1, c2 & -c2), l2.tag = 2, Ag(h2, l2));
                    h2.lanes |= c2;
                    l2 = h2.alternate;
                    l2 !== null && (l2.lanes |= c2);
                    sg(h2.return, c2);
                    k2.lanes |= c2;
                    break;
                  }
                  l2 = l2.next;
                }
              } else
                g2 = h2.tag === 10 ? h2.type === b2.type ? null : h2.child : h2.child;
              if (g2 !== null)
                g2.return = h2;
              else
                for (g2 = h2; g2 !== null; ) {
                  if (g2 === b2) {
                    g2 = null;
                    break;
                  }
                  h2 = g2.sibling;
                  if (h2 !== null) {
                    h2.return = g2.return;
                    g2 = h2;
                    break;
                  }
                  g2 = g2.return;
                }
              h2 = g2;
            }
        fi(a2, b2, e2.children, c2);
        b2 = b2.child;
      }
      return b2;
    case 9:
      return e2 = b2.type, f2 = b2.pendingProps, d2 = f2.children, tg(b2, c2), e2 = vg(e2, f2.unstable_observedBits), d2 = d2(e2), b2.flags |= 1, fi(a2, b2, d2, c2), b2.child;
    case 14:
      return e2 = b2.type, f2 = lg(e2, b2.pendingProps), f2 = lg(e2.type, f2), ii(a2, b2, e2, f2, d2, c2);
    case 15:
      return ki(a2, b2, b2.type, b2.pendingProps, d2, c2);
    case 17:
      return d2 = b2.type, e2 = b2.pendingProps, e2 = b2.elementType === d2 ? e2 : lg(d2, e2), a2 !== null && (a2.alternate = null, b2.alternate = null, b2.flags |= 2), b2.tag = 1, Ff(d2) ? (a2 = true, Jf(b2)) : a2 = false, tg(b2, c2), Mg(b2, d2, e2), Og(b2, d2, e2, c2), qi(null, b2, d2, true, a2, c2);
    case 19:
      return Ai(a2, b2, c2);
    case 23:
      return mi(a2, b2, c2);
    case 24:
      return mi(a2, b2, c2);
  }
  throw Error(y$1(156, b2.tag));
};
function ik(a2, b2, c2, d2) {
  this.tag = a2;
  this.key = c2;
  this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
  this.index = 0;
  this.ref = null;
  this.pendingProps = b2;
  this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
  this.mode = d2;
  this.flags = 0;
  this.lastEffect = this.firstEffect = this.nextEffect = null;
  this.childLanes = this.lanes = 0;
  this.alternate = null;
}
function nh(a2, b2, c2, d2) {
  return new ik(a2, b2, c2, d2);
}
function ji(a2) {
  a2 = a2.prototype;
  return !(!a2 || !a2.isReactComponent);
}
function hk(a2) {
  if (typeof a2 === "function")
    return ji(a2) ? 1 : 0;
  if (a2 !== void 0 && a2 !== null) {
    a2 = a2.$$typeof;
    if (a2 === Aa)
      return 11;
    if (a2 === Da)
      return 14;
  }
  return 2;
}
function Tg(a2, b2) {
  var c2 = a2.alternate;
  c2 === null ? (c2 = nh(a2.tag, b2, a2.key, a2.mode), c2.elementType = a2.elementType, c2.type = a2.type, c2.stateNode = a2.stateNode, c2.alternate = a2, a2.alternate = c2) : (c2.pendingProps = b2, c2.type = a2.type, c2.flags = 0, c2.nextEffect = null, c2.firstEffect = null, c2.lastEffect = null);
  c2.childLanes = a2.childLanes;
  c2.lanes = a2.lanes;
  c2.child = a2.child;
  c2.memoizedProps = a2.memoizedProps;
  c2.memoizedState = a2.memoizedState;
  c2.updateQueue = a2.updateQueue;
  b2 = a2.dependencies;
  c2.dependencies = b2 === null ? null : { lanes: b2.lanes, firstContext: b2.firstContext };
  c2.sibling = a2.sibling;
  c2.index = a2.index;
  c2.ref = a2.ref;
  return c2;
}
function Vg(a2, b2, c2, d2, e2, f2) {
  var g2 = 2;
  d2 = a2;
  if (typeof a2 === "function")
    ji(a2) && (g2 = 1);
  else if (typeof a2 === "string")
    g2 = 5;
  else
    a:
      switch (a2) {
        case ua:
          return Xg(c2.children, e2, f2, b2);
        case Ha:
          g2 = 8;
          e2 |= 16;
          break;
        case wa:
          g2 = 8;
          e2 |= 1;
          break;
        case xa:
          return a2 = nh(12, c2, b2, e2 | 8), a2.elementType = xa, a2.type = xa, a2.lanes = f2, a2;
        case Ba:
          return a2 = nh(13, c2, b2, e2), a2.type = Ba, a2.elementType = Ba, a2.lanes = f2, a2;
        case Ca:
          return a2 = nh(19, c2, b2, e2), a2.elementType = Ca, a2.lanes = f2, a2;
        case Ia:
          return vi(c2, e2, f2, b2);
        case Ja:
          return a2 = nh(24, c2, b2, e2), a2.elementType = Ja, a2.lanes = f2, a2;
        default:
          if (typeof a2 === "object" && a2 !== null)
            switch (a2.$$typeof) {
              case ya:
                g2 = 10;
                break a;
              case za:
                g2 = 9;
                break a;
              case Aa:
                g2 = 11;
                break a;
              case Da:
                g2 = 14;
                break a;
              case Ea:
                g2 = 16;
                d2 = null;
                break a;
              case Fa:
                g2 = 22;
                break a;
            }
          throw Error(y$1(130, a2 == null ? a2 : typeof a2, ""));
      }
  b2 = nh(g2, c2, b2, e2);
  b2.elementType = a2;
  b2.type = d2;
  b2.lanes = f2;
  return b2;
}
function Xg(a2, b2, c2, d2) {
  a2 = nh(7, a2, d2, b2);
  a2.lanes = c2;
  return a2;
}
function vi(a2, b2, c2, d2) {
  a2 = nh(23, a2, d2, b2);
  a2.elementType = Ia;
  a2.lanes = c2;
  return a2;
}
function Ug(a2, b2, c2) {
  a2 = nh(6, a2, null, b2);
  a2.lanes = c2;
  return a2;
}
function Wg(a2, b2, c2) {
  b2 = nh(4, a2.children !== null ? a2.children : [], a2.key, b2);
  b2.lanes = c2;
  b2.stateNode = { containerInfo: a2.containerInfo, pendingChildren: null, implementation: a2.implementation };
  return b2;
}
function jk(a2, b2, c2) {
  this.tag = b2;
  this.containerInfo = a2;
  this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
  this.timeoutHandle = -1;
  this.pendingContext = this.context = null;
  this.hydrate = c2;
  this.callbackNode = null;
  this.callbackPriority = 0;
  this.eventTimes = Zc(0);
  this.expirationTimes = Zc(-1);
  this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
  this.entanglements = Zc(0);
  this.mutableSourceEagerHydrationData = null;
}
function kk(a2, b2, c2) {
  var d2 = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
  return { $$typeof: ta, key: d2 == null ? null : "" + d2, children: a2, containerInfo: b2, implementation: c2 };
}
function lk(a2, b2, c2, d2) {
  var e2 = b2.current, f2 = Hg(), g2 = Ig(e2);
  a:
    if (c2) {
      c2 = c2._reactInternals;
      b: {
        if (Zb(c2) !== c2 || c2.tag !== 1)
          throw Error(y$1(170));
        var h2 = c2;
        do {
          switch (h2.tag) {
            case 3:
              h2 = h2.stateNode.context;
              break b;
            case 1:
              if (Ff(h2.type)) {
                h2 = h2.stateNode.__reactInternalMemoizedMergedChildContext;
                break b;
              }
          }
          h2 = h2.return;
        } while (h2 !== null);
        throw Error(y$1(171));
      }
      if (c2.tag === 1) {
        var k2 = c2.type;
        if (Ff(k2)) {
          c2 = If(c2, k2, h2);
          break a;
        }
      }
      c2 = h2;
    } else
      c2 = Cf;
  b2.context === null ? b2.context = c2 : b2.pendingContext = c2;
  b2 = zg(f2, g2);
  b2.payload = { element: a2 };
  d2 = d2 === void 0 ? null : d2;
  d2 !== null && (b2.callback = d2);
  Ag(e2, b2);
  Jg(e2, g2, f2);
  return g2;
}
function mk(a2) {
  a2 = a2.current;
  if (!a2.child)
    return null;
  switch (a2.child.tag) {
    case 5:
      return a2.child.stateNode;
    default:
      return a2.child.stateNode;
  }
}
function nk(a2, b2) {
  a2 = a2.memoizedState;
  if (a2 !== null && a2.dehydrated !== null) {
    var c2 = a2.retryLane;
    a2.retryLane = c2 !== 0 && c2 < b2 ? c2 : b2;
  }
}
function ok(a2, b2) {
  nk(a2, b2);
  (a2 = a2.alternate) && nk(a2, b2);
}
function pk() {
  return null;
}
function qk(a2, b2, c2) {
  var d2 = c2 != null && c2.hydrationOptions != null && c2.hydrationOptions.mutableSources || null;
  c2 = new jk(a2, b2, c2 != null && c2.hydrate === true);
  b2 = nh(3, null, null, b2 === 2 ? 7 : b2 === 1 ? 3 : 0);
  c2.current = b2;
  b2.stateNode = c2;
  xg(b2);
  a2[ff] = c2.current;
  cf(a2.nodeType === 8 ? a2.parentNode : a2);
  if (d2)
    for (a2 = 0; a2 < d2.length; a2++) {
      b2 = d2[a2];
      var e2 = b2._getVersion;
      e2 = e2(b2._source);
      c2.mutableSourceEagerHydrationData == null ? c2.mutableSourceEagerHydrationData = [b2, e2] : c2.mutableSourceEagerHydrationData.push(b2, e2);
    }
  this._internalRoot = c2;
}
qk.prototype.render = function(a2) {
  lk(a2, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
  var a2 = this._internalRoot, b2 = a2.containerInfo;
  lk(null, a2, null, function() {
    b2[ff] = null;
  });
};
function rk(a2) {
  return !(!a2 || a2.nodeType !== 1 && a2.nodeType !== 9 && a2.nodeType !== 11 && (a2.nodeType !== 8 || a2.nodeValue !== " react-mount-point-unstable "));
}
function sk(a2, b2) {
  b2 || (b2 = a2 ? a2.nodeType === 9 ? a2.documentElement : a2.firstChild : null, b2 = !(!b2 || b2.nodeType !== 1 || !b2.hasAttribute("data-reactroot")));
  if (!b2)
    for (var c2; c2 = a2.lastChild; )
      a2.removeChild(c2);
  return new qk(a2, 0, b2 ? { hydrate: true } : void 0);
}
function tk(a2, b2, c2, d2, e2) {
  var f2 = c2._reactRootContainer;
  if (f2) {
    var g2 = f2._internalRoot;
    if (typeof e2 === "function") {
      var h2 = e2;
      e2 = function() {
        var a3 = mk(g2);
        h2.call(a3);
      };
    }
    lk(b2, g2, a2, e2);
  } else {
    f2 = c2._reactRootContainer = sk(c2, d2);
    g2 = f2._internalRoot;
    if (typeof e2 === "function") {
      var k2 = e2;
      e2 = function() {
        var a3 = mk(g2);
        k2.call(a3);
      };
    }
    Xj(function() {
      lk(b2, g2, a2, e2);
    });
  }
  return mk(g2);
}
ec = function(a2) {
  if (a2.tag === 13) {
    var b2 = Hg();
    Jg(a2, 4, b2);
    ok(a2, 4);
  }
};
fc = function(a2) {
  if (a2.tag === 13) {
    var b2 = Hg();
    Jg(a2, 67108864, b2);
    ok(a2, 67108864);
  }
};
gc = function(a2) {
  if (a2.tag === 13) {
    var b2 = Hg(), c2 = Ig(a2);
    Jg(a2, c2, b2);
    ok(a2, c2);
  }
};
hc = function(a2, b2) {
  return b2();
};
yb = function(a2, b2, c2) {
  switch (b2) {
    case "input":
      ab(a2, c2);
      b2 = c2.name;
      if (c2.type === "radio" && b2 != null) {
        for (c2 = a2; c2.parentNode; )
          c2 = c2.parentNode;
        c2 = c2.querySelectorAll("input[name=" + JSON.stringify("" + b2) + '][type="radio"]');
        for (b2 = 0; b2 < c2.length; b2++) {
          var d2 = c2[b2];
          if (d2 !== a2 && d2.form === a2.form) {
            var e2 = Db(d2);
            if (!e2)
              throw Error(y$1(90));
            Wa(d2);
            ab(d2, e2);
          }
        }
      }
      break;
    case "textarea":
      ib(a2, c2);
      break;
    case "select":
      b2 = c2.value, b2 != null && fb(a2, !!c2.multiple, b2, false);
  }
};
Gb = Wj;
Hb = function(a2, b2, c2, d2, e2) {
  var f2 = X;
  X |= 4;
  try {
    return gg(98, a2.bind(null, b2, c2, d2, e2));
  } finally {
    X = f2, X === 0 && (wj(), ig());
  }
};
Ib = function() {
  (X & 49) === 0 && (Vj(), Oj());
};
Jb = function(a2, b2) {
  var c2 = X;
  X |= 2;
  try {
    return a2(b2);
  } finally {
    X = c2, X === 0 && (wj(), ig());
  }
};
function uk(a2, b2) {
  var c2 = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
  if (!rk(b2))
    throw Error(y$1(200));
  return kk(a2, b2, null, c2);
}
var vk = { Events: [Cb, ue, Db, Eb, Fb, Oj, { current: false }] }, wk = { findFiberByHostInstance: wc, bundleType: 0, version: "17.0.2", rendererPackageName: "react-dom" };
var xk = { bundleType: wk.bundleType, version: wk.version, rendererPackageName: wk.rendererPackageName, rendererConfig: wk.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: ra.ReactCurrentDispatcher, findHostInstanceByFiber: function(a2) {
  a2 = cc(a2);
  return a2 === null ? null : a2.stateNode;
}, findFiberByHostInstance: wk.findFiberByHostInstance || pk, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null };
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined") {
  var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!yk.isDisabled && yk.supportsFiber)
    try {
      Lf = yk.inject(xk), Mf = yk;
    } catch (a2) {
    }
}
reactDom_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
reactDom_production_min.createPortal = uk;
reactDom_production_min.findDOMNode = function(a2) {
  if (a2 == null)
    return null;
  if (a2.nodeType === 1)
    return a2;
  var b2 = a2._reactInternals;
  if (b2 === void 0) {
    if (typeof a2.render === "function")
      throw Error(y$1(188));
    throw Error(y$1(268, Object.keys(a2)));
  }
  a2 = cc(b2);
  a2 = a2 === null ? null : a2.stateNode;
  return a2;
};
reactDom_production_min.flushSync = function(a2, b2) {
  var c2 = X;
  if ((c2 & 48) !== 0)
    return a2(b2);
  X |= 1;
  try {
    if (a2)
      return gg(99, a2.bind(null, b2));
  } finally {
    X = c2, ig();
  }
};
reactDom_production_min.hydrate = function(a2, b2, c2) {
  if (!rk(b2))
    throw Error(y$1(200));
  return tk(null, a2, b2, true, c2);
};
reactDom_production_min.render = function(a2, b2, c2) {
  if (!rk(b2))
    throw Error(y$1(200));
  return tk(null, a2, b2, false, c2);
};
reactDom_production_min.unmountComponentAtNode = function(a2) {
  if (!rk(a2))
    throw Error(y$1(40));
  return a2._reactRootContainer ? (Xj(function() {
    tk(null, null, a2, false, function() {
      a2._reactRootContainer = null;
      a2[ff] = null;
    });
  }), true) : false;
};
reactDom_production_min.unstable_batchedUpdates = Wj;
reactDom_production_min.unstable_createPortal = function(a2, b2) {
  return uk(a2, b2, 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null);
};
reactDom_production_min.unstable_renderSubtreeIntoContainer = function(a2, b2, c2, d2) {
  if (!rk(c2))
    throw Error(y$1(200));
  if (a2 == null || a2._reactInternals === void 0)
    throw Error(y$1(38));
  return tk(a2, b2, c2, false, d2);
};
reactDom_production_min.version = "17.0.2";
function checkDCE() {
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") {
    return;
  }
  try {
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    console.error(err);
  }
}
{
  checkDCE();
  reactDom.exports = reactDom_production_min;
}
var ReactDOM = reactDom.exports;
const modalRoot = document.createElement("div");
modalRoot.setAttribute("id", "modal-root");
(_e = document.querySelector("body")) == null ? void 0 : _e.appendChild(modalRoot);
const Modal = (props) => {
  const {
    isOpen,
    onClose,
    isDestroyMode = true,
    children: children2,
    className,
    size = "small",
    isClickOverlayToClose = false,
    noPadding = false
  } = props;
  const backdropDefaultClass = "tw-fixed tw-top-0 tw-left-0 tw-right-0 tw-bottom-0 tw-w-full tw-h-screen tw-bg-[#14193180] tw-z-[10000]";
  const stateClass = isOpen ? "tw-flex" : "tw-hidden";
  const modalSizeClasses = {
    small: "tablet:tw-max-w-md tablet:tw-w-108",
    medium: "tablet:tw-max-w-2xl tablet:tw-w-160",
    full: "tablet:tw-max-w-2xl tablet:tw-w-160 fullScreen:tw-max-w-6xl fullScreen:tw-w-280"
  };
  const paddingClasses = noPadding ? "tw-p-0" : "tw-p-6";
  if (isDestroyMode && !isOpen) {
    return null;
  }
  return ReactDOM.createPortal(/* @__PURE__ */ jsx$1("div", {
    className: "web-console",
    children: /* @__PURE__ */ jsxs("div", {
      className: classNames$1("tw-grid tw-fixed tw-inset-0 tw-z-[10000] tw-place-content-center", stateClass),
      children: [/* @__PURE__ */ jsx$1("div", {
        onClick: isClickOverlayToClose && onClose ? onClose : () => {
        },
        className: classNames$1(backdropDefaultClass)
      }), /* @__PURE__ */ jsx$1("div", {
        className: classNames$1("tw-fixed tw-inset-x-0 tw-bottom-0 tw-z-[20000] tw-bg-White tw-rounded-t-lg tablet:tw-static tablet:tw-m-6 tablet:tw-rounded-lg", modalSizeClasses[size], paddingClasses, className),
        children: children2
      })]
    })
  }), modalRoot);
};
Modal.displayName = "Modal";
const STANDARD_COLORS = {
  current: "typography tw-text-current",
  transparent: "typography tw-text-transparent",
  dark: "typography tw-text-dark",
  white: "typography tw-text-white",
  "primary-100": "typography tw-text-primary-100",
  "primary-200": "typography tw-text-primary-200",
  "primary-300": "typography tw-text-primary-300",
  "primary-400": "typography tw-text-primary-400",
  "primary-500": "typography tw-text-primary-500",
  "primary-600": "typography tw-text-primary-600",
  "grayscale-100": "typography tw-text-grayscale-100",
  "grayscale-200": "typography tw-text-grayscale-200",
  "grayscale-300": "typography tw-text-grayscale-300",
  "grayscale-400": "typography tw-text-grayscale-400",
  "grayscale-500": "typography tw-text-grayscale-500",
  "grayscale-600": "typography tw-text-grayscale-600",
  "grayscale-700": "typography tw-text-grayscale-700",
  "grayscale-800": "typography tw-text-grayscale-800",
  "red-100": "typography tw-text-red-100",
  "red-200": "typography tw-text-red-200",
  "red-300": "typography tw-text-red-300",
  "red-400": "typography tw-text-red-400",
  "red-500": "typography tw-text-red-500",
  "red-600": "typography tw-text-red-600",
  "orange-100": "typography tw-text-orange-100",
  "orange-200": "typography tw-text-orange-200",
  "orange-300": "typography tw-text-orange-300",
  "orange-400": "typography tw-text-orange-400",
  "orange-500": "typography tw-text-orange-500",
  "orange-600": "typography tw-text-orange-600",
  "yellow-100": "typography tw-text-yellow-100",
  "yellow-200": "typography tw-text-yellow-200",
  "yellow-300": "typography tw-text-yellow-300",
  "yellow-400": "typography tw-text-yellow-400",
  "yellow-500": "typography tw-text-yellow-500",
  "yellow-600": "typography tw-text-yellow-600",
  "green-100": "typography tw-text-green-100",
  "green-200": "typography tw-text-green-200",
  "green-300": "typography tw-text-green-300",
  "green-400": "typography tw-text-green-400",
  "green-500": "typography tw-text-green-500",
  "green-600": "typography tw-text-green-600",
  "darkblue-100": "typography tw-text-darkblue-100",
  "darkblue-200": "typography tw-text-darkblue-200",
  "darkblue-300": "typography tw-text-darkblue-300",
  "darkblue-400": "typography tw-text-darkblue-400",
  "darkblue-500": "typography tw-text-darkblue-500",
  "darkblue-600": "typography tw-text-darkblue-600",
  "lightblue-100": "typography tw-text-lightblue-100",
  "lightblue-200": "typography tw-text-lightblue-200",
  "lightblue-300": "typography tw-text-lightblue-300",
  "lightblue-400": "typography tw-text-lightblue-400",
  "lightblue-500": "typography tw-text-lightblue-500",
  "lightblue-600": "typography tw-text-lightblue-600"
};
const LEGACY_COLORS = {
  Accent: "typography tw-text-Accent",
  AntiFlashWhite: "typography tw-text-AntiFlashWhite",
  Black: "typography tw-text-Black",
  DarkBlue: "typography tw-text-DarkBlue",
  DarkLight: "typography tw-text-DarkLight",
  DarkNudePrimary: "typography tw-text-DarkNudePrimary",
  DarkPrimary: "typography tw-text-DarkPrimary",
  LightBlue: "typography tw-text-LightBlue",
  LightNudePrimary: "typography tw-text-LightNudePrimary",
  LightPrimary: "typography tw-text-LightPrimary",
  NudeDarkBlue: "typography tw-text-NudeDarkBlue",
  NudeGreen: "typography tw-text-NudeGreen",
  NudeLightBlue: "typography tw-text-NudeLightBlue",
  NudeOrange: "typography tw-text-NudeOrange",
  NudePrimary: "typography tw-text-NudePrimary",
  NudeRed: "typography tw-text-NudeRed",
  NudeYellow: "typography tw-text-NudeYellow",
  Orange: "typography tw-text-Orange",
  Red: "typography tw-text-Red",
  Secondary: "typography tw-text-Secondary",
  Tertiary: "typography tw-text-Tertiary",
  Transparent: "typography tw-text-Transparent",
  White: "typography tw-text-White",
  Yellow: "typography tw-text-Yellow",
  Green: "typography tw-text-Green-500",
  "Gray-0": "typography tw-text-Gray-0",
  "Gray-100": "typography tw-text-Gray-100",
  "Gray-200": "typography tw-text-Gray-200",
  "Gray-300": "typography tw-text-Gray-300",
  "Gray-400": "typography tw-text-Gray-400",
  "Gray-500": "typography tw-text-Gray-500",
  "Gray-600": "typography tw-text-Gray-600",
  "Gray-700": "typography tw-text-Gray-700",
  "Gray-800": "typography tw-text-Gray-800",
  "Green-100": "typography tw-text-Green-100",
  "Green-200": "typography tw-text-Green-200",
  "Green-300": "typography tw-text-Green-300",
  "Green-400": "typography tw-text-Green-400",
  "Green-500": "typography tw-text-Green-500",
  "Primary-0": "typography tw-text-Primary-0",
  "Primary-100": "typography tw-text-Primary-100",
  "Primary-200": "typography tw-text-Primary-200",
  "Primary-300": "typography tw-text-Primary-300",
  "Primary-400": "typography tw-text-Primary-400",
  "Primary-500": "typography tw-text-Primary-500",
  "Primary-600": "typography tw-text-Primary-600",
  "Primary-700": "typography tw-text-Primary-700",
  "Primary-800": "typography tw-text-Primary-800"
};
const LEGACY_NFT_COLORS = {
  NFTAliceBlue: "typography tw-text-NFTAliceBlue",
  NFTAntiFlashWhite: "typography tw-text-NFTAntiFlashWhite",
  NFTBrandeisBlue: "typography tw-text-NFTBrandeisBlue",
  NFTFrenchSkyBlue: "typography tw-text-NFTFrenchSkyBlue",
  NFTGhostWhite: "typography tw-text-NFTGhostWhite",
  NFTMetallicSilver: "typography tw-text-NFTMetallicSilver",
  NFTPastelRed: "typography tw-text-NFTPastelRed"
};
const colorMapping = __spreadValues(__spreadValues(__spreadValues({}, STANDARD_COLORS), LEGACY_COLORS), LEGACY_NFT_COLORS);
const variantMapping = {
  "heading-1": "h1",
  "heading-2": "h2",
  "heading-3": "h3",
  "heading-4": "h4",
  "heading-5": "h5",
  "heading-6": "h6",
  "title-1": "p",
  "title-2": "p",
  "title-3": "p",
  "title-4": "p",
  "title-5": "p",
  "title-6": "p",
  "title-7": "p",
  "title-8": "p",
  "title-9": "p",
  "title-10": "p",
  "title-11": "p",
  "body-1": "p",
  "body-2": "p",
  "body-3": "p",
  "body-4": "p",
  "body-5": "p"
};
const Typography = forwardRef((props, ref) => {
  const _a2 = props, {
    variant,
    className,
    color = "Black"
  } = _a2, rest = __objRest(_a2, [
    "variant",
    "className",
    "color"
  ]);
  const classes2 = [variant, colorMapping[color], className].join(" ");
  const htmlTypography = variantMapping[variant];
  return createElement(htmlTypography, __spreadProps(__spreadValues({}, rest), {
    className: classNames$1(classes2, variant, className),
    ref
  }));
});
Typography.displayName = "Typography";
const DEEPLE_LOGO_IMAGE = "/assets/logo/deeple_logo_colored.svg";
const NFT_LOGO_IMAGE = "/assets/images/nft/nft-logo.png";
const NFT_SIDEBAR_BACKGROUND = "/assets/images/nft/nft-sidebar-background.png";
const WELCOME_GRAPHIC = "/assets/graphic/welcome.svg";
const SHIPPING_GRAPHIC = "/assets/graphic/shipping.svg";
const DEFAULT_ADD_PRODUCT_GRAPHIC = "/assets/graphic/add-product.svg";
const PRODUCT_NOT_FOUND_GRAPHIC = "/assets/graphic/product-not-found.svg";
const IMAGE_TYPE_WHITE_LISTS = ["image/png", "image/jpeg"];
const IMAGE_TYPE_WHITE_LISTS_REGEX = new RegExp(/\.(jpe?g|png)$/, "i");
const IMAGE_PATH = "/assets/images";
const UPGRADE_PLAN_SUCCESS = `${IMAGE_PATH}/upgrade-plan-success.svg`;
const NOT_ALLOW_THIS_FEATURE = `${IMAGE_PATH}/not-allow-this-feature.svg`;
const STORE_CREATED = `${IMAGE_PATH}/store-created.png`;
const UPLOAD_FILE = "/assets/graphic/uploader.svg";
const SHIPPING_METHOD = `${IMAGE_PATH}/shipping-method.png`;
const LOADING = `${IMAGE_PATH}/loading.svg`;
const PAYMENT_CAROUSEL_WHAT_IS_DEEPLE_PAY = `${IMAGE_PATH}/payment_carousel_1.svg`;
const PAYMENT_CAROUSEL_CHECK_PAYMENT = `${IMAGE_PATH}/payment_carousel_2.svg`;
const PAYMENT_CAROUSEL_WITHDRAW = `${IMAGE_PATH}/payment_carousel_3.svg`;
const AI_BOT_SETTING = `${IMAGE_PATH}/ai_guideline_1.svg`;
const AI_WELCOME_MESSAGE = `${IMAGE_PATH}/ai_guideline_2.svg`;
const AI_SPECIAL_KNOWLEDGE = `${IMAGE_PATH}/ai_guideline_3.svg`;
const CONNECT_GUIDELINE = `${IMAGE_PATH}/connect_guideline.svg`;
const LINE_LOGO = `${IMAGE_PATH}/brands/brand-line.svg`;
const FACEBOOK_LOGO = `${IMAGE_PATH}/brands/brand-facebook.svg`;
const INSTAGRAM_LOGO = `${IMAGE_PATH}/brands/brand-instagram.svg`;
const SHIPPING_LOGO = `${IMAGE_PATH}/shipping.png`;
const SHIPPOP_LOGO = `${IMAGE_PATH}/shippop.png`;
const LALAMOVE_LOGO = `${IMAGE_PATH}/lalamove.png`;
const NFT_CASHBACK_GETTING_STARTED_PLACEHOLDER = `${IMAGE_PATH}/nft/nft-cashback-getting-started-hero-placeholder.png`;
const NFT_CONNECT_WALLET_PLACEHOLDER = `${IMAGE_PATH}/nft/nft-connect-wallet-placeholder.png`;
const NFT_USE_NFT_CASHBACK_PLACEHOLDER = `${IMAGE_PATH}/nft/nft-use-nft-cashback-placeholder.png`;
const NFT_STORE_SUCCESSFULLY_CREATED = `${IMAGE_PATH}/nft/store-created-successfully.png`;
const ENABLE_CONTINUE_SHOPPING = `${IMAGE_PATH}/enable-continue-shopping.png`;
const DEEPLE_PAY_GUIDELINE = `${IMAGE_PATH}/payment/deeple-pay-guideline.png`;
const BANK_TRANSFER_GUIDELINE = `${IMAGE_PATH}/payment/bank-transfer-guideline.png`;
const MODAL_PHONE_NUBMER_COVER = `${IMAGE_PATH}/modal-phone-number-cover.png`;
const PAYMENT_SUMMARY_IMAGE = `${IMAGE_PATH}/payment-summary.png`;
const VISA_ICON_PATH = `${IMAGE_PATH}/credit-cards/visa.png`;
const MASTERCARD_ICON_PATH = `${IMAGE_PATH}/credit-cards/mastercard.png`;
const JCB_ICON_PATH = `${IMAGE_PATH}/credit-cards/jcb.png`;
const AMERICAN_EXPRESS_ICON_PATH = `${IMAGE_PATH}/credit-cards/american-express.png`;
const FACEBOOK_RECURRING_NOTIFICATION_PATH = `${IMAGE_PATH}/broadcast/facebook-recurring-notification-cover.svg`;
const ICON_CONNECT_APPLE_PATH = `${IMAGE_PATH}/icons/connects/icon-connect-apple.svg`;
const ICON_CONNECT_FACEBOOK_PATH = `${IMAGE_PATH}/icons/connects/icon-connect-facebook.svg`;
const ICON_CONNECT_GOOGLE_PATH = `${IMAGE_PATH}/icons/connects/icon-connect-google.svg`;
const ICON_CONNECT_INSTAGRAM_PATH = `${IMAGE_PATH}/icons/connects/icon-connect-instagram.svg`;
const ICON_CONNECT_LINE_PATH = `${IMAGE_PATH}/icons/connects/icon-connect-line.svg`;
const ICON_CONNECT_PROFILE_PATH = `${IMAGE_PATH}/icons/connects/icon-connect-profile.svg`;
const ICON_DISCONNECT_PATH = `${IMAGE_PATH}/icons/connects/icon-disconnect.svg`;
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
function _toPrimitive(input, hint) {
  if (_typeof$1(input) !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof$1(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof$1(key) === "symbol" ? key : String(key);
}
function _defineProperty$4(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function ownKeys$3(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
    }
    keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$3(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$3(Object(source2), true).forEach(function(key) {
        _defineProperty$4(target, key, source2[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2));
    } else {
      ownKeys$3(Object(source2)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
      });
    }
  }
  return target;
}
var defaultOptions$1 = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: true
};
var i18nInstance;
var I18nContext = React__default.createContext();
function setDefaults() {
  var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  defaultOptions$1 = _objectSpread$3(_objectSpread$3({}, defaultOptions$1), options2);
}
function getDefaults() {
  return defaultOptions$1;
}
var ReportNamespaces = function() {
  function ReportNamespaces2() {
    _classCallCheck$1(this, ReportNamespaces2);
    this.usedNamespaces = {};
  }
  _createClass$1(ReportNamespaces2, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;
      namespaces.forEach(function(ns) {
        if (!_this.usedNamespaces[ns])
          _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);
  return ReportNamespaces2;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: "3rdParty",
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
function warn() {
  if (console && console.warn) {
    var _console;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (typeof args[0] === "string")
      args[0] = "react-i18next:: ".concat(args[0]);
    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  if (typeof args[0] === "string" && alreadyWarned[args[0]])
    return;
  if (typeof args[0] === "string")
    alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb2) {
  i18n.loadNamespaces(ns, function() {
    if (i18n.isInitialized) {
      cb2();
    } else {
      var initialized = function initialized2() {
        setTimeout(function() {
          i18n.off("initialized", initialized2);
        }, 0);
        cb2();
      };
      i18n.on("initialized", initialized);
    }
  });
}
function hasLoadedNamespace(ns, i18n) {
  var options2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!i18n.languages || !i18n.languages.length) {
    warnOnce("i18n.languages were undefined or empty", i18n.languages);
    return true;
  }
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === "cimode")
    return true;
  var loadNotPending = function loadNotPending2(l2, n2) {
    var loadState = i18n.services.backendConnector.state["".concat(l2, "|").concat(n2)];
    return loadState === -1 || loadState === 2;
  };
  if (options2.bindI18n && options2.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns))
    return false;
  if (i18n.hasResourceBundle(lng, ns))
    return true;
  if (!i18n.services.backendConnector.backend)
    return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns)))
    return true;
  return false;
}
function _arrayWithHoles$3(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArrayLimit$3(arr, i2) {
  var _i = arr == null ? null : typeof Symbol != "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i != null) {
    var _s, _e2, _x, _r, _arr = [], _n = true, _d = false;
    try {
      if (_x = (_i = _i.call(arr)).next, i2 === 0) {
        if (Object(_i) !== _i)
          return;
        _n = false;
      } else
        for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i2); _n = true) {
          ;
        }
    } catch (err) {
      _d = true, _e2 = err;
    } finally {
      try {
        if (!_n && _i["return"] != null && (_r = _i["return"](), Object(_r) !== _r))
          return;
      } finally {
        if (_d)
          throw _e2;
      }
    }
    return _arr;
  }
}
function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function _unsupportedIterableToArray$3(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray$3(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor)
    n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray$3(o2, minLen);
}
function _nonIterableRest$3() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$3(arr, i2) {
  return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i2) || _unsupportedIterableToArray$3(arr, i2) || _nonIterableRest$3();
}
function ownKeys$2(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
    }
    keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$2(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$2(Object(source2), true).forEach(function(key) {
        _defineProperty$4(target, key, source2[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2));
    } else {
      ownKeys$2(Object(source2)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
      });
    }
  }
  return target;
}
function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var i18nFromProps = props.i18n;
  var _ref3 = useContext(I18nContext) || {}, i18nFromContext = _ref3.i18n, defaultNSFromContext = _ref3.defaultNS;
  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces)
    i18n.reportNamespaces = new ReportNamespaces();
  if (!i18n) {
    warnOnce("You will need to pass in an i18next instance by using initReactI18next");
    var notReadyT = function notReadyT2(k2) {
      return Array.isArray(k2) ? k2[k2.length - 1] : k2;
    };
    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }
  if (i18n.options.react && i18n.options.react.wait !== void 0)
    warnOnce("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  var i18nOptions = _objectSpread$2(_objectSpread$2(_objectSpread$2({}, getDefaults()), i18n.options.react), props);
  var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === "string" ? [namespaces] : namespaces || ["translation"];
  if (i18n.reportNamespaces.addUsedNamespaces)
    i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n2) {
    return hasLoadedNamespace(n2, i18n, i18nOptions);
  });
  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
  }
  var _useState = useState(getT), _useState2 = _slicedToArray$3(_useState, 2), t2 = _useState2[0], setT = _useState2[1];
  var isMounted = useRef(true);
  useEffect(function() {
    var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;
    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function() {
        if (isMounted.current)
          setT(getT);
      });
    }
    function boundReset() {
      if (isMounted.current)
        setT(getT);
    }
    if (bindI18n && i18n)
      i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n)
      i18n.store.on(bindI18nStore, boundReset);
    return function() {
      isMounted.current = false;
      if (bindI18n && i18n)
        bindI18n.split(" ").forEach(function(e2) {
          return i18n.off(e2, boundReset);
        });
      if (bindI18nStore && i18n)
        bindI18nStore.split(" ").forEach(function(e2) {
          return i18n.store.off(e2, boundReset);
        });
    };
  }, [i18n, namespaces.join()]);
  var isInitial = useRef(true);
  useEffect(function() {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }
    isInitial.current = false;
  }, [i18n]);
  var ret = [t2, i18n, ready];
  ret.t = t2;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready)
    return ret;
  if (!ready && !useSuspense)
    return ret;
  throw new Promise(function(resolve) {
    loadNamespaces(i18n, namespaces, function() {
      resolve();
    });
  });
}
function I18nextProvider(_ref3) {
  var i18n = _ref3.i18n, defaultNS = _ref3.defaultNS, children2 = _ref3.children;
  var value = useMemo(function() {
    return {
      i18n,
      defaultNS
    };
  }, [i18n, defaultNS]);
  return createElement(I18nContext.Provider, {
    value
  }, children2);
}
function AdminModeWarningPopup(props) {
  const {
    t: t2
  } = useTranslation();
  const {
    onClose,
    isOpen,
    onSubmit
  } = props;
  return /* @__PURE__ */ jsx$1(Modal, {
    size: "medium",
    onClose,
    isOpen,
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-pb-6 tw-w-full tw-h-fit desktop:tw-p-6",
      children: [/* @__PURE__ */ jsx$1("div", {
        className: "tw-flex tw-justify-center tw-w-full",
        children: /* @__PURE__ */ jsx$1(Icon, {
          className: "tw-text-Orange",
          size: IconSize.CUSTOM,
          width: 48,
          height: 48,
          name: IconName.CIRCLE_EXCLAMTION_SOLID
        })
      }), /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-py-6 tw-text-center",
        variant: "title-2",
        color: COLORS.Gray[800],
        children: t2("facebookLive.adminModeWarningPopup.title")
      }), /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-text-center",
        variant: "title-8",
        color: COLORS.Gray[800],
        children: t2("facebookLive.adminModeWarningPopup.subtitle")
      }), /* @__PURE__ */ jsx$1("img", {
        src: ENABLE_CONTINUE_SHOPPING,
        alt: "enable continue shopping",
        className: "tw-mx-auto tw-w-[383px] tw-h-[110px]"
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-3",
        color: COLORS.Gray[500],
        className: "tw-text-center",
        children: t2("facebookLive.adminModeWarningPopup.description")
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-justify-between tw-mt-10",
        children: [/* @__PURE__ */ jsx$1(Button, {
          size: "large",
          variant: "text",
          className: "tw-w-full tw-text-Primary-600",
          onClick: onClose,
          children: t2("facebookLive.adminModeWarningPopup.cancel")
        }), /* @__PURE__ */ jsx$1("div", {
          className: "tw-w-8"
        }), /* @__PURE__ */ jsx$1(Button, {
          size: "large",
          variant: "primary",
          className: "tw-w-full tw-bg-Primary-600",
          onClick: onSubmit,
          children: t2("facebookLive.adminModeWarningPopup.confirm")
        })]
      })]
    })
  });
}
const Status = ({
  label,
  color = "bg-Gray-400"
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "tw-inline-flex tw-items-center",
    children: [/* @__PURE__ */ jsx$1("div", {
      className: `tw-inline-block tw-h-1.5 tw-w-1.5 tw-rounded-full tw-${color}`
    }), /* @__PURE__ */ jsx$1(Typography, {
      variant: "body-3",
      className: "tw-ml-2",
      children: label
    })]
  });
};
const StepperBar = ({
  currentStep = 0,
  maxStep = 4
}) => {
  const renderSteppers = () => {
    const steppers = [];
    for (let index2 = 0; index2 < maxStep; index2 += 1) {
      steppers.push(/* @__PURE__ */ jsx$1("div", {
        className: `tw-h-2 tw-flex-1 tw-mr-3 tw-rounded-full last:tw-mr-0 ${index2 < currentStep ? "tw-bg-Primary-600" : "tw-bg-NudePrimary"}`
      }));
    }
    return steppers;
  };
  return /* @__PURE__ */ jsx$1("div", {
    className: "tw-flex tw-w-full",
    children: renderSteppers()
  });
};
function CardDeeplePayContactSupport({
  isNewShop = true,
  isRounded = false
}) {
  const {
    t: t2
  } = useTranslation();
  const backDropStyle = {
    backgroundColor: "rgba(182, 186, 200, 0.3)"
  };
  return /* @__PURE__ */ jsx$1("div", {
    className: classNames$1("tw-absolute tw-top-0 tw-right-0 tw-bottom-0 tw-left-0 tw-flex tw-justify-center tw-items-center tw-p-6", {
      "tw-rounded-lg": isRounded
    }),
    style: backDropStyle,
    children: /* @__PURE__ */ jsxs("article", {
      className: "tw-p-8 tw-max-w-[515px] tw-bg-White tw-rounded-lg",
      children: [/* @__PURE__ */ jsx$1("h3", {
        className: "tw-text-[28px] tw-font-medium tw-leading-10 tw-text-center tw-text-Gray-800",
        dangerouslySetInnerHTML: {
          __html: t2(isNewShop ? "payment.contactCustomerSupport.title.newShop" : "payment.contactCustomerSupport.title.oldShop")
        }
      }), /* @__PURE__ */ jsx$1("p", {
        className: "tw-mt-6 tw-text-sm tw-font-normal tw-text-center tw-text-Gray-500",
        children: t2("payment.contactCustomerSupport.description")
      })]
    })
  });
}
const Alert = ({
  children: children2,
  type = "quickstart",
  Icon: Icon2,
  Action
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: classNames$1("tw-box-border tw-flex tw-p-[10px] tw-w-full tw-rounded-lg tw-border", {
      "tw-bg-LightNudePrimary tw-border-Primary-600": type === "quickstart",
      "tw-bg-NudeOrange tw-border-Orange": type === "warning",
      "tw-bg-NudeDarkBlue tw-border-DarkBlue": type === "information"
    }),
    children: [Icon2 && /* @__PURE__ */ jsx$1("div", {
      className: "tw-flex-none tw-mr-4",
      children: /* @__PURE__ */ jsx$1(Icon2, {})
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-flex-wrap mobile:tw-flex-auto",
      children: [/* @__PURE__ */ jsx$1("div", {
        className: "tw-flex-auto",
        children: children2
      }), Action && /* @__PURE__ */ jsx$1("div", {
        className: "tw-flex-auto tw-mt-2 tw-mb-auto mobile:tw-flex-none tablet:tw-mt-auto tablet:tw-ml-4",
        children: /* @__PURE__ */ jsx$1(Action, {})
      })]
    })]
  });
};
Alert.displayName = "Alert";
function FacebookLiveAlert(props) {
  const {
    onClick: onClick2
  } = props;
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(Alert, {
    type: "information",
    Icon: () => /* @__PURE__ */ jsx$1(Icon, {
      name: IconName.INFORMATION_CIRCLE,
      className: "tw-text-DarkBlue"
    }),
    children: [/* @__PURE__ */ jsx$1(Typography, {
      variant: "title-9",
      color: COLORS.Gray[800],
      children: t2("facebookLive.alert.title")
    }), /* @__PURE__ */ jsxs("ul", {
      children: [/* @__PURE__ */ jsx$1("li", {
        children: /* @__PURE__ */ jsxs(Typography, {
          variant: "body-3",
          className: "tw-mt-2",
          color: COLORS.Gray[500],
          children: ["1. ", t2("facebookLive.alert.1")]
        })
      }), /* @__PURE__ */ jsx$1("li", {
        children: /* @__PURE__ */ jsxs(Typography, {
          variant: "body-3",
          color: COLORS.Gray[500],
          children: ["2. ", t2("facebookLive.alert.2")]
        })
      }), /* @__PURE__ */ jsx$1("li", {
        children: /* @__PURE__ */ jsxs(Typography, {
          variant: "body-3",
          color: COLORS.Gray[500],
          children: ["3. ", t2("facebookLive.alert.3")]
        })
      })]
    }), /* @__PURE__ */ jsx$1(Button, {
      variant: "text",
      onClick: onClick2,
      className: "tw-mt-2",
      children: t2("facebookLive.alert.btn")
    })]
  });
}
var DEVICE;
(function(DEVICE2) {
  DEVICE2["MOBILE"] = "MOBILE";
  DEVICE2["TABLET"] = "TABLET";
  DEVICE2["DESKTOP"] = "DESKTOP";
  DEVICE2["FULLSCREEN"] = "FULLSCREEN";
})(DEVICE || (DEVICE = {}));
var useDevice = () => {
  const queries = ["767px", "1023px", "1439px"];
  const devices = [DEVICE.MOBILE, DEVICE.TABLET, DEVICE.DESKTOP];
  const mediaQueryLists = queries.map((query) => window.matchMedia(`(max-width: ${query})`));
  const getValue2 = () => {
    const index2 = mediaQueryLists.findIndex((mql) => mql.matches);
    return typeof devices[index2] !== "undefined" ? devices[index2] : DEVICE.FULLSCREEN;
  };
  const [value, setValue] = useState(getValue2);
  useEffect(() => {
    const handler = () => setValue(getValue2);
    mediaQueryLists.forEach((mql) => mql.addListener(handler));
    return () => mediaQueryLists.forEach((mql) => mql.removeListener(handler));
  }, []);
  return {
    device: value,
    isMobile: value === DEVICE.MOBILE,
    isTablet: value === DEVICE.TABLET,
    isDesktop: value === DEVICE.DESKTOP,
    isFullScreen: value === DEVICE.FULLSCREEN
  };
};
var PaymentType;
(function(PaymentType2) {
  PaymentType2["DeeplePay"] = "DeeplePay";
  PaymentType2["BankTransfer"] = "BankTransfer";
})(PaymentType || (PaymentType = {}));
function ModalPaymentPreview({
  isOpen,
  type,
  lang = "th",
  onClose
}) {
  const {
    t: t2,
    i18n
  } = useTranslation();
  const {
    isFullScreen
  } = useDevice();
  const isDeeplePay = type === PaymentType.DeeplePay;
  useEffect(() => {
    void i18n.changeLanguage(lang);
  }, [lang, i18n]);
  return /* @__PURE__ */ jsx$1(Modal, {
    isOpen,
    size: isFullScreen ? "medium" : "small",
    onClose,
    isClickOverlayToClose: false,
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-flex-col tw-justify-center tw-p-6",
      children: [/* @__PURE__ */ jsx$1("img", {
        src: isDeeplePay ? DEEPLE_PAY_GUIDELINE : BANK_TRANSFER_GUIDELINE,
        className: "tw-mx-auto tw-w-[245px] tw-h-auto",
        alt: "Deeple pay guideline"
      }), /* @__PURE__ */ jsx$1("p", {
        className: "tw-mt-6 tw-mb-10 tw-text-sm tw-font-normal tw-text-center tw-text-Gray-500",
        children: t2(isDeeplePay ? "payment.deeplePayGuideline" : "payment.bankTransferGuideline")
      }), /* @__PURE__ */ jsx$1(Button, {
        size: "fullWidth",
        onClick: onClose,
        children: t2("common.modal.close")
      })]
    })
  });
}
var autoplay_min = "";
var swiper_min = "";
function isObject$b(obj) {
  return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function extend$3(target = {}, src2 = {}) {
  Object.keys(src2).forEach((key) => {
    if (typeof target[key] === "undefined")
      target[key] = src2[key];
    else if (isObject$b(src2[key]) && isObject$b(target[key]) && Object.keys(src2[key]).length > 0) {
      extend$3(target[key], src2[key]);
    }
  });
}
const ssrDocument = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function getDocument() {
  const doc = typeof document !== "undefined" ? document : {};
  extend$3(doc, ssrDocument);
  return doc;
}
const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(callback) {
    if (typeof setTimeout === "undefined") {
      callback();
      return null;
    }
    return setTimeout(callback, 0);
  },
  cancelAnimationFrame(id2) {
    if (typeof setTimeout === "undefined") {
      return;
    }
    clearTimeout(id2);
  }
};
function getWindow$1() {
  const win = typeof window !== "undefined" ? window : {};
  extend$3(win, ssrWindow);
  return win;
}
function makeReactive(obj) {
  const proto = obj.__proto__;
  Object.defineProperty(obj, "__proto__", {
    get() {
      return proto;
    },
    set(value) {
      proto.__proto__ = value;
    }
  });
}
class Dom7 extends Array {
  constructor(items) {
    if (typeof items === "number") {
      super(items);
    } else {
      super(...items || []);
      makeReactive(this);
    }
  }
}
function arrayFlat(arr = []) {
  const res = [];
  arr.forEach((el) => {
    if (Array.isArray(el)) {
      res.push(...arrayFlat(el));
    } else {
      res.push(el);
    }
  });
  return res;
}
function arrayFilter$2(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
  const uniqueArray = [];
  for (let i2 = 0; i2 < arr.length; i2 += 1) {
    if (uniqueArray.indexOf(arr[i2]) === -1)
      uniqueArray.push(arr[i2]);
  }
  return uniqueArray;
}
function qsa(selector, context) {
  if (typeof selector !== "string") {
    return [selector];
  }
  const a2 = [];
  const res = context.querySelectorAll(selector);
  for (let i2 = 0; i2 < res.length; i2 += 1) {
    a2.push(res[i2]);
  }
  return a2;
}
function $(selector, context) {
  const window2 = getWindow$1();
  const document2 = getDocument();
  let arr = [];
  if (!context && selector instanceof Dom7) {
    return selector;
  }
  if (!selector) {
    return new Dom7(arr);
  }
  if (typeof selector === "string") {
    const html2 = selector.trim();
    if (html2.indexOf("<") >= 0 && html2.indexOf(">") >= 0) {
      let toCreate = "div";
      if (html2.indexOf("<li") === 0)
        toCreate = "ul";
      if (html2.indexOf("<tr") === 0)
        toCreate = "tbody";
      if (html2.indexOf("<td") === 0 || html2.indexOf("<th") === 0)
        toCreate = "tr";
      if (html2.indexOf("<tbody") === 0)
        toCreate = "table";
      if (html2.indexOf("<option") === 0)
        toCreate = "select";
      const tempParent = document2.createElement(toCreate);
      tempParent.innerHTML = html2;
      for (let i2 = 0; i2 < tempParent.childNodes.length; i2 += 1) {
        arr.push(tempParent.childNodes[i2]);
      }
    } else {
      arr = qsa(selector.trim(), context || document2);
    }
  } else if (selector.nodeType || selector === window2 || selector === document2) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7)
      return selector;
    arr = selector;
  }
  return new Dom7(arrayUnique(arr));
}
$.fn = Dom7.prototype;
function addClass(...classes2) {
  const classNames2 = arrayFlat(classes2.map((c2) => c2.split(" ")));
  this.forEach((el) => {
    el.classList.add(...classNames2);
  });
  return this;
}
function removeClass(...classes2) {
  const classNames2 = arrayFlat(classes2.map((c2) => c2.split(" ")));
  this.forEach((el) => {
    el.classList.remove(...classNames2);
  });
  return this;
}
function toggleClass(...classes2) {
  const classNames2 = arrayFlat(classes2.map((c2) => c2.split(" ")));
  this.forEach((el) => {
    classNames2.forEach((className) => {
      el.classList.toggle(className);
    });
  });
}
function hasClass(...classes2) {
  const classNames2 = arrayFlat(classes2.map((c2) => c2.split(" ")));
  return arrayFilter$2(this, (el) => {
    return classNames2.filter((className) => el.classList.contains(className)).length > 0;
  }).length > 0;
}
function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === "string") {
    if (this[0])
      return this[0].getAttribute(attrs);
    return void 0;
  }
  for (let i2 = 0; i2 < this.length; i2 += 1) {
    if (arguments.length === 2) {
      this[i2].setAttribute(attrs, value);
    } else {
      for (const attrName in attrs) {
        this[i2][attrName] = attrs[attrName];
        this[i2].setAttribute(attrName, attrs[attrName]);
      }
    }
  }
  return this;
}
function removeAttr(attr2) {
  for (let i2 = 0; i2 < this.length; i2 += 1) {
    this[i2].removeAttribute(attr2);
  }
  return this;
}
function transform(transform2) {
  for (let i2 = 0; i2 < this.length; i2 += 1) {
    this[i2].style.transform = transform2;
  }
  return this;
}
function transition$1(duration) {
  for (let i2 = 0; i2 < this.length; i2 += 1) {
    this[i2].style.transitionDuration = typeof duration !== "string" ? `${duration}ms` : duration;
  }
  return this;
}
function on(...args) {
  let [eventType, targetSelector, listener, capture] = args;
  if (typeof args[1] === "function") {
    [eventType, listener, capture] = args;
    targetSelector = void 0;
  }
  if (!capture)
    capture = false;
  function handleLiveEvent(e2) {
    const target = e2.target;
    if (!target)
      return;
    const eventData = e2.target.dom7EventData || [];
    if (eventData.indexOf(e2) < 0) {
      eventData.unshift(e2);
    }
    if ($(target).is(targetSelector))
      listener.apply(target, eventData);
    else {
      const parents2 = $(target).parents();
      for (let k2 = 0; k2 < parents2.length; k2 += 1) {
        if ($(parents2[k2]).is(targetSelector))
          listener.apply(parents2[k2], eventData);
      }
    }
  }
  function handleEvent(e2) {
    const eventData = e2 && e2.target ? e2.target.dom7EventData || [] : [];
    if (eventData.indexOf(e2) < 0) {
      eventData.unshift(e2);
    }
    listener.apply(this, eventData);
  }
  const events2 = eventType.split(" ");
  let j;
  for (let i2 = 0; i2 < this.length; i2 += 1) {
    const el = this[i2];
    if (!targetSelector) {
      for (j = 0; j < events2.length; j += 1) {
        const event = events2[j];
        if (!el.dom7Listeners)
          el.dom7Listeners = {};
        if (!el.dom7Listeners[event])
          el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      for (j = 0; j < events2.length; j += 1) {
        const event = events2[j];
        if (!el.dom7LiveListeners)
          el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[event])
          el.dom7LiveListeners[event] = [];
        el.dom7LiveListeners[event].push({
          listener,
          proxyListener: handleLiveEvent
        });
        el.addEventListener(event, handleLiveEvent, capture);
      }
    }
  }
  return this;
}
function off(...args) {
  let [eventType, targetSelector, listener, capture] = args;
  if (typeof args[1] === "function") {
    [eventType, listener, capture] = args;
    targetSelector = void 0;
  }
  if (!capture)
    capture = false;
  const events2 = eventType.split(" ");
  for (let i2 = 0; i2 < events2.length; i2 += 1) {
    const event = events2[i2];
    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];
      let handlers;
      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }
      if (handlers && handlers.length) {
        for (let k2 = handlers.length - 1; k2 >= 0; k2 -= 1) {
          const handler = handlers[k2];
          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k2, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k2, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k2, 1);
          }
        }
      }
    }
  }
  return this;
}
function trigger(...args) {
  const window2 = getWindow$1();
  const events2 = args[0].split(" ");
  const eventData = args[1];
  for (let i2 = 0; i2 < events2.length; i2 += 1) {
    const event = events2[i2];
    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];
      if (window2.CustomEvent) {
        const evt = new window2.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
        el.dom7EventData = args.filter((data2, dataIndex) => dataIndex > 0);
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
  }
  return this;
}
function transitionEnd$1(callback) {
  const dom = this;
  function fireCallBack(e2) {
    if (e2.target !== this)
      return;
    callback.call(this, e2);
    dom.off("transitionend", fireCallBack);
  }
  if (callback) {
    dom.on("transitionend", fireCallBack);
  }
  return this;
}
function outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      const styles2 = this.styles();
      return this[0].offsetWidth + parseFloat(styles2.getPropertyValue("margin-right")) + parseFloat(styles2.getPropertyValue("margin-left"));
    }
    return this[0].offsetWidth;
  }
  return null;
}
function outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      const styles2 = this.styles();
      return this[0].offsetHeight + parseFloat(styles2.getPropertyValue("margin-top")) + parseFloat(styles2.getPropertyValue("margin-bottom"));
    }
    return this[0].offsetHeight;
  }
  return null;
}
function offset$2() {
  if (this.length > 0) {
    const window2 = getWindow$1();
    const document2 = getDocument();
    const el = this[0];
    const box = el.getBoundingClientRect();
    const body = document2.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window2 ? window2.scrollY : el.scrollTop;
    const scrollLeft = el === window2 ? window2.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }
  return null;
}
function styles() {
  const window2 = getWindow$1();
  if (this[0])
    return window2.getComputedStyle(this[0], null);
  return {};
}
function css$3(props, value) {
  const window2 = getWindow$1();
  let i2;
  if (arguments.length === 1) {
    if (typeof props === "string") {
      if (this[0])
        return window2.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      for (i2 = 0; i2 < this.length; i2 += 1) {
        for (const prop in props) {
          this[i2].style[prop] = props[prop];
        }
      }
      return this;
    }
  }
  if (arguments.length === 2 && typeof props === "string") {
    for (i2 = 0; i2 < this.length; i2 += 1) {
      this[i2].style[props] = value;
    }
    return this;
  }
  return this;
}
function each(callback) {
  if (!callback)
    return this;
  this.forEach((el, index2) => {
    callback.apply(el, [el, index2]);
  });
  return this;
}
function filter(callback) {
  const result = arrayFilter$2(this, callback);
  return $(result);
}
function html(html2) {
  if (typeof html2 === "undefined") {
    return this[0] ? this[0].innerHTML : null;
  }
  for (let i2 = 0; i2 < this.length; i2 += 1) {
    this[i2].innerHTML = html2;
  }
  return this;
}
function text(text2) {
  if (typeof text2 === "undefined") {
    return this[0] ? this[0].textContent.trim() : null;
  }
  for (let i2 = 0; i2 < this.length; i2 += 1) {
    this[i2].textContent = text2;
  }
  return this;
}
function is(selector) {
  const window2 = getWindow$1();
  const document2 = getDocument();
  const el = this[0];
  let compareWith;
  let i2;
  if (!el || typeof selector === "undefined")
    return false;
  if (typeof selector === "string") {
    if (el.matches)
      return el.matches(selector);
    if (el.webkitMatchesSelector)
      return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector)
      return el.msMatchesSelector(selector);
    compareWith = $(selector);
    for (i2 = 0; i2 < compareWith.length; i2 += 1) {
      if (compareWith[i2] === el)
        return true;
    }
    return false;
  }
  if (selector === document2) {
    return el === document2;
  }
  if (selector === window2) {
    return el === window2;
  }
  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;
    for (i2 = 0; i2 < compareWith.length; i2 += 1) {
      if (compareWith[i2] === el)
        return true;
    }
    return false;
  }
  return false;
}
function index$1() {
  let child = this[0];
  let i2;
  if (child) {
    i2 = 0;
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1)
        i2 += 1;
    }
    return i2;
  }
  return void 0;
}
function eq$4(index2) {
  if (typeof index2 === "undefined")
    return this;
  const length2 = this.length;
  if (index2 > length2 - 1) {
    return $([]);
  }
  if (index2 < 0) {
    const returnIndex = length2 + index2;
    if (returnIndex < 0)
      return $([]);
    return $([this[returnIndex]]);
  }
  return $([this[index2]]);
}
function append$1(...els) {
  let newChild;
  const document2 = getDocument();
  for (let k2 = 0; k2 < els.length; k2 += 1) {
    newChild = els[k2];
    for (let i2 = 0; i2 < this.length; i2 += 1) {
      if (typeof newChild === "string") {
        const tempDiv = document2.createElement("div");
        tempDiv.innerHTML = newChild;
        while (tempDiv.firstChild) {
          this[i2].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (let j = 0; j < newChild.length; j += 1) {
          this[i2].appendChild(newChild[j]);
        }
      } else {
        this[i2].appendChild(newChild);
      }
    }
  }
  return this;
}
function prepend(newChild) {
  const document2 = getDocument();
  let i2;
  let j;
  for (i2 = 0; i2 < this.length; i2 += 1) {
    if (typeof newChild === "string") {
      const tempDiv = document2.createElement("div");
      tempDiv.innerHTML = newChild;
      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i2].insertBefore(tempDiv.childNodes[j], this[i2].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i2].insertBefore(newChild[j], this[i2].childNodes[0]);
      }
    } else {
      this[i2].insertBefore(newChild, this[i2].childNodes[0]);
    }
  }
  return this;
}
function next$1(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return $([this[0].nextElementSibling]);
      }
      return $([]);
    }
    if (this[0].nextElementSibling)
      return $([this[0].nextElementSibling]);
    return $([]);
  }
  return $([]);
}
function nextAll(selector) {
  const nextEls = [];
  let el = this[0];
  if (!el)
    return $([]);
  while (el.nextElementSibling) {
    const next2 = el.nextElementSibling;
    if (selector) {
      if ($(next2).is(selector))
        nextEls.push(next2);
    } else
      nextEls.push(next2);
    el = next2;
  }
  return $(nextEls);
}
function prev$1(selector) {
  if (this.length > 0) {
    const el = this[0];
    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return $([el.previousElementSibling]);
      }
      return $([]);
    }
    if (el.previousElementSibling)
      return $([el.previousElementSibling]);
    return $([]);
  }
  return $([]);
}
function prevAll(selector) {
  const prevEls = [];
  let el = this[0];
  if (!el)
    return $([]);
  while (el.previousElementSibling) {
    const prev2 = el.previousElementSibling;
    if (selector) {
      if ($(prev2).is(selector))
        prevEls.push(prev2);
    } else
      prevEls.push(prev2);
    el = prev2;
  }
  return $(prevEls);
}
function parent(selector) {
  const parents2 = [];
  for (let i2 = 0; i2 < this.length; i2 += 1) {
    if (this[i2].parentNode !== null) {
      if (selector) {
        if ($(this[i2].parentNode).is(selector))
          parents2.push(this[i2].parentNode);
      } else {
        parents2.push(this[i2].parentNode);
      }
    }
  }
  return $(parents2);
}
function parents(selector) {
  const parents2 = [];
  for (let i2 = 0; i2 < this.length; i2 += 1) {
    let parent2 = this[i2].parentNode;
    while (parent2) {
      if (selector) {
        if ($(parent2).is(selector))
          parents2.push(parent2);
      } else {
        parents2.push(parent2);
      }
      parent2 = parent2.parentNode;
    }
  }
  return $(parents2);
}
function closest(selector) {
  let closest2 = this;
  if (typeof selector === "undefined") {
    return $([]);
  }
  if (!closest2.is(selector)) {
    closest2 = closest2.parents(selector).eq(0);
  }
  return closest2;
}
function find(selector) {
  const foundElements = [];
  for (let i2 = 0; i2 < this.length; i2 += 1) {
    const found = this[i2].querySelectorAll(selector);
    for (let j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }
  return $(foundElements);
}
function children(selector) {
  const children2 = [];
  for (let i2 = 0; i2 < this.length; i2 += 1) {
    const childNodes = this[i2].children;
    for (let j = 0; j < childNodes.length; j += 1) {
      if (!selector || $(childNodes[j]).is(selector)) {
        children2.push(childNodes[j]);
      }
    }
  }
  return $(children2);
}
function remove$1() {
  for (let i2 = 0; i2 < this.length; i2 += 1) {
    if (this[i2].parentNode)
      this[i2].parentNode.removeChild(this[i2]);
  }
  return this;
}
const Methods = {
  addClass,
  removeClass,
  hasClass,
  toggleClass,
  attr,
  removeAttr,
  transform,
  transition: transition$1,
  on,
  off,
  trigger,
  transitionEnd: transitionEnd$1,
  outerWidth,
  outerHeight,
  styles,
  offset: offset$2,
  css: css$3,
  each,
  html,
  text,
  is,
  index: index$1,
  eq: eq$4,
  append: append$1,
  prepend,
  next: next$1,
  nextAll,
  prev: prev$1,
  prevAll,
  parent,
  parents,
  closest,
  find,
  children,
  filter,
  remove: remove$1
};
Object.keys(Methods).forEach((methodName) => {
  Object.defineProperty($.fn, methodName, {
    value: Methods[methodName],
    writable: true
  });
});
function deleteProps(obj) {
  const object2 = obj;
  Object.keys(object2).forEach((key) => {
    try {
      object2[key] = null;
    } catch (e2) {
    }
    try {
      delete object2[key];
    } catch (e2) {
    }
  });
}
function nextTick(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }
  return setTimeout(callback, delay);
}
function now() {
  return Date.now();
}
function getComputedStyle$2(el) {
  const window2 = getWindow$1();
  let style;
  if (window2.getComputedStyle) {
    style = window2.getComputedStyle(el, null);
  }
  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }
  if (!style) {
    style = el.style;
  }
  return style;
}
function getTranslate(el, axis) {
  if (axis === void 0) {
    axis = "x";
  }
  const window2 = getWindow$1();
  let matrix;
  let curTransform;
  let transformMatrix;
  const curStyle = getComputedStyle$2(el);
  if (window2.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;
    if (curTransform.split(",").length > 6) {
      curTransform = curTransform.split(", ").map((a2) => a2.replace(",", ".")).join(", ");
    }
    transformMatrix = new window2.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
    matrix = transformMatrix.toString().split(",");
  }
  if (axis === "x") {
    if (window2.WebKitCSSMatrix)
      curTransform = transformMatrix.m41;
    else if (matrix.length === 16)
      curTransform = parseFloat(matrix[12]);
    else
      curTransform = parseFloat(matrix[4]);
  }
  if (axis === "y") {
    if (window2.WebKitCSSMatrix)
      curTransform = transformMatrix.m42;
    else if (matrix.length === 16)
      curTransform = parseFloat(matrix[13]);
    else
      curTransform = parseFloat(matrix[5]);
  }
  return curTransform || 0;
}
function isObject$a(o2) {
  return typeof o2 === "object" && o2 !== null && o2.constructor && Object.prototype.toString.call(o2).slice(8, -1) === "Object";
}
function isNode(node2) {
  if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") {
    return node2 instanceof HTMLElement;
  }
  return node2 && (node2.nodeType === 1 || node2.nodeType === 11);
}
function extend$2() {
  const to = Object(arguments.length <= 0 ? void 0 : arguments[0]);
  const noExtend = ["__proto__", "constructor", "prototype"];
  for (let i2 = 1; i2 < arguments.length; i2 += 1) {
    const nextSource = i2 < 0 || arguments.length <= i2 ? void 0 : arguments[i2];
    if (nextSource !== void 0 && nextSource !== null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter((key) => noExtend.indexOf(key) < 0);
      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
        if (desc !== void 0 && desc.enumerable) {
          if (isObject$a(to[nextKey]) && isObject$a(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$2(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject$a(to[nextKey]) && isObject$a(nextSource[nextKey])) {
            to[nextKey] = {};
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$2(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }
  return to;
}
function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll(_ref3) {
  let {
    swiper,
    targetPosition,
    side
  } = _ref3;
  const window2 = getWindow$1();
  const startPosition = -swiper.translate;
  let startTime = null;
  let time;
  const duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = "none";
  window2.cancelAnimationFrame(swiper.cssModeFrameID);
  const dir = targetPosition > startPosition ? "next" : "prev";
  const isOutOfBound = (current, target) => {
    return dir === "next" && current >= target || dir === "prev" && current <= target;
  };
  const animate = () => {
    time = new Date().getTime();
    if (startTime === null) {
      startTime = time;
    }
    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }
    swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    });
    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = "hidden";
      swiper.wrapperEl.style.scrollSnapType = "";
      setTimeout(() => {
        swiper.wrapperEl.style.overflow = "";
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window2.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }
    swiper.cssModeFrameID = window2.requestAnimationFrame(animate);
  };
  animate();
}
let support;
function calcSupport() {
  const window2 = getWindow$1();
  const document2 = getDocument();
  return {
    smoothScroll: document2.documentElement && "scrollBehavior" in document2.documentElement.style,
    touch: !!("ontouchstart" in window2 || window2.DocumentTouch && document2 instanceof window2.DocumentTouch),
    passiveListener: function checkPassiveListener() {
      let supportsPassive = false;
      try {
        const opts = Object.defineProperty({}, "passive", {
          get() {
            supportsPassive = true;
          }
        });
        window2.addEventListener("testPassiveListener", null, opts);
      } catch (e2) {
      }
      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return "ongesturestart" in window2;
    }()
  };
}
function getSupport() {
  if (!support) {
    support = calcSupport();
  }
  return support;
}
let deviceCached;
function calcDevice(_temp) {
  let {
    userAgent
  } = _temp === void 0 ? {} : _temp;
  const support2 = getSupport();
  const window2 = getWindow$1();
  const platform = window2.navigator.platform;
  const ua2 = userAgent || window2.navigator.userAgent;
  const device = {
    ios: false,
    android: false
  };
  const screenWidth = window2.screen.width;
  const screenHeight = window2.screen.height;
  const android = ua2.match(/(Android);?[\s\/]+([\d.]+)?/);
  let ipad = ua2.match(/(iPad).*OS\s([\d_]+)/);
  const ipod = ua2.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua2.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const windows = platform === "Win32";
  let macos = platform === "MacIntel";
  const iPadScreens = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  if (!ipad && macos && support2.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
    ipad = ua2.match(/(Version)\/([\d.]+)/);
    if (!ipad)
      ipad = [0, 1, "13_0_0"];
    macos = false;
  }
  if (android && !windows) {
    device.os = "android";
    device.android = true;
  }
  if (ipad || iphone || ipod) {
    device.os = "ios";
    device.ios = true;
  }
  return device;
}
function getDevice(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }
  return deviceCached;
}
let browser;
function calcBrowser() {
  const window2 = getWindow$1();
  function isSafari() {
    const ua2 = window2.navigator.userAgent.toLowerCase();
    return ua2.indexOf("safari") >= 0 && ua2.indexOf("chrome") < 0 && ua2.indexOf("android") < 0;
  }
  return {
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window2.navigator.userAgent)
  };
}
function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }
  return browser;
}
function Resize(_ref3) {
  let {
    swiper,
    on: on2,
    emit
  } = _ref3;
  const window2 = getWindow$1();
  let observer = null;
  let animationFrame = null;
  const resizeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized)
      return;
    emit("beforeResize");
    emit("resize");
  };
  const createObserver = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized)
      return;
    observer = new ResizeObserver((entries) => {
      animationFrame = window2.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries.forEach((_ref22) => {
          let {
            contentBoxSize,
            contentRect,
            target
          } = _ref22;
          if (target && target !== swiper.el)
            return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });
        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };
  const removeObserver = () => {
    if (animationFrame) {
      window2.cancelAnimationFrame(animationFrame);
    }
    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };
  const orientationChangeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized)
      return;
    emit("orientationchange");
  };
  on2("init", () => {
    if (swiper.params.resizeObserver && typeof window2.ResizeObserver !== "undefined") {
      createObserver();
      return;
    }
    window2.addEventListener("resize", resizeHandler);
    window2.addEventListener("orientationchange", orientationChangeHandler);
  });
  on2("destroy", () => {
    removeObserver();
    window2.removeEventListener("resize", resizeHandler);
    window2.removeEventListener("orientationchange", orientationChangeHandler);
  });
}
function Observer(_ref3) {
  let {
    swiper,
    extendParams,
    on: on2,
    emit
  } = _ref3;
  const observers = [];
  const window2 = getWindow$1();
  const attach = function(target, options2) {
    if (options2 === void 0) {
      options2 = {};
    }
    const ObserverFunc = window2.MutationObserver || window2.WebkitMutationObserver;
    const observer = new ObserverFunc((mutations) => {
      if (mutations.length === 1) {
        emit("observerUpdate", mutations[0]);
        return;
      }
      const observerUpdate = function observerUpdate2() {
        emit("observerUpdate", mutations[0]);
      };
      if (window2.requestAnimationFrame) {
        window2.requestAnimationFrame(observerUpdate);
      } else {
        window2.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options2.attributes === "undefined" ? true : options2.attributes,
      childList: typeof options2.childList === "undefined" ? true : options2.childList,
      characterData: typeof options2.characterData === "undefined" ? true : options2.characterData
    });
    observers.push(observer);
  };
  const init2 = () => {
    if (!swiper.params.observer)
      return;
    if (swiper.params.observeParents) {
      const containerParents = swiper.$el.parents();
      for (let i2 = 0; i2 < containerParents.length; i2 += 1) {
        attach(containerParents[i2]);
      }
    }
    attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    });
    attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  };
  const destroy = () => {
    observers.forEach((observer) => {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };
  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on2("init", init2);
  on2("destroy", destroy);
}
var eventsEmitter = {
  on(events2, handler, priority) {
    const self2 = this;
    if (typeof handler !== "function")
      return self2;
    const method = priority ? "unshift" : "push";
    events2.split(" ").forEach((event) => {
      if (!self2.eventsListeners[event])
        self2.eventsListeners[event] = [];
      self2.eventsListeners[event][method](handler);
    });
    return self2;
  },
  once(events2, handler, priority) {
    const self2 = this;
    if (typeof handler !== "function")
      return self2;
    function onceHandler() {
      self2.off(events2, onceHandler);
      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      handler.apply(self2, args);
    }
    onceHandler.__emitterProxy = handler;
    return self2.on(events2, onceHandler, priority);
  },
  onAny(handler, priority) {
    const self2 = this;
    if (typeof handler !== "function")
      return self2;
    const method = priority ? "unshift" : "push";
    if (self2.eventsAnyListeners.indexOf(handler) < 0) {
      self2.eventsAnyListeners[method](handler);
    }
    return self2;
  },
  offAny(handler) {
    const self2 = this;
    if (!self2.eventsAnyListeners)
      return self2;
    const index2 = self2.eventsAnyListeners.indexOf(handler);
    if (index2 >= 0) {
      self2.eventsAnyListeners.splice(index2, 1);
    }
    return self2;
  },
  off(events2, handler) {
    const self2 = this;
    if (!self2.eventsListeners)
      return self2;
    events2.split(" ").forEach((event) => {
      if (typeof handler === "undefined") {
        self2.eventsListeners[event] = [];
      } else if (self2.eventsListeners[event]) {
        self2.eventsListeners[event].forEach((eventHandler, index2) => {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self2.eventsListeners[event].splice(index2, 1);
          }
        });
      }
    });
    return self2;
  },
  emit() {
    const self2 = this;
    if (!self2.eventsListeners)
      return self2;
    let events2;
    let data2;
    let context;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    if (typeof args[0] === "string" || Array.isArray(args[0])) {
      events2 = args[0];
      data2 = args.slice(1, args.length);
      context = self2;
    } else {
      events2 = args[0].events;
      data2 = args[0].data;
      context = args[0].context || self2;
    }
    data2.unshift(context);
    const eventsArray = Array.isArray(events2) ? events2 : events2.split(" ");
    eventsArray.forEach((event) => {
      if (self2.eventsAnyListeners && self2.eventsAnyListeners.length) {
        self2.eventsAnyListeners.forEach((eventHandler) => {
          eventHandler.apply(context, [event, ...data2]);
        });
      }
      if (self2.eventsListeners && self2.eventsListeners[event]) {
        self2.eventsListeners[event].forEach((eventHandler) => {
          eventHandler.apply(context, data2);
        });
      }
    });
    return self2;
  }
};
function updateSize() {
  const swiper = this;
  let width;
  let height;
  const $el = swiper.$el;
  if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }
  if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }
  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  }
  width = width - parseInt($el.css("padding-left") || 0, 10) - parseInt($el.css("padding-right") || 0, 10);
  height = height - parseInt($el.css("padding-top") || 0, 10) - parseInt($el.css("padding-bottom") || 0, 10);
  if (Number.isNaN(width))
    width = 0;
  if (Number.isNaN(height))
    height = 0;
  Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  });
}
function updateSlides() {
  const swiper = this;
  function getDirectionLabel(property2) {
    if (swiper.isHorizontal()) {
      return property2;
    }
    return {
      "width": "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      "marginRight": "marginBottom"
    }[property2];
  }
  function getDirectionPropertyValue(node2, label) {
    return parseFloat(node2.getPropertyValue(getDirectionLabel(label)) || 0);
  }
  const params = swiper.params;
  const {
    $wrapperEl,
    size: swiperSize,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === "function") {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }
  let offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === "function") {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }
  const previousSnapGridLength = swiper.snapGrid.length;
  const previousSlidesGridLength = swiper.slidesGrid.length;
  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index2 = 0;
  if (typeof swiperSize === "undefined") {
    return;
  }
  if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
  }
  swiper.virtualSize = -spaceBetween;
  if (rtl)
    slides.css({
      marginLeft: "",
      marginBottom: "",
      marginTop: ""
    });
  else
    slides.css({
      marginRight: "",
      marginBottom: "",
      marginTop: ""
    });
  if (params.centeredSlides && params.cssMode) {
    setCSSProperty(swiper.wrapperEl, "--swiper-centered-offset-before", "");
    setCSSProperty(swiper.wrapperEl, "--swiper-centered-offset-after", "");
  }
  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
  if (gridEnabled) {
    swiper.grid.initSlides(slidesLength);
  }
  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key) => {
    return typeof params.breakpoints[key].slidesPerView !== "undefined";
  }).length > 0;
  for (let i2 = 0; i2 < slidesLength; i2 += 1) {
    slideSize = 0;
    const slide2 = slides.eq(i2);
    if (gridEnabled) {
      swiper.grid.updateSlide(i2, slide2, slidesLength, getDirectionLabel);
    }
    if (slide2.css("display") === "none")
      continue;
    if (params.slidesPerView === "auto") {
      if (shouldResetSlideSize) {
        slides[i2].style[getDirectionLabel("width")] = ``;
      }
      const slideStyles = getComputedStyle(slide2[0]);
      const currentTransform = slide2[0].style.transform;
      const currentWebKitTransform = slide2[0].style.webkitTransform;
      if (currentTransform) {
        slide2[0].style.transform = "none";
      }
      if (currentWebKitTransform) {
        slide2[0].style.webkitTransform = "none";
      }
      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? slide2.outerWidth(true) : slide2.outerHeight(true);
      } else {
        const width = getDirectionPropertyValue(slideStyles, "width");
        const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
        const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
        const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
        const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
        const boxSizing = slideStyles.getPropertyValue("box-sizing");
        if (boxSizing && boxSizing === "border-box") {
          slideSize = width + marginLeft + marginRight;
        } else {
          const {
            clientWidth,
            offsetWidth
          } = slide2[0];
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }
      if (currentTransform) {
        slide2[0].style.transform = currentTransform;
      }
      if (currentWebKitTransform) {
        slide2[0].style.webkitTransform = currentWebKitTransform;
      }
      if (params.roundLengths)
        slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths)
        slideSize = Math.floor(slideSize);
      if (slides[i2]) {
        slides[i2].style[getDirectionLabel("width")] = `${slideSize}px`;
      }
    }
    if (slides[i2]) {
      slides[i2].swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);
    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i2 !== 0)
        slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i2 === 0)
        slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1e3)
        slidePosition = 0;
      if (params.roundLengths)
        slidePosition = Math.floor(slidePosition);
      if (index2 % params.slidesPerGroup === 0)
        snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths)
        slidePosition = Math.floor(slidePosition);
      if ((index2 - Math.min(swiper.params.slidesPerGroupSkip, index2)) % swiper.params.slidesPerGroup === 0)
        snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }
    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index2 += 1;
  }
  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) {
    $wrapperEl.css({
      width: `${swiper.virtualSize + params.spaceBetween}px`
    });
  }
  if (params.setWrapperSize) {
    $wrapperEl.css({
      [getDirectionLabel("width")]: `${swiper.virtualSize + params.spaceBetween}px`
    });
  }
  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
  }
  if (!params.centeredSlides) {
    const newSlidesGrid = [];
    for (let i2 = 0; i2 < snapGrid.length; i2 += 1) {
      let slidesGridItem = snapGrid[i2];
      if (params.roundLengths)
        slidesGridItem = Math.floor(slidesGridItem);
      if (snapGrid[i2] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }
  if (snapGrid.length === 0)
    snapGrid = [0];
  if (params.spaceBetween !== 0) {
    const key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
    slides.filter((_23, slideIndex) => {
      if (!params.cssMode)
        return true;
      if (slideIndex === slides.length - 1) {
        return false;
      }
      return true;
    }).css({
      [key]: `${spaceBetween}px`
    });
  }
  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach((slideSizeValue) => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    const maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map((snap) => {
      if (snap < 0)
        return -offsetBefore;
      if (snap > maxSnap)
        return maxSnap + offsetAfter;
      return snap;
    });
  }
  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach((slideSizeValue) => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    if (allSlidesSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }
  Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });
  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    setCSSProperty(swiper.wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
    setCSSProperty(swiper.wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper.snapGrid[0];
    const addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map((v2) => v2 + addToSnapGrid);
    swiper.slidesGrid = swiper.slidesGrid.map((v2) => v2 + addToSlidesGrid);
  }
  if (slidesLength !== previousSlidesLength) {
    swiper.emit("slidesLengthChange");
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow)
      swiper.checkOverflow();
    swiper.emit("snapGridLengthChange");
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit("slidesGridLengthChange");
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
    const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);
    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded)
        swiper.$el.addClass(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.$el.removeClass(backFaceHiddenClass);
    }
  }
}
function updateAutoHeight(speed) {
  const swiper = this;
  const activeSlides = [];
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  let newHeight = 0;
  let i2;
  if (typeof speed === "number") {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }
  const getSlideByIndex = (index2) => {
    if (isVirtual) {
      return swiper.slides.filter((el) => parseInt(el.getAttribute("data-swiper-slide-index"), 10) === index2)[0];
    }
    return swiper.slides.eq(index2)[0];
  };
  if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      swiper.visibleSlides.each((slide2) => {
        activeSlides.push(slide2);
      });
    } else {
      for (i2 = 0; i2 < Math.ceil(swiper.params.slidesPerView); i2 += 1) {
        const index2 = swiper.activeIndex + i2;
        if (index2 > swiper.slides.length && !isVirtual)
          break;
        activeSlides.push(getSlideByIndex(index2));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  }
  for (i2 = 0; i2 < activeSlides.length; i2 += 1) {
    if (typeof activeSlides[i2] !== "undefined") {
      const height = activeSlides[i2].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  }
  if (newHeight || newHeight === 0)
    swiper.$wrapperEl.css("height", `${newHeight}px`);
}
function updateSlidesOffset() {
  const swiper = this;
  const slides = swiper.slides;
  for (let i2 = 0; i2 < slides.length; i2 += 1) {
    slides[i2].swiperSlideOffset = swiper.isHorizontal() ? slides[i2].offsetLeft : slides[i2].offsetTop;
  }
}
function updateSlidesProgress(translate2) {
  if (translate2 === void 0) {
    translate2 = this && this.translate || 0;
  }
  const swiper = this;
  const params = swiper.params;
  const {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0)
    return;
  if (typeof slides[0].swiperSlideOffset === "undefined")
    swiper.updateSlidesOffset();
  let offsetCenter = -translate2;
  if (rtl)
    offsetCenter = translate2;
  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];
  for (let i2 = 0; i2 < slides.length; i2 += 1) {
    const slide2 = slides[i2];
    let slideOffset = slide2.swiperSlideOffset;
    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }
    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + params.spaceBetween);
    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + params.spaceBetween);
    const slideBefore = -(offsetCenter - slideOffset);
    const slideAfter = slideBefore + swiper.slidesSizesGrid[i2];
    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
    if (isVisible) {
      swiper.visibleSlides.push(slide2);
      swiper.visibleSlidesIndexes.push(i2);
      slides.eq(i2).addClass(params.slideVisibleClass);
    }
    slide2.progress = rtl ? -slideProgress : slideProgress;
    slide2.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }
  swiper.visibleSlides = $(swiper.visibleSlides);
}
function updateProgress(translate2) {
  const swiper = this;
  if (typeof translate2 === "undefined") {
    const multiplier = swiper.rtlTranslate ? -1 : 1;
    translate2 = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }
  const params = swiper.params;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let {
    progress,
    isBeginning,
    isEnd
  } = swiper;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate2 - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }
  Object.assign(swiper, {
    progress,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight)
    swiper.updateSlidesProgress(translate2);
  if (isBeginning && !wasBeginning) {
    swiper.emit("reachBeginning toEdge");
  }
  if (isEnd && !wasEnd) {
    swiper.emit("reachEnd toEdge");
  }
  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit("fromEdge");
  }
  swiper.emit("progress", progress);
}
function updateSlidesClasses() {
  const swiper = this;
  const {
    slides,
    params,
    $wrapperEl,
    activeIndex,
    realIndex
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
  let activeSlide;
  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
  } else {
    activeSlide = slides.eq(activeIndex);
  }
  activeSlide.addClass(params.slideActiveClass);
  if (params.loop) {
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    }
  }
  let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  }
  let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }
  if (params.loop) {
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicateNextClass);
    }
    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicatePrevClass);
    }
  }
  swiper.emitSlidesClasses();
}
function updateActiveIndex(newActiveIndex) {
  const swiper = this;
  const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  const {
    slidesGrid,
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  let activeIndex = newActiveIndex;
  let snapIndex;
  if (typeof activeIndex === "undefined") {
    for (let i2 = 0; i2 < slidesGrid.length; i2 += 1) {
      if (typeof slidesGrid[i2 + 1] !== "undefined") {
        if (translate2 >= slidesGrid[i2] && translate2 < slidesGrid[i2 + 1] - (slidesGrid[i2 + 1] - slidesGrid[i2]) / 2) {
          activeIndex = i2;
        } else if (translate2 >= slidesGrid[i2] && translate2 < slidesGrid[i2 + 1]) {
          activeIndex = i2 + 1;
        }
      } else if (translate2 >= slidesGrid[i2]) {
        activeIndex = i2;
      }
    }
    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === "undefined")
        activeIndex = 0;
    }
  }
  if (snapGrid.indexOf(translate2) >= 0) {
    snapIndex = snapGrid.indexOf(translate2);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length)
    snapIndex = snapGrid.length - 1;
  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit("snapIndexChange");
    }
    return;
  }
  const realIndex = parseInt(swiper.slides.eq(activeIndex).attr("data-swiper-slide-index") || activeIndex, 10);
  Object.assign(swiper, {
    snapIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  swiper.emit("activeIndexChange");
  swiper.emit("snapIndexChange");
  if (previousRealIndex !== realIndex) {
    swiper.emit("realIndexChange");
  }
  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit("slideChange");
  }
}
function updateClickedSlide(e2) {
  const swiper = this;
  const params = swiper.params;
  const slide2 = $(e2).closest(`.${params.slideClass}`)[0];
  let slideFound = false;
  let slideIndex;
  if (slide2) {
    for (let i2 = 0; i2 < swiper.slides.length; i2 += 1) {
      if (swiper.slides[i2] === slide2) {
        slideFound = true;
        slideIndex = i2;
        break;
      }
    }
  }
  if (slide2 && slideFound) {
    swiper.clickedSlide = slide2;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt($(slide2).attr("data-swiper-slide-index"), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = void 0;
    swiper.clickedIndex = void 0;
    return;
  }
  if (params.slideToClickedSlide && swiper.clickedIndex !== void 0 && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}
var update = {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide
};
function getSwiperTranslate(axis) {
  if (axis === void 0) {
    axis = this.isHorizontal() ? "x" : "y";
  }
  const swiper = this;
  const {
    params,
    rtlTranslate: rtl,
    translate: translate2,
    $wrapperEl
  } = swiper;
  if (params.virtualTranslate) {
    return rtl ? -translate2 : translate2;
  }
  if (params.cssMode) {
    return translate2;
  }
  let currentTranslate = getTranslate($wrapperEl[0], axis);
  if (rtl)
    currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}
function setTranslate(translate2, byController) {
  const swiper = this;
  const {
    rtlTranslate: rtl,
    params,
    $wrapperEl,
    wrapperEl,
    progress
  } = swiper;
  let x2 = 0;
  let y2 = 0;
  const z2 = 0;
  if (swiper.isHorizontal()) {
    x2 = rtl ? -translate2 : translate2;
  } else {
    y2 = translate2;
  }
  if (params.roundLengths) {
    x2 = Math.floor(x2);
    y2 = Math.floor(y2);
  }
  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x2 : -y2;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform(`translate3d(${x2}px, ${y2}px, ${z2}px)`);
  }
  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x2 : y2;
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate2 - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== progress) {
    swiper.updateProgress(translate2);
  }
  swiper.emit("setTranslate", swiper.translate, byController);
}
function minTranslate() {
  return -this.snapGrid[0];
}
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function translateTo(translate2, speed, runCallbacks, translateBounds, internal) {
  if (translate2 === void 0) {
    translate2 = 0;
  }
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (translateBounds === void 0) {
    translateBounds = true;
  }
  const swiper = this;
  const {
    params,
    wrapperEl
  } = swiper;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  const minTranslate2 = swiper.minTranslate();
  const maxTranslate2 = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate2 > minTranslate2)
    newTranslate = minTranslate2;
  else if (translateBounds && translate2 < maxTranslate2)
    newTranslate = maxTranslate2;
  else
    newTranslate = translate2;
  swiper.updateProgress(newTranslate);
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    if (speed === 0) {
      wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? "left" : "top"
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? "left" : "top"]: -newTranslate,
        behavior: "smooth"
      });
    }
    return true;
  }
  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit("beforeTransitionStart", speed, internal);
      swiper.emit("transitionEnd");
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit("beforeTransitionStart", speed, internal);
      swiper.emit("transitionStart");
    }
    if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd2(e2) {
          if (!swiper || swiper.destroyed)
            return;
          if (e2.target !== this)
            return;
          swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;
          if (runCallbacks) {
            swiper.emit("transitionEnd");
          }
        };
      }
      swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
    }
  }
  return true;
}
var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo
};
function setTransition(duration, byController) {
  const swiper = this;
  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }
  swiper.emit("setTransition", duration, byController);
}
function transitionEmit(_ref3) {
  let {
    swiper,
    runCallbacks,
    direction,
    step
  } = _ref3;
  const {
    activeIndex,
    previousIndex
  } = swiper;
  let dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex)
      dir = "next";
    else if (activeIndex < previousIndex)
      dir = "prev";
    else
      dir = "reset";
  }
  swiper.emit(`transition${step}`);
  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === "reset") {
      swiper.emit(`slideResetTransition${step}`);
      return;
    }
    swiper.emit(`slideChangeTransition${step}`);
    if (dir === "next") {
      swiper.emit(`slideNextTransition${step}`);
    } else {
      swiper.emit(`slidePrevTransition${step}`);
    }
  }
}
function transitionStart(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params
  } = swiper;
  if (params.cssMode)
    return;
  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: "Start"
  });
}
function transitionEnd(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode)
    return;
  swiper.setTransition(0);
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: "End"
  });
}
var transition = {
  setTransition,
  transitionStart,
  transitionEnd
};
function slideTo(index2, speed, runCallbacks, internal, initial) {
  if (index2 === void 0) {
    index2 = 0;
  }
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (typeof index2 !== "number" && typeof index2 !== "string") {
    throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index2}] given.`);
  }
  if (typeof index2 === "string") {
    const indexAsNumber = parseInt(index2, 10);
    const isValidNumber = isFinite(indexAsNumber);
    if (!isValidNumber) {
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index2}] given.`);
    }
    index2 = indexAsNumber;
  }
  const swiper = this;
  let slideIndex = index2;
  if (slideIndex < 0)
    slideIndex = 0;
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;
  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }
  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length)
    snapIndex = snapGrid.length - 1;
  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
    swiper.emit("beforeSlideChangeStart");
  }
  const translate2 = -snapGrid[snapIndex];
  swiper.updateProgress(translate2);
  if (params.normalizeSlideIndex) {
    for (let i2 = 0; i2 < slidesGrid.length; i2 += 1) {
      const normalizedTranslate = -Math.floor(translate2 * 100);
      const normalizedGrid = Math.floor(slidesGrid[i2] * 100);
      const normalizedGridNext = Math.floor(slidesGrid[i2 + 1] * 100);
      if (typeof slidesGrid[i2 + 1] !== "undefined") {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i2;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i2 + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i2;
      }
    }
  }
  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate2 < swiper.translate && translate2 < swiper.minTranslate()) {
      return false;
    }
    if (!swiper.allowSlidePrev && translate2 > swiper.translate && translate2 > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex)
        return false;
    }
  }
  let direction;
  if (slideIndex > activeIndex)
    direction = "next";
  else if (slideIndex < activeIndex)
    direction = "prev";
  else
    direction = "reset";
  if (rtl && -translate2 === swiper.translate || !rtl && translate2 === swiper.translate) {
    swiper.updateActiveIndex(slideIndex);
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    swiper.updateSlidesClasses();
    if (params.effect !== "slide") {
      swiper.setTranslate(translate2);
    }
    if (direction !== "reset") {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }
    return false;
  }
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    const t2 = rtl ? translate2 : -translate2;
    if (speed === 0) {
      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = "none";
        swiper._immediateVirtual = true;
      }
      wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t2;
      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper.wrapperEl.style.scrollSnapType = "";
          swiper._swiperImmediateVirtual = false;
        });
      }
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: t2,
          side: isH ? "left" : "top"
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? "left" : "top"]: t2,
        behavior: "smooth"
      });
    }
    return true;
  }
  swiper.setTransition(speed);
  swiper.setTranslate(translate2);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit("beforeTransitionStart", speed, internal);
  swiper.transitionStart(runCallbacks, direction);
  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;
    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd2(e2) {
        if (!swiper || swiper.destroyed)
          return;
        if (e2.target !== this)
          return;
        swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }
    swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
  }
  return true;
}
function slideToLoop(index2, speed, runCallbacks, internal) {
  if (index2 === void 0) {
    index2 = 0;
  }
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  let newIndex = index2;
  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }
  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
function slideNext(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    animating,
    enabled,
    params
  } = swiper;
  if (!enabled)
    return swiper;
  let perGroup = params.slidesPerGroup;
  if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
  }
  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
  if (params.loop) {
    if (animating && params.loopPreventsSlide)
      return false;
    swiper.loopFix();
    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }
  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }
  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
function slidePrev(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params,
    animating,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled)
    return swiper;
  if (params.loop) {
    if (animating && params.loopPreventsSlide)
      return false;
    swiper.loopFix();
    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }
  const translate2 = rtlTranslate ? swiper.translate : -swiper.translate;
  function normalize2(val) {
    if (val < 0)
      return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  const normalizedTranslate = normalize2(translate2);
  const normalizedSnapGrid = snapGrid.map((val) => normalize2(val));
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  if (typeof prevSnap === "undefined" && params.cssMode) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        prevSnapIndex = snapIndex;
      }
    });
    if (typeof prevSnapIndex !== "undefined") {
      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }
  let prevIndex = 0;
  if (typeof prevSnap !== "undefined") {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0)
      prevIndex = swiper.activeIndex - 1;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }
  if (params.rewind && swiper.isBeginning) {
    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
function slideReset(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
function slideToClosest(speed, runCallbacks, internal, threshold) {
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (threshold === void 0) {
    threshold = 0.5;
  }
  const swiper = this;
  let index2 = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index2);
  const snapIndex = skip + Math.floor((index2 - skip) / swiper.params.slidesPerGroup);
  const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  if (translate2 >= swiper.snapGrid[snapIndex]) {
    const currentSnap = swiper.snapGrid[snapIndex];
    const nextSnap = swiper.snapGrid[snapIndex + 1];
    if (translate2 - currentSnap > (nextSnap - currentSnap) * threshold) {
      index2 += swiper.params.slidesPerGroup;
    }
  } else {
    const prevSnap = swiper.snapGrid[snapIndex - 1];
    const currentSnap = swiper.snapGrid[snapIndex];
    if (translate2 - prevSnap <= (currentSnap - prevSnap) * threshold) {
      index2 -= swiper.params.slidesPerGroup;
    }
  }
  index2 = Math.max(index2, 0);
  index2 = Math.min(index2, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index2, speed, runCallbacks, internal);
}
function slideToClickedSlide() {
  const swiper = this;
  const {
    params,
    $wrapperEl
  } = swiper;
  const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.clickedIndex;
  let realIndex;
  if (params.loop) {
    if (swiper.animating)
      return;
    realIndex = parseInt($(swiper.clickedSlide).attr("data-swiper-slide-index"), 10);
    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
        nextTick(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
      nextTick(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}
var slide = {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide
};
function loopCreate() {
  const swiper = this;
  const document2 = getDocument();
  const {
    params,
    $wrapperEl
  } = swiper;
  const $selector = $wrapperEl.children().length > 0 ? $($wrapperEl.children()[0].parentNode) : $wrapperEl;
  $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
  let slides = $selector.children(`.${params.slideClass}`);
  if (params.loopFillGroupWithBlank) {
    const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
    if (blankSlidesNum !== params.slidesPerGroup) {
      for (let i2 = 0; i2 < blankSlidesNum; i2 += 1) {
        const blankNode = $(document2.createElement("div")).addClass(`${params.slideClass} ${params.slideBlankClass}`);
        $selector.append(blankNode);
      }
      slides = $selector.children(`.${params.slideClass}`);
    }
  }
  if (params.slidesPerView === "auto" && !params.loopedSlides)
    params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;
  if (swiper.loopedSlides > slides.length) {
    swiper.loopedSlides = slides.length;
  }
  const prependSlides = [];
  const appendSlides = [];
  slides.each((el, index2) => {
    const slide2 = $(el);
    if (index2 < swiper.loopedSlides) {
      appendSlides.push(el);
    }
    if (index2 < slides.length && index2 >= slides.length - swiper.loopedSlides) {
      prependSlides.push(el);
    }
    slide2.attr("data-swiper-slide-index", index2);
  });
  for (let i2 = 0; i2 < appendSlides.length; i2 += 1) {
    $selector.append($(appendSlides[i2].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
  for (let i2 = prependSlides.length - 1; i2 >= 0; i2 -= 1) {
    $selector.prepend($(prependSlides[i2].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}
function loopFix() {
  const swiper = this;
  swiper.emit("beforeLoopFix");
  const {
    activeIndex,
    slides,
    loopedSlides,
    allowSlidePrev,
    allowSlideNext,
    snapGrid,
    rtlTranslate: rtl
  } = swiper;
  let newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  const snapTranslate = -snapGrid[activeIndex];
  const diff = snapTranslate - swiper.getTranslate();
  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    const slideChanged = swiper.slideTo(newIndex, 0, false, true);
    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;
    const slideChanged = swiper.slideTo(newIndex, 0, false, true);
    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit("loopFix");
}
function loopDestroy() {
  const swiper = this;
  const {
    $wrapperEl,
    params,
    slides
  } = swiper;
  $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
  slides.removeAttr("data-swiper-slide-index");
}
var loop = {
  loopCreate,
  loopFix,
  loopDestroy
};
function setGrabCursor(moving) {
  const swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode)
    return;
  const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
  el.style.cursor = "move";
  el.style.cursor = moving ? "-webkit-grabbing" : "-webkit-grab";
  el.style.cursor = moving ? "-moz-grabbin" : "-moz-grab";
  el.style.cursor = moving ? "grabbing" : "grab";
}
function unsetGrabCursor() {
  const swiper = this;
  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }
  swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
}
var grabCursor = {
  setGrabCursor,
  unsetGrabCursor
};
function closestElement(selector, base) {
  if (base === void 0) {
    base = this;
  }
  function __closestFrom(el) {
    if (!el || el === getDocument() || el === getWindow$1())
      return null;
    if (el.assignedSlot)
      el = el.assignedSlot;
    const found = el.closest(selector);
    return found || __closestFrom(el.getRootNode().host);
  }
  return __closestFrom(base);
}
function onTouchStart(event) {
  const swiper = this;
  const document2 = getDocument();
  const window2 = getWindow$1();
  const data2 = swiper.touchEventsData;
  const {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled)
    return;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }
  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }
  let e2 = event;
  if (e2.originalEvent)
    e2 = e2.originalEvent;
  let $targetEl = $(e2.target);
  if (params.touchEventsTarget === "wrapper") {
    if (!$targetEl.closest(swiper.wrapperEl).length)
      return;
  }
  data2.isTouchEvent = e2.type === "touchstart";
  if (!data2.isTouchEvent && "which" in e2 && e2.which === 3)
    return;
  if (!data2.isTouchEvent && "button" in e2 && e2.button > 0)
    return;
  if (data2.isTouched && data2.isMoved)
    return;
  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
  if (swipingClassHasValue && e2.target && e2.target.shadowRoot && event.path && event.path[0]) {
    $targetEl = $(event.path[0]);
  }
  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
  const isTargetShadow = !!(e2.target && e2.target.shadowRoot);
  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, e2.target) : $targetEl.closest(noSwipingSelector)[0])) {
    swiper.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0])
      return;
  }
  touches.currentX = e2.type === "touchstart" ? e2.targetTouches[0].pageX : e2.pageX;
  touches.currentY = e2.type === "touchstart" ? e2.targetTouches[0].pageY : e2.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY;
  const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window2.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === "prevent") {
      event.preventDefault();
    } else {
      return;
    }
  }
  Object.assign(data2, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: void 0,
    startMoving: void 0
  });
  touches.startX = startX;
  touches.startY = startY;
  data2.touchStartTime = now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = void 0;
  if (params.threshold > 0)
    data2.allowThresholdMove = false;
  if (e2.type !== "touchstart") {
    let preventDefault = true;
    if ($targetEl.is(data2.focusableElements)) {
      preventDefault = false;
      if ($targetEl[0].nodeName === "SELECT") {
        data2.isTouched = false;
      }
    }
    if (document2.activeElement && $(document2.activeElement).is(data2.focusableElements) && document2.activeElement !== $targetEl[0]) {
      document2.activeElement.blur();
    }
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
      e2.preventDefault();
    }
  }
  if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }
  swiper.emit("touchStart", e2);
}
function onTouchMove(event) {
  const document2 = getDocument();
  const swiper = this;
  const data2 = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled)
    return;
  let e2 = event;
  if (e2.originalEvent)
    e2 = e2.originalEvent;
  if (!data2.isTouched) {
    if (data2.startMoving && data2.isScrolling) {
      swiper.emit("touchMoveOpposite", e2);
    }
    return;
  }
  if (data2.isTouchEvent && e2.type !== "touchmove")
    return;
  const targetTouch = e2.type === "touchmove" && e2.targetTouches && (e2.targetTouches[0] || e2.changedTouches[0]);
  const pageX = e2.type === "touchmove" ? targetTouch.pageX : e2.pageX;
  const pageY = e2.type === "touchmove" ? targetTouch.pageY : e2.pageY;
  if (e2.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    if (!$(e2.target).is(data2.focusableElements)) {
      swiper.allowClick = false;
    }
    if (data2.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data2.touchStartTime = now();
    }
    return;
  }
  if (data2.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data2.isTouched = false;
        data2.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }
  if (data2.isTouchEvent && document2.activeElement) {
    if (e2.target === document2.activeElement && $(e2.target).is(data2.focusableElements)) {
      data2.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }
  if (data2.allowTouchCallbacks) {
    swiper.emit("touchMove", e2);
  }
  if (e2.targetTouches && e2.targetTouches.length > 1)
    return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold)
    return;
  if (typeof data2.isScrolling === "undefined") {
    let touchAngle;
    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data2.isScrolling = false;
    } else {
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data2.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }
  if (data2.isScrolling) {
    swiper.emit("touchMoveOpposite", e2);
  }
  if (typeof data2.startMoving === "undefined") {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data2.startMoving = true;
    }
  }
  if (data2.isScrolling) {
    data2.isTouched = false;
    return;
  }
  if (!data2.startMoving) {
    return;
  }
  swiper.allowClick = false;
  if (!params.cssMode && e2.cancelable) {
    e2.preventDefault();
  }
  if (params.touchMoveStopPropagation && !params.nested) {
    e2.stopPropagation();
  }
  if (!data2.isMoved) {
    if (params.loop && !params.cssMode) {
      swiper.loopFix();
    }
    data2.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);
    if (swiper.animating) {
      swiper.$wrapperEl.trigger("webkitTransitionEnd transitionend");
    }
    data2.allowMomentumBounce = false;
    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }
    swiper.emit("sliderFirstMove", e2);
  }
  swiper.emit("sliderMove", e2);
  data2.isMoved = true;
  let diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl)
    diff = -diff;
  swiper.swipeDirection = diff > 0 ? "prev" : "next";
  data2.currentTranslate = diff + data2.startTranslate;
  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if (diff > 0 && data2.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance)
      data2.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data2.startTranslate + diff) ** resistanceRatio;
  } else if (diff < 0 && data2.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance)
      data2.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data2.startTranslate - diff) ** resistanceRatio;
  }
  if (disableParentSwiper) {
    e2.preventedByNestedSwiper = true;
  }
  if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data2.currentTranslate < data2.startTranslate) {
    data2.currentTranslate = data2.startTranslate;
  }
  if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data2.currentTranslate > data2.startTranslate) {
    data2.currentTranslate = data2.startTranslate;
  }
  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data2.currentTranslate = data2.startTranslate;
  }
  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data2.allowThresholdMove) {
      if (!data2.allowThresholdMove) {
        data2.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data2.currentTranslate = data2.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data2.currentTranslate = data2.startTranslate;
      return;
    }
  }
  if (!params.followFinger || params.cssMode)
    return;
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  }
  swiper.updateProgress(data2.currentTranslate);
  swiper.setTranslate(data2.currentTranslate);
}
function onTouchEnd(event) {
  const swiper = this;
  const data2 = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled)
    return;
  let e2 = event;
  if (e2.originalEvent)
    e2 = e2.originalEvent;
  if (data2.allowTouchCallbacks) {
    swiper.emit("touchEnd", e2);
  }
  data2.allowTouchCallbacks = false;
  if (!data2.isTouched) {
    if (data2.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }
    data2.isMoved = false;
    data2.startMoving = false;
    return;
  }
  if (params.grabCursor && data2.isMoved && data2.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  }
  const touchEndTime = now();
  const timeDiff = touchEndTime - data2.touchStartTime;
  if (swiper.allowClick) {
    const pathTree = e2.path || e2.composedPath && e2.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e2.target);
    swiper.emit("tap click", e2);
    if (timeDiff < 300 && touchEndTime - data2.lastClickTime < 300) {
      swiper.emit("doubleTap doubleClick", e2);
    }
  }
  data2.lastClickTime = now();
  nextTick(() => {
    if (!swiper.destroyed)
      swiper.allowClick = true;
  });
  if (!data2.isTouched || !data2.isMoved || !swiper.swipeDirection || touches.diff === 0 || data2.currentTranslate === data2.startTranslate) {
    data2.isTouched = false;
    data2.isMoved = false;
    data2.startMoving = false;
    return;
  }
  data2.isTouched = false;
  data2.isMoved = false;
  data2.startMoving = false;
  let currentPos;
  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data2.currentTranslate;
  }
  if (params.cssMode) {
    return;
  }
  if (swiper.params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  }
  let stopIndex = 0;
  let groupSize = swiper.slidesSizesGrid[0];
  for (let i2 = 0; i2 < slidesGrid.length; i2 += i2 < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment2 = i2 < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (typeof slidesGrid[i2 + increment2] !== "undefined") {
      if (currentPos >= slidesGrid[i2] && currentPos < slidesGrid[i2 + increment2]) {
        stopIndex = i2;
        groupSize = slidesGrid[i2 + increment2] - slidesGrid[i2];
      }
    } else if (currentPos >= slidesGrid[i2]) {
      stopIndex = i2;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }
  let rewindFirstIndex = null;
  let rewindLastIndex = null;
  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  }
  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
  if (timeDiff > params.longSwipesMs) {
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === "next") {
      if (ratio >= params.longSwipesRatio)
        swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
      else
        swiper.slideTo(stopIndex);
    }
    if (swiper.swipeDirection === "prev") {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    const isNavButtonTarget = swiper.navigation && (e2.target === swiper.navigation.nextEl || e2.target === swiper.navigation.prevEl);
    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === "next") {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }
      if (swiper.swipeDirection === "prev") {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e2.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}
function onResize() {
  const swiper = this;
  const {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0)
    return;
  if (params.breakpoints) {
    swiper.setBreakpoint();
  }
  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper;
  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();
  if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }
  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}
function onClick(e2) {
  const swiper = this;
  if (!swiper.enabled)
    return;
  if (!swiper.allowClick) {
    if (swiper.params.preventClicks)
      e2.preventDefault();
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e2.stopPropagation();
      e2.stopImmediatePropagation();
    }
  }
}
function onScroll() {
  const swiper = this;
  const {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled)
    return;
  swiper.previousTranslate = swiper.translate;
  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  }
  if (swiper.translate === -0)
    swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }
  swiper.emit("setTranslate", swiper.translate, false);
}
let dummyEventAttached = false;
function dummyEventListener() {
}
const events = (swiper, method) => {
  const document2 = getDocument();
  const {
    params,
    touchEvents,
    el,
    wrapperEl,
    device,
    support: support2
  } = swiper;
  const capture = !!params.nested;
  const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
  const swiperMethod = method;
  if (!support2.touch) {
    el[domMethod](touchEvents.start, swiper.onTouchStart, false);
    document2[domMethod](touchEvents.move, swiper.onTouchMove, capture);
    document2[domMethod](touchEvents.end, swiper.onTouchEnd, false);
  } else {
    const passiveListener = touchEvents.start === "touchstart" && support2.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
    el[domMethod](touchEvents.move, swiper.onTouchMove, support2.passiveListener ? {
      passive: false,
      capture
    } : capture);
    el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
    if (touchEvents.cancel) {
      el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    }
  }
  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]("click", swiper.onClick, true);
  }
  if (params.cssMode) {
    wrapperEl[domMethod]("scroll", swiper.onScroll);
  }
  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize, true);
  } else {
    swiper[swiperMethod]("observerUpdate", onResize, true);
  }
};
function attachEvents() {
  const swiper = this;
  const document2 = getDocument();
  const {
    params,
    support: support2
  } = swiper;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);
  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }
  swiper.onClick = onClick.bind(swiper);
  if (support2.touch && !dummyEventAttached) {
    document2.addEventListener("touchstart", dummyEventListener);
    dummyEventAttached = true;
  }
  events(swiper, "on");
}
function detachEvents() {
  const swiper = this;
  events(swiper, "off");
}
var events$1 = {
  attachEvents,
  detachEvents
};
const isGridEnabled = (swiper, params) => {
  return swiper.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
  const swiper = this;
  const {
    activeIndex,
    initialized,
    loopedSlides = 0,
    params,
    $el
  } = swiper;
  const breakpoints2 = params.breakpoints;
  if (!breakpoints2 || breakpoints2 && Object.keys(breakpoints2).length === 0)
    return;
  const breakpoint = swiper.getBreakpoint(breakpoints2, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint)
    return;
  const breakpointOnlyParams = breakpoint in breakpoints2 ? breakpoints2[breakpoint] : void 0;
  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
  const wasMultiRow = isGridEnabled(swiper, params);
  const isMultiRow = isGridEnabled(swiper, breakpointParams);
  const wasEnabled = params.enabled;
  if (wasMultiRow && !isMultiRow) {
    $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    $el.addClass(`${params.containerModifierClass}grid`);
    if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") {
      $el.addClass(`${params.containerModifierClass}grid-column`);
    }
    swiper.emitContainerClasses();
  }
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
  if (directionChanged && initialized) {
    swiper.changeDirection();
  }
  extend$2(swiper.params, breakpointParams);
  const isEnabled = swiper.params.enabled;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });
  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }
  swiper.currentBreakpoint = breakpoint;
  swiper.emit("_beforeBreakpoint", breakpointParams);
  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate();
    swiper.updateSlides();
    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
  }
  swiper.emit("breakpoint", breakpointParams);
}
function getBreakpoint(breakpoints2, base, containerEl) {
  if (base === void 0) {
    base = "window";
  }
  if (!breakpoints2 || base === "container" && !containerEl)
    return void 0;
  let breakpoint = false;
  const window2 = getWindow$1();
  const currentHeight = base === "window" ? window2.innerHeight : containerEl.clientHeight;
  const points = Object.keys(breakpoints2).map((point) => {
    if (typeof point === "string" && point.indexOf("@") === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value = currentHeight * minRatio;
      return {
        value,
        point
      };
    }
    return {
      value: point,
      point
    };
  });
  points.sort((a2, b2) => parseInt(a2.value, 10) - parseInt(b2.value, 10));
  for (let i2 = 0; i2 < points.length; i2 += 1) {
    const {
      point,
      value
    } = points[i2];
    if (base === "window") {
      if (window2.matchMedia(`(min-width: ${value}px)`).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }
  return breakpoint || "max";
}
var breakpoints = {
  setBreakpoint,
  getBreakpoint
};
function prepareClasses(entries, prefix2) {
  const resultClasses = [];
  entries.forEach((item) => {
    if (typeof item === "object") {
      Object.keys(item).forEach((classNames2) => {
        if (item[classNames2]) {
          resultClasses.push(prefix2 + classNames2);
        }
      });
    } else if (typeof item === "string") {
      resultClasses.push(prefix2 + item);
    }
  });
  return resultClasses;
}
function addClasses() {
  const swiper = this;
  const {
    classNames: classNames2,
    params,
    rtl,
    $el,
    device,
    support: support2
  } = swiper;
  const suffixes = prepareClasses(["initialized", params.direction, {
    "pointer-events": !support2.touch
  }, {
    "free-mode": swiper.params.freeMode && params.freeMode.enabled
  }, {
    "autoheight": params.autoHeight
  }, {
    "rtl": rtl
  }, {
    "grid": params.grid && params.grid.rows > 1
  }, {
    "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
  }, {
    "android": device.android
  }, {
    "ios": device.ios
  }, {
    "css-mode": params.cssMode
  }, {
    "centered": params.cssMode && params.centeredSlides
  }], params.containerModifierClass);
  classNames2.push(...suffixes);
  $el.addClass([...classNames2].join(" "));
  swiper.emitContainerClasses();
}
function removeClasses() {
  const swiper = this;
  const {
    $el,
    classNames: classNames2
  } = swiper;
  $el.removeClass(classNames2.join(" "));
  swiper.emitContainerClasses();
}
var classes = {
  addClasses,
  removeClasses
};
function loadImage(imageEl, src2, srcset, sizes, checkForComplete, callback) {
  const window2 = getWindow$1();
  let image;
  function onReady() {
    if (callback)
      callback();
  }
  const isPicture = $(imageEl).parent("picture")[0];
  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src2) {
      image = new window2.Image();
      image.onload = onReady;
      image.onerror = onReady;
      if (sizes) {
        image.sizes = sizes;
      }
      if (srcset) {
        image.srcset = srcset;
      }
      if (src2) {
        image.src = src2;
      }
    } else {
      onReady();
    }
  } else {
    onReady();
  }
}
function preloadImages() {
  const swiper = this;
  swiper.imagesToLoad = swiper.$el.find("img");
  function onReady() {
    if (typeof swiper === "undefined" || swiper === null || !swiper || swiper.destroyed)
      return;
    if (swiper.imagesLoaded !== void 0)
      swiper.imagesLoaded += 1;
    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady)
        swiper.update();
      swiper.emit("imagesReady");
    }
  }
  for (let i2 = 0; i2 < swiper.imagesToLoad.length; i2 += 1) {
    const imageEl = swiper.imagesToLoad[i2];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute("src"), imageEl.srcset || imageEl.getAttribute("srcset"), imageEl.sizes || imageEl.getAttribute("sizes"), true, onReady);
  }
}
var images = {
  loadImage,
  preloadImages
};
function checkOverflow() {
  const swiper = this;
  const {
    isLocked: wasLocked,
    params
  } = swiper;
  const {
    slidesOffsetBefore
  } = params;
  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper.slides.length - 1;
    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }
  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }
  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }
  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }
  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? "lock" : "unlock");
  }
}
var checkOverflow$1 = {
  checkOverflow
};
var defaults$5 = {
  init: true,
  direction: "horizontal",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: "input, select, option, textarea, button, video, label",
  width: null,
  height: null,
  preventInteractionOnTransition: false,
  userAgent: null,
  url: null,
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  autoHeight: false,
  setWrapperSize: false,
  virtualTranslate: false,
  effect: "slide",
  breakpoints: void 0,
  breakpointsBase: "window",
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  watchOverflow: true,
  roundLengths: false,
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  uniqueNavElements: true,
  resistance: true,
  resistanceRatio: 0.85,
  watchSlidesProgress: false,
  grabCursor: false,
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  preloadImages: true,
  updateOnImagesReady: true,
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopFillGroupWithBlank: false,
  loopPreventsSlide: true,
  rewind: false,
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  noSwiping: true,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  containerModifierClass: "swiper-",
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-invisible-blank",
  slideActiveClass: "swiper-slide-active",
  slideDuplicateActiveClass: "swiper-slide-duplicate-active",
  slideVisibleClass: "swiper-slide-visible",
  slideDuplicateClass: "swiper-slide-duplicate",
  slideNextClass: "swiper-slide-next",
  slideDuplicateNextClass: "swiper-slide-duplicate-next",
  slidePrevClass: "swiper-slide-prev",
  slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
  wrapperClass: "swiper-wrapper",
  runCallbacksOnInit: true,
  _emitClasses: false
};
function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj) {
    if (obj === void 0) {
      obj = {};
    }
    const moduleParamName = Object.keys(obj)[0];
    const moduleParams = obj[moduleParamName];
    if (typeof moduleParams !== "object" || moduleParams === null) {
      extend$2(allModulesParams, obj);
      return;
    }
    if (["navigation", "pagination", "scrollbar"].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
      params[moduleParamName] = {
        auto: true
      };
    }
    if (!(moduleParamName in params && "enabled" in moduleParams)) {
      extend$2(allModulesParams, obj);
      return;
    }
    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }
    if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }
    if (!params[moduleParamName])
      params[moduleParamName] = {
        enabled: false
      };
    extend$2(allModulesParams, obj);
  };
}
const prototypes = {
  eventsEmitter,
  update,
  translate,
  transition,
  slide,
  loop,
  grabCursor,
  events: events$1,
  breakpoints,
  checkOverflow: checkOverflow$1,
  classes,
  images
};
const extendedDefaults = {};
class Swiper$1 {
  constructor() {
    let el;
    let params;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") {
      params = args[0];
    } else {
      [el, params] = args;
    }
    if (!params)
      params = {};
    params = extend$2({}, params);
    if (el && !params.el)
      params.el = el;
    if (params.el && $(params.el).length > 1) {
      const swipers = [];
      $(params.el).each((containerEl) => {
        const newParams = extend$2({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper$1(newParams));
      });
      return swipers;
    }
    const swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [...swiper.__modules__];
    if (params.modules && Array.isArray(params.modules)) {
      swiper.modules.push(...params.modules);
    }
    const allModulesParams = {};
    swiper.modules.forEach((mod) => {
      mod({
        swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    });
    const swiperParams = extend$2({}, defaults$5, allModulesParams);
    swiper.params = extend$2({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = extend$2({}, swiper.params);
    swiper.passedParams = extend$2({}, params);
    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach((eventName) => {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }
    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    }
    swiper.$ = $;
    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      classNames: [],
      slides: $(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      isHorizontal() {
        return swiper.params.direction === "horizontal";
      },
      isVertical() {
        return swiper.params.direction === "vertical";
      },
      activeIndex: 0,
      realIndex: 0,
      isBeginning: true,
      isEnd: false,
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      touchEvents: function touchEvents() {
        const touch = ["touchstart", "touchmove", "touchend", "touchcancel"];
        const desktop = ["pointerdown", "pointermove", "pointerup"];
        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        focusableElements: swiper.params.focusableElements,
        lastClickTime: now(),
        clickTimeout: void 0,
        velocities: [],
        allowMomentumBounce: void 0,
        isTouchEvent: void 0,
        startMoving: void 0
      },
      allowClick: true,
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit("_swiper");
    if (swiper.params.init) {
      swiper.init();
    }
    return swiper;
  }
  enable() {
    const swiper = this;
    if (swiper.enabled)
      return;
    swiper.enabled = true;
    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }
    swiper.emit("enable");
  }
  disable() {
    const swiper = this;
    if (!swiper.enabled)
      return;
    swiper.enabled = false;
    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }
    swiper.emit("disable");
  }
  setProgress(progress, speed) {
    const swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    const min2 = swiper.minTranslate();
    const max2 = swiper.maxTranslate();
    const current = (max2 - min2) * progress + min2;
    swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  emitContainerClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el)
      return;
    const cls = swiper.el.className.split(" ").filter((className) => {
      return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit("_containerClasses", cls.join(" "));
  }
  getSlideClasses(slideEl) {
    const swiper = this;
    return slideEl.className.split(" ").filter((className) => {
      return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(" ");
  }
  emitSlidesClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el)
      return;
    const updates = [];
    swiper.slides.each((slideEl) => {
      const classNames2 = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames: classNames2
      });
      swiper.emit("_slideClass", slideEl, classNames2);
    });
    swiper.emit("_slideClasses", updates);
  }
  slidesPerViewDynamic(view, exact) {
    if (view === void 0) {
      view = "current";
    }
    if (exact === void 0) {
      exact = false;
    }
    const swiper = this;
    const {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    let spv = 1;
    if (params.centeredSlides) {
      let slideSize = slides[activeIndex].swiperSlideSize;
      let breakLoop;
      for (let i2 = activeIndex + 1; i2 < slides.length; i2 += 1) {
        if (slides[i2] && !breakLoop) {
          slideSize += slides[i2].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize)
            breakLoop = true;
        }
      }
      for (let i2 = activeIndex - 1; i2 >= 0; i2 -= 1) {
        if (slides[i2] && !breakLoop) {
          slideSize += slides[i2].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize)
            breakLoop = true;
        }
      }
    } else {
      if (view === "current") {
        for (let i2 = activeIndex + 1; i2 < slides.length; i2 += 1) {
          const slideInView = exact ? slidesGrid[i2] + slidesSizesGrid[i2] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i2] - slidesGrid[activeIndex] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        for (let i2 = activeIndex - 1; i2 >= 0; i2 -= 1) {
          const slideInView = slidesGrid[activeIndex] - slidesGrid[i2] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      }
    }
    return spv;
  }
  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed)
      return;
    const {
      snapGrid,
      params
    } = swiper;
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    function setTranslate2() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    let translated;
    if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
      setTranslate2();
      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === "auto" || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
      if (!translated) {
        setTranslate2();
      }
    }
    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
    swiper.emit("update");
  }
  changeDirection(newDirection, needUpdate) {
    if (needUpdate === void 0) {
      needUpdate = true;
    }
    const swiper = this;
    const currentDirection = swiper.params.direction;
    if (!newDirection) {
      newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
    }
    if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") {
      return swiper;
    }
    swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.each((slideEl) => {
      if (newDirection === "vertical") {
        slideEl.style.width = "";
      } else {
        slideEl.style.height = "";
      }
    });
    swiper.emit("changeDirection");
    if (needUpdate)
      swiper.update();
    return swiper;
  }
  mount(el) {
    const swiper = this;
    if (swiper.mounted)
      return true;
    const $el = $(el || swiper.params.el);
    el = $el[0];
    if (!el) {
      return false;
    }
    el.swiper = swiper;
    const getWrapperSelector = () => {
      return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
    };
    const getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = $(el.shadowRoot.querySelector(getWrapperSelector()));
        res.children = (options2) => $el.children(options2);
        return res;
      }
      return $el.children(getWrapperSelector());
    };
    let $wrapperEl = getWrapper();
    if ($wrapperEl.length === 0 && swiper.params.createElements) {
      const document2 = getDocument();
      const wrapper = document2.createElement("div");
      $wrapperEl = $(wrapper);
      wrapper.className = swiper.params.wrapperClass;
      $el.append(wrapper);
      $el.children(`.${swiper.params.slideClass}`).each((slideEl) => {
        $wrapperEl.append(slideEl);
      });
    }
    Object.assign(swiper, {
      $el,
      el,
      $wrapperEl,
      wrapperEl: $wrapperEl[0],
      mounted: true,
      rtl: el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl",
      rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl"),
      wrongRTL: $wrapperEl.css("display") === "-webkit-box"
    });
    return true;
  }
  init(el) {
    const swiper = this;
    if (swiper.initialized)
      return swiper;
    const mounted = swiper.mount(el);
    if (mounted === false)
      return swiper;
    swiper.emit("beforeInit");
    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    }
    swiper.addClasses();
    if (swiper.params.loop) {
      swiper.loopCreate();
    }
    swiper.updateSize();
    swiper.updateSlides();
    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    }
    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }
    if (swiper.params.preloadImages) {
      swiper.preloadImages();
    }
    if (swiper.params.loop) {
      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    }
    swiper.attachEvents();
    swiper.initialized = true;
    swiper.emit("init");
    swiper.emit("afterInit");
    return swiper;
  }
  destroy(deleteInstance, cleanStyles) {
    if (deleteInstance === void 0) {
      deleteInstance = true;
    }
    if (cleanStyles === void 0) {
      cleanStyles = true;
    }
    const swiper = this;
    const {
      params,
      $el,
      $wrapperEl,
      slides
    } = swiper;
    if (typeof swiper.params === "undefined" || swiper.destroyed) {
      return null;
    }
    swiper.emit("beforeDestroy");
    swiper.initialized = false;
    swiper.detachEvents();
    if (params.loop) {
      swiper.loopDestroy();
    }
    if (cleanStyles) {
      swiper.removeClasses();
      $el.removeAttr("style");
      $wrapperEl.removeAttr("style");
      if (slides && slides.length) {
        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index");
      }
    }
    swiper.emit("destroy");
    Object.keys(swiper.eventsListeners).forEach((eventName) => {
      swiper.off(eventName);
    });
    if (deleteInstance !== false) {
      swiper.$el[0].swiper = null;
      deleteProps(swiper);
    }
    swiper.destroyed = true;
    return null;
  }
  static extendDefaults(newDefaults) {
    extend$2(extendedDefaults, newDefaults);
  }
  static get extendedDefaults() {
    return extendedDefaults;
  }
  static get defaults() {
    return defaults$5;
  }
  static installModule(mod) {
    if (!Swiper$1.prototype.__modules__)
      Swiper$1.prototype.__modules__ = [];
    const modules = Swiper$1.prototype.__modules__;
    if (typeof mod === "function" && modules.indexOf(mod) < 0) {
      modules.push(mod);
    }
  }
  static use(module) {
    if (Array.isArray(module)) {
      module.forEach((m2) => Swiper$1.installModule(m2));
      return Swiper$1;
    }
    Swiper$1.installModule(module);
    return Swiper$1;
  }
}
Object.keys(prototypes).forEach((prototypeGroup) => {
  Object.keys(prototypes[prototypeGroup]).forEach((protoMethod) => {
    Swiper$1.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper$1.use([Resize, Observer]);
function Autoplay(_ref3) {
  let {
    swiper,
    extendParams,
    on: on2,
    emit
  } = _ref3;
  let timeout;
  swiper.autoplay = {
    running: false,
    paused: false
  };
  extendParams({
    autoplay: {
      enabled: false,
      delay: 3e3,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  });
  function run() {
    const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    let delay = swiper.params.autoplay.delay;
    if ($activeSlideEl.attr("data-swiper-autoplay")) {
      delay = $activeSlideEl.attr("data-swiper-autoplay") || swiper.params.autoplay.delay;
    }
    clearTimeout(timeout);
    timeout = nextTick(() => {
      let autoplayResult;
      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          emit("autoplay");
        } else if (!swiper.isBeginning) {
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          emit("autoplay");
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          emit("autoplay");
        } else {
          stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        emit("autoplay");
      } else if (!swiper.isEnd) {
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        emit("autoplay");
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
        emit("autoplay");
      } else {
        stop();
      }
      if (swiper.params.cssMode && swiper.autoplay.running)
        run();
      else if (autoplayResult === false) {
        run();
      }
    }, delay);
  }
  function start2() {
    if (typeof timeout !== "undefined")
      return false;
    if (swiper.autoplay.running)
      return false;
    swiper.autoplay.running = true;
    emit("autoplayStart");
    run();
    return true;
  }
  function stop() {
    if (!swiper.autoplay.running)
      return false;
    if (typeof timeout === "undefined")
      return false;
    if (timeout) {
      clearTimeout(timeout);
      timeout = void 0;
    }
    swiper.autoplay.running = false;
    emit("autoplayStop");
    return true;
  }
  function pause(speed) {
    if (!swiper.autoplay.running)
      return;
    if (swiper.autoplay.paused)
      return;
    if (timeout)
      clearTimeout(timeout);
    swiper.autoplay.paused = true;
    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      run();
    } else {
      ["transitionend", "webkitTransitionEnd"].forEach((event) => {
        swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
      });
    }
  }
  function onVisibilityChange() {
    const document2 = getDocument();
    if (document2.visibilityState === "hidden" && swiper.autoplay.running) {
      pause();
    }
    if (document2.visibilityState === "visible" && swiper.autoplay.paused) {
      run();
      swiper.autoplay.paused = false;
    }
  }
  function onTransitionEnd(e2) {
    if (!swiper || swiper.destroyed || !swiper.$wrapperEl)
      return;
    if (e2.target !== swiper.$wrapperEl[0])
      return;
    ["transitionend", "webkitTransitionEnd"].forEach((event) => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
    swiper.autoplay.paused = false;
    if (!swiper.autoplay.running) {
      stop();
    } else {
      run();
    }
  }
  function onMouseEnter() {
    if (swiper.params.autoplay.disableOnInteraction) {
      stop();
    } else {
      emit("autoplayPause");
      pause();
    }
    ["transitionend", "webkitTransitionEnd"].forEach((event) => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
  }
  function onMouseLeave() {
    if (swiper.params.autoplay.disableOnInteraction) {
      return;
    }
    swiper.autoplay.paused = false;
    emit("autoplayResume");
    run();
  }
  function attachMouseEvents() {
    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.$el.on("mouseenter", onMouseEnter);
      swiper.$el.on("mouseleave", onMouseLeave);
    }
  }
  function detachMouseEvents() {
    swiper.$el.off("mouseenter", onMouseEnter);
    swiper.$el.off("mouseleave", onMouseLeave);
  }
  on2("init", () => {
    if (swiper.params.autoplay.enabled) {
      start2();
      const document2 = getDocument();
      document2.addEventListener("visibilitychange", onVisibilityChange);
      attachMouseEvents();
    }
  });
  on2("beforeTransitionStart", (_s, speed, internal) => {
    if (swiper.autoplay.running) {
      if (internal || !swiper.params.autoplay.disableOnInteraction) {
        swiper.autoplay.pause(speed);
      } else {
        stop();
      }
    }
  });
  on2("sliderFirstMove", () => {
    if (swiper.autoplay.running) {
      if (swiper.params.autoplay.disableOnInteraction) {
        stop();
      } else {
        pause();
      }
    }
  });
  on2("touchEnd", () => {
    if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
      run();
    }
  });
  on2("destroy", () => {
    detachMouseEvents();
    if (swiper.autoplay.running) {
      stop();
    }
    const document2 = getDocument();
    document2.removeEventListener("visibilitychange", onVisibilityChange);
  });
  Object.assign(swiper.autoplay, {
    pause,
    run,
    start: start2,
    stop
  });
}
function isObject$9(o2) {
  return typeof o2 === "object" && o2 !== null && o2.constructor && Object.prototype.toString.call(o2).slice(8, -1) === "Object";
}
function extend$1(target, src2) {
  const noExtend = ["__proto__", "constructor", "prototype"];
  Object.keys(src2).filter((key) => noExtend.indexOf(key) < 0).forEach((key) => {
    if (typeof target[key] === "undefined")
      target[key] = src2[key];
    else if (isObject$9(src2[key]) && isObject$9(target[key]) && Object.keys(src2[key]).length > 0) {
      if (src2[key].__swiper__)
        target[key] = src2[key];
      else
        extend$1(target[key], src2[key]);
    } else {
      target[key] = src2[key];
    }
  });
}
function needsNavigation(params) {
  if (params === void 0) {
    params = {};
  }
  return params.navigation && typeof params.navigation.nextEl === "undefined" && typeof params.navigation.prevEl === "undefined";
}
function needsPagination(params) {
  if (params === void 0) {
    params = {};
  }
  return params.pagination && typeof params.pagination.el === "undefined";
}
function needsScrollbar(params) {
  if (params === void 0) {
    params = {};
  }
  return params.scrollbar && typeof params.scrollbar.el === "undefined";
}
function uniqueClasses(classNames2) {
  if (classNames2 === void 0) {
    classNames2 = "";
  }
  const classes2 = classNames2.split(" ").map((c2) => c2.trim()).filter((c2) => !!c2);
  const unique = [];
  classes2.forEach((c2) => {
    if (unique.indexOf(c2) < 0)
      unique.push(c2);
  });
  return unique.join(" ");
}
const paramsList = [
  "modules",
  "init",
  "_direction",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_preloadImages",
  "updateOnImagesReady",
  "_loop",
  "_loopAdditionalSlides",
  "_loopedSlides",
  "_loopFillGroupWithBlank",
  "loopPreventsSlide",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideBlankClass",
  "slideActiveClass",
  "slideDuplicateActiveClass",
  "slideVisibleClass",
  "slideDuplicateClass",
  "slideNextClass",
  "slideDuplicateNextClass",
  "slidePrevClass",
  "slideDuplicatePrevClass",
  "wrapperClass",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "lazy",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom"
];
function getParams(obj) {
  if (obj === void 0) {
    obj = {};
  }
  const params = {
    on: {}
  };
  const events2 = {};
  const passedParams = {};
  extend$1(params, Swiper$1.defaults);
  extend$1(params, Swiper$1.extendedDefaults);
  params._emitClasses = true;
  params.init = false;
  const rest = {};
  const allowedParams = paramsList.map((key) => key.replace(/_/, ""));
  Object.keys(obj).forEach((key) => {
    if (allowedParams.indexOf(key) >= 0) {
      if (isObject$9(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        extend$1(params[key], obj[key]);
        extend$1(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === "function") {
      events2[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
    } else {
      rest[key] = obj[key];
    }
  });
  ["navigation", "pagination", "scrollbar"].forEach((key) => {
    if (params[key] === true)
      params[key] = {};
    if (params[key] === false)
      delete params[key];
  });
  return {
    params,
    passedParams,
    rest,
    events: events2
  };
}
function mountSwiper(_ref3, swiperParams) {
  let {
    el,
    nextEl,
    prevEl,
    paginationEl,
    scrollbarEl,
    swiper
  } = _ref3;
  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }
  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }
  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }
  swiper.init(el);
}
function calcLoopedSlides(slides, swiperParams) {
  let slidesPerViewParams = swiperParams.slidesPerView;
  if (swiperParams.breakpoints) {
    const breakpoint = Swiper$1.prototype.getBreakpoint(swiperParams.breakpoints);
    const breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : void 0;
    if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) {
      slidesPerViewParams = breakpointOnlyParams.slidesPerView;
    }
  }
  let loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
  loopedSlides += swiperParams.loopAdditionalSlides;
  if (loopedSlides > slides.length) {
    loopedSlides = slides.length;
  }
  return loopedSlides;
}
function renderLoop(swiper, slides, swiperParams) {
  const modifiedSlides = slides.map((child, index2) => {
    return /* @__PURE__ */ React__default.cloneElement(child, {
      swiper,
      "data-swiper-slide-index": index2
    });
  });
  function duplicateSlide(child, index2, position2) {
    return /* @__PURE__ */ React__default.cloneElement(child, {
      key: `${child.key}-duplicate-${index2}-${position2}`,
      className: `${child.props.className || ""} ${swiperParams.slideDuplicateClass}`
    });
  }
  if (swiperParams.loopFillGroupWithBlank) {
    const blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;
    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
      for (let i2 = 0; i2 < blankSlidesNum; i2 += 1) {
        const blankSlide = /* @__PURE__ */ React__default.createElement("div", {
          className: `${swiperParams.slideClass} ${swiperParams.slideBlankClass}`
        });
        modifiedSlides.push(blankSlide);
      }
    }
  }
  if (swiperParams.slidesPerView === "auto" && !swiperParams.loopedSlides) {
    swiperParams.loopedSlides = modifiedSlides.length;
  }
  const loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
  const prependSlides = [];
  const appendSlides = [];
  modifiedSlides.forEach((child, index2) => {
    if (index2 < loopedSlides) {
      appendSlides.push(duplicateSlide(child, index2, "prepend"));
    }
    if (index2 < modifiedSlides.length && index2 >= modifiedSlides.length - loopedSlides) {
      prependSlides.push(duplicateSlide(child, index2, "append"));
    }
  });
  if (swiper) {
    swiper.loopedSlides = loopedSlides;
  }
  return [...prependSlides, ...modifiedSlides, ...appendSlides];
}
function getChangedParams(swiperParams, oldParams, children2, oldChildren) {
  const keys2 = [];
  if (!oldParams)
    return keys2;
  const addKey = (key) => {
    if (keys2.indexOf(key) < 0)
      keys2.push(key);
  };
  const oldChildrenKeys = oldChildren.map((child) => child.key);
  const childrenKeys = children2.map((child) => child.key);
  if (oldChildrenKeys.join("") !== childrenKeys.join(""))
    addKey("children");
  if (oldChildren.length !== children2.length)
    addKey("children");
  const watchParams = paramsList.filter((key) => key[0] === "_").map((key) => key.replace(/_/, ""));
  watchParams.forEach((key) => {
    if (key in swiperParams && key in oldParams) {
      if (isObject$9(swiperParams[key]) && isObject$9(oldParams[key])) {
        const newKeys = Object.keys(swiperParams[key]);
        const oldKeys = Object.keys(oldParams[key]);
        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach((newKey) => {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach((oldKey) => {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey])
              addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys2;
}
function processChildren(c2) {
  const slides = [];
  React__default.Children.toArray(c2).forEach((child) => {
    if (child.type && child.type.displayName === "SwiperSlide") {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach((slide2) => slides.push(slide2));
    }
  });
  return slides;
}
function getChildren(c2) {
  const slides = [];
  const slots = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  React__default.Children.toArray(c2).forEach((child) => {
    if (child.type && child.type.displayName === "SwiperSlide") {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      const foundSlides = processChildren(child.props.children);
      if (foundSlides.length > 0) {
        foundSlides.forEach((slide2) => slides.push(slide2));
      } else {
        slots["container-end"].push(child);
      }
    } else {
      slots["container-end"].push(child);
    }
  });
  return {
    slides,
    slots
  };
}
function updateSwiper(_ref3) {
  let {
    swiper,
    slides,
    passedParams,
    changedParams,
    nextEl,
    prevEl,
    scrollbarEl,
    paginationEl
  } = _ref3;
  const updateParams = changedParams.filter((key) => key !== "children" && key !== "direction");
  const {
    params: currentParams,
    pagination,
    navigation,
    scrollbar,
    virtual,
    thumbs
  } = swiper;
  let needThumbsInit;
  let needControllerInit;
  let needPaginationInit;
  let needScrollbarInit;
  let needNavigationInit;
  if (changedParams.includes("thumbs") && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }
  if (changedParams.includes("controller") && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }
  if (changedParams.includes("pagination") && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }
  if (changedParams.includes("scrollbar") && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }
  if (changedParams.includes("navigation") && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }
  const destroyModule = (mod) => {
    if (!swiper[mod])
      return;
    swiper[mod].destroy();
    if (mod === "navigation") {
      currentParams[mod].prevEl = void 0;
      currentParams[mod].nextEl = void 0;
      swiper[mod].prevEl = void 0;
      swiper[mod].nextEl = void 0;
    } else {
      currentParams[mod].el = void 0;
      swiper[mod].el = void 0;
    }
  };
  updateParams.forEach((key) => {
    if (isObject$9(currentParams[key]) && isObject$9(passedParams[key])) {
      extend$1(currentParams[key], passedParams[key]);
    } else {
      const newValue = passedParams[key];
      if ((newValue === true || newValue === false) && (key === "navigation" || key === "pagination" || key === "scrollbar")) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });
  if (updateParams.includes("controller") && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control) {
    swiper.controller.control = currentParams.controller.control;
  }
  if (changedParams.includes("children") && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes("children") && swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }
  if (needThumbsInit) {
    const initialized = thumbs.init();
    if (initialized)
      thumbs.update(true);
  }
  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }
  if (needPaginationInit) {
    if (paginationEl)
      currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }
  if (needScrollbarInit) {
    if (scrollbarEl)
      currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }
  if (needNavigationInit) {
    if (nextEl)
      currentParams.navigation.nextEl = nextEl;
    if (prevEl)
      currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }
  if (changedParams.includes("allowSlideNext")) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }
  if (changedParams.includes("allowSlidePrev")) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }
  if (changedParams.includes("direction")) {
    swiper.changeDirection(passedParams.direction, false);
  }
  swiper.update();
}
function updateOnVirtualData(swiper) {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled)
    return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();
  if (swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }
  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
}
function renderVirtual(swiper, slides, virtualData) {
  if (!virtualData)
    return null;
  const style = swiper.isHorizontal() ? {
    [swiper.rtlTranslate ? "right" : "left"]: `${virtualData.offset}px`
  } : {
    top: `${virtualData.offset}px`
  };
  return slides.filter((child, index2) => index2 >= virtualData.from && index2 <= virtualData.to).map((child) => {
    return /* @__PURE__ */ React__default.cloneElement(child, {
      swiper,
      style
    });
  });
}
function useIsomorphicLayoutEffect$1(callback, deps) {
  if (typeof window === "undefined")
    return useEffect(callback, deps);
  return useLayoutEffect(callback, deps);
}
const SwiperSlideContext = /* @__PURE__ */ createContext(null);
const SwiperContext = /* @__PURE__ */ createContext(null);
const Swiper = /* @__PURE__ */ forwardRef(function(_temp, externalElRef) {
  let _a2 = _temp === void 0 ? {} : _temp, {
    className,
    tag: Tag = "div",
    wrapperTag: WrapperTag = "div",
    children: children2,
    onSwiper
  } = _a2, rest = __objRest(_a2, [
    "className",
    "tag",
    "wrapperTag",
    "children",
    "onSwiper"
  ]);
  let eventsAssigned = false;
  const [containerClasses, setContainerClasses] = useState("swiper");
  const [virtualData, setVirtualData] = useState(null);
  const [breakpointChanged, setBreakpointChanged] = useState(false);
  const initializedRef = useRef(false);
  const swiperElRef = useRef(null);
  const swiperRef = useRef(null);
  const oldPassedParamsRef = useRef(null);
  const oldSlides = useRef(null);
  const nextElRef = useRef(null);
  const prevElRef = useRef(null);
  const paginationElRef = useRef(null);
  const scrollbarElRef = useRef(null);
  const {
    params: swiperParams,
    passedParams,
    rest: restProps,
    events: events2
  } = getParams(rest);
  const {
    slides,
    slots
  } = getChildren(children2);
  const onBeforeBreakpoint = () => {
    setBreakpointChanged(!breakpointChanged);
  };
  Object.assign(swiperParams.on, {
    _containerClasses(swiper, classes2) {
      setContainerClasses(classes2);
    }
  });
  const initSwiper = () => {
    Object.assign(swiperParams.on, events2);
    eventsAssigned = true;
    swiperRef.current = new Swiper$1(swiperParams);
    swiperRef.current.loopCreate = () => {
    };
    swiperRef.current.loopDestroy = () => {
    };
    if (swiperParams.loop) {
      swiperRef.current.loopedSlides = calcLoopedSlides(slides, swiperParams);
    }
    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      const extendWith = {
        cache: false,
        slides,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      extend$1(swiperRef.current.params.virtual, extendWith);
      extend$1(swiperRef.current.originalParams.virtual, extendWith);
    }
  };
  if (!swiperElRef.current) {
    initSwiper();
  }
  if (swiperRef.current) {
    swiperRef.current.on("_beforeBreakpoint", onBeforeBreakpoint);
  }
  const attachEvents2 = () => {
    if (eventsAssigned || !events2 || !swiperRef.current)
      return;
    Object.keys(events2).forEach((eventName) => {
      swiperRef.current.on(eventName, events2[eventName]);
    });
  };
  const detachEvents2 = () => {
    if (!events2 || !swiperRef.current)
      return;
    Object.keys(events2).forEach((eventName) => {
      swiperRef.current.off(eventName, events2[eventName]);
    });
  };
  useEffect(() => {
    return () => {
      if (swiperRef.current)
        swiperRef.current.off("_beforeBreakpoint", onBeforeBreakpoint);
    };
  });
  useEffect(() => {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  });
  useIsomorphicLayoutEffect$1(() => {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }
    if (!swiperElRef.current)
      return;
    if (swiperRef.current.destroyed) {
      initSwiper();
    }
    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper)
      onSwiper(swiperRef.current);
    return () => {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []);
  useIsomorphicLayoutEffect$1(() => {
    attachEvents2();
    const changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;
    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides,
        passedParams,
        changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }
    return () => {
      detachEvents2();
    };
  });
  useIsomorphicLayoutEffect$1(() => {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]);
  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }
    if (!swiperParams.loop || swiperRef.current && swiperRef.current.destroyed) {
      return slides.map((child) => {
        return /* @__PURE__ */ React__default.cloneElement(child, {
          swiper: swiperRef.current
        });
      });
    }
    return renderLoop(swiperRef.current, slides, swiperParams);
  }
  return /* @__PURE__ */ jsx$1(Tag, __spreadProps(__spreadValues({
    ref: swiperElRef,
    className: uniqueClasses(`${containerClasses}${className ? ` ${className}` : ""}`)
  }, restProps), {
    children: /* @__PURE__ */ jsxs(SwiperContext.Provider, {
      value: swiperRef.current,
      children: [slots["container-start"], needsNavigation(swiperParams) && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx$1("div", {
          ref: prevElRef,
          className: "swiper-button-prev"
        }), /* @__PURE__ */ jsx$1("div", {
          ref: nextElRef,
          className: "swiper-button-next"
        })]
      }), needsScrollbar(swiperParams) && /* @__PURE__ */ jsx$1("div", {
        ref: scrollbarElRef,
        className: "swiper-scrollbar"
      }), needsPagination(swiperParams) && /* @__PURE__ */ jsx$1("div", {
        ref: paginationElRef,
        className: "swiper-pagination"
      }), /* @__PURE__ */ jsxs(WrapperTag, {
        className: "swiper-wrapper",
        children: [slots["wrapper-start"], renderSlides(), slots["wrapper-end"]]
      }), slots["container-end"]]
    })
  }));
});
Swiper.displayName = "Swiper";
const SwiperSlide = /* @__PURE__ */ forwardRef(function(_temp, externalRef) {
  let _a2 = _temp === void 0 ? {} : _temp, {
    tag: Tag = "div",
    children: children2,
    className = "",
    swiper,
    zoom,
    virtualIndex
  } = _a2, rest = __objRest(_a2, [
    "tag",
    "children",
    "className",
    "swiper",
    "zoom",
    "virtualIndex"
  ]);
  const slideElRef = useRef(null);
  const [slideClasses, setSlideClasses] = useState("swiper-slide");
  function updateClasses(_s, el, classNames2) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames2);
    }
  }
  useIsomorphicLayoutEffect$1(() => {
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }
    if (!slideElRef.current || !swiper) {
      return;
    }
    if (swiper.destroyed) {
      if (slideClasses !== "swiper-slide") {
        setSlideClasses("swiper-slide");
      }
      return;
    }
    swiper.on("_slideClass", updateClasses);
    return () => {
      if (!swiper)
        return;
      swiper.off("_slideClass", updateClasses);
    };
  });
  useIsomorphicLayoutEffect$1(() => {
    if (swiper && slideElRef.current) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  const slideData = {
    isActive: slideClasses.indexOf("swiper-slide-active") >= 0 || slideClasses.indexOf("swiper-slide-duplicate-active") >= 0,
    isVisible: slideClasses.indexOf("swiper-slide-visible") >= 0,
    isDuplicate: slideClasses.indexOf("swiper-slide-duplicate") >= 0,
    isPrev: slideClasses.indexOf("swiper-slide-prev") >= 0 || slideClasses.indexOf("swiper-slide-duplicate-prev") >= 0,
    isNext: slideClasses.indexOf("swiper-slide-next") >= 0 || slideClasses.indexOf("swiper-slide-duplicate-next") >= 0
  };
  const renderChildren = () => {
    return typeof children2 === "function" ? children2(slideData) : children2;
  };
  return /* @__PURE__ */ jsx$1(Tag, __spreadProps(__spreadValues({
    ref: slideElRef,
    className: uniqueClasses(`${slideClasses}${className ? ` ${className}` : ""}`),
    "data-swiper-slide-index": virtualIndex
  }, rest), {
    children: /* @__PURE__ */ jsx$1(SwiperSlideContext.Provider, {
      value: slideData,
      children: zoom ? /* @__PURE__ */ jsx$1("div", {
        className: "swiper-zoom-container",
        "data-swiper-zoom": typeof zoom === "number" ? zoom : void 0,
        children: renderChildren()
      }) : renderChildren()
    })
  }));
});
SwiperSlide.displayName = "SwiperSlide";
const Carousel = (_f) => {
  var _g = _f, {
    children: children2,
    spaceBetween,
    isShowPagination = true,
    onSlideChange,
    paginationSize = "medium"
  } = _g, carouselProps = __objRest(_g, [
    "children",
    "spaceBetween",
    "isShowPagination",
    "onSlideChange",
    "paginationSize"
  ]);
  const [activeIndex, setActiveIndex] = useState(0);
  const getPaginationSizeClasses = () => {
    switch (paginationSize) {
      case "small":
        return "tw-w-2 tw-h-2 tw-mx-1";
      case "medium":
        return "tw-w-4 tw-h-4 tw-mx-3";
      default:
        return "";
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx$1(Swiper, __spreadProps(__spreadValues({
      spaceBetween: spaceBetween || 1,
      scrollbar: {
        draggable: true
      },
      preloadImages: true,
      onSlideChange: (swiper) => {
        if (onSlideChange) {
          onSlideChange(swiper);
        }
        setActiveIndex(swiper.activeIndex);
      }
    }, carouselProps), {
      children: React__default.Children.map(children2, (child, index2) => {
        return /* @__PURE__ */ jsx$1("div", {
          className: "tw-flex tw-justify-center tw-items-center",
          children: /* @__PURE__ */ jsx$1(SwiperSlide, {
            children: React__default.isValidElement(child) && React__default.cloneElement(child)
          }, index2)
        });
      })
    })), isShowPagination && /* @__PURE__ */ jsx$1("div", {
      className: "tw-flex tw-justify-center tw-my-6",
      children: React__default.Children.map(children2, (child, index2) => {
        const bgPagination = index2 === activeIndex ? "tw-bg-Gray-300" : "tw-bg-Gray-500";
        return /* @__PURE__ */ jsx$1("div", {
          className: classNames$1("tw-rounded-full", bgPagination, getPaginationSizeClasses())
        });
      })
    })]
  });
};
Carousel.displayName = "Carousel";
const AI_CAROUSEL_MODALS = [
  {
    img: AI_BOT_SETTING,
    title: "ai.aiGuideline.slide1.title",
    description: "ai.aiGuideline.slide1.description"
  },
  {
    img: AI_WELCOME_MESSAGE,
    title: "ai.aiGuideline.slide2.title",
    description: "ai.aiGuideline.slide2.description"
  },
  {
    img: AI_SPECIAL_KNOWLEDGE,
    title: "ai.aiGuideline.slide3.title",
    description: "ai.aiGuideline.slide3.description"
  }
];
const AI_DETAILS = [
  {
    title: "ai.aiGuideline.botSetting",
    description: "ai.aiGuideline.botSettingDescription"
  },
  {
    title: "ai.aiGuideline.botWelcomeMessage",
    description: "ai.aiGuideline.botWelcomeMessageDescription"
  },
  {
    title: "ai.aiGuideline.botSpecialKnowledge",
    description: "ai.aiGuideline.botSpecialKnowledgeDescription"
  }
];
const AIGuidelineModal = (props) => {
  const {
    t: t2,
    i18n
  } = useTranslation();
  const {
    isOpen,
    lang = "th",
    onClose
  } = props;
  const {
    isFullScreen
  } = useDevice();
  useEffect(() => {
    void i18n.changeLanguage(lang);
  }, [lang, i18n]);
  return /* @__PURE__ */ jsx$1(Modal, {
    isOpen,
    size: isFullScreen ? "full" : "small",
    onClose,
    noPadding: true,
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-flex",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "tw-hidden tw-flex-col tw-justify-between tw-p-20 fullScreen:tw-flex fullScreen:tw-w-1/2",
        children: [/* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx$1(Typography, {
            variant: "title-9",
            color: "Gray-400",
            className: "tw-whitespace-pre-line",
            children: t2("ai.aiGuideline.preTitle")
          }), /* @__PURE__ */ jsx$1(Typography, {
            variant: "heading-3",
            className: "tw-whitespace-pre-line",
            children: t2("ai.aiGuideline.title")
          })]
        }), /* @__PURE__ */ jsxs("div", {
          children: [AI_DETAILS.map((detail) => /* @__PURE__ */ jsxs(Fragment, {
            children: [/* @__PURE__ */ jsx$1(Typography, {
              variant: "title-7",
              className: "tw-whitespace-pre-line",
              children: t2(detail.title)
            }), /* @__PURE__ */ jsx$1(Typography, {
              variant: "body-3",
              color: "Gray-500",
              className: "tw-pb-8 tw-whitespace-pre-line",
              children: t2(detail.description)
            })]
          })), /* @__PURE__ */ jsx$1(Button, {
            size: "fullWidth",
            className: "tw-pb-4",
            onClick: onClose,
            children: t2("ai.aiGuideline.trainBot")
          })]
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-py-4 tw-px-10 tw-w-full tw-bg-White tw-rounded-r-lg fullScreen:tw-py-20 fullScreen:tw-w-1/2 fullScreen:tw-bg-NudeDarkBlue",
        children: [/* @__PURE__ */ jsx$1(Carousel, {
          slidesPerView: 1,
          autoplay: {
            delay: 3e3
          },
          paginationSize: "small",
          modules: [Autoplay],
          children: AI_CAROUSEL_MODALS.map((slide2) => /* @__PURE__ */ jsxs("div", {
            children: [/* @__PURE__ */ jsx$1(Typography, {
              variant: "title-2",
              color: "Gray-800",
              className: "tw-hidden tw-pb-12 tw-text-center tw-whitespace-pre-line fullScreen:tw-block",
              children: t2(slide2.title)
            }), /* @__PURE__ */ jsx$1("img", {
              src: slide2.img,
              alt: "payment-pic",
              className: "tw-pb-12 tw-m-auto tw-max-w-[320px]"
            }), /* @__PURE__ */ jsx$1(Typography, {
              variant: "title-8",
              color: "Gray-500",
              className: "tw-hidden tw-pb-4 tw-text-center tw-whitespace-pre-line fullScreen:tw-block",
              children: t2(slide2.description)
            }), /* @__PURE__ */ jsx$1(Typography, {
              variant: "title-4",
              color: "Gray-800",
              className: "tw-block tw-pb-4 tw-text-center tw-whitespace-pre-line fullScreen:tw-hidden",
              children: t2(slide2.title)
            }), /* @__PURE__ */ jsx$1(Typography, {
              variant: "title-9",
              color: "Gray-500",
              className: "tw-block tw-pb-4  tw-text-center tw-whitespace-pre-line fullScreen:tw-hidden",
              children: t2(slide2.description)
            })]
          }, slide2.title))
        }), /* @__PURE__ */ jsx$1("div", {
          className: "tw-block fullScreen:tw-hidden",
          children: /* @__PURE__ */ jsx$1(Button, {
            size: "fullWidth",
            className: "tw-pb-4",
            onClick: onClose,
            children: t2("ai.aiGuideline.trainBot")
          })
        })]
      })]
    })
  });
};
var navigation_min = "";
const PAYMENT_CAROUSEL_MODALS = [
  {
    img: PAYMENT_CAROUSEL_WHAT_IS_DEEPLE_PAY,
    title: "payment.paymentGuideline.slide1.title",
    description: "payment.paymentGuideline.slide1.description",
    note: "payment.paymentGuideline.slide1.note"
  },
  {
    img: PAYMENT_CAROUSEL_CHECK_PAYMENT,
    title: "payment.paymentGuideline.slide2.title",
    description: "payment.paymentGuideline.slide2.description",
    note: "payment.paymentGuideline.slide2.note"
  },
  {
    img: PAYMENT_CAROUSEL_WITHDRAW,
    title: "payment.paymentGuideline.slide3.title",
    description: "payment.paymentGuideline.slide3.description",
    note: "payment.paymentGuideline.slide3.note"
  }
];
const PaymentPopupContent = (props) => {
  const {
    t: t2
  } = useTranslation();
  const [swiper, setSwiper] = useState(null);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const {
    onClickDone,
    onClickSetting
  } = props;
  const lastSlideIndex = PAYMENT_CAROUSEL_MODALS.length - 1;
  const {
    isFullScreen
  } = useDevice();
  const onInitSwiper = (swiperInstance) => {
    setSwiper(swiperInstance);
  };
  const onSlideChange = (swiperInstance) => {
    setCurrentSlideIndex(swiperInstance.activeIndex);
  };
  const handleSlideNext = () => {
    swiper == null ? void 0 : swiper.slideNext();
  };
  const handleSlidePrev = () => {
    swiper == null ? void 0 : swiper.slidePrev();
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx$1(Carousel, {
      slidesPerView: 1,
      onSwiper: onInitSwiper,
      onSlideChange,
      allowTouchMove: !isFullScreen,
      paginationSize: "small",
      children: PAYMENT_CAROUSEL_MODALS.map((slide2) => /* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx$1("img", {
          src: slide2.img,
          alt: "payment-pic",
          className: "tw-pt-4 tw-pb-2 tw-m-auto tw-max-w-[340px] fullScreen:tw-py-8 fullScreen:tw-max-w-[400px]"
        }), /* @__PURE__ */ jsx$1(Typography, {
          variant: isFullScreen ? "title-2" : "title-4",
          color: "Gray-800",
          className: "tw-pb-4 tw-text-center fullScreen:tw-pb-8 fullScreen:tw-whitespace-pre-line",
          children: t2(slide2.title)
        }), /* @__PURE__ */ jsx$1(Typography, {
          variant: isFullScreen ? "title-8" : "title-10",
          color: "Gray-500",
          className: "tw-px-8 tw-pb-4 tw-text-center fullScreen:tw-whitespace-pre-line",
          children: t2(slide2.description)
        }), /* @__PURE__ */ jsx$1(Typography, {
          variant: isFullScreen ? "body-3" : "body-5",
          color: "Orange",
          className: "tw-text-center fullScreen:tw-whitespace-pre-line",
          children: t2(slide2.note)
        })]
      }, slide2.title))
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-hidden tw-justify-between tw-pt-4 tw-mx-8 fullScreen:tw-flex",
      children: [/* @__PURE__ */ jsx$1("div", {
        children: currentSlideIndex !== 0 && /* @__PURE__ */ jsx$1(Button, {
          size: "large",
          variant: "text",
          onClick: handleSlidePrev,
          children: t2("payment.prev")
        })
      }), /* @__PURE__ */ jsx$1("div", {
        children: currentSlideIndex === lastSlideIndex && /* @__PURE__ */ jsx$1(Button, {
          size: "large",
          variant: "secondary",
          onClick: onClickSetting,
          children: t2("payment.connectAccount")
        })
      }), /* @__PURE__ */ jsx$1("div", {
        children: currentSlideIndex !== lastSlideIndex ? /* @__PURE__ */ jsx$1(Button, {
          size: "large",
          onClick: handleSlideNext,
          children: t2("payment.next")
        }) : /* @__PURE__ */ jsx$1(Button, {
          size: "large",
          onClick: onClickDone,
          children: t2("payment.goToTransactionPage")
        })
      })]
    }), /* @__PURE__ */ jsx$1("div", {
      className: "tw-flex tw-justify-between tw-pt-2 tw-mx-8 fullScreen:tw-hidden",
      children: currentSlideIndex === lastSlideIndex && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx$1(Button, {
          size: "large",
          variant: "text",
          onClick: onClickDone,
          children: t2("payment.skip")
        }), /* @__PURE__ */ jsx$1(Button, {
          size: "large",
          onClick: onClickSetting,
          children: t2("payment.connectAccount")
        })]
      })
    })]
  });
};
const PaymentGuidelineModal = (props) => {
  const {
    i18n
  } = useTranslation();
  const {
    isOpen,
    lang = "th",
    onClickDone,
    onClickSetting,
    onClose
  } = props;
  const {
    isFullScreen
  } = useDevice();
  useEffect(() => {
    void i18n.changeLanguage(lang);
  }, [lang, i18n]);
  return /* @__PURE__ */ jsx$1(Modal, {
    isOpen,
    size: isFullScreen ? "medium" : "small",
    onClose,
    isClickOverlayToClose: false,
    children: /* @__PURE__ */ jsx$1(PaymentPopupContent, {
      onClickDone,
      onClickSetting
    })
  });
};
var index = "";
var ElevationShadowType;
(function(ElevationShadowType2) {
  ElevationShadowType2["NONE"] = "none";
  ElevationShadowType2["SMALL"] = "small";
  ElevationShadowType2["MEDIUM"] = "medium";
  ElevationShadowType2["LARGE"] = "large";
  ElevationShadowType2["EXTRA"] = "extra";
})(ElevationShadowType || (ElevationShadowType = {}));
const shadowClasses = {
  [ElevationShadowType.NONE]: "tw-rounded-none tablet:tw-rounded-lg tw-shadow-none",
  [ElevationShadowType.SMALL]: "tw-rounded-none tablet:tw-rounded-lg tw-shadow-sm",
  [ElevationShadowType.MEDIUM]: "tw-rounded-none tablet:tw-rounded-lg tw-shadow-md",
  [ElevationShadowType.LARGE]: "tw-rounded-none tablet:tw-rounded-lg tw-shadow-lg",
  [ElevationShadowType.EXTRA]: "tw-rounded-none tablet:tw-rounded-lg tw-shadow-xl"
};
var ContentSize;
(function(ContentSize2) {
  ContentSize2["FULL"] = "full";
  ContentSize2["VERTICAL_1"] = "vertical-1";
  ContentSize2["VERTICAL_2"] = "vertical-2";
  ContentSize2["VERTICAL_3"] = "vertical-3";
  ContentSize2["VERTICAL_4"] = "vertical-4";
  ContentSize2["VERTICAL_5"] = "vertical-5";
  ContentSize2["HORIZONTAL_1"] = "horizontal-1";
  ContentSize2["HORIZONTAL_2"] = "horizontal-2";
  ContentSize2["HORIZONTAL_3"] = "horizontal-3";
  ContentSize2["HORIZONTAL_4"] = "horizontal-4";
  ContentSize2["HORIZONTAL_5"] = "horizontal-5";
  ContentSize2["TINY_1"] = "tiny-1";
  ContentSize2["TINY_2"] = "tiny-2";
  ContentSize2["TINY_3"] = "tiny-3";
  ContentSize2["TINY_4"] = "tiny-4";
  ContentSize2["TINY_5"] = "tiny-5";
  ContentSize2["SMALL_1"] = "small-1";
  ContentSize2["SMALL_2"] = "small-2";
  ContentSize2["SMALL_3"] = "small-3";
  ContentSize2["SMALL_4"] = "small-4";
  ContentSize2["SMALL_5"] = "small-5";
  ContentSize2["MEDIUM_1"] = "medium-1";
  ContentSize2["MEDIUM_2"] = "medium-2";
  ContentSize2["MEDIUM_3"] = "medium-3";
  ContentSize2["MEDIUM_4"] = "medium-4";
  ContentSize2["MEDIUM_5"] = "medium-5";
  ContentSize2["LARGE_1"] = "large-1";
  ContentSize2["LARGE_2"] = "large-2";
  ContentSize2["LARGE_3"] = "large-3";
  ContentSize2["LARGE_4"] = "large-4";
  ContentSize2["LARGE_5"] = "large-5";
  ContentSize2["HUGE_1"] = "huge-1";
  ContentSize2["HUGE_2"] = "huge-2";
  ContentSize2["HUGE_3"] = "huge-3";
  ContentSize2["HUGE_4"] = "huge-4";
  ContentSize2["HUGE_5"] = "huge-5";
  ContentSize2["CUSTOM_1"] = "custom-1";
})(ContentSize || (ContentSize = {}));
const ContentClasses = {
  [ContentSize.FULL]: "tw-p-0",
  [ContentSize.VERTICAL_1]: "tw-py-2",
  [ContentSize.VERTICAL_2]: "tw-py-4",
  [ContentSize.VERTICAL_3]: "tw-py-6",
  [ContentSize.VERTICAL_4]: "tw-py-8",
  [ContentSize.VERTICAL_5]: "tw-py-12",
  [ContentSize.HORIZONTAL_1]: "tw-px-2",
  [ContentSize.HORIZONTAL_2]: "tw-px-4",
  [ContentSize.HORIZONTAL_3]: "tw-px-6",
  [ContentSize.HORIZONTAL_4]: "tw-px-8",
  [ContentSize.HORIZONTAL_5]: "tw-px-12",
  [ContentSize.TINY_1]: "tw-p-2",
  [ContentSize.TINY_2]: "tw-px-4 tw-py-2",
  [ContentSize.TINY_3]: "tw-px-6 tw-py-2",
  [ContentSize.TINY_4]: "tw-px-8 tw-py-2",
  [ContentSize.TINY_5]: "tw-px-12 tw-py-2",
  [ContentSize.SMALL_1]: "tw-py-4 tw-px-2",
  [ContentSize.SMALL_2]: "tw-p-4",
  [ContentSize.SMALL_3]: "tw-py-4 tw-px-6",
  [ContentSize.SMALL_4]: "tw-py-4 tw-px-8",
  [ContentSize.SMALL_5]: "tw-py-4 tw-px-12",
  [ContentSize.MEDIUM_1]: "tw-py-6 tw-px-2",
  [ContentSize.MEDIUM_2]: "tw-py-6 tw-px-4",
  [ContentSize.MEDIUM_3]: "tw-p-6",
  [ContentSize.MEDIUM_4]: "tw-py-6 tw-px-8",
  [ContentSize.MEDIUM_5]: "tw-py-6 tw-px-12",
  [ContentSize.LARGE_1]: "tw-py-8 tw-px-2",
  [ContentSize.LARGE_2]: "tw-py-8 tw-px-4",
  [ContentSize.LARGE_3]: "tw-py-8 tw-px-6",
  [ContentSize.LARGE_4]: "tw-p-8",
  [ContentSize.LARGE_5]: "tw-py-8 tw-px-12",
  [ContentSize.HUGE_1]: "tw-py-12 tw-px-2",
  [ContentSize.HUGE_2]: "tw-py-12 tw-px-4",
  [ContentSize.HUGE_3]: "tw-py-12 tw-px-6",
  [ContentSize.HUGE_4]: "tw-py-12 tw-px-8",
  [ContentSize.HUGE_5]: "tw-p-12",
  [ContentSize.CUSTOM_1]: "tw-px-6 tw-py-5"
};
const Card = (_h) => {
  var _i = _h, {
    children: children2,
    shadowSize = ElevationShadowType.SMALL,
    contentSize = ContentSize.FULL,
    hasBorder = true,
    className
  } = _i, props = __objRest(_i, [
    "children",
    "shadowSize",
    "contentSize",
    "hasBorder",
    "className"
  ]);
  return /* @__PURE__ */ jsx$1("div", __spreadProps(__spreadValues({
    className: classNames$1(shadowClasses[shadowSize], ContentClasses[contentSize], {
      "tw-border tw-border-Gray-200": hasBorder
    }, className)
  }, props), {
    children: children2
  }));
};
Card.displayName = "Card";
const ThemeContext$1 = createContext({
  theme: "deeple",
  setTheme: (newTheme) => newTheme
});
function useTheme() {
  const themeContext = useContext(ThemeContext$1);
  return __spreadProps(__spreadValues({}, themeContext), {
    isNFTMode: themeContext.theme === "nft",
    isDeepleMode: themeContext.theme === "deeple"
  });
}
function QuickStartCard({
  className = "",
  imageUrl,
  isSuccess = false,
  onClickPrimary,
  onClickTutorial,
  primaryLabel,
  subTitle,
  title,
  tutorialLabel
}) {
  const {
    isNFTMode
  } = useTheme();
  return /* @__PURE__ */ jsx$1(Card, {
    className: `quick-start-content tw-bg-White ${className}`,
    contentSize: ContentSize.SMALL_2,
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-flex-1 mobile:tw-flex-col tablet:tw-flex-row",
      children: [/* @__PURE__ */ jsx$1("figure", {
        className: classNames$1("tw-m-auto tw-w-48", {
          "tw-bg-Primary-200 tw-w-full tablet:tw-w-[222px] tw-rounded tw-flex tw-justify-center tw-items-center": isNFTMode
        }),
        children: /* @__PURE__ */ jsx$1("img", {
          loading: "lazy",
          src: imageUrl,
          className: classNames$1("tw-w-full", {
            "tw-py-3 tw-px-5 tw-max-w-[222px] tw-max-h-[193px]": isNFTMode
          }),
          alt: "quick-start"
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: classNames$1("tw-flex tw-flex-col tw-flex-1 tw-justify-between", {
          "tw-mt-4 tablet:tw-ml-4": isNFTMode
        }),
        children: [/* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx$1(Typography, {
            variant: "heading-2",
            color: "Dark",
            className: "tw-font-medium mobile:tw-hidden tablet:tw-block",
            children: title
          }), /* @__PURE__ */ jsx$1(Typography, {
            variant: "title-8",
            color: "Dark",
            className: "tw-font-medium mobile:tw-block tablet:tw-hidden",
            children: title
          }), /* @__PURE__ */ jsx$1(Typography, {
            variant: "body-3",
            color: "Gray-500",
            children: subTitle
          })]
        }), /* @__PURE__ */ jsxs("div", {
          className: "tw-flex",
          children: [/* @__PURE__ */ jsxs(Button, {
            variant: "secondary",
            className: "tw-flex tw-justify-center tw-items-center tw-mr-3 tw-font-semibold tw-cursor-pointer quick-start-btn",
            onClick: onClickTutorial,
            children: [/* @__PURE__ */ jsx$1(Icon, {
              name: IconName.CIRCLE_PLAY,
              size: IconSize.LARGE,
              className: "tw-fill-Gray-400"
            }), tutorialLabel]
          }), /* @__PURE__ */ jsxs(Button, {
            variant: "primary",
            className: classNames$1("tw-flex tw-justify-center tw-items-center tw-font-semibold disabled:tw-text-Gray-400 disabled:tw-bg-Gray-200 tw-cursor-pointer quick-start-btn", {
              "tw-bg-Green-500": isSuccess && isNFTMode
            }),
            onClick: onClickPrimary,
            children: [isSuccess && /* @__PURE__ */ jsx$1(Icon, {
              name: isNFTMode ? IconName.CHECK : IconName.CIRCLE_CHECK,
              color: isNFTMode ? COLORS.White : COLORS.Primary[600],
              size: isNFTMode ? IconSize.SMALL : IconSize.LARGE,
              className: "tw-mr-2 tw-fill-White"
            }), primaryLabel]
          })]
        })]
      })]
    })
  });
}
const GTM_EVENT = {
  SIGNUP: "signup",
  LOGIN: "login",
  PASSWORD_RESET: "password_reset",
  CREATE_STORE: "create_store",
  ADD_CATALOG: "add_catalog",
  ADD_PRODUCT: "add_product",
  ADD_SHIPPING: "add_shipping",
  ADD_TO_CART: "add_to_cart",
  ADD_CREDIT_CARD: "add_credit_card",
  ADD_BILLING_INFO: "add_billing_info",
  AI_SETTING: "ai_setting",
  SET_FIRST_MESSAGE: "set_first_message",
  ADD_KNOWLEDGE: "add_knowledge",
  SET_SYNONYM_PRODUCT_NAME: "set_synonym_product_name",
  COMPLETELY_CONNECTED_STORES: "completely_connected_stores",
  PURCHASE: "purchase"
};
const GTM_VARIABLE_NAME = {
  CHANNEL: "channel",
  LOGIN_METHOD: "login_method",
  USER_ID: "user_id",
  TYPE_OF_BUSINESS: "type_of_business",
  STORES: "stores"
};
const GTM_CHANNEL = {
  GOOGLE: "google",
  FACEBOOK: "facebook",
  INSTAGRAM: "instagram",
  EMAIL: "email",
  LINE: "line"
};
var gtm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GTM_EVENT,
  GTM_VARIABLE_NAME,
  GTM_CHANNEL
}, Symbol.toStringTag, { value: "Module" }));
const NotAllowThisFeatureModal = (props) => {
  const {
    t: t2,
    i18n
  } = useTranslation();
  const {
    isOpen,
    lang = "th",
    onClickUpgrade
  } = props;
  useEffect(() => {
    void i18n.changeLanguage(lang);
  }, [lang, i18n]);
  return /* @__PURE__ */ jsx$1(Modal, {
    isOpen,
    size: "medium",
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-box-border tw-p-6 tw-px-0 md:tw-px-6 tw-m-auto tw-max-w-full tw-text-center web-console",
      style: {
        width: 575
      },
      children: [/* @__PURE__ */ jsx$1("img", {
        src: NOT_ALLOW_THIS_FEATURE,
        alt: "upgrade-plan-success",
        className: "tw-m-auto"
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-1",
        className: "tw-mt-4",
        children: t2("plan.notAllowFeatureModal.title")
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-3",
        className: "tw-m-auto tw-mt-4 tw-max-w-full",
        style: {
          width: 468
        },
        color: COLORS.Gray[500],
        children: t2("plan.notAllowFeatureModal.description1")
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-3",
        className: "tw-m-auto tw-mt-4 tw-max-w-full",
        style: {
          width: 468
        },
        color: COLORS.Gray[500],
        children: t2("plan.notAllowFeatureModal.description2")
      }), /* @__PURE__ */ jsx$1(Button, {
        variant: "primary",
        size: "large",
        className: "tw-mt-7",
        onClick: onClickUpgrade,
        children: t2("plan.notAllowFeatureModal.upgradeButton")
      })]
    })
  });
};
const UpgradePlanSuccessModal = (props) => {
  const {
    t: t2,
    i18n
  } = useTranslation();
  const {
    isOpen,
    onClickDone,
    lang = "th",
    billingDate,
    isDuringFreeTrialPeriod,
    packageName
  } = props;
  useEffect(() => {
    void i18n.changeLanguage(lang);
  }, [lang, i18n]);
  return /* @__PURE__ */ jsx$1(Modal, {
    isOpen,
    size: "medium",
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-box-border tw-p-6 tw-px-0 md:tw-px-6 tw-m-auto tw-max-w-full tw-text-center web-console",
      style: {
        width: 575
      },
      children: [/* @__PURE__ */ jsx$1("img", {
        src: UPGRADE_PLAN_SUCCESS,
        alt: "upgrade-plan-success",
        className: "tw-m-auto"
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-1",
        className: "tw-mt-4",
        children: t2("plan.upgradePlan.successModal.title")
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-3",
        className: "tw-m-auto tw-mt-4 tw-max-w-full",
        style: {
          width: 468
        },
        color: COLORS.Gray[600],
        children: t2("plan.upgradePlan.successModal.startPackage", {
          package: packageName
        })
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-3",
        className: "tw-m-auto tw-mt-4 tw-max-w-full",
        style: {
          width: 468
        },
        color: COLORS.Gray[500],
        children: isDuringFreeTrialPeriod ? t2("plan.upgradePlan.successModal.fromFreePackage") : t2("plan.upgradePlan.successModal.fromPaidPackage")
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-9",
        className: "tw-m-auto tw-mt-4 tw-max-w-full",
        style: {
          width: 468
        },
        color: COLORS.DarkLight,
        children: t2("plan.upgradePlan.successModal.nextBillingDate", {
          billingDate
        })
      }), /* @__PURE__ */ jsx$1(Button, {
        variant: "primary",
        size: "large",
        className: "tw-mt-7",
        onClick: onClickDone,
        children: t2("plan.upgradePlan.successModal.doneButton")
      })]
    })
  });
};
const LoadingPopup$1 = ({
  isOpen
}) => {
  return isOpen ? /* @__PURE__ */ jsxs("div", {
    className: "tw-flex tw-fixed tw-top-0 tw-left-0 tw-z-[20000] tw-justify-center tw-items-center tw-w-screen tw-h-screen",
    children: [/* @__PURE__ */ jsx$1("div", {
      className: "tw-w-screen tw-h-screen tw-bg-Gray-700 tw-opacity-30 "
    }), /* @__PURE__ */ jsx$1("div", {
      className: "tw-flex tw-fixed tw-top-0 tw-left-0 tw-z-[30000] tw-justify-center tw-items-center tw-w-screen tw-h-screen",
      children: /* @__PURE__ */ jsx$1("div", {
        className: "tw-p-1 tw-w-fit tw-h-fit tw-bg-Gray-0 tw-rounded-[50%] tw-shadow-sm",
        children: /* @__PURE__ */ jsx$1("img", {
          className: "mobile:tw-w-16 tablet:tw-w-24",
          src: LOADING,
          alt: "loading"
        })
      })
    })]
  }) : null;
};
const Step = ({
  steps,
  completed
}) => {
  return /* @__PURE__ */ jsx$1("div", {
    className: "tw-flex tw-space-x-1 tw-h-2",
    children: Array.from({
      length: steps
    }, (_23, index2) => /* @__PURE__ */ jsx$1("div", {
      className: classNames$1("tw-flex-1 tw-rounded", index2 < completed ? "tw-bg-LightPrimary" : "tw-bg-NudePrimary")
    }, index2))
  });
};
Step.displayName = "Step";
const QuickStartBroadcastBar$1 = ({
  steps,
  completed,
  nextStep,
  currentPage,
  isCurrentPageCompleted = false,
  isRequiredStepsCompleted = false,
  onAllSettingsClick,
  onActionClick,
  onDone,
  lang = "th"
}) => {
  const {
    t: t2,
    i18n
  } = useTranslation();
  useEffect(() => {
    setTimeout(() => {
      void i18n.changeLanguage(lang);
    }, 0);
  }, [lang, i18n]);
  return /* @__PURE__ */ jsx$1(Alert, {
    type: "quickstart",
    Icon: () => /* @__PURE__ */ jsx$1(Icon, {
      name: IconName.STORE,
      size: IconSize.MEDIUM,
      className: "tw-fill-Primary-600"
    }),
    Action: () => /* @__PURE__ */ jsxs(Fragment, {
      children: [!isRequiredStepsCompleted && /* @__PURE__ */ jsx$1(Button, {
        variant: "tertiary",
        size: "small",
        onClick: onAllSettingsClick,
        children: t2("gettingStarted.allSettings")
      }), isRequiredStepsCompleted && /* @__PURE__ */ jsx$1(Button, {
        variant: "tertiary",
        size: "small",
        onClick: onDone,
        children: t2("gettingStarted.done")
      }), nextStep && nextStep !== currentPage && /* @__PURE__ */ jsx$1(Button, {
        className: "tw-ml-4",
        variant: "primary",
        size: "small",
        onClick: onActionClick,
        children: t2(`gettingStarted.steps.${nextStep}.button`)
      })]
    }),
    children: /* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsx$1(Typography, {
        variant: "title-7",
        className: "tw-text-Gray-700",
        children: currentPage !== "any" ? t2(`gettingStarted.steps.${currentPage}.${isCurrentPageCompleted ? "completed" : "incomplete"}.title`) : t2(`gettingStarted.steps.default.title`)
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-3",
        className: "tw-mb-1 tw-text-Gray-500",
        children: t2("gettingStarted.steps.default.subtitle", {
          steps,
          completed
        })
      }), /* @__PURE__ */ jsx$1(Step, {
        steps,
        completed
      })]
    })
  });
};
QuickStartBroadcastBar$1.displayName = "QuickStartBroadcastBar";
const YourStoreIsCreatedModal = (props) => {
  const {
    t: t2,
    i18n
  } = useTranslation();
  const {
    isOpen,
    lang = "th",
    isSetupBotCompleted,
    onClickNextStep,
    onDone,
    onClose
  } = props;
  useEffect(() => {
    void i18n.changeLanguage(lang);
  }, [lang, i18n]);
  return /* @__PURE__ */ jsx$1(Modal, {
    isOpen,
    size: "medium",
    onClose,
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-box-border tw-text-center web-console",
      children: [/* @__PURE__ */ jsx$1("img", {
        src: STORE_CREATED,
        alt: "your-store-is-created",
        className: "tw-m-auto"
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-1",
        children: t2("gettingStarted.modal.storeCreated.title")
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-3",
        className: "tw-mt-4 tw-text-Gray-500",
        children: t2("gettingStarted.modal.storeCreated.subtitle")
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-flex-col tw-m-auto tw-mt-7 mobile:tw-flex-row mobile:tw-space-y-0 mobile:tw-space-x-4",
        children: [!isSetupBotCompleted && /* @__PURE__ */ jsx$1(Button, {
          variant: "text",
          size: "large",
          className: "tw-order-last tw-mt-4 tw-w-full mobile:tw-order-first mobile:tw-mt-0",
          onClick: onClickNextStep,
          children: t2("gettingStarted.modal.storeCreated.trainBot")
        }), /* @__PURE__ */ jsx$1(Button, {
          variant: "primary",
          size: "large",
          className: "tw-w-full",
          onClick: onDone,
          children: t2("gettingStarted.modal.storeCreated.done")
        })]
      })]
    })
  });
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(d2, b2) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
    d3.__proto__ = b3;
  } || function(d3, b3) {
    for (var p2 in b3)
      if (b3.hasOwnProperty(p2))
        d3[p2] = b3[p2];
  };
  return extendStatics(d2, b2);
};
function __extends(d2, b2) {
  extendStatics(d2, b2);
  function __() {
    this.constructor = d2;
  }
  d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
}
var __assign$1 = function() {
  __assign$1 = Object.assign || function __assign2(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$1.apply(this, arguments);
};
(function(Object2) {
  typeof globalThis !== "object" && (this ? get2() : (Object2.defineProperty(Object2.prototype, "_T_", {
    configurable: true,
    get: get2
  }), _T_));
  function get2() {
    var global2 = this || self;
    global2.globalThis = global2;
    delete Object2.prototype._T_;
  }
})(Object);
var globalThis$1 = globalThis;
var global$1 = globalThis$1;
var console$1 = global$1.console;
var genericMessage = "Invariant Violation";
var _a$1 = Object.setPrototypeOf, setPrototypeOf = _a$1 === void 0 ? function(obj, proto) {
  obj.__proto__ = proto;
  return obj;
} : _a$1;
var InvariantError = function(_super) {
  __extends(InvariantError2, _super);
  function InvariantError2(message) {
    if (message === void 0) {
      message = genericMessage;
    }
    var _this = _super.call(this, typeof message === "number" ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
    _this.framesToPop = 1;
    _this.name = genericMessage;
    setPrototypeOf(_this, InvariantError2.prototype);
    return _this;
  }
  return InvariantError2;
}(Error);
function invariant$1(condition, message) {
  if (!condition) {
    throw new InvariantError(message);
  }
}
var verbosityLevels = ["log", "warn", "error", "silent"];
var verbosityLevel = verbosityLevels.indexOf("log");
function wrapConsoleMethod(method) {
  return function() {
    if (verbosityLevels.indexOf(method) >= verbosityLevel) {
      return console$1[method].apply(console$1, arguments);
    }
  };
}
(function(invariant2) {
  invariant2.log = wrapConsoleMethod("log");
  invariant2.warn = wrapConsoleMethod("warn");
  invariant2.error = wrapConsoleMethod("error");
})(invariant$1 || (invariant$1 = {}));
function setVerbosity(level) {
  var old = verbosityLevels[verbosityLevel];
  verbosityLevel = Math.max(0, verbosityLevels.indexOf(level));
  return old;
}
var processStub = global$1.process || { env: {} };
if (!global$1.process)
  try {
    Object.defineProperty(globalThis$1, "process", {
      value: processStub,
      writable: true,
      enumerable: false,
      configurable: true
    });
  } catch (_b) {
  }
function isNonEmptyArray(value) {
  return Array.isArray(value) && value.length > 0;
}
var canUseWeakMap = typeof WeakMap === "function" && !(typeof navigator === "object" && navigator.product === "ReactNative");
function compact$1() {
  var objects = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    objects[_i] = arguments[_i];
  }
  var result = Object.create(null);
  objects.forEach(function(obj) {
    if (!obj)
      return;
    Object.keys(obj).forEach(function(key) {
      var value = obj[key];
      if (value !== void 0) {
        result[key] = value;
      }
    });
  });
  return result;
}
var _a = Object.prototype, toString$8 = _a.toString, hasOwnProperty$d = _a.hasOwnProperty;
var fnToStr = Function.prototype.toString;
var previousComparisons = new Map();
function equal$1(a2, b2) {
  try {
    return check(a2, b2);
  } finally {
    previousComparisons.clear();
  }
}
function check(a2, b2) {
  if (a2 === b2) {
    return true;
  }
  var aTag = toString$8.call(a2);
  var bTag = toString$8.call(b2);
  if (aTag !== bTag) {
    return false;
  }
  switch (aTag) {
    case "[object Array]":
      if (a2.length !== b2.length)
        return false;
    case "[object Object]": {
      if (previouslyCompared(a2, b2))
        return true;
      var aKeys = definedKeys(a2);
      var bKeys = definedKeys(b2);
      var keyCount = aKeys.length;
      if (keyCount !== bKeys.length)
        return false;
      for (var k2 = 0; k2 < keyCount; ++k2) {
        if (!hasOwnProperty$d.call(b2, aKeys[k2])) {
          return false;
        }
      }
      for (var k2 = 0; k2 < keyCount; ++k2) {
        var key = aKeys[k2];
        if (!check(a2[key], b2[key])) {
          return false;
        }
      }
      return true;
    }
    case "[object Error]":
      return a2.name === b2.name && a2.message === b2.message;
    case "[object Number]":
      if (a2 !== a2)
        return b2 !== b2;
    case "[object Boolean]":
    case "[object Date]":
      return +a2 === +b2;
    case "[object RegExp]":
    case "[object String]":
      return a2 == "" + b2;
    case "[object Map]":
    case "[object Set]": {
      if (a2.size !== b2.size)
        return false;
      if (previouslyCompared(a2, b2))
        return true;
      var aIterator = a2.entries();
      var isMap = aTag === "[object Map]";
      while (true) {
        var info = aIterator.next();
        if (info.done)
          break;
        var _a2 = info.value, aKey = _a2[0], aValue = _a2[1];
        if (!b2.has(aKey)) {
          return false;
        }
        if (isMap && !check(aValue, b2.get(aKey))) {
          return false;
        }
      }
      return true;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      var aCode = fnToStr.call(a2);
      if (aCode !== fnToStr.call(b2)) {
        return false;
      }
      return !endsWith(aCode, nativeCodeSuffix);
    }
  }
  return false;
}
function definedKeys(obj) {
  return Object.keys(obj).filter(isDefinedKey, obj);
}
function isDefinedKey(key) {
  return this[key] !== void 0;
}
var nativeCodeSuffix = "{ [native code] }";
function endsWith(full, suffix) {
  var fromIndex = full.length - suffix.length;
  return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function previouslyCompared(a2, b2) {
  var bSet = previousComparisons.get(a2);
  if (bSet) {
    if (bSet.has(b2))
      return true;
  } else {
    previousComparisons.set(a2, bSet = new Set());
  }
  bSet.add(b2);
  return false;
}
var generateErrorMessage = function(err) {
  var message = "";
  if (isNonEmptyArray(err.graphQLErrors)) {
    err.graphQLErrors.forEach(function(graphQLError) {
      var errorMessage = graphQLError ? graphQLError.message : "Error message not found.";
      message += errorMessage + "\n";
    });
  }
  if (err.networkError) {
    message += err.networkError.message + "\n";
  }
  message = message.replace(/\n$/, "");
  return message;
};
var ApolloError = function(_super) {
  __extends(ApolloError2, _super);
  function ApolloError2(_a2) {
    var graphQLErrors = _a2.graphQLErrors, networkError = _a2.networkError, errorMessage = _a2.errorMessage, extraInfo = _a2.extraInfo;
    var _this = _super.call(this, errorMessage) || this;
    _this.graphQLErrors = graphQLErrors || [];
    _this.networkError = networkError || null;
    _this.message = errorMessage || generateErrorMessage(_this);
    _this.extraInfo = extraInfo;
    _this.__proto__ = ApolloError2.prototype;
    return _this;
  }
  return ApolloError2;
}(Error);
var NetworkStatus;
(function(NetworkStatus2) {
  NetworkStatus2[NetworkStatus2["loading"] = 1] = "loading";
  NetworkStatus2[NetworkStatus2["setVariables"] = 2] = "setVariables";
  NetworkStatus2[NetworkStatus2["fetchMore"] = 3] = "fetchMore";
  NetworkStatus2[NetworkStatus2["refetch"] = 4] = "refetch";
  NetworkStatus2[NetworkStatus2["poll"] = 6] = "poll";
  NetworkStatus2[NetworkStatus2["ready"] = 7] = "ready";
  NetworkStatus2[NetworkStatus2["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
function mergeOptions(defaults2, options2) {
  return compact$1(defaults2, options2, options2.variables && {
    variables: __assign$1(__assign$1({}, defaults2.variables), options2.variables)
  });
}
var __assign = function() {
  __assign = Object.assign || function __assign2(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
function devAssert(condition, message) {
  const booleanCondition = Boolean(condition);
  if (!booleanCondition) {
    throw new Error(message);
  }
}
function isObjectLike$6(value) {
  return typeof value == "object" && value !== null;
}
function invariant(condition, message) {
  const booleanCondition = Boolean(condition);
  if (!booleanCondition) {
    throw new Error(message != null ? message : "Unexpected invariant triggered.");
  }
}
const LineRegExp = /\r\n|[\n\r]/g;
function getLocation(source2, position2) {
  let lastLineStart = 0;
  let line2 = 1;
  for (const match2 of source2.body.matchAll(LineRegExp)) {
    typeof match2.index === "number" || invariant(false);
    if (match2.index >= position2) {
      break;
    }
    lastLineStart = match2.index + match2[0].length;
    line2 += 1;
  }
  return {
    line: line2,
    column: position2 + 1 - lastLineStart
  };
}
function printLocation(location) {
  return printSourceLocation(location.source, getLocation(location.source, location.start));
}
function printSourceLocation(source2, sourceLocation) {
  const firstLineColumnOffset = source2.locationOffset.column - 1;
  const body = "".padStart(firstLineColumnOffset) + source2.body;
  const lineIndex = sourceLocation.line - 1;
  const lineOffset = source2.locationOffset.line - 1;
  const lineNum = sourceLocation.line + lineOffset;
  const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  const columnNum = sourceLocation.column + columnOffset;
  const locationStr = `${source2.name}:${lineNum}:${columnNum}
`;
  const lines = body.split(/\r\n|[\n\r]/g);
  const locationLine = lines[lineIndex];
  if (locationLine.length > 120) {
    const subLineIndex = Math.floor(columnNum / 80);
    const subLineColumnNum = columnNum % 80;
    const subLines = [];
    for (let i2 = 0; i2 < locationLine.length; i2 += 80) {
      subLines.push(locationLine.slice(i2, i2 + 80));
    }
    return locationStr + printPrefixedLines([
      [`${lineNum} |`, subLines[0]],
      ...subLines.slice(1, subLineIndex + 1).map((subLine) => ["|", subLine]),
      ["|", "^".padStart(subLineColumnNum)],
      ["|", subLines[subLineIndex + 1]]
    ]);
  }
  return locationStr + printPrefixedLines([
    [`${lineNum - 1} |`, lines[lineIndex - 1]],
    [`${lineNum} |`, locationLine],
    ["|", "^".padStart(columnNum)],
    [`${lineNum + 1} |`, lines[lineIndex + 1]]
  ]);
}
function printPrefixedLines(lines) {
  const existingLines = lines.filter(([_23, line2]) => line2 !== void 0);
  const padLen = Math.max(...existingLines.map(([prefix2]) => prefix2.length));
  return existingLines.map(([prefix2, line2]) => prefix2.padStart(padLen) + (line2 ? " " + line2 : "")).join("\n");
}
function toNormalizedOptions(args) {
  const firstArg = args[0];
  if (firstArg == null || "kind" in firstArg || "length" in firstArg) {
    return {
      nodes: firstArg,
      source: args[1],
      positions: args[2],
      path: args[3],
      originalError: args[4],
      extensions: args[5]
    };
  }
  return firstArg;
}
class GraphQLError extends Error {
  constructor(message, ...rawArgs) {
    var _this$nodes, _nodeLocations$, _ref3;
    const { nodes, source: source2, positions, path, originalError, extensions } = toNormalizedOptions(rawArgs);
    super(message);
    this.name = "GraphQLError";
    this.path = path !== null && path !== void 0 ? path : void 0;
    this.originalError = originalError !== null && originalError !== void 0 ? originalError : void 0;
    this.nodes = undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [nodes] : void 0);
    const nodeLocations = undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node2) => node2.loc).filter((loc) => loc != null));
    this.source = source2 !== null && source2 !== void 0 ? source2 : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
    this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc) => loc.start);
    this.locations = positions && source2 ? positions.map((pos) => getLocation(source2, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc) => getLocation(loc.source, loc.start));
    const originalExtensions = isObjectLike$6(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : void 0;
    this.extensions = (_ref3 = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref3 !== void 0 ? _ref3 : Object.create(null);
    Object.defineProperties(this, {
      message: {
        writable: true,
        enumerable: true
      },
      name: {
        enumerable: false
      },
      nodes: {
        enumerable: false
      },
      source: {
        enumerable: false
      },
      positions: {
        enumerable: false
      },
      originalError: {
        enumerable: false
      }
    });
    if (originalError !== null && originalError !== void 0 && originalError.stack) {
      Object.defineProperty(this, "stack", {
        value: originalError.stack,
        writable: true,
        configurable: true
      });
    } else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GraphQLError);
    } else {
      Object.defineProperty(this, "stack", {
        value: Error().stack,
        writable: true,
        configurable: true
      });
    }
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let output2 = this.message;
    if (this.nodes) {
      for (const node2 of this.nodes) {
        if (node2.loc) {
          output2 += "\n\n" + printLocation(node2.loc);
        }
      }
    } else if (this.source && this.locations) {
      for (const location of this.locations) {
        output2 += "\n\n" + printSourceLocation(this.source, location);
      }
    }
    return output2;
  }
  toJSON() {
    const formattedError = {
      message: this.message
    };
    if (this.locations != null) {
      formattedError.locations = this.locations;
    }
    if (this.path != null) {
      formattedError.path = this.path;
    }
    if (this.extensions != null && Object.keys(this.extensions).length > 0) {
      formattedError.extensions = this.extensions;
    }
    return formattedError;
  }
}
function undefinedIfEmpty(array2) {
  return array2 === void 0 || array2.length === 0 ? void 0 : array2;
}
function syntaxError(source2, position2, description) {
  return new GraphQLError(`Syntax Error: ${description}`, {
    source: source2,
    positions: [position2]
  });
}
class Location {
  constructor(startToken, endToken, source2) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source2;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class Token {
  constructor(kind, start2, end2, line2, column2, value) {
    this.kind = kind;
    this.start = start2;
    this.end = end2;
    this.line = line2;
    this.column = column2;
    this.value = value;
    this.prev = null;
    this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
var OperationTypeNode;
(function(OperationTypeNode2) {
  OperationTypeNode2["QUERY"] = "query";
  OperationTypeNode2["MUTATION"] = "mutation";
  OperationTypeNode2["SUBSCRIPTION"] = "subscription";
})(OperationTypeNode || (OperationTypeNode = {}));
var DirectiveLocation;
(function(DirectiveLocation2) {
  DirectiveLocation2["QUERY"] = "QUERY";
  DirectiveLocation2["MUTATION"] = "MUTATION";
  DirectiveLocation2["SUBSCRIPTION"] = "SUBSCRIPTION";
  DirectiveLocation2["FIELD"] = "FIELD";
  DirectiveLocation2["FRAGMENT_DEFINITION"] = "FRAGMENT_DEFINITION";
  DirectiveLocation2["FRAGMENT_SPREAD"] = "FRAGMENT_SPREAD";
  DirectiveLocation2["INLINE_FRAGMENT"] = "INLINE_FRAGMENT";
  DirectiveLocation2["VARIABLE_DEFINITION"] = "VARIABLE_DEFINITION";
  DirectiveLocation2["SCHEMA"] = "SCHEMA";
  DirectiveLocation2["SCALAR"] = "SCALAR";
  DirectiveLocation2["OBJECT"] = "OBJECT";
  DirectiveLocation2["FIELD_DEFINITION"] = "FIELD_DEFINITION";
  DirectiveLocation2["ARGUMENT_DEFINITION"] = "ARGUMENT_DEFINITION";
  DirectiveLocation2["INTERFACE"] = "INTERFACE";
  DirectiveLocation2["UNION"] = "UNION";
  DirectiveLocation2["ENUM"] = "ENUM";
  DirectiveLocation2["ENUM_VALUE"] = "ENUM_VALUE";
  DirectiveLocation2["INPUT_OBJECT"] = "INPUT_OBJECT";
  DirectiveLocation2["INPUT_FIELD_DEFINITION"] = "INPUT_FIELD_DEFINITION";
})(DirectiveLocation || (DirectiveLocation = {}));
var Kind;
(function(Kind2) {
  Kind2["NAME"] = "Name";
  Kind2["DOCUMENT"] = "Document";
  Kind2["OPERATION_DEFINITION"] = "OperationDefinition";
  Kind2["VARIABLE_DEFINITION"] = "VariableDefinition";
  Kind2["SELECTION_SET"] = "SelectionSet";
  Kind2["FIELD"] = "Field";
  Kind2["ARGUMENT"] = "Argument";
  Kind2["FRAGMENT_SPREAD"] = "FragmentSpread";
  Kind2["INLINE_FRAGMENT"] = "InlineFragment";
  Kind2["FRAGMENT_DEFINITION"] = "FragmentDefinition";
  Kind2["VARIABLE"] = "Variable";
  Kind2["INT"] = "IntValue";
  Kind2["FLOAT"] = "FloatValue";
  Kind2["STRING"] = "StringValue";
  Kind2["BOOLEAN"] = "BooleanValue";
  Kind2["NULL"] = "NullValue";
  Kind2["ENUM"] = "EnumValue";
  Kind2["LIST"] = "ListValue";
  Kind2["OBJECT"] = "ObjectValue";
  Kind2["OBJECT_FIELD"] = "ObjectField";
  Kind2["DIRECTIVE"] = "Directive";
  Kind2["NAMED_TYPE"] = "NamedType";
  Kind2["LIST_TYPE"] = "ListType";
  Kind2["NON_NULL_TYPE"] = "NonNullType";
  Kind2["SCHEMA_DEFINITION"] = "SchemaDefinition";
  Kind2["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
  Kind2["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
  Kind2["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
  Kind2["FIELD_DEFINITION"] = "FieldDefinition";
  Kind2["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
  Kind2["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
  Kind2["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
  Kind2["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
  Kind2["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
  Kind2["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
  Kind2["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
  Kind2["SCHEMA_EXTENSION"] = "SchemaExtension";
  Kind2["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
  Kind2["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
  Kind2["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
  Kind2["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
  Kind2["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
  Kind2["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
})(Kind || (Kind = {}));
function isWhiteSpace(code) {
  return code === 9 || code === 32;
}
function isDigit(code) {
  return code >= 48 && code <= 57;
}
function isLetter(code) {
  return code >= 97 && code <= 122 || code >= 65 && code <= 90;
}
function isNameStart(code) {
  return isLetter(code) || code === 95;
}
function isNameContinue(code) {
  return isLetter(code) || isDigit(code) || code === 95;
}
function dedentBlockStringLines(lines) {
  var _firstNonEmptyLine2;
  let commonIndent = Number.MAX_SAFE_INTEGER;
  let firstNonEmptyLine = null;
  let lastNonEmptyLine = -1;
  for (let i2 = 0; i2 < lines.length; ++i2) {
    var _firstNonEmptyLine;
    const line2 = lines[i2];
    const indent = leadingWhitespace(line2);
    if (indent === line2.length) {
      continue;
    }
    firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i2;
    lastNonEmptyLine = i2;
    if (i2 !== 0 && indent < commonIndent) {
      commonIndent = indent;
    }
  }
  return lines.map((line2, i2) => i2 === 0 ? line2 : line2.slice(commonIndent)).slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function leadingWhitespace(str) {
  let i2 = 0;
  while (i2 < str.length && isWhiteSpace(str.charCodeAt(i2))) {
    ++i2;
  }
  return i2;
}
var TokenKind;
(function(TokenKind2) {
  TokenKind2["SOF"] = "<SOF>";
  TokenKind2["EOF"] = "<EOF>";
  TokenKind2["BANG"] = "!";
  TokenKind2["DOLLAR"] = "$";
  TokenKind2["AMP"] = "&";
  TokenKind2["PAREN_L"] = "(";
  TokenKind2["PAREN_R"] = ")";
  TokenKind2["SPREAD"] = "...";
  TokenKind2["COLON"] = ":";
  TokenKind2["EQUALS"] = "=";
  TokenKind2["AT"] = "@";
  TokenKind2["BRACKET_L"] = "[";
  TokenKind2["BRACKET_R"] = "]";
  TokenKind2["BRACE_L"] = "{";
  TokenKind2["PIPE"] = "|";
  TokenKind2["BRACE_R"] = "}";
  TokenKind2["NAME"] = "Name";
  TokenKind2["INT"] = "Int";
  TokenKind2["FLOAT"] = "Float";
  TokenKind2["STRING"] = "String";
  TokenKind2["BLOCK_STRING"] = "BlockString";
  TokenKind2["COMMENT"] = "Comment";
})(TokenKind || (TokenKind = {}));
class Lexer {
  constructor(source2) {
    const startOfFileToken = new Token(TokenKind.SOF, 0, 0, 0, 0);
    this.source = source2;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  advance() {
    this.lastToken = this.token;
    const token2 = this.token = this.lookahead();
    return token2;
  }
  lookahead() {
    let token2 = this.token;
    if (token2.kind !== TokenKind.EOF) {
      do {
        if (token2.next) {
          token2 = token2.next;
        } else {
          const nextToken = readNextToken(this, token2.end);
          token2.next = nextToken;
          nextToken.prev = token2;
          token2 = nextToken;
        }
      } while (token2.kind === TokenKind.COMMENT);
    }
    return token2;
  }
}
function isPunctuatorTokenKind(kind) {
  return kind === TokenKind.BANG || kind === TokenKind.DOLLAR || kind === TokenKind.AMP || kind === TokenKind.PAREN_L || kind === TokenKind.PAREN_R || kind === TokenKind.SPREAD || kind === TokenKind.COLON || kind === TokenKind.EQUALS || kind === TokenKind.AT || kind === TokenKind.BRACKET_L || kind === TokenKind.BRACKET_R || kind === TokenKind.BRACE_L || kind === TokenKind.PIPE || kind === TokenKind.BRACE_R;
}
function isUnicodeScalarValue(code) {
  return code >= 0 && code <= 55295 || code >= 57344 && code <= 1114111;
}
function isSupplementaryCodePoint(body, location) {
  return isLeadingSurrogate(body.charCodeAt(location)) && isTrailingSurrogate(body.charCodeAt(location + 1));
}
function isLeadingSurrogate(code) {
  return code >= 55296 && code <= 56319;
}
function isTrailingSurrogate(code) {
  return code >= 56320 && code <= 57343;
}
function printCodePointAt(lexer, location) {
  const code = lexer.source.body.codePointAt(location);
  if (code === void 0) {
    return TokenKind.EOF;
  } else if (code >= 32 && code <= 126) {
    const char2 = String.fromCodePoint(code);
    return char2 === '"' ? `'"'` : `"${char2}"`;
  }
  return "U+" + code.toString(16).toUpperCase().padStart(4, "0");
}
function createToken(lexer, kind, start2, end2, value) {
  const line2 = lexer.line;
  const col = 1 + start2 - lexer.lineStart;
  return new Token(kind, start2, end2, line2, col, value);
}
function readNextToken(lexer, start2) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position2 = start2;
  while (position2 < bodyLength) {
    const code = body.charCodeAt(position2);
    switch (code) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++position2;
        continue;
      case 10:
        ++position2;
        ++lexer.line;
        lexer.lineStart = position2;
        continue;
      case 13:
        if (body.charCodeAt(position2 + 1) === 10) {
          position2 += 2;
        } else {
          ++position2;
        }
        ++lexer.line;
        lexer.lineStart = position2;
        continue;
      case 35:
        return readComment(lexer, position2);
      case 33:
        return createToken(lexer, TokenKind.BANG, position2, position2 + 1);
      case 36:
        return createToken(lexer, TokenKind.DOLLAR, position2, position2 + 1);
      case 38:
        return createToken(lexer, TokenKind.AMP, position2, position2 + 1);
      case 40:
        return createToken(lexer, TokenKind.PAREN_L, position2, position2 + 1);
      case 41:
        return createToken(lexer, TokenKind.PAREN_R, position2, position2 + 1);
      case 46:
        if (body.charCodeAt(position2 + 1) === 46 && body.charCodeAt(position2 + 2) === 46) {
          return createToken(lexer, TokenKind.SPREAD, position2, position2 + 3);
        }
        break;
      case 58:
        return createToken(lexer, TokenKind.COLON, position2, position2 + 1);
      case 61:
        return createToken(lexer, TokenKind.EQUALS, position2, position2 + 1);
      case 64:
        return createToken(lexer, TokenKind.AT, position2, position2 + 1);
      case 91:
        return createToken(lexer, TokenKind.BRACKET_L, position2, position2 + 1);
      case 93:
        return createToken(lexer, TokenKind.BRACKET_R, position2, position2 + 1);
      case 123:
        return createToken(lexer, TokenKind.BRACE_L, position2, position2 + 1);
      case 124:
        return createToken(lexer, TokenKind.PIPE, position2, position2 + 1);
      case 125:
        return createToken(lexer, TokenKind.BRACE_R, position2, position2 + 1);
      case 34:
        if (body.charCodeAt(position2 + 1) === 34 && body.charCodeAt(position2 + 2) === 34) {
          return readBlockString(lexer, position2);
        }
        return readString(lexer, position2);
    }
    if (isDigit(code) || code === 45) {
      return readNumber(lexer, position2, code);
    }
    if (isNameStart(code)) {
      return readName(lexer, position2);
    }
    throw syntaxError(lexer.source, position2, code === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : isUnicodeScalarValue(code) || isSupplementaryCodePoint(body, position2) ? `Unexpected character: ${printCodePointAt(lexer, position2)}.` : `Invalid character: ${printCodePointAt(lexer, position2)}.`);
  }
  return createToken(lexer, TokenKind.EOF, bodyLength, bodyLength);
}
function readComment(lexer, start2) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position2 = start2 + 1;
  while (position2 < bodyLength) {
    const code = body.charCodeAt(position2);
    if (code === 10 || code === 13) {
      break;
    }
    if (isUnicodeScalarValue(code)) {
      ++position2;
    } else if (isSupplementaryCodePoint(body, position2)) {
      position2 += 2;
    } else {
      break;
    }
  }
  return createToken(lexer, TokenKind.COMMENT, start2, position2, body.slice(start2 + 1, position2));
}
function readNumber(lexer, start2, firstCode) {
  const body = lexer.source.body;
  let position2 = start2;
  let code = firstCode;
  let isFloat = false;
  if (code === 45) {
    code = body.charCodeAt(++position2);
  }
  if (code === 48) {
    code = body.charCodeAt(++position2);
    if (isDigit(code)) {
      throw syntaxError(lexer.source, position2, `Invalid number, unexpected digit after 0: ${printCodePointAt(lexer, position2)}.`);
    }
  } else {
    position2 = readDigits(lexer, position2, code);
    code = body.charCodeAt(position2);
  }
  if (code === 46) {
    isFloat = true;
    code = body.charCodeAt(++position2);
    position2 = readDigits(lexer, position2, code);
    code = body.charCodeAt(position2);
  }
  if (code === 69 || code === 101) {
    isFloat = true;
    code = body.charCodeAt(++position2);
    if (code === 43 || code === 45) {
      code = body.charCodeAt(++position2);
    }
    position2 = readDigits(lexer, position2, code);
    code = body.charCodeAt(position2);
  }
  if (code === 46 || isNameStart(code)) {
    throw syntaxError(lexer.source, position2, `Invalid number, expected digit but got: ${printCodePointAt(lexer, position2)}.`);
  }
  return createToken(lexer, isFloat ? TokenKind.FLOAT : TokenKind.INT, start2, position2, body.slice(start2, position2));
}
function readDigits(lexer, start2, firstCode) {
  if (!isDigit(firstCode)) {
    throw syntaxError(lexer.source, start2, `Invalid number, expected digit but got: ${printCodePointAt(lexer, start2)}.`);
  }
  const body = lexer.source.body;
  let position2 = start2 + 1;
  while (isDigit(body.charCodeAt(position2))) {
    ++position2;
  }
  return position2;
}
function readString(lexer, start2) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position2 = start2 + 1;
  let chunkStart = position2;
  let value = "";
  while (position2 < bodyLength) {
    const code = body.charCodeAt(position2);
    if (code === 34) {
      value += body.slice(chunkStart, position2);
      return createToken(lexer, TokenKind.STRING, start2, position2 + 1, value);
    }
    if (code === 92) {
      value += body.slice(chunkStart, position2);
      const escape2 = body.charCodeAt(position2 + 1) === 117 ? body.charCodeAt(position2 + 2) === 123 ? readEscapedUnicodeVariableWidth(lexer, position2) : readEscapedUnicodeFixedWidth(lexer, position2) : readEscapedCharacter(lexer, position2);
      value += escape2.value;
      position2 += escape2.size;
      chunkStart = position2;
      continue;
    }
    if (code === 10 || code === 13) {
      break;
    }
    if (isUnicodeScalarValue(code)) {
      ++position2;
    } else if (isSupplementaryCodePoint(body, position2)) {
      position2 += 2;
    } else {
      throw syntaxError(lexer.source, position2, `Invalid character within String: ${printCodePointAt(lexer, position2)}.`);
    }
  }
  throw syntaxError(lexer.source, position2, "Unterminated string.");
}
function readEscapedUnicodeVariableWidth(lexer, position2) {
  const body = lexer.source.body;
  let point = 0;
  let size = 3;
  while (size < 12) {
    const code = body.charCodeAt(position2 + size++);
    if (code === 125) {
      if (size < 5 || !isUnicodeScalarValue(point)) {
        break;
      }
      return {
        value: String.fromCodePoint(point),
        size
      };
    }
    point = point << 4 | readHexDigit(code);
    if (point < 0) {
      break;
    }
  }
  throw syntaxError(lexer.source, position2, `Invalid Unicode escape sequence: "${body.slice(position2, position2 + size)}".`);
}
function readEscapedUnicodeFixedWidth(lexer, position2) {
  const body = lexer.source.body;
  const code = read16BitHexCode(body, position2 + 2);
  if (isUnicodeScalarValue(code)) {
    return {
      value: String.fromCodePoint(code),
      size: 6
    };
  }
  if (isLeadingSurrogate(code)) {
    if (body.charCodeAt(position2 + 6) === 92 && body.charCodeAt(position2 + 7) === 117) {
      const trailingCode = read16BitHexCode(body, position2 + 8);
      if (isTrailingSurrogate(trailingCode)) {
        return {
          value: String.fromCodePoint(code, trailingCode),
          size: 12
        };
      }
    }
  }
  throw syntaxError(lexer.source, position2, `Invalid Unicode escape sequence: "${body.slice(position2, position2 + 6)}".`);
}
function read16BitHexCode(body, position2) {
  return readHexDigit(body.charCodeAt(position2)) << 12 | readHexDigit(body.charCodeAt(position2 + 1)) << 8 | readHexDigit(body.charCodeAt(position2 + 2)) << 4 | readHexDigit(body.charCodeAt(position2 + 3));
}
function readHexDigit(code) {
  return code >= 48 && code <= 57 ? code - 48 : code >= 65 && code <= 70 ? code - 55 : code >= 97 && code <= 102 ? code - 87 : -1;
}
function readEscapedCharacter(lexer, position2) {
  const body = lexer.source.body;
  const code = body.charCodeAt(position2 + 1);
  switch (code) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: "\n",
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw syntaxError(lexer.source, position2, `Invalid character escape sequence: "${body.slice(position2, position2 + 2)}".`);
}
function readBlockString(lexer, start2) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let lineStart = lexer.lineStart;
  let position2 = start2 + 3;
  let chunkStart = position2;
  let currentLine = "";
  const blockLines = [];
  while (position2 < bodyLength) {
    const code = body.charCodeAt(position2);
    if (code === 34 && body.charCodeAt(position2 + 1) === 34 && body.charCodeAt(position2 + 2) === 34) {
      currentLine += body.slice(chunkStart, position2);
      blockLines.push(currentLine);
      const token2 = createToken(lexer, TokenKind.BLOCK_STRING, start2, position2 + 3, dedentBlockStringLines(blockLines).join("\n"));
      lexer.line += blockLines.length - 1;
      lexer.lineStart = lineStart;
      return token2;
    }
    if (code === 92 && body.charCodeAt(position2 + 1) === 34 && body.charCodeAt(position2 + 2) === 34 && body.charCodeAt(position2 + 3) === 34) {
      currentLine += body.slice(chunkStart, position2);
      chunkStart = position2 + 1;
      position2 += 4;
      continue;
    }
    if (code === 10 || code === 13) {
      currentLine += body.slice(chunkStart, position2);
      blockLines.push(currentLine);
      if (code === 13 && body.charCodeAt(position2 + 1) === 10) {
        position2 += 2;
      } else {
        ++position2;
      }
      currentLine = "";
      chunkStart = position2;
      lineStart = position2;
      continue;
    }
    if (isUnicodeScalarValue(code)) {
      ++position2;
    } else if (isSupplementaryCodePoint(body, position2)) {
      position2 += 2;
    } else {
      throw syntaxError(lexer.source, position2, `Invalid character within String: ${printCodePointAt(lexer, position2)}.`);
    }
  }
  throw syntaxError(lexer.source, position2, "Unterminated string.");
}
function readName(lexer, start2) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position2 = start2 + 1;
  while (position2 < bodyLength) {
    const code = body.charCodeAt(position2);
    if (isNameContinue(code)) {
      ++position2;
    } else {
      break;
    }
  }
  return createToken(lexer, TokenKind.NAME, start2, position2, body.slice(start2, position2));
}
const MAX_ARRAY_LENGTH = 10;
const MAX_RECURSIVE_DEPTH = 2;
function inspect(value) {
  return formatValue(value, []);
}
function formatValue(value, seenValues) {
  switch (typeof value) {
    case "string":
      return JSON.stringify(value);
    case "function":
      return value.name ? `[function ${value.name}]` : "[function]";
    case "object":
      return formatObjectValue(value, seenValues);
    default:
      return String(value);
  }
}
function formatObjectValue(value, previouslySeenValues) {
  if (value === null) {
    return "null";
  }
  if (previouslySeenValues.includes(value)) {
    return "[Circular]";
  }
  const seenValues = [...previouslySeenValues, value];
  if (isJSONable(value)) {
    const jsonValue = value.toJSON();
    if (jsonValue !== value) {
      return typeof jsonValue === "string" ? jsonValue : formatValue(jsonValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }
  return formatObject(value, seenValues);
}
function isJSONable(value) {
  return typeof value.toJSON === "function";
}
function formatObject(object2, seenValues) {
  const entries = Object.entries(object2);
  if (entries.length === 0) {
    return "{}";
  }
  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return "[" + getObjectTag(object2) + "]";
  }
  const properties = entries.map(([key, value]) => key + ": " + formatValue(value, seenValues));
  return "{ " + properties.join(", ") + " }";
}
function formatArray(array2, seenValues) {
  if (array2.length === 0) {
    return "[]";
  }
  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return "[Array]";
  }
  const len = Math.min(MAX_ARRAY_LENGTH, array2.length);
  const remaining = array2.length - len;
  const items = [];
  for (let i2 = 0; i2 < len; ++i2) {
    items.push(formatValue(array2[i2], seenValues));
  }
  if (remaining === 1) {
    items.push("... 1 more item");
  } else if (remaining > 1) {
    items.push(`... ${remaining} more items`);
  }
  return "[" + items.join(", ") + "]";
}
function getObjectTag(object2) {
  const tag = Object.prototype.toString.call(object2).replace(/^\[object /, "").replace(/]$/, "");
  if (tag === "Object" && typeof object2.constructor === "function") {
    const name = object2.constructor.name;
    if (typeof name === "string" && name !== "") {
      return name;
    }
  }
  return tag;
}
const instanceOf = function instanceOf2(value, constructor) {
  return value instanceof constructor;
};
class Source {
  constructor(body, name = "GraphQL request", locationOffset = {
    line: 1,
    column: 1
  }) {
    typeof body === "string" || devAssert(false, `Body must be a string. Received: ${inspect(body)}.`);
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 || devAssert(false, "line in locationOffset is 1-indexed and must be positive.");
    this.locationOffset.column > 0 || devAssert(false, "column in locationOffset is 1-indexed and must be positive.");
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function isSource(source2) {
  return instanceOf(source2, Source);
}
function parse$1(source2, options2) {
  const parser2 = new Parser(source2, options2);
  return parser2.parseDocument();
}
class Parser {
  constructor(source2, options2 = {}) {
    const sourceObj = isSource(source2) ? source2 : new Source(source2);
    this._lexer = new Lexer(sourceObj);
    this._options = options2;
    this._tokenCounter = 0;
  }
  parseName() {
    const token2 = this.expectToken(TokenKind.NAME);
    return this.node(token2, {
      kind: Kind.NAME,
      value: token2.value
    });
  }
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: Kind.DOCUMENT,
      definitions: this.many(TokenKind.SOF, this.parseDefinition, TokenKind.EOF)
    });
  }
  parseDefinition() {
    if (this.peek(TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    }
    const hasDescription = this.peekDescription();
    const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (hasDescription) {
        throw syntaxError(this._lexer.source, this._lexer.token.start, "Unexpected description, descriptions are supported only on type definitions.");
      }
      switch (keywordToken.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(keywordToken);
  }
  parseOperationDefinition() {
    const start2 = this._lexer.token;
    if (this.peek(TokenKind.BRACE_L)) {
      return this.node(start2, {
        kind: Kind.OPERATION_DEFINITION,
        operation: OperationTypeNode.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    }
    const operation = this.parseOperationType();
    let name;
    if (this.peek(TokenKind.NAME)) {
      name = this.parseName();
    }
    return this.node(start2, {
      kind: Kind.OPERATION_DEFINITION,
      operation,
      name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet()
    });
  }
  parseOperationType() {
    const operationToken = this.expectToken(TokenKind.NAME);
    switch (operationToken.value) {
      case "query":
        return OperationTypeNode.QUERY;
      case "mutation":
        return OperationTypeNode.MUTATION;
      case "subscription":
        return OperationTypeNode.SUBSCRIPTION;
    }
    throw this.unexpected(operationToken);
  }
  parseVariableDefinitions() {
    return this.optionalMany(TokenKind.PAREN_L, this.parseVariableDefinition, TokenKind.PAREN_R);
  }
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: Kind.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(TokenKind.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  parseVariable() {
    const start2 = this._lexer.token;
    this.expectToken(TokenKind.DOLLAR);
    return this.node(start2, {
      kind: Kind.VARIABLE,
      name: this.parseName()
    });
  }
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: Kind.SELECTION_SET,
      selections: this.many(TokenKind.BRACE_L, this.parseSelection, TokenKind.BRACE_R)
    });
  }
  parseSelection() {
    return this.peek(TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
  }
  parseField() {
    const start2 = this._lexer.token;
    const nameOrAlias = this.parseName();
    let alias;
    let name;
    if (this.expectOptionalToken(TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }
    return this.node(start2, {
      kind: Kind.FIELD,
      alias,
      name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(TokenKind.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  parseArguments(isConst) {
    const item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(TokenKind.PAREN_L, item, TokenKind.PAREN_R);
  }
  parseArgument(isConst = false) {
    const start2 = this._lexer.token;
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return this.node(start2, {
      kind: Kind.ARGUMENT,
      name,
      value: this.parseValueLiteral(isConst)
    });
  }
  parseConstArgument() {
    return this.parseArgument(true);
  }
  parseFragment() {
    const start2 = this._lexer.token;
    this.expectToken(TokenKind.SPREAD);
    const hasTypeCondition = this.expectOptionalKeyword("on");
    if (!hasTypeCondition && this.peek(TokenKind.NAME)) {
      return this.node(start2, {
        kind: Kind.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false)
      });
    }
    return this.node(start2, {
      kind: Kind.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet()
    });
  }
  parseFragmentDefinition() {
    const start2 = this._lexer.token;
    this.expectKeyword("fragment");
    if (this._options.allowLegacyFragmentVariables === true) {
      return this.node(start2, {
        kind: Kind.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet()
      });
    }
    return this.node(start2, {
      kind: Kind.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet()
    });
  }
  parseFragmentName() {
    if (this._lexer.token.value === "on") {
      throw this.unexpected();
    }
    return this.parseName();
  }
  parseValueLiteral(isConst) {
    const token2 = this._lexer.token;
    switch (token2.kind) {
      case TokenKind.BRACKET_L:
        return this.parseList(isConst);
      case TokenKind.BRACE_L:
        return this.parseObject(isConst);
      case TokenKind.INT:
        this.advanceLexer();
        return this.node(token2, {
          kind: Kind.INT,
          value: token2.value
        });
      case TokenKind.FLOAT:
        this.advanceLexer();
        return this.node(token2, {
          kind: Kind.FLOAT,
          value: token2.value
        });
      case TokenKind.STRING:
      case TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();
      case TokenKind.NAME:
        this.advanceLexer();
        switch (token2.value) {
          case "true":
            return this.node(token2, {
              kind: Kind.BOOLEAN,
              value: true
            });
          case "false":
            return this.node(token2, {
              kind: Kind.BOOLEAN,
              value: false
            });
          case "null":
            return this.node(token2, {
              kind: Kind.NULL
            });
          default:
            return this.node(token2, {
              kind: Kind.ENUM,
              value: token2.value
            });
        }
      case TokenKind.DOLLAR:
        if (isConst) {
          this.expectToken(TokenKind.DOLLAR);
          if (this._lexer.token.kind === TokenKind.NAME) {
            const varName = this._lexer.token.value;
            throw syntaxError(this._lexer.source, token2.start, `Unexpected variable "$${varName}" in constant value.`);
          } else {
            throw this.unexpected(token2);
          }
        }
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(true);
  }
  parseStringLiteral() {
    const token2 = this._lexer.token;
    this.advanceLexer();
    return this.node(token2, {
      kind: Kind.STRING,
      value: token2.value,
      block: token2.kind === TokenKind.BLOCK_STRING
    });
  }
  parseList(isConst) {
    const item = () => this.parseValueLiteral(isConst);
    return this.node(this._lexer.token, {
      kind: Kind.LIST,
      values: this.any(TokenKind.BRACKET_L, item, TokenKind.BRACKET_R)
    });
  }
  parseObject(isConst) {
    const item = () => this.parseObjectField(isConst);
    return this.node(this._lexer.token, {
      kind: Kind.OBJECT,
      fields: this.any(TokenKind.BRACE_L, item, TokenKind.BRACE_R)
    });
  }
  parseObjectField(isConst) {
    const start2 = this._lexer.token;
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return this.node(start2, {
      kind: Kind.OBJECT_FIELD,
      name,
      value: this.parseValueLiteral(isConst)
    });
  }
  parseDirectives(isConst) {
    const directives = [];
    while (this.peek(TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }
    return directives;
  }
  parseConstDirectives() {
    return this.parseDirectives(true);
  }
  parseDirective(isConst) {
    const start2 = this._lexer.token;
    this.expectToken(TokenKind.AT);
    return this.node(start2, {
      kind: Kind.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst)
    });
  }
  parseTypeReference() {
    const start2 = this._lexer.token;
    let type;
    if (this.expectOptionalToken(TokenKind.BRACKET_L)) {
      const innerType = this.parseTypeReference();
      this.expectToken(TokenKind.BRACKET_R);
      type = this.node(start2, {
        kind: Kind.LIST_TYPE,
        type: innerType
      });
    } else {
      type = this.parseNamedType();
    }
    if (this.expectOptionalToken(TokenKind.BANG)) {
      return this.node(start2, {
        kind: Kind.NON_NULL_TYPE,
        type
      });
    }
    return type;
  }
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: Kind.NAMED_TYPE,
      name: this.parseName()
    });
  }
  peekDescription() {
    return this.peek(TokenKind.STRING) || this.peek(TokenKind.BLOCK_STRING);
  }
  parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  parseSchemaDefinition() {
    const start2 = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword("schema");
    const directives = this.parseConstDirectives();
    const operationTypes = this.many(TokenKind.BRACE_L, this.parseOperationTypeDefinition, TokenKind.BRACE_R);
    return this.node(start2, {
      kind: Kind.SCHEMA_DEFINITION,
      description,
      directives,
      operationTypes
    });
  }
  parseOperationTypeDefinition() {
    const start2 = this._lexer.token;
    const operation = this.parseOperationType();
    this.expectToken(TokenKind.COLON);
    const type = this.parseNamedType();
    return this.node(start2, {
      kind: Kind.OPERATION_TYPE_DEFINITION,
      operation,
      type
    });
  }
  parseScalarTypeDefinition() {
    const start2 = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword("scalar");
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    return this.node(start2, {
      kind: Kind.SCALAR_TYPE_DEFINITION,
      description,
      name,
      directives
    });
  }
  parseObjectTypeDefinition() {
    const start2 = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword("type");
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start2, {
      kind: Kind.OBJECT_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields
    });
  }
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(TokenKind.AMP, this.parseNamedType) : [];
  }
  parseFieldsDefinition() {
    return this.optionalMany(TokenKind.BRACE_L, this.parseFieldDefinition, TokenKind.BRACE_R);
  }
  parseFieldDefinition() {
    const start2 = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    this.expectToken(TokenKind.COLON);
    const type = this.parseTypeReference();
    const directives = this.parseConstDirectives();
    return this.node(start2, {
      kind: Kind.FIELD_DEFINITION,
      description,
      name,
      arguments: args,
      type,
      directives
    });
  }
  parseArgumentDefs() {
    return this.optionalMany(TokenKind.PAREN_L, this.parseInputValueDef, TokenKind.PAREN_R);
  }
  parseInputValueDef() {
    const start2 = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    const type = this.parseTypeReference();
    let defaultValue;
    if (this.expectOptionalToken(TokenKind.EQUALS)) {
      defaultValue = this.parseConstValueLiteral();
    }
    const directives = this.parseConstDirectives();
    return this.node(start2, {
      kind: Kind.INPUT_VALUE_DEFINITION,
      description,
      name,
      type,
      defaultValue,
      directives
    });
  }
  parseInterfaceTypeDefinition() {
    const start2 = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword("interface");
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start2, {
      kind: Kind.INTERFACE_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields
    });
  }
  parseUnionTypeDefinition() {
    const start2 = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword("union");
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();
    return this.node(start2, {
      kind: Kind.UNION_TYPE_DEFINITION,
      description,
      name,
      directives,
      types
    });
  }
  parseUnionMemberTypes() {
    return this.expectOptionalToken(TokenKind.EQUALS) ? this.delimitedMany(TokenKind.PIPE, this.parseNamedType) : [];
  }
  parseEnumTypeDefinition() {
    const start2 = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword("enum");
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();
    return this.node(start2, {
      kind: Kind.ENUM_TYPE_DEFINITION,
      description,
      name,
      directives,
      values
    });
  }
  parseEnumValuesDefinition() {
    return this.optionalMany(TokenKind.BRACE_L, this.parseEnumValueDefinition, TokenKind.BRACE_R);
  }
  parseEnumValueDefinition() {
    const start2 = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseEnumValueName();
    const directives = this.parseConstDirectives();
    return this.node(start2, {
      kind: Kind.ENUM_VALUE_DEFINITION,
      description,
      name,
      directives
    });
  }
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null") {
      throw syntaxError(this._lexer.source, this._lexer.token.start, `${getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
    }
    return this.parseName();
  }
  parseInputObjectTypeDefinition() {
    const start2 = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword("input");
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();
    return this.node(start2, {
      kind: Kind.INPUT_OBJECT_TYPE_DEFINITION,
      description,
      name,
      directives,
      fields
    });
  }
  parseInputFieldsDefinition() {
    return this.optionalMany(TokenKind.BRACE_L, this.parseInputValueDef, TokenKind.BRACE_R);
  }
  parseTypeSystemExtension() {
    const keywordToken = this._lexer.lookahead();
    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    }
    throw this.unexpected(keywordToken);
  }
  parseSchemaExtension() {
    const start2 = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("schema");
    const directives = this.parseConstDirectives();
    const operationTypes = this.optionalMany(TokenKind.BRACE_L, this.parseOperationTypeDefinition, TokenKind.BRACE_R);
    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }
    return this.node(start2, {
      kind: Kind.SCHEMA_EXTENSION,
      directives,
      operationTypes
    });
  }
  parseScalarTypeExtension() {
    const start2 = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("scalar");
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    if (directives.length === 0) {
      throw this.unexpected();
    }
    return this.node(start2, {
      kind: Kind.SCALAR_TYPE_EXTENSION,
      name,
      directives
    });
  }
  parseObjectTypeExtension() {
    const start2 = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("type");
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }
    return this.node(start2, {
      kind: Kind.OBJECT_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields
    });
  }
  parseInterfaceTypeExtension() {
    const start2 = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("interface");
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }
    return this.node(start2, {
      kind: Kind.INTERFACE_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields
    });
  }
  parseUnionTypeExtension() {
    const start2 = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("union");
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();
    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }
    return this.node(start2, {
      kind: Kind.UNION_TYPE_EXTENSION,
      name,
      directives,
      types
    });
  }
  parseEnumTypeExtension() {
    const start2 = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("enum");
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();
    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }
    return this.node(start2, {
      kind: Kind.ENUM_TYPE_EXTENSION,
      name,
      directives,
      values
    });
  }
  parseInputObjectTypeExtension() {
    const start2 = this._lexer.token;
    this.expectKeyword("extend");
    this.expectKeyword("input");
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();
    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }
    return this.node(start2, {
      kind: Kind.INPUT_OBJECT_TYPE_EXTENSION,
      name,
      directives,
      fields
    });
  }
  parseDirectiveDefinition() {
    const start2 = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword("directive");
    this.expectToken(TokenKind.AT);
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    const repeatable = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const locations = this.parseDirectiveLocations();
    return this.node(start2, {
      kind: Kind.DIRECTIVE_DEFINITION,
      description,
      name,
      arguments: args,
      repeatable,
      locations
    });
  }
  parseDirectiveLocations() {
    return this.delimitedMany(TokenKind.PIPE, this.parseDirectiveLocation);
  }
  parseDirectiveLocation() {
    const start2 = this._lexer.token;
    const name = this.parseName();
    if (Object.prototype.hasOwnProperty.call(DirectiveLocation, name.value)) {
      return name;
    }
    throw this.unexpected(start2);
  }
  node(startToken, node2) {
    if (this._options.noLocation !== true) {
      node2.loc = new Location(startToken, this._lexer.lastToken, this._lexer.source);
    }
    return node2;
  }
  peek(kind) {
    return this._lexer.token.kind === kind;
  }
  expectToken(kind) {
    const token2 = this._lexer.token;
    if (token2.kind === kind) {
      this.advanceLexer();
      return token2;
    }
    throw syntaxError(this._lexer.source, token2.start, `Expected ${getTokenKindDesc(kind)}, found ${getTokenDesc(token2)}.`);
  }
  expectOptionalToken(kind) {
    const token2 = this._lexer.token;
    if (token2.kind === kind) {
      this.advanceLexer();
      return true;
    }
    return false;
  }
  expectKeyword(value) {
    const token2 = this._lexer.token;
    if (token2.kind === TokenKind.NAME && token2.value === value) {
      this.advanceLexer();
    } else {
      throw syntaxError(this._lexer.source, token2.start, `Expected "${value}", found ${getTokenDesc(token2)}.`);
    }
  }
  expectOptionalKeyword(value) {
    const token2 = this._lexer.token;
    if (token2.kind === TokenKind.NAME && token2.value === value) {
      this.advanceLexer();
      return true;
    }
    return false;
  }
  unexpected(atToken) {
    const token2 = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(this._lexer.source, token2.start, `Unexpected ${getTokenDesc(token2)}.`);
  }
  any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];
    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }
    return nodes;
  }
  optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      const nodes = [];
      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));
      return nodes;
    }
    return [];
  }
  many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];
    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));
    return nodes;
  }
  delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    const nodes = [];
    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));
    return nodes;
  }
  advanceLexer() {
    const { maxTokens } = this._options;
    const token2 = this._lexer.advance();
    if (maxTokens !== void 0 && token2.kind !== TokenKind.EOF) {
      ++this._tokenCounter;
      if (this._tokenCounter > maxTokens) {
        throw syntaxError(this._lexer.source, token2.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
      }
    }
  }
}
function getTokenDesc(token2) {
  const value = token2.value;
  return getTokenKindDesc(token2.kind) + (value != null ? ` "${value}"` : "");
}
function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? `"${kind}"` : kind;
}
var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string2) {
  return string2.replace(/[\s,]+/g, " ").trim();
}
function cacheKeyFromLoc(loc) {
  return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
  var seenKeys = new Set();
  var definitions = [];
  ast.definitions.forEach(function(fragmentDefinition) {
    if (fragmentDefinition.kind === "FragmentDefinition") {
      var fragmentName = fragmentDefinition.name.value;
      var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
      var sourceKeySet = fragmentSourceMap.get(fragmentName);
      if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
        if (printFragmentWarnings) {
          console.warn("Warning: fragment with name " + fragmentName + " already exists.\ngraphql-tag enforces all fragment names across your application to be unique; read more about\nthis in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
        }
      } else if (!sourceKeySet) {
        fragmentSourceMap.set(fragmentName, sourceKeySet = new Set());
      }
      sourceKeySet.add(sourceKey);
      if (!seenKeys.has(sourceKey)) {
        seenKeys.add(sourceKey);
        definitions.push(fragmentDefinition);
      }
    } else {
      definitions.push(fragmentDefinition);
    }
  });
  return __assign(__assign({}, ast), { definitions });
}
function stripLoc(doc) {
  var workSet = new Set(doc.definitions);
  workSet.forEach(function(node2) {
    if (node2.loc)
      delete node2.loc;
    Object.keys(node2).forEach(function(key) {
      var value = node2[key];
      if (value && typeof value === "object") {
        workSet.add(value);
      }
    });
  });
  var loc = doc.loc;
  if (loc) {
    delete loc.startToken;
    delete loc.endToken;
  }
  return doc;
}
function parseDocument(source2) {
  var cacheKey = normalize(source2);
  if (!docCache.has(cacheKey)) {
    var parsed = parse$1(source2, {
      experimentalFragmentVariables,
      allowLegacyFragmentVariables: experimentalFragmentVariables
    });
    if (!parsed || parsed.kind !== "Document") {
      throw new Error("Not a valid GraphQL document.");
    }
    docCache.set(cacheKey, stripLoc(processFragments(parsed)));
  }
  return docCache.get(cacheKey);
}
function gql(literals) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  if (typeof literals === "string") {
    literals = [literals];
  }
  var result = literals[0];
  args.forEach(function(arg, i2) {
    if (arg && arg.kind === "Document") {
      result += arg.loc.source.body;
    } else {
      result += arg;
    }
    result += literals[i2 + 1];
  });
  return parseDocument(result);
}
function resetCaches() {
  docCache.clear();
  fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
  printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
  experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
  experimentalFragmentVariables = false;
}
var extras = {
  gql,
  resetCaches,
  disableFragmentWarnings,
  enableExperimentalFragmentVariables,
  disableExperimentalFragmentVariables
};
(function(gql_1) {
  gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
var gql$1 = gql;
setVerbosity("log");
gql$1.resetCaches;
gql$1.disableFragmentWarnings;
gql$1.enableExperimentalFragmentVariables;
gql$1.disableExperimentalFragmentVariables;
var cache$1 = new (canUseWeakMap ? WeakMap : Map)();
function getApolloContext() {
  var context = cache$1.get(React__default.createContext);
  if (!context) {
    context = React__default.createContext({});
    context.displayName = "ApolloContext";
    cache$1.set(React__default.createContext, context);
  }
  return context;
}
var ApolloProvider = function(_a2) {
  var client = _a2.client, children2 = _a2.children;
  var ApolloContext = getApolloContext();
  return React__default.createElement(ApolloContext.Consumer, null, function(context) {
    if (context === void 0) {
      context = {};
    }
    if (client && context.client !== client) {
      context = Object.assign({}, context, { client });
    }
    invariant$1(context.client, 28);
    return React__default.createElement(ApolloContext.Provider, { value: context }, children2);
  });
};
function useApolloClient() {
  var client = React__default.useContext(getApolloContext()).client;
  invariant$1(client, 33);
  return client;
}
var DocumentType;
(function(DocumentType2) {
  DocumentType2[DocumentType2["Query"] = 0] = "Query";
  DocumentType2[DocumentType2["Mutation"] = 1] = "Mutation";
  DocumentType2[DocumentType2["Subscription"] = 2] = "Subscription";
})(DocumentType || (DocumentType = {}));
var cache = new Map();
function operationName(type) {
  var name;
  switch (type) {
    case DocumentType.Query:
      name = "Query";
      break;
    case DocumentType.Mutation:
      name = "Mutation";
      break;
    case DocumentType.Subscription:
      name = "Subscription";
      break;
  }
  return name;
}
function parser(document2) {
  var cached = cache.get(document2);
  if (cached)
    return cached;
  var variables, type, name;
  invariant$1(!!document2 && !!document2.kind, 34);
  var fragments = document2.definitions.filter(function(x2) {
    return x2.kind === "FragmentDefinition";
  });
  var queries = document2.definitions.filter(function(x2) {
    return x2.kind === "OperationDefinition" && x2.operation === "query";
  });
  var mutations = document2.definitions.filter(function(x2) {
    return x2.kind === "OperationDefinition" && x2.operation === "mutation";
  });
  var subscriptions = document2.definitions.filter(function(x2) {
    return x2.kind === "OperationDefinition" && x2.operation === "subscription";
  });
  invariant$1(!fragments.length || (queries.length || mutations.length || subscriptions.length), 35);
  invariant$1(queries.length + mutations.length + subscriptions.length <= 1, 36);
  type = queries.length ? DocumentType.Query : DocumentType.Mutation;
  if (!queries.length && !mutations.length)
    type = DocumentType.Subscription;
  var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
  invariant$1(definitions.length === 1, 37);
  var definition = definitions[0];
  variables = definition.variableDefinitions || [];
  if (definition.name && definition.name.kind === "Name") {
    name = definition.name.value;
  } else {
    name = "data";
  }
  var payload = { name, type, variables };
  cache.set(document2, payload);
  return payload;
}
var OperationData = function() {
  function OperationData2(options2, context) {
    this.isMounted = false;
    this.previousOptions = {};
    this.context = {};
    this.options = {};
    this.options = options2 || {};
    this.context = context || {};
  }
  OperationData2.prototype.getOptions = function() {
    return this.options;
  };
  OperationData2.prototype.setOptions = function(newOptions, storePrevious) {
    if (storePrevious === void 0) {
      storePrevious = false;
    }
    if (storePrevious && !equal$1(this.options, newOptions)) {
      this.previousOptions = this.options;
    }
    this.options = newOptions;
  };
  OperationData2.prototype.unmount = function() {
    this.isMounted = false;
  };
  OperationData2.prototype.refreshClient = function() {
    var client = this.options && this.options.client || this.context && this.context.client;
    invariant$1(!!client, 29);
    var isNew = false;
    if (client !== this.client) {
      isNew = true;
      this.client = client;
      this.cleanup();
    }
    return {
      client: this.client,
      isNew
    };
  };
  OperationData2.prototype.verifyDocumentType = function(document2, type) {
    var operation = parser(document2);
    operationName(type);
    operationName(operation.type);
    invariant$1(operation.type === type, 30);
  };
  return OperationData2;
}();
var MutationData = function(_super) {
  __extends(MutationData2, _super);
  function MutationData2(_a2) {
    var options2 = _a2.options, context = _a2.context, result = _a2.result, setResult = _a2.setResult;
    var _this = _super.call(this, options2, context) || this;
    _this.runMutation = function(mutationFunctionOptions) {
      if (mutationFunctionOptions === void 0) {
        mutationFunctionOptions = {};
      }
      _this.onMutationStart();
      var mutationId = _this.generateNewMutationId();
      return _this.mutate(mutationFunctionOptions).then(function(response) {
        _this.onMutationCompleted(response, mutationId);
        return response;
      }).catch(function(error2) {
        _this.onMutationError(error2, mutationId);
        if (!_this.getOptions().onError)
          throw error2;
      });
    };
    _this.verifyDocumentType(options2.mutation, DocumentType.Mutation);
    _this.result = result;
    _this.setResult = setResult;
    _this.mostRecentMutationId = 0;
    return _this;
  }
  MutationData2.prototype.execute = function(result) {
    this.isMounted = true;
    this.verifyDocumentType(this.getOptions().mutation, DocumentType.Mutation);
    return [
      this.runMutation,
      __assign$1(__assign$1({}, result), { client: this.refreshClient().client })
    ];
  };
  MutationData2.prototype.afterExecute = function() {
    this.isMounted = true;
    return this.unmount.bind(this);
  };
  MutationData2.prototype.cleanup = function() {
  };
  MutationData2.prototype.mutate = function(options2) {
    return this.refreshClient().client.mutate(mergeOptions(this.getOptions(), options2));
  };
  MutationData2.prototype.onMutationStart = function() {
    if (!this.result.loading && !this.getOptions().ignoreResults) {
      this.updateResult({
        loading: true,
        error: void 0,
        data: void 0,
        called: true
      });
    }
  };
  MutationData2.prototype.onMutationCompleted = function(response, mutationId) {
    var _a2 = this.getOptions(), onCompleted = _a2.onCompleted, ignoreResults = _a2.ignoreResults;
    var data2 = response.data, errors = response.errors;
    var error2 = errors && errors.length > 0 ? new ApolloError({ graphQLErrors: errors }) : void 0;
    var callOncomplete = function() {
      return onCompleted ? onCompleted(data2) : null;
    };
    if (this.isMostRecentMutation(mutationId) && !ignoreResults) {
      this.updateResult({
        called: true,
        loading: false,
        data: data2,
        error: error2
      });
    }
    callOncomplete();
  };
  MutationData2.prototype.onMutationError = function(error2, mutationId) {
    var onError = this.getOptions().onError;
    if (this.isMostRecentMutation(mutationId)) {
      this.updateResult({
        loading: false,
        error: error2,
        data: void 0,
        called: true
      });
    }
    if (onError) {
      onError(error2);
    }
  };
  MutationData2.prototype.generateNewMutationId = function() {
    return ++this.mostRecentMutationId;
  };
  MutationData2.prototype.isMostRecentMutation = function(mutationId) {
    return this.mostRecentMutationId === mutationId;
  };
  MutationData2.prototype.updateResult = function(result) {
    if (this.isMounted && (!this.previousResult || !equal$1(this.previousResult, result))) {
      this.setResult(result);
      this.previousResult = result;
    }
  };
  return MutationData2;
}(OperationData);
var QueryData = function(_super) {
  __extends(QueryData2, _super);
  function QueryData2(_a2) {
    var options2 = _a2.options, context = _a2.context, onNewData = _a2.onNewData;
    var _this = _super.call(this, options2, context) || this;
    _this.runLazy = false;
    _this.previous = Object.create(null);
    _this.runLazyQuery = function(options3) {
      _this.cleanup();
      _this.runLazy = true;
      _this.lazyOptions = options3;
      _this.onNewData();
    };
    _this.getQueryResult = function() {
      var result = _this.observableQueryFields();
      var options3 = _this.getOptions();
      if (options3.skip) {
        result = __assign$1(__assign$1({}, result), { data: void 0, error: void 0, loading: false, networkStatus: NetworkStatus.ready, called: true });
      } else if (_this.currentObservable) {
        var currentResult = _this.currentObservable.getCurrentResult();
        var data2 = currentResult.data, loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
        var error2 = currentResult.error;
        if (errors && errors.length > 0) {
          error2 = new ApolloError({ graphQLErrors: errors });
        }
        result = __assign$1(__assign$1({}, result), {
          data: data2,
          loading,
          networkStatus,
          error: error2,
          called: true
        });
        if (loading)
          ;
        else if (error2) {
          Object.assign(result, {
            data: (_this.currentObservable.getLastResult() || {}).data
          });
        } else {
          var fetchPolicy = _this.currentObservable.options.fetchPolicy;
          var partialRefetch = options3.partialRefetch;
          if (partialRefetch && partial && (!data2 || Object.keys(data2).length === 0) && fetchPolicy !== "cache-only") {
            Object.assign(result, {
              loading: true,
              networkStatus: NetworkStatus.loading
            });
            result.refetch();
            return result;
          }
        }
      }
      result.client = _this.client;
      _this.setOptions(options3, true);
      var previousResult = _this.previous.result;
      _this.previous.loading = previousResult && previousResult.loading || false;
      result.previousData = previousResult && (previousResult.data || previousResult.previousData);
      _this.previous.result = result;
      _this.currentObservable && _this.currentObservable.resetQueryStoreErrors();
      return result;
    };
    _this.obsRefetch = function(variables) {
      var _a3;
      return (_a3 = _this.currentObservable) === null || _a3 === void 0 ? void 0 : _a3.refetch(variables);
    };
    _this.obsFetchMore = function(fetchMoreOptions) {
      return _this.currentObservable.fetchMore(fetchMoreOptions);
    };
    _this.obsUpdateQuery = function(mapFn) {
      return _this.currentObservable.updateQuery(mapFn);
    };
    _this.obsStartPolling = function(pollInterval) {
      var _a3;
      (_a3 = _this.currentObservable) === null || _a3 === void 0 ? void 0 : _a3.startPolling(pollInterval);
    };
    _this.obsStopPolling = function() {
      var _a3;
      (_a3 = _this.currentObservable) === null || _a3 === void 0 ? void 0 : _a3.stopPolling();
    };
    _this.obsSubscribeToMore = function(options3) {
      return _this.currentObservable.subscribeToMore(options3);
    };
    _this.onNewData = onNewData;
    return _this;
  }
  QueryData2.prototype.execute = function() {
    this.refreshClient();
    var _a2 = this.getOptions(), skip = _a2.skip, query = _a2.query;
    if (skip || query !== this.previous.query) {
      this.removeQuerySubscription();
      this.removeObservable(!skip);
      this.previous.query = query;
    }
    this.updateObservableQuery();
    if (this.isMounted)
      this.startQuerySubscription();
    return this.getExecuteSsrResult() || this.getExecuteResult();
  };
  QueryData2.prototype.executeLazy = function() {
    return !this.runLazy ? [
      this.runLazyQuery,
      {
        loading: false,
        networkStatus: NetworkStatus.ready,
        called: false,
        data: void 0
      }
    ] : [this.runLazyQuery, this.execute()];
  };
  QueryData2.prototype.fetchData = function() {
    var _this = this;
    var options2 = this.getOptions();
    if (options2.skip || options2.ssr === false)
      return false;
    return new Promise(function(resolve) {
      return _this.startQuerySubscription(resolve);
    });
  };
  QueryData2.prototype.afterExecute = function(_a2) {
    var _b = (_a2 === void 0 ? {} : _a2).lazy, lazy = _b === void 0 ? false : _b;
    this.isMounted = true;
    if (!lazy || this.runLazy) {
      this.handleErrorOrCompleted();
    }
    this.previousOptions = this.getOptions();
    return this.unmount.bind(this);
  };
  QueryData2.prototype.cleanup = function() {
    this.removeQuerySubscription();
    this.removeObservable(true);
    delete this.previous.result;
  };
  QueryData2.prototype.getOptions = function() {
    var options2 = _super.prototype.getOptions.call(this);
    if (this.lazyOptions) {
      options2.variables = __assign$1(__assign$1({}, options2.variables), this.lazyOptions.variables);
      options2.context = __assign$1(__assign$1({}, options2.context), this.lazyOptions.context);
    }
    if (this.runLazy) {
      delete options2.skip;
    }
    return options2;
  };
  QueryData2.prototype.ssrInitiated = function() {
    return this.context && this.context.renderPromises;
  };
  QueryData2.prototype.getExecuteResult = function() {
    var result = this.getQueryResult();
    this.startQuerySubscription();
    return result;
  };
  QueryData2.prototype.getExecuteSsrResult = function() {
    var _a2 = this.getOptions(), ssr = _a2.ssr, skip = _a2.skip;
    var ssrDisabled = ssr === false;
    var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
    var ssrLoading = __assign$1({ loading: true, networkStatus: NetworkStatus.loading, called: true, data: void 0, stale: false, client: this.client }, this.observableQueryFields());
    if (ssrDisabled && (this.ssrInitiated() || fetchDisabled)) {
      this.previous.result = ssrLoading;
      return ssrLoading;
    }
    var result;
    if (this.ssrInitiated()) {
      if (skip) {
        result = this.getQueryResult();
      } else {
        result = this.context.renderPromises.addQueryPromise(this, this.getQueryResult) || ssrLoading;
      }
    }
    return result;
  };
  QueryData2.prototype.prepareObservableQueryOptions = function() {
    var options2 = this.getOptions();
    this.verifyDocumentType(options2.query, DocumentType.Query);
    var displayName = options2.displayName || "Query";
    if (this.ssrInitiated() && (options2.fetchPolicy === "network-only" || options2.fetchPolicy === "cache-and-network")) {
      options2.fetchPolicy = "cache-first";
    }
    return __assign$1(__assign$1({}, options2), { displayName, context: options2.context });
  };
  QueryData2.prototype.initializeObservableQuery = function() {
    if (this.ssrInitiated()) {
      this.currentObservable = this.context.renderPromises.getSSRObservable(this.getOptions());
    }
    if (!this.currentObservable) {
      var observableQueryOptions = this.prepareObservableQueryOptions();
      this.previous.observableQueryOptions = __assign$1(__assign$1({}, observableQueryOptions), { children: null });
      this.currentObservable = this.refreshClient().client.watchQuery(__assign$1({}, observableQueryOptions));
      if (this.ssrInitiated()) {
        this.context.renderPromises.registerSSRObservable(this.currentObservable, observableQueryOptions);
      }
    }
  };
  QueryData2.prototype.updateObservableQuery = function() {
    if (!this.currentObservable) {
      this.initializeObservableQuery();
      return;
    }
    if (this.getOptions().skip)
      return;
    var newObservableQueryOptions = __assign$1(__assign$1({}, this.prepareObservableQueryOptions()), { children: null });
    if (!equal$1(newObservableQueryOptions, this.previous.observableQueryOptions)) {
      this.previous.observableQueryOptions = newObservableQueryOptions;
      this.currentObservable.setOptions(newObservableQueryOptions).catch(function() {
      });
    }
  };
  QueryData2.prototype.startQuerySubscription = function(onNewData) {
    var _this = this;
    if (onNewData === void 0) {
      onNewData = this.onNewData;
    }
    if (this.currentSubscription || this.getOptions().skip)
      return;
    this.currentSubscription = this.currentObservable.subscribe({
      next: function(_a2) {
        var loading = _a2.loading, networkStatus = _a2.networkStatus, data2 = _a2.data;
        var previousResult = _this.previous.result;
        if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && equal$1(previousResult.data, data2)) {
          return;
        }
        onNewData();
      },
      error: function(error2) {
        _this.resubscribeToQuery();
        if (!error2.hasOwnProperty("graphQLErrors"))
          throw error2;
        var previousResult = _this.previous.result;
        if (previousResult && previousResult.loading || !equal$1(error2, _this.previous.error)) {
          _this.previous.error = error2;
          onNewData();
        }
      }
    });
  };
  QueryData2.prototype.resubscribeToQuery = function() {
    this.removeQuerySubscription();
    var currentObservable = this.currentObservable;
    if (currentObservable) {
      var lastError = currentObservable.getLastError();
      var lastResult = currentObservable.getLastResult();
      currentObservable.resetLastResults();
      this.startQuerySubscription();
      Object.assign(currentObservable, {
        lastError,
        lastResult
      });
    }
  };
  QueryData2.prototype.handleErrorOrCompleted = function() {
    if (!this.currentObservable || !this.previous.result)
      return;
    var _a2 = this.previous.result, data2 = _a2.data, loading = _a2.loading, error2 = _a2.error;
    if (!loading) {
      var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError, skip = _b.skip;
      if (this.previousOptions && !this.previous.loading && equal$1(this.previousOptions.query, query) && equal$1(this.previousOptions.variables, variables)) {
        return;
      }
      if (onCompleted && !error2 && !skip) {
        onCompleted(data2);
      } else if (onError && error2) {
        onError(error2);
      }
    }
  };
  QueryData2.prototype.removeQuerySubscription = function() {
    if (this.currentSubscription) {
      this.currentSubscription.unsubscribe();
      delete this.currentSubscription;
    }
  };
  QueryData2.prototype.removeObservable = function(andDelete) {
    if (this.currentObservable) {
      this.currentObservable["tearDownQuery"]();
      if (andDelete) {
        delete this.currentObservable;
      }
    }
  };
  QueryData2.prototype.observableQueryFields = function() {
    var _a2;
    return {
      variables: (_a2 = this.currentObservable) === null || _a2 === void 0 ? void 0 : _a2.variables,
      refetch: this.obsRefetch,
      fetchMore: this.obsFetchMore,
      updateQuery: this.obsUpdateQuery,
      startPolling: this.obsStartPolling,
      stopPolling: this.obsStopPolling,
      subscribeToMore: this.obsSubscribeToMore
    };
  };
  return QueryData2;
}(OperationData);
function useDeepMemo(memoFn, key) {
  var ref = useRef();
  if (!ref.current || !equal$1(key, ref.current.key)) {
    ref.current = { key, value: memoFn() };
  }
  return ref.current.value;
}
function useBaseQuery(query, options2, lazy) {
  if (lazy === void 0) {
    lazy = false;
  }
  var context = useContext(getApolloContext());
  var _a2 = useReducer(function(x2) {
    return x2 + 1;
  }, 0), tick = _a2[0], forceUpdate = _a2[1];
  var updatedOptions = options2 ? __assign$1(__assign$1({}, options2), { query }) : { query };
  var queryDataRef = useRef();
  var queryData = queryDataRef.current || (queryDataRef.current = new QueryData({
    options: updatedOptions,
    context,
    onNewData: function() {
      if (!queryData.ssrInitiated()) {
        Promise.resolve().then(function() {
          return queryDataRef.current && forceUpdate();
        });
      } else {
        forceUpdate();
      }
    }
  }));
  queryData.setOptions(updatedOptions);
  queryData.context = context;
  var memo2 = {
    options: __assign$1(__assign$1({}, updatedOptions), { onError: void 0, onCompleted: void 0 }),
    context,
    tick
  };
  var result = useDeepMemo(function() {
    return lazy ? queryData.executeLazy() : queryData.execute();
  }, memo2);
  var queryResult = lazy ? result[1] : result;
  useEffect(function() {
    return function() {
      return queryData.cleanup();
    };
  }, []);
  useEffect(function() {
    return queryData.afterExecute({ lazy });
  }, [
    queryResult.loading,
    queryResult.networkStatus,
    queryResult.error,
    queryResult.data
  ]);
  return result;
}
function useLazyQuery(query, options2) {
  return useBaseQuery(query, options2, true);
}
function useMutation(mutation, options2) {
  var context = useContext(getApolloContext());
  var _a2 = useState({ called: false, loading: false }), result = _a2[0], setResult = _a2[1];
  var updatedOptions = options2 ? __assign$1(__assign$1({}, options2), { mutation }) : { mutation };
  var mutationDataRef = useRef();
  function getMutationDataRef() {
    if (!mutationDataRef.current) {
      mutationDataRef.current = new MutationData({
        options: updatedOptions,
        context,
        result,
        setResult
      });
    }
    return mutationDataRef.current;
  }
  var mutationData = getMutationDataRef();
  mutationData.setOptions(updatedOptions);
  mutationData.context = context;
  useEffect(function() {
    return mutationData.afterExecute();
  });
  return mutationData.execute(result);
}
function useQuery(query, options2) {
  return useBaseQuery(query, options2, false);
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? Object(arguments[i2]) : {};
    var ownKeys2 = Object.keys(source2);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2.push.apply(ownKeys2, Object.getOwnPropertySymbols(source2).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source2, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _defineProperty$3(target, key, source2[key]);
    });
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _assertThisInitialized$1(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _possibleConstructorReturn$1(self2, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1(self2);
}
function _getPrototypeOf$1(o2) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$1(o2);
}
function _setPrototypeOf(o2, p2) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf(o2, p2);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
var consoleLogger = {
  type: "logger",
  log: function log(args) {
    this.output("log", args);
  },
  warn: function warn2(args) {
    this.output("warn", args);
  },
  error: function error(args) {
    this.output("error", args);
  },
  output: function output(type, args) {
    if (console && console[type])
      console[type].apply(console, args);
  }
};
var Logger = function() {
  function Logger2(concreteLogger) {
    var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck(this, Logger2);
    this.init(concreteLogger, options2);
  }
  _createClass(Logger2, [{
    key: "init",
    value: function init2(concreteLogger) {
      var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.prefix = options2.prefix || "i18next:";
      this.logger = concreteLogger || consoleLogger;
      this.options = options2;
      this.debug = options2.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log2() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return this.forward(args, "log", "", true);
    }
  }, {
    key: "warn",
    value: function warn3() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return this.forward(args, "warn", "", true);
    }
  }, {
    key: "error",
    value: function error2() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return this.forward(args, "error", "");
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix2, debugOnly) {
      if (debugOnly && !this.debug)
        return null;
      if (typeof args[0] === "string")
        args[0] = "".concat(prefix2).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create2(moduleName) {
      return new Logger2(this.logger, _objectSpread$1({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }, this.options));
    }
  }]);
  return Logger2;
}();
var baseLogger = new Logger();
var EventEmitter = function() {
  function EventEmitter2() {
    _classCallCheck(this, EventEmitter2);
    this.observers = {};
  }
  _createClass(EventEmitter2, [{
    key: "on",
    value: function on2(events2, listener) {
      var _this = this;
      events2.split(" ").forEach(function(event) {
        _this.observers[event] = _this.observers[event] || [];
        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off2(event, listener) {
      if (!this.observers[event])
        return;
      if (!listener) {
        delete this.observers[event];
        return;
      }
      this.observers[event] = this.observers[event].filter(function(l2) {
        return l2 !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function(observer) {
          observer.apply(void 0, args);
        });
      }
      if (this.observers["*"]) {
        var _cloned = [].concat(this.observers["*"]);
        _cloned.forEach(function(observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);
  return EventEmitter2;
}();
function defer() {
  var res;
  var rej;
  var promise = new Promise(function(resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object2) {
  if (object2 == null)
    return "";
  return "" + object2;
}
function copy$1(a2, s, t2) {
  a2.forEach(function(m2) {
    if (s[m2])
      t2[m2] = s[m2];
  });
}
function getLastOfPath(object2, path, Empty) {
  function cleanKey(key2) {
    return key2 && key2.indexOf("###") > -1 ? key2.replace(/###/g, ".") : key2;
  }
  function canNotTraverseDeeper() {
    return !object2 || typeof object2 === "string";
  }
  var stack = typeof path !== "string" ? [].concat(path) : path.split(".");
  while (stack.length > 1) {
    if (canNotTraverseDeeper())
      return {};
    var key = cleanKey(stack.shift());
    if (!object2[key] && Empty)
      object2[key] = new Empty();
    if (Object.prototype.hasOwnProperty.call(object2, key)) {
      object2 = object2[key];
    } else {
      object2 = {};
    }
  }
  if (canNotTraverseDeeper())
    return {};
  return {
    obj: object2,
    k: cleanKey(stack.shift())
  };
}
function setPath(object2, path, newValue) {
  var _getLastOfPath = getLastOfPath(object2, path, Object), obj = _getLastOfPath.obj, k2 = _getLastOfPath.k;
  obj[k2] = newValue;
}
function pushPath(object2, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object2, path, Object), obj = _getLastOfPath2.obj, k2 = _getLastOfPath2.k;
  obj[k2] = obj[k2] || [];
  if (concat)
    obj[k2] = obj[k2].concat(newValue);
  if (!concat)
    obj[k2].push(newValue);
}
function getPath(object2, path) {
  var _getLastOfPath3 = getLastOfPath(object2, path), obj = _getLastOfPath3.obj, k2 = _getLastOfPath3.k;
  if (!obj)
    return void 0;
  return obj[k2];
}
function getPathWithDefaults(data2, defaultData, key) {
  var value = getPath(data2, key);
  if (value !== void 0) {
    return value;
  }
  return getPath(defaultData, key);
}
function deepExtend(target, source2, overwrite) {
  for (var prop in source2) {
    if (prop !== "__proto__" && prop !== "constructor") {
      if (prop in target) {
        if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source2[prop] === "string" || source2[prop] instanceof String) {
          if (overwrite)
            target[prop] = source2[prop];
        } else {
          deepExtend(target[prop], source2[prop], overwrite);
        }
      } else {
        target[prop] = source2[prop];
      }
    }
  }
  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function escape(data2) {
  if (typeof data2 === "string") {
    return data2.replace(/[&<>"'\/]/g, function(s) {
      return _entityMap[s];
    });
  }
  return data2;
}
var isIE10 = typeof window !== "undefined" && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!obj)
    return void 0;
  if (obj[path])
    return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;
  for (var i2 = 0; i2 < paths.length; ++i2) {
    if (typeof current[paths[i2]] === "string" && i2 + 1 < paths.length) {
      return void 0;
    }
    if (current[paths[i2]] === void 0) {
      var j = 2;
      var p2 = paths.slice(i2, i2 + j).join(keySeparator);
      var mix = current[p2];
      while (mix === void 0 && paths.length > i2 + j) {
        j++;
        p2 = paths.slice(i2, i2 + j).join(keySeparator);
        mix = current[p2];
      }
      if (mix === void 0)
        return void 0;
      if (typeof mix === "string")
        return mix;
      if (p2 && typeof mix[p2] === "string")
        return mix[p2];
      var joinedPath = paths.slice(i2 + j).join(keySeparator);
      if (joinedPath)
        return deepFind(mix, joinedPath, keySeparator);
      return void 0;
    }
    current = current[paths[i2]];
  }
  return current;
}
var ResourceStore = function(_EventEmitter) {
  _inherits(ResourceStore2, _EventEmitter);
  function ResourceStore2(data2) {
    var _this;
    var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    _classCallCheck(this, ResourceStore2);
    _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(ResourceStore2).call(this));
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$1(_this));
    }
    _this.data = data2 || {};
    _this.options = options2;
    if (_this.options.keySeparator === void 0) {
      _this.options.keySeparator = ".";
    }
    if (_this.options.ignoreJSONStructure === void 0) {
      _this.options.ignoreJSONStructure = true;
    }
    return _this;
  }
  _createClass(ResourceStore2, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index2 = this.options.ns.indexOf(ns);
      if (index2 > -1) {
        this.options.ns.splice(index2, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      var keySeparator = options2.keySeparator !== void 0 ? options2.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options2.ignoreJSONStructure !== void 0 ? options2.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== "string")
        path = path.concat(key);
      if (key && typeof key === "string")
        path = path.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf(".") > -1) {
        path = lng.split(".");
      }
      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== "string")
        return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options2 = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === void 0)
        keySeparator = ".";
      var path = [lng, ns];
      if (key)
        path = path.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf(".") > -1) {
        path = lng.split(".");
        value = ns;
        ns = path[1];
      }
      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options2.silent)
        this.emit("added", lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources2) {
      var options2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        silent: false
      };
      for (var m2 in resources2) {
        if (typeof resources2[m2] === "string" || Object.prototype.toString.apply(resources2[m2]) === "[object Array]")
          this.addResource(lng, ns, m2, resources2[m2], {
            silent: true
          });
      }
      if (!options2.silent)
        this.emit("added", lng, ns, resources2);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources2, deep, overwrite) {
      var options2 = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];
      if (lng.indexOf(".") > -1) {
        path = lng.split(".");
        deep = resources2;
        resources2 = ns;
        ns = path[1];
      }
      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};
      if (deep) {
        deepExtend(pack, resources2, overwrite);
      } else {
        pack = _objectSpread$1({}, pack, resources2);
      }
      setPath(this.data, path, pack);
      if (!options2.silent)
        this.emit("added", lng, ns, resources2);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }
      this.removeNamespaces(ns);
      this.emit("removed", lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== void 0;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns)
        ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === "v1")
        return _objectSpread$1({}, {}, this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);
  return ResourceStore2;
}(EventEmitter);
var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options2, translator) {
    var _this = this;
    processors.forEach(function(processor) {
      if (_this.processors[processor])
        value = _this.processors[processor].process(value, key, options2, translator);
    });
    return value;
  }
};
var checkedLoadedFor = {};
var Translator = function(_EventEmitter) {
  _inherits(Translator2, _EventEmitter);
  function Translator2(services) {
    var _this;
    var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck(this, Translator2);
    _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(Translator2).call(this));
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$1(_this));
    }
    copy$1(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], services, _assertThisInitialized$1(_this));
    _this.options = options2;
    if (_this.options.keySeparator === void 0) {
      _this.options.keySeparator = ".";
    }
    _this.logger = baseLogger.create("translator");
    return _this;
  }
  _createClass(Translator2, [{
    key: "changeLanguage",
    value: function changeLanguage2(lng) {
      if (lng)
        this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      };
      var resolved = this.resolve(key, options2);
      return resolved && resolved.res !== void 0;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options2) {
      var nsSeparator = options2.nsSeparator !== void 0 ? options2.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === void 0)
        nsSeparator = ":";
      var keySeparator = options2.keySeparator !== void 0 ? options2.keySeparator : this.options.keySeparator;
      var namespaces = options2.ns || this.options.defaultNS;
      if (nsSeparator && key.indexOf(nsSeparator) > -1) {
        var m2 = key.match(this.interpolator.nestingRegexp);
        if (m2 && m2.length > 0) {
          return {
            key,
            namespaces
          };
        }
        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1)
          namespaces = parts.shift();
        key = parts.join(keySeparator);
      }
      if (typeof namespaces === "string")
        namespaces = [namespaces];
      return {
        key,
        namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate2(keys2, options2, lastKey) {
      var _this2 = this;
      if (_typeof(options2) !== "object" && this.options.overloadTranslationOptionHandler) {
        options2 = this.options.overloadTranslationOptionHandler(arguments);
      }
      if (!options2)
        options2 = {};
      if (keys2 === void 0 || keys2 === null)
        return "";
      if (!Array.isArray(keys2))
        keys2 = [String(keys2)];
      var keySeparator = options2.keySeparator !== void 0 ? options2.keySeparator : this.options.keySeparator;
      var _this$extractFromKey = this.extractFromKey(keys2[keys2.length - 1], options2), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
      var namespace = namespaces[namespaces.length - 1];
      var lng = options2.lng || this.language;
      var appendNamespaceToCIMode = options2.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if (lng && lng.toLowerCase() === "cimode") {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options2.nsSeparator || this.options.nsSeparator;
          return namespace + nsSeparator + key;
        }
        return key;
      }
      var resolved = this.resolve(keys2, options2);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ["[object Number]", "[object Function]", "[object RegExp]"];
      var joinArrays = options2.joinArrays !== void 0 ? options2.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
        if (!options2.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn("accessing an object - but returnObjects options is not enabled!");
          }
          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$1({}, options2, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
        }
        if (keySeparator) {
          var resTypeIsArray = resType === "[object Array]";
          var copy2 = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
          for (var m2 in res) {
            if (Object.prototype.hasOwnProperty.call(res, m2)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m2);
              copy2[m2] = this.translate(deepKey, _objectSpread$1({}, options2, {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy2[m2] === deepKey)
                copy2[m2] = res[m2];
            }
          }
          res = copy2;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
        res = res.join(joinArrays);
        if (res)
          res = this.extendTranslation(res, keys2, options2, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options2.count !== void 0 && typeof options2.count !== "string";
        var hasDefaultValue = Translator2.hasDefaultValue(options2);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options2.count) : "";
        var defaultValue = options2["defaultValue".concat(defaultValueSuffix)] || options2.defaultValue;
        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }
        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
          if (keySeparator) {
            var fk2 = this.resolve(key, _objectSpread$1({}, options2, {
              keySeparator: false
            }));
            if (fk2 && fk2.res)
              this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
          }
          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options2.lng || this.language);
          if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) {
            for (var i2 = 0; i2 < fallbackLngs.length; i2++) {
              lngs.push(fallbackLngs[i2]);
            }
          } else if (this.options.saveMissingTo === "all") {
            lngs = this.languageUtils.toResolveHierarchy(options2.lng || this.language);
          } else {
            lngs.push(options2.lng || this.language);
          }
          var send = function send2(l2, k2, fallbackValue) {
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l2, namespace, k2, updateMissing ? fallbackValue : res, updateMissing, options2);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l2, namespace, k2, updateMissing ? fallbackValue : res, updateMissing, options2);
            }
            _this2.emit("missingKey", l2, namespace, k2, res);
          };
          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function(language) {
                _this2.pluralResolver.getSuffixes(language).forEach(function(suffix) {
                  send([language], key + suffix, options2["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }
        res = this.extendTranslation(res, keys2, options2, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey)
          res = "".concat(namespace, ":").concat(key);
        if (usedKey && this.options.parseMissingKeyHandler)
          res = this.options.parseMissingKeyHandler(res);
      }
      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options2, resolved, lastKey) {
      var _this3 = this;
      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, options2, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved
        });
      } else if (!options2.skipInterpolation) {
        if (options2.interpolation)
          this.interpolator.init(_objectSpread$1({}, options2, {
            interpolation: _objectSpread$1({}, this.options.interpolation, options2.interpolation)
          }));
        var skipOnVariables = options2.interpolation && options2.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
        var nestBef;
        if (skipOnVariables) {
          var nb2 = res.match(this.interpolator.nestingRegexp);
          nestBef = nb2 && nb2.length;
        }
        var data2 = options2.replace && typeof options2.replace !== "string" ? options2.replace : options2;
        if (this.options.interpolation.defaultVariables)
          data2 = _objectSpread$1({}, this.options.interpolation.defaultVariables, data2);
        res = this.interpolator.interpolate(res, data2, options2.lng || this.language, options2);
        if (skipOnVariables) {
          var na2 = res.match(this.interpolator.nestingRegexp);
          var nestAft = na2 && na2.length;
          if (nestBef < nestAft)
            options2.nest = false;
        }
        if (options2.nest !== false)
          res = this.interpolator.nest(res, function() {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            if (lastKey && lastKey[0] === args[0] && !options2.context) {
              _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
              return null;
            }
            return _this3.translate.apply(_this3, args.concat([key]));
          }, options2);
        if (options2.interpolation)
          this.interpolator.reset();
      }
      var postProcess = options2.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === "string" ? [postProcess] : postProcess;
      if (res !== void 0 && res !== null && postProcessorNames && postProcessorNames.length && options2.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$1({
          i18nResolved: resolved
        }, options2) : options2, this);
      }
      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys2) {
      var _this4 = this;
      var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys2 === "string")
        keys2 = [keys2];
      keys2.forEach(function(k2) {
        if (_this4.isValidLookup(found))
          return;
        var extracted = _this4.extractFromKey(k2, options2);
        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS)
          namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options2.count !== void 0 && typeof options2.count !== "string";
        var needsContextHandling = options2.context !== void 0 && typeof options2.context === "string" && options2.context !== "";
        var codes = options2.lngs ? options2.lngs : _this4.languageUtils.toResolveHierarchy(options2.lng || _this4.language, options2.fallbackLng);
        namespaces.forEach(function(ns) {
          if (_this4.isValidLookup(found))
            return;
          usedNS = ns;
          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), `" won't get resolved as namespace "`).concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
          }
          codes.forEach(function(code) {
            if (_this4.isValidLookup(found))
              return;
            usedLng = code;
            var finalKey = key;
            var finalKeys = [finalKey];
            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options2);
            } else {
              var pluralSuffix;
              if (needsPluralHandling)
                pluralSuffix = _this4.pluralResolver.getSuffix(code, options2.count);
              if (needsPluralHandling && needsContextHandling)
                finalKeys.push(finalKey + pluralSuffix);
              if (needsContextHandling)
                finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options2.context));
              if (needsPluralHandling)
                finalKeys.push(finalKey += pluralSuffix);
            }
            var possibleKey;
            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options2);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey,
        exactUsedKey,
        usedLng,
        usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== void 0 && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource)
        return this.i18nFormat.getResource(code, ns, key, options2);
      return this.resourceStore.getResource(code, ns, key, options2);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options2) {
      var prefix2 = "defaultValue";
      for (var option in options2) {
        if (Object.prototype.hasOwnProperty.call(options2, option) && prefix2 === option.substring(0, prefix2.length) && options2[option] !== void 0) {
          return true;
        }
      }
      return false;
    }
  }]);
  return Translator2;
}(EventEmitter);
function capitalize$2(string2) {
  return string2.charAt(0).toUpperCase() + string2.slice(1);
}
var LanguageUtil = function() {
  function LanguageUtil2(options2) {
    _classCallCheck(this, LanguageUtil2);
    this.options = options2;
    this.whitelist = this.options.supportedLngs || false;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create("languageUtils");
  }
  _createClass(LanguageUtil2, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf("-") < 0)
        return null;
      var p2 = code.split("-");
      if (p2.length === 2)
        return null;
      p2.pop();
      if (p2[p2.length - 1].toLowerCase() === "x")
        return null;
      return this.formatLanguageCode(p2.join("-"));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf("-") < 0)
        return code;
      var p2 = code.split("-");
      return this.formatLanguageCode(p2[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === "string" && code.indexOf("-") > -1) {
        var specialCases = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
        var p2 = code.split("-");
        if (this.options.lowerCaseLng) {
          p2 = p2.map(function(part) {
            return part.toLowerCase();
          });
        } else if (p2.length === 2) {
          p2[0] = p2[0].toLowerCase();
          p2[1] = p2[1].toUpperCase();
          if (specialCases.indexOf(p2[1].toLowerCase()) > -1)
            p2[1] = capitalize$2(p2[1].toLowerCase());
        } else if (p2.length === 3) {
          p2[0] = p2[0].toLowerCase();
          if (p2[1].length === 2)
            p2[1] = p2[1].toUpperCase();
          if (p2[0] !== "sgn" && p2[2].length === 2)
            p2[2] = p2[2].toUpperCase();
          if (specialCases.indexOf(p2[1].toLowerCase()) > -1)
            p2[1] = capitalize$2(p2[1].toLowerCase());
          if (specialCases.indexOf(p2[2].toLowerCase()) > -1)
            p2[2] = capitalize$2(p2[2].toLowerCase());
        }
        return p2.join("-");
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted(code) {
      this.logger.deprecate("languageUtils.isWhitelisted", `function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it's usage asap.`);
      return this.isSupportedCode(code);
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }
      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;
      if (!codes)
        return null;
      var found;
      codes.forEach(function(code) {
        if (found)
          return;
        var cleanedLng = _this.formatLanguageCode(code);
        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng))
          found = cleanedLng;
      });
      if (!found && this.options.supportedLngs) {
        codes.forEach(function(code) {
          if (found)
            return;
          var lngOnly = _this.getLanguagePartFromCode(code);
          if (_this.isSupportedCode(lngOnly))
            return found = lngOnly;
          found = _this.options.supportedLngs.find(function(supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0)
              return supportedLng;
          });
        });
      }
      if (!found)
        found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks)
        return [];
      if (typeof fallbacks === "function")
        fallbacks = fallbacks(code);
      if (typeof fallbacks === "string")
        fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === "[object Array]")
        return fallbacks;
      if (!code)
        return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found)
        found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found)
        found = fallbacks[this.formatLanguageCode(code)];
      if (!found)
        found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found)
        found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;
      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];
      var addCode = function addCode2(c2) {
        if (!c2)
          return;
        if (_this2.isSupportedCode(c2)) {
          codes.push(c2);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c2));
        }
      };
      if (typeof code === "string" && code.indexOf("-") > -1) {
        if (this.options.load !== "languageOnly")
          addCode(this.formatLanguageCode(code));
        if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly")
          addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== "currentOnly")
          addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === "string") {
        addCode(this.formatLanguageCode(code));
      }
      fallbackCodes.forEach(function(fc2) {
        if (codes.indexOf(fc2) < 0)
          addCode(_this2.formatLanguageCode(fc2));
      });
      return codes;
    }
  }]);
  return LanguageUtil2;
}();
var sets = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n2) {
    return Number(n2 > 1);
  },
  2: function _2(n2) {
    return Number(n2 != 1);
  },
  3: function _3(n2) {
    return 0;
  },
  4: function _4(n2) {
    return Number(n2 % 10 == 1 && n2 % 100 != 11 ? 0 : n2 % 10 >= 2 && n2 % 10 <= 4 && (n2 % 100 < 10 || n2 % 100 >= 20) ? 1 : 2);
  },
  5: function _5(n2) {
    return Number(n2 == 0 ? 0 : n2 == 1 ? 1 : n2 == 2 ? 2 : n2 % 100 >= 3 && n2 % 100 <= 10 ? 3 : n2 % 100 >= 11 ? 4 : 5);
  },
  6: function _6(n2) {
    return Number(n2 == 1 ? 0 : n2 >= 2 && n2 <= 4 ? 1 : 2);
  },
  7: function _7(n2) {
    return Number(n2 == 1 ? 0 : n2 % 10 >= 2 && n2 % 10 <= 4 && (n2 % 100 < 10 || n2 % 100 >= 20) ? 1 : 2);
  },
  8: function _8(n2) {
    return Number(n2 == 1 ? 0 : n2 == 2 ? 1 : n2 != 8 && n2 != 11 ? 2 : 3);
  },
  9: function _9(n2) {
    return Number(n2 >= 2);
  },
  10: function _10(n2) {
    return Number(n2 == 1 ? 0 : n2 == 2 ? 1 : n2 < 7 ? 2 : n2 < 11 ? 3 : 4);
  },
  11: function _11(n2) {
    return Number(n2 == 1 || n2 == 11 ? 0 : n2 == 2 || n2 == 12 ? 1 : n2 > 2 && n2 < 20 ? 2 : 3);
  },
  12: function _12(n2) {
    return Number(n2 % 10 != 1 || n2 % 100 == 11);
  },
  13: function _13(n2) {
    return Number(n2 !== 0);
  },
  14: function _14(n2) {
    return Number(n2 == 1 ? 0 : n2 == 2 ? 1 : n2 == 3 ? 2 : 3);
  },
  15: function _15(n2) {
    return Number(n2 % 10 == 1 && n2 % 100 != 11 ? 0 : n2 % 10 >= 2 && (n2 % 100 < 10 || n2 % 100 >= 20) ? 1 : 2);
  },
  16: function _16(n2) {
    return Number(n2 % 10 == 1 && n2 % 100 != 11 ? 0 : n2 !== 0 ? 1 : 2);
  },
  17: function _17(n2) {
    return Number(n2 == 1 || n2 % 10 == 1 && n2 % 100 != 11 ? 0 : 1);
  },
  18: function _18(n2) {
    return Number(n2 == 0 ? 0 : n2 == 1 ? 1 : 2);
  },
  19: function _19(n2) {
    return Number(n2 == 1 ? 0 : n2 == 0 || n2 % 100 > 1 && n2 % 100 < 11 ? 1 : n2 % 100 > 10 && n2 % 100 < 20 ? 2 : 3);
  },
  20: function _20(n2) {
    return Number(n2 == 1 ? 0 : n2 == 0 || n2 % 100 > 0 && n2 % 100 < 20 ? 1 : 2);
  },
  21: function _21(n2) {
    return Number(n2 % 100 == 1 ? 1 : n2 % 100 == 2 ? 2 : n2 % 100 == 3 || n2 % 100 == 4 ? 3 : 0);
  },
  22: function _22(n2) {
    return Number(n2 == 1 ? 0 : n2 == 2 ? 1 : (n2 < 0 || n2 > 10) && n2 % 10 == 0 ? 2 : 3);
  }
};
function createRules() {
  var rules = {};
  sets.forEach(function(set2) {
    set2.lngs.forEach(function(l2) {
      rules[l2] = {
        numbers: set2.nr,
        plurals: _rulesPluralsTypes[set2.fc]
      };
    });
  });
  return rules;
}
var PluralResolver = function() {
  function PluralResolver2(languageUtils) {
    var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck(this, PluralResolver2);
    this.languageUtils = languageUtils;
    this.options = options2;
    this.logger = baseLogger.create("pluralResolver");
    this.rules = createRules();
  }
  _createClass(PluralResolver2, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var rule = this.getRule(code);
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      return this.getSuffixes(code).map(function(suffix) {
        return key + suffix;
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;
      var rule = this.getRule(code);
      if (!rule) {
        return [];
      }
      return rule.numbers.map(function(number2) {
        return _this.getSuffix(code, number2);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var _this2 = this;
      var rule = this.getRule(code);
      if (rule) {
        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        var suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          if (suffix === 2) {
            suffix = "plural";
          } else if (suffix === 1) {
            suffix = "";
          }
        }
        var returnSuffix = function returnSuffix2() {
          return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
        };
        if (this.options.compatibilityJSON === "v1") {
          if (suffix === 1)
            return "";
          if (typeof suffix === "number")
            return "_plural_".concat(suffix.toString());
          return returnSuffix();
        } else if (this.options.compatibilityJSON === "v2") {
          return returnSuffix();
        } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          return returnSuffix();
        }
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
      }
      this.logger.warn("no plural rule found for: ".concat(code));
      return "";
    }
  }]);
  return PluralResolver2;
}();
var Interpolator = function() {
  function Interpolator2() {
    var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, Interpolator2);
    this.logger = baseLogger.create("interpolator");
    this.options = options2;
    this.format = options2.interpolation && options2.interpolation.format || function(value) {
      return value;
    };
    this.init(options2);
  }
  _createClass(Interpolator2, [{
    key: "init",
    value: function init2() {
      var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (!options2.interpolation)
        options2.interpolation = {
          escapeValue: true
        };
      var iOpts = options2.interpolation;
      this.escape = iOpts.escape !== void 0 ? iOpts.escape : escape;
      this.escapeValue = iOpts.escapeValue !== void 0 ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== void 0 ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
      this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
      this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape("$t(");
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(")");
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1e3;
      this.alwaysFormat = iOpts.alwaysFormat !== void 0 ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options)
        this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, "g");
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data2, lng, options2) {
      var _this = this;
      var match2;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
      function regexSafe(val) {
        return val.replace(/\$/g, "$$$$");
      }
      var handleFormat = function handleFormat2(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data2, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, void 0, lng, _objectSpread$1({}, options2, data2, {
            interpolationkey: key
          })) : path;
        }
        var p2 = key.split(_this.formatSeparator);
        var k2 = p2.shift().trim();
        var f2 = p2.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data2, defaultData, k2), f2, lng, _objectSpread$1({}, options2, data2, {
          interpolationkey: k2
        }));
      };
      this.resetRegExp();
      var missingInterpolationHandler = options2 && options2.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options2 && options2.interpolation && options2.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function(todo) {
        replaces = 0;
        while (match2 = todo.regex.exec(str)) {
          value = handleFormat(match2[1].trim());
          if (value === void 0) {
            if (typeof missingInterpolationHandler === "function") {
              var temp = missingInterpolationHandler(str, match2, options2);
              value = typeof temp === "string" ? temp : "";
            } else if (skipOnVariables) {
              value = match2[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(match2[1], " for interpolating ").concat(str));
              value = "";
            }
          } else if (typeof value !== "string" && !_this.useRawValueToEscape) {
            value = makeString(value);
          }
          var safeValue = todo.safeValue(value);
          str = str.replace(match2[0], safeValue);
          if (skipOnVariables) {
            todo.regex.lastIndex += safeValue.length;
            todo.regex.lastIndex -= match2[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }
          replaces++;
          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc2) {
      var _this2 = this;
      var options2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      var match2;
      var value;
      var clonedOptions = _objectSpread$1({}, options2);
      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;
      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0)
          return key;
        var c2 = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c2[1]);
        key = c2[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');
        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions)
            clonedOptions = _objectSpread$1({}, inheritedOptions, clonedOptions);
        } catch (e2) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e2);
          return "".concat(key).concat(sep).concat(optionsString);
        }
        delete clonedOptions.defaultValue;
        return key;
      }
      while (match2 = this.nestingRegexp.exec(str)) {
        var formatters2 = [];
        var doReduce = false;
        if (match2[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match2[1])) {
          var r2 = match2[1].split(this.formatSeparator).map(function(elem) {
            return elem.trim();
          });
          match2[1] = r2.shift();
          formatters2 = r2;
          doReduce = true;
        }
        value = fc2(handleHasOptions.call(this, match2[1].trim(), clonedOptions), clonedOptions);
        if (value && match2[0] === str && typeof value !== "string")
          return value;
        if (typeof value !== "string")
          value = makeString(value);
        if (!value) {
          this.logger.warn("missed to resolve ".concat(match2[1], " for nesting ").concat(str));
          value = "";
        }
        if (doReduce) {
          value = formatters2.reduce(function(v2, f2) {
            return _this2.format(v2, f2, options2.lng, _objectSpread$1({}, options2, {
              interpolationkey: match2[1].trim()
            }));
          }, value.trim());
        }
        str = str.replace(match2[0], value);
        this.regexp.lastIndex = 0;
      }
      return str;
    }
  }]);
  return Interpolator2;
}();
function remove(arr, what) {
  var found = arr.indexOf(what);
  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}
var Connector = function(_EventEmitter) {
  _inherits(Connector2, _EventEmitter);
  function Connector2(backend, store, services) {
    var _this;
    var options2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    _classCallCheck(this, Connector2);
    _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(Connector2).call(this));
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$1(_this));
    }
    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options2;
    _this.logger = baseLogger.create("backendConnector");
    _this.state = {};
    _this.queue = [];
    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options2.backend, options2);
    }
    return _this;
  }
  _createClass(Connector2, [{
    key: "queueLoad",
    value: function queueLoad(languages2, namespaces, options2, callback) {
      var _this2 = this;
      var toLoad = [];
      var pending = [];
      var toLoadLanguages = [];
      var toLoadNamespaces = [];
      languages2.forEach(function(lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function(ns) {
          var name = "".concat(lng, "|").concat(ns);
          if (!options2.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0)
            ;
          else if (_this2.state[name] === 1) {
            if (pending.indexOf(name) < 0)
              pending.push(name);
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending.indexOf(name) < 0)
              pending.push(name);
            if (toLoad.indexOf(name) < 0)
              toLoad.push(name);
            if (toLoadNamespaces.indexOf(ns) < 0)
              toLoadNamespaces.push(ns);
          }
        });
        if (!hasAllNamespaces)
          toLoadLanguages.push(lng);
      });
      if (toLoad.length || pending.length) {
        this.queue.push({
          pending,
          loaded: {},
          errors: [],
          callback
        });
      }
      return {
        toLoad,
        pending,
        toLoadLanguages,
        toLoadNamespaces
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data2) {
      var s = name.split("|");
      var lng = s[0];
      var ns = s[1];
      if (err)
        this.emit("failedLoading", lng, ns, err);
      if (data2) {
        this.store.addResourceBundle(lng, ns, data2);
      }
      this.state[name] = err ? -1 : 2;
      var loaded2 = {};
      this.queue.forEach(function(q2) {
        pushPath(q2.loaded, [lng], ns);
        remove(q2.pending, name);
        if (err)
          q2.errors.push(err);
        if (q2.pending.length === 0 && !q2.done) {
          Object.keys(q2.loaded).forEach(function(l2) {
            if (!loaded2[l2])
              loaded2[l2] = [];
            if (q2.loaded[l2].length) {
              q2.loaded[l2].forEach(function(ns2) {
                if (loaded2[l2].indexOf(ns2) < 0)
                  loaded2[l2].push(ns2);
              });
            }
          });
          q2.done = true;
          if (q2.errors.length) {
            q2.callback(q2.errors);
          } else {
            q2.callback();
          }
        }
      });
      this.emit("loaded", loaded2);
      this.queue = this.queue.filter(function(q2) {
        return !q2.done;
      });
    }
  }, {
    key: "read",
    value: function read2(lng, ns, fcName) {
      var _this3 = this;
      var tried = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 350;
      var callback = arguments.length > 5 ? arguments[5] : void 0;
      if (!lng.length)
        return callback(null, {});
      return this.backend[fcName](lng, ns, function(err, data2) {
        if (err && data2 && tried < 5) {
          setTimeout(function() {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }
        callback(err, data2);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages2, namespaces) {
      var _this4 = this;
      var options2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : void 0;
      if (!this.backend) {
        this.logger.warn("No backend was added via i18next.use. Will not load resources.");
        return callback && callback();
      }
      if (typeof languages2 === "string")
        languages2 = this.languageUtils.toResolveHierarchy(languages2);
      if (typeof namespaces === "string")
        namespaces = [namespaces];
      var toLoad = this.queueLoad(languages2, namespaces, options2, callback);
      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length)
          callback();
        return null;
      }
      toLoad.toLoad.forEach(function(name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages2, namespaces, callback) {
      this.prepareLoading(languages2, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages2, namespaces, callback) {
      this.prepareLoading(languages2, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;
      var prefix2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      var s = name.split("|");
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, "read", void 0, void 0, function(err, data2) {
        if (err)
          _this5.logger.warn("".concat(prefix2, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data2)
          _this5.logger.log("".concat(prefix2, "loaded namespace ").concat(ns, " for language ").concat(lng), data2);
        _this5.loaded(name, err, data2);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages2, namespace, key, fallbackValue, isUpdate) {
      var options2 = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
        return;
      }
      if (key === void 0 || key === null || key === "")
        return;
      if (this.backend && this.backend.create) {
        this.backend.create(languages2, namespace, key, fallbackValue, null, _objectSpread$1({}, options2, {
          isUpdate
        }));
      }
      if (!languages2 || !languages2[0])
        return;
      this.store.addResource(languages2[0], namespace, key, fallbackValue);
    }
  }]);
  return Connector2;
}(EventEmitter);
function get$3() {
  return {
    debug: false,
    initImmediate: true,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: false,
    whitelist: false,
    nonExplicitWhitelist: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: "all",
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: "fallback",
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle2(args) {
      var ret = {};
      if (_typeof(args[1]) === "object")
        ret = args[1];
      if (typeof args[1] === "string")
        ret.defaultValue = args[1];
      if (typeof args[2] === "string")
        ret.tDescription = args[2];
      if (_typeof(args[2]) === "object" || _typeof(args[3]) === "object") {
        var options2 = args[3] || args[2];
        Object.keys(options2).forEach(function(key) {
          ret[key] = options2[key];
        });
      }
      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format2(value, _format, lng, options2) {
        return value;
      },
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: false
    }
  };
}
function transformOptions(options2) {
  if (typeof options2.ns === "string")
    options2.ns = [options2.ns];
  if (typeof options2.fallbackLng === "string")
    options2.fallbackLng = [options2.fallbackLng];
  if (typeof options2.fallbackNS === "string")
    options2.fallbackNS = [options2.fallbackNS];
  if (options2.whitelist) {
    if (options2.whitelist && options2.whitelist.indexOf("cimode") < 0) {
      options2.whitelist = options2.whitelist.concat(["cimode"]);
    }
    options2.supportedLngs = options2.whitelist;
  }
  if (options2.nonExplicitWhitelist) {
    options2.nonExplicitSupportedLngs = options2.nonExplicitWhitelist;
  }
  if (options2.supportedLngs && options2.supportedLngs.indexOf("cimode") < 0) {
    options2.supportedLngs = options2.supportedLngs.concat(["cimode"]);
  }
  return options2;
}
function noop$4() {
}
var I18n = function(_EventEmitter) {
  _inherits(I18n2, _EventEmitter);
  function I18n2() {
    var _this;
    var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : void 0;
    _classCallCheck(this, I18n2);
    _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(I18n2).call(this));
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$1(_this));
    }
    _this.options = transformOptions(options2);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    if (callback && !_this.isInitialized && !options2.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options2, callback);
        return _possibleConstructorReturn$1(_this, _assertThisInitialized$1(_this));
      }
      setTimeout(function() {
        _this.init(options2, callback);
      }, 0);
    }
    return _this;
  }
  _createClass(I18n2, [{
    key: "init",
    value: function init2() {
      var _this2 = this;
      var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : void 0;
      if (typeof options2 === "function") {
        callback = options2;
        options2 = {};
      }
      if (options2.whitelist && !options2.supportedLngs) {
        this.logger.deprecate("whitelist", 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
      }
      if (options2.nonExplicitWhitelist && !options2.nonExplicitSupportedLngs) {
        this.logger.deprecate("whitelist", 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
      }
      this.options = _objectSpread$1({}, get$3(), this.options, transformOptions(options2));
      this.format = this.options.interpolation.format;
      if (!callback)
        callback = noop$4;
      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject)
          return null;
        if (typeof ClassOrObject === "function")
          return new ClassOrObject();
        return ClassOrObject;
      }
      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }
        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on("*", function(event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          _this2.emit.apply(_this2, [event].concat(args));
        });
        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }
        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init)
            s.i18nFormat.init(this);
        }
        this.translator = new Translator(this.services, this.options);
        this.translator.on("*", function(event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function(m2) {
          if (m2.init)
            m2.init(_this2);
        });
      }
      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== "dev")
          this.options.lng = codes[0];
      }
      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn("init: no languageDetector is used and no lng is defined");
      }
      var storeApi = ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"];
      storeApi.forEach(function(fcName) {
        _this2[fcName] = function() {
          var _this2$store;
          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"];
      storeApiChained.forEach(function(fcName) {
        _this2[fcName] = function() {
          var _this2$store2;
          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
          return _this2;
        };
      });
      var deferred = defer();
      var load = function load2() {
        var finish = function finish2(err, t2) {
          if (_this2.isInitialized)
            _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
          _this2.isInitialized = true;
          if (!_this2.options.isClone)
            _this2.logger.log("initialized", _this2.options);
          _this2.emit("initialized", _this2.options);
          deferred.resolve(t2);
          callback(err, t2);
        };
        if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized)
          return finish(null, _this2.t.bind(_this2));
        _this2.changeLanguage(_this2.options.lng, finish);
      };
      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }
      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;
      var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop$4;
      var usedCallback = callback;
      var usedLng = typeof language === "string" ? language : this.language;
      if (typeof language === "function")
        usedCallback = language;
      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === "cimode")
          return usedCallback();
        var toLoad = [];
        var append2 = function append3(lng) {
          if (!lng)
            return;
          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
          lngs.forEach(function(l2) {
            if (toLoad.indexOf(l2) < 0)
              toLoad.push(l2);
          });
        };
        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function(l2) {
            return append2(l2);
          });
        } else {
          append2(usedLng);
        }
        if (this.options.preload) {
          this.options.preload.forEach(function(l2) {
            return append2(l2);
          });
        }
        this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs)
        lngs = this.languages;
      if (!ns)
        ns = this.options.ns;
      if (!callback)
        callback = noop$4;
      this.services.backendConnector.reload(lngs, ns, function(err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use2(module) {
      if (!module)
        throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
      if (!module.type)
        throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
      if (module.type === "backend") {
        this.modules.backend = module;
      }
      if (module.type === "logger" || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }
      if (module.type === "languageDetector") {
        this.modules.languageDetector = module;
      }
      if (module.type === "i18nFormat") {
        this.modules.i18nFormat = module;
      }
      if (module.type === "postProcessor") {
        postProcessor.addPostProcessor(module);
      }
      if (module.type === "3rdParty") {
        this.modules.external.push(module);
      }
      return this;
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage2(lng, callback) {
      var _this4 = this;
      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit("languageChanging", lng);
      var done = function done2(err, l2) {
        if (l2) {
          _this4.language = l2;
          _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l2);
          _this4.translator.changeLanguage(l2);
          _this4.isLanguageChangingTo = void 0;
          _this4.emit("languageChanged", l2);
          _this4.logger.log("languageChanged", l2);
        } else {
          _this4.isLanguageChangingTo = void 0;
        }
        deferred.resolve(function() {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback)
          callback(err, function() {
            return _this4.t.apply(_this4, arguments);
          });
      };
      var setLng = function setLng2(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector)
          lngs = [];
        var l2 = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
        if (l2) {
          if (!_this4.language) {
            _this4.language = l2;
            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l2);
          }
          if (!_this4.translator.language)
            _this4.translator.changeLanguage(l2);
          if (_this4.services.languageDetector)
            _this4.services.languageDetector.cacheUserLanguage(l2);
        }
        _this4.loadResources(l2, function(err) {
          done(err, l2);
        });
      };
      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }
      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns) {
      var _this5 = this;
      var fixedT = function fixedT2(key, opts) {
        var options2;
        if (_typeof(opts) !== "object") {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }
          options2 = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options2 = _objectSpread$1({}, opts);
        }
        options2.lng = options2.lng || fixedT2.lng;
        options2.lngs = options2.lngs || fixedT2.lngs;
        options2.ns = options2.ns || fixedT2.ns;
        return _this5.t(key, options2);
      };
      if (typeof lng === "string") {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }
      fixedT.ns = ns;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t2() {
      var _this$translator;
      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;
      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace2(ns) {
      var _this6 = this;
      var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (!this.isInitialized) {
        this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
        return false;
      }
      if (!this.languages || !this.languages.length) {
        this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
        return false;
      }
      var lng = this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === "cimode")
        return true;
      var loadNotPending = function loadNotPending2(l2, n2) {
        var loadState = _this6.services.backendConnector.state["".concat(l2, "|").concat(n2)];
        return loadState === -1 || loadState === 2;
      };
      if (options2.precheck) {
        var preResult = options2.precheck(this, loadNotPending);
        if (preResult !== void 0)
          return preResult;
      }
      if (this.hasResourceBundle(lng, ns))
        return true;
      if (!this.services.backendConnector.backend)
        return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns)))
        return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces2(ns, callback) {
      var _this7 = this;
      var deferred = defer();
      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }
      if (typeof ns === "string")
        ns = [ns];
      ns.forEach(function(n2) {
        if (_this7.options.ns.indexOf(n2) < 0)
          _this7.options.ns.push(n2);
      });
      this.loadResources(function(err) {
        deferred.resolve();
        if (callback)
          callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === "string")
        lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function(lng) {
        return preloaded.indexOf(lng) < 0;
      });
      if (!newLngs.length) {
        if (callback)
          callback();
        return Promise.resolve();
      }
      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function(err) {
        deferred.resolve();
        if (callback)
          callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng)
        lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
      if (!lng)
        return "rtl";
      var rtlLngs = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam"];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? "rtl" : "ltr";
    }
  }, {
    key: "createInstance",
    value: function createInstance2() {
      var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : void 0;
      return new I18n2(options2, callback);
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;
      var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop$4;
      var mergedOptions = _objectSpread$1({}, this.options, options2, {
        isClone: true
      });
      var clone2 = new I18n2(mergedOptions);
      var membersToCopy = ["store", "services", "language"];
      membersToCopy.forEach(function(m2) {
        clone2[m2] = _this8[m2];
      });
      clone2.services = _objectSpread$1({}, this.services);
      clone2.services.utils = {
        hasLoadedNamespace: clone2.hasLoadedNamespace.bind(clone2)
      };
      clone2.translator = new Translator(clone2.services, clone2.options);
      clone2.translator.on("*", function(event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }
        clone2.emit.apply(clone2, [event].concat(args));
      });
      clone2.init(mergedOptions, callback);
      clone2.translator.options = clone2.options;
      clone2.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone2.hasLoadedNamespace.bind(clone2)
      };
      return clone2;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages
      };
    }
  }]);
  return I18n2;
}(EventEmitter);
var i18next = new I18n();
var Language;
(function(Language2) {
  Language2["TH"] = "th";
  Language2["EN"] = "en";
})(Language || (Language = {}));
const en$m = {
  aiGuideline: {
    trainBot: "Train bot",
    preTitle: "3 simple steps to help your bot become even smarter!",
    title: "AI Settings",
    botSetting: "Bot setting",
    botSettingDescription: "Customize your bot responses to sound admin-like and to be store-specific.",
    botWelcomeMessage: "Welcome message",
    botWelcomeMessageDescription: "Create a store welcome message with product suggestions or necessary information for new customers.",
    botSpecialKnowledge: "Specialized Knowledge",
    botSpecialKnowledgeDescription: "Train your bot to answer store-specific questions and chat more comprehensively with FAQs .",
    slide1: {
      title: "AI Settings",
      description: "Enable/disable or customize any feature of your bot to meet your store's needs, such as the time your bot resumes responding, the product display, and the shopping flow setting."
    },
    slide2: {
      title: "Welcome message",
      description: "Create a welcome message for new customers. You can include text, images, a product catalog, and even product suggestions from your store in up to 4 messages."
    },
    slide3: {
      title: "Specialized Knowledge",
      description: "Train your bot to provide comprehensive answers to your customers by - Set a group of similar 3-4 questions - Set the answer in text, images, or a product catalog -Begin training your bot and wait 1 minute for it to learn the answer."
    }
  }
};
const en$l = {
  cancel: "Cancel",
  connect: "Connect",
  connected: "connected",
  description: {
    facebook: "Connect by Login and select the 'Page' you want to connect to.",
    instagram: "Connect with your Instagram Business account linked to your Facebook page",
    line: "Connect by filling out the Channel ID, Channel secret and Channel access token of the store by going to the LINE official account."
  },
  disconnect: "Disconnect",
  learnMore: "Learn more",
  lineChannelAccessToken: "Channel access token",
  lineChannelAccessTokenAlertInformation: "If the Merchant does not have a LINE Developers Account, the Merchant must create a Developers Account by logging in with the Merchant's LINE account or Business Account first.",
  lineChannelAccessTokenTitle: "Enter the Channel access token",
  lineChannelAccessTokenDescription1: 'to <a href="https://developers.line.biz/console/" class="tw-text-primary-600 tw-font-medium" target="_blank">https://developers.line.biz/console/</a>',
  lineChannelAccessTokenDescription2: 'Select the <strong class="tw-font-medium">Provider</strong> of the account you want to connect to, select the <strong class="tw-font-medium">merchant account</strong> you want to connect to, go to the <strong class="tw-font-medium">Channel Setting</strong> section and scroll to the Channel access token (long-lived) section. Copy the Channel access token obtained from LINE Developer and enter it in the deeple console from Then click "Connect"',
  lineChannelId: "Channel ID",
  lineChannelIdAndSecretTitle: "Enter your Channel ID, Channel secret",
  lineChannelIdAndSecretDescription: 'go to <a href="https://account.line.biz/login?redirectUri=https%3A%2F%2Fmanager.line.biz%2F%3Fstatus%3Dsuccess%26status%3Dcancelled" class="tw-text-primary-600 tw-font-medium" target="_blank">LINE Official Account</a> page of the store, select <strong class="tw-font-medium">"Setting"</strong>, select <strong class="tw-font-medium">"Messaging API"</strong>, click the <strong class="tw-font-medium">"Enable Messaging API"</strong> button, select the desired provider, you can create a new provider (New provider) or choose from an existing one. and then click "OK" choose the desired provider you can create a new provider (New provider) or choose from the existing one then click "OK" Copy the Channel ID and Channel secret to enter in deeple console.',
  lineChannelSecret: "Channel secret",
  lineConnectMessageApi: "Connect Messaging API",
  lineConnectMessageApiAlertInformation: `You can apply for a new <a href="https://manager.line.biz/" class="tw-text-primary-600" target="_blank">LINE Official Account</a> if you don't have one.Or if you have another LINE account, you can contact <a href="https://lineforbusiness.com/th-en/contact" class="tw-text-primary-600" target="_blank">LINE Thailand</a> to request a transfer to an Official Account.If you already have a valid account, you can skip this step.`,
  new: "New",
  title: {
    facebook: "Facebook Page",
    instagram: "Instagram Business",
    line: "LINE Official Account"
  },
  watchVideo: "Watch video"
};
const en$k = {
  gettingStarted: {
    title: "Cashback",
    hero: {
      title: "Earn cashback Upto 20% with NFTs",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    stepsTitle: "Getting Started",
    stepsTogo: "{{step}} steps to go",
    connectWallet: {
      title: "Connect Wallet",
      description: "Add catalogs, products and their details to your store and fill the inventory, making the bot ready to sell your products",
      button: "Connected"
    },
    useNftCashback: {
      title: "Use NFT Cashback",
      description: "Select shipping methods and set shipping fees that suit your store best.",
      button: "Add shipping"
    },
    watchTutorial: "Watch Tutorial"
  }
};
const en$j = {
  error: {
    categoryNameCannotBeEmpty: "Catalog name cannot be empty",
    duplicateCategoryName: "Catalog name cannot duplicated",
    exceedMaximumCategoryLimit: "Catalog limit is exceeded"
  }
};
const en$i = {
  action: {
    next: "next"
  },
  modal: {
    errorUpload: {
      title: "Cannot upload image.",
      description: "Please ensure that your image is .JPG, .JPEG or .PNG file with a file size of less than 2 MB.",
      ok: "OK"
    },
    confirmationModal: {
      confirm: "Confirm",
      cancel: "Cancel"
    },
    close: "Close"
  },
  date: {
    days: "days",
    day: "day"
  }
};
const en$h = {
  description: "With the Messaging API, chatbots can answer customer questions. provide product information and close the sale in time",
  facebook: {
    connect: {
      error: "Facebook page connect failed",
      success: "Facebook page was connected"
    },
    disconnect: {
      error: "Facebook page failed to disconnect",
      success: "Facebook page was disconnected"
    }
  },
  instagram: {
    connect: {
      error: "Instagram Business failed to connect",
      success: "Instagram Business was connected"
    },
    disconnect: {
      error: "Instagram Business failed to disconnect",
      success: "Instagram Business was disconnected"
    }
  },
  line: {
    connect: {
      error: "Line credential failed to connect",
      success: "Line credential was connected"
    },
    disconnect: {
      error: "Line credential failed to disconnect",
      success: "Line credential was disconnected"
    }
  },
  title: "Connect Store"
};
const en$g = {
  optional: "- optional",
  sideBar: {
    title: "Welcome to deeple",
    paragraph1: "Hello {{name}},",
    paragraph2: "We woud like to know your store information for a bit",
    paragraph3: "Get started by creating your store and be ready to have just about anything of your store managed all in one place with deeple.",
    logout: "Logout"
  },
  detail: {
    title: "Choose Your Store",
    title2: "Create Your First Store",
    notHasStoreTitle: {
      prefix: "Connect to all social media channels (Facebook Page, Instagram Business, Line OA) by creating",
      label: " only one deeple store."
    },
    hasStoreTitle: "Go chat with your customers now!",
    createStore: {
      label: "Create new store",
      button: "Create"
    },
    add: "Add",
    cancel: "Cancel",
    choose: "Choose",
    storeName: {
      label: "Store Name",
      placeholder: "Name",
      error: "Please enter your store name"
    },
    businessType: {
      label: "Type of business",
      placeholder: "Choose your business"
    },
    customBusinessType: {
      error: "Please enter your type of business"
    },
    refCode: {
      label: "Referral code",
      placeholder: "Code"
    }
  },
  businessType: {
    AGENCY_AND_ADVERTISING: "Agency & Advertising",
    AGRICULTURE_AND_FORESTRY: "Agriculture & Forestry",
    AUTOMOTIVE_AND_PARTS: "Automotive & Parts",
    BEAUTY_AND_COSMETIC: "Beauty & Cosmetic",
    CONSTRUCTION: "Construction",
    CLOTHES_AND_FASHION_GOODS: "Clothes & Fashion goods",
    EDUCATION: "Education",
    ELECTRONIC_DEVICES_AND_GADGETS: "Electronic devices & Gadgets",
    FINANCIAL_SERVICES: "Financial services",
    FOOD_DRINK_AND_BAKERY: "Food, Drink & Bakery",
    FURNITURE_AND_DECORATION: "Furniture & Decoration",
    GENERAL_GOODS: "General goods",
    GOLD_AND_JEWELS: "Gold & Jewels",
    GOVERNMENT: "Government",
    HEALTH_CARE: "Health Care",
    INSURANCE: "Insurance",
    MEDIA_AND_ENTERTAINMENT: "Media & Entertainment",
    MERCHANDISE: "Merchandise",
    PET_SUPPLY: "Pet supply",
    PHARMACEUTICALS_AND_BIOTECH: "Pharmaceuticals & Biotech",
    HEALTH_CARE_PHARMACEUTICALS_AND_BIOTECH: "Health Care Pharmaceuticals & Biotech",
    PROFESSIONAL_AND_TECHNICAL_SERVICES: "Professional & Technical services",
    STATIONERY_AND_SPORT: "Stationery & Sport",
    TECHNOLOGY_SOFTWARE: "Technology Software",
    TELECOMMUNICATION: "Telecommunication",
    HOTEL_TRAVEL_AND_LEISURE: "Hotel, Travel & Leisure",
    OTHER: "Others (fill the form)"
  },
  nft: {
    contactLinks: {
      title: "Our Community"
    },
    createStoreForm: {
      customBusinessTypeLabel: "Other"
    },
    sideBar: {
      title: "Welcome to NFT's"
    }
  }
};
const en$f = {
  adminModeWarningPopup: {
    title: "Please activate 'Bot shopping mode'",
    subtitle: "to start selling through Facebook Live",
    description: "The store can be disabled. 'Bot shopping mode' after the live ends",
    cancel: "Close",
    confirm: "Go to AI setings"
  },
  alert: {
    title: "for selling products through Facebook Live without interruption Please check the settings. 'Chat reply mode' as follows:",
    1: "Enable 'Bot shopping mode' (required).",
    2: "Select the chat response mode as 'AI Sales mode'.",
    3: "Turn off working hours of Admin mode.",
    btn: "Check settings"
  }
};
const en$e = {
  steps: {
    default: {
      title: "Getting started",
      subtitle: "Your setup has been completed ({{completed}}/{{steps}})"
    },
    setupProduct: {
      button: "Next",
      incomplete: {
        title: "Add product"
      },
      completed: {
        title: "Your product(s) is added."
      }
    },
    setupShippingMethod: {
      button: "Next",
      incomplete: {
        title: "Add shipping"
      },
      completed: {
        title: "Your shipping is added."
      }
    },
    setupChannelConnection: {
      button: "Next",
      incomplete: {
        title: "Connect your Facebook page or LINE OA"
      },
      completed: {
        title: "Your store is connected to sales channel."
      }
    },
    setupDeeplePay: {
      button: "Next",
      incomplete: {
        title: "Payment deeple pay (optional)"
      },
      completed: {
        title: "You have successfully set up deeple pay."
      }
    },
    setupBot: {
      button: "Train bot",
      incomplete: {
        title: "Train your bot (optional)"
      },
      completed: {
        title: "Your bot is successfully trained!"
      }
    }
  },
  allSettings: "Getting started",
  done: "Done",
  modal: {
    storeCreated: {
      title: "Your Store is Created",
      subtitle: "Your AI chatbot is ready for use now! To enhance the bot intelligence, you can customize Bot settings, Welcome message and train your bot by adding Specialized Knowledge.",
      trainBot: "Train your bot",
      setupDeeplePay: "Payment deeple pay",
      done: "Done"
    }
  }
};
const en$d = {
  cancel: "Cancel",
  content: "Once the connection is 'disconnected',<br />the connected data cannot be restored.",
  disconnect: "Disconnect",
  disconnecting: "Disconnecting...",
  title: {
    facebook: "Disconnect Facebook Page?",
    instagram: "Disconnect Instagram?",
    line: "Disconnect LINE Official Account?"
  }
};
const en$c = {
  alertContent: '\u0E04\u0E38\u0E13\u0E08\u0E30\u0E40\u0E2B\u0E47\u0E19\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E40\u0E1E\u0E08\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19 \u0E21\u0E2D\u0E07\u0E44\u0E21\u0E48\u0E40\u0E2B\u0E47\u0E19\u0E40\u0E1E\u0E08 <a href="" class="tw-text-primary-500" target="_blank">\u0E14\u0E39\u0E27\u0E34\u0E18\u0E35</a>',
  cancel: "Cancel",
  connect: "Connect",
  connecting: "connecting...",
  title: {
    facebook: "Connect Facebook Page",
    instagram: "Connect Instagram"
  }
};
const en$b = {
  brand: {
    facebook: {
      content: "Connect to your Facebook page by 'logging in' and selecting the 'Facebook Page' to which you want to connect."
    },
    instagram: {
      content: "Connect with your Instagram Business account linked to your Facebook page"
    },
    line: {
      content1: "Connect by filling out the Channel ID, Channel secret and Channel access token of the store by going to the LINE official account.",
      content2: "Channel ID and secret are in 'Basic settings'.",
      content3: "Channel access token are in 'Messaging API'",
      content4: "Copy and fill in the blanks. Watch this",
      content5: "video tutorial"
    }
  },
  description: "Connected to your store's Facebook Page or LINE Official Account, deeple AI chatbot will be able to assist customers, provide product information, and close sales in time.",
  done: "Done",
  title: "Gather all customer chats from every social media channel in one place."
};
const en$a = {
  headingHtml: "Facebook Broadcast<br>(Recurring Notifications)",
  content: "The Recurring Notifications enable your shop to safely deliver messages to customers on Messenger, reducing the chance of suspension. It is suitable for newsletter, promotion, or other notifications to keep you engaged with your current and new customers."
};
const en$9 = {
  cancel: "Later",
  description1: "You can connect with us by providing your phone number for better support experience.",
  description2: "Your phone number will not be shared to third-party.",
  errorMessage: "Phone number must be at least 10 digits",
  label: "Phone number",
  placeholder: "Enter 10 digits phone number",
  submit: "Save",
  title: "We\u2019re here to help!"
};
const en$8 = {
  update: {
    success: "Update successfully.",
    fail: "Update fail."
  },
  upload: {
    success: "Upload successfully",
    fail: "Upload fail"
  },
  submit: {
    success: "Submit successfully.",
    fail: "Submit fail."
  }
};
const en$7 = {
  sectionOrderDetailDeeplePay: {
    syncBtn: "Sync Payment Status",
    amount: "Amount",
    paidAt: "Paid At",
    paymentChannel: "Payment Channel",
    paymentStatus: "Payment Status"
  },
  modalSyncDeeplePayStatusFailure: {
    title: "Payment is not found",
    description: "Please wait and try again",
    submitBtn: "Okay"
  },
  modalSyncDeeplePayStatusSuccess: {
    title: "Payment Successfully",
    amount: "Amount",
    receiptNo: "Receipt No",
    submitBtn: "Okay"
  }
};
const en$6 = {
  next: "Next",
  skip: "Skip",
  goToTransactionPage: "Payment setting",
  prev: "Previous",
  connectAccount: "Connect Account",
  paymentGuideline: {
    slide1: {
      title: "What is deeple pay?",
      description: "'deeple pay' is an online payment gateway integrated with deeple AI chatbot to provide customers more payment options and allow your store to track all incoming and outgoing transactions in real time.",
      note: "You can view the fee rates for all payment channels on 'Payment channels' page."
    },
    slide2: {
      title: "Keep track of all transactions in real time.",
      description: "Track all incoming transactions from your customers across all payment channels, including all the withdrawals from your store account in real time.",
      note: "You can view the fee rates for all payment channels on 'Payment channels' page."
    },
    slide3: {
      title: "Make withdrawals in just a few clicks.",
      description: "Simply attach your bank account to Deeple Pay and you can withdraw your store balance instantly.",
      note: "You can view the fee rates for all payment channels on 'Payment channels' page."
    }
  },
  deeplePayGuideline: "Ex. when a customer enters the payment process, pays through deeple pay.",
  bankTransferGuideline: "Ex. when a customer enters the payment process, pays via bank account transfer.",
  contactCustomerSupport: {
    title: {
      newShop: "Enable Debit/Credit card and E-wallet",
      oldShop: "Enable deeple pay"
    },
    description: "Please contact deeple Support at Live-Chat, LINE OA (@kandadigital), Facebook Page (Kanda Digital), Call Center at 08-2639-1645 business hours 10:00-19:00 every day. Public holidays and public holidays"
  }
};
const en$5 = {
  upgradePlan: {
    pageTitle: "Upgrade your store for more advanced features on deeple",
    pageSubTitle: "We offer different pricing plans for every size of business, Choose one that suits you best",
    promotionEnd: "Promotion End",
    save: "SAVE {{ discountPercent }}%",
    forAnnually: "FOR ANNUALLY",
    defaultPricePerYear: "\u0E3F{{ defaultPricePerYear }}",
    billMonthly: "Bill Monthly",
    billAnnually: "Bill Annually",
    useFree2Month: "FREE 2 MONTHS",
    discount: "{{ discountPercent }}% DISCOUNT",
    common: {
      freePlan: "Free Plan",
      starter_1: "Starter-S",
      starter_2: "Starter-M",
      starter_3: "Starter-L",
      basicPlan: "Basic Plan",
      standardPlan: "Standard Plan",
      advancedPlan: "Advanced Plan",
      customPlan: "Custom Plan"
    },
    featureList: {
      buttonShowFeature: "Show detailed plan comparison",
      buttonHideFeature: "Hide detailed plan comparison"
    },
    table: {
      unlimited: "Unlimited",
      title: {
        chatTable: "Chat & Shop features",
        integrationTable: "Integration",
        consoleTable: "Console Accessibility",
        addonTable: "Add-on",
        deeplePayTable: "deeple pay",
        storeTable: "Store Management Features",
        shipping: "Shipping",
        bankTransferTable: "Bank Transfer"
      },
      feature: {
        "deeplePayFeeRate.creditCard.rate": "Credit / Debit Card",
        "deeplePayFeeRate.mobileBanking.rate": "Mobile Banking",
        "deeplePayFeeRate.qrCash.rate": "QR Payment",
        "deeplePayFeeRate.rabbitLinePay.rate": "Rabbit Line Pay",
        "deeplePayFeeRate.trueMoneyWallet.rate": "True Money Wallet",
        "deeplePayFeeRate.withdrawal.fix": "Withdraw",
        adminCount: "Admin Account",
        aiAddress: "AI Address Recognition",
        aiProductSearch: "AI Visual Product Search",
        aiProductSearchAddon: "AI Visual Product Search",
        aiUpsell: "AI Upsell Intelligence",
        broadcastQuota: "LINE OA and Facebook Broadcast",
        chat: "In-Chat Web Shopping",
        chatIntegration: "Chat Platform Integration (LINE OA, Facebook, Instagram)",
        cod: "COD Deposit",
        consignmentReport: "Consignment Report",
        consignmentReportExport: "Consignment Report Export",
        consoleApp: "deeple Console App (iOS & Android)",
        customerReport: "Customer Report",
        customerReportExport: "Customer Report Export",
        customTheme: "Custom Theme",
        delivery: "Delivery Choice",
        digitalProduct: "Digital Product (Coupon, Gift Voucher)",
        extraAdmin: "Extra Admin",
        externalPaymentGateway: "External Payment Gateway",
        facebookCommentToChat: "Facebook Comment to Chat",
        facebookLiveToChat: "Facebook Live to Chat",
        faqQuota: "AI Specialized Knowledge",
        flatRate: "Shipping Cost: Flat Rate",
        logistic: "Logistics",
        manualCalculation: "Shipping Cost: Manual Calculation",
        openAPI: "Open API",
        orderPickup: "Schedule Order Pick Up",
        orderQuota: "Orders Per Month",
        offlineOrder: "Offline Order",
        fileUploadViaChat: "File upload via chat",
        pickupStore: "Pickup at Store",
        postcodeBase: "Shipping Cost: Post Code Based",
        productQuota: "Product",
        promotion: "Campaign & Promotion",
        realTimeWithdrawal: "Real Time Withdrawal",
        saleReport: "Sales Report",
        saleReportExport: "Sales Report Export",
        subscriberQuota: "Customers",
        support: "Contact deeple Support",
        zortIntegration: "ZORT Integration",
        bankTransferFee: "Bank Transfer fee",
        manualApprovalOrders: "Manual Approval Orders",
        manualOrders: "(Manual orders)"
      },
      titleInfo: {
        "deeplePayFeeRate.creditCard.rate": "Excluding 7% VAT",
        "deeplePayFeeRate.qrCash.rate": "Excluding 7% VAT",
        "deeplePayFeeRate.mobileBanking.rate": "Minimum TH15",
        "deeplePayFeeRate.rabbitLinePay.rate": "Coming Soon",
        "deeplePayFeeRate.trueMoneyWallet.rate": "Excluding 7% VAT",
        "deeplePayFeeRate.withdrawal.fix": "Including 7% VAT",
        aiProductSearch: "Buy more via add-on",
        faqQuota: "Train AI Chatbot",
        adminCount: "Buy more via add-on",
        bankTransferTooltip: "fee 0 baht limit order (for bank transfer)",
        zeroFee: "fee 0 baht",
        limitOrder: "limit order (for bank transfer)",
        onlyDeeplePayOrders: "Only deeple pay orders",
        offlineOrder: "Orders not purchased via chat channel",
        fileUploadViaChat: "<ul class='tw-px-2.5 tw-list-disc'><li>File format: .pdf .doc .docx .xls .xlsx</li><li>Max file size: 4 MB, 8 MB</li><li>File expiry date: 14 days, 30 days</li></ul>"
      },
      fileUploadViaChat: {
        standard: "4 MB, 14 Days",
        premium: "8 MB, 30 Days",
        profession: "8 MB, 14 Days",
        platform: "(LINE, FB)"
      }
    },
    successModal: {
      title: "Your package has been upgraded!",
      startPackage: "You\u2019re now starting {{ package }}.",
      fromFreePackage: "Your monthly billing cycle will begin after a free 14-day use of package.",
      fromPaidPackage: "Your monthly billing cycle will be renewed on the same date as previously.",
      nextBillingDate: "Your billing date: {{ billingDate }}",
      doneButton: "Done"
    },
    card: {
      contactUs: "Contact us",
      chooseButtonText: "Choose this plan",
      selectedButtonText: "Your current plan",
      pricePerMonth: "/mo",
      pricePerYear: "/y",
      features: {
        faqQuota: "AI Specialized Knowledge",
        productQuota: "Product",
        admin: "Admin Account",
        subscriberQuota: "Customers",
        saleReport: "Sales Report",
        customerReport: "Customer Report",
        consignmentReport: "Consignment Report"
      },
      free: {
        title: "Free",
        subTitle: "Best for trial use"
      },
      starter_1: {
        title: "Starter-S",
        subTitle: ""
      },
      starter_2: {
        title: "Starter-M",
        subTitle: ""
      },
      starter_3: {
        title: "Starter-L",
        subTitle: ""
      },
      standard: {
        title: "Basic",
        subTitle: "Best for small-sized business"
      },
      professional: {
        title: "Standard",
        subTitle: "Best for medium-sized business"
      },
      premium: {
        title: "Advanced",
        subTitle: "Best for medium-large sized business"
      },
      custom: {
        title: "Custom",
        subTitle: "Best for medium-large sized business"
      },
      usingCustom: {
        title: "Custom",
        subTitle: "Here is what you customize for your plan"
      },
      needMore: {
        title: "Need more?",
        subTitle: "Contact our team again to customize your plan"
      }
    }
  },
  notAllowFeatureModal: {
    title: "Please upgrade your package.",
    description1: "Would you like to continue this? Please upgrade your package.",
    description2: "You can get a lot more out of it and all features.",
    upgradeButton: "Upgrade package"
  }
};
const en$4 = {
  firstStep: "Add payment method",
  title: "Confirm ({{ packageType }}) package",
  secondStep: "Add billing information",
  paymentMethodForm: {
    cardNo: "Card number",
    expireDate: "Expire date",
    cvv: "CVV",
    cardHolderNameLabel: "Cardholder name",
    cardHolderNamePlaceholder: "Cardholder name",
    setPaymentMethodPrimaryLabel: "Set this payment method as primary",
    description1: "Your card will be used for payment of package and add-ons. When saved, it will be charged to make sure it\u2019s valid. The amount will automatically be refunded. By adding your debit or credit card, you agree to",
    termAndCondition: "Terms of service",
    submit: "Save",
    validation: {
      cardNo: {
        max: "Card No is invalid",
        min: "Card No is invalid",
        required: "Card No is invalid"
      },
      expireDate: {
        invalidDate: "Expire date is invalid",
        required: "Expire date is required",
        length: "Expire date is invalid"
      },
      cardholderName: {
        containNumber: "Cardholder Name is invalid",
        required: "Cardholder Name is required"
      },
      cvv: {
        required: "CVV is required",
        length: "CVV is invalid"
      }
    }
  },
  billingAddressForm: {
    selectPlaceholder: "Select",
    nameLabel: "Full name",
    namePlaceholder: "Full name",
    addressLabel: "Contact address",
    addressPlaceholder: "Contact address",
    postalCodeLabel: "Postal code",
    postalCodePlaceholder: "101100",
    taxIdLabel: "TAX ID",
    taxIdPlaceholder: "TAX ID",
    contactPersonLabel: "Contact person - optional",
    contactPersonPlaceholder: "Full name",
    phoneNumberLabel: "Phone number",
    phoneNumberPlaceholder: "+66",
    emailLabel: "Email",
    emailPlaceholder: "Name@mail.com",
    personal: "Personal",
    corporate: "Corporate",
    documentVerificationCertificateLabel: "Document verification",
    documentVerificationCertificatePlaceholder: "Add Image",
    corporateDocumentVerificationCertificateLabel: "Commercial Registration Certificate",
    corporateDocumentVerificationCertificatePlaceholder: "Add Commercial Registration Certificate",
    cancel: "Cancel",
    submit: "Submit",
    mr: "Mr.",
    mrs: "Mrs.",
    miss: "Miss",
    subDistrictLabel: "Sub-district",
    districtLabel: "District",
    provinceLabel: "Province",
    corporateNameLabel: "Company name",
    corporateAddressLabel: "Company Address",
    corporateNamePlaceholder: "Company name",
    validation: {
      name: {
        required: "name is required"
      },
      address: {
        required: "address is required"
      },
      taxId: {
        required: "Tax ID is required",
        length: "Tax ID should be 13 digits"
      },
      phoneNumber: {
        required: "Phone number is required",
        length: "Phone number is invalid"
      },
      email: {
        email: "Email is invalid",
        required: "Email is required"
      },
      subDistrict: {
        required: "Sub district is required"
      },
      district: {
        required: "District is required"
      },
      province: {
        required: "Province is required"
      },
      postalCode: {
        length: "Postal code is invalid",
        required: "Postal code is required"
      },
      documentVerificationCertificatePath: {
        required: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23"
      }
    },
    uploadImageSuccess: "Image has been saved",
    uploadImageError: "Saving image error"
  },
  billingAddressSection: {
    submitBillingAddressSuccess: "Your billing information has been saved.",
    submitBillingAddressError: "Saving billing information error."
  },
  paymentSummary: {
    title: "Plan Upgrade",
    description: "Your next billing will be charged on {{ effectiveDate }}",
    submitText: "Start your package",
    detail: "Payment summary",
    upgradeTo: "Paying:",
    credit: "Credit",
    creditDescription: "Credit is the money compensated after deducting all the charges for your package and add-ons.",
    total: "Total",
    discount: "Discount",
    imageSearchPackage: "",
    addon: "",
    changePackageError: "Something went wrong please try again later"
  },
  modalRemmoveCreditCard: {
    title: "Are you sure you want to remove ?",
    confirm: "Confirm",
    cancel: "Cancel"
  },
  useChangePackageSummary: {
    defaultError: "Please try again"
  },
  packageType: {
    starter_1: "Starter-S package",
    starter_2: "Starter-M package",
    starter_3: "Starter-L package",
    standard: "Basic package",
    premium: "Advance package",
    professional: "Standard package"
  },
  codeItem: {
    code: "Code",
    expiredDate: "Expired date",
    remark: "Remark: This discount code can be applied to every billing cycle.",
    defaultPromotion: "Free 2 months"
  },
  codeTextField: {
    redeem: "Apply",
    useCode: "Any discount code",
    placeholder: "Discount code",
    error: {
      promotionCoditionNotMatch: "Condition not meet(unable to apply)",
      promotionExipred: "Code expired",
      promotionNotActive: "Incorrect code",
      promotionNotFound: "Incorrect code",
      promotionQuotaReached: "Quota reached"
    }
  },
  subscriptionType: {
    annually: "Annually",
    monthly: "Monthly"
  },
  paymentSection: {
    addCreditCardSuccess: "Your credit card has been saved",
    addCreditCardError: "Something went wrong. Please try again later.",
    removeCreditCardSuccess: "Card {{ brand }} {{ cardNo ]}} has been removed",
    removeCreditCardError: "Cannot remove card {{ brand }} {{ cardNo ]}"
  }
};
const en$3 = {
  header: "Products",
  default: {
    title: "Start adding products to your store",
    description: "You can manage all of your store's products and inventory here.",
    manageSKU: "Create product variations (SKU)",
    categorizeProduct: "Categorize products and add inventory",
    editProduct: "Edit and update the product list and quantity",
    searchProduct: "Help with product search.",
    add: "Add new product"
  },
  productList: {
    items: "{{value}} Product(s)",
    status: "Status",
    category: "Catalog",
    price: "Price",
    variantList: "Variation",
    search: {
      productName: "Search product name",
      category: "Filters by catalog"
    },
    filter: {
      search: "Search catalog",
      selected: "{{value}} selected:",
      allItem: "All item"
    },
    edit: "Edit",
    clear: "Clear",
    productNotFound: {
      title: "Product not found",
      description: "Please change search keywords or filter"
    },
    pagination: {
      total: "Showing result: {{range}} of {{total}}",
      page: "Page",
      show: "Shows",
      perPage: "per page"
    }
  },
  title: {
    add: "Add Product",
    edit: "Edit Product"
  },
  isActive: "Active",
  isInactive: "Inactive",
  productImage: {
    title: "Product image",
    upload: {
      label: "Upload or drag and drop an images",
      button: "Upload"
    }
  },
  productDetail: {
    title: "Product details",
    name: "Product name",
    category: {
      label: "Category",
      placeholder: "Select category"
    },
    brand: "Brand",
    description: "Description",
    productCode: {
      label: "Product code",
      placeholder: "e.g., Product001, Product-001"
    },
    cfCode: {
      label: "Product CF code",
      tooltip: "Needs to fill if you want to use Live to chat feature",
      placeholder: "e.g., CfProduct001, CfProduct-001"
    }
  },
  pricing: {
    title: "Pricing",
    price: "Price (\u0E3F)",
    costPrice: "Cost price (\u0E3F)",
    freeProduct: "Free product"
  },
  advanceDetail: {
    title: "Advanced detail",
    productUnit: {
      label: "Product unit",
      placeholder: "e.g., piece(s), box"
    },
    weightPerUnit: "Weight per unit (g)",
    dimension: "Product dimension (cm)",
    width: "Width",
    length: "Length",
    height: "Height"
  },
  productProperty: {
    title: "Product property",
    addProperty: "Add property",
    type: {
      label: "Property Type",
      placeholder: "e.g., Material"
    },
    value: {
      label: "Property Value",
      placeholder: "e.g., Cotton, Leather"
    },
    additional: "Additional product info e.g. material or quality"
  },
  category: {
    title: "Add category",
    create: "Create new category",
    name: "Category name",
    add: "Add",
    cancel: "Cancel"
  },
  save: "Save",
  addSKU: "Add SKU",
  confirm: "Confirm",
  error: {
    pricingLowerThanZero: "Price must greater than 0",
    valueLowerThanZero: "This field must greater than 0",
    valueOverThanLimit: "This field must lower than 9999",
    required: "This field is required",
    productCodeHasWrongFormat: "Please enter 3-50 characters (EN/TH alphabets, special letters (_,-), and numerals only.)",
    CFCodeHasWrongFormat: "Please enter 3-50 characters (EN/TH alphabets, special letters (_,-), and numerals only.)"
  },
  notification: {
    createSuccess: "Create successfully.",
    createFailed: "Update fail.Create fail.",
    editSuccess: "Update successfully.",
    editFailed: "Update fail."
  },
  modal: {
    cancel: {
      title: "Are you sure you want to cancel?",
      detail: "You will lost all of your information on this page",
      confirm: "Confirm"
    },
    confirmDeleteProduct: {
      title: "Are you sure you want to delete?",
      description: "You will lost all of your information",
      confirm: "Confirm"
    }
  },
  productSKU: {
    title: "Product SKU",
    noSKUDescription: "Does your product come in different SKUs, like size, color or material?",
    addSKUButton: "Add Product SKU",
    addOption: "Add another option",
    addSKUPopup: {
      title: "Add product SKU",
      skuName: { label: "SKU Name", placeholder: "e.g., Size or Color" },
      skuValue: {
        label: "SKU Value",
        placeholder: "Separate choices with enter"
      },
      cancel: "Cancel",
      add: "Add"
    },
    manageSKU: {
      title: "Manage SKU",
      editAllSKU: "Edit all SKUs",
      optional: "Optional",
      sku: "SKU",
      image: "Image",
      skuCode: "SKU code",
      inventory: "Inventory",
      price: "Price",
      costPrice: "Cost price (\u0E3F)",
      weight: "Weight (g)",
      dimension: "Dimension (cm)",
      width: "Width",
      length: "Length",
      height: "Height",
      field: "Field"
    },
    error: {
      maximumProductSKU: "Total product SKU can\u2019t exceed total of 55 SKUs",
      duplicatedSKUName: "SKU name must not be the same",
      itemValueOverThanLimit: "SKU value must be less than or equal to 50 characters",
      duplicateSKUValue: "Duplicate SKU value",
      emptyProductSKUCode: "Product SKU code should not be empty.",
      emptyProductSKUPrice: "Product SKU price should not be empty.",
      emptyProductSKUDimension: "Product SKU Dimension should not be empty.",
      inventoryNotEmpty: "Before editing or deleting a product or SKUs, please ensure that the inventory remains 0 or that none are reserved.",
      duplicatedProductName: "Product name is duplicated with other product",
      duplicatedProductCode: "Product code is duplicated with other product",
      duplicatedCFCode: "CF code is duplicated with other product",
      descriptionExceedLimit: "Product description cannot exceed 2,500 characters",
      priceReachLimit: "Product price must be less than 1 million baht",
      overQuota: "Product quota reached limit. Please upgrade your plan",
      productCodeNotFound: "Product code is not found",
      incorrectDigitalContent: "Incorrect Digital content",
      duplicatedDigitalContent: "Duplicated Digital content",
      outputTypeIsNotCodeImport: "Output type is not code import",
      contentAvailabilityIsNotMatch: "Content Availability is not match",
      skuValueCannotContainKey: "SKU name and SKU value must not be the same",
      skuKeyDuplicated: "SKU name must not be the same",
      productVariantInventoryNotEmpty: "Before deleting a SKU value ({{value}}), please ensure that the inventory remains 0 or that none are reserved."
    },
    modal: {
      deleteSKU: {
        title: "Are you sure you want to remove SKU?",
        description: "You will lost all of your information on this SKU",
        cancel: "Cancel",
        delete: "Delete"
      },
      cannotDeleteProduct: {
        title: "Cannot delete product."
      },
      cannotDeleteSKU: {
        title: "Cannot delete SKUs.",
        description: "Before deleting a product or SKUs, please ensure that the inventory remains 0 or that none are reserved.",
        ok: "Ok"
      }
    }
  },
  inventory: {
    title: "Inventory",
    stock: "Stock quantity",
    info: "The stock quantity cannot be less than the amount reserved.",
    reserve: "Reserved: {{value}}"
  },
  deleteProduct: "Delete product",
  import: {
    button: {
      label: "Import product",
      subLabel: "Format: CSV / XLSX",
      download: "Download a sample"
    }
  }
};
const en$2 = {
  title: "Shipping",
  noShippingActive: "At least 1 shipping method should be active",
  reachLimit: "Cannot create shipping over 4 types\n(exclude pickup)",
  calculationType: {
    flatPrice: "Flat price",
    postalCode: "Postal code price",
    mannual: "Admin manually calculated price",
    lalamove: "Lalamove",
    shippop: "Shippop",
    pickup: "Pick up"
  },
  shippingMethod: {
    title: "Shipping method",
    addButton: "Add method",
    duplicate: "Duplicate",
    setActive: "Set as active",
    setInactive: "Set as inactive",
    delete: "Delete",
    other: "Other",
    placeholder: {
      title: "Shipping method management",
      subTitle: "With many choices of shipping methods that manages all of your shipping needs in one place.",
      addButton: "Add method",
      list1: "Shipping price checking",
      list2: "Messenger Calling",
      list3: "Tracking system",
      list4: "Book shipping with the best price",
      list5: "Cash on delivery",
      list6: "Issue tax invoice"
    },
    shippingMethodCard: {
      active: "Active",
      estimatedDelivery: "Estimated Delivery",
      inactive: "Inactive",
      priceCalculation: "Price Calculation",
      COD: "Cash on delivery"
    },
    offlinePickUp: {
      title: "Offline pick-up",
      subTitle: "This method requires customers to pick up their orders at store",
      pickupTitle: "Non-scheduled pick up",
      pickupSubTitle: "Allow customers to pick up their orders anytime",
      manageStoresButton: "Manage Available Stores"
    },
    shippingInfoGraphic: {
      title: "Shipping infographic",
      example: "See example",
      subTitle: "Upload the image to show shipping information.",
      uploadButton: "Upload",
      optional: "Optional"
    },
    confirmationModal: {
      deleteShipping: {
        title: "Are you sure you want to delete {{name}} ?",
        subTitle: "You will lost all of your information"
      },
      removeShippingInfoGraphic: {
        title: "Are you sure you want to remove this image?"
      },
      example: {
        description: "The image you upload will be displayed in the chat room when the customer asks about the delivery.",
        okay: "Okay"
      }
    },
    selectShippingMethod: {
      learnMore: "Learn more",
      setUpShipping: "Shipping by shop",
      title: "Select shipping method",
      comingSoon: "Coming soon",
      customizeShipping: {
        title: "Set up shipping methods to fit your store",
        description: "You can customize your shipping methods with means supported by the console."
      },
      connectShippop: {
        title: "Connect with SHIPPOP",
        description: "Connect API with your SHIPPOP account."
      },
      connectLalamove: {
        title: "Connect with LALAMOVE",
        description: "Connect API with your LALAMOVE account to activate the same-day delivery."
      }
    },
    shippingForm: {
      name: "Carrier name",
      active: "Active",
      inactive: "Inactive",
      addShipping: "Add shipping method",
      shippingDetail: "Shipping detail",
      selectCarrier: "Select carrier",
      carrier: "Carrier",
      estimatedTime: "Estimated delivery time",
      to: "to",
      selectPriceCalculation: "Select price calculation",
      flatPrice: "Flat Price",
      manual: "Manual",
      postcodeBased: "Postcode Based",
      enterPrice: "Enter price",
      price: "Shipping price",
      cod: "Cash on delivery",
      flatPriceAlert: "Shipping price will be a single fixed price for every order.",
      manualPriceAlert: "Admin will need to fill in the shipping prices manually for every created order. Click here to fill in shipping prices.",
      cancel: "Cancel",
      save: "Save",
      carrierNameIsRequired: "Carrier name is required.",
      minCannotZero: "Min. delivery time must be greater than 0",
      minLessThanMax: "Min. delivery should less than max.",
      maxCannotZero: "Max. delivery time must be greater than 0",
      maxMoreThanMin: "Max. delivery should more than min.",
      noDepositFee: "No deposit fee",
      noManagementFee: "No management fee",
      percentage: "Calculate as percentage",
      customPrice: "Custom price",
      minimumOrder: "Minimum order",
      depositFee: "Deposit fee",
      depositCannotZero: "Deposit must be greater than 0",
      managementFee: "Management fee",
      managementFeeCannotZero: "Management fee must be greater than 0",
      optional: "optional"
    }
  }
};
const en$1 = {
  ai: en$m,
  cardConnect: en$l,
  cashback: en$k,
  category: en$j,
  common: en$i,
  connectPage: en$h,
  createStore: en$g,
  facebookLive: en$f,
  gettingStarted: en$e,
  modalConfirmDisconnection: en$d,
  modalConnect: en$c,
  modalConnectGuideline: en$b,
  modalFacebookRecurringNotification: en$a,
  modalPhoneNumber: en$9,
  notify: en$8,
  order: en$7,
  payment: en$6,
  plan: en$5,
  planUpgrade: en$4,
  product: en$3,
  shipping: en$2
};
const th$m = {
  aiGuideline: {
    trainBot: "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E1D\u0E36\u0E01\u0E1A\u0E2D\u0E17",
    preTitle: "3 \u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E07\u0E48\u0E32\u0E22 \u0E46 \u0E43\u0E19\u0E01\u0E32\u0E23\u0E2A\u0E2D\u0E19\u0E41\u0E0A\u0E17\u0E1A\u0E2D\u0E17\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E09\u0E25\u0E32\u0E14\u0E22\u0E34\u0E48\u0E07\u0E02\u0E36\u0E49\u0E19!",
    title: "AI Settings",
    botSetting: "\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E1A\u0E2D\u0E17",
    botSettingDescription: "\u0E1B\u0E23\u0E31\u0E1A\u0E41\u0E15\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E15\u0E2D\u0E1A\u0E01\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E1A\u0E2D\u0E17\u0E43\u0E2B\u0E49\u0E43\u0E01\u0E25\u0E49\u0E40\u0E04\u0E35\u0E22\u0E07\u0E41\u0E2D\u0E14\u0E21\u0E34\u0E19 \u0E41\u0E25\u0E30\u0E40\u0E02\u0E49\u0E32\u0E01\u0E31\u0E1A\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    botWelcomeMessage: "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E15\u0E49\u0E2D\u0E19\u0E23\u0E31\u0E1A",
    botWelcomeMessageDescription: "\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E15\u0E49\u0E2D\u0E19\u0E23\u0E31\u0E1A \u0E43\u0E2B\u0E49\u0E41\u0E19\u0E30\u0E19\u0E33\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E2B\u0E23\u0E37\u0E2D\u0E43\u0E2B\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19 \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E43\u0E2B\u0E21\u0E48",
    botSpecialKnowledge: "\u0E04\u0E27\u0E32\u0E21\u0E23\u0E39\u0E49\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E17\u0E32\u0E07",
    botSpecialKnowledgeDescription: "\u0E2A\u0E2D\u0E19\u0E41\u0E0A\u0E17\u0E1A\u0E2D\u0E17\u0E43\u0E2B\u0E49\u0E15\u0E2D\u0E1A\u0E04\u0E33\u0E16\u0E32\u0E21 \u0E41\u0E25\u0E30\u0E1E\u0E39\u0E14\u0E04\u0E38\u0E22\u0E44\u0E14\u0E49\u0E21\u0E32\u0E01\u0E02\u0E36\u0E49\u0E19 \u0E14\u0E49\u0E27\u0E22\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E04\u0E04\u0E33\u0E16\u0E32\u0E21\u0E17\u0E35\u0E48\u0E1E\u0E1A\u0E1A\u0E48\u0E2D\u0E22",
    slide1: {
      title: "\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E41\u0E0A\u0E17\u0E1A\u0E2D\u0E17",
      description: "\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1B\u0E34\u0E14-\u0E1B\u0E34\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 \u0E15\u0E31\u0E49\u0E07\u0E40\u0E27\u0E25\u0E32\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E41\u0E0A\u0E17\u0E1A\u0E2D\u0E17\u0E01\u0E25\u0E31\u0E1A\u0E21\u0E32\u0E17\u0E33\u0E07\u0E32\u0E19\u0E44\u0E14\u0E49\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 \u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E01\u0E32\u0E23\u0E42\u0E0A\u0E27\u0E4C\u0E40\u0E21\u0E19\u0E39\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E1C\u0E48\u0E32\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E41\u0E0A\u0E17"
    },
    slide2: {
      title: "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E15\u0E49\u0E2D\u0E19\u0E23\u0E31\u0E1A",
      description: "\u0E1B\u0E23\u0E31\u0E1A\u0E41\u0E15\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E15\u0E49\u0E2D\u0E19\u0E23\u0E31\u0E1A\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E43\u0E2B\u0E21\u0E48 \u0E42\u0E14\u0E22\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E \u0E40\u0E21\u0E19\u0E39\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33\u0E08\u0E32\u0E01\u0E17\u0E32\u0E07\u0E23\u0E49\u0E32\u0E19 \u0E44\u0E14\u0E49\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14 4 \u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21"
    },
    slide3: {
      title: "\u0E04\u0E27\u0E32\u0E21\u0E23\u0E39\u0E49\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E17\u0E32\u0E07",
      description: "\u0E2A\u0E2D\u0E19\u0E41\u0E0A\u0E17\u0E1A\u0E2D\u0E17\u0E43\u0E2B\u0E49\u0E15\u0E2D\u0E1A\u0E04\u0E33\u0E16\u0E32\u0E21\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E44\u0E14\u0E49\u0E04\u0E23\u0E2D\u0E1A\u0E04\u0E25\u0E38\u0E21\u0E22\u0E34\u0E48\u0E07\u0E02\u0E36\u0E49\u0E19 \n\u0E14\u0E49\u0E27\u0E22\u0E01\u0E32\u0E23\u0E43\u0E2A\u0E48\u0E0A\u0E38\u0E14\u0E04\u0E33\u0E16\u0E32\u0E21\u0E17\u0E35\u0E48\u0E04\u0E25\u0E49\u0E32\u0E22\u0E01\u0E31\u0E19 3-4 \u0E04\u0E33\u0E16\u0E32\u0E21\u0E15\u0E48\u0E2D 1 \u0E04\u0E33\u0E15\u0E2D\u0E1A\n \u0E42\u0E14\u0E22\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E04\u0E33\u0E15\u0E2D\u0E1A\u0E40\u0E1B\u0E47\u0E19\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21 \u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E21\u0E19\u0E39\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E01\u0E47\u0E44\u0E14\u0E49"
    }
  }
};
const th$l = {
  cancel: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
  connect: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D",
  connected: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27",
  description: {
    facebook: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E14\u0E49\u0E27\u0E22\u0E01\u0E32\u0E23 Login \u0E41\u0E25\u0E30\u0E40\u0E25\u0E37\u0E2D\u0E01 \u2018Page\u2019 \u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D",
    instagram: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08 Instagram \u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E01\u0E31\u0E1A\u0E40\u0E1E\u0E08 Facebook \u0E44\u0E27\u0E49\u0E41\u0E25\u0E49\u0E27",
    line: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E14\u0E49\u0E27\u0E22\u0E01\u0E32\u0E23\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 Channel ID, Channel secret \u0E41\u0E25\u0E30 Channel access token \u0E02\u0E2D\u0E07\u0E23\u0E49\u0E32\u0E19 \u0E42\u0E14\u0E22\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E01\u0E32\u0E23\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23 LINE"
  },
  disconnect: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D",
  learnMore: "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
  lineChannelAccessToken: "Channel access token",
  lineChannelAccessTokenAlertInformation: "\u0E2B\u0E32\u0E01\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E21\u0E35 Account \u0E02\u0E2D\u0E07 LINE Developers \u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E08\u0E30\u0E15\u0E49\u0E2D\u0E07\u0E17\u0E33\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07 Developers Account \u0E42\u0E14\u0E22\u0E01\u0E32\u0E23 login \u0E14\u0E49\u0E27\u0E22 LINE account \u0E2B\u0E23\u0E37\u0E2D Business Account \u0E02\u0E2D\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E01\u0E48\u0E2D\u0E19",
  lineChannelAccessTokenTitle: "\u0E01\u0E23\u0E2D\u0E01 Channel access token",
  lineChannelAccessTokenDescription1: '\u0E44\u0E1B\u0E17\u0E35\u0E48 <a href="https://developers.line.biz/console/" class="tw-text-primary-600 tw-font-medium" target="_blank">https://developers.line.biz/console/</a>',
  lineChannelAccessTokenDescription2: '\u0E40\u0E25\u0E37\u0E2D\u0E01 <strong class="tw-font-medium">Provider</strong> \u0E02\u0E2D\u0E07 Account \u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D \u0E40\u0E25\u0E37\u0E2D\u0E01 <strong class="tw-font-medium">Account</strong> \u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E2B\u0E31\u0E27\u0E02\u0E49\u0E2D <strong class="tw-font-medium">Channel Setting</strong> \u0E41\u0E25\u0E30\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E2B\u0E31\u0E27\u0E02\u0E49\u0E2D Channel access token (long-lived) \u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01 Channel access token \u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E08\u0E32\u0E01 LINE Developer \u0E21\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E43\u0E19 deeple console \u0E08\u0E32\u0E01\u0E19\u0E31\u0E49\u0E19\u0E04\u0E25\u0E34\u0E01 "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D"',
  lineChannelId: "Channel ID",
  lineChannelIdAndSecretTitle: "\u0E01\u0E23\u0E2D\u0E01 Channel ID, Channel secret",
  lineChannelIdAndSecretDescription: '\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32 <a href="https://account.line.biz/login?redirectUri=https%3A%2F%2Fmanager.line.biz%2F%3Fstatus%3Dsuccess%26status%3Dcancelled" class="tw-text-primary-600 tw-font-medium" target="_blank">LINE Official Account</a> \u0E02\u0E2D\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32 \u0E40\u0E25\u0E37\u0E2D\u0E01 <strong class="tw-font-medium">"Setting"</strong> \u0E40\u0E25\u0E37\u0E2D\u0E01 <strong class="tw-font-medium">"Messaging API"</strong> \u0E04\u0E25\u0E34\u0E01\u0E1B\u0E38\u0E48\u0E21 <strong class="tw-font-medium">"Enable Messaging API"</strong> \u0E40\u0E25\u0E37\u0E2D\u0E01 provider \u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E42\u0E14\u0E22\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E23\u0E49\u0E32\u0E07 provider \u0E43\u0E2B\u0E21\u0E48 (New provider) \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27 \u0E08\u0E32\u0E01\u0E19\u0E31\u0E49\u0E19\u0E04\u0E25\u0E34\u0E01 "\u0E15\u0E01\u0E25\u0E07" \u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01 Channel ID \u0E41\u0E25\u0E30 Channel secret \u0E21\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E43\u0E19 deeple console',
  lineChannelSecret: "Channel secret",
  lineConnectMessageApi: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D Messaging API",
  lineConnectMessageApiAlertInformation: `\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E21\u0E31\u0E04\u0E23 <a href="https://manager.line.biz/" class="tw-text-primary-600" target="_blank">LINE Official Account</a> \u0E44\u0E14\u0E49\u0E43\u0E2B\u0E21\u0E48\u0E16\u0E49\u0E32\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E21\u0E35\u0E1A\u0E31\u0E0D\u0E0A\u0E35 \u0E2B\u0E23\u0E37\u0E2D\u0E16\u0E49\u0E32\u0E21\u0E35\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E41\u0E1A\u0E1A\u0E2D\u0E37\u0E48\u0E19\u0E02\u0E2D\u0E07 LINE \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D <a href="https://lineforbusiness.com/th-en/contact" class="tw-text-primary-600" target="_blank">LINE Thailand</a> \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E22\u0E49\u0E32\u0E22\u0E21\u0E32\u0E40\u0E1B\u0E47\u0E19 Official Account \u0E44\u0E14\u0E49 \u0E16\u0E49\u0E32\u0E21\u0E35\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E02\u0E49\u0E32\u0E21\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E19\u0E35\u0E49\u0E44\u0E14\u0E49\u0E40\u0E25\u0E22`,
  new: "\u0E43\u0E2B\u0E21\u0E48",
  title: {
    facebook: "Facebook Page",
    instagram: "Instagram Business",
    line: "LINE Official Account"
  },
  watchVideo: "\u0E14\u0E39\u0E27\u0E34\u0E14\u0E35\u0E42\u0E2D"
};
const th$k = {
  gettingStarted: {
    title: "Cashback",
    hero: {
      title: "Earn cashback Upto 20% with NFTs",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    stepsTitle: "Getting Started",
    stepsTogo: "{{step}} steps to go",
    connectWallet: {
      title: "Connect Wallet",
      description: "Add catalogs, products and their details to your store and fill the inventory, making the bot ready to sell your products",
      button: "Connected"
    },
    useNftCashback: {
      title: "Use NFT Cashback",
      description: "Select shipping methods and set shipping fees that suit your store best.",
      button: "Add shipping"
    },
    watchTutorial: "Watch Tutorial"
  }
};
const th$j = {
  error: {
    categoryNameCannotBeEmpty: "\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E21\u0E19\u0E39\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E27\u0E49\u0E19\u0E27\u0E48\u0E32\u0E07\u0E44\u0E14\u0E49",
    duplicateCategoryName: "\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E21\u0E19\u0E39\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E0B\u0E49\u0E33\u0E44\u0E14\u0E49",
    exceedMaximumCategoryLimit: "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E02\u0E2D\u0E07\u0E40\u0E21\u0E19\u0E39\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E40\u0E01\u0E34\u0E19\u0E02\u0E35\u0E14\u0E08\u0E33\u0E01\u0E31\u0E14"
  }
};
const th$i = {
  action: {
    next: "\u0E16\u0E31\u0E14\u0E44\u0E1B"
  },
  modal: {
    errorUpload: {
      title: "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E44\u0E14\u0E49",
      description: "\u0E42\u0E1B\u0E23\u0E14\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1B\u0E47\u0E19\u0E44\u0E1F\u0E25\u0E4C .JPG, .JPEG \u0E2B\u0E23\u0E37\u0E2D .PNG \u0E17\u0E35\u0E48\u0E21\u0E35\u0E02\u0E19\u0E32\u0E14\u0E44\u0E1F\u0E25\u0E4C\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 2 MB",
      ok: "\u0E15\u0E01\u0E25\u0E07"
    },
    confirmationModal: {
      confirm: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
      cancel: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01"
    },
    close: "\u0E1B\u0E34\u0E14"
  },
  date: {
    days: "\u0E27\u0E31\u0E19",
    day: "\u0E27\u0E31\u0E19"
  }
};
const th$h = {
  description: "\u0E14\u0E49\u0E27\u0E22 Messaging API \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E0A\u0E17\u0E1A\u0E2D\u0E17\u0E08\u0E30\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E15\u0E2D\u0E1A\u0E04\u0E33\u0E16\u0E32\u0E21\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32 \u0E43\u0E2B\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E41\u0E25\u0E30\u0E1B\u0E34\u0E14\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E44\u0E14\u0E49\u0E17\u0E31\u0E19",
  facebook: {
    connect: {
      error: "Facebook page \u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27",
      success: "Facebook page \u0E16\u0E39\u0E01\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D"
    },
    disconnect: {
      error: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A Facebook \u0E40\u0E1E\u0E08 \u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27",
      success: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A Facebook \u0E40\u0E1E\u0E08"
    }
  },
  instagram: {
    connect: {
      error: "Instagram Business \u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27",
      success: "Instagram Business \u0E16\u0E39\u0E01\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D"
    },
    disconnect: {
      error: "Instagram Business \u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27",
      success: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A Instagram Business"
    }
  },
  line: {
    connect: {
      error: "Line credential \u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27",
      success: "Line credential \u0E16\u0E39\u0E01\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D"
    },
    disconnect: {
      error: "Line credential \u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27",
      success: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A Line credential"
    }
  },
  title: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32"
};
const th$g = {
  optional: "- \u0E16\u0E49\u0E32\u0E21\u0E35",
  sideBar: {
    title: "\u0E22\u0E34\u0E19\u0E14\u0E35\u0E15\u0E49\u0E2D\u0E19\u0E23\u0E31\u0E1A",
    paragraph1: "\u0E04\u0E38\u0E13 {{name}},",
    paragraph2: "\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E44\u0E14\u0E49\u0E23\u0E39\u0E49\u0E08\u0E31\u0E01\u0E04\u0E38\u0E13\u0E21\u0E32\u0E01\u0E02\u0E36\u0E49\u0E19",
    paragraph3: "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E14\u0E49\u0E27\u0E22\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E2B\u0E25\u0E31\u0E07\u0E23\u0E49\u0E32\u0E19\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E1A\u0E19\u0E23\u0E30\u0E1A\u0E1A\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32\u0E44\u0E14\u0E49\u0E43\u0E19\u0E17\u0E35\u0E48\u0E40\u0E14\u0E35\u0E22\u0E27",
    logout: "\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E23\u0E30\u0E1A\u0E1A"
  },
  detail: {
    title: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    title2: "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    notHasStoreTitle: {
      prefix: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E17\u0E38\u0E01\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E42\u0E0B\u0E40\u0E0A\u0E35\u0E22\u0E25\u0E21\u0E35\u0E40\u0E14\u0E35\u0E22 (Facebook Page, Instagram Business, Line OA)",
      label: " \u0E40\u0E1E\u0E35\u0E22\u0E07\u0E23\u0E49\u0E32\u0E19\u0E40\u0E14\u0E35\u0E22\u0E27"
    },
    hasStoreTitle: "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E41\u0E0A\u0E17\u0E01\u0E31\u0E1A\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E40\u0E25\u0E22!",
    createStore: {
      label: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E43\u0E2B\u0E21\u0E48",
      button: "\u0E2A\u0E23\u0E49\u0E32\u0E07"
    },
    cancel: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
    add: "\u0E40\u0E1E\u0E34\u0E48\u0E21",
    choose: "\u0E40\u0E25\u0E37\u0E2D\u0E01",
    storeName: {
      label: "\u0E0A\u0E37\u0E48\u0E2D\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32",
      placeholder: "\u0E01\u0E23\u0E2D\u0E01\u0E0A\u0E37\u0E48\u0E2D\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32",
      error: "\u0E42\u0E1B\u0E23\u0E14\u0E01\u0E23\u0E2D\u0E01\u0E0A\u0E37\u0E48\u0E2D\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32"
    },
    businessType: {
      label: "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08",
      placeholder: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E02\u0E2D\u0E07\u0E17\u0E48\u0E32\u0E19"
    },
    customBusinessType: {
      error: "\u0E42\u0E1B\u0E23\u0E14\u0E01\u0E23\u0E2D\u0E01\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08"
    },
    refCode: {
      label: "\u0E23\u0E2B\u0E31\u0E2A\u0E2D\u0E49\u0E32\u0E07\u0E2D\u0E34\u0E07",
      placeholder: "\u0E01\u0E23\u0E2D\u0E01\u0E23\u0E2B\u0E31\u0E2A\u0E2D\u0E49\u0E32\u0E07\u0E2D\u0E34\u0E07"
    }
  },
  businessType: {
    AGENCY_AND_ADVERTISING: "\u0E40\u0E2D\u0E40\u0E08\u0E19\u0E0B\u0E35\u0E48\u0E41\u0E25\u0E30\u0E42\u0E06\u0E29\u0E13\u0E32",
    AGRICULTURE_AND_FORESTRY: "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E40\u0E01\u0E29\u0E15\u0E23",
    AUTOMOTIVE_AND_PARTS: "\u0E2D\u0E30\u0E44\u0E2B\u0E25\u0E48\u0E41\u0E25\u0E30\u0E1B\u0E23\u0E30\u0E14\u0E31\u0E1A\u0E22\u0E19\u0E15\u0E4C",
    BEAUTY_AND_COSMETIC: "\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2A\u0E33\u0E2D\u0E32\u0E07\u0E41\u0E25\u0E30\u0E04\u0E27\u0E32\u0E21\u0E07\u0E32\u0E21",
    CONSTRUCTION: "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E01\u0E48\u0E2D\u0E2A\u0E23\u0E49\u0E32\u0E07",
    CLOTHES_AND_FASHION_GOODS: "\u0E40\u0E2A\u0E37\u0E49\u0E2D\u0E1C\u0E49\u0E32\u0E41\u0E25\u0E30\u0E41\u0E1F\u0E0A\u0E31\u0E48\u0E19",
    EDUCATION: "\u0E2A\u0E16\u0E32\u0E1A\u0E31\u0E19\u0E01\u0E32\u0E23\u0E28\u0E36\u0E01\u0E29\u0E32",
    ELECTRONIC_DEVICES_AND_GADGETS: "\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E44\u0E1F\u0E1F\u0E49\u0E32\u0E41\u0E25\u0E30\u0E41\u0E01\u0E47\u0E14\u0E40\u0E08\u0E47\u0E15",
    FINANCIAL_SERVICES: "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E14\u0E49\u0E32\u0E19\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19",
    FOOD_DRINK_AND_BAKERY: "\u0E2D\u0E32\u0E2B\u0E32\u0E23 \u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E14\u0E37\u0E48\u0E21\u0E41\u0E25\u0E30\u0E02\u0E19\u0E21",
    FURNITURE_AND_DECORATION: "\u0E40\u0E1F\u0E2D\u0E23\u0E4C\u0E19\u0E34\u0E40\u0E08\u0E2D\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E02\u0E2D\u0E07\u0E15\u0E01\u0E41\u0E15\u0E48\u0E07\u0E1A\u0E49\u0E32\u0E19",
    GENERAL_GOODS: "\u0E02\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B",
    GOLD_AND_JEWELS: "\u0E17\u0E2D\u0E07\u0E41\u0E25\u0E30\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E1B\u0E23\u0E30\u0E14\u0E31\u0E1A",
    GOVERNMENT: "\u0E07\u0E32\u0E19\u0E23\u0E32\u0E0A\u0E01\u0E32\u0E23",
    HEALTH_CARE: "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2A\u0E38\u0E02\u0E20\u0E32\u0E1E",
    INSURANCE: "\u0E1B\u0E23\u0E30\u0E01\u0E31\u0E19\u0E20\u0E31\u0E22",
    MEDIA_AND_ENTERTAINMENT: "\u0E2A\u0E37\u0E48\u0E2D\u0E41\u0E25\u0E30\u0E2A\u0E34\u0E48\u0E07\u0E1A\u0E31\u0E19\u0E40\u0E17\u0E34\u0E07",
    MERCHANDISE: "\u0E02\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E23\u0E30\u0E25\u0E36\u0E01",
    PET_SUPPLY: "\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E2A\u0E31\u0E15\u0E27\u0E40\u0E25\u0E35\u0E49\u0E22\u0E07",
    PHARMACEUTICALS_AND_BIOTECH: "\u0E22\u0E32\u0E41\u0E25\u0E30\u0E40\u0E27\u0E0A\u0E20\u0E31\u0E13\u0E11\u0E4C",
    HEALTH_CARE_PHARMACEUTICALS_AND_BIOTECH: "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2A\u0E38\u0E02\u0E20\u0E32\u0E1E \u0E22\u0E32\u0E41\u0E25\u0E30\u0E40\u0E27\u0E0A\u0E20\u0E31\u0E13\u0E11\u0E4C",
    PROFESSIONAL_AND_TECHNICAL_SERVICES: "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E14\u0E49\u0E32\u0E19\u0E15\u0E48\u0E32\u0E07\u0E46",
    STATIONERY_AND_SPORT: "\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E01\u0E32\u0E23\u0E28\u0E36\u0E01\u0E29\u0E32\u0E41\u0E25\u0E30\u0E01\u0E35\u0E2C\u0E32",
    TECHNOLOGY_SOFTWARE: "\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C",
    TELECOMMUNICATION: "\u0E01\u0E32\u0E23\u0E2A\u0E37\u0E48\u0E2D\u0E2A\u0E32\u0E23",
    HOTEL_TRAVEL_AND_LEISURE: "\u0E42\u0E23\u0E07\u0E41\u0E23\u0E21\u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E17\u0E48\u0E2D\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E27",
    OTHER: "\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E42\u0E1B\u0E23\u0E14\u0E23\u0E30\u0E1A\u0E38"
  },
  nft: {
    contactLinks: {
      title: "\u0E0A\u0E38\u0E21\u0E0A\u0E19\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32"
    },
    createStoreForm: {
      customBusinessTypeLabel: "\u0E42\u0E1B\u0E23\u0E14\u0E23\u0E30\u0E1A\u0E38"
    },
    sideBar: {
      title: "\u0E22\u0E34\u0E19\u0E14\u0E35\u0E15\u0E49\u0E2D\u0E19\u0E23\u0E31\u0E1A\u0E2A\u0E39\u0E48 NFT"
    }
  }
};
const th$f = {
  adminModeWarningPopup: {
    title: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 \u2018\u0E42\u0E2B\u0E21\u0E14\u0E0A\u0E4A\u0E2D\u0E1B\u0E1B\u0E34\u0E49\u0E07\u0E15\u0E48\u0E2D\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u2019",
    subtitle: "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E34\u0E48\u0E21\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E1C\u0E48\u0E32\u0E19\u0E40\u0E1F\u0E0B\u0E1A\u0E38\u0E4A\u0E01\u0E44\u0E25\u0E1F\u0E4C",
    description: "\u0E42\u0E14\u0E22\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 \u201C\u0E42\u0E2B\u0E21\u0E14\u0E0A\u0E49\u0E2D\u0E1B\u0E1B\u0E34\u0E49\u0E07\u0E15\u0E48\u0E2D\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u201D \u0E44\u0E14\u0E49\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E44\u0E25\u0E1F\u0E4C\u0E08\u0E1A",
    cancel: "\u0E1B\u0E34\u0E14",
    confirm: "\u0E44\u0E1B\u0E2B\u0E19\u0E49\u0E32\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32"
  },
  alert: {
    title: "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E1C\u0E48\u0E32\u0E19\u0E40\u0E1F\u0E0B\u0E1A\u0E38\u0E4A\u0E01\u0E44\u0E25\u0E1F\u0E4C\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E21\u0E48\u0E2A\u0E30\u0E14\u0E38\u0E14 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32 '\u0E42\u0E2B\u0E21\u0E14\u0E01\u0E32\u0E23\u0E15\u0E2D\u0E1A\u0E41\u0E0A\u0E17' \u0E14\u0E31\u0E07\u0E19\u0E35\u0E49",
    1: "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 '\u0E42\u0E2B\u0E21\u0E14\u0E0A\u0E49\u0E2D\u0E1B\u0E1B\u0E34\u0E49\u0E07\u0E15\u0E48\u0E2D\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07' (\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19)",
    2: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E42\u0E2B\u0E21\u0E14\u0E01\u0E32\u0E23\u0E15\u0E2D\u0E1A\u0E41\u0E0A\u0E17\u0E40\u0E1B\u0E47\u0E19 'AI Sales mode'",
    3: "\u0E1B\u0E34\u0E14\u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07\u0E17\u0E33\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07 Admin mode",
    btn: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32"
  }
};
const th$e = {
  steps: {
    default: {
      title: "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19",
      subtitle: "\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27 ({{completed}}/{{steps}})"
    },
    setupProduct: {
      button: "\u0E16\u0E31\u0E14\u0E44\u0E1B",
      incomplete: {
        title: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32"
      },
      completed: {
        title: "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E16\u0E39\u0E01\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E41\u0E25\u0E49\u0E27"
      }
    },
    setupShippingMethod: {
      button: "\u0E16\u0E31\u0E14\u0E44\u0E1B",
      incomplete: {
        title: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E27\u0E34\u0E18\u0E35\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07"
      },
      completed: {
        title: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E41\u0E25\u0E49\u0E27"
      }
    },
    setupChannelConnection: {
      button: "\u0E16\u0E31\u0E14\u0E44\u0E1B",
      incomplete: {
        title: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A Facebook \u0E2B\u0E23\u0E37\u0E2D LINE OA"
      },
      completed: {
        title: "\u0E23\u0E49\u0E32\u0E19\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E41\u0E25\u0E49\u0E27"
      }
    },
    setupDeeplePay: {
      button: "\u0E16\u0E31\u0E14\u0E44\u0E1B",
      incomplete: {
        title: "\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19 - deeple pay (\u0E44\u0E21\u0E48\u0E1A\u0E31\u0E07\u0E04\u0E31\u0E1A)"
      },
      completed: {
        title: "\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27"
      }
    },
    setupBot: {
      button: "\u0E40\u0E17\u0E23\u0E19\u0E41\u0E0A\u0E17\u0E1A\u0E2D\u0E17",
      incomplete: {
        title: "\u0E40\u0E17\u0E23\u0E19\u0E41\u0E0A\u0E17\u0E1A\u0E2D\u0E17 (\u0E44\u0E21\u0E48\u0E1A\u0E31\u0E07\u0E04\u0E31\u0E1A)"
      },
      completed: {
        title: "\u0E40\u0E17\u0E23\u0E19\u0E41\u0E0A\u0E17\u0E1A\u0E2D\u0E17\u0E41\u0E25\u0E49\u0E27"
      }
    }
  },
  allSettings: "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32",
  done: "\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
  modal: {
    storeCreated: {
      title: "\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E02\u0E32\u0E22\u0E41\u0E25\u0E49\u0E27",
      subtitle: "\u0E1A\u0E2D\u0E17\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E41\u0E25\u0E49\u0E27! \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E38\u0E07\u0E04\u0E27\u0E32\u0E21\u0E09\u0E25\u0E32\u0E14\u0E02\u0E2D\u0E07\u0E1A\u0E2D\u0E17 \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E1B\u0E23\u0E31\u0E1A\u0E41\u0E15\u0E48\u0E07\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E1A\u0E2D\u0E17 \u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E15\u0E49\u0E2D\u0E19\u0E23\u0E31\u0E1A \u0E41\u0E25\u0E30\u0E1D\u0E36\u0E01\u0E1A\u0E2D\u0E17\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E27\u0E32\u0E21\u0E23\u0E39\u0E49\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E17\u0E32\u0E07",
      trainBot: "\u0E40\u0E17\u0E23\u0E19\u0E41\u0E0A\u0E17\u0E1A\u0E2D\u0E17",
      setupDeeplePay: "\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19",
      done: "\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08"
    }
  }
};
const th$d = {
  cancel: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
  content: "\u0E40\u0E21\u0E37\u0E48\u0E2D \u2018\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u2019 \u0E41\u0E25\u0E49\u0E27<br />\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E08\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E01\u0E25\u0E31\u0E1A\u0E21\u0E32\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E44\u0E14\u0E49",
  disconnect: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D",
  disconnecting: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D...",
  title: {
    facebook: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D Facebook Page?",
    instagram: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D Instagram?",
    line: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D LINE Official Account?"
  }
};
const th$c = {
  alertContent: '\u0E04\u0E38\u0E13\u0E08\u0E30\u0E40\u0E2B\u0E47\u0E19\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E40\u0E1E\u0E08\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19 \u0E21\u0E2D\u0E07\u0E44\u0E21\u0E48\u0E40\u0E2B\u0E47\u0E19\u0E40\u0E1E\u0E08 <a href="" class="tw-text-primary-500" target="_blank">\u0E14\u0E39\u0E27\u0E34\u0E18\u0E35</a>',
  cancel: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
  connect: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D",
  connecting: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D...",
  title: {
    facebook: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E40\u0E1E\u0E08 Facebook",
    instagram: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A Instagram"
  }
};
const th$b = {
  brand: {
    facebook: {
      content: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E40\u0E23\u0E34\u0E48\u0E21\u0E14\u0E49\u0E27\u0E22\u0E01\u0E32\u0E23 Login \u0E41\u0E25\u0E30\u0E40\u0E25\u0E37\u0E2D\u0E01 \u2018Page\u2019 \u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D"
    },
    instagram: {
      content: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08 Instagram \u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E01\u0E31\u0E1A\u0E40\u0E1E\u0E08 Facebook \u0E44\u0E27\u0E49\u0E41\u0E25\u0E49\u0E27"
    },
    line: {
      content1: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E14\u0E49\u0E27\u0E22\u0E01\u0E32\u0E23\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 Channel ID, Channel secret \u0E41\u0E25\u0E30 Channel access token \u0E02\u0E2D\u0E07\u0E23\u0E49\u0E32\u0E19 \u0E42\u0E14\u0E22\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E01\u0E32\u0E23\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23 LINE",
      content2: "Channel ID, Channel secret \u0E08\u0E30\u0E2D\u0E22\u0E39\u0E48\u0E17\u0E35\u0E48\u0E40\u0E21\u0E19\u0E39 Basic setting",
      content3: "Channel access token \u0E08\u0E30\u0E2D\u0E22\u0E39\u0E48\u0E17\u0E35\u0E48\u0E40\u0E21\u0E19\u0E39  Messaging API",
      content4: "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E25\u0E30\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E25\u0E07\u0E43\u0E19\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14",
      content5: "\u0E14\u0E39\u0E27\u0E35\u0E14\u0E35\u0E42\u0E2D\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A"
    }
  },
  description: "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A Facebook Page \u0E2B\u0E23\u0E37\u0E2D LINE Official Account \u0E02\u0E2D\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32 Chatbot \u0E08\u0E30\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E15\u0E2D\u0E1A\u0E04\u0E33\u0E16\u0E32\u0E21\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32 \u0E43\u0E2B\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E41\u0E25\u0E30\u0E1B\u0E34\u0E14\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E44\u0E14\u0E49\u0E17\u0E31\u0E19",
  done: "\u0E15\u0E01\u0E25\u0E07",
  title: "\u0E23\u0E27\u0E21\u0E41\u0E0A\u0E17\u0E08\u0E32\u0E01\u0E17\u0E38\u0E01\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E43\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E14\u0E35\u0E22\u0E27"
};
const th$a = {
  headingHtml: "\u0E1A\u0E23\u0E2D\u0E14\u0E41\u0E04\u0E2A\u0E15\u0E4C Facebook<br>(Recurring Notifications)",
  content: "\u0E23\u0E30\u0E1A\u0E1A\u0E1A\u0E23\u0E2D\u0E14\u0E41\u0E04\u0E2A\u0E15\u0E4C\u0E41\u0E1A\u0E1A\u0E1E\u0E34\u0E40\u0E28\u0E29\u0E17\u0E35\u0E48\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E43\u0E2B\u0E49\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E2B\u0E32\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E1C\u0E48\u0E32\u0E19 Messenger \u0E44\u0E14\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E25\u0E14\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E40\u0E1E\u0E08\u0E16\u0E39\u0E01\u0E23\u0E30\u0E07\u0E31\u0E1A \u0E40\u0E2B\u0E21\u0E32\u0E30\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E02\u0E48\u0E32\u0E27\u0E2A\u0E32\u0E23 \u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E48\u0E19 \u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E41\u0E08\u0E49\u0E07\u0E40\u0E15\u0E37\u0E2D\u0E19\u0E2D\u0E37\u0E48\u0E19 \u0E46 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19 \u0E41\u0E25\u0E30\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E43\u0E2B\u0E21\u0E48\u0E44\u0E14\u0E49\u0E17\u0E38\u0E01\u0E27\u0E31\u0E19"
};
const th$9 = {
  cancel: "\u0E44\u0E27\u0E49\u0E17\u0E35\u0E2B\u0E25\u0E31\u0E07",
  description1: "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E43\u0E19\u0E01\u0E32\u0E23\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E17\u0E35\u0E48\u0E14\u0E35\u0E22\u0E34\u0E48\u0E07\u0E02\u0E36\u0E49\u0E19",
  description2: "\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17\u0E08\u0E30\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E2B\u0E49\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E40\u0E14\u0E47\u0E14\u0E02\u0E32\u0E14",
  errorMessage: "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E08\u0E33\u0E19\u0E27\u0E19 10 \u0E2B\u0E25\u0E31\u0E01",
  label: "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C",
  placeholder: "\u0E01\u0E23\u0E2D\u0E01\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C 10 \u0E2B\u0E25\u0E31\u0E01",
  submit: "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
  title: "\u0E40\u0E23\u0E32\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E04\u0E38\u0E13\u0E17\u0E31\u0E19\u0E17\u0E35!"
};
const en = {
  update: {
    success: "\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15 \u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
    fail: "\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15 \u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27"
  },
  upload: {
    success: "\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 \u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
    fail: "\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 \u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27"
  },
  submit: {
    success: "\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 \u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
    fail: "\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 \u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27"
  }
};
const th$8 = {
  sectionOrderDetailDeeplePay: {
    syncBtn: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19",
    amount: "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19\u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E0A\u0E33\u0E23\u0E30",
    paidAt: "\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E40\u0E21\u0E37\u0E48\u0E2D",
    paymentChannel: "\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19",
    paymentStatus: "\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19"
  },
  modalSyncDeeplePayStatusFailure: {
    title: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19",
    description: "\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E23\u0E2D\u0E2A\u0E31\u0E01\u0E04\u0E23\u0E39\u0E48 \u0E41\u0E25\u0E30\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    submitBtn: "\u0E15\u0E01\u0E25\u0E07"
  },
  modalSyncDeeplePayStatusSuccess: {
    title: "\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
    amount: "\u0E08\u0E33\u0E19\u0E27\u0E19",
    receiptNo: "\u0E43\u0E1A\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E17\u0E35\u0E48",
    submitBtn: "\u0E15\u0E01\u0E25\u0E07"
  }
};
const th$7 = {
  next: "\u0E16\u0E31\u0E14\u0E44\u0E1B",
  skip: "\u0E02\u0E49\u0E32\u0E21\u0E44\u0E1B\u0E01\u0E48\u0E2D\u0E19",
  goToTransactionPage: "\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19",
  prev: "\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32",
  connectAccount: "\u0E1C\u0E39\u0E01\u0E1A\u0E31\u0E0D\u0E0A\u0E35",
  paymentGuideline: {
    slide1: {
      title: "deeple pay \u0E04\u0E37\u0E2D\u0E2D\u0E30\u0E44\u0E23?",
      description: "\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E14\u0E49\u0E27\u0E22 deeple pay \u0E40\u0E1B\u0E47\u0E19\u0E23\u0E30\u0E1A\u0E1A\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E2D\u0E2D\u0E19\u0E44\u0E25\u0E19\u0E4C (Payment Gateway) \n \u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E41\u0E0A\u0E17\u0E1A\u0E2D\u0E17\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E17\u0E32\u0E07\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E43\u0E2B\u0E49\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E43\u0E0A\u0E49\u0E08\u0E48\u0E32\u0E22\u0E44\u0E14\u0E49\u0E2B\u0E25\u0E32\u0E22\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E21\u0E32\u0E01\u0E02\u0E36\u0E49\u0E19 \n \u0E41\u0E25\u0E30\u0E0A\u0E48\u0E27\u0E22\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E40\u0E0A\u0E47\u0E04\u0E22\u0E2D\u0E14\u0E40\u0E07\u0E34\u0E19\u0E40\u0E02\u0E49\u0E32 - \u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E40\u0E23\u0E35\u0E22\u0E25\u0E44\u0E17\u0E21\u0E4C",
      note: "\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E14\u0E39\u0E40\u0E23\u0E17\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E17\u0E38\u0E01\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19"
    },
    slide2: {
      title: "\u0E40\u0E0A\u0E47\u0E01\u0E40\u0E07\u0E34\u0E19\u0E40\u0E02\u0E49\u0E32 - \u0E2D\u0E2D\u0E01 \u0E41\u0E1A\u0E1A\u0E40\u0E23\u0E35\u0E22\u0E25\u0E44\u0E17\u0E21\u0E4C",
      description: "\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E22\u0E2D\u0E14\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E08\u0E32\u0E01\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E08\u0E32\u0E01\u0E17\u0E38\u0E01\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07 \n \u0E23\u0E27\u0E21\u0E17\u0E31\u0E49\u0E07\u0E23\u0E31\u0E1A\u0E23\u0E39\u0E49\u0E04\u0E27\u0E32\u0E21\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E2B\u0E27\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E21\u0E35\u0E01\u0E32\u0E23\u0E16\u0E2D\u0E19 - \u0E42\u0E2D\u0E19\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E44\u0E14\u0E49\u0E41\u0E1A\u0E1A\u0E40\u0E23\u0E35\u0E22\u0E25\u0E44\u0E17\u0E21\u0E4C",
      note: "\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E14\u0E39\u0E40\u0E23\u0E17\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E17\u0E38\u0E01\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19"
    },
    slide3: {
      title: "\u0E16\u0E2D\u0E19 - \u0E42\u0E2D\u0E19\u0E40\u0E07\u0E34\u0E19\u0E44\u0E14\u0E49\u0E43\u0E19\u0E44\u0E21\u0E48\u0E01\u0E35\u0E48\u0E04\u0E25\u0E34\u0E01",
      description: "\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E41\u0E04\u0E48\u0E1C\u0E39\u0E01\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E18\u0E19\u0E32\u0E04\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E31\u0E1A deeple pay \u0E01\u0E47\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16 \n \u0E16\u0E2D\u0E19 -  \u0E42\u0E2D\u0E19\u0E40\u0E07\u0E34\u0E19\u0E22\u0E2D\u0E14\u0E02\u0E32\u0E22\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E23\u0E30\u0E1A\u0E1A\u0E44\u0E14\u0E49\u0E40\u0E25\u0E22",
      note: "\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E14\u0E39\u0E40\u0E23\u0E17\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E17\u0E38\u0E01\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19"
    }
  },
  deeplePayGuideline: "\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07 \u0E40\u0E21\u0E37\u0E48\u0E2D\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E08\u0E48\u0E32\u0E22\u0E1C\u0E48\u0E32\u0E19 deeple pay",
  bankTransferGuideline: "\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07 \u0E40\u0E21\u0E37\u0E48\u0E2D\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E08\u0E48\u0E32\u0E22\u0E42\u0E2D\u0E19\u0E1C\u0E48\u0E32\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E18\u0E19\u0E32\u0E04\u0E32\u0E23",
  contactCustomerSupport: {
    title: {
      newShop: "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19<br/>Debit/Credit card \u0E41\u0E25\u0E30 E-wallet",
      oldShop: "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 deeple pay"
    },
    description: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D deeple Support \u0E17\u0E35\u0E48\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07 Live-Chat, LINE OA (@kandadigital), Facebook Page (Kanda Digital), Call Center \u0E40\u0E1A\u0E2D\u0E23\u0E4C 08-2639-1645 \u0E0A\u0E48\u0E27\u0E07\u0E40\u0E27\u0E25\u0E32\u0E17\u0E33\u0E01\u0E32\u0E23 10:00-19:00 \u0E19. \u0E17\u0E38\u0E01\u0E27\u0E31\u0E19\u0E44\u0E21\u0E48\u0E40\u0E27\u0E49\u0E19\u0E27\u0E31\u0E19\u0E2B\u0E22\u0E38\u0E14\u0E23\u0E32\u0E0A\u0E01\u0E32\u0E23\u0E41\u0E25\u0E30\u0E27\u0E31\u0E19\u0E2B\u0E22\u0E38\u0E14\u0E19\u0E31\u0E01\u0E02\u0E31\u0E15\u0E24\u0E01\u0E29\u0E4C"
  }
};
const th$6 = {
  upgradePlan: {
    pageTitle: "\u0E2D\u0E31\u0E1B\u0E40\u0E01\u0E23\u0E14\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 deeple \u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E15\u0E47\u0E21\u0E1B\u0E23\u0E30\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E20\u0E32\u0E1E",
    pageSubTitle: "\u0E40\u0E23\u0E32\u0E21\u0E35\u0E41\u0E1E\u0E47\u0E04\u0E40\u0E01\u0E08\u0E43\u0E2B\u0E49\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E17\u0E38\u0E01\u0E02\u0E19\u0E32\u0E14 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E21\u0E31\u0E48\u0E19\u0E43\u0E08\u0E27\u0E48\u0E32\u0E08\u0E30\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E23\u0E30\u0E1A\u0E1A\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32\u0E44\u0E14\u0E49\u0E04\u0E38\u0E49\u0E21\u0E04\u0E48\u0E32\u0E17\u0E35\u0E48\u0E2A\u0E38\u0E14",
    promotionEnd: "\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E2A\u0E34\u0E49\u0E19\u0E2A\u0E38\u0E14\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48",
    save: "\u0E1B\u0E23\u0E30\u0E2B\u0E22\u0E31\u0E14 {{ discountPercent }}%",
    forAnnually: "\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E23\u0E32\u0E22\u0E1B\u0E35",
    defaultPricePerYear: "\u0E3F{{ defaultPricePerYear }}",
    billMonthly: "\u0E23\u0E32\u0E22\u0E40\u0E14\u0E37\u0E2D\u0E19",
    billAnnually: "\u0E23\u0E32\u0E22\u0E1B\u0E35",
    useFree2Month: "\u0E43\u0E0A\u0E49\u0E1F\u0E23\u0E35 2 \u0E40\u0E14\u0E37\u0E2D\u0E19",
    discount: "\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14 {{ discountPercent }}%",
    common: {
      freePlan: "Free Plan",
      starter_1: "Starter-S",
      starter_2: "Starter-M",
      starter_3: "Starter-L",
      basicPlan: "Basic Plan",
      standardPlan: "Standard Plan",
      advancedPlan: "Advanced Plan",
      customPlan: "Custom Plan"
    },
    featureList: {
      buttonShowFeature: "\u0E41\u0E2A\u0E14\u0E07\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E40\u0E1B\u0E23\u0E35\u0E22\u0E1A\u0E40\u0E17\u0E35\u0E22\u0E1A\u0E41\u0E1E\u0E25\u0E19",
      buttonHideFeature: "\u0E0B\u0E48\u0E2D\u0E19\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E40\u0E1B\u0E23\u0E35\u0E22\u0E1A\u0E40\u0E17\u0E35\u0E22\u0E1A\u0E41\u0E1E\u0E25\u0E19"
    },
    table: {
      unlimited: "\u0E44\u0E21\u0E48\u0E08\u0E33\u0E01\u0E31\u0E14",
      title: {
        chatTable: "\u0E1F\u0E35\u0E40\u0E08\u0E2D\u0E23\u0E4C\u0E0A\u0E48\u0E27\u0E22\u0E02\u0E32\u0E22\u0E1C\u0E48\u0E32\u0E19\u0E41\u0E0A\u0E17",
        integrationTable: "\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D",
        consoleTable: "\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E23\u0E30\u0E1A\u0E1A\u0E2B\u0E25\u0E31\u0E07\u0E23\u0E49\u0E32\u0E19",
        addonTable: "\u0E41\u0E1E\u0E47\u0E04\u0E40\u0E01\u0E08\u0E40\u0E2A\u0E23\u0E34\u0E21",
        deeplePayTable: "deeple pay",
        storeTable: "\u0E1F\u0E35\u0E40\u0E08\u0E2D\u0E23\u0E4C\u0E0A\u0E48\u0E27\u0E22\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E23\u0E30\u0E1A\u0E1A\u0E2B\u0E25\u0E31\u0E07\u0E23\u0E49\u0E32\u0E19",
        shipping: "\u0E01\u0E32\u0E23\u0E02\u0E19\u0E2A\u0E48\u0E07",
        bankTransferTable: "\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E1C\u0E48\u0E32\u0E19\u0E01\u0E32\u0E23\u0E42\u0E2D\u0E19"
      },
      feature: {
        "deeplePayFeeRate.creditCard.rate": "\u0E1A\u0E31\u0E15\u0E23\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15/\u0E40\u0E14\u0E1A\u0E34\u0E15",
        "deeplePayFeeRate.mobileBanking.rate": "\u0E41\u0E2D\u0E1B\u0E2F \u0E18\u0E19\u0E32\u0E04\u0E32\u0E23",
        "deeplePayFeeRate.qrCash.rate": "\u0E04\u0E34\u0E27\u0E2D\u0E32\u0E23\u0E4C\u0E42\u0E04\u0E49\u0E14",
        "deeplePayFeeRate.rabbitLinePay.rate": "\u0E41\u0E23\u0E1A\u0E1A\u0E34\u0E17\u0E44\u0E25\u0E19\u0E4C\u0E40\u0E1E\u0E22\u0E4C",
        "deeplePayFeeRate.trueMoneyWallet.rate": "\u0E17\u0E23\u0E39\u0E21\u0E31\u0E19\u0E19\u0E35\u0E48 \u0E27\u0E2D\u0E25\u0E40\u0E25\u0E47\u0E15",
        "deeplePayFeeRate.withdrawal.fix": "\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E01\u0E32\u0E23\u0E16\u0E2D\u0E19-\u0E42\u0E2D\u0E19\u0E40\u0E07\u0E34\u0E19 (\u0E15\u0E48\u0E2D\u0E04\u0E23\u0E31\u0E49\u0E07)",
        adminCount: "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E41\u0E2D\u0E14\u0E21\u0E34\u0E19",
        aiAddress: "AI \u0E0A\u0E48\u0E27\u0E22\u0E01\u0E23\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34",
        aiProductSearch: "AI \u0E0A\u0E48\u0E27\u0E22\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E08\u0E32\u0E01\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E",
        aiProductSearchAddon: "AI \u0E0A\u0E48\u0E27\u0E22\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E08\u0E32\u0E01\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E",
        aiUpsell: "AI \u0E40\u0E2A\u0E19\u0E2D\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34",
        broadcastQuota: "\u0E23\u0E30\u0E1A\u0E1A\u0E1A\u0E23\u0E2D\u0E14\u0E41\u0E04\u0E2A\u0E15\u0E4C\u0E1A\u0E19 LINE OA \u0E41\u0E25\u0E30 Facebook",
        chat: "\u0E23\u0E30\u0E1A\u0E1A\u0E41\u0E2A\u0E14\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 In-Chat Web Shopping",
        chatIntegration: "\u0E41\u0E1E\u0E25\u0E15\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E41\u0E0A\u0E17 (LINE OA, Facebook, Instagram)",
        cod: "\u0E21\u0E31\u0E14\u0E08\u0E33\u0E41\u0E25\u0E30\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E1B\u0E25\u0E32\u0E22\u0E17\u0E32\u0E07 (COD)",
        consignmentReport: "\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E01\u0E32\u0E23\u0E19\u0E33\u0E2A\u0E48\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        consignmentReportExport: "\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E43\u0E1A\u0E1B\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E31\u0E2A\u0E14\u0E38",
        consoleApp: "\u0E41\u0E2D\u0E1B\u0E2F deeple Console (iOS & Android)",
        customerReport: "\u0E23\u0E30\u0E1A\u0E1A\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
        customerReportExport: "\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
        customTheme: "\u0E1B\u0E23\u0E31\u0E1A\u0E41\u0E15\u0E48\u0E07\u0E18\u0E35\u0E21\u0E23\u0E49\u0E32\u0E19",
        delivery: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
        digitalProduct: "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25 (\u0E40\u0E0A\u0E48\u0E19 \u0E04\u0E39\u0E1B\u0E2D\u0E07 \u0E1A\u0E31\u0E15\u0E23\u0E02\u0E2D\u0E07\u0E02\u0E27\u0E31\u0E0D)",
        extraAdmin: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E08\u0E33\u0E19\u0E27\u0E19\u0E41\u0E2D\u0E14\u0E21\u0E34\u0E19 (\u0E15\u0E48\u0E2D\u0E04\u0E19)",
        externalPaymentGateway: "\u0E23\u0E30\u0E1A\u0E1A\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E2D\u0E2D\u0E19\u0E44\u0E25\u0E19\u0E4C\u0E2D\u0E37\u0E48\u0E19 \u0E46",
        facebookCommentToChat: "\u0E23\u0E30\u0E1A\u0E1A\u0E15\u0E2D\u0E1A\u0E04\u0E2D\u0E21\u0E40\u0E21\u0E19\u0E15\u0E4C\u0E41\u0E25\u0E30\u0E17\u0E31\u0E01\u0E41\u0E0A\u0E17\u0E1A\u0E19 Facebook",
        facebookLiveToChat: "\u0E23\u0E30\u0E1A\u0E1A\u0E14\u0E36\u0E07\u0E04\u0E2D\u0E21\u0E40\u0E21\u0E19\u0E15\u0E4C\u0E08\u0E32\u0E01 Facebook Live",
        faqQuota: "\u0E2A\u0E2D\u0E19 AI \u0E15\u0E2D\u0E1A\u0E04\u0E33\u0E16\u0E32\u0E21\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08",
        flatRate: "\u0E23\u0E30\u0E1A\u0E1A\u0E04\u0E33\u0E19\u0E27\u0E13\u0E04\u0E48\u0E32\u0E2A\u0E48\u0E07\u0E04\u0E07\u0E17\u0E35\u0E48",
        logistic: "\u0E23\u0E30\u0E1A\u0E1A\u0E02\u0E19\u0E2A\u0E48\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        manualCalculation: "\u0E23\u0E30\u0E1A\u0E1A\u0E41\u0E2D\u0E14\u0E21\u0E34\u0E19\u0E04\u0E33\u0E19\u0E27\u0E13\u0E04\u0E48\u0E32\u0E2A\u0E48\u0E07\u0E14\u0E49\u0E27\u0E22\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07",
        openAPI: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D API",
        orderPickup: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E27\u0E25\u0E32\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
        orderQuota: "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E2D\u0E2D\u0E40\u0E14\u0E2D\u0E23\u0E4C\u0E15\u0E48\u0E2D\u0E40\u0E14\u0E37\u0E2D\u0E19",
        offlineOrder: "\u0E2D\u0E2D\u0E40\u0E14\u0E2D\u0E23\u0E4C\u0E2D\u0E2D\u0E1F\u0E44\u0E25\u0E19\u0E4C",
        fileUploadViaChat: "\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E44\u0E1F\u0E25\u0E4C\u0E1C\u0E48\u0E32\u0E19\u0E41\u0E0A\u0E17",
        pickupStore: "\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E23\u0E49\u0E32\u0E19/\u0E2A\u0E32\u0E02\u0E32",
        postcodeBase: "\u0E23\u0E30\u0E1A\u0E1A\u0E04\u0E33\u0E19\u0E27\u0E13\u0E04\u0E48\u0E32\u0E2A\u0E48\u0E07\u0E15\u0E32\u0E21\u0E23\u0E2B\u0E31\u0E2A\u0E44\u0E1B\u0E23\u0E29\u0E13\u0E35\u0E22\u0E4C",
        productQuota: "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        promotion: "\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E21\u0E37\u0E2D\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E41\u0E04\u0E21\u0E40\u0E1B\u0E0D\u0E41\u0E25\u0E30\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19",
        realTimeWithdrawal: "\u0E16\u0E2D\u0E19-\u0E42\u0E2D\u0E19\u0E40\u0E07\u0E34\u0E19\u0E41\u0E1A\u0E1A\u0E40\u0E23\u0E35\u0E22\u0E25\u0E44\u0E17\u0E21\u0E4C",
        saleReport: "\u0E23\u0E30\u0E1A\u0E1A\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22",
        saleReportExport: "\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22",
        subscriberQuota: "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14",
        support: "\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D deeple support",
        zortIntegration: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E23\u0E30\u0E1A\u0E1A\u0E2A\u0E15\u0E47\u0E2D\u0E01 ZORT",
        bankTransferFee: "\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E01\u0E32\u0E23\u0E42\u0E2D\u0E19",
        manualApprovalOrders: "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E2D\u0E2D\u0E40\u0E14\u0E2D\u0E23\u0E4C\u0E17\u0E35\u0E48\u0E0A\u0E33\u0E23\u0E30\u0E1C\u0E48\u0E32\u0E19\u0E01\u0E32\u0E23\u0E42\u0E2D\u0E19\u0E15\u0E48\u0E2D\u0E40\u0E14\u0E37\u0E2D\u0E19",
        manualOrders: "(\u0E2D\u0E2D\u0E40\u0E14\u0E2D\u0E23\u0E4C)"
      },
      titleInfo: {
        "deeplePayFeeRate.creditCard.rate": "\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E23\u0E27\u0E21 VAT 7%",
        "deeplePayFeeRate.qrCash.rate": "\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E23\u0E27\u0E21 VAT 7%",
        "deeplePayFeeRate.mobileBanking.rate": "\u0E02\u0E31\u0E49\u0E19\u0E15\u0E48\u0E33 15 \u0E1A\u0E32\u0E17",
        "deeplePayFeeRate.rabbitLinePay.rate": "Coming Soon",
        "deeplePayFeeRate.trueMoneyWallet.rate": "\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E23\u0E27\u0E21 VAT 7%",
        "deeplePayFeeRate.withdrawal.fix": "\u0E23\u0E27\u0E21 VAT 7%",
        aiProductSearch: "*\u0E0B\u0E37\u0E49\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E44\u0E14\u0E49\u0E43\u0E19\u0E41\u0E1E\u0E47\u0E04\u0E40\u0E01\u0E08\u0E40\u0E2A\u0E23\u0E34\u0E21",
        faqQuota: "Train AI Chatbot",
        adminCount: "*\u0E0B\u0E37\u0E49\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E44\u0E14\u0E49\u0E43\u0E19\u0E41\u0E1E\u0E47\u0E04\u0E40\u0E01\u0E08\u0E40\u0E2A\u0E23\u0E34\u0E21",
        zeroFee: "\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21 0 \u0E1A\u0E32\u0E17",
        limitOrder: "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E2D\u0E2D\u0E40\u0E14\u0E2D\u0E23\u0E4C\u0E17\u0E35\u0E48\u0E08\u0E33\u0E01\u0E31\u0E14 (\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E1C\u0E48\u0E32\u0E19\u0E01\u0E32\u0E23\u0E42\u0E2D\u0E19)",
        onlyDeeplePayOrders: "\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E2D\u0E2D\u0E23\u0E4C\u0E40\u0E14\u0E2D\u0E23\u0E4C\u0E17\u0E35\u0E48\u0E0A\u0E33\u0E23\u0E30\u0E1C\u0E48\u0E32\u0E19 deeple pay",
        offlineOrder: "\u0E2D\u0E2D\u0E40\u0E14\u0E2D\u0E23\u0E4C\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E0B\u0E37\u0E49\u0E2D\u0E1C\u0E48\u0E32\u0E19\u0E41\u0E0A\u0E17",
        fileUploadViaChat: "<ul class='tw-px-2.5 tw-list-disc'><li>\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E44\u0E1F\u0E25\u0E4C: .pdf .doc .docx .xls .xlsx</li><li>\u0E02\u0E19\u0E32\u0E14\u0E44\u0E1F\u0E25\u0E4C: 4 MB, 8 MB</li><li>\u0E2D\u0E32\u0E22\u0E38\u0E44\u0E1F\u0E25\u0E4C: 14 \u0E27\u0E31\u0E19, 30 \u0E27\u0E31\u0E19</li></ul>"
      },
      fileUploadViaChat: {
        standard: "4 MB, 14 \u0E27\u0E31\u0E19",
        premium: "8 MB, 30 \u0E27\u0E31\u0E19",
        profession: "8 MB, 14 \u0E27\u0E31\u0E19",
        platform: "(LINE, FB)"
      }
    },
    successModal: {
      title: "\u0E41\u0E1E\u0E47\u0E04\u0E40\u0E01\u0E08\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E17\u0E33\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1B\u0E40\u0E01\u0E23\u0E14\u0E41\u0E25\u0E49\u0E27",
      startPackage: "\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E40\u0E23\u0E34\u0E48\u0E21\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 {{ package }} \u0E41\u0E25\u0E49\u0E27",
      fromFreePackage: "\u0E01\u0E32\u0E23\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E23\u0E32\u0E22\u0E40\u0E14\u0E37\u0E2D\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E30\u0E40\u0E23\u0E34\u0E48\u0E21\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E41\u0E1E\u0E47\u0E04\u0E40\u0E01\u0E08\u0E1F\u0E23\u0E35 14 \u0E27\u0E31\u0E19",
      fromPaidPackage: "\u0E01\u0E32\u0E23\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E23\u0E32\u0E22\u0E40\u0E14\u0E37\u0E2D\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D\u0E2D\u0E32\u0E22\u0E38\u0E43\u0E19\u0E27\u0E31\u0E19\u0E40\u0E14\u0E35\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49",
      nextBillingDate: "\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19: {{ billingDate }}",
      doneButton: "\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E49\u0E19"
    },
    card: {
      contactUs: "\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E40\u0E23\u0E32",
      chooseButtonText: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E41\u0E1E\u0E25\u0E19\u0E19\u0E35\u0E49",
      selectedButtonText: "\u0E41\u0E1E\u0E25\u0E19\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      pricePerMonth: "/\u0E40\u0E14\u0E37\u0E2D\u0E19",
      pricePerYear: "/\u0E1B\u0E35",
      features: {
        faqQuota: "\u0E2A\u0E2D\u0E19 AI \u0E15\u0E2D\u0E1A\u0E04\u0E33\u0E16\u0E32\u0E21\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08",
        productQuota: "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        admin: "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E41\u0E2D\u0E14\u0E21\u0E34\u0E19",
        subscriberQuota: "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14",
        saleReport: "\u0E23\u0E30\u0E1A\u0E1A\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22",
        customerReport: "\u0E23\u0E30\u0E1A\u0E1A\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
        consignmentReport: "\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E01\u0E32\u0E23\u0E19\u0E33\u0E2A\u0E48\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32"
      },
      free: {
        title: "Free",
        subTitle: "\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19"
      },
      starter_1: {
        title: "Starter-S",
        subTitle: ""
      },
      starter_2: {
        title: "Starter-M",
        subTitle: ""
      },
      starter_3: {
        title: "Starter-L",
        subTitle: ""
      },
      standard: {
        title: "Basic",
        subTitle: "\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E01\u0E31\u0E1A\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E02\u0E19\u0E32\u0E14\u0E40\u0E25\u0E47\u0E01"
      },
      professional: {
        title: "Standard",
        subTitle: "\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E01\u0E31\u0E1A\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E02\u0E19\u0E32\u0E14\u0E40\u0E25\u0E47\u0E01\u0E16\u0E36\u0E07\u0E01\u0E25\u0E32\u0E07"
      },
      premium: {
        title: "Advanced",
        subTitle: "\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E01\u0E31\u0E1A\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E02\u0E19\u0E32\u0E14\u0E01\u0E25\u0E32\u0E07\u0E16\u0E36\u0E07\u0E43\u0E2B\u0E0D\u0E48"
      },
      custom: {
        title: "Custom",
        subTitle: "\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E41\u0E1E\u0E25\u0E19\u0E44\u0E14\u0E49\u0E15\u0E32\u0E21\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23"
      },
      usingCustom: {
        title: "Custom",
        subTitle: "\u0E41\u0E1E\u0E25\u0E19\u0E17\u0E35\u0E48\u0E1B\u0E23\u0E31\u0E1A\u0E41\u0E25\u0E49\u0E27\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
      },
      needMore: {
        title: "Need more?",
        subTitle: "\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E40\u0E23\u0E32\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E23\u0E31\u0E1A\u0E41\u0E1E\u0E25\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21"
      }
    }
  },
  notAllowFeatureModal: {
    title: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E2D\u0E31\u0E1B\u0E40\u0E01\u0E23\u0E14\u0E41\u0E1E\u0E47\u0E04\u0E40\u0E01\u0E08\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    description1: "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48? \u0E01\u0E23\u0E38\u0E13\u0E32\u0E2D\u0E31\u0E1B\u0E40\u0E01\u0E23\u0E14\u0E41\u0E1E\u0E47\u0E04\u0E40\u0E01\u0E08\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    description2: "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E0A\u0E49\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E0A\u0E19\u0E4C\u0E41\u0E25\u0E30\u0E04\u0E38\u0E13\u0E2A\u0E21\u0E1A\u0E31\u0E15\u0E34\u0E02\u0E2D\u0E07\u0E1F\u0E35\u0E40\u0E08\u0E2D\u0E23\u0E4C\u0E19\u0E35\u0E49\u0E44\u0E14\u0E49\u0E21\u0E32\u0E01\u0E02\u0E36\u0E49\u0E19",
    upgradeButton: "\u0E2D\u0E31\u0E1B\u0E40\u0E01\u0E23\u0E14\u0E41\u0E1E\u0E47\u0E04\u0E40\u0E01\u0E08"
  }
};
const th$5 = {
  header: "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
  default: {
    title: "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E19\u0E23\u0E49\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    description: "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E41\u0E25\u0E30\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E20\u0E32\u0E22\u0E43\u0E19\u0E23\u0E49\u0E32\u0E19\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48",
    manageSKU: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 (SKU)",
    categorizeProduct: "\u0E08\u0E31\u0E14\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\u0E41\u0E25\u0E30\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
    editProduct: "\u0E41\u0E01\u0E49\u0E44\u0E02 \u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E41\u0E25\u0E30\u0E08\u0E33\u0E19\u0E27\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
    searchProduct: "\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23",
    add: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32"
  },
  productList: {
    items: "{{value}} \u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
    status: "\u0E2A\u0E16\u0E32\u0E19\u0E30",
    category: "\u0E40\u0E21\u0E19\u0E39\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
    price: "\u0E23\u0E32\u0E04\u0E32",
    variantList: "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
    search: {
      productName: "\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E0A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
      category: "\u0E15\u0E31\u0E27\u0E01\u0E23\u0E2D\u0E07\u0E15\u0E32\u0E21\u0E40\u0E21\u0E19\u0E39\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32"
    },
    filter: {
      search: "\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E40\u0E21\u0E19\u0E39\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
      selected: "{{value}} \u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01:",
      allItem: "\u0E40\u0E21\u0E19\u0E39\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14"
    },
    productNotFound: {
      title: "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
      description: "\u0E25\u0E2D\u0E07\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E15\u0E31\u0E27\u0E01\u0E23\u0E2D\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E33\u0E04\u0E49\u0E19\u0E2B\u0E32"
    },
    edit: "\u0E41\u0E01\u0E49\u0E44\u0E02",
    clear: "\u0E25\u0E49\u0E32\u0E07",
    pagination: {
      total: "\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07\u0E1C\u0E25: {{range}} \u0E08\u0E32\u0E01 {{total}}",
      page: "\u0E2B\u0E19\u0E49\u0E32",
      show: "\u0E41\u0E2A\u0E14\u0E07",
      perPage: "\u0E15\u0E48\u0E2D\u0E2B\u0E19\u0E49\u0E32"
    }
  },
  title: {
    add: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E2B\u0E21\u0E48",
    edit: "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32"
  },
  isActive: "\u0E41\u0E2A\u0E14\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
  isInactive: "\u0E44\u0E21\u0E48\u0E41\u0E2A\u0E14\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
  productImage: {
    title: "\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
    upload: {
      label: "\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E2B\u0E23\u0E37\u0E2D\u0E27\u0E32\u0E07\u0E20\u0E32\u0E1E\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
      button: "\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14"
    }
  },
  productDetail: {
    title: "\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
    name: "\u0E0A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
    category: {
      label: "\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48/\u0E40\u0E21\u0E19\u0E39\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
      placeholder: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48/\u0E40\u0E21\u0E19\u0E39\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32"
    },
    brand: "\u0E22\u0E35\u0E48\u0E2B\u0E49\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
    description: "\u0E04\u0E33\u0E2D\u0E18\u0E34\u0E1A\u0E32\u0E22\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
    productCode: {
      label: "\u0E42\u0E04\u0E49\u0E14\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
      placeholder: "\u0E40\u0E0A\u0E48\u0E19 Product001 \u0E2B\u0E23\u0E37\u0E2D Product-001"
    },
    cfCode: {
      label: "CF \u0E42\u0E04\u0E49\u0E14\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
      tooltip: "\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E43\u0E2A\u0E48 \u0E16\u0E49\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E01\u0E32\u0E23\u0E15\u0E2D\u0E1A\u0E01\u0E25\u0E31\u0E1A\u0E40\u0E1F\u0E0B\u0E1A\u0E38\u0E4A\u0E01\u0E44\u0E25\u0E1F\u0E4C",
      placeholder: "\u0E40\u0E0A\u0E48\u0E19 CfProduct001 \u0E2B\u0E23\u0E37\u0E2D CfProduct-001"
    }
  },
  pricing: {
    title: "\u0E23\u0E32\u0E04\u0E32\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
    price: "\u0E23\u0E32\u0E04\u0E32 (\u0E3F)",
    costPrice: "\u0E23\u0E32\u0E04\u0E32\u0E15\u0E49\u0E19\u0E17\u0E38\u0E19 (\u0E3F)",
    freeProduct: "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E1F\u0E23\u0E35"
  },
  advanceDetail: {
    title: "\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    productUnit: {
      label: "\u0E2B\u0E19\u0E48\u0E27\u0E22\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
      placeholder: "\u0E40\u0E0A\u0E48\u0E19 \u0E0A\u0E34\u0E49\u0E19 \u0E2B\u0E23\u0E37\u0E2D \u0E01\u0E25\u0E48\u0E2D\u0E07"
    },
    weightPerUnit: "\u0E19\u0E49\u0E33\u0E2B\u0E19\u0E31\u0E01\u0E15\u0E48\u0E2D\u0E2B\u0E19\u0E48\u0E27\u0E22 (\u0E01\u0E23\u0E31\u0E21)",
    dimension: "\u0E02\u0E19\u0E32\u0E14\u0E02\u0E2D\u0E07\u0E1E\u0E31\u0E2A\u0E14\u0E38 (\u0E0B\u0E21.)",
    width: "\u0E01\u0E27\u0E49\u0E32\u0E07",
    length: "\u0E22\u0E32\u0E27",
    height: "\u0E2A\u0E39\u0E07"
  },
  productProperty: {
    title: "\u0E04\u0E38\u0E13\u0E2A\u0E21\u0E1A\u0E31\u0E15\u0E34\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
    addProperty: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E38\u0E13\u0E2A\u0E21\u0E1A\u0E31\u0E15\u0E34\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
    type: {
      label: "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E04\u0E38\u0E13\u0E2A\u0E21\u0E1A\u0E31\u0E15\u0E34",
      placeholder: "\u0E40\u0E0A\u0E48\u0E19 \u0E27\u0E31\u0E2A\u0E14\u0E38"
    },
    value: {
      label: "\u0E04\u0E48\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2A\u0E21\u0E1A\u0E31\u0E15\u0E34",
      placeholder: "\u0E40\u0E0A\u0E48\u0E19 \u0E1C\u0E49\u0E32, \u0E2B\u0E19\u0E31\u0E07"
    },
    additional: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E40\u0E0A\u0E48\u0E19 \u0E27\u0E31\u0E2A\u0E14\u0E38 \u0E2B\u0E23\u0E37\u0E2D\u0E25\u0E31\u0E01\u0E29\u0E13\u0E30"
  },
  category: {
    title: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48/\u0E40\u0E21\u0E19\u0E39\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
    create: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48/\u0E40\u0E21\u0E19\u0E39\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E2B\u0E21\u0E48",
    name: "\u0E0A\u0E37\u0E48\u0E2D\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48/\u0E40\u0E21\u0E19\u0E39\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
    add: "\u0E40\u0E1E\u0E34\u0E48\u0E21",
    cancel: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01"
  },
  save: "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
  addSKU: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
  confirm: "\u0E15\u0E01\u0E25\u0E07",
  error: {
    pricingLowerThanZero: "\u0E23\u0E32\u0E04\u0E32\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 0",
    valueLowerThanZero: "\u0E42\u0E1B\u0E23\u0E14\u0E01\u0E23\u0E2D\u0E14\u0E04\u0E48\u0E32\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 0",
    valueOverThanLimit: "\u0E42\u0E1B\u0E23\u0E14\u0E01\u0E23\u0E2D\u0E01\u0E04\u0E48\u0E32\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E17\u0E48\u0E32\u0E01\u0E31\u0E1A 9999",
    required: "\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E30\u0E1A\u0E38\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E19\u0E0A\u0E48\u0E2D\u0E07\u0E19\u0E35\u0E49",
    productCodeHasWrongFormat: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E23\u0E30\u0E1A\u0E38 3-50 \u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23 (\u0E20\u0E32\u0E29\u0E32\u0E44\u0E17\u0E22 \u0E2D\u0E31\u0E07\u0E01\u0E24\u0E29 \u0E2A\u0E31\u0E0D\u0E25\u0E31\u0E01\u0E29\u0E13\u0E4C ( _ , - ) \u0E41\u0E25\u0E30\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19)",
    CFCodeHasWrongFormat: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E23\u0E30\u0E1A\u0E38 3-50 \u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23 (\u0E20\u0E32\u0E29\u0E32\u0E44\u0E17\u0E22 \u0E2D\u0E31\u0E07\u0E01\u0E24\u0E29 \u0E2A\u0E31\u0E0D\u0E25\u0E31\u0E01\u0E29\u0E13\u0E4C ( _ , - ) \u0E41\u0E25\u0E30\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19)"
  },
  notification: {
    createSuccess: "\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
    createFailed: "\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27",
    editSuccess: "\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
    editFailed: "\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27",
    deleteSuccess: "\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
    deleteFailed: "\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27"
  },
  modal: {
    cancel: {
      title: "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
      detail: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E08\u0E30\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
      confirm: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19"
    },
    confirmDeleteProduct: {
      title: "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A",
      description: "\u0E04\u0E38\u0E13\u0E08\u0E30\u0E2A\u0E39\u0E0D\u0E40\u0E2A\u0E35\u0E22\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
      confirm: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19"
    }
  },
  productSKU: {
    title: "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
    noSKUDescription: "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E21\u0E35\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E15\u0E48\u0E32\u0E07\u0E46 \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48 \u0E40\u0E0A\u0E48\u0E19 \u0E02\u0E19\u0E32\u0E14 \u0E2A\u0E35 \u0E2B\u0E23\u0E37\u0E2D\u0E27\u0E31\u0E2A\u0E14\u0E38",
    addOption: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
    addSKUButton: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
    addSKUPopup: {
      title: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
      skuName: {
        label: "\u0E0A\u0E37\u0E48\u0E2D\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        placeholder: "\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07 \u0E40\u0E0A\u0E48\u0E19 \u0E02\u0E19\u0E32\u0E14 \u0E2B\u0E23\u0E37\u0E2D \u0E2A\u0E35"
      },
      skuValue: {
        label: "\u0E04\u0E48\u0E32\u0E02\u0E2D\u0E07\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 (SKU value)",
        placeholder: "\u0E01\u0E14 Enter \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01 "
      },
      cancel: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
      add: "\u0E40\u0E1E\u0E34\u0E48\u0E21"
    },
    manageSKU: {
      title: "\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
      editAllSKU: "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
      optional: "\u0E16\u0E49\u0E32\u0E21\u0E35",
      sku: "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
      image: "\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
      skuCode: "\u0E23\u0E2B\u0E31\u0E2A\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
      inventory: "\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
      price: "\u0E23\u0E32\u0E04\u0E32",
      costPrice: "\u0E23\u0E32\u0E04\u0E32\u0E15\u0E49\u0E19\u0E17\u0E38\u0E19 (\u0E3F)",
      weight: "\u0E19\u0E49\u0E33\u0E2B\u0E19\u0E31\u0E01 (\u0E01.)",
      dimension: "\u0E02\u0E19\u0E32\u0E14 (\u0E0B\u0E21.)",
      width: "\u0E01\u0E27\u0E49\u0E32\u0E07",
      length: "\u0E22\u0E32\u0E27",
      height: "\u0E2A\u0E39\u0E07",
      field: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02"
    },
    error: {
      maximumProductSKU: "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E15\u0E49\u0E2D\u0E07\u0E44\u0E21\u0E48\u0E40\u0E01\u0E34\u0E19 55 \u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01",
      duplicatedSKUName: "\u0E0A\u0E37\u0E48\u0E2D\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E44\u0E21\u0E48\u0E0B\u0E49\u0E33\u0E01\u0E31\u0E19",
      itemValueOverThanLimit: "\u0E04\u0E48\u0E32\u0E02\u0E2D\u0E07\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E17\u0E48\u0E32\u0E01\u0E31\u0E1A 50 \u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23",
      duplicateSKUValue: "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E44\u0E21\u0E48\u0E0B\u0E49\u0E33\u0E01\u0E31\u0E19",
      emptyProductSKUCode: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E23\u0E2B\u0E31\u0E2A\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
      emptyProductSKUPrice: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E23\u0E32\u0E04\u0E32\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
      emptyProductSKUDimension: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E19\u0E32\u0E14\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
      inventoryNotEmpty: "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E44\u0E14\u0E49\u0E42\u0E1B\u0E23\u0E14\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32 \u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E19\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E19\u0E35\u0E49\u0E40\u0E2B\u0E25\u0E37\u0E2D 0 \u0E0A\u0E34\u0E49\u0E19",
      duplicatedProductName: "\u0E0A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E0B\u0E49\u0E33\u0E01\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2D\u0E37\u0E48\u0E19",
      duplicatedProductCode: "\u0E23\u0E2B\u0E31\u0E2A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E0B\u0E49\u0E33\u0E01\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2D\u0E37\u0E48\u0E19",
      duplicatedCFCode: "\u0E23\u0E2B\u0E31\u0E2A CF \u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E0B\u0E49\u0E33\u0E01\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2D\u0E37\u0E48\u0E19",
      descriptionExceedLimit: "\u0E04\u0E33\u0E2D\u0E18\u0E34\u0E1A\u0E32\u0E22\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E44\u0E21\u0E48\u0E04\u0E27\u0E23\u0E40\u0E01\u0E34\u0E19 2,500 \u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23",
      priceReachLimit: "\u0E23\u0E32\u0E04\u0E32\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E04\u0E48\u0E32\u0E44\u0E21\u0E48\u0E40\u0E01\u0E34\u0E19\u0E01\u0E27\u0E48\u0E32 1 \u0E25\u0E49\u0E32\u0E19\u0E1A\u0E32\u0E17",
      overQuota: "\u0E42\u0E04\u0E49\u0E27\u0E15\u0E49\u0E32\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E40\u0E15\u0E47\u0E21 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E2D\u0E31\u0E1E\u0E40\u0E01\u0E23\u0E14\u0E41\u0E1E\u0E25\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
      productCodeNotFound: "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
      incorrectDigitalContent: "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
      duplicatedDigitalContent: "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25\u0E0B\u0E49\u0E33",
      outputTypeIsNotCodeImport: "\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25 \u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48 import",
      contentAvailabilityIsNotMatch: "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E23\u0E30\u0E22\u0E30\u0E40\u0E27\u0E25\u0E32\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
      skuValueCannotContainKey: "SKU name \u0E41\u0E25\u0E30 SKU value \u0E15\u0E49\u0E2D\u0E07\u0E44\u0E21\u0E48\u0E0B\u0E49\u0E33\u0E01\u0E31\u0E19",
      skuKeyDuplicated: "SKU name \u0E15\u0E49\u0E2D\u0E07\u0E44\u0E21\u0E48\u0E0B\u0E49\u0E33\u0E01\u0E31\u0E19",
      productVariantInventoryNotEmpty: "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E01\u0E49\u0E44\u0E02\u0E04\u0E48\u0E32\u0E02\u0E2D\u0E07\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 ({{value}}) \u0E44\u0E14\u0E49\u0E42\u0E1B\u0E23\u0E14\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32 \u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E43\u0E19\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E19\u0E35\u0E49\u0E40\u0E2B\u0E25\u0E37\u0E2D 0 \u0E0A\u0E34\u0E49\u0E19"
    },
    modal: {
      deleteSKU: {
        title: "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
        description: "\u0E04\u0E38\u0E13\u0E08\u0E30\u0E2A\u0E39\u0E0D\u0E40\u0E2A\u0E35\u0E22\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E43\u0E19\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E19\u0E35\u0E49",
        cancel: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        delete: "\u0E25\u0E1A"
      },
      cannotDeleteProduct: {
        title: "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E25\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E44\u0E14\u0E49"
      },
      cannotDeleteSKU: {
        title: "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E25\u0E1A\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E44\u0E14\u0E49",
        description: "\u0E01\u0E48\u0E2D\u0E19\u0E25\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E23\u0E37\u0E2D \u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E42\u0E1B\u0E23\u0E14\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32 \u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E04\u0E07\u0E04\u0E25\u0E31\u0E07\u0E22\u0E31\u0E07\u0E04\u0E07\u0E40\u0E1B\u0E47\u0E19 0 \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E08\u0E2D\u0E07\u0E44\u0E27\u0E49",
        ok: "\u0E15\u0E01\u0E25\u0E07"
      }
    }
  },
  inventory: {
    title: "\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
    stock: "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E02\u0E2D\u0E07\u0E43\u0E19\u0E04\u0E25\u0E31\u0E07",
    info: "\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E08\u0E33\u0E19\u0E27\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E04\u0E07\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32\u0E08\u0E33\u0E19\u0E27\u0E19\u0E02\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E44\u0E27\u0E49",
    reserve: "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E02\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E2A\u0E33\u0E23\u0E2D\u0E07: {{value}}"
  },
  deleteProduct: "\u0E25\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
  import: {
    button: {
      label: "\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
      subLabel: "\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A: CSV / XLSX",
      download: "\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E1F\u0E25\u0E4C"
    }
  }
};
const th$4 = {
  title: "\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
  noShippingActive: "\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E01\u0E32\u0E23\u0E02\u0E19\u0E2A\u0E48\u0E07\n\u0E44\u0E27\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22 1 \u0E41\u0E1A\u0E1A",
  reachLimit: "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E40\u0E01\u0E34\u0E19 4 \u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\n(\u0E44\u0E21\u0E48\u0E23\u0E27\u0E21\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E14\u0E49\u0E27\u0E22\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07)",
  calculationType: {
    flatPrice: "\u0E04\u0E48\u0E32\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E04\u0E07\u0E17\u0E35\u0E48",
    postalCode: "\u0E04\u0E48\u0E32\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E15\u0E32\u0E21\u0E23\u0E2B\u0E31\u0E2A\u0E44\u0E1B\u0E23\u0E29\u0E13\u0E35\u0E22\u0E4C",
    mannual: "\u0E04\u0E48\u0E32\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E44\u0E1B\u0E15\u0E32\u0E21\u0E17\u0E35\u0E48\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E01\u0E33\u0E2B\u0E19\u0E14",
    lalamove: "Lalamove",
    shippop: "Shippop",
    pickup: "\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E14\u0E49\u0E27\u0E22\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07"
  },
  shippingMethod: {
    title: "\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
    addButton: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
    duplicate: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E0B\u0E49\u0E33",
    setActive: "\u0E40\u0E1B\u0E34\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19",
    setInactive: "\u0E1B\u0E34\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19",
    delete: "\u0E25\u0E1A",
    other: "\u0E2D\u0E37\u0E48\u0E19\u0E46",
    placeholder: {
      title: "\u0E23\u0E30\u0E1A\u0E1A\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
      subTitle: "\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E0A\u0E31\u0E49\u0E19\u0E19\u0E33\u0E17\u0E35\u0E48\u0E2B\u0E25\u0E32\u0E01\u0E2B\u0E25\u0E32\u0E22\u0E41\u0E25\u0E30\u0E04\u0E23\u0E1A\u0E27\u0E07\u0E08\u0E23 \u0E43\u0E2B\u0E49\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E43\u0E0A\u0E49 \u0E2D\u0E35\u0E01\u0E17\u0E31\u0E49\u0E07\u0E22\u0E31\u0E07\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E0A\u0E48\u0E27\u0E22\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07",
      addButton: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
      list1: "\u0E40\u0E0A\u0E47\u0E04\u0E04\u0E48\u0E32\u0E2A\u0E48\u0E07",
      list2: "\u0E40\u0E23\u0E35\u0E22\u0E01\u0E04\u0E19\u0E21\u0E32\u0E23\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E1A\u0E49\u0E32\u0E19",
      list3: "\u0E23\u0E30\u0E1A\u0E1A\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E1E\u0E31\u0E2A\u0E14\u0E38",
      list4: "\u0E08\u0E2D\u0E07\u0E02\u0E19\u0E2A\u0E48\u0E07\u0E23\u0E32\u0E04\u0E32\u0E16\u0E39\u0E01",
      list5: "\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E1B\u0E25\u0E32\u0E22\u0E17\u0E32\u0E07",
      list6: "\u0E2D\u0E2D\u0E01\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E20\u0E32\u0E29\u0E35"
    },
    shippingMethodCard: {
      active: "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19",
      estimatedDelivery: "\u0E23\u0E30\u0E22\u0E30\u0E40\u0E27\u0E25\u0E32\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
      inactive: "\u0E1B\u0E34\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19",
      priceCalculation: "\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E04\u0E34\u0E14\u0E04\u0E48\u0E32\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
      COD: "\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E1B\u0E25\u0E32\u0E22\u0E17\u0E32\u0E07"
    },
    offlinePickUp: {
      title: "\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E14\u0E49\u0E27\u0E22\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07",
      subTitle: "\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E21\u0E32\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E49\u0E04\u0E32\u0E44\u0E14\u0E49\u0E14\u0E49\u0E27\u0E22\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23",
      pickupTitle: "\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E23\u0E30\u0E1A\u0E38\u0E40\u0E27\u0E25\u0E32",
      pickupSubTitle: "\u0E23\u0E31\u0E1A\u0E44\u0E14\u0E49\u0E19\u0E2D\u0E01\u0E40\u0E27\u0E25\u0E32\u0E01\u0E32\u0E23\u0E17\u0E33\u0E01\u0E32\u0E23",
      manageStoresButton: "\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E2A\u0E32\u0E02\u0E32\u0E17\u0E35\u0E48\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23"
    },
    shippingInfoGraphic: {
      title: "\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
      example: "\u0E14\u0E39\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07",
      subTitle: "\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E2A\u0E14\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
      uploadButton: "\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14",
      optional: "\u0E16\u0E49\u0E32\u0E21\u0E35"
    },
    confirmationModal: {
      deleteShipping: {
        title: "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E08\u0E30 '\u0E25\u0E1A' {{name}} \u0E43\u0E0A\u0E48\u0E23\u0E36\u0E44\u0E21\u0E48?",
        subTitle: "\u0E02\u0E49\u0E2D\u0E21\u0E38\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E30\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E2D\u0E2D\u0E01"
      },
      removeShippingInfoGraphic: {
        title: "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E08\u0E30 '\u0E25\u0E1A' \u0E23\u0E39\u0E1B\u0E19\u0E35\u0E49\u0E43\u0E0A\u0E48\u0E23\u0E36\u0E44\u0E21\u0E48?"
      },
      example: {
        description: "\u0E20\u0E32\u0E1E\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E08\u0E30\u0E42\u0E0A\u0E27\u0E4C\u0E43\u0E19\u0E1A\u0E17\u0E2A\u0E19\u0E17\u0E19\u0E32\u0E40\u0E27\u0E25\u0E32\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E16\u0E32\u0E21\u0E16\u0E36\u0E07\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
        okay: "\u0E15\u0E01\u0E25\u0E07"
      }
    },
    selectShippingMethod: {
      title: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
      learnMore: "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
      setUpShipping: "\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E40\u0E2D\u0E07",
      comingSoon: "\u0E40\u0E23\u0E47\u0E27\u0E46\u0E19\u0E35\u0E49",
      customizeShipping: {
        title: "\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E40\u0E2D\u0E07",
        description: "\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E17\u0E33\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E14\u0E49\u0E27\u0E22\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07 \u0E42\u0E14\u0E22\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E23\u0E30\u0E1A\u0E38\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17\u0E02\u0E19\u0E2A\u0E48\u0E07 \u0E41\u0E25\u0E30\u0E23\u0E32\u0E04\u0E32\u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E44\u0E14\u0E49"
      },
      connectShippop: {
        title: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A SHIPPOP",
        description: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D API \u0E01\u0E31\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35 SHIPPOP \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E41\u0E25\u0E30\u0E17\u0E33\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E1C\u0E48\u0E32\u0E19 SHIPPOP \u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34"
      },
      connectLalamove: {
        title: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A LALAMOVE",
        description: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E1A\u0E31\u0E0D\u0E0A\u0E35 LALAMOVE \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E04\u0E33\u0E19\u0E27\u0E19\u0E04\u0E48\u0E32\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E41\u0E25\u0E30\u0E17\u0E33\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E20\u0E32\u0E22\u0E43\u0E19 1 \u0E27\u0E31\u0E19"
      }
    },
    shippingForm: {
      name: "\u0E0A\u0E37\u0E48\u0E2D\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17\u0E02\u0E19\u0E2A\u0E48\u0E07",
      active: "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19",
      inactive: "\u0E1B\u0E34\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19",
      addShipping: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
      shippingDetail: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
      selectCarrier: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17\u0E02\u0E19\u0E2A\u0E48\u0E07",
      carrier: "\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17\u0E02\u0E19\u0E2A\u0E48\u0E07",
      estimatedTime: "\u0E41\u0E08\u0E49\u0E07\u0E23\u0E30\u0E22\u0E30\u0E40\u0E27\u0E25\u0E32\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E42\u0E14\u0E22\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13",
      to: "\u0E16\u0E36\u0E07",
      selectPriceCalculation: "\u0E01\u0E32\u0E23\u0E04\u0E33\u0E19\u0E27\u0E19\u0E04\u0E48\u0E32\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
      flatPrice: "\u0E04\u0E48\u0E32\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E04\u0E07\u0E17\u0E35\u0E48",
      manual: "\u0E04\u0E33\u0E19\u0E27\u0E19\u0E04\u0E48\u0E32\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E40\u0E2D\u0E07",
      postcodeBased: "\u0E04\u0E33\u0E19\u0E27\u0E19\u0E15\u0E32\u0E21\u0E23\u0E2B\u0E31\u0E2A\u0E44\u0E1B\u0E23\u0E29\u0E13\u0E35\u0E22\u0E4C",
      enterPrice: "\u0E01\u0E23\u0E2D\u0E01\u0E23\u0E32\u0E04\u0E32\u0E04\u0E48\u0E32\u0E2A\u0E48\u0E07",
      price: "\u0E04\u0E48\u0E32\u0E2A\u0E48\u0E07",
      cod: "\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E1B\u0E25\u0E32\u0E22\u0E17\u0E32\u0E07",
      flatPriceAlert: "\u0E04\u0E48\u0E32\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E08\u0E30\u0E16\u0E39\u0E01\u0E04\u0E34\u0E14\u0E40\u0E17\u0E48\u0E32\u0E01\u0E31\u0E19\u0E43\u0E19\u0E17\u0E38\u0E01\u0E46 \u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D",
      manualPriceAlert: "\u0E41\u0E2D\u0E14\u0E21\u0E34\u0E19\u0E08\u0E30\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E23\u0E2D\u0E01\u0E23\u0E32\u0E04\u0E32\u0E04\u0E48\u0E32\u0E2A\u0E48\u0E07\u0E43\u0E2B\u0E49\u0E01\u0E31\u0E1A\u0E2D\u0E2D\u0E40\u0E14\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E14\u0E49\u0E27\u0E22\u0E15\u0E19\u0E40\u0E2D\u0E07\u0E43\u0E19\u0E17\u0E38\u0E01\u0E46 \u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D",
      cancel: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
      save: "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
      carrierNameIsRequired: "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E0A\u0E37\u0E48\u0E2D\u0E02\u0E19\u0E2A\u0E48\u0E07",
      minCannotZero: "\u0E23\u0E30\u0E22\u0E30\u0E40\u0E27\u0E25\u0E32\u0E15\u0E48\u0E33\u0E2A\u0E38\u0E14\u0E04\u0E27\u0E23\u0E21\u0E35\u0E04\u0E48\u0E32\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 0",
      minLessThanMax: "\u0E23\u0E30\u0E22\u0E30\u0E40\u0E27\u0E25\u0E32\u0E15\u0E48\u0E33\u0E2A\u0E38\u0E14\u0E15\u0E49\u0E2D\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32\u0E23\u0E30\u0E22\u0E30\u0E40\u0E27\u0E25\u0E32\u0E02\u0E19\u0E2A\u0E48\u0E07\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14",
      maxCannotZero: "\u0E23\u0E30\u0E22\u0E30\u0E40\u0E27\u0E25\u0E32\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14\u0E04\u0E27\u0E23\u0E21\u0E35\u0E04\u0E48\u0E32\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 0",
      maxMoreThanMin: "\u0E23\u0E30\u0E22\u0E30\u0E40\u0E27\u0E25\u0E32\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32\u0E23\u0E30\u0E22\u0E30\u0E40\u0E27\u0E25\u0E32\u0E02\u0E19\u0E2A\u0E48\u0E07\u0E15\u0E48\u0E33\u0E2A\u0E38\u0E14",
      noDepositFee: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E21\u0E31\u0E14\u0E08\u0E33",
      noManagementFee: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21",
      percentage: "\u0E04\u0E33\u0E19\u0E27\u0E13\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E1B\u0E2D\u0E23\u0E4C\u0E40\u0E0B\u0E47\u0E19\u0E15\u0E4C",
      customPrice: "\u0E23\u0E32\u0E04\u0E32\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E2D\u0E07",
      minimumOrder: "\u0E22\u0E2D\u0E14\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E02\u0E31\u0E49\u0E19\u0E15\u0E48\u0E33",
      depositFee: "\u0E40\u0E07\u0E34\u0E19\u0E04\u0E48\u0E32\u0E21\u0E31\u0E14\u0E08\u0E33",
      depositCannotZero: "\u0E40\u0E07\u0E34\u0E19\u0E04\u0E48\u0E32\u0E21\u0E31\u0E14\u0E08\u0E33\u0E04\u0E27\u0E23\u0E21\u0E35\u0E04\u0E48\u0E32\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 0",
      managementFee: "\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21",
      managementFeeCannotZero: "\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E04\u0E27\u0E23\u0E21\u0E35\u0E04\u0E48\u0E32\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 0",
      optional: "\u0E16\u0E49\u0E32\u0E21\u0E35"
    }
  }
};
const th$3 = {
  firstStep: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19",
  title: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E40\u0E25\u0E37\u0E2D\u0E01 ({{ packageType }})",
  secondStep: "\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E32\u0E23\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19",
  paymentMethodForm: {
    cardNo: "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E1A\u0E31\u0E15\u0E23",
    expireDate: "\u0E27\u0E31\u0E19\u0E2B\u0E21\u0E14\u0E2D\u0E32\u0E22\u0E38",
    cvv: "CVV",
    cardHolderNameLabel: "\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E16\u0E37\u0E2D\u0E1A\u0E31\u0E15\u0E23",
    cardHolderNamePlaceholder: "\u0E0A\u0E37\u0E48\u0E2D - \u0E19\u0E32\u0E21\u0E2A\u0E01\u0E38\u0E25\u0E2B\u0E19\u0E49\u0E32\u0E1A\u0E31\u0E15\u0E23",
    setPaymentMethodPrimaryLabel: "Set this payment method as primary",
    description1: "\u0E1A\u0E31\u0E15\u0E23\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E30\u0E16\u0E39\u0E01\u0E43\u0E0A\u0E49\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E04\u0E48\u0E32\u0E41\u0E1E\u0E47\u0E01\u0E40\u0E01\u0E08\u0E41\u0E25\u0E30\u0E1F\u0E35\u0E40\u0E08\u0E2D\u0E23\u0E4C\u0E40\u0E2A\u0E23\u0E34\u0E21 \u0E41\u0E25\u0E30\u0E17\u0E14\u0E25\u0E2D\u0E07\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E17\u0E31\u0E19\u0E17\u0E35\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E1A\u0E31\u0E15\u0E23\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E44\u0E14\u0E49 \u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E19\u0E31\u0E49\u0E19\u0E23\u0E30\u0E1A\u0E1A\u0E08\u0E30\u0E17\u0E33\u0E01\u0E32\u0E23\u0E04\u0E37\u0E19\u0E40\u0E07\u0E34\u0E19\u0E43\u0E2B\u0E49\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 \u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1A\u0E31\u0E15\u0E23\u0E40\u0E14\u0E1A\u0E34\u0E15\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15\u0E2B\u0E21\u0E32\u0E22\u0E16\u0E36\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E15\u0E01\u0E25\u0E07\u0E15\u0E32\u0E21",
    termAndCondition: "Terms of service",
    submit: "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
    validation: {
      cardNo: {
        max: "\u0E40\u0E25\u0E02\u0E1A\u0E31\u0E15\u0E23\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
        min: "\u0E40\u0E25\u0E02\u0E1A\u0E31\u0E15\u0E23\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
        required: "\u0E40\u0E25\u0E02\u0E1A\u0E31\u0E15\u0E23\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07"
      },
      expireDate: {
        invalidDate: "\u0E27\u0E31\u0E19\u0E2B\u0E21\u0E14\u0E2D\u0E32\u0E22\u0E38\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
        required: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E23\u0E30\u0E1A\u0E38\u0E27\u0E31\u0E19\u0E2B\u0E21\u0E14\u0E2D\u0E32\u0E22\u0E38",
        length: "\u0E27\u0E31\u0E19\u0E2B\u0E21\u0E14\u0E2D\u0E32\u0E22\u0E38\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E27\u0E31\u0E19\u0E43\u0E19\u0E2D\u0E19\u0E32\u0E04\u0E15"
      },
      cardholderName: {
        containNumber: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E43\u0E2A\u0E48\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E16\u0E37\u0E2D\u0E1A\u0E31\u0E15\u0E23\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23",
        required: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E23\u0E30\u0E1A\u0E38\u0E0A\u0E37\u0E48\u0E2D\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E1A\u0E19\u0E1A\u0E31\u0E15\u0E23"
      },
      cvv: {
        required: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E23\u0E30\u0E1A\u0E38\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02 CVV",
        length: "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02 CVV\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07"
      }
    }
  },
  billingAddressForm: {
    selectPlaceholder: "\u0E40\u0E25\u0E37\u0E2D\u0E01",
    nameLabel: "\u0E0A\u0E37\u0E48\u0E2D - \u0E19\u0E32\u0E21\u0E2A\u0E01\u0E38\u0E25",
    corporateNameLabel: "\u0E0A\u0E37\u0E48\u0E2D\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17",
    namePlaceholder: "\u0E0A\u0E37\u0E48\u0E2D-\u0E19\u0E32\u0E21\u0E2A\u0E01\u0E38\u0E25\u0E08\u0E23\u0E34\u0E07",
    corporateNamePlaceholder: "\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17",
    addressLabel: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E15\u0E32\u0E21\u0E1A\u0E31\u0E15\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E32\u0E0A\u0E19",
    corporateAddressLabel: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17",
    addressPlaceholder: "\u0E40\u0E25\u0E02\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48",
    postalCodeLabel: "\u0E23\u0E2B\u0E31\u0E2A\u0E44\u0E1B\u0E23\u0E29\u0E13\u0E35\u0E22\u0E4C",
    postalCodePlaceholder: "101100",
    taxIdLabel: "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E1B\u0E23\u0E30\u0E08\u0E33\u0E15\u0E31\u0E27\u0E1C\u0E39\u0E49\u0E40\u0E2A\u0E35\u0E22\u0E20\u0E32\u0E29\u0E35",
    taxIdPlaceholder: "\u0E40\u0E25\u0E02\u0E1A\u0E31\u0E15\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E32\u0E0A\u0E19 13 \u0E2B\u0E25\u0E31\u0E01",
    contactPersonLabel: "\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D - \u0E16\u0E49\u0E32\u0E21\u0E35",
    contactPersonPlaceholder: "\u0E0A\u0E37\u0E48\u0E2D",
    phoneNumberLabel: "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C",
    phoneNumberPlaceholder: "+66",
    emailLabel: "\u0E2D\u0E35\u0E40\u0E21\u0E25",
    emailPlaceholder: "Name@mail.com",
    personal: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25",
    corporate: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E19\u0E34\u0E15\u0E34\u0E1A\u0E38\u0E04\u0E04\u0E25",
    documentVerificationCertificateLabel: "\u0E1A\u0E31\u0E15\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E32\u0E0A\u0E19",
    corporateDocumentVerificationCertificateLabel: "\u0E43\u0E1A\u0E08\u0E14\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E01\u0E32\u0E23\u0E04\u0E49\u0E32",
    documentVerificationCertificatePlaceholder: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E39\u0E1B\u0E1A\u0E31\u0E15\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E32\u0E0A\u0E19",
    corporateDocumentVerificationCertificatePlaceholder: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E39\u0E1B\u0E43\u0E1A\u0E08\u0E14\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E01\u0E32\u0E23\u0E04\u0E49\u0E32",
    cancel: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
    submit: "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
    mr: "\u0E19\u0E32\u0E22",
    mrs: "\u0E19\u0E32\u0E07",
    miss: "\u0E19\u0E32\u0E07\u0E2A\u0E32\u0E27",
    subDistrictLabel: "\u0E41\u0E02\u0E27\u0E07/\u0E15\u0E33\u0E1A\u0E25",
    districtLabel: "\u0E40\u0E02\u0E15/\u0E2D\u0E33\u0E40\u0E20\u0E2D",
    provinceLabel: "\u0E08\u0E31\u0E07\u0E2B\u0E27\u0E31\u0E14",
    validation: {
      name: {
        required: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E43\u0E2A\u0E48\u0E0A\u0E37\u0E48\u0E2D"
      },
      address: {
        required: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E43\u0E2A\u0E48\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48"
      },
      taxId: {
        required: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E1B\u0E23\u0E30\u0E08\u0E33\u0E15\u0E31\u0E27\u0E1C\u0E39\u0E49\u0E40\u0E2A\u0E35\u0E22\u0E20\u0E32\u0E29\u0E35",
        length: "\u0E40\u0E25\u0E02\u0E1B\u0E23\u0E30\u0E08\u0E33\u0E15\u0E31\u0E27\u0E1C\u0E39\u0E49\u0E40\u0E2A\u0E35\u0E22\u0E20\u0E32\u0E29\u0E35\u0E04\u0E27\u0E23\u0E22\u0E32\u0E27 13 \u0E2B\u0E25\u0E31\u0E01"
      },
      phoneNumber: {
        required: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C",
        length: "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E04\u0E27\u0E23\u0E22\u0E32\u0E27 10 \u0E2B\u0E25\u0E31\u0E01"
      },
      email: {
        email: "\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
        required: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E43\u0E2A\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25"
      },
      documentVerificationCertificatePath: {
        required: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23"
      },
      subDistrict: {
        required: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E43\u0E2A\u0E48\u0E41\u0E02\u0E27\u0E07/\u0E15\u0E33\u0E1A\u0E25"
      },
      district: {
        required: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E43\u0E2A\u0E48\u0E40\u0E02\u0E15/\u0E2D\u0E33\u0E40\u0E20\u0E2D"
      },
      province: {
        required: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E43\u0E2A\u0E48\u0E08\u0E31\u0E07\u0E2B\u0E27\u0E31\u0E14"
      },
      postalCode: {
        length: "\u0E23\u0E2B\u0E31\u0E2A\u0E44\u0E1B\u0E23\u0E29\u0E13\u0E35\u0E22\u0E4C\u0E04\u0E27\u0E23\u0E22\u0E32\u0E27 5 \u0E2B\u0E25\u0E31\u0E01",
        required: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E43\u0E2A\u0E48\u0E23\u0E2B\u0E31\u0E2A\u0E44\u0E1B\u0E23\u0E29\u0E13\u0E35\u0E22\u0E4C"
      }
    },
    uploadImageSuccess: "\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E23\u0E39\u0E1B\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
    uploadImageError: "\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E23\u0E39\u0E1B\u0E44\u0E21\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08"
  },
  billingAddressSection: {
    submitBillingAddressSuccess: "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E32\u0E23\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27",
    submitBillingAddressError: "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E32\u0E23\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E44\u0E21\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08"
  },
  paymentSection: {
    addCreditCardSuccess: "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E1A\u0E31\u0E15\u0E23\u0E41\u0E25\u0E49\u0E27",
    addCreditCardError: "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E1A\u0E31\u0E15\u0E23\u0E44\u0E21\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
    removeCreditCardSuccess: "\u0E1A\u0E31\u0E15\u0E23 {{ brand }} {{ cardNo ]}} \u0E16\u0E39\u0E01\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E23\u0E30\u0E1A\u0E1A",
    removeCreditCardError: "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E25\u0E1A\u0E1A\u0E31\u0E15\u0E23 {{ brand }} {{ cardNo ]}} \u0E08\u0E32\u0E01\u0E23\u0E30\u0E1A\u0E1A"
  },
  paymentSummary: {
    title: "\u0E2D\u0E31\u0E1E\u0E40\u0E01\u0E23\u0E14\u0E41\u0E1E\u0E25\u0E19\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19",
    description: "\u0E23\u0E2D\u0E1A\u0E1A\u0E34\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E30\u0E16\u0E39\u0E01\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E43\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48 {{ effectiveDate }}",
    submitText: "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E43\u0E0A\u0E49\u0E41\u0E1E\u0E25\u0E19",
    detail: "\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19",
    upgradeTo: "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E44\u0E1B\u0E22\u0E31\u0E07:",
    credit: "\u0E40\u0E07\u0E34\u0E19\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15",
    creditDescription: "\u0E40\u0E07\u0E34\u0E19\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15 \u0E04\u0E37\u0E2D\u0E40\u0E07\u0E34\u0E19\u0E0A\u0E14\u0E40\u0E0A\u0E22\u0E2B\u0E25\u0E31\u0E07\u0E01\u0E32\u0E23\u0E2B\u0E31\u0E01\u0E04\u0E48\u0E32\u0E43\u0E0A\u0E49\u0E08\u0E48\u0E32\u0E22\u0E02\u0E2D\u0E07 \u0E41\u0E1E\u0E47\u0E04\u0E40\u0E01\u0E08\u0E41\u0E25\u0E30\u0E1F\u0E35\u0E40\u0E08\u0E2D\u0E23\u0E4C\u0E40\u0E2A\u0E23\u0E34\u0E21\u0E23\u0E32\u0E22\u0E40\u0E14\u0E37\u0E2D\u0E19\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E44\u0E1B",
    total: "\u0E22\u0E2D\u0E14\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19",
    discount: "\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14",
    imageSearchPackage: "\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E14\u0E49\u0E27\u0E22 AI 1,000 \u0E23\u0E39\u0E1B ({{ subscriptionType }})",
    addon: "Integration ({{ subscriptionType }})",
    changePackageError: "\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07"
  },
  modalRemmoveCreditCard: {
    title: "\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E16\u0E2D\u0E19\u0E01\u0E32\u0E23\u0E1C\u0E39\u0E01\u0E1A\u0E31\u0E15\u0E23 ?",
    confirm: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19",
    cancel: "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01"
  },
  useChangePackageSummary: {
    defaultError: "Please try again"
  },
  packageType: {
    starter_1: "\u0E41\u0E1E\u0E47\u0E04\u0E40\u0E01\u0E08 Starter-S",
    starter_2: "\u0E41\u0E1E\u0E47\u0E04\u0E40\u0E01\u0E08 Starter-M",
    starter_3: "\u0E41\u0E1E\u0E47\u0E04\u0E40\u0E01\u0E08 Starter-L",
    standard: "\u0E41\u0E1E\u0E47\u0E04\u0E40\u0E01\u0E08\u0E40\u0E1A\u0E2A\u0E34\u0E04",
    premium: "\u0E41\u0E1E\u0E47\u0E01\u0E40\u0E01\u0E08\u0E41\u0E2D\u0E14\u0E27\u0E32\u0E19\u0E0B\u0E4C",
    professional: "\u0E41\u0E1E\u0E47\u0E01\u0E40\u0E01\u0E08\u0E2A\u0E41\u0E15\u0E19\u0E14\u0E32\u0E23\u0E4C\u0E14"
  },
  codeItem: {
    code: "\u0E23\u0E2B\u0E31\u0E2A",
    expiredDate: "\u0E27\u0E31\u0E19\u0E2B\u0E21\u0E14\u0E2D\u0E32\u0E22\u0E38",
    remark: "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E2B\u0E15\u0E38 : {{ name }} \u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14\u0E21\u0E35\u0E1C\u0E25\u0E01\u0E31\u0E1A\u0E17\u0E38\u0E01\u0E23\u0E2D\u0E1A\u0E1A\u0E34\u0E25",
    defaultPromotion: "\u0E43\u0E0A\u0E49\u0E1F\u0E23\u0E35 2 \u0E40\u0E14\u0E37\u0E2D\u0E19"
  },
  codeTextField: {
    redeem: "\u0E43\u0E0A\u0E49\u0E42\u0E04\u0E49\u0E14",
    useCode: "\u0E21\u0E35\u0E42\u0E04\u0E49\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48",
    placeholder: "\u0E43\u0E2A\u0E48\u0E42\u0E04\u0E49\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14",
    error: {
      promotionCoditionNotMatch: "Condition not meet(unable to apply)",
      promotionExipred: "Code expired",
      promotionNotActive: "Incorrect code",
      promotionNotFound: "Incorrect code",
      promotionQuotaReached: "Quota reached"
    }
  },
  subscriptionType: {
    annually: "\u0E23\u0E32\u0E22\u0E1B\u0E35",
    monthly: "\u0E23\u0E32\u0E22\u0E40\u0E14\u0E37\u0E2D\u0E19"
  }
};
const th$2 = {
  ai: th$m,
  cardConnect: th$l,
  cashback: th$k,
  category: th$j,
  common: th$i,
  connectPage: th$h,
  createStore: th$g,
  facebookLive: th$f,
  gettingStarted: th$e,
  modalConfirmDisconnection: th$d,
  modalConnect: th$c,
  modalConnectGuideline: th$b,
  modalFacebookRecurringNotification: th$a,
  modalPhoneNumber: th$9,
  notify: en,
  order: th$8,
  payment: th$7,
  plan: th$6,
  product: th$5,
  shipping: th$4,
  planUpgrade: th$3
};
const resources = {
  [Language.TH]: { translation: th$2 },
  [Language.EN]: { translation: en$1 }
};
const languages = [Language.TH, Language.EN];
const getDefaultLanguage = () => {
  const i18nLng = localStorage.getItem("i18nextLng");
  if (i18nLng) {
    return i18nLng;
  }
  localStorage.setItem("i18nextLng", Language.TH);
  return Language.TH;
};
void i18next.use(initReactI18next).init({
  resources,
  fallbackLng: Language.TH,
  interpolation: {
    escapeValue: false
  },
  lng: getDefaultLanguage(),
  nsSeparator: false,
  react: {
    useSuspense: true
  },
  supportedLngs: languages
});
var LoadingPopup;
(function(LoadingPopup2) {
  LoadingPopup2["SET_IS_OPEN_LOADING"] = "setIsOpenLoading";
})(LoadingPopup || (LoadingPopup = {}));
const initialStore = {
  isLoading: false
};
const reducer$1 = (state, action) => {
  var _a2;
  switch (action.type) {
    case LoadingPopup.SET_IS_OPEN_LOADING: {
      return __spreadProps(__spreadValues({}, state), {
        isLoading: (_a2 = action == null ? void 0 : action.payload) == null ? void 0 : _a2.value
      });
    }
    default:
      return state;
  }
};
const useLoading = () => {
  const [store, dispatch] = useReducer(reducer$1, initialStore);
  const setOpenLoadingPopup = (value) => {
    dispatch({
      type: LoadingPopup.SET_IS_OPEN_LOADING,
      payload: { value }
    });
  };
  return { setOpenLoadingPopup, isOpenLoadingModal: store == null ? void 0 : store.isLoading };
};
const UIProvider = ({
  children: children2
}) => {
  const {
    isOpenLoadingModal
  } = useLoading();
  return /* @__PURE__ */ jsxs("div", {
    className: "web-console",
    children: [/* @__PURE__ */ jsx$1(LoadingPopup$1, {
      isOpen: isOpenLoadingModal
    }), children2]
  });
};
function ContextProviders({
  children: children2
}) {
  return /* @__PURE__ */ jsx$1(I18nextProvider, {
    i18n: i18next,
    children: /* @__PURE__ */ jsx$1(ApolloProvider, {
      client: window == null ? void 0 : window.getApolloClient(() => ({})),
      children: /* @__PURE__ */ jsx$1(UIProvider, {
        children: children2
      })
    })
  });
}
const GUIDELINE = gql$1`
  query guideline($projectId: ID!) {
    guideline(projectId: $projectId) {
      hasCategories
      hasProducts
      hasShippingMethod
      hasConnect
      hasFaqs
      hasPaymentMethod
    }
  }
`;
const UPDATE_QUICKSTART = gql$1`
  mutation updateQuickStart($projectId: ID!) {
    updateQuickstart(projectId: $projectId) {
      isRequiredGuidelineCompleted
    }
  }
`;
const QUICKSTART = gql$1`
  query quickstart($projectId: ID!) {
    quickstart(projectId: $projectId) {
      isRequiredGuidelineCompleted
    }
  }
`;
const INITIAL_STEP = "setupProduct";
const stepDefinitions = {
  setupProduct: {
    completed: (guideline) => !!((guideline == null ? void 0 : guideline.hasCategories) && guideline.hasProducts),
    next: "setupShippingMethod",
    required: true
  },
  setupShippingMethod: {
    completed: (guideline) => !!(guideline == null ? void 0 : guideline.hasShippingMethod),
    next: "setupChannelConnection",
    required: true
  },
  setupChannelConnection: {
    completed: (guideline) => !!(guideline == null ? void 0 : guideline.hasConnect),
    next: "setupBot",
    required: true
  },
  setupBot: {
    completed: (guideline) => !!(guideline == null ? void 0 : guideline.hasFaqs),
    required: false
  }
};
const stepDefinitionsWithDeeplePay = {
  setupProduct: {
    completed: (guideline) => !!((guideline == null ? void 0 : guideline.hasCategories) && guideline.hasProducts),
    next: "setupShippingMethod",
    required: true
  },
  setupShippingMethod: {
    completed: (guideline) => !!(guideline == null ? void 0 : guideline.hasShippingMethod),
    next: "setupChannelConnection",
    required: true
  },
  setupChannelConnection: {
    completed: (guideline) => !!(guideline == null ? void 0 : guideline.hasConnect),
    next: "setupDeeplePay",
    required: true
  },
  setupDeeplePay: {
    completed: (guideline) => !!(guideline == null ? void 0 : guideline.hasPaymentMethod),
    next: "setupBot",
    required: false
  },
  setupBot: {
    completed: (guideline) => !!(guideline == null ? void 0 : guideline.hasFaqs),
    required: false
  }
};
const determineStepState = (stepDef, guideline) => {
  const stepState = {};
  Object.entries(stepDef).forEach((step) => {
    const [name, _a2] = step, _b = _a2, { completed } = _b, definitions = __objRest(_b, ["completed"]);
    stepState[name] = __spreadValues({
      completed: completed(guideline)
    }, definitions);
  });
  return stepState;
};
const determineTodoStep = (state, step = INITIAL_STEP) => {
  if (!state[step].completed)
    return step;
  if (!state[step].next)
    return null;
  return determineTodoStep(state, state[step].next);
};
const determineNextStep = (state, step = INITIAL_STEP) => {
  if (!state[step].completed)
    return step;
  return determineTodoStep(state, state[step].next);
};
const useQuickStartBroadcastBar = (projectId, currentPage, isDeeplePayEnabled) => {
  var _a2;
  const STEP_DEFINITIONS = isDeeplePayEnabled ? stepDefinitionsWithDeeplePay : stepDefinitions;
  const {
    data: data2,
    loading,
    refetch: refetchGuideline
  } = useQuery(GUIDELINE, {
    variables: { projectId }
  });
  const { data: quickstart } = useQuery(QUICKSTART, {
    variables: { projectId }
  });
  const [updateQuickStart] = useMutation(UPDATE_QUICKSTART, {
    variables: { projectId }
  });
  const stepState = determineStepState(STEP_DEFINITIONS, data2 == null ? void 0 : data2.guideline);
  const todoStep = determineTodoStep(stepState);
  const isCurrentPageCompleted = (_a2 = stepState[currentPage]) == null ? void 0 : _a2.completed;
  const nextStep = todoStep && determineNextStep(stepState, stepState[todoStep].next);
  const allStepsCount = Object.keys(STEP_DEFINITIONS).length;
  const requiredStepsCount = Object.entries(STEP_DEFINITIONS).filter(([_name, { required }]) => required).length;
  const completedStepsCount = Object.entries(stepState).filter(([_name, { completed }]) => completed).length;
  const completedRequiredStepsCount = Object.entries(stepState).filter(([_name, { completed, required }]) => completed && required).length;
  const isSetupBotCompleted = Object.values(stepState).every((step) => step.completed);
  window.refetchGuideline = refetchGuideline;
  return {
    allStepsCount,
    completedStepsCount,
    completedRequiredStepsCount,
    requiredStepsCount,
    isCurrentPageCompleted,
    isSetupBotCompleted,
    isRequiredGuidelineCompleted: quickstart == null ? void 0 : quickstart.quickstart.isRequiredGuidelineCompleted,
    todoStep,
    nextStep,
    loading,
    refetchGuideline,
    updateQuickStart
  };
};
const PAGE_MAPPINGS = {
  "products-inventory/products": "setupProduct",
  "shipping/shipping-default": "setupShippingMethod",
  "store-settings/connect": "setupChannelConnection",
  "deeple-pay/payment-channel": "setupDeeplePay",
  "payment-method/payment-channel": "setupDeeplePay",
  "ai-settings/specialized-knowledge": "setupBot"
};
const getCurrentPage = (pathname) => {
  for (const path of Object.keys(PAGE_MAPPINGS)) {
    if (pathname.includes(path)) {
      return PAGE_MAPPINGS[path];
    }
  }
  return "any";
};
const QuickStartBroadcastBar = ({
  lang = "th",
  isDeeplePayEnabled = false,
  isNewPaymentEnabled = true
}) => {
  const URL_MAPPING = {
    setupProduct: "products-inventory/products",
    setupShippingMethod: "shipping/shipping-default",
    setupChannelConnection: "store-settings/connect",
    setupDeeplePay: isNewPaymentEnabled ? "payment-method/payment-channel" : "deeple-pay/payment-channel",
    setupBot: "ai-settings/specialized-knowledge"
  };
  const projectId = window.getProjectId();
  const useHistory = window.getParentUseHistory();
  const {
    push,
    location
  } = useHistory();
  const currentPage = getCurrentPage(location.pathname);
  const {
    loading,
    completedStepsCount,
    todoStep,
    isCurrentPageCompleted,
    isSetupBotCompleted,
    isRequiredGuidelineCompleted,
    nextStep,
    allStepsCount,
    requiredStepsCount,
    completedRequiredStepsCount,
    refetchGuideline,
    updateQuickStart
  } = useQuickStartBroadcastBar(projectId, currentPage, isDeeplePayEnabled);
  const [isOpen, setIsOpen] = useState(false);
  const [isBroadcastBarOpen, setIsBroadcastBarOpen] = useState(true);
  const actualNextStep = (currentPage !== todoStep ? todoStep : nextStep) || "";
  const isRequiredStepsCompleted = requiredStepsCount === completedRequiredStepsCount;
  const onAllSettingsClick = () => {
    push(`/project/${projectId}/quick-start`);
  };
  const onActionClick = () => {
    push(`/project/${projectId}/${URL_MAPPING[actualNextStep]}`);
    void refetchGuideline();
  };
  const hideBroadcastBar = () => {
    setIsBroadcastBarOpen(false);
  };
  const onDone = () => {
    setIsOpen(false);
    void updateQuickStart();
  };
  const onClose = () => {
    void updateQuickStart();
  };
  const handleClickNextLinkOnSuccessQuickStartModal = () => {
    setIsOpen(false);
    void updateQuickStart();
    const path = isDeeplePayEnabled ? `/project/${projectId}/${URL_MAPPING.setupDeeplePay}` : `/project/${projectId}/${URL_MAPPING.setupBot}`;
    push(path);
  };
  useEffect(() => {
    if (isRequiredStepsCompleted) {
      setIsOpen(isRequiredStepsCompleted);
    }
  }, [isRequiredStepsCompleted]);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [isBroadcastBarOpen && /* @__PURE__ */ jsx$1("div", {
      className: "tw-p-4",
      children: /* @__PURE__ */ jsx$1(QuickStartBroadcastBar$1, {
        onAllSettingsClick,
        onActionClick,
        onDone: hideBroadcastBar,
        steps: allStepsCount,
        completed: completedStepsCount,
        currentPage,
        isCurrentPageCompleted,
        nextStep: actualNextStep,
        isRequiredStepsCompleted,
        lang
      })
    }), /* @__PURE__ */ jsx$1(YourStoreIsCreatedModal, {
      isOpen: isRequiredGuidelineCompleted === false && isOpen,
      isSetupBotCompleted,
      onDone,
      onClickNextStep: handleClickNextLinkOnSuccessQuickStartModal,
      onClose
    })]
  });
};
const QuickStartBroadcastBarWithContext = (props) => {
  return /* @__PURE__ */ jsx$1(ContextProviders, {
    children: /* @__PURE__ */ jsx$1(QuickStartBroadcastBar, __spreadValues({}, props))
  });
};
var lodash = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(module, exports) {
  (function() {
    var undefined$1;
    var VERSION2 = "4.17.21";
    var LARGE_ARRAY_SIZE2 = 200;
    var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT2 = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
    var MAX_MEMOIZE_SIZE2 = 500;
    var PLACEHOLDER = "__lodash_placeholder__";
    var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    var COMPARE_PARTIAL_FLAG2 = 1, COMPARE_UNORDERED_FLAG2 = 2;
    var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    var HOT_COUNT2 = 800, HOT_SPAN2 = 16;
    var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    var INFINITY2 = 1 / 0, MAX_SAFE_INTEGER2 = 9007199254740991, MAX_INTEGER2 = 17976931348623157e292, NAN2 = 0 / 0;
    var MAX_ARRAY_LENGTH2 = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH2 - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH2 >>> 1;
    var wrapFlags = [
      ["ary", WRAP_ARY_FLAG],
      ["bind", WRAP_BIND_FLAG],
      ["bindKey", WRAP_BIND_KEY_FLAG],
      ["curry", WRAP_CURRY_FLAG],
      ["curryRight", WRAP_CURRY_RIGHT_FLAG],
      ["flip", WRAP_FLIP_FLAG],
      ["partial", WRAP_PARTIAL_FLAG],
      ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
      ["rearg", WRAP_REARG_FLAG]
    ];
    var argsTag2 = "[object Arguments]", arrayTag2 = "[object Array]", asyncTag2 = "[object AsyncFunction]", boolTag2 = "[object Boolean]", dateTag2 = "[object Date]", domExcTag = "[object DOMException]", errorTag2 = "[object Error]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]", mapTag2 = "[object Map]", numberTag2 = "[object Number]", nullTag2 = "[object Null]", objectTag2 = "[object Object]", promiseTag2 = "[object Promise]", proxyTag2 = "[object Proxy]", regexpTag2 = "[object RegExp]", setTag2 = "[object Set]", stringTag2 = "[object String]", symbolTag2 = "[object Symbol]", undefinedTag2 = "[object Undefined]", weakMapTag2 = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag2 = "[object ArrayBuffer]", dataViewTag2 = "[object DataView]", float32Tag2 = "[object Float32Array]", float64Tag2 = "[object Float64Array]", int8Tag2 = "[object Int8Array]", int16Tag2 = "[object Int16Array]", int32Tag2 = "[object Int32Array]", uint8Tag2 = "[object Uint8Array]", uint8ClampedTag2 = "[object Uint8ClampedArray]", uint16Tag2 = "[object Uint16Array]", uint32Tag2 = "[object Uint32Array]";
    var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    var reIsDeepProp2 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp2 = /^\w*$/, rePropName2 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar2.source);
    var reTrimStart2 = /^\s+/;
    var reWhitespace2 = /\s/;
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    var reAsciiWord2 = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    var reEscapeChar2 = /\\(\\)?/g;
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    var reFlags = /\w*$/;
    var reIsBadHex2 = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary2 = /^0b[01]+$/i;
    var reIsHostCtor2 = /^\[object .+?Constructor\]$/;
    var reIsOctal2 = /^0o[0-7]+$/i;
    var reIsUint2 = /^(?:0|[1-9]\d*)$/;
    var reLatin2 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var reNoMatch = /($^)/;
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    var rsAstralRange2 = "\\ud800-\\udfff", rsComboMarksRange2 = "\\u0300-\\u036f", reComboHalfMarksRange2 = "\\ufe20-\\ufe2f", rsComboSymbolsRange2 = "\\u20d0-\\u20ff", rsComboRange2 = rsComboMarksRange2 + reComboHalfMarksRange2 + rsComboSymbolsRange2, rsDingbatRange2 = "\\u2700-\\u27bf", rsLowerRange2 = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange2 = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange2 = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange2 = "\\u2000-\\u206f", rsSpaceRange2 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange2 = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange2 = "\\ufe0e\\ufe0f", rsBreakRange2 = rsMathOpRange2 + rsNonCharRange2 + rsPunctuationRange2 + rsSpaceRange2;
    var rsApos2 = "['\u2019]", rsAstral2 = "[" + rsAstralRange2 + "]", rsBreak2 = "[" + rsBreakRange2 + "]", rsCombo2 = "[" + rsComboRange2 + "]", rsDigits2 = "\\d+", rsDingbat2 = "[" + rsDingbatRange2 + "]", rsLower2 = "[" + rsLowerRange2 + "]", rsMisc2 = "[^" + rsAstralRange2 + rsBreakRange2 + rsDigits2 + rsDingbatRange2 + rsLowerRange2 + rsUpperRange2 + "]", rsFitz2 = "\\ud83c[\\udffb-\\udfff]", rsModifier2 = "(?:" + rsCombo2 + "|" + rsFitz2 + ")", rsNonAstral2 = "[^" + rsAstralRange2 + "]", rsRegional2 = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair2 = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper2 = "[" + rsUpperRange2 + "]", rsZWJ2 = "\\u200d";
    var rsMiscLower2 = "(?:" + rsLower2 + "|" + rsMisc2 + ")", rsMiscUpper2 = "(?:" + rsUpper2 + "|" + rsMisc2 + ")", rsOptContrLower2 = "(?:" + rsApos2 + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper2 = "(?:" + rsApos2 + "(?:D|LL|M|RE|S|T|VE))?", reOptMod2 = rsModifier2 + "?", rsOptVar2 = "[" + rsVarRange2 + "]?", rsOptJoin2 = "(?:" + rsZWJ2 + "(?:" + [rsNonAstral2, rsRegional2, rsSurrPair2].join("|") + ")" + rsOptVar2 + reOptMod2 + ")*", rsOrdLower2 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper2 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq2 = rsOptVar2 + reOptMod2 + rsOptJoin2, rsEmoji2 = "(?:" + [rsDingbat2, rsRegional2, rsSurrPair2].join("|") + ")" + rsSeq2, rsSymbol2 = "(?:" + [rsNonAstral2 + rsCombo2 + "?", rsCombo2, rsRegional2, rsSurrPair2, rsAstral2].join("|") + ")";
    var reApos2 = RegExp(rsApos2, "g");
    var reComboMark2 = RegExp(rsCombo2, "g");
    var reUnicode2 = RegExp(rsFitz2 + "(?=" + rsFitz2 + ")|" + rsSymbol2 + rsSeq2, "g");
    var reUnicodeWord2 = RegExp([
      rsUpper2 + "?" + rsLower2 + "+" + rsOptContrLower2 + "(?=" + [rsBreak2, rsUpper2, "$"].join("|") + ")",
      rsMiscUpper2 + "+" + rsOptContrUpper2 + "(?=" + [rsBreak2, rsUpper2 + rsMiscLower2, "$"].join("|") + ")",
      rsUpper2 + "?" + rsMiscLower2 + "+" + rsOptContrLower2,
      rsUpper2 + "+" + rsOptContrUpper2,
      rsOrdUpper2,
      rsOrdLower2,
      rsDigits2,
      rsEmoji2
    ].join("|"), "g");
    var reHasUnicode2 = RegExp("[" + rsZWJ2 + rsAstralRange2 + rsComboRange2 + rsVarRange2 + "]");
    var reHasUnicodeWord2 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    var contextProps = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ];
    var templateCounter = -1;
    var typedArrayTags2 = {};
    typedArrayTags2[float32Tag2] = typedArrayTags2[float64Tag2] = typedArrayTags2[int8Tag2] = typedArrayTags2[int16Tag2] = typedArrayTags2[int32Tag2] = typedArrayTags2[uint8Tag2] = typedArrayTags2[uint8ClampedTag2] = typedArrayTags2[uint16Tag2] = typedArrayTags2[uint32Tag2] = true;
    typedArrayTags2[argsTag2] = typedArrayTags2[arrayTag2] = typedArrayTags2[arrayBufferTag2] = typedArrayTags2[boolTag2] = typedArrayTags2[dataViewTag2] = typedArrayTags2[dateTag2] = typedArrayTags2[errorTag2] = typedArrayTags2[funcTag2] = typedArrayTags2[mapTag2] = typedArrayTags2[numberTag2] = typedArrayTags2[objectTag2] = typedArrayTags2[regexpTag2] = typedArrayTags2[setTag2] = typedArrayTags2[stringTag2] = typedArrayTags2[weakMapTag2] = false;
    var cloneableTags = {};
    cloneableTags[argsTag2] = cloneableTags[arrayTag2] = cloneableTags[arrayBufferTag2] = cloneableTags[dataViewTag2] = cloneableTags[boolTag2] = cloneableTags[dateTag2] = cloneableTags[float32Tag2] = cloneableTags[float64Tag2] = cloneableTags[int8Tag2] = cloneableTags[int16Tag2] = cloneableTags[int32Tag2] = cloneableTags[mapTag2] = cloneableTags[numberTag2] = cloneableTags[objectTag2] = cloneableTags[regexpTag2] = cloneableTags[setTag2] = cloneableTags[stringTag2] = cloneableTags[symbolTag2] = cloneableTags[uint8Tag2] = cloneableTags[uint8ClampedTag2] = cloneableTags[uint16Tag2] = cloneableTags[uint32Tag2] = true;
    cloneableTags[errorTag2] = cloneableTags[funcTag2] = cloneableTags[weakMapTag2] = false;
    var deburredLetters2 = {
      "\xC0": "A",
      "\xC1": "A",
      "\xC2": "A",
      "\xC3": "A",
      "\xC4": "A",
      "\xC5": "A",
      "\xE0": "a",
      "\xE1": "a",
      "\xE2": "a",
      "\xE3": "a",
      "\xE4": "a",
      "\xE5": "a",
      "\xC7": "C",
      "\xE7": "c",
      "\xD0": "D",
      "\xF0": "d",
      "\xC8": "E",
      "\xC9": "E",
      "\xCA": "E",
      "\xCB": "E",
      "\xE8": "e",
      "\xE9": "e",
      "\xEA": "e",
      "\xEB": "e",
      "\xCC": "I",
      "\xCD": "I",
      "\xCE": "I",
      "\xCF": "I",
      "\xEC": "i",
      "\xED": "i",
      "\xEE": "i",
      "\xEF": "i",
      "\xD1": "N",
      "\xF1": "n",
      "\xD2": "O",
      "\xD3": "O",
      "\xD4": "O",
      "\xD5": "O",
      "\xD6": "O",
      "\xD8": "O",
      "\xF2": "o",
      "\xF3": "o",
      "\xF4": "o",
      "\xF5": "o",
      "\xF6": "o",
      "\xF8": "o",
      "\xD9": "U",
      "\xDA": "U",
      "\xDB": "U",
      "\xDC": "U",
      "\xF9": "u",
      "\xFA": "u",
      "\xFB": "u",
      "\xFC": "u",
      "\xDD": "Y",
      "\xFD": "y",
      "\xFF": "y",
      "\xC6": "Ae",
      "\xE6": "ae",
      "\xDE": "Th",
      "\xFE": "th",
      "\xDF": "ss",
      "\u0100": "A",
      "\u0102": "A",
      "\u0104": "A",
      "\u0101": "a",
      "\u0103": "a",
      "\u0105": "a",
      "\u0106": "C",
      "\u0108": "C",
      "\u010A": "C",
      "\u010C": "C",
      "\u0107": "c",
      "\u0109": "c",
      "\u010B": "c",
      "\u010D": "c",
      "\u010E": "D",
      "\u0110": "D",
      "\u010F": "d",
      "\u0111": "d",
      "\u0112": "E",
      "\u0114": "E",
      "\u0116": "E",
      "\u0118": "E",
      "\u011A": "E",
      "\u0113": "e",
      "\u0115": "e",
      "\u0117": "e",
      "\u0119": "e",
      "\u011B": "e",
      "\u011C": "G",
      "\u011E": "G",
      "\u0120": "G",
      "\u0122": "G",
      "\u011D": "g",
      "\u011F": "g",
      "\u0121": "g",
      "\u0123": "g",
      "\u0124": "H",
      "\u0126": "H",
      "\u0125": "h",
      "\u0127": "h",
      "\u0128": "I",
      "\u012A": "I",
      "\u012C": "I",
      "\u012E": "I",
      "\u0130": "I",
      "\u0129": "i",
      "\u012B": "i",
      "\u012D": "i",
      "\u012F": "i",
      "\u0131": "i",
      "\u0134": "J",
      "\u0135": "j",
      "\u0136": "K",
      "\u0137": "k",
      "\u0138": "k",
      "\u0139": "L",
      "\u013B": "L",
      "\u013D": "L",
      "\u013F": "L",
      "\u0141": "L",
      "\u013A": "l",
      "\u013C": "l",
      "\u013E": "l",
      "\u0140": "l",
      "\u0142": "l",
      "\u0143": "N",
      "\u0145": "N",
      "\u0147": "N",
      "\u014A": "N",
      "\u0144": "n",
      "\u0146": "n",
      "\u0148": "n",
      "\u014B": "n",
      "\u014C": "O",
      "\u014E": "O",
      "\u0150": "O",
      "\u014D": "o",
      "\u014F": "o",
      "\u0151": "o",
      "\u0154": "R",
      "\u0156": "R",
      "\u0158": "R",
      "\u0155": "r",
      "\u0157": "r",
      "\u0159": "r",
      "\u015A": "S",
      "\u015C": "S",
      "\u015E": "S",
      "\u0160": "S",
      "\u015B": "s",
      "\u015D": "s",
      "\u015F": "s",
      "\u0161": "s",
      "\u0162": "T",
      "\u0164": "T",
      "\u0166": "T",
      "\u0163": "t",
      "\u0165": "t",
      "\u0167": "t",
      "\u0168": "U",
      "\u016A": "U",
      "\u016C": "U",
      "\u016E": "U",
      "\u0170": "U",
      "\u0172": "U",
      "\u0169": "u",
      "\u016B": "u",
      "\u016D": "u",
      "\u016F": "u",
      "\u0171": "u",
      "\u0173": "u",
      "\u0174": "W",
      "\u0175": "w",
      "\u0176": "Y",
      "\u0177": "y",
      "\u0178": "Y",
      "\u0179": "Z",
      "\u017B": "Z",
      "\u017D": "Z",
      "\u017A": "z",
      "\u017C": "z",
      "\u017E": "z",
      "\u0132": "IJ",
      "\u0133": "ij",
      "\u0152": "Oe",
      "\u0153": "oe",
      "\u0149": "'n",
      "\u017F": "s"
    };
    var htmlEscapes = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    };
    var htmlUnescapes = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    };
    var stringEscapes = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    };
    var freeParseFloat = parseFloat, freeParseInt2 = parseInt;
    var freeGlobal2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
    var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
    var freeExports = exports && !exports.nodeType && exports;
    var freeModule = freeExports && true && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal2.process;
    var nodeUtil2 = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e2) {
      }
    }();
    var nodeIsArrayBuffer = nodeUtil2 && nodeUtil2.isArrayBuffer, nodeIsDate = nodeUtil2 && nodeUtil2.isDate, nodeIsMap = nodeUtil2 && nodeUtil2.isMap, nodeIsRegExp = nodeUtil2 && nodeUtil2.isRegExp, nodeIsSet = nodeUtil2 && nodeUtil2.isSet, nodeIsTypedArray2 = nodeUtil2 && nodeUtil2.isTypedArray;
    function apply2(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    function arrayAggregator2(array2, setter, iteratee, accumulator) {
      var index2 = -1, length2 = array2 == null ? 0 : array2.length;
      while (++index2 < length2) {
        var value = array2[index2];
        setter(accumulator, value, iteratee(value), array2);
      }
      return accumulator;
    }
    function arrayEach(array2, iteratee) {
      var index2 = -1, length2 = array2 == null ? 0 : array2.length;
      while (++index2 < length2) {
        if (iteratee(array2[index2], index2, array2) === false) {
          break;
        }
      }
      return array2;
    }
    function arrayEachRight(array2, iteratee) {
      var length2 = array2 == null ? 0 : array2.length;
      while (length2--) {
        if (iteratee(array2[length2], length2, array2) === false) {
          break;
        }
      }
      return array2;
    }
    function arrayEvery(array2, predicate) {
      var index2 = -1, length2 = array2 == null ? 0 : array2.length;
      while (++index2 < length2) {
        if (!predicate(array2[index2], index2, array2)) {
          return false;
        }
      }
      return true;
    }
    function arrayFilter2(array2, predicate) {
      var index2 = -1, length2 = array2 == null ? 0 : array2.length, resIndex = 0, result = [];
      while (++index2 < length2) {
        var value = array2[index2];
        if (predicate(value, index2, array2)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    function arrayIncludes2(array2, value) {
      var length2 = array2 == null ? 0 : array2.length;
      return !!length2 && baseIndexOf2(array2, value, 0) > -1;
    }
    function arrayIncludesWith2(array2, value, comparator) {
      var index2 = -1, length2 = array2 == null ? 0 : array2.length;
      while (++index2 < length2) {
        if (comparator(value, array2[index2])) {
          return true;
        }
      }
      return false;
    }
    function arrayMap2(array2, iteratee) {
      var index2 = -1, length2 = array2 == null ? 0 : array2.length, result = Array(length2);
      while (++index2 < length2) {
        result[index2] = iteratee(array2[index2], index2, array2);
      }
      return result;
    }
    function arrayPush2(array2, values) {
      var index2 = -1, length2 = values.length, offset2 = array2.length;
      while (++index2 < length2) {
        array2[offset2 + index2] = values[index2];
      }
      return array2;
    }
    function arrayReduce2(array2, iteratee, accumulator, initAccum) {
      var index2 = -1, length2 = array2 == null ? 0 : array2.length;
      if (initAccum && length2) {
        accumulator = array2[++index2];
      }
      while (++index2 < length2) {
        accumulator = iteratee(accumulator, array2[index2], index2, array2);
      }
      return accumulator;
    }
    function arrayReduceRight(array2, iteratee, accumulator, initAccum) {
      var length2 = array2 == null ? 0 : array2.length;
      if (initAccum && length2) {
        accumulator = array2[--length2];
      }
      while (length2--) {
        accumulator = iteratee(accumulator, array2[length2], length2, array2);
      }
      return accumulator;
    }
    function arraySome2(array2, predicate) {
      var index2 = -1, length2 = array2 == null ? 0 : array2.length;
      while (++index2 < length2) {
        if (predicate(array2[index2], index2, array2)) {
          return true;
        }
      }
      return false;
    }
    var asciiSize = baseProperty2("length");
    function asciiToArray2(string2) {
      return string2.split("");
    }
    function asciiWords2(string2) {
      return string2.match(reAsciiWord2) || [];
    }
    function baseFindKey(collection, predicate, eachFunc) {
      var result;
      eachFunc(collection, function(value, key, collection2) {
        if (predicate(value, key, collection2)) {
          result = key;
          return false;
        }
      });
      return result;
    }
    function baseFindIndex2(array2, predicate, fromIndex, fromRight) {
      var length2 = array2.length, index2 = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index2-- : ++index2 < length2) {
        if (predicate(array2[index2], index2, array2)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIndexOf2(array2, value, fromIndex) {
      return value === value ? strictIndexOf2(array2, value, fromIndex) : baseFindIndex2(array2, baseIsNaN2, fromIndex);
    }
    function baseIndexOfWith(array2, value, fromIndex, comparator) {
      var index2 = fromIndex - 1, length2 = array2.length;
      while (++index2 < length2) {
        if (comparator(array2[index2], value)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIsNaN2(value) {
      return value !== value;
    }
    function baseMean(array2, iteratee) {
      var length2 = array2 == null ? 0 : array2.length;
      return length2 ? baseSum(array2, iteratee) / length2 : NAN2;
    }
    function baseProperty2(key) {
      return function(object2) {
        return object2 == null ? undefined$1 : object2[key];
      };
    }
    function basePropertyOf2(object2) {
      return function(key) {
        return object2 == null ? undefined$1 : object2[key];
      };
    }
    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
      eachFunc(collection, function(value, index2, collection2) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index2, collection2);
      });
      return accumulator;
    }
    function baseSortBy2(array2, comparer) {
      var length2 = array2.length;
      array2.sort(comparer);
      while (length2--) {
        array2[length2] = array2[length2].value;
      }
      return array2;
    }
    function baseSum(array2, iteratee) {
      var result, index2 = -1, length2 = array2.length;
      while (++index2 < length2) {
        var current = iteratee(array2[index2]);
        if (current !== undefined$1) {
          result = result === undefined$1 ? current : result + current;
        }
      }
      return result;
    }
    function baseTimes2(n2, iteratee) {
      var index2 = -1, result = Array(n2);
      while (++index2 < n2) {
        result[index2] = iteratee(index2);
      }
      return result;
    }
    function baseToPairs(object2, props) {
      return arrayMap2(props, function(key) {
        return [key, object2[key]];
      });
    }
    function baseTrim2(string2) {
      return string2 ? string2.slice(0, trimmedEndIndex2(string2) + 1).replace(reTrimStart2, "") : string2;
    }
    function baseUnary2(func) {
      return function(value) {
        return func(value);
      };
    }
    function baseValues(object2, props) {
      return arrayMap2(props, function(key) {
        return object2[key];
      });
    }
    function cacheHas2(cache2, key) {
      return cache2.has(key);
    }
    function charsStartIndex(strSymbols, chrSymbols) {
      var index2 = -1, length2 = strSymbols.length;
      while (++index2 < length2 && baseIndexOf2(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function charsEndIndex(strSymbols, chrSymbols) {
      var index2 = strSymbols.length;
      while (index2-- && baseIndexOf2(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function countHolders(array2, placeholder) {
      var length2 = array2.length, result = 0;
      while (length2--) {
        if (array2[length2] === placeholder) {
          ++result;
        }
      }
      return result;
    }
    var deburrLetter2 = basePropertyOf2(deburredLetters2);
    var escapeHtmlChar = basePropertyOf2(htmlEscapes);
    function escapeStringChar(chr) {
      return "\\" + stringEscapes[chr];
    }
    function getValue2(object2, key) {
      return object2 == null ? undefined$1 : object2[key];
    }
    function hasUnicode2(string2) {
      return reHasUnicode2.test(string2);
    }
    function hasUnicodeWord2(string2) {
      return reHasUnicodeWord2.test(string2);
    }
    function iteratorToArray(iterator) {
      var data2, result = [];
      while (!(data2 = iterator.next()).done) {
        result.push(data2.value);
      }
      return result;
    }
    function mapToArray2(map2) {
      var index2 = -1, result = Array(map2.size);
      map2.forEach(function(value, key) {
        result[++index2] = [key, value];
      });
      return result;
    }
    function overArg2(func, transform2) {
      return function(arg) {
        return func(transform2(arg));
      };
    }
    function replaceHolders(array2, placeholder) {
      var index2 = -1, length2 = array2.length, resIndex = 0, result = [];
      while (++index2 < length2) {
        var value = array2[index2];
        if (value === placeholder || value === PLACEHOLDER) {
          array2[index2] = PLACEHOLDER;
          result[resIndex++] = index2;
        }
      }
      return result;
    }
    function setToArray2(set2) {
      var index2 = -1, result = Array(set2.size);
      set2.forEach(function(value) {
        result[++index2] = value;
      });
      return result;
    }
    function setToPairs(set2) {
      var index2 = -1, result = Array(set2.size);
      set2.forEach(function(value) {
        result[++index2] = [value, value];
      });
      return result;
    }
    function strictIndexOf2(array2, value, fromIndex) {
      var index2 = fromIndex - 1, length2 = array2.length;
      while (++index2 < length2) {
        if (array2[index2] === value) {
          return index2;
        }
      }
      return -1;
    }
    function strictLastIndexOf(array2, value, fromIndex) {
      var index2 = fromIndex + 1;
      while (index2--) {
        if (array2[index2] === value) {
          return index2;
        }
      }
      return index2;
    }
    function stringSize(string2) {
      return hasUnicode2(string2) ? unicodeSize(string2) : asciiSize(string2);
    }
    function stringToArray2(string2) {
      return hasUnicode2(string2) ? unicodeToArray2(string2) : asciiToArray2(string2);
    }
    function trimmedEndIndex2(string2) {
      var index2 = string2.length;
      while (index2-- && reWhitespace2.test(string2.charAt(index2))) {
      }
      return index2;
    }
    var unescapeHtmlChar = basePropertyOf2(htmlUnescapes);
    function unicodeSize(string2) {
      var result = reUnicode2.lastIndex = 0;
      while (reUnicode2.test(string2)) {
        ++result;
      }
      return result;
    }
    function unicodeToArray2(string2) {
      return string2.match(reUnicode2) || [];
    }
    function unicodeWords2(string2) {
      return string2.match(reUnicodeWord2) || [];
    }
    var runInContext = function runInContext2(context) {
      context = context == null ? root2 : _23.defaults(root2.Object(), context, _23.pick(root2, contextProps));
      var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
      var arrayProto2 = Array2.prototype, funcProto2 = Function2.prototype, objectProto2 = Object2.prototype;
      var coreJsData2 = context["__core-js_shared__"];
      var funcToString2 = funcProto2.toString;
      var hasOwnProperty2 = objectProto2.hasOwnProperty;
      var idCounter = 0;
      var maskSrcKey2 = function() {
        var uid = /[^.]+$/.exec(coreJsData2 && coreJsData2.keys && coreJsData2.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
      }();
      var nativeObjectToString2 = objectProto2.toString;
      var objectCtorString = funcToString2.call(Object2);
      var oldDash = root2._;
      var reIsNative2 = RegExp2("^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
      var Buffer2 = moduleExports ? context.Buffer : undefined$1, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined$1, getPrototype = overArg2(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable2 = objectProto2.propertyIsEnumerable, splice2 = arrayProto2.splice, spreadableSymbol2 = Symbol2 ? Symbol2.isConcatSpreadable : undefined$1, symIterator = Symbol2 ? Symbol2.iterator : undefined$1, symToStringTag2 = Symbol2 ? Symbol2.toStringTag : undefined$1;
      var defineProperty2 = function() {
        try {
          var func = getNative2(Object2, "defineProperty");
          func({}, "", {});
          return func;
        } catch (e2) {
        }
      }();
      var ctxClearTimeout = context.clearTimeout !== root2.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root2.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root2.setTimeout && context.setTimeout;
      var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols2 = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined$1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto2.join, nativeKeys2 = overArg2(Object2.keys, Object2), nativeMax2 = Math2.max, nativeMin = Math2.min, nativeNow2 = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto2.reverse;
      var DataView2 = getNative2(context, "DataView"), Map2 = getNative2(context, "Map"), Promise2 = getNative2(context, "Promise"), Set2 = getNative2(context, "Set"), WeakMap2 = getNative2(context, "WeakMap"), nativeCreate2 = getNative2(Object2, "create");
      var metaMap = WeakMap2 && new WeakMap2();
      var realNames = {};
      var dataViewCtorString2 = toSource2(DataView2), mapCtorString2 = toSource2(Map2), promiseCtorString2 = toSource2(Promise2), setCtorString2 = toSource2(Set2), weakMapCtorString2 = toSource2(WeakMap2);
      var symbolProto2 = Symbol2 ? Symbol2.prototype : undefined$1, symbolValueOf2 = symbolProto2 ? symbolProto2.valueOf : undefined$1, symbolToString2 = symbolProto2 ? symbolProto2.toString : undefined$1;
      function lodash2(value) {
        if (isObjectLike2(value) && !isArray2(value) && !(value instanceof LazyWrapper)) {
          if (value instanceof LodashWrapper) {
            return value;
          }
          if (hasOwnProperty2.call(value, "__wrapped__")) {
            return wrapperClone(value);
          }
        }
        return new LodashWrapper(value);
      }
      var baseCreate = function() {
        function object2() {
        }
        return function(proto) {
          if (!isObject2(proto)) {
            return {};
          }
          if (objectCreate) {
            return objectCreate(proto);
          }
          object2.prototype = proto;
          var result2 = new object2();
          object2.prototype = undefined$1;
          return result2;
        };
      }();
      function baseLodash() {
      }
      function LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$1;
      }
      lodash2.templateSettings = {
        "escape": reEscape,
        "evaluate": reEvaluate,
        "interpolate": reInterpolate,
        "variable": "",
        "imports": {
          "_": lodash2
        }
      };
      lodash2.prototype = baseLodash.prototype;
      lodash2.prototype.constructor = lodash2;
      LodashWrapper.prototype = baseCreate(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;
      function LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH2;
        this.__views__ = [];
      }
      function lazyClone() {
        var result2 = new LazyWrapper(this.__wrapped__);
        result2.__actions__ = copyArray(this.__actions__);
        result2.__dir__ = this.__dir__;
        result2.__filtered__ = this.__filtered__;
        result2.__iteratees__ = copyArray(this.__iteratees__);
        result2.__takeCount__ = this.__takeCount__;
        result2.__views__ = copyArray(this.__views__);
        return result2;
      }
      function lazyReverse() {
        if (this.__filtered__) {
          var result2 = new LazyWrapper(this);
          result2.__dir__ = -1;
          result2.__filtered__ = true;
        } else {
          result2 = this.clone();
          result2.__dir__ *= -1;
        }
        return result2;
      }
      function lazyValue() {
        var array2 = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray2(array2), isRight = dir < 0, arrLength = isArr ? array2.length : 0, view = getView(0, arrLength, this.__views__), start2 = view.start, end2 = view.end, length2 = end2 - start2, index2 = isRight ? end2 : start2 - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length2, this.__takeCount__);
        if (!isArr || !isRight && arrLength == length2 && takeCount == length2) {
          return baseWrapperValue(array2, this.__actions__);
        }
        var result2 = [];
        outer:
          while (length2-- && resIndex < takeCount) {
            index2 += dir;
            var iterIndex = -1, value = array2[index2];
            while (++iterIndex < iterLength) {
              var data2 = iteratees[iterIndex], iteratee2 = data2.iteratee, type = data2.type, computed = iteratee2(value);
              if (type == LAZY_MAP_FLAG) {
                value = computed;
              } else if (!computed) {
                if (type == LAZY_FILTER_FLAG) {
                  continue outer;
                } else {
                  break outer;
                }
              }
            }
            result2[resIndex++] = value;
          }
        return result2;
      }
      LazyWrapper.prototype = baseCreate(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;
      function Hash2(entries) {
        var index2 = -1, length2 = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length2) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function hashClear2() {
        this.__data__ = nativeCreate2 ? nativeCreate2(null) : {};
        this.size = 0;
      }
      function hashDelete2(key) {
        var result2 = this.has(key) && delete this.__data__[key];
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function hashGet2(key) {
        var data2 = this.__data__;
        if (nativeCreate2) {
          var result2 = data2[key];
          return result2 === HASH_UNDEFINED2 ? undefined$1 : result2;
        }
        return hasOwnProperty2.call(data2, key) ? data2[key] : undefined$1;
      }
      function hashHas2(key) {
        var data2 = this.__data__;
        return nativeCreate2 ? data2[key] !== undefined$1 : hasOwnProperty2.call(data2, key);
      }
      function hashSet2(key, value) {
        var data2 = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data2[key] = nativeCreate2 && value === undefined$1 ? HASH_UNDEFINED2 : value;
        return this;
      }
      Hash2.prototype.clear = hashClear2;
      Hash2.prototype["delete"] = hashDelete2;
      Hash2.prototype.get = hashGet2;
      Hash2.prototype.has = hashHas2;
      Hash2.prototype.set = hashSet2;
      function ListCache2(entries) {
        var index2 = -1, length2 = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length2) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function listCacheClear2() {
        this.__data__ = [];
        this.size = 0;
      }
      function listCacheDelete2(key) {
        var data2 = this.__data__, index2 = assocIndexOf2(data2, key);
        if (index2 < 0) {
          return false;
        }
        var lastIndex = data2.length - 1;
        if (index2 == lastIndex) {
          data2.pop();
        } else {
          splice2.call(data2, index2, 1);
        }
        --this.size;
        return true;
      }
      function listCacheGet2(key) {
        var data2 = this.__data__, index2 = assocIndexOf2(data2, key);
        return index2 < 0 ? undefined$1 : data2[index2][1];
      }
      function listCacheHas2(key) {
        return assocIndexOf2(this.__data__, key) > -1;
      }
      function listCacheSet2(key, value) {
        var data2 = this.__data__, index2 = assocIndexOf2(data2, key);
        if (index2 < 0) {
          ++this.size;
          data2.push([key, value]);
        } else {
          data2[index2][1] = value;
        }
        return this;
      }
      ListCache2.prototype.clear = listCacheClear2;
      ListCache2.prototype["delete"] = listCacheDelete2;
      ListCache2.prototype.get = listCacheGet2;
      ListCache2.prototype.has = listCacheHas2;
      ListCache2.prototype.set = listCacheSet2;
      function MapCache2(entries) {
        var index2 = -1, length2 = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length2) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function mapCacheClear2() {
        this.size = 0;
        this.__data__ = {
          "hash": new Hash2(),
          "map": new (Map2 || ListCache2)(),
          "string": new Hash2()
        };
      }
      function mapCacheDelete2(key) {
        var result2 = getMapData2(this, key)["delete"](key);
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function mapCacheGet2(key) {
        return getMapData2(this, key).get(key);
      }
      function mapCacheHas2(key) {
        return getMapData2(this, key).has(key);
      }
      function mapCacheSet2(key, value) {
        var data2 = getMapData2(this, key), size2 = data2.size;
        data2.set(key, value);
        this.size += data2.size == size2 ? 0 : 1;
        return this;
      }
      MapCache2.prototype.clear = mapCacheClear2;
      MapCache2.prototype["delete"] = mapCacheDelete2;
      MapCache2.prototype.get = mapCacheGet2;
      MapCache2.prototype.has = mapCacheHas2;
      MapCache2.prototype.set = mapCacheSet2;
      function SetCache2(values2) {
        var index2 = -1, length2 = values2 == null ? 0 : values2.length;
        this.__data__ = new MapCache2();
        while (++index2 < length2) {
          this.add(values2[index2]);
        }
      }
      function setCacheAdd2(value) {
        this.__data__.set(value, HASH_UNDEFINED2);
        return this;
      }
      function setCacheHas2(value) {
        return this.__data__.has(value);
      }
      SetCache2.prototype.add = SetCache2.prototype.push = setCacheAdd2;
      SetCache2.prototype.has = setCacheHas2;
      function Stack2(entries) {
        var data2 = this.__data__ = new ListCache2(entries);
        this.size = data2.size;
      }
      function stackClear2() {
        this.__data__ = new ListCache2();
        this.size = 0;
      }
      function stackDelete2(key) {
        var data2 = this.__data__, result2 = data2["delete"](key);
        this.size = data2.size;
        return result2;
      }
      function stackGet2(key) {
        return this.__data__.get(key);
      }
      function stackHas2(key) {
        return this.__data__.has(key);
      }
      function stackSet2(key, value) {
        var data2 = this.__data__;
        if (data2 instanceof ListCache2) {
          var pairs = data2.__data__;
          if (!Map2 || pairs.length < LARGE_ARRAY_SIZE2 - 1) {
            pairs.push([key, value]);
            this.size = ++data2.size;
            return this;
          }
          data2 = this.__data__ = new MapCache2(pairs);
        }
        data2.set(key, value);
        this.size = data2.size;
        return this;
      }
      Stack2.prototype.clear = stackClear2;
      Stack2.prototype["delete"] = stackDelete2;
      Stack2.prototype.get = stackGet2;
      Stack2.prototype.has = stackHas2;
      Stack2.prototype.set = stackSet2;
      function arrayLikeKeys2(value, inherited) {
        var isArr = isArray2(value), isArg = !isArr && isArguments2(value), isBuff = !isArr && !isArg && isBuffer2(value), isType = !isArr && !isArg && !isBuff && isTypedArray2(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes2(value.length, String2) : [], length2 = result2.length;
        for (var key in value) {
          if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex2(key, length2)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function arraySample(array2) {
        var length2 = array2.length;
        return length2 ? array2[baseRandom(0, length2 - 1)] : undefined$1;
      }
      function arraySampleSize(array2, n2) {
        return shuffleSelf(copyArray(array2), baseClamp(n2, 0, array2.length));
      }
      function arrayShuffle(array2) {
        return shuffleSelf(copyArray(array2));
      }
      function assignMergeValue(object2, key, value) {
        if (value !== undefined$1 && !eq2(object2[key], value) || value === undefined$1 && !(key in object2)) {
          baseAssignValue2(object2, key, value);
        }
      }
      function assignValue(object2, key, value) {
        var objValue = object2[key];
        if (!(hasOwnProperty2.call(object2, key) && eq2(objValue, value)) || value === undefined$1 && !(key in object2)) {
          baseAssignValue2(object2, key, value);
        }
      }
      function assocIndexOf2(array2, key) {
        var length2 = array2.length;
        while (length2--) {
          if (eq2(array2[length2][0], key)) {
            return length2;
          }
        }
        return -1;
      }
      function baseAggregator2(collection, setter, iteratee2, accumulator) {
        baseEach2(collection, function(value, key, collection2) {
          setter(accumulator, value, iteratee2(value), collection2);
        });
        return accumulator;
      }
      function baseAssign(object2, source2) {
        return object2 && copyObject(source2, keys2(source2), object2);
      }
      function baseAssignIn(object2, source2) {
        return object2 && copyObject(source2, keysIn(source2), object2);
      }
      function baseAssignValue2(object2, key, value) {
        if (key == "__proto__" && defineProperty2) {
          defineProperty2(object2, key, {
            "configurable": true,
            "enumerable": true,
            "value": value,
            "writable": true
          });
        } else {
          object2[key] = value;
        }
      }
      function baseAt(object2, paths) {
        var index2 = -1, length2 = paths.length, result2 = Array2(length2), skip = object2 == null;
        while (++index2 < length2) {
          result2[index2] = skip ? undefined$1 : get2(object2, paths[index2]);
        }
        return result2;
      }
      function baseClamp(number2, lower, upper) {
        if (number2 === number2) {
          if (upper !== undefined$1) {
            number2 = number2 <= upper ? number2 : upper;
          }
          if (lower !== undefined$1) {
            number2 = number2 >= lower ? number2 : lower;
          }
        }
        return number2;
      }
      function baseClone2(value, bitmask, customizer, key, object2, stack) {
        var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
        if (customizer) {
          result2 = object2 ? customizer(value, key, object2, stack) : customizer(value);
        }
        if (result2 !== undefined$1) {
          return result2;
        }
        if (!isObject2(value)) {
          return value;
        }
        var isArr = isArray2(value);
        if (isArr) {
          result2 = initCloneArray(value);
          if (!isDeep) {
            return copyArray(value, result2);
          }
        } else {
          var tag = getTag2(value), isFunc = tag == funcTag2 || tag == genTag2;
          if (isBuffer2(value)) {
            return cloneBuffer(value, isDeep);
          }
          if (tag == objectTag2 || tag == argsTag2 || isFunc && !object2) {
            result2 = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) {
              return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object2 ? value : {};
            }
            result2 = initCloneByTag(value, tag, isDeep);
          }
        }
        stack || (stack = new Stack2());
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result2);
        if (isSet(value)) {
          value.forEach(function(subValue) {
            result2.add(baseClone2(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap(value)) {
          value.forEach(function(subValue, key2) {
            result2.set(key2, baseClone2(subValue, bitmask, customizer, key2, value, stack));
          });
        }
        var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys2 : isFlat ? keysIn : keys2;
        var props = isArr ? undefined$1 : keysFunc(value);
        arrayEach(props || value, function(subValue, key2) {
          if (props) {
            key2 = subValue;
            subValue = value[key2];
          }
          assignValue(result2, key2, baseClone2(subValue, bitmask, customizer, key2, value, stack));
        });
        return result2;
      }
      function baseConforms(source2) {
        var props = keys2(source2);
        return function(object2) {
          return baseConformsTo(object2, source2, props);
        };
      }
      function baseConformsTo(object2, source2, props) {
        var length2 = props.length;
        if (object2 == null) {
          return !length2;
        }
        object2 = Object2(object2);
        while (length2--) {
          var key = props[length2], predicate = source2[key], value = object2[key];
          if (value === undefined$1 && !(key in object2) || !predicate(value)) {
            return false;
          }
        }
        return true;
      }
      function baseDelay(func, wait, args) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        return setTimeout2(function() {
          func.apply(undefined$1, args);
        }, wait);
      }
      function baseDifference(array2, values2, iteratee2, comparator) {
        var index2 = -1, includes2 = arrayIncludes2, isCommon = true, length2 = array2.length, result2 = [], valuesLength = values2.length;
        if (!length2) {
          return result2;
        }
        if (iteratee2) {
          values2 = arrayMap2(values2, baseUnary2(iteratee2));
        }
        if (comparator) {
          includes2 = arrayIncludesWith2;
          isCommon = false;
        } else if (values2.length >= LARGE_ARRAY_SIZE2) {
          includes2 = cacheHas2;
          isCommon = false;
          values2 = new SetCache2(values2);
        }
        outer:
          while (++index2 < length2) {
            var value = array2[index2], computed = iteratee2 == null ? value : iteratee2(value);
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values2[valuesIndex] === computed) {
                  continue outer;
                }
              }
              result2.push(value);
            } else if (!includes2(values2, computed, comparator)) {
              result2.push(value);
            }
          }
        return result2;
      }
      var baseEach2 = createBaseEach2(baseForOwn2);
      var baseEachRight = createBaseEach2(baseForOwnRight, true);
      function baseEvery(collection, predicate) {
        var result2 = true;
        baseEach2(collection, function(value, index2, collection2) {
          result2 = !!predicate(value, index2, collection2);
          return result2;
        });
        return result2;
      }
      function baseExtremum(array2, iteratee2, comparator) {
        var index2 = -1, length2 = array2.length;
        while (++index2 < length2) {
          var value = array2[index2], current = iteratee2(value);
          if (current != null && (computed === undefined$1 ? current === current && !isSymbol2(current) : comparator(current, computed))) {
            var computed = current, result2 = value;
          }
        }
        return result2;
      }
      function baseFill(array2, value, start2, end2) {
        var length2 = array2.length;
        start2 = toInteger2(start2);
        if (start2 < 0) {
          start2 = -start2 > length2 ? 0 : length2 + start2;
        }
        end2 = end2 === undefined$1 || end2 > length2 ? length2 : toInteger2(end2);
        if (end2 < 0) {
          end2 += length2;
        }
        end2 = start2 > end2 ? 0 : toLength(end2);
        while (start2 < end2) {
          array2[start2++] = value;
        }
        return array2;
      }
      function baseFilter(collection, predicate) {
        var result2 = [];
        baseEach2(collection, function(value, index2, collection2) {
          if (predicate(value, index2, collection2)) {
            result2.push(value);
          }
        });
        return result2;
      }
      function baseFlatten2(array2, depth, predicate, isStrict, result2) {
        var index2 = -1, length2 = array2.length;
        predicate || (predicate = isFlattenable2);
        result2 || (result2 = []);
        while (++index2 < length2) {
          var value = array2[index2];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              baseFlatten2(value, depth - 1, predicate, isStrict, result2);
            } else {
              arrayPush2(result2, value);
            }
          } else if (!isStrict) {
            result2[result2.length] = value;
          }
        }
        return result2;
      }
      var baseFor2 = createBaseFor2();
      var baseForRight = createBaseFor2(true);
      function baseForOwn2(object2, iteratee2) {
        return object2 && baseFor2(object2, iteratee2, keys2);
      }
      function baseForOwnRight(object2, iteratee2) {
        return object2 && baseForRight(object2, iteratee2, keys2);
      }
      function baseFunctions(object2, props) {
        return arrayFilter2(props, function(key) {
          return isFunction3(object2[key]);
        });
      }
      function baseGet2(object2, path) {
        path = castPath2(path, object2);
        var index2 = 0, length2 = path.length;
        while (object2 != null && index2 < length2) {
          object2 = object2[toKey2(path[index2++])];
        }
        return index2 && index2 == length2 ? object2 : undefined$1;
      }
      function baseGetAllKeys2(object2, keysFunc, symbolsFunc) {
        var result2 = keysFunc(object2);
        return isArray2(object2) ? result2 : arrayPush2(result2, symbolsFunc(object2));
      }
      function baseGetTag2(value) {
        if (value == null) {
          return value === undefined$1 ? undefinedTag2 : nullTag2;
        }
        return symToStringTag2 && symToStringTag2 in Object2(value) ? getRawTag2(value) : objectToString2(value);
      }
      function baseGt(value, other) {
        return value > other;
      }
      function baseHas2(object2, key) {
        return object2 != null && hasOwnProperty2.call(object2, key);
      }
      function baseHasIn2(object2, key) {
        return object2 != null && key in Object2(object2);
      }
      function baseInRange(number2, start2, end2) {
        return number2 >= nativeMin(start2, end2) && number2 < nativeMax2(start2, end2);
      }
      function baseIntersection(arrays, iteratee2, comparator) {
        var includes2 = comparator ? arrayIncludesWith2 : arrayIncludes2, length2 = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
        while (othIndex--) {
          var array2 = arrays[othIndex];
          if (othIndex && iteratee2) {
            array2 = arrayMap2(array2, baseUnary2(iteratee2));
          }
          maxLength = nativeMin(array2.length, maxLength);
          caches[othIndex] = !comparator && (iteratee2 || length2 >= 120 && array2.length >= 120) ? new SetCache2(othIndex && array2) : undefined$1;
        }
        array2 = arrays[0];
        var index2 = -1, seen = caches[0];
        outer:
          while (++index2 < length2 && result2.length < maxLength) {
            var value = array2[index2], computed = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (!(seen ? cacheHas2(seen, computed) : includes2(result2, computed, comparator))) {
              othIndex = othLength;
              while (--othIndex) {
                var cache2 = caches[othIndex];
                if (!(cache2 ? cacheHas2(cache2, computed) : includes2(arrays[othIndex], computed, comparator))) {
                  continue outer;
                }
              }
              if (seen) {
                seen.push(computed);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseInverter(object2, setter, iteratee2, accumulator) {
        baseForOwn2(object2, function(value, key, object3) {
          setter(accumulator, iteratee2(value), key, object3);
        });
        return accumulator;
      }
      function baseInvoke(object2, path, args) {
        path = castPath2(path, object2);
        object2 = parent2(object2, path);
        var func = object2 == null ? object2 : object2[toKey2(last(path))];
        return func == null ? undefined$1 : apply2(func, object2, args);
      }
      function baseIsArguments2(value) {
        return isObjectLike2(value) && baseGetTag2(value) == argsTag2;
      }
      function baseIsArrayBuffer(value) {
        return isObjectLike2(value) && baseGetTag2(value) == arrayBufferTag2;
      }
      function baseIsDate(value) {
        return isObjectLike2(value) && baseGetTag2(value) == dateTag2;
      }
      function baseIsEqual2(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }
        if (value == null || other == null || !isObjectLike2(value) && !isObjectLike2(other)) {
          return value !== value && other !== other;
        }
        return baseIsEqualDeep2(value, other, bitmask, customizer, baseIsEqual2, stack);
      }
      function baseIsEqualDeep2(object2, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray2(object2), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag2 : getTag2(object2), othTag = othIsArr ? arrayTag2 : getTag2(other);
        objTag = objTag == argsTag2 ? objectTag2 : objTag;
        othTag = othTag == argsTag2 ? objectTag2 : othTag;
        var objIsObj = objTag == objectTag2, othIsObj = othTag == objectTag2, isSameTag = objTag == othTag;
        if (isSameTag && isBuffer2(object2)) {
          if (!isBuffer2(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack2());
          return objIsArr || isTypedArray2(object2) ? equalArrays2(object2, other, bitmask, customizer, equalFunc, stack) : equalByTag2(object2, other, objTag, bitmask, customizer, equalFunc, stack);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG2)) {
          var objIsWrapped = objIsObj && hasOwnProperty2.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack2());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack || (stack = new Stack2());
        return equalObjects2(object2, other, bitmask, customizer, equalFunc, stack);
      }
      function baseIsMap(value) {
        return isObjectLike2(value) && getTag2(value) == mapTag2;
      }
      function baseIsMatch2(object2, source2, matchData, customizer) {
        var index2 = matchData.length, length2 = index2, noCustomizer = !customizer;
        if (object2 == null) {
          return !length2;
        }
        object2 = Object2(object2);
        while (index2--) {
          var data2 = matchData[index2];
          if (noCustomizer && data2[2] ? data2[1] !== object2[data2[0]] : !(data2[0] in object2)) {
            return false;
          }
        }
        while (++index2 < length2) {
          data2 = matchData[index2];
          var key = data2[0], objValue = object2[key], srcValue = data2[1];
          if (noCustomizer && data2[2]) {
            if (objValue === undefined$1 && !(key in object2)) {
              return false;
            }
          } else {
            var stack = new Stack2();
            if (customizer) {
              var result2 = customizer(objValue, srcValue, key, object2, source2, stack);
            }
            if (!(result2 === undefined$1 ? baseIsEqual2(srcValue, objValue, COMPARE_PARTIAL_FLAG2 | COMPARE_UNORDERED_FLAG2, customizer, stack) : result2)) {
              return false;
            }
          }
        }
        return true;
      }
      function baseIsNative2(value) {
        if (!isObject2(value) || isMasked2(value)) {
          return false;
        }
        var pattern = isFunction3(value) ? reIsNative2 : reIsHostCtor2;
        return pattern.test(toSource2(value));
      }
      function baseIsRegExp(value) {
        return isObjectLike2(value) && baseGetTag2(value) == regexpTag2;
      }
      function baseIsSet(value) {
        return isObjectLike2(value) && getTag2(value) == setTag2;
      }
      function baseIsTypedArray2(value) {
        return isObjectLike2(value) && isLength2(value.length) && !!typedArrayTags2[baseGetTag2(value)];
      }
      function baseIteratee2(value) {
        if (typeof value == "function") {
          return value;
        }
        if (value == null) {
          return identity2;
        }
        if (typeof value == "object") {
          return isArray2(value) ? baseMatchesProperty2(value[0], value[1]) : baseMatches2(value);
        }
        return property2(value);
      }
      function baseKeys2(object2) {
        if (!isPrototype2(object2)) {
          return nativeKeys2(object2);
        }
        var result2 = [];
        for (var key in Object2(object2)) {
          if (hasOwnProperty2.call(object2, key) && key != "constructor") {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseKeysIn(object2) {
        if (!isObject2(object2)) {
          return nativeKeysIn(object2);
        }
        var isProto = isPrototype2(object2), result2 = [];
        for (var key in object2) {
          if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object2, key)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseLt(value, other) {
        return value < other;
      }
      function baseMap2(collection, iteratee2) {
        var index2 = -1, result2 = isArrayLike2(collection) ? Array2(collection.length) : [];
        baseEach2(collection, function(value, key, collection2) {
          result2[++index2] = iteratee2(value, key, collection2);
        });
        return result2;
      }
      function baseMatches2(source2) {
        var matchData = getMatchData2(source2);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable2(matchData[0][0], matchData[0][1]);
        }
        return function(object2) {
          return object2 === source2 || baseIsMatch2(object2, source2, matchData);
        };
      }
      function baseMatchesProperty2(path, srcValue) {
        if (isKey2(path) && isStrictComparable2(srcValue)) {
          return matchesStrictComparable2(toKey2(path), srcValue);
        }
        return function(object2) {
          var objValue = get2(object2, path);
          return objValue === undefined$1 && objValue === srcValue ? hasIn2(object2, path) : baseIsEqual2(srcValue, objValue, COMPARE_PARTIAL_FLAG2 | COMPARE_UNORDERED_FLAG2);
        };
      }
      function baseMerge(object2, source2, srcIndex, customizer, stack) {
        if (object2 === source2) {
          return;
        }
        baseFor2(source2, function(srcValue, key) {
          stack || (stack = new Stack2());
          if (isObject2(srcValue)) {
            baseMergeDeep(object2, source2, key, srcIndex, baseMerge, customizer, stack);
          } else {
            var newValue = customizer ? customizer(safeGet(object2, key), srcValue, key + "", object2, source2, stack) : undefined$1;
            if (newValue === undefined$1) {
              newValue = srcValue;
            }
            assignMergeValue(object2, key, newValue);
          }
        }, keysIn);
      }
      function baseMergeDeep(object2, source2, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet(object2, key), srcValue = safeGet(source2, key), stacked = stack.get(srcValue);
        if (stacked) {
          assignMergeValue(object2, key, stacked);
          return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + "", object2, source2, stack) : undefined$1;
        var isCommon = newValue === undefined$1;
        if (isCommon) {
          var isArr = isArray2(srcValue), isBuff = !isArr && isBuffer2(srcValue), isTyped = !isArr && !isBuff && isTypedArray2(srcValue);
          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray2(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject2(srcValue) || isArguments2(srcValue)) {
            newValue = objValue;
            if (isArguments2(objValue)) {
              newValue = toPlainObject(objValue);
            } else if (!isObject2(objValue) || isFunction3(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack["delete"](srcValue);
        }
        assignMergeValue(object2, key, newValue);
      }
      function baseNth(array2, n2) {
        var length2 = array2.length;
        if (!length2) {
          return;
        }
        n2 += n2 < 0 ? length2 : 0;
        return isIndex2(n2, length2) ? array2[n2] : undefined$1;
      }
      function baseOrderBy2(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap2(iteratees, function(iteratee2) {
            if (isArray2(iteratee2)) {
              return function(value) {
                return baseGet2(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
              };
            }
            return iteratee2;
          });
        } else {
          iteratees = [identity2];
        }
        var index2 = -1;
        iteratees = arrayMap2(iteratees, baseUnary2(getIteratee()));
        var result2 = baseMap2(collection, function(value, key, collection2) {
          var criteria = arrayMap2(iteratees, function(iteratee2) {
            return iteratee2(value);
          });
          return { "criteria": criteria, "index": ++index2, "value": value };
        });
        return baseSortBy2(result2, function(object2, other) {
          return compareMultiple2(object2, other, orders);
        });
      }
      function basePick(object2, paths) {
        return basePickBy(object2, paths, function(value, path) {
          return hasIn2(object2, path);
        });
      }
      function basePickBy(object2, paths, predicate) {
        var index2 = -1, length2 = paths.length, result2 = {};
        while (++index2 < length2) {
          var path = paths[index2], value = baseGet2(object2, path);
          if (predicate(value, path)) {
            baseSet(result2, castPath2(path, object2), value);
          }
        }
        return result2;
      }
      function basePropertyDeep2(path) {
        return function(object2) {
          return baseGet2(object2, path);
        };
      }
      function basePullAll(array2, values2, iteratee2, comparator) {
        var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf2, index2 = -1, length2 = values2.length, seen = array2;
        if (array2 === values2) {
          values2 = copyArray(values2);
        }
        if (iteratee2) {
          seen = arrayMap2(array2, baseUnary2(iteratee2));
        }
        while (++index2 < length2) {
          var fromIndex = 0, value = values2[index2], computed = iteratee2 ? iteratee2(value) : value;
          while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
            if (seen !== array2) {
              splice2.call(seen, fromIndex, 1);
            }
            splice2.call(array2, fromIndex, 1);
          }
        }
        return array2;
      }
      function basePullAt(array2, indexes) {
        var length2 = array2 ? indexes.length : 0, lastIndex = length2 - 1;
        while (length2--) {
          var index2 = indexes[length2];
          if (length2 == lastIndex || index2 !== previous) {
            var previous = index2;
            if (isIndex2(index2)) {
              splice2.call(array2, index2, 1);
            } else {
              baseUnset(array2, index2);
            }
          }
        }
        return array2;
      }
      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }
      function baseRange(start2, end2, step, fromRight) {
        var index2 = -1, length2 = nativeMax2(nativeCeil((end2 - start2) / (step || 1)), 0), result2 = Array2(length2);
        while (length2--) {
          result2[fromRight ? length2 : ++index2] = start2;
          start2 += step;
        }
        return result2;
      }
      function baseRepeat(string2, n2) {
        var result2 = "";
        if (!string2 || n2 < 1 || n2 > MAX_SAFE_INTEGER2) {
          return result2;
        }
        do {
          if (n2 % 2) {
            result2 += string2;
          }
          n2 = nativeFloor(n2 / 2);
          if (n2) {
            string2 += string2;
          }
        } while (n2);
        return result2;
      }
      function baseRest2(func, start2) {
        return setToString2(overRest2(func, start2, identity2), func + "");
      }
      function baseSample(collection) {
        return arraySample(values(collection));
      }
      function baseSampleSize(collection, n2) {
        var array2 = values(collection);
        return shuffleSelf(array2, baseClamp(n2, 0, array2.length));
      }
      function baseSet(object2, path, value, customizer) {
        if (!isObject2(object2)) {
          return object2;
        }
        path = castPath2(path, object2);
        var index2 = -1, length2 = path.length, lastIndex = length2 - 1, nested = object2;
        while (nested != null && ++index2 < length2) {
          var key = toKey2(path[index2]), newValue = value;
          if (key === "__proto__" || key === "constructor" || key === "prototype") {
            return object2;
          }
          if (index2 != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
            if (newValue === undefined$1) {
              newValue = isObject2(objValue) ? objValue : isIndex2(path[index2 + 1]) ? [] : {};
            }
          }
          assignValue(nested, key, newValue);
          nested = nested[key];
        }
        return object2;
      }
      var baseSetData = !metaMap ? identity2 : function(func, data2) {
        metaMap.set(func, data2);
        return func;
      };
      var baseSetToString2 = !defineProperty2 ? identity2 : function(func, string2) {
        return defineProperty2(func, "toString", {
          "configurable": true,
          "enumerable": false,
          "value": constant2(string2),
          "writable": true
        });
      };
      function baseShuffle(collection) {
        return shuffleSelf(values(collection));
      }
      function baseSlice2(array2, start2, end2) {
        var index2 = -1, length2 = array2.length;
        if (start2 < 0) {
          start2 = -start2 > length2 ? 0 : length2 + start2;
        }
        end2 = end2 > length2 ? length2 : end2;
        if (end2 < 0) {
          end2 += length2;
        }
        length2 = start2 > end2 ? 0 : end2 - start2 >>> 0;
        start2 >>>= 0;
        var result2 = Array2(length2);
        while (++index2 < length2) {
          result2[index2] = array2[index2 + start2];
        }
        return result2;
      }
      function baseSome(collection, predicate) {
        var result2;
        baseEach2(collection, function(value, index2, collection2) {
          result2 = predicate(value, index2, collection2);
          return !result2;
        });
        return !!result2;
      }
      function baseSortedIndex(array2, value, retHighest) {
        var low = 0, high = array2 == null ? low : array2.length;
        if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
          while (low < high) {
            var mid = low + high >>> 1, computed = array2[mid];
            if (computed !== null && !isSymbol2(computed) && (retHighest ? computed <= value : computed < value)) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return high;
        }
        return baseSortedIndexBy(array2, value, identity2, retHighest);
      }
      function baseSortedIndexBy(array2, value, iteratee2, retHighest) {
        var low = 0, high = array2 == null ? 0 : array2.length;
        if (high === 0) {
          return 0;
        }
        value = iteratee2(value);
        var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol2(value), valIsUndefined = value === undefined$1;
        while (low < high) {
          var mid = nativeFloor((low + high) / 2), computed = iteratee2(array2[mid]), othIsDefined = computed !== undefined$1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol2(computed);
          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? computed <= value : computed < value;
          }
          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return nativeMin(high, MAX_ARRAY_INDEX);
      }
      function baseSortedUniq(array2, iteratee2) {
        var index2 = -1, length2 = array2.length, resIndex = 0, result2 = [];
        while (++index2 < length2) {
          var value = array2[index2], computed = iteratee2 ? iteratee2(value) : value;
          if (!index2 || !eq2(computed, seen)) {
            var seen = computed;
            result2[resIndex++] = value === 0 ? 0 : value;
          }
        }
        return result2;
      }
      function baseToNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol2(value)) {
          return NAN2;
        }
        return +value;
      }
      function baseToString2(value) {
        if (typeof value == "string") {
          return value;
        }
        if (isArray2(value)) {
          return arrayMap2(value, baseToString2) + "";
        }
        if (isSymbol2(value)) {
          return symbolToString2 ? symbolToString2.call(value) : "";
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -INFINITY2 ? "-0" : result2;
      }
      function baseUniq2(array2, iteratee2, comparator) {
        var index2 = -1, includes2 = arrayIncludes2, length2 = array2.length, isCommon = true, result2 = [], seen = result2;
        if (comparator) {
          isCommon = false;
          includes2 = arrayIncludesWith2;
        } else if (length2 >= LARGE_ARRAY_SIZE2) {
          var set3 = iteratee2 ? null : createSet2(array2);
          if (set3) {
            return setToArray2(set3);
          }
          isCommon = false;
          includes2 = cacheHas2;
          seen = new SetCache2();
        } else {
          seen = iteratee2 ? [] : result2;
        }
        outer:
          while (++index2 < length2) {
            var value = array2[index2], computed = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed) {
                  continue outer;
                }
              }
              if (iteratee2) {
                seen.push(computed);
              }
              result2.push(value);
            } else if (!includes2(seen, computed, comparator)) {
              if (seen !== result2) {
                seen.push(computed);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseUnset(object2, path) {
        path = castPath2(path, object2);
        object2 = parent2(object2, path);
        return object2 == null || delete object2[toKey2(last(path))];
      }
      function baseUpdate(object2, path, updater, customizer) {
        return baseSet(object2, path, updater(baseGet2(object2, path)), customizer);
      }
      function baseWhile(array2, predicate, isDrop, fromRight) {
        var length2 = array2.length, index2 = fromRight ? length2 : -1;
        while ((fromRight ? index2-- : ++index2 < length2) && predicate(array2[index2], index2, array2)) {
        }
        return isDrop ? baseSlice2(array2, fromRight ? 0 : index2, fromRight ? index2 + 1 : length2) : baseSlice2(array2, fromRight ? index2 + 1 : 0, fromRight ? length2 : index2);
      }
      function baseWrapperValue(value, actions) {
        var result2 = value;
        if (result2 instanceof LazyWrapper) {
          result2 = result2.value();
        }
        return arrayReduce2(actions, function(result3, action) {
          return action.func.apply(action.thisArg, arrayPush2([result3], action.args));
        }, result2);
      }
      function baseXor(arrays, iteratee2, comparator) {
        var length2 = arrays.length;
        if (length2 < 2) {
          return length2 ? baseUniq2(arrays[0]) : [];
        }
        var index2 = -1, result2 = Array2(length2);
        while (++index2 < length2) {
          var array2 = arrays[index2], othIndex = -1;
          while (++othIndex < length2) {
            if (othIndex != index2) {
              result2[index2] = baseDifference(result2[index2] || array2, arrays[othIndex], iteratee2, comparator);
            }
          }
        }
        return baseUniq2(baseFlatten2(result2, 1), iteratee2, comparator);
      }
      function baseZipObject(props, values2, assignFunc) {
        var index2 = -1, length2 = props.length, valsLength = values2.length, result2 = {};
        while (++index2 < length2) {
          var value = index2 < valsLength ? values2[index2] : undefined$1;
          assignFunc(result2, props[index2], value);
        }
        return result2;
      }
      function castArrayLikeObject(value) {
        return isArrayLikeObject(value) ? value : [];
      }
      function castFunction(value) {
        return typeof value == "function" ? value : identity2;
      }
      function castPath2(value, object2) {
        if (isArray2(value)) {
          return value;
        }
        return isKey2(value, object2) ? [value] : stringToPath2(toString3(value));
      }
      var castRest = baseRest2;
      function castSlice2(array2, start2, end2) {
        var length2 = array2.length;
        end2 = end2 === undefined$1 ? length2 : end2;
        return !start2 && end2 >= length2 ? array2 : baseSlice2(array2, start2, end2);
      }
      var clearTimeout2 = ctxClearTimeout || function(id2) {
        return root2.clearTimeout(id2);
      };
      function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length2 = buffer.length, result2 = allocUnsafe ? allocUnsafe(length2) : new buffer.constructor(length2);
        buffer.copy(result2);
        return result2;
      }
      function cloneArrayBuffer(arrayBuffer) {
        var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
        return result2;
      }
      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }
      function cloneRegExp(regexp) {
        var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result2.lastIndex = regexp.lastIndex;
        return result2;
      }
      function cloneSymbol(symbol) {
        return symbolValueOf2 ? Object2(symbolValueOf2.call(symbol)) : {};
      }
      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }
      function compareAscending2(value, other) {
        if (value !== other) {
          var valIsDefined = value !== undefined$1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol2(value);
          var othIsDefined = other !== undefined$1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol2(other);
          if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
            return 1;
          }
          if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
            return -1;
          }
        }
        return 0;
      }
      function compareMultiple2(object2, other, orders) {
        var index2 = -1, objCriteria = object2.criteria, othCriteria = other.criteria, length2 = objCriteria.length, ordersLength = orders.length;
        while (++index2 < length2) {
          var result2 = compareAscending2(objCriteria[index2], othCriteria[index2]);
          if (result2) {
            if (index2 >= ordersLength) {
              return result2;
            }
            var order2 = orders[index2];
            return result2 * (order2 == "desc" ? -1 : 1);
          }
        }
        return object2.index - other.index;
      }
      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax2(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
        while (++leftIndex < leftLength) {
          result2[leftIndex] = partials[leftIndex];
        }
        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[holders[argsIndex]] = args[argsIndex];
          }
        }
        while (rangeLength--) {
          result2[leftIndex++] = args[argsIndex++];
        }
        return result2;
      }
      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax2(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
        while (++argsIndex < rangeLength) {
          result2[argsIndex] = args[argsIndex];
        }
        var offset2 = argsIndex;
        while (++rightIndex < rightLength) {
          result2[offset2 + rightIndex] = partials[rightIndex];
        }
        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[offset2 + holders[holdersIndex]] = args[argsIndex++];
          }
        }
        return result2;
      }
      function copyArray(source2, array2) {
        var index2 = -1, length2 = source2.length;
        array2 || (array2 = Array2(length2));
        while (++index2 < length2) {
          array2[index2] = source2[index2];
        }
        return array2;
      }
      function copyObject(source2, props, object2, customizer) {
        var isNew = !object2;
        object2 || (object2 = {});
        var index2 = -1, length2 = props.length;
        while (++index2 < length2) {
          var key = props[index2];
          var newValue = customizer ? customizer(object2[key], source2[key], key, object2, source2) : undefined$1;
          if (newValue === undefined$1) {
            newValue = source2[key];
          }
          if (isNew) {
            baseAssignValue2(object2, key, newValue);
          } else {
            assignValue(object2, key, newValue);
          }
        }
        return object2;
      }
      function copySymbols(source2, object2) {
        return copyObject(source2, getSymbols2(source2), object2);
      }
      function copySymbolsIn(source2, object2) {
        return copyObject(source2, getSymbolsIn(source2), object2);
      }
      function createAggregator2(setter, initializer) {
        return function(collection, iteratee2) {
          var func = isArray2(collection) ? arrayAggregator2 : baseAggregator2, accumulator = initializer ? initializer() : {};
          return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
        };
      }
      function createAssigner(assigner) {
        return baseRest2(function(object2, sources) {
          var index2 = -1, length2 = sources.length, customizer = length2 > 1 ? sources[length2 - 1] : undefined$1, guard = length2 > 2 ? sources[2] : undefined$1;
          customizer = assigner.length > 3 && typeof customizer == "function" ? (length2--, customizer) : undefined$1;
          if (guard && isIterateeCall2(sources[0], sources[1], guard)) {
            customizer = length2 < 3 ? undefined$1 : customizer;
            length2 = 1;
          }
          object2 = Object2(object2);
          while (++index2 < length2) {
            var source2 = sources[index2];
            if (source2) {
              assigner(object2, source2, index2, customizer);
            }
          }
          return object2;
        });
      }
      function createBaseEach2(eachFunc, fromRight) {
        return function(collection, iteratee2) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike2(collection)) {
            return eachFunc(collection, iteratee2);
          }
          var length2 = collection.length, index2 = fromRight ? length2 : -1, iterable = Object2(collection);
          while (fromRight ? index2-- : ++index2 < length2) {
            if (iteratee2(iterable[index2], index2, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }
      function createBaseFor2(fromRight) {
        return function(object2, iteratee2, keysFunc) {
          var index2 = -1, iterable = Object2(object2), props = keysFunc(object2), length2 = props.length;
          while (length2--) {
            var key = props[fromRight ? length2 : ++index2];
            if (iteratee2(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object2;
        };
      }
      function createBind(func, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var fn2 = this && this !== root2 && this instanceof wrapper ? Ctor : func;
          return fn2.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
      }
      function createCaseFirst2(methodName) {
        return function(string2) {
          string2 = toString3(string2);
          var strSymbols = hasUnicode2(string2) ? stringToArray2(string2) : undefined$1;
          var chr = strSymbols ? strSymbols[0] : string2.charAt(0);
          var trailing = strSymbols ? castSlice2(strSymbols, 1).join("") : string2.slice(1);
          return chr[methodName]() + trailing;
        };
      }
      function createCompounder2(callback) {
        return function(string2) {
          return arrayReduce2(words2(deburr2(string2).replace(reApos2, "")), callback, "");
        };
      }
      function createCtor(Ctor) {
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return new Ctor();
            case 1:
              return new Ctor(args[0]);
            case 2:
              return new Ctor(args[0], args[1]);
            case 3:
              return new Ctor(args[0], args[1], args[2]);
            case 4:
              return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
              return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
          }
          var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
          return isObject2(result2) ? result2 : thisBinding;
        };
      }
      function createCurry(func, bitmask, arity) {
        var Ctor = createCtor(func);
        function wrapper() {
          var length2 = arguments.length, args = Array2(length2), index2 = length2, placeholder = getHolder(wrapper);
          while (index2--) {
            args[index2] = arguments[index2];
          }
          var holders = length2 < 3 && args[0] !== placeholder && args[length2 - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
          length2 -= holders.length;
          if (length2 < arity) {
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined$1, args, holders, undefined$1, undefined$1, arity - length2);
          }
          var fn2 = this && this !== root2 && this instanceof wrapper ? Ctor : func;
          return apply2(fn2, this, args);
        }
        return wrapper;
      }
      function createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
          var iterable = Object2(collection);
          if (!isArrayLike2(collection)) {
            var iteratee2 = getIteratee(predicate, 3);
            collection = keys2(collection);
            predicate = function(key) {
              return iteratee2(iterable[key], key, iterable);
            };
          }
          var index2 = findIndexFunc(collection, predicate, fromIndex);
          return index2 > -1 ? iterable[iteratee2 ? collection[index2] : index2] : undefined$1;
        };
      }
      function createFlow(fromRight) {
        return flatRest(function(funcs) {
          var length2 = funcs.length, index2 = length2, prereq = LodashWrapper.prototype.thru;
          if (fromRight) {
            funcs.reverse();
          }
          while (index2--) {
            var func = funcs[index2];
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT2);
            }
            if (prereq && !wrapper && getFuncName(func) == "wrapper") {
              var wrapper = new LodashWrapper([], true);
            }
          }
          index2 = wrapper ? index2 : length2;
          while (++index2 < length2) {
            func = funcs[index2];
            var funcName = getFuncName(func), data2 = funcName == "wrapper" ? getData(func) : undefined$1;
            if (data2 && isLaziable(data2[0]) && data2[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data2[4].length && data2[9] == 1) {
              wrapper = wrapper[getFuncName(data2[0])].apply(wrapper, data2[3]);
            } else {
              wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
            }
          }
          return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && isArray2(value)) {
              return wrapper.plant(value).value();
            }
            var index3 = 0, result2 = length2 ? funcs[index3].apply(this, args) : value;
            while (++index3 < length2) {
              result2 = funcs[index3].call(this, result2);
            }
            return result2;
          };
        });
      }
      function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
        var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined$1 : createCtor(func);
        function wrapper() {
          var length2 = arguments.length, args = Array2(length2), index2 = length2;
          while (index2--) {
            args[index2] = arguments[index2];
          }
          if (isCurried) {
            var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
          }
          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }
          if (partialsRight) {
            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
          }
          length2 -= holdersCount;
          if (isCurried && length2 < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary2, arity - length2);
          }
          var thisBinding = isBind ? thisArg : this, fn2 = isBindKey ? thisBinding[func] : func;
          length2 = args.length;
          if (argPos) {
            args = reorder(args, argPos);
          } else if (isFlip && length2 > 1) {
            args.reverse();
          }
          if (isAry && ary2 < length2) {
            args.length = ary2;
          }
          if (this && this !== root2 && this instanceof wrapper) {
            fn2 = Ctor || createCtor(fn2);
          }
          return fn2.apply(thisBinding, args);
        }
        return wrapper;
      }
      function createInverter(setter, toIteratee) {
        return function(object2, iteratee2) {
          return baseInverter(object2, setter, toIteratee(iteratee2), {});
        };
      }
      function createMathOperation(operator, defaultValue) {
        return function(value, other) {
          var result2;
          if (value === undefined$1 && other === undefined$1) {
            return defaultValue;
          }
          if (value !== undefined$1) {
            result2 = value;
          }
          if (other !== undefined$1) {
            if (result2 === undefined$1) {
              return other;
            }
            if (typeof value == "string" || typeof other == "string") {
              value = baseToString2(value);
              other = baseToString2(other);
            } else {
              value = baseToNumber(value);
              other = baseToNumber(other);
            }
            result2 = operator(value, other);
          }
          return result2;
        };
      }
      function createOver(arrayFunc) {
        return flatRest(function(iteratees) {
          iteratees = arrayMap2(iteratees, baseUnary2(getIteratee()));
          return baseRest2(function(args) {
            var thisArg = this;
            return arrayFunc(iteratees, function(iteratee2) {
              return apply2(iteratee2, thisArg, args);
            });
          });
        });
      }
      function createPadding(length2, chars) {
        chars = chars === undefined$1 ? " " : baseToString2(chars);
        var charsLength = chars.length;
        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars, length2) : chars;
        }
        var result2 = baseRepeat(chars, nativeCeil(length2 / stringSize(chars)));
        return hasUnicode2(chars) ? castSlice2(stringToArray2(result2), 0, length2).join("") : result2.slice(0, length2);
      }
      function createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn2 = this && this !== root2 && this instanceof wrapper ? Ctor : func;
          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }
          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }
          return apply2(fn2, isBind ? thisArg : this, args);
        }
        return wrapper;
      }
      function createRange(fromRight) {
        return function(start2, end2, step) {
          if (step && typeof step != "number" && isIterateeCall2(start2, end2, step)) {
            end2 = step = undefined$1;
          }
          start2 = toFinite2(start2);
          if (end2 === undefined$1) {
            end2 = start2;
            start2 = 0;
          } else {
            end2 = toFinite2(end2);
          }
          step = step === undefined$1 ? start2 < end2 ? 1 : -1 : toFinite2(step);
          return baseRange(start2, end2, step, fromRight);
        };
      }
      function createRelationalOperation(operator) {
        return function(value, other) {
          if (!(typeof value == "string" && typeof other == "string")) {
            value = toNumber2(value);
            other = toNumber2(other);
          }
          return operator(value, other);
        };
      }
      function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
        var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined$1, newHoldersRight = isCurry ? undefined$1 : holders, newPartials = isCurry ? partials : undefined$1, newPartialsRight = isCurry ? undefined$1 : partials;
        bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
        }
        var newData = [
          func,
          bitmask,
          thisArg,
          newPartials,
          newHolders,
          newPartialsRight,
          newHoldersRight,
          argPos,
          ary2,
          arity
        ];
        var result2 = wrapFunc.apply(undefined$1, newData);
        if (isLaziable(func)) {
          setData(result2, newData);
        }
        result2.placeholder = placeholder;
        return setWrapToString(result2, func, bitmask);
      }
      function createRound(methodName) {
        var func = Math2[methodName];
        return function(number2, precision) {
          number2 = toNumber2(number2);
          precision = precision == null ? 0 : nativeMin(toInteger2(precision), 292);
          if (precision && nativeIsFinite(number2)) {
            var pair = (toString3(number2) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
            pair = (toString3(value) + "e").split("e");
            return +(pair[0] + "e" + (+pair[1] - precision));
          }
          return func(number2);
        };
      }
      var createSet2 = !(Set2 && 1 / setToArray2(new Set2([, -0]))[1] == INFINITY2) ? noop3 : function(values2) {
        return new Set2(values2);
      };
      function createToPairs(keysFunc) {
        return function(object2) {
          var tag = getTag2(object2);
          if (tag == mapTag2) {
            return mapToArray2(object2);
          }
          if (tag == setTag2) {
            return setToPairs(object2);
          }
          return baseToPairs(object2, keysFunc(object2));
        };
      }
      function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        var length2 = partials ? partials.length : 0;
        if (!length2) {
          bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
          partials = holders = undefined$1;
        }
        ary2 = ary2 === undefined$1 ? ary2 : nativeMax2(toInteger2(ary2), 0);
        arity = arity === undefined$1 ? arity : toInteger2(arity);
        length2 -= holders ? holders.length : 0;
        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials, holdersRight = holders;
          partials = holders = undefined$1;
        }
        var data2 = isBindKey ? undefined$1 : getData(func);
        var newData = [
          func,
          bitmask,
          thisArg,
          partials,
          holders,
          partialsRight,
          holdersRight,
          argPos,
          ary2,
          arity
        ];
        if (data2) {
          mergeData(newData, data2);
        }
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax2(newData[9] - length2, 0);
        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
        }
        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result2 = createBind(func, bitmask, thisArg);
        } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
          result2 = createCurry(func, bitmask, arity);
        } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
          result2 = createPartial(func, bitmask, thisArg, partials);
        } else {
          result2 = createHybrid.apply(undefined$1, newData);
        }
        var setter = data2 ? baseSetData : setData;
        return setWrapToString(setter(result2, newData), func, bitmask);
      }
      function customDefaultsAssignIn(objValue, srcValue, key, object2) {
        if (objValue === undefined$1 || eq2(objValue, objectProto2[key]) && !hasOwnProperty2.call(object2, key)) {
          return srcValue;
        }
        return objValue;
      }
      function customDefaultsMerge(objValue, srcValue, key, object2, source2, stack) {
        if (isObject2(objValue) && isObject2(srcValue)) {
          stack.set(srcValue, objValue);
          baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
          stack["delete"](srcValue);
        }
        return objValue;
      }
      function customOmitClone(value) {
        return isPlainObject2(value) ? undefined$1 : value;
      }
      function equalArrays2(array2, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG2, arrLength = array2.length, othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        var arrStacked = stack.get(array2);
        var othStacked = stack.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array2;
        }
        var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG2 ? new SetCache2() : undefined$1;
        stack.set(array2, other);
        stack.set(other, array2);
        while (++index2 < arrLength) {
          var arrValue = array2[index2], othValue = other[index2];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index2, other, array2, stack) : customizer(arrValue, othValue, index2, array2, other, stack);
          }
          if (compared !== undefined$1) {
            if (compared) {
              continue;
            }
            result2 = false;
            break;
          }
          if (seen) {
            if (!arraySome2(other, function(othValue2, othIndex) {
              if (!cacheHas2(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
              result2 = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result2 = false;
            break;
          }
        }
        stack["delete"](array2);
        stack["delete"](other);
        return result2;
      }
      function equalByTag2(object2, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag2:
            if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
              return false;
            }
            object2 = object2.buffer;
            other = other.buffer;
          case arrayBufferTag2:
            if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object2), new Uint8Array2(other))) {
              return false;
            }
            return true;
          case boolTag2:
          case dateTag2:
          case numberTag2:
            return eq2(+object2, +other);
          case errorTag2:
            return object2.name == other.name && object2.message == other.message;
          case regexpTag2:
          case stringTag2:
            return object2 == other + "";
          case mapTag2:
            var convert = mapToArray2;
          case setTag2:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG2;
            convert || (convert = setToArray2);
            if (object2.size != other.size && !isPartial) {
              return false;
            }
            var stacked = stack.get(object2);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG2;
            stack.set(object2, other);
            var result2 = equalArrays2(convert(object2), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object2);
            return result2;
          case symbolTag2:
            if (symbolValueOf2) {
              return symbolValueOf2.call(object2) == symbolValueOf2.call(other);
            }
        }
        return false;
      }
      function equalObjects2(object2, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG2, objProps = getAllKeys2(object2), objLength = objProps.length, othProps = getAllKeys2(other), othLength = othProps.length;
        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index2 = objLength;
        while (index2--) {
          var key = objProps[index2];
          if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
            return false;
          }
        }
        var objStacked = stack.get(object2);
        var othStacked = stack.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object2;
        }
        var result2 = true;
        stack.set(object2, other);
        stack.set(other, object2);
        var skipCtor = isPartial;
        while (++index2 < objLength) {
          key = objProps[index2];
          var objValue = object2[key], othValue = other[key];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack) : customizer(objValue, othValue, key, object2, other, stack);
          }
          if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result2 = false;
            break;
          }
          skipCtor || (skipCtor = key == "constructor");
        }
        if (result2 && !skipCtor) {
          var objCtor = object2.constructor, othCtor = other.constructor;
          if (objCtor != othCtor && ("constructor" in object2 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
            result2 = false;
          }
        }
        stack["delete"](object2);
        stack["delete"](other);
        return result2;
      }
      function flatRest(func) {
        return setToString2(overRest2(func, undefined$1, flatten2), func + "");
      }
      function getAllKeys2(object2) {
        return baseGetAllKeys2(object2, keys2, getSymbols2);
      }
      function getAllKeysIn(object2) {
        return baseGetAllKeys2(object2, keysIn, getSymbolsIn);
      }
      var getData = !metaMap ? noop3 : function(func) {
        return metaMap.get(func);
      };
      function getFuncName(func) {
        var result2 = func.name + "", array2 = realNames[result2], length2 = hasOwnProperty2.call(realNames, result2) ? array2.length : 0;
        while (length2--) {
          var data2 = array2[length2], otherFunc = data2.func;
          if (otherFunc == null || otherFunc == func) {
            return data2.name;
          }
        }
        return result2;
      }
      function getHolder(func) {
        var object2 = hasOwnProperty2.call(lodash2, "placeholder") ? lodash2 : func;
        return object2.placeholder;
      }
      function getIteratee() {
        var result2 = lodash2.iteratee || iteratee;
        result2 = result2 === iteratee ? baseIteratee2 : result2;
        return arguments.length ? result2(arguments[0], arguments[1]) : result2;
      }
      function getMapData2(map3, key) {
        var data2 = map3.__data__;
        return isKeyable2(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
      }
      function getMatchData2(object2) {
        var result2 = keys2(object2), length2 = result2.length;
        while (length2--) {
          var key = result2[length2], value = object2[key];
          result2[length2] = [key, value, isStrictComparable2(value)];
        }
        return result2;
      }
      function getNative2(object2, key) {
        var value = getValue2(object2, key);
        return baseIsNative2(value) ? value : undefined$1;
      }
      function getRawTag2(value) {
        var isOwn = hasOwnProperty2.call(value, symToStringTag2), tag = value[symToStringTag2];
        try {
          value[symToStringTag2] = undefined$1;
          var unmasked = true;
        } catch (e2) {
        }
        var result2 = nativeObjectToString2.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag2] = tag;
          } else {
            delete value[symToStringTag2];
          }
        }
        return result2;
      }
      var getSymbols2 = !nativeGetSymbols2 ? stubArray2 : function(object2) {
        if (object2 == null) {
          return [];
        }
        object2 = Object2(object2);
        return arrayFilter2(nativeGetSymbols2(object2), function(symbol) {
          return propertyIsEnumerable2.call(object2, symbol);
        });
      };
      var getSymbolsIn = !nativeGetSymbols2 ? stubArray2 : function(object2) {
        var result2 = [];
        while (object2) {
          arrayPush2(result2, getSymbols2(object2));
          object2 = getPrototype(object2);
        }
        return result2;
      };
      var getTag2 = baseGetTag2;
      if (DataView2 && getTag2(new DataView2(new ArrayBuffer(1))) != dataViewTag2 || Map2 && getTag2(new Map2()) != mapTag2 || Promise2 && getTag2(Promise2.resolve()) != promiseTag2 || Set2 && getTag2(new Set2()) != setTag2 || WeakMap2 && getTag2(new WeakMap2()) != weakMapTag2) {
        getTag2 = function(value) {
          var result2 = baseGetTag2(value), Ctor = result2 == objectTag2 ? value.constructor : undefined$1, ctorString = Ctor ? toSource2(Ctor) : "";
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString2:
                return dataViewTag2;
              case mapCtorString2:
                return mapTag2;
              case promiseCtorString2:
                return promiseTag2;
              case setCtorString2:
                return setTag2;
              case weakMapCtorString2:
                return weakMapTag2;
            }
          }
          return result2;
        };
      }
      function getView(start2, end2, transforms) {
        var index2 = -1, length2 = transforms.length;
        while (++index2 < length2) {
          var data2 = transforms[index2], size2 = data2.size;
          switch (data2.type) {
            case "drop":
              start2 += size2;
              break;
            case "dropRight":
              end2 -= size2;
              break;
            case "take":
              end2 = nativeMin(end2, start2 + size2);
              break;
            case "takeRight":
              start2 = nativeMax2(start2, end2 - size2);
              break;
          }
        }
        return { "start": start2, "end": end2 };
      }
      function getWrapDetails(source2) {
        var match2 = source2.match(reWrapDetails);
        return match2 ? match2[1].split(reSplitDetails) : [];
      }
      function hasPath2(object2, path, hasFunc) {
        path = castPath2(path, object2);
        var index2 = -1, length2 = path.length, result2 = false;
        while (++index2 < length2) {
          var key = toKey2(path[index2]);
          if (!(result2 = object2 != null && hasFunc(object2, key))) {
            break;
          }
          object2 = object2[key];
        }
        if (result2 || ++index2 != length2) {
          return result2;
        }
        length2 = object2 == null ? 0 : object2.length;
        return !!length2 && isLength2(length2) && isIndex2(key, length2) && (isArray2(object2) || isArguments2(object2));
      }
      function initCloneArray(array2) {
        var length2 = array2.length, result2 = new array2.constructor(length2);
        if (length2 && typeof array2[0] == "string" && hasOwnProperty2.call(array2, "index")) {
          result2.index = array2.index;
          result2.input = array2.input;
        }
        return result2;
      }
      function initCloneObject(object2) {
        return typeof object2.constructor == "function" && !isPrototype2(object2) ? baseCreate(getPrototype(object2)) : {};
      }
      function initCloneByTag(object2, tag, isDeep) {
        var Ctor = object2.constructor;
        switch (tag) {
          case arrayBufferTag2:
            return cloneArrayBuffer(object2);
          case boolTag2:
          case dateTag2:
            return new Ctor(+object2);
          case dataViewTag2:
            return cloneDataView(object2, isDeep);
          case float32Tag2:
          case float64Tag2:
          case int8Tag2:
          case int16Tag2:
          case int32Tag2:
          case uint8Tag2:
          case uint8ClampedTag2:
          case uint16Tag2:
          case uint32Tag2:
            return cloneTypedArray(object2, isDeep);
          case mapTag2:
            return new Ctor();
          case numberTag2:
          case stringTag2:
            return new Ctor(object2);
          case regexpTag2:
            return cloneRegExp(object2);
          case setTag2:
            return new Ctor();
          case symbolTag2:
            return cloneSymbol(object2);
        }
      }
      function insertWrapDetails(source2, details) {
        var length2 = details.length;
        if (!length2) {
          return source2;
        }
        var lastIndex = length2 - 1;
        details[lastIndex] = (length2 > 1 ? "& " : "") + details[lastIndex];
        details = details.join(length2 > 2 ? ", " : " ");
        return source2.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
      }
      function isFlattenable2(value) {
        return isArray2(value) || isArguments2(value) || !!(spreadableSymbol2 && value && value[spreadableSymbol2]);
      }
      function isIndex2(value, length2) {
        var type = typeof value;
        length2 = length2 == null ? MAX_SAFE_INTEGER2 : length2;
        return !!length2 && (type == "number" || type != "symbol" && reIsUint2.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
      }
      function isIterateeCall2(value, index2, object2) {
        if (!isObject2(object2)) {
          return false;
        }
        var type = typeof index2;
        if (type == "number" ? isArrayLike2(object2) && isIndex2(index2, object2.length) : type == "string" && index2 in object2) {
          return eq2(object2[index2], value);
        }
        return false;
      }
      function isKey2(value, object2) {
        if (isArray2(value)) {
          return false;
        }
        var type = typeof value;
        if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol2(value)) {
          return true;
        }
        return reIsPlainProp2.test(value) || !reIsDeepProp2.test(value) || object2 != null && value in Object2(object2);
      }
      function isKeyable2(value) {
        var type = typeof value;
        return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
      }
      function isLaziable(func) {
        var funcName = getFuncName(func), other = lodash2[funcName];
        if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
          return false;
        }
        if (func === other) {
          return true;
        }
        var data2 = getData(other);
        return !!data2 && func === data2[0];
      }
      function isMasked2(func) {
        return !!maskSrcKey2 && maskSrcKey2 in func;
      }
      var isMaskable = coreJsData2 ? isFunction3 : stubFalse2;
      function isPrototype2(value) {
        var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto2;
        return value === proto;
      }
      function isStrictComparable2(value) {
        return value === value && !isObject2(value);
      }
      function matchesStrictComparable2(key, srcValue) {
        return function(object2) {
          if (object2 == null) {
            return false;
          }
          return object2[key] === srcValue && (srcValue !== undefined$1 || key in Object2(object2));
        };
      }
      function memoizeCapped2(func) {
        var result2 = memoize2(func, function(key) {
          if (cache2.size === MAX_MEMOIZE_SIZE2) {
            cache2.clear();
          }
          return key;
        });
        var cache2 = result2.cache;
        return result2;
      }
      function mergeData(data2, source2) {
        var bitmask = data2[1], srcBitmask = source2[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
        var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data2[7].length <= source2[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source2[7].length <= source2[8] && bitmask == WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) {
          return data2;
        }
        if (srcBitmask & WRAP_BIND_FLAG) {
          data2[2] = source2[2];
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }
        var value = source2[3];
        if (value) {
          var partials = data2[3];
          data2[3] = partials ? composeArgs(partials, value, source2[4]) : value;
          data2[4] = partials ? replaceHolders(data2[3], PLACEHOLDER) : source2[4];
        }
        value = source2[5];
        if (value) {
          partials = data2[5];
          data2[5] = partials ? composeArgsRight(partials, value, source2[6]) : value;
          data2[6] = partials ? replaceHolders(data2[5], PLACEHOLDER) : source2[6];
        }
        value = source2[7];
        if (value) {
          data2[7] = value;
        }
        if (srcBitmask & WRAP_ARY_FLAG) {
          data2[8] = data2[8] == null ? source2[8] : nativeMin(data2[8], source2[8]);
        }
        if (data2[9] == null) {
          data2[9] = source2[9];
        }
        data2[0] = source2[0];
        data2[1] = newBitmask;
        return data2;
      }
      function nativeKeysIn(object2) {
        var result2 = [];
        if (object2 != null) {
          for (var key in Object2(object2)) {
            result2.push(key);
          }
        }
        return result2;
      }
      function objectToString2(value) {
        return nativeObjectToString2.call(value);
      }
      function overRest2(func, start2, transform3) {
        start2 = nativeMax2(start2 === undefined$1 ? func.length - 1 : start2, 0);
        return function() {
          var args = arguments, index2 = -1, length2 = nativeMax2(args.length - start2, 0), array2 = Array2(length2);
          while (++index2 < length2) {
            array2[index2] = args[start2 + index2];
          }
          index2 = -1;
          var otherArgs = Array2(start2 + 1);
          while (++index2 < start2) {
            otherArgs[index2] = args[index2];
          }
          otherArgs[start2] = transform3(array2);
          return apply2(func, this, otherArgs);
        };
      }
      function parent2(object2, path) {
        return path.length < 2 ? object2 : baseGet2(object2, baseSlice2(path, 0, -1));
      }
      function reorder(array2, indexes) {
        var arrLength = array2.length, length2 = nativeMin(indexes.length, arrLength), oldArray = copyArray(array2);
        while (length2--) {
          var index2 = indexes[length2];
          array2[length2] = isIndex2(index2, arrLength) ? oldArray[index2] : undefined$1;
        }
        return array2;
      }
      function safeGet(object2, key) {
        if (key === "constructor" && typeof object2[key] === "function") {
          return;
        }
        if (key == "__proto__") {
          return;
        }
        return object2[key];
      }
      var setData = shortOut2(baseSetData);
      var setTimeout2 = ctxSetTimeout || function(func, wait) {
        return root2.setTimeout(func, wait);
      };
      var setToString2 = shortOut2(baseSetToString2);
      function setWrapToString(wrapper, reference2, bitmask) {
        var source2 = reference2 + "";
        return setToString2(wrapper, insertWrapDetails(source2, updateWrapDetails(getWrapDetails(source2), bitmask)));
      }
      function shortOut2(func) {
        var count = 0, lastCalled = 0;
        return function() {
          var stamp = nativeNow2(), remaining = HOT_SPAN2 - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT2) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(undefined$1, arguments);
        };
      }
      function shuffleSelf(array2, size2) {
        var index2 = -1, length2 = array2.length, lastIndex = length2 - 1;
        size2 = size2 === undefined$1 ? length2 : size2;
        while (++index2 < size2) {
          var rand = baseRandom(index2, lastIndex), value = array2[rand];
          array2[rand] = array2[index2];
          array2[index2] = value;
        }
        array2.length = size2;
        return array2;
      }
      var stringToPath2 = memoizeCapped2(function(string2) {
        var result2 = [];
        if (string2.charCodeAt(0) === 46) {
          result2.push("");
        }
        string2.replace(rePropName2, function(match2, number2, quote, subString) {
          result2.push(quote ? subString.replace(reEscapeChar2, "$1") : number2 || match2);
        });
        return result2;
      });
      function toKey2(value) {
        if (typeof value == "string" || isSymbol2(value)) {
          return value;
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -INFINITY2 ? "-0" : result2;
      }
      function toSource2(func) {
        if (func != null) {
          try {
            return funcToString2.call(func);
          } catch (e2) {
          }
          try {
            return func + "";
          } catch (e2) {
          }
        }
        return "";
      }
      function updateWrapDetails(details, bitmask) {
        arrayEach(wrapFlags, function(pair) {
          var value = "_." + pair[0];
          if (bitmask & pair[1] && !arrayIncludes2(details, value)) {
            details.push(value);
          }
        });
        return details.sort();
      }
      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }
        var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result2.__actions__ = copyArray(wrapper.__actions__);
        result2.__index__ = wrapper.__index__;
        result2.__values__ = wrapper.__values__;
        return result2;
      }
      function chunk(array2, size2, guard) {
        if (guard ? isIterateeCall2(array2, size2, guard) : size2 === undefined$1) {
          size2 = 1;
        } else {
          size2 = nativeMax2(toInteger2(size2), 0);
        }
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2 || size2 < 1) {
          return [];
        }
        var index2 = 0, resIndex = 0, result2 = Array2(nativeCeil(length2 / size2));
        while (index2 < length2) {
          result2[resIndex++] = baseSlice2(array2, index2, index2 += size2);
        }
        return result2;
      }
      function compact2(array2) {
        var index2 = -1, length2 = array2 == null ? 0 : array2.length, resIndex = 0, result2 = [];
        while (++index2 < length2) {
          var value = array2[index2];
          if (value) {
            result2[resIndex++] = value;
          }
        }
        return result2;
      }
      function concat() {
        var length2 = arguments.length;
        if (!length2) {
          return [];
        }
        var args = Array2(length2 - 1), array2 = arguments[0], index2 = length2;
        while (index2--) {
          args[index2 - 1] = arguments[index2];
        }
        return arrayPush2(isArray2(array2) ? copyArray(array2) : [array2], baseFlatten2(args, 1));
      }
      var difference = baseRest2(function(array2, values2) {
        return isArrayLikeObject(array2) ? baseDifference(array2, baseFlatten2(values2, 1, isArrayLikeObject, true)) : [];
      });
      var differenceBy = baseRest2(function(array2, values2) {
        var iteratee2 = last(values2);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return isArrayLikeObject(array2) ? baseDifference(array2, baseFlatten2(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
      });
      var differenceWith = baseRest2(function(array2, values2) {
        var comparator = last(values2);
        if (isArrayLikeObject(comparator)) {
          comparator = undefined$1;
        }
        return isArrayLikeObject(array2) ? baseDifference(array2, baseFlatten2(values2, 1, isArrayLikeObject, true), undefined$1, comparator) : [];
      });
      function drop(array2, n2, guard) {
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2) {
          return [];
        }
        n2 = guard || n2 === undefined$1 ? 1 : toInteger2(n2);
        return baseSlice2(array2, n2 < 0 ? 0 : n2, length2);
      }
      function dropRight2(array2, n2, guard) {
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2) {
          return [];
        }
        n2 = guard || n2 === undefined$1 ? 1 : toInteger2(n2);
        n2 = length2 - n2;
        return baseSlice2(array2, 0, n2 < 0 ? 0 : n2);
      }
      function dropRightWhile(array2, predicate) {
        return array2 && array2.length ? baseWhile(array2, getIteratee(predicate, 3), true, true) : [];
      }
      function dropWhile(array2, predicate) {
        return array2 && array2.length ? baseWhile(array2, getIteratee(predicate, 3), true) : [];
      }
      function fill(array2, value, start2, end2) {
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2) {
          return [];
        }
        if (start2 && typeof start2 != "number" && isIterateeCall2(array2, value, start2)) {
          start2 = 0;
          end2 = length2;
        }
        return baseFill(array2, value, start2, end2);
      }
      function findIndex2(array2, predicate, fromIndex) {
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger2(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax2(length2 + index2, 0);
        }
        return baseFindIndex2(array2, getIteratee(predicate, 3), index2);
      }
      function findLastIndex(array2, predicate, fromIndex) {
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2) {
          return -1;
        }
        var index2 = length2 - 1;
        if (fromIndex !== undefined$1) {
          index2 = toInteger2(fromIndex);
          index2 = fromIndex < 0 ? nativeMax2(length2 + index2, 0) : nativeMin(index2, length2 - 1);
        }
        return baseFindIndex2(array2, getIteratee(predicate, 3), index2, true);
      }
      function flatten2(array2) {
        var length2 = array2 == null ? 0 : array2.length;
        return length2 ? baseFlatten2(array2, 1) : [];
      }
      function flattenDeep(array2) {
        var length2 = array2 == null ? 0 : array2.length;
        return length2 ? baseFlatten2(array2, INFINITY2) : [];
      }
      function flattenDepth(array2, depth) {
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2) {
          return [];
        }
        depth = depth === undefined$1 ? 1 : toInteger2(depth);
        return baseFlatten2(array2, depth);
      }
      function fromPairs(pairs) {
        var index2 = -1, length2 = pairs == null ? 0 : pairs.length, result2 = {};
        while (++index2 < length2) {
          var pair = pairs[index2];
          result2[pair[0]] = pair[1];
        }
        return result2;
      }
      function head(array2) {
        return array2 && array2.length ? array2[0] : undefined$1;
      }
      function indexOf(array2, value, fromIndex) {
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger2(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax2(length2 + index2, 0);
        }
        return baseIndexOf2(array2, value, index2);
      }
      function initial(array2) {
        var length2 = array2 == null ? 0 : array2.length;
        return length2 ? baseSlice2(array2, 0, -1) : [];
      }
      var intersection = baseRest2(function(arrays) {
        var mapped = arrayMap2(arrays, castArrayLikeObject);
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
      });
      var intersectionBy = baseRest2(function(arrays) {
        var iteratee2 = last(arrays), mapped = arrayMap2(arrays, castArrayLikeObject);
        if (iteratee2 === last(mapped)) {
          iteratee2 = undefined$1;
        } else {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
      });
      var intersectionWith = baseRest2(function(arrays) {
        var comparator = last(arrays), mapped = arrayMap2(arrays, castArrayLikeObject);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        if (comparator) {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
      });
      function join(array2, separator) {
        return array2 == null ? "" : nativeJoin.call(array2, separator);
      }
      function last(array2) {
        var length2 = array2 == null ? 0 : array2.length;
        return length2 ? array2[length2 - 1] : undefined$1;
      }
      function lastIndexOf(array2, value, fromIndex) {
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2) {
          return -1;
        }
        var index2 = length2;
        if (fromIndex !== undefined$1) {
          index2 = toInteger2(fromIndex);
          index2 = index2 < 0 ? nativeMax2(length2 + index2, 0) : nativeMin(index2, length2 - 1);
        }
        return value === value ? strictLastIndexOf(array2, value, index2) : baseFindIndex2(array2, baseIsNaN2, index2, true);
      }
      function nth(array2, n2) {
        return array2 && array2.length ? baseNth(array2, toInteger2(n2)) : undefined$1;
      }
      var pull = baseRest2(pullAll);
      function pullAll(array2, values2) {
        return array2 && array2.length && values2 && values2.length ? basePullAll(array2, values2) : array2;
      }
      function pullAllBy(array2, values2, iteratee2) {
        return array2 && array2.length && values2 && values2.length ? basePullAll(array2, values2, getIteratee(iteratee2, 2)) : array2;
      }
      function pullAllWith(array2, values2, comparator) {
        return array2 && array2.length && values2 && values2.length ? basePullAll(array2, values2, undefined$1, comparator) : array2;
      }
      var pullAt = flatRest(function(array2, indexes) {
        var length2 = array2 == null ? 0 : array2.length, result2 = baseAt(array2, indexes);
        basePullAt(array2, arrayMap2(indexes, function(index2) {
          return isIndex2(index2, length2) ? +index2 : index2;
        }).sort(compareAscending2));
        return result2;
      });
      function remove2(array2, predicate) {
        var result2 = [];
        if (!(array2 && array2.length)) {
          return result2;
        }
        var index2 = -1, indexes = [], length2 = array2.length;
        predicate = getIteratee(predicate, 3);
        while (++index2 < length2) {
          var value = array2[index2];
          if (predicate(value, index2, array2)) {
            result2.push(value);
            indexes.push(index2);
          }
        }
        basePullAt(array2, indexes);
        return result2;
      }
      function reverse(array2) {
        return array2 == null ? array2 : nativeReverse.call(array2);
      }
      function slice2(array2, start2, end2) {
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2) {
          return [];
        }
        if (end2 && typeof end2 != "number" && isIterateeCall2(array2, start2, end2)) {
          start2 = 0;
          end2 = length2;
        } else {
          start2 = start2 == null ? 0 : toInteger2(start2);
          end2 = end2 === undefined$1 ? length2 : toInteger2(end2);
        }
        return baseSlice2(array2, start2, end2);
      }
      function sortedIndex(array2, value) {
        return baseSortedIndex(array2, value);
      }
      function sortedIndexBy(array2, value, iteratee2) {
        return baseSortedIndexBy(array2, value, getIteratee(iteratee2, 2));
      }
      function sortedIndexOf(array2, value) {
        var length2 = array2 == null ? 0 : array2.length;
        if (length2) {
          var index2 = baseSortedIndex(array2, value);
          if (index2 < length2 && eq2(array2[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedLastIndex(array2, value) {
        return baseSortedIndex(array2, value, true);
      }
      function sortedLastIndexBy(array2, value, iteratee2) {
        return baseSortedIndexBy(array2, value, getIteratee(iteratee2, 2), true);
      }
      function sortedLastIndexOf(array2, value) {
        var length2 = array2 == null ? 0 : array2.length;
        if (length2) {
          var index2 = baseSortedIndex(array2, value, true) - 1;
          if (eq2(array2[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedUniq(array2) {
        return array2 && array2.length ? baseSortedUniq(array2) : [];
      }
      function sortedUniqBy(array2, iteratee2) {
        return array2 && array2.length ? baseSortedUniq(array2, getIteratee(iteratee2, 2)) : [];
      }
      function tail(array2) {
        var length2 = array2 == null ? 0 : array2.length;
        return length2 ? baseSlice2(array2, 1, length2) : [];
      }
      function take(array2, n2, guard) {
        if (!(array2 && array2.length)) {
          return [];
        }
        n2 = guard || n2 === undefined$1 ? 1 : toInteger2(n2);
        return baseSlice2(array2, 0, n2 < 0 ? 0 : n2);
      }
      function takeRight(array2, n2, guard) {
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2) {
          return [];
        }
        n2 = guard || n2 === undefined$1 ? 1 : toInteger2(n2);
        n2 = length2 - n2;
        return baseSlice2(array2, n2 < 0 ? 0 : n2, length2);
      }
      function takeRightWhile(array2, predicate) {
        return array2 && array2.length ? baseWhile(array2, getIteratee(predicate, 3), false, true) : [];
      }
      function takeWhile(array2, predicate) {
        return array2 && array2.length ? baseWhile(array2, getIteratee(predicate, 3)) : [];
      }
      var union = baseRest2(function(arrays) {
        return baseUniq2(baseFlatten2(arrays, 1, isArrayLikeObject, true));
      });
      var unionBy = baseRest2(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseUniq2(baseFlatten2(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
      });
      var unionWith = baseRest2(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseUniq2(baseFlatten2(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
      });
      function uniq2(array2) {
        return array2 && array2.length ? baseUniq2(array2) : [];
      }
      function uniqBy(array2, iteratee2) {
        return array2 && array2.length ? baseUniq2(array2, getIteratee(iteratee2, 2)) : [];
      }
      function uniqWith2(array2, comparator) {
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return array2 && array2.length ? baseUniq2(array2, undefined$1, comparator) : [];
      }
      function unzip(array2) {
        if (!(array2 && array2.length)) {
          return [];
        }
        var length2 = 0;
        array2 = arrayFilter2(array2, function(group) {
          if (isArrayLikeObject(group)) {
            length2 = nativeMax2(group.length, length2);
            return true;
          }
        });
        return baseTimes2(length2, function(index2) {
          return arrayMap2(array2, baseProperty2(index2));
        });
      }
      function unzipWith(array2, iteratee2) {
        if (!(array2 && array2.length)) {
          return [];
        }
        var result2 = unzip(array2);
        if (iteratee2 == null) {
          return result2;
        }
        return arrayMap2(result2, function(group) {
          return apply2(iteratee2, undefined$1, group);
        });
      }
      var without = baseRest2(function(array2, values2) {
        return isArrayLikeObject(array2) ? baseDifference(array2, values2) : [];
      });
      var xor = baseRest2(function(arrays) {
        return baseXor(arrayFilter2(arrays, isArrayLikeObject));
      });
      var xorBy = baseRest2(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseXor(arrayFilter2(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
      });
      var xorWith = baseRest2(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseXor(arrayFilter2(arrays, isArrayLikeObject), undefined$1, comparator);
      });
      var zip = baseRest2(unzip);
      function zipObject(props, values2) {
        return baseZipObject(props || [], values2 || [], assignValue);
      }
      function zipObjectDeep(props, values2) {
        return baseZipObject(props || [], values2 || [], baseSet);
      }
      var zipWith = baseRest2(function(arrays) {
        var length2 = arrays.length, iteratee2 = length2 > 1 ? arrays[length2 - 1] : undefined$1;
        iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined$1;
        return unzipWith(arrays, iteratee2);
      });
      function chain(value) {
        var result2 = lodash2(value);
        result2.__chain__ = true;
        return result2;
      }
      function tap(value, interceptor) {
        interceptor(value);
        return value;
      }
      function thru(value, interceptor) {
        return interceptor(value);
      }
      var wrapperAt = flatRest(function(paths) {
        var length2 = paths.length, start2 = length2 ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object2) {
          return baseAt(object2, paths);
        };
        if (length2 > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex2(start2)) {
          return this.thru(interceptor);
        }
        value = value.slice(start2, +start2 + (length2 ? 1 : 0));
        value.__actions__.push({
          "func": thru,
          "args": [interceptor],
          "thisArg": undefined$1
        });
        return new LodashWrapper(value, this.__chain__).thru(function(array2) {
          if (length2 && !array2.length) {
            array2.push(undefined$1);
          }
          return array2;
        });
      });
      function wrapperChain() {
        return chain(this);
      }
      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }
      function wrapperNext() {
        if (this.__values__ === undefined$1) {
          this.__values__ = toArray2(this.value());
        }
        var done = this.__index__ >= this.__values__.length, value = done ? undefined$1 : this.__values__[this.__index__++];
        return { "done": done, "value": value };
      }
      function wrapperToIterator() {
        return this;
      }
      function wrapperPlant(value) {
        var result2, parent3 = this;
        while (parent3 instanceof baseLodash) {
          var clone3 = wrapperClone(parent3);
          clone3.__index__ = 0;
          clone3.__values__ = undefined$1;
          if (result2) {
            previous.__wrapped__ = clone3;
          } else {
            result2 = clone3;
          }
          var previous = clone3;
          parent3 = parent3.__wrapped__;
        }
        previous.__wrapped__ = value;
        return result2;
      }
      function wrapperReverse() {
        var value = this.__wrapped__;
        if (value instanceof LazyWrapper) {
          var wrapped = value;
          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }
          wrapped = wrapped.reverse();
          wrapped.__actions__.push({
            "func": thru,
            "args": [reverse],
            "thisArg": undefined$1
          });
          return new LodashWrapper(wrapped, this.__chain__);
        }
        return this.thru(reverse);
      }
      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }
      var countBy = createAggregator2(function(result2, value, key) {
        if (hasOwnProperty2.call(result2, key)) {
          ++result2[key];
        } else {
          baseAssignValue2(result2, key, 1);
        }
      });
      function every(collection, predicate, guard) {
        var func = isArray2(collection) ? arrayEvery : baseEvery;
        if (guard && isIterateeCall2(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      function filter2(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter2 : baseFilter;
        return func(collection, getIteratee(predicate, 3));
      }
      var find2 = createFind(findIndex2);
      var findLast = createFind(findLastIndex);
      function flatMap(collection, iteratee2) {
        return baseFlatten2(map2(collection, iteratee2), 1);
      }
      function flatMapDeep(collection, iteratee2) {
        return baseFlatten2(map2(collection, iteratee2), INFINITY2);
      }
      function flatMapDepth(collection, iteratee2, depth) {
        depth = depth === undefined$1 ? 1 : toInteger2(depth);
        return baseFlatten2(map2(collection, iteratee2), depth);
      }
      function forEach3(collection, iteratee2) {
        var func = isArray2(collection) ? arrayEach : baseEach2;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function forEachRight(collection, iteratee2) {
        var func = isArray2(collection) ? arrayEachRight : baseEachRight;
        return func(collection, getIteratee(iteratee2, 3));
      }
      var groupBy2 = createAggregator2(function(result2, value, key) {
        if (hasOwnProperty2.call(result2, key)) {
          result2[key].push(value);
        } else {
          baseAssignValue2(result2, key, [value]);
        }
      });
      function includes(collection, value, fromIndex, guard) {
        collection = isArrayLike2(collection) ? collection : values(collection);
        fromIndex = fromIndex && !guard ? toInteger2(fromIndex) : 0;
        var length2 = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax2(length2 + fromIndex, 0);
        }
        return isString2(collection) ? fromIndex <= length2 && collection.indexOf(value, fromIndex) > -1 : !!length2 && baseIndexOf2(collection, value, fromIndex) > -1;
      }
      var invokeMap = baseRest2(function(collection, path, args) {
        var index2 = -1, isFunc = typeof path == "function", result2 = isArrayLike2(collection) ? Array2(collection.length) : [];
        baseEach2(collection, function(value) {
          result2[++index2] = isFunc ? apply2(path, value, args) : baseInvoke(value, path, args);
        });
        return result2;
      });
      var keyBy = createAggregator2(function(result2, value, key) {
        baseAssignValue2(result2, key, value);
      });
      function map2(collection, iteratee2) {
        var func = isArray2(collection) ? arrayMap2 : baseMap2;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function orderBy(collection, iteratees, orders, guard) {
        if (collection == null) {
          return [];
        }
        if (!isArray2(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }
        orders = guard ? undefined$1 : orders;
        if (!isArray2(orders)) {
          orders = orders == null ? [] : [orders];
        }
        return baseOrderBy2(collection, iteratees, orders);
      }
      var partition = createAggregator2(function(result2, value, key) {
        result2[key ? 0 : 1].push(value);
      }, function() {
        return [[], []];
      });
      function reduce(collection, iteratee2, accumulator) {
        var func = isArray2(collection) ? arrayReduce2 : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach2);
      }
      function reduceRight(collection, iteratee2, accumulator) {
        var func = isArray2(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
      }
      function reject(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter2 : baseFilter;
        return func(collection, negate(getIteratee(predicate, 3)));
      }
      function sample(collection) {
        var func = isArray2(collection) ? arraySample : baseSample;
        return func(collection);
      }
      function sampleSize(collection, n2, guard) {
        if (guard ? isIterateeCall2(collection, n2, guard) : n2 === undefined$1) {
          n2 = 1;
        } else {
          n2 = toInteger2(n2);
        }
        var func = isArray2(collection) ? arraySampleSize : baseSampleSize;
        return func(collection, n2);
      }
      function shuffle(collection) {
        var func = isArray2(collection) ? arrayShuffle : baseShuffle;
        return func(collection);
      }
      function size(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike2(collection)) {
          return isString2(collection) ? stringSize(collection) : collection.length;
        }
        var tag = getTag2(collection);
        if (tag == mapTag2 || tag == setTag2) {
          return collection.size;
        }
        return baseKeys2(collection).length;
      }
      function some(collection, predicate, guard) {
        var func = isArray2(collection) ? arraySome2 : baseSome;
        if (guard && isIterateeCall2(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      var sortBy2 = baseRest2(function(collection, iteratees) {
        if (collection == null) {
          return [];
        }
        var length2 = iteratees.length;
        if (length2 > 1 && isIterateeCall2(collection, iteratees[0], iteratees[1])) {
          iteratees = [];
        } else if (length2 > 2 && isIterateeCall2(iteratees[0], iteratees[1], iteratees[2])) {
          iteratees = [iteratees[0]];
        }
        return baseOrderBy2(collection, baseFlatten2(iteratees, 1), []);
      });
      var now2 = ctxNow || function() {
        return root2.Date.now();
      };
      function after(n2, func) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        n2 = toInteger2(n2);
        return function() {
          if (--n2 < 1) {
            return func.apply(this, arguments);
          }
        };
      }
      function ary(func, n2, guard) {
        n2 = guard ? undefined$1 : n2;
        n2 = func && n2 == null ? func.length : n2;
        return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n2);
      }
      function before(n2, func) {
        var result2;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        n2 = toInteger2(n2);
        return function() {
          if (--n2 > 0) {
            result2 = func.apply(this, arguments);
          }
          if (n2 <= 1) {
            func = undefined$1;
          }
          return result2;
        };
      }
      var bind3 = baseRest2(function(func, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind3));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(func, bitmask, thisArg, partials, holders);
      });
      var bindKey = baseRest2(function(object2, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(key, bitmask, object2, partials, holders);
      });
      function curry(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result2.placeholder = curry.placeholder;
        return result2;
      }
      function curryRight(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result2.placeholder = curryRight.placeholder;
        return result2;
      }
      function debounce2(func, wait, options2) {
        var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        wait = toNumber2(wait) || 0;
        if (isObject2(options2)) {
          leading = !!options2.leading;
          maxing = "maxWait" in options2;
          maxWait = maxing ? nativeMax2(toNumber2(options2.maxWait) || 0, wait) : maxWait;
          trailing = "trailing" in options2 ? !!options2.trailing : trailing;
        }
        function invokeFunc(time) {
          var args = lastArgs, thisArg = lastThis;
          lastArgs = lastThis = undefined$1;
          lastInvokeTime = time;
          result2 = func.apply(thisArg, args);
          return result2;
        }
        function leadingEdge(time) {
          lastInvokeTime = time;
          timerId = setTimeout2(timerExpired, wait);
          return leading ? invokeFunc(time) : result2;
        }
        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
          return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time = now2();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          timerId = setTimeout2(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
          timerId = undefined$1;
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined$1;
          return result2;
        }
        function cancel() {
          if (timerId !== undefined$1) {
            clearTimeout2(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$1;
        }
        function flush() {
          return timerId === undefined$1 ? result2 : trailingEdge(now2());
        }
        function debounced() {
          var time = now2(), isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;
          if (isInvoking) {
            if (timerId === undefined$1) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              clearTimeout2(timerId);
              timerId = setTimeout2(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined$1) {
            timerId = setTimeout2(timerExpired, wait);
          }
          return result2;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }
      var defer2 = baseRest2(function(func, args) {
        return baseDelay(func, 1, args);
      });
      var delay = baseRest2(function(func, wait, args) {
        return baseDelay(func, toNumber2(wait) || 0, args);
      });
      function flip2(func) {
        return createWrap(func, WRAP_FLIP_FLAG);
      }
      function memoize2(func, resolver) {
        if (typeof func != "function" || resolver != null && typeof resolver != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        var memoized = function() {
          var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache2 = memoized.cache;
          if (cache2.has(key)) {
            return cache2.get(key);
          }
          var result2 = func.apply(this, args);
          memoized.cache = cache2.set(key, result2) || cache2;
          return result2;
        };
        memoized.cache = new (memoize2.Cache || MapCache2)();
        return memoized;
      }
      memoize2.Cache = MapCache2;
      function negate(predicate) {
        if (typeof predicate != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }
      function once2(func) {
        return before(2, func);
      }
      var overArgs = castRest(function(func, transforms) {
        transforms = transforms.length == 1 && isArray2(transforms[0]) ? arrayMap2(transforms[0], baseUnary2(getIteratee())) : arrayMap2(baseFlatten2(transforms, 1), baseUnary2(getIteratee()));
        var funcsLength = transforms.length;
        return baseRest2(function(args) {
          var index2 = -1, length2 = nativeMin(args.length, funcsLength);
          while (++index2 < length2) {
            args[index2] = transforms[index2].call(this, args[index2]);
          }
          return apply2(func, this, args);
        });
      });
      var partial = baseRest2(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
      });
      var partialRight = baseRest2(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
      });
      var rearg = flatRest(function(func, indexes) {
        return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
      });
      function rest(func, start2) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        start2 = start2 === undefined$1 ? start2 : toInteger2(start2);
        return baseRest2(func, start2);
      }
      function spread3(func, start2) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        start2 = start2 == null ? 0 : nativeMax2(toInteger2(start2), 0);
        return baseRest2(function(args) {
          var array2 = args[start2], otherArgs = castSlice2(args, 0, start2);
          if (array2) {
            arrayPush2(otherArgs, array2);
          }
          return apply2(func, this, otherArgs);
        });
      }
      function throttle(func, wait, options2) {
        var leading = true, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        if (isObject2(options2)) {
          leading = "leading" in options2 ? !!options2.leading : leading;
          trailing = "trailing" in options2 ? !!options2.trailing : trailing;
        }
        return debounce2(func, wait, {
          "leading": leading,
          "maxWait": wait,
          "trailing": trailing
        });
      }
      function unary(func) {
        return ary(func, 1);
      }
      function wrap(value, wrapper) {
        return partial(castFunction(wrapper), value);
      }
      function castArray() {
        if (!arguments.length) {
          return [];
        }
        var value = arguments[0];
        return isArray2(value) ? value : [value];
      }
      function clone2(value) {
        return baseClone2(value, CLONE_SYMBOLS_FLAG);
      }
      function cloneWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone2(value, CLONE_SYMBOLS_FLAG, customizer);
      }
      function cloneDeep(value) {
        return baseClone2(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }
      function cloneDeepWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone2(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
      }
      function conformsTo(object2, source2) {
        return source2 == null || baseConformsTo(object2, source2, keys2(source2));
      }
      function eq2(value, other) {
        return value === other || value !== value && other !== other;
      }
      var gt = createRelationalOperation(baseGt);
      var gte = createRelationalOperation(function(value, other) {
        return value >= other;
      });
      var isArguments2 = baseIsArguments2(function() {
        return arguments;
      }()) ? baseIsArguments2 : function(value) {
        return isObjectLike2(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable2.call(value, "callee");
      };
      var isArray2 = Array2.isArray;
      var isArrayBuffer2 = nodeIsArrayBuffer ? baseUnary2(nodeIsArrayBuffer) : baseIsArrayBuffer;
      function isArrayLike2(value) {
        return value != null && isLength2(value.length) && !isFunction3(value);
      }
      function isArrayLikeObject(value) {
        return isObjectLike2(value) && isArrayLike2(value);
      }
      function isBoolean2(value) {
        return value === true || value === false || isObjectLike2(value) && baseGetTag2(value) == boolTag2;
      }
      var isBuffer2 = nativeIsBuffer || stubFalse2;
      var isDate2 = nodeIsDate ? baseUnary2(nodeIsDate) : baseIsDate;
      function isElement2(value) {
        return isObjectLike2(value) && value.nodeType === 1 && !isPlainObject2(value);
      }
      function isEmpty2(value) {
        if (value == null) {
          return true;
        }
        if (isArrayLike2(value) && (isArray2(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer2(value) || isTypedArray2(value) || isArguments2(value))) {
          return !value.length;
        }
        var tag = getTag2(value);
        if (tag == mapTag2 || tag == setTag2) {
          return !value.size;
        }
        if (isPrototype2(value)) {
          return !baseKeys2(value).length;
        }
        for (var key in value) {
          if (hasOwnProperty2.call(value, key)) {
            return false;
          }
        }
        return true;
      }
      function isEqual3(value, other) {
        return baseIsEqual2(value, other);
      }
      function isEqualWith(value, other, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        var result2 = customizer ? customizer(value, other) : undefined$1;
        return result2 === undefined$1 ? baseIsEqual2(value, other, undefined$1, customizer) : !!result2;
      }
      function isError(value) {
        if (!isObjectLike2(value)) {
          return false;
        }
        var tag = baseGetTag2(value);
        return tag == errorTag2 || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject2(value);
      }
      function isFinite2(value) {
        return typeof value == "number" && nativeIsFinite(value);
      }
      function isFunction3(value) {
        if (!isObject2(value)) {
          return false;
        }
        var tag = baseGetTag2(value);
        return tag == funcTag2 || tag == genTag2 || tag == asyncTag2 || tag == proxyTag2;
      }
      function isInteger(value) {
        return typeof value == "number" && value == toInteger2(value);
      }
      function isLength2(value) {
        return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
      }
      function isObject2(value) {
        var type = typeof value;
        return value != null && (type == "object" || type == "function");
      }
      function isObjectLike2(value) {
        return value != null && typeof value == "object";
      }
      var isMap = nodeIsMap ? baseUnary2(nodeIsMap) : baseIsMap;
      function isMatch(object2, source2) {
        return object2 === source2 || baseIsMatch2(object2, source2, getMatchData2(source2));
      }
      function isMatchWith(object2, source2, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseIsMatch2(object2, source2, getMatchData2(source2), customizer);
      }
      function isNaN2(value) {
        return isNumber2(value) && value != +value;
      }
      function isNative(value) {
        if (isMaskable(value)) {
          throw new Error2(CORE_ERROR_TEXT);
        }
        return baseIsNative2(value);
      }
      function isNull(value) {
        return value === null;
      }
      function isNil2(value) {
        return value == null;
      }
      function isNumber2(value) {
        return typeof value == "number" || isObjectLike2(value) && baseGetTag2(value) == numberTag2;
      }
      function isPlainObject2(value) {
        if (!isObjectLike2(value) || baseGetTag2(value) != objectTag2) {
          return false;
        }
        var proto = getPrototype(value);
        if (proto === null) {
          return true;
        }
        var Ctor = hasOwnProperty2.call(proto, "constructor") && proto.constructor;
        return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString2.call(Ctor) == objectCtorString;
      }
      var isRegExp = nodeIsRegExp ? baseUnary2(nodeIsRegExp) : baseIsRegExp;
      function isSafeInteger(value) {
        return isInteger(value) && value >= -MAX_SAFE_INTEGER2 && value <= MAX_SAFE_INTEGER2;
      }
      var isSet = nodeIsSet ? baseUnary2(nodeIsSet) : baseIsSet;
      function isString2(value) {
        return typeof value == "string" || !isArray2(value) && isObjectLike2(value) && baseGetTag2(value) == stringTag2;
      }
      function isSymbol2(value) {
        return typeof value == "symbol" || isObjectLike2(value) && baseGetTag2(value) == symbolTag2;
      }
      var isTypedArray2 = nodeIsTypedArray2 ? baseUnary2(nodeIsTypedArray2) : baseIsTypedArray2;
      function isUndefined2(value) {
        return value === undefined$1;
      }
      function isWeakMap(value) {
        return isObjectLike2(value) && getTag2(value) == weakMapTag2;
      }
      function isWeakSet(value) {
        return isObjectLike2(value) && baseGetTag2(value) == weakSetTag;
      }
      var lt = createRelationalOperation(baseLt);
      var lte = createRelationalOperation(function(value, other) {
        return value <= other;
      });
      function toArray2(value) {
        if (!value) {
          return [];
        }
        if (isArrayLike2(value)) {
          return isString2(value) ? stringToArray2(value) : copyArray(value);
        }
        if (symIterator && value[symIterator]) {
          return iteratorToArray(value[symIterator]());
        }
        var tag = getTag2(value), func = tag == mapTag2 ? mapToArray2 : tag == setTag2 ? setToArray2 : values;
        return func(value);
      }
      function toFinite2(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber2(value);
        if (value === INFINITY2 || value === -INFINITY2) {
          var sign = value < 0 ? -1 : 1;
          return sign * MAX_INTEGER2;
        }
        return value === value ? value : 0;
      }
      function toInteger2(value) {
        var result2 = toFinite2(value), remainder = result2 % 1;
        return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
      }
      function toLength(value) {
        return value ? baseClamp(toInteger2(value), 0, MAX_ARRAY_LENGTH2) : 0;
      }
      function toNumber2(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol2(value)) {
          return NAN2;
        }
        if (isObject2(value)) {
          var other = typeof value.valueOf == "function" ? value.valueOf() : value;
          value = isObject2(other) ? other + "" : other;
        }
        if (typeof value != "string") {
          return value === 0 ? value : +value;
        }
        value = baseTrim2(value);
        var isBinary = reIsBinary2.test(value);
        return isBinary || reIsOctal2.test(value) ? freeParseInt2(value.slice(2), isBinary ? 2 : 8) : reIsBadHex2.test(value) ? NAN2 : +value;
      }
      function toPlainObject(value) {
        return copyObject(value, keysIn(value));
      }
      function toSafeInteger(value) {
        return value ? baseClamp(toInteger2(value), -MAX_SAFE_INTEGER2, MAX_SAFE_INTEGER2) : value === 0 ? value : 0;
      }
      function toString3(value) {
        return value == null ? "" : baseToString2(value);
      }
      var assign2 = createAssigner(function(object2, source2) {
        if (isPrototype2(source2) || isArrayLike2(source2)) {
          copyObject(source2, keys2(source2), object2);
          return;
        }
        for (var key in source2) {
          if (hasOwnProperty2.call(source2, key)) {
            assignValue(object2, key, source2[key]);
          }
        }
      });
      var assignIn = createAssigner(function(object2, source2) {
        copyObject(source2, keysIn(source2), object2);
      });
      var assignInWith = createAssigner(function(object2, source2, srcIndex, customizer) {
        copyObject(source2, keysIn(source2), object2, customizer);
      });
      var assignWith = createAssigner(function(object2, source2, srcIndex, customizer) {
        copyObject(source2, keys2(source2), object2, customizer);
      });
      var at = flatRest(baseAt);
      function create2(prototype, properties) {
        var result2 = baseCreate(prototype);
        return properties == null ? result2 : baseAssign(result2, properties);
      }
      var defaults2 = baseRest2(function(object2, sources) {
        object2 = Object2(object2);
        var index2 = -1;
        var length2 = sources.length;
        var guard = length2 > 2 ? sources[2] : undefined$1;
        if (guard && isIterateeCall2(sources[0], sources[1], guard)) {
          length2 = 1;
        }
        while (++index2 < length2) {
          var source2 = sources[index2];
          var props = keysIn(source2);
          var propsIndex = -1;
          var propsLength = props.length;
          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value = object2[key];
            if (value === undefined$1 || eq2(value, objectProto2[key]) && !hasOwnProperty2.call(object2, key)) {
              object2[key] = source2[key];
            }
          }
        }
        return object2;
      });
      var defaultsDeep = baseRest2(function(args) {
        args.push(undefined$1, customDefaultsMerge);
        return apply2(mergeWith, undefined$1, args);
      });
      function findKey2(object2, predicate) {
        return baseFindKey(object2, getIteratee(predicate, 3), baseForOwn2);
      }
      function findLastKey(object2, predicate) {
        return baseFindKey(object2, getIteratee(predicate, 3), baseForOwnRight);
      }
      function forIn(object2, iteratee2) {
        return object2 == null ? object2 : baseFor2(object2, getIteratee(iteratee2, 3), keysIn);
      }
      function forInRight(object2, iteratee2) {
        return object2 == null ? object2 : baseForRight(object2, getIteratee(iteratee2, 3), keysIn);
      }
      function forOwn(object2, iteratee2) {
        return object2 && baseForOwn2(object2, getIteratee(iteratee2, 3));
      }
      function forOwnRight(object2, iteratee2) {
        return object2 && baseForOwnRight(object2, getIteratee(iteratee2, 3));
      }
      function functions(object2) {
        return object2 == null ? [] : baseFunctions(object2, keys2(object2));
      }
      function functionsIn(object2) {
        return object2 == null ? [] : baseFunctions(object2, keysIn(object2));
      }
      function get2(object2, path, defaultValue) {
        var result2 = object2 == null ? undefined$1 : baseGet2(object2, path);
        return result2 === undefined$1 ? defaultValue : result2;
      }
      function has2(object2, path) {
        return object2 != null && hasPath2(object2, path, baseHas2);
      }
      function hasIn2(object2, path) {
        return object2 != null && hasPath2(object2, path, baseHasIn2);
      }
      var invert = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString2.call(value);
        }
        result2[value] = key;
      }, constant2(identity2));
      var invertBy = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString2.call(value);
        }
        if (hasOwnProperty2.call(result2, value)) {
          result2[value].push(key);
        } else {
          result2[value] = [key];
        }
      }, getIteratee);
      var invoke = baseRest2(baseInvoke);
      function keys2(object2) {
        return isArrayLike2(object2) ? arrayLikeKeys2(object2) : baseKeys2(object2);
      }
      function keysIn(object2) {
        return isArrayLike2(object2) ? arrayLikeKeys2(object2, true) : baseKeysIn(object2);
      }
      function mapKeys2(object2, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn2(object2, function(value, key, object3) {
          baseAssignValue2(result2, iteratee2(value, key, object3), value);
        });
        return result2;
      }
      function mapValues2(object2, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn2(object2, function(value, key, object3) {
          baseAssignValue2(result2, key, iteratee2(value, key, object3));
        });
        return result2;
      }
      var merge2 = createAssigner(function(object2, source2, srcIndex) {
        baseMerge(object2, source2, srcIndex);
      });
      var mergeWith = createAssigner(function(object2, source2, srcIndex, customizer) {
        baseMerge(object2, source2, srcIndex, customizer);
      });
      var omit = flatRest(function(object2, paths) {
        var result2 = {};
        if (object2 == null) {
          return result2;
        }
        var isDeep = false;
        paths = arrayMap2(paths, function(path) {
          path = castPath2(path, object2);
          isDeep || (isDeep = path.length > 1);
          return path;
        });
        copyObject(object2, getAllKeysIn(object2), result2);
        if (isDeep) {
          result2 = baseClone2(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
        }
        var length2 = paths.length;
        while (length2--) {
          baseUnset(result2, paths[length2]);
        }
        return result2;
      });
      function omitBy(object2, predicate) {
        return pickBy(object2, negate(getIteratee(predicate)));
      }
      var pick = flatRest(function(object2, paths) {
        return object2 == null ? {} : basePick(object2, paths);
      });
      function pickBy(object2, predicate) {
        if (object2 == null) {
          return {};
        }
        var props = arrayMap2(getAllKeysIn(object2), function(prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy(object2, props, function(value, path) {
          return predicate(value, path[0]);
        });
      }
      function result(object2, path, defaultValue) {
        path = castPath2(path, object2);
        var index2 = -1, length2 = path.length;
        if (!length2) {
          length2 = 1;
          object2 = undefined$1;
        }
        while (++index2 < length2) {
          var value = object2 == null ? undefined$1 : object2[toKey2(path[index2])];
          if (value === undefined$1) {
            index2 = length2;
            value = defaultValue;
          }
          object2 = isFunction3(value) ? value.call(object2) : value;
        }
        return object2;
      }
      function set2(object2, path, value) {
        return object2 == null ? object2 : baseSet(object2, path, value);
      }
      function setWith(object2, path, value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object2 == null ? object2 : baseSet(object2, path, value, customizer);
      }
      var toPairs = createToPairs(keys2);
      var toPairsIn = createToPairs(keysIn);
      function transform2(object2, iteratee2, accumulator) {
        var isArr = isArray2(object2), isArrLike = isArr || isBuffer2(object2) || isTypedArray2(object2);
        iteratee2 = getIteratee(iteratee2, 4);
        if (accumulator == null) {
          var Ctor = object2 && object2.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject2(object2)) {
            accumulator = isFunction3(Ctor) ? baseCreate(getPrototype(object2)) : {};
          } else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach : baseForOwn2)(object2, function(value, index2, object3) {
          return iteratee2(accumulator, value, index2, object3);
        });
        return accumulator;
      }
      function unset2(object2, path) {
        return object2 == null ? true : baseUnset(object2, path);
      }
      function update2(object2, path, updater) {
        return object2 == null ? object2 : baseUpdate(object2, path, castFunction(updater));
      }
      function updateWith(object2, path, updater, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object2 == null ? object2 : baseUpdate(object2, path, castFunction(updater), customizer);
      }
      function values(object2) {
        return object2 == null ? [] : baseValues(object2, keys2(object2));
      }
      function valuesIn(object2) {
        return object2 == null ? [] : baseValues(object2, keysIn(object2));
      }
      function clamp2(number2, lower, upper) {
        if (upper === undefined$1) {
          upper = lower;
          lower = undefined$1;
        }
        if (upper !== undefined$1) {
          upper = toNumber2(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined$1) {
          lower = toNumber2(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp(toNumber2(number2), lower, upper);
      }
      function inRange(number2, start2, end2) {
        start2 = toFinite2(start2);
        if (end2 === undefined$1) {
          end2 = start2;
          start2 = 0;
        } else {
          end2 = toFinite2(end2);
        }
        number2 = toNumber2(number2);
        return baseInRange(number2, start2, end2);
      }
      function random(lower, upper, floating) {
        if (floating && typeof floating != "boolean" && isIterateeCall2(lower, upper, floating)) {
          upper = floating = undefined$1;
        }
        if (floating === undefined$1) {
          if (typeof upper == "boolean") {
            floating = upper;
            upper = undefined$1;
          } else if (typeof lower == "boolean") {
            floating = lower;
            lower = undefined$1;
          }
        }
        if (lower === undefined$1 && upper === undefined$1) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite2(lower);
          if (upper === undefined$1) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite2(upper);
          }
        }
        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }
        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
        }
        return baseRandom(lower, upper);
      }
      var camelCase2 = createCompounder2(function(result2, word, index2) {
        word = word.toLowerCase();
        return result2 + (index2 ? capitalize2(word) : word);
      });
      function capitalize2(string2) {
        return upperFirst2(toString3(string2).toLowerCase());
      }
      function deburr2(string2) {
        string2 = toString3(string2);
        return string2 && string2.replace(reLatin2, deburrLetter2).replace(reComboMark2, "");
      }
      function endsWith2(string2, target, position2) {
        string2 = toString3(string2);
        target = baseToString2(target);
        var length2 = string2.length;
        position2 = position2 === undefined$1 ? length2 : baseClamp(toInteger2(position2), 0, length2);
        var end2 = position2;
        position2 -= target.length;
        return position2 >= 0 && string2.slice(position2, end2) == target;
      }
      function escape2(string2) {
        string2 = toString3(string2);
        return string2 && reHasUnescapedHtml.test(string2) ? string2.replace(reUnescapedHtml, escapeHtmlChar) : string2;
      }
      function escapeRegExp2(string2) {
        string2 = toString3(string2);
        return string2 && reHasRegExpChar.test(string2) ? string2.replace(reRegExpChar2, "\\$&") : string2;
      }
      var kebabCase = createCompounder2(function(result2, word, index2) {
        return result2 + (index2 ? "-" : "") + word.toLowerCase();
      });
      var lowerCase = createCompounder2(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toLowerCase();
      });
      var lowerFirst = createCaseFirst2("toLowerCase");
      function pad(string2, length2, chars) {
        string2 = toString3(string2);
        length2 = toInteger2(length2);
        var strLength = length2 ? stringSize(string2) : 0;
        if (!length2 || strLength >= length2) {
          return string2;
        }
        var mid = (length2 - strLength) / 2;
        return createPadding(nativeFloor(mid), chars) + string2 + createPadding(nativeCeil(mid), chars);
      }
      function padEnd(string2, length2, chars) {
        string2 = toString3(string2);
        length2 = toInteger2(length2);
        var strLength = length2 ? stringSize(string2) : 0;
        return length2 && strLength < length2 ? string2 + createPadding(length2 - strLength, chars) : string2;
      }
      function padStart(string2, length2, chars) {
        string2 = toString3(string2);
        length2 = toInteger2(length2);
        var strLength = length2 ? stringSize(string2) : 0;
        return length2 && strLength < length2 ? createPadding(length2 - strLength, chars) + string2 : string2;
      }
      function parseInt2(string2, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        return nativeParseInt(toString3(string2).replace(reTrimStart2, ""), radix || 0);
      }
      function repeat2(string2, n2, guard) {
        if (guard ? isIterateeCall2(string2, n2, guard) : n2 === undefined$1) {
          n2 = 1;
        } else {
          n2 = toInteger2(n2);
        }
        return baseRepeat(toString3(string2), n2);
      }
      function replace2() {
        var args = arguments, string2 = toString3(args[0]);
        return args.length < 3 ? string2 : string2.replace(args[1], args[2]);
      }
      var snakeCase2 = createCompounder2(function(result2, word, index2) {
        return result2 + (index2 ? "_" : "") + word.toLowerCase();
      });
      function split2(string2, separator, limit) {
        if (limit && typeof limit != "number" && isIterateeCall2(string2, separator, limit)) {
          separator = limit = undefined$1;
        }
        limit = limit === undefined$1 ? MAX_ARRAY_LENGTH2 : limit >>> 0;
        if (!limit) {
          return [];
        }
        string2 = toString3(string2);
        if (string2 && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
          separator = baseToString2(separator);
          if (!separator && hasUnicode2(string2)) {
            return castSlice2(stringToArray2(string2), 0, limit);
          }
        }
        return string2.split(separator, limit);
      }
      var startCase = createCompounder2(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + upperFirst2(word);
      });
      function startsWith(string2, target, position2) {
        string2 = toString3(string2);
        position2 = position2 == null ? 0 : baseClamp(toInteger2(position2), 0, string2.length);
        target = baseToString2(target);
        return string2.slice(position2, position2 + target.length) == target;
      }
      function template(string2, options2, guard) {
        var settings = lodash2.templateSettings;
        if (guard && isIterateeCall2(string2, options2, guard)) {
          options2 = undefined$1;
        }
        string2 = toString3(string2);
        options2 = assignInWith({}, options2, settings, customDefaultsAssignIn);
        var imports = assignInWith({}, options2.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys2(imports), importsValues = baseValues(imports, importsKeys);
        var isEscaping, isEvaluating, index2 = 0, interpolate = options2.interpolate || reNoMatch, source2 = "__p += '";
        var reDelimiters = RegExp2((options2.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options2.evaluate || reNoMatch).source + "|$", "g");
        var sourceURL = "//# sourceURL=" + (hasOwnProperty2.call(options2, "sourceURL") ? (options2.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
        string2.replace(reDelimiters, function(match2, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset2) {
          interpolateValue || (interpolateValue = esTemplateValue);
          source2 += string2.slice(index2, offset2).replace(reUnescapedString, escapeStringChar);
          if (escapeValue) {
            isEscaping = true;
            source2 += "' +\n__e(" + escapeValue + ") +\n'";
          }
          if (evaluateValue) {
            isEvaluating = true;
            source2 += "';\n" + evaluateValue + ";\n__p += '";
          }
          if (interpolateValue) {
            source2 += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
          }
          index2 = offset2 + match2.length;
          return match2;
        });
        source2 += "';\n";
        var variable = hasOwnProperty2.call(options2, "variable") && options2.variable;
        if (!variable) {
          source2 = "with (obj) {\n" + source2 + "\n}\n";
        } else if (reForbiddenIdentifierChars.test(variable)) {
          throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
        }
        source2 = (isEvaluating ? source2.replace(reEmptyStringLeading, "") : source2).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
        source2 = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source2 + "return __p\n}";
        var result2 = attempt(function() {
          return Function2(importsKeys, sourceURL + "return " + source2).apply(undefined$1, importsValues);
        });
        result2.source = source2;
        if (isError(result2)) {
          throw result2;
        }
        return result2;
      }
      function toLower(value) {
        return toString3(value).toLowerCase();
      }
      function toUpper(value) {
        return toString3(value).toUpperCase();
      }
      function trim2(string2, chars, guard) {
        string2 = toString3(string2);
        if (string2 && (guard || chars === undefined$1)) {
          return baseTrim2(string2);
        }
        if (!string2 || !(chars = baseToString2(chars))) {
          return string2;
        }
        var strSymbols = stringToArray2(string2), chrSymbols = stringToArray2(chars), start2 = charsStartIndex(strSymbols, chrSymbols), end2 = charsEndIndex(strSymbols, chrSymbols) + 1;
        return castSlice2(strSymbols, start2, end2).join("");
      }
      function trimEnd(string2, chars, guard) {
        string2 = toString3(string2);
        if (string2 && (guard || chars === undefined$1)) {
          return string2.slice(0, trimmedEndIndex2(string2) + 1);
        }
        if (!string2 || !(chars = baseToString2(chars))) {
          return string2;
        }
        var strSymbols = stringToArray2(string2), end2 = charsEndIndex(strSymbols, stringToArray2(chars)) + 1;
        return castSlice2(strSymbols, 0, end2).join("");
      }
      function trimStart(string2, chars, guard) {
        string2 = toString3(string2);
        if (string2 && (guard || chars === undefined$1)) {
          return string2.replace(reTrimStart2, "");
        }
        if (!string2 || !(chars = baseToString2(chars))) {
          return string2;
        }
        var strSymbols = stringToArray2(string2), start2 = charsStartIndex(strSymbols, stringToArray2(chars));
        return castSlice2(strSymbols, start2).join("");
      }
      function truncate(string2, options2) {
        var length2 = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
        if (isObject2(options2)) {
          var separator = "separator" in options2 ? options2.separator : separator;
          length2 = "length" in options2 ? toInteger2(options2.length) : length2;
          omission = "omission" in options2 ? baseToString2(options2.omission) : omission;
        }
        string2 = toString3(string2);
        var strLength = string2.length;
        if (hasUnicode2(string2)) {
          var strSymbols = stringToArray2(string2);
          strLength = strSymbols.length;
        }
        if (length2 >= strLength) {
          return string2;
        }
        var end2 = length2 - stringSize(omission);
        if (end2 < 1) {
          return omission;
        }
        var result2 = strSymbols ? castSlice2(strSymbols, 0, end2).join("") : string2.slice(0, end2);
        if (separator === undefined$1) {
          return result2 + omission;
        }
        if (strSymbols) {
          end2 += result2.length - end2;
        }
        if (isRegExp(separator)) {
          if (string2.slice(end2).search(separator)) {
            var match2, substring = result2;
            if (!separator.global) {
              separator = RegExp2(separator.source, toString3(reFlags.exec(separator)) + "g");
            }
            separator.lastIndex = 0;
            while (match2 = separator.exec(substring)) {
              var newEnd = match2.index;
            }
            result2 = result2.slice(0, newEnd === undefined$1 ? end2 : newEnd);
          }
        } else if (string2.indexOf(baseToString2(separator), end2) != end2) {
          var index2 = result2.lastIndexOf(separator);
          if (index2 > -1) {
            result2 = result2.slice(0, index2);
          }
        }
        return result2 + omission;
      }
      function unescape2(string2) {
        string2 = toString3(string2);
        return string2 && reHasEscapedHtml.test(string2) ? string2.replace(reEscapedHtml, unescapeHtmlChar) : string2;
      }
      var upperCase = createCompounder2(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toUpperCase();
      });
      var upperFirst2 = createCaseFirst2("toUpperCase");
      function words2(string2, pattern, guard) {
        string2 = toString3(string2);
        pattern = guard ? undefined$1 : pattern;
        if (pattern === undefined$1) {
          return hasUnicodeWord2(string2) ? unicodeWords2(string2) : asciiWords2(string2);
        }
        return string2.match(pattern) || [];
      }
      var attempt = baseRest2(function(func, args) {
        try {
          return apply2(func, undefined$1, args);
        } catch (e2) {
          return isError(e2) ? e2 : new Error2(e2);
        }
      });
      var bindAll = flatRest(function(object2, methodNames) {
        arrayEach(methodNames, function(key) {
          key = toKey2(key);
          baseAssignValue2(object2, key, bind3(object2[key], object2));
        });
        return object2;
      });
      function cond(pairs) {
        var length2 = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
        pairs = !length2 ? [] : arrayMap2(pairs, function(pair) {
          if (typeof pair[1] != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT2);
          }
          return [toIteratee(pair[0]), pair[1]];
        });
        return baseRest2(function(args) {
          var index2 = -1;
          while (++index2 < length2) {
            var pair = pairs[index2];
            if (apply2(pair[0], this, args)) {
              return apply2(pair[1], this, args);
            }
          }
        });
      }
      function conforms(source2) {
        return baseConforms(baseClone2(source2, CLONE_DEEP_FLAG));
      }
      function constant2(value) {
        return function() {
          return value;
        };
      }
      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }
      var flow = createFlow();
      var flowRight = createFlow(true);
      function identity2(value) {
        return value;
      }
      function iteratee(func) {
        return baseIteratee2(typeof func == "function" ? func : baseClone2(func, CLONE_DEEP_FLAG));
      }
      function matches(source2) {
        return baseMatches2(baseClone2(source2, CLONE_DEEP_FLAG));
      }
      function matchesProperty(path, srcValue) {
        return baseMatchesProperty2(path, baseClone2(srcValue, CLONE_DEEP_FLAG));
      }
      var method = baseRest2(function(path, args) {
        return function(object2) {
          return baseInvoke(object2, path, args);
        };
      });
      var methodOf = baseRest2(function(object2, args) {
        return function(path) {
          return baseInvoke(object2, path, args);
        };
      });
      function mixin(object2, source2, options2) {
        var props = keys2(source2), methodNames = baseFunctions(source2, props);
        if (options2 == null && !(isObject2(source2) && (methodNames.length || !props.length))) {
          options2 = source2;
          source2 = object2;
          object2 = this;
          methodNames = baseFunctions(source2, keys2(source2));
        }
        var chain2 = !(isObject2(options2) && "chain" in options2) || !!options2.chain, isFunc = isFunction3(object2);
        arrayEach(methodNames, function(methodName) {
          var func = source2[methodName];
          object2[methodName] = func;
          if (isFunc) {
            object2.prototype[methodName] = function() {
              var chainAll = this.__chain__;
              if (chain2 || chainAll) {
                var result2 = object2(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                actions.push({ "func": func, "args": arguments, "thisArg": object2 });
                result2.__chain__ = chainAll;
                return result2;
              }
              return func.apply(object2, arrayPush2([this.value()], arguments));
            };
          }
        });
        return object2;
      }
      function noConflict() {
        if (root2._ === this) {
          root2._ = oldDash;
        }
        return this;
      }
      function noop3() {
      }
      function nthArg(n2) {
        n2 = toInteger2(n2);
        return baseRest2(function(args) {
          return baseNth(args, n2);
        });
      }
      var over = createOver(arrayMap2);
      var overEvery = createOver(arrayEvery);
      var overSome = createOver(arraySome2);
      function property2(path) {
        return isKey2(path) ? baseProperty2(toKey2(path)) : basePropertyDeep2(path);
      }
      function propertyOf(object2) {
        return function(path) {
          return object2 == null ? undefined$1 : baseGet2(object2, path);
        };
      }
      var range = createRange();
      var rangeRight = createRange(true);
      function stubArray2() {
        return [];
      }
      function stubFalse2() {
        return false;
      }
      function stubObject() {
        return {};
      }
      function stubString() {
        return "";
      }
      function stubTrue() {
        return true;
      }
      function times(n2, iteratee2) {
        n2 = toInteger2(n2);
        if (n2 < 1 || n2 > MAX_SAFE_INTEGER2) {
          return [];
        }
        var index2 = MAX_ARRAY_LENGTH2, length2 = nativeMin(n2, MAX_ARRAY_LENGTH2);
        iteratee2 = getIteratee(iteratee2);
        n2 -= MAX_ARRAY_LENGTH2;
        var result2 = baseTimes2(length2, iteratee2);
        while (++index2 < n2) {
          iteratee2(index2);
        }
        return result2;
      }
      function toPath(value) {
        if (isArray2(value)) {
          return arrayMap2(value, toKey2);
        }
        return isSymbol2(value) ? [value] : copyArray(stringToPath2(toString3(value)));
      }
      function uniqueId(prefix2) {
        var id2 = ++idCounter;
        return toString3(prefix2) + id2;
      }
      var add = createMathOperation(function(augend, addend) {
        return augend + addend;
      }, 0);
      var ceil = createRound("ceil");
      var divide = createMathOperation(function(dividend, divisor) {
        return dividend / divisor;
      }, 1);
      var floor = createRound("floor");
      function max2(array2) {
        return array2 && array2.length ? baseExtremum(array2, identity2, baseGt) : undefined$1;
      }
      function maxBy(array2, iteratee2) {
        return array2 && array2.length ? baseExtremum(array2, getIteratee(iteratee2, 2), baseGt) : undefined$1;
      }
      function mean(array2) {
        return baseMean(array2, identity2);
      }
      function meanBy(array2, iteratee2) {
        return baseMean(array2, getIteratee(iteratee2, 2));
      }
      function min2(array2) {
        return array2 && array2.length ? baseExtremum(array2, identity2, baseLt) : undefined$1;
      }
      function minBy(array2, iteratee2) {
        return array2 && array2.length ? baseExtremum(array2, getIteratee(iteratee2, 2), baseLt) : undefined$1;
      }
      var multiply = createMathOperation(function(multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);
      var round2 = createRound("round");
      var subtract = createMathOperation(function(minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);
      function sum(array2) {
        return array2 && array2.length ? baseSum(array2, identity2) : 0;
      }
      function sumBy(array2, iteratee2) {
        return array2 && array2.length ? baseSum(array2, getIteratee(iteratee2, 2)) : 0;
      }
      lodash2.after = after;
      lodash2.ary = ary;
      lodash2.assign = assign2;
      lodash2.assignIn = assignIn;
      lodash2.assignInWith = assignInWith;
      lodash2.assignWith = assignWith;
      lodash2.at = at;
      lodash2.before = before;
      lodash2.bind = bind3;
      lodash2.bindAll = bindAll;
      lodash2.bindKey = bindKey;
      lodash2.castArray = castArray;
      lodash2.chain = chain;
      lodash2.chunk = chunk;
      lodash2.compact = compact2;
      lodash2.concat = concat;
      lodash2.cond = cond;
      lodash2.conforms = conforms;
      lodash2.constant = constant2;
      lodash2.countBy = countBy;
      lodash2.create = create2;
      lodash2.curry = curry;
      lodash2.curryRight = curryRight;
      lodash2.debounce = debounce2;
      lodash2.defaults = defaults2;
      lodash2.defaultsDeep = defaultsDeep;
      lodash2.defer = defer2;
      lodash2.delay = delay;
      lodash2.difference = difference;
      lodash2.differenceBy = differenceBy;
      lodash2.differenceWith = differenceWith;
      lodash2.drop = drop;
      lodash2.dropRight = dropRight2;
      lodash2.dropRightWhile = dropRightWhile;
      lodash2.dropWhile = dropWhile;
      lodash2.fill = fill;
      lodash2.filter = filter2;
      lodash2.flatMap = flatMap;
      lodash2.flatMapDeep = flatMapDeep;
      lodash2.flatMapDepth = flatMapDepth;
      lodash2.flatten = flatten2;
      lodash2.flattenDeep = flattenDeep;
      lodash2.flattenDepth = flattenDepth;
      lodash2.flip = flip2;
      lodash2.flow = flow;
      lodash2.flowRight = flowRight;
      lodash2.fromPairs = fromPairs;
      lodash2.functions = functions;
      lodash2.functionsIn = functionsIn;
      lodash2.groupBy = groupBy2;
      lodash2.initial = initial;
      lodash2.intersection = intersection;
      lodash2.intersectionBy = intersectionBy;
      lodash2.intersectionWith = intersectionWith;
      lodash2.invert = invert;
      lodash2.invertBy = invertBy;
      lodash2.invokeMap = invokeMap;
      lodash2.iteratee = iteratee;
      lodash2.keyBy = keyBy;
      lodash2.keys = keys2;
      lodash2.keysIn = keysIn;
      lodash2.map = map2;
      lodash2.mapKeys = mapKeys2;
      lodash2.mapValues = mapValues2;
      lodash2.matches = matches;
      lodash2.matchesProperty = matchesProperty;
      lodash2.memoize = memoize2;
      lodash2.merge = merge2;
      lodash2.mergeWith = mergeWith;
      lodash2.method = method;
      lodash2.methodOf = methodOf;
      lodash2.mixin = mixin;
      lodash2.negate = negate;
      lodash2.nthArg = nthArg;
      lodash2.omit = omit;
      lodash2.omitBy = omitBy;
      lodash2.once = once2;
      lodash2.orderBy = orderBy;
      lodash2.over = over;
      lodash2.overArgs = overArgs;
      lodash2.overEvery = overEvery;
      lodash2.overSome = overSome;
      lodash2.partial = partial;
      lodash2.partialRight = partialRight;
      lodash2.partition = partition;
      lodash2.pick = pick;
      lodash2.pickBy = pickBy;
      lodash2.property = property2;
      lodash2.propertyOf = propertyOf;
      lodash2.pull = pull;
      lodash2.pullAll = pullAll;
      lodash2.pullAllBy = pullAllBy;
      lodash2.pullAllWith = pullAllWith;
      lodash2.pullAt = pullAt;
      lodash2.range = range;
      lodash2.rangeRight = rangeRight;
      lodash2.rearg = rearg;
      lodash2.reject = reject;
      lodash2.remove = remove2;
      lodash2.rest = rest;
      lodash2.reverse = reverse;
      lodash2.sampleSize = sampleSize;
      lodash2.set = set2;
      lodash2.setWith = setWith;
      lodash2.shuffle = shuffle;
      lodash2.slice = slice2;
      lodash2.sortBy = sortBy2;
      lodash2.sortedUniq = sortedUniq;
      lodash2.sortedUniqBy = sortedUniqBy;
      lodash2.split = split2;
      lodash2.spread = spread3;
      lodash2.tail = tail;
      lodash2.take = take;
      lodash2.takeRight = takeRight;
      lodash2.takeRightWhile = takeRightWhile;
      lodash2.takeWhile = takeWhile;
      lodash2.tap = tap;
      lodash2.throttle = throttle;
      lodash2.thru = thru;
      lodash2.toArray = toArray2;
      lodash2.toPairs = toPairs;
      lodash2.toPairsIn = toPairsIn;
      lodash2.toPath = toPath;
      lodash2.toPlainObject = toPlainObject;
      lodash2.transform = transform2;
      lodash2.unary = unary;
      lodash2.union = union;
      lodash2.unionBy = unionBy;
      lodash2.unionWith = unionWith;
      lodash2.uniq = uniq2;
      lodash2.uniqBy = uniqBy;
      lodash2.uniqWith = uniqWith2;
      lodash2.unset = unset2;
      lodash2.unzip = unzip;
      lodash2.unzipWith = unzipWith;
      lodash2.update = update2;
      lodash2.updateWith = updateWith;
      lodash2.values = values;
      lodash2.valuesIn = valuesIn;
      lodash2.without = without;
      lodash2.words = words2;
      lodash2.wrap = wrap;
      lodash2.xor = xor;
      lodash2.xorBy = xorBy;
      lodash2.xorWith = xorWith;
      lodash2.zip = zip;
      lodash2.zipObject = zipObject;
      lodash2.zipObjectDeep = zipObjectDeep;
      lodash2.zipWith = zipWith;
      lodash2.entries = toPairs;
      lodash2.entriesIn = toPairsIn;
      lodash2.extend = assignIn;
      lodash2.extendWith = assignInWith;
      mixin(lodash2, lodash2);
      lodash2.add = add;
      lodash2.attempt = attempt;
      lodash2.camelCase = camelCase2;
      lodash2.capitalize = capitalize2;
      lodash2.ceil = ceil;
      lodash2.clamp = clamp2;
      lodash2.clone = clone2;
      lodash2.cloneDeep = cloneDeep;
      lodash2.cloneDeepWith = cloneDeepWith;
      lodash2.cloneWith = cloneWith;
      lodash2.conformsTo = conformsTo;
      lodash2.deburr = deburr2;
      lodash2.defaultTo = defaultTo;
      lodash2.divide = divide;
      lodash2.endsWith = endsWith2;
      lodash2.eq = eq2;
      lodash2.escape = escape2;
      lodash2.escapeRegExp = escapeRegExp2;
      lodash2.every = every;
      lodash2.find = find2;
      lodash2.findIndex = findIndex2;
      lodash2.findKey = findKey2;
      lodash2.findLast = findLast;
      lodash2.findLastIndex = findLastIndex;
      lodash2.findLastKey = findLastKey;
      lodash2.floor = floor;
      lodash2.forEach = forEach3;
      lodash2.forEachRight = forEachRight;
      lodash2.forIn = forIn;
      lodash2.forInRight = forInRight;
      lodash2.forOwn = forOwn;
      lodash2.forOwnRight = forOwnRight;
      lodash2.get = get2;
      lodash2.gt = gt;
      lodash2.gte = gte;
      lodash2.has = has2;
      lodash2.hasIn = hasIn2;
      lodash2.head = head;
      lodash2.identity = identity2;
      lodash2.includes = includes;
      lodash2.indexOf = indexOf;
      lodash2.inRange = inRange;
      lodash2.invoke = invoke;
      lodash2.isArguments = isArguments2;
      lodash2.isArray = isArray2;
      lodash2.isArrayBuffer = isArrayBuffer2;
      lodash2.isArrayLike = isArrayLike2;
      lodash2.isArrayLikeObject = isArrayLikeObject;
      lodash2.isBoolean = isBoolean2;
      lodash2.isBuffer = isBuffer2;
      lodash2.isDate = isDate2;
      lodash2.isElement = isElement2;
      lodash2.isEmpty = isEmpty2;
      lodash2.isEqual = isEqual3;
      lodash2.isEqualWith = isEqualWith;
      lodash2.isError = isError;
      lodash2.isFinite = isFinite2;
      lodash2.isFunction = isFunction3;
      lodash2.isInteger = isInteger;
      lodash2.isLength = isLength2;
      lodash2.isMap = isMap;
      lodash2.isMatch = isMatch;
      lodash2.isMatchWith = isMatchWith;
      lodash2.isNaN = isNaN2;
      lodash2.isNative = isNative;
      lodash2.isNil = isNil2;
      lodash2.isNull = isNull;
      lodash2.isNumber = isNumber2;
      lodash2.isObject = isObject2;
      lodash2.isObjectLike = isObjectLike2;
      lodash2.isPlainObject = isPlainObject2;
      lodash2.isRegExp = isRegExp;
      lodash2.isSafeInteger = isSafeInteger;
      lodash2.isSet = isSet;
      lodash2.isString = isString2;
      lodash2.isSymbol = isSymbol2;
      lodash2.isTypedArray = isTypedArray2;
      lodash2.isUndefined = isUndefined2;
      lodash2.isWeakMap = isWeakMap;
      lodash2.isWeakSet = isWeakSet;
      lodash2.join = join;
      lodash2.kebabCase = kebabCase;
      lodash2.last = last;
      lodash2.lastIndexOf = lastIndexOf;
      lodash2.lowerCase = lowerCase;
      lodash2.lowerFirst = lowerFirst;
      lodash2.lt = lt;
      lodash2.lte = lte;
      lodash2.max = max2;
      lodash2.maxBy = maxBy;
      lodash2.mean = mean;
      lodash2.meanBy = meanBy;
      lodash2.min = min2;
      lodash2.minBy = minBy;
      lodash2.stubArray = stubArray2;
      lodash2.stubFalse = stubFalse2;
      lodash2.stubObject = stubObject;
      lodash2.stubString = stubString;
      lodash2.stubTrue = stubTrue;
      lodash2.multiply = multiply;
      lodash2.nth = nth;
      lodash2.noConflict = noConflict;
      lodash2.noop = noop3;
      lodash2.now = now2;
      lodash2.pad = pad;
      lodash2.padEnd = padEnd;
      lodash2.padStart = padStart;
      lodash2.parseInt = parseInt2;
      lodash2.random = random;
      lodash2.reduce = reduce;
      lodash2.reduceRight = reduceRight;
      lodash2.repeat = repeat2;
      lodash2.replace = replace2;
      lodash2.result = result;
      lodash2.round = round2;
      lodash2.runInContext = runInContext2;
      lodash2.sample = sample;
      lodash2.size = size;
      lodash2.snakeCase = snakeCase2;
      lodash2.some = some;
      lodash2.sortedIndex = sortedIndex;
      lodash2.sortedIndexBy = sortedIndexBy;
      lodash2.sortedIndexOf = sortedIndexOf;
      lodash2.sortedLastIndex = sortedLastIndex;
      lodash2.sortedLastIndexBy = sortedLastIndexBy;
      lodash2.sortedLastIndexOf = sortedLastIndexOf;
      lodash2.startCase = startCase;
      lodash2.startsWith = startsWith;
      lodash2.subtract = subtract;
      lodash2.sum = sum;
      lodash2.sumBy = sumBy;
      lodash2.template = template;
      lodash2.times = times;
      lodash2.toFinite = toFinite2;
      lodash2.toInteger = toInteger2;
      lodash2.toLength = toLength;
      lodash2.toLower = toLower;
      lodash2.toNumber = toNumber2;
      lodash2.toSafeInteger = toSafeInteger;
      lodash2.toString = toString3;
      lodash2.toUpper = toUpper;
      lodash2.trim = trim2;
      lodash2.trimEnd = trimEnd;
      lodash2.trimStart = trimStart;
      lodash2.truncate = truncate;
      lodash2.unescape = unescape2;
      lodash2.uniqueId = uniqueId;
      lodash2.upperCase = upperCase;
      lodash2.upperFirst = upperFirst2;
      lodash2.each = forEach3;
      lodash2.eachRight = forEachRight;
      lodash2.first = head;
      mixin(lodash2, function() {
        var source2 = {};
        baseForOwn2(lodash2, function(func, methodName) {
          if (!hasOwnProperty2.call(lodash2.prototype, methodName)) {
            source2[methodName] = func;
          }
        });
        return source2;
      }(), { "chain": false });
      lodash2.VERSION = VERSION2;
      arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
        lodash2[methodName].placeholder = lodash2;
      });
      arrayEach(["drop", "take"], function(methodName, index2) {
        LazyWrapper.prototype[methodName] = function(n2) {
          n2 = n2 === undefined$1 ? 1 : nativeMax2(toInteger2(n2), 0);
          var result2 = this.__filtered__ && !index2 ? new LazyWrapper(this) : this.clone();
          if (result2.__filtered__) {
            result2.__takeCount__ = nativeMin(n2, result2.__takeCount__);
          } else {
            result2.__views__.push({
              "size": nativeMin(n2, MAX_ARRAY_LENGTH2),
              "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
            });
          }
          return result2;
        };
        LazyWrapper.prototype[methodName + "Right"] = function(n2) {
          return this.reverse()[methodName](n2).reverse();
        };
      });
      arrayEach(["filter", "map", "takeWhile"], function(methodName, index2) {
        var type = index2 + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
        LazyWrapper.prototype[methodName] = function(iteratee2) {
          var result2 = this.clone();
          result2.__iteratees__.push({
            "iteratee": getIteratee(iteratee2, 3),
            "type": type
          });
          result2.__filtered__ = result2.__filtered__ || isFilter;
          return result2;
        };
      });
      arrayEach(["head", "last"], function(methodName, index2) {
        var takeName = "take" + (index2 ? "Right" : "");
        LazyWrapper.prototype[methodName] = function() {
          return this[takeName](1).value()[0];
        };
      });
      arrayEach(["initial", "tail"], function(methodName, index2) {
        var dropName = "drop" + (index2 ? "" : "Right");
        LazyWrapper.prototype[methodName] = function() {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });
      LazyWrapper.prototype.compact = function() {
        return this.filter(identity2);
      };
      LazyWrapper.prototype.find = function(predicate) {
        return this.filter(predicate).head();
      };
      LazyWrapper.prototype.findLast = function(predicate) {
        return this.reverse().find(predicate);
      };
      LazyWrapper.prototype.invokeMap = baseRest2(function(path, args) {
        if (typeof path == "function") {
          return new LazyWrapper(this);
        }
        return this.map(function(value) {
          return baseInvoke(value, path, args);
        });
      });
      LazyWrapper.prototype.reject = function(predicate) {
        return this.filter(negate(getIteratee(predicate)));
      };
      LazyWrapper.prototype.slice = function(start2, end2) {
        start2 = toInteger2(start2);
        var result2 = this;
        if (result2.__filtered__ && (start2 > 0 || end2 < 0)) {
          return new LazyWrapper(result2);
        }
        if (start2 < 0) {
          result2 = result2.takeRight(-start2);
        } else if (start2) {
          result2 = result2.drop(start2);
        }
        if (end2 !== undefined$1) {
          end2 = toInteger2(end2);
          result2 = end2 < 0 ? result2.dropRight(-end2) : result2.take(end2 - start2);
        }
        return result2;
      };
      LazyWrapper.prototype.takeRightWhile = function(predicate) {
        return this.reverse().takeWhile(predicate).reverse();
      };
      LazyWrapper.prototype.toArray = function() {
        return this.take(MAX_ARRAY_LENGTH2);
      };
      baseForOwn2(LazyWrapper.prototype, function(func, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash2[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
        if (!lodashFunc) {
          return;
        }
        lodash2.prototype[methodName] = function() {
          var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray2(value);
          var interceptor = function(value2) {
            var result3 = lodashFunc.apply(lodash2, arrayPush2([value2], args));
            return isTaker && chainAll ? result3[0] : result3;
          };
          if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
            isLazy = useLazy = false;
          }
          var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
          if (!retUnwrapped && useLazy) {
            value = onlyLazy ? value : new LazyWrapper(this);
            var result2 = func.apply(value, args);
            result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined$1 });
            return new LodashWrapper(result2, chainAll);
          }
          if (isUnwrapped && onlyLazy) {
            return func.apply(this, args);
          }
          result2 = this.thru(interceptor);
          return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
        };
      });
      arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
        var func = arrayProto2[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
        lodash2.prototype[methodName] = function() {
          var args = arguments;
          if (retUnwrapped && !this.__chain__) {
            var value = this.value();
            return func.apply(isArray2(value) ? value : [], args);
          }
          return this[chainName](function(value2) {
            return func.apply(isArray2(value2) ? value2 : [], args);
          });
        };
      });
      baseForOwn2(LazyWrapper.prototype, function(func, methodName) {
        var lodashFunc = lodash2[methodName];
        if (lodashFunc) {
          var key = lodashFunc.name + "";
          if (!hasOwnProperty2.call(realNames, key)) {
            realNames[key] = [];
          }
          realNames[key].push({ "name": methodName, "func": lodashFunc });
        }
      });
      realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
        "name": "wrapper",
        "func": undefined$1
      }];
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;
      lodash2.prototype.at = wrapperAt;
      lodash2.prototype.chain = wrapperChain;
      lodash2.prototype.commit = wrapperCommit;
      lodash2.prototype.next = wrapperNext;
      lodash2.prototype.plant = wrapperPlant;
      lodash2.prototype.reverse = wrapperReverse;
      lodash2.prototype.toJSON = lodash2.prototype.valueOf = lodash2.prototype.value = wrapperValue;
      lodash2.prototype.first = lodash2.prototype.head;
      if (symIterator) {
        lodash2.prototype[symIterator] = wrapperToIterator;
      }
      return lodash2;
    };
    var _23 = runInContext();
    if (freeModule) {
      (freeModule.exports = _23)._ = _23;
      freeExports._ = _23;
    } else {
      root2._ = _23;
    }
  }).call(commonjsGlobal);
})(lodash, lodash.exports);
const AddProductCard = ({
  handleAddProduct,
  handleImportProduct,
  handleDownloadExample
}) => {
  const {
    t: t2
  } = useTranslation();
  const featureList = ["product.default.manageSKU", "product.default.categorizeProduct", "product.default.editProduct", "product.default.searchProduct"];
  const handleClick = () => {
    const input = document.getElementById("upload-product");
    if (input) {
      input.click();
    }
  };
  const handleChange = (event) => {
    const file = lodash.exports.get(event.target.files, 0);
    if (file) {
      handleImportProduct(file);
      event.target.value = "";
    }
  };
  return /* @__PURE__ */ jsxs(Card, {
    className: "tw-box-border tw-grid tw-h-fit tw-bg-White mobile:tw-grid-cols-1 mobile:tw-p-4 mobile:tw-w-full tablet:tw-grid-cols-2 tablet:tw-gap-x-4 tablet:tw-p-10 tablet:tw-w-fit",
    children: [/* @__PURE__ */ jsx$1("div", {
      className: "tw-flex tw-justify-center tw-pb-2 tw-w-full mobile:tw-block tablet:tw-hidden",
      children: /* @__PURE__ */ jsx$1("img", {
        className: "tw-items-center tw-w-full tw-max-w-full",
        src: DEFAULT_ADD_PRODUCT_GRAPHIC,
        alt: "default-pic"
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "mobile:tw-text-center tablet:tw-text-left",
      children: [/* @__PURE__ */ jsx$1(Typography, {
        variant: "title-2",
        color: COLORS.Gray[800],
        children: t2("product.default.title")
      }), /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-pt-2",
        variant: "body-2",
        color: COLORS.Gray[500],
        children: t2("product.default.description")
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-text-left mobile:tw-justify-center mobile:tw-pt-4 tablet:tw-pt-6",
        children: featureList.map((value) => /* @__PURE__ */ jsxs(Typography, {
          className: "tw-items-center tw-pt-2 mobile:tw-inline-flex mobile:tw-mr-4 tablet:tw-flex",
          variant: "title-9",
          color: COLORS.Gray[500],
          children: [/* @__PURE__ */ jsx$1(Icon, {
            className: "tw-inline-block tw-align-middle",
            name: IconName.OUTLINE_CHECK_CIRCLE,
            size: IconSize.MEDIUM
          }), /* @__PURE__ */ jsx$1("span", {
            className: "tw-inline-block tw-align-middle tw-ml-1",
            children: t2(value)
          })]
        }, value))
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-box-border tablet:tw-flex tablet:tw-justify-start",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "tw-text-left mobile:tw-hidden tablet:tw-block tablet:tw-w-52",
          children: [/* @__PURE__ */ jsx$1(Button, {
            size: "medium",
            variant: "tertiary",
            className: "tw-items-center tw-cursor-pointer mobile:tw-mt-4 mobile:tw-w-full tablet:tw-mt-14 tablet:tw-max-h-12",
            onClick: handleClick,
            children: /* @__PURE__ */ jsxs("div", {
              className: "tw-inline-flex tw-justify-center tw-items-center tw-w-full tw-text-center",
              children: [/* @__PURE__ */ jsx$1(Icon, {
                className: "tw-pr-2 tw-fill-Primary-600",
                name: IconName.DOWNLOAD,
                size: IconSize.LARGE
              }), /* @__PURE__ */ jsxs("div", {
                children: [/* @__PURE__ */ jsx$1(Typography, {
                  variant: "title-10",
                  color: COLORS.Primary[600],
                  children: t2("product.import.button.label")
                }), /* @__PURE__ */ jsx$1(Typography, {
                  variant: "body-5",
                  color: COLORS.Primary[600],
                  children: t2("product.import.button.subLabel")
                })]
              })]
            })
          }), /* @__PURE__ */ jsx$1("input", {
            name: "import-products",
            type: "file",
            id: "upload-product",
            accept: ".csv, .xlsx",
            onChange: handleChange,
            className: "tw-hidden"
          }), /* @__PURE__ */ jsx$1(Typography, {
            className: "tw-cursor-pointer mobile:tw-pt-4 tablet:tw-pt-1",
            variant: "body-4",
            color: COLORS.Accent,
            onClick: handleDownloadExample,
            children: t2("product.import.button.download")
          })]
        }), /* @__PURE__ */ jsxs(Button, {
          className: "tw-box-border tw-inline-flex tw-justify-center tw-cursor-pointer mobile:tw-mt-4 mobile:tw-w-full tablet:tw-mt-14 tablet:tw-ml-4 tablet:tw-w-52 tablet:tw-max-h-12",
          variant: "primary",
          size: "medium",
          onClick: handleAddProduct,
          children: [/* @__PURE__ */ jsx$1(Icon, {
            className: "tw-pr-2 tw-fill-White",
            name: IconName.PLUS,
            size: IconSize.LARGE
          }), t2("product.default.add")]
        })]
      })]
    }), /* @__PURE__ */ jsx$1("div", {
      className: "tw-flex tw-justify-center tw-self-center tw-py-6 mobile:tw-hidden tablet:tw-block",
      children: /* @__PURE__ */ jsx$1("img", {
        className: "tw-items-center tw-w-full tw-max-w-[490px]",
        src: DEFAULT_ADD_PRODUCT_GRAPHIC,
        alt: "default-pic"
      })
    })]
  });
};
const AddProductComponent = (props) => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx$1("div", {
    className: " tw-box-border tw-justify-center tw-items-center tw-w-full tw-h-fit mobile:tw-p-0 tablet:tw-py-10 tablet:tw-px-28",
    children: /* @__PURE__ */ jsx$1("div", {
      className: "tw-flex tw-flex-wrap tw-justify-center tw-w-full",
      children: /* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "tw-py-4 mobile:tw-pl-4 tablet:tw-pl-0",
          children: /* @__PURE__ */ jsx$1(Typography, {
            variant: "title-4",
            color: COLORS.Gray[800],
            children: t2("product.header")
          })
        }), /* @__PURE__ */ jsx$1(AddProductCard, __spreadValues({}, props))]
      })
    })
  });
};
const AddProduct = (props) => {
  return /* @__PURE__ */ jsx$1(ContextProviders, {
    children: /* @__PURE__ */ jsx$1(AddProductComponent, __spreadValues({}, props))
  });
};
function BannerNFT({
  title,
  description
}) {
  return /* @__PURE__ */ jsxs("section", {
    className: "tw-text-White tw-bg-Primary-500 tw-rounded-md tablet:tw-flex",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "lg:tw-flex-1 tw-pt-8 tw-text-center tablet:tw-pl-11 tablet:tw-text-left",
      children: [/* @__PURE__ */ jsx$1(Typography, {
        variant: "title-1",
        color: "White",
        className: "tw-mt-2",
        children: title
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-2",
        color: "White",
        className: "tw-mt-2",
        children: description
      })]
    }), /* @__PURE__ */ jsx$1("figure", {
      className: "lg:tw-flex-1 tw-pr-14",
      children: /* @__PURE__ */ jsx$1("img", {
        src: NFT_CASHBACK_GETTING_STARTED_PLACEHOLDER,
        alt: "hero"
      })
    })]
  });
}
function Steps({
  totalStep,
  currentStep
}) {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs("div", {
    className: "tw-flex tw-items-center",
    children: [new Array(totalStep).fill(0).map((_23, step) => /* @__PURE__ */ jsx$1("div", {
      className: classNames$1("tw-flex-[1] tw-h-[9px] tw-w-full tw-rounded-full tw-ml-2", {
        "tw-bg-Primary-400": currentStep - 1 >= step,
        "tw-bg-Primary-300": currentStep - 1 < step
      })
    }, step)), /* @__PURE__ */ jsx$1("div", {
      className: "tw-ml-2",
      children: /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-8",
        children: t2("cashback.gettingStarted.stepsTogo", {
          step: totalStep - currentStep
        })
      })
    })]
  });
}
function CashbackGettingStarted({
  isNFTUsed,
  isWalletConnected
}) {
  const {
    t: t2
  } = useTranslation();
  const steps = [isWalletConnected, isNFTUsed];
  const step = steps.filter(Boolean).length;
  return /* @__PURE__ */ jsxs("main", {
    className: "tw-mx-auto tw-max-w-[926px]",
    children: [/* @__PURE__ */ jsx$1(Typography, {
      variant: "title-3",
      color: "Gray-800",
      className: "tw-mb-3",
      children: t2("cashback.gettingStarted.title")
    }), /* @__PURE__ */ jsx$1(BannerNFT, {
      title: t2("cashback.gettingStarted.hero.title"),
      description: t2("cashback.gettingStarted.hero.description")
    }), /* @__PURE__ */ jsx$1(Typography, {
      variant: "title-3",
      className: "tw-my-6",
      children: t2("cashback.gettingStarted.stepsTitle")
    }), /* @__PURE__ */ jsx$1("div", {
      className: "tw-mb-8",
      children: /* @__PURE__ */ jsx$1(Steps, {
        currentStep: step,
        totalStep: steps.length
      })
    }), /* @__PURE__ */ jsx$1(QuickStartCard, {
      imageUrl: NFT_CONNECT_WALLET_PLACEHOLDER,
      title: t2("cashback.gettingStarted.connectWallet.title"),
      subTitle: t2("cashback.gettingStarted.connectWallet.description"),
      primaryLabel: t2("cashback.gettingStarted.connectWallet.button"),
      tutorialLabel: t2("cashback.gettingStarted.watchTutorial"),
      isSuccess: isWalletConnected
    }), /* @__PURE__ */ jsx$1("div", {
      className: "tw-mt-6"
    }), /* @__PURE__ */ jsx$1(QuickStartCard, {
      imageUrl: NFT_USE_NFT_CASHBACK_PLACEHOLDER,
      title: t2("cashback.gettingStarted.useNftCashback.title"),
      subTitle: t2("cashback.gettingStarted.useNftCashback.description"),
      primaryLabel: t2("cashback.gettingStarted.useNftCashback.button"),
      tutorialLabel: t2("cashback.gettingStarted.watchTutorial"),
      isSuccess: isNFTUsed
    })]
  });
}
function getImageSrc(variant) {
  switch (variant) {
    case "apple":
      return ICON_CONNECT_APPLE_PATH;
    case "facebook":
      return ICON_CONNECT_FACEBOOK_PATH;
    case "google":
      return ICON_CONNECT_GOOGLE_PATH;
    case "instagram":
      return ICON_CONNECT_INSTAGRAM_PATH;
    case "line":
      return ICON_CONNECT_LINE_PATH;
    default:
      throw new Error("Error! invalid icon variant");
  }
}
function IconConnect({
  variant,
  className = "",
  style = {}
}) {
  const imgSrc = getImageSrc(variant);
  return /* @__PURE__ */ jsx$1("div", {
    className: classNames$1("tw-w-auto tw-h-auto", className),
    style,
    children: /* @__PURE__ */ jsx$1("img", {
      src: imgSrc,
      className: "tw-w-full tw-h-full",
      alt: "icon connect"
    })
  });
}
const VIDEO_FACEBOOK_CONNECT_URL = "https://www.youtube.com/watch?v=C5kiHmG5OjI";
const VIDEO_INSTAGRAM_CONNECT_URL = "https://www.youtube.com/watch?v=11pzQ_HTgLg";
const VIDEO_LINE_CONNECT_URL = "https://www.youtube.com/watch?v=hWFVoU50Tok";
function getVideoLink(variant) {
  switch (variant) {
    case "facebook":
      return VIDEO_FACEBOOK_CONNECT_URL;
    case "instagram":
      return VIDEO_INSTAGRAM_CONNECT_URL;
    case "line":
      return VIDEO_LINE_CONNECT_URL;
    default:
      return "";
  }
}
function CardConnectInfo({
  isNew,
  isShowConnectButton,
  variant,
  onConnect,
  onClickWatchVideo = () => {
  }
}) {
  const {
    t: t2
  } = useTranslation();
  const handleClickWatchVideo = (event) => {
    event.preventDefault();
    onClickWatchVideo(variant);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "tw-flex tw-justify-between tw-items-start tablet:tw-items-center",
    children: [/* @__PURE__ */ jsx$1(IconConnect, {
      variant,
      className: "tw-w-8 tw-h-8 tablet:tw-w-auto tablet:tw-h-auto"
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-flex-1 tw-self-start tw-ml-4 tablet:tw-mx-8",
      children: [/* @__PURE__ */ jsxs("h3", {
        className: "tw-inline-flex tw-items-center tw-text-lg tw-font-medium tw-leading-6 tw-text-grayscale-800",
        children: [t2(`cardConnect.title.${variant}`), isNew && /* @__PURE__ */ jsx$1("span", {
          className: "tw-py-1 tw-px-[6px] tw-ml-4 tw-w-auto tw-h-6 tw-text-xs tw-font-medium tw-text-white tw-bg-gradient-deeple tw-rounded",
          children: t2("cardConnect.new")
        })]
      }), /* @__PURE__ */ jsx$1("p", {
        className: "tw-mt-1 tw-text-sm tw-font-normal tw-text-grayscale-500",
        children: t2(`cardConnect.description.${variant}`)
      }), /* @__PURE__ */ jsx$1("a", {
        href: getVideoLink(variant),
        className: "tw-block tw-mt-1 tw-text-xs tw-font-medium tw-text-primary-600 hover:tw-cursor-pointer",
        target: "_blank",
        rel: "noreferrer noopener",
        onClick: handleClickWatchVideo,
        children: t2("cardConnect.watchVideo")
      }), isShowConnectButton && /* @__PURE__ */ jsx$1(Button, {
        className: "tw-block tw-mt-4 tablet:tw-hidden",
        onClick: onConnect,
        children: t2("cardConnect.connect")
      })]
    }), isShowConnectButton && /* @__PURE__ */ jsx$1(Button, {
      className: "tw-hidden tablet:tw-block",
      onClick: onConnect,
      children: t2("cardConnect.connect")
    })]
  });
}
var isCheckBoxInput = (element) => element.type === "checkbox";
var isDateObject = (value) => value instanceof Date;
var isNullOrUndefined = (value) => value == null;
const isObjectType = (value) => typeof value === "object";
var isObject$8 = (value) => !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !isDateObject(value);
var getEventValue = (event) => isObject$8(event) && event.target ? isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));
var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];
var isUndefined$1 = (val) => val === void 0;
var get$2 = (obj, path, defaultValue) => {
  if (!path || !isObject$8(obj)) {
    return defaultValue;
  }
  const result = compact(path.split(/[,[\].]+?/)).reduce((result2, key) => isNullOrUndefined(result2) ? result2 : result2[key], obj);
  return isUndefined$1(result) || result === obj ? isUndefined$1(obj[path]) ? defaultValue : obj[path] : result;
};
const EVENTS = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
};
const VALIDATION_MODE = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
};
const INPUT_VALIDATION_RULES = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
};
const HookFormContext = React__default.createContext(null);
const useFormContext = () => React__default.useContext(HookFormContext);
const FormProvider = (props) => {
  const _a2 = props, { children: children2 } = _a2, data2 = __objRest(_a2, ["children"]);
  return React__default.createElement(HookFormContext.Provider, { value: data2 }, props.children);
};
var getProxyFormState = (formState, _proxyFormState, localProxyFormState, isRoot = true) => {
  const result = {};
  for (const key in formState) {
    Object.defineProperty(result, key, {
      get: () => {
        const _key = key;
        if (_proxyFormState[_key] !== VALIDATION_MODE.all) {
          _proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
        }
        localProxyFormState && (localProxyFormState[_key] = true);
        return formState[_key];
      }
    });
  }
  return result;
};
var isEmptyObject = (value) => isObject$8(value) && !Object.keys(value).length;
var shouldRenderFormState = (formStateData, _proxyFormState, isRoot) => {
  const _a2 = formStateData, { name } = _a2, formState = __objRest(_a2, ["name"]);
  return isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key) => _proxyFormState[key] === (!isRoot || VALIDATION_MODE.all));
};
var convertToArrayPayload = (value) => Array.isArray(value) ? value : [value];
var shouldSubscribeByName = (name, signalName, exact) => exact && signalName ? name === signalName : !name || !signalName || name === signalName || convertToArrayPayload(name).some((currentName) => currentName && (currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function useSubscribe(props) {
  const _props = React__default.useRef(props);
  _props.current = props;
  React__default.useEffect(() => {
    const tearDown = (subscription2) => {
      if (subscription2) {
        subscription2.unsubscribe();
      }
    };
    const subscription = !props.disabled && _props.current.subject.subscribe({
      next: _props.current.callback
    });
    return () => tearDown(subscription);
  }, [props.disabled]);
}
function useFormState(props) {
  const methods = useFormContext();
  const { control = methods.control, disabled, name, exact } = props || {};
  const [formState, updateFormState] = React__default.useState(control._formState);
  const _localProxyFormState = React__default.useRef({
    isDirty: false,
    dirtyFields: false,
    touchedFields: false,
    isValidating: false,
    isValid: false,
    errors: false
  });
  const _name = React__default.useRef(name);
  const _mounted = React__default.useRef(true);
  _name.current = name;
  const callback = React__default.useCallback((value) => _mounted.current && shouldSubscribeByName(_name.current, value.name, exact) && shouldRenderFormState(value, _localProxyFormState.current) && updateFormState(__spreadValues(__spreadValues({}, control._formState), value)), [control, exact]);
  useSubscribe({
    disabled,
    callback,
    subject: control._subjects.state
  });
  React__default.useEffect(() => {
    _mounted.current = true;
    return () => {
      _mounted.current = false;
    };
  }, []);
  return getProxyFormState(formState, control._proxyFormState, _localProxyFormState.current, false);
}
var isString$1 = (value) => typeof value === "string";
var generateWatchOutput = (names, _names, formValues, isGlobal) => {
  const isArray2 = Array.isArray(names);
  if (isString$1(names)) {
    isGlobal && _names.watch.add(names);
    return get$2(formValues, names);
  }
  if (isArray2) {
    return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName), get$2(formValues, fieldName)));
  }
  isGlobal && (_names.watchAll = true);
  return formValues;
};
var isFunction$5 = (value) => typeof value === "function";
var objectHasFunction = (data2) => {
  for (const key in data2) {
    if (isFunction$5(data2[key])) {
      return true;
    }
  }
  return false;
};
function useWatch(props) {
  const methods = useFormContext();
  const { control = methods.control, name, defaultValue, disabled, exact } = props || {};
  const _name = React__default.useRef(name);
  _name.current = name;
  const callback = React__default.useCallback((formState) => {
    if (shouldSubscribeByName(_name.current, formState.name, exact)) {
      const fieldValues = generateWatchOutput(_name.current, control._names, formState.values || control._formValues);
      updateValue(isUndefined$1(_name.current) || isObject$8(fieldValues) && !objectHasFunction(fieldValues) ? __spreadValues({}, fieldValues) : Array.isArray(fieldValues) ? [...fieldValues] : isUndefined$1(fieldValues) ? defaultValue : fieldValues);
    }
  }, [control, exact, defaultValue]);
  useSubscribe({
    disabled,
    subject: control._subjects.watch,
    callback
  });
  const [value, updateValue] = React__default.useState(isUndefined$1(defaultValue) ? control._getWatch(name) : defaultValue);
  React__default.useEffect(() => {
    control._removeUnmounted();
  });
  return value;
}
function useController(props) {
  const methods = useFormContext();
  const { name, control = methods.control, shouldUnregister } = props;
  const isArrayField = isNameInFieldArray(control._names.array, name);
  const value = useWatch({
    control,
    name,
    defaultValue: get$2(control._formValues, name, get$2(control._defaultValues, name, props.defaultValue)),
    exact: true
  });
  const formState = useFormState({
    control,
    name
  });
  const _registerProps = React__default.useRef(control.register(name, __spreadProps(__spreadValues({}, props.rules), {
    value
  })));
  React__default.useEffect(() => {
    const updateMounted = (name2, value2) => {
      const field = get$2(control._fields, name2);
      if (field) {
        field._f.mount = value2;
      }
    };
    updateMounted(name, true);
    return () => {
      const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
      (isArrayField ? _shouldUnregisterField && !control._stateFlags.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
    };
  }, [name, control, isArrayField, shouldUnregister]);
  return {
    field: {
      name,
      value,
      onChange: React__default.useCallback((event) => {
        _registerProps.current.onChange({
          target: {
            value: getEventValue(event),
            name
          },
          type: EVENTS.CHANGE
        });
      }, [name]),
      onBlur: React__default.useCallback(() => {
        _registerProps.current.onBlur({
          target: {
            value: get$2(control._formValues, name),
            name
          },
          type: EVENTS.BLUR
        });
      }, [name, control]),
      ref: React__default.useCallback((elm) => {
        const field = get$2(control._fields, name);
        if (elm && field && elm.focus) {
          field._f.ref = {
            focus: () => elm.focus(),
            setCustomValidity: (message) => elm.setCustomValidity(message),
            reportValidity: () => elm.reportValidity()
          };
        }
      }, [name, control._fields])
    },
    formState,
    fieldState: control.getFieldState(name, formState)
  };
}
const Controller = (props) => props.render(useController(props));
var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria ? __spreadProps(__spreadValues({}, errors[name]), {
  types: __spreadProps(__spreadValues({}, errors[name] && errors[name].types ? errors[name].types : {}), {
    [type]: message || true
  })
}) : {};
var isKey$4 = (value) => /^\w*$/.test(value);
var stringToPath$2 = (input) => compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
function set$1(object2, path, value) {
  let index2 = -1;
  const tempPath = isKey$4(path) ? [path] : stringToPath$2(path);
  const length2 = tempPath.length;
  const lastIndex = length2 - 1;
  while (++index2 < length2) {
    const key = tempPath[index2];
    let newValue = value;
    if (index2 !== lastIndex) {
      const objValue = object2[key];
      newValue = isObject$8(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index2 + 1]) ? [] : {};
    }
    object2[key] = newValue;
    object2 = object2[key];
  }
  return object2;
}
const focusFieldBy = (fields, callback, fieldsNames) => {
  for (const key of fieldsNames || Object.keys(fields)) {
    const field = get$2(fields, key);
    if (field) {
      const _a2 = field, { _f } = _a2, currentField = __objRest(_a2, ["_f"]);
      if (_f && callback(_f.name)) {
        if (_f.ref.focus && isUndefined$1(_f.ref.focus())) {
          break;
        } else if (_f.refs) {
          _f.refs[0].focus();
          break;
        }
      } else if (isObject$8(currentField)) {
        focusFieldBy(currentField, callback);
      }
    }
  }
};
var isWatched = (name, _names, isBlurEvent) => !isBlurEvent && (_names.watchAll || _names.watch.has(name) || [..._names.watch].some((watchName) => name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
function cloneObject(data2) {
  let copy2;
  const isArray2 = Array.isArray(data2);
  if (data2 instanceof Date) {
    copy2 = new Date(data2);
  } else if (data2 instanceof Set) {
    copy2 = new Set(data2);
  } else if (isArray2 || isObject$8(data2)) {
    copy2 = isArray2 ? [] : {};
    for (const key in data2) {
      if (isFunction$5(data2[key])) {
        copy2 = data2;
        break;
      }
      copy2[key] = cloneObject(data2[key]);
    }
  } else {
    return data2;
  }
  return copy2;
}
function createSubject() {
  let _observers = [];
  const next2 = (value) => {
    for (const observer of _observers) {
      observer.next(value);
    }
  };
  const subscribe2 = (observer) => {
    _observers.push(observer);
    return {
      unsubscribe: () => {
        _observers = _observers.filter((o2) => o2 !== observer);
      }
    };
  };
  const unsubscribe2 = () => {
    _observers = [];
  };
  return {
    get observers() {
      return _observers;
    },
    next: next2,
    subscribe: subscribe2,
    unsubscribe: unsubscribe2
  };
}
var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);
function deepEqual(object1, object2) {
  if (isPrimitive(object1) || isPrimitive(object2)) {
    return object1 === object2;
  }
  if (isDateObject(object1) && isDateObject(object2)) {
    return object1.getTime() === object2.getTime();
  }
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (const key of keys1) {
    const val1 = object1[key];
    if (!keys2.includes(key)) {
      return false;
    }
    if (key !== "ref") {
      const val2 = object2[key];
      if (isDateObject(val1) && isDateObject(val2) || isObject$8(val1) && isObject$8(val2) || Array.isArray(val1) && Array.isArray(val2) ? !deepEqual(val1, val2) : val1 !== val2) {
        return false;
      }
    }
  }
  return true;
}
var getValidationModes = (mode) => ({
  isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
  isOnBlur: mode === VALIDATION_MODE.onBlur,
  isOnChange: mode === VALIDATION_MODE.onChange,
  isOnAll: mode === VALIDATION_MODE.all,
  isOnTouch: mode === VALIDATION_MODE.onTouched
});
var isBoolean = (value) => typeof value === "boolean";
var isFileInput = (element) => element.type === "file";
var isHTMLElement$1 = (value) => value instanceof HTMLElement;
var isMultipleSelect = (element) => element.type === `select-multiple`;
var isRadioInput = (element) => element.type === "radio";
var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);
var isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
var live = (ref) => isHTMLElement$1(ref) && ref.isConnected;
function baseGet$4(object2, updatePath) {
  const length2 = updatePath.slice(0, -1).length;
  let index2 = 0;
  while (index2 < length2) {
    object2 = isUndefined$1(object2) ? index2++ : object2[updatePath[index2++]];
  }
  return object2;
}
function unset(object2, path) {
  const updatePath = isKey$4(path) ? [path] : stringToPath$2(path);
  const childObject = updatePath.length == 1 ? object2 : baseGet$4(object2, updatePath);
  const key = updatePath[updatePath.length - 1];
  let previousObjRef;
  if (childObject) {
    delete childObject[key];
  }
  for (let k2 = 0; k2 < updatePath.slice(0, -1).length; k2++) {
    let index2 = -1;
    let objectRef;
    const currentPaths = updatePath.slice(0, -(k2 + 1));
    const currentPathsLength = currentPaths.length - 1;
    if (k2 > 0) {
      previousObjRef = object2;
    }
    while (++index2 < currentPaths.length) {
      const item = currentPaths[index2];
      objectRef = objectRef ? objectRef[item] : object2[item];
      if (currentPathsLength === index2 && (isObject$8(objectRef) && isEmptyObject(objectRef) || Array.isArray(objectRef) && !objectRef.filter((data2) => !isUndefined$1(data2)).length)) {
        previousObjRef ? delete previousObjRef[item] : delete object2[item];
      }
      previousObjRef = objectRef;
    }
  }
  return object2;
}
function markFieldsDirty(data2, fields = {}) {
  const isParentNodeArray = Array.isArray(data2);
  if (isObject$8(data2) || isParentNodeArray) {
    for (const key in data2) {
      if (Array.isArray(data2[key]) || isObject$8(data2[key]) && !objectHasFunction(data2[key])) {
        fields[key] = Array.isArray(data2[key]) ? [] : {};
        markFieldsDirty(data2[key], fields[key]);
      } else if (!isNullOrUndefined(data2[key])) {
        fields[key] = true;
      }
    }
  }
  return fields;
}
function getDirtyFieldsFromDefaultValues(data2, formValues, dirtyFieldsFromValues) {
  const isParentNodeArray = Array.isArray(data2);
  if (isObject$8(data2) || isParentNodeArray) {
    for (const key in data2) {
      if (Array.isArray(data2[key]) || isObject$8(data2[key]) && !objectHasFunction(data2[key])) {
        if (isUndefined$1(formValues) || isPrimitive(dirtyFieldsFromValues[key])) {
          dirtyFieldsFromValues[key] = Array.isArray(data2[key]) ? markFieldsDirty(data2[key], []) : __spreadValues({}, markFieldsDirty(data2[key]));
        } else {
          getDirtyFieldsFromDefaultValues(data2[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        }
      } else {
        dirtyFieldsFromValues[key] = !deepEqual(data2[key], formValues[key]);
      }
    }
  }
  return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));
const defaultResult = {
  value: false,
  isValid: false
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options2) => {
  if (Array.isArray(options2)) {
    if (options2.length > 1) {
      const values = options2.filter((option) => option && option.checked && !option.disabled).map((option) => option.value);
      return { value: values, isValid: !!values.length };
    }
    return options2[0].checked && !options2[0].disabled ? options2[0].attributes && !isUndefined$1(options2[0].attributes.value) ? isUndefined$1(options2[0].value) || options2[0].value === "" ? validResult : { value: options2[0].value, isValid: true } : validResult : defaultResult;
  }
  return defaultResult;
};
var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined$1(value) ? value : valueAsNumber ? value === "" ? NaN : +value : valueAsDate && isString$1(value) ? new Date(value) : setValueAs ? setValueAs(value) : value;
const defaultReturn = {
  isValid: false,
  value: null
};
var getRadioValue = (options2) => Array.isArray(options2) ? options2.reduce((previous, option) => option && option.checked && !option.disabled ? {
  isValid: true,
  value: option.value
} : previous, defaultReturn) : defaultReturn;
function getFieldValue(_f) {
  const ref = _f.ref;
  if (_f.refs ? _f.refs.every((ref2) => ref2.disabled) : ref.disabled) {
    return;
  }
  if (isFileInput(ref)) {
    return ref.files;
  }
  if (isRadioInput(ref)) {
    return getRadioValue(_f.refs).value;
  }
  if (isMultipleSelect(ref)) {
    return [...ref.selectedOptions].map(({ value }) => value);
  }
  if (isCheckBoxInput(ref)) {
    return getCheckboxValue(_f.refs).value;
  }
  return getFieldValueAs(isUndefined$1(ref.value) ? _f.ref.value : ref.value, _f);
}
var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
  const fields = {};
  for (const name of fieldsNames) {
    const field = get$2(_fields, name);
    field && set$1(fields, name, field._f);
  }
  return {
    criteriaMode,
    names: [...fieldsNames],
    fields,
    shouldUseNativeValidation
  };
};
var isRegex = (value) => value instanceof RegExp;
var getRuleValue = (rule) => isUndefined$1(rule) ? void 0 : isRegex(rule) ? rule.source : isObject$8(rule) ? isRegex(rule.value) ? rule.value.source : rule.value : rule;
var hasValidation = (options2) => options2.mount && (options2.required || options2.min || options2.max || options2.maxLength || options2.minLength || options2.pattern || options2.validate);
function schemaErrorLookup(errors, _fields, name) {
  const error2 = get$2(errors, name);
  if (error2 || isKey$4(name)) {
    return {
      error: error2,
      name
    };
  }
  const names = name.split(".");
  while (names.length) {
    const fieldName = names.join(".");
    const field = get$2(_fields, fieldName);
    const foundError = get$2(errors, fieldName);
    if (field && !Array.isArray(field) && name !== fieldName) {
      return { name };
    }
    if (foundError && foundError.type) {
      return {
        name: fieldName,
        error: foundError
      };
    }
    names.pop();
  }
  return {
    name
  };
}
var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
  if (mode.isOnAll) {
    return false;
  } else if (!isSubmitted && mode.isOnTouch) {
    return !(isTouched || isBlurEvent);
  } else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
    return !isBlurEvent;
  } else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
    return isBlurEvent;
  }
  return true;
};
var unsetEmptyArray = (ref, name) => !compact(get$2(ref, name)).length && unset(ref, name);
var isMessage = (value) => isString$1(value) || React__default.isValidElement(value);
function getValidateError(result, ref, type = "validate") {
  if (isMessage(result) || Array.isArray(result) && result.every(isMessage) || isBoolean(result) && !result) {
    return {
      type,
      message: isMessage(result) ? result : "",
      ref
    };
  }
}
var getValueAndMessage = (validationData) => isObject$8(validationData) && !isRegex(validationData) ? validationData : {
  value: validationData,
  message: ""
};
var validateField = async (field, inputValue, validateAllFieldCriteria, shouldUseNativeValidation) => {
  const { ref, refs, required, maxLength, minLength, min: min2, max: max2, pattern, validate, name, valueAsNumber, mount, disabled } = field._f;
  if (!mount || disabled) {
    return {};
  }
  const inputRef = refs ? refs[0] : ref;
  const setCustomValidity = (message) => {
    if (shouldUseNativeValidation && inputRef.reportValidity) {
      inputRef.setCustomValidity(isBoolean(message) ? "" : message || " ");
      inputRef.reportValidity();
    }
  };
  const error2 = {};
  const isRadio = isRadioInput(ref);
  const isCheckBox = isCheckBoxInput(ref);
  const isRadioOrCheckbox2 = isRadio || isCheckBox;
  const isEmpty2 = (valueAsNumber || isFileInput(ref)) && !ref.value || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
  const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error2);
  const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
    const message = exceedMax ? maxLengthMessage : minLengthMessage;
    error2[name] = __spreadValues({
      type: exceedMax ? maxType : minType,
      message,
      ref
    }, appendErrorsCurry(exceedMax ? maxType : minType, message));
  };
  if (required && (!isRadioOrCheckbox2 && (isEmpty2 || isNullOrUndefined(inputValue)) || isBoolean(inputValue) && !inputValue || isCheckBox && !getCheckboxValue(refs).isValid || isRadio && !getRadioValue(refs).isValid)) {
    const { value, message } = isMessage(required) ? { value: !!required, message: required } : getValueAndMessage(required);
    if (value) {
      error2[name] = __spreadValues({
        type: INPUT_VALIDATION_RULES.required,
        message,
        ref: inputRef
      }, appendErrorsCurry(INPUT_VALIDATION_RULES.required, message));
      if (!validateAllFieldCriteria) {
        setCustomValidity(message);
        return error2;
      }
    }
  }
  if (!isEmpty2 && (!isNullOrUndefined(min2) || !isNullOrUndefined(max2))) {
    let exceedMax;
    let exceedMin;
    const maxOutput = getValueAndMessage(max2);
    const minOutput = getValueAndMessage(min2);
    if (!isNaN(inputValue)) {
      const valueNumber = ref.valueAsNumber || +inputValue;
      if (!isNullOrUndefined(maxOutput.value)) {
        exceedMax = valueNumber > maxOutput.value;
      }
      if (!isNullOrUndefined(minOutput.value)) {
        exceedMin = valueNumber < minOutput.value;
      }
    } else {
      const valueDate = ref.valueAsDate || new Date(inputValue);
      if (isString$1(maxOutput.value)) {
        exceedMax = valueDate > new Date(maxOutput.value);
      }
      if (isString$1(minOutput.value)) {
        exceedMin = valueDate < new Date(minOutput.value);
      }
    }
    if (exceedMax || exceedMin) {
      getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
      if (!validateAllFieldCriteria) {
        setCustomValidity(error2[name].message);
        return error2;
      }
    }
  }
  if ((maxLength || minLength) && !isEmpty2 && isString$1(inputValue)) {
    const maxLengthOutput = getValueAndMessage(maxLength);
    const minLengthOutput = getValueAndMessage(minLength);
    const exceedMax = !isNullOrUndefined(maxLengthOutput.value) && inputValue.length > maxLengthOutput.value;
    const exceedMin = !isNullOrUndefined(minLengthOutput.value) && inputValue.length < minLengthOutput.value;
    if (exceedMax || exceedMin) {
      getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
      if (!validateAllFieldCriteria) {
        setCustomValidity(error2[name].message);
        return error2;
      }
    }
  }
  if (pattern && !isEmpty2 && isString$1(inputValue)) {
    const { value: patternValue, message } = getValueAndMessage(pattern);
    if (isRegex(patternValue) && !inputValue.match(patternValue)) {
      error2[name] = __spreadValues({
        type: INPUT_VALIDATION_RULES.pattern,
        message,
        ref
      }, appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message));
      if (!validateAllFieldCriteria) {
        setCustomValidity(message);
        return error2;
      }
    }
  }
  if (validate) {
    if (isFunction$5(validate)) {
      const result = await validate(inputValue);
      const validateError = getValidateError(result, inputRef);
      if (validateError) {
        error2[name] = __spreadValues(__spreadValues({}, validateError), appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message));
        if (!validateAllFieldCriteria) {
          setCustomValidity(validateError.message);
          return error2;
        }
      }
    } else if (isObject$8(validate)) {
      let validationResult = {};
      for (const key in validate) {
        if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
          break;
        }
        const validateError = getValidateError(await validate[key](inputValue), inputRef, key);
        if (validateError) {
          validationResult = __spreadValues(__spreadValues({}, validateError), appendErrorsCurry(key, validateError.message));
          setCustomValidity(validateError.message);
          if (validateAllFieldCriteria) {
            error2[name] = validationResult;
          }
        }
      }
      if (!isEmptyObject(validationResult)) {
        error2[name] = __spreadValues({
          ref: inputRef
        }, validationResult);
        if (!validateAllFieldCriteria) {
          return error2;
        }
      }
    }
  }
  setCustomValidity(true);
  return error2;
};
const defaultOptions = {
  mode: VALIDATION_MODE.onSubmit,
  reValidateMode: VALIDATION_MODE.onChange,
  shouldFocusError: true
};
function createFormControl(props = {}) {
  let _options = __spreadValues(__spreadValues({}, defaultOptions), props);
  let _formState = {
    isDirty: false,
    isValidating: false,
    dirtyFields: {},
    isSubmitted: false,
    submitCount: 0,
    touchedFields: {},
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    errors: {}
  };
  let _fields = {};
  let _defaultValues = cloneObject(_options.defaultValues) || {};
  let _formValues = _options.shouldUnregister ? {} : cloneObject(_defaultValues);
  let _stateFlags = {
    action: false,
    mount: false,
    watch: false
  };
  let _names = {
    mount: new Set(),
    unMount: new Set(),
    array: new Set(),
    watch: new Set()
  };
  let delayErrorCallback;
  let timer = 0;
  let validateFields = {};
  const _proxyFormState = {
    isDirty: false,
    dirtyFields: false,
    touchedFields: false,
    isValidating: false,
    isValid: false,
    errors: false
  };
  const _subjects = {
    watch: createSubject(),
    array: createSubject(),
    state: createSubject()
  };
  const validationModeBeforeSubmit = getValidationModes(_options.mode);
  const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
  const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
  const debounce2 = (callback, wait) => (...args) => {
    clearTimeout(timer);
    timer = window.setTimeout(() => callback(...args), wait);
  };
  const _updateValid = async (shouldSkipRender) => {
    let isValid2 = false;
    if (_proxyFormState.isValid) {
      isValid2 = _options.resolver ? isEmptyObject((await _executeSchema()).errors) : await executeBuildInValidation(_fields, true);
      if (!shouldSkipRender && isValid2 !== _formState.isValid) {
        _formState.isValid = isValid2;
        _subjects.state.next({
          isValid: isValid2
        });
      }
    }
    return isValid2;
  };
  const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
    if (args && method) {
      _stateFlags.action = true;
      if (shouldUpdateFieldsAndState && Array.isArray(get$2(_fields, name))) {
        const fieldValues = method(get$2(_fields, name), args.argA, args.argB);
        shouldSetValues && set$1(_fields, name, fieldValues);
      }
      if (_proxyFormState.errors && shouldUpdateFieldsAndState && Array.isArray(get$2(_formState.errors, name))) {
        const errors = method(get$2(_formState.errors, name), args.argA, args.argB);
        shouldSetValues && set$1(_formState.errors, name, errors);
        unsetEmptyArray(_formState.errors, name);
      }
      if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray(get$2(_formState.touchedFields, name))) {
        const touchedFields = method(get$2(_formState.touchedFields, name), args.argA, args.argB);
        shouldSetValues && set$1(_formState.touchedFields, name, touchedFields);
      }
      if (_proxyFormState.dirtyFields) {
        _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
      }
      _subjects.state.next({
        isDirty: _getDirty(name, values),
        dirtyFields: _formState.dirtyFields,
        errors: _formState.errors,
        isValid: _formState.isValid
      });
    } else {
      set$1(_formValues, name, values);
    }
  };
  const updateErrors = (name, error2) => (set$1(_formState.errors, name, error2), _subjects.state.next({
    errors: _formState.errors
  }));
  const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
    const field = get$2(_fields, name);
    if (field) {
      const defaultValue = get$2(_formValues, name, isUndefined$1(value) ? get$2(_defaultValues, name) : value);
      isUndefined$1(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? set$1(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f)) : setFieldValue(name, defaultValue);
      _stateFlags.mount && _updateValid();
    }
  };
  const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
    let isFieldDirty = false;
    const output2 = {
      name
    };
    const isPreviousFieldTouched = get$2(_formState.touchedFields, name);
    if (_proxyFormState.isDirty) {
      const isPreviousFormDirty = _formState.isDirty;
      _formState.isDirty = output2.isDirty = _getDirty();
      isFieldDirty = isPreviousFormDirty !== output2.isDirty;
    }
    if (_proxyFormState.dirtyFields && (!isBlurEvent || shouldDirty)) {
      const isPreviousFieldDirty = get$2(_formState.dirtyFields, name);
      const isCurrentFieldPristine = deepEqual(get$2(_defaultValues, name), fieldValue);
      isCurrentFieldPristine ? unset(_formState.dirtyFields, name) : set$1(_formState.dirtyFields, name, true);
      output2.dirtyFields = _formState.dirtyFields;
      isFieldDirty = isFieldDirty || isPreviousFieldDirty !== get$2(_formState.dirtyFields, name);
    }
    if (isBlurEvent && !isPreviousFieldTouched) {
      set$1(_formState.touchedFields, name, isBlurEvent);
      output2.touchedFields = _formState.touchedFields;
      isFieldDirty = isFieldDirty || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
    }
    isFieldDirty && shouldRender && _subjects.state.next(output2);
    return isFieldDirty ? output2 : {};
  };
  const shouldRenderByError = async (shouldSkipRender, name, isValid2, error2, fieldState) => {
    const previousFieldError = get$2(_formState.errors, name);
    const shouldUpdateValid = _proxyFormState.isValid && _formState.isValid !== isValid2;
    if (props.delayError && error2) {
      delayErrorCallback = delayErrorCallback || debounce2(updateErrors, props.delayError);
      delayErrorCallback(name, error2);
    } else {
      clearTimeout(timer);
      error2 ? set$1(_formState.errors, name, error2) : unset(_formState.errors, name);
    }
    if (((error2 ? !deepEqual(previousFieldError, error2) : previousFieldError) || !isEmptyObject(fieldState) || shouldUpdateValid) && !shouldSkipRender) {
      const updatedFormState = __spreadProps(__spreadValues(__spreadValues({}, fieldState), shouldUpdateValid ? { isValid: isValid2 } : {}), {
        errors: _formState.errors,
        name
      });
      _formState = __spreadValues(__spreadValues({}, _formState), updatedFormState);
      _subjects.state.next(updatedFormState);
    }
    validateFields[name]--;
    if (_proxyFormState.isValidating && !Object.values(validateFields).some((v2) => v2)) {
      _subjects.state.next({
        isValidating: false
      });
      validateFields = {};
    }
  };
  const _executeSchema = async (name) => _options.resolver ? await _options.resolver(__spreadValues({}, _formValues), _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation)) : {};
  const executeSchemaAndUpdateState = async (names) => {
    const { errors } = await _executeSchema();
    if (names) {
      for (const name of names) {
        const error2 = get$2(errors, name);
        error2 ? set$1(_formState.errors, name, error2) : unset(_formState.errors, name);
      }
    } else {
      _formState.errors = errors;
    }
    return errors;
  };
  const executeBuildInValidation = async (fields, shouldOnlyCheckValid, context = {
    valid: true
  }) => {
    for (const name in fields) {
      const field = fields[name];
      if (field) {
        const _a2 = field, { _f: fieldReference } = _a2, fieldValue = __objRest(_a2, ["_f"]);
        if (fieldReference) {
          const fieldError = await validateField(field, get$2(_formValues, fieldReference.name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation);
          if (fieldError[fieldReference.name]) {
            context.valid = false;
            if (shouldOnlyCheckValid) {
              break;
            }
          }
          if (!shouldOnlyCheckValid) {
            fieldError[fieldReference.name] ? set$1(_formState.errors, fieldReference.name, fieldError[fieldReference.name]) : unset(_formState.errors, fieldReference.name);
          }
        }
        fieldValue && await executeBuildInValidation(fieldValue, shouldOnlyCheckValid, context);
      }
    }
    return context.valid;
  };
  const _removeUnmounted = () => {
    for (const name of _names.unMount) {
      const field = get$2(_fields, name);
      field && (field._f.refs ? field._f.refs.every((ref) => !live(ref)) : !live(field._f.ref)) && unregister(name);
    }
    _names.unMount = new Set();
  };
  const _getDirty = (name, data2) => (name && data2 && set$1(_formValues, name, data2), !deepEqual(getValues(), _defaultValues));
  const _getWatch = (names, defaultValue, isGlobal) => {
    const fieldValues = __spreadValues({}, _stateFlags.mount ? _formValues : isUndefined$1(defaultValue) ? _defaultValues : isString$1(names) ? { [names]: defaultValue } : defaultValue);
    return generateWatchOutput(names, _names, fieldValues, isGlobal);
  };
  const _getFieldArray = (name) => compact(get$2(_stateFlags.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get$2(_defaultValues, name, []) : []));
  const setFieldValue = (name, value, options2 = {}) => {
    const field = get$2(_fields, name);
    let fieldValue = value;
    if (field) {
      const fieldReference = field._f;
      if (fieldReference) {
        !fieldReference.disabled && set$1(_formValues, name, getFieldValueAs(value, fieldReference));
        fieldValue = isWeb && isHTMLElement$1(fieldReference.ref) && isNullOrUndefined(value) ? "" : value;
        if (isMultipleSelect(fieldReference.ref)) {
          [...fieldReference.ref.options].forEach((selectRef) => selectRef.selected = fieldValue.includes(selectRef.value));
        } else if (fieldReference.refs) {
          if (isCheckBoxInput(fieldReference.ref)) {
            fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef) => !checkboxRef.disabled && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data2) => data2 === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
          } else {
            fieldReference.refs.forEach((radioRef) => radioRef.checked = radioRef.value === fieldValue);
          }
        } else if (isFileInput(fieldReference.ref)) {
          fieldReference.ref.value = "";
        } else {
          fieldReference.ref.value = fieldValue;
          if (!fieldReference.ref.type) {
            _subjects.watch.next({
              name
            });
          }
        }
      }
    }
    (options2.shouldDirty || options2.shouldTouch) && updateTouchAndDirty(name, fieldValue, options2.shouldTouch, options2.shouldDirty, true);
    options2.shouldValidate && trigger2(name);
  };
  const setValues = (name, value, options2) => {
    for (const fieldKey in value) {
      const fieldValue = value[fieldKey];
      const fieldName = `${name}.${fieldKey}`;
      const field = get$2(_fields, fieldName);
      (_names.array.has(name) || !isPrimitive(fieldValue) || field && !field._f) && !isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options2) : setFieldValue(fieldName, fieldValue, options2);
    }
  };
  const setValue = (name, value, options2 = {}) => {
    const field = get$2(_fields, name);
    const isFieldArray = _names.array.has(name);
    const cloneValue = cloneObject(value);
    set$1(_formValues, name, cloneValue);
    if (isFieldArray) {
      _subjects.array.next({
        name,
        values: _formValues
      });
      if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options2.shouldDirty) {
        _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
        _subjects.state.next({
          name,
          dirtyFields: _formState.dirtyFields,
          isDirty: _getDirty(name, cloneValue)
        });
      }
    } else {
      field && !field._f && !isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options2) : setFieldValue(name, cloneValue, options2);
    }
    isWatched(name, _names) && _subjects.state.next({});
    _subjects.watch.next({
      name
    });
  };
  const onChange2 = async (event) => {
    const target = event.target;
    let name = target.name;
    const field = get$2(_fields, name);
    if (field) {
      let error2;
      let isValid2;
      const fieldValue = target.type ? getFieldValue(field._f) : getEventValue(event);
      const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
      const shouldSkipValidation = !hasValidation(field._f) && !_options.resolver && !get$2(_formState.errors, name) && !field._f.deps || skipValidation(isBlurEvent, get$2(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
      const watched = isWatched(name, _names, isBlurEvent);
      set$1(_formValues, name, fieldValue);
      if (isBlurEvent) {
        field._f.onBlur && field._f.onBlur(event);
      } else if (field._f.onChange) {
        field._f.onChange(event);
      }
      const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
      const shouldRender = !isEmptyObject(fieldState) || watched;
      !isBlurEvent && _subjects.watch.next({
        name,
        type: event.type
      });
      if (shouldSkipValidation) {
        return shouldRender && _subjects.state.next(__spreadValues({ name }, watched ? {} : fieldState));
      }
      !isBlurEvent && watched && _subjects.state.next({});
      validateFields[name] = validateFields[name] ? 1 : 1;
      _subjects.state.next({
        isValidating: true
      });
      if (_options.resolver) {
        const { errors } = await _executeSchema([name]);
        const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
        const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
        error2 = errorLookupResult.error;
        name = errorLookupResult.name;
        isValid2 = isEmptyObject(errors);
      } else {
        error2 = (await validateField(field, get$2(_formValues, name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
        isValid2 = await _updateValid(true);
      }
      field._f.deps && trigger2(field._f.deps);
      shouldRenderByError(false, name, isValid2, error2, fieldState);
    }
  };
  const trigger2 = async (name, options2 = {}) => {
    let isValid2;
    let validationResult;
    const fieldNames = convertToArrayPayload(name);
    _subjects.state.next({
      isValidating: true
    });
    if (_options.resolver) {
      const errors = await executeSchemaAndUpdateState(isUndefined$1(name) ? name : fieldNames);
      isValid2 = isEmptyObject(errors);
      validationResult = name ? !fieldNames.some((name2) => get$2(errors, name2)) : isValid2;
    } else if (name) {
      validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
        const field = get$2(_fields, fieldName);
        return await executeBuildInValidation(field && field._f ? { [fieldName]: field } : field);
      }))).every(Boolean);
      !(!validationResult && !_formState.isValid) && _updateValid();
    } else {
      validationResult = isValid2 = await executeBuildInValidation(_fields);
    }
    _subjects.state.next(__spreadProps(__spreadValues(__spreadValues({}, !isString$1(name) || _proxyFormState.isValid && isValid2 !== _formState.isValid ? {} : { name }), _options.resolver ? { isValid: isValid2 } : {}), {
      errors: _formState.errors,
      isValidating: false
    }));
    options2.shouldFocus && !validationResult && focusFieldBy(_fields, (key) => get$2(_formState.errors, key), name ? fieldNames : _names.mount);
    return validationResult;
  };
  const getValues = (fieldNames) => {
    const values = __spreadValues(__spreadValues({}, _defaultValues), _stateFlags.mount ? _formValues : {});
    return isUndefined$1(fieldNames) ? values : isString$1(fieldNames) ? get$2(values, fieldNames) : fieldNames.map((name) => get$2(values, name));
  };
  const getFieldState = (name, formState) => ({
    invalid: !!get$2((formState || _formState).errors, name),
    isDirty: !!get$2((formState || _formState).dirtyFields, name),
    isTouched: !!get$2((formState || _formState).touchedFields, name),
    error: get$2((formState || _formState).errors, name)
  });
  const clearErrors = (name) => {
    name ? convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName)) : _formState.errors = {};
    _subjects.state.next({
      errors: _formState.errors
    });
  };
  const setError = (name, error2, options2) => {
    const ref = (get$2(_fields, name, { _f: {} })._f || {}).ref;
    set$1(_formState.errors, name, __spreadProps(__spreadValues({}, error2), {
      ref
    }));
    _subjects.state.next({
      name,
      errors: _formState.errors,
      isValid: false
    });
    options2 && options2.shouldFocus && ref && ref.focus && ref.focus();
  };
  const watch = (name, defaultValue) => isFunction$5(name) ? _subjects.watch.subscribe({
    next: (info) => name(_getWatch(void 0, defaultValue), info)
  }) : _getWatch(name, defaultValue, true);
  const unregister = (name, options2 = {}) => {
    for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
      _names.mount.delete(fieldName);
      _names.array.delete(fieldName);
      if (get$2(_fields, fieldName)) {
        if (!options2.keepValue) {
          unset(_fields, fieldName);
          unset(_formValues, fieldName);
        }
        !options2.keepError && unset(_formState.errors, fieldName);
        !options2.keepDirty && unset(_formState.dirtyFields, fieldName);
        !options2.keepTouched && unset(_formState.touchedFields, fieldName);
        !_options.shouldUnregister && !options2.keepDefaultValue && unset(_defaultValues, fieldName);
      }
    }
    _subjects.watch.next({});
    _subjects.state.next(__spreadValues(__spreadValues({}, _formState), !options2.keepDirty ? {} : { isDirty: _getDirty() }));
    !options2.keepIsValid && _updateValid();
  };
  const register = (name, options2 = {}) => {
    let field = get$2(_fields, name);
    const disabledIsDefined = isBoolean(options2.disabled);
    set$1(_fields, name, {
      _f: __spreadValues(__spreadProps(__spreadValues({}, field && field._f ? field._f : { ref: { name } }), {
        name,
        mount: true
      }), options2)
    });
    _names.mount.add(name);
    field ? disabledIsDefined && set$1(_formValues, name, options2.disabled ? void 0 : get$2(_formValues, name, getFieldValue(field._f))) : updateValidAndValue(name, true, options2.value);
    return __spreadProps(__spreadValues(__spreadValues({}, disabledIsDefined ? { disabled: options2.disabled } : {}), _options.shouldUseNativeValidation ? {
      required: !!options2.required,
      min: getRuleValue(options2.min),
      max: getRuleValue(options2.max),
      minLength: getRuleValue(options2.minLength),
      maxLength: getRuleValue(options2.maxLength),
      pattern: getRuleValue(options2.pattern)
    } : {}), {
      name,
      onChange: onChange2,
      onBlur: onChange2,
      ref: (ref) => {
        if (ref) {
          register(name, options2);
          field = get$2(_fields, name);
          const fieldRef = isUndefined$1(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
          const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
          const refs = field._f.refs || [];
          if (radioOrCheckbox ? refs.find((option) => option === fieldRef) : fieldRef === field._f.ref) {
            return;
          }
          set$1(_fields, name, {
            _f: __spreadValues(__spreadValues({}, field._f), radioOrCheckbox ? {
              refs: [
                ...refs.filter(live),
                fieldRef,
                ...!!Array.isArray(get$2(_defaultValues, name)) ? [{}] : []
              ],
              ref: { type: fieldRef.type, name }
            } : { ref: fieldRef })
          });
          updateValidAndValue(name, false, void 0, fieldRef);
        } else {
          field = get$2(_fields, name, {});
          if (field._f) {
            field._f.mount = false;
          }
          (_options.shouldUnregister || options2.shouldUnregister) && !(isNameInFieldArray(_names.array, name) && _stateFlags.action) && _names.unMount.add(name);
        }
      }
    });
  };
  const handleSubmit = (onValid, onInvalid) => async (e2) => {
    if (e2) {
      e2.preventDefault && e2.preventDefault();
      e2.persist && e2.persist();
    }
    let hasNoPromiseError = true;
    let fieldValues = cloneObject(_formValues);
    _subjects.state.next({
      isSubmitting: true
    });
    try {
      if (_options.resolver) {
        const { errors, values } = await _executeSchema();
        _formState.errors = errors;
        fieldValues = values;
      } else {
        await executeBuildInValidation(_fields);
      }
      if (isEmptyObject(_formState.errors) && Object.keys(_formState.errors).every((name) => get$2(fieldValues, name))) {
        _subjects.state.next({
          errors: {},
          isSubmitting: true
        });
        await onValid(fieldValues, e2);
      } else {
        if (onInvalid) {
          await onInvalid(__spreadValues({}, _formState.errors), e2);
        }
        _options.shouldFocusError && focusFieldBy(_fields, (key) => get$2(_formState.errors, key), _names.mount);
      }
    } catch (err) {
      hasNoPromiseError = false;
      throw err;
    } finally {
      _formState.isSubmitted = true;
      _subjects.state.next({
        isSubmitted: true,
        isSubmitting: false,
        isSubmitSuccessful: isEmptyObject(_formState.errors) && hasNoPromiseError,
        submitCount: _formState.submitCount + 1,
        errors: _formState.errors
      });
    }
  };
  const resetField = (name, options2 = {}) => {
    if (get$2(_fields, name)) {
      if (isUndefined$1(options2.defaultValue)) {
        setValue(name, get$2(_defaultValues, name));
      } else {
        setValue(name, options2.defaultValue);
        set$1(_defaultValues, name, options2.defaultValue);
      }
      if (!options2.keepTouched) {
        unset(_formState.touchedFields, name);
      }
      if (!options2.keepDirty) {
        unset(_formState.dirtyFields, name);
        _formState.isDirty = options2.defaultValue ? _getDirty(name, get$2(_defaultValues, name)) : _getDirty();
      }
      if (!options2.keepError) {
        unset(_formState.errors, name);
        _proxyFormState.isValid && _updateValid();
      }
      _subjects.state.next(__spreadValues({}, _formState));
    }
  };
  const reset = (formValues, keepStateOptions = {}) => {
    const updatedValues = formValues || _defaultValues;
    const cloneUpdatedValues = cloneObject(updatedValues);
    const values = formValues && !isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;
    if (!keepStateOptions.keepDefaultValues) {
      _defaultValues = updatedValues;
    }
    if (!keepStateOptions.keepValues) {
      if (isWeb && isUndefined$1(formValues)) {
        for (const name of _names.mount) {
          const field = get$2(_fields, name);
          if (field && field._f) {
            const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
            try {
              isHTMLElement$1(fieldReference) && fieldReference.closest("form").reset();
              break;
            } catch (_a2) {
            }
          }
        }
      }
      _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? cloneObject(_defaultValues) : {} : cloneUpdatedValues;
      _fields = {};
      _subjects.array.next({
        values
      });
      _subjects.watch.next({
        values
      });
    }
    _names = {
      mount: new Set(),
      unMount: new Set(),
      array: new Set(),
      watch: new Set(),
      watchAll: false,
      focus: ""
    };
    _stateFlags.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
    _stateFlags.watch = !!props.shouldUnregister;
    _subjects.state.next({
      submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
      isDirty: keepStateOptions.keepDirty ? _formState.isDirty : keepStateOptions.keepDefaultValues ? !deepEqual(formValues, _defaultValues) : false,
      isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
      dirtyFields: keepStateOptions.keepDirty ? _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? Object.entries(formValues).reduce((previous, [key, value]) => __spreadProps(__spreadValues({}, previous), {
        [key]: value !== get$2(_defaultValues, key)
      }), {}) : {},
      touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
      errors: keepStateOptions.keepErrors ? _formState.errors : {},
      isSubmitting: false,
      isSubmitSuccessful: false
    });
  };
  const setFocus = (name, options2 = {}) => {
    const field = get$2(_fields, name)._f;
    const fieldRef = field.refs ? field.refs[0] : field.ref;
    options2.shouldSelect ? fieldRef.select() : fieldRef.focus();
  };
  return {
    control: {
      register,
      unregister,
      getFieldState,
      _executeSchema,
      _getWatch,
      _getDirty,
      _updateValid,
      _removeUnmounted,
      _updateFieldArray,
      _getFieldArray,
      _subjects,
      _proxyFormState,
      get _fields() {
        return _fields;
      },
      get _formValues() {
        return _formValues;
      },
      get _stateFlags() {
        return _stateFlags;
      },
      set _stateFlags(value) {
        _stateFlags = value;
      },
      get _defaultValues() {
        return _defaultValues;
      },
      get _names() {
        return _names;
      },
      set _names(value) {
        _names = value;
      },
      get _formState() {
        return _formState;
      },
      set _formState(value) {
        _formState = value;
      },
      get _options() {
        return _options;
      },
      set _options(value) {
        _options = __spreadValues(__spreadValues({}, _options), value);
      }
    },
    trigger: trigger2,
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    resetField,
    clearErrors,
    unregister,
    setError,
    setFocus,
    getFieldState
  };
}
function useForm(props = {}) {
  const _formControl = React__default.useRef();
  const [formState, updateFormState] = React__default.useState({
    isDirty: false,
    isValidating: false,
    dirtyFields: {},
    isSubmitted: false,
    submitCount: 0,
    touchedFields: {},
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    errors: {}
  });
  if (_formControl.current) {
    _formControl.current.control._options = props;
  } else {
    _formControl.current = __spreadProps(__spreadValues({}, createFormControl(props)), {
      formState
    });
  }
  const control = _formControl.current.control;
  const callback = React__default.useCallback((value) => {
    if (shouldRenderFormState(value, control._proxyFormState, true)) {
      control._formState = __spreadValues(__spreadValues({}, control._formState), value);
      updateFormState(__spreadValues({}, control._formState));
    }
  }, [control]);
  useSubscribe({
    subject: control._subjects.state,
    callback
  });
  React__default.useEffect(() => {
    if (!control._stateFlags.mount) {
      control._proxyFormState.isValid && control._updateValid();
      control._stateFlags.mount = true;
    }
    if (control._stateFlags.watch) {
      control._stateFlags.watch = false;
      control._subjects.state.next({});
    }
    control._removeUnmounted();
  });
  _formControl.current.formState = getProxyFormState(formState, control._proxyFormState);
  return _formControl.current;
}
function getColorFrom(variant) {
  switch (variant) {
    case "information":
      return "tw-border-darkblue-500 tw-bg-darkblue-100";
    case "success":
      return "tw-border-green-500 tw-bg-green-100";
    case "warning":
      return "tw-border-orange-500 tw-bg-orange-100";
    case "error":
      return "tw-border-red-500 tw-bg-red-100";
    default:
      throw new Error("Error! invalid alert outline variant");
  }
}
function getIconNameFrom(variant) {
  switch (variant) {
    case "information":
    case "warning":
      return IconName.CIRCLE_EXCLAMTION_SOLID;
    case "success":
      return IconName.CIRCLE_CHECK;
    case "error":
      return IconName.OUTLINE_X_CIRCLE;
    default:
      throw new Error("Error! invalid alert outline variant");
  }
}
function getIconColorForm(type) {
  switch (type) {
    case "information":
      return "tw-text-darkblue-500";
    case "success":
      return "tw-fill-green-500";
    case "warning":
      return "tw-text-orange-500";
    case "error":
      return "tw-text-red-500";
    default:
      throw new Error("Error! invalid alert outline variant");
  }
}
function AlertOutline({
  actionText = "",
  className = "",
  content = "",
  style = {},
  title = "",
  type = "information",
  onClickAction,
  onClose
}) {
  const color = getColorFrom(type);
  const iconName = getIconNameFrom(type);
  const iconColor = getIconColorForm(type);
  const isInformation = type === "information";
  return /* @__PURE__ */ jsxs("div", {
    className: classNames$1("tw-flex tw-justify-between tw-items-start tw-border tw-border-solid tw-rounded-lg tw-p-4 tw-min-w-fit tw-h-auto", color, className),
    style,
    children: [/* @__PURE__ */ jsx$1("div", {
      className: "tw-w-5 tw-h-5",
      children: /* @__PURE__ */ jsx$1(Icon, {
        name: iconName,
        size: IconSize.MEDIUM,
        className: classNames$1(iconColor, {
          "tw-rotate-180": isInformation
        })
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-flex-1 tw-mx-4",
      children: [title && /* @__PURE__ */ jsx$1("h1", {
        className: "tw-text-sm tw-font-normal tw-text-grayscale-800 tw-select-none",
        children: title
      }), /* @__PURE__ */ jsx$1("p", {
        className: classNames$1("tw-text-grayscale-500 tw-text-sm tw-font-normal tw-select-none", {
          "tw-mt-2": title
        }),
        dangerouslySetInnerHTML: {
          __html: content
        }
      }), onClickAction && /* @__PURE__ */ jsx$1(Button, {
        className: "tw-mt-2",
        size: "small",
        variant: "tertiary",
        onClick: onClickAction,
        children: actionText
      })]
    }), onClose && /* @__PURE__ */ jsx$1("div", {
      className: "tw-w-5 tw-h-5",
      children: /* @__PURE__ */ jsx$1(Button, {
        variant: "custom",
        className: "tw-p-[5px] tw-min-w-fit",
        onClick: onClose,
        children: /* @__PURE__ */ jsx$1(Icon, {
          name: IconName.CLOSE,
          size: IconSize.MEDIUM,
          className: "tw-mx-auto tw-w-[10px] tw-h-[10px] tw-fill-grayscale-500"
        })
      })
    })]
  });
}
function CardConnectLineInfo({
  isShowConnectLineInfo,
  onCancel,
  onConnect
}) {
  const {
    t: t2
  } = useTranslation();
  const {
    formState: {
      errors
    },
    register,
    handleSubmit
  } = useForm();
  const submitForm = (formData) => {
    onConnect(formData);
  };
  if (!isShowConnectLineInfo) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "tw-pt-8 tw-pb-4 tw-mt-6 tablet:tw-mt-8",
      children: [/* @__PURE__ */ jsx$1("h4", {
        className: "tw-text-base tw-font-medium tw-text-grayscale-800",
        children: t2("cardConnect.lineChannelIdAndSecretTitle")
      }), /* @__PURE__ */ jsx$1("p", {
        className: "tw-text-base tw-font-normal tw-text-grayscale-800",
        dangerouslySetInnerHTML: {
          __html: t2("cardConnect.lineChannelIdAndSecretDescription")
        }
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-my-4",
      children: [/* @__PURE__ */ jsx$1("h4", {
        className: "tw-text-base tw-font-medium tw-text-grayscale-800",
        children: t2("cardConnect.lineChannelAccessTokenTitle")
      }), /* @__PURE__ */ jsx$1("p", {
        className: "tw-text-base tw-font-normal tw-text-grayscale-800",
        dangerouslySetInnerHTML: {
          __html: t2("cardConnect.lineChannelAccessTokenDescription1")
        }
      }), /* @__PURE__ */ jsx$1(AlertOutline, {
        type: "information",
        className: "tw-my-[10px]",
        content: t2("cardConnect.lineChannelAccessTokenAlertInformation")
      }), /* @__PURE__ */ jsx$1("p", {
        className: "tw-text-base tw-font-normal tw-text-grayscale-800",
        dangerouslySetInnerHTML: {
          __html: t2("cardConnect.lineChannelAccessTokenDescription2")
        }
      }), /* @__PURE__ */ jsx$1("a", {
        href: "https://tutorials.1convo.ai/getstarted/connection",
        className: "tw-block tw-mt-[10px] tw-text-base tw-font-medium tw-text-primary-600",
        target: "_blank",
        rel: "noreferrer",
        children: t2("cardConnect.learnMore")
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-mt-8",
      children: [/* @__PURE__ */ jsx$1("h3", {
        className: "tw-text-xl tw-font-medium tw-text-grayscale-800",
        children: t2("cardConnect.lineConnectMessageApi")
      }), /* @__PURE__ */ jsxs("form", {
        onSubmit: handleSubmit(submitForm),
        children: [/* @__PURE__ */ jsxs("div", {
          className: "tw-flex tw-flex-col tw-mt-4",
          children: [/* @__PURE__ */ jsx$1("label", {
            htmlFor: "lineChannelId",
            className: "tw-text-sm tw-font-medium tw-text-grayscale-600",
            children: t2("cardConnect.lineChannelId")
          }), /* @__PURE__ */ jsx$1("input", __spreadValues({
            type: "text",
            id: "lineChannelId",
            className: classNames$1("tw-mt-1 tw-border tw-border-solid tw-rounded tw-py-3 tw-px-4 tw-text-grayscale-800 tw-text-sm tw-font-normal disabled:tw-bg-grayscale-200 disabled:tw-text-grayscale-400 placeholder:tw-text-grayscale-400 read-only:tw-bg-grayscale-200 read-only:tw-text-grayscale-400 focus-within:tw-outline-0", {
              "tw-border-grayscale-400 focus:tw-border-primary-400": !errors.lineChannelId,
              "tw-border-red-500": errors.lineChannelId
            })
          }, register("lineChannelId", {
            required: true
          })))]
        }), /* @__PURE__ */ jsxs("div", {
          className: "tw-flex tw-flex-col tw-mt-4",
          children: [/* @__PURE__ */ jsx$1("label", {
            htmlFor: "lineChannelSecret",
            className: "tw-text-sm tw-font-medium tw-text-grayscale-600",
            children: t2("cardConnect.lineChannelSecret")
          }), /* @__PURE__ */ jsx$1("input", __spreadValues({
            type: "text",
            id: "lineChannelSecret",
            className: classNames$1("tw-mt-1 tw-border tw-border-solid tw-rounded tw-py-3 tw-px-4 tw-text-grayscale-800 tw-text-sm tw-font-normal disabled:tw-bg-grayscale-200 disabled:tw-text-grayscale-400 placeholder:tw-text-grayscale-400 read-only:tw-bg-grayscale-200 read-only:tw-text-grayscale-400 focus-within:tw-outline-0", {
              "tw-border-grayscale-400 focus:tw-border-primary-400": !errors.lineChannelSecret,
              "tw-border-red-500": errors.lineChannelSecret
            })
          }, register("lineChannelSecret", {
            required: true
          })))]
        }), /* @__PURE__ */ jsxs("div", {
          className: "tw-flex tw-flex-col tw-mt-4",
          children: [/* @__PURE__ */ jsx$1("label", {
            htmlFor: "lineChannelAccessToken",
            className: "tw-text-sm tw-font-medium tw-text-grayscale-600",
            children: t2("cardConnect.lineChannelAccessToken")
          }), /* @__PURE__ */ jsx$1("input", __spreadValues({
            type: "text",
            id: "lineChannelAccessToken",
            className: classNames$1("tw-mt-1 tw-border tw-border-solid tw-rounded tw-py-3 tw-px-4 tw-text-grayscale-800 tw-text-sm tw-font-normal disabled:tw-bg-grayscale-200 disabled:tw-text-grayscale-400 placeholder:tw-text-grayscale-400 read-only:tw-bg-grayscale-200 read-only:tw-text-grayscale-400 focus-within:tw-outline-0", {
              "tw-border-grayscale-400 focus:tw-border-primary-400": !errors.lineChannelAccessToken,
              "tw-border-red-500": errors.lineChannelAccessToken
            })
          }, register("lineChannelAccessToken", {
            required: true
          })))]
        }), /* @__PURE__ */ jsx$1(AlertOutline, {
          type: "information",
          className: "tw-mt-9",
          content: t2("cardConnect.lineConnectMessageApiAlertInformation")
        }), /* @__PURE__ */ jsxs("div", {
          className: "tw-flex tw-justify-end tw-items-center tw-pt-4 tw-mt-8",
          children: [/* @__PURE__ */ jsx$1(Button, {
            type: "button",
            size: "medium",
            variant: "text",
            onClick: onCancel,
            children: t2("cardConnect.cancel")
          }), /* @__PURE__ */ jsx$1(Button, {
            type: "submit",
            size: "medium",
            variant: "primary",
            className: "tw-ml-3",
            children: t2("cardConnect.connect")
          })]
        })]
      })]
    })]
  });
}
function CardDisconnectInfo({
  isConnected,
  profilePicture,
  title,
  onDisconnect
}) {
  const {
    t: t2
  } = useTranslation();
  if (!isConnected) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "tw-flex tw-flex-col tw-items-start tw-pl-12 tw-mt-4 tablet:tw-flex-row tablet:tw-items-center tablet:tw-pl-0 tablet:tw-mt-9",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-items-start tablet:tw-flex-1",
      children: [/* @__PURE__ */ jsx$1("img", {
        src: profilePicture || ICON_CONNECT_PROFILE_PATH,
        className: "tw-w-8 tw-h-8 tw-rounded-full tablet:tw-w-[54px] tablet:tw-h-[54px]",
        alt: "connect profile"
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-ml-4",
        children: [/* @__PURE__ */ jsx$1("h4", {
          className: "tw-text-xl tw-font-medium tw-text-grayscale-800",
          children: title
        }), /* @__PURE__ */ jsx$1("div", {
          className: "tw-p-1 tw-w-fit tw-text-xs tw-font-medium tw-text-white tw-bg-green-400 tw-rounded",
          children: t2("cardConnect.connected")
        })]
      })]
    }), /* @__PURE__ */ jsx$1(Button, {
      variant: "custom",
      className: "tw-mt-8 tw-text-white tw-bg-red-400 hover:tw-bg-red-500 tablet:tw-mt-0",
      onClick: onDisconnect,
      children: t2("cardConnect.disconnect")
    })]
  });
}
function CardDisconnectLineInfo({
  isShowDisconnectLineInfo,
  lineChannelAccessToken,
  lineChannelAccount,
  lineChannelId,
  lineChannelPicture,
  lineChannelSecret,
  title,
  onDisconnect
}) {
  const {
    t: t2
  } = useTranslation();
  if (!isShowDisconnectLineInfo) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "tw-mt-6 tablet:tw-pt-8 tablet:tw-mt-8",
    children: [/* @__PURE__ */ jsx$1("h3", {
      className: "tw-text-lg tw-font-medium tw-leading-6 tw-text-grayscale-800 tablet:tw-text-xl",
      children: t2("cardConnect.lineConnectMessageApi")
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-justify-between tw-items-start tw-mt-4 tablet:tw-mt-8",
      children: [/* @__PURE__ */ jsx$1("img", {
        src: lineChannelPicture || ICON_CONNECT_PROFILE_PATH,
        className: "tw-w-8 tw-h-8 tw-rounded-full tablet:tw-w-[54px] tablet:tw-h-[54px]",
        alt: "connect profile"
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-flex-1 tw-ml-4",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "tw-inline-flex tw-items-baseline",
          children: [/* @__PURE__ */ jsx$1("h4", {
            className: "tw-text-xl tw-font-medium tw-text-grayscale-800",
            children: title
          }), /* @__PURE__ */ jsx$1("small", {
            className: "tw-ml-2 tw-text-sm tw-font-medium tw-text-grayscale-600",
            children: lineChannelAccount
          })]
        }), /* @__PURE__ */ jsx$1("div", {
          className: "tw-p-1 tw-w-fit tw-text-xs tw-font-medium tw-text-white tw-bg-green-400 tw-rounded",
          children: t2("cardConnect.connected")
        })]
      })]
    }), /* @__PURE__ */ jsxs("form", {
      className: "tw-mt-4 tablet:tw-mt-8",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-flex-col tw-mt-4",
        children: [/* @__PURE__ */ jsx$1("label", {
          htmlFor: "lineChannelId",
          className: "tw-text-sm tw-font-medium tw-text-grayscale-600",
          children: t2("cardConnect.lineChannelId")
        }), /* @__PURE__ */ jsx$1("input", {
          disabled: true,
          type: "text",
          name: "lineChannelId",
          className: "tw-py-3 tw-px-4 tw-mt-1 tw-text-sm tw-font-normal tw-text-grayscale-800 placeholder:tw-text-grayscale-400 read-only:tw-text-grayscale-400 disabled:tw-text-grayscale-400 read-only:tw-bg-grayscale-200 disabled:tw-bg-grayscale-200 tw-rounded tw-border tw-border-grayscale-400 tw-border-solid",
          value: lineChannelId
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-flex-col tw-mt-4",
        children: [/* @__PURE__ */ jsx$1("label", {
          htmlFor: "lineChannelSecret",
          className: "tw-text-sm tw-font-medium tw-text-grayscale-600",
          children: t2("cardConnect.lineChannelSecret")
        }), /* @__PURE__ */ jsx$1("input", {
          disabled: true,
          type: "text",
          id: "lineChannelSecret",
          name: "lineChannelSecret",
          className: "tw-py-3 tw-px-4 tw-mt-1 tw-text-sm tw-font-normal tw-text-grayscale-800 placeholder:tw-text-grayscale-400 read-only:tw-text-grayscale-400 disabled:tw-text-grayscale-400 read-only:tw-bg-grayscale-200 disabled:tw-bg-grayscale-200 tw-rounded tw-border tw-border-grayscale-400 tw-border-solid",
          value: lineChannelSecret
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-flex-col tw-mt-4",
        children: [/* @__PURE__ */ jsx$1("label", {
          htmlFor: "lineChannelAccessToken",
          className: "tw-text-sm tw-font-medium tw-text-grayscale-600",
          children: t2("cardConnect.lineChannelAccessToken")
        }), /* @__PURE__ */ jsx$1("input", {
          disabled: true,
          type: "text",
          id: "lineChannelAccessToken",
          name: "lineChannelAccessToken",
          className: "tw-py-3 tw-px-4 tw-mt-1 tw-text-sm tw-font-normal tw-text-grayscale-800 placeholder:tw-text-grayscale-400 read-only:tw-text-grayscale-400 disabled:tw-text-grayscale-400 read-only:tw-bg-grayscale-200 disabled:tw-bg-grayscale-200 tw-rounded tw-border tw-border-grayscale-400 tw-border-solid",
          value: lineChannelAccessToken
        })]
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-mt-9 tablet:tw-flex tablet:tw-justify-end",
        children: /* @__PURE__ */ jsx$1(Button, {
          variant: "custom",
          className: "tw-text-white tw-bg-red-400 hover:tw-bg-red-500 tablet:tw-mt-4",
          onClick: onDisconnect,
          children: t2("cardConnect.disconnect")
        })
      })]
    })]
  });
}
function CardConnect({
  variant,
  connectedTitle = "",
  className = "",
  isConnected = false,
  isNew = false,
  lineChannelAccessToken = "",
  lineChannelAccount = "",
  lineChannelId = "",
  lineChannelPicture = "",
  lineChannelSecret = "",
  profilePicture = "",
  style = {},
  onClickConnect = () => {
  },
  onClickDisconnect = () => {
  },
  onClickWatchVideo = () => {
  }
}) {
  const [isShowConnectLineForm, setIsShowConnectLineForm] = useState(false);
  const isFacebook = variant === "facebook";
  const isInstagram = variant === "instagram";
  const isLine = variant === "line";
  const handleClickCancelConnectLineForm = () => {
    setIsShowConnectLineForm(false);
  };
  const handleClickConnectButton = () => {
    if (isLine) {
      setIsShowConnectLineForm(true);
    }
    onClickConnect();
  };
  const handleClickConnectLineForm = (data2) => {
    onClickConnect(data2);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: classNames$1("tw-border tw-border-solid tw-border-grayscale-200 tw-box-border tw-py-6 tw-px-4 tw-bg-white tablet:tw-rounded-lg tablet:tw-py-8 tablet:tw-px-9", className),
    style,
    children: [/* @__PURE__ */ jsx$1(CardConnectInfo, {
      isNew,
      isShowConnectButton: !isConnected && !isShowConnectLineForm,
      variant,
      onConnect: handleClickConnectButton,
      onClickWatchVideo
    }), /* @__PURE__ */ jsx$1(CardDisconnectInfo, {
      isConnected: isConnected && (isFacebook || isInstagram),
      profilePicture,
      title: connectedTitle,
      onDisconnect: onClickDisconnect
    }), /* @__PURE__ */ jsx$1(CardConnectLineInfo, {
      isShowConnectLineInfo: !isConnected && isLine && isShowConnectLineForm,
      onCancel: handleClickCancelConnectLineForm,
      onConnect: handleClickConnectLineForm
    }), /* @__PURE__ */ jsx$1(CardDisconnectLineInfo, {
      isShowDisconnectLineInfo: isConnected && isLine,
      lineChannelAccessToken,
      lineChannelAccount,
      lineChannelId,
      lineChannelPicture,
      lineChannelSecret,
      title: connectedTitle,
      onDisconnect: onClickDisconnect
    })]
  });
}
function ModalConfirmDisconnection({
  isOpen,
  variant,
  isLoading = false,
  onClose,
  onConfirm
}) {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(Modal, {
    isClickOverlayToClose: false,
    isOpen,
    size: "small",
    onClose,
    children: [/* @__PURE__ */ jsx$1("img", {
      src: ICON_DISCONNECT_PATH,
      className: "tw-block tw-mx-auto",
      alt: "icon disconnect"
    }), /* @__PURE__ */ jsx$1("h1", {
      className: "tw-py-4 tw-px-6 tw-mt-2 tw-text-[28px] tw-font-medium tw-leading-10 tw-text-center tw-text-grayscale-800",
      children: t2(`modalConfirmDisconnection.title.${variant}`)
    }), /* @__PURE__ */ jsx$1("p", {
      className: "tw-py-2 tw-px-6 tw-text-sm tw-font-normal tw-text-center tw-text-grayscale-500",
      dangerouslySetInnerHTML: {
        __html: t2("modalConfirmDisconnection.content")
      }
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-justify-between tw-items-center tw-mt-8 tw-mb-6",
      children: [/* @__PURE__ */ jsx$1(Button, {
        className: classNames$1("tw-mr-1", {
          "tablet:tw-flex-1": !isLoading
        }),
        size: "large",
        variant: "text",
        onClick: onClose,
        children: t2("modalConfirmDisconnection.cancel")
      }), /* @__PURE__ */ jsx$1(Button, {
        className: "tw-flex-1 tw-ml-1",
        size: "large",
        variant: "primary",
        onClick: onConfirm,
        disabled: isLoading,
        children: t2(isLoading ? "modalConfirmDisconnection.disconnecting" : "modalConfirmDisconnection.disconnect")
      })]
    })]
  });
}
const Radio = React__default.forwardRef((props, ref) => {
  const _a2 = props, {
    radioSize = "normal",
    className
  } = _a2, htmlAttributes = __objRest(_a2, [
    "radioSize",
    "className"
  ]);
  const isNormal = radioSize === "normal";
  const isLarge = radioSize === "large";
  return /* @__PURE__ */ jsx$1("input", __spreadValues({
    type: "radio",
    ref,
    className: classNames$1("tw-appearance-none tw-block tw-border tw-border-solid tw-border-grayscale-400 tw-rounded-full tw-box-border tw-bg-white tw-transition tw-duration-200 hover:tw-cursor-pointer checked:tw-border-primary-500 disabled:tw-bg-grayscale-200 checked:disabled:tw-border-primary-300", {
      "tw-w-[14px] tw-h-[14px] checked:tw-border-4": isNormal,
      "tw-w-5 tw-h-5 checked:tw-border-[6px]": isLarge
    }, className)
  }, htmlAttributes));
});
Radio.displayName = "Radio";
function getSizingChecker(size) {
  return {
    isNormal: size === "normal",
    isLarge: size === "large"
  };
}
function getVariantChecker(variant) {
  return {
    isDefault: variant === "default",
    isButton: variant === "button",
    isSelectButton: variant === "selectButton",
    isButtonDescription: variant === "buttonDescription",
    isSelectDescription: variant === "selectDescription"
  };
}
function getAvailableChecker(disabled, readOnly) {
  return {
    isAvailable: !disabled && !readOnly,
    isUnavailable: disabled || readOnly
  };
}
function RadioButtonButton(_j) {
  var _k = _j, {
    label,
    checked = false,
    disabled = false,
    radioButtonSize = "normal",
    readOnly = false
  } = _k, htmlRadioInputAttributes = __objRest(_k, [
    "label",
    "checked",
    "disabled",
    "radioButtonSize",
    "readOnly"
  ]);
  const {
    isNormal,
    isLarge
  } = getSizingChecker(radioButtonSize);
  const {
    isAvailable,
    isUnavailable
  } = getAvailableChecker(disabled, readOnly);
  return /* @__PURE__ */ jsxs("label", {
    className: classNames$1("tw-relative tw-border tw-border-solid tw-rounded hover:tw-cursor-pointer", {
      "tw-border-grayscale-400 tw-bg-white": isAvailable && !checked,
      "tw-border-grayscale-400 tw-bg-grayscale-200": isUnavailable && !checked,
      "tw-border-primary-500 tw-bg-primary-200": isAvailable && checked,
      "tw-border-primary-300 tw-bg-primary-100": isUnavailable && checked,
      "tw-py-2 tw-px-4": isNormal,
      "tw-p-4": isLarge
    }),
    children: [/* @__PURE__ */ jsx$1(Radio, __spreadValues({
      className: "tw-sr-only",
      checked,
      disabled,
      readOnly
    }, htmlRadioInputAttributes)), /* @__PURE__ */ jsx$1("span", {
      className: classNames$1("tw-font-serif tw-font-medium tw-select-none", {
        "tw-text-grayscale-800": isAvailable,
        "tw-text-grayscale-400": isUnavailable && !checked,
        "tw-text-primary-300": isUnavailable && checked,
        "tw-text-sm": isNormal,
        "tw-text-base": isLarge
      }),
      children: label
    })]
  });
}
function RadioButtonButtonDescription(_l) {
  var _m = _l, {
    label,
    checked = false,
    description = "",
    disabled = false,
    radioButtonSize = "normal",
    readOnly = false
  } = _m, htmlRadioInputAttributes = __objRest(_m, [
    "label",
    "checked",
    "description",
    "disabled",
    "radioButtonSize",
    "readOnly"
  ]);
  const {
    isNormal,
    isLarge
  } = getSizingChecker(radioButtonSize);
  const {
    isAvailable,
    isUnavailable
  } = getAvailableChecker(disabled, readOnly);
  return /* @__PURE__ */ jsxs("label", {
    className: classNames$1("tw-relative tw-inline-flex tw-flex-col tw-items-start tw-border tw-border-solid tw-rounded hover:tw-cursor-pointer", {
      "tw-border-grayscale-400 tw-bg-white": isAvailable && !checked,
      "tw-border-grayscale-400 tw-bg-grayscale-200": isUnavailable && !checked,
      "tw-border-primary-500 tw-bg-primary-200": isAvailable && checked,
      "tw-border-primary-300 tw-bg-primary-100": isUnavailable && checked,
      "tw-py-2 tw-px-4": isNormal,
      "tw-p-4": isLarge
    }),
    children: [/* @__PURE__ */ jsx$1(Radio, __spreadValues({
      className: "tw-sr-only",
      checked,
      disabled,
      readOnly
    }, htmlRadioInputAttributes)), /* @__PURE__ */ jsx$1("span", {
      className: classNames$1("tw-font-serif tw-font-medium", {
        "tw-text-grayscale-800": isAvailable,
        "tw-text-grayscale-400": isUnavailable && !checked,
        "tw-text-primary-300": isUnavailable && checked,
        "tw-text-sm": isNormal,
        "tw-text-base": isLarge
      }),
      children: label
    }), /* @__PURE__ */ jsx$1("small", {
      className: classNames$1("tw-mt-1 tw-text-sm tw-font-serif tw-font-medium", {
        "tw-text-grayscale-600": isAvailable,
        "tw-text-grayscale-400": isUnavailable,
        "tw-text-primary-300": isUnavailable && checked
      }),
      children: description
    })]
  });
}
let nanoid = (size = 21) => {
  let id2 = "";
  let bytes = crypto.getRandomValues(new Uint8Array(size));
  while (size--) {
    let byte = bytes[size] & 63;
    if (byte < 36) {
      id2 += byte.toString(36);
    } else if (byte < 62) {
      id2 += (byte - 26).toString(36).toUpperCase();
    } else if (byte < 63) {
      id2 += "_";
    } else {
      id2 += "-";
    }
  }
  return id2;
};
function RadioButtonDefault(_n) {
  var _o = _n, {
    label,
    disabled = false,
    radioButtonSize = "normal",
    readOnly = false
  } = _o, htmlRadioInputAttributes = __objRest(_o, [
    "label",
    "disabled",
    "radioButtonSize",
    "readOnly"
  ]);
  const id2 = nanoid();
  const {
    isNormal,
    isLarge
  } = getSizingChecker(radioButtonSize);
  const {
    isUnavailable
  } = getAvailableChecker(disabled, readOnly);
  const _a2 = htmlRadioInputAttributes, {
    className
  } = _a2, radioAttributes = __objRest(_a2, [
    "className"
  ]);
  return /* @__PURE__ */ jsxs("div", {
    className: classNames$1("tw-inline-flex tw-justify-between tw-items-center", className),
    children: [/* @__PURE__ */ jsx$1(Radio, __spreadValues({
      className: "tw-shrink-0",
      id: id2,
      disabled,
      radioSize: radioButtonSize
    }, radioAttributes)), /* @__PURE__ */ jsx$1("label", {
      htmlFor: id2,
      className: classNames$1("tw-ml-2 tw-font-sans tw-font-medium tw-select-none tw-text-ellipsis tw-overflow-hidden", {
        "tw-text-grayscale-400": isUnavailable,
        "tw-text-grayscale-800": !isUnavailable,
        "tw-text-sm": isNormal,
        "tw-text-base": isLarge
      }),
      children: label
    })]
  });
}
function RadioButtonSelectButton(_p) {
  var _q = _p, {
    label,
    checked = false,
    disabled = false,
    radioButtonSize = "normal",
    readOnly = false
  } = _q, htmlRadioInputAttributes = __objRest(_q, [
    "label",
    "checked",
    "disabled",
    "radioButtonSize",
    "readOnly"
  ]);
  const {
    isNormal,
    isLarge
  } = getSizingChecker(radioButtonSize);
  const {
    isAvailable,
    isUnavailable
  } = getAvailableChecker(disabled, readOnly);
  return /* @__PURE__ */ jsxs("label", {
    className: classNames$1("tw-relative tw-inline-flex tw-justify-center tw-items-center tw-border tw-border-solid tw-rounded hover:tw-cursor-pointer", {
      "tw-border-grayscale-400 tw-bg-white": isAvailable && !checked,
      "tw-border-grayscale-400 tw-bg-grayscale-200": isUnavailable && !checked,
      "tw-border-primary-500 tw-bg-primary-200": isAvailable && checked,
      "tw-border-primary-300 tw-bg-primary-100": isUnavailable && checked,
      "tw-py-2 tw-px-4": isNormal,
      "tw-p-4": isLarge
    }),
    children: [/* @__PURE__ */ jsx$1(Radio, __spreadValues({
      checked,
      disabled,
      readOnly
    }, htmlRadioInputAttributes)), /* @__PURE__ */ jsx$1("span", {
      className: classNames$1("tw-ml-2 tw-font-serif tw-font-medium", {
        "tw-text-grayscale-800": isAvailable,
        "tw-text-grayscale-400": isUnavailable && !checked,
        "tw-text-primary-300": isUnavailable && checked,
        "tw-text-sm": isNormal,
        "tw-text-base": isLarge
      }),
      children: label
    })]
  });
}
function RadioButtonSelectDescription(_r) {
  var _s = _r, {
    label,
    checked = false,
    description = "",
    disabled = false,
    radioButtonSize = "normal",
    readOnly = false
  } = _s, htmlRadioInputAttributes = __objRest(_s, [
    "label",
    "checked",
    "description",
    "disabled",
    "radioButtonSize",
    "readOnly"
  ]);
  const {
    isNormal,
    isLarge
  } = getSizingChecker(radioButtonSize);
  const {
    isAvailable,
    isUnavailable
  } = getAvailableChecker(disabled, readOnly);
  return /* @__PURE__ */ jsxs("label", {
    className: classNames$1("tw-relative tw-inline-flex tw-justify-center tw-items-center tw-border tw-border-solid tw-rounded hover:tw-cursor-pointer", {
      "tw-border-grayscale-400 tw-bg-white": isAvailable && !checked,
      "tw-border-grayscale-400 tw-bg-grayscale-200": isUnavailable && !checked,
      "tw-border-primary-500 tw-bg-primary-200": isAvailable && checked,
      "tw-border-primary-300 tw-bg-primary-100": isUnavailable && checked,
      "tw-py-2 tw-px-4": isNormal,
      "tw-p-4": isLarge
    }),
    children: [/* @__PURE__ */ jsx$1(Radio, __spreadValues({
      checked,
      disabled,
      readOnly
    }, htmlRadioInputAttributes)), /* @__PURE__ */ jsxs("span", {
      className: "tw-flex tw-flex-col tw-items-start tw-ml-4",
      children: [/* @__PURE__ */ jsx$1("span", {
        className: classNames$1("tw-font-serif tw-font-medium", {
          "tw-text-grayscale-800": isAvailable,
          "tw-text-grayscale-400": isUnavailable && !checked,
          "tw-text-primary-300": isUnavailable && checked,
          "tw-text-sm": isNormal,
          "tw-text-base": isLarge
        }),
        children: label
      }), /* @__PURE__ */ jsx$1("small", {
        className: classNames$1("tw-mt-1 tw-text-sm tw-font-serif tw-font-medium", {
          "tw-text-grayscale-600": isAvailable,
          "tw-text-grayscale-400": isUnavailable,
          "tw-text-primary-300": isUnavailable && checked
        }),
        children: description
      })]
    })]
  });
}
function RadioButton$2(_t) {
  var _u = _t, {
    label,
    description = "",
    radioButtonSize = "normal",
    variant = "default"
  } = _u, htmlRadioInputAttributes = __objRest(_u, [
    "label",
    "description",
    "radioButtonSize",
    "variant"
  ]);
  const {
    isButton,
    isSelectButton,
    isButtonDescription,
    isSelectDescription
  } = getVariantChecker(variant);
  if (isButton) {
    return /* @__PURE__ */ jsx$1(RadioButtonButton, __spreadValues({
      label,
      radioButtonSize
    }, htmlRadioInputAttributes));
  }
  if (isSelectButton) {
    return /* @__PURE__ */ jsx$1(RadioButtonSelectButton, __spreadValues({
      label,
      radioButtonSize
    }, htmlRadioInputAttributes));
  }
  if (isButtonDescription) {
    return /* @__PURE__ */ jsx$1(RadioButtonButtonDescription, __spreadValues({
      label,
      description,
      radioButtonSize
    }, htmlRadioInputAttributes));
  }
  if (isSelectDescription) {
    return /* @__PURE__ */ jsx$1(RadioButtonSelectDescription, __spreadValues({
      label,
      description,
      radioButtonSize
    }, htmlRadioInputAttributes));
  }
  return /* @__PURE__ */ jsx$1(RadioButtonDefault, __spreadValues({
    label,
    radioButtonSize
  }, htmlRadioInputAttributes));
}
function ModalConnect({
  isOpen,
  isLoading = false,
  list = [],
  variant,
  onClose,
  onConnect
}) {
  const {
    t: t2
  } = useTranslation();
  const {
    control,
    handleSubmit,
    setValue
  } = useForm({
    defaultValues: {
      selectedItemId: ""
    }
  });
  const submitForm = (formData) => {
    onConnect(formData);
  };
  useEffect(() => {
    if (isOpen && list.length > 0) {
      setValue("selectedItemId", list[0].id);
    }
  }, [isOpen, list]);
  return /* @__PURE__ */ jsxs(Modal, {
    isClickOverlayToClose: false,
    isOpen,
    size: "medium",
    onClose,
    children: [/* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-justify-center tw-items-center tw-py-4 tw-mt-8",
      children: [/* @__PURE__ */ jsx$1(IconConnect, {
        variant,
        className: "tw-mr-2 tw-w-8 tw-h-8"
      }), /* @__PURE__ */ jsx$1("h1", {
        className: "tw-ml-2 tw-text-xl tw-font-semibold tw-text-grayscale-800",
        children: t2(`modalConnect.title.${variant}`)
      })]
    }), /* @__PURE__ */ jsx$1("div", {
      className: "tw-py-4 tw-px-6",
      children: /* @__PURE__ */ jsx$1(AlertOutline, {
        type: "information",
        content: t2("modalConnect.alertContent")
      })
    }), /* @__PURE__ */ jsxs("form", {
      className: "tw-py-6",
      onSubmit: handleSubmit(submitForm),
      children: [/* @__PURE__ */ jsx$1("div", {
        className: "tw-overflow-y-scroll tw-px-6 tw-max-h-[182px]",
        children: list.map(({
          id: itemId,
          name: itemName,
          url
        }, index2) => /* @__PURE__ */ jsxs("div", {
          className: classNames$1("tw-flex tw-justify-between tw-items-center", {
            "tw-mt-[10px]": index2 !== 0
          }),
          children: [/* @__PURE__ */ jsx$1(Controller, {
            name: "selectedItemId",
            control,
            render: ({
              field: {
                name,
                value,
                onChange: onChange2
              }
            }) => /* @__PURE__ */ jsx$1(RadioButton$2, {
              className: "tw-max-w-[calc(100%_-_62px)]",
              checked: value === itemId,
              label: itemName,
              name,
              radioButtonSize: "large",
              value: itemId,
              onChange: onChange2
            })
          }), /* @__PURE__ */ jsx$1("img", {
            src: url || ICON_CONNECT_PROFILE_PATH,
            className: "tw-ml-2 tw-w-[54px] tw-h-[54px] tw-rounded-full",
            alt: "connect profile"
          })]
        }, itemId))
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-justify-end tw-items-center tw-px-6 tw-mt-8",
        children: [/* @__PURE__ */ jsx$1(Button, {
          type: "button",
          size: "large",
          variant: "text",
          className: "tw-mr-1",
          onClick: onClose,
          children: t2("modalConnect.cancel")
        }), /* @__PURE__ */ jsx$1(Button, {
          type: "submit",
          size: "large",
          variant: "primary",
          className: "tw-ml-1",
          disabled: isLoading,
          children: t2(isLoading ? "modalConnect.connecting" : "modalConnect.connect")
        })]
      })]
    })]
  });
}
const CONNECT_FACEBOOK_PAGE = gql$1`
  mutation connectFacebookPage(
    $projectId: ID!
    $pageId: ID!
    $userId: String!
    $accessToken: String!
  ) {
    connectFacebookPage(
      projectId: $projectId
      pageId: $pageId
      userId: $userId
      accessToken: $accessToken
    )
  }
`;
const CONNECT_INSTAGRAM_BUSINESS = gql$1`
  mutation connectInstagramBusiness(
    $projectId: ID!
    $pageId: ID!
    $userId: String!
    $accessToken: String!
  ) {
    connectInstagramBusiness(
      projectId: $projectId
      pageId: $pageId
      userId: $userId
      accessToken: $accessToken
    )
  }
`;
const DISCONNECT_FACEBOOK_PAGE = gql$1`
  mutation disconnectFacebookPage($projectId: ID!) {
    disconnectFacebookPage(projectId: $projectId)
  }
`;
const DISCONNECT_INSTAGRAM_BUSINESS = gql$1`
  mutation disconnectInstagramBusiness($projectId: ID!) {
    disconnectInstagramBusiness(projectId: $projectId)
  }
`;
const UPDATE_CONNECT_CREDENTIAL = gql$1`
  mutation updateConnectCredential(
    $projectId: ID!
    $channelId: String!
    $channelSecret: String!
    $channelAccessToken: String!
  ) {
    updateConnectCredential(
      projectId: $projectId
      channelId: $channelId
      channelSecret: $channelSecret
      channelAccessToken: $channelAccessToken
    ) {
      id
      refId
      lineChannelAccessToken
      lineChannelId
      lineChannelSecret
    }
  }
`;
const DELETE_CONNECT_CREDENTIAL = gql$1`
  mutation deleteConnectCredential($projectId: ID!) {
    deleteConnectCredential(projectId: $projectId) {
      id
      refId
      lineChannelAccessToken
      lineChannelId
      lineChannelSecret
    }
  }
`;
const CONNECT_CREDENTIAL = gql$1`
  query getProject($projectId: ID!) {
    getProject(projectId: $projectId) {
      facebookPageName
      facebookPagePicture
      id
      instagramBusinessName
      instagramBusinessPicture
      isAllowingConnectMoreChannel
      isFacebookConnected
      isInstagramConnected
      isLineConnected
      lineChannelAccessToken
      lineChannelAccount
      lineChannelId
      lineChannelName
      lineChannelPicture
      lineChannelSecret
      refId
    }
  }
`;
const PROJECT_INFO = gql$1`
  query getProject($projectId: ID!) {
    getProject(projectId: $projectId) {
      configuration {
        shipping {
          shippop {
            isActive
          }
        }
        product {
          digitalContent {
            isActive
          }
        }
      }
      availablePackageSubscriptionTypeToUpgrade
      botGender
      facebookPageId
      id
      instagramBusinessId
      instagramBusinessName
      instagramBusinessPicture
      isAddonPackageEnabled
      isAddonPackageEnabled
      isAdvancedConsignmentReportEnabled
      isAdvancedCustomerReportEnabled
      isAdvancedSalesReportEnabled
      isAllowApproveBySlip
      isAllowingConnectMoreChannel
      isBankTransferEnabled
      isBroadcastMessageEnabled
      isConsignmentReportEnabled
      isCustomThemeConfigurationEnabled
      isCustomerReportEnabled
      isDeeplePayEnabled
      isDisabled
      isEnterprise
      isFacebookAutoEngagementEnabled
      isGuidelineCompleted
      isInitialProjectCompleted
      isIntegrationEnabled
      isOfflineOrderEnabled
      isOpenApiConfigurationEnabled
      isPaymentGatewayAddonEnabled
      isSalesReportEnabled
      isSupportLegacyPayment
      isUsingCustomPackage
      isUsingDeeplePay
      isUsingNotSupportedPackage
      monthlyBillingPaymentIssueType
      packageEntityLevel # use to check current plan e.g. FREE,PROFESSIONAL,PREMIUM
      refId
      isChatbotEnabled
      isFacebookConnected
      isInstagramConnected
      isLineConnected
      isChatbotEnabled
      isKymApproved
      isUsingDeeplePay
    }
  }
`;
const RE_AUTHORIZE_FACEBOOK_LOGIN = "reauthorize";
const DEFAULT_FACEBOOK_PAGE_SCOPE = "pages_messaging,pages_manage_metadata,pages_manage_engagement,pages_read_engagement,pages_show_list";
const DEFAULT_INSTAGRAM_SCOPE = DEFAULT_FACEBOOK_PAGE_SCOPE.concat(",instagram_basic,instagram_manage_messages,instagram_manage_insights,instagram_manage_comments");
const login = (isFacebookScope = true) => {
  return new Promise((resolve) => {
    window.FB.login((loginResponse) => {
      if (loginResponse.authResponse) {
        const { accessToken, userID } = loginResponse.authResponse;
        const payload = { accessToken, userId: userID };
        resolve(payload);
      }
    }, {
      auth_type: RE_AUTHORIZE_FACEBOOK_LOGIN,
      scope: isFacebookScope ? DEFAULT_FACEBOOK_PAGE_SCOPE : DEFAULT_INSTAGRAM_SCOPE
    });
  });
};
const me = (method, fields) => {
  return new Promise((resolve) => {
    window.FB.api("/me", method, { fields }, (response) => {
      resolve(response);
    });
  });
};
const notifySuccess = (message) => {
  const win = window;
  if (win.notifySuccess) {
    win.notifySuccess(message);
  }
};
const notifyError = (message) => {
  const win = window;
  if (win.notifyError) {
    win.notifyError(message);
  }
};
function addGoogleTagEvent(event, variables = {}) {
  if (window.dataLayer) {
    window.dataLayer.push(__spreadValues({
      event
    }, variables));
  }
}
function Connect({
  projectId,
  setGuidelineCompletedStepCount = (_projectId) => {
  },
  onFetchGuideline = () => {
  },
  onClickWatchVideo = () => {
  }
}) {
  var _a2, _b, _c, _d, _e2, _f, _g, _h, _i, _j;
  const {
    t: t2
  } = useTranslation();
  const [facebookAccessToken, setFacebookAccessToken] = useState("");
  const [facebookUserId, setFacebookUserId] = useState("");
  const [facebookPages, setFacebookPages] = useState([]);
  const [isOpenModalConnectFacebook, setIsOpenModalConnectFacebook] = useState(false);
  const [isOpenModalConfirmDisconnectionFaceook, setIsOpenModalConfirmDisconnectionFacebook] = useState(false);
  const [instagramAccessToken, setInstagramAccessToken] = useState("");
  const [instagramUserId, setInstagramUserId] = useState("");
  const [instagramBusinessAccounts, setInstagramBusinessAccounts] = useState([]);
  const [isOpenModalConnectInstagram, setIsOpenModalConnectInstagram] = useState(false);
  const [isOpenModalConfirmDisconnectionInstagram, setIsOpenModalConfirmDisconnectionInstagram] = useState(false);
  const [isOpenModalConfirmDisconnectionLine, setIsOpenModalConfirmDisconnectionLine] = useState(false);
  const {
    loading: loadingConnectCredential,
    data: connectCredentialData,
    refetch: refetchCredential
  } = useQuery(CONNECT_CREDENTIAL, {
    skip: !projectId,
    variables: {
      projectId
    }
  });
  const [connectFacebookPage, {
    loading: loadingConnectFacebookPage
  }] = useMutation(CONNECT_FACEBOOK_PAGE, {
    refetchQueries: [{
      query: PROJECT_INFO,
      variables: {
        projectId
      }
    }],
    async onCompleted() {
      notifySuccess(t2("connectPage.facebook.connect.success"));
      addGoogleTagEvent(GTM_EVENT.COMPLETELY_CONNECTED_STORES, {
        [GTM_VARIABLE_NAME.STORES]: GTM_CHANNEL.FACEBOOK
      });
      await refetchCredential();
      setGuidelineCompletedStepCount(projectId);
    },
    onError(_error) {
      notifyError(t2("connectPage.facebook.connect.error"));
    }
  });
  const [disconnectFacebookPage, {
    loading: loadingDisconnectFacebookPage
  }] = useMutation(DISCONNECT_FACEBOOK_PAGE, {
    async onCompleted() {
      notifySuccess(t2("connectPage.facebook.disconnect.success"));
      await refetchCredential();
      onFetchGuideline();
    },
    onError(_error) {
      notifySuccess(t2("connectPage.facebook.disconnect.error"));
    }
  });
  const [connectInstagramBusiness, {
    loading: loadingConnectInstagramBusiness
  }] = useMutation(CONNECT_INSTAGRAM_BUSINESS, {
    refetchQueries: [{
      query: PROJECT_INFO,
      variables: {
        projectId
      }
    }],
    async onCompleted() {
      notifySuccess(t2("connectPage.instagram.connect.success"));
      addGoogleTagEvent(GTM_EVENT.COMPLETELY_CONNECTED_STORES, {
        [GTM_VARIABLE_NAME.STORES]: GTM_CHANNEL.INSTAGRAM
      });
      await refetchCredential();
      setGuidelineCompletedStepCount(projectId);
    },
    onError() {
      notifyError(t2("connectPage.instagram.connect.error"));
    }
  });
  const [disconnectInstagramBusiness, {
    loading: loadingDisconnectInstagramBusiness
  }] = useMutation(DISCONNECT_INSTAGRAM_BUSINESS, {
    async onCompleted() {
      notifySuccess(t2("connectPage.instagram.disconnect.success"));
      await refetchCredential();
      onFetchGuideline();
    },
    onError() {
      notifyError(t2("connectPage.instagram.disconnect.error"));
    }
  });
  const [updateConnectCredential, {
    loading: loadingUpdateConnectCredential
  }] = useMutation(UPDATE_CONNECT_CREDENTIAL, {
    refetchQueries: [{
      query: PROJECT_INFO,
      variables: {
        projectId
      }
    }, {
      query: CONNECT_CREDENTIAL,
      variables: {
        projectId
      }
    }],
    async onCompleted() {
      notifySuccess(t2("connectPage.line.connect.success"));
      addGoogleTagEvent(GTM_EVENT.COMPLETELY_CONNECTED_STORES, {
        [GTM_VARIABLE_NAME.STORES]: GTM_CHANNEL.LINE
      });
      await refetchCredential();
      setGuidelineCompletedStepCount(projectId);
    },
    onError() {
      notifyError(t2("connectPage.line.connect.error"));
    }
  });
  const [deleteConnectCredential, {
    loading: loadingDeleteConnectCredential
  }] = useMutation(DELETE_CONNECT_CREDENTIAL, {
    refetchQueries: [{
      query: CONNECT_CREDENTIAL,
      variables: {
        projectId
      }
    }],
    async onCompleted() {
      await refetchCredential();
      onFetchGuideline();
      notifySuccess(t2("connectPage.line.disconnect.success"));
    },
    onError() {
      notifyError(t2("connectPage.line.disconnect.error"));
    }
  });
  const credential = connectCredentialData == null ? void 0 : connectCredentialData.getProject;
  const facebookPageName = (_a2 = credential == null ? void 0 : credential.facebookPageName) != null ? _a2 : "";
  const facebookPagePicture = (_b = credential == null ? void 0 : credential.facebookPagePicture) != null ? _b : "";
  const isFacebookConnected = credential == null ? void 0 : credential.isFacebookConnected;
  const instagramBusinessName = (_c = credential == null ? void 0 : credential.instagramBusinessName) != null ? _c : "";
  const instagramBusinessPicture = (_d = credential == null ? void 0 : credential.instagramBusinessPicture) != null ? _d : "";
  const isInstagramConnected = credential == null ? void 0 : credential.isInstagramConnected;
  const isLineConnected = credential == null ? void 0 : credential.isLineConnected;
  const lineChannelAccessToken = (_e2 = credential == null ? void 0 : credential.lineChannelAccessToken) != null ? _e2 : "";
  const lineChannelAccount = (_f = credential == null ? void 0 : credential.lineChannelAccount) != null ? _f : "";
  const lineChannelId = (_g = credential == null ? void 0 : credential.lineChannelId) != null ? _g : "";
  const lineChannelName = (_h = credential == null ? void 0 : credential.lineChannelName) != null ? _h : "";
  const lineChannelPicture = (_i = credential == null ? void 0 : credential.lineChannelPicture) != null ? _i : "";
  const lineChannelSecret = (_j = credential == null ? void 0 : credential.lineChannelSecret) != null ? _j : "";
  const isLoading = loadingConnectCredential || loadingUpdateConnectCredential || loadingDeleteConnectCredential;
  const handleClickConnectFacebook = async () => {
    var _a3, _b2;
    const loginResponse = await login();
    const {
      accessToken: token2,
      userId: id2
    } = loginResponse;
    const apiRespons = await me("get", "accounts{picture,id,name}");
    const pages = (_b2 = (_a3 = apiRespons == null ? void 0 : apiRespons.accounts) == null ? void 0 : _a3.data) != null ? _b2 : [];
    setFacebookAccessToken(token2);
    setFacebookUserId(id2);
    if (pages.length === 1) {
      const selectedPage = pages[0];
      try {
        await connectFacebookPage({
          variables: {
            projectId,
            pageId: selectedPage.id,
            accessToken: token2,
            userId: id2
          }
        });
      } catch (error2) {
        notifyError(t2("connectPage.facebook.connect.error"));
      }
    } else {
      const selectablePages = pages.map((page) => {
        const {
          url
        } = page.picture.data;
        return {
          id: page.id,
          name: page.name,
          url
        };
      });
      setFacebookPages(selectablePages);
      setIsOpenModalConnectFacebook(true);
    }
  };
  const handleClickDisconnectFacebook = () => {
    setIsOpenModalConfirmDisconnectionFacebook(true);
  };
  const handleCloseModalConnectFacebook = () => {
    setIsOpenModalConnectFacebook(false);
  };
  const handleConnectModalConnectFacebook = async ({
    selectedItemId
  }) => {
    const selectedPage = facebookPages.find((facebookPage) => facebookPage.id === selectedItemId);
    if (!selectedPage || !facebookAccessToken || !facebookUserId)
      return;
    try {
      await connectFacebookPage({
        variables: {
          projectId,
          pageId: selectedPage.id,
          accessToken: facebookAccessToken,
          userId: facebookUserId
        }
      });
      setIsOpenModalConnectFacebook(false);
    } catch (error2) {
      setIsOpenModalConnectFacebook(false);
      notifyError(t2("connectPage.facebook.connect.error"));
    }
  };
  const handleCloseModalConfirmDisconnectionFacebook = () => {
    setIsOpenModalConfirmDisconnectionFacebook(false);
  };
  const handleConfirmModalConfirmDisconnectionFacebook = async () => {
    try {
      await disconnectFacebookPage({
        variables: {
          projectId
        }
      });
      setIsOpenModalConfirmDisconnectionFacebook(false);
    } catch (error2) {
      setIsOpenModalConfirmDisconnectionFacebook(false);
      notifyError(t2("connectPage.facebook.disconnect.error"));
    }
  };
  const handleClickConnectInstagram = async () => {
    var _a3, _b2;
    const isFacebookScope = false;
    const loginResponse = await login(isFacebookScope);
    const {
      accessToken: token2,
      userId: id2
    } = loginResponse;
    const apiRespons = await me("get", "accounts{picture,id,name}");
    const accounts = (_b2 = (_a3 = apiRespons == null ? void 0 : apiRespons.accounts) == null ? void 0 : _a3.data) != null ? _b2 : [];
    setInstagramAccessToken(token2);
    setInstagramUserId(id2);
    if (accounts.length === 1) {
      const selectedAccount = accounts[0];
      try {
        await connectInstagramBusiness({
          variables: {
            projectId,
            pageId: selectedAccount.id,
            accessToken: token2,
            userId: id2
          }
        });
      } catch (error2) {
        notifyError(t2("connectPage.instagram.connect.error"));
      }
    } else {
      const selectableAccounts = accounts.map((page) => {
        const {
          url
        } = page.picture.data;
        return {
          id: page.id,
          name: page.name,
          url
        };
      });
      setInstagramBusinessAccounts(selectableAccounts);
      setIsOpenModalConnectInstagram(true);
    }
  };
  const handleClickDisconnectInstagram = () => {
    setIsOpenModalConfirmDisconnectionInstagram(true);
  };
  const handleCloseModalConnectInstagram = () => {
    setIsOpenModalConnectInstagram(false);
  };
  const handleConnectModalConnectInstagram = async ({
    selectedItemId
  }) => {
    const selectedAccount = instagramBusinessAccounts.find((instagramBusinessAccount) => instagramBusinessAccount.id === selectedItemId);
    if (!selectedAccount || !instagramAccessToken || !instagramUserId)
      return;
    try {
      await connectInstagramBusiness({
        variables: {
          projectId,
          pageId: selectedAccount.id,
          accessToken: instagramAccessToken,
          userId: instagramUserId
        }
      });
      setIsOpenModalConnectInstagram(false);
    } catch (error2) {
      setIsOpenModalConnectInstagram(false);
      notifyError(t2("connectPage.instagram.connect.error"));
    }
  };
  const handleCloseModalConfirmDisconnectionInstagram = () => {
    setIsOpenModalConfirmDisconnectionInstagram(false);
  };
  const handleConfirmModalConfirmDisconnectionInstagram = async () => {
    try {
      await disconnectInstagramBusiness({
        variables: {
          projectId
        }
      });
      setIsOpenModalConfirmDisconnectionInstagram(false);
    } catch (error2) {
      setIsOpenModalConfirmDisconnectionInstagram(false);
      notifyError(t2("connectPage.instagram.disconnect.error"));
    }
  };
  const handleClickConnectLine = async (data2) => {
    if (!data2) {
      return;
    }
    const {
      lineChannelAccessToken: channelAccessToken,
      lineChannelId: channelId,
      lineChannelSecret: channelSecret
    } = data2;
    await updateConnectCredential({
      variables: {
        projectId,
        channelAccessToken,
        channelId,
        channelSecret
      }
    });
  };
  const handleClickDisconnectLine = () => {
    setIsOpenModalConfirmDisconnectionLine(true);
  };
  const handleCloseModalConfirmDisconnectionLine = () => {
    setIsOpenModalConfirmDisconnectionLine(false);
  };
  const handleConfirmModalConfirmDisconnectionLine = async () => {
    await deleteConnectCredential({
      variables: {
        projectId
      }
    });
    setIsOpenModalConfirmDisconnectionLine(false);
  };
  if (isLoading) {
    return /* @__PURE__ */ jsx$1(LoadingPopup$1, {
      isOpen: true
    });
  }
  return /* @__PURE__ */ jsxs("section", {
    className: "tw-py-5 tw-min-h-full tw-bg-grayscale-100 desktop:tw-py-12",
    children: [/* @__PURE__ */ jsxs("header", {
      className: "tw-px-4 tw-pt-1 tw-pb-6 desktop:tw-p-0 desktop:tw-mx-auto desktop:tw-w-[942px]",
      children: [/* @__PURE__ */ jsx$1("h1", {
        className: "tw-text-2xl tw-font-medium tw-text-grayscale-800",
        children: t2("connectPage.title")
      }), /* @__PURE__ */ jsx$1("p", {
        className: "tw-mt-4 tw-text-base tw-font-normal tw-text-grayscale-600",
        children: t2("connectPage.description")
      })]
    }), credential && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx$1(CardConnect, {
        className: "tw-mt-6 desktop:tw-mx-auto desktop:tw-w-[942px]",
        connectedTitle: facebookPageName,
        isConnected: isFacebookConnected,
        profilePicture: facebookPagePicture,
        variant: "facebook",
        onClickConnect: handleClickConnectFacebook,
        onClickDisconnect: handleClickDisconnectFacebook,
        onClickWatchVideo
      }), /* @__PURE__ */ jsx$1(CardConnect, {
        className: "tw-mt-6 desktop:tw-mx-auto desktop:tw-w-[942px]",
        connectedTitle: instagramBusinessName,
        isNew: true,
        isConnected: isInstagramConnected,
        profilePicture: instagramBusinessPicture,
        variant: "instagram",
        onClickConnect: handleClickConnectInstagram,
        onClickDisconnect: handleClickDisconnectInstagram,
        onClickWatchVideo
      }), /* @__PURE__ */ jsx$1(CardConnect, {
        className: "tw-mt-6 desktop:tw-mx-auto desktop:tw-w-[942px]",
        connectedTitle: lineChannelName,
        isConnected: isLineConnected,
        lineChannelAccessToken,
        lineChannelAccount,
        lineChannelId,
        lineChannelPicture,
        lineChannelSecret,
        variant: "line",
        onClickConnect: handleClickConnectLine,
        onClickDisconnect: handleClickDisconnectLine,
        onClickWatchVideo
      }), /* @__PURE__ */ jsx$1(ModalConnect, {
        isOpen: isOpenModalConnectFacebook,
        isLoading: loadingConnectFacebookPage,
        list: facebookPages,
        variant: "facebook",
        onClose: handleCloseModalConnectFacebook,
        onConnect: handleConnectModalConnectFacebook
      }), /* @__PURE__ */ jsx$1(ModalConfirmDisconnection, {
        isOpen: isOpenModalConfirmDisconnectionFaceook,
        isLoading: loadingDisconnectFacebookPage,
        variant: "facebook",
        onClose: handleCloseModalConfirmDisconnectionFacebook,
        onConfirm: handleConfirmModalConfirmDisconnectionFacebook
      }), /* @__PURE__ */ jsx$1(ModalConnect, {
        isOpen: isOpenModalConnectInstagram,
        isLoading: loadingConnectInstagramBusiness,
        list: instagramBusinessAccounts,
        variant: "instagram",
        onClose: handleCloseModalConnectInstagram,
        onConnect: handleConnectModalConnectInstagram
      }), /* @__PURE__ */ jsx$1(ModalConfirmDisconnection, {
        isOpen: isOpenModalConfirmDisconnectionInstagram,
        isLoading: loadingDisconnectInstagramBusiness,
        variant: "instagram",
        onClose: handleCloseModalConfirmDisconnectionInstagram,
        onConfirm: handleConfirmModalConfirmDisconnectionInstagram
      }), /* @__PURE__ */ jsx$1(ModalConfirmDisconnection, {
        isOpen: isOpenModalConfirmDisconnectionLine,
        variant: "line",
        onClose: handleCloseModalConfirmDisconnectionLine,
        onConfirm: handleConfirmModalConfirmDisconnectionLine
      })]
    })]
  });
}
function Page$6({
  projectId,
  setGuidelineCompletedStepCount,
  onFetchGuideline,
  onClickWatchVideo
}) {
  return /* @__PURE__ */ jsx$1(ContextProviders, {
    children: /* @__PURE__ */ jsx$1(Connect, {
      projectId,
      setGuidelineCompletedStepCount,
      onFetchGuideline,
      onClickWatchVideo
    })
  });
}
var objectProto$e = Object.prototype;
function isPrototype$2(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$e;
  return value === proto;
}
var _isPrototype = isPrototype$2;
function overArg$1(func, transform2) {
  return function(arg) {
    return func(transform2(arg));
  };
}
var _overArg = overArg$1;
var overArg = _overArg;
var nativeKeys$1 = overArg(Object.keys, Object);
var _nativeKeys = nativeKeys$1;
var isPrototype$1 = _isPrototype, nativeKeys = _nativeKeys;
var objectProto$d = Object.prototype;
var hasOwnProperty$c = objectProto$d.hasOwnProperty;
function baseKeys$2(object2) {
  if (!isPrototype$1(object2)) {
    return nativeKeys(object2);
  }
  var result = [];
  for (var key in Object(object2)) {
    if (hasOwnProperty$c.call(object2, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
var _baseKeys = baseKeys$2;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$8 = freeGlobal || freeSelf || Function("return this")();
var _root = root$8;
var root$7 = _root;
var Symbol$6 = root$7.Symbol;
var _Symbol = Symbol$6;
var Symbol$5 = _Symbol;
var objectProto$c = Object.prototype;
var hasOwnProperty$b = objectProto$c.hasOwnProperty;
var nativeObjectToString$1 = objectProto$c.toString;
var symToStringTag$1 = Symbol$5 ? Symbol$5.toStringTag : void 0;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$b.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e2) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;
var objectProto$b = Object.prototype;
var nativeObjectToString = objectProto$b.toString;
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1;
var Symbol$4 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString;
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$4 ? Symbol$4.toStringTag : void 0;
function baseGetTag$5(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$5;
function isObject$7(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_1 = isObject$7;
var baseGetTag$4 = _baseGetTag, isObject$6 = isObject_1;
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$4(value) {
  if (!isObject$6(value)) {
    return false;
  }
  var tag = baseGetTag$4(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction$4;
var root$6 = _root;
var coreJsData$1 = root$6["__core-js_shared__"];
var _coreJsData = coreJsData$1;
var coreJsData = _coreJsData;
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked$1;
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e2) {
    }
    try {
      return func + "";
    } catch (e2) {
    }
  }
  return "";
}
var _toSource = toSource$2;
var isFunction$3 = isFunction_1, isMasked = _isMasked, isObject$5 = isObject_1, toSource$1 = _toSource;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype, objectProto$a = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$a = objectProto$a.hasOwnProperty;
var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty$a).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function baseIsNative$1(value) {
  if (!isObject$5(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$3(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$1;
function getValue$1(object2, key) {
  return object2 == null ? void 0 : object2[key];
}
var _getValue = getValue$1;
var baseIsNative = _baseIsNative, getValue = _getValue;
function getNative$7(object2, key) {
  var value = getValue(object2, key);
  return baseIsNative(value) ? value : void 0;
}
var _getNative = getNative$7;
var getNative$6 = _getNative, root$5 = _root;
var DataView$1 = getNative$6(root$5, "DataView");
var _DataView = DataView$1;
var getNative$5 = _getNative, root$4 = _root;
var Map$4 = getNative$5(root$4, "Map");
var _Map = Map$4;
var getNative$4 = _getNative, root$3 = _root;
var Promise$2 = getNative$4(root$3, "Promise");
var _Promise = Promise$2;
var getNative$3 = _getNative, root$2 = _root;
var Set$3 = getNative$3(root$2, "Set");
var _Set = Set$3;
var getNative$2 = _getNative, root$1 = _root;
var WeakMap$2 = getNative$2(root$1, "WeakMap");
var _WeakMap = WeakMap$2;
var DataView = _DataView, Map$3 = _Map, Promise$1 = _Promise, Set$2 = _Set, WeakMap$1 = _WeakMap, baseGetTag$3 = _baseGetTag, toSource = _toSource;
var mapTag$3 = "[object Map]", objectTag$2 = "[object Object]", promiseTag = "[object Promise]", setTag$3 = "[object Set]", weakMapTag$1 = "[object WeakMap]";
var dataViewTag$2 = "[object DataView]";
var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map$3), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$2), weakMapCtorString = toSource(WeakMap$1);
var getTag$2 = baseGetTag$3;
if (DataView && getTag$2(new DataView(new ArrayBuffer(1))) != dataViewTag$2 || Map$3 && getTag$2(new Map$3()) != mapTag$3 || Promise$1 && getTag$2(Promise$1.resolve()) != promiseTag || Set$2 && getTag$2(new Set$2()) != setTag$3 || WeakMap$1 && getTag$2(new WeakMap$1()) != weakMapTag$1) {
  getTag$2 = function(value) {
    var result = baseGetTag$3(value), Ctor = result == objectTag$2 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$2;
        case mapCtorString:
          return mapTag$3;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$3;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result;
  };
}
var _getTag = getTag$2;
function isObjectLike$5(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$5;
var baseGetTag$2 = _baseGetTag, isObjectLike$4 = isObjectLike_1;
var argsTag$2 = "[object Arguments]";
function baseIsArguments$1(value) {
  return isObjectLike$4(value) && baseGetTag$2(value) == argsTag$2;
}
var _baseIsArguments = baseIsArguments$1;
var baseIsArguments = _baseIsArguments, isObjectLike$3 = isObjectLike_1;
var objectProto$9 = Object.prototype;
var hasOwnProperty$9 = objectProto$9.hasOwnProperty;
var propertyIsEnumerable$1 = objectProto$9.propertyIsEnumerable;
var isArguments$4 = baseIsArguments(function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike$3(value) && hasOwnProperty$9.call(value, "callee") && !propertyIsEnumerable$1.call(value, "callee");
};
var isArguments_1 = isArguments$4;
var isArray$e = Array.isArray;
var isArray_1 = isArray$e;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
function isLength$3(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}
var isLength_1 = isLength$3;
var isFunction$2 = isFunction_1, isLength$2 = isLength_1;
function isArrayLike$5(value) {
  return value != null && isLength$2(value.length) && !isFunction$2(value);
}
var isArrayLike_1 = isArrayLike$5;
var isBuffer$4 = { exports: {} };
function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;
(function(module, exports) {
  var root2 = _root, stubFalse2 = stubFalse_1;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer2 = moduleExports ? root2.Buffer : void 0;
  var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
  var isBuffer2 = nativeIsBuffer || stubFalse2;
  module.exports = isBuffer2;
})(isBuffer$4, isBuffer$4.exports);
var baseGetTag$1 = _baseGetTag, isLength$1 = isLength_1, isObjectLike$2 = isObjectLike_1;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", objectTag$1 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag] = typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$1] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag] = false;
function baseIsTypedArray$1(value) {
  return isObjectLike$2(value) && isLength$1(value.length) && !!typedArrayTags[baseGetTag$1(value)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
function baseUnary$2(func) {
  return function(value) {
    return func(value);
  };
}
var _baseUnary = baseUnary$2;
var _nodeUtil = { exports: {} };
(function(module, exports) {
  var freeGlobal2 = _freeGlobal;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil2 = function() {
    try {
      var types = freeModule && freeModule.require && freeModule.require("util").types;
      if (types) {
        return types;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e2) {
    }
  }();
  module.exports = nodeUtil2;
})(_nodeUtil, _nodeUtil.exports);
var baseIsTypedArray = _baseIsTypedArray, baseUnary$1 = _baseUnary, nodeUtil = _nodeUtil.exports;
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray$3 = nodeIsTypedArray ? baseUnary$1(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$3;
var baseKeys$1 = _baseKeys, getTag$1 = _getTag, isArguments$3 = isArguments_1, isArray$d = isArray_1, isArrayLike$4 = isArrayLike_1, isBuffer$3 = isBuffer$4.exports, isPrototype = _isPrototype, isTypedArray$2 = isTypedArray_1;
var mapTag$1 = "[object Map]", setTag$1 = "[object Set]";
var objectProto$8 = Object.prototype;
var hasOwnProperty$8 = objectProto$8.hasOwnProperty;
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike$4(value) && (isArray$d(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer$3(value) || isTypedArray$2(value) || isArguments$3(value))) {
    return !value.length;
  }
  var tag = getTag$1(value);
  if (tag == mapTag$1 || tag == setTag$1) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys$1(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty$8.call(value, key)) {
      return false;
    }
  }
  return true;
}
var isEmpty_1 = isEmpty;
var Select$2 = "";
function _extends$4() {
  _extends$4 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source2 = arguments[i2];
      for (var key in source2) {
        if (Object.prototype.hasOwnProperty.call(source2, key)) {
          target[key] = source2[key];
        }
      }
    }
    return target;
  };
  return _extends$4.apply(this, arguments);
}
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i2 = 0; i2 < document.styleSheets.length; i2++) {
    if (document.styleSheets[i2].ownerNode === tag) {
      return document.styleSheets[i2];
    }
  }
}
function createStyleElement(options2) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options2.key);
  if (options2.nonce !== void 0) {
    tag.setAttribute("nonce", options2.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  tag.setAttribute("data-s", "");
  return tag;
}
var StyleSheet = /* @__PURE__ */ function() {
  function StyleSheet2(options2) {
    var _this = this;
    this._insertTag = function(tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options2.speedy === void 0 ? true : options2.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options2.nonce;
    this.key = options2.key;
    this.container = options2.container;
    this.prepend = options2.prepend;
    this.insertionPoint = options2.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e2) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function(tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet2;
}();
var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var abs = Math.abs;
var from = String.fromCharCode;
var assign = Object.assign;
function hash$2(value, length2) {
  return charat(value, 0) ^ 45 ? (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}
function trim$2(value) {
  return value.trim();
}
function match$4(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}
function indexof(value, search) {
  return value.indexOf(search);
}
function charat(value, index2) {
  return value.charCodeAt(index2) | 0;
}
function substr(value, begin, end2) {
  return value.slice(begin, end2);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append(value, array2) {
  return array2.push(value), value;
}
function combine(array2, callback) {
  return array2.map(callback).join("");
}
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = "";
function node(value, root2, parent2, type, props, children2, length2) {
  return { value, root: root2, parent: parent2, type, props, children: children2, line, column, length: length2, return: "" };
}
function copy(root2, props) {
  return assign(node("", null, null, "", null, null, 0), root2, { length: -root2.length }, props);
}
function char() {
  return character;
}
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10)
    column = 1, line--;
  return character;
}
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10)
    column = 1, line++;
  return character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(begin, end2) {
  return substr(characters, begin, end2);
}
function token(type) {
  switch (type) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type) {
  return trim$2(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function whitespace(type) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token(type) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index2, count) {
  while (--count && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice(index2, caret() + (count < 6 && peek() == 32 && next() == 32));
}
function delimiter(type) {
  while (next())
    switch (character) {
      case type:
        return position;
      case 34:
      case 39:
        if (type !== 34 && type !== 39)
          delimiter(character);
        break;
      case 40:
        if (type === 41)
          delimiter(type);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(type, index2) {
  while (next())
    if (type + character === 47 + 10)
      break;
    else if (type + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(index2, position - 1) + "*" + from(type === 47 ? type : next());
}
function identifier(index2) {
  while (!token(peek()))
    next();
  return slice(index2, position);
}
function compile(value) {
  return dealloc(parse("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse(value, root2, parent2, rule, rules, rulesets, pseudo, points, declarations) {
  var index2 = 0;
  var offset2 = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property2 = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type = "";
  var props = rules;
  var children2 = rulesets;
  var reference2 = rule;
  var characters2 = type;
  while (scanning)
    switch (previous = character2, character2 = next()) {
      case 40:
        if (previous != 108 && charat(characters2, length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1)
            ampersand = -1;
          break;
        }
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace(previous);
        break;
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), root2, parent2), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      case 123 * variable:
        points[index2++] = strlen(characters2) * ampersand;
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          case 0:
          case 125:
            scanning = 0;
          case 59 + offset2:
            if (property2 > 0 && strlen(characters2) - length2)
              append(property2 > 32 ? declaration(characters2 + ";", rule, parent2, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent2, length2 - 2), declarations);
            break;
          case 59:
            characters2 += ";";
          default:
            append(reference2 = ruleset(characters2, root2, parent2, index2, offset2, rules, points, type, props = [], children2 = [], length2), rulesets);
            if (character2 === 123)
              if (offset2 === 0)
                parse(characters2, root2, reference2, reference2, props, rulesets, length2, points, children2);
              else
                switch (atrule === 99 && charat(characters2, 3) === 110 ? 100 : atrule) {
                  case 100:
                  case 109:
                  case 115:
                    parse(value, reference2, reference2, rule && append(ruleset(value, reference2, reference2, 0, 0, rules, points, type, rules, props = [], length2), children2), rules, children2, length2, points, rule ? props : children2);
                    break;
                  default:
                    parse(characters2, reference2, reference2, reference2, [""], children2, 0, points, children2);
                }
        }
        index2 = offset2 = property2 = 0, variable = ampersand = 1, type = characters2 = "", length2 = pseudo;
        break;
      case 58:
        length2 = 1 + strlen(characters2), property2 = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          case 38:
            ampersand = offset2 > 0 ? 1 : (characters2 += "\f", -1);
            break;
          case 44:
            points[index2++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset2 = length2 = strlen(type = characters2 += identifier(caret())), character2++;
            break;
          case 45:
            if (previous === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value, root2, parent2, index2, offset2, rules, points, type, props, children2, length2) {
  var post = offset2 - 1;
  var rule = offset2 === 0 ? rules : [""];
  var size = sizeof(rule);
  for (var i2 = 0, j = 0, k2 = 0; i2 < index2; ++i2)
    for (var x2 = 0, y2 = substr(value, post + 1, post = abs(j = points[i2])), z2 = value; x2 < size; ++x2)
      if (z2 = trim$2(j > 0 ? rule[x2] + " " + y2 : replace(y2, /&\f/g, rule[x2])))
        props[k2++] = z2;
  return node(value, root2, parent2, offset2 === 0 ? RULESET : type, props, children2, length2);
}
function comment(value, root2, parent2) {
  return node(value, root2, parent2, COMMENT, from(char()), substr(value, 2, -2), 0);
}
function declaration(value, root2, parent2, length2) {
  return node(value, root2, parent2, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
}
function serialize(children2, callback) {
  var output2 = "";
  var length2 = sizeof(children2);
  for (var i2 = 0; i2 < length2; i2++)
    output2 += callback(children2[i2], i2, children2, callback) || "";
  return output2;
}
function stringify(element, index2, children2, callback) {
  switch (element.type) {
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize(element.children, callback) + "}";
    case RULESET:
      element.value = element.props.join(",");
  }
  return strlen(children2 = serialize(element.children, callback)) ? element.return = element.value + "{" + children2 + "}" : "";
}
function middleware(collection) {
  var length2 = sizeof(collection);
  return function(element, index2, children2, callback) {
    var output2 = "";
    for (var i2 = 0; i2 < length2; i2++)
      output2 += collection[i2](element, index2, children2, callback) || "";
    return output2;
  };
}
function rulesheet(callback) {
  return function(element) {
    if (!element.root) {
      if (element = element.return)
        callback(element);
    }
  };
}
function memoize$2(fn2) {
  var cache2 = Object.create(null);
  return function(arg) {
    if (cache2[arg] === void 0)
      cache2[arg] = fn2(arg);
    return cache2[arg];
  };
}
var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index2) {
  var previous = 0;
  var character2 = 0;
  while (true) {
    previous = character2;
    character2 = peek();
    if (previous === 38 && character2 === 12) {
      points[index2] = 1;
    }
    if (token(character2)) {
      break;
    }
    next();
  }
  return slice(begin, position);
};
var toRules = function toRules2(parsed, points) {
  var index2 = -1;
  var character2 = 44;
  do {
    switch (token(character2)) {
      case 0:
        if (character2 === 38 && peek() === 12) {
          points[index2] = 1;
        }
        parsed[index2] += identifierWithPointTracking(position - 1, points, index2);
        break;
      case 2:
        parsed[index2] += delimit(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index2] = peek() === 58 ? "&\f" : "";
          points[index2] = parsed[index2].length;
          break;
        }
      default:
        parsed[index2] += from(character2);
    }
  } while (character2 = next());
  return parsed;
};
var getRules = function getRules2(value, points) {
  return dealloc(toRules(alloc(value), points));
};
var fixedElements = /* @__PURE__ */ new WeakMap();
var compat = function compat2(element) {
  if (element.type !== "rule" || !element.parent || element.length < 1) {
    return;
  }
  var value = element.value, parent2 = element.parent;
  var isImplicitRule = element.column === parent2.column && element.line === parent2.line;
  while (parent2.type !== "rule") {
    parent2 = parent2.parent;
    if (!parent2)
      return;
  }
  if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent2)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent2.props;
  for (var i2 = 0, k2 = 0; i2 < rules.length; i2++) {
    for (var j = 0; j < parentRules.length; j++, k2++) {
      element.props[k2] = points[i2] ? rules[i2].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i2];
    }
  }
};
var removeLabel = function removeLabel2(element) {
  if (element.type === "decl") {
    var value = element.value;
    if (value.charCodeAt(0) === 108 && value.charCodeAt(2) === 98) {
      element["return"] = "";
      element.value = "";
    }
  }
};
function prefix(value, length2) {
  switch (hash$2(value, length2)) {
    case 5103:
      return WEBKIT + "print-" + value + value;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    case 6165:
      return WEBKIT + value + MS + "flex-" + value + value;
    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
    case 5443:
      return WEBKIT + value + MS + "flex-item-" + replace(value, /flex-|-self/, "") + value;
    case 4675:
      return WEBKIT + value + MS + "flex-line-pack" + replace(value, /align-content|flex-|-self/, "") + value;
    case 5548:
      return WEBKIT + value + MS + replace(value, "shrink", "negative") + value;
    case 5292:
      return WEBKIT + value + MS + replace(value, "basis", "preferred-size") + value;
    case 6060:
      return WEBKIT + "box-" + replace(value, "-grow", "") + WEBKIT + value + MS + replace(value, "grow", "positive") + value;
    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value) - 1 - length2 > 6)
        switch (charat(value, length2 + 1)) {
          case 109:
            if (charat(value, length2 + 4) !== 45)
              break;
          case 102:
            return replace(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
          case 115:
            return ~indexof(value, "stretch") ? prefix(replace(value, "stretch", "fill-available"), length2) + value : value;
        }
      break;
    case 4949:
      if (charat(value, length2 + 1) !== 115)
        break;
    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))) {
        case 107:
          return replace(value, ":", ":" + WEBKIT) + value;
        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
      }
      break;
    case 5936:
      switch (charat(value, length2 + 11)) {
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
var prefixer = function prefixer2(element, index2, children2, callback) {
  if (element.length > -1) {
    if (!element["return"])
      switch (element.type) {
        case DECLARATION:
          element["return"] = prefix(element.value, element.length);
          break;
        case KEYFRAMES:
          return serialize([copy(element, {
            value: replace(element.value, "@", "@" + WEBKIT)
          })], callback);
        case RULESET:
          if (element.length)
            return combine(element.props, function(value) {
              switch (match$4(value, /(::plac\w+|:read-\w+)/)) {
                case ":read-only":
                case ":read-write":
                  return serialize([copy(element, {
                    props: [replace(value, /:(read-\w+)/, ":" + MOZ + "$1")]
                  })], callback);
                case "::placeholder":
                  return serialize([copy(element, {
                    props: [replace(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
                  }), copy(element, {
                    props: [replace(value, /:(plac\w+)/, ":" + MOZ + "$1")]
                  }), copy(element, {
                    props: [replace(value, /:(plac\w+)/, MS + "input-$1")]
                  })], callback);
              }
              return "";
            });
      }
  }
};
var defaultStylisPlugins = [prefixer];
var createCache = function createCache2(options2) {
  var key = options2.key;
  if (key === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function(node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options2.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  {
    container = options2.container || document.head;
    Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node2) {
      var attrib = node2.getAttribute("data-emotion").split(" ");
      for (var i2 = 1; i2 < attrib.length; i2++) {
        inserted[attrib[i2]] = true;
      }
      nodesToHydrate.push(node2);
    });
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function(rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles2) {
      return serialize(compile(styles2), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache2.inserted[serialized.name] = true;
      }
    };
  }
  var cache2 = {
    key,
    sheet: new StyleSheet({
      key,
      container,
      nonce: options2.nonce,
      speedy: options2.speedy,
      prepend: options2.prepend,
      insertionPoint: options2.insertionPoint
    }),
    nonce: options2.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache2.sheet.hydrate(nodesToHydrate);
  return cache2;
};
var reactIs$1 = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = typeof Symbol === "function" && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w$1 = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a2) {
  if (typeof a2 === "object" && a2 !== null) {
    var u = a2.$$typeof;
    switch (u) {
      case c:
        switch (a2 = a2.type, a2) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a2;
          default:
            switch (a2 = a2 && a2.$$typeof, a2) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a2;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a2) {
  return z(a2) === m;
}
reactIs_production_min.AsyncMode = l;
reactIs_production_min.ConcurrentMode = m;
reactIs_production_min.ContextConsumer = k;
reactIs_production_min.ContextProvider = h;
reactIs_production_min.Element = c;
reactIs_production_min.ForwardRef = n;
reactIs_production_min.Fragment = e;
reactIs_production_min.Lazy = t;
reactIs_production_min.Memo = r;
reactIs_production_min.Portal = d;
reactIs_production_min.Profiler = g;
reactIs_production_min.StrictMode = f;
reactIs_production_min.Suspense = p;
reactIs_production_min.isAsyncMode = function(a2) {
  return A(a2) || z(a2) === l;
};
reactIs_production_min.isConcurrentMode = A;
reactIs_production_min.isContextConsumer = function(a2) {
  return z(a2) === k;
};
reactIs_production_min.isContextProvider = function(a2) {
  return z(a2) === h;
};
reactIs_production_min.isElement = function(a2) {
  return typeof a2 === "object" && a2 !== null && a2.$$typeof === c;
};
reactIs_production_min.isForwardRef = function(a2) {
  return z(a2) === n;
};
reactIs_production_min.isFragment = function(a2) {
  return z(a2) === e;
};
reactIs_production_min.isLazy = function(a2) {
  return z(a2) === t;
};
reactIs_production_min.isMemo = function(a2) {
  return z(a2) === r;
};
reactIs_production_min.isPortal = function(a2) {
  return z(a2) === d;
};
reactIs_production_min.isProfiler = function(a2) {
  return z(a2) === g;
};
reactIs_production_min.isStrictMode = function(a2) {
  return z(a2) === f;
};
reactIs_production_min.isSuspense = function(a2) {
  return z(a2) === p;
};
reactIs_production_min.isValidElementType = function(a2) {
  return typeof a2 === "string" || typeof a2 === "function" || a2 === e || a2 === m || a2 === g || a2 === f || a2 === p || a2 === q || typeof a2 === "object" && a2 !== null && (a2.$$typeof === t || a2.$$typeof === r || a2.$$typeof === h || a2.$$typeof === k || a2.$$typeof === n || a2.$$typeof === w$1 || a2.$$typeof === x || a2.$$typeof === y || a2.$$typeof === v);
};
reactIs_production_min.typeOf = z;
{
  reactIs$1.exports = reactIs_production_min;
}
var reactIs = reactIs$1.exports;
var FORWARD_REF_STATICS = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
var isBrowser$2 = true;
function getRegisteredStyles(registered, registeredStyles, classNames2) {
  var rawClassName = "";
  classNames2.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles2(cache2, serialized, isStringTag) {
  var className = cache2.key + "-" + serialized.name;
  if ((isStringTag === false || isBrowser$2 === false) && cache2.registered[className] === void 0) {
    cache2.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles2(cache2, serialized, isStringTag) {
  registerStyles(cache2, serialized, isStringTag);
  var className = cache2.key + "-" + serialized.name;
  if (cache2.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      cache2.insert(serialized === current ? "." + className : "", current, cache2.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};
function murmur2(str) {
  var h2 = 0;
  var k2, i2 = 0, len = str.length;
  for (; len >= 4; ++i2, len -= 4) {
    k2 = str.charCodeAt(i2) & 255 | (str.charCodeAt(++i2) & 255) << 8 | (str.charCodeAt(++i2) & 255) << 16 | (str.charCodeAt(++i2) & 255) << 24;
    k2 = (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16);
    k2 ^= k2 >>> 24;
    h2 = (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16) ^ (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h2 ^= (str.charCodeAt(i2 + 2) & 255) << 16;
    case 2:
      h2 ^= (str.charCodeAt(i2 + 1) & 255) << 8;
    case 1:
      h2 ^= str.charCodeAt(i2) & 255;
      h2 = (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  h2 ^= h2 >>> 13;
  h2 = (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  return ((h2 ^ h2 >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property2) {
  return property2.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};
var processStyleName = /* @__PURE__ */ memoize$2(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key, value) {
  switch (key) {
    case "animation":
    case "animationName": {
      if (typeof value === "string") {
        return value.replace(animationRegex, function(match2, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) {
    return value + "px";
  }
  return value;
};
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }
  if (interpolation.__emotion_styles !== void 0) {
    return interpolation;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      if (interpolation.anim === 1) {
        cursor = {
          name: interpolation.name,
          styles: interpolation.styles,
          next: cursor
        };
        return interpolation.name;
      }
      if (interpolation.styles !== void 0) {
        var next2 = interpolation.next;
        if (next2 !== void 0) {
          while (next2 !== void 0) {
            cursor = {
              name: next2.name,
              styles: next2.styles,
              next: cursor
            };
            next2 = next2.next;
          }
        }
        var styles2 = interpolation.styles + ";";
        return styles2;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result);
      }
      break;
    }
  }
  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  return cached !== void 0 ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string2 = "";
  if (Array.isArray(obj)) {
    for (var i2 = 0; i2 < obj.length; i2++) {
      string2 += handleInterpolation(mergedProps, registered, obj[i2]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== "object") {
        if (registered != null && registered[value] !== void 0) {
          string2 += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string2 += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === "NO_COMPONENT_SELECTOR" && false) {
          throw new Error(noComponentSelectorMessage);
        }
        if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string2 += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (_key) {
            case "animation":
            case "animationName": {
              string2 += processStyleName(_key) + ":" + interpolated + ";";
              break;
            }
            default: {
              string2 += _key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string2;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var cursor;
var serializeStyles = function serializeStyles2(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles2 = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles2 += handleInterpolation(mergedProps, registered, strings);
  } else {
    styles2 += strings[0];
  }
  for (var i2 = 1; i2 < args.length; i2++) {
    styles2 += handleInterpolation(mergedProps, registered, args[i2]);
    if (stringMode) {
      styles2 += strings[i2];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match2;
  while ((match2 = labelPattern.exec(styles2)) !== null) {
    identifierName += "-" + match2[1];
  }
  var name = murmur2(styles2) + identifierName;
  return {
    name,
    styles: styles2,
    next: cursor
  };
};
var syncFallback = function syncFallback2(create2) {
  return create2();
};
var useInsertionEffect = React$2["useInsertionEffect"] ? React$2["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var hasOwnProperty$7 = {}.hasOwnProperty;
var EmotionCacheContext = /* @__PURE__ */ createContext(typeof HTMLElement !== "undefined" ? /* @__PURE__ */ createCache({
  key: "css"
}) : null);
EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  return /* @__PURE__ */ forwardRef(function(props, ref) {
    var cache2 = useContext(EmotionCacheContext);
    return func(props, cache2, ref);
  });
};
var ThemeContext = /* @__PURE__ */ createContext({});
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps2(type, props) {
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty$7.call(props, key)) {
      newProps[key] = props[key];
    }
  }
  newProps[typePropName] = type;
  return newProps;
};
var Insertion$1 = function Insertion(_ref3) {
  var cache2 = _ref3.cache, serialized = _ref3.serialized, isStringTag = _ref3.isStringTag;
  registerStyles(cache2, serialized, isStringTag);
  useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(cache2, serialized, isStringTag);
  });
  return null;
};
var Emotion = /* @__PURE__ */ withEmotionCache(function(props, cache2, ref) {
  var cssProp = props.css;
  if (typeof cssProp === "string" && cache2.registered[cssProp] !== void 0) {
    cssProp = cache2.registered[cssProp];
  }
  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = "";
  if (typeof props.className === "string") {
    className = getRegisteredStyles(cache2.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, void 0, useContext(ThemeContext));
  className += cache2.key + "-" + serialized.name;
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty$7.call(props, key) && key !== "css" && key !== typePropName && true) {
      newProps[key] = props[key];
    }
  }
  newProps.ref = ref;
  newProps.className = className;
  return /* @__PURE__ */ createElement(Fragment$1, null, /* @__PURE__ */ createElement(Insertion$1, {
    cache: cache2,
    serialized,
    isStringTag: typeof WrappedComponent === "string"
  }), /* @__PURE__ */ createElement(WrappedComponent, newProps));
});
var jsx = function jsx2(type, props) {
  var args = arguments;
  if (props == null || !hasOwnProperty$7.call(props, "css")) {
    return createElement.apply(void 0, args);
  }
  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);
  for (var i2 = 2; i2 < argsLength; i2++) {
    createElementArgArray[i2] = args[i2];
  }
  return createElement.apply(null, createElementArgArray);
};
function css$2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}
var keyframes = function keyframes2() {
  var insertable = css$2.apply(void 0, arguments);
  var name = "animation-" + insertable.name;
  return {
    name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString3() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};
var classnames = function classnames2(args) {
  var len = args.length;
  var i2 = 0;
  var cls = "";
  for (; i2 < len; i2++) {
    var arg = args[i2];
    if (arg == null)
      continue;
    var toAdd = void 0;
    switch (typeof arg) {
      case "boolean":
        break;
      case "object": {
        if (Array.isArray(arg)) {
          toAdd = classnames2(arg);
        } else {
          toAdd = "";
          for (var k2 in arg) {
            if (arg[k2] && k2) {
              toAdd && (toAdd += " ");
              toAdd += k2;
            }
          }
        }
        break;
      }
      default: {
        toAdd = arg;
      }
    }
    if (toAdd) {
      cls && (cls += " ");
      cls += toAdd;
    }
  }
  return cls;
};
function merge$1(registered, css4, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);
  if (registeredStyles.length < 2) {
    return className;
  }
  return rawClassName + css4(registeredStyles);
}
var Insertion2 = function Insertion3(_ref3) {
  var cache2 = _ref3.cache, serializedArr = _ref3.serializedArr;
  useInsertionEffectAlwaysWithSyncFallback(function() {
    for (var i2 = 0; i2 < serializedArr.length; i2++) {
      insertStyles(cache2, serializedArr[i2], false);
    }
  });
  return null;
};
var ClassNames = /* @__PURE__ */ withEmotionCache(function(props, cache2) {
  var hasRendered = false;
  var serializedArr = [];
  var css4 = function css5() {
    if (hasRendered && false) {
      throw new Error("css can only be used during render");
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var serialized = serializeStyles(args, cache2.registered);
    serializedArr.push(serialized);
    registerStyles(cache2, serialized, false);
    return cache2.key + "-" + serialized.name;
  };
  var cx = function cx2() {
    if (hasRendered && false) {
      throw new Error("cx can only be used during render");
    }
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return merge$1(cache2.registered, css4, classnames(args));
  };
  var content = {
    css: css4,
    cx,
    theme: useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /* @__PURE__ */ createElement(Fragment$1, null, /* @__PURE__ */ createElement(Insertion2, {
    cache: cache2,
    serializedArr
  }), ele);
});
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _objectWithoutPropertiesLoose$2(source2, excluded) {
  if (source2 == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source2);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source2[key];
  }
  return target;
}
function _objectWithoutProperties$1(source2, excluded) {
  if (source2 == null)
    return {};
  var target = _objectWithoutPropertiesLoose$2(source2, excluded);
  var key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source2);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key = sourceSymbolKeys[i2];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source2, key))
        continue;
      target[key] = source2[key];
    }
  }
  return target;
}
function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys$1(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
    }
    keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread2(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$1(Object(source2), true).forEach(function(key) {
        _defineProperty$2(target, key, source2[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2));
    } else {
      ownKeys$1(Object(source2)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
      });
    }
  }
  return target;
}
function _getPrototypeOf(o2) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf(o2);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _possibleConstructorReturn(self2, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self2);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
var _excluded$3$1 = ["className", "clearValue", "cx", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
var noop$3 = function noop() {
};
function applyPrefixToName(prefix2, name) {
  if (!name) {
    return prefix2;
  } else if (name[0] === "-") {
    return prefix2 + name;
  } else {
    return prefix2 + "__" + name;
  }
}
function classNames(prefix2, state, className) {
  var arr = [className];
  if (state && prefix2) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix2, key)));
      }
    }
  }
  return arr.filter(function(i2) {
    return i2;
  }).map(function(i2) {
    return String(i2).trim();
  }).join(" ");
}
var cleanValue = function cleanValue2(value) {
  if (isArray$c(value))
    return value.filter(Boolean);
  if (_typeof(value) === "object" && value !== null)
    return [value];
  return [];
};
var cleanCommonProps = function cleanCommonProps2(props) {
  props.className;
  props.clearValue;
  props.cx;
  props.getStyles;
  props.getValue;
  props.hasValue;
  props.isMulti;
  props.isRtl;
  props.options;
  props.selectOption;
  props.selectProps;
  props.setValue;
  props.theme;
  var innerProps = _objectWithoutProperties$1(props, _excluded$3$1);
  return _objectSpread2({}, innerProps);
};
function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}
function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}
function scrollTo(el, top2) {
  if (isDocumentElement(el)) {
    window.scrollTo(0, top2);
    return;
  }
  el.scrollTop = top2;
}
function getScrollParent$1(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === "absolute";
  var overflowRx = /(auto|scroll)/;
  if (style.position === "fixed")
    return document.documentElement;
  for (var parent2 = element; parent2 = parent2.parentElement; ) {
    style = getComputedStyle(parent2);
    if (excludeStaticParent && style.position === "static") {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent2;
    }
  }
  return document.documentElement;
}
function easeOutCubic(t2, b2, c2, d2) {
  return c2 * ((t2 = t2 / d2 - 1) * t2 * t2 + 1) + b2;
}
function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : noop$3;
  var start2 = getScrollTop(element);
  var change = to - start2;
  var increment = 10;
  var currentTime = 0;
  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start2, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}
function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;
  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
function isTouchCapable() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e2) {
    return false;
  }
}
function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e2) {
    return false;
  }
}
var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }
};
var w = typeof window !== "undefined" ? window : {};
if (w.addEventListener && w.removeEventListener) {
  w.addEventListener("p", noop$3, options);
  w.removeEventListener("p", noop$3, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
  return item != null;
}
function isArray$c(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue) {
  return multiValue;
}
function getMenuPlacement(_ref3) {
  var maxHeight = _ref3.maxHeight, menuEl = _ref3.menuEl, minHeight = _ref3.minHeight, placement = _ref3.placement, shouldScroll = _ref3.shouldScroll, isFixedPosition = _ref3.isFixedPosition, theme = _ref3.theme;
  var spacing2 = theme.spacing;
  var scrollParent = getScrollParent$1(menuEl);
  var defaultState = {
    placement: "bottom",
    maxHeight
  };
  if (!menuEl || !menuEl.offsetParent)
    return defaultState;
  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
  var viewHeight = window.innerHeight;
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;
  switch (placement) {
    case "auto":
    case "bottom":
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: "bottom",
          maxHeight
        };
      }
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        return {
          placement: "bottom",
          maxHeight
        };
      }
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: "bottom",
          maxHeight: constrainedHeight
        };
      }
      if (placement === "auto" || isFixedPosition) {
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing2.controlHeight, maxHeight);
        }
        return {
          placement: "top",
          maxHeight: _constrainedHeight
        };
      }
      if (placement === "bottom") {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }
        return {
          placement: "bottom",
          maxHeight
        };
      }
      break;
    case "top":
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: "top",
          maxHeight
        };
      }
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: "top",
          maxHeight
        };
      }
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight;
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: "top",
          maxHeight: _constrainedHeight2
        };
      }
      return {
        placement: "bottom",
        maxHeight
      };
    default:
      throw new Error('Invalid placement provided "'.concat(placement, '".'));
  }
  return defaultState;
}
function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: "top",
    top: "bottom"
  };
  return placement ? placementToCSSProp[placement] : "bottom";
}
var coercePlacement = function coercePlacement2(p2) {
  return p2 === "auto" ? "bottom" : p2;
};
var menuCSS = function menuCSS2(_ref22) {
  var _ref3;
  var placement = _ref22.placement, _ref2$theme = _ref22.theme, borderRadius2 = _ref2$theme.borderRadius, spacing2 = _ref2$theme.spacing, colors2 = _ref2$theme.colors;
  return _ref3 = {
    label: "menu"
  }, _defineProperty$3(_ref3, alignToControl(placement), "100%"), _defineProperty$3(_ref3, "backgroundColor", colors2.neutral0), _defineProperty$3(_ref3, "borderRadius", borderRadius2), _defineProperty$3(_ref3, "boxShadow", "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)"), _defineProperty$3(_ref3, "marginBottom", spacing2.menuGutter), _defineProperty$3(_ref3, "marginTop", spacing2.menuGutter), _defineProperty$3(_ref3, "position", "absolute"), _defineProperty$3(_ref3, "width", "100%"), _defineProperty$3(_ref3, "zIndex", 1), _ref3;
};
var PortalPlacementContext = /* @__PURE__ */ createContext({
  getPortalPlacement: null
});
var MenuPlacer = /* @__PURE__ */ function(_Component) {
  _inherits(MenuPlacer2, _Component);
  var _super = _createSuper(MenuPlacer2);
  function MenuPlacer2() {
    var _this;
    _classCallCheck(this, MenuPlacer2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    };
    _this.context = void 0;
    _this.getPlacement = function(ref) {
      var _this$props = _this.props, minMenuHeight = _this$props.minMenuHeight, maxMenuHeight = _this$props.maxMenuHeight, menuPlacement = _this$props.menuPlacement, menuPosition = _this$props.menuPosition, menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView, theme = _this$props.theme;
      if (!ref)
        return;
      var isFixedPosition = menuPosition === "fixed";
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll,
        isFixedPosition,
        theme
      });
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (getPortalPlacement)
        getPortalPlacement(state);
      _this.setState(state);
    };
    _this.getUpdatedProps = function() {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return _objectSpread2(_objectSpread2({}, _this.props), {}, {
        placement,
        maxHeight: _this.state.maxHeight
      });
    };
    return _this;
  }
  _createClass(MenuPlacer2, [{
    key: "render",
    value: function render() {
      var children2 = this.props.children;
      return children2({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);
  return MenuPlacer2;
}(Component);
MenuPlacer.contextType = PortalPlacementContext;
var Menu = function Menu2(props) {
  var children2 = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerRef = props.innerRef, innerProps = props.innerProps;
  return jsx("div", _extends$4({
    css: getStyles("menu", props),
    className: cx({
      menu: true
    }, className),
    ref: innerRef
  }, innerProps), children2);
};
var menuListCSS = function menuListCSS2(_ref4) {
  var maxHeight = _ref4.maxHeight, baseUnit2 = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight,
    overflowY: "auto",
    paddingBottom: baseUnit2,
    paddingTop: baseUnit2,
    position: "relative",
    WebkitOverflowScrolling: "touch"
  };
};
var MenuList = function MenuList2(props) {
  var children2 = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
  return jsx("div", _extends$4({
    css: getStyles("menuList", props),
    className: cx({
      "menu-list": true,
      "menu-list--is-multi": isMulti
    }, className),
    ref: innerRef
  }, innerProps), children2);
};
var noticeCSS = function noticeCSS2(_ref5) {
  var _ref5$theme = _ref5.theme, baseUnit2 = _ref5$theme.spacing.baseUnit, colors2 = _ref5$theme.colors;
  return {
    color: colors2.neutral40,
    padding: "".concat(baseUnit2 * 2, "px ").concat(baseUnit2 * 3, "px"),
    textAlign: "center"
  };
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage2(props) {
  var children2 = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("div", _extends$4({
    css: getStyles("noOptionsMessage", props),
    className: cx({
      "menu-notice": true,
      "menu-notice--no-options": true
    }, className)
  }, innerProps), children2);
};
NoOptionsMessage.defaultProps = {
  children: "No options"
};
var LoadingMessage = function LoadingMessage2(props) {
  var children2 = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("div", _extends$4({
    css: getStyles("loadingMessage", props),
    className: cx({
      "menu-notice": true,
      "menu-notice--loading": true
    }, className)
  }, innerProps), children2);
};
LoadingMessage.defaultProps = {
  children: "Loading..."
};
var menuPortalCSS = function menuPortalCSS2(_ref6) {
  var rect = _ref6.rect, offset2 = _ref6.offset, position2 = _ref6.position;
  return {
    left: rect.left,
    position: position2,
    top: offset2,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = /* @__PURE__ */ function(_Component2) {
  _inherits(MenuPortal2, _Component2);
  var _super2 = _createSuper(MenuPortal2);
  function MenuPortal2() {
    var _this2;
    _classCallCheck(this, MenuPortal2);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _this2.state = {
      placement: null
    };
    _this2.getPortalPlacement = function(_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement);
      if (placement !== initialPlacement) {
        _this2.setState({
          placement
        });
      }
    };
    return _this2;
  }
  _createClass(MenuPortal2, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props, appendTo = _this$props2.appendTo, children2 = _this$props2.children, className = _this$props2.className, controlElement = _this$props2.controlElement, cx = _this$props2.cx, innerProps = _this$props2.innerProps, menuPlacement = _this$props2.menuPlacement, position2 = _this$props2.menuPosition, getStyles = _this$props2.getStyles;
      var isFixed = position2 === "fixed";
      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }
      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset2 = rect[placement] + scrollDistance;
      var state = {
        offset: offset2,
        position: position2,
        rect
      };
      var menuWrapper = jsx("div", _extends$4({
        css: getStyles("menuPortal", state),
        className: cx({
          "menu-portal": true
        }, className)
      }, innerProps), children2);
      return jsx(PortalPlacementContext.Provider, {
        value: {
          getPortalPlacement: this.getPortalPlacement
        }
      }, appendTo ? /* @__PURE__ */ reactDom.exports.createPortal(menuWrapper, appendTo) : menuWrapper);
    }
  }]);
  return MenuPortal2;
}(Component);
var containerCSS = function containerCSS2(_ref3) {
  var isDisabled = _ref3.isDisabled, isRtl = _ref3.isRtl;
  return {
    label: "container",
    direction: isRtl ? "rtl" : void 0,
    pointerEvents: isDisabled ? "none" : void 0,
    position: "relative"
  };
};
var SelectContainer = function SelectContainer2(props) {
  var children2 = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
  return jsx("div", _extends$4({
    css: getStyles("container", props),
    className: cx({
      "--is-disabled": isDisabled,
      "--is-rtl": isRtl
    }, className)
  }, innerProps), children2);
};
var valueContainerCSS = function valueContainerCSS2(_ref22) {
  var spacing2 = _ref22.theme.spacing, isMulti = _ref22.isMulti, hasValue = _ref22.hasValue, controlShouldRenderValue = _ref22.selectProps.controlShouldRenderValue;
  return {
    alignItems: "center",
    display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    padding: "".concat(spacing2.baseUnit / 2, "px ").concat(spacing2.baseUnit * 2, "px"),
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  };
};
var ValueContainer = function ValueContainer2(props) {
  var children2 = props.children, className = props.className, cx = props.cx, innerProps = props.innerProps, isMulti = props.isMulti, getStyles = props.getStyles, hasValue = props.hasValue;
  return jsx("div", _extends$4({
    css: getStyles("valueContainer", props),
    className: cx({
      "value-container": true,
      "value-container--is-multi": isMulti,
      "value-container--has-value": hasValue
    }, className)
  }, innerProps), children2);
};
var indicatorsContainerCSS = function indicatorsContainerCSS2() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer2(props) {
  var children2 = props.children, className = props.className, cx = props.cx, innerProps = props.innerProps, getStyles = props.getStyles;
  return jsx("div", _extends$4({
    css: getStyles("indicatorsContainer", props),
    className: cx({
      indicators: true
    }, className)
  }, innerProps), children2);
};
var _templateObject;
var _excluded$2$1 = ["size"];
var _ref2$1 = {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var Svg = function Svg2(_ref3) {
  var size = _ref3.size, props = _objectWithoutProperties$1(_ref3, _excluded$2$1);
  return jsx("svg", _extends$4({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2$1
  }, props));
};
var CrossIcon = function CrossIcon2(props) {
  return jsx(Svg, _extends$4({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron2(props) {
  return jsx(Svg, _extends$4({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
};
var baseCSS = function baseCSS2(_ref3) {
  var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit2 = _ref3$theme.spacing.baseUnit, colors2 = _ref3$theme.colors;
  return {
    label: "indicatorContainer",
    color: isFocused ? colors2.neutral60 : colors2.neutral20,
    display: "flex",
    padding: baseUnit2 * 2,
    transition: "color 150ms",
    ":hover": {
      color: isFocused ? colors2.neutral80 : colors2.neutral40
    }
  };
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator2(props) {
  var children2 = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("div", _extends$4({
    css: getStyles("dropdownIndicator", props),
    className: cx({
      indicator: true,
      "dropdown-indicator": true
    }, className)
  }, innerProps), children2 || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator2(props) {
  var children2 = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("div", _extends$4({
    css: getStyles("clearIndicator", props),
    className: cx({
      indicator: true,
      "clear-indicator": true
    }, className)
  }, innerProps), children2 || jsx(CrossIcon, null));
};
var indicatorSeparatorCSS = function indicatorSeparatorCSS2(_ref4) {
  var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit2 = _ref4$theme.spacing.baseUnit, colors2 = _ref4$theme.colors;
  return {
    label: "indicatorSeparator",
    alignSelf: "stretch",
    backgroundColor: isDisabled ? colors2.neutral10 : colors2.neutral20,
    marginBottom: baseUnit2 * 2,
    marginTop: baseUnit2 * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator2(props) {
  var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("span", _extends$4({}, innerProps, {
    css: getStyles("indicatorSeparator", props),
    className: cx({
      "indicator-separator": true
    }, className)
  }));
};
var loadingDotAnimations = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS2(_ref5) {
  var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors2 = _ref5$theme.colors, baseUnit2 = _ref5$theme.spacing.baseUnit;
  return {
    label: "loadingIndicator",
    color: isFocused ? colors2.neutral60 : colors2.neutral20,
    display: "flex",
    padding: baseUnit2 * 2,
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: "center",
    verticalAlign: "middle"
  };
};
var LoadingDot = function LoadingDot2(_ref6) {
  var delay = _ref6.delay, offset2 = _ref6.offset;
  return jsx("span", {
    css: /* @__PURE__ */ css$2({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: offset2 ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, "", "")
  });
};
var LoadingIndicator = function LoadingIndicator2(props) {
  var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isRtl = props.isRtl;
  return jsx("div", _extends$4({
    css: getStyles("loadingIndicator", props),
    className: cx({
      indicator: true,
      "loading-indicator": true
    }, className)
  }, innerProps), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};
var css$1 = function css(_ref3) {
  var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, _ref$theme = _ref3.theme, colors2 = _ref$theme.colors, borderRadius2 = _ref$theme.borderRadius, spacing2 = _ref$theme.spacing;
  return {
    label: "control",
    alignItems: "center",
    backgroundColor: isDisabled ? colors2.neutral5 : colors2.neutral0,
    borderColor: isDisabled ? colors2.neutral10 : isFocused ? colors2.primary : colors2.neutral20,
    borderRadius: borderRadius2,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors2.primary) : void 0,
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: spacing2.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms",
    "&:hover": {
      borderColor: isFocused ? colors2.primary : colors2.neutral30
    }
  };
};
var Control = function Control2(props) {
  var children2 = props.children, cx = props.cx, getStyles = props.getStyles, className = props.className, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
  return jsx("div", _extends$4({
    ref: innerRef,
    css: getStyles("control", props),
    className: cx({
      control: true,
      "control--is-disabled": isDisabled,
      "control--is-focused": isFocused,
      "control--menu-is-open": menuIsOpen
    }, className)
  }, innerProps), children2);
};
var _excluded$1$1 = ["data"];
var groupCSS = function groupCSS2(_ref3) {
  var spacing2 = _ref3.theme.spacing;
  return {
    paddingBottom: spacing2.baseUnit * 2,
    paddingTop: spacing2.baseUnit * 2
  };
};
var Group = function Group2(props) {
  var children2 = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
  return jsx("div", _extends$4({
    css: getStyles("group", props),
    className: cx({
      group: true
    }, className)
  }, innerProps), jsx(Heading, _extends$4({}, headingProps, {
    selectProps,
    theme,
    getStyles,
    cx
  }), label), jsx("div", null, children2));
};
var groupHeadingCSS = function groupHeadingCSS2(_ref22) {
  var spacing2 = _ref22.theme.spacing;
  return {
    label: "group",
    color: "#999",
    cursor: "default",
    display: "block",
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: spacing2.baseUnit * 3,
    paddingRight: spacing2.baseUnit * 3,
    textTransform: "uppercase"
  };
};
var GroupHeading = function GroupHeading2(props) {
  var getStyles = props.getStyles, cx = props.cx, className = props.className;
  var _cleanCommonProps = cleanCommonProps(props);
  _cleanCommonProps.data;
  var innerProps = _objectWithoutProperties$1(_cleanCommonProps, _excluded$1$1);
  return jsx("div", _extends$4({
    css: getStyles("groupHeading", props),
    className: cx({
      "group-heading": true
    }, className)
  }, innerProps));
};
var _excluded$4 = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS2(_ref3) {
  var isDisabled = _ref3.isDisabled, value = _ref3.value, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return _objectSpread2({
    margin: spacing2.baseUnit / 2,
    paddingBottom: spacing2.baseUnit / 2,
    paddingTop: spacing2.baseUnit / 2,
    visibility: isDisabled ? "hidden" : "visible",
    color: colors2.neutral80,
    transform: value ? "translateZ(0)" : ""
  }, containerStyle);
};
var spacingStyle = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": _objectSpread2({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, spacingStyle)
};
var inputStyle = function inputStyle2(isHidden) {
  return _objectSpread2({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: "100%"
  }, spacingStyle);
};
var Input = function Input2(props) {
  var className = props.className, cx = props.cx, getStyles = props.getStyles, value = props.value;
  var _cleanCommonProps = cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = _objectWithoutProperties$1(_cleanCommonProps, _excluded$4);
  return jsx("div", {
    className: cx({
      "input-container": true
    }, className),
    css: getStyles("input", props),
    "data-value": value || ""
  }, jsx("input", _extends$4({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};
var multiValueCSS = function multiValueCSS2(_ref3) {
  var _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, borderRadius2 = _ref$theme.borderRadius, colors2 = _ref$theme.colors;
  return {
    label: "multiValue",
    backgroundColor: colors2.neutral10,
    borderRadius: borderRadius2 / 2,
    display: "flex",
    margin: spacing2.baseUnit / 2,
    minWidth: 0
  };
};
var multiValueLabelCSS = function multiValueLabelCSS2(_ref22) {
  var _ref2$theme = _ref22.theme, borderRadius2 = _ref2$theme.borderRadius, colors2 = _ref2$theme.colors, cropWithEllipsis = _ref22.cropWithEllipsis;
  return {
    borderRadius: borderRadius2 / 2,
    color: colors2.neutral80,
    fontSize: "85%",
    overflow: "hidden",
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis || cropWithEllipsis === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS2(_ref3) {
  var _ref3$theme = _ref3.theme, spacing2 = _ref3$theme.spacing, borderRadius2 = _ref3$theme.borderRadius, colors2 = _ref3$theme.colors, isFocused = _ref3.isFocused;
  return {
    alignItems: "center",
    borderRadius: borderRadius2 / 2,
    backgroundColor: isFocused ? colors2.dangerLight : void 0,
    display: "flex",
    paddingLeft: spacing2.baseUnit,
    paddingRight: spacing2.baseUnit,
    ":hover": {
      backgroundColor: colors2.dangerLight,
      color: colors2.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric2(_ref4) {
  var children2 = _ref4.children, innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children2);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children2 = _ref5.children, innerProps = _ref5.innerProps;
  return jsx("div", _extends$4({
    role: "button"
  }, innerProps), children2 || jsx(CrossIcon, {
    size: 14
  }));
}
var MultiValue = function MultiValue2(props) {
  var children2 = props.children, className = props.className, components2 = props.components, cx = props.cx, data2 = props.data, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
  var Container = components2.Container, Label2 = components2.Label, Remove = components2.Remove;
  return jsx(ClassNames, null, function(_ref6) {
    var css4 = _ref6.css, emotionCx = _ref6.cx;
    return jsx(Container, {
      data: data2,
      innerProps: _objectSpread2({
        className: emotionCx(css4(getStyles("multiValue", props)), cx({
          "multi-value": true,
          "multi-value--is-disabled": isDisabled
        }, className))
      }, innerProps),
      selectProps
    }, jsx(Label2, {
      data: data2,
      innerProps: {
        className: emotionCx(css4(getStyles("multiValueLabel", props)), cx({
          "multi-value__label": true
        }, className))
      },
      selectProps
    }, children2), jsx(Remove, {
      data: data2,
      innerProps: _objectSpread2({
        className: emotionCx(css4(getStyles("multiValueRemove", props)), cx({
          "multi-value__remove": true
        }, className)),
        "aria-label": "Remove ".concat(children2 || "option")
      }, removeProps),
      selectProps
    }));
  });
};
var optionCSS = function optionCSS2(_ref3) {
  var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, isSelected = _ref3.isSelected, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return {
    label: "option",
    backgroundColor: isSelected ? colors2.primary : isFocused ? colors2.primary25 : "transparent",
    color: isDisabled ? colors2.neutral20 : isSelected ? colors2.neutral0 : "inherit",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    padding: "".concat(spacing2.baseUnit * 2, "px ").concat(spacing2.baseUnit * 3, "px"),
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
    ":active": {
      backgroundColor: !isDisabled ? isSelected ? colors2.primary : colors2.primary50 : void 0
    }
  };
};
var Option = function Option2(props) {
  var children2 = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
  return jsx("div", _extends$4({
    css: getStyles("option", props),
    className: cx({
      option: true,
      "option--is-disabled": isDisabled,
      "option--is-focused": isFocused,
      "option--is-selected": isSelected
    }, className),
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children2);
};
var placeholderCSS = function placeholderCSS2(_ref3) {
  var _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return {
    label: "placeholder",
    color: colors2.neutral50,
    gridArea: "1 / 1 / 2 / 3",
    marginLeft: spacing2.baseUnit / 2,
    marginRight: spacing2.baseUnit / 2
  };
};
var Placeholder = function Placeholder2(props) {
  var children2 = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("div", _extends$4({
    css: getStyles("placeholder", props),
    className: cx({
      placeholder: true
    }, className)
  }, innerProps), children2);
};
var css2 = function css3(_ref3) {
  var isDisabled = _ref3.isDisabled, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return {
    label: "singleValue",
    color: isDisabled ? colors2.neutral40 : colors2.neutral80,
    gridArea: "1 / 1 / 2 / 3",
    marginLeft: spacing2.baseUnit / 2,
    marginRight: spacing2.baseUnit / 2,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  };
};
var SingleValue = function SingleValue2(props) {
  var children2 = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, innerProps = props.innerProps;
  return jsx("div", _extends$4({
    css: getStyles("singleValue", props),
    className: cx({
      "single-value": true,
      "single-value--is-disabled": isDisabled
    }, className)
  }, innerProps), children2);
};
var components = {
  ClearIndicator,
  Control,
  DropdownIndicator,
  DownChevron,
  CrossIcon,
  Group,
  GroupHeading,
  IndicatorsContainer,
  IndicatorSeparator,
  Input,
  LoadingIndicator,
  Menu,
  MenuList,
  MenuPortal,
  LoadingMessage,
  NoOptionsMessage,
  MultiValue,
  MultiValueContainer,
  MultiValueLabel,
  MultiValueRemove,
  Option,
  Placeholder,
  SelectContainer,
  SingleValue,
  ValueContainer
};
var defaultComponents = function defaultComponents2(props) {
  return _objectSpread2(_objectSpread2({}, components), props.components);
};
function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArrayLimit$2(arr, i2) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e2;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d = true;
    _e2 = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e2;
    }
  }
  return _arr;
}
function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function _unsupportedIterableToArray$2(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray$2(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor)
    n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray$2(o2, minLen);
}
function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$2(arr, i2) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i2) || _unsupportedIterableToArray$2(arr, i2) || _nonIterableRest$2();
}
var _excluded$3 = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function useStateManager(_ref3) {
  var _ref$defaultInputValu = _ref3.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref3.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref3.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref3.inputValue, propsMenuIsOpen = _ref3.menuIsOpen, propsOnChange = _ref3.onChange, propsOnInputChange = _ref3.onInputChange, propsOnMenuClose = _ref3.onMenuClose, propsOnMenuOpen = _ref3.onMenuOpen, propsValue = _ref3.value, restSelectProps = _objectWithoutProperties$1(_ref3, _excluded$3);
  var _useState = useState(propsInputValue !== void 0 ? propsInputValue : defaultInputValue), _useState2 = _slicedToArray$2(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
  var _useState3 = useState(propsMenuIsOpen !== void 0 ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = _slicedToArray$2(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
  var _useState5 = useState(propsValue !== void 0 ? propsValue : defaultValue), _useState6 = _slicedToArray$2(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
  var onChange2 = useCallback(function(value2, actionMeta) {
    if (typeof propsOnChange === "function") {
      propsOnChange(value2, actionMeta);
    }
    setStateValue(value2);
  }, [propsOnChange]);
  var onInputChange = useCallback(function(value2, actionMeta) {
    var newValue;
    if (typeof propsOnInputChange === "function") {
      newValue = propsOnInputChange(value2, actionMeta);
    }
    setStateInputValue(newValue !== void 0 ? newValue : value2);
  }, [propsOnInputChange]);
  var onMenuOpen = useCallback(function() {
    if (typeof propsOnMenuOpen === "function") {
      propsOnMenuOpen();
    }
    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = useCallback(function() {
    if (typeof propsOnMenuClose === "function") {
      propsOnMenuClose();
    }
    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== void 0 ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== void 0 ? propsMenuIsOpen : stateMenuIsOpen;
  var value = propsValue !== void 0 ? propsValue : stateValue;
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    inputValue,
    menuIsOpen,
    onChange: onChange2,
    onInputChange,
    onMenuClose,
    onMenuOpen,
    value
  });
}
function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray$2(arr);
}
function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread$1();
}
var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === "number" && value !== value;
};
function isEqual$1(first, second) {
  if (first === second) {
    return true;
  }
  if (safeIsNaN(first) && safeIsNaN(second)) {
    return true;
  }
  return false;
}
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i2 = 0; i2 < newInputs.length; i2++) {
    if (!isEqual$1(newInputs[i2], lastInputs[i2])) {
      return false;
    }
  }
  return true;
}
function memoizeOne(resultFn, isEqual3) {
  if (isEqual3 === void 0) {
    isEqual3 = areInputsEqual;
  }
  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;
  function memoized() {
    var newArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }
    if (calledOnce && lastThis === this && isEqual3(newArgs, lastArgs)) {
      return lastResult;
    }
    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  }
  return memoized;
}
var _ref = {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var A11yText = function A11yText2(props) {
  return jsx("span", _extends$4({
    css: _ref
  }, props));
};
var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
    switch (context) {
      case "menu":
        return "Use Up and Down to choose options".concat(isDisabled ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "");
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function onChange(props) {
    var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
    switch (action) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(label, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
      case "select-option":
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context, focused = props.focused, options2 = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
    var getArrayIndex = function getArrayIndex2(arr, item) {
      return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
    };
    if (context === "value" && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }
    if (context === "menu") {
      var disabled = isDisabled ? " disabled" : "";
      var status = "".concat(isSelected ? "selected" : "focused").concat(disabled);
      return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options2, focused), ".");
    }
    return "";
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
  }
};
var LiveRegion = function LiveRegion2(props) {
  var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id2 = props.id;
  var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel4 = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled3 = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options2 = selectProps.options, screenReaderStatus2 = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
  var ariaLabel = selectProps["aria-label"];
  var ariaLive = selectProps["aria-live"];
  var messages = useMemo(function() {
    return _objectSpread2(_objectSpread2({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]);
  var ariaSelected = useMemo(function() {
    var message = "";
    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
      var asOption = function asOption2(val) {
        return !Array.isArray(val) ? val : null;
      };
      var selected = removedValue || option || asOption(value);
      var label = selected ? getOptionLabel4(selected) : "";
      var multiSelected = selectedOptions || removedValues || void 0;
      var labels = multiSelected ? multiSelected.map(getOptionLabel4) : [];
      var onChangeProps = _objectSpread2({
        isDisabled: selected && isOptionDisabled3(selected, selectValue),
        label,
        labels
      }, ariaSelection);
      message = messages.onChange(onChangeProps);
    }
    return message;
  }, [ariaSelection, messages, isOptionDisabled3, selectValue, getOptionLabel4]);
  var ariaFocused = useMemo(function() {
    var focusMsg = "";
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused,
        label: getOptionLabel4(focused),
        isDisabled: isOptionDisabled3(focused, selectValue),
        isSelected,
        options: options2,
        context: focused === focusedOption ? "menu" : "value",
        selectValue
      };
      focusMsg = messages.onFocus(onFocusProps);
    }
    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel4, isOptionDisabled3, messages, options2, selectValue]);
  var ariaResults = useMemo(function() {
    var resultsMsg = "";
    if (menuIsOpen && options2.length && messages.onFilter) {
      var resultsMessage = screenReaderStatus2({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue,
        resultsMessage
      });
    }
    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options2, screenReaderStatus2]);
  var ariaGuidance = useMemo(function() {
    var guidanceMsg = "";
    if (messages.guidance) {
      var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
      guidanceMsg = messages.guidance({
        "aria-label": ariaLabel,
        context,
        isDisabled: focusedOption && isOptionDisabled3(focusedOption, selectValue),
        isMulti,
        isSearchable,
        tabSelectsValue
      });
    }
    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled3, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue]);
  var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
  var ScreenReaderText = jsx(React__default.Fragment, null, jsx("span", {
    id: "aria-selection"
  }, ariaSelected), jsx("span", {
    id: "aria-context"
  }, ariaContext));
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
  return jsx(React__default.Fragment, null, jsx(A11yText, {
    id: id2
  }, isInitialFocus && ScreenReaderText), jsx(A11yText, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};
var diacritics = [{
  base: "A",
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: "AA",
  letters: "\uA732"
}, {
  base: "AE",
  letters: "\xC6\u01FC\u01E2"
}, {
  base: "AO",
  letters: "\uA734"
}, {
  base: "AU",
  letters: "\uA736"
}, {
  base: "AV",
  letters: "\uA738\uA73A"
}, {
  base: "AY",
  letters: "\uA73C"
}, {
  base: "B",
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: "C",
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: "D",
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: "DZ",
  letters: "\u01F1\u01C4"
}, {
  base: "Dz",
  letters: "\u01F2\u01C5"
}, {
  base: "E",
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: "F",
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: "G",
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: "H",
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: "I",
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: "J",
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: "K",
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: "L",
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: "LJ",
  letters: "\u01C7"
}, {
  base: "Lj",
  letters: "\u01C8"
}, {
  base: "M",
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: "N",
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: "NJ",
  letters: "\u01CA"
}, {
  base: "Nj",
  letters: "\u01CB"
}, {
  base: "O",
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: "OI",
  letters: "\u01A2"
}, {
  base: "OO",
  letters: "\uA74E"
}, {
  base: "OU",
  letters: "\u0222"
}, {
  base: "P",
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: "Q",
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: "R",
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: "S",
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: "T",
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: "TZ",
  letters: "\uA728"
}, {
  base: "U",
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: "V",
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: "VY",
  letters: "\uA760"
}, {
  base: "W",
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: "X",
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: "Y",
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: "Z",
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: "a",
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: "aa",
  letters: "\uA733"
}, {
  base: "ae",
  letters: "\xE6\u01FD\u01E3"
}, {
  base: "ao",
  letters: "\uA735"
}, {
  base: "au",
  letters: "\uA737"
}, {
  base: "av",
  letters: "\uA739\uA73B"
}, {
  base: "ay",
  letters: "\uA73D"
}, {
  base: "b",
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: "c",
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: "d",
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: "dz",
  letters: "\u01F3\u01C6"
}, {
  base: "e",
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: "f",
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: "g",
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: "h",
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: "hv",
  letters: "\u0195"
}, {
  base: "i",
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: "j",
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: "k",
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: "l",
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: "lj",
  letters: "\u01C9"
}, {
  base: "m",
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: "n",
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: "nj",
  letters: "\u01CC"
}, {
  base: "o",
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: "oi",
  letters: "\u01A3"
}, {
  base: "ou",
  letters: "\u0223"
}, {
  base: "oo",
  letters: "\uA74F"
}, {
  base: "p",
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: "q",
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: "r",
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: "s",
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: "t",
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: "tz",
  letters: "\uA729"
}, {
  base: "u",
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: "v",
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: "vy",
  letters: "\uA761"
}, {
  base: "w",
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: "x",
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: "y",
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: "z",
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp("[" + diacritics.map(function(d2) {
  return d2.letters;
}).join("") + "]", "g");
var diacriticToBase = {};
for (var i$1 = 0; i$1 < diacritics.length; i$1++) {
  var diacritic = diacritics[i$1];
  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}
var stripDiacritics = function stripDiacritics2(str) {
  return str.replace(anyDiacritic, function(match2) {
    return diacriticToBase[match2];
  });
};
var memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics);
var trimString = function trimString2(str) {
  return str.replace(/^\s+|\s+$/g, "");
};
var defaultStringify = function defaultStringify2(option) {
  return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter2(config) {
  return function(option, rawInput) {
    if (option.data.__isNew__)
      return true;
    var _ignoreCase$ignoreAcc = _objectSpread2({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: "any"
    }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify2 = _ignoreCase$ignoreAcc.stringify, trim2 = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
    var input = trim2 ? trimString(rawInput) : rawInput;
    var candidate = trim2 ? trimString(stringify2(option)) : stringify2(option);
    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input = memoizedStripDiacriticsForInput(input);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};
var _excluded$2 = ["innerRef"];
function DummyInput(_ref3) {
  var innerRef = _ref3.innerRef, props = _objectWithoutProperties$1(_ref3, _excluded$2);
  return jsx("input", _extends$4({
    ref: innerRef
  }, props, {
    css: /* @__PURE__ */ css$2({
      label: "dummyInput",
      background: 0,
      border: 0,
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      width: 1,
      color: "transparent",
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, "", "")
  }));
}
var cancelScroll = function cancelScroll2(event) {
  event.preventDefault();
  event.stopPropagation();
};
function useScrollCapture(_ref3) {
  var isEnabled = _ref3.isEnabled, onBottomArrive = _ref3.onBottomArrive, onBottomLeave = _ref3.onBottomLeave, onTopArrive = _ref3.onTopArrive, onTopLeave = _ref3.onTopLeave;
  var isBottom = useRef(false);
  var isTop = useRef(false);
  var touchStart = useRef(0);
  var scrollTarget = useRef(null);
  var handleEventDelta = useCallback(function(event, delta) {
    if (scrollTarget.current === null)
      return;
    var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false;
    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave)
        onBottomLeave(event);
      isBottom.current = false;
    }
    if (isDeltaPositive && isTop.current) {
      if (onTopLeave)
        onTopLeave(event);
      isTop.current = false;
    }
    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }
      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true;
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }
      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    }
    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = useCallback(function(event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart2 = useCallback(function(event) {
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove2 = useCallback(function(event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = useCallback(function(el) {
    if (!el)
      return;
    var notPassive = supportsPassiveEvents ? {
      passive: false
    } : false;
    el.addEventListener("wheel", onWheel, notPassive);
    el.addEventListener("touchstart", onTouchStart2, notPassive);
    el.addEventListener("touchmove", onTouchMove2, notPassive);
  }, [onTouchMove2, onTouchStart2, onWheel]);
  var stopListening = useCallback(function(el) {
    if (!el)
      return;
    el.removeEventListener("wheel", onWheel, false);
    el.removeEventListener("touchstart", onTouchStart2, false);
    el.removeEventListener("touchmove", onTouchMove2, false);
  }, [onTouchMove2, onTouchStart2, onWheel]);
  useEffect(function() {
    if (!isEnabled)
      return;
    var element = scrollTarget.current;
    startListening(element);
    return function() {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function(element) {
    scrollTarget.current = element;
  };
}
var STYLE_KEYS = ["boxSizing", "height", "overflow", "paddingRight", "position"];
var LOCK_STYLES = {
  boxSizing: "border-box",
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function preventTouchMove(e2) {
  e2.preventDefault();
}
function allowTouchMove(e2) {
  e2.stopPropagation();
}
function preventInertiaScroll() {
  var top2 = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top2 + this.offsetHeight;
  if (top2 === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top2 - 1;
  }
}
function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};
function useScrollLock(_ref3) {
  var isEnabled = _ref3.isEnabled, _ref$accountForScroll = _ref3.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = useRef({});
  var scrollTarget = useRef(null);
  var addScrollLock = useCallback(function(touchScrollTarget) {
    if (!canUseDOM)
      return;
    var target = document.body;
    var targetStyle = target && target.style;
    if (accountForScrollbars) {
      STYLE_KEYS.forEach(function(key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    }
    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function(key) {
        var val = LOCK_STYLES[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    }
    if (target && isTouchDevice()) {
      target.addEventListener("touchmove", preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.addEventListener("touchstart", preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener("touchmove", allowTouchMove, listenerOptions);
      }
    }
    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = useCallback(function(touchScrollTarget) {
    if (!canUseDOM)
      return;
    var target = document.body;
    var targetStyle = target && target.style;
    activeScrollLocks = Math.max(activeScrollLocks - 1, 0);
    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function(key) {
        var val = originalStyles.current[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    }
    if (target && isTouchDevice()) {
      target.removeEventListener("touchmove", preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener("touchstart", preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener("touchmove", allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  useEffect(function() {
    if (!isEnabled)
      return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function() {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function(element) {
    scrollTarget.current = element;
  };
}
var blurSelectInput = function blurSelectInput2() {
  return document.activeElement && document.activeElement.blur();
};
var _ref2 = {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function ScrollManager(_ref3) {
  var children2 = _ref3.children, lockEnabled = _ref3.lockEnabled, _ref$captureEnabled = _ref3.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref3.onBottomArrive, onBottomLeave = _ref3.onBottomLeave, onTopArrive = _ref3.onTopArrive, onTopLeave = _ref3.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive,
    onBottomLeave,
    onTopArrive,
    onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });
  var targetRef = function targetRef2(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };
  return jsx(React__default.Fragment, null, lockEnabled && jsx("div", {
    onClick: blurSelectInput,
    css: _ref2
  }), children2(targetRef));
}
var formatGroupLabel = function formatGroupLabel2(group) {
  return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled2(option) {
  return !!option.isDisabled;
};
var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css2,
  valueContainer: valueContainerCSS
};
var colors = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
};
var borderRadius = 4;
var baseUnit = 4;
var controlHeight = 38;
var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit,
  controlHeight,
  menuGutter
};
var defaultTheme = {
  borderRadius,
  colors,
  spacing
};
var defaultProps$2 = {
  "aria-live": "polite",
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return "No options";
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function screenReaderStatus(_ref3) {
    var count = _ref3.count;
    return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true
};
function toCategorizedOption(props, option, selectValue, index2) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);
  var isSelected = _isOptionSelected(props, option, selectValue);
  var label = getOptionLabel2(props, option);
  var value = getOptionValue2(props, option);
  return {
    type: "option",
    data: option,
    isDisabled,
    isSelected,
    label,
    value,
    index: index2
  };
}
function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function(groupOrOption, groupOrOptionIndex) {
    if ("options" in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function(categorizedOption2) {
        return isFocusable(props, categorizedOption2);
      });
      return categorizedOptions.length > 0 ? {
        type: "group",
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : void 0;
    }
    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable(props, categorizedOption) ? categorizedOption : void 0;
  }).filter(notNullish);
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === "group") {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray$1(categorizedOption.options.map(function(option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
  var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
  var data2 = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label,
    value,
    data: data2
  }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
    if (nextFocusedIndex > -1) {
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      return nextSelectValue[lastFocusedIndex];
    }
  }
  return null;
}
function getNextFocusedOption(state, options2) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options2.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options2[0];
}
var getOptionLabel2 = function getOptionLabel3(props, data2) {
  return props.getOptionLabel(data2);
};
var getOptionValue2 = function getOptionValue3(props, data2) {
  return props.getOptionValue(data2);
};
function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1)
    return true;
  if (typeof props.isOptionSelected === "function") {
    return props.isOptionSelected(option, selectValue);
  }
  var candidate = getOptionValue2(props, option);
  return selectValue.some(function(i2) {
    return getOptionValue2(props, i2) === candidate;
  });
}
function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions2(props) {
  var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
  if (hideSelectedOptions === void 0)
    return isMulti;
  return hideSelectedOptions;
};
var instanceId = 1;
var Select$1 = /* @__PURE__ */ function(_Component) {
  _inherits(Select2, _Component);
  var _super = _createSuper(Select2);
  function Select2(_props) {
    var _this;
    _classCallCheck(this, Select2);
    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.instancePrefix = "";
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;
    _this.getControlRef = function(ref) {
      _this.controlRef = ref;
    };
    _this.focusedOptionRef = null;
    _this.getFocusedOptionRef = function(ref) {
      _this.focusedOptionRef = ref;
    };
    _this.menuListRef = null;
    _this.getMenuListRef = function(ref) {
      _this.menuListRef = ref;
    };
    _this.inputRef = null;
    _this.getInputRef = function(ref) {
      _this.inputRef = ref;
    };
    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;
    _this.onChange = function(newValue, actionMeta) {
      var _this$props = _this.props, onChange2 = _this$props.onChange, name = _this$props.name;
      actionMeta.name = name;
      _this.ariaOnChange(newValue, actionMeta);
      onChange2(newValue, actionMeta);
    };
    _this.setValue = function(newValue, action, option) {
      var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
      _this.onInputChange("", {
        action: "set-value",
        prevInputValue: inputValue
      });
      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      }
      _this.setState({
        clearFocusValueOnUpdate: true
      });
      _this.onChange(newValue, {
        action,
        option
      });
    };
    _this.selectOption = function(newValue) {
      var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
      var selectValue = _this.state.selectValue;
      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
      var isDisabled = _this.isOptionDisabled(newValue, selectValue);
      if (deselected) {
        var candidate = _this.getOptionValue(newValue);
        _this.setValue(multiValueAsValue(selectValue.filter(function(i2) {
          return _this.getOptionValue(i2) !== candidate;
        })), "deselect-option", newValue);
      } else if (!isDisabled) {
        if (isMulti) {
          _this.setValue(multiValueAsValue([].concat(_toConsumableArray$1(selectValue), [newValue])), "select-option", newValue);
        } else {
          _this.setValue(singleValueAsValue(newValue), "select-option");
        }
      } else {
        _this.ariaOnChange(singleValueAsValue(newValue), {
          action: "select-option",
          option: newValue,
          name
        });
        return;
      }
      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };
    _this.removeValue = function(removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var candidate = _this.getOptionValue(removedValue);
      var newValueArray = selectValue.filter(function(i2) {
        return _this.getOptionValue(i2) !== candidate;
      });
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: "remove-value",
        removedValue
      });
      _this.focusInput();
    };
    _this.clearValue = function() {
      var selectValue = _this.state.selectValue;
      _this.onChange(valueTernary(_this.props.isMulti, [], null), {
        action: "clear",
        removedValues: selectValue
      });
    };
    _this.popValue = function() {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: "pop-value",
        removedValue: lastSelectedValue
      });
    };
    _this.getValue = function() {
      return _this.state.selectValue;
    };
    _this.cx = function() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };
    _this.getOptionLabel = function(data2) {
      return getOptionLabel2(_this.props, data2);
    };
    _this.getOptionValue = function(data2) {
      return getOptionValue2(_this.props, data2);
    };
    _this.getStyles = function(key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = "border-box";
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };
    _this.getElementId = function(element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    };
    _this.getComponents = function() {
      return defaultComponents(_this.props);
    };
    _this.buildCategorizedOptions = function() {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };
    _this.getCategorizedOptions = function() {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };
    _this.buildFocusableOptions = function() {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };
    _this.getFocusableOptions = function() {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };
    _this.ariaOnChange = function(value, actionMeta) {
      _this.setState({
        ariaSelection: _objectSpread2({
          value
        }, actionMeta)
      });
    };
    _this.onMenuMouseDown = function(event) {
      if (event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      _this.focusInput();
    };
    _this.onMenuMouseMove = function(event) {
      _this.blockOptionHover = false;
    };
    _this.onControlMouseDown = function(event) {
      var openMenuOnClick = _this.props.openMenuOnClick;
      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }
        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu("first");
        }
      } else {
        if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
          _this.onMenuClose();
        }
      }
      if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
        event.preventDefault();
      }
    };
    _this.onDropdownIndicatorMouseDown = function(event) {
      if (event && event.type === "mousedown" && event.button !== 0) {
        return;
      }
      if (_this.props.isDisabled)
        return;
      var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
      _this.focusInput();
      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      } else {
        _this.openMenu("first");
      }
      event.preventDefault();
      event.stopPropagation();
    };
    _this.onClearIndicatorMouseDown = function(event) {
      if (event && event.type === "mousedown" && event.button !== 0) {
        return;
      }
      _this.clearValue();
      event.preventDefault();
      event.stopPropagation();
      _this.openAfterFocus = false;
      if (event.type === "touchend") {
        _this.focusInput();
      } else {
        setTimeout(function() {
          return _this.focusInput();
        });
      }
    };
    _this.onScroll = function(event) {
      if (typeof _this.props.closeMenuOnScroll === "boolean") {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === "function") {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };
    _this.onCompositionStart = function() {
      _this.isComposing = true;
    };
    _this.onCompositionEnd = function() {
      _this.isComposing = false;
    };
    _this.onTouchStart = function(_ref22) {
      var touches = _ref22.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };
    _this.onTouchMove = function(_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };
    _this.onTouchEnd = function(event) {
      if (_this.userIsDragging)
        return;
      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      }
      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };
    _this.onControlTouchEnd = function(event) {
      if (_this.userIsDragging)
        return;
      _this.onControlMouseDown(event);
    };
    _this.onClearIndicatorTouchEnd = function(event) {
      if (_this.userIsDragging)
        return;
      _this.onClearIndicatorMouseDown(event);
    };
    _this.onDropdownIndicatorTouchEnd = function(event) {
      if (_this.userIsDragging)
        return;
      _this.onDropdownIndicatorMouseDown(event);
    };
    _this.handleInputChange = function(event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;
      _this.setState({
        inputIsHiddenAfterUpdate: false
      });
      _this.onInputChange(inputValue, {
        action: "input-change",
        prevInputValue
      });
      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };
    _this.onInputFocus = function(event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });
      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu("first");
      }
      _this.openAfterFocus = false;
    };
    _this.onInputBlur = function(event) {
      var prevInputValue = _this.props.inputValue;
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();
        return;
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
      _this.onInputChange("", {
        action: "input-blur",
        prevInputValue
      });
      _this.onMenuClose();
      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };
    _this.onOptionHover = function(focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }
      _this.setState({
        focusedOption
      });
    };
    _this.shouldHideSelectedOptions = function() {
      return shouldHideSelectedOptions(_this.props);
    };
    _this.onKeyDown = function(event) {
      var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
      if (isDisabled)
        return;
      if (typeof onKeyDown === "function") {
        onKeyDown(event);
        if (event.defaultPrevented) {
          return;
        }
      }
      _this.blockOptionHover = true;
      switch (event.key) {
        case "ArrowLeft":
          if (!isMulti || inputValue)
            return;
          _this.focusValue("previous");
          break;
        case "ArrowRight":
          if (!isMulti || inputValue)
            return;
          _this.focusValue("next");
          break;
        case "Delete":
        case "Backspace":
          if (inputValue)
            return;
          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue)
              return;
            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }
          break;
        case "Tab":
          if (_this.isComposing)
            return;
          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }
          _this.selectOption(focusedOption);
          break;
        case "Enter":
          if (event.keyCode === 229) {
            break;
          }
          if (menuIsOpen) {
            if (!focusedOption)
              return;
            if (_this.isComposing)
              return;
            _this.selectOption(focusedOption);
            break;
          }
          return;
        case "Escape":
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange("", {
              action: "menu-close",
              prevInputValue: inputValue
            });
            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }
          break;
        case " ":
          if (inputValue) {
            return;
          }
          if (!menuIsOpen) {
            _this.openMenu("first");
            break;
          }
          if (!focusedOption)
            return;
          _this.selectOption(focusedOption);
          break;
        case "ArrowUp":
          if (menuIsOpen) {
            _this.focusOption("up");
          } else {
            _this.openMenu("last");
          }
          break;
        case "ArrowDown":
          if (menuIsOpen) {
            _this.focusOption("down");
          } else {
            _this.openMenu("first");
          }
          break;
        case "PageUp":
          if (!menuIsOpen)
            return;
          _this.focusOption("pageup");
          break;
        case "PageDown":
          if (!menuIsOpen)
            return;
          _this.focusOption("pagedown");
          break;
        case "Home":
          if (!menuIsOpen)
            return;
          _this.focusOption("first");
          break;
        case "End":
          if (!menuIsOpen)
            return;
          _this.focusOption("last");
          break;
        default:
          return;
      }
      event.preventDefault();
    };
    _this.instancePrefix = "react-select-" + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = cleanValue(_props.value);
    return _this;
  }
  _createClass(Select2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();
      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        document.addEventListener("scroll", this.onScroll, true);
      }
      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;
      if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }
      if (isFocused && isDisabled && !prevProps.isDisabled) {
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      }
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener("scroll", this.onScroll, true);
    }
  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }
  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef)
        return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef)
        return;
      this.inputRef.blur();
    }
  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;
      var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }
      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex]
      }, function() {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
      if (!this.props.isMulti)
        return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
      }
      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length)
        return;
      switch (direction) {
        case "previous":
          if (focusedIndex === 0) {
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case "next":
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }
      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first";
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options2 = this.getFocusableOptions();
      if (!options2.length)
        return;
      var nextFocus = 0;
      var focusedIndex = options2.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
      }
      if (direction === "up") {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options2.length - 1;
      } else if (direction === "down") {
        nextFocus = (focusedIndex + 1) % options2.length;
      } else if (direction === "pageup") {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0)
          nextFocus = 0;
      } else if (direction === "pagedown") {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options2.length - 1)
          nextFocus = options2.length - 1;
      } else if (direction === "last") {
        nextFocus = options2.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options2[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: "getTheme",
    value: function getTheme() {
      if (!this.props.theme) {
        return defaultTheme;
      }
      if (typeof this.props.theme === "function") {
        return this.props.theme(defaultTheme);
      }
      return _objectSpread2(_objectSpread2({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getValue2 = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
      var isMulti = props.isMulti, isRtl = props.isRtl, options2 = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue,
        cx,
        getStyles,
        getValue: getValue2,
        hasValue,
        isMulti,
        isRtl,
        options: options2,
        selectOption,
        selectProps: props,
        setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props, isClearable2 = _this$props7.isClearable, isMulti = _this$props7.isMulti;
      if (isClearable2 === void 0)
        return isMulti;
      return isClearable2;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled3(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data2, context) {
      if (typeof this.props.formatOptionLabel === "function") {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data2, {
          context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data2);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel3(data2) {
      return this.props.formatGroupLabel(data2);
    }
  }, {
    key: "startListeningComposition",
    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener("compositionstart", this.onCompositionStart, false);
        document.addEventListener("compositionend", this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener("compositionstart", this.onCompositionStart);
        document.removeEventListener("compositionend", this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener("touchstart", this.onTouchStart, false);
        document.addEventListener("touchmove", this.onTouchMove, false);
        document.addEventListener("touchend", this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener("touchstart", this.onTouchStart);
        document.removeEventListener("touchmove", this.onTouchMove);
        document.removeEventListener("touchend", this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen;
      var _this$getComponents = this.getComponents(), Input3 = _this$getComponents.Input;
      var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
      var commonProps = this.commonProps;
      var id2 = inputId || this.getElementId("input");
      var ariaAttributes = _objectSpread2(_objectSpread2({
        "aria-autocomplete": "list",
        "aria-expanded": menuIsOpen,
        "aria-haspopup": true,
        "aria-controls": this.getElementId("listbox"),
        "aria-owns": this.getElementId("listbox"),
        "aria-errormessage": this.props["aria-errormessage"],
        "aria-invalid": this.props["aria-invalid"],
        "aria-label": this.props["aria-label"],
        "aria-labelledby": this.props["aria-labelledby"],
        role: "combobox"
      }, !isSearchable && {
        "aria-readonly": true
      }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
        "aria-describedby": this.getElementId("live-region")
      } : {
        "aria-describedby": this.getElementId("placeholder")
      });
      if (!isSearchable) {
        return /* @__PURE__ */ jsx$1(DummyInput, __spreadValues({
          id: id2,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop$3,
          onFocus: this.onInputFocus,
          disabled: isDisabled,
          tabIndex,
          inputMode: "none",
          form,
          value: ""
        }, ariaAttributes));
      }
      return /* @__PURE__ */ jsx$1(Input3, __spreadValues(__spreadProps(__spreadValues({}, commonProps), {
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id: id2,
        innerRef: this.getInputRef,
        isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex,
        form,
        type: "text",
        value: inputValue
      }), ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;
      var _this$getComponents2 = this.getComponents(), MultiValue3 = _this$getComponents2.MultiValue, MultiValueContainer2 = _this$getComponents2.MultiValueContainer, MultiValueLabel2 = _this$getComponents2.MultiValueLabel, MultiValueRemove2 = _this$getComponents2.MultiValueRemove, SingleValue3 = _this$getComponents2.SingleValue, Placeholder3 = _this$getComponents2.Placeholder;
      var commonProps = this.commonProps;
      var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
      var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /* @__PURE__ */ createElement(Placeholder3, __spreadProps(__spreadValues({}, commonProps), {
          key: "placeholder",
          isDisabled,
          isFocused,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), placeholder);
      }
      if (isMulti) {
        return selectValue.map(function(opt, index2) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return /* @__PURE__ */ createElement(MultiValue3, __spreadProps(__spreadValues({}, commonProps), {
            components: {
              Container: MultiValueContainer2,
              Label: MultiValueLabel2,
              Remove: MultiValueRemove2
            },
            isFocused: isOptionFocused,
            isDisabled,
            key,
            index: index2,
            removeProps: {
              onClick: function onClick2() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd2() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e2) {
                e2.preventDefault();
                e2.stopPropagation();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, "value"));
        });
      }
      if (inputValue) {
        return null;
      }
      var singleValue = selectValue[0];
      return /* @__PURE__ */ jsx$1(SingleValue3, __spreadProps(__spreadValues({}, commonProps), {
        data: singleValue,
        isDisabled,
        children: this.formatOptionLabel(singleValue, "value")
      }));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(), ClearIndicator3 = _this$getComponents3.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;
      if (!this.isClearable() || !ClearIndicator3 || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }
      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ jsx$1(ClearIndicator3, __spreadProps(__spreadValues({}, commonProps), {
        innerProps,
        isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(), LoadingIndicator3 = _this$getComponents4.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator3 || !isLoading)
        return null;
      var innerProps = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ jsx$1(LoadingIndicator3, __spreadProps(__spreadValues({}, commonProps), {
        innerProps,
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(), DropdownIndicator3 = _this$getComponents5.DropdownIndicator, IndicatorSeparator3 = _this$getComponents5.IndicatorSeparator;
      if (!DropdownIndicator3 || !IndicatorSeparator3)
        return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /* @__PURE__ */ jsx$1(IndicatorSeparator3, __spreadProps(__spreadValues({}, commonProps), {
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(), DropdownIndicator3 = _this$getComponents6.DropdownIndicator;
      if (!DropdownIndicator3)
        return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ jsx$1(DropdownIndicator3, __spreadProps(__spreadValues({}, commonProps), {
        innerProps,
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;
      var _this$getComponents7 = this.getComponents(), Group3 = _this$getComponents7.Group, GroupHeading3 = _this$getComponents7.GroupHeading, Menu3 = _this$getComponents7.Menu, MenuList3 = _this$getComponents7.MenuList, MenuPortal2 = _this$getComponents7.MenuPortal, LoadingMessage3 = _this$getComponents7.LoadingMessage, NoOptionsMessage3 = _this$getComponents7.NoOptionsMessage, Option3 = _this$getComponents7.Option;
      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage2 = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage2 = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen)
        return null;
      var render = function render2(props, id2) {
        var type = props.type, data2 = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
        var isFocused = focusedOption === data2;
        var onHover = isDisabled ? void 0 : function() {
          return _this4.onOptionHover(data2);
        };
        var onSelect = isDisabled ? void 0 : function() {
          return _this4.selectOption(data2);
        };
        var optionId = "".concat(_this4.getElementId("option"), "-").concat(id2);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1
        };
        return /* @__PURE__ */ createElement(Option3, __spreadProps(__spreadValues({}, commonProps), {
          innerProps,
          data: data2,
          isDisabled,
          isSelected,
          key: optionId,
          label,
          type,
          value,
          isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : void 0
        }), _this4.formatOptionLabel(props.data, "menu"));
      };
      var menuUI;
      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function(item) {
          if (item.type === "group") {
            var _data = item.data, options2 = item.options, groupIndex = item.index;
            var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /* @__PURE__ */ createElement(Group3, __spreadProps(__spreadValues({}, commonProps), {
              key: groupId,
              data: _data,
              options: options2,
              Heading: GroupHeading3,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this4.formatGroupLabel(item.data)
            }), item.options.map(function(option) {
              return render(option, "".concat(groupIndex, "-").concat(option.index));
            }));
          } else if (item.type === "option") {
            return render(item, "".concat(item.index));
          }
        });
      } else if (isLoading) {
        var message = loadingMessage2({
          inputValue
        });
        if (message === null)
          return null;
        menuUI = /* @__PURE__ */ jsx$1(LoadingMessage3, __spreadProps(__spreadValues({}, commonProps), {
          children: message
        }));
      } else {
        var _message = noOptionsMessage2({
          inputValue
        });
        if (_message === null)
          return null;
        menuUI = /* @__PURE__ */ jsx$1(NoOptionsMessage3, __spreadProps(__spreadValues({}, commonProps), {
          children: _message
        }));
      }
      var menuPlacementProps = {
        minMenuHeight,
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView
      };
      var menuElement = /* @__PURE__ */ jsx$1(MenuPlacer, __spreadProps(__spreadValues(__spreadValues({}, commonProps), menuPlacementProps), {
        children: function(_ref4) {
          var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
          return /* @__PURE__ */ jsx$1(Menu3, __spreadProps(__spreadValues(__spreadValues({}, commonProps), menuPlacementProps), {
            innerRef: ref,
            innerProps: {
              onMouseDown: _this4.onMenuMouseDown,
              onMouseMove: _this4.onMenuMouseMove,
              id: _this4.getElementId("listbox")
            },
            isLoading,
            placement,
            children: /* @__PURE__ */ jsx$1(ScrollManager, {
              captureEnabled: captureMenuScroll,
              onTopArrive: onMenuScrollToTop,
              onBottomArrive: onMenuScrollToBottom,
              lockEnabled: menuShouldBlockScroll,
              children: function(scrollTargetRef) {
                return /* @__PURE__ */ jsx$1(MenuList3, __spreadProps(__spreadValues({}, commonProps), {
                  innerRef: function innerRef(instance) {
                    _this4.getMenuListRef(instance);
                    scrollTargetRef(instance);
                  },
                  isLoading,
                  maxHeight,
                  focusedOption,
                  children: menuUI
                }));
              }
            })
          }));
        }
      }));
      return menuPortalTarget || menuPosition === "fixed" ? /* @__PURE__ */ jsx$1(MenuPortal2, __spreadProps(__spreadValues({}, commonProps), {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement,
        menuPosition,
        children: menuElement
      })) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;
      var _this$props13 = this.props, delimiter2 = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled)
        return;
      if (isMulti) {
        if (delimiter2) {
          var value = selectValue.map(function(opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter2);
          return /* @__PURE__ */ jsx$1("input", {
            name,
            type: "hidden",
            value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function(opt, i2) {
            return /* @__PURE__ */ jsx$1("input", {
              name,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            }, "i-".concat(i2));
          }) : /* @__PURE__ */ jsx$1("input", {
            name,
            type: "hidden"
          });
          return /* @__PURE__ */ jsx$1("div", {
            children: input
          });
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
        return /* @__PURE__ */ jsx$1("input", {
          name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /* @__PURE__ */ jsx$1(LiveRegion, __spreadProps(__spreadValues({}, commonProps), {
        id: this.getElementId("live-region"),
        ariaSelection,
        focusedOption,
        focusedValue,
        isFocused,
        selectValue,
        focusableOptions
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getComponents8 = this.getComponents(), Control3 = _this$getComponents8.Control, IndicatorsContainer3 = _this$getComponents8.IndicatorsContainer, SelectContainer3 = _this$getComponents8.SelectContainer, ValueContainer3 = _this$getComponents8.ValueContainer;
      var _this$props14 = this.props, className = _this$props14.className, id2 = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ jsxs(SelectContainer3, __spreadProps(__spreadValues({}, commonProps), {
        className,
        innerProps: {
          id: id2,
          onKeyDown: this.onKeyDown
        },
        isDisabled,
        isFocused,
        children: [this.renderLiveRegion(), /* @__PURE__ */ jsxs(Control3, __spreadProps(__spreadValues({}, commonProps), {
          innerRef: this.getControlRef,
          innerProps: {
            onMouseDown: this.onControlMouseDown,
            onTouchEnd: this.onControlTouchEnd
          },
          isDisabled,
          isFocused,
          menuIsOpen,
          children: [/* @__PURE__ */ jsxs(ValueContainer3, __spreadProps(__spreadValues({}, commonProps), {
            isDisabled,
            children: [this.renderPlaceholderOrValue(), this.renderInput()]
          })), /* @__PURE__ */ jsxs(IndicatorsContainer3, __spreadProps(__spreadValues({}, commonProps), {
            isDisabled,
            children: [this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator()]
          }))]
        })), this.renderMenu(), this.renderFormField()]
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
      var options2 = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
      var selectValue = cleanValue(value);
      var newMenuOptionsState = {};
      if (prevProps && (value !== prevProps.value || options2 !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        newMenuOptionsState = {
          selectValue,
          focusedOption,
          focusedValue,
          clearFocusValueOnUpdate: false
        };
      }
      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: void 0
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;
      if (isFocused && !hasKeptFocus) {
        newAriaSelection = {
          value: valueTernary(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: "initial-input-focus"
        };
        hasKeptFocus = !prevWasFocused;
      }
      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") {
        newAriaSelection = null;
      }
      return _objectSpread2(_objectSpread2(_objectSpread2({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);
  return Select2;
}(Component);
Select$1.defaultProps = defaultProps$2;
var StateManagedSelect = /* @__PURE__ */ React__default.forwardRef(function(props, ref) {
  var baseSelectProps = useStateManager(props);
  return /* @__PURE__ */ jsx$1(Select$1, __spreadValues({
    ref
  }, baseSelectProps));
});
var ReactSelect = StateManagedSelect;
const Select = (props) => {
  const {
    value,
    isDisabled,
    isInvalid,
    options: options2,
    placeholder,
    onChange: onChange2,
    isMulti,
    className,
    closeMenuOnSelect
  } = props;
  return /* @__PURE__ */ jsx$1(ReactSelect, {
    closeMenuOnSelect,
    isMulti,
    value,
    isDisabled,
    className: `${className} ${isInvalid ? "react-select__control--is-invalid" : ""}`,
    placeholder,
    classNamePrefix: "react-select",
    options: options2,
    onChange: onChange2,
    components: {
      IndicatorSeparator: null
    }
  });
};
Select.defaultProps = {
  isDisabled: false,
  isInvalid: false,
  placeholder: "Placeholder"
};
Select.displayName = "Select";
var baseGetTag = _baseGetTag, isObjectLike$1 = isObjectLike_1;
var symbolTag$1 = "[object Symbol]";
function isSymbol$5(value) {
  return typeof value == "symbol" || isObjectLike$1(value) && baseGetTag(value) == symbolTag$1;
}
var isSymbol_1 = isSymbol$5;
var isArray$b = isArray_1, isSymbol$4 = isSymbol_1;
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey$3(value, object2) {
  if (isArray$b(value)) {
    return false;
  }
  var type = typeof value;
  if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol$4(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object2 != null && value in Object(object2);
}
var _isKey = isKey$3;
var getNative$1 = _getNative;
var nativeCreate$4 = getNative$1(Object, "create");
var _nativeCreate = nativeCreate$4;
var nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete$1;
var nativeCreate$2 = _nativeCreate;
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$7 = Object.prototype;
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;
function hashGet$1(key) {
  var data2 = this.__data__;
  if (nativeCreate$2) {
    var result = data2[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$6.call(data2, key) ? data2[key] : void 0;
}
var _hashGet = hashGet$1;
var nativeCreate$1 = _nativeCreate;
var objectProto$6 = Object.prototype;
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
function hashHas$1(key) {
  var data2 = this.__data__;
  return nativeCreate$1 ? data2[key] !== void 0 : hasOwnProperty$5.call(data2, key);
}
var _hashHas = hashHas$1;
var nativeCreate = _nativeCreate;
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(key, value) {
  var data2 = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data2[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
var _hashSet = hashSet$1;
var hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype["delete"] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$3(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq$3;
var eq$2 = eq_1;
function assocIndexOf$4(array2, key) {
  var length2 = array2.length;
  while (length2--) {
    if (eq$2(array2[length2][0], key)) {
      return length2;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$4;
var assocIndexOf$3 = _assocIndexOf;
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete$1(key) {
  var data2 = this.__data__, index2 = assocIndexOf$3(data2, key);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data2.length - 1;
  if (index2 == lastIndex) {
    data2.pop();
  } else {
    splice.call(data2, index2, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$1;
var assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(key) {
  var data2 = this.__data__, index2 = assocIndexOf$2(data2, key);
  return index2 < 0 ? void 0 : data2[index2][1];
}
var _listCacheGet = listCacheGet$1;
var assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas$1;
var assocIndexOf = _assocIndexOf;
function listCacheSet$1(key, value) {
  var data2 = this.__data__, index2 = assocIndexOf(data2, key);
  if (index2 < 0) {
    ++this.size;
    data2.push([key, value]);
  } else {
    data2[index2][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet$1;
var listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$4(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype["delete"] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4;
var Hash = _Hash, ListCache$3 = _ListCache, Map$2 = _Map;
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$2 || ListCache$3)(),
    "string": new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var _isKeyable = isKeyable$1;
var isKeyable = _isKeyable;
function getMapData$4(map2, key) {
  var data2 = map2.__data__;
  return isKeyable(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
}
var _getMapData = getMapData$4;
var getMapData$3 = _getMapData;
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete$1;
var getMapData$2 = _getMapData;
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}
var _mapCacheGet = mapCacheGet$1;
var getMapData$1 = _getMapData;
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}
var _mapCacheHas = mapCacheHas$1;
var getMapData = _getMapData;
function mapCacheSet$1(key, value) {
  var data2 = getMapData(this, key), size = data2.size;
  data2.set(key, value);
  this.size += data2.size == size ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$1;
var mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$3(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype["delete"] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3;
var MapCache$2 = _MapCache;
var FUNC_ERROR_TEXT = "Expected a function";
function memoize$1(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache2 = memoized.cache;
    if (cache2.has(key)) {
      return cache2.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache2.set(key, result) || cache2;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache$2)();
  return memoized;
}
memoize$1.Cache = MapCache$2;
var memoize_1 = memoize$1;
var memoize = memoize_1;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    if (cache2.size === MAX_MEMOIZE_SIZE) {
      cache2.clear();
    }
    return key;
  });
  var cache2 = result.cache;
  return result;
}
var _memoizeCapped = memoizeCapped$1;
var memoizeCapped = _memoizeCapped;
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath$1 = memoizeCapped(function(string2) {
  var result = [];
  if (string2.charCodeAt(0) === 46) {
    result.push("");
  }
  string2.replace(rePropName, function(match2, number2, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, "$1") : number2 || match2);
  });
  return result;
});
var _stringToPath = stringToPath$1;
function arrayMap$2(array2, iteratee) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length, result = Array(length2);
  while (++index2 < length2) {
    result[index2] = iteratee(array2[index2], index2, array2);
  }
  return result;
}
var _arrayMap = arrayMap$2;
var Symbol$3 = _Symbol, arrayMap$1 = _arrayMap, isArray$a = isArray_1, isSymbol$3 = isSymbol_1;
var INFINITY$3 = 1 / 0;
var symbolProto$1 = Symbol$3 ? Symbol$3.prototype : void 0, symbolToString$1 = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString$1(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray$a(value)) {
    return arrayMap$1(value, baseToString$1) + "";
  }
  if (isSymbol$3(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$3 ? "-0" : result;
}
var _baseToString = baseToString$1;
var baseToString = _baseToString;
function toString$7(value) {
  return value == null ? "" : baseToString(value);
}
var toString_1 = toString$7;
var isArray$9 = isArray_1, isKey$2 = _isKey, stringToPath = _stringToPath, toString$6 = toString_1;
function castPath$2(value, object2) {
  if (isArray$9(value)) {
    return value;
  }
  return isKey$2(value, object2) ? [value] : stringToPath(toString$6(value));
}
var _castPath = castPath$2;
var isSymbol$2 = isSymbol_1;
var INFINITY$2 = 1 / 0;
function toKey$4(value) {
  if (typeof value == "string" || isSymbol$2(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$2 ? "-0" : result;
}
var _toKey = toKey$4;
var castPath$1 = _castPath, toKey$3 = _toKey;
function baseGet$3(object2, path) {
  path = castPath$1(path, object2);
  var index2 = 0, length2 = path.length;
  while (object2 != null && index2 < length2) {
    object2 = object2[toKey$3(path[index2++])];
  }
  return index2 && index2 == length2 ? object2 : void 0;
}
var _baseGet = baseGet$3;
var baseGet$2 = _baseGet;
function get$1(object2, path, defaultValue) {
  var result = object2 == null ? void 0 : baseGet$2(object2, path);
  return result === void 0 ? defaultValue : result;
}
var get_1 = get$1;
const useClickOutside = (ref, callback) => {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref && !ref.contains(event.target)) {
        callback();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, callback]);
};
const Tooltip = ({
  children: children2,
  description,
  variant = "default",
  position: position2 = "top",
  arrow: arrow2
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const refContainer = useRef(null);
  useClickOutside(refContainer == null ? void 0 : refContainer.current, () => setIsOpen(false));
  const variantClass = () => {
    switch (variant) {
      case "white":
        return "tw-bg-White tw-text-Black";
      case "primary":
        return "tw-bg-LightNudePrimary tw-border tw-border-Primary-600 tw-border-solid tw-text-Black";
      case "default":
        return "tw-bg-Gray-400 tw-text-White";
      default:
        return "";
    }
  };
  const positionClass = () => {
    switch (position2) {
      case "top":
        return "tw-bottom-full tw-right-2/4 tw-translate-x-2/4 tw-mb-2";
      case "bottom":
        return "tw-top-full tw-right-2/4 tw-translate-x-2/4 tw-mt-2";
      case "left":
        return "tw-right-full tw-bottom-2/4 tw-translate-y-2/4 tw-mr-2";
      case "right":
        return "tw-left-full tw-bottom-2/4 tw-translate-y-2/4 tw-ml-2";
      default:
        return "";
    }
  };
  const arrowClass = () => {
    if (arrow2) {
      const [direction, positionKey] = arrow2.split("-");
      const isHorizontal = ["top", "bottom"].includes(direction);
      const arrowDirection = {
        top: "tw--rotate-45 tw-transform tw-bottom-full tw-origin-top-right tw-border-b-0 tw-border-l-0",
        right: "tw-rotate-45 tw-transform tw-left-full tw-origin-top-left tw-border-b-0 tw-border-l-0",
        left: "tw-rotate-45 tw-transform tw-origin-bottom-right tw-right-full tw-border-t-0 tw-border-r-0",
        bottom: "tw--rotate-45 tw-transform tw-origin-bottom-right tw-bottom-0 tw-border-t-0 tw-border-r-0"
      };
      const arrowPosition = {
        top: "tw-top-[15%]",
        center: isHorizontal ? "tw--translate-x-2/4 tw-left-2/4" : "tw-translate-y-2/4 tw-bottom-2/4",
        bottom: "tw-bottom-[15%]",
        left: "tw-left-[15%]",
        right: "tw-right-[15%]"
      };
      const defaultArrowClass = "tw-absolute tw-h-2 tw-w-2";
      return classNames$1(arrowDirection[direction], arrowPosition[positionKey], defaultArrowClass);
    }
    return "";
  };
  const descriptionClassName = classNames$1("tw-absolute", "tw-rounded-lg", "tw-px-4", "tw-py-2", "title-10", "tw-w-max", variantClass(), positionClass(), isOpen ? "tw-block" : "tw-hidden", "group-hover:tw-block");
  return /* @__PURE__ */ jsxs("div", {
    className: "tw-group tw-inline-block tw-relative tw-cursor-pointer",
    ref: refContainer,
    onClick: () => setIsOpen(true),
    children: [children2, /* @__PURE__ */ jsxs("div", {
      className: descriptionClassName,
      children: [/* @__PURE__ */ jsx$1("div", {
        className: "tw-relative",
        children: description
      }), arrow2 && /* @__PURE__ */ jsx$1("div", {
        className: classNames$1(arrowClass(), variantClass())
      })]
    })]
  });
};
const FormDropdown = (_v) => {
  var _w = _v, {
    label,
    info,
    isOptional = false,
    error: error2,
    placeholder,
    handleChange,
    options: options2 = [],
    value,
    disabled
  } = _w, props = __objRest(_w, [
    "label",
    "info",
    "isOptional",
    "error",
    "placeholder",
    "handleChange",
    "options",
    "value",
    "disabled"
  ]);
  const {
    t: t2
  } = useTranslation();
  const handleSelect = (value2) => {
    handleChange(get_1(value2, "value"));
  };
  return /* @__PURE__ */ jsxs("div", {
    children: [label && /* @__PURE__ */ jsx$1("div", {
      className: "tw-inline-flex tw-pb-1 tw-w-full",
      children: /* @__PURE__ */ jsxs("div", {
        className: "tw-inline-flex tw-w-full tw-max-w-full tw-truncate",
        children: [/* @__PURE__ */ jsx$1(Typography, {
          className: "tw-pr-1 tw-w-fit tw-truncate",
          variant: "title-9",
          color: error2 ? COLORS.Red : COLORS.Gray[600],
          children: label
        }), info && /* @__PURE__ */ jsx$1(Tooltip, {
          description: /* @__PURE__ */ jsx$1("p", {
            children: info
          }),
          variant: "default",
          position: "right",
          arrow: "left-center",
          children: /* @__PURE__ */ jsx$1(Icon, {
            name: IconName.INFO,
            viewBox: "0 0 32 32",
            size: IconSize.MEDIUM,
            className: "tw-pr-1 tw-fill-Gray-400"
          })
        }), isOptional && /* @__PURE__ */ jsx$1(Typography, {
          className: "tw-pr-1",
          variant: "title-9",
          color: COLORS.Gray[500],
          children: t2("createStore.optional")
        })]
      })
    }), /* @__PURE__ */ jsx$1(Select, __spreadValues({
      value,
      options: options2,
      placeholder,
      onChange: handleSelect,
      isDisabled: disabled,
      isInvalid: !isEmpty_1(error2)
    }, props)), error2 && /* @__PURE__ */ jsx$1(Typography, {
      className: "tw-pt-1 tw-pb-2 tw-w-full tw-text-left",
      variant: "body-3",
      color: COLORS.Red,
      children: t2(error2)
    })]
  });
};
function noop$2() {
}
function returnTrue() {
  return true;
}
function charIsNumber(char2) {
  return !!(char2 || "").match(/\d/);
}
function isNil$1(val) {
  return val === null || val === void 0;
}
function escapeRegExp(str) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function getThousandsGroupRegex(thousandsGroupStyle) {
  switch (thousandsGroupStyle) {
    case "lakh":
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case "wan":
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case "thousand":
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}
function applyThousandSeparator(str, thousandSeparator, thousandsGroupStyle) {
  var thousandsGroupRegex = getThousandsGroupRegex(thousandsGroupStyle);
  var index2 = str.search(/[1-9]/);
  index2 = index2 === -1 ? str.length : index2;
  return str.substring(0, index2) + str.substring(index2, str.length).replace(thousandsGroupRegex, "$1" + thousandSeparator);
}
function splitDecimal(numStr, allowNegative) {
  if (allowNegative === void 0)
    allowNegative = true;
  var hasNagation = numStr[0] === "-";
  var addNegation = hasNagation && allowNegative;
  numStr = numStr.replace("-", "");
  var parts = numStr.split(".");
  var beforeDecimal = parts[0];
  var afterDecimal = parts[1] || "";
  return {
    beforeDecimal,
    afterDecimal,
    hasNagation,
    addNegation
  };
}
function fixLeadingZero(numStr) {
  if (!numStr) {
    return numStr;
  }
  var isNegative = numStr[0] === "-";
  if (isNegative) {
    numStr = numStr.substring(1, numStr.length);
  }
  var parts = numStr.split(".");
  var beforeDecimal = parts[0].replace(/^0+/, "") || "0";
  var afterDecimal = parts[1] || "";
  return "" + (isNegative ? "-" : "") + beforeDecimal + (afterDecimal ? "." + afterDecimal : "");
}
function limitToScale(numStr, scale, fixedDecimalScale) {
  var str = "";
  var filler = fixedDecimalScale ? "0" : "";
  for (var i2 = 0; i2 <= scale - 1; i2++) {
    str += numStr[i2] || filler;
  }
  return str;
}
function repeat(str, count) {
  return Array(count + 1).join(str);
}
function toNumericString(num) {
  num += "";
  var sign = num[0] === "-" ? "-" : "";
  if (sign) {
    num = num.substring(1);
  }
  var ref = num.split(/[eE]/g);
  var coefficient = ref[0];
  var exponent = ref[1];
  exponent = Number(exponent);
  if (!exponent) {
    return sign + coefficient;
  }
  coefficient = coefficient.replace(".", "");
  var decimalIndex = 1 + exponent;
  var coffiecientLn = coefficient.length;
  if (decimalIndex < 0) {
    coefficient = "0." + repeat("0", Math.abs(decimalIndex)) + coefficient;
  } else if (decimalIndex >= coffiecientLn) {
    coefficient = coefficient + repeat("0", decimalIndex - coffiecientLn);
  } else {
    coefficient = (coefficient.substring(0, decimalIndex) || "0") + "." + coefficient.substring(decimalIndex);
  }
  return sign + coefficient;
}
function roundToPrecision(numStr, scale, fixedDecimalScale) {
  if (["", "-"].indexOf(numStr) !== -1) {
    return numStr;
  }
  var shoudHaveDecimalSeparator = numStr.indexOf(".") !== -1 && scale;
  var ref = splitDecimal(numStr);
  var beforeDecimal = ref.beforeDecimal;
  var afterDecimal = ref.afterDecimal;
  var hasNagation = ref.hasNagation;
  var floatValue = parseFloat("0." + (afterDecimal || "0"));
  var floatValueStr = afterDecimal.length <= scale ? "0." + afterDecimal : floatValue.toFixed(scale);
  var roundedDecimalParts = floatValueStr.split(".");
  var intPart = beforeDecimal.split("").reverse().reduce(function(roundedStr, current, idx) {
    if (roundedStr.length > idx) {
      return (Number(roundedStr[0]) + Number(current)).toString() + roundedStr.substring(1, roundedStr.length);
    }
    return current + roundedStr;
  }, roundedDecimalParts[0]);
  var decimalPart = limitToScale(roundedDecimalParts[1] || "", Math.min(scale, afterDecimal.length), fixedDecimalScale);
  var negation = hasNagation ? "-" : "";
  var decimalSeparator = shoudHaveDecimalSeparator ? "." : "";
  return "" + negation + intPart + decimalSeparator + decimalPart;
}
function setCaretPosition(el, caretPos) {
  el.value = el.value;
  if (el !== null) {
    if (el.createTextRange) {
      var range = el.createTextRange();
      range.move("character", caretPos);
      range.select();
      return true;
    }
    if (el.selectionStart || el.selectionStart === 0) {
      el.focus();
      el.setSelectionRange(caretPos, caretPos);
      return true;
    }
    el.focus();
    return false;
  }
}
function findChangedIndex(prevValue, newValue) {
  var i2 = 0, j = 0;
  var prevLength = prevValue.length;
  var newLength = newValue.length;
  while (prevValue[i2] === newValue[i2] && i2 < prevLength) {
    i2++;
  }
  while (prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] && newLength - j > i2 && prevLength - j > i2) {
    j++;
  }
  return { start: i2, end: prevLength - j };
}
function clamp(num, min2, max2) {
  return Math.min(Math.max(num, min2), max2);
}
function getCurrentCaretPosition(el) {
  return Math.max(el.selectionStart, el.selectionEnd);
}
function addInputMode(format2) {
  return format2 || typeof navigator !== "undefined" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function objectWithoutProperties(obj, exclude) {
  var target = {};
  for (var k2 in obj)
    if (Object.prototype.hasOwnProperty.call(obj, k2) && exclude.indexOf(k2) === -1)
      target[k2] = obj[k2];
  return target;
}
var defaultProps$1 = {
  displayType: "input",
  decimalSeparator: ".",
  thousandsGroupStyle: "thousand",
  fixedDecimalScale: false,
  prefix: "",
  suffix: "",
  allowNegative: true,
  allowEmptyFormatting: false,
  allowLeadingZeros: false,
  isNumericString: false,
  type: "text",
  onValueChange: noop$2,
  onChange: noop$2,
  onKeyDown: noop$2,
  onMouseUp: noop$2,
  onFocus: noop$2,
  onBlur: noop$2,
  isAllowed: returnTrue
};
var NumberFormat = /* @__PURE__ */ function(superclass) {
  function NumberFormat2(props) {
    superclass.call(this, props);
    var defaultValue = props.defaultValue;
    this.validateProps();
    var formattedValue = this.formatValueProp(defaultValue);
    this.state = {
      value: formattedValue,
      numAsString: this.removeFormatting(formattedValue),
      mounted: false
    };
    this.selectionBeforeInput = {
      selectionStart: 0,
      selectionEnd: 0
    };
    this.onChange = this.onChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }
  if (superclass)
    NumberFormat2.__proto__ = superclass;
  NumberFormat2.prototype = Object.create(superclass && superclass.prototype);
  NumberFormat2.prototype.constructor = NumberFormat2;
  NumberFormat2.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      mounted: true
    });
  };
  NumberFormat2.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    this.updateValueIfRequired(prevProps);
  };
  NumberFormat2.prototype.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.focusTimeout);
    clearTimeout(this.caretPositionTimeout);
  };
  NumberFormat2.prototype.updateValueIfRequired = function updateValueIfRequired(prevProps) {
    var ref = this;
    var props = ref.props;
    var state = ref.state;
    var focusedElm = ref.focusedElm;
    var stateValue = state.value;
    var lastNumStr = state.numAsString;
    if (lastNumStr === void 0)
      lastNumStr = "";
    if (prevProps !== props) {
      this.validateProps();
      var lastValueWithNewFormat = this.formatNumString(lastNumStr);
      var formattedValue = isNil$1(props.value) ? lastValueWithNewFormat : this.formatValueProp();
      var numAsString = this.removeFormatting(formattedValue);
      var floatValue = parseFloat(numAsString);
      var lastFloatValue = parseFloat(lastNumStr);
      if ((!isNaN(floatValue) || !isNaN(lastFloatValue)) && floatValue !== lastFloatValue || lastValueWithNewFormat !== stateValue || focusedElm === null && formattedValue !== stateValue) {
        this.updateValue({
          formattedValue,
          numAsString,
          input: focusedElm,
          source: "prop",
          event: null
        });
      }
    }
  };
  NumberFormat2.prototype.getFloatString = function getFloatString(num) {
    if (num === void 0)
      num = "";
    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    var numRegex = this.getNumberRegex(true);
    var hasNegation = num[0] === "-";
    if (hasNegation) {
      num = num.replace("-", "");
    }
    if (decimalSeparator && decimalScale === 0) {
      num = num.split(decimalSeparator)[0];
    }
    num = (num.match(numRegex) || []).join("").replace(decimalSeparator, ".");
    var firstDecimalIndex = num.indexOf(".");
    if (firstDecimalIndex !== -1) {
      num = num.substring(0, firstDecimalIndex) + "." + num.substring(firstDecimalIndex + 1, num.length).replace(new RegExp(escapeRegExp(decimalSeparator), "g"), "");
    }
    if (hasNegation) {
      num = "-" + num;
    }
    return num;
  };
  NumberFormat2.prototype.getNumberRegex = function getNumberRegex(g2, ignoreDecimalSeparator) {
    var ref = this.props;
    var format2 = ref.format;
    var decimalScale = ref.decimalScale;
    var customNumerals = ref.customNumerals;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    return new RegExp("[0-9" + (customNumerals ? customNumerals.join("") : "") + "]" + (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format2 ? "|" + escapeRegExp(decimalSeparator) : ""), g2 ? "g" : void 0);
  };
  NumberFormat2.prototype.getSeparators = function getSeparators() {
    var ref = this.props;
    var decimalSeparator = ref.decimalSeparator;
    var ref$1 = this.props;
    var thousandSeparator = ref$1.thousandSeparator;
    var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;
    if (thousandSeparator === true) {
      thousandSeparator = ",";
    }
    if (!allowedDecimalSeparators) {
      allowedDecimalSeparators = [decimalSeparator, "."];
    }
    return {
      decimalSeparator,
      thousandSeparator,
      allowedDecimalSeparators
    };
  };
  NumberFormat2.prototype.getMaskAtIndex = function getMaskAtIndex(index2) {
    var ref = this.props;
    var mask = ref.mask;
    if (mask === void 0)
      mask = " ";
    if (typeof mask === "string") {
      return mask;
    }
    return mask[index2] || " ";
  };
  NumberFormat2.prototype.getValueObject = function getValueObject(formattedValue, numAsString) {
    var floatValue = parseFloat(numAsString);
    return {
      formattedValue,
      value: numAsString,
      floatValue: isNaN(floatValue) ? void 0 : floatValue
    };
  };
  NumberFormat2.prototype.validateProps = function validateProps() {
    var ref = this.props;
    var mask = ref.mask;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    var thousandSeparator = ref$1.thousandSeparator;
    if (decimalSeparator === thousandSeparator) {
      throw new Error("\n          Decimal separator can't be same as thousand separator.\n          thousandSeparator: " + thousandSeparator + ' (thousandSeparator = {true} is same as thousandSeparator = ",")\n          decimalSeparator: ' + decimalSeparator + " (default value for decimalSeparator is .)\n       ");
    }
    if (mask) {
      var maskAsStr = mask === "string" ? mask : mask.toString();
      if (maskAsStr.match(/\d/g)) {
        throw new Error("\n          Mask " + mask + " should not contain numeric character;\n        ");
      }
    }
  };
  NumberFormat2.prototype.setPatchedCaretPosition = function setPatchedCaretPosition(el, caretPos, currentValue) {
    setCaretPosition(el, caretPos);
    this.caretPositionTimeout = setTimeout(function() {
      if (el.value === currentValue) {
        setCaretPosition(el, caretPos);
      }
    }, 0);
  };
  NumberFormat2.prototype.correctCaretPosition = function correctCaretPosition(value, caretPos, direction) {
    var ref = this.props;
    var prefix2 = ref.prefix;
    var suffix = ref.suffix;
    var format2 = ref.format;
    if (value === "") {
      return 0;
    }
    caretPos = clamp(caretPos, 0, value.length);
    if (!format2) {
      var hasNegation = value[0] === "-";
      return clamp(caretPos, prefix2.length + (hasNegation ? 1 : 0), value.length - suffix.length);
    }
    if (typeof format2 === "function") {
      return caretPos;
    }
    if (format2[caretPos] === "#" && charIsNumber(value[caretPos])) {
      return caretPos;
    }
    if (format2[caretPos - 1] === "#" && charIsNumber(value[caretPos - 1])) {
      return caretPos;
    }
    var firstHashPosition = format2.indexOf("#");
    var lastHashPosition = format2.lastIndexOf("#");
    caretPos = clamp(caretPos, firstHashPosition, lastHashPosition + 1);
    var nextPos = format2.substring(caretPos, format2.length).indexOf("#");
    var caretLeftBound = caretPos;
    var caretRightBound = caretPos + (nextPos === -1 ? 0 : nextPos);
    while (caretLeftBound > firstHashPosition && (format2[caretLeftBound] !== "#" || !charIsNumber(value[caretLeftBound]))) {
      caretLeftBound -= 1;
    }
    var goToLeft = !charIsNumber(value[caretRightBound]) || direction === "left" && caretPos !== firstHashPosition || caretPos - caretLeftBound < caretRightBound - caretPos;
    if (goToLeft) {
      return charIsNumber(value[caretLeftBound]) ? caretLeftBound + 1 : caretLeftBound;
    }
    return caretRightBound;
  };
  NumberFormat2.prototype.getCaretPosition = function getCaretPosition(inputValue, formattedValue, caretPos) {
    var ref = this.props;
    var format2 = ref.format;
    var stateValue = this.state.value;
    var numRegex = this.getNumberRegex(true);
    var inputNumber = (inputValue.match(numRegex) || []).join("");
    var formattedNumber = (formattedValue.match(numRegex) || []).join("");
    var j, i2;
    j = 0;
    for (i2 = 0; i2 < caretPos; i2++) {
      var currentInputChar = inputValue[i2] || "";
      var currentFormatChar = formattedValue[j] || "";
      if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) {
        continue;
      }
      if (currentInputChar === "0" && currentFormatChar.match(numRegex) && currentFormatChar !== "0" && inputNumber.length !== formattedNumber.length) {
        continue;
      }
      while (currentInputChar !== formattedValue[j] && j < formattedValue.length) {
        j++;
      }
      j++;
    }
    if (typeof format2 === "string" && !stateValue) {
      j = formattedValue.length;
    }
    j = this.correctCaretPosition(formattedValue, j);
    return j;
  };
  NumberFormat2.prototype.removePrefixAndSuffix = function removePrefixAndSuffix(val) {
    var ref = this.props;
    var format2 = ref.format;
    var prefix2 = ref.prefix;
    var suffix = ref.suffix;
    if (!format2 && val) {
      var isNegative = val[0] === "-";
      if (isNegative) {
        val = val.substring(1, val.length);
      }
      val = prefix2 && val.indexOf(prefix2) === 0 ? val.substring(prefix2.length, val.length) : val;
      var suffixLastIndex = val.lastIndexOf(suffix);
      val = suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length ? val.substring(0, suffixLastIndex) : val;
      if (isNegative) {
        val = "-" + val;
      }
    }
    return val;
  };
  NumberFormat2.prototype.removePatternFormatting = function removePatternFormatting(val) {
    var ref = this.props;
    var format2 = ref.format;
    var formatArray2 = format2.split("#").filter(function(str) {
      return str !== "";
    });
    var start2 = 0;
    var numStr = "";
    for (var i2 = 0, ln = formatArray2.length; i2 <= ln; i2++) {
      var part = formatArray2[i2] || "";
      var index2 = i2 === ln ? val.length : val.indexOf(part, start2);
      if (index2 === -1) {
        numStr = val;
        break;
      } else {
        numStr += val.substring(start2, index2);
        start2 = index2 + part.length;
      }
    }
    return (numStr.match(this.getNumberRegex(true)) || []).join("");
  };
  NumberFormat2.prototype.removeFormatting = function removeFormatting(val) {
    var ref = this.props;
    var format2 = ref.format;
    var removeFormatting2 = ref.removeFormatting;
    if (!val) {
      return val;
    }
    if (!format2) {
      val = this.removePrefixAndSuffix(val);
      val = this.getFloatString(val);
    } else if (typeof format2 === "string") {
      val = this.removePatternFormatting(val);
    } else if (typeof removeFormatting2 === "function") {
      val = removeFormatting2(val);
    } else {
      val = (val.match(this.getNumberRegex(true)) || []).join("");
    }
    return val;
  };
  NumberFormat2.prototype.formatWithPattern = function formatWithPattern(numStr) {
    var ref = this.props;
    var format2 = ref.format;
    var hashCount = 0;
    var formattedNumberAry = format2.split("");
    for (var i2 = 0, ln = format2.length; i2 < ln; i2++) {
      if (format2[i2] === "#") {
        formattedNumberAry[i2] = numStr[hashCount] || this.getMaskAtIndex(hashCount);
        hashCount += 1;
      }
    }
    return formattedNumberAry.join("");
  };
  NumberFormat2.prototype.formatAsNumber = function formatAsNumber(numStr) {
    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix2 = ref.prefix;
    var suffix = ref.suffix;
    var allowNegative = ref.allowNegative;
    var thousandsGroupStyle = ref.thousandsGroupStyle;
    var ref$1 = this.getSeparators();
    var thousandSeparator = ref$1.thousandSeparator;
    var decimalSeparator = ref$1.decimalSeparator;
    var hasDecimalSeparator = numStr.indexOf(".") !== -1 || decimalScale && fixedDecimalScale;
    var ref$2 = splitDecimal(numStr, allowNegative);
    var beforeDecimal = ref$2.beforeDecimal;
    var afterDecimal = ref$2.afterDecimal;
    var addNegation = ref$2.addNegation;
    if (decimalScale !== void 0) {
      afterDecimal = limitToScale(afterDecimal, decimalScale, fixedDecimalScale);
    }
    if (thousandSeparator) {
      beforeDecimal = applyThousandSeparator(beforeDecimal, thousandSeparator, thousandsGroupStyle);
    }
    if (prefix2) {
      beforeDecimal = prefix2 + beforeDecimal;
    }
    if (suffix) {
      afterDecimal = afterDecimal + suffix;
    }
    if (addNegation) {
      beforeDecimal = "-" + beforeDecimal;
    }
    numStr = beforeDecimal + (hasDecimalSeparator && decimalSeparator || "") + afterDecimal;
    return numStr;
  };
  NumberFormat2.prototype.formatNumString = function formatNumString(numStr) {
    if (numStr === void 0)
      numStr = "";
    var ref = this.props;
    var format2 = ref.format;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var customNumerals = ref.customNumerals;
    var formattedValue = numStr;
    if (customNumerals && customNumerals.length === 10) {
      var customNumeralRegex = new RegExp("[" + customNumerals.join("") + "]", "g");
      formattedValue = numStr.replace(customNumeralRegex, function(digit) {
        return customNumerals.indexOf(digit).toString();
      });
    }
    if (numStr === "" && !allowEmptyFormatting) {
      formattedValue = "";
    } else if (numStr === "-" && !format2) {
      formattedValue = "-";
    } else if (typeof format2 === "string") {
      formattedValue = this.formatWithPattern(formattedValue);
    } else if (typeof format2 === "function") {
      formattedValue = format2(formattedValue);
    } else {
      formattedValue = this.formatAsNumber(formattedValue);
    }
    return formattedValue;
  };
  NumberFormat2.prototype.formatValueProp = function formatValueProp(defaultValue) {
    var ref = this.props;
    var format2 = ref.format;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var ref$1 = this.props;
    var value = ref$1.value;
    var isNumericString = ref$1.isNumericString;
    value = isNil$1(value) ? defaultValue : value;
    var isNonNumericFalsy = !value && value !== 0;
    if (isNonNumericFalsy && allowEmptyFormatting) {
      value = "";
    }
    if (isNonNumericFalsy && !allowEmptyFormatting) {
      return "";
    }
    if (typeof value === "number") {
      value = toNumericString(value);
      isNumericString = true;
    }
    if (value === "Infinity" && isNumericString) {
      value = "";
    }
    if (isNumericString && !format2 && typeof decimalScale === "number") {
      value = roundToPrecision(value, decimalScale, fixedDecimalScale);
    }
    var formattedValue = isNumericString ? this.formatNumString(value) : this.formatInput(value);
    return formattedValue;
  };
  NumberFormat2.prototype.formatNegation = function formatNegation(value) {
    if (value === void 0)
      value = "";
    var ref = this.props;
    var allowNegative = ref.allowNegative;
    var negationRegex = new RegExp("(-)");
    var doubleNegationRegex = new RegExp("(-)(.)*(-)");
    var hasNegation = negationRegex.test(value);
    var removeNegation = doubleNegationRegex.test(value);
    value = value.replace(/-/g, "");
    if (hasNegation && !removeNegation && allowNegative) {
      value = "-" + value;
    }
    return value;
  };
  NumberFormat2.prototype.formatInput = function formatInput(value) {
    if (value === void 0)
      value = "";
    var ref = this.props;
    var format2 = ref.format;
    if (!format2) {
      value = this.removePrefixAndSuffix(value);
      value = this.formatNegation(value);
    }
    value = this.removeFormatting(value);
    return this.formatNumString(value);
  };
  NumberFormat2.prototype.isCharacterAFormat = function isCharacterAFormat(caretPos, value) {
    var ref = this.props;
    var format2 = ref.format;
    var prefix2 = ref.prefix;
    var suffix = ref.suffix;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    if (typeof format2 === "string" && format2[caretPos] !== "#") {
      return true;
    }
    if (!format2 && (caretPos < prefix2.length || caretPos >= value.length - suffix.length || decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator)) {
      return true;
    }
    return false;
  };
  NumberFormat2.prototype.correctInputValue = function correctInputValue(caretPos, lastValue, value) {
    var this$1$1 = this;
    var ref = this.props;
    var format2 = ref.format;
    var allowNegative = ref.allowNegative;
    var prefix2 = ref.prefix;
    var suffix = ref.suffix;
    var decimalScale = ref.decimalScale;
    var ref$1 = this.getSeparators();
    var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;
    var decimalSeparator = ref$1.decimalSeparator;
    var lastNumStr = this.state.numAsString || "";
    var ref$2 = this.selectionBeforeInput;
    var selectionStart = ref$2.selectionStart;
    var selectionEnd = ref$2.selectionEnd;
    var ref$3 = findChangedIndex(lastValue, value);
    var start2 = ref$3.start;
    var end2 = ref$3.end;
    if (!format2 && start2 === end2 && allowedDecimalSeparators.indexOf(value[selectionStart]) !== -1) {
      var separator = decimalScale === 0 ? "" : decimalSeparator;
      return value.substr(0, selectionStart) + separator + value.substr(selectionStart + 1, value.length);
    }
    var leftBound = !!format2 ? 0 : prefix2.length;
    var rightBound = lastValue.length - (!!format2 ? 0 : suffix.length);
    if (value.length > lastValue.length || !value.length || start2 === end2 || selectionStart === 0 && selectionEnd === lastValue.length || start2 === 0 && end2 === lastValue.length || selectionStart === leftBound && selectionEnd === rightBound) {
      return value;
    }
    var deletedValues = lastValue.substr(start2, end2 - start2);
    var formatGotDeleted = !![].concat(deletedValues).find(function(deletedVal, idx) {
      return this$1$1.isCharacterAFormat(idx + start2, lastValue);
    });
    if (formatGotDeleted) {
      var deletedValuePortion = lastValue.substr(start2);
      var recordIndexOfFormatCharacters = {};
      var resolvedPortion = [];
      [].concat(deletedValuePortion).forEach(function(currentPortion, idx) {
        if (this$1$1.isCharacterAFormat(idx + start2, lastValue)) {
          recordIndexOfFormatCharacters[idx] = currentPortion;
        } else if (idx > deletedValues.length - 1) {
          resolvedPortion.push(currentPortion);
        }
      });
      Object.keys(recordIndexOfFormatCharacters).forEach(function(idx) {
        if (resolvedPortion.length > idx) {
          resolvedPortion.splice(idx, 0, recordIndexOfFormatCharacters[idx]);
        } else {
          resolvedPortion.push(recordIndexOfFormatCharacters[idx]);
        }
      });
      value = lastValue.substr(0, start2) + resolvedPortion.join("");
    }
    if (!format2) {
      var numericString = this.removeFormatting(value);
      var ref$4 = splitDecimal(numericString, allowNegative);
      var beforeDecimal = ref$4.beforeDecimal;
      var afterDecimal = ref$4.afterDecimal;
      var addNegation = ref$4.addNegation;
      var isBeforeDecimalPoint = caretPos < value.indexOf(decimalSeparator) + 1;
      if (numericString.length < lastNumStr.length && isBeforeDecimalPoint && beforeDecimal === "" && !parseFloat(afterDecimal)) {
        return addNegation ? "-" : "";
      }
    }
    return value;
  };
  NumberFormat2.prototype.updateValue = function updateValue(params) {
    var formattedValue = params.formattedValue;
    var input = params.input;
    var setCaretPosition2 = params.setCaretPosition;
    if (setCaretPosition2 === void 0)
      setCaretPosition2 = true;
    var source2 = params.source;
    var event = params.event;
    var numAsString = params.numAsString;
    var caretPos = params.caretPos;
    var ref = this.props;
    var onValueChange = ref.onValueChange;
    var ref$1 = this.state;
    var lastValue = ref$1.value;
    if (input) {
      if (caretPos === void 0 && setCaretPosition2) {
        var inputValue = params.inputValue || input.value;
        var currentCaretPosition = getCurrentCaretPosition(input);
        input.value = formattedValue;
        caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition);
      }
      input.value = formattedValue;
      if (setCaretPosition2) {
        this.setPatchedCaretPosition(input, caretPos, formattedValue);
      }
    }
    if (numAsString === void 0) {
      numAsString = this.removeFormatting(formattedValue);
    }
    if (formattedValue !== lastValue) {
      this.setState({ value: formattedValue, numAsString });
      onValueChange(this.getValueObject(formattedValue, numAsString), { event, source: source2 });
    }
  };
  NumberFormat2.prototype.onChange = function onChange2(e2) {
    var el = e2.target;
    var inputValue = el.value;
    var ref = this;
    var state = ref.state;
    var props = ref.props;
    var isAllowed = props.isAllowed;
    var lastValue = state.value || "";
    var currentCaretPosition = getCurrentCaretPosition(el);
    inputValue = this.correctInputValue(currentCaretPosition, lastValue, inputValue);
    var formattedValue = this.formatInput(inputValue) || "";
    var numAsString = this.removeFormatting(formattedValue);
    var valueObj = this.getValueObject(formattedValue, numAsString);
    var isChangeAllowed = isAllowed(valueObj);
    if (!isChangeAllowed) {
      formattedValue = lastValue;
    }
    this.updateValue({
      formattedValue,
      numAsString,
      inputValue,
      input: el,
      event: e2,
      source: "event"
    });
    if (isChangeAllowed) {
      props.onChange(e2);
    }
  };
  NumberFormat2.prototype.onBlur = function onBlur(e2) {
    var ref = this;
    var props = ref.props;
    var state = ref.state;
    var format2 = props.format;
    var onBlur2 = props.onBlur;
    var allowLeadingZeros = props.allowLeadingZeros;
    var numAsString = state.numAsString;
    var lastValue = state.value;
    this.focusedElm = null;
    clearTimeout(this.focusTimeout);
    clearTimeout(this.caretPositionTimeout);
    if (!format2) {
      if (isNaN(parseFloat(numAsString))) {
        numAsString = "";
      }
      if (!allowLeadingZeros) {
        numAsString = fixLeadingZero(numAsString);
      }
      var formattedValue = this.formatNumString(numAsString);
      if (formattedValue !== lastValue) {
        this.updateValue({
          formattedValue,
          numAsString,
          input: e2.target,
          setCaretPosition: false,
          event: e2,
          source: "event"
        });
        onBlur2(e2);
        return;
      }
    }
    onBlur2(e2);
  };
  NumberFormat2.prototype.onKeyDown = function onKeyDown(e2) {
    var el = e2.target;
    var key = e2.key;
    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    var value = el.value;
    if (value === void 0)
      value = "";
    var expectedCaretPosition;
    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix2 = ref.prefix;
    var suffix = ref.suffix;
    var format2 = ref.format;
    var onKeyDown2 = ref.onKeyDown;
    var ignoreDecimalSeparator = decimalScale !== void 0 && fixedDecimalScale;
    var numRegex = this.getNumberRegex(false, ignoreDecimalSeparator);
    var negativeRegex = new RegExp("-");
    var isPatternFormat = typeof format2 === "string";
    this.selectionBeforeInput = {
      selectionStart,
      selectionEnd
    };
    if (key === "ArrowLeft" || key === "Backspace") {
      expectedCaretPosition = selectionStart - 1;
    } else if (key === "ArrowRight") {
      expectedCaretPosition = selectionStart + 1;
    } else if (key === "Delete") {
      expectedCaretPosition = selectionStart;
    }
    if (expectedCaretPosition === void 0 || selectionStart !== selectionEnd) {
      onKeyDown2(e2);
      return;
    }
    var newCaretPosition = expectedCaretPosition;
    var leftBound = isPatternFormat ? format2.indexOf("#") : prefix2.length;
    var rightBound = isPatternFormat ? format2.lastIndexOf("#") + 1 : value.length - suffix.length;
    if (key === "ArrowLeft" || key === "ArrowRight") {
      var direction = key === "ArrowLeft" ? "left" : "right";
      newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
    } else if (key === "Delete" && !numRegex.test(value[expectedCaretPosition]) && !negativeRegex.test(value[expectedCaretPosition])) {
      while (!numRegex.test(value[newCaretPosition]) && newCaretPosition < rightBound) {
        newCaretPosition++;
      }
    } else if (key === "Backspace" && !numRegex.test(value[expectedCaretPosition])) {
      if (selectionStart <= leftBound + 1 && value[0] === "-" && typeof format2 === "undefined") {
        var newValue = value.substring(1);
        this.updateValue({
          formattedValue: newValue,
          caretPos: newCaretPosition,
          input: el,
          event: e2,
          source: "event"
        });
      } else if (!negativeRegex.test(value[expectedCaretPosition])) {
        while (!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > leftBound) {
          newCaretPosition--;
        }
        newCaretPosition = this.correctCaretPosition(value, newCaretPosition, "left");
      }
    }
    if (newCaretPosition !== expectedCaretPosition || expectedCaretPosition < leftBound || expectedCaretPosition > rightBound) {
      e2.preventDefault();
      this.setPatchedCaretPosition(el, newCaretPosition, value);
    }
    if (e2.isUnitTestRun) {
      this.setPatchedCaretPosition(el, newCaretPosition, value);
    }
    onKeyDown2(e2);
  };
  NumberFormat2.prototype.onMouseUp = function onMouseUp(e2) {
    var el = e2.target;
    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    var value = el.value;
    if (value === void 0)
      value = "";
    if (selectionStart === selectionEnd) {
      var caretPosition = this.correctCaretPosition(value, selectionStart);
      if (caretPosition !== selectionStart) {
        this.setPatchedCaretPosition(el, caretPosition, value);
      }
    }
    this.props.onMouseUp(e2);
  };
  NumberFormat2.prototype.onFocus = function onFocus2(e2) {
    var this$1$1 = this;
    e2.persist();
    this.focusedElm = e2.target;
    this.focusTimeout = setTimeout(function() {
      var el = e2.target;
      var selectionStart = el.selectionStart;
      var selectionEnd = el.selectionEnd;
      var value = el.value;
      if (value === void 0)
        value = "";
      var caretPosition = this$1$1.correctCaretPosition(value, selectionStart);
      if (caretPosition !== selectionStart && !(selectionStart === 0 && selectionEnd === value.length)) {
        this$1$1.setPatchedCaretPosition(el, caretPosition, value);
      }
      this$1$1.props.onFocus(e2);
    }, 0);
  };
  NumberFormat2.prototype.render = function render() {
    var ref = this.props;
    var type = ref.type;
    var displayType = ref.displayType;
    var customInput = ref.customInput;
    var renderText = ref.renderText;
    var getInputRef = ref.getInputRef;
    var format2 = ref.format;
    ref.thousandSeparator;
    ref.decimalSeparator;
    ref.allowedDecimalSeparators;
    ref.thousandsGroupStyle;
    ref.decimalScale;
    ref.fixedDecimalScale;
    ref.prefix;
    ref.suffix;
    ref.removeFormatting;
    ref.mask;
    ref.defaultValue;
    ref.isNumericString;
    ref.allowNegative;
    ref.allowEmptyFormatting;
    ref.allowLeadingZeros;
    ref.onValueChange;
    ref.isAllowed;
    ref.customNumerals;
    ref.onChange;
    ref.onKeyDown;
    ref.onMouseUp;
    ref.onFocus;
    ref.onBlur;
    ref.value;
    var rest = objectWithoutProperties(ref, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "thousandSeparator", "decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "decimalScale", "fixedDecimalScale", "prefix", "suffix", "removeFormatting", "mask", "defaultValue", "isNumericString", "allowNegative", "allowEmptyFormatting", "allowLeadingZeros", "onValueChange", "isAllowed", "customNumerals", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value"]);
    var otherProps = rest;
    var ref$1 = this.state;
    var value = ref$1.value;
    var mounted = ref$1.mounted;
    var inputMode = mounted && addInputMode(format2) ? "numeric" : void 0;
    var inputProps = Object.assign({ inputMode }, otherProps, {
      type,
      value,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onMouseUp: this.onMouseUp,
      onFocus: this.onFocus,
      onBlur: this.onBlur
    });
    if (displayType === "text") {
      return renderText ? renderText(value, otherProps) || null : React__default.createElement("span", Object.assign({}, otherProps, { ref: getInputRef }), value);
    } else if (customInput) {
      var CustomInput = customInput;
      return React__default.createElement(CustomInput, Object.assign({}, inputProps, { ref: getInputRef }));
    }
    return React__default.createElement("input", Object.assign({}, inputProps, { ref: getInputRef }));
  };
  return NumberFormat2;
}(React__default.Component);
NumberFormat.defaultProps = defaultProps$1;
const TextField$1 = (props, ref) => {
  const _a2 = props, {
    isError = false,
    value,
    LeftIcon,
    RightIcon,
    type = "text",
    disabled,
    maxLength,
    handleChange = () => {
    },
    format: format2,
    placeholder,
    decimal = 0,
    mask,
    prefix: prefix2,
    allowNegative = false,
    minValue,
    maxValue,
    thousandSeparator = false,
    className = "",
    inputClassName = "",
    suffix = ""
  } = _a2, rest = __objRest(_a2, [
    "isError",
    "value",
    "LeftIcon",
    "RightIcon",
    "type",
    "disabled",
    "maxLength",
    "handleChange",
    "format",
    "placeholder",
    "decimal",
    "mask",
    "prefix",
    "allowNegative",
    "minValue",
    "maxValue",
    "thousandSeparator",
    "className",
    "inputClassName",
    "suffix"
  ]);
  const defaultClass = "tw-flex tw-px-4 tw-py-3.5 tw-rounded tw-border tw-border-solid";
  const stateClass = isError ? "tw-border-Red focus-within:tw-border-Red" : "tw-border-Gray-400 focus-within:tw-border-Primary-600";
  const bgClass = disabled ? "tw-bg-Gray-200" : "tw-bg-White";
  const generatedId = `input-${nanoid()}`;
  const isAllowed = ({
    floatValue
  }) => {
    if (minValue) {
      return floatValue ? floatValue >= minValue : true;
    }
    if (maxValue) {
      return floatValue ? floatValue <= maxValue : true;
    }
    return true;
  };
  const handleSetFocus = () => {
    const input = document.getElementById(generatedId);
    if (input) {
      input.focus();
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className: `${defaultClass} ${stateClass} ${bgClass} ${className}`,
    onClick: () => handleSetFocus(),
    children: [!!LeftIcon && /* @__PURE__ */ jsx$1("div", {
      className: "tw-pr-2 tw-pl-1",
      children: LeftIcon
    }), type === "number" ? /* @__PURE__ */ jsx$1(NumberFormat, {
      id: generatedId,
      className: `tw-flex-1 tw-p-0 tw-m-0 tw-w-full tw-text-sm placeholder:tw-text-Gray-400 tw-text-Gray-800 tw-border-none focus-visible:tw-outline-none ${inputClassName}`,
      allowNegative,
      prefix: prefix2,
      decimalScale: decimal,
      mask,
      format: format2,
      placeholder,
      thousandSeparator,
      onValueChange: ({
        floatValue
      }) => handleChange(floatValue),
      disabled,
      value,
      isAllowed,
      getInputRef: ref,
      name: rest.name,
      onChange: rest.onChange,
      defaultValue: rest.defaultValue,
      suffix
    }) : /* @__PURE__ */ jsx$1("input", __spreadValues({
      maxLength,
      type,
      id: generatedId,
      value,
      className: `tw-flex-1 tw-p-0 tw-m-0 tw-w-full tw-text-sm placeholder:tw-text-Gray-400 tw-text-Gray-800 tw-border-none focus-visible:tw-outline-none ${inputClassName}`,
      disabled,
      placeholder,
      onChange: (e2) => {
        var _a3;
        return handleChange(((_a3 = e2 == null ? void 0 : e2.target) == null ? void 0 : _a3.value) || "");
      },
      ref
    }, rest)), !!RightIcon && /* @__PURE__ */ jsx$1("div", {
      className: "tw-pr-1 tw-pl-2",
      children: RightIcon
    })]
  });
};
TextField$1.displayName = "TextField";
var TextField$2 = forwardRef(TextField$1);
const FormInput = (_x) => {
  var _y = _x, {
    label,
    info,
    isOptional = false,
    error: error2,
    maxLength,
    type = "text",
    handleChange,
    placeholder,
    value
  } = _y, props = __objRest(_y, [
    "label",
    "info",
    "isOptional",
    "error",
    "maxLength",
    "type",
    "handleChange",
    "placeholder",
    "value"
  ]);
  const {
    t: t2
  } = useTranslation();
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (value && maxLength && type === "text" && typeof value === "string") {
      setCount((value == null ? void 0 : value.length) || 0);
    }
  }, [value, maxLength, type]);
  return /* @__PURE__ */ jsxs("div", {
    children: [label && /* @__PURE__ */ jsxs("div", {
      className: "tw-inline-flex tw-pb-1 tw-w-full",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "tw-inline-flex tw-w-full tw-max-w-full",
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "tw-flex tw-w-fit tw-max-w-[70%] tw-truncate",
          children: /* @__PURE__ */ jsx$1(Typography, {
            className: "tw-pr-1 tw-w-fit",
            variant: "title-9",
            color: error2 ? COLORS.Red : COLORS.Gray[600],
            children: label
          })
        }), info && /* @__PURE__ */ jsx$1(Tooltip, {
          description: /* @__PURE__ */ jsx$1("p", {
            children: info
          }),
          variant: "default",
          position: "right",
          arrow: "left-center",
          children: /* @__PURE__ */ jsx$1(Icon, {
            name: IconName.INFO,
            viewBox: "0 0 32 32",
            size: IconSize.MEDIUM,
            className: "tw-pr-1 tw-fill-Gray-400"
          })
        }), isOptional && /* @__PURE__ */ jsx$1(Typography, {
          className: "tw-pr-1",
          variant: "title-9",
          color: COLORS.Gray[500],
          children: t2("createStore.optional")
        })]
      }), maxLength && /* @__PURE__ */ jsx$1("div", {
        children: /* @__PURE__ */ jsx$1(Typography, {
          variant: "body-3",
          color: COLORS.Gray[500],
          children: `${count}/${maxLength}`
        })
      })]
    }), /* @__PURE__ */ jsx$1(TextField$2, __spreadValues({
      value,
      type,
      defaultValue: value,
      placeholder,
      handleChange: (value2) => handleChange(value2),
      isError: !isEmpty_1(error2),
      maxLength
    }, props)), error2 && /* @__PURE__ */ jsx$1(Typography, {
      className: "tw-pt-1 tw-pb-2 tw-w-full tw-text-left",
      variant: "body-3",
      color: COLORS.Red,
      children: t2(error2)
    })]
  });
};
var reactResponsive = { exports: {} };
(function(module, exports) {
  !function(root2, factory) {
    module.exports = factory(React__default);
  }(typeof self != "undefined" ? self : commonjsGlobal, function(__WEBPACK_EXTERNAL_MODULE_1__) {
    return function(modules) {
      function __webpack_require__(moduleId) {
        if (installedModules[moduleId])
          return installedModules[moduleId].exports;
        var module2 = installedModules[moduleId] = {
          i: moduleId,
          l: false,
          exports: {}
        };
        return modules[moduleId].call(module2.exports, module2, module2.exports, __webpack_require__), module2.l = true, module2.exports;
      }
      var installedModules = {};
      return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function(exports2, name, getter) {
        __webpack_require__.o(exports2, name) || Object.defineProperty(exports2, name, {
          configurable: false,
          enumerable: true,
          get: getter
        });
      }, __webpack_require__.n = function(module2) {
        var getter = module2 && module2.__esModule ? function() {
          return module2.default;
        } : function() {
          return module2;
        };
        return __webpack_require__.d(getter, "a", getter), getter;
      }, __webpack_require__.o = function(object2, property2) {
        return Object.prototype.hasOwnProperty.call(object2, property2);
      }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 8);
    }([function(module2, exports2, __webpack_require__) {
      var __importDefault = this && this.__importDefault || function(mod) {
        return mod && mod.__esModule ? mod : {
          default: mod
        };
      };
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      var react_1 = __importDefault(__webpack_require__(1)), matchmediaquery_1 = __importDefault(__webpack_require__(9)), hyphenate_style_name_1 = __importDefault(__webpack_require__(2)), shallow_equal_1 = __webpack_require__(11), toQuery_1 = __importDefault(__webpack_require__(3)), Context_1 = __importDefault(__webpack_require__(7)), makeQuery = function(settings) {
        return settings.query || (0, toQuery_1.default)(settings);
      }, hyphenateKeys = function(obj) {
        if (obj) {
          return Object.keys(obj).reduce(function(result, key) {
            return result[(0, hyphenate_style_name_1.default)(key)] = obj[key], result;
          }, {});
        }
      }, useIsUpdate = function() {
        var ref = react_1.default.useRef(false);
        return react_1.default.useEffect(function() {
          ref.current = true;
        }, []), ref.current;
      }, useDevice2 = function(deviceFromProps) {
        var deviceFromContext = react_1.default.useContext(Context_1.default), getDevice2 = function() {
          return hyphenateKeys(deviceFromProps) || hyphenateKeys(deviceFromContext);
        }, _a2 = react_1.default.useState(getDevice2), device = _a2[0], setDevice = _a2[1];
        return react_1.default.useEffect(function() {
          var newDevice = getDevice2();
          (0, shallow_equal_1.shallowEqualObjects)(device, newDevice) || setDevice(newDevice);
        }, [deviceFromProps, deviceFromContext]), device;
      }, useQuery2 = function(settings) {
        var getQuery = function() {
          return makeQuery(settings);
        }, _a2 = react_1.default.useState(getQuery), query = _a2[0], setQuery = _a2[1];
        return react_1.default.useEffect(function() {
          var newQuery = getQuery();
          query !== newQuery && setQuery(newQuery);
        }, [settings]), query;
      }, useMatchMedia = function(query, device) {
        var getMatchMedia = function() {
          return (0, matchmediaquery_1.default)(query, device || {}, !!device);
        }, _a2 = react_1.default.useState(getMatchMedia), mq = _a2[0], setMq = _a2[1], isUpdate = useIsUpdate();
        return react_1.default.useEffect(function() {
          if (isUpdate) {
            var newMq_1 = getMatchMedia();
            return setMq(newMq_1), function() {
              newMq_1 && newMq_1.dispose();
            };
          }
        }, [query, device]), mq;
      }, useMatches = function(mediaQuery) {
        var _a2 = react_1.default.useState(mediaQuery.matches), matches = _a2[0], setMatches = _a2[1];
        return react_1.default.useEffect(function() {
          var updateMatches = function() {
            setMatches(mediaQuery.matches);
          };
          return mediaQuery.addListener(updateMatches), updateMatches(), function() {
            mediaQuery.removeListener(updateMatches);
          };
        }, [mediaQuery]), matches;
      }, useMediaQuery = function(settings, device, onChange2) {
        var deviceSettings = useDevice2(device), query = useQuery2(settings);
        if (!query)
          throw new Error("Invalid or missing MediaQuery!");
        var mq = useMatchMedia(query, deviceSettings), matches = useMatches(mq), isUpdate = useIsUpdate();
        return react_1.default.useEffect(function() {
          isUpdate && onChange2 && onChange2(matches);
        }, [matches]), react_1.default.useEffect(function() {
          return function() {
            mq && mq.dispose();
          };
        }, []), matches;
      };
      exports2.default = useMediaQuery;
    }, function(module2, exports2) {
      module2.exports = __WEBPACK_EXTERNAL_MODULE_1__;
    }, function(module2, __webpack_exports__, __webpack_require__) {
      function toHyphenLower(match2) {
        return "-" + match2.toLowerCase();
      }
      function hyphenateStyleName(name) {
        if (cache2.hasOwnProperty(name))
          return cache2[name];
        var hName = name.replace(uppercasePattern, toHyphenLower);
        return cache2[name] = msPattern.test(hName) ? "-" + hName : hName;
      }
      Object.defineProperty(__webpack_exports__, "__esModule", {
        value: true
      });
      var uppercasePattern = /[A-Z]/g, msPattern = /^ms-/, cache2 = {};
      __webpack_exports__.default = hyphenateStyleName;
    }, function(module2, exports2, __webpack_require__) {
      var __importDefault = this && this.__importDefault || function(mod) {
        return mod && mod.__esModule ? mod : {
          default: mod
        };
      };
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      var hyphenate_style_name_1 = __importDefault(__webpack_require__(2)), mediaQuery_1 = __importDefault(__webpack_require__(12)), negate = function(cond) {
        return "not ".concat(cond);
      }, keyVal = function(k2, v2) {
        var realKey = (0, hyphenate_style_name_1.default)(k2);
        return typeof v2 == "number" && (v2 = "".concat(v2, "px")), v2 === true ? realKey : v2 === false ? negate(realKey) : "(".concat(realKey, ": ").concat(v2, ")");
      }, join = function(conds) {
        return conds.join(" and ");
      }, toQuery = function(obj) {
        var rules = [];
        return Object.keys(mediaQuery_1.default.all).forEach(function(k2) {
          var v2 = obj[k2];
          v2 != null && rules.push(keyVal(k2, v2));
        }), join(rules);
      };
      exports2.default = toQuery;
    }, function(module2, exports2, __webpack_require__) {
      module2.exports = __webpack_require__(14);
    }, function(module2, exports2, __webpack_require__) {
      module2.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    }, function(module2, exports2) {
      module2.exports = Function.call.bind(Object.prototype.hasOwnProperty);
    }, function(module2, exports2, __webpack_require__) {
      var __importDefault = this && this.__importDefault || function(mod) {
        return mod && mod.__esModule ? mod : {
          default: mod
        };
      };
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      var react_1 = __importDefault(__webpack_require__(1)), Context = react_1.default.createContext(void 0);
      exports2.default = Context;
    }, function(module2, exports2, __webpack_require__) {
      var __importDefault = this && this.__importDefault || function(mod) {
        return mod && mod.__esModule ? mod : {
          default: mod
        };
      };
      Object.defineProperty(exports2, "__esModule", {
        value: true
      }), exports2.Context = exports2.toQuery = exports2.useMediaQuery = exports2.default = void 0;
      var useMediaQuery_1 = __importDefault(__webpack_require__(0));
      exports2.useMediaQuery = useMediaQuery_1.default;
      var Component_1 = __importDefault(__webpack_require__(18));
      exports2.default = Component_1.default;
      var toQuery_1 = __importDefault(__webpack_require__(3));
      exports2.toQuery = toQuery_1.default;
      var Context_1 = __importDefault(__webpack_require__(7));
      exports2.Context = Context_1.default;
    }, function(module2, exports2, __webpack_require__) {
      function Mql(query, values, forceStatic) {
        function addListener(listener) {
          mql && mql.addListener(listener);
        }
        function removeListener(listener) {
          mql && mql.removeListener(listener);
        }
        function update2(evt) {
          self2.matches = evt.matches, self2.media = evt.media;
        }
        function dispose() {
          mql && mql.removeListener(update2);
        }
        var self2 = this;
        if (dynamicMatch && !forceStatic) {
          var mql = dynamicMatch.call(window, query);
          this.matches = mql.matches, this.media = mql.media, mql.addListener(update2);
        } else
          this.matches = staticMatch(query, values), this.media = query;
        this.addListener = addListener, this.removeListener = removeListener, this.dispose = dispose;
      }
      function matchMedia(query, values, forceStatic) {
        return new Mql(query, values, forceStatic);
      }
      var staticMatch = __webpack_require__(10).match, dynamicMatch = typeof window != "undefined" ? window.matchMedia : null;
      module2.exports = matchMedia;
    }, function(module2, exports2, __webpack_require__) {
      function matchQuery(mediaQuery, values) {
        return parseQuery(mediaQuery).some(function(query) {
          var inverse = query.inverse, typeMatch = query.type === "all" || values.type === query.type;
          if (typeMatch && inverse || !typeMatch && !inverse)
            return false;
          var expressionsMatch = query.expressions.every(function(expression) {
            var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
            if (!value)
              return false;
            switch (feature) {
              case "orientation":
              case "scan":
                return value.toLowerCase() === expValue.toLowerCase();
              case "width":
              case "height":
              case "device-width":
              case "device-height":
                expValue = toPx(expValue), value = toPx(value);
                break;
              case "resolution":
                expValue = toDpi(expValue), value = toDpi(value);
                break;
              case "aspect-ratio":
              case "device-aspect-ratio":
              case "device-pixel-ratio":
                expValue = toDecimal(expValue), value = toDecimal(value);
                break;
              case "grid":
              case "color":
              case "color-index":
              case "monochrome":
                expValue = parseInt(expValue, 10) || 1, value = parseInt(value, 10) || 0;
            }
            switch (modifier) {
              case "min":
                return value >= expValue;
              case "max":
                return value <= expValue;
              default:
                return value === expValue;
            }
          });
          return expressionsMatch && !inverse || !expressionsMatch && inverse;
        });
      }
      function parseQuery(mediaQuery) {
        return mediaQuery.split(",").map(function(query) {
          query = query.trim();
          var captures = query.match(RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || "", parsed = {};
          return parsed.inverse = !!modifier && modifier.toLowerCase() === "not", parsed.type = type ? type.toLowerCase() : "all", expressions = expressions.match(/\([^\)]+\)/g) || [], parsed.expressions = expressions.map(function(expression) {
            var captures2 = expression.match(RE_MQ_EXPRESSION), feature = captures2[1].toLowerCase().match(RE_MQ_FEATURE);
            return {
              modifier: feature[1],
              feature: feature[2],
              value: captures2[2]
            };
          }), parsed;
        });
      }
      function toDecimal(ratio) {
        var numbers, decimal = Number(ratio);
        return decimal || (numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/), decimal = numbers[1] / numbers[2]), decimal;
      }
      function toDpi(resolution) {
        var value = parseFloat(resolution);
        switch (String(resolution).match(RE_RESOLUTION_UNIT)[1]) {
          case "dpcm":
            return value / 2.54;
          case "dppx":
            return 96 * value;
          default:
            return value;
        }
      }
      function toPx(length2) {
        var value = parseFloat(length2);
        switch (String(length2).match(RE_LENGTH_UNIT)[1]) {
          case "em":
          case "rem":
            return 16 * value;
          case "cm":
            return 96 * value / 2.54;
          case "mm":
            return 96 * value / 2.54 / 10;
          case "in":
            return 96 * value;
          case "pt":
            return 72 * value;
          case "pc":
            return 72 * value / 12;
          default:
            return value;
        }
      }
      exports2.match = matchQuery, exports2.parse = parseQuery;
      var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
    }, function(module2, __webpack_exports__, __webpack_require__) {
      function shallowEqualObjects(objA, objB) {
        if (objA === objB)
          return true;
        if (!objA || !objB)
          return false;
        var aKeys = Object.keys(objA), bKeys = Object.keys(objB), len = aKeys.length;
        if (bKeys.length !== len)
          return false;
        for (var i2 = 0; i2 < len; i2++) {
          var key = aKeys[i2];
          if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key))
            return false;
        }
        return true;
      }
      function shallowEqualArrays(arrA, arrB) {
        if (arrA === arrB)
          return true;
        if (!arrA || !arrB)
          return false;
        var len = arrA.length;
        if (arrB.length !== len)
          return false;
        for (var i2 = 0; i2 < len; i2++)
          if (arrA[i2] !== arrB[i2])
            return false;
        return true;
      }
      Object.defineProperty(__webpack_exports__, "__esModule", {
        value: true
      }), __webpack_require__.d(__webpack_exports__, "shallowEqualArrays", function() {
        return shallowEqualArrays;
      }), __webpack_require__.d(__webpack_exports__, "shallowEqualObjects", function() {
        return shallowEqualObjects;
      });
    }, function(module2, exports2, __webpack_require__) {
      var __assign2 = this && this.__assign || function() {
        return __assign2 = Object.assign || function(t2) {
          for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
            s = arguments[i2];
            for (var p2 in s)
              Object.prototype.hasOwnProperty.call(s, p2) && (t2[p2] = s[p2]);
          }
          return t2;
        }, __assign2.apply(this, arguments);
      }, __rest = this && this.__rest || function(s, e2) {
        var t2 = {};
        for (var p2 in s)
          Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0 && (t2[p2] = s[p2]);
        if (s != null && typeof Object.getOwnPropertySymbols == "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++)
            e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]) && (t2[p2[i2]] = s[p2[i2]]);
        return t2;
      }, __importDefault = this && this.__importDefault || function(mod) {
        return mod && mod.__esModule ? mod : {
          default: mod
        };
      };
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      var prop_types_1 = __importDefault(__webpack_require__(13)), stringOrNumber = prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]), types = {
        all: prop_types_1.default.bool,
        grid: prop_types_1.default.bool,
        aural: prop_types_1.default.bool,
        braille: prop_types_1.default.bool,
        handheld: prop_types_1.default.bool,
        print: prop_types_1.default.bool,
        projection: prop_types_1.default.bool,
        screen: prop_types_1.default.bool,
        tty: prop_types_1.default.bool,
        tv: prop_types_1.default.bool,
        embossed: prop_types_1.default.bool
      }, matchers = {
        orientation: prop_types_1.default.oneOf(["portrait", "landscape"]),
        scan: prop_types_1.default.oneOf(["progressive", "interlace"]),
        aspectRatio: prop_types_1.default.string,
        deviceAspectRatio: prop_types_1.default.string,
        height: stringOrNumber,
        deviceHeight: stringOrNumber,
        width: stringOrNumber,
        deviceWidth: stringOrNumber,
        color: prop_types_1.default.bool,
        colorIndex: prop_types_1.default.bool,
        monochrome: prop_types_1.default.bool,
        resolution: stringOrNumber,
        type: Object.keys(types)
      }, featureMatchers = __rest(matchers, ["type"]), features = __assign2({
        minAspectRatio: prop_types_1.default.string,
        maxAspectRatio: prop_types_1.default.string,
        minDeviceAspectRatio: prop_types_1.default.string,
        maxDeviceAspectRatio: prop_types_1.default.string,
        minHeight: stringOrNumber,
        maxHeight: stringOrNumber,
        minDeviceHeight: stringOrNumber,
        maxDeviceHeight: stringOrNumber,
        minWidth: stringOrNumber,
        maxWidth: stringOrNumber,
        minDeviceWidth: stringOrNumber,
        maxDeviceWidth: stringOrNumber,
        minColor: prop_types_1.default.number,
        maxColor: prop_types_1.default.number,
        minColorIndex: prop_types_1.default.number,
        maxColorIndex: prop_types_1.default.number,
        minMonochrome: prop_types_1.default.number,
        maxMonochrome: prop_types_1.default.number,
        minResolution: stringOrNumber,
        maxResolution: stringOrNumber
      }, featureMatchers), all2 = __assign2(__assign2({}, types), features);
      exports2.default = {
        all: all2,
        types,
        matchers,
        features
      };
    }, function(module2, exports2, __webpack_require__) {
      var ReactIs = __webpack_require__(4);
      module2.exports = __webpack_require__(15)(ReactIs.isElement, true);
    }, function(module2, exports2, __webpack_require__) {
      !function() {
        function isValidElementType(type) {
          return typeof type == "string" || typeof type == "function" || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type == "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object2) {
          if (typeof object2 == "object" && object2 !== null) {
            var $$typeof = object2.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object2.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
        }
        function isAsyncMode(object2) {
          return hasWarnedAboutDeprecatedIsAsyncMode || (hasWarnedAboutDeprecatedIsAsyncMode = true, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), isConcurrentMode(object2) || typeOf(object2) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object2) {
          return typeOf(object2) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object2) {
          return typeOf(object2) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object2) {
          return typeOf(object2) === REACT_PROVIDER_TYPE;
        }
        function isElement2(object2) {
          return typeof object2 == "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object2) {
          return typeOf(object2) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object2) {
          return typeOf(object2) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object2) {
          return typeOf(object2) === REACT_LAZY_TYPE;
        }
        function isMemo(object2) {
          return typeOf(object2) === REACT_MEMO_TYPE;
        }
        function isPortal(object2) {
          return typeOf(object2) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object2) {
          return typeOf(object2) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object2) {
          return typeOf(object2) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object2) {
          return typeOf(object2) === REACT_SUSPENSE_TYPE;
        }
        var hasSymbol = typeof Symbol == "function" && Symbol.for, REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103, REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106, REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107, REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108, REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114, REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109, REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110, REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111, REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111, REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112, REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113, REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120, REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115, REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116, REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121, REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117, REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118, REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119, AsyncMode = REACT_ASYNC_MODE_TYPE, ConcurrentMode = REACT_CONCURRENT_MODE_TYPE, ContextConsumer = REACT_CONTEXT_TYPE, ContextProvider = REACT_PROVIDER_TYPE, Element2 = REACT_ELEMENT_TYPE, ForwardRef2 = REACT_FORWARD_REF_TYPE, Fragment2 = REACT_FRAGMENT_TYPE, Lazy = REACT_LAZY_TYPE, Memo = REACT_MEMO_TYPE, Portal = REACT_PORTAL_TYPE, Profiler = REACT_PROFILER_TYPE, StrictMode = REACT_STRICT_MODE_TYPE, Suspense = REACT_SUSPENSE_TYPE, hasWarnedAboutDeprecatedIsAsyncMode = false;
        exports2.AsyncMode = AsyncMode, exports2.ConcurrentMode = ConcurrentMode, exports2.ContextConsumer = ContextConsumer, exports2.ContextProvider = ContextProvider, exports2.Element = Element2, exports2.ForwardRef = ForwardRef2, exports2.Fragment = Fragment2, exports2.Lazy = Lazy, exports2.Memo = Memo, exports2.Portal = Portal, exports2.Profiler = Profiler, exports2.StrictMode = StrictMode, exports2.Suspense = Suspense, exports2.isAsyncMode = isAsyncMode, exports2.isConcurrentMode = isConcurrentMode, exports2.isContextConsumer = isContextConsumer, exports2.isContextProvider = isContextProvider, exports2.isElement = isElement2, exports2.isForwardRef = isForwardRef, exports2.isFragment = isFragment, exports2.isLazy = isLazy, exports2.isMemo = isMemo, exports2.isPortal = isPortal, exports2.isProfiler = isProfiler, exports2.isStrictMode = isStrictMode, exports2.isSuspense = isSuspense, exports2.isValidElementType = isValidElementType, exports2.typeOf = typeOf;
      }();
    }, function(module2, exports2, __webpack_require__) {
      function emptyFunctionThatReturnsNull() {
        return null;
      }
      var ReactIs = __webpack_require__(4), assign2 = __webpack_require__(16), ReactPropTypesSecret2 = __webpack_require__(5), has2 = __webpack_require__(6), checkPropTypes = __webpack_require__(17), printWarning = function() {
      };
      printWarning = function(text2) {
        var message = "Warning: " + text2;
        typeof console != "undefined" && console.error(message);
        try {
          throw new Error(message);
        } catch (x2) {
        }
      }, module2.exports = function(isValidElement, throwOnDirectAccess) {
        function getIteratorFn(maybeIterable) {
          var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
          if (typeof iteratorFn == "function")
            return iteratorFn;
        }
        function is2(x2, y2) {
          return x2 === y2 ? x2 !== 0 || 1 / x2 == 1 / y2 : x2 !== x2 && y2 !== y2;
        }
        function PropTypeError(message, data2) {
          this.message = message, this.data = data2 && typeof data2 == "object" ? data2 : {}, this.stack = "";
        }
        function createChainableTypeChecker(validate) {
          function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            if (componentName = componentName || ANONYMOUS, propFullName = propFullName || propName, secret !== ReactPropTypesSecret2) {
              if (throwOnDirectAccess) {
                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                throw err.name = "Invariant Violation", err;
              }
              if (typeof console != "undefined") {
                var cacheKey = componentName + ":" + propName;
                !manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3 && (printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), manualPropTypeCallCache[cacheKey] = true, manualPropTypeWarningCount++);
              }
            }
            return props[propName] == null ? isRequired ? new PropTypeError(props[propName] === null ? "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `null`." : "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `undefined`.") : null : validate(props, propName, componentName, location, propFullName);
          }
          var manualPropTypeCallCache = {}, manualPropTypeWarningCount = 0, chainedCheckType = checkType.bind(null, false);
          return chainedCheckType.isRequired = checkType.bind(null, true), chainedCheckType;
        }
        function createPrimitiveTypeChecker(expectedType) {
          function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            if (getPropType(propValue) !== expectedType)
              return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPreciseType(propValue) + "` supplied to `" + componentName + "`, expected `" + expectedType + "`.", {
                expectedType
              });
            return null;
          }
          return createChainableTypeChecker(validate);
        }
        function createArrayOfTypeChecker(typeChecker) {
          function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker != "function")
              return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
              return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected an array.");
            }
            for (var i2 = 0; i2 < propValue.length; i2++) {
              var error2 = typeChecker(propValue, i2, componentName, location, propFullName + "[" + i2 + "]", ReactPropTypesSecret2);
              if (error2 instanceof Error)
                return error2;
            }
            return null;
          }
          return createChainableTypeChecker(validate);
        }
        function createInstanceTypeChecker(expectedClass) {
          function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
              var expectedClassName = expectedClass.name || ANONYMOUS;
              return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getClassName(props[propName]) + "` supplied to `" + componentName + "`, expected instance of `" + expectedClassName + "`.");
            }
            return null;
          }
          return createChainableTypeChecker(validate);
        }
        function createEnumTypeChecker(expectedValues) {
          function validate(props, propName, componentName, location, propFullName) {
            for (var propValue = props[propName], i2 = 0; i2 < expectedValues.length; i2++)
              if (is2(propValue, expectedValues[i2]))
                return null;
            var valuesString = JSON.stringify(expectedValues, function(key, value) {
              return getPreciseType(value) === "symbol" ? String(value) : value;
            });
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` supplied to `" + componentName + "`, expected one of " + valuesString + ".");
          }
          return Array.isArray(expectedValues) ? createChainableTypeChecker(validate) : (printWarning(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), emptyFunctionThatReturnsNull);
        }
        function createObjectOfTypeChecker(typeChecker) {
          function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker != "function")
              return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
            var propValue = props[propName], propType = getPropType(propValue);
            if (propType !== "object")
              return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected an object.");
            for (var key in propValue)
              if (has2(propValue, key)) {
                var error2 = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret2);
                if (error2 instanceof Error)
                  return error2;
              }
            return null;
          }
          return createChainableTypeChecker(validate);
        }
        function createUnionTypeChecker(arrayOfTypeCheckers) {
          function validate(props, propName, componentName, location, propFullName) {
            for (var expectedTypes = [], i3 = 0; i3 < arrayOfTypeCheckers.length; i3++) {
              var checker2 = arrayOfTypeCheckers[i3], checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret2);
              if (checkerResult == null)
                return null;
              checkerResult.data && has2(checkerResult.data, "expectedType") && expectedTypes.push(checkerResult.data.expectedType);
            }
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`" + (expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "") + ".");
          }
          if (!Array.isArray(arrayOfTypeCheckers))
            return printWarning("Invalid argument supplied to oneOfType, expected an instance of array."), emptyFunctionThatReturnsNull;
          for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
            var checker = arrayOfTypeCheckers[i2];
            if (typeof checker != "function")
              return printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i2 + "."), emptyFunctionThatReturnsNull;
          }
          return createChainableTypeChecker(validate);
        }
        function invalidValidatorError(componentName, location, propFullName, key, type) {
          return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
        }
        function createShapeTypeChecker(shapeTypes) {
          function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName], propType = getPropType(propValue);
            if (propType !== "object")
              return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
            for (var key in shapeTypes) {
              var checker = shapeTypes[key];
              if (typeof checker != "function")
                return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
              var error2 = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret2);
              if (error2)
                return error2;
            }
            return null;
          }
          return createChainableTypeChecker(validate);
        }
        function createStrictShapeTypeChecker(shapeTypes) {
          function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName], propType = getPropType(propValue);
            if (propType !== "object")
              return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
            var allKeys = assign2({}, props[propName], shapeTypes);
            for (var key in allKeys) {
              var checker = shapeTypes[key];
              if (has2(shapeTypes, key) && typeof checker != "function")
                return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
              if (!checker)
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
              var error2 = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret2);
              if (error2)
                return error2;
            }
            return null;
          }
          return createChainableTypeChecker(validate);
        }
        function isNode2(propValue) {
          switch (typeof propValue) {
            case "number":
            case "string":
            case "undefined":
              return true;
            case "boolean":
              return !propValue;
            case "object":
              if (Array.isArray(propValue))
                return propValue.every(isNode2);
              if (propValue === null || isValidElement(propValue))
                return true;
              var iteratorFn = getIteratorFn(propValue);
              if (!iteratorFn)
                return false;
              var step, iterator = iteratorFn.call(propValue);
              if (iteratorFn !== propValue.entries) {
                for (; !(step = iterator.next()).done; )
                  if (!isNode2(step.value))
                    return false;
              } else
                for (; !(step = iterator.next()).done; ) {
                  var entry = step.value;
                  if (entry && !isNode2(entry[1]))
                    return false;
                }
              return true;
            default:
              return false;
          }
        }
        function isSymbol2(propType, propValue) {
          return propType === "symbol" || !!propValue && (propValue["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && propValue instanceof Symbol);
        }
        function getPropType(propValue) {
          var propType = typeof propValue;
          return Array.isArray(propValue) ? "array" : propValue instanceof RegExp ? "object" : isSymbol2(propType, propValue) ? "symbol" : propType;
        }
        function getPreciseType(propValue) {
          if (propValue === void 0 || propValue === null)
            return "" + propValue;
          var propType = getPropType(propValue);
          if (propType === "object") {
            if (propValue instanceof Date)
              return "date";
            if (propValue instanceof RegExp)
              return "regexp";
          }
          return propType;
        }
        function getPostfixForTypeWarning(value) {
          var type = getPreciseType(value);
          switch (type) {
            case "array":
            case "object":
              return "an " + type;
            case "boolean":
            case "date":
            case "regexp":
              return "a " + type;
            default:
              return type;
          }
        }
        function getClassName(propValue) {
          return propValue.constructor && propValue.constructor.name ? propValue.constructor.name : ANONYMOUS;
        }
        var ITERATOR_SYMBOL = typeof Symbol == "function" && Symbol.iterator, FAUX_ITERATOR_SYMBOL = "@@iterator", ANONYMOUS = "<<anonymous>>", ReactPropTypes = {
          array: createPrimitiveTypeChecker("array"),
          bigint: createPrimitiveTypeChecker("bigint"),
          bool: createPrimitiveTypeChecker("boolean"),
          func: createPrimitiveTypeChecker("function"),
          number: createPrimitiveTypeChecker("number"),
          object: createPrimitiveTypeChecker("object"),
          string: createPrimitiveTypeChecker("string"),
          symbol: createPrimitiveTypeChecker("symbol"),
          any: function() {
            return createChainableTypeChecker(emptyFunctionThatReturnsNull);
          }(),
          arrayOf: createArrayOfTypeChecker,
          element: function() {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];
              if (!isValidElement(propValue)) {
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement.");
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }(),
          elementType: function() {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];
              if (!ReactIs.isValidElementType(propValue)) {
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement type.");
              }
              return null;
            }
            return createChainableTypeChecker(validate);
          }(),
          instanceOf: createInstanceTypeChecker,
          node: function() {
            function validate(props, propName, componentName, location, propFullName) {
              return isNode2(props[propName]) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`, expected a ReactNode.");
            }
            return createChainableTypeChecker(validate);
          }(),
          objectOf: createObjectOfTypeChecker,
          oneOf: createEnumTypeChecker,
          oneOfType: createUnionTypeChecker,
          shape: createShapeTypeChecker,
          exact: createStrictShapeTypeChecker
        };
        return PropTypeError.prototype = Error.prototype, ReactPropTypes.checkPropTypes = checkPropTypes, ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache, ReactPropTypes.PropTypes = ReactPropTypes, ReactPropTypes;
      };
    }, function(module2, exports2, __webpack_require__) {
      function toObject2(val) {
        if (val === null || val === void 0)
          throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(val);
      }
      /*
      object-assign
      (c) Sindre Sorhus
      @license MIT
      */
      var getOwnPropertySymbols2 = Object.getOwnPropertySymbols, hasOwnProperty2 = Object.prototype.hasOwnProperty, propIsEnumerable2 = Object.prototype.propertyIsEnumerable;
      module2.exports = function() {
        try {
          if (!Object.assign)
            return false;
          var test1 = new String("abc");
          if (test1[5] = "de", Object.getOwnPropertyNames(test1)[0] === "5")
            return false;
          for (var test2 = {}, i2 = 0; i2 < 10; i2++)
            test2["_" + String.fromCharCode(i2)] = i2;
          if (Object.getOwnPropertyNames(test2).map(function(n2) {
            return test2[n2];
          }).join("") !== "0123456789")
            return false;
          var test3 = {};
          return "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
          }), Object.keys(Object.assign({}, test3)).join("") === "abcdefghijklmnopqrst";
        } catch (err) {
          return false;
        }
      }() ? Object.assign : function(target, source2) {
        for (var from2, symbols, to = toObject2(target), s = 1; s < arguments.length; s++) {
          from2 = Object(arguments[s]);
          for (var key in from2)
            hasOwnProperty2.call(from2, key) && (to[key] = from2[key]);
          if (getOwnPropertySymbols2) {
            symbols = getOwnPropertySymbols2(from2);
            for (var i2 = 0; i2 < symbols.length; i2++)
              propIsEnumerable2.call(from2, symbols[i2]) && (to[symbols[i2]] = from2[symbols[i2]]);
          }
        }
        return to;
      };
    }, function(module2, exports2, __webpack_require__) {
      function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
        for (var typeSpecName in typeSpecs)
          if (has2(typeSpecs, typeSpecName)) {
            var error2;
            try {
              if (typeof typeSpecs[typeSpecName] != "function") {
                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw err.name = "Invariant Violation", err;
              }
              error2 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret2);
            } catch (ex) {
              error2 = ex;
            }
            if (!error2 || error2 instanceof Error || printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error2 + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), error2 instanceof Error && !(error2.message in loggedTypeFailures)) {
              loggedTypeFailures[error2.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning("Failed " + location + " type: " + error2.message + (stack != null ? stack : ""));
            }
          }
      }
      var printWarning = function() {
      }, ReactPropTypesSecret2 = __webpack_require__(5), loggedTypeFailures = {}, has2 = __webpack_require__(6);
      printWarning = function(text2) {
        var message = "Warning: " + text2;
        typeof console != "undefined" && console.error(message);
        try {
          throw new Error(message);
        } catch (x2) {
        }
      }, checkPropTypes.resetWarningCache = function() {
        loggedTypeFailures = {};
      }, module2.exports = checkPropTypes;
    }, function(module2, exports2, __webpack_require__) {
      var __rest = this && this.__rest || function(s, e2) {
        var t2 = {};
        for (var p2 in s)
          Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0 && (t2[p2] = s[p2]);
        if (s != null && typeof Object.getOwnPropertySymbols == "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++)
            e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]) && (t2[p2[i2]] = s[p2[i2]]);
        return t2;
      }, __importDefault = this && this.__importDefault || function(mod) {
        return mod && mod.__esModule ? mod : {
          default: mod
        };
      };
      Object.defineProperty(exports2, "__esModule", {
        value: true
      });
      var useMediaQuery_1 = __importDefault(__webpack_require__(0)), MediaQuery = function(_a2) {
        var children2 = _a2.children, device = _a2.device, onChange2 = _a2.onChange, settings = __rest(_a2, ["children", "device", "onChange"]), matches = (0, useMediaQuery_1.default)(settings, device, onChange2);
        return typeof children2 == "function" ? children2(matches) : matches ? children2 : null;
      };
      exports2.default = MediaQuery;
    }]);
  });
})(reactResponsive);
const useScreenSize = () => {
  const isMobile = reactResponsive.exports.useMediaQuery({ maxWidth: 767 });
  const isTablet = reactResponsive.exports.useMediaQuery({ minWidth: 768, maxWidth: 1023 });
  const isDesktop = reactResponsive.exports.useMediaQuery({ minWidth: 1024 });
  const isFullScreen = reactResponsive.exports.useMediaQuery({ minWidth: 1440 });
  const isPortrait = reactResponsive.exports.useMediaQuery({ orientation: "portrait" });
  const isLandscape = reactResponsive.exports.useMediaQuery({ orientation: "landscape" });
  return {
    isMobile,
    isTablet,
    isDesktop,
    isFullScreen,
    isPortrait,
    isLandscape
  };
};
var BusinessType;
(function(BusinessType2) {
  BusinessType2["BEAUTY_AND_COSMETIC"] = "BEAUTY_AND_COSMETIC";
  BusinessType2["CLOTHES_AND_FASHION_GOODS"] = "CLOTHES_AND_FASHION_GOODS";
  BusinessType2["EDUCATION"] = "EDUCATION";
  BusinessType2["FOOD_DRINK_AND_BAKERY"] = "FOOD_DRINK_AND_BAKERY";
  BusinessType2["FURNITURE_AND_DECORATION"] = "FURNITURE_AND_DECORATION";
  BusinessType2["GENERAL_GOODS"] = "GENERAL_GOODS";
  BusinessType2["GOLD_AND_JEWELS"] = "GOLD_AND_JEWELS";
  BusinessType2["MEDIA_AND_ENTERTAINMENT"] = "MEDIA_AND_ENTERTAINMENT";
  BusinessType2["MERCHANDISE"] = "MERCHANDISE";
  BusinessType2["HEALTH_CARE_PHARMACEUTICALS_AND_BIOTECH"] = "HEALTH_CARE_PHARMACEUTICALS_AND_BIOTECH";
  BusinessType2["STATIONERY_AND_SPORT"] = "STATIONERY_AND_SPORT";
  BusinessType2["OTHER"] = "OTHER";
})(BusinessType || (BusinessType = {}));
const CreateStoreCard = ({
  createProject,
  isAllowedToCreateProject = false
}) => {
  const {
    t: t2
  } = useTranslation();
  const {
    isMobile
  } = useScreenSize();
  const [isShowDetail, setIsShowDetail] = useState(false);
  const [image, setImage] = useState();
  const [storeName, setStoreName] = useState("");
  const [businessType, setBusinessType] = useState(BusinessType.BEAUTY_AND_COSMETIC);
  const [customBusinessType, setCustomBusinessType] = useState("");
  const [refCode, setRefCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const isOtherBusinessType = businessType === BusinessType.OTHER;
  const {
    register,
    handleSubmit,
    formState: {
      errors
    },
    setValue
  } = useForm();
  const businessOptions = Object.keys(BusinessType).map((value) => {
    return {
      key: value,
      label: t2(`createStore.businessType.${value}`),
      value
    };
  });
  const optionValue = businessOptions.find(({
    value
  }) => value === businessType);
  const addStore = () => {
    setIsShowDetail(true);
  };
  const resetStoreData = () => {
    setIsShowDetail(false);
    setStoreName("");
    setImage(void 0);
    setBusinessType(BusinessType.BEAUTY_AND_COSMETIC);
    setCustomBusinessType("");
    setRefCode("");
  };
  const onSubmit = () => {
    if (isEmpty_1(errors) && isAllowedToCreateProject) {
      setIsLoading(true);
      createProject({
        projectName: storeName.trim() || "",
        businessType,
        customBusinessType,
        refCode,
        image: image == null ? void 0 : image.currentImage
      });
      resetStoreData();
      setIsLoading(false);
    }
  };
  const handleSetStoreName = (value) => {
    setValue("storeName", value);
    setStoreName(value);
  };
  const handleSetCustomBusinessType = (value) => {
    setValue("customBusinessType", value);
    setCustomBusinessType(value);
  };
  useEffect(() => {
    register("storeName", {
      required: true
    });
    register("customBusinessType", {
      required: isOtherBusinessType
    });
  }, [isOtherBusinessType, register]);
  const getShowImage = () => {
    if (isShowDetail && image) {
      return /* @__PURE__ */ jsx$1("img", {
        id: "storeImage",
        alt: "store",
        src: image == null ? void 0 : image.showImage,
        className: "tw-object-cover tw-w-32 tw-h-32 tw-rounded-full"
      });
    }
    return /* @__PURE__ */ jsx$1("div", {
      className: "tw-box-border tw-flex tw-justify-center tw-items-center tw-w-32 tw-h-32 tw-rounded-full tw-border-2 tw-border-Gray-300 tw-border-dashed",
      children: /* @__PURE__ */ jsx$1(Icon, {
        className: "tw-fill-Gray-400",
        name: IconName.STORE,
        size: IconSize.EXTRA_LARGE,
        viewBox: "-10 0 48 24"
      })
    });
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs(Card, {
      className: "tw-box-border tw-items-center tw-mb-6 tw-w-full tw-h-fit tw-text-center tw-bg-White",
      shadowSize: ElevationShadowType.LARGE,
      contentSize: ContentSize.MEDIUM_2,
      children: [/* @__PURE__ */ jsx$1("div", {
        className: isShowDetail ? "tw-flex tw-justify-center tw-pb-2" : "tw-flex tw-justify-center tw-pb-4",
        children: getShowImage()
      }), isShowDetail ? /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "tw-pb-2 tw-w-full",
          children: /* @__PURE__ */ jsx$1(FormInput, {
            value: storeName,
            label: t2("createStore.detail.storeName.label"),
            placeholder: t2("createStore.detail.storeName.placeholder"),
            name: "storeName",
            error: (errors == null ? void 0 : errors.storeName) && t2("createStore.detail.storeName.error"),
            handleChange: handleSetStoreName
          })
        }), /* @__PURE__ */ jsx$1("div", {
          className: "tw-pb-2 tw-w-full tw-text-left",
          children: /* @__PURE__ */ jsx$1(FormDropdown, {
            value: optionValue,
            className: "tw-justify-start",
            label: t2("createStore.detail.businessType.label"),
            placeholder: t2("createStore.detail.businessType.placeholder"),
            options: businessOptions,
            handleChange: setBusinessType
          })
        }), isOtherBusinessType && /* @__PURE__ */ jsx$1("div", {
          className: "tw-pb-2 tw-w-full tw-text-left",
          children: /* @__PURE__ */ jsx$1(FormInput, {
            value: customBusinessType,
            handleChange: handleSetCustomBusinessType,
            name: "customBusinessType",
            error: (errors == null ? void 0 : errors.customBusinessType) && t2("createStore.detail.customBusinessType.error")
          })
        }), /* @__PURE__ */ jsx$1("div", {
          className: "tw-pb-8 tw-w-full",
          children: /* @__PURE__ */ jsx$1(FormInput, {
            value: refCode,
            label: t2("createStore.detail.refCode.label"),
            isOptional: true,
            placeholder: t2("createStore.detail.refCode.placeholder"),
            handleChange: setRefCode
          })
        })]
      }) : /* @__PURE__ */ jsx$1("div", {
        className: "tw-flex tw-justify-center tw-pb-4",
        children: /* @__PURE__ */ jsx$1(Typography, {
          variant: "title-6",
          color: COLORS.Gray[400],
          children: t2("createStore.detail.createStore.label")
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: isShowDetail ? "tw-grid tw-grid-cols-2 tw-gap-2" : "",
        children: [isShowDetail && /* @__PURE__ */ jsx$1(Button, {
          className: "tw-w-full tw-min-w-full hover:tw-bg-White tw-border-none tw-cursor-pointer",
          variant: "text",
          onClick: resetStoreData,
          children: /* @__PURE__ */ jsx$1(Typography, {
            className: "tw-truncate",
            variant: "title-6",
            color: COLORS.Primary[600],
            children: isShowDetail ? t2("createStore.detail.cancel") : t2("createStore.detail.add")
          })
        }), /* @__PURE__ */ jsx$1(Button, {
          className: `tw-truncate tw-cursor-pointer tw-min-w-full tw-w-full tw-border-none ${isShowDetail ? "tw-bg-Primary-600 hover:tw-bg-Primary-600" : "tw-bg-Gray-200 hover:tw-bg-Gray-200"}`,
          disabled: isLoading,
          onClick: isShowDetail ? handleSubmit(onSubmit) : addStore,
          children: /* @__PURE__ */ jsx$1(Typography, {
            className: "tw-truncate",
            variant: "title-6",
            color: isShowDetail ? COLORS.White : COLORS.Gray[800],
            children: isShowDetail ? t2("createStore.detail.createStore.button") : t2("createStore.detail.add")
          })
        })]
      })]
    }), isMobile && /* @__PURE__ */ jsx$1(Modal, {
      className: "tw-bg-Gray-100 mobile:tw-block tablet:tw-hidden desktop:tw-hidden fullScreen:tw-hidden",
      isOpen: isShowDetail,
      onClose: resetStoreData,
      children: /* @__PURE__ */ jsx$1("div", {
        className: "tw-relative tw-h-full",
        children: /* @__PURE__ */ jsxs("div", {
          className: "tw-overflow-y-scroll tw-px-4 tw-h-full create-store-body",
          children: [/* @__PURE__ */ jsx$1(Typography, {
            className: "tw-py-6",
            variant: "title-9",
            children: t2("createStore.detail.createStore.label")
          }), /* @__PURE__ */ jsx$1("div", {
            className: isShowDetail ? "tw-flex tw-justify-center tw-pb-2" : "tw-flex tw-justify-center tw-pb-4",
            children: getShowImage()
          }), /* @__PURE__ */ jsxs("div", {
            className: "tw-relative tw-h-fit",
            children: [/* @__PURE__ */ jsx$1("div", {
              className: "tw-relative tw-pt-4 tw-pb-2 tw-w-full",
              children: /* @__PURE__ */ jsx$1(FormInput, {
                value: storeName,
                label: t2("createStore.detail.storeName.label"),
                placeholder: t2("createStore.detail.storeName.placeholder"),
                name: "storeName",
                error: (errors == null ? void 0 : errors.storeName) && t2("createStore.detail.storeName.error"),
                handleChange: handleSetStoreName
              })
            }), /* @__PURE__ */ jsx$1("div", {
              className: "tw-pb-2 tw-w-full tw-text-left",
              children: /* @__PURE__ */ jsx$1(FormDropdown, {
                value: optionValue,
                className: "tw-justify-start",
                label: t2("createStore.detail.businessType.label"),
                placeholder: t2("createStore.detail.businessType.placeholder"),
                options: businessOptions,
                handleChange: setBusinessType
              })
            }), isOtherBusinessType && /* @__PURE__ */ jsx$1("div", {
              className: "tw-pb-2 tw-w-full tw-text-left",
              children: /* @__PURE__ */ jsx$1(FormInput, {
                value: customBusinessType,
                handleChange: handleSetCustomBusinessType,
                name: "customBusinessType",
                error: (errors == null ? void 0 : errors.customBusinessType) && t2("createStore.detail.customBusinessType.error")
              })
            }), /* @__PURE__ */ jsx$1("div", {
              className: "tw-pb-8 tw-w-full",
              children: /* @__PURE__ */ jsx$1(FormInput, {
                value: refCode,
                label: t2("createStore.detail.refCode.label"),
                isOptional: true,
                placeholder: t2("createStore.detail.refCode.placeholder"),
                handleChange: setRefCode
              })
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: "tw-box-border tw-grid tw-grid-cols-2 tw-gap-2 tw-w-full",
            children: [/* @__PURE__ */ jsx$1(Button, {
              className: "tw-w-full tw-min-w-full tw-bg-Gray-100 tw-border-none tw-cursor-pointer",
              variant: "text",
              onClick: resetStoreData,
              children: /* @__PURE__ */ jsx$1(Typography, {
                className: "tw-truncate",
                variant: "title-6",
                color: COLORS.Primary[600],
                children: t2("createStore.detail.cancel")
              })
            }), /* @__PURE__ */ jsx$1(Button, {
              className: `tw-truncate tw-cursor-pointer tw-min-w-full tw-w-full tw-border-none ${isShowDetail ? "tw-bg-Primary-600 hover:tw-bg-Primary-600" : "tw-bg-Gray-200 hover:tw-bg-Gray-200"}`,
              disabled: isLoading,
              onClick: isShowDetail ? handleSubmit(onSubmit) : addStore,
              children: /* @__PURE__ */ jsx$1(Typography, {
                className: "tw-truncate",
                variant: "title-6",
                color: isShowDetail ? COLORS.White : COLORS.Gray[800],
                children: isShowDetail ? t2("createStore.detail.createStore.button") : t2("createStore.detail.add")
              })
            })]
          })]
        })
      })
    }), /* @__PURE__ */ jsx$1(LoadingPopup$1, {
      isOpen: isLoading
    })]
  });
};
function CardCreateStoreNFTContent({
  isShowForm,
  onClickAddStore
}) {
  const {
    t: t2
  } = useTranslation();
  if (isShowForm) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx$1("div", {
      className: "tw-flex tw-justify-center tw-pt-[52px] tw-pb-3",
      children: /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-truncate",
        variant: "title-8",
        children: t2("createStore.detail.createStore.label")
      })
    }), /* @__PURE__ */ jsx$1(Button, {
      className: "tw-w-full tw-min-w-full tw-text-base tw-font-medium tw-text-Gray-800 group-hover:tw-text-White tw-truncate tw-bg-NFTAliceBlue group-hover:tw-bg-NFTBrandeisBlue tw-border-none tw-cursor-pointer",
      size: "large",
      variant: "custom",
      onClick: onClickAddStore,
      children: t2("createStore.detail.add")
    })]
  });
}
const customStyles$1 = {
  control(provided, state) {
    return __spreadProps(__spreadValues({}, provided), {
      backgroundColor: "#FFFFFF",
      borderColor: state.isFocused ? "#0076FF" : "#B6BAC8",
      minHeight: 48,
      "&:hover": {
        borderColor: "#B6BAC8"
      }
    });
  },
  dropdownIndicator(provided, state) {
    return __spreadProps(__spreadValues({}, provided), {
      color: state.isFocused ? "#0076FF" : "#B6BAC8",
      "&:hover": {
        color: "#B6BAC8"
      }
    });
  },
  indicatorSeparator(provided) {
    return __spreadProps(__spreadValues({}, provided), {
      width: 0
    });
  },
  option(provided, state) {
    return __spreadProps(__spreadValues({}, provided), {
      backgroundColor: state.isSelected ? "#0076FF" : "#FFFFFF",
      color: state.isSelected ? "#FBFCFE" : "#121419",
      paddingTop: 14,
      paddingRight: 18,
      paddingBottom: 14,
      paddingLeft: 18,
      "&:active": {
        backgroundColor: "#0076FF",
        color: "#FBFCFE"
      }
    });
  },
  singleValue(provided) {
    return __spreadProps(__spreadValues({}, provided), {
      color: "#121419"
    });
  },
  valueContainer(provided) {
    return __spreadProps(__spreadValues({}, provided), {
      paddingTop: "0.875rem",
      paddingRight: "1rem",
      paddingBottom: "0.875rem",
      paddingLeft: "1rem"
    });
  }
};
function CardCreateStoreNFTForm({
  isMobile,
  isShowForm,
  onClickCancel,
  onCreateProject
}) {
  const {
    t: t2
  } = useTranslation();
  const businessOptions = Object.keys(BusinessType).map((value) => {
    return {
      label: t2(`createStore.businessType.${value}`),
      value
    };
  });
  const defaultValues = {
    businessType: businessOptions[0],
    customBusinessType: "",
    projectName: "",
    refCode: ""
  };
  const [isLoading, setIsLoading] = useState(false);
  const [isOtherBusinessType, setIsOtherBusinessType] = useState(false);
  const {
    control,
    formState: {
      errors
    },
    handleSubmit,
    register,
    reset
  } = useForm({
    defaultValues
  });
  const selectedBusinessType = useWatch({
    control,
    name: "businessType"
  });
  useEffect(() => {
    setIsOtherBusinessType(selectedBusinessType.value === BusinessType.OTHER);
  }, [selectedBusinessType]);
  const submit = (data2) => {
    setIsLoading(true);
    const {
      businessType,
      customBusinessType,
      projectName,
      refCode
    } = data2;
    onCreateProject({
      businessType: businessType.value,
      customBusinessType,
      projectName,
      refCode
    });
    reset(__spreadValues({}, defaultValues));
    setIsLoading(false);
  };
  const handleClickCancel = () => {
    reset(__spreadValues({}, defaultValues));
    setIsLoading(false);
    onClickCancel();
  };
  if (!isShowForm) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("form", {
      className: isMobile ? "tw-flex tw-flex-col tw-flex-1 tw-h-full tw-pt-6 tw-pb-11" : "tw-mt-[52px]",
      onSubmit: handleSubmit(submit),
      children: [/* @__PURE__ */ jsxs("div", {
        className: "tw-mb-1 tw-min-h-[92px] tablet:tw-mb-2",
        children: [/* @__PURE__ */ jsx$1("label", {
          className: classNames$1("tw-block tw-mb-1 tw-text-sm tw-font-medium tw-text-left", {
            "tw-text-Gray-600": isMobile
          }),
          htmlFor: "projectName",
          children: t2("createStore.detail.storeName.label")
        }), /* @__PURE__ */ jsx$1("input", __spreadValues({
          type: "text",
          id: "projectName",
          className: classNames$1("tw-block tw-border tw-rounded tw-py-[14px] tw-px-4 tw-w-full tw-text-Gray-800", {
            "tw-border-Gray-400 focus-visible:tw-outline-NFTBrandeisBlue": !(errors == null ? void 0 : errors.projectName),
            "tw-border-Red focus-visible:tw-outline-Red": errors == null ? void 0 : errors.projectName
          }),
          placeholder: t2("createStore.detail.storeName.placeholder")
        }, register("projectName", {
          required: true
        }))), (errors == null ? void 0 : errors.projectName) && /* @__PURE__ */ jsx$1("small", {
          className: "tw-block tw-mt-1 tw-text-xs tw-font-normal tw-text-left tw-text-Red",
          children: t2("createStore.detail.storeName.error")
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: isOtherBusinessType ? "tw-mb-1" : isMobile ? "tw-mb-6" : "tw-mb-7",
        children: [/* @__PURE__ */ jsx$1("label", {
          className: classNames$1("tw-block tw-mb-1 tw-text-sm tw-font-medium tw-text-left", {
            "tw-text-Gray-600": isMobile
          }),
          htmlFor: "businessType",
          children: t2("createStore.detail.businessType.label")
        }), /* @__PURE__ */ jsx$1(Controller, {
          name: "businessType",
          control,
          render: ({
            field
          }) => /* @__PURE__ */ jsx$1(ReactSelect, __spreadProps(__spreadValues({}, field), {
            id: "businessType",
            placeholder: t2("createStore.detail.businessType.placeholder"),
            classNamePrefix: "nft-react-select",
            options: businessOptions,
            styles: customStyles$1,
            isClearable: false,
            isSearchable: false
          }))
        })]
      }), isOtherBusinessType && /* @__PURE__ */ jsxs("div", {
        className: `tw-relative tw-min-h-[68px] ${isMobile ? "tw-mb-1" : "tw-mb-2"}`,
        children: [/* @__PURE__ */ jsx$1("label", {
          htmlFor: "customBusinessType",
          className: "tw-sr-only",
          children: t2("createStore.nft.createStoreForm.customBusinessTypeLabel")
        }), /* @__PURE__ */ jsx$1("input", __spreadValues({
          type: "text",
          id: "customBusinessType",
          className: classNames$1("tw-block tw-border tw-rounded tw-py-[14px] tw-px-4 tw-w-full tw-text-Gray-800", {
            "tw-border-Gray-400 focus-visible:tw-outline-NFTBrandeisBlue": !(errors == null ? void 0 : errors.customBusinessType),
            "tw-border-Red focus-visible:tw-outline-Red": errors == null ? void 0 : errors.customBusinessType
          })
        }, register("customBusinessType", {
          required: isOtherBusinessType
        }))), (errors == null ? void 0 : errors.customBusinessType) && /* @__PURE__ */ jsx$1("small", {
          className: "tw-block tw-mt-1 tw-text-xs tw-font-normal tw-text-left tw-text-Red",
          children: t2("createStore.detail.customBusinessType.error")
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: isMobile ? "tw-hidden tw-mb-6" : "tw-hidden tw-mb-9",
        children: [/* @__PURE__ */ jsxs("label", {
          className: classNames$1("tw-block tw-mb-1 tw-text-sm tw-font-medium tw-text-left", {
            "tw-text-Gray-600": isMobile
          }),
          htmlFor: "refCode",
          children: [t2("createStore.detail.refCode.label"), " ", t2("createStore.optional")]
        }), /* @__PURE__ */ jsx$1("input", __spreadValues({
          type: "text",
          id: "refCode",
          className: "tw-block tw-py-[14px] tw-px-4 tw-w-full tw-text-Gray-800 tw-rounded tw-border tw-border-Gray-400 focus-visible:tw-outline-NFTBrandeisBlue",
          placeholder: t2("createStore.detail.refCode.placeholder")
        }, register("refCode")))]
      }), /* @__PURE__ */ jsxs("div", {
        className: classNames$1("tw-flex tw-justify-between", {
          "tw-mt-auto": isMobile
        }),
        children: [/* @__PURE__ */ jsx$1(Button, {
          type: "button",
          className: "tw-flex-1 tw-py-3 tw-px-6 tw-mr-1 tw-truncate hover:tw-bg-Transparent tw-border-none tablet:tw-min-w-fit",
          variant: "text",
          onClick: handleClickCancel,
          children: t2("createStore.detail.cancel")
        }), /* @__PURE__ */ jsx$1(Button, {
          type: "submit",
          className: "tw-flex-1 tw-py-3 tw-px-6 tw-ml-1 tw-truncate tablet:tw-min-w-fit",
          disabled: isLoading,
          children: t2("createStore.detail.createStore.button")
        })]
      })]
    }), /* @__PURE__ */ jsx$1(LoadingPopup$1, {
      isOpen: isLoading
    })]
  });
}
function CardCreateStoreNFTHeader({
  isMobile,
  isShowForm
}) {
  const {
    t: t2
  } = useTranslation();
  if (!(isMobile && isShowForm)) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "tw-mt-9 tw-mb-6",
    children: [/* @__PURE__ */ jsx$1(Typography, {
      className: "tw-mb-2",
      color: COLORS.Gray[800],
      variant: "title-6",
      children: t2("createStore.detail.title2")
    }), /* @__PURE__ */ jsxs(Typography, {
      color: COLORS.Gray[500],
      variant: "title-8",
      children: [t2("createStore.detail.title2"), /* @__PURE__ */ jsx$1("span", {
        className: "tw-text-NFTFrenchSkyBlue",
        children: t2("createStore.detail.notHasStoreTitle.label")
      })]
    })]
  });
}
function CardCreateStoreNFTImage({
  image,
  isMobile,
  isShowForm
}) {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx$1("div", {
    className: classNames$1("tw-flex tw-justify-center tw-items-center tw-w-full tw-pb-0", {
      "tw-absolute tw-top-0 tw-left-0 tw-mt-[-61px]": !(isMobile && isShowForm),
      "tw-static tw-top-auto tw-left-auto tw-mt-0": isMobile && isShowForm
    }),
    children: isShowForm ? image ? /* @__PURE__ */ jsx$1("img", {
      alt: "store",
      className: "tw-object-cover tw-w-[122px] tw-h-[122px] tw-rounded-full",
      src: image
    }) : /* @__PURE__ */ jsx$1("div", {
      className: "tw-flex tw-justify-center tw-items-center tw-w-[122px] tw-h-[122px] tw-bg-NFTBrandeisBlue tw-rounded-full",
      children: /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-truncate",
        variant: "heading-4",
        color: COLORS.White,
        children: t2("N/A")
      })
    }) : /* @__PURE__ */ jsx$1("div", {
      className: "tw-flex tw-justify-center tw-items-center tw-w-[122px] tw-h-[122px] tw-bg-NFTAntiFlashWhite tw-rounded-full",
      children: /* @__PURE__ */ jsx$1(Icon, {
        className: "tw-w-[66px] tw-h-[66px] tw-fill-NFTMetallicSilver",
        name: IconName.STORE_NFT
      })
    })
  });
}
function CardCreateStoreNFT({
  onCreateProject
}) {
  const {
    isMobile
  } = useScreenSize();
  const [isShowForm, setIsShowForm] = useState(false);
  const handleClickAddStore = () => setIsShowForm(true);
  const handleClickCancel = () => setIsShowForm(false);
  return /* @__PURE__ */ jsx$1("div", {
    className: classNames$1("tw-box-border tw-px-2 tw-w-full tw-max-w-xs desktop:tw-p-2", {
      "tw-fixed tw-top-0 tw-left-0 tw-flex tw-px-0 tw-w-full tw-max-w-none tw-h-full tw-overflow-y-auto tw-bg-NFTGhostWhite": isMobile && isShowForm
    }),
    children: /* @__PURE__ */ jsxs(Card, {
      className: classNames$1("tw-relative tw-mt-[61px] tw-rounded-md tw-box-border tw-w-full tw-bg-White tw-group tablet:tw-rounded-md desktop:tw-rounded-md", {
        "hover:tw-border-Transparent hover:tw-bg-White": isShowForm,
        "hover:tw-border-NFTBrandeisBlue hover:tw-bg-NFTAliceBlue": !isShowForm,
        "tw-mb-6 tw-h-fit": !(isMobile && isShowForm),
        "tw-flex tw-flex-col tw-mt-0 tw-mb-0 tw-border-none tw-flex-1 tw-overflow-y-scroll tw-bg-NFTGhostWhite": isMobile && isShowForm
      }),
      contentSize: isMobile && isShowForm ? ContentSize.HORIZONTAL_2 : ContentSize.LARGE_4,
      shadowSize: isMobile && isShowForm ? ElevationShadowType.NONE : ElevationShadowType.EXTRA,
      children: [/* @__PURE__ */ jsx$1(CardCreateStoreNFTHeader, {
        isMobile,
        isShowForm
      }), /* @__PURE__ */ jsx$1(CardCreateStoreNFTImage, {
        isMobile,
        isShowForm
      }), /* @__PURE__ */ jsx$1(CardCreateStoreNFTContent, {
        isShowForm,
        onClickAddStore: handleClickAddStore
      }), /* @__PURE__ */ jsx$1(CardCreateStoreNFTForm, {
        isMobile,
        isShowForm,
        onClickCancel: handleClickCancel,
        onCreateProject
      })]
    })
  });
}
const customStyles = {
  control(provided, state) {
    return __spreadProps(__spreadValues({}, provided), {
      backgroundColor: "transparent",
      border: state.isFocused ? 0 : 0,
      borderBottomStyle: "solid",
      borderBottomWidth: "1px",
      borderBottomColor: "#0076FF",
      borderRadius: 0,
      boxShadow: state.isFocused ? "none" : "none",
      cursor: "pointer",
      userSelect: "none"
    });
  },
  dropdownIndicator(provided) {
    return __spreadProps(__spreadValues({}, provided), {
      color: "#0076FF",
      "&:hover": {
        color: "#0076FF"
      }
    });
  },
  indicatorSeparator(provided) {
    return __spreadProps(__spreadValues({}, provided), {
      width: 0
    });
  },
  menu(provided) {
    return __spreadProps(__spreadValues({}, provided), {
      borderRadius: "5px",
      marginTop: "1.75rem",
      "&:hover": {
        cursor: "pointer"
      }
    });
  },
  menuList(provided) {
    return __spreadProps(__spreadValues({}, provided), {
      border: "0.5px solid #E6EBF3",
      boxShadow: "0px 5px 10px rgba(20, 25, 49, 0.0776606)",
      paddingTop: "0.5rem",
      paddingBottom: "0.5rem"
    });
  },
  option(provided, state) {
    return __spreadProps(__spreadValues({}, provided), {
      backgroundColor: state.isSelected ? "#0076FF" : "#FFFFFF",
      color: state.isSelected ? "#FBFCFE" : "#121419",
      padding: "1rem 0.875rem",
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: 1.43,
      "&:active": {
        backgroundColor: "#0076FF",
        color: "#FBFCFE"
      },
      "&:hover": {
        cursor: "pointer"
      }
    });
  },
  singleValue(provided) {
    return __spreadProps(__spreadValues({}, provided), {
      color: "#121419",
      fontSize: "2rem",
      fontWeight: "500",
      lineHeight: 1.5,
      "@media only screen and (min-width: 768px)": {
        fontSize: "2.5rem",
        lineHeight: 1.6
      }
    });
  },
  valueContainer(provided) {
    return __spreadProps(__spreadValues({}, provided), {
      paddingTop: "0.5rem",
      paddingRight: 0,
      paddingBottom: "0.5rem",
      paddingLeft: 0
    });
  }
};
var CreateStoreStep;
(function(CreateStoreStep2) {
  CreateStoreStep2["Step1"] = "Step1";
  CreateStoreStep2["Step2"] = "Step2";
})(CreateStoreStep || (CreateStoreStep = {}));
function FormCreateStore({
  onCreateProject
}) {
  const {
    t: t2
  } = useTranslation();
  const businessOptions = Object.keys(BusinessType).map((value) => {
    return {
      label: t2(`createStore.businessType.${value}`),
      value
    };
  });
  const [step, setStep] = useState(CreateStoreStep.Step1);
  const [isFirstStep, setIsFirstStep] = useState(step === CreateStoreStep.Step1);
  const [isOtherBusinessType, setIsOtherBusinessType] = useState(false);
  const {
    control,
    formState: {
      errors
    },
    handleSubmit,
    register
  } = useForm({
    defaultValues: {
      businessType: businessOptions[0],
      customBusinessType: "",
      projectName: "",
      refCode: ""
    }
  });
  const selectedBusinessType = useWatch({
    control,
    name: "businessType"
  });
  useEffect(() => {
    setIsFirstStep(step === CreateStoreStep.Step1);
  }, [step]);
  useEffect(() => {
    setIsOtherBusinessType(selectedBusinessType.value === BusinessType.OTHER);
  }, [selectedBusinessType]);
  const submit = (data2) => {
    if (isFirstStep) {
      setStep(CreateStoreStep.Step2);
      return;
    }
    const {
      businessType,
      customBusinessType,
      projectName,
      refCode
    } = data2;
    onCreateProject({
      businessType: businessType.value,
      customBusinessType,
      projectName,
      refCode
    });
  };
  return /* @__PURE__ */ jsxs("form", {
    className: "tw-flex tw-flex-col tw-w-full",
    onSubmit: handleSubmit(submit),
    children: [isFirstStep ? /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-flex-col tw-flex-1",
      children: [/* @__PURE__ */ jsx$1("label", {
        htmlFor: "projectName",
        className: "tw-mb-1 tw-text-2xl tw-font-medium tw-text-NFTMetallicSilver",
        children: t2("createStore.detail.storeName.label")
      }), /* @__PURE__ */ jsx$1("input", __spreadValues({
        type: "text",
        id: "projectName",
        className: classNames$1("tw-border-b tw-border-solid tw-border-NFTBrandeisBlue tw-py-2 tw-text-Gray-800 tw-text-[32px] tw-font-semibold tw-leading-[48px] tw-bg-Transparent focus-within:tw-outline-none tablet:tw-text-[40px] tablet:tw-font-medium tablet:tw-leading-[64px]", {
          "tw-border-NFTPastelRed": errors.projectName
        })
      }, register("projectName", {
        required: true
      }))), errors.projectName && /* @__PURE__ */ jsx$1("small", {
        className: "tw-mt-[10px] tw-text-base tw-font-normal tw-text-NFTPastelRed",
        children: t2("createStore.detail.storeName.error")
      })]
    }) : /* @__PURE__ */ jsxs("div", {
      className: "tw-flex-1",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-flex-col tw-mb-5 tablet:tw-mb-[30px]",
        children: [/* @__PURE__ */ jsx$1("label", {
          htmlFor: "businessType",
          className: "tw-mb-1 tw-text-2xl tw-font-medium tw-text-NFTMetallicSilver",
          children: t2("createStore.detail.businessType.label")
        }), /* @__PURE__ */ jsx$1(Controller, {
          name: "businessType",
          control,
          render: ({
            field
          }) => /* @__PURE__ */ jsx$1(ReactSelect, __spreadProps(__spreadValues({}, field), {
            id: "businessType",
            placeholder: t2("createStore.detail.businessType.placeholder"),
            classNamePrefix: "nft-react-select",
            styles: customStyles,
            options: businessOptions,
            isClearable: false,
            isSearchable: false
          }))
        })]
      }), isOtherBusinessType && /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-relative tw-flex-col tw-mb-5 tablet:tw-mb-[30px]",
        children: [/* @__PURE__ */ jsx$1("label", {
          htmlFor: "customBusinessType",
          className: "tw-mb-1 tw-text-2xl tw-font-medium tw-text-NFTMetallicSilver",
          children: t2("createStore.nft.createStoreForm.customBusinessTypeLabel")
        }), /* @__PURE__ */ jsx$1("input", __spreadValues({
          type: "text",
          id: "customBusinessType",
          className: classNames$1("tw-border-b tw-border-solid tw-border-NFTBrandeisBlue tw-py-2 tw-text-Gray-800 tw-text-[32px] tw-font-semibold tw-leading-[48px] tw-bg-Transparent focus-within:tw-outline-none tablet:tw-text-[40px] tablet:tw-font-medium tablet:tw-leading-[64px]", {
            "tw-border-NFTPastelRed": errors.customBusinessType
          })
        }, register("customBusinessType", {
          required: isOtherBusinessType
        }))), errors.customBusinessType && /* @__PURE__ */ jsx$1("small", {
          className: "tw-mt-[10px] tw-text-base tw-font-normal tw-text-NFTPastelRed",
          children: t2("createStore.detail.customBusinessType.error")
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-hidden tw-flex-col",
        children: [/* @__PURE__ */ jsxs("label", {
          htmlFor: "refCode",
          className: "tw-mb-1 tw-text-2xl tw-font-medium tw-text-NFTMetallicSilver",
          children: [t2("createStore.detail.refCode.label"), " ", t2("createStore.optional")]
        }), /* @__PURE__ */ jsx$1("input", __spreadValues({
          type: "text",
          id: "refCode",
          className: "tw-py-2 tw-text-[32px] tw-font-semibold tw-leading-[48px] tw-text-Gray-800 tw-bg-Transparent tw-border-b tw-border-NFTBrandeisBlue tw-border-solid focus-within:tw-outline-none tablet:tw-text-[40px] tablet:tw-font-medium tablet:tw-leading-[64px]"
        }, register("refCode")))]
      })]
    }), /* @__PURE__ */ jsx$1("div", {
      className: "tw-font-medium tw-leading-6 tablet:tw-self-end tablet:tw-pb-10 desktop:tw-pb-0",
      children: /* @__PURE__ */ jsx$1(Button, {
        type: "submit",
        className: "tw-w-full tw-capitalize tablet:tw-w-auto",
        size: "large",
        children: t2("common.action.next")
      })
    })]
  });
}
function CreateStoreDetailForm({
  isAllowedToCreateProject = false,
  isEmptyStore = false,
  isNFTMode = false,
  createProject
}) {
  if (!isAllowedToCreateProject) {
    return null;
  }
  if (isNFTMode) {
    return isEmptyStore ? /* @__PURE__ */ jsx$1(FormCreateStore, {
      onCreateProject: createProject
    }) : /* @__PURE__ */ jsx$1(CardCreateStoreNFT, {
      onCreateProject: createProject
    });
  }
  return /* @__PURE__ */ jsx$1("div", {
    className: "tw-box-border tw-px-2 tw-w-full tw-max-w-xs desktop:tw-p-2",
    children: /* @__PURE__ */ jsx$1(CreateStoreCard, {
      isAllowedToCreateProject,
      createProject
    })
  });
}
function CreateStoreDetailHeader({
  isEmptyStore = false,
  isNFTMode = false
}) {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs("div", {
    className: classNames$1("tw-pb-5 tablet:tw-pb-10 desktop:tw-pb-16", {
      "tw-pb-6 tablet:tw-pb-16 desktop:tw-pb-[72px]": isNFTMode && !isEmptyStore,
      "tw-pb-16 tablet:tw-pb-[110px]": isNFTMode && isEmptyStore
    }),
    children: [/* @__PURE__ */ jsx$1(Typography, {
      className: classNames$1({
        "tw-mb-2 tablet:tw-text-[32px] tablet:tw-leading-[48px] desktop:tw-text-2xl": isNFTMode
      }),
      color: COLORS.Gray[800],
      variant: "heading-6",
      children: isEmptyStore ? t2("createStore.detail.title2") : t2("createStore.detail.title")
    }), /* @__PURE__ */ jsxs(Typography, {
      className: classNames$1({
        "tw-text-base": isNFTMode
      }),
      color: COLORS.Gray[500],
      variant: "title-6",
      children: [/* @__PURE__ */ jsx$1("span", {
        children: t2("createStore.detail.notHasStoreTitle.prefix")
      }), /* @__PURE__ */ jsx$1("span", {
        children: t2("createStore.detail.notHasStoreTitle.label")
      })]
    })]
  });
}
const StoreCard = ({
  image,
  isNFTMode = false,
  storeName,
  onClick: onClick2
}) => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(Card, {
    className: classNames$1("tw-box-border tw-items-center tw-mb-6 tw-w-full tw-h-fit tw-text-center tw-bg-White", {
      "tw-relative tw-mt-[61px] tw-rounded-md tw-group tablet:tw-rounded-md desktop:tw-rounded-md hover:tw-border-NFTBrandeisBlue hover:tw-bg-NFTAliceBlue": isNFTMode
    }),
    contentSize: isNFTMode ? ContentSize.LARGE_4 : ContentSize.MEDIUM_2,
    shadowSize: isNFTMode ? ElevationShadowType.EXTRA : ElevationShadowType.LARGE,
    children: [/* @__PURE__ */ jsx$1("div", {
      className: classNames$1("tw-flex tw-justify-center tw-pb-4", {
        "tw-absolute tw-top-0 tw-left-0 tw-mt-[-61px] tw-mx-auto tw-block tw-w-full tw-pb-0": isNFTMode
      }),
      children: image ? /* @__PURE__ */ jsx$1("img", {
        src: image,
        className: classNames$1("tw-object-cover tw-w-32  tw-h-32 tw-rounded-full", {
          "tw-w-[122px] tw-h-[122px]": isNFTMode
        }),
        alt: "storeName"
      }) : /* @__PURE__ */ jsx$1("div", {
        className: classNames$1("tw-flex tw-justify-center tw-items-center tw-truncate tw-rounded-full", {
          "tw-w-[122px] tw-h-[122px] tw-bg-NFTBrandeisBlue": isNFTMode,
          "tw-w-32 tw-h-32 tw-bg-DarkBlue": !isNFTMode
        }),
        children: /* @__PURE__ */ jsx$1(Typography, {
          className: "tw-truncate",
          variant: "heading-4",
          color: COLORS.White,
          children: storeName ? t2(storeName.substring(0, 2).toLocaleUpperCase()) : t2("N/A")
        })
      })
    }), /* @__PURE__ */ jsx$1("div", {
      className: classNames$1("tw-flex tw-justify-center tw-pb-4", {
        "tw-pt-[52px] tw-pb-3": isNFTMode
      }),
      children: /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-truncate",
        variant: isNFTMode ? "title-8" : "title-6",
        children: storeName
      })
    }), /* @__PURE__ */ jsx$1(Button, {
      className: classNames$1("tw-border-none tw-w-full tw-min-w-full tw-text-White tw-text-xl tw-font-medium tw-truncate tw-cursor-pointer", {
        "tw-text-Gray-800 tw-text-base tw-bg-NFTAliceBlue group-hover:tw-text-White group-hover:tw-bg-NFTBrandeisBlue": isNFTMode
      }),
      size: isNFTMode ? "large" : "medium",
      variant: isNFTMode ? "custom" : "primary",
      onClick: onClick2,
      children: t2("createStore.detail.choose")
    })]
  });
};
const PROJECT = "project";
const SHIPPING = "shipping";
const SHIPPING_DEFAULT = "shipping-default";
const SHIPPING_FORM = "shipping-form";
function CreateStoreDetailList({
  isNFTMode = false,
  list
}) {
  return /* @__PURE__ */ jsx$1(Fragment, {
    children: list.map(({
      storeName,
      image,
      projectId = ""
    }) => /* @__PURE__ */ jsx$1("div", {
      className: "tw-box-border tw-px-2 tw-w-full tw-max-w-xs desktop:tw-p-2",
      children: /* @__PURE__ */ jsx$1(StoreCard, {
        image,
        isNFTMode,
        storeName,
        onClick: () => window.location.replace(`/${PROJECT}/${projectId}`)
      })
    }, `${storeName.split(" ").join("_")}_${projectId}`))
  });
}
function CreateStoreDetail({
  className = "",
  isAllowedToCreateProject = false,
  isNFTMode = false,
  storeList = [],
  createProject
}) {
  const isEmptyStore = isEmpty_1(storeList);
  return /* @__PURE__ */ jsx$1("div", {
    className: classNames$1("tw-box-border tw-overflow-hidden tw-px-4 tw-w-screen tw-h-full tw-bg-Gray-100 tablet:tw-px-12 tablet:tw-w-screen tablet:tw-h-fit desktop:tw-px-20 desktop:tw-pt-24 desktop:tw-pb-8 desktop:tw-w-2/3 desktop:tw-h-full", {
      "tablet:tw-pb-12": isNFTMode && !isEmptyStore
    }, className),
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-overflow-y-auto tw-flex-col tw-w-full tw-h-full",
      children: [/* @__PURE__ */ jsx$1(CreateStoreDetailHeader, {
        isEmptyStore,
        isNFTMode
      }), /* @__PURE__ */ jsxs("div", {
        className: classNames$1("tw-relative tw-grid-cols-1 tw-box-border tw-grid tw-overflow-x-hidden tw-overflow-y-auto tw-justify-items-center tw-h-fit tablet:tw-grid-cols-2 fullScreen:tw-grid-cols-3", {
          "tw-pb-6": !isNFTMode,
          "tw-flex-1 tw-pb-11 tablet:tw-grid-cols-1 tablet:tw-pb-12 desktop:tw-pb-[66px] fullScreen:tw-grid-cols-1": isNFTMode && isEmptyStore
        }),
        children: [/* @__PURE__ */ jsx$1(CreateStoreDetailList, {
          isNFTMode,
          list: storeList
        }), /* @__PURE__ */ jsx$1(CreateStoreDetailForm, {
          isAllowedToCreateProject,
          isEmptyStore,
          isNFTMode,
          createProject
        })]
      })]
    })
  });
}
var i = function(e2, i2) {
  for (var a2 in i2.fields) {
    var f2 = i2.fields[a2];
    if (f2 && f2.ref && "reportValidity" in f2.ref) {
      var t2 = get$2(e2, a2);
      f2.ref.setCustomValidity(t2 && t2.message || ""), f2.ref.reportValidity();
    }
  }
}, a = function(a2, f2) {
  f2.shouldUseNativeValidation && i(a2, f2);
  var t2 = {};
  for (var o2 in a2) {
    var s = get$2(f2.fields, o2);
    set$1(t2, o2, Object.assign(a2[o2], { ref: s && s.ref }));
  }
  return t2;
};
var o = function(o2, n2, a$1) {
  return n2 === void 0 && (n2 = {}), a$1 === void 0 && (a$1 = {}), function(s, i$1, c2) {
    try {
      return Promise.resolve(function(t2, r2) {
        try {
          var u = (n2.context && false, Promise.resolve(o2[a$1.mode === "sync" ? "validateSync" : "validate"](s, Object.assign({ abortEarly: false }, n2, { context: i$1 }))).then(function(t3) {
            return c2.shouldUseNativeValidation && i({}, c2), { values: t3, errors: {} };
          }));
        } catch (e2) {
          return r2(e2);
        }
        return u && u.then ? u.then(void 0, r2) : u;
      }(0, function(e2) {
        return { values: {}, errors: a((o3 = e2, n3 = !c2.shouldUseNativeValidation && c2.criteriaMode === "all", (o3.inner || []).reduce(function(e3, t2) {
          if (e3[t2.path] || (e3[t2.path] = { message: t2.message, type: t2.type }), n3) {
            var o4 = e3[t2.path].types, a2 = o4 && o4[t2.type];
            e3[t2.path] = appendErrors(t2.path, n3, e3, t2.type, a2 ? [].concat(a2, t2.message) : t2.message);
          }
          return e3;
        }, {})), c2) };
        var o3, n3;
      }));
    } catch (e2) {
      return Promise.reject(e2);
    }
  };
};
var map;
try {
  map = Map;
} catch (_23) {
}
var set;
try {
  set = Set;
} catch (_23) {
}
function baseClone(src2, circulars, clones) {
  if (!src2 || typeof src2 !== "object" || typeof src2 === "function") {
    return src2;
  }
  if (src2.nodeType && "cloneNode" in src2) {
    return src2.cloneNode(true);
  }
  if (src2 instanceof Date) {
    return new Date(src2.getTime());
  }
  if (src2 instanceof RegExp) {
    return new RegExp(src2);
  }
  if (Array.isArray(src2)) {
    return src2.map(clone);
  }
  if (map && src2 instanceof map) {
    return new Map(Array.from(src2.entries()));
  }
  if (set && src2 instanceof set) {
    return new Set(Array.from(src2.values()));
  }
  if (src2 instanceof Object) {
    circulars.push(src2);
    var obj = Object.create(src2);
    clones.push(obj);
    for (var key in src2) {
      var idx = circulars.findIndex(function(i2) {
        return i2 === src2[key];
      });
      obj[key] = idx > -1 ? clones[idx] : baseClone(src2[key], circulars, clones);
    }
    return obj;
  }
  return src2;
}
function clone(src2) {
  return baseClone(src2, [], []);
}
const toString$5 = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : () => "";
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function printNumber(val) {
  if (val != +val)
    return "NaN";
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? "-0" : "" + val;
}
function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false)
    return "" + val;
  const typeOf = typeof val;
  if (typeOf === "number")
    return printNumber(val);
  if (typeOf === "string")
    return quoteStrings ? `"${val}"` : val;
  if (typeOf === "function")
    return "[Function " + (val.name || "anonymous") + "]";
  if (typeOf === "symbol")
    return symbolToString.call(val).replace(SYMBOL_REGEXP, "Symbol($1)");
  const tag = toString$5.call(val).slice(8, -1);
  if (tag === "Date")
    return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
  if (tag === "Error" || val instanceof Error)
    return "[" + errorToString.call(val) + "]";
  if (tag === "RegExp")
    return regExpToString.call(val);
  return null;
}
function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null)
    return result;
  return JSON.stringify(value, function(key, value2) {
    let result2 = printSimpleValue(this[key], quoteStrings);
    if (result2 !== null)
      return result2;
    return value2;
  }, 2);
}
let mixed = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    let isCast = originalValue != null && originalValue !== value;
    let msg = `${path} must be a \`${type}\` type, but the final value was: \`${printValue(value, true)}\`` + (isCast ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : ".");
    if (value === null) {
      msg += `
 If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
    }
    return msg;
  },
  defined: "${path} must be defined"
};
let string = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
};
let number = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
};
let date = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
};
let boolean = {
  isValue: "${path} field must be ${value}"
};
let object = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let array = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean
});
var objectProto$5 = Object.prototype;
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
function baseHas$1(object2, key) {
  return object2 != null && hasOwnProperty$4.call(object2, key);
}
var _baseHas = baseHas$1;
var MAX_SAFE_INTEGER = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$3(value, length2) {
  var type = typeof value;
  length2 = length2 == null ? MAX_SAFE_INTEGER : length2;
  return !!length2 && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
}
var _isIndex = isIndex$3;
var castPath = _castPath, isArguments$2 = isArguments_1, isArray$8 = isArray_1, isIndex$2 = _isIndex, isLength = isLength_1, toKey$2 = _toKey;
function hasPath$2(object2, path, hasFunc) {
  path = castPath(path, object2);
  var index2 = -1, length2 = path.length, result = false;
  while (++index2 < length2) {
    var key = toKey$2(path[index2]);
    if (!(result = object2 != null && hasFunc(object2, key))) {
      break;
    }
    object2 = object2[key];
  }
  if (result || ++index2 != length2) {
    return result;
  }
  length2 = object2 == null ? 0 : object2.length;
  return !!length2 && isLength(length2) && isIndex$2(key, length2) && (isArray$8(object2) || isArguments$2(object2));
}
var _hasPath = hasPath$2;
var baseHas = _baseHas, hasPath$1 = _hasPath;
function has(object2, path) {
  return object2 != null && hasPath$1(object2, path, baseHas);
}
var has_1 = has;
const isSchema = (obj) => obj && obj.__isYupSchema__;
class Condition {
  constructor(refs, options2) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;
    if (typeof options2 === "function") {
      this.fn = options2;
      return;
    }
    if (!has_1(options2, "is"))
      throw new TypeError("`is:` is required for `when()` conditions");
    if (!options2.then && !options2.otherwise)
      throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: is2,
      then,
      otherwise
    } = options2;
    let check2 = typeof is2 === "function" ? is2 : (...values) => values.every((value) => value === is2);
    this.fn = function(...args) {
      let options3 = args.pop();
      let schema2 = args.pop();
      let branch = check2(...args) ? then : otherwise;
      if (!branch)
        return void 0;
      if (typeof branch === "function")
        return branch(schema2);
      return schema2.concat(branch.resolve(options3));
    };
  }
  resolve(base, options2) {
    let values = this.refs.map((ref) => ref.getValue(options2 == null ? void 0 : options2.value, options2 == null ? void 0 : options2.parent, options2 == null ? void 0 : options2.context));
    let schema2 = this.fn.apply(base, values.concat(base, options2));
    if (schema2 === void 0 || schema2 === base)
      return base;
    if (!isSchema(schema2))
      throw new TypeError("conditions must return a schema object");
    return schema2.resolve(options2);
  }
}
function toArray(value) {
  return value == null ? [] : [].concat(value);
}
function _extends$3() {
  _extends$3 = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source2 = arguments[i2];
      for (var key in source2) {
        if (Object.prototype.hasOwnProperty.call(source2, key)) {
          target[key] = source2[key];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}
let strReg = /\$\{\s*(\w+)\s*\}/g;
class ValidationError extends Error {
  static formatError(message, params) {
    const path = params.label || params.path || "this";
    if (path !== params.path)
      params = _extends$3({}, params, {
        path
      });
    if (typeof message === "string")
      return message.replace(strReg, (_23, key) => printValue(params[key]));
    if (typeof message === "function")
      return message(params);
    return message;
  }
  static isError(err) {
    return err && err.name === "ValidationError";
  }
  constructor(errorOrErrors, value, field, type) {
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.errors = void 0;
    this.params = void 0;
    this.inner = void 0;
    this.name = "ValidationError";
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach((err) => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        this.inner = this.inner.concat(err.inner.length ? err.inner : err);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    if (Error.captureStackTrace)
      Error.captureStackTrace(this, ValidationError);
  }
}
const once = (cb2) => {
  let fired = false;
  return (...args) => {
    if (fired)
      return;
    fired = true;
    cb2(...args);
  };
};
function runTests(options2, cb2) {
  let {
    endEarly,
    tests,
    args,
    value,
    errors,
    sort,
    path
  } = options2;
  let callback = once(cb2);
  let count = tests.length;
  const nestedErrors = [];
  errors = errors ? errors : [];
  if (!count)
    return errors.length ? callback(new ValidationError(errors, value, path)) : callback(null, value);
  for (let i2 = 0; i2 < tests.length; i2++) {
    const test = tests[i2];
    test(args, function finishTestRun(err) {
      if (err) {
        if (!ValidationError.isError(err)) {
          return callback(err, value);
        }
        if (endEarly) {
          err.value = value;
          return callback(err, value);
        }
        nestedErrors.push(err);
      }
      if (--count <= 0) {
        if (nestedErrors.length) {
          if (sort)
            nestedErrors.sort(sort);
          if (errors.length)
            nestedErrors.push(...errors);
          errors = nestedErrors;
        }
        if (errors.length) {
          callback(new ValidationError(errors, value, path), value);
          return;
        }
        callback(null, value);
      }
    });
  }
}
var getNative = _getNative;
var defineProperty$2 = function() {
  try {
    var func = getNative(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e2) {
  }
}();
var _defineProperty$1 = defineProperty$2;
var defineProperty$1 = _defineProperty$1;
function baseAssignValue$3(object2, key, value) {
  if (key == "__proto__" && defineProperty$1) {
    defineProperty$1(object2, key, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object2[key] = value;
  }
}
var _baseAssignValue = baseAssignValue$3;
function createBaseFor$1(fromRight) {
  return function(object2, iteratee, keysFunc) {
    var index2 = -1, iterable = Object(object2), props = keysFunc(object2), length2 = props.length;
    while (length2--) {
      var key = props[fromRight ? length2 : ++index2];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object2;
  };
}
var _createBaseFor = createBaseFor$1;
var createBaseFor = _createBaseFor;
var baseFor$1 = createBaseFor();
var _baseFor = baseFor$1;
function baseTimes$1(n2, iteratee) {
  var index2 = -1, result = Array(n2);
  while (++index2 < n2) {
    result[index2] = iteratee(index2);
  }
  return result;
}
var _baseTimes = baseTimes$1;
var baseTimes = _baseTimes, isArguments$1 = isArguments_1, isArray$7 = isArray_1, isBuffer$2 = isBuffer$4.exports, isIndex$1 = _isIndex, isTypedArray$1 = isTypedArray_1;
var objectProto$4 = Object.prototype;
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
function arrayLikeKeys$1(value, inherited) {
  var isArr = isArray$7(value), isArg = !isArr && isArguments$1(value), isBuff = !isArr && !isArg && isBuffer$2(value), isType = !isArr && !isArg && !isBuff && isTypedArray$1(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length2 = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex$1(key, length2)))) {
      result.push(key);
    }
  }
  return result;
}
var _arrayLikeKeys = arrayLikeKeys$1;
var arrayLikeKeys = _arrayLikeKeys, baseKeys = _baseKeys, isArrayLike$3 = isArrayLike_1;
function keys$3(object2) {
  return isArrayLike$3(object2) ? arrayLikeKeys(object2) : baseKeys(object2);
}
var keys_1 = keys$3;
var baseFor = _baseFor, keys$2 = keys_1;
function baseForOwn$3(object2, iteratee) {
  return object2 && baseFor(object2, iteratee, keys$2);
}
var _baseForOwn = baseForOwn$3;
var ListCache$2 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$2();
  this.size = 0;
}
var _stackClear = stackClear$1;
function stackDelete$1(key) {
  var data2 = this.__data__, result = data2["delete"](key);
  this.size = data2.size;
  return result;
}
var _stackDelete = stackDelete$1;
function stackGet$1(key) {
  return this.__data__.get(key);
}
var _stackGet = stackGet$1;
function stackHas$1(key) {
  return this.__data__.has(key);
}
var _stackHas = stackHas$1;
var ListCache$1 = _ListCache, Map$1 = _Map, MapCache$1 = _MapCache;
var LARGE_ARRAY_SIZE$1 = 200;
function stackSet$1(key, value) {
  var data2 = this.__data__;
  if (data2 instanceof ListCache$1) {
    var pairs = data2.__data__;
    if (!Map$1 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) {
      pairs.push([key, value]);
      this.size = ++data2.size;
      return this;
    }
    data2 = this.__data__ = new MapCache$1(pairs);
  }
  data2.set(key, value);
  this.size = data2.size;
  return this;
}
var _stackSet = stackSet$1;
var ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
function Stack$2(entries) {
  var data2 = this.__data__ = new ListCache(entries);
  this.size = data2.size;
}
Stack$2.prototype.clear = stackClear;
Stack$2.prototype["delete"] = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;
var _Stack = Stack$2;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas$1;
var MapCache = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
function SetCache$2(values) {
  var index2 = -1, length2 = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index2 < length2) {
    this.add(values[index2]);
  }
}
SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd;
SetCache$2.prototype.has = setCacheHas;
var _SetCache = SetCache$2;
function arraySome$1(array2, predicate) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length;
  while (++index2 < length2) {
    if (predicate(array2[index2], index2, array2)) {
      return true;
    }
  }
  return false;
}
var _arraySome = arraySome$1;
function cacheHas$2(cache2, key) {
  return cache2.has(key);
}
var _cacheHas = cacheHas$2;
var SetCache$1 = _SetCache, arraySome = _arraySome, cacheHas$1 = _cacheHas;
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays$2(array2, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array2.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array2);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array2;
  }
  var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache$1() : void 0;
  stack.set(array2, other);
  stack.set(other, array2);
  while (++index2 < arrLength) {
    var arrValue = array2[index2], othValue = other[index2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array2, stack) : customizer(arrValue, othValue, index2, array2, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas$1(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack["delete"](array2);
  stack["delete"](other);
  return result;
}
var _equalArrays = equalArrays$2;
var root = _root;
var Uint8Array$2 = root.Uint8Array;
var _Uint8Array = Uint8Array$2;
function mapToArray$1(map2) {
  var index2 = -1, result = Array(map2.size);
  map2.forEach(function(value, key) {
    result[++index2] = [key, value];
  });
  return result;
}
var _mapToArray = mapToArray$1;
function setToArray$3(set2) {
  var index2 = -1, result = Array(set2.size);
  set2.forEach(function(value) {
    result[++index2] = value;
  });
  return result;
}
var _setToArray = setToArray$3;
var Symbol$2 = _Symbol, Uint8Array$1 = _Uint8Array, eq$1 = eq_1, equalArrays$1 = _equalArrays, mapToArray = _mapToArray, setToArray$2 = _setToArray;
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
var symbolProto = Symbol$2 ? Symbol$2.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag$1(object2, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
        return false;
      }
      object2 = object2.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object2), new Uint8Array$1(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag:
    case numberTag:
      return eq$1(+object2, +other);
    case errorTag:
      return object2.name == other.name && object2.message == other.message;
    case regexpTag:
    case stringTag:
      return object2 == other + "";
    case mapTag:
      var convert = mapToArray;
    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray$2);
      if (object2.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object2);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;
      stack.set(object2, other);
      var result = equalArrays$1(convert(object2), convert(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object2);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object2) == symbolValueOf.call(other);
      }
  }
  return false;
}
var _equalByTag = equalByTag$1;
function arrayPush$2(array2, values) {
  var index2 = -1, length2 = values.length, offset2 = array2.length;
  while (++index2 < length2) {
    array2[offset2 + index2] = values[index2];
  }
  return array2;
}
var _arrayPush = arrayPush$2;
var arrayPush$1 = _arrayPush, isArray$6 = isArray_1;
function baseGetAllKeys$1(object2, keysFunc, symbolsFunc) {
  var result = keysFunc(object2);
  return isArray$6(object2) ? result : arrayPush$1(result, symbolsFunc(object2));
}
var _baseGetAllKeys = baseGetAllKeys$1;
function arrayFilter$1(array2, predicate) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length, resIndex = 0, result = [];
  while (++index2 < length2) {
    var value = array2[index2];
    if (predicate(value, index2, array2)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var _arrayFilter = arrayFilter$1;
function stubArray$1() {
  return [];
}
var stubArray_1 = stubArray$1;
var arrayFilter = _arrayFilter, stubArray = stubArray_1;
var objectProto$3 = Object.prototype;
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbols$1 = !nativeGetSymbols ? stubArray : function(object2) {
  if (object2 == null) {
    return [];
  }
  object2 = Object(object2);
  return arrayFilter(nativeGetSymbols(object2), function(symbol) {
    return propertyIsEnumerable.call(object2, symbol);
  });
};
var _getSymbols = getSymbols$1;
var baseGetAllKeys = _baseGetAllKeys, getSymbols = _getSymbols, keys$1 = keys_1;
function getAllKeys$1(object2) {
  return baseGetAllKeys(object2, keys$1, getSymbols);
}
var _getAllKeys = getAllKeys$1;
var getAllKeys = _getAllKeys;
var COMPARE_PARTIAL_FLAG$3 = 1;
var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function equalObjects$1(object2, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys(object2), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index2 = objLength;
  while (index2--) {
    var key = objProps[index2];
    if (!(isPartial ? key in other : hasOwnProperty$2.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack.get(object2);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object2;
  }
  var result = true;
  stack.set(object2, other);
  stack.set(other, object2);
  var skipCtor = isPartial;
  while (++index2 < objLength) {
    key = objProps[index2];
    var objValue = object2[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack) : customizer(objValue, othValue, key, object2, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object2.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object2 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack["delete"](object2);
  stack["delete"](other);
  return result;
}
var _equalObjects = equalObjects$1;
var Stack$1 = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag = _getTag, isArray$5 = isArray_1, isBuffer$1 = isBuffer$4.exports, isTypedArray = isTypedArray_1;
var COMPARE_PARTIAL_FLAG$2 = 1;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function baseIsEqualDeep$1(object2, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$5(object2), othIsArr = isArray$5(other), objTag = objIsArr ? arrayTag : getTag(object2), othTag = othIsArr ? arrayTag : getTag(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$1(object2)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$1());
    return objIsArr || isTypedArray(object2) ? equalArrays(object2, other, bitmask, customizer, equalFunc, stack) : equalByTag(object2, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$1.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$1.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack$1());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$1());
  return equalObjects(object2, other, bitmask, customizer, equalFunc, stack);
}
var _baseIsEqualDeep = baseIsEqualDeep$1;
var baseIsEqualDeep = _baseIsEqualDeep, isObjectLike = isObjectLike_1;
function baseIsEqual$3(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$3, stack);
}
var _baseIsEqual = baseIsEqual$3;
var Stack = _Stack, baseIsEqual$2 = _baseIsEqual;
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch$1(object2, source2, matchData, customizer) {
  var index2 = matchData.length, length2 = index2, noCustomizer = !customizer;
  if (object2 == null) {
    return !length2;
  }
  object2 = Object(object2);
  while (index2--) {
    var data2 = matchData[index2];
    if (noCustomizer && data2[2] ? data2[1] !== object2[data2[0]] : !(data2[0] in object2)) {
      return false;
    }
  }
  while (++index2 < length2) {
    data2 = matchData[index2];
    var key = data2[0], objValue = object2[key], srcValue = data2[1];
    if (noCustomizer && data2[2]) {
      if (objValue === void 0 && !(key in object2)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object2, source2, stack);
      }
      if (!(result === void 0 ? baseIsEqual$2(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}
var _baseIsMatch = baseIsMatch$1;
var isObject$4 = isObject_1;
function isStrictComparable$2(value) {
  return value === value && !isObject$4(value);
}
var _isStrictComparable = isStrictComparable$2;
var isStrictComparable$1 = _isStrictComparable, keys = keys_1;
function getMatchData$1(object2) {
  var result = keys(object2), length2 = result.length;
  while (length2--) {
    var key = result[length2], value = object2[key];
    result[length2] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}
var _getMatchData = getMatchData$1;
function matchesStrictComparable$2(key, srcValue) {
  return function(object2) {
    if (object2 == null) {
      return false;
    }
    return object2[key] === srcValue && (srcValue !== void 0 || key in Object(object2));
  };
}
var _matchesStrictComparable = matchesStrictComparable$2;
var baseIsMatch = _baseIsMatch, getMatchData = _getMatchData, matchesStrictComparable$1 = _matchesStrictComparable;
function baseMatches$1(source2) {
  var matchData = getMatchData(source2);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object2) {
    return object2 === source2 || baseIsMatch(object2, source2, matchData);
  };
}
var _baseMatches = baseMatches$1;
function baseHasIn$1(object2, key) {
  return object2 != null && key in Object(object2);
}
var _baseHasIn = baseHasIn$1;
var baseHasIn = _baseHasIn, hasPath = _hasPath;
function hasIn$1(object2, path) {
  return object2 != null && hasPath(object2, path, baseHasIn);
}
var hasIn_1 = hasIn$1;
var baseIsEqual$1 = _baseIsEqual, get = get_1, hasIn = hasIn_1, isKey$1 = _isKey, isStrictComparable = _isStrictComparable, matchesStrictComparable = _matchesStrictComparable, toKey$1 = _toKey;
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$1(path), srcValue);
  }
  return function(object2) {
    var objValue = get(object2, path);
    return objValue === void 0 && objValue === srcValue ? hasIn(object2, path) : baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
var _baseMatchesProperty = baseMatchesProperty$1;
function identity$4(value) {
  return value;
}
var identity_1 = identity$4;
function baseProperty$1(key) {
  return function(object2) {
    return object2 == null ? void 0 : object2[key];
  };
}
var _baseProperty = baseProperty$1;
var baseGet$1 = _baseGet;
function basePropertyDeep$1(path) {
  return function(object2) {
    return baseGet$1(object2, path);
  };
}
var _basePropertyDeep = basePropertyDeep$1;
var baseProperty = _baseProperty, basePropertyDeep = _basePropertyDeep, isKey = _isKey, toKey = _toKey;
function property$1(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
var property_1 = property$1;
var baseMatches = _baseMatches, baseMatchesProperty = _baseMatchesProperty, identity$3 = identity_1, isArray$4 = isArray_1, property = property_1;
function baseIteratee$4(value) {
  if (typeof value == "function") {
    return value;
  }
  if (value == null) {
    return identity$3;
  }
  if (typeof value == "object") {
    return isArray$4(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}
var _baseIteratee = baseIteratee$4;
var baseAssignValue$2 = _baseAssignValue, baseForOwn$2 = _baseForOwn, baseIteratee$3 = _baseIteratee;
function mapValues(object2, iteratee) {
  var result = {};
  iteratee = baseIteratee$3(iteratee);
  baseForOwn$2(object2, function(value, key, object3) {
    baseAssignValue$2(result, key, iteratee(value, key, object3));
  });
  return result;
}
var mapValues_1 = mapValues;
function Cache(maxSize) {
  this._maxSize = maxSize;
  this.clear();
}
Cache.prototype.clear = function() {
  this._size = 0;
  this._values = Object.create(null);
};
Cache.prototype.get = function(key) {
  return this._values[key];
};
Cache.prototype.set = function(key, value) {
  this._size >= this._maxSize && this.clear();
  if (!(key in this._values))
    this._size++;
  return this._values[key] = value;
};
var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, DIGIT_REGEX = /^\d+$/, LEAD_DIGIT_REGEX = /^\d/, SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, MAX_CACHE_SIZE = 512;
var pathCache = new Cache(MAX_CACHE_SIZE), setCache = new Cache(MAX_CACHE_SIZE), getCache = new Cache(MAX_CACHE_SIZE);
var propertyExpr = {
  Cache,
  split,
  normalizePath,
  setter: function(path) {
    var parts = normalizePath(path);
    return setCache.get(path) || setCache.set(path, function setter(obj, value) {
      var index2 = 0;
      var len = parts.length;
      var data2 = obj;
      while (index2 < len - 1) {
        var part = parts[index2];
        if (part === "__proto__" || part === "constructor" || part === "prototype") {
          return obj;
        }
        data2 = data2[parts[index2++]];
      }
      data2[parts[index2]] = value;
    });
  },
  getter: function(path, safe) {
    var parts = normalizePath(path);
    return getCache.get(path) || getCache.set(path, function getter(data2) {
      var index2 = 0, len = parts.length;
      while (index2 < len) {
        if (data2 != null || !safe)
          data2 = data2[parts[index2++]];
        else
          return;
      }
      return data2;
    });
  },
  join: function(segments) {
    return segments.reduce(function(path, part) {
      return path + (isQuoted(part) || DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
    }, "");
  },
  forEach: function(path, cb2, thisArg) {
    forEach$1(Array.isArray(path) ? path : split(path), cb2, thisArg);
  }
};
function normalizePath(path) {
  return pathCache.get(path) || pathCache.set(path, split(path).map(function(part) {
    return part.replace(CLEAN_QUOTES_REGEX, "$2");
  }));
}
function split(path) {
  return path.match(SPLIT_REGEX) || [""];
}
function forEach$1(parts, iter, thisArg) {
  var len = parts.length, part, idx, isArray2, isBracket;
  for (idx = 0; idx < len; idx++) {
    part = parts[idx];
    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"';
      }
      isBracket = isQuoted(part);
      isArray2 = !isBracket && /^\d+$/.test(part);
      iter.call(thisArg, part, isBracket, isArray2, idx, parts);
    }
  }
}
function isQuoted(str) {
  return typeof str === "string" && str && ["'", '"'].indexOf(str.charAt(0)) !== -1;
}
function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX);
}
function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part);
}
function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part));
}
const prefixes = {
  context: "$",
  value: "."
};
class Reference {
  constructor(key, options2 = {}) {
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== "string")
      throw new TypeError("ref must be a string, got: " + key);
    this.key = key.trim();
    if (key === "")
      throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix2 = this.isContext ? prefixes.context : this.isValue ? prefixes.value : "";
    this.path = this.key.slice(prefix2.length);
    this.getter = this.path && propertyExpr.getter(this.path, true);
    this.map = options2.map;
  }
  getValue(value, parent2, context) {
    let result = this.isContext ? context : this.isValue ? value : parent2;
    if (this.getter)
      result = this.getter(result || {});
    if (this.map)
      result = this.map(result);
    return result;
  }
  cast(value, options2) {
    return this.getValue(value, options2 == null ? void 0 : options2.parent, options2 == null ? void 0 : options2.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(value) {
    return value && value.__isYupRef;
  }
}
Reference.prototype.__isYupRef = true;
function _extends$2() {
  _extends$2 = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source2 = arguments[i2];
      for (var key in source2) {
        if (Object.prototype.hasOwnProperty.call(source2, key)) {
          target[key] = source2[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$1(source2, excluded) {
  if (source2 == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source2);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source2[key];
  }
  return target;
}
function createValidation(config) {
  function validate(_ref3, cb2) {
    let {
      value,
      path = "",
      label,
      options: options2,
      originalValue,
      sync
    } = _ref3, rest = _objectWithoutPropertiesLoose$1(_ref3, ["value", "path", "label", "options", "originalValue", "sync"]);
    const {
      name,
      test,
      params,
      message
    } = config;
    let {
      parent: parent2,
      context
    } = options2;
    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent2, context) : item;
    }
    function createError3(overrides = {}) {
      const nextParams = mapValues_1(_extends$2({
        value,
        originalValue,
        label,
        path: overrides.path || path
      }, params, overrides.params), resolve);
      const error2 = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
      error2.params = nextParams;
      return error2;
    }
    let ctx = _extends$2({
      path,
      parent: parent2,
      type: name,
      createError: createError3,
      resolve,
      options: options2,
      originalValue
    }, rest);
    if (!sync) {
      try {
        Promise.resolve(test.call(ctx, value, ctx)).then((validOrError) => {
          if (ValidationError.isError(validOrError))
            cb2(validOrError);
          else if (!validOrError)
            cb2(createError3());
          else
            cb2(null, validOrError);
        }).catch(cb2);
      } catch (err) {
        cb2(err);
      }
      return;
    }
    let result;
    try {
      var _ref22;
      result = test.call(ctx, value, ctx);
      if (typeof ((_ref22 = result) == null ? void 0 : _ref22.then) === "function") {
        throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
      }
    } catch (err) {
      cb2(err);
      return;
    }
    if (ValidationError.isError(result))
      cb2(result);
    else if (!result)
      cb2(createError3());
    else
      cb2(null, result);
  }
  validate.OPTIONS = config;
  return validate;
}
let trim$1 = (part) => part.substr(0, part.length - 1).substr(1);
function getIn(schema2, path, value, context = value) {
  let parent2, lastPart, lastPartDebug;
  if (!path)
    return {
      parent: parent2,
      parentPath: path,
      schema: schema2
    };
  propertyExpr.forEach(path, (_part, isBracket, isArray2) => {
    let part = isBracket ? trim$1(_part) : _part;
    schema2 = schema2.resolve({
      context,
      parent: parent2,
      value
    });
    if (schema2.innerType) {
      let idx = isArray2 ? parseInt(part, 10) : 0;
      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. because there is no value at that index. `);
      }
      parent2 = value;
      value = value && value[idx];
      schema2 = schema2.innerType;
    }
    if (!isArray2) {
      if (!schema2.fields || !schema2.fields[part])
        throw new Error(`The schema does not contain the path: ${path}. (failed at: ${lastPartDebug} which is a type: "${schema2._type}")`);
      parent2 = value;
      value = value && value[part];
      schema2 = schema2.fields[part];
    }
    lastPart = part;
    lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
  });
  return {
    schema: schema2,
    parent: parent2,
    parentPath: lastPart
  };
}
class ReferenceSet {
  constructor() {
    this.list = void 0;
    this.refs = void 0;
    this.list = new Set();
    this.refs = new Map();
  }
  get size() {
    return this.list.size + this.refs.size;
  }
  describe() {
    const description = [];
    for (const item of this.list)
      description.push(item);
    for (const [, ref] of this.refs)
      description.push(ref.describe());
    return description;
  }
  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }
  resolveAll(resolve) {
    return this.toArray().reduce((acc, e2) => acc.concat(Reference.isRef(e2) ? resolve(e2) : e2), []);
  }
  add(value) {
    Reference.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  }
  delete(value) {
    Reference.isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
  }
  clone() {
    const next2 = new ReferenceSet();
    next2.list = new Set(this.list);
    next2.refs = new Map(this.refs);
    return next2;
  }
  merge(newItems, removeItems) {
    const next2 = this.clone();
    newItems.list.forEach((value) => next2.add(value));
    newItems.refs.forEach((value) => next2.add(value));
    removeItems.list.forEach((value) => next2.delete(value));
    removeItems.refs.forEach((value) => next2.delete(value));
    return next2;
  }
}
function _extends$1() {
  _extends$1 = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source2 = arguments[i2];
      for (var key in source2) {
        if (Object.prototype.hasOwnProperty.call(source2, key)) {
          target[key] = source2[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
class BaseSchema {
  constructor(options2) {
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this._typeError = void 0;
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = (options2 == null ? void 0 : options2.type) || "mixed";
    this.spec = _extends$1({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      nullable: false,
      presence: "optional"
    }, options2 == null ? void 0 : options2.spec);
  }
  get _type() {
    return this.type;
  }
  _typeCheck(_value) {
    return true;
  }
  clone(spec) {
    if (this._mutate) {
      if (spec)
        Object.assign(this.spec, spec);
      return this;
    }
    const next2 = Object.create(Object.getPrototypeOf(this));
    next2.type = this.type;
    next2._typeError = this._typeError;
    next2._whitelistError = this._whitelistError;
    next2._blacklistError = this._blacklistError;
    next2._whitelist = this._whitelist.clone();
    next2._blacklist = this._blacklist.clone();
    next2.exclusiveTests = _extends$1({}, this.exclusiveTests);
    next2.deps = [...this.deps];
    next2.conditions = [...this.conditions];
    next2.tests = [...this.tests];
    next2.transforms = [...this.transforms];
    next2.spec = clone(_extends$1({}, this.spec, spec));
    return next2;
  }
  label(label) {
    let next2 = this.clone();
    next2.spec.label = label;
    return next2;
  }
  meta(...args) {
    if (args.length === 0)
      return this.spec.meta;
    let next2 = this.clone();
    next2.spec.meta = Object.assign(next2.spec.meta || {}, args[0]);
    return next2;
  }
  withMutation(fn2) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn2(this);
    this._mutate = before;
    return result;
  }
  concat(schema2) {
    if (!schema2 || schema2 === this)
      return this;
    if (schema2.type !== this.type && this.type !== "mixed")
      throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema2.type}`);
    let base = this;
    let combined = schema2.clone();
    const mergedSpec = _extends$1({}, base.spec, combined.spec);
    combined.spec = mergedSpec;
    combined._typeError || (combined._typeError = base._typeError);
    combined._whitelistError || (combined._whitelistError = base._whitelistError);
    combined._blacklistError || (combined._blacklistError = base._blacklistError);
    combined._whitelist = base._whitelist.merge(schema2._whitelist, schema2._blacklist);
    combined._blacklist = base._blacklist.merge(schema2._blacklist, schema2._whitelist);
    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests;
    combined.withMutation((next2) => {
      schema2.tests.forEach((fn2) => {
        next2.test(fn2.OPTIONS);
      });
    });
    combined.transforms = [...base.transforms, ...combined.transforms];
    return combined;
  }
  isType(v2) {
    if (this.spec.nullable && v2 === null)
      return true;
    return this._typeCheck(v2);
  }
  resolve(options2) {
    let schema2 = this;
    if (schema2.conditions.length) {
      let conditions = schema2.conditions;
      schema2 = schema2.clone();
      schema2.conditions = [];
      schema2 = conditions.reduce((schema3, condition) => condition.resolve(schema3, options2), schema2);
      schema2 = schema2.resolve(options2);
    }
    return schema2;
  }
  cast(value, options2 = {}) {
    let resolvedSchema = this.resolve(_extends$1({
      value
    }, options2));
    let result = resolvedSchema._cast(value, options2);
    if (value !== void 0 && options2.assert !== false && resolvedSchema.isType(result) !== true) {
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options2.path || "field"} could not be cast to a value that satisfies the schema type: "${resolvedSchema._type}". 

attempted value: ${formattedValue} 
` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
    }
    return result;
  }
  _cast(rawValue, _options) {
    let value = rawValue === void 0 ? rawValue : this.transforms.reduce((value2, fn2) => fn2.call(this, value2, rawValue, this), rawValue);
    if (value === void 0) {
      value = this.getDefault();
    }
    return value;
  }
  _validate(_value, options2 = {}, cb2) {
    let {
      sync,
      path,
      from: from2 = [],
      originalValue = _value,
      strict = this.spec.strict,
      abortEarly = this.spec.abortEarly
    } = options2;
    let value = _value;
    if (!strict) {
      value = this._cast(value, _extends$1({
        assert: false
      }, options2));
    }
    let args = {
      value,
      path,
      options: options2,
      originalValue,
      schema: this,
      label: this.spec.label,
      sync,
      from: from2
    };
    let initialTests = [];
    if (this._typeError)
      initialTests.push(this._typeError);
    let finalTests = [];
    if (this._whitelistError)
      finalTests.push(this._whitelistError);
    if (this._blacklistError)
      finalTests.push(this._blacklistError);
    runTests({
      args,
      value,
      path,
      sync,
      tests: initialTests,
      endEarly: abortEarly
    }, (err) => {
      if (err)
        return void cb2(err, value);
      runTests({
        tests: this.tests.concat(finalTests),
        args,
        path,
        sync,
        value,
        endEarly: abortEarly
      }, cb2);
    });
  }
  validate(value, options2, maybeCb) {
    let schema2 = this.resolve(_extends$1({}, options2, {
      value
    }));
    return typeof maybeCb === "function" ? schema2._validate(value, options2, maybeCb) : new Promise((resolve, reject) => schema2._validate(value, options2, (err, value2) => {
      if (err)
        reject(err);
      else
        resolve(value2);
    }));
  }
  validateSync(value, options2) {
    let schema2 = this.resolve(_extends$1({}, options2, {
      value
    }));
    let result;
    schema2._validate(value, _extends$1({}, options2, {
      sync: true
    }), (err, value2) => {
      if (err)
        throw err;
      result = value2;
    });
    return result;
  }
  isValid(value, options2) {
    return this.validate(value, options2).then(() => true, (err) => {
      if (ValidationError.isError(err))
        return false;
      throw err;
    });
  }
  isValidSync(value, options2) {
    try {
      this.validateSync(value, options2);
      return true;
    } catch (err) {
      if (ValidationError.isError(err))
        return false;
      throw err;
    }
  }
  _getDefault() {
    let defaultValue = this.spec.default;
    if (defaultValue == null) {
      return defaultValue;
    }
    return typeof defaultValue === "function" ? defaultValue.call(this) : clone(defaultValue);
  }
  getDefault(options2) {
    let schema2 = this.resolve(options2 || {});
    return schema2._getDefault();
  }
  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }
    let next2 = this.clone({
      default: def
    });
    return next2;
  }
  strict(isStrict = true) {
    let next2 = this.clone();
    next2.spec.strict = isStrict;
    return next2;
  }
  _isPresent(value) {
    return value != null;
  }
  defined(message = mixed.defined) {
    return this.test({
      message,
      name: "defined",
      exclusive: true,
      test(value) {
        return value !== void 0;
      }
    });
  }
  required(message = mixed.required) {
    return this.clone({
      presence: "required"
    }).withMutation((s) => s.test({
      message,
      name: "required",
      exclusive: true,
      test(value) {
        return this.schema._isPresent(value);
      }
    }));
  }
  notRequired() {
    let next2 = this.clone({
      presence: "optional"
    });
    next2.tests = next2.tests.filter((test) => test.OPTIONS.name !== "required");
    return next2;
  }
  nullable(isNullable = true) {
    let next2 = this.clone({
      nullable: isNullable !== false
    });
    return next2;
  }
  transform(fn2) {
    let next2 = this.clone();
    next2.transforms.push(fn2);
    return next2;
  }
  test(...args) {
    let opts;
    if (args.length === 1) {
      if (typeof args[0] === "function") {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }
    if (opts.message === void 0)
      opts.message = mixed.default;
    if (typeof opts.test !== "function")
      throw new TypeError("`test` is a required parameters");
    let next2 = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next2.exclusiveTests[opts.name] === true;
    if (opts.exclusive) {
      if (!opts.name)
        throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    }
    if (opts.name)
      next2.exclusiveTests[opts.name] = !!opts.exclusive;
    next2.tests = next2.tests.filter((fn2) => {
      if (fn2.OPTIONS.name === opts.name) {
        if (isExclusive)
          return false;
        if (fn2.OPTIONS.test === validate.OPTIONS.test)
          return false;
      }
      return true;
    });
    next2.tests.push(validate);
    return next2;
  }
  when(keys2, options2) {
    if (!Array.isArray(keys2) && typeof keys2 !== "string") {
      options2 = keys2;
      keys2 = ".";
    }
    let next2 = this.clone();
    let deps = toArray(keys2).map((key) => new Reference(key));
    deps.forEach((dep) => {
      if (dep.isSibling)
        next2.deps.push(dep.key);
    });
    next2.conditions.push(new Condition(deps, options2));
    return next2;
  }
  typeError(message) {
    let next2 = this.clone();
    next2._typeError = createValidation({
      message,
      name: "typeError",
      test(value) {
        if (value !== void 0 && !this.schema.isType(value))
          return this.createError({
            params: {
              type: this.schema._type
            }
          });
        return true;
      }
    });
    return next2;
  }
  oneOf(enums, message = mixed.oneOf) {
    let next2 = this.clone();
    enums.forEach((val) => {
      next2._whitelist.add(val);
      next2._blacklist.delete(val);
    });
    next2._whitelistError = createValidation({
      message,
      name: "oneOf",
      test(value) {
        if (value === void 0)
          return true;
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: valids.toArray().join(", "),
            resolved
          }
        });
      }
    });
    return next2;
  }
  notOneOf(enums, message = mixed.notOneOf) {
    let next2 = this.clone();
    enums.forEach((val) => {
      next2._blacklist.add(val);
      next2._whitelist.delete(val);
    });
    next2._blacklistError = createValidation({
      message,
      name: "notOneOf",
      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value))
          return this.createError({
            params: {
              values: invalids.toArray().join(", "),
              resolved
            }
          });
        return true;
      }
    });
    return next2;
  }
  strip(strip = true) {
    let next2 = this.clone();
    next2.spec.strip = strip;
    return next2;
  }
  describe() {
    const next2 = this.clone();
    const {
      label,
      meta
    } = next2.spec;
    const description = {
      meta,
      label,
      type: next2.type,
      oneOf: next2._whitelist.describe(),
      notOneOf: next2._blacklist.describe(),
      tests: next2.tests.map((fn2) => ({
        name: fn2.OPTIONS.name,
        params: fn2.OPTIONS.params
      })).filter((n2, idx, list) => list.findIndex((c2) => c2.name === n2.name) === idx)
    };
    return description;
  }
}
BaseSchema.prototype.__isYupSchema__ = true;
for (const method of ["validate", "validateSync"])
  BaseSchema.prototype[`${method}At`] = function(path, value, options2 = {}) {
    const {
      parent: parent2,
      parentPath,
      schema: schema2
    } = getIn(this, path, value, options2.context);
    return schema2[method](parent2 && parent2[parentPath], _extends$1({}, options2, {
      parent: parent2,
      path
    }));
  };
for (const alias of ["equals", "is"])
  BaseSchema.prototype[alias] = BaseSchema.prototype.oneOf;
for (const alias of ["not", "nope"])
  BaseSchema.prototype[alias] = BaseSchema.prototype.notOneOf;
BaseSchema.prototype.optional = BaseSchema.prototype.notRequired;
const Mixed = BaseSchema;
Mixed.prototype;
const isAbsent = (value) => value == null;
function create$3() {
  return new BooleanSchema();
}
class BooleanSchema extends BaseSchema {
  constructor() {
    super({
      type: "boolean"
    });
    this.withMutation(() => {
      this.transform(function(value) {
        if (!this.isType(value)) {
          if (/^(true|1)$/i.test(String(value)))
            return true;
          if (/^(false|0)$/i.test(String(value)))
            return false;
        }
        return value;
      });
    });
  }
  _typeCheck(v2) {
    if (v2 instanceof Boolean)
      v2 = v2.valueOf();
    return typeof v2 === "boolean";
  }
  isTrue(message = boolean.isValue) {
    return this.test({
      message,
      name: "is-value",
      exclusive: true,
      params: {
        value: "true"
      },
      test(value) {
        return isAbsent(value) || value === true;
      }
    });
  }
  isFalse(message = boolean.isValue) {
    return this.test({
      message,
      name: "is-value",
      exclusive: true,
      params: {
        value: "false"
      },
      test(value) {
        return isAbsent(value) || value === false;
      }
    });
  }
}
create$3.prototype = BooleanSchema.prototype;
let rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
let rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let isTrimmed = (value) => isAbsent(value) || value === value.trim();
let objStringTag = {}.toString();
function create$2() {
  return new StringSchema();
}
class StringSchema extends BaseSchema {
  constructor() {
    super({
      type: "string"
    });
    this.withMutation(() => {
      this.transform(function(value) {
        if (this.isType(value))
          return value;
        if (Array.isArray(value))
          return value;
        const strValue = value != null && value.toString ? value.toString() : value;
        if (strValue === objStringTag)
          return value;
        return strValue;
      });
    });
  }
  _typeCheck(value) {
    if (value instanceof String)
      value = value.valueOf();
    return typeof value === "string";
  }
  _isPresent(value) {
    return super._isPresent(value) && !!value.length;
  }
  length(length2, message = string.length) {
    return this.test({
      message,
      name: "length",
      exclusive: true,
      params: {
        length: length2
      },
      test(value) {
        return isAbsent(value) || value.length === this.resolve(length2);
      }
    });
  }
  min(min2, message = string.min) {
    return this.test({
      message,
      name: "min",
      exclusive: true,
      params: {
        min: min2
      },
      test(value) {
        return isAbsent(value) || value.length >= this.resolve(min2);
      }
    });
  }
  max(max2, message = string.max) {
    return this.test({
      name: "max",
      exclusive: true,
      message,
      params: {
        max: max2
      },
      test(value) {
        return isAbsent(value) || value.length <= this.resolve(max2);
      }
    });
  }
  matches(regex, options2) {
    let excludeEmptyString = false;
    let message;
    let name;
    if (options2) {
      if (typeof options2 === "object") {
        ({
          excludeEmptyString = false,
          message,
          name
        } = options2);
      } else {
        message = options2;
      }
    }
    return this.test({
      name: name || "matches",
      message: message || string.matches,
      params: {
        regex
      },
      test: (value) => isAbsent(value) || value === "" && excludeEmptyString || value.search(regex) !== -1
    });
  }
  email(message = string.email) {
    return this.matches(rEmail, {
      name: "email",
      message,
      excludeEmptyString: true
    });
  }
  url(message = string.url) {
    return this.matches(rUrl, {
      name: "url",
      message,
      excludeEmptyString: true
    });
  }
  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: "uuid",
      message,
      excludeEmptyString: false
    });
  }
  ensure() {
    return this.default("").transform((val) => val === null ? "" : val);
  }
  trim(message = string.trim) {
    return this.transform((val) => val != null ? val.trim() : val).test({
      message,
      name: "trim",
      test: isTrimmed
    });
  }
  lowercase(message = string.lowercase) {
    return this.transform((value) => !isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: "string_case",
      exclusive: true,
      test: (value) => isAbsent(value) || value === value.toLowerCase()
    });
  }
  uppercase(message = string.uppercase) {
    return this.transform((value) => !isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: "string_case",
      exclusive: true,
      test: (value) => isAbsent(value) || value === value.toUpperCase()
    });
  }
}
create$2.prototype = StringSchema.prototype;
let isNaN$1 = (value) => value != +value;
function create$1() {
  return new NumberSchema();
}
class NumberSchema extends BaseSchema {
  constructor() {
    super({
      type: "number"
    });
    this.withMutation(() => {
      this.transform(function(value) {
        let parsed = value;
        if (typeof parsed === "string") {
          parsed = parsed.replace(/\s/g, "");
          if (parsed === "")
            return NaN;
          parsed = +parsed;
        }
        if (this.isType(parsed))
          return parsed;
        return parseFloat(parsed);
      });
    });
  }
  _typeCheck(value) {
    if (value instanceof Number)
      value = value.valueOf();
    return typeof value === "number" && !isNaN$1(value);
  }
  min(min2, message = number.min) {
    return this.test({
      message,
      name: "min",
      exclusive: true,
      params: {
        min: min2
      },
      test(value) {
        return isAbsent(value) || value >= this.resolve(min2);
      }
    });
  }
  max(max2, message = number.max) {
    return this.test({
      message,
      name: "max",
      exclusive: true,
      params: {
        max: max2
      },
      test(value) {
        return isAbsent(value) || value <= this.resolve(max2);
      }
    });
  }
  lessThan(less, message = number.lessThan) {
    return this.test({
      message,
      name: "max",
      exclusive: true,
      params: {
        less
      },
      test(value) {
        return isAbsent(value) || value < this.resolve(less);
      }
    });
  }
  moreThan(more, message = number.moreThan) {
    return this.test({
      message,
      name: "min",
      exclusive: true,
      params: {
        more
      },
      test(value) {
        return isAbsent(value) || value > this.resolve(more);
      }
    });
  }
  positive(msg = number.positive) {
    return this.moreThan(0, msg);
  }
  negative(msg = number.negative) {
    return this.lessThan(0, msg);
  }
  integer(message = number.integer) {
    return this.test({
      name: "integer",
      message,
      test: (val) => isAbsent(val) || Number.isInteger(val)
    });
  }
  truncate() {
    return this.transform((value) => !isAbsent(value) ? value | 0 : value);
  }
  round(method) {
    var _method;
    let avail = ["ceil", "floor", "round", "trunc"];
    method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round";
    if (method === "trunc")
      return this.truncate();
    if (avail.indexOf(method.toLowerCase()) === -1)
      throw new TypeError("Only valid options for round() are: " + avail.join(", "));
    return this.transform((value) => !isAbsent(value) ? Math[method](value) : value);
  }
}
create$1.prototype = NumberSchema.prototype;
var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date2) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11], minutesOffset = 0, timestamp, struct;
  if (struct = isoReg.exec(date2)) {
    for (var i2 = 0, k2; k2 = numericKeys[i2]; ++i2)
      struct[k2] = +struct[k2] || 0;
    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1;
    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0;
    if ((struct[8] === void 0 || struct[8] === "") && (struct[9] === void 0 || struct[9] === ""))
      timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);
    else {
      if (struct[8] !== "Z" && struct[9] !== void 0) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === "+")
          minutesOffset = 0 - minutesOffset;
      }
      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else
    timestamp = Date.parse ? Date.parse(date2) : NaN;
  return timestamp;
}
let invalidDate = new Date("");
let isDate$2 = (obj) => Object.prototype.toString.call(obj) === "[object Date]";
class DateSchema extends BaseSchema {
  constructor() {
    super({
      type: "date"
    });
    this.withMutation(() => {
      this.transform(function(value) {
        if (this.isType(value))
          return value;
        value = parseIsoDate(value);
        return !isNaN(value) ? new Date(value) : invalidDate;
      });
    });
  }
  _typeCheck(v2) {
    return isDate$2(v2) && !isNaN(v2.getTime());
  }
  prepareParam(ref, name) {
    let param;
    if (!Reference.isRef(ref)) {
      let cast = this.cast(ref);
      if (!this._typeCheck(cast))
        throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
      param = cast;
    } else {
      param = ref;
    }
    return param;
  }
  min(min2, message = date.min) {
    let limit = this.prepareParam(min2, "min");
    return this.test({
      message,
      name: "min",
      exclusive: true,
      params: {
        min: min2
      },
      test(value) {
        return isAbsent(value) || value >= this.resolve(limit);
      }
    });
  }
  max(max2, message = date.max) {
    let limit = this.prepareParam(max2, "max");
    return this.test({
      message,
      name: "max",
      exclusive: true,
      params: {
        max: max2
      },
      test(value) {
        return isAbsent(value) || value <= this.resolve(limit);
      }
    });
  }
}
DateSchema.INVALID_DATE = invalidDate;
DateSchema.prototype;
function arrayReduce$1(array2, iteratee, accumulator, initAccum) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length;
  if (initAccum && length2) {
    accumulator = array2[++index2];
  }
  while (++index2 < length2) {
    accumulator = iteratee(accumulator, array2[index2], index2, array2);
  }
  return accumulator;
}
var _arrayReduce = arrayReduce$1;
function basePropertyOf$1(object2) {
  return function(key) {
    return object2 == null ? void 0 : object2[key];
  };
}
var _basePropertyOf = basePropertyOf$1;
var basePropertyOf = _basePropertyOf;
var deburredLetters = {
  "\xC0": "A",
  "\xC1": "A",
  "\xC2": "A",
  "\xC3": "A",
  "\xC4": "A",
  "\xC5": "A",
  "\xE0": "a",
  "\xE1": "a",
  "\xE2": "a",
  "\xE3": "a",
  "\xE4": "a",
  "\xE5": "a",
  "\xC7": "C",
  "\xE7": "c",
  "\xD0": "D",
  "\xF0": "d",
  "\xC8": "E",
  "\xC9": "E",
  "\xCA": "E",
  "\xCB": "E",
  "\xE8": "e",
  "\xE9": "e",
  "\xEA": "e",
  "\xEB": "e",
  "\xCC": "I",
  "\xCD": "I",
  "\xCE": "I",
  "\xCF": "I",
  "\xEC": "i",
  "\xED": "i",
  "\xEE": "i",
  "\xEF": "i",
  "\xD1": "N",
  "\xF1": "n",
  "\xD2": "O",
  "\xD3": "O",
  "\xD4": "O",
  "\xD5": "O",
  "\xD6": "O",
  "\xD8": "O",
  "\xF2": "o",
  "\xF3": "o",
  "\xF4": "o",
  "\xF5": "o",
  "\xF6": "o",
  "\xF8": "o",
  "\xD9": "U",
  "\xDA": "U",
  "\xDB": "U",
  "\xDC": "U",
  "\xF9": "u",
  "\xFA": "u",
  "\xFB": "u",
  "\xFC": "u",
  "\xDD": "Y",
  "\xFD": "y",
  "\xFF": "y",
  "\xC6": "Ae",
  "\xE6": "ae",
  "\xDE": "Th",
  "\xFE": "th",
  "\xDF": "ss",
  "\u0100": "A",
  "\u0102": "A",
  "\u0104": "A",
  "\u0101": "a",
  "\u0103": "a",
  "\u0105": "a",
  "\u0106": "C",
  "\u0108": "C",
  "\u010A": "C",
  "\u010C": "C",
  "\u0107": "c",
  "\u0109": "c",
  "\u010B": "c",
  "\u010D": "c",
  "\u010E": "D",
  "\u0110": "D",
  "\u010F": "d",
  "\u0111": "d",
  "\u0112": "E",
  "\u0114": "E",
  "\u0116": "E",
  "\u0118": "E",
  "\u011A": "E",
  "\u0113": "e",
  "\u0115": "e",
  "\u0117": "e",
  "\u0119": "e",
  "\u011B": "e",
  "\u011C": "G",
  "\u011E": "G",
  "\u0120": "G",
  "\u0122": "G",
  "\u011D": "g",
  "\u011F": "g",
  "\u0121": "g",
  "\u0123": "g",
  "\u0124": "H",
  "\u0126": "H",
  "\u0125": "h",
  "\u0127": "h",
  "\u0128": "I",
  "\u012A": "I",
  "\u012C": "I",
  "\u012E": "I",
  "\u0130": "I",
  "\u0129": "i",
  "\u012B": "i",
  "\u012D": "i",
  "\u012F": "i",
  "\u0131": "i",
  "\u0134": "J",
  "\u0135": "j",
  "\u0136": "K",
  "\u0137": "k",
  "\u0138": "k",
  "\u0139": "L",
  "\u013B": "L",
  "\u013D": "L",
  "\u013F": "L",
  "\u0141": "L",
  "\u013A": "l",
  "\u013C": "l",
  "\u013E": "l",
  "\u0140": "l",
  "\u0142": "l",
  "\u0143": "N",
  "\u0145": "N",
  "\u0147": "N",
  "\u014A": "N",
  "\u0144": "n",
  "\u0146": "n",
  "\u0148": "n",
  "\u014B": "n",
  "\u014C": "O",
  "\u014E": "O",
  "\u0150": "O",
  "\u014D": "o",
  "\u014F": "o",
  "\u0151": "o",
  "\u0154": "R",
  "\u0156": "R",
  "\u0158": "R",
  "\u0155": "r",
  "\u0157": "r",
  "\u0159": "r",
  "\u015A": "S",
  "\u015C": "S",
  "\u015E": "S",
  "\u0160": "S",
  "\u015B": "s",
  "\u015D": "s",
  "\u015F": "s",
  "\u0161": "s",
  "\u0162": "T",
  "\u0164": "T",
  "\u0166": "T",
  "\u0163": "t",
  "\u0165": "t",
  "\u0167": "t",
  "\u0168": "U",
  "\u016A": "U",
  "\u016C": "U",
  "\u016E": "U",
  "\u0170": "U",
  "\u0172": "U",
  "\u0169": "u",
  "\u016B": "u",
  "\u016D": "u",
  "\u016F": "u",
  "\u0171": "u",
  "\u0173": "u",
  "\u0174": "W",
  "\u0175": "w",
  "\u0176": "Y",
  "\u0177": "y",
  "\u0178": "Y",
  "\u0179": "Z",
  "\u017B": "Z",
  "\u017D": "Z",
  "\u017A": "z",
  "\u017C": "z",
  "\u017E": "z",
  "\u0132": "IJ",
  "\u0133": "ij",
  "\u0152": "Oe",
  "\u0153": "oe",
  "\u0149": "'n",
  "\u017F": "s"
};
var deburrLetter$1 = basePropertyOf(deburredLetters);
var _deburrLetter = deburrLetter$1;
var deburrLetter = _deburrLetter, toString$4 = toString_1;
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
var rsComboMarksRange$3 = "\\u0300-\\u036f", reComboHalfMarksRange$3 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$3 = "\\u20d0-\\u20ff", rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3;
var rsCombo$2 = "[" + rsComboRange$3 + "]";
var reComboMark = RegExp(rsCombo$2, "g");
function deburr$1(string2) {
  string2 = toString$4(string2);
  return string2 && string2.replace(reLatin, deburrLetter).replace(reComboMark, "");
}
var deburr_1 = deburr$1;
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function asciiWords$1(string2) {
  return string2.match(reAsciiWord) || [];
}
var _asciiWords = asciiWords$1;
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function hasUnicodeWord$1(string2) {
  return reHasUnicodeWord.test(string2);
}
var _hasUnicodeWord = hasUnicodeWord$1;
var rsAstralRange$2 = "\\ud800-\\udfff", rsComboMarksRange$2 = "\\u0300-\\u036f", reComboHalfMarksRange$2 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$2 = "\\u20d0-\\u20ff", rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange$2 = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
var rsApos$1 = "['\u2019]", rsBreak = "[" + rsBreakRange + "]", rsCombo$1 = "[" + rsComboRange$2 + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange$2 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz$1 = "\\ud83c[\\udffb-\\udfff]", rsModifier$1 = "(?:" + rsCombo$1 + "|" + rsFitz$1 + ")", rsNonAstral$1 = "[^" + rsAstralRange$2 + "]", rsRegional$1 = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair$1 = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ$2 = "\\u200d";
var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos$1 + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos$1 + "(?:D|LL|M|RE|S|T|VE))?", reOptMod$1 = rsModifier$1 + "?", rsOptVar$1 = "[" + rsVarRange$2 + "]?", rsOptJoin$1 = "(?:" + rsZWJ$2 + "(?:" + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join("|") + ")" + rsOptVar$1 + reOptMod$1 + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1, rsEmoji = "(?:" + [rsDingbat, rsRegional$1, rsSurrPair$1].join("|") + ")" + rsSeq$1;
var reUnicodeWord = RegExp([
  rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
  rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
  rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
  rsUpper + "+" + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join("|"), "g");
function unicodeWords$1(string2) {
  return string2.match(reUnicodeWord) || [];
}
var _unicodeWords = unicodeWords$1;
var asciiWords = _asciiWords, hasUnicodeWord = _hasUnicodeWord, toString$3 = toString_1, unicodeWords = _unicodeWords;
function words$1(string2, pattern, guard) {
  string2 = toString$3(string2);
  pattern = guard ? void 0 : pattern;
  if (pattern === void 0) {
    return hasUnicodeWord(string2) ? unicodeWords(string2) : asciiWords(string2);
  }
  return string2.match(pattern) || [];
}
var words_1 = words$1;
var arrayReduce = _arrayReduce, deburr = deburr_1, words = words_1;
var rsApos = "['\u2019]";
var reApos = RegExp(rsApos, "g");
function createCompounder$2(callback) {
  return function(string2) {
    return arrayReduce(words(deburr(string2).replace(reApos, "")), callback, "");
  };
}
var _createCompounder = createCompounder$2;
var createCompounder$1 = _createCompounder;
var snakeCase = createCompounder$1(function(result, word, index2) {
  return result + (index2 ? "_" : "") + word.toLowerCase();
});
var snakeCase_1 = snakeCase;
function baseSlice$2(array2, start2, end2) {
  var index2 = -1, length2 = array2.length;
  if (start2 < 0) {
    start2 = -start2 > length2 ? 0 : length2 + start2;
  }
  end2 = end2 > length2 ? length2 : end2;
  if (end2 < 0) {
    end2 += length2;
  }
  length2 = start2 > end2 ? 0 : end2 - start2 >>> 0;
  start2 >>>= 0;
  var result = Array(length2);
  while (++index2 < length2) {
    result[index2] = array2[index2 + start2];
  }
  return result;
}
var _baseSlice = baseSlice$2;
var baseSlice$1 = _baseSlice;
function castSlice$1(array2, start2, end2) {
  var length2 = array2.length;
  end2 = end2 === void 0 ? length2 : end2;
  return !start2 && end2 >= length2 ? array2 : baseSlice$1(array2, start2, end2);
}
var _castSlice = castSlice$1;
var rsAstralRange$1 = "\\ud800-\\udfff", rsComboMarksRange$1 = "\\u0300-\\u036f", reComboHalfMarksRange$1 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$1 = "\\u20d0-\\u20ff", rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1, rsVarRange$1 = "\\ufe0e\\ufe0f";
var rsZWJ$1 = "\\u200d";
var reHasUnicode = RegExp("[" + rsZWJ$1 + rsAstralRange$1 + rsComboRange$1 + rsVarRange$1 + "]");
function hasUnicode$2(string2) {
  return reHasUnicode.test(string2);
}
var _hasUnicode = hasUnicode$2;
function asciiToArray$1(string2) {
  return string2.split("");
}
var _asciiToArray = asciiToArray$1;
var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f";
var rsAstral = "[" + rsAstralRange + "]", rsCombo = "[" + rsComboRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsZWJ = "\\u200d";
var reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
function unicodeToArray$1(string2) {
  return string2.match(reUnicode) || [];
}
var _unicodeToArray = unicodeToArray$1;
var asciiToArray = _asciiToArray, hasUnicode$1 = _hasUnicode, unicodeToArray = _unicodeToArray;
function stringToArray$1(string2) {
  return hasUnicode$1(string2) ? unicodeToArray(string2) : asciiToArray(string2);
}
var _stringToArray = stringToArray$1;
var castSlice = _castSlice, hasUnicode = _hasUnicode, stringToArray = _stringToArray, toString$2 = toString_1;
function createCaseFirst$1(methodName) {
  return function(string2) {
    string2 = toString$2(string2);
    var strSymbols = hasUnicode(string2) ? stringToArray(string2) : void 0;
    var chr = strSymbols ? strSymbols[0] : string2.charAt(0);
    var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string2.slice(1);
    return chr[methodName]() + trailing;
  };
}
var _createCaseFirst = createCaseFirst$1;
var createCaseFirst = _createCaseFirst;
var upperFirst$1 = createCaseFirst("toUpperCase");
var upperFirst_1 = upperFirst$1;
var toString$1 = toString_1, upperFirst = upperFirst_1;
function capitalize$1(string2) {
  return upperFirst(toString$1(string2).toLowerCase());
}
var capitalize_1 = capitalize$1;
var capitalize = capitalize_1, createCompounder = _createCompounder;
var camelCase = createCompounder(function(result, word, index2) {
  word = word.toLowerCase();
  return result + (index2 ? capitalize(word) : word);
});
var camelCase_1 = camelCase;
var baseAssignValue$1 = _baseAssignValue, baseForOwn$1 = _baseForOwn, baseIteratee$2 = _baseIteratee;
function mapKeys(object2, iteratee) {
  var result = {};
  iteratee = baseIteratee$2(iteratee);
  baseForOwn$1(object2, function(value, key, object3) {
    baseAssignValue$1(result, iteratee(value, key, object3), value);
  });
  return result;
}
var mapKeys_1 = mapKeys;
var toposort$2 = { exports: {} };
toposort$2.exports = function(edges) {
  return toposort(uniqueNodes(edges), edges);
};
toposort$2.exports.array = toposort;
function toposort(nodes, edges) {
  var cursor2 = nodes.length, sorted = new Array(cursor2), visited = {}, i2 = cursor2, outgoingEdges = makeOutgoingEdges(edges), nodesHash = makeNodesHash(nodes);
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    }
  });
  while (i2--) {
    if (!visited[i2])
      visit(nodes[i2], i2, new Set());
  }
  return sorted;
  function visit(node2, i3, predecessors) {
    if (predecessors.has(node2)) {
      var nodeRep;
      try {
        nodeRep = ", node was:" + JSON.stringify(node2);
      } catch (e2) {
        nodeRep = "";
      }
      throw new Error("Cyclic dependency" + nodeRep);
    }
    if (!nodesHash.has(node2)) {
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node2));
    }
    if (visited[i3])
      return;
    visited[i3] = true;
    var outgoing = outgoingEdges.get(node2) || new Set();
    outgoing = Array.from(outgoing);
    if (i3 = outgoing.length) {
      predecessors.add(node2);
      do {
        var child = outgoing[--i3];
        visit(child, nodesHash.get(child), predecessors);
      } while (i3);
      predecessors.delete(node2);
    }
    sorted[--cursor2] = node2;
  }
}
function uniqueNodes(arr) {
  var res = new Set();
  for (var i2 = 0, len = arr.length; i2 < len; i2++) {
    var edge = arr[i2];
    res.add(edge[0]);
    res.add(edge[1]);
  }
  return Array.from(res);
}
function makeOutgoingEdges(arr) {
  var edges = new Map();
  for (var i2 = 0, len = arr.length; i2 < len; i2++) {
    var edge = arr[i2];
    if (!edges.has(edge[0]))
      edges.set(edge[0], new Set());
    if (!edges.has(edge[1]))
      edges.set(edge[1], new Set());
    edges.get(edge[0]).add(edge[1]);
  }
  return edges;
}
function makeNodesHash(arr) {
  var res = new Map();
  for (var i2 = 0, len = arr.length; i2 < len; i2++) {
    res.set(arr[i2], i2);
  }
  return res;
}
var toposort$1 = toposort$2.exports;
function sortFields(fields, excludedEdges = []) {
  let edges = [];
  let nodes = new Set();
  let excludes = new Set(excludedEdges.map(([a2, b2]) => `${a2}-${b2}`));
  function addNode(depPath, key) {
    let node2 = propertyExpr.split(depPath)[0];
    nodes.add(node2);
    if (!excludes.has(`${key}-${node2}`))
      edges.push([key, node2]);
  }
  for (const key in fields)
    if (has_1(fields, key)) {
      let value = fields[key];
      nodes.add(key);
      if (Reference.isRef(value) && value.isSibling)
        addNode(value.path, key);
      else if (isSchema(value) && "deps" in value)
        value.deps.forEach((path) => addNode(path, key));
    }
  return toposort$1.array(Array.from(nodes), edges).reverse();
}
function findIndex$1(arr, err) {
  let idx = Infinity;
  arr.some((key, ii2) => {
    var _err$path;
    if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
      idx = ii2;
      return true;
    }
  });
  return idx;
}
function sortByKeyOrder(keys2) {
  return (a2, b2) => {
    return findIndex$1(keys2, a2) - findIndex$1(keys2, b2);
  };
}
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source2 = arguments[i2];
      for (var key in source2) {
        if (Object.prototype.hasOwnProperty.call(source2, key)) {
          target[key] = source2[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
let isObject$3 = (obj) => Object.prototype.toString.call(obj) === "[object Object]";
function unknown(ctx, value) {
  let known = Object.keys(ctx.fields);
  return Object.keys(value).filter((key) => known.indexOf(key) === -1);
}
const defaultSort = sortByKeyOrder([]);
class ObjectSchema extends BaseSchema {
  constructor(spec) {
    super({
      type: "object"
    });
    this.fields = Object.create(null);
    this._sortErrors = defaultSort;
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(() => {
      this.transform(function coerce(value) {
        if (typeof value === "string") {
          try {
            value = JSON.parse(value);
          } catch (err) {
            value = null;
          }
        }
        if (this.isType(value))
          return value;
        return null;
      });
      if (spec) {
        this.shape(spec);
      }
    });
  }
  _typeCheck(value) {
    return isObject$3(value) || typeof value === "function";
  }
  _cast(_value, options2 = {}) {
    var _options$stripUnknown;
    let value = super._cast(_value, options2);
    if (value === void 0)
      return this.getDefault();
    if (!this._typeCheck(value))
      return value;
    let fields = this.fields;
    let strip = (_options$stripUnknown = options2.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
    let props = this._nodes.concat(Object.keys(value).filter((v2) => this._nodes.indexOf(v2) === -1));
    let intermediateValue = {};
    let innerOptions = _extends({}, options2, {
      parent: intermediateValue,
      __validating: options2.__validating || false
    });
    let isChanged = false;
    for (const prop of props) {
      let field = fields[prop];
      let exists = has_1(value, prop);
      if (field) {
        let fieldValue;
        let inputValue = value[prop];
        innerOptions.path = (options2.path ? `${options2.path}.` : "") + prop;
        field = field.resolve({
          value: inputValue,
          context: options2.context,
          parent: intermediateValue
        });
        let fieldSpec = "spec" in field ? field.spec : void 0;
        let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
        if (fieldSpec == null ? void 0 : fieldSpec.strip) {
          isChanged = isChanged || prop in value;
          continue;
        }
        fieldValue = !options2.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
        if (fieldValue !== void 0) {
          intermediateValue[prop] = fieldValue;
        }
      } else if (exists && !strip) {
        intermediateValue[prop] = value[prop];
      }
      if (intermediateValue[prop] !== value[prop]) {
        isChanged = true;
      }
    }
    return isChanged ? intermediateValue : value;
  }
  _validate(_value, opts = {}, callback) {
    let errors = [];
    let {
      sync,
      from: from2 = [],
      originalValue = _value,
      abortEarly = this.spec.abortEarly,
      recursive = this.spec.recursive
    } = opts;
    from2 = [{
      schema: this,
      value: originalValue
    }, ...from2];
    opts.__validating = true;
    opts.originalValue = originalValue;
    opts.from = from2;
    super._validate(_value, opts, (err, value) => {
      if (err) {
        if (!ValidationError.isError(err) || abortEarly) {
          return void callback(err, value);
        }
        errors.push(err);
      }
      if (!recursive || !isObject$3(value)) {
        callback(errors[0] || null, value);
        return;
      }
      originalValue = originalValue || value;
      let tests = this._nodes.map((key) => (_23, cb2) => {
        let path = key.indexOf(".") === -1 ? (opts.path ? `${opts.path}.` : "") + key : `${opts.path || ""}["${key}"]`;
        let field = this.fields[key];
        if (field && "validate" in field) {
          field.validate(value[key], _extends({}, opts, {
            path,
            from: from2,
            strict: true,
            parent: value,
            originalValue: originalValue[key]
          }), cb2);
          return;
        }
        cb2(null);
      });
      runTests({
        sync,
        tests,
        value,
        errors,
        endEarly: abortEarly,
        sort: this._sortErrors,
        path: opts.path
      }, callback);
    });
  }
  clone(spec) {
    const next2 = super.clone(spec);
    next2.fields = _extends({}, this.fields);
    next2._nodes = this._nodes;
    next2._excludedEdges = this._excludedEdges;
    next2._sortErrors = this._sortErrors;
    return next2;
  }
  concat(schema2) {
    let next2 = super.concat(schema2);
    let nextFields = next2.fields;
    for (let [field, schemaOrRef] of Object.entries(this.fields)) {
      const target = nextFields[field];
      if (target === void 0) {
        nextFields[field] = schemaOrRef;
      } else if (target instanceof BaseSchema && schemaOrRef instanceof BaseSchema) {
        nextFields[field] = schemaOrRef.concat(target);
      }
    }
    return next2.withMutation(() => next2.shape(nextFields, this._excludedEdges));
  }
  getDefaultFromShape() {
    let dft = {};
    this._nodes.forEach((key) => {
      const field = this.fields[key];
      dft[key] = "default" in field ? field.getDefault() : void 0;
    });
    return dft;
  }
  _getDefault() {
    if ("default" in this.spec) {
      return super._getDefault();
    }
    if (!this._nodes.length) {
      return void 0;
    }
    return this.getDefaultFromShape();
  }
  shape(additions, excludes = []) {
    let next2 = this.clone();
    let fields = Object.assign(next2.fields, additions);
    next2.fields = fields;
    next2._sortErrors = sortByKeyOrder(Object.keys(fields));
    if (excludes.length) {
      if (!Array.isArray(excludes[0]))
        excludes = [excludes];
      next2._excludedEdges = [...next2._excludedEdges, ...excludes];
    }
    next2._nodes = sortFields(fields, next2._excludedEdges);
    return next2;
  }
  pick(keys2) {
    const picked = {};
    for (const key of keys2) {
      if (this.fields[key])
        picked[key] = this.fields[key];
    }
    return this.clone().withMutation((next2) => {
      next2.fields = {};
      return next2.shape(picked);
    });
  }
  omit(keys2) {
    const next2 = this.clone();
    const fields = next2.fields;
    next2.fields = {};
    for (const key of keys2) {
      delete fields[key];
    }
    return next2.withMutation(() => next2.shape(fields));
  }
  from(from2, to, alias) {
    let fromGetter = propertyExpr.getter(from2, true);
    return this.transform((obj) => {
      if (obj == null)
        return obj;
      let newObj = obj;
      if (has_1(obj, from2)) {
        newObj = _extends({}, obj);
        if (!alias)
          delete newObj[from2];
        newObj[to] = fromGetter(obj);
      }
      return newObj;
    });
  }
  noUnknown(noAllow = true, message = object.noUnknown) {
    if (typeof noAllow === "string") {
      message = noAllow;
      noAllow = true;
    }
    let next2 = this.test({
      name: "noUnknown",
      exclusive: true,
      message,
      test(value) {
        if (value == null)
          return true;
        const unknownKeys = unknown(this.schema, value);
        return !noAllow || unknownKeys.length === 0 || this.createError({
          params: {
            unknown: unknownKeys.join(", ")
          }
        });
      }
    });
    next2.spec.noUnknown = noAllow;
    return next2;
  }
  unknown(allow = true, message = object.noUnknown) {
    return this.noUnknown(!allow, message);
  }
  transformKeys(fn2) {
    return this.transform((obj) => obj && mapKeys_1(obj, (_23, key) => fn2(key)));
  }
  camelCase() {
    return this.transformKeys(camelCase_1);
  }
  snakeCase() {
    return this.transformKeys(snakeCase_1);
  }
  constantCase() {
    return this.transformKeys((key) => snakeCase_1(key).toUpperCase());
  }
  describe() {
    let base = super.describe();
    base.fields = mapValues_1(this.fields, (value) => value.describe());
    return base;
  }
}
function create(spec) {
  return new ObjectSchema(spec);
}
create.prototype = ObjectSchema.prototype;
const schema$2 = create().shape({
  phoneNumber: create$2().matches(/^\d{10}$/, {
    excludeEmptyString: true,
    message: "PhoneNumberMatchError"
  })
});
function ModalPhoneNumber({
  isOpen,
  onClose,
  onSubmit
}) {
  var _a2, _b;
  const {
    t: t2
  } = useTranslation();
  const {
    control,
    formState: {
      errors
    },
    handleSubmit
  } = useForm({
    resolver: o(schema$2),
    defaultValues: {
      phoneNumber: ""
    }
  });
  const phoneNumber = useWatch({
    control,
    name: "phoneNumber"
  });
  const submitForm = async (formData) => {
    await onSubmit(formData);
  };
  return /* @__PURE__ */ jsx$1(Modal, {
    isOpen,
    size: "medium",
    isClickOverlayToClose: false,
    onClose,
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-flex-col",
      children: [/* @__PURE__ */ jsx$1("img", {
        src: MODAL_PHONE_NUBMER_COVER,
        className: "tw-mx-auto tw-w-[383px] tw-h-auto",
        alt: "Cover"
      }), /* @__PURE__ */ jsx$1("h3", {
        className: "tw-mt-4 tw-text-[28px] tw-font-medium tw-leading-10 tw-text-center tw-text-Gray-800",
        children: t2("modalPhoneNumber.title")
      }), /* @__PURE__ */ jsxs("p", {
        className: "tw-mt-6 tw-text-base tw-font-medium tw-text-center tw-text-Gray-800",
        children: [t2("modalPhoneNumber.description1"), /* @__PURE__ */ jsx$1("br", {}), t2("modalPhoneNumber.description2")]
      }), /* @__PURE__ */ jsxs("form", {
        className: "tw-mt-4",
        onSubmit: handleSubmit(submitForm),
        children: [/* @__PURE__ */ jsx$1("label", {
          htmlFor: "phoneNumber",
          className: "tw-mb-1 tw-text-sm tw-font-medium tw-text-Gray-600",
          children: t2("modalPhoneNumber.label")
        }), /* @__PURE__ */ jsx$1(Controller, {
          name: "phoneNumber",
          control,
          render: ({
            field: {
              onBlur,
              onChange: onChange2,
              value
            }
          }) => {
            var _a3, _b2;
            return /* @__PURE__ */ jsx$1(TextField$2, {
              type: "text",
              id: "phoneNumber",
              placeholder: t2("modalPhoneNumber.placeholder"),
              value,
              isError: Boolean((_b2 = (_a3 = errors == null ? void 0 : errors.phoneNumber) == null ? void 0 : _a3.message) == null ? void 0 : _b2.length),
              onBlur,
              handleChange: onChange2
            });
          }
        }), /* @__PURE__ */ jsx$1("p", {
          className: "tw-mt-1 tw-h-4 tw-text-xs tw-text-Red",
          children: ((_b = (_a2 = errors == null ? void 0 : errors.phoneNumber) == null ? void 0 : _a2.message) == null ? void 0 : _b.length) ? t2("modalPhoneNumber.errorMessage") : ""
        }), /* @__PURE__ */ jsxs("div", {
          className: "tw-flex tw-justify-between tw-mt-6",
          children: [/* @__PURE__ */ jsx$1(Button, {
            type: "button",
            variant: "text",
            size: "fullWidth",
            onClick: onClose,
            children: t2("modalPhoneNumber.cancel")
          }), /* @__PURE__ */ jsx$1(Button, {
            type: "submit",
            size: "fullWidth",
            className: "tw-ml-4",
            disabled: !(phoneNumber == null ? void 0 : phoneNumber.length),
            children: t2("modalPhoneNumber.submit")
          })]
        })]
      })]
    })
  });
}
const IS_ENTERPRISE_PAGE_ENABLED = {}.REACT_APP_ENTERPRISE_PAGE_ENABLE === "true";
const DISCORD_URL = {}.REACT_APP_DISCORD_URL || "/";
const FACEBOOK_URL = {}.REACT_APP_FACEBOOK_URL || "/";
const TELEGRAM_URL = {}.REACT_APP_TELEGRAM_URL || "/";
const TWITTER_URL = {}.REACT_APP_TWITTER_URL || "/";
const MODAL_PHONE_NUMBER_STORAGE_KEY = "modalPhonenumber";
const socialLinks = [{
  icon: IconName.FACEBOOK,
  url: FACEBOOK_URL
}, {
  icon: IconName.TWITTER,
  url: TWITTER_URL
}, {
  icon: IconName.TELEGRAM,
  url: TELEGRAM_URL
}, {
  icon: IconName.DISCORD,
  url: DISCORD_URL
}];
const getUsernameTextColor = (isNFT, isMobile, isHideTopMenu) => {
  if (isNFT && isMobile && !isHideTopMenu) {
    return COLORS.Gray[800];
  }
  if (isNFT) {
    return COLORS.NFTGhostWhite;
  }
  return COLORS.Gray[800];
};
const getLogoutIconColor = (isNFT, isMobile, isHideTopMenu) => {
  if (isNFT && isMobile && !isHideTopMenu) {
    return "tw-fill-NFTBrandeisBlue";
  }
  if (isNFT) {
    return "tw-fill-NFTGhostWhite";
  }
  return "tw-fill-Primary-600";
};
const getLogoutTextColor = (isNFT, isMobile, isHideTopMenu) => {
  if (isNFT && isMobile && !isHideTopMenu) {
    return COLORS.NFTBrandeisBlue;
  }
  if (isNFT) {
    return COLORS.NFTGhostWhite;
  }
  return COLORS.Primary[600];
};
const getSidebarBackground = (condition) => {
  if (!condition) {
    return void 0;
  }
  return {
    backgroundImage: `url("${NFT_SIDEBAR_BACKGROUND}")`
  };
};
function SidebarCreateStore({
  hasStore = false,
  userName = "",
  isNFTMode = false,
  isHideTopBarMenu = false,
  logout
}) {
  const {
    t: t2
  } = useTranslation();
  const {
    isMobile,
    isDesktop,
    isFullScreen
  } = useScreenSize();
  const sidebarBackgroundStyles = getSidebarBackground(isNFTMode && (isDesktop || isFullScreen));
  return /* @__PURE__ */ jsx$1("div", {
    className: classNames$1("tw-box-border tw-px-3 tw-pt-6 tw-pb-10 tw-w-screen tw-h-fit tw-bg-Gray-100 tw-overflow-hidden tablet:tw-px-12 tablet:tw-pt-12 tablet:tw-pb-10 tablet:tw-w-screen tablet:tw-h-fit tablet:tw-bg-Gray-100 desktop:tw-px-9 desktop:tw-pt-12 desktop:tw-pb-8 desktop:tw-w-1/3 desktop:tw-h-screen desktop:tw-bg-White", {
      "desktop:tw-relative desktop:tw-bg-NFTBrandeisBlue desktop:before:tw-content-[' '] desktop:before:tw-absolute desktop:before:tw-top-0 desktop:before:tw-left-0 desktop:before:tw-w-full desktop:before:tw-h-full desktop:before:tw-bg-nft-gradient-sidebar": isNFTMode
    }),
    style: sidebarBackgroundStyles,
    children: /* @__PURE__ */ jsxs("div", {
      className: classNames$1("tw-relative tw-h-full", {
        "tw-hidden desktop:tw-block": isNFTMode && isHideTopBarMenu
      }),
      children: [/* @__PURE__ */ jsx$1("img", {
        className: classNames$1("tw-hidden desktop:tw-block desktop:tw-w-1/4", {
          "desktop:tw-w-[38px] desktop:tw-h-[38px]": isNFTMode
        }),
        src: isNFTMode ? NFT_LOGO_IMAGE : DEEPLE_LOGO_IMAGE,
        alt: isNFTMode ? "nft-logo" : "deeple-logo"
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-overflow-x-hidden tw-overflow-y-auto tw-flex-col tw-h-full tw-max-h-fit",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "tw-hidden desktop:tw-block desktop:tw-overflow-y-auto desktop:tw-h-full",
          children: [/* @__PURE__ */ jsx$1(Typography, {
            className: classNames$1("tw-pb-8", {
              "tw-pt-6 tw-leading-[59px]": isNFTMode,
              "tw-pt-16": !isNFTMode
            }),
            variant: isNFTMode ? "heading-3" : "heading-6",
            color: isNFTMode ? COLORS.NFTGhostWhite : COLORS.Gray[800],
            children: isNFTMode ? t2("createStore.nft.sideBar.title") : t2("createStore.sideBar.title")
          }), /* @__PURE__ */ jsx$1(Typography, {
            className: classNames$1("tw-pb-4", {
              "tw-font-normal tw-leading-[26px]": isNFTMode
            }),
            color: isNFTMode ? COLORS.NFTGhostWhite : COLORS.Gray[500],
            variant: "title-7",
            children: t2("createStore.sideBar.paragraph1", {
              name: userName.split(" ")[0]
            })
          }), /* @__PURE__ */ jsx$1(Typography, {
            className: classNames$1({
              "tw-pb-4": hasStore,
              "tw-pb-8": !hasStore,
              "tw-pb-0 tw-font-normal tw-leading-[26px]": isNFTMode
            }),
            color: isNFTMode ? COLORS.NFTGhostWhite : COLORS.Gray[500],
            variant: "title-7",
            children: t2(hasStore ? "createStore.sideBar.paragraph3" : "createStore.sideBar.paragraph2")
          }), /* @__PURE__ */ jsx$1("img", {
            className: isNFTMode ? "tw-hidden" : "tw-w-[300px]",
            src: hasStore ? WELCOME_GRAPHIC : SHIPPING_GRAPHIC,
            alt: "deeple-logo"
          })]
        }), /* @__PURE__ */ jsxs("div", {
          className: classNames$1("tw-inline-flex tw-flex-row tw-items-center tw-w-full desktop:tw-pb-8", {
            "desktop:tw-pb-5": isNFTMode
          }),
          children: [/* @__PURE__ */ jsxs("div", {
            className: "tw-inline-flex tw-basis-2/4 tw-items-center",
            children: [/* @__PURE__ */ jsx$1("div", {
              className: classNames$1("tw-hidden desktop:tw-flex desktop:tw-justify-center desktop:tw-items-center desktop:tw-rounded-full desktop:tw-w-10 desktop:tw-h-10 desktop:tw-bg-Gray-100", {
                "desktop:tw-w-[42px] desktop:tw-h-[42px] desktop:tw-text-Gray-400": isNFTMode
              }),
              children: userName.substring(0, 2)
            }), /* @__PURE__ */ jsx$1(Typography, {
              className: "desktop:tw-pl-2",
              variant: "title-9",
              color: getUsernameTextColor(isNFTMode, isMobile, isHideTopBarMenu),
              children: t2(userName)
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: "tw-inline-flex tw-basis-2/4 tw-justify-end tw-items-center tw-w-fit tw-cursor-pointer",
            onClick: logout,
            children: [/* @__PURE__ */ jsx$1(Icon, {
              className: getLogoutIconColor(isNFTMode, isMobile, isHideTopBarMenu),
              name: IconName.LOGOUT,
              size: IconSize.DEFAULT
            }), /* @__PURE__ */ jsx$1(Typography, {
              className: "tw-pl-1",
              variant: "title-9",
              color: getLogoutTextColor(isNFTMode, isMobile, isHideTopBarMenu),
              children: t2("createStore.sideBar.logout")
            })]
          })]
        }), isNFTMode && /* @__PURE__ */ jsxs("div", {
          className: "tw-hidden desktop:tw-flex desktop:tw-justify-between desktop:tw-items-center desktop:tw-pt-4 desktop:tw-pb-8 desktop:tw-border-t desktop:tw-border-White desktop:tw-border-solid",
          children: [/* @__PURE__ */ jsx$1(Typography, {
            variant: "title-9",
            color: COLORS.NFTGhostWhite,
            children: t2("createStore.nft.contactLinks.title")
          }), /* @__PURE__ */ jsx$1("ul", {
            className: "tw-inline-flex tw-items-center",
            children: socialLinks.map(({
              icon,
              url
            }) => /* @__PURE__ */ jsx$1("li", {
              className: "tw-ml-4 first:tw-ml-0",
              children: /* @__PURE__ */ jsx$1("a", {
                href: url,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ jsx$1(Icon, {
                  className: "tw-fill-NFTGhostWhite",
                  name: icon,
                  size: IconSize.MEDIUM
                })
              })
            }, `${icon}_icon`))
          })]
        })]
      })]
    })
  });
}
const CREATE_PROJECT = gql$1`
  mutation (
    $projectName: String!
    $image: String
    $businessType: BusinessType!
    $customBusinessType: String
    $refCode: String
  ) {
    createProject(
      projectName: $projectName
      image: $image
      businessType: $businessType
      customBusinessType: $customBusinessType
      refCode: $refCode
    ) {
      projectId
    }
  }
`;
const LOGOUT = gql$1`
  mutation logout {
    logout @client {
      me
    }
  }
`;
const UPDATE_USER_PHONE_NUMBER = gql$1`
  mutation ($phoneNumber: String) {
    updateUser(phoneNumber: $phoneNumber) {
      id
      phoneNumber
    }
  }
`;
const USER = gql$1`
  query user($projectId: ID) {
    me(projectId: $projectId) {
      id
      email
      displayName
      avatar
      firstname
      lastname
      language
      isEmailVerified
      phoneNumber
      permissions {
        id
        projectId
        projectName
        projectLogo
        role
        isEnterprise
        isGuidelineCompleted
        isDisabled
        isInitialProjectCompleted
      }
      isAllowedToCreateProject
      isAccepted
      acceptedAt
    }
  }
`;
const USER_WITHOUT_IS_ENTERPRISE = gql$1`
  query user($projectId: ID) {
    me(projectId: $projectId) {
      id
      email
      displayName
      avatar
      firstname
      lastname
      language
      isEmailVerified
      phoneNumber
      permissions {
        id
        projectId
        projectName
        projectLogo
        role
        isGuidelineCompleted
        isDisabled
        isInitialProjectCompleted
      }
      isAllowedToCreateProject
      isAccepted
      acceptedAt
    }
  }
`;
const FLAG_USER_WITH_IS_ENTERPRISE = IS_ENTERPRISE_PAGE_ENABLED ? USER : USER_WITHOUT_IS_ENTERPRISE;
function addModalPhoneNumberStore() {
  localStorage.setItem(MODAL_PHONE_NUMBER_STORAGE_KEY, "true");
}
function hasModalPhoneNumberStore() {
  const storeValue = localStorage.getItem(MODAL_PHONE_NUMBER_STORAGE_KEY);
  return Boolean(storeValue);
}
function removeModalPhoneNumberStore() {
  localStorage.removeItem(MODAL_PHONE_NUMBER_STORAGE_KEY);
}
const TOKEN_LOCAL_STORAGE_KEY = "deepleid";
const removeToken = () => {
  localStorage.removeItem(TOKEN_LOCAL_STORAGE_KEY);
};
const useLogout = () => {
  const client = useApolloClient();
  const [logoutService] = useMutation(LOGOUT);
  const logout = async () => {
    removeToken();
    removeModalPhoneNumberStore();
    await logoutService();
    await client.resetStore();
  };
  return logout;
};
function CreateStore({
  isShowModalCongratulations,
  isShowModalPrivacyPolicy
}) {
  var _a2, _b, _c, _d, _e2, _f, _g, _h, _i;
  const {
    t: t2
  } = useTranslation();
  const logout = useLogout();
  const {
    isNFTMode
  } = useTheme();
  const [isShowModalPhoneNumber, setIsShowModalPhoneNumber] = useState(false);
  const {
    data: data2,
    loading
  } = useQuery(FLAG_USER_WITH_IS_ENTERPRISE);
  const [createStore] = useMutation(CREATE_PROJECT, {
    onError: (error2) => console.error(error2)
  });
  const [updateUserPhoneNumber] = useMutation(UPDATE_USER_PHONE_NUMBER);
  const projects = (_b = (_a2 = data2 == null ? void 0 : data2.me) == null ? void 0 : _a2.permissions) != null ? _b : [];
  const customerName = (_d = (_c = data2 == null ? void 0 : data2.me) == null ? void 0 : _c.displayName) != null ? _d : "";
  const phoneNumber = (_f = (_e2 = data2 == null ? void 0 : data2.me) == null ? void 0 : _e2.phoneNumber) != null ? _f : "";
  const isAllowedToCreateProject = (_h = (_g = data2 == null ? void 0 : data2.me) == null ? void 0 : _g.isAllowedToCreateProject) != null ? _h : false;
  const hasStore = !lodash.exports.isEmpty(projects);
  const isAccepted = Boolean((_i = data2 == null ? void 0 : data2.me) == null ? void 0 : _i.isAccepted);
  const isNotAccepted = !isAccepted;
  const storeList = projects.map(({
    projectLogo,
    projectName,
    projectId
  }) => ({
    storeName: projectName,
    image: projectLogo,
    projectId
  }));
  const popupModalPhoneNumber = () => {
    if (isShowModalCongratulations) {
      removeModalPhoneNumberStore();
    }
    if (loading || isNotAccepted || isShowModalPrivacyPolicy || isShowModalCongratulations || phoneNumber.length || hasModalPhoneNumberStore()) {
      return;
    }
    addModalPhoneNumberStore();
    setIsShowModalPhoneNumber(true);
  };
  const createProject = async (value) => {
    const data22 = await createStore({
      variables: __spreadProps(__spreadValues({}, value), {
        image: ""
      })
    });
    const projectId = lodash.exports.get(data22, "data.createProject.projectId");
    if (!projectId) {
      window.location.reload();
    }
    addGoogleTagEvent(GTM_EVENT.CREATE_STORE, {
      [GTM_VARIABLE_NAME.TYPE_OF_BUSINESS]: value.customBusinessType || value.businessType
    });
    window.location.replace(`/${PROJECT}/${projectId}/get-started`);
  };
  const handleCloseModalPhoneNumber = () => {
    setIsShowModalPhoneNumber(false);
  };
  const handleSubmitModalPhoneNumber = async (data22) => {
    try {
      const {
        phoneNumber: phoneNumber2
      } = data22;
      setIsShowModalPhoneNumber(false);
      await updateUserPhoneNumber({
        variables: {
          phoneNumber: phoneNumber2
        }
      });
      notifySuccess(t2("notify.update.success"));
    } catch (error2) {
      notifyError(t2("notify.update.fail"));
    }
  };
  useEffect(() => {
    popupModalPhoneNumber();
  }, [phoneNumber, isAccepted, isShowModalCongratulations, isShowModalPrivacyPolicy]);
  return /* @__PURE__ */ jsxs("div", {
    className: "tw-flex tw-flex-col tw-w-screen tw-h-screen desktop:tw-inline-flex desktop:tw-flex-row",
    children: [/* @__PURE__ */ jsx$1(SidebarCreateStore, {
      hasStore,
      logout,
      userName: customerName,
      isNFTMode,
      isHideTopBarMenu: lodash.exports.isEmpty(storeList)
    }), /* @__PURE__ */ jsx$1(CreateStoreDetail, {
      className: "tw-flex-1",
      createProject,
      isAllowedToCreateProject,
      storeList,
      isNFTMode
    }), /* @__PURE__ */ jsx$1(ModalPhoneNumber, {
      isOpen: isShowModalPhoneNumber,
      onClose: handleCloseModalPhoneNumber,
      onSubmit: handleSubmitModalPhoneNumber
    })]
  });
}
function Page$5({
  isShowModalCongratulations,
  isShowModalPrivacyPolicy
}) {
  return /* @__PURE__ */ jsx$1(ContextProviders, {
    children: /* @__PURE__ */ jsx$1(CreateStore, {
      isShowModalCongratulations,
      isShowModalPrivacyPolicy
    })
  });
}
function Switch(_z) {
  var _A = _z, {
    disabled = false,
    handleChange = () => {
    },
    id: id2 = nanoid()
  } = _A, restProps = __objRest(_A, [
    "disabled",
    "handleChange",
    "id"
  ]);
  return /* @__PURE__ */ jsx$1("div", {
    className: "tw-inline-block tw-relative tw-w-[39px] tw-h-6",
    children: /* @__PURE__ */ jsxs("label", {
      htmlFor: id2,
      className: "tw-relative",
      children: [/* @__PURE__ */ jsx$1("input", __spreadValues({
        type: "checkbox",
        id: id2,
        className: "tw-peer tw-cursor-pointer",
        hidden: true,
        disabled,
        onClick: (e2) => handleChange(e2.currentTarget.checked)
      }, restProps)), /* @__PURE__ */ jsx$1("div", {
        className: "tw-relative before:tw-absolute before:tw-top-[1px] before:tw-left-[1px] peer-checked:before:tw-left-[calc(100%-23px)] tw-w-full before:tw-w-[22px] tw-h-full before:tw-h-[22px] before:tw-content-[''] tw-bg-Gray-400 before:tw-bg-White peer-checked:tw-bg-Primary-500 peer-disabled:peer-checked:before:tw-bg-LightNudePrimary peer-disabled:peer-checked:tw-bg-DarkNudePrimary peer-disabled:tw-bg-Gray-200 peer-disabled:before:tw-bg-Gray-100 tw-rounded-full before:tw-rounded-full tw-transition-all tw-cursor-pointer peer-disabled:tw-cursor-not-allowed "
      })]
    })
  });
}
var Switch$1 = forwardRef(Switch);
const CancelProductModal = ({
  isOpenCancelModal,
  handleClose,
  confirm,
  cancel
}) => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx$1(Modal, {
    isOpen: isOpenCancelModal,
    onClose: handleClose,
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-p-6 tw-text-center",
      children: [/* @__PURE__ */ jsx$1(Typography, {
        variant: "title-3",
        className: "tw-pb-4",
        children: t2("product.modal.cancel.title")
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-3",
        className: "tw-pb-8",
        children: t2("product.modal.cancel.detail")
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-grid tw-justify-items-center mobile:tw-grid-cols-1 tablet:tw-grid-cols-2",
        children: [/* @__PURE__ */ jsx$1(Button, {
          onClick: cancel,
          className: "mobile:tw-mt-4 mobile:tw-w-full tablet:tw-mt-0 tablet:tw-w-fit",
          variant: "secondary",
          children: t2("product.category.cancel")
        }), /* @__PURE__ */ jsx$1(Button, {
          onClick: confirm,
          className: "mobile:tw-mt-4 mobile:tw-w-full tablet:tw-mt-0 tablet:tw-w-fit",
          variant: "primary",
          children: t2("product.modal.cancel.confirm")
        })]
      })]
    })
  });
};
CancelProductModal.displayName = "CancelProductModal";
const CreateCategoryModal = ({
  isOpenCategoryModal,
  handleClose,
  confirm,
  cancel
}) => {
  var _a2;
  const {
    t: t2
  } = useTranslation();
  const {
    register,
    handleSubmit,
    unregister,
    formState: {
      errors
    },
    setValue
  } = useForm();
  const [categoryName, setCategoryName] = useState("");
  const handleCancelModal = () => {
    unregister("categoryName");
    cancel();
  };
  const submitField = () => {
    void confirm(categoryName);
    setCategoryName("");
  };
  useEffect(() => {
    register("categoryName", {
      required: "product.error.required"
    });
  }, [register]);
  return /* @__PURE__ */ jsx$1(Modal, {
    className: "mobile:tw-min-w-fit tablet:tw-min-w-[30%]",
    isOpen: isOpenCategoryModal,
    onClose: handleClose,
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-px-6",
      children: [/* @__PURE__ */ jsx$1("div", {
        className: "tw-text-left mobile:tw-pt-4 tablet:tw-pt-12",
        children: /* @__PURE__ */ jsx$1(Typography, {
          variant: "title-3",
          className: "tw-pb-4",
          children: t2("product.category.create")
        })
      }), /* @__PURE__ */ jsx$1("div", {
        className: "mobile:tw-py-4 tablet:tw-pt-8 tablet:tw-pb-12",
        children: /* @__PURE__ */ jsx$1(FormInput, {
          value: categoryName,
          label: t2("product.category.name"),
          handleChange: (value) => {
            setCategoryName(value);
            setValue("categoryName", value);
          },
          error: t2((_a2 = errors == null ? void 0 : errors.categoryName) == null ? void 0 : _a2.message)
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-grid tw-justify-items-center mobile:tw-grid-cols-1 mobile:tw-gap-y-2 tablet:tw-grid-cols-2 tablet:tw-gap-x-4",
        children: [/* @__PURE__ */ jsx$1(Button, {
          onClick: handleCancelModal,
          className: "mobile:tw-mt-4 mobile:tw-w-full tablet:tw-mt-0 tablet:tw-w-fit",
          variant: "secondary",
          children: t2("product.category.cancel")
        }), /* @__PURE__ */ jsx$1(Button, {
          onClick: handleSubmit(submitField),
          className: "mobile:tw-mt-4 mobile:tw-w-full tablet:tw-mt-0 tablet:tw-w-fit",
          variant: "primary",
          children: t2("product.category.add")
        })]
      })]
    })
  });
};
const ErrorDeleteProductModal = ({
  isOpen,
  handleCloseModal,
  description
}) => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx$1(Modal, {
    size: "small",
    isOpen,
    onClose: handleCloseModal,
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-h-fit tablet:tw-w-full",
      children: [/* @__PURE__ */ jsx$1("div", {
        className: "tw-flex tw-justify-center tw-w-full",
        children: /* @__PURE__ */ jsx$1(Icon, {
          name: IconName.CLOSE_CIRCLE,
          size: IconSize.LARGE
        })
      }), /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-py-6 tw-text-center",
        variant: "title-2",
        color: COLORS.Gray[800],
        children: t2("product.productSKU.modal.cannotDeleteProduct.title")
      }), /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-pb-10 tw-text-center",
        variant: "body-3",
        color: COLORS.Gray[500],
        children: t2(description)
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-w-full",
        children: /* @__PURE__ */ jsx$1(Button, {
          size: "large",
          variant: "primary",
          className: "tw-w-full",
          onClick: () => handleCloseModal(),
          children: t2("product.productSKU.modal.cannotDeleteSKU.ok")
        })
      })]
    })
  });
};
ErrorDeleteProductModal.defaultProps = {
  description: ""
};
const ErrorSKUModal = ({
  isOpen,
  handleCloseModal
}) => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx$1(Modal, {
    size: "small",
    isOpen,
    onClose: handleCloseModal,
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-h-fit tablet:tw-w-fit",
      children: [/* @__PURE__ */ jsx$1(Typography, {
        className: "tw-py-6 tw-text-center",
        variant: "title-2",
        color: COLORS.Gray[800],
        children: t2("product.productSKU.modal.cannotDeleteSKU.title")
      }), /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-pb-10 tw-text-center",
        variant: "body-3",
        color: COLORS.Gray[500],
        children: t2("product.productSKU.modal.cannotDeleteSKU.description")
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-w-full",
        children: /* @__PURE__ */ jsx$1(Button, {
          variant: "primary",
          className: "tw-w-full",
          onClick: () => handleCloseModal(),
          children: t2("product.productSKU.modal.cannotDeleteSKU.ok")
        })
      })]
    })
  });
};
const REGEX_PRODUCT_CODE_SUPPORT_CHARACTER = /^([a-zA-Z\u0E01-\u0E7F0-9][a-zA-Z\u0E01-\u0E7F0-9_-]+[a-zA-Z\u0E01-\u0E7F0-9])$/;
const REGEX_CF_CODE_SUPPORT_CHARACTER = /^([a-zA-Z\u0E01-\u0E2E][a-zA-Z\u0E01-\u0E2E0-9_-]+[a-zA-Z\u0E01-\u0E2E0-9])$/;
gql$1`
  mutation uploadImage($projectId: ID!, $file: Upload!) {
    uploadImage(projectId: $projectId, file: $file)
  }
`;
const SIGNED_URL_UPLOAD_IMAGE = gql$1`
  mutation signedUrlForImageUpload(
    $projectId: ID!
    $imageFile: FileMetadataForSignedUrlInput!
    $type: UploadDirectoryType!
    $customerId: ID
  ) {
    signedUrlForImageUpload(
      projectId: $projectId
      imageFile: $imageFile
      type: $type
      customerId: $customerId
    ) {
      signedUrl
      publicUrl
      requestHeaders {
        key
        value
      }
      filePath
    }
  }
`;
var UploadDirectoryType;
(function(UploadDirectoryType2) {
  UploadDirectoryType2["PROJECT_PUBLIC"] = "PROJECT_PUBLIC";
  UploadDirectoryType2["PROJECT_CHAT"] = "PROJECT_CHAT";
  UploadDirectoryType2["USER"] = "USER";
  UploadDirectoryType2["PROJECT_RECEIPT"] = "PROJECT_RECEIPT";
  UploadDirectoryType2["PROJECT_CERTIFICATION"] = "PROJECT_CERTIFICATION";
  UploadDirectoryType2["PROJECT_MENU"] = "PROJECT_MENU";
})(UploadDirectoryType || (UploadDirectoryType = {}));
var axios$2 = { exports: {} };
var bind$2 = function bind(fn2, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i2 = 0; i2 < args.length; i2++) {
      args[i2] = arguments[i2];
    }
    return fn2.apply(thisArg, args);
  };
};
var bind$1 = bind$2;
var toString = Object.prototype.toString;
function isArray$3(val) {
  return toString.call(val) === "[object Array]";
}
function isUndefined(val) {
  return typeof val === "undefined";
}
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
function isArrayBuffer(val) {
  return toString.call(val) === "[object ArrayBuffer]";
}
function isFormData(val) {
  return typeof FormData !== "undefined" && val instanceof FormData;
}
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}
function isString(val) {
  return typeof val === "string";
}
function isNumber(val) {
  return typeof val === "number";
}
function isObject$2(val) {
  return val !== null && typeof val === "object";
}
function isPlainObject(val) {
  if (toString.call(val) !== "[object Object]") {
    return false;
  }
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate$1(val) {
  return toString.call(val) === "[object Date]";
}
function isFile(val) {
  return toString.call(val) === "[object File]";
}
function isBlob(val) {
  return toString.call(val) === "[object Blob]";
}
function isFunction$1(val) {
  return toString.call(val) === "[object Function]";
}
function isStream(val) {
  return isObject$2(val) && isFunction$1(val.pipe);
}
function isURLSearchParams(val) {
  return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv() {
  if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function forEach(obj, fn2) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray$3(obj)) {
    for (var i2 = 0, l2 = obj.length; i2 < l2; i2++) {
      fn2.call(null, obj[i2], i2, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn2.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge() {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray$3(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }
  for (var i2 = 0, l2 = arguments.length; i2 < l2; i2++) {
    forEach(arguments[i2], assignValue);
  }
  return result;
}
function extend(a2, b2, thisArg) {
  forEach(b2, function assignValue(val, key) {
    if (thisArg && typeof val === "function") {
      a2[key] = bind$1(val, thisArg);
    } else {
      a2[key] = val;
    }
  });
  return a2;
}
function stripBOM(content) {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
}
var utils$d = {
  isArray: isArray$3,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isObject: isObject$2,
  isPlainObject,
  isUndefined,
  isDate: isDate$1,
  isFile,
  isBlob,
  isFunction: isFunction$1,
  isStream,
  isURLSearchParams,
  isStandardBrowserEnv,
  forEach,
  merge,
  extend,
  trim,
  stripBOM
};
var utils$c = utils$d;
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$2 = function buildURL(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$c.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$c.forEach(params, function serialize2(val, key) {
      if (val === null || typeof val === "undefined") {
        return;
      }
      if (utils$c.isArray(val)) {
        key = key + "[]";
      } else {
        val = [val];
      }
      utils$c.forEach(val, function parseValue(v2) {
        if (utils$c.isDate(v2)) {
          v2 = v2.toISOString();
        } else if (utils$c.isObject(v2)) {
          v2 = JSON.stringify(v2);
        }
        parts.push(encode(key) + "=" + encode(v2));
      });
    });
    serializedParams = parts.join("&");
  }
  if (serializedParams) {
    var hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
};
var utils$b = utils$d;
function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options2) {
  this.handlers.push({
    fulfilled,
    rejected,
    synchronous: options2 ? options2.synchronous : false,
    runWhen: options2 ? options2.runWhen : null
  });
  return this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function eject(id2) {
  if (this.handlers[id2]) {
    this.handlers[id2] = null;
  }
};
InterceptorManager$1.prototype.forEach = function forEach2(fn2) {
  utils$b.forEach(this.handlers, function forEachHandler(h2) {
    if (h2 !== null) {
      fn2(h2);
    }
  });
};
var InterceptorManager_1 = InterceptorManager$1;
var utils$a = utils$d;
var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$a.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};
var enhanceError$2 = function enhanceError(error2, config, code, request2, response) {
  error2.config = config;
  if (code) {
    error2.code = code;
  }
  error2.request = request2;
  error2.response = response;
  error2.isAxiosError = true;
  error2.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error2;
};
var enhanceError$1 = enhanceError$2;
var createError$2 = function createError(message, config, code, request2, response) {
  var error2 = new Error(message);
  return enhanceError$1(error2, config, code, request2, response);
};
var createError$1 = createError$2;
var settle$1 = function settle(resolve, reject, response) {
  var validateStatus2 = response.config.validateStatus;
  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve(response);
  } else {
    reject(createError$1("Request failed with status code " + response.status, response.config, null, response.request, response));
  }
};
var utils$9 = utils$d;
var cookies$1 = utils$9.isStandardBrowserEnv() ? function standardBrowserEnv() {
  return {
    write: function write2(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + "=" + encodeURIComponent(value));
      if (utils$9.isNumber(expires)) {
        cookie.push("expires=" + new Date(expires).toGMTString());
      }
      if (utils$9.isString(path)) {
        cookie.push("path=" + path);
      }
      if (utils$9.isString(domain)) {
        cookie.push("domain=" + domain);
      }
      if (secure === true) {
        cookie.push("secure");
      }
      document.cookie = cookie.join("; ");
    },
    read: function read2(name) {
      var match2 = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
      return match2 ? decodeURIComponent(match2[3]) : null;
    },
    remove: function remove2(name) {
      this.write(name, "", Date.now() - 864e5);
    }
  };
}() : function nonStandardBrowserEnv() {
  return {
    write: function write2() {
    },
    read: function read2() {
      return null;
    },
    remove: function remove2() {
    }
  };
}();
var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};
var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};
var isAbsoluteURL2 = isAbsoluteURL$1;
var combineURLs2 = combineURLs$1;
var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL2(requestedURL)) {
    return combineURLs2(baseURL, requestedURL);
  }
  return requestedURL;
};
var utils$8 = utils$d;
var ignoreDuplicateOf = [
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
];
var parseHeaders$1 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i2;
  if (!headers) {
    return parsed;
  }
  utils$8.forEach(headers.split("\n"), function parser2(line2) {
    i2 = line2.indexOf(":");
    key = utils$8.trim(line2.substr(0, i2)).toLowerCase();
    val = utils$8.trim(line2.substr(i2 + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === "set-cookie") {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    }
  });
  return parsed;
};
var utils$7 = utils$d;
var isURLSameOrigin$1 = utils$7.isStandardBrowserEnv() ? function standardBrowserEnv2() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement("a");
  var originURL;
  function resolveURL(url) {
    var href = url;
    if (msie) {
      urlParsingNode.setAttribute("href", href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute("href", href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin2(requestURL) {
    var parsed = utils$7.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv2() {
  return function isURLSameOrigin2() {
    return true;
  };
}();
function Cancel$3(message) {
  this.message = message;
}
Cancel$3.prototype.toString = function toString2() {
  return "Cancel" + (this.message ? ": " + this.message : "");
};
Cancel$3.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel$3;
var utils$6 = utils$d;
var settle2 = settle$1;
var cookies = cookies$1;
var buildURL$1 = buildURL$2;
var buildFullPath2 = buildFullPath$1;
var parseHeaders2 = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var createError2 = createError$2;
var defaults$4 = defaults_1;
var Cancel$2 = Cancel_1;
var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }
      if (config.signal) {
        config.signal.removeEventListener("abort", onCanceled);
      }
    }
    if (utils$6.isFormData(requestData)) {
      delete requestHeaders["Content-Type"];
    }
    var request2 = new XMLHttpRequest();
    if (config.auth) {
      var username = config.auth.username || "";
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
      requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
    }
    var fullPath = buildFullPath2(config.baseURL, config.url);
    request2.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true);
    request2.timeout = config.timeout;
    function onloadend() {
      if (!request2) {
        return;
      }
      var responseHeaders = "getAllResponseHeaders" in request2 ? parseHeaders2(request2.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === "text" || responseType === "json" ? request2.responseText : request2.response;
      var response = {
        data: responseData,
        status: request2.status,
        statusText: request2.statusText,
        headers: responseHeaders,
        config,
        request: request2
      };
      settle2(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);
      request2 = null;
    }
    if ("onloadend" in request2) {
      request2.onloadend = onloadend;
    } else {
      request2.onreadystatechange = function handleLoad() {
        if (!request2 || request2.readyState !== 4) {
          return;
        }
        if (request2.status === 0 && !(request2.responseURL && request2.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request2.onabort = function handleAbort() {
      if (!request2) {
        return;
      }
      reject(createError2("Request aborted", config, "ECONNABORTED", request2));
      request2 = null;
    };
    request2.onerror = function handleError() {
      reject(createError2("Network Error", config, null, request2));
      request2 = null;
    };
    request2.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
      var transitional2 = config.transitional || defaults$4.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError2(timeoutErrorMessage, config, transitional2.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request2));
      request2 = null;
    };
    if (utils$6.isStandardBrowserEnv()) {
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }
    if ("setRequestHeader" in request2) {
      utils$6.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
          delete requestHeaders[key];
        } else {
          request2.setRequestHeader(key, val);
        }
      });
    }
    if (!utils$6.isUndefined(config.withCredentials)) {
      request2.withCredentials = !!config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request2.responseType = config.responseType;
    }
    if (typeof config.onDownloadProgress === "function") {
      request2.addEventListener("progress", config.onDownloadProgress);
    }
    if (typeof config.onUploadProgress === "function" && request2.upload) {
      request2.upload.addEventListener("progress", config.onUploadProgress);
    }
    if (config.cancelToken || config.signal) {
      onCanceled = function(cancel) {
        if (!request2) {
          return;
        }
        reject(!cancel || cancel && cancel.type ? new Cancel$2("canceled") : cancel);
        request2.abort();
        request2 = null;
      };
      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
      }
    }
    if (!requestData) {
      requestData = null;
    }
    request2.send(requestData);
  });
};
var utils$5 = utils$d;
var normalizeHeaderName2 = normalizeHeaderName$1;
var enhanceError2 = enhanceError$2;
var DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(headers, value) {
  if (!utils$5.isUndefined(headers) && utils$5.isUndefined(headers["Content-Type"])) {
    headers["Content-Type"] = value;
  }
}
function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== "undefined") {
    adapter = xhr;
  } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
    adapter = xhr;
  }
  return adapter;
}
function stringifySafely(rawValue, parser2, encoder) {
  if (utils$5.isString(rawValue)) {
    try {
      (parser2 || JSON.parse)(rawValue);
      return utils$5.trim(rawValue);
    } catch (e2) {
      if (e2.name !== "SyntaxError") {
        throw e2;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
var defaults$3 = {
  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data2, headers) {
    normalizeHeaderName2(headers, "Accept");
    normalizeHeaderName2(headers, "Content-Type");
    if (utils$5.isFormData(data2) || utils$5.isArrayBuffer(data2) || utils$5.isBuffer(data2) || utils$5.isStream(data2) || utils$5.isFile(data2) || utils$5.isBlob(data2)) {
      return data2;
    }
    if (utils$5.isArrayBufferView(data2)) {
      return data2.buffer;
    }
    if (utils$5.isURLSearchParams(data2)) {
      setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
      return data2.toString();
    }
    if (utils$5.isObject(data2) || headers && headers["Content-Type"] === "application/json") {
      setContentTypeIfUnset(headers, "application/json");
      return stringifySafely(data2);
    }
    return data2;
  }],
  transformResponse: [function transformResponse(data2) {
    var transitional2 = this.transitional || defaults$3.transitional;
    var silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
    var forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
    if (strictJSONParsing || forcedJSONParsing && utils$5.isString(data2) && data2.length) {
      try {
        return JSON.parse(data2);
      } catch (e2) {
        if (strictJSONParsing) {
          if (e2.name === "SyntaxError") {
            throw enhanceError2(e2, this, "E_JSON_PARSE");
          }
          throw e2;
        }
      }
    }
    return data2;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*"
    }
  }
};
utils$5.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
  defaults$3.headers[method] = {};
});
utils$5.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  defaults$3.headers[method] = utils$5.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$3;
var utils$4 = utils$d;
var defaults$2 = defaults_1;
var transformData$1 = function transformData(data2, headers, fns) {
  var context = this || defaults$2;
  utils$4.forEach(fns, function transform2(fn2) {
    data2 = fn2.call(context, data2, headers);
  });
  return data2;
};
var isCancel$1 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};
var utils$3 = utils$d;
var transformData2 = transformData$1;
var isCancel2 = isCancel$1;
var defaults$1 = defaults_1;
var Cancel$1 = Cancel_1;
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new Cancel$1("canceled");
  }
}
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = config.headers || {};
  config.data = transformData2.call(config, config.data, config.headers, config.transformRequest);
  config.headers = utils$3.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils$3.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults$1.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData2.call(config, response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel2(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData2.call(config, reason.response.data, reason.response.headers, config.transformResponse);
      }
    }
    return Promise.reject(reason);
  });
};
var utils$2 = utils$d;
var mergeConfig$2 = function mergeConfig(config1, config2) {
  config2 = config2 || {};
  var config = {};
  function getMergedValue(target, source2) {
    if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source2)) {
      return utils$2.merge(target, source2);
    } else if (utils$2.isPlainObject(source2)) {
      return utils$2.merge({}, source2);
    } else if (utils$2.isArray(source2)) {
      return source2.slice();
    }
    return source2;
  }
  function mergeDeepProperties(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function valueFromConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    }
  }
  function defaultToConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  var mergeMap = {
    "url": valueFromConfig2,
    "method": valueFromConfig2,
    "data": valueFromConfig2,
    "baseURL": defaultToConfig2,
    "transformRequest": defaultToConfig2,
    "transformResponse": defaultToConfig2,
    "paramsSerializer": defaultToConfig2,
    "timeout": defaultToConfig2,
    "timeoutMessage": defaultToConfig2,
    "withCredentials": defaultToConfig2,
    "adapter": defaultToConfig2,
    "responseType": defaultToConfig2,
    "xsrfCookieName": defaultToConfig2,
    "xsrfHeaderName": defaultToConfig2,
    "onUploadProgress": defaultToConfig2,
    "onDownloadProgress": defaultToConfig2,
    "decompress": defaultToConfig2,
    "maxContentLength": defaultToConfig2,
    "maxBodyLength": defaultToConfig2,
    "transport": defaultToConfig2,
    "httpAgent": defaultToConfig2,
    "httpsAgent": defaultToConfig2,
    "cancelToken": defaultToConfig2,
    "socketPath": defaultToConfig2,
    "responseEncoding": defaultToConfig2,
    "validateStatus": mergeDirectKeys
  };
  utils$2.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge2 = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge2(prop);
    utils$2.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
};
var data$1 = {
  "version": "0.24.0"
};
var VERSION = data$1.version;
var validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i2) {
  validators$1[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i2 < 1 ? "n " : " ") + type;
  };
});
var deprecatedWarnings = {};
validators$1.transitional = function transitional(validator2, version, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return function(value, opt, opts) {
    if (validator2 === false) {
      throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
    }
    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions(options2, schema2, allowUnknown) {
  if (typeof options2 !== "object") {
    throw new TypeError("options must be an object");
  }
  var keys2 = Object.keys(options2);
  var i2 = keys2.length;
  while (i2-- > 0) {
    var opt = keys2[i2];
    var validator2 = schema2[opt];
    if (validator2) {
      var value = options2[opt];
      var result = value === void 0 || validator2(value, opt, options2);
      if (result !== true) {
        throw new TypeError("option " + opt + " must be " + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error("Unknown option " + opt);
    }
  }
}
var validator$1 = {
  assertOptions,
  validators: validators$1
};
var utils$1 = utils$d;
var buildURL2 = buildURL$2;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest2 = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;
var validators = validator.validators;
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
Axios$1.prototype.request = function request(config) {
  if (typeof config === "string") {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }
  config = mergeConfig$1(this.defaults, config);
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = "get";
  }
  var transitional2 = config.transitional;
  if (transitional2 !== void 0) {
    validator.assertOptions(transitional2, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
      return;
    }
    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;
  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest2, void 0];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }
    return promise;
  }
  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error2) {
      onRejected(error2);
      break;
    }
  }
  try {
    promise = dispatchRequest2(newConfig);
  } catch (error2) {
    return Promise.reject(error2);
  }
  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }
  return promise;
};
Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  return buildURL2(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
utils$1.forEach(["delete", "get", "head", "options"], function forEachMethodNoData2(method) {
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function forEachMethodWithData2(method) {
  Axios$1.prototype[method] = function(url, data2, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: data2
    }));
  };
});
var Axios_1 = Axios$1;
var Cancel = Cancel_1;
function CancelToken(executor) {
  if (typeof executor !== "function") {
    throw new TypeError("executor must be a function.");
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token2 = this;
  this.promise.then(function(cancel) {
    if (!token2._listeners)
      return;
    var i2;
    var l2 = token2._listeners.length;
    for (i2 = 0; i2 < l2; i2++) {
      token2._listeners[i2](cancel);
    }
    token2._listeners = null;
  });
  this.promise.then = function(onfulfilled) {
    var _resolve;
    var promise = new Promise(function(resolve) {
      token2.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);
    promise.cancel = function reject() {
      token2.unsubscribe(_resolve);
    };
    return promise;
  };
  executor(function cancel(message) {
    if (token2.reason) {
      return;
    }
    token2.reason = new Cancel(message);
    resolvePromise(token2.reason);
  });
}
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }
  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};
CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index2 = this._listeners.indexOf(listener);
  if (index2 !== -1) {
    this._listeners.splice(index2, 1);
  }
};
CancelToken.source = function source() {
  var cancel;
  var token2 = new CancelToken(function executor(c2) {
    cancel = c2;
  });
  return {
    token: token2,
    cancel
  };
};
var CancelToken_1 = CancelToken;
var spread = function spread2(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};
var isAxiosError = function isAxiosError2(payload) {
  return typeof payload === "object" && payload.isAxiosError === true;
};
var utils = utils$d;
var bind2 = bind$2;
var Axios = Axios_1;
var mergeConfig2 = mergeConfig$2;
var defaults = defaults_1;
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind2(Axios.prototype.request, context);
  utils.extend(instance, Axios.prototype, context);
  utils.extend(instance, context);
  instance.create = function create2(instanceConfig) {
    return createInstance(mergeConfig2(defaultConfig, instanceConfig));
  };
  return instance;
}
var axios$1 = createInstance(defaults);
axios$1.Axios = Axios;
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;
axios$1.VERSION = data$1.version;
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;
axios$1.isAxiosError = isAxiosError;
axios$2.exports = axios$1;
axios$2.exports.default = axios$1;
var axios = axios$2.exports;
const validateFileType = (file) => {
  const typeImages = file.name.match(IMAGE_TYPE_WHITE_LISTS_REGEX);
  if (!IMAGE_TYPE_WHITE_LISTS.includes(file.type) || !typeImages || typeImages && !typeImages.length) {
    return false;
  }
  return true;
};
const uploadFileToGCS = (file, requestHeaders, signedUrl) => {
  return new Promise((resolve, reject) => {
    if (!requestHeaders.length || !signedUrl) {
      reject();
    }
    const xhr2 = new XMLHttpRequest();
    xhr2.open("PUT", signedUrl, true);
    xhr2.onload = () => {
      const { status } = xhr2;
      if (status === 200) {
        resolve();
      } else {
        reject();
      }
    };
    xhr2.onerror = () => {
      reject();
    };
    requestHeaders.forEach((header) => {
      const { key, value } = header;
      if (key !== "filename") {
        xhr2.setRequestHeader(key, value);
      }
    });
    xhr2.send(file);
  });
};
const useUploadImage = () => {
  const [signUrlForImage, { loading }] = useMutation(SIGNED_URL_UPLOAD_IMAGE);
  const uploadImage = useCallback(async (projectId, file, type, customerId) => {
    var _a2;
    const isValidFileType = validateFileType(file);
    if (!isValidFileType) {
      throw new Error("uploadImage.type.error");
    }
    const result = await signUrlForImage({
      variables: {
        projectId,
        imageFile: {
          contentType: file.type,
          sizeInByte: file.size
        },
        type: type || UploadDirectoryType.PROJECT_PUBLIC,
        customerId
      }
    });
    const signedUrlForImageUploadData = (_a2 = result == null ? void 0 : result.data) == null ? void 0 : _a2.signedUrlForImageUpload;
    const requestHeaders = (signedUrlForImageUploadData == null ? void 0 : signedUrlForImageUploadData.requestHeaders) || [];
    const signedUrl = (signedUrlForImageUploadData == null ? void 0 : signedUrlForImageUploadData.signedUrl) || "";
    const publicUrl = (signedUrlForImageUploadData == null ? void 0 : signedUrlForImageUploadData.publicUrl) || "";
    const filePath = (signedUrlForImageUploadData == null ? void 0 : signedUrlForImageUploadData.filePath) || "";
    await uploadFileToGCS(file, requestHeaders, signedUrl);
    return { publicUrl, filePath };
  }, [signUrlForImage]);
  return { uploadImage, isLoading: loading };
};
var reWhitespace = /\s/;
function trimmedEndIndex$1(string2) {
  var index2 = string2.length;
  while (index2-- && reWhitespace.test(string2.charAt(index2))) {
  }
  return index2;
}
var _trimmedEndIndex = trimmedEndIndex$1;
var trimmedEndIndex = _trimmedEndIndex;
var reTrimStart = /^\s+/;
function baseTrim$1(string2) {
  return string2 ? string2.slice(0, trimmedEndIndex(string2) + 1).replace(reTrimStart, "") : string2;
}
var _baseTrim = baseTrim$1;
var baseTrim = _baseTrim, isObject$1 = isObject_1, isSymbol$1 = isSymbol_1;
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber$1(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$1(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_1 = toNumber$1;
var toNumber = toNumber_1;
var INFINITY$1 = 1 / 0, MAX_INTEGER = 17976931348623157e292;
function toFinite$1(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY$1 || value === -INFINITY$1) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}
var toFinite_1 = toFinite$1;
var toFinite = toFinite_1;
function toInteger$2(value) {
  var result = toFinite(value), remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}
var toInteger_1 = toInteger$2;
var baseSlice = _baseSlice, toInteger$1 = toInteger_1;
function dropRight(array2, n2, guard) {
  var length2 = array2 == null ? 0 : array2.length;
  if (!length2) {
    return [];
  }
  n2 = guard || n2 === void 0 ? 1 : toInteger$1(n2);
  n2 = length2 - n2;
  return baseSlice(array2, 0, n2 < 0 ? 0 : n2);
}
var dropRight_1 = dropRight;
var DigitalContentStatus;
(function(DigitalContentStatus2) {
  DigitalContentStatus2["AVAILABLE"] = "AVAILABLE";
  DigitalContentStatus2["PURCHASED"] = "PURCHASED";
  DigitalContentStatus2["REDEEMED"] = "REDEEMED";
  DigitalContentStatus2["EXPIRED"] = "EXPIRED";
})(DigitalContentStatus || (DigitalContentStatus = {}));
var OrderProductOption;
(function(OrderProductOption2) {
  OrderProductOption2["ORDER_UP"] = "order-up";
  OrderProductOption2["ORDER_DOWN"] = "order-down";
})(OrderProductOption || (OrderProductOption = {}));
var ProductType;
(function(ProductType2) {
  ProductType2["DIGITAL_CONTENT"] = "DIGITAL_CONTENT";
  ProductType2["SINGLE_SKU_WITH_OPTIONS"] = "SINGLE_SKU_WITH_OPTIONS";
  ProductType2["SKU"] = "SKU";
})(ProductType || (ProductType = {}));
var ProductOptionKey;
(function(ProductOptionKey2) {
  ProductOptionKey2["IS_ACTIVE"] = "isActive";
  ProductOptionKey2["NAME"] = "name";
  ProductOptionKey2["IS_MULTIPLE_CHOICES"] = "isMultipleChoices";
  ProductOptionKey2["IS_REQUIRED"] = "isRequired";
  ProductOptionKey2["MAXIMUM"] = "maximum";
  ProductOptionKey2["CHOICES"] = "choices";
})(ProductOptionKey || (ProductOptionKey = {}));
var ProductSKUInputDataType;
(function(ProductSKUInputDataType2) {
  ProductSKUInputDataType2["PRICE"] = "price";
  ProductSKUInputDataType2["SELECTED"] = "selected";
  ProductSKUInputDataType2["IS_FREE"] = "isFree";
  ProductSKUInputDataType2["PRODUCT_CODE"] = "productCode";
  ProductSKUInputDataType2["IMAGE"] = "image";
  ProductSKUInputDataType2["WEIGHT"] = "weight";
  ProductSKUInputDataType2["DIMENSION"] = "dimension";
  ProductSKUInputDataType2["PRODUCT_CF_CODE"] = "productCfCode";
})(ProductSKUInputDataType || (ProductSKUInputDataType = {}));
var ErrorAddProduct;
(function(ErrorAddProduct2) {
  ErrorAddProduct2["BASIC_PACK_CANNOT_EXCEED_PRODUCT_QUOTA"] = "ADD_PRODUCT:BASIC_PACK_CANNOT_EXCEED_PRODUCT_QUOTA";
  ErrorAddProduct2["DUPLICATED_PRODUCT_NAME"] = "ADD_PRODUCT:DUPLICATED_PRODUCT_NAME";
  ErrorAddProduct2["DUPLICATED_PRODUCT_CODE"] = "ADD_PRODUCT:DUPLICATED_PRODUCT_CODE";
  ErrorAddProduct2["DESCRIPTION_EXCEED_LIMIT"] = "ADD_PRODUCT:DESCRIPTION_EXCEED_LIMIT";
  ErrorAddProduct2["PRICE_REACH_LIMIT"] = "ADD_PRODUCT:PRICE_REACH_LIMIT";
  ErrorAddProduct2["DUPLICATED_CF_CODE"] = "ADD_PRODUCT:DUPLICATED_CF_CODE";
})(ErrorAddProduct || (ErrorAddProduct = {}));
var ErrorEditProduct;
(function(ErrorEditProduct2) {
  ErrorEditProduct2["DUPLICATED_PRODUCT_CODE"] = "EDIT_PRODUCT:DUPLICATED_PRODUCT_CODE";
  ErrorEditProduct2["DUPLICATED_PRODUCT_NAME"] = "EDIT_PRODUCT:DUPLICATED_PRODUCT_NAME";
  ErrorEditProduct2["INVENTORY_NOT_EMPTY_CASE"] = "EDIT_PRODUCT:INVENTORY_NOT_EMPTY_CASE";
  ErrorEditProduct2["DESCRIPTION_EXCEED_LIMIT"] = "EDIT_PRODUCT:DESCRIPTION_EXCEED_LIMIT";
  ErrorEditProduct2["PRICE_REACH_LIMIT"] = "EDIT_PRODUCT:PRICE_REACH_LIMIT";
  ErrorEditProduct2["INCORRECT_PRODUCT"] = "EDIT_PRODUCT:INCORRECT_PRODUCT";
  ErrorEditProduct2["DUPLICATED_CF_CODE"] = "EDIT_PRODUCT:DUPLICATED_CF_CODE";
})(ErrorEditProduct || (ErrorEditProduct = {}));
var ErrorDeleteProduct;
(function(ErrorDeleteProduct2) {
  ErrorDeleteProduct2["INVENTORY_NOT_EMPTY_CASE"] = "DELETE_PRODUCT:INVENTORY_NOT_EMPTY_CASE";
})(ErrorDeleteProduct || (ErrorDeleteProduct = {}));
var ErrorImportProduct;
(function(ErrorImportProduct2) {
  ErrorImportProduct2["INCORRECT_UPLOAD_FORMAT"] = "IMPORT_PRODUCTS:INCORRECT_UPLOAD_FORMAT";
  ErrorImportProduct2["BASIC_PACK_CANNOT_EXCEED_PRODUCT_QUOTA"] = "IMPORT_PRODUCTS:BASIC_PACK_CANNOT_EXCEED_PRODUCT_QUOTA";
  ErrorImportProduct2["CATEGORY_NOT_FOUND"] = "IMPORT_PRODUCTS:CATEGORY_NOT_FOUND";
  ErrorImportProduct2["DUPLICATED_PRODUCT_CODE"] = "IMPORT_PRODUCTS:DUPLICATED_PRODUCT_CODE";
  ErrorImportProduct2["DUPLICATED_PRODUCT_NAME"] = "IMPORT_PRODUCTS:DUPLICATED_PRODUCT_NAME";
  ErrorImportProduct2["FILE_TYPE_IS_NOT_PERMITTED"] = "IMPORT_PRODUCTS:FILE_TYPE_IS_NOT_PERMITTED";
  ErrorImportProduct2["DESCRIPTION_EXCEED_LIMIT"] = "IMPORT_PRODUCTS:DESCRIPTION_EXCEED_LIMIT";
  ErrorImportProduct2["PRICE_REACH_LIMIT"] = "IMPORT_PRODUCTS:PRICE_REACH_LIMIT";
  ErrorImportProduct2["EXCEED_PRODUCT_QUOTA"] = "IMPORT_PRODUCTS:EXCEED_PRODUCT_QUOTA";
  ErrorImportProduct2["MISSING_C_COMMERCE_PACKAGE"] = "IMPORT_PRODUCTS:MISSING_C_COMMERCE_PACKAGE";
  ErrorImportProduct2["DUPLICATED_PRODUCT_TYPE_SKU"] = "IMPORT_PRODUCTS:DUPLICATED_PRODUCT_TYPE_SKU";
  ErrorImportProduct2["DUPLICATED_PRODUCT_CODE_IN_IMPORT_DATA"] = "IMPORT_PRODUCTS:DUPLICATED_PRODUCT_CODE_IN_IMPORT_DATA";
  ErrorImportProduct2["DUPLICATED_PRODUCT_NAME_IN_IMPORT_DATA"] = "IMPORT_PRODUCTS:DUPLICATED_PRODUCT_NAME_IN_IMPORT_DATA";
  ErrorImportProduct2["PRODUCT_CODE_CANNOT_BE_EMPTY"] = "IMPORT_PRODUCTS:PRODUCT_CODE_CANNOT_BE_EMPTY";
  ErrorImportProduct2["PRODUCT_CODE_NOT_FOUND"] = "IMPORT_DIGITAL_CONTENTS:PRODUCT_CODE_NOT_FOUND";
  ErrorImportProduct2["INCORRECT_DIGITAL_CONTENTS"] = "IMPORT_DIGITAL_CONTENTS:INCORRECT_DIGITAL_CONTENTS";
  ErrorImportProduct2["DUPLICATED_DIGITAL_CONTENT"] = "IMPORT_DIGITAL_CONTENTS:DUPLICATED_DIGITAL_CONTENT";
  ErrorImportProduct2["PRODUCT_OUTPUT_TYPE_IS_NOT_CODE_IMPORTED"] = "IMPORT_DIGITAL_CONTENTS:PRODUCT_OUTPUT_TYPE_IS_NOT_CODE_IMPORTED";
  ErrorImportProduct2["DIGITAL_CONTENT_AVAILABILITY_TYPE_IS_NOT_MATCHED"] = "IMPORT_DIGITAL_CONTENTS:DIGITAL_CONTENT_AVAILABILITY_TYPE_IS_NOT_MATCHED";
})(ErrorImportProduct || (ErrorImportProduct = {}));
var ErrorImportInventory;
(function(ErrorImportInventory2) {
  ErrorImportInventory2["DUPLICATED_PRODUCT_SKU_CODES"] = "IMPORTED_PRODUCT_INVENTORIES:DUPLICATED_PRODUCT_SKU_CODES";
  ErrorImportInventory2["EXCEED_MAXIMUM_IMPORT_ROWS"] = "IMPORTED_PRODUCT_INVENTORIES:EXCEED_MAXIMUM_IMPORT_ROWS";
  ErrorImportInventory2["FILE_TYPE_IS_NOT_PERMITTED"] = "IMPORTED_PRODUCT_INVENTORIES:FILE_TYPE_IS_NOT_PERMITTED";
  ErrorImportInventory2["INVALID_UPLOAD_FORMAT"] = "IMPORTED_PRODUCT_INVENTORIES:INVALID_UPLOAD_FORMAT";
  ErrorImportInventory2["INVENTORY_LESS_THAN_RESERVED"] = "IMPORTED_PRODUCT_INVENTORIES:INVENTORY_LESS_THAN_RESERVED";
  ErrorImportInventory2["PRODUCT_SKU_CODES_NOT_EXISTED"] = "IMPORTED_PRODUCT_INVENTORIES:PRODUCT_SKU_CODES_NOT_EXISTED";
})(ErrorImportInventory || (ErrorImportInventory = {}));
var DigitalContentAvailability;
(function(DigitalContentAvailability2) {
  DigitalContentAvailability2["PERIOD_AFTER_PURCHASED"] = "PERIOD_AFTER_PURCHASED";
  DigitalContentAvailability2["EXPIRY_DATE"] = "EXPIRY_DATE";
  DigitalContentAvailability2["DATE_RANGE"] = "DATE_RANGE";
  DigitalContentAvailability2["NO_EXPIRY"] = "NO_EXPIRY";
})(DigitalContentAvailability || (DigitalContentAvailability = {}));
var DigitalContentProductType;
(function(DigitalContentProductType2) {
  DigitalContentProductType2["TOP_UP_AND_VOUCHER"] = "TOP_UP_AND_VOUCHER";
  DigitalContentProductType2["EVENT_TICKET"] = "EVENT_TICKET";
  DigitalContentProductType2["ONLINE_COURSE"] = "ONLINE_COURSE";
})(DigitalContentProductType || (DigitalContentProductType = {}));
var ProductOutputType;
(function(ProductOutputType2) {
  ProductOutputType2["STATIC"] = "STATIC";
  ProductOutputType2["QR_CODE"] = "QR_CODE";
  ProductOutputType2["CODE_IMPORTED"] = "CODE_IMPORTED";
  ProductOutputType2["CODE_AUTO_GENERATED"] = "CODE_AUTO_GENERATED";
  ProductOutputType2["CODE_GENERATED_FROM_OTHER"] = "CODE_GENERATED_FROM_OTHER";
})(ProductOutputType || (ProductOutputType = {}));
var UpdateInventoryType;
(function(UpdateInventoryType2) {
  UpdateInventoryType2["ADD"] = "ADD";
  UpdateInventoryType2["REPLACE"] = "UPDATE";
})(UpdateInventoryType || (UpdateInventoryType = {}));
function moveItemInArrayFromIndexToIndex(array2, fromIndex, toIndex = 0) {
  if (fromIndex === toIndex)
    return array2;
  const newArray = [...array2];
  const target = newArray[fromIndex];
  const inc = toIndex < fromIndex ? -1 : 1;
  for (let i2 = fromIndex; i2 !== toIndex; i2 += inc) {
    newArray[i2] = newArray[i2 + inc];
  }
  newArray[toIndex] = target;
  return newArray;
}
var ErrorAddCategory;
(function(ErrorAddCategory2) {
  ErrorAddCategory2["CATEGORY_NAME_CANNOT_BE_EMPTY"] = "ADD_CATEGORY:CATEGORY_NAME_CANNOT_BE_EMPTY";
  ErrorAddCategory2["DUPLICATED_CATEGORY_NAME"] = "ADD_CATEGORY:DUPLICATED_CATEGORY_NAME";
  ErrorAddCategory2["EXCEED_MAXIMUM_CATEGORIES_LIMIT"] = "ADD_CATEGORY:EXCEED_MAXIMUM_CATEGORIES_LIMIT";
})(ErrorAddCategory || (ErrorAddCategory = {}));
var ErrorUpdateCategory;
(function(ErrorUpdateCategory2) {
  ErrorUpdateCategory2["CATEGORY_NAME_CANNOT_BE_EMPTY"] = "UPDATE_CATEGORY:CATEGORY_NAME_CANNOT_BE_EMPTY";
  ErrorUpdateCategory2["DUPLICATED_CATEGORY_NAME"] = "UPDATE_CATEGORY:DUPLICATED_CATEGORY_NAME";
})(ErrorUpdateCategory || (ErrorUpdateCategory = {}));
const NETWORK_ERROR = "Network error: Failed to fetch";
const mapErrorMessage = (errMessage) => {
  switch (errMessage) {
    case NETWORK_ERROR:
      return "Network error please try again later";
    case ErrorAddProduct.BASIC_PACK_CANNOT_EXCEED_PRODUCT_QUOTA:
      return "product.productSKU.error.overQuota";
    case ErrorDeleteProduct.INVENTORY_NOT_EMPTY_CASE:
      return "product.productSKU.error.inventoryNotEmpty";
    case ErrorEditProduct.INVENTORY_NOT_EMPTY_CASE:
      return "product.productSKU.error.inventoryNotEmpty";
    case ErrorAddProduct.DUPLICATED_PRODUCT_CODE:
    case ErrorEditProduct.DUPLICATED_PRODUCT_CODE:
      return "product.productSKU.error.duplicatedProductCode";
    case ErrorAddProduct.DUPLICATED_CF_CODE:
    case ErrorEditProduct.DUPLICATED_CF_CODE:
      return "product.productSKU.error.duplicatedCFCode";
    case ErrorAddProduct.DUPLICATED_PRODUCT_NAME:
    case ErrorEditProduct.DUPLICATED_PRODUCT_NAME:
      return "product.productSKU.error.duplicatedProductName";
    case ErrorAddProduct.DESCRIPTION_EXCEED_LIMIT:
    case ErrorEditProduct.DESCRIPTION_EXCEED_LIMIT:
      return "product.productSKU.error.descriptionExceedLimit";
    case ErrorAddProduct.PRICE_REACH_LIMIT:
    case ErrorEditProduct.PRICE_REACH_LIMIT:
      return "product.productSKU.error.priceReachLimit";
    case ErrorAddCategory.CATEGORY_NAME_CANNOT_BE_EMPTY:
    case ErrorUpdateCategory.CATEGORY_NAME_CANNOT_BE_EMPTY:
      return "category.error.categoryNameCannotBeEmpty";
    case ErrorAddCategory.DUPLICATED_CATEGORY_NAME:
    case ErrorUpdateCategory.DUPLICATED_CATEGORY_NAME:
      return "category.error.duplicateCategoryName";
    case ErrorAddCategory.EXCEED_MAXIMUM_CATEGORIES_LIMIT:
      return "category.error.exceedMaximumCategoryLimit";
    case "emptyProductSKUCode":
      return "product.productSKU.error.emptyProductSKUCode";
    case "emptyProductSKUPrice":
      return "product.productSKU.error.emptyProductSKUPrice";
    case "emptyProductSKUDimension":
      return "product.productSKU.error.emptyProductSKUDimension";
    default:
      return void 0;
  }
};
var baseIsEqual = _baseIsEqual;
function isEqual(value, other) {
  return baseIsEqual(value, other);
}
var isEqual_1 = isEqual;
var Symbol$1 = _Symbol, isArguments = isArguments_1, isArray$2 = isArray_1;
var spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : void 0;
function isFlattenable$1(value) {
  return isArray$2(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
var _isFlattenable = isFlattenable$1;
var arrayPush = _arrayPush, isFlattenable = _isFlattenable;
function baseFlatten$1(array2, depth, predicate, isStrict, result) {
  var index2 = -1, length2 = array2.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index2 < length2) {
    var value = array2[index2];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        baseFlatten$1(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}
var _baseFlatten = baseFlatten$1;
var isArrayLike$2 = isArrayLike_1;
function createBaseEach$1(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$2(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length2 = collection.length, index2 = fromRight ? length2 : -1, iterable = Object(collection);
    while (fromRight ? index2-- : ++index2 < length2) {
      if (iteratee(iterable[index2], index2, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}
var _createBaseEach = createBaseEach$1;
var baseForOwn = _baseForOwn, createBaseEach = _createBaseEach;
var baseEach$2 = createBaseEach(baseForOwn);
var _baseEach = baseEach$2;
var baseEach$1 = _baseEach, isArrayLike$1 = isArrayLike_1;
function baseMap$1(collection, iteratee) {
  var index2 = -1, result = isArrayLike$1(collection) ? Array(collection.length) : [];
  baseEach$1(collection, function(value, key, collection2) {
    result[++index2] = iteratee(value, key, collection2);
  });
  return result;
}
var _baseMap = baseMap$1;
function baseSortBy$1(array2, comparer) {
  var length2 = array2.length;
  array2.sort(comparer);
  while (length2--) {
    array2[length2] = array2[length2].value;
  }
  return array2;
}
var _baseSortBy = baseSortBy$1;
var isSymbol = isSymbol_1;
function compareAscending$1(value, other) {
  if (value !== other) {
    var valIsDefined = value !== void 0, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
    var othIsDefined = other !== void 0, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
      return 1;
    }
    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}
var _compareAscending = compareAscending$1;
var compareAscending = _compareAscending;
function compareMultiple$1(object2, other, orders) {
  var index2 = -1, objCriteria = object2.criteria, othCriteria = other.criteria, length2 = objCriteria.length, ordersLength = orders.length;
  while (++index2 < length2) {
    var result = compareAscending(objCriteria[index2], othCriteria[index2]);
    if (result) {
      if (index2 >= ordersLength) {
        return result;
      }
      var order2 = orders[index2];
      return result * (order2 == "desc" ? -1 : 1);
    }
  }
  return object2.index - other.index;
}
var _compareMultiple = compareMultiple$1;
var arrayMap = _arrayMap, baseGet = _baseGet, baseIteratee$1 = _baseIteratee, baseMap = _baseMap, baseSortBy = _baseSortBy, baseUnary = _baseUnary, compareMultiple = _compareMultiple, identity$2 = identity_1, isArray$1 = isArray_1;
function baseOrderBy$1(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray$1(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
      }
      return iteratee;
    });
  } else {
    iteratees = [identity$2];
  }
  var index2 = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee$1));
  var result = baseMap(collection, function(value, key, collection2) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { "criteria": criteria, "index": ++index2, "value": value };
  });
  return baseSortBy(result, function(object2, other) {
    return compareMultiple(object2, other, orders);
  });
}
var _baseOrderBy = baseOrderBy$1;
function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
var _apply = apply$1;
var apply = _apply;
var nativeMax = Math.max;
function overRest$1(func, start2, transform2) {
  start2 = nativeMax(start2 === void 0 ? func.length - 1 : start2, 0);
  return function() {
    var args = arguments, index2 = -1, length2 = nativeMax(args.length - start2, 0), array2 = Array(length2);
    while (++index2 < length2) {
      array2[index2] = args[start2 + index2];
    }
    index2 = -1;
    var otherArgs = Array(start2 + 1);
    while (++index2 < start2) {
      otherArgs[index2] = args[index2];
    }
    otherArgs[start2] = transform2(array2);
    return apply(func, this, otherArgs);
  };
}
var _overRest = overRest$1;
function constant$1(value) {
  return function() {
    return value;
  };
}
var constant_1 = constant$1;
var constant = constant_1, defineProperty = _defineProperty$1, identity$1 = identity_1;
var baseSetToString$1 = !defineProperty ? identity$1 : function(func, string2) {
  return defineProperty(func, "toString", {
    "configurable": true,
    "enumerable": false,
    "value": constant(string2),
    "writable": true
  });
};
var _baseSetToString = baseSetToString$1;
var HOT_COUNT = 800, HOT_SPAN = 16;
var nativeNow = Date.now;
function shortOut$1(func) {
  var count = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(void 0, arguments);
  };
}
var _shortOut = shortOut$1;
var baseSetToString = _baseSetToString, shortOut = _shortOut;
var setToString$1 = shortOut(baseSetToString);
var _setToString = setToString$1;
var identity = identity_1, overRest = _overRest, setToString = _setToString;
function baseRest$1(func, start2) {
  return setToString(overRest(func, start2, identity), func + "");
}
var _baseRest = baseRest$1;
var eq = eq_1, isArrayLike = isArrayLike_1, isIndex = _isIndex, isObject = isObject_1;
function isIterateeCall$1(value, index2, object2) {
  if (!isObject(object2)) {
    return false;
  }
  var type = typeof index2;
  if (type == "number" ? isArrayLike(object2) && isIndex(index2, object2.length) : type == "string" && index2 in object2) {
    return eq(object2[index2], value);
  }
  return false;
}
var _isIterateeCall = isIterateeCall$1;
var baseFlatten = _baseFlatten, baseOrderBy = _baseOrderBy, baseRest = _baseRest, isIterateeCall = _isIterateeCall;
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length2 = iteratees.length;
  if (length2 > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length2 > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});
var sortBy_1 = sortBy;
function baseFindIndex$1(array2, predicate, fromIndex, fromRight) {
  var length2 = array2.length, index2 = fromIndex + (fromRight ? 1 : -1);
  while (fromRight ? index2-- : ++index2 < length2) {
    if (predicate(array2[index2], index2, array2)) {
      return index2;
    }
  }
  return -1;
}
var _baseFindIndex = baseFindIndex$1;
function baseIsNaN$1(value) {
  return value !== value;
}
var _baseIsNaN = baseIsNaN$1;
function strictIndexOf$1(array2, value, fromIndex) {
  var index2 = fromIndex - 1, length2 = array2.length;
  while (++index2 < length2) {
    if (array2[index2] === value) {
      return index2;
    }
  }
  return -1;
}
var _strictIndexOf = strictIndexOf$1;
var baseFindIndex = _baseFindIndex, baseIsNaN = _baseIsNaN, strictIndexOf = _strictIndexOf;
function baseIndexOf$1(array2, value, fromIndex) {
  return value === value ? strictIndexOf(array2, value, fromIndex) : baseFindIndex(array2, baseIsNaN, fromIndex);
}
var _baseIndexOf = baseIndexOf$1;
var baseIndexOf = _baseIndexOf;
function arrayIncludes$1(array2, value) {
  var length2 = array2 == null ? 0 : array2.length;
  return !!length2 && baseIndexOf(array2, value, 0) > -1;
}
var _arrayIncludes = arrayIncludes$1;
function arrayIncludesWith$1(array2, value, comparator) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length;
  while (++index2 < length2) {
    if (comparator(value, array2[index2])) {
      return true;
    }
  }
  return false;
}
var _arrayIncludesWith = arrayIncludesWith$1;
function noop$1() {
}
var noop_1 = noop$1;
var Set$1 = _Set, noop2 = noop_1, setToArray$1 = _setToArray;
var INFINITY = 1 / 0;
var createSet$1 = !(Set$1 && 1 / setToArray$1(new Set$1([, -0]))[1] == INFINITY) ? noop2 : function(values) {
  return new Set$1(values);
};
var _createSet = createSet$1;
var SetCache = _SetCache, arrayIncludes = _arrayIncludes, arrayIncludesWith = _arrayIncludesWith, cacheHas = _cacheHas, createSet = _createSet, setToArray = _setToArray;
var LARGE_ARRAY_SIZE = 200;
function baseUniq$2(array2, iteratee, comparator) {
  var index2 = -1, includes = arrayIncludes, length2 = array2.length, isCommon = true, result = [], seen = result;
  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  } else if (length2 >= LARGE_ARRAY_SIZE) {
    var set2 = iteratee ? null : createSet(array2);
    if (set2) {
      return setToArray(set2);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache();
  } else {
    seen = iteratee ? [] : result;
  }
  outer:
    while (++index2 < length2) {
      var value = array2[index2], computed = iteratee ? iteratee(value) : value;
      value = comparator || value !== 0 ? value : 0;
      if (isCommon && computed === computed) {
        var seenIndex = seen.length;
        while (seenIndex--) {
          if (seen[seenIndex] === computed) {
            continue outer;
          }
        }
        if (iteratee) {
          seen.push(computed);
        }
        result.push(value);
      } else if (!includes(seen, computed, comparator)) {
        if (seen !== result) {
          seen.push(computed);
        }
        result.push(value);
      }
    }
  return result;
}
var _baseUniq = baseUniq$2;
var baseUniq$1 = _baseUniq;
function uniq(array2) {
  return array2 && array2.length ? baseUniq$1(array2) : [];
}
var uniq_1 = uniq;
var baseUniq = _baseUniq;
function uniqWith(array2, comparator) {
  comparator = typeof comparator == "function" ? comparator : void 0;
  return array2 && array2.length ? baseUniq(array2, void 0, comparator) : [];
}
var uniqWith_1 = uniqWith;
const TYPE_NAME = "__typename";
const convertArrayOfNullToNull = (arr) => {
  if (!arr) {
    return null;
  }
  const isValid2 = arr.every((data2) => !data2);
  return isValid2 ? null : arr;
};
const updateProductSKUsWithProductDetailSetting = (productSKUs, isProductWithShadowSKU, productData) => {
  return productSKUs.map((productSKU, i2) => {
    return __spreadProps(__spreadValues({}, productSKU), {
      image: productSKUs[i2].image || "",
      weight: isProductWithShadowSKU ? Number(productData.weight) : productSKU.weight,
      price: isProductWithShadowSKU ? productData.defaultPrice : productSKU.price || 0,
      productCode: isProductWithShadowSKU ? productData.productCode : productSKU.productCode,
      cfCode: isProductWithShadowSKU ? productData.cfCode || null : productSKU.cfCode || null,
      dimension: isProductWithShadowSKU ? convertArrayOfNullToNull(productData == null ? void 0 : productData.dimension) : convertArrayOfNullToNull(productSKU == null ? void 0 : productSKU.dimension)
    });
  });
};
const getProductSKUsOptionsFromDigitalContentOutputType = (outputType) => {
  let optionsData = {};
  switch (outputType) {
    case ProductOutputType.CODE_AUTO_GENERATED:
      optionsData = {
        digitalContentOptions: {
          outputType,
          settings: {
            availability: {
              type: DigitalContentAvailability.NO_EXPIRY,
              settings: {}
            }
          }
        }
      };
      break;
    case ProductOutputType.STATIC:
      optionsData = {
        digitalContentOptions: {
          outputType,
          settings: {
            content: ""
          }
        }
      };
      break;
    case ProductOutputType.CODE_IMPORTED:
      optionsData = {
        digitalContentOptions: {
          outputType,
          settings: {
            availability: { type: DigitalContentAvailability.NO_EXPIRY }
          }
        }
      };
      break;
    case ProductOutputType.CODE_GENERATED_FROM_OTHER:
      optionsData = {
        digitalContentOptions: {
          outputType
        }
      };
      break;
  }
  return optionsData;
};
function removeTypenameField(value) {
  if (value === null || value === void 0) {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map((v2) => removeTypenameField(v2));
  }
  if (typeof value === "object") {
    const newObj = {};
    Object.entries(value).forEach(([key, v2]) => {
      if (key !== TYPE_NAME) {
        newObj[key] = removeTypenameField(v2);
      }
    });
    return newObj;
  }
  return value;
}
function removeFieldByName(valueInput, name) {
  if (!valueInput) {
    return valueInput;
  }
  if (Array.isArray(valueInput)) {
    return valueInput.map((value) => removeFieldByName(value, name));
  }
  if (typeof valueInput === "object") {
    const newObj = {};
    Object.entries(valueInput).forEach(([key, value]) => {
      if (!name.includes(key)) {
        newObj[key] = removeFieldByName(value, name);
      }
    });
    return newObj;
  }
  return valueInput;
}
const getInitAllTypesFromProductSKUs = (productSKUsData) => {
  let allTypes = [];
  productSKUsData.forEach((productSKU) => {
    var _a2;
    (_a2 = productSKU == null ? void 0 : productSKU.productType) == null ? void 0 : _a2.forEach((type) => {
      const keyIndex = allTypes.findIndex((_a4) => {
        var _b = _a4, { value: _a3 } = _b, newType = __objRest(_b, ["value"]);
        const { key } = type;
        return JSON.stringify(key) === JSON.stringify(newType);
      });
      if (keyIndex !== -1) {
        const _c = type, { key } = _c, temp = __objRest(_c, ["key"]);
        allTypes[keyIndex].value = [...allTypes[keyIndex].value, temp];
      } else {
        const _d = type, { key } = _d, temp = __objRest(_d, ["key"]);
        allTypes = [...allTypes, __spreadProps(__spreadValues({}, key), { value: [temp] })];
      }
    });
  });
  const allUniqTypesValue = allTypes.map((type) => uniqWith_1(type.value, isEqual_1));
  const finalStringArrayAllTypesValue = allUniqTypesValue.map((valueItem) => valueItem.map((valueItemValue) => valueItemValue.value));
  const results2 = allTypes.map((type, index2) => __spreadProps(__spreadValues({}, type), {
    nanoid: nanoid(),
    value: finalStringArrayAllTypesValue[index2]
  }));
  return results2;
};
const findProductSKUItemMultiBySKUId = (productSKUs, firstItemKey, firstItemValue, secondItemKey, secondItemValue) => {
  return productSKUs.find((productSKU) => get_1(productSKU, "productType[0].key.key") === firstItemKey && get_1(productSKU, "productType[0].value") === firstItemValue && get_1(productSKU, "productType[1].key.key") === secondItemKey && get_1(productSKU, "productType[1].value") === secondItemValue);
};
const getProductTypeIdBySKUValue = (productSKUs, firstItemValue, index2) => {
  const productSKUItemValueID = productSKUs.find((productSKU) => get_1(productSKU, `productType[${index2}].value`) === firstItemValue);
  return get_1(productSKUItemValueID, `productType[${index2}].id`);
};
const getProductTypeKeyIdBySKUKeyValue = (productSKUs, itemKey, index2) => {
  const productSKUItemValueID = productSKUs.find((productSKU) => get_1(productSKU, `productType[${index2}].key.key`) === itemKey);
  return get_1(productSKUItemValueID, `productType[${index2}].key.id`);
};
const findProductSKUItemSingleBySKUId = (productSKUs, firstItemKey, firstItemValue) => {
  return productSKUs.find((productSKU) => get_1(productSKU, "productType[0].key.key") === firstItemKey && get_1(productSKU, "productType[0].value") === firstItemValue);
};
const constructSKUsData = (productData, productSKUs, productId = void 0, productIsActive, productIsFree, variationList, productSKUShadowId, outputType) => {
  const firstVariationValue = get_1(variationList, "[0].value", []);
  const secondVariationValue = get_1(variationList, "[1].value", []);
  const newProductSKUsData = [];
  const defaultWeight = productData.weightPerUnit ? { weight: Number(productData.weightPerUnit) } : { weight: 0 };
  const defaultDimension = (productData == null ? void 0 : productData.width) || (productData == null ? void 0 : productData.length) || (productData == null ? void 0 : productData.height) ? {
    dimension: [
      productData == null ? void 0 : productData.width,
      productData == null ? void 0 : productData.length,
      productData == null ? void 0 : productData.height
    ]
  } : {};
  if (!variationList.length) {
    let defaultDigitalContentOptions = {};
    if (outputType) {
      defaultDigitalContentOptions = getProductSKUsOptionsFromDigitalContentOutputType(outputType);
    }
    return [
      __spreadValues(__spreadProps(__spreadValues(__spreadValues({
        id: productSKUShadowId || void 0,
        nanoid: nanoid(),
        productCode: productData.productCode,
        cfCode: productData.cfCode || null
      }, defaultWeight), defaultDimension), {
        price: productData.price,
        productType: [],
        selected: productIsActive,
        isFree: productIsFree,
        image: "",
        inventory: 0
      }), defaultDigitalContentOptions)
    ];
  }
  firstVariationValue.forEach((firstItemValue) => {
    if (variationList.length === 2) {
      secondVariationValue.forEach((secondItemValue) => {
        const existProductSKU = findProductSKUItemMultiBySKUId(productSKUs, variationList[0].key, firstItemValue, variationList[1].key, secondItemValue);
        if (existProductSKU) {
          newProductSKUsData.push(__spreadProps(__spreadValues({}, existProductSKU), {
            nanoid: nanoid(),
            productId
          }));
        } else {
          let defaultDigitalContentOptions = {};
          if (outputType) {
            defaultDigitalContentOptions = getProductSKUsOptionsFromDigitalContentOutputType(outputType);
          }
          newProductSKUsData.push(__spreadValues(__spreadProps(__spreadValues(__spreadValues({
            productId,
            price: productData.price,
            nanoid: nanoid(),
            productCode: (productData == null ? void 0 : productData.productCode) ? `${productData == null ? void 0 : productData.productCode}-${nanoid()}` : ""
          }, defaultWeight), defaultDimension), {
            image: "",
            selected: productIsActive,
            deleted: false,
            isFree: productIsFree,
            inventory: 0,
            productType: [
              {
                id: getProductTypeIdBySKUValue(productSKUs, firstItemValue, 0),
                value: firstItemValue,
                key: {
                  id: getProductTypeKeyIdBySKUKeyValue(productSKUs, variationList[0].key, 0),
                  key: variationList[0].key
                }
              },
              {
                id: getProductTypeIdBySKUValue(productSKUs, secondItemValue, 1),
                value: secondItemValue,
                key: {
                  id: getProductTypeKeyIdBySKUKeyValue(productSKUs, variationList[1].key, 1),
                  key: variationList[1].key
                }
              }
            ]
          }), defaultDigitalContentOptions));
        }
      });
    } else {
      const existProductSKU = findProductSKUItemSingleBySKUId(productSKUs, variationList[0].key, firstItemValue);
      if (existProductSKU) {
        newProductSKUsData.push(__spreadProps(__spreadValues({}, existProductSKU), {
          nanoid: nanoid(),
          productId,
          productType: [
            {
              value: firstItemValue,
              key: {
                id: getProductTypeKeyIdBySKUKeyValue(productSKUs, variationList[0].key, 0),
                key: variationList[0].key
              }
            }
          ]
        }));
      } else {
        let defaultDigitalContentOptions = {};
        if (outputType) {
          defaultDigitalContentOptions = getProductSKUsOptionsFromDigitalContentOutputType(outputType);
        }
        newProductSKUsData.push(__spreadValues(__spreadProps(__spreadValues(__spreadValues({
          productId,
          price: productData.price,
          nanoid: nanoid(),
          productCode: (productData == null ? void 0 : productData.productCode) ? `${productData == null ? void 0 : productData.productCode}-${nanoid()}` : ""
        }, defaultWeight), defaultDimension), {
          image: "",
          selected: productIsActive,
          deleted: false,
          isFree: productIsFree,
          inventory: 0,
          productType: [
            {
              value: firstItemValue,
              key: {
                id: getProductTypeKeyIdBySKUKeyValue(productSKUs, variationList[0].key, 0),
                key: variationList[0].key
              }
            }
          ]
        }), defaultDigitalContentOptions));
      }
    }
    return null;
  });
  return newProductSKUsData;
};
const mappingValidationErrorsList = (errors) => {
  const { t: t2 } = useTranslation();
  const errorList = uniq_1(errors).map((value) => {
    switch (value) {
      case "Error(1)": {
        return { id: 1, value: `(1) ${t2("product.error.required")}` };
      }
      case "Error(2)": {
        return {
          id: 2,
          value: `(2) ${t2("product.error.productCodeHasWrongFormat")}`
        };
      }
      case "Error(3)": {
        return {
          id: 3,
          value: `(3) ${t2("product.error.CFCodeHasWrongFormat")}`
        };
      }
      case "Error(4)": {
        return {
          id: 4,
          value: `(4) ${t2("product.error.pricingLowerThanZero")}`
        };
      }
      case "Error(5)": {
        return { id: 5, value: `(5) ${t2("product.inventory.info")}` };
      }
      default:
        return { id: 1, value: `(1) ${t2("product.error.required")}` };
    }
  });
  return sortBy_1(errorList, (value) => value.id).map((data2) => data2.value);
};
const getIsProductDataChanged = (isProductWithShadowSKU, oldProduct, newProduct) => {
  var _a2;
  const isFreeProduct = (oldProduct == null ? void 0 : oldProduct.productSKUs) && (oldProduct == null ? void 0 : oldProduct.productSKUs.length) ? oldProduct == null ? void 0 : oldProduct.productSKUs.every(({ isFree }) => isFree) : false;
  const newProductData = isProductWithShadowSKU ? newProduct : lodash.exports.omit(newProduct, "inventory");
  const transformedInventoryProduct = isProductWithShadowSKU ? { inventory: get_1(oldProduct == null ? void 0 : oldProduct.productSKUs, "0.inventory") } : {};
  const transformedProduct = __spreadValues({
    images: get_1(oldProduct, "images"),
    productSKUs: oldProduct == null ? void 0 : oldProduct.productSKUs,
    productName: get_1(oldProduct, "name"),
    brand: get_1(oldProduct, "brand"),
    description: get_1(oldProduct, "description"),
    category: get_1(oldProduct, "categories.0.id"),
    productCode: get_1(oldProduct, "productCode"),
    cfCode: get_1(oldProduct, "cfCode"),
    price: get_1(oldProduct, "defaultPrice", 0),
    costPrice: get_1(oldProduct, "defaultCostPrice"),
    isActive: (oldProduct == null ? void 0 : oldProduct.productSKUs) && ((_a2 = oldProduct == null ? void 0 : oldProduct.productSKUs) == null ? void 0 : _a2.length) ? oldProduct == null ? void 0 : oldProduct.productSKUs.some(({ selected }) => selected) : true,
    productUnit: get_1(oldProduct, "unit", ""),
    weightPerUnit: get_1(oldProduct, "weight"),
    width: get_1(oldProduct, "dimension.0"),
    length: get_1(oldProduct, "dimension.1"),
    height: get_1(oldProduct, "dimension.2"),
    property: get_1(oldProduct, "properties", []),
    isFreeProduct
  }, transformedInventoryProduct);
  return !isEqual_1(transformedProduct, newProductData);
};
const ADD_CATEGORY = gql$1`
  mutation addCategory($projectId: ID!, $category: CategoryInput!) {
    addCategory(projectId: $projectId, category: $category) {
      id
      projectId
      name
      image
      isActive
      properties {
        name
      }
      variations {
        name
      }
      updatedAt
      isHomePageCategory
    }
  }
`;
const ALL_CATEGORY = gql$1`
  query allCategory($projectId: ID!) {
    categories(projectId: $projectId) {
      results {
        id
        projectId
        name
        image
        isActive
        properties {
          name
        }
        variations {
          name
        }
        isHomePageCategory
        updatedAt
      }
      total
    }
  }
`;
const ALL_CATEGORY_WITH_HIGHLIGHT_PRODUCTS = gql$1`
  query allCategory($projectId: ID!) {
    categories(projectId: $projectId) {
      results {
        id
        projectId
        name
        image
        isActive
        properties {
          name
        }
        variations {
          name
        }
        highlightProducts {
          id
          name
          images {
            src
          }
          isCustomSKU
          defaultPrice
          productSKUs {
            price
            variableTypes {
              key
              value
            }
            inventory
            reserved
            digitalContentOptions {
              outputType
              settings {
                availability {
                  type
                  settings {
                    unit
                    value
                    availableAt
                    expiredAt
                  }
                }
                content
              }
            }
            digitalProductInventories {
              status
              inventory
            }
          }
        }
        isHomePageCategory
        updatedAt
      }
      total
    }
  }
`;
const useGetCategory = (projectId, notifyFailed) => {
  var _a2;
  const { t: t2 } = useTranslation();
  const { data: categoryDataResponse } = useQuery(ALL_CATEGORY_WITH_HIGHLIGHT_PRODUCTS, {
    variables: {
      projectId
    }
  });
  const [createCategory] = useMutation(ADD_CATEGORY, {
    update(cache2, { data: { addCategory: addedCategory } }) {
      const cachedCategories = cache2.readQuery({
        query: ALL_CATEGORY,
        variables: {
          projectId
        }
      });
      if (cachedCategories) {
        const newCacheCategoriesResult = [
          ...cachedCategories.categories.results,
          addedCategory
        ];
        cache2.writeQuery({
          query: ALL_CATEGORY,
          variables: {
            projectId
          },
          data: {
            categories: {
              results: newCacheCategoriesResult,
              total: newCacheCategoriesResult.length,
              __typename: cachedCategories.categories.__typename
            }
          }
        });
      }
    },
    onError: (err) => notifyFailed && notifyFailed(t2(mapErrorMessage(err == null ? void 0 : err.message)))
  });
  const addCategory = (newCategory) => {
    return createCategory({
      variables: {
        category: newCategory,
        projectId
      }
    });
  };
  const categoryResults = ((_a2 = categoryDataResponse == null ? void 0 : categoryDataResponse.categories) == null ? void 0 : _a2.results) || [];
  const categoryData = categoryResults.filter(({ isHomePageCategory }) => !isHomePageCategory);
  return { categoryData, addCategory };
};
const ADD_PRODUCT = gql$1`
  mutation addProduct(
    $projectId: ID!
    $categoryId: ID!
    $product: InputProduct!
  ) {
    addProduct(
      projectId: $projectId
      categoryId: $categoryId
      product: $product
    ) {
      id
      cfCode
      projectId
      outputType
      name
      brand
      productCode
      description
      additionalDescription
      weight
      dimension
      defaultCostPrice
      properties {
        id
        name
        value
      }
      categories {
        id
        projectId
        name
        description
        image
        isFree
        isActive
        isDeleted
        properties {
          name
        }
        variations {
          name
        }
      }
      images {
        src
      }
      deleted
      isCustomSKU
      defaultPrice
      productSKUs {
        id
        cfCode
        productId
        productCode
        costPrice
        price
        image {
          src
        }
        selected
        deleted
        isFree
        productType {
          value
          key {
            key
          }
        }
        inventory
        reserved
        createdAt
        updatedAt
        productName
        productImages {
          src
        }
        options {
          name
          isActive
          isMultipleChoices
          isRequired
          maximum
          choices {
            name
            price
            isActive
            isDefault
            isSelected
          }
        }
        weight
        dimension
        #region For digital content product
        digitalContentOptions {
          outputType
          settings {
            availability {
              type
              settings {
                # PERIOD_AFTER_PURCHASED
                # days
                unit
                value
                # DATE_RANGE
                availableAt
                # EXPIRY_DATE
                expiredAt
              }
            }
            content
          }
        }
        #endregion
      }
    }
  }
`;
const DELETE_PRODUCT = gql$1`
  mutation deleteProduct($projectId: ID!, $id: ID!) {
    deleteProduct(projectId: $projectId, id: $id) {
      id
      projectId
      name
      brand
      productCode
      description
    }
  }
`;
const EDIT_PRODUCT = gql$1`
  mutation editProduct(
    $projectId: ID!
    $categoryId: ID!
    $productId: ID!
    $product: InputProduct!
  ) {
    editProduct(
      projectId: $projectId
      categoryId: $categoryId
      productId: $productId
      product: $product
    ) {
      id
      cfCode
      projectId
      outputType
      name
      brand
      productCode
      description
      additionalDescription
      weight
      dimension
      defaultCostPrice
      properties {
        id
        name
        value
      }
      categories {
        id
        projectId
        name
        description
        image
        isFree
        isActive
        isDeleted
        properties {
          name
        }
        variations {
          name
        }
      }
      images {
        src
      }
      deleted
      isCustomSKU
      defaultPrice
      productSKUs {
        id
        cfCode
        productId
        productCode
        costPrice
        price
        image {
          src
        }
        selected
        deleted
        isFree
        productType {
          value
          key {
            key
          }
        }
        inventory
        reserved
        createdAt
        updatedAt
        productName
        productImages {
          src
        }
        options {
          name
          isActive
          isMultipleChoices
          isRequired
          maximum
          choices {
            name
            price
            isActive
            isDefault
            isSelected
          }
        }
        weight
        dimension
        #region For digital content product
        digitalContentOptions {
          outputType
          settings {
            availability {
              type
              settings {
                # PERIOD_AFTER_PURCHASED
                # days
                unit
                value
                # DATE_RANGE
                availableAt
                # EXPIRY_DATE
                expiredAt
              }
            }
            content
          }
        }
        #endregion
      }
    }
  }
`;
gql$1`
  mutation importProducts($projectId: ID!, $file: Upload!) {
    importProducts(projectId: $projectId, file: $file)
  }
`;
gql$1`
  mutation importDigitalContents($projectId: ID!, $file: Upload!) {
    importDigitalContents(projectId: $projectId, file: $file)
  }
`;
const PRODUCT = gql$1`
  query product($projectId: ID!, $id: ID!) {
    product(projectId: $projectId, id: $id) {
      id
      cfCode
      #region For digital content product
      outputType
      contentType
      #endregion
      type
      projectId
      name
      brand
      defaultPrice
      isCustomSKU
      productCode
      description
      additionalDescription
      unit
      weight
      dimension
      defaultCostPrice
      properties {
        id
        name
        value
      }
      images {
        src
      }
      categories {
        id
        name
      }
      productSKUs {
        id
        cfCode
        price
        productId
        costPrice
        productCode
        inventory
        reserved
        selected
        deleted
        isFree
        image {
          src
        }
        productType {
          value
          key {
            key
          }
        }
        options {
          name
          isActive
          isMultipleChoices
          isRequired
          maximum
          choices {
            name
            price
            isActive
            isDefault
            isSelected
          }
        }
        weight
        dimension
        #region For digital content product
        digitalContentOptions {
          outputType
          settings {
            availability {
              type
              settings {
                # PERIOD_AFTER_PURCHASED
                # days
                unit
                value
                # DATE_RANGE
                availableAt
                # EXPIRY_DATE
                expiredAt
              }
            }
            content
          }
        }
        #endregion
      }
    }
  }
`;
const PRODUCTS = gql$1`
  query products(
    $projectId: ID!
    $limit: Int
    $offset: Int
    $filter: ProductFilterInput
  ) {
    products(
      projectId: $projectId
      limit: $limit
      offset: $offset
      filter: $filter
    ) {
      results {
        id
        cfCode
        #region For digital content product
        outputType
        contentType
        #endregion
        projectId
        name
        type
        brand
        defaultPrice
        unit
        weight
        dimension
        defaultCostPrice
        images {
          src
        }
        categories {
          id
          name
        }
        productSKUs {
          id
          cfCode
          price
          productId
          productCode
          inventory
          reserved
          selected
          deleted
          costPrice
          isFree
          image {
            src
          }
          productType {
            value
            key {
              key
            }
          }
          weight
          dimension
          #region For digital content product
          digitalContentOptions {
            outputType
            settings {
              availability {
                type
                settings {
                  # PERIOD_AFTER_PURCHASED
                  # days
                  unit
                  value
                  # DATE_RANGE
                  availableAt
                  # EXPIRY_DATE
                  expiredAt
                }
              }
              content
            }
          }
          #endregion
        }
      }
      total
    }
  }
`;
const useGetProduct = (projectId, selectedProductId) => {
  const {
    loading: loadingGetProductData,
    data: productData,
    refetch
  } = useQuery(PRODUCT, {
    skip: !projectId || !selectedProductId,
    variables: {
      projectId,
      id: selectedProductId
    }
  });
  const [
    addProduct,
    {
      data: dataAddProduct,
      error: errorAddProduct,
      loading: loadingSubmitAddProduct
    }
  ] = useMutation(ADD_PRODUCT, {
    onError: (err) => {
      throw new Error(err == null ? void 0 : err.message);
    }
  });
  const [
    editProduct,
    {
      data: dataEditProduct,
      error: errorEditProduct,
      loading: loadingSubmitEditProduct
    }
  ] = useMutation(EDIT_PRODUCT, {
    onError: (err) => {
      throw new Error(err == null ? void 0 : err.message);
    }
  });
  const [
    deleteProduct,
    {
      data: dataDeleteProduct,
      error: errorDeleteProduct,
      loading: loadingDeleteProduct
    }
  ] = useMutation(DELETE_PRODUCT, {
    onError: (err) => {
      throw new Error(err == null ? void 0 : err.message);
    }
  });
  const data2 = lodash.exports.get(productData, "product");
  return {
    loadingGetProductData,
    productData: data2,
    refetchProduct: refetch,
    addProduct,
    dataAddProduct,
    loadingSubmitAddProduct,
    editProduct,
    dataEditProduct,
    loadingSubmitEditProduct,
    errorAddProduct,
    errorEditProduct,
    deleteProduct,
    dataDeleteProduct,
    errorDeleteProduct,
    loadingDeleteProduct
  };
};
const UPDATE_INVENTORY = gql$1`
  mutation updateInventory($projectId: ID!, $inventories: [InputInventory]!) {
    updateInventory(projectId: $projectId, inventories: $inventories) {
      productSKUId
      value
    }
  }
`;
const useInventory = () => {
  const [updateInventory, { loading: loadingUpdateInventory }] = useMutation(UPDATE_INVENTORY);
  return { updateInventory, loadingUpdateInventory };
};
const useProductData = ({
  projectId,
  isEditMode,
  selectedProductId,
  closeProductForm,
  notifySuccess: notifySuccess2,
  notifyFailed,
  refetchProducts,
  refetchGuideline
}) => {
  const { t: t2 } = useTranslation();
  const {
    loadingGetProductData,
    loadingSubmitAddProduct,
    loadingSubmitEditProduct,
    loadingDeleteProduct,
    productData,
    refetchProduct,
    addProduct,
    editProduct,
    deleteProduct
  } = useGetProduct(projectId, selectedProductId);
  const { categoryData, addCategory } = useGetCategory(projectId, notifyFailed);
  const { updateInventory } = useInventory();
  const { uploadImage } = useUploadImage();
  const initialProductData = {
    images: [],
    productName: "",
    productSKUs: [],
    brand: "",
    description: "",
    category: "",
    productCode: "",
    price: 0,
    costPrice: void 0,
    cfCode: "",
    width: void 0,
    length: void 0,
    height: void 0,
    productUnit: "",
    weightPerUnit: void 0,
    isFreeProduct: false,
    isActive: true,
    property: [],
    inventory: void 0
  };
  const initProductSKUs = isEditMode ? get_1(productData, ["productSKUs"], []) : [];
  const [product, setProduct] = useState(initialProductData);
  const [isOpenCancelModal, setIsOpenCancelModal] = useState(false);
  const [isOpenCategoryModal, setIsOpenCategoryModal] = useState(false);
  const [isOpenExpandProperty, setIsOpenExpandProperty] = useState(false);
  const [variationListData, setVariationListData] = useState(getInitAllTypesFromProductSKUs(initProductSKUs));
  const [deleteProductErrorMessage, setDeleteProductErrorMessage] = useState("");
  const [isOpenDeleteProductModal, setIsOpenDeleteProductModal] = useState(false);
  const {
    register,
    handleSubmit,
    unregister,
    setError,
    formState: { errors },
    setValue,
    clearErrors
  } = useForm();
  const type = ProductType.SKU;
  const isProductWithShadowSKU = variationListData.length === 0;
  const isCustomSKU = !isProductWithShadowSKU;
  const IMAGE_UPLOAD_MAX_LENGTH = 10;
  const cleanDataProductSKUs = (productSKUs) => removeTypenameField(removeFieldByName(productSKUs, [
    "nanoid",
    "productId",
    "inventory",
    "reserved",
    "digitalContentOptions"
  ])) || [];
  const addNewProperty = () => {
    const propertyId = product == null ? void 0 : product.property.length;
    setProduct(__spreadProps(__spreadValues({}, product), {
      property: [...product == null ? void 0 : product.property, { name: "", value: "" }]
    }));
    register(`property.${propertyId}.name`, {
      required: "product.error.required"
    });
    register(`property.${propertyId}.value`, {
      required: "product.error.required"
    });
  };
  const removeProperty = (key) => {
    const value = product == null ? void 0 : product.property.filter((_value, index2) => key !== index2);
    unregister(`property.${key}.name`);
    unregister(`property.${key}.value`);
    setProduct(__spreadProps(__spreadValues({}, product), { property: value }));
  };
  const setPropertyValue = (index2, field, value) => {
    setValue(`property.${index2}.${field}`, value);
    const newProperty = product == null ? void 0 : product.property.map((v2, i2) => {
      if (i2 === index2) {
        return __spreadProps(__spreadValues({}, v2), { [field]: value });
      }
      return v2;
    });
    setProduct(__spreadProps(__spreadValues({}, product), { property: newProperty }));
  };
  const setVariantAndCategory = (categoryId) => {
    const selectedCategory = categoryData.find(({ id: id2 }) => id2 === categoryId);
    const properties = (selectedCategory == null ? void 0 : selectedCategory.properties) || [];
    const selectedProperties = properties.map(({ name, value }, propertyId) => {
      register(`property.${propertyId}.name`, {
        required: "product.error.required"
      });
      register(`property.${propertyId}.value`, {
        required: "product.error.required"
      });
      setValue(`property.${propertyId}.name`, name);
      setValue(`property.${propertyId}.value`, value);
      return { name };
    }) || [];
    setValue("category", categoryId);
    setProduct(__spreadProps(__spreadValues({}, product), {
      category: categoryId,
      property: selectedProperties
    }));
    if (!isEmpty_1(selectedProperties)) {
      setIsOpenExpandProperty(true);
    }
  };
  const setFreeProduct = () => {
    const updatedFreeProductSKUs = product == null ? void 0 : product.productSKUs.map((value) => __spreadProps(__spreadValues({}, value), {
      isFree: !(product == null ? void 0 : product.isFreeProduct)
    }));
    setProduct(__spreadProps(__spreadValues({}, product), {
      productSKUs: updatedFreeProductSKUs,
      isFreeProduct: !(product == null ? void 0 : product.isFreeProduct)
    }));
  };
  const setActiveProduct = () => {
    const updatedActiveProductSKUs = product == null ? void 0 : product.productSKUs.map((value) => __spreadProps(__spreadValues({}, value), {
      selected: !(product == null ? void 0 : product.isActive)
    }));
    setProduct(__spreadProps(__spreadValues({}, product), {
      productSKUs: updatedActiveProductSKUs,
      isActive: !(product == null ? void 0 : product.isActive)
    }));
  };
  const cancelModal = () => {
    setIsOpenCategoryModal(false);
    setIsOpenCancelModal(false);
  };
  const getDimension = () => convertArrayOfNullToNull([
    Number(product == null ? void 0 : product.width) || void 0,
    Number(product == null ? void 0 : product.length) || void 0,
    Number(product == null ? void 0 : product.height) || void 0
  ]);
  const handleSetCoverImage = (index2) => {
    const reArrangedImages = moveItemInArrayFromIndexToIndex(product == null ? void 0 : product.images, index2, 0);
    setProduct(__spreadProps(__spreadValues({}, product), {
      images: reArrangedImages
    }));
  };
  const handleRemoveImage = (index2) => {
    const filteredImage = product == null ? void 0 : product.images.filter((value, i2) => i2 !== index2);
    setProduct(__spreadProps(__spreadValues({}, product), {
      images: filteredImage
    }));
  };
  const handleChangeImage = (file) => {
    var _a2, _b;
    if (file) {
      const imageItems = [];
      let inputFile = file || [];
      if ((inputFile == null ? void 0 : inputFile.length) + ((_a2 = product == null ? void 0 : product.images) == null ? void 0 : _a2.length) > IMAGE_UPLOAD_MAX_LENGTH) {
        inputFile = dropRight_1(inputFile, (inputFile == null ? void 0 : inputFile.length) + ((_b = product == null ? void 0 : product.images) == null ? void 0 : _b.length) - IMAGE_UPLOAD_MAX_LENGTH);
      }
      inputFile.forEach((imageFile) => {
        const value = window.URL.createObjectURL(imageFile);
        imageItems.push({ src: value, file: imageFile });
      });
      setProduct(__spreadProps(__spreadValues({}, product), {
        images: [...(product == null ? void 0 : product.images) || [], ...imageItems]
      }));
    }
  };
  const generateShadowProductSKUs = () => {
    if (!(product == null ? void 0 : product.productSKUs.length)) {
      return [
        {
          productCode: product == null ? void 0 : product.productCode,
          cfCode: (product == null ? void 0 : product.cfCode) || null,
          price: Number(product == null ? void 0 : product.price) || 0,
          productType: [],
          selected: product == null ? void 0 : product.isActive,
          isFree: product == null ? void 0 : product.isFreeProduct,
          image: "",
          dimension: convertArrayOfNullToNull([
            Number(product == null ? void 0 : product.width) || void 0,
            Number(product == null ? void 0 : product.length) || void 0,
            Number(product == null ? void 0 : product.height) || void 0
          ]),
          weight: Number(product == null ? void 0 : product.weightPerUnit) || 0
        }
      ];
    }
    return void 0;
  };
  const handleSetUploadImage = async () => {
    const result = ((product == null ? void 0 : product.images) || []).map(async (value) => {
      if (value == null ? void 0 : value.file) {
        const newUrlImage = await uploadImage(projectId, value == null ? void 0 : value.file);
        return { src: newUrlImage == null ? void 0 : newUrlImage.publicUrl };
      }
      return value;
    });
    return Promise.all(result).then((value) => value.map((image) => ({ src: (image == null ? void 0 : image.src) || "" })));
  };
  const handleSetUploadProductSKUImage = async () => {
    const result = await Promise.all(product == null ? void 0 : product.productSKUs.map(async (value) => {
      var _a2, _b, _c;
      if ((_a2 = value == null ? void 0 : value.image) == null ? void 0 : _a2.file) {
        const newUrlImage = await uploadImage(projectId, (_b = value == null ? void 0 : value.image) == null ? void 0 : _b.file);
        return __spreadProps(__spreadValues({}, value), {
          image: newUrlImage == null ? void 0 : newUrlImage.publicUrl
        });
      }
      return __spreadProps(__spreadValues({}, value), { image: (_c = value == null ? void 0 : value.image) == null ? void 0 : _c.src });
    }));
    return result;
  };
  const getProduct = async () => {
    var _a2;
    if (isEditMode) {
      const data2 = await refetchProduct();
      if (data2) {
        const productData2 = get_1(data2, "data.product");
        const productSKUs = get_1(productData2, "productSKUs", []);
        const isFreeProduct = productSKUs && productSKUs.length ? productSKUs.every(({ isFree }) => isFree) : false;
        setProduct(__spreadProps(__spreadValues({}, product), {
          images: get_1(productData2, "images"),
          productSKUs,
          productName: get_1(productData2, "name"),
          brand: get_1(productData2, "brand"),
          description: get_1(productData2, "description"),
          category: get_1(productData2, "categories.0.id"),
          productCode: get_1(productData2, "productCode"),
          cfCode: get_1(productData2, "cfCode"),
          price: get_1(productData2, "defaultPrice", 0),
          costPrice: get_1(productData2, "defaultCostPrice"),
          isActive: productSKUs && (productSKUs == null ? void 0 : productSKUs.length) ? productSKUs.some(({ selected }) => selected) : true,
          productUnit: get_1(productData2, "unit", ""),
          weightPerUnit: get_1(productData2, "weight"),
          width: get_1(productData2, "dimension.0"),
          length: get_1(productData2, "dimension.1"),
          height: get_1(productData2, "dimension.2"),
          property: get_1(productData2, "properties", []),
          isFreeProduct,
          inventory: isProductWithShadowSKU ? get_1(productSKUs, "0.inventory") : 0
        }));
        setVariationListData(getInitAllTypesFromProductSKUs(productSKUs));
        (_a2 = productData2 == null ? void 0 : productData2.properties) == null ? void 0 : _a2.forEach(({ name, value }, index2) => {
          register(`property.${index2}.name`, {
            required: "product.error.required"
          });
          register(`property.${index2}.value`, {
            required: "product.error.required"
          });
          setValue(`property.${index2}.name`, name);
          setValue(`property.${index2}.value`, value);
        });
        setValue("productName", get_1(productData2, "name"));
        setValue("category", get_1(productData2, "categories.0.id"));
        setValue("productCode", get_1(productData2, "productCode"));
        setValue("price", get_1(productData2, "defaultPrice"));
        setValue("width", get_1(productData2, "dimension.0"));
        setValue("length", get_1(productData2, "dimension.1"));
        setValue("height", get_1(productData2, "dimension.2"));
        if (isProductWithShadowSKU) {
          setValue("inventory", get_1(productSKUs, "0.inventory"));
        }
        if (isFreeProduct) {
          unregister("price");
        }
      }
    }
  };
  const checkProductSKUData = () => {
    const hasEmptyProductSKUsCode = !isProductWithShadowSKU && (product == null ? void 0 : product.productSKUs.filter(({ productCode }) => {
      return lodash.exports.isNil(productCode) || isEmpty_1(productCode);
    }).length) > 0;
    const hasEmptyProductSKUsPrice = !isProductWithShadowSKU && (product == null ? void 0 : product.productSKUs.filter(({ price, isFree }) => {
      return (lodash.exports.isNil(price) || price <= 0) && !isFree;
    }).length) > 0;
    const hasEmptyDimension = !isProductWithShadowSKU && (product == null ? void 0 : product.productSKUs.filter(({ dimension }) => {
      var _a2;
      const dimensionLength = (_a2 = dimension || []) == null ? void 0 : _a2.filter((value) => !lodash.exports.isNil(value)).length;
      return dimensionLength > 0 && dimensionLength < 3;
    }).length) > 0;
    if (hasEmptyProductSKUsCode) {
      throw new Error("emptyProductSKUCode");
    }
    if (hasEmptyProductSKUsPrice) {
      throw new Error("emptyProductSKUPrice");
    }
    if (hasEmptyDimension) {
      throw new Error("emptyProductSKUDimension");
    }
  };
  const getRemovedInventoryValue = (productSKUs) => {
    const removedInventoryValue = productData == null ? void 0 : productData.productSKUs.map((data2) => {
      const result = productSKUs.find(({ id: id2 }) => id2 === (data2 == null ? void 0 : data2.id));
      if (lodash.exports.isNil(result)) {
        return { productSKUId: data2 == null ? void 0 : data2.id, value: -(data2 == null ? void 0 : data2.inventory) };
      }
      return void 0;
    });
    return removedInventoryValue.filter(Boolean);
  };
  const handleAddProduct = async () => {
    var _a2;
    const images2 = await handleSetUploadImage();
    const productSKUWithUploadedImage = await handleSetUploadProductSKUImage();
    checkProductSKUData();
    const variables = {
      projectId,
      categoryId: product == null ? void 0 : product.category,
      product: {
        type,
        name: product == null ? void 0 : product.productName,
        brand: product == null ? void 0 : product.brand,
        productCode: product == null ? void 0 : product.productCode,
        cfCode: (product == null ? void 0 : product.cfCode) || "",
        description: product == null ? void 0 : product.description,
        unit: product == null ? void 0 : product.productUnit,
        weight: Number(product == null ? void 0 : product.weightPerUnit) || 0,
        isCustomSKU,
        defaultPrice: Number(product == null ? void 0 : product.price) || 0,
        defaultCostPrice: Number(product == null ? void 0 : product.costPrice) || void 0,
        images: images2,
        productSKUs: !isEmpty_1(productSKUWithUploadedImage) ? cleanDataProductSKUs(productSKUWithUploadedImage) : generateShadowProductSKUs(),
        properties: product == null ? void 0 : product.property.map(({ id: id2, name, value }) => {
          return { id: id2, name, value };
        }),
        dimension: getDimension()
      }
    };
    const data2 = await addProduct({ variables });
    const productId = get_1(data2, "data.addProduct.id");
    const productSKUs = get_1(data2, "data.addProduct.productSKUs");
    await updateInventory({
      variables: {
        projectId,
        inventories: isProductWithShadowSKU ? [{ productSKUId: (_a2 = productSKUs[0]) == null ? void 0 : _a2.id, value: product == null ? void 0 : product.inventory }] : productSKUWithUploadedImage.map((data22) => {
          var _a3;
          return {
            productSKUId: (data22 == null ? void 0 : data22.id) || ((_a3 = productSKUs.find(({ productCode }) => {
              return productCode.includes(data22 == null ? void 0 : data22.productCode);
            })) == null ? void 0 : _a3.id),
            value: (data22 == null ? void 0 : data22.inventory) || 0
          };
        })
      }
    });
    addGoogleTagEvent(GTM_EVENT.ADD_PRODUCT);
    await closeProductForm(productId);
  };
  const handleEditProduct = async () => {
    const images2 = await handleSetUploadImage();
    const productSKUWithUploadedImage = await handleSetUploadProductSKUImage();
    checkProductSKUData();
    const removedValue = getRemovedInventoryValue(productSKUWithUploadedImage);
    if ((removedValue == null ? void 0 : removedValue.length) > 0) {
      await updateInventory({
        variables: {
          projectId,
          inventories: removedValue
        }
      });
    }
    const data2 = await editProduct({
      variables: {
        productId: selectedProductId,
        projectId,
        categoryId: product == null ? void 0 : product.category,
        product: {
          id: selectedProductId,
          type,
          name: product == null ? void 0 : product.productName,
          brand: product == null ? void 0 : product.brand,
          productCode: product == null ? void 0 : product.productCode,
          cfCode: (product == null ? void 0 : product.cfCode) || "",
          description: product == null ? void 0 : product.description,
          unit: product == null ? void 0 : product.productUnit,
          weight: Number(product == null ? void 0 : product.weightPerUnit) || 0,
          isCustomSKU,
          defaultPrice: Number(product == null ? void 0 : product.price) || (product == null ? void 0 : product.price) || 0,
          defaultCostPrice: Number(product == null ? void 0 : product.costPrice) || void 0,
          images: images2,
          productSKUs: updateProductSKUsWithProductDetailSetting(cleanDataProductSKUs(productSKUWithUploadedImage), isProductWithShadowSKU, {
            weight: Number(product == null ? void 0 : product.weightPerUnit) || 0,
            defaultPrice: Number(product == null ? void 0 : product.price) || (product == null ? void 0 : product.price) || 0,
            productCode: product == null ? void 0 : product.productCode,
            cfCode: product == null ? void 0 : product.cfCode,
            dimension: getDimension()
          }),
          properties: product == null ? void 0 : product.property.map(({ id: id2, name, value }) => {
            return { id: id2, name, value };
          }),
          dimension: getDimension()
        }
      }
    });
    const productSKUs = get_1(data2, "data.editProduct.productSKUs");
    await updateInventory({
      variables: {
        projectId,
        inventories: productSKUWithUploadedImage.map((data22) => {
          var _a2;
          const getSumValue = () => {
            var _a3;
            const productInventory = (product == null ? void 0 : product.inventory) || 0;
            const shadowProductSKUInventory = (data22 == null ? void 0 : data22.inventory) || 0;
            if (isProductWithShadowSKU) {
              return productInventory - shadowProductSKUInventory;
            }
            const productSKUInventory = ((_a3 = productSKUs.find(({ id: id2 }) => id2 === (data22 == null ? void 0 : data22.id))) == null ? void 0 : _a3.inventory) || 0;
            return ((data22 == null ? void 0 : data22.inventory) || 0) - productSKUInventory;
          };
          return {
            productSKUId: (data22 == null ? void 0 : data22.id) || ((_a2 = productSKUs.find(({ productCode }) => {
              return productCode.includes(data22 == null ? void 0 : data22.productCode);
            })) == null ? void 0 : _a2.id),
            value: getSumValue() || 0
          };
        })
      }
    });
  };
  const handleDeleteProduct = async () => {
    try {
      const isAllProductHasZeroInventory = (product == null ? void 0 : product.productSKUs.filter(({ inventory, reserved }) => inventory > 0 || reserved > 0).length) === 0;
      if (isAllProductHasZeroInventory || isProductWithShadowSKU && ((product == null ? void 0 : product.inventory) || 0) <= 0) {
        const removedValue = productData == null ? void 0 : productData.productSKUs.map(({ id: id2, inventory }) => {
          return { productSKUId: id2, value: -inventory };
        });
        if ((removedValue == null ? void 0 : removedValue.length) > 0) {
          await updateInventory({
            variables: {
              projectId,
              inventories: [
                ...removedValue,
                ...getRemovedInventoryValue(product == null ? void 0 : product.productSKUs)
              ]
            }
          });
        }
      }
      await deleteProduct({
        variables: {
          projectId,
          id: productData == null ? void 0 : productData.id
        }
      });
      if (notifySuccess2)
        notifySuccess2(t2("product.notification.deleteSuccess"));
      refetchProducts();
      setIsOpenDeleteProductModal(false);
      closeProductForm();
    } catch (err) {
      setDeleteProductErrorMessage(t2(mapErrorMessage((err == null ? void 0 : err.message) || "") || "product.notification.deleteFailed"));
      setIsOpenDeleteProductModal(false);
    }
  };
  const confirmCancelModal = () => {
    setIsOpenCancelModal(false);
    setIsOpenCategoryModal(false);
    setProduct(initialProductData);
    unregister();
    closeProductForm();
  };
  const confirmCreateCategoryModal = async (value) => {
    const data2 = await addCategory({
      id: `category-${value}`,
      image: "",
      isActive: true,
      name: value,
      projectId,
      properties: [],
      variations: []
    });
    const categoryId = get_1(data2, "data.addCategory.id");
    if (categoryId) {
      addGoogleTagEvent(GTM_EVENT.ADD_CATALOG);
      setProduct(__spreadProps(__spreadValues({}, product), { category: categoryId, property: [] }));
      setValue("category", categoryId);
    }
    setIsOpenCategoryModal(false);
  };
  const submitForm = async () => {
    try {
      if (isEditMode) {
        await handleEditProduct();
        if (notifySuccess2)
          notifySuccess2(t2("product.notification.editSuccess"));
        await refetchProducts();
        closeProductForm();
      } else {
        await handleAddProduct();
        if (notifySuccess2)
          notifySuccess2(t2("product.notification.createSuccess"));
        await refetchProducts();
        if (refetchGuideline) {
          await refetchGuideline();
        }
        closeProductForm();
      }
    } catch (err) {
      if (isEditMode) {
        if (notifyFailed)
          notifyFailed(t2(mapErrorMessage((err == null ? void 0 : err.message) || "") || "product.notification.editFailed"));
      } else if (notifyFailed)
        notifyFailed(t2(mapErrorMessage((err == null ? void 0 : err.message) || "") || "product.notification.createFailed"));
    }
  };
  useEffect(() => {
    void getProduct();
  }, [isEditMode, selectedProductId]);
  useEffect(() => {
    register("productName", { required: "product.error.required" });
    register("category", { required: "product.error.required" });
    register("productCode", {
      required: "product.error.required",
      minLength: {
        value: 3,
        message: "product.error.productCodeHasWrongFormat"
      },
      maxLength: {
        value: 50,
        message: "product.error.productCodeHasWrongFormat"
      },
      pattern: {
        value: REGEX_PRODUCT_CODE_SUPPORT_CHARACTER,
        message: "product.error.productCodeHasWrongFormat"
      }
    });
    register("inventory", {
      required: isProductWithShadowSKU && "product.error.required",
      validate: (value) => {
        if (value < get_1(productData, "productSKUs[0].reserved") || 0) {
          return "product.inventory.info";
        }
        return void 0;
      }
    });
    if (product == null ? void 0 : product.isFreeProduct) {
      unregister("price");
    } else {
      register("price", {
        required: "product.error.required",
        validate: (value) => {
          if (value <= 0) {
            return "product.error.pricingLowerThanZero";
          }
          return void 0;
        }
      });
    }
  }, [product == null ? void 0 : product.isFreeProduct, isProductWithShadowSKU, register]);
  useEffect(() => {
    if (product == null ? void 0 : product.cfCode) {
      register("cfCode", {
        minLength: {
          value: 3,
          message: "product.error.CFCodeHasWrongFormat"
        },
        pattern: {
          value: REGEX_CF_CODE_SUPPORT_CHARACTER,
          message: "product.error.CFCodeHasWrongFormat"
        }
      });
    } else {
      unregister("cfCode");
    }
  }, [product == null ? void 0 : product.cfCode]);
  useEffect(() => {
    if ((product == null ? void 0 : product.width) || (product == null ? void 0 : product.height) || (product == null ? void 0 : product.length)) {
      register("width", {
        required: "product.error.required",
        validate: (value) => {
          if (value <= 0) {
            return "product.error.valueLowerThanZero";
          }
          return void 0;
        },
        max: {
          value: 9999,
          message: "product.error.valueOverThanLimit"
        }
      });
      register("height", {
        required: "product.error.required",
        validate: (value) => {
          if (value <= 0) {
            return "product.error.valueLowerThanZero";
          }
          return void 0;
        },
        max: {
          value: 9999,
          message: "product.error.valueOverThanLimit"
        }
      });
      register("length", {
        required: "product.error.required",
        validate: (value) => {
          if (value <= 0) {
            return "product.error.valueLowerThanZero";
          }
          return void 0;
        },
        max: {
          value: 9999,
          message: "product.error.valueOverThanLimit"
        }
      });
    } else {
      unregister("width");
      unregister("height");
      unregister("length");
    }
  }, [product.width, product.height, product.length]);
  useEffect(() => {
    const hasActiveValue = product == null ? void 0 : product.productSKUs.find(({ selected }) => selected);
    const isFreeProduct = (product == null ? void 0 : product.productSKUs) && (product == null ? void 0 : product.productSKUs.length) && (product == null ? void 0 : product.productSKUs.every(({ isFree }) => isFree));
    setProduct(__spreadProps(__spreadValues({}, product), {
      isActive: !lodash.exports.isNil(hasActiveValue),
      isFreeProduct
    }));
  }, [product == null ? void 0 : product.productSKUs]);
  return {
    handleSubmit,
    submitForm,
    handleDeleteProduct,
    setValue,
    errors,
    setError,
    clearErrors,
    image: { handleSetCoverImage, handleRemoveImage, handleChangeImage },
    product: {
      productValue: product,
      productData,
      isProductWithShadowSKU,
      setProduct,
      loadingGetProductData,
      loadingSubmitAddProduct,
      loadingSubmitEditProduct,
      loadingDeleteProduct,
      addNewProperty,
      removeProperty,
      setFreeProduct,
      setActiveProduct,
      setPropertyValue,
      setVariationListData,
      variationListData
    },
    category: {
      categoryData,
      setVariantAndCategory,
      confirmCreateCategoryModal
    },
    ui: {
      isOpenCancelModal,
      isOpenCategoryModal,
      confirmCancelModal,
      setIsOpenCategoryModal,
      isOpenExpandProperty,
      cancelModal,
      setIsOpenCancelModal,
      deleteProductErrorMessage,
      setDeleteProductErrorMessage,
      isOpenDeleteProductModal,
      setIsOpenDeleteProductModal
    }
  };
};
const InventorySection = ({
  inventory,
  reserved = 0,
  errors,
  handleSetInventory,
  isClientStore
}) => {
  var _a2, _b;
  const {
    t: t2
  } = useTranslation();
  const handleChange = (value) => {
    handleSetInventory(value);
  };
  return /* @__PURE__ */ jsxs(Card, {
    className: "tw-px-6 tw-pt-6 tw-pb-11 tw-mt-6 tw-bg-White",
    contentSize: ContentSize.FULL,
    shadowSize: ElevationShadowType.NONE,
    children: [/* @__PURE__ */ jsx$1("div", {
      className: "tw-w-full",
      children: /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-5",
        children: t2("product.inventory.title")
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-grid tw-mt-4",
      children: [/* @__PURE__ */ jsx$1(FormInput, {
        type: "number",
        value: inventory,
        min: 0,
        decimal: 0,
        thousandSeparator: true,
        label: t2("product.inventory.stock"),
        name: "price",
        error: t2((_a2 = errors == null ? void 0 : errors.inventory) == null ? void 0 : _a2.message),
        handleChange: (value) => handleChange(value),
        disabled: isClientStore
      }), !((_b = errors == null ? void 0 : errors.inventory) == null ? void 0 : _b.message) && /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-pt-1",
        variant: "body-4",
        color: COLORS.Gray[500],
        children: t2("product.inventory.info")
      })]
    }), reserved && reserved > 0 ? /* @__PURE__ */ jsx$1(Typography, {
      className: "tw-pt-4",
      variant: "title-10",
      color: COLORS.Gray[600],
      children: t2("product.inventory.reserve", {
        value: reserved
      })
    }) : null]
  });
};
const Expand = ({
  title = "",
  className,
  children: children2,
  info,
  isOpen
}) => {
  const [isShowDetail, setIsShowDetail] = useState(isOpen || false);
  const borderClass = isShowDetail ? "tw-border tw-border-Gray-200 tw-border-b-0 tw-rounded-tr-lg tw-rounded-tl-lg" : "tw-border tw-border-Gray-200 tw-rounded-lg";
  useEffect(() => {
    if (isOpen)
      setIsShowDetail(isOpen);
  }, [isOpen]);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx$1("div", {
      className: classNames$1("tw-p-6 tw-h-fit", borderClass, className),
      onClick: () => setIsShowDetail(!isShowDetail),
      children: /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-justify-between tw-w-full",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "tw-inline-flex tw-items-center",
          children: [/* @__PURE__ */ jsx$1(Typography, {
            className: classNames$1("tw-cursor-pointer"),
            onClick: () => setIsShowDetail(!isShowDetail),
            variant: "title-5",
            children: title
          }), info && /* @__PURE__ */ jsx$1(Tooltip, {
            description: /* @__PURE__ */ jsx$1("p", {
              children: info
            }),
            variant: "default",
            position: "top",
            arrow: "bottom-center",
            children: /* @__PURE__ */ jsx$1(Icon, {
              name: IconName.INFO,
              size: IconSize.LARGE,
              className: "tw-pl-1 tw-fill-Gray-400"
            })
          })]
        }), /* @__PURE__ */ jsx$1("div", {
          className: "tw-cursor-pointer",
          children: isShowDetail ? /* @__PURE__ */ jsx$1(Icon, {
            name: IconName.UP,
            size: IconSize.LARGE
          }) : /* @__PURE__ */ jsx$1(Icon, {
            name: IconName.DOWN,
            size: IconSize.LARGE
          })
        })]
      })
    }), isShowDetail && /* @__PURE__ */ jsx$1("div", {
      className: "tw-p-6 tw-bg-White tw-rounded-b-lg tw-border tw-border-t-0 tw-border-Gray-200",
      children: children2
    })]
  });
};
function ControlledExpand({
  title = "",
  className,
  children: children2,
  info,
  isOpen,
  onClick: onClick2,
  closeIconName = IconName.DOWN
}) {
  return /* @__PURE__ */ jsxs("div", {
    className: "tw-overflow-hidden",
    children: [/* @__PURE__ */ jsx$1("div", {
      className: classNames$1("tw-p-6 tw-h-fit", {
        "tw-rounded-t-lg tw-border tw-border-b-0 tw-border-Gray-200": isOpen,
        "tw-rounded-lg tw-border tw-border-Gray-200": !isOpen
      }, className),
      onClick: onClick2,
      children: /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-justify-between tw-w-full",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "tw-inline-flex tw-items-center",
          onClick: onClick2,
          role: "button",
          tabIndex: -1,
          children: [title, info && /* @__PURE__ */ jsx$1(Tooltip, {
            description: /* @__PURE__ */ jsx$1("p", {
              children: info
            }),
            variant: "default",
            position: "top",
            arrow: "bottom-center",
            children: /* @__PURE__ */ jsx$1(Icon, {
              name: IconName.INFO,
              size: IconSize.LARGE,
              className: "tw-pl-1 tw-fill-Gray-400"
            })
          })]
        }), /* @__PURE__ */ jsx$1("div", {
          className: "tw-cursor-pointer",
          children: isOpen ? /* @__PURE__ */ jsx$1(Icon, {
            name: IconName.CHREVRON_UP_OUTLINE,
            size: IconSize.MEDIUM,
            className: "tw-stroke-Gray-800"
          }) : /* @__PURE__ */ jsx$1(Icon, {
            name: closeIconName,
            size: IconSize.MEDIUM,
            className: "tw-stroke-Gray-800"
          })
        })]
      })
    }), /* @__PURE__ */ jsx$1("div", {
      className: classNames$1("tw-overflow-hidden tw-bg-White tw-rounded-b-lg  tw-border-Gray-200 tw-transition-[max-height]", {
        "tw-max-h-[auto] tw-border tw-border-t-0": isOpen,
        "tw-max-h-0 tw-border-0": !isOpen
      }),
      children: /* @__PURE__ */ jsx$1("div", {
        className: "tw-p-6",
        children: children2
      })
    })]
  });
}
const ProductAdvanceDetailSection = (props) => {
  var _a2, _b, _c;
  const {
    productUnit,
    setProductUnit,
    weightPerUnit,
    setWeightPerUnit,
    width,
    errors,
    setValue,
    setWidth,
    setLength,
    setHeight,
    height,
    length: length2,
    isClientStore
  } = props;
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(Expand, {
    className: "tw-mt-6 tw-bg-White",
    title: t2("product.advanceDetail.title"),
    children: [/* @__PURE__ */ jsxs("div", {
      className: "tw-grid mobile:tw-grid-cols-1 tablet:tw-grid-cols-2 tablet:tw-gap-x-4",
      children: [/* @__PURE__ */ jsx$1(FormInput, {
        value: productUnit,
        maxLength: 50,
        label: t2("product.advanceDetail.productUnit.label"),
        placeholder: t2("product.advanceDetail.productUnit.placeholder"),
        isOptional: true,
        handleChange: setProductUnit,
        disabled: isClientStore
      }), /* @__PURE__ */ jsx$1("div", {
        className: "mobile:tw-pt-9 tablet:tw-pt-0",
        children: /* @__PURE__ */ jsx$1(FormInput, {
          value: weightPerUnit,
          type: "number",
          decimal: 2,
          min: 0,
          label: t2("product.advanceDetail.weightPerUnit"),
          isOptional: true,
          handleChange: (value) => setWeightPerUnit(value),
          disabled: isClientStore
        })
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-grid tw-pt-9 mobile:tw-grid-cols-1 tablet:tw-grid-cols-3 tablet:tw-gap-x-3",
      children: [/* @__PURE__ */ jsx$1(FormInput, {
        value: width,
        type: "number",
        decimal: 2,
        min: 0,
        max: 9999,
        label: t2("product.advanceDetail.dimension"),
        isOptional: true,
        placeholder: t2("product.advanceDetail.width"),
        error: t2((_a2 = errors == null ? void 0 : errors.width) == null ? void 0 : _a2.message),
        handleChange: (value) => {
          setValue("width", value);
          setWidth(value);
        },
        disabled: isClientStore
      }), /* @__PURE__ */ jsx$1("div", {
        className: "mobile:tw-pt-4 tablet:tw-pt-6",
        children: /* @__PURE__ */ jsx$1(FormInput, {
          type: "number",
          value: length2,
          decimal: 2,
          min: 0,
          max: 9999,
          placeholder: t2("product.advanceDetail.length"),
          error: t2((_b = errors == null ? void 0 : errors.length) == null ? void 0 : _b.message),
          handleChange: (value) => {
            setValue("length", value);
            setLength(value);
          },
          disabled: isClientStore
        })
      }), /* @__PURE__ */ jsx$1("div", {
        className: "mobile:tw-pt-4 tablet:tw-pt-6",
        children: /* @__PURE__ */ jsx$1(FormInput, {
          type: "number",
          value: height,
          decimal: 2,
          min: 0,
          max: 9999,
          error: t2((_c = errors == null ? void 0 : errors.height) == null ? void 0 : _c.message),
          placeholder: t2("product.advanceDetail.height"),
          handleChange: (value) => {
            setValue("height", value);
            setHeight(value);
          },
          disabled: isClientStore
        })
      })]
    })]
  });
};
const TextArea = (props) => {
  const _a2 = props, {
    isError = false,
    disabled,
    handleChange
  } = _a2, rest = __objRest(_a2, [
    "isError",
    "disabled",
    "handleChange"
  ]);
  const generatedId = `input-${nanoid()}`;
  const defaultClass = "tw-flex tw-px-4 tw-py-3.5 tw-rounded tw-border tw-border-solid";
  const stateClass = isError ? "tw-border-Red focus-within:tw-border-Red" : "tw-border-Gray-400 focus-within:tw-border-Primary-600";
  const resizeClass = disabled ? "tw-resize-none" : "";
  const bgClass = disabled ? "tw-bg-Gray-200" : "tw-bg-White";
  const handleSetFocus = () => {
    const input = document.getElementById(generatedId);
    if (input) {
      input.focus();
    }
  };
  return /* @__PURE__ */ jsx$1("div", {
    className: `${defaultClass} ${stateClass} ${bgClass}`,
    onClick: () => handleSetFocus(),
    children: /* @__PURE__ */ jsx$1("textarea", __spreadValues({
      className: `tw-p-0 tw-m-0 focus-visible:tw-outline-none tw-flex-1 placeholder:tw-text-Gray-400 tw-text-sm tw-text-Gray-800 ${resizeClass}`,
      onChange: (e2) => handleChange(e2.target.value),
      disabled
    }, rest))
  });
};
TextArea.displayName = "TextArea";
const FormTextArea = (_B) => {
  var _C = _B, {
    label,
    info,
    isOptional = false,
    error: error2,
    maxLength,
    handleChange,
    placeholder,
    value
  } = _C, props = __objRest(_C, [
    "label",
    "info",
    "isOptional",
    "error",
    "maxLength",
    "handleChange",
    "placeholder",
    "value"
  ]);
  const {
    t: t2
  } = useTranslation();
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (value && maxLength) {
      setCount((value == null ? void 0 : value.length) || 0);
    }
  }, [value, maxLength]);
  return /* @__PURE__ */ jsxs("div", {
    children: [label && /* @__PURE__ */ jsxs("div", {
      className: "tw-inline-flex tw-pb-1 tw-w-full",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "tw-inline-flex tw-w-full tw-max-w-full tw-truncate",
        children: [/* @__PURE__ */ jsx$1(Typography, {
          className: "tw-pr-1 tw-w-fit tw-truncate",
          variant: "title-9",
          color: error2 ? COLORS.Red : COLORS.Gray[600],
          children: label
        }), info && /* @__PURE__ */ jsx$1(Tooltip, {
          description: /* @__PURE__ */ jsx$1("p", {
            children: info
          }),
          variant: "default",
          position: "right",
          arrow: "left-center",
          children: /* @__PURE__ */ jsx$1(Icon, {
            name: IconName.INFO,
            size: IconSize.MEDIUM,
            viewBox: "0 0 32 32",
            className: "tw-pr-1 tw-fill-Gray-400"
          })
        }), isOptional && /* @__PURE__ */ jsx$1(Typography, {
          className: "tw-pr-1",
          variant: "title-9",
          color: COLORS.Gray[500],
          children: t2("createStore.optional")
        })]
      }), maxLength && /* @__PURE__ */ jsx$1("div", {
        children: /* @__PURE__ */ jsx$1(Typography, {
          variant: "body-3",
          color: COLORS.Gray[500],
          children: `${count}/${maxLength}`
        })
      })]
    }), /* @__PURE__ */ jsx$1(TextArea, __spreadValues({
      value,
      defaultValue: value,
      placeholder,
      handleChange,
      isError: !isEmpty_1(error2),
      maxLength
    }, props)), error2 && /* @__PURE__ */ jsx$1(Typography, {
      className: "tw-pt-1 tw-pb-2 tw-w-full tw-text-left",
      variant: "body-3",
      color: COLORS.Red,
      children: t2(error2)
    })]
  });
};
var propTypes = { exports: {} };
var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {
}
function emptyFunctionWithReset() {
}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    err.name = "Invariant Violation";
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes.exports = factoryWithThrowingShims();
}
var PropTypes = propTypes.exports;
function __awaiter(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e2) {
        reject(e2);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e2) {
        reject(e2);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _23 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y2, t2, g2;
  return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
    return this;
  }), g2;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_23)
      try {
        if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _23.label++;
            return { value: op[1], done: false };
          case 5:
            _23.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _23.ops.pop();
            _23.trys.pop();
            continue;
          default:
            if (!(t2 = _23.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _23 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _23.label = op[1];
              break;
            }
            if (op[0] === 6 && _23.label < t2[1]) {
              _23.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _23.label < t2[2]) {
              _23.label = t2[2];
              _23.ops.push(op);
              break;
            }
            if (t2[2])
              _23.ops.pop();
            _23.trys.pop();
            continue;
        }
        op = body.call(thisArg, _23);
      } catch (e2) {
        op = [6, e2];
        y2 = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __read(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e2;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error2) {
    e2 = { error: error2 };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e2)
        throw e2.error;
    }
  }
  return ar;
}
function __spread() {
  for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
    ar = ar.concat(__read(arguments[i2]));
  return ar;
}
var COMMON_MIME_TYPES = new Map([
  ["avi", "video/avi"],
  ["gif", "image/gif"],
  ["ico", "image/x-icon"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["mp4", "video/mp4"],
  ["pdf", "application/pdf"],
  ["png", "image/png"],
  ["zip", "application/zip"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]
]);
function toFileWithPath(file, path) {
  var f2 = withMimeType(file);
  if (typeof f2.path !== "string") {
    var webkitRelativePath = file.webkitRelativePath;
    Object.defineProperty(f2, "path", {
      value: typeof path === "string" ? path : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
      writable: false,
      configurable: false,
      enumerable: true
    });
  }
  return f2;
}
function withMimeType(file) {
  var name = file.name;
  var hasExtension = name && name.lastIndexOf(".") !== -1;
  if (hasExtension && !file.type) {
    var ext = name.split(".").pop().toLowerCase();
    var type = COMMON_MIME_TYPES.get(ext);
    if (type) {
      Object.defineProperty(file, "type", {
        value: type,
        writable: false,
        configurable: false,
        enumerable: true
      });
    }
  }
  return file;
}
var FILES_TO_IGNORE = [
  ".DS_Store",
  "Thumbs.db"
];
function fromEvent(evt) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(_a2) {
      return [2, isDragEvt(evt) && evt.dataTransfer ? getDataTransferFiles(evt.dataTransfer, evt.type) : getInputFiles(evt)];
    });
  });
}
function isDragEvt(value) {
  return !!value.dataTransfer;
}
function getInputFiles(evt) {
  var files = isInput(evt.target) ? evt.target.files ? fromList(evt.target.files) : [] : [];
  return files.map(function(file) {
    return toFileWithPath(file);
  });
}
function isInput(value) {
  return value !== null;
}
function getDataTransferFiles(dt, type) {
  return __awaiter(this, void 0, void 0, function() {
    var items, files;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          if (!dt.items)
            return [3, 2];
          items = fromList(dt.items).filter(function(item) {
            return item.kind === "file";
          });
          if (type !== "drop") {
            return [2, items];
          }
          return [4, Promise.all(items.map(toFilePromises))];
        case 1:
          files = _a2.sent();
          return [2, noIgnoredFiles(flatten(files))];
        case 2:
          return [2, noIgnoredFiles(fromList(dt.files).map(function(file) {
            return toFileWithPath(file);
          }))];
      }
    });
  });
}
function noIgnoredFiles(files) {
  return files.filter(function(file) {
    return FILES_TO_IGNORE.indexOf(file.name) === -1;
  });
}
function fromList(items) {
  var files = [];
  for (var i2 = 0; i2 < items.length; i2++) {
    var file = items[i2];
    files.push(file);
  }
  return files;
}
function toFilePromises(item) {
  if (typeof item.webkitGetAsEntry !== "function") {
    return fromDataTransferItem(item);
  }
  var entry = item.webkitGetAsEntry();
  if (entry && entry.isDirectory) {
    return fromDirEntry(entry);
  }
  return fromDataTransferItem(item);
}
function flatten(items) {
  return items.reduce(function(acc, files) {
    return __spread(acc, Array.isArray(files) ? flatten(files) : [files]);
  }, []);
}
function fromDataTransferItem(item) {
  var file = item.getAsFile();
  if (!file) {
    return Promise.reject(item + " is not a File");
  }
  var fwp = toFileWithPath(file);
  return Promise.resolve(fwp);
}
function fromEntry(entry) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(_a2) {
      return [2, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
    });
  });
}
function fromDirEntry(entry) {
  var reader = entry.createReader();
  return new Promise(function(resolve, reject) {
    var entries = [];
    function readEntries() {
      var _this = this;
      reader.readEntries(function(batch) {
        return __awaiter(_this, void 0, void 0, function() {
          var files, err_1, items;
          return __generator(this, function(_a2) {
            switch (_a2.label) {
              case 0:
                if (!!batch.length)
                  return [3, 5];
                _a2.label = 1;
              case 1:
                _a2.trys.push([1, 3, , 4]);
                return [4, Promise.all(entries)];
              case 2:
                files = _a2.sent();
                resolve(files);
                return [3, 4];
              case 3:
                err_1 = _a2.sent();
                reject(err_1);
                return [3, 4];
              case 4:
                return [3, 6];
              case 5:
                items = Promise.all(batch.map(fromEntry));
                entries.push(items);
                readEntries();
                _a2.label = 6;
              case 6:
                return [2];
            }
          });
        });
      }, function(err) {
        reject(err);
      });
    }
    readEntries();
  });
}
function fromFileEntry(entry) {
  return __awaiter(this, void 0, void 0, function() {
    return __generator(this, function(_a2) {
      return [2, new Promise(function(resolve, reject) {
        entry.file(function(file) {
          var fwp = toFileWithPath(file, entry.fullPath);
          resolve(fwp);
        }, function(err) {
          reject(err);
        });
      })];
    });
  });
}
var _default = function(file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
    var fileName = file.name || "";
    var mimeType = (file.type || "").toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, "");
    return acceptedFilesArray.some(function(type) {
      var validType = type.trim().toLowerCase();
      if (validType.charAt(0) === ".") {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith("/*")) {
        return baseMimeType === validType.replace(/\/.*$/, "");
      }
      return mimeType === validType;
    });
  }
  return true;
};
function _slicedToArray$1(arr, i2) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i2) || _unsupportedIterableToArray$1(arr, i2) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$1(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray$1(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor)
    n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray$1(o2, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function _iterableToArrayLimit$1(arr, i2) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e2;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d = true;
    _e2 = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e2;
    }
  }
  return _arr;
}
function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr))
    return arr;
}
var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";
var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr2(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr2(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr2(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
};
function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || _default(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize)
        return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize)
        return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize)
      return [false, getTooSmallRejectionErr(minSize)];
    else if (isDefined(maxSize) && file.size > maxSize)
      return [false, getTooLargeRejectionErr(maxSize)];
  }
  return [true, null];
}
function isDefined(value) {
  return value !== void 0 && value !== null;
}
function allFilesAccepted(_ref3) {
  var files = _ref3.files, accept = _ref3.accept, minSize = _ref3.minSize, maxSize = _ref3.maxSize, multiple = _ref3.multiple, maxFiles = _ref3.maxFiles;
  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }
  return files.every(function(file) {
    var _fileAccepted = fileAccepted(file, accept), _fileAccepted2 = _slicedToArray$1(_fileAccepted, 1), accepted = _fileAccepted2[0];
    var _fileMatchSize = fileMatchSize(file, minSize, maxSize), _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
    return accepted && sizeMatch;
  });
}
function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }
  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  }
  return Array.prototype.some.call(event.dataTransfer.types, function(type) {
    return type === "Files" || type === "application/x-moz-file";
  });
}
function onDocumentDragOver(event) {
  event.preventDefault();
}
function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}
function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function(event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    return fns.some(function(fn2) {
      if (!isPropagationStopped(event) && fn2) {
        fn2.apply(void 0, [event].concat(args));
      }
      return isPropagationStopped(event);
    });
  };
}
var _excluded$1 = ["children"], _excluded2 = ["open"], _excluded3 = ["refKey", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], _excluded4 = ["refKey", "onChange", "onClick"];
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray(arr);
}
function _slicedToArray(arr, i2) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i2) || _unsupportedIterableToArray(arr, i2) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor)
    n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray(o2, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i2) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e2;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d = true;
    _e2 = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e2;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function ownKeys(object2, enumerableOnly) {
  var keys2 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
    }
    keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source2 = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys(Object(source2), true).forEach(function(key) {
        _defineProperty(target, key, source2[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2));
    } else {
      ownKeys(Object(source2)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties(source2, excluded) {
  if (source2 == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source2, excluded);
  var key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source2);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key = sourceSymbolKeys[i2];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source2, key))
        continue;
      target[key] = source2[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source2, excluded) {
  if (source2 == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source2);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source2[key];
  }
  return target;
}
var Dropzone$1 = /* @__PURE__ */ forwardRef(function(_ref3, ref) {
  var children2 = _ref3.children, params = _objectWithoutProperties(_ref3, _excluded$1);
  var _useDropzone = useDropzone(params), open = _useDropzone.open, props = _objectWithoutProperties(_useDropzone, _excluded2);
  useImperativeHandle(ref, function() {
    return {
      open
    };
  }, [open]);
  return /* @__PURE__ */ jsx$1(Fragment, {
    children: children2(_objectSpread(_objectSpread({}, props), {}, {
      open
    }))
  });
});
Dropzone$1.displayName = "Dropzone";
var defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null
};
Dropzone$1.defaultProps = defaultProps;
Dropzone$1.propTypes = {
  children: PropTypes.func,
  accept: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  multiple: PropTypes.bool,
  preventDropOnDocument: PropTypes.bool,
  noClick: PropTypes.bool,
  noKeyboard: PropTypes.bool,
  noDrag: PropTypes.bool,
  noDragEventsBubbling: PropTypes.bool,
  minSize: PropTypes.number,
  maxSize: PropTypes.number,
  maxFiles: PropTypes.number,
  disabled: PropTypes.bool,
  getFilesFromEvent: PropTypes.func,
  onFileDialogCancel: PropTypes.func,
  onFileDialogOpen: PropTypes.func,
  onDragEnter: PropTypes.func,
  onDragLeave: PropTypes.func,
  onDragOver: PropTypes.func,
  onDrop: PropTypes.func,
  onDropAccepted: PropTypes.func,
  onDropRejected: PropTypes.func,
  validator: PropTypes.func
};
var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  draggedFiles: [],
  acceptedFiles: [],
  fileRejections: []
};
function useDropzone() {
  var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var _defaultProps$options = _objectSpread(_objectSpread({}, defaultProps), options2), accept = _defaultProps$options.accept, disabled = _defaultProps$options.disabled, getFilesFromEvent = _defaultProps$options.getFilesFromEvent, maxSize = _defaultProps$options.maxSize, minSize = _defaultProps$options.minSize, multiple = _defaultProps$options.multiple, maxFiles = _defaultProps$options.maxFiles, onDragEnter = _defaultProps$options.onDragEnter, onDragLeave = _defaultProps$options.onDragLeave, onDragOver = _defaultProps$options.onDragOver, onDrop = _defaultProps$options.onDrop, onDropAccepted = _defaultProps$options.onDropAccepted, onDropRejected = _defaultProps$options.onDropRejected, onFileDialogCancel = _defaultProps$options.onFileDialogCancel, onFileDialogOpen = _defaultProps$options.onFileDialogOpen, preventDropOnDocument = _defaultProps$options.preventDropOnDocument, noClick = _defaultProps$options.noClick, noKeyboard = _defaultProps$options.noKeyboard, noDrag = _defaultProps$options.noDrag, noDragEventsBubbling = _defaultProps$options.noDragEventsBubbling, validator2 = _defaultProps$options.validator;
  var rootRef = useRef(null);
  var inputRef = useRef(null);
  var _useReducer = useReducer(reducer, initialState), _useReducer2 = _slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
  var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive, draggedFiles = state.draggedFiles;
  var openFileDialog = useCallback(function() {
    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      if (typeof onFileDialogOpen === "function") {
        onFileDialogOpen();
      }
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpen]);
  var onWindowFocus = function onWindowFocus2() {
    if (isFileDialogActive) {
      setTimeout(function() {
        if (inputRef.current) {
          var files = inputRef.current.files;
          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            if (typeof onFileDialogCancel === "function") {
              onFileDialogCancel();
            }
          }
        }
      }, 300);
    }
  };
  useEffect(function() {
    window.addEventListener("focus", onWindowFocus, false);
    return function() {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancel]);
  var onKeyDownCb = useCallback(function(event) {
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }
    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, inputRef, openFileDialog]);
  var onFocusCb = useCallback(function() {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = useCallback(function() {
    dispatch({
      type: "blur"
    });
  }, []);
  var onClickCb = useCallback(function() {
    if (noClick) {
      return;
    }
    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [inputRef, noClick, openFileDialog]);
  var dragTargetsRef = useRef([]);
  var onDocumentDrop = function onDocumentDrop2(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      return;
    }
    event.preventDefault();
    dragTargetsRef.current = [];
  };
  useEffect(function() {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }
    return function() {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  var onDragEnterCb = useCallback(function(event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);
    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function(draggedFiles2) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }
        dispatch({
          draggedFiles: draggedFiles2,
          isDragActive: true,
          type: "setDraggedFiles"
        });
        if (onDragEnter) {
          onDragEnter(event);
        }
      });
    }
  }, [getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
  var onDragOverCb = useCallback(function(event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);
    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {
      }
    }
    if (hasFiles && onDragOver) {
      onDragOver(event);
    }
    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = useCallback(function(event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var targets = dragTargetsRef.current.filter(function(target) {
      return rootRef.current && rootRef.current.contains(target);
    });
    var targetIdx = targets.indexOf(event.target);
    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }
    dragTargetsRef.current = targets;
    if (targets.length > 0) {
      return;
    }
    dispatch({
      isDragActive: false,
      type: "setDraggedFiles",
      draggedFiles: []
    });
    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var onDropCb = useCallback(function(event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];
    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function(files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
          var _fileAccepted = fileAccepted(file, accept), _fileAccepted2 = _slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
          var _fileMatchSize = fileMatchSize(file, minSize, maxSize), _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
          var customErrors = validator2 ? validator2(file) : null;
          if (accepted && sizeMatch && !customErrors) {
            acceptedFiles.push(file);
          } else {
            var errors = [acceptError, sizeError];
            if (customErrors) {
              errors = errors.concat(customErrors);
            }
            fileRejections.push({
              file,
              errors: errors.filter(function(e2) {
                return e2;
              })
            });
          }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
          acceptedFiles.forEach(function(file) {
            fileRejections.push({
              file,
              errors: [TOO_MANY_FILES_REJECTION]
            });
          });
          acceptedFiles.splice(0);
        }
        dispatch({
          acceptedFiles,
          fileRejections,
          type: "setFiles"
        });
        if (onDrop) {
          onDrop(acceptedFiles, fileRejections, event);
        }
        if (fileRejections.length > 0 && onDropRejected) {
          onDropRejected(fileRejections, event);
        }
        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted(acceptedFiles, event);
        }
      });
    }
    dispatch({
      type: "reset"
    });
  }, [multiple, accept, minSize, maxSize, maxFiles, getFilesFromEvent, onDrop, onDropAccepted, onDropRejected, noDragEventsBubbling, validator2]);
  var composeHandler = function composeHandler2(fn2) {
    return disabled ? null : fn2;
  };
  var composeKeyboardHandler = function composeKeyboardHandler2(fn2) {
    return noKeyboard ? null : composeHandler(fn2);
  };
  var composeDragHandler = function composeDragHandler2(fn2) {
    return noDrag ? null : composeHandler(fn2);
  };
  var stopPropagation = function stopPropagation2(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };
  var getRootProps = useMemo(function() {
    return function() {
      var _ref22 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref2$refKey = _ref22.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, onKeyDown = _ref22.onKeyDown, onFocus2 = _ref22.onFocus, onBlur = _ref22.onBlur, onClick2 = _ref22.onClick, onDragEnter2 = _ref22.onDragEnter, onDragOver2 = _ref22.onDragOver, onDragLeave2 = _ref22.onDragLeave, onDrop2 = _ref22.onDrop, rest = _objectWithoutProperties(_ref22, _excluded3);
      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus2, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick2, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter2, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver2, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave2, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop2, onDropCb))
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = useCallback(function(event) {
    event.stopPropagation();
  }, []);
  var getInputProps = useMemo(function() {
    return function() {
      var _ref3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange2 = _ref3.onChange, onClick2 = _ref3.onClick, rest = _objectWithoutProperties(_ref3, _excluded4);
      var inputProps = _defineProperty({
        accept,
        multiple,
        type: "file",
        style: {
          display: "none"
        },
        onChange: composeHandler(composeEventHandlers(onChange2, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick2, onInputElementClick)),
        autoComplete: "off",
        tabIndex: -1
      }, refKey, inputRef);
      return _objectSpread(_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  var fileCount = draggedFiles.length;
  var isDragAccept = fileCount > 0 && allFilesAccepted({
    files: draggedFiles,
    accept,
    minSize,
    maxSize,
    multiple,
    maxFiles
  });
  var isDragReject = fileCount > 0 && !isDragAccept;
  return _objectSpread(_objectSpread({}, state), {}, {
    isDragAccept,
    isDragReject,
    isFocused: isFocused && !disabled,
    getRootProps,
    getInputProps,
    rootRef,
    inputRef,
    open: composeHandler(openFileDialog)
  });
}
function reducer(state, action) {
  switch (action.type) {
    case "focus":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: true
      });
    case "blur":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: false
      });
    case "openDialog":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: true
      });
    case "closeDialog":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });
    case "setDraggedFiles":
      var isDragActive = action.isDragActive, draggedFiles = action.draggedFiles;
      return _objectSpread(_objectSpread({}, state), {}, {
        draggedFiles,
        isDragActive
      });
    case "setFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });
    case "reset":
      return _objectSpread({}, initialState);
    default:
      return state;
  }
}
const Dropzone = ({
  acceptFileTypes,
  className = "",
  children: children2,
  maxFiles,
  maxSize,
  isMultiple,
  isDisabled,
  onDrop
}) => {
  const dropzoneOption = {
    accept: acceptFileTypes,
    disabled: isDisabled,
    maxFiles,
    maxSize,
    multiple: isMultiple,
    onDrop
  };
  const {
    getRootProps,
    getInputProps
  } = useDropzone(dropzoneOption);
  return /* @__PURE__ */ jsxs("div", __spreadProps(__spreadValues({}, getRootProps()), {
    className,
    children: [/* @__PURE__ */ jsx$1("input", __spreadValues({}, getInputProps())), children2]
  }));
};
Dropzone.displayName = "Dropzone";
const UploadErrorModal = ({
  isOpen,
  handleClose
}) => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx$1(Modal, {
    size: "small",
    isOpen,
    onClose: handleClose,
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-h-fit tablet:tw-w-full",
      children: [/* @__PURE__ */ jsx$1("div", {
        className: "tw-flex tw-justify-center tw-w-full",
        children: /* @__PURE__ */ jsx$1(Icon, {
          name: IconName.REMOVE_GALLERY,
          size: IconSize.LARGE
        })
      }), /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-py-6 tw-text-center",
        variant: "title-2",
        color: COLORS.Gray[800],
        children: t2("common.modal.errorUpload.title")
      }), /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-pb-10 tw-text-center",
        variant: "body-3",
        color: COLORS.Gray[500],
        children: t2("common.modal.errorUpload.description")
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-w-full",
        children: /* @__PURE__ */ jsx$1(Button, {
          size: "large",
          variant: "primary",
          className: "tw-w-full",
          onClick: handleClose,
          children: t2("common.modal.errorUpload.ok")
        })
      })]
    })
  });
};
const ImagePanel = ({
  src: src2,
  onChange: onChange2 = () => {
  },
  onRemove = () => {
  },
  isSelected = false,
  isDisabled = false
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "tw-inline-block tw-relative tw-w-32 tw-h-32 tw-rounded-lg tw-border tw-border-Gray-300",
    children: [/* @__PURE__ */ jsx$1("img", {
      className: "tw-object-cover tw-absolute tw-z-10 tw-w-full tw-h-full tw-rounded-lg",
      src: src2,
      alt: "panel"
    }), !isDisabled && /* @__PURE__ */ jsx$1("div", {
      className: "tw-flex tw-absolute tw--top-3 tw--right-3 tw-z-20 tw-justify-center tw-items-center tw-w-6 tw-h-6 tw-bg-White tw-rounded-full tw-border-0 tw-cursor-pointer",
      onClick: onRemove,
      children: /* @__PURE__ */ jsx$1(Icon, {
        name: IconName.CLOSE,
        size: IconSize.EXTRA_SMALL
      })
    }), /* @__PURE__ */ jsx$1("div", {
      className: classNames$1("tw-flex tw-absolute tw-z-30 tw-items-end tw-w-full tw-h-full", {
        "tw-opacity-0": !isSelected,
        "hover:tw-opacity-100": !isSelected
      }),
      children: /* @__PURE__ */ jsx$1("div", {
        className: classNames$1("tw-flex tw-relative tw-justify-center tw-items-center tw-w-full tw-h-8 tw-bg-Primary-600 tw-rounded-b-md tw-cursor-pointer", {
          "tw-bg-Primary-600": isSelected,
          "tw-bg-opacity-70": !isSelected
        }),
        onClick: onChange2,
        children: /* @__PURE__ */ jsx$1(Typography, {
          color: "White",
          variant: "body-3",
          children: "Cover"
        })
      })
    })]
  });
};
ImagePanel.displayName = "ImagePanel";
const ImageUpload = ({
  iconName,
  label,
  iconSize
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "tw-flex tw-flex-col tw-flex-1 tw-justify-center tw-items-center tw-py-7 tw-bg-Gray-100 tw-rounded tw-border tw-border-Gray-400 tw-border-dashed tw-cursor-pointer",
    children: [/* @__PURE__ */ jsx$1("div", {
      className: "tw-pb-3 tw-w-10",
      children: /* @__PURE__ */ jsx$1("div", {
        className: "tw-flex tw-relative tw-justify-center tw-items-center tw-w-10 tw-h-10 tw-bg-Tertiary tw-rounded-full",
        children: /* @__PURE__ */ jsx$1(Icon, {
          name: iconName,
          className: "tw-fill-Primary-500",
          size: iconSize
        })
      })
    }), /* @__PURE__ */ jsx$1(Typography, {
      className: "tw-text-center tw-text-Gray-500",
      variant: "body-4",
      children: label
    })]
  });
};
const MultipleImageUploader = ({
  acceptFileTypes,
  onDrop = () => {
  },
  onChange: onChange2 = () => {
  },
  onRemove = () => {
  },
  images: images2,
  maxSize,
  limit,
  isDisabled
}) => {
  const {
    t: t2
  } = useTranslation();
  const [isOpenErrorModal, setIsOpenErrorModal] = useState(false);
  const handleDrop = (acceptFiles, fileRejections, event) => {
    if (!isEmpty_1(fileRejections)) {
      setIsOpenErrorModal(true);
    }
    onDrop(acceptFiles, fileRejections, event);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "tw-flex tw-overflow-x-auto tw-flex-col tw-flex-wrap tw-gap-x-4 tw-content-start tw-pt-4 tw-h-44",
    children: [images2.map((image, index2) => /* @__PURE__ */ jsx$1(ImagePanel, {
      src: image,
      isSelected: !index2,
      onChange: () => {
        if (isDisabled) {
          return;
        }
        onChange2(index2);
      },
      onRemove: () => onRemove(index2),
      isDisabled
    }, image)), (!limit || images2.length < limit) && !isDisabled && /* @__PURE__ */ jsx$1(Dropzone, {
      maxSize,
      acceptFileTypes,
      isMultiple: true,
      onDrop: handleDrop,
      children: /* @__PURE__ */ jsx$1("div", {
        className: "tw-flex tw-w-32 tw-h-32",
        children: /* @__PURE__ */ jsx$1(ImageUpload, {
          iconName: IconName.UPLOADER,
          label: t2("Upload images")
        })
      })
    }), /* @__PURE__ */ jsx$1(UploadErrorModal, {
      isOpen: isOpenErrorModal,
      handleClose: () => setIsOpenErrorModal(false)
    })]
  });
};
MultipleImageUploader.displayName = "MultipleImageUploader";
MultipleImageUploader.defaultProps = {
  isDisabled: false,
  maxSize: 2097152,
  acceptFileTypes: ["image/png", "image/jpeg", "image/jpg"]
};
const UploadPanel = ({
  acceptFileTypes,
  maxFiles,
  maxSize,
  isMultiple,
  isDisabled,
  onDrop = () => {
  },
  className = "",
  labelButton,
  title
}) => {
  const [isOpenErrorModal, setIsOpenErrorModal] = useState(false);
  const handleDrop = (acceptFiles, fileRejections, event) => {
    if (!isEmpty_1(fileRejections)) {
      setIsOpenErrorModal(true);
    }
    onDrop(acceptFiles, fileRejections, event);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs(Dropzone, {
      className: classNames$1("tw-border tw-border-dashed tw-border-Gray-400 tw-bg-Gray-100 tw-p-4 tw-flex tw-flex-col tw-justify-center tw-items-center tw-rounded tw-h-[200px] tablet:tw-h-full", {
        "tw-cursor-pointer": !isDisabled,
        "tw-cursor-not-allowed": isDisabled
      }, className),
      isMultiple,
      isDisabled,
      maxSize,
      maxFiles,
      acceptFileTypes,
      onDrop: handleDrop,
      children: [/* @__PURE__ */ jsx$1("img", {
        className: "tw-pb-4 tw-w-24 tablet:tw-w-44",
        src: UPLOAD_FILE,
        alt: "upload-file"
      }), title && /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-hidden tw-pt-2 tw-pb-6 tw-text-center tablet:tw-block",
        variant: "title-7",
        children: title
      }), /* @__PURE__ */ jsx$1(Button, {
        disabled: isDisabled,
        className: "tw-border tw-border-DarkPrimary tw-border-solid",
        size: "medium",
        variant: "tertiary",
        children: /* @__PURE__ */ jsx$1(Typography, {
          variant: "title-8",
          color: "DarkPrimary",
          children: labelButton
        })
      })]
    }), /* @__PURE__ */ jsx$1(UploadErrorModal, {
      isOpen: isOpenErrorModal,
      handleClose: () => setIsOpenErrorModal(false)
    })]
  });
};
UploadPanel.displayName = "UploadPanel";
UploadPanel.defaultProps = {
  isDisabled: false,
  maxSize: 2097152,
  isMultiple: false,
  acceptFileTypes: ["image/png", "image/jpeg", "image/jpg"]
};
const ProductDetailSection = ({
  images: images2,
  handleChangeImage,
  handleSetCoverImage,
  handleRemoveImage,
  setValue,
  setCfCode,
  setProductName,
  productName,
  errors,
  categoryOption,
  description,
  brand,
  setProductCode,
  setVariantAndCategory,
  setIsOpenCategoryModal,
  setBrand,
  cfCode,
  productCode,
  setDescription,
  category,
  isEditMode = false,
  isClientStore = false,
  isMasterStore = false
}) => {
  var _a2, _b, _c, _d;
  const {
    t: t2
  } = useTranslation();
  const IMAGE_UPLOAD_MAX_LENGTH = 10;
  const isDisabledProductCode = isEditMode && isMasterStore || isClientStore;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs(Card, {
      className: "tw-px-6 tw-pt-6 tw-pb-11 tw-bg-White",
      contentSize: ContentSize.FULL,
      shadowSize: ElevationShadowType.NONE,
      children: [/* @__PURE__ */ jsxs("div", {
        className: "tw-inline-flex tw-justify-between tw-items-center tw-w-full",
        children: [/* @__PURE__ */ jsx$1(Typography, {
          variant: "title-5",
          children: t2("product.productImage.title")
        }), /* @__PURE__ */ jsx$1(Typography, {
          variant: "body-3",
          color: COLORS.Gray[500],
          children: `${(images2 == null ? void 0 : images2.length) || 0}/${IMAGE_UPLOAD_MAX_LENGTH}`
        })]
      }), images2 && (images2 == null ? void 0 : images2.length) > 0 ? /* @__PURE__ */ jsx$1(MultipleImageUploader, {
        images: images2.map(({
          src: src2
        }) => src2 || ""),
        onDrop: (file) => handleChangeImage(file),
        onChange: handleSetCoverImage,
        onRemove: handleRemoveImage,
        limit: IMAGE_UPLOAD_MAX_LENGTH,
        isDisabled: isClientStore
      }) : /* @__PURE__ */ jsx$1(UploadPanel, {
        className: "tw-mt-4",
        isMultiple: true,
        labelButton: t2("product.productImage.upload.button"),
        onDrop: (image) => handleChangeImage(image),
        title: t2("product.productImage.upload.label"),
        isDisabled: isClientStore
      })]
    }), /* @__PURE__ */ jsxs(Card, {
      className: "tw-px-6 tw-pt-6 tw-pb-11 tw-mt-6 tw-bg-White",
      contentSize: ContentSize.FULL,
      shadowSize: ElevationShadowType.NONE,
      children: [/* @__PURE__ */ jsx$1("div", {
        className: "tw-w-full",
        children: /* @__PURE__ */ jsx$1(Typography, {
          variant: "title-5",
          children: t2("product.productDetail.title")
        })
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-pt-4",
        children: /* @__PURE__ */ jsx$1(FormInput, {
          value: productName,
          label: t2("product.productDetail.name"),
          name: "productName",
          error: t2((_a2 = errors == null ? void 0 : errors.productName) == null ? void 0 : _a2.message),
          maxLength: 100,
          disabled: isClientStore,
          handleChange: (value) => {
            setValue("productName", value);
            setProductName(value);
          }
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-grid tw-pt-9 mobile:tw-grid-cols-1 tablet:tw-grid-cols-2 tablet:tw-gap-x-4",
        children: [/* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx$1(FormDropdown, {
            value: categoryOption.find(({
              key
            }) => key === category),
            options: categoryOption,
            label: t2("product.productDetail.category.label"),
            placeholder: t2("product.productDetail.category.placeholder"),
            name: "category",
            error: t2((_b = errors == null ? void 0 : errors.category) == null ? void 0 : _b.message),
            disabled: isClientStore,
            handleChange: (value) => setVariantAndCategory(value)
          }), !isClientStore && /* @__PURE__ */ jsx$1(Typography, {
            onClick: () => setIsOpenCategoryModal(true),
            className: "tw-pt-1 tw-cursor-pointer",
            variant: "body-3",
            color: COLORS.Primary[600],
            children: t2("product.category.title")
          })]
        }), /* @__PURE__ */ jsx$1("div", {
          className: "mobile:tw-pt-9 tablet:tw-pt-0",
          children: /* @__PURE__ */ jsx$1(FormInput, {
            value: brand,
            label: t2("product.productDetail.brand"),
            isOptional: true,
            maxLength: 50,
            disabled: isClientStore,
            handleChange: setBrand
          })
        })]
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-pt-9",
        children: /* @__PURE__ */ jsx$1(FormTextArea, {
          value: description,
          label: t2("product.productDetail.description"),
          isOptional: true,
          maxLength: 2500,
          disabled: isClientStore,
          handleChange: setDescription
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-grid tw-pt-9 mobile:tw-grid-cols-1 tablet:tw-grid-cols-2 tablet:tw-gap-x-4",
        children: [/* @__PURE__ */ jsx$1(FormInput, {
          value: productCode,
          label: t2("product.productDetail.productCode.label"),
          placeholder: t2("product.productDetail.productCode.placeholder"),
          name: "productCode",
          maxLength: 50,
          disabled: isDisabledProductCode,
          error: t2((_c = errors == null ? void 0 : errors.productCode) == null ? void 0 : _c.message),
          handleChange: (value) => {
            setValue("productCode", value);
            setProductCode(value);
          }
        }), /* @__PURE__ */ jsx$1("div", {
          className: "mobile:tw-pt-9 tablet:tw-pt-0",
          children: /* @__PURE__ */ jsx$1(FormInput, {
            value: cfCode,
            maxLength: 50,
            label: t2("product.productDetail.cfCode.label"),
            placeholder: t2("product.productDetail.cfCode.placeholder"),
            info: t2("product.productDetail.cfCode.tooltip"),
            error: t2((_d = errors == null ? void 0 : errors.cfCode) == null ? void 0 : _d.message),
            isOptional: true,
            disabled: isClientStore,
            handleChange: (value) => {
              setCfCode(value);
              setValue("cfCode", value);
            }
          })
        })]
      })]
    })]
  });
};
const ProductFooter = (props) => {
  const {
    handleBackToProductList,
    handleSubmit,
    submitForm,
    isEditMode,
    handleDeleteProduct,
    isOpenDeleteProductModal,
    setIsOpenDeleteProductModal
  } = props;
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "tw-py-6 tw-w-full mobile:tw-px-4 tablet:tw-px-0 ",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "tw-grid tw-justify-between tw-w-full mobile:tw-grid-cols-2 mobile:tw-gap-x-2 tablet:tw-grid-cols-12",
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "mobile:tw-mt-4 mobile:tw-w-full tablet:tw-col-span-6 tablet:tw-mt-0 tablet:tw-w-fit",
          children: isEditMode && /* @__PURE__ */ jsx$1(Button, {
            variant: "custom",
            size: "large",
            onClick: () => {
              setIsOpenDeleteProductModal(!isOpenDeleteProductModal);
            },
            className: "tw-w-full tw-text-Red tw-bg-Transparent hover:tw-bg-Transparent tw-rounded",
            children: t2("product.deleteProduct")
          })
        }), /* @__PURE__ */ jsxs("div", {
          className: "tw-justify-self-end mobile:tw-col-span-6 mobile:tw-w-full tablet:tw-inline-flex tablet:tw-w-fit",
          children: [/* @__PURE__ */ jsx$1(Button, {
            className: "tw-mr-2 mobile:tw-hidden tablet:tw-block",
            size: "large",
            onClick: handleBackToProductList,
            variant: "text",
            children: t2("product.category.cancel")
          }), /* @__PURE__ */ jsx$1(Button, {
            size: "large",
            onClick: handleSubmit(submitForm),
            className: "mobile:tw-mt-4 mobile:tw-w-full tablet:tw-mt-0 tablet:tw-w-fit",
            variant: "primary",
            children: t2("product.save")
          })]
        })]
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-justify-self-end tw-mt-4 tw-w-full mobile:tw-block tablet:tw-hidden",
        children: /* @__PURE__ */ jsx$1(Button, {
          size: "large",
          onClick: handleBackToProductList,
          className: "tw-w-full",
          variant: "text",
          children: t2("product.category.cancel")
        })
      })]
    }), /* @__PURE__ */ jsx$1(Modal, {
      size: "small",
      onClose: () => setIsOpenDeleteProductModal(false),
      isOpen: isOpenDeleteProductModal,
      children: /* @__PURE__ */ jsxs("div", {
        className: "tw-w-full tw-h-fit",
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "tw-flex tw-justify-center tw-w-full",
          children: /* @__PURE__ */ jsx$1(Icon, {
            name: IconName.TRASH,
            size: IconSize.LARGE
          })
        }), /* @__PURE__ */ jsx$1(Typography, {
          className: "tw-py-6 tw-text-center",
          variant: "title-2",
          color: COLORS.Gray[800],
          children: t2("product.modal.confirmDeleteProduct.title")
        }), /* @__PURE__ */ jsx$1(Typography, {
          className: "tw-pb-10 tw-text-center",
          variant: "body-3",
          color: COLORS.Gray[500],
          children: t2("product.modal.confirmDeleteProduct.description")
        }), /* @__PURE__ */ jsxs("div", {
          className: "tw-flex tw-justify-between",
          children: [/* @__PURE__ */ jsx$1(Button, {
            size: "large",
            variant: "text",
            className: "tw-text-Primary-600 mobile:tw-w-full tablet:tw-w-fit",
            onClick: () => setIsOpenDeleteProductModal(false),
            children: t2("product.productSKU.modal.deleteSKU.cancel")
          }), /* @__PURE__ */ jsx$1(Button, {
            size: "large",
            variant: "primary",
            className: "tw-bg-Primary-600 mobile:tw-w-full tablet:tw-w-fit",
            onClick: () => handleDeleteProduct(),
            children: t2("product.modal.confirmDeleteProduct.confirm")
          })]
        })]
      })
    })]
  });
};
var Checkbox$1 = "";
const Checkbox = (props) => {
  const {
    checked = false,
    handleChange,
    disabled = false
  } = props;
  const [isChecked, setIsChecked] = useState(checked);
  return /* @__PURE__ */ jsx$1("div", {
    className: "tw-inline-block tw-relative tw-cursor-pointer",
    children: /* @__PURE__ */ jsx$1("input", __spreadValues({
      type: "checkbox",
      checked: isChecked,
      disabled,
      onClick: () => {
        setIsChecked(!isChecked);
        if (handleChange)
          handleChange();
      },
      className: "tw-w-6 tw-h-6 tw-rounded tw-border tw-border-Gray-400 checked:disabled:tw-accent-Gray-400 checked:tw-accent-Primary-600 disabled:tw-accent-Gray-200 tw-cursor-pointer checkbox"
    }, props))
  });
};
Checkbox.displayName = "Checkbox";
const ProductPricingSection = ({
  isFreeProduct,
  setFreeProduct,
  price,
  errors,
  setValue,
  setPrice,
  costPrice,
  setCostPrice,
  isClientStore
}) => {
  var _a2;
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(Card, {
    className: "tw-px-6 tw-pt-6 tw-pb-11 tw-mt-6 tw-bg-White",
    contentSize: ContentSize.FULL,
    shadowSize: ElevationShadowType.NONE,
    children: [/* @__PURE__ */ jsx$1("div", {
      className: "tw-w-full",
      children: /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-5",
        children: t2("product.pricing.title")
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-items-center tw-py-4",
      children: [/* @__PURE__ */ jsx$1(Checkbox, {
        checked: isFreeProduct,
        handleChange: setFreeProduct,
        disabled: isClientStore
      }), /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-pl-1",
        variant: "body-3",
        children: t2("product.pricing.freeProduct")
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-grid mobile:tw-grid-cols-1 tablet:tw-grid-cols-2 tablet:tw-gap-x-4",
      children: [/* @__PURE__ */ jsx$1(FormInput, {
        disabled: isFreeProduct || isClientStore,
        type: "number",
        value: price,
        decimal: 2,
        min: 0,
        thousandSeparator: true,
        label: t2("product.pricing.price"),
        name: "price",
        error: t2((_a2 = errors == null ? void 0 : errors.price) == null ? void 0 : _a2.message),
        handleChange: (value) => {
          setValue("price", value);
          setPrice(value);
        }
      }), /* @__PURE__ */ jsx$1("div", {
        className: "mobile:tw-pt-9 tablet:tw-pt-0",
        children: /* @__PURE__ */ jsx$1(FormInput, {
          value: costPrice,
          type: "number",
          decimal: 2,
          min: 0,
          thousandSeparator: true,
          label: t2("product.pricing.costPrice"),
          isOptional: true,
          handleChange: (value) => setCostPrice(value),
          disabled: isClientStore
        })
      })]
    })]
  });
};
const ProductPropertySection = (props) => {
  const {
    property: property2,
    removeProperty,
    isOpenExpandProperty,
    setPropertyValue,
    addNewProperty,
    errors,
    isClientStore = false
  } = props;
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(Expand, {
    isOpen: isOpenExpandProperty,
    className: "tw-mt-6 tw-bg-White",
    title: t2("product.productProperty.title"),
    info: t2("product.productProperty.additional"),
    children: [property2.map((data2, index2) => {
      var _a2, _b, _c, _d, _e2, _f, _g, _h, _i;
      const {
        id: id2 = 0,
        name,
        value
      } = data2;
      return /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "tw-justify-end tw-w-full mobile:tw-flex tablet:tw-hidden",
          children: /* @__PURE__ */ jsx$1("div", {
            className: "tw-p-2 tw-w-fit tw-h-fit tw-bg-Gray-100 tw-rounded",
            onClick: () => removeProperty(index2),
            children: /* @__PURE__ */ jsx$1(Icon, {
              className: "tw-fill-Gray-500",
              name: IconName.DELETE,
              size: IconSize.SMALL
            })
          })
        }, id2), /* @__PURE__ */ jsxs("div", {
          className: "tw-grid tw-gap-4 tw-pb-9 tw-w-full tablet:tw-grid-cols-3",
          children: [/* @__PURE__ */ jsx$1("div", {
            className: "tablet:tw-col-span-1",
            children: /* @__PURE__ */ jsx$1(FormInput, {
              label: t2("product.productProperty.type.label"),
              placeholder: t2("product.productProperty.type.placeholder"),
              value: name,
              maxLength: 50,
              error: t2((_c = (_b = (_a2 = errors == null ? void 0 : errors.property) == null ? void 0 : _a2[index2]) == null ? void 0 : _b.name) == null ? void 0 : _c.message),
              handleChange: (value2) => setPropertyValue(index2, "name", value2),
              disabled: isClientStore
            })
          }), /* @__PURE__ */ jsxs("div", {
            className: "tw-grid tw-grid-cols-12 tw-items-center tw-w-full mobile:tw-pt-4 tablet:tw-col-span-2 tablet:tw-pt-0",
            children: [/* @__PURE__ */ jsx$1("div", {
              className: "mobile:tw-col-span-12 tablet:tw-col-span-11",
              children: /* @__PURE__ */ jsx$1(FormInput, {
                value,
                maxLength: 50,
                error: t2((_f = (_e2 = (_d = errors == null ? void 0 : errors.property) == null ? void 0 : _d[index2]) == null ? void 0 : _e2.value) == null ? void 0 : _f.message),
                label: t2("product.productProperty.value.label"),
                placeholder: t2("product.productProperty.value.placeholder"),
                handleChange: (value2) => setPropertyValue(index2, "value", value2),
                disabled: isClientStore
              })
            }), !isClientStore && /* @__PURE__ */ jsx$1("div", {
              className: `tw-box-border tw-cursor-pointer mobile:tw-hidden tablet:tw-block tw-p-2 ${((_i = (_h = (_g = errors == null ? void 0 : errors.property) == null ? void 0 : _g[index2]) == null ? void 0 : _h.value) == null ? void 0 : _i.message) ? "" : "tw-mt-5"} tw-bg-Gray-100 tw-w-fit tw-h-fit tw-rounded tablet:tw-col-span-1 tw-justify-self-end`,
              onClick: () => removeProperty(index2),
              children: /* @__PURE__ */ jsx$1(Icon, {
                className: "tw-fill-Gray-500",
                name: IconName.DELETE,
                size: IconSize.SMALL
              })
            })]
          }), /* @__PURE__ */ jsx$1("div", {
            className: index2 === property2.length - 1 ? "tw-hidden" : "tw-mt-6 mobile:tw-border mobile:tw-block tablet:tw-hidden tw-border-Gray-200"
          })]
        })]
      });
    }), /* @__PURE__ */ jsx$1("div", {
      className: "tw-flex tw-justify-center tw-items-center tw-w-full",
      children: !isClientStore && /* @__PURE__ */ jsxs(Button, {
        variant: "tertiary",
        className: "tw-inline-flex",
        onClick: addNewProperty,
        children: [/* @__PURE__ */ jsx$1(Icon, {
          className: "tw-mr-1 tw-fill-Primary-600",
          name: IconName.PLUS,
          size: IconSize.MEDIUM
        }), t2("product.productProperty.addProperty")]
      })
    })]
  });
};
var reactTable = { exports: {} };
var reactTable_production_min = { exports: {} };
(function(module, exports) {
  !function(e2, t2) {
    t2(exports, React__default);
  }(commonjsGlobal, function(e2, t2) {
    function n2(e3, t3, n3, o3, r3, i3, u2) {
      try {
        var l3 = e3[i3](u2), s2 = l3.value;
      } catch (e4) {
        return void n3(e4);
      }
      l3.done ? t3(s2) : Promise.resolve(s2).then(o3, r3);
    }
    function o2(e3) {
      return function() {
        var t3 = this, o3 = arguments;
        return new Promise(function(r3, i3) {
          var u2 = e3.apply(t3, o3);
          function l3(e4) {
            n2(u2, r3, i3, l3, s2, "next", e4);
          }
          function s2(e4) {
            n2(u2, r3, i3, l3, s2, "throw", e4);
          }
          l3(void 0);
        });
      };
    }
    function r2() {
      return (r2 = Object.assign || function(e3) {
        for (var t3 = 1; t3 < arguments.length; t3++) {
          var n3 = arguments[t3];
          for (var o3 in n3)
            Object.prototype.hasOwnProperty.call(n3, o3) && (e3[o3] = n3[o3]);
        }
        return e3;
      }).apply(this, arguments);
    }
    function i2(e3, t3) {
      if (e3 == null)
        return {};
      var n3, o3, r3 = {}, i3 = Object.keys(e3);
      for (o3 = 0; o3 < i3.length; o3++)
        n3 = i3[o3], t3.indexOf(n3) >= 0 || (r3[n3] = e3[n3]);
      return r3;
    }
    function u(e3) {
      var t3 = function(e4, t4) {
        if (typeof e4 != "object" || e4 === null)
          return e4;
        var n3 = e4[Symbol.toPrimitive];
        if (n3 !== void 0) {
          var o3 = n3.call(e4, t4 || "default");
          if (typeof o3 != "object")
            return o3;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (t4 === "string" ? String : Number)(e4);
      }(e3, "string");
      return typeof t3 == "symbol" ? t3 : String(t3);
    }
    t2 = t2 && Object.prototype.hasOwnProperty.call(t2, "default") ? t2.default : t2;
    var l2 = { init: "init" }, s = function(e3) {
      var t3 = e3.value;
      return t3 === void 0 ? "" : t3;
    }, a2 = function() {
      return t2.createElement(t2.Fragment, null, "\xA0");
    }, c2 = { Cell: s, width: 150, minWidth: 0, maxWidth: Number.MAX_SAFE_INTEGER };
    function d2() {
      for (var e3 = arguments.length, t3 = new Array(e3), n3 = 0; n3 < e3; n3++)
        t3[n3] = arguments[n3];
      return t3.reduce(function(e4, t4) {
        var n4 = t4.style, o3 = t4.className;
        return e4 = r2({}, e4, {}, i2(t4, ["style", "className"])), n4 && (e4.style = e4.style ? r2({}, e4.style || {}, {}, n4 || {}) : n4), o3 && (e4.className = e4.className ? e4.className + " " + o3 : o3), e4.className === "" && delete e4.className, e4;
      }, {});
    }
    var f2 = function(e3, t3) {
      return t3 === void 0 && (t3 = {}), function(n3) {
        return n3 === void 0 && (n3 = {}), [].concat(e3, [n3]).reduce(function(e4, o3) {
          return function e5(t4, n4, o4) {
            return typeof n4 == "function" ? e5({}, n4(t4, o4)) : Array.isArray(n4) ? d2.apply(void 0, [t4].concat(n4)) : d2(t4, n4);
          }(e4, o3, r2({}, t3, { userProps: n3 }));
        }, {});
      };
    }, p2 = function(e3, t3, n3, o3) {
      return n3 === void 0 && (n3 = {}), e3.reduce(function(e4, t4) {
        return t4(e4, n3);
      }, t3);
    }, g2 = function(e3, t3, n3) {
      return n3 === void 0 && (n3 = {}), e3.forEach(function(e4) {
        e4(t3, n3);
      });
    };
    function v2(e3, t3, n3, o3) {
      e3.findIndex(function(e4) {
        return e4.pluginName === n3;
      });
      t3.forEach(function(t4) {
        e3.findIndex(function(e4) {
          return e4.pluginName === t4;
        });
      });
    }
    function m2(e3, t3) {
      return typeof e3 == "function" ? e3(t3) : e3;
    }
    function h2(e3) {
      var n3 = t2.useRef();
      return n3.current = e3, t2.useCallback(function() {
        return n3.current;
      }, []);
    }
    var y2 = typeof document != "undefined" ? t2.useLayoutEffect : t2.useEffect;
    function w2(e3, n3) {
      var o3 = t2.useRef(false);
      y2(function() {
        o3.current && e3(), o3.current = true;
      }, n3);
    }
    function R2(e3, t3, n3) {
      return n3 === void 0 && (n3 = {}), function(o3, i3) {
        i3 === void 0 && (i3 = {});
        var u2 = typeof o3 == "string" ? t3[o3] : o3;
        if (u2 === void 0)
          throw console.info(t3), new Error("Renderer Error \u261D\uFE0F");
        return b2(u2, r2({}, e3, { column: t3 }, n3, {}, i3));
      };
    }
    function b2(e3, n3) {
      return function(e4) {
        return typeof e4 == "function" && ((t3 = Object.getPrototypeOf(e4)).prototype && t3.prototype.isReactComponent);
        var t3;
      }(o3 = e3) || typeof o3 == "function" || function(e4) {
        return typeof e4 == "object" && typeof e4.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e4.$$typeof.description);
      }(o3) ? t2.createElement(e3, n3) : e3;
      var o3;
    }
    function S2(e3, t3, n3) {
      return n3 === void 0 && (n3 = 0), e3.map(function(e4) {
        return x2(e4 = r2({}, e4, { parent: t3, depth: n3 })), e4.columns && (e4.columns = S2(e4.columns, e4, n3 + 1)), e4;
      });
    }
    function C(e3) {
      return G2(e3, "columns");
    }
    function x2(e3) {
      var t3 = e3.id, n3 = e3.accessor, o3 = e3.Header;
      if (typeof n3 == "string") {
        t3 = t3 || n3;
        var r3 = n3.split(".");
        n3 = function(e4) {
          return function(e5, t4, n4) {
            if (!t4)
              return e5;
            var o4, r4 = typeof t4 == "function" ? t4 : JSON.stringify(t4), i3 = E.get(r4) || function() {
              var e6 = function(e7) {
                return function e8(t5, n5) {
                  n5 === void 0 && (n5 = []);
                  if (Array.isArray(t5))
                    for (var o5 = 0; o5 < t5.length; o5 += 1)
                      e8(t5[o5], n5);
                  else
                    n5.push(t5);
                  return n5;
                }(e7).map(function(e8) {
                  return String(e8).replace(".", "_");
                }).join(".").replace(W2, ".").replace(O2, "").split(".");
              }(t4);
              return E.set(r4, e6), e6;
            }();
            try {
              o4 = i3.reduce(function(e6, t5) {
                return e6[t5];
              }, e5);
            } catch (e6) {
            }
            return o4 !== void 0 ? o4 : n4;
          }(e4, r3);
        };
      }
      if (!t3 && typeof o3 == "string" && o3 && (t3 = o3), !t3 && e3.columns)
        throw console.error(e3), new Error('A column ID (or unique "Header" value) is required!');
      if (!t3)
        throw console.error(e3), new Error("A column ID (or string accessor) is required!");
      return Object.assign(e3, { id: t3, accessor: n3 }), e3;
    }
    function P2(e3, t3) {
      if (!t3)
        throw new Error();
      return Object.assign(e3, r2({ Header: a2, Footer: a2 }, c2, {}, t3, {}, e3)), Object.assign(e3, { originalWidth: e3.width }), e3;
    }
    function B2(e3, t3, n3) {
      n3 === void 0 && (n3 = function() {
        return {};
      });
      for (var o3 = [], i3 = e3, u2 = 0, l3 = function() {
        return u2++;
      }, s2 = function() {
        var e4 = { headers: [] }, u3 = [], s3 = i3.some(function(e5) {
          return e5.parent;
        });
        i3.forEach(function(o4) {
          var i4, a3 = [].concat(u3).reverse()[0];
          if (s3) {
            if (o4.parent)
              i4 = r2({}, o4.parent, { originalId: o4.parent.id, id: o4.parent.id + "_" + l3(), headers: [o4] }, n3(o4));
            else
              i4 = P2(r2({ originalId: o4.id + "_placeholder", id: o4.id + "_placeholder_" + l3(), placeholderOf: o4, headers: [o4] }, n3(o4)), t3);
            a3 && a3.originalId === i4.originalId ? a3.headers.push(o4) : u3.push(i4);
          }
          e4.headers.push(o4);
        }), o3.push(e4), i3 = u3;
      }; i3.length; )
        s2();
      return o3.reverse();
    }
    var E = new Map();
    function I2() {
      for (var e3 = arguments.length, t3 = new Array(e3), n3 = 0; n3 < e3; n3++)
        t3[n3] = arguments[n3];
      for (var o3 = 0; o3 < t3.length; o3 += 1)
        if (t3[o3] !== void 0)
          return t3[o3];
    }
    function F2(e3) {
      if (typeof e3 == "function")
        return e3;
    }
    function G2(e3, t3) {
      var n3 = [];
      return function e4(o3) {
        o3.forEach(function(o4) {
          o4[t3] ? e4(o4[t3]) : n3.push(o4);
        });
      }(e3), n3;
    }
    function A2(e3, t3) {
      var n3 = t3.manualExpandedKey, o3 = t3.expanded, r3 = t3.expandSubRows, i3 = r3 === void 0 || r3, u2 = [];
      return e3.forEach(function(e4) {
        return function e5(t4, r4) {
          r4 === void 0 && (r4 = true), t4.isExpanded = t4.original && t4.original[n3] || o3[t4.id], t4.canExpand = t4.subRows && !!t4.subRows.length, r4 && u2.push(t4), t4.subRows && t4.subRows.length && t4.isExpanded && t4.subRows.forEach(function(t5) {
            return e5(t5, i3);
          });
        }(e4);
      }), u2;
    }
    function k2(e3, t3, n3) {
      return F2(e3) || t3[e3] || n3[e3] || n3.text;
    }
    function H2(e3, t3, n3) {
      return e3 ? e3(t3, n3) : t3 === void 0;
    }
    function T2() {
      throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");
    }
    var z2 = null;
    var W2 = /\[/g, O2 = /\]/g;
    var M2 = function(e3) {
      return r2({ role: "table" }, e3);
    }, j = function(e3) {
      return r2({ role: "rowgroup" }, e3);
    }, N2 = function(e3, t3) {
      var n3 = t3.column;
      return r2({ key: "header_" + n3.id, colSpan: n3.totalVisibleHeaderCount, role: "columnheader" }, e3);
    }, L = function(e3, t3) {
      var n3 = t3.column;
      return r2({ key: "footer_" + n3.id, colSpan: n3.totalVisibleHeaderCount }, e3);
    }, D2 = function(e3, t3) {
      return r2({ key: "headerGroup_" + t3.index, role: "row" }, e3);
    }, V2 = function(e3, t3) {
      return r2({ key: "footerGroup_" + t3.index }, e3);
    }, _23 = function(e3, t3) {
      return r2({ key: "row_" + t3.row.id, role: "row" }, e3);
    }, X2 = function(e3, t3) {
      var n3 = t3.cell;
      return r2({ key: "cell_" + n3.row.id + "_" + n3.column.id, role: "cell" }, e3);
    };
    function q2() {
      return { useOptions: [], stateReducers: [], useControlledState: [], columns: [], columnsDeps: [], allColumns: [], allColumnsDeps: [], accessValue: [], materializedColumns: [], materializedColumnsDeps: [], useInstanceAfterData: [], visibleColumns: [], visibleColumnsDeps: [], headerGroups: [], headerGroupsDeps: [], useInstanceBeforeDimensions: [], useInstance: [], prepareRow: [], getTableProps: [M2], getTableBodyProps: [j], getHeaderGroupProps: [D2], getFooterGroupProps: [V2], getHeaderProps: [N2], getFooterProps: [L], getRowProps: [_23], getCellProps: [X2], useFinalInstance: [] };
    }
    l2.resetHiddenColumns = "resetHiddenColumns", l2.toggleHideColumn = "toggleHideColumn", l2.setHiddenColumns = "setHiddenColumns", l2.toggleHideAllColumns = "toggleHideAllColumns";
    var K = function(e3) {
      e3.getToggleHiddenProps = [U2], e3.getToggleHideAllColumnsProps = [$2], e3.stateReducers.push(J), e3.useInstanceBeforeDimensions.push(Y2), e3.headerGroupsDeps.push(function(e4, t3) {
        var n3 = t3.instance;
        return [].concat(e4, [n3.state.hiddenColumns]);
      }), e3.useInstance.push(Q);
    };
    K.pluginName = "useColumnVisibility";
    var U2 = function(e3, t3) {
      var n3 = t3.column;
      return [e3, { onChange: function(e4) {
        n3.toggleHidden(!e4.target.checked);
      }, style: { cursor: "pointer" }, checked: n3.isVisible, title: "Toggle Column Visible" }];
    }, $2 = function(e3, t3) {
      var n3 = t3.instance;
      return [e3, { onChange: function(e4) {
        n3.toggleHideAllColumns(!e4.target.checked);
      }, style: { cursor: "pointer" }, checked: !n3.allColumnsHidden && !n3.state.hiddenColumns.length, title: "Toggle All Columns Hidden", indeterminate: !n3.allColumnsHidden && n3.state.hiddenColumns.length }];
    };
    function J(e3, t3, n3, o3) {
      if (t3.type === l2.init)
        return r2({ hiddenColumns: [] }, e3);
      if (t3.type === l2.resetHiddenColumns)
        return r2({}, e3, { hiddenColumns: o3.initialState.hiddenColumns || [] });
      if (t3.type === l2.toggleHideColumn) {
        var i3 = (t3.value !== void 0 ? t3.value : !e3.hiddenColumns.includes(t3.columnId)) ? [].concat(e3.hiddenColumns, [t3.columnId]) : e3.hiddenColumns.filter(function(e4) {
          return e4 !== t3.columnId;
        });
        return r2({}, e3, { hiddenColumns: i3 });
      }
      return t3.type === l2.setHiddenColumns ? r2({}, e3, { hiddenColumns: m2(t3.value, e3.hiddenColumns) }) : t3.type === l2.toggleHideAllColumns ? r2({}, e3, { hiddenColumns: (t3.value !== void 0 ? t3.value : !e3.hiddenColumns.length) ? o3.allColumns.map(function(e4) {
        return e4.id;
      }) : [] }) : void 0;
    }
    function Y2(e3) {
      var n3 = e3.headers, o3 = e3.state.hiddenColumns;
      t2.useRef(false).current;
      var r3 = 0;
      n3.forEach(function(e4) {
        return r3 += function e5(t3, n4) {
          t3.isVisible = n4 && !o3.includes(t3.id);
          var r4 = 0;
          return t3.headers && t3.headers.length ? t3.headers.forEach(function(n5) {
            return r4 += e5(n5, t3.isVisible);
          }) : r4 = t3.isVisible ? 1 : 0, t3.totalVisibleHeaderCount = r4, r4;
        }(e4, true);
      });
    }
    function Q(e3) {
      var n3 = e3.columns, o3 = e3.flatHeaders, r3 = e3.dispatch, i3 = e3.allColumns, u2 = e3.getHooks, s2 = e3.state.hiddenColumns, a3 = e3.autoResetHiddenColumns, c3 = a3 === void 0 || a3, d3 = h2(e3), p3 = i3.length === s2.length, g3 = t2.useCallback(function(e4, t3) {
        return r3({ type: l2.toggleHideColumn, columnId: e4, value: t3 });
      }, [r3]), v3 = t2.useCallback(function(e4) {
        return r3({ type: l2.setHiddenColumns, value: e4 });
      }, [r3]), m3 = t2.useCallback(function(e4) {
        return r3({ type: l2.toggleHideAllColumns, value: e4 });
      }, [r3]), y3 = f2(u2().getToggleHideAllColumnsProps, { instance: d3() });
      o3.forEach(function(e4) {
        e4.toggleHidden = function(t3) {
          r3({ type: l2.toggleHideColumn, columnId: e4.id, value: t3 });
        }, e4.getToggleHiddenProps = f2(u2().getToggleHiddenProps, { instance: d3(), column: e4 });
      });
      var R3 = h2(c3);
      w2(function() {
        R3() && r3({ type: l2.resetHiddenColumns });
      }, [r3, n3]), Object.assign(e3, { allColumnsHidden: p3, toggleHideColumn: g3, setHiddenColumns: v3, toggleHideAllColumns: m3, getToggleHideAllColumnsProps: y3 });
    }
    var Z2 = {}, ee2 = {}, te2 = function(e3, t3, n3) {
      return e3;
    }, ne2 = function(e3, t3) {
      return e3.subRows || [];
    }, oe2 = function(e3, t3, n3) {
      return "" + (n3 ? [n3.id, t3].join(".") : t3);
    }, re2 = function(e3) {
      return e3;
    };
    function ie2(e3) {
      var t3 = e3.initialState, n3 = t3 === void 0 ? Z2 : t3, o3 = e3.defaultColumn, u2 = o3 === void 0 ? ee2 : o3, l3 = e3.getSubRows, s2 = l3 === void 0 ? ne2 : l3, a3 = e3.getRowId, c3 = a3 === void 0 ? oe2 : a3, d3 = e3.stateReducer, f3 = d3 === void 0 ? te2 : d3, p3 = e3.useControlledState, g3 = p3 === void 0 ? re2 : p3;
      return r2({}, i2(e3, ["initialState", "defaultColumn", "getSubRows", "getRowId", "stateReducer", "useControlledState"]), { initialState: n3, defaultColumn: u2, getSubRows: s2, getRowId: c3, stateReducer: f3, useControlledState: g3 });
    }
    function ue2(e3, t3) {
      t3 === void 0 && (t3 = 0);
      var n3 = 0, o3 = 0, r3 = 0, i3 = 0;
      return e3.forEach(function(e4) {
        var u2 = e4.headers;
        if (e4.totalLeft = t3, u2 && u2.length) {
          var l3 = ue2(u2, t3), s2 = l3[0], a3 = l3[1], c3 = l3[2], d3 = l3[3];
          e4.totalMinWidth = s2, e4.totalWidth = a3, e4.totalMaxWidth = c3, e4.totalFlexWidth = d3;
        } else
          e4.totalMinWidth = e4.minWidth, e4.totalWidth = Math.min(Math.max(e4.minWidth, e4.width), e4.maxWidth), e4.totalMaxWidth = e4.maxWidth, e4.totalFlexWidth = e4.canResize ? e4.totalWidth : 0;
        e4.isVisible && (t3 += e4.totalWidth, n3 += e4.totalMinWidth, o3 += e4.totalWidth, r3 += e4.totalMaxWidth, i3 += e4.totalFlexWidth);
      }), [n3, o3, r3, i3];
    }
    function le2(e3) {
      var t3 = e3.data, n3 = e3.rows, o3 = e3.flatRows, r3 = e3.rowsById, i3 = e3.column, u2 = e3.getRowId, l3 = e3.getSubRows, s2 = e3.accessValueHooks, a3 = e3.getInstance;
      t3.forEach(function(e4, c3) {
        return function e5(n4, c4, d3, f3, g3) {
          d3 === void 0 && (d3 = 0);
          var v3 = n4, m3 = u2(n4, c4, f3), h3 = r3[m3];
          if (h3)
            h3.subRows && h3.originalSubRows.forEach(function(t4, n5) {
              return e5(t4, n5, d3 + 1, h3);
            });
          else if ((h3 = { id: m3, original: v3, index: c4, depth: d3, cells: [{}] }).cells.map = T2, h3.cells.filter = T2, h3.cells.forEach = T2, h3.cells[0].getCellProps = T2, h3.values = {}, g3.push(h3), o3.push(h3), r3[m3] = h3, h3.originalSubRows = l3(n4, c4), h3.originalSubRows) {
            var y3 = [];
            h3.originalSubRows.forEach(function(t4, n5) {
              return e5(t4, n5, d3 + 1, h3, y3);
            }), h3.subRows = y3;
          }
          i3.accessor && (h3.values[i3.id] = i3.accessor(n4, c4, h3, g3, t3)), h3.values[i3.id] = p2(s2, h3.values[i3.id], { row: h3, column: i3, instance: a3() });
        }(e4, c3, 0, void 0, n3);
      });
    }
    l2.resetExpanded = "resetExpanded", l2.toggleRowExpanded = "toggleRowExpanded", l2.toggleAllRowsExpanded = "toggleAllRowsExpanded";
    var se2 = function(e3) {
      e3.getToggleAllRowsExpandedProps = [ae2], e3.getToggleRowExpandedProps = [ce2], e3.stateReducers.push(de2), e3.useInstance.push(fe2), e3.prepareRow.push(pe2);
    };
    se2.pluginName = "useExpanded";
    var ae2 = function(e3, t3) {
      var n3 = t3.instance;
      return [e3, { onClick: function(e4) {
        n3.toggleAllRowsExpanded();
      }, style: { cursor: "pointer" }, title: "Toggle All Rows Expanded" }];
    }, ce2 = function(e3, t3) {
      var n3 = t3.row;
      return [e3, { onClick: function() {
        n3.toggleRowExpanded();
      }, style: { cursor: "pointer" }, title: "Toggle Row Expanded" }];
    };
    function de2(e3, t3, n3, o3) {
      if (t3.type === l2.init)
        return r2({ expanded: {} }, e3);
      if (t3.type === l2.resetExpanded)
        return r2({}, e3, { expanded: o3.initialState.expanded || {} });
      if (t3.type === l2.toggleAllRowsExpanded) {
        var s2 = t3.value, a3 = o3.isAllRowsExpanded, c3 = o3.rowsById;
        if (s2 !== void 0 ? s2 : !a3) {
          var d3 = {};
          return Object.keys(c3).forEach(function(e4) {
            d3[e4] = true;
          }), r2({}, e3, { expanded: d3 });
        }
        return r2({}, e3, { expanded: {} });
      }
      if (t3.type === l2.toggleRowExpanded) {
        var f3, p3 = t3.id, g3 = t3.value, v3 = e3.expanded[p3], m3 = g3 !== void 0 ? g3 : !v3;
        if (!v3 && m3)
          return r2({}, e3, { expanded: r2({}, e3.expanded, (f3 = {}, f3[p3] = true, f3)) });
        if (v3 && !m3) {
          var h3 = e3.expanded;
          h3[p3];
          return r2({}, e3, { expanded: i2(h3, [p3].map(u)) });
        }
        return e3;
      }
    }
    function fe2(e3) {
      var n3 = e3.data, o3 = e3.rows, r3 = e3.rowsById, i3 = e3.manualExpandedKey, u2 = i3 === void 0 ? "expanded" : i3, s2 = e3.paginateExpandedRows, a3 = s2 === void 0 || s2, c3 = e3.expandSubRows, d3 = c3 === void 0 || c3, p3 = e3.autoResetExpanded, g3 = p3 === void 0 || p3, m3 = e3.getHooks, y3 = e3.plugins, R3 = e3.state.expanded, b3 = e3.dispatch;
      v2(y3, ["useSortBy", "useGroupBy", "usePivotColumns", "useGlobalFilter"], "useExpanded");
      var S3 = h2(g3), C2 = Boolean(Object.keys(r3).length && Object.keys(R3).length);
      C2 && Object.keys(r3).some(function(e4) {
        return !R3[e4];
      }) && (C2 = false), w2(function() {
        S3() && b3({ type: l2.resetExpanded });
      }, [b3, n3]);
      var x3 = t2.useCallback(function(e4, t3) {
        b3({ type: l2.toggleRowExpanded, id: e4, value: t3 });
      }, [b3]), P3 = t2.useCallback(function(e4) {
        return b3({ type: l2.toggleAllRowsExpanded, value: e4 });
      }, [b3]), B3 = t2.useMemo(function() {
        return a3 ? A2(o3, { manualExpandedKey: u2, expanded: R3, expandSubRows: d3 }) : o3;
      }, [a3, o3, u2, R3, d3]), E2 = t2.useMemo(function() {
        return function(e4) {
          var t3 = 0;
          return Object.keys(e4).forEach(function(e5) {
            var n4 = e5.split(".");
            t3 = Math.max(t3, n4.length);
          }), t3;
        }(R3);
      }, [R3]), I3 = h2(e3), F3 = f2(m3().getToggleAllRowsExpandedProps, { instance: I3() });
      Object.assign(e3, { preExpandedRows: o3, expandedRows: B3, rows: B3, expandedDepth: E2, isAllRowsExpanded: C2, toggleRowExpanded: x3, toggleAllRowsExpanded: P3, getToggleAllRowsExpandedProps: F3 });
    }
    function pe2(e3, t3) {
      var n3 = t3.instance.getHooks, o3 = t3.instance;
      e3.toggleRowExpanded = function(t4) {
        return o3.toggleRowExpanded(e3.id, t4);
      }, e3.getToggleRowExpandedProps = f2(n3().getToggleRowExpandedProps, { instance: o3, row: e3 });
    }
    var ge2 = function(e3, t3, n3) {
      return e3 = e3.filter(function(e4) {
        return t3.some(function(t4) {
          var o3 = e4.values[t4];
          return String(o3).toLowerCase().includes(String(n3).toLowerCase());
        });
      });
    };
    ge2.autoRemove = function(e3) {
      return !e3;
    };
    var ve2 = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          var o3 = e4.values[t4];
          return o3 === void 0 || String(o3).toLowerCase() === String(n3).toLowerCase();
        });
      });
    };
    ve2.autoRemove = function(e3) {
      return !e3;
    };
    var me2 = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          var o3 = e4.values[t4];
          return o3 === void 0 || String(o3) === String(n3);
        });
      });
    };
    me2.autoRemove = function(e3) {
      return !e3;
    };
    var he2 = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          return e4.values[t4].includes(n3);
        });
      });
    };
    he2.autoRemove = function(e3) {
      return !e3 || !e3.length;
    };
    var ye = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          var o3 = e4.values[t4];
          return o3 && o3.length && n3.every(function(e5) {
            return o3.includes(e5);
          });
        });
      });
    };
    ye.autoRemove = function(e3) {
      return !e3 || !e3.length;
    };
    var we2 = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          var o3 = e4.values[t4];
          return o3 && o3.length && n3.some(function(e5) {
            return o3.includes(e5);
          });
        });
      });
    };
    we2.autoRemove = function(e3) {
      return !e3 || !e3.length;
    };
    var Re2 = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          var o3 = e4.values[t4];
          return n3.includes(o3);
        });
      });
    };
    Re2.autoRemove = function(e3) {
      return !e3 || !e3.length;
    };
    var be2 = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          return e4.values[t4] === n3;
        });
      });
    };
    be2.autoRemove = function(e3) {
      return e3 === void 0;
    };
    var Se2 = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          return e4.values[t4] == n3;
        });
      });
    };
    Se2.autoRemove = function(e3) {
      return e3 == null;
    };
    var Ce2 = function(e3, t3, n3) {
      var o3 = n3 || [], r3 = o3[0], i3 = o3[1];
      if ((r3 = typeof r3 == "number" ? r3 : -1 / 0) > (i3 = typeof i3 == "number" ? i3 : 1 / 0)) {
        var u2 = r3;
        r3 = i3, i3 = u2;
      }
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          var n4 = e4.values[t4];
          return n4 >= r3 && n4 <= i3;
        });
      });
    };
    Ce2.autoRemove = function(e3) {
      return !e3 || typeof e3[0] != "number" && typeof e3[1] != "number";
    };
    var xe = Object.freeze({ __proto__: null, text: ge2, exactText: ve2, exactTextCase: me2, includes: he2, includesAll: ye, includesSome: we2, includesValue: Re2, exact: be2, equals: Se2, between: Ce2 });
    l2.resetFilters = "resetFilters", l2.setFilter = "setFilter", l2.setAllFilters = "setAllFilters";
    var Pe2 = function(e3) {
      e3.stateReducers.push(Be2), e3.useInstance.push(Ee2);
    };
    function Be2(e3, t3, n3, o3) {
      if (t3.type === l2.init)
        return r2({ filters: [] }, e3);
      if (t3.type === l2.resetFilters)
        return r2({}, e3, { filters: o3.initialState.filters || [] });
      if (t3.type === l2.setFilter) {
        var i3 = t3.columnId, u2 = t3.filterValue, s2 = o3.allColumns, a3 = o3.filterTypes, c3 = s2.find(function(e4) {
          return e4.id === i3;
        });
        if (!c3)
          throw new Error("React-Table: Could not find a column with id: " + i3);
        var d3 = k2(c3.filter, a3 || {}, xe), f3 = e3.filters.find(function(e4) {
          return e4.id === i3;
        }), p3 = m2(u2, f3 && f3.value);
        return H2(d3.autoRemove, p3, c3) ? r2({}, e3, { filters: e3.filters.filter(function(e4) {
          return e4.id !== i3;
        }) }) : r2({}, e3, f3 ? { filters: e3.filters.map(function(e4) {
          return e4.id === i3 ? { id: i3, value: p3 } : e4;
        }) } : { filters: [].concat(e3.filters, [{ id: i3, value: p3 }]) });
      }
      if (t3.type === l2.setAllFilters) {
        var g3 = t3.filters, v3 = o3.allColumns, h3 = o3.filterTypes;
        return r2({}, e3, { filters: m2(g3, e3.filters).filter(function(e4) {
          var t4 = v3.find(function(t5) {
            return t5.id === e4.id;
          });
          return !H2(k2(t4.filter, h3 || {}, xe).autoRemove, e4.value, t4);
        }) });
      }
    }
    function Ee2(e3) {
      var n3 = e3.data, o3 = e3.rows, r3 = e3.flatRows, i3 = e3.rowsById, u2 = e3.allColumns, s2 = e3.filterTypes, a3 = e3.manualFilters, c3 = e3.defaultCanFilter, d3 = c3 !== void 0 && c3, f3 = e3.disableFilters, p3 = e3.state.filters, g3 = e3.dispatch, v3 = e3.autoResetFilters, m3 = v3 === void 0 || v3, y3 = t2.useCallback(function(e4, t3) {
        g3({ type: l2.setFilter, columnId: e4, filterValue: t3 });
      }, [g3]), R3 = t2.useCallback(function(e4) {
        g3({ type: l2.setAllFilters, filters: e4 });
      }, [g3]);
      u2.forEach(function(e4) {
        var t3 = e4.id, n4 = e4.accessor, o4 = e4.defaultCanFilter, r4 = e4.disableFilters;
        e4.canFilter = n4 ? I2(r4 !== true && void 0, f3 !== true && void 0, true) : I2(o4, d3, false), e4.setFilter = function(t4) {
          return y3(e4.id, t4);
        };
        var i4 = p3.find(function(e5) {
          return e5.id === t3;
        });
        e4.filterValue = i4 && i4.value;
      });
      var b3 = t2.useMemo(function() {
        if (a3 || !p3.length)
          return [o3, r3, i3];
        var e4 = [], t3 = {};
        return [function n4(o4, r4) {
          r4 === void 0 && (r4 = 0);
          var i4 = o4;
          return (i4 = p3.reduce(function(e5, t4) {
            var n5 = t4.id, o5 = t4.value, i5 = u2.find(function(e6) {
              return e6.id === n5;
            });
            if (!i5)
              return e5;
            r4 === 0 && (i5.preFilteredRows = e5);
            var l3 = k2(i5.filter, s2 || {}, xe);
            return l3 ? (i5.filteredRows = l3(e5, [n5], o5), i5.filteredRows) : (console.warn("Could not find a valid 'column.filter' for column with the ID: " + i5.id + "."), e5);
          }, o4)).forEach(function(o5) {
            e4.push(o5), t3[o5.id] = o5, o5.subRows && (o5.subRows = o5.subRows && o5.subRows.length > 0 ? n4(o5.subRows, r4 + 1) : o5.subRows);
          }), i4;
        }(o3), e4, t3];
      }, [a3, p3, o3, r3, i3, u2, s2]), S3 = b3[0], C2 = b3[1], x3 = b3[2];
      t2.useMemo(function() {
        u2.filter(function(e4) {
          return !p3.find(function(t3) {
            return t3.id === e4.id;
          });
        }).forEach(function(e4) {
          e4.preFilteredRows = S3, e4.filteredRows = S3;
        });
      }, [S3, p3, u2]);
      var P3 = h2(m3);
      w2(function() {
        P3() && g3({ type: l2.resetFilters });
      }, [g3, a3 ? null : n3]), Object.assign(e3, { preFilteredRows: o3, preFilteredFlatRows: r3, preFilteredRowsById: i3, filteredRows: S3, filteredFlatRows: C2, filteredRowsById: x3, rows: S3, flatRows: C2, rowsById: x3, setFilter: y3, setAllFilters: R3 });
    }
    Pe2.pluginName = "useFilters", l2.resetGlobalFilter = "resetGlobalFilter", l2.setGlobalFilter = "setGlobalFilter";
    var Ie2 = function(e3) {
      e3.stateReducers.push(Fe2), e3.useInstance.push(Ge2);
    };
    function Fe2(e3, t3, n3, o3) {
      if (t3.type === l2.resetGlobalFilter)
        return r2({}, e3, { globalFilter: o3.initialState.globalFilter || void 0 });
      if (t3.type === l2.setGlobalFilter) {
        var u2 = t3.filterValue, s2 = o3.userFilterTypes, a3 = k2(o3.globalFilter, s2 || {}, xe), c3 = m2(u2, e3.globalFilter);
        if (H2(a3.autoRemove, c3)) {
          e3.globalFilter;
          return i2(e3, ["globalFilter"]);
        }
        return r2({}, e3, { globalFilter: c3 });
      }
    }
    function Ge2(e3) {
      var n3 = e3.data, o3 = e3.rows, r3 = e3.flatRows, i3 = e3.rowsById, u2 = e3.allColumns, s2 = e3.filterTypes, a3 = e3.globalFilter, c3 = e3.manualGlobalFilter, d3 = e3.state.globalFilter, f3 = e3.dispatch, p3 = e3.autoResetGlobalFilter, g3 = p3 === void 0 || p3, v3 = e3.disableGlobalFilter, m3 = t2.useCallback(function(e4) {
        f3({ type: l2.setGlobalFilter, filterValue: e4 });
      }, [f3]), y3 = t2.useMemo(function() {
        if (c3 || d3 === void 0)
          return [o3, r3, i3];
        var e4 = [], t3 = {}, n4 = k2(a3, s2 || {}, xe);
        if (!n4)
          return console.warn("Could not find a valid 'globalFilter' option."), o3;
        u2.forEach(function(e5) {
          var t4 = e5.disableGlobalFilter;
          e5.canFilter = I2(t4 !== true && void 0, v3 !== true && void 0, true);
        });
        var l3 = u2.filter(function(e5) {
          return e5.canFilter === true;
        });
        return [function o4(r4) {
          return (r4 = n4(r4, l3.map(function(e5) {
            return e5.id;
          }), d3)).forEach(function(n5) {
            e4.push(n5), t3[n5.id] = n5, n5.subRows = n5.subRows && n5.subRows.length ? o4(n5.subRows) : n5.subRows;
          }), r4;
        }(o3), e4, t3];
      }, [c3, d3, a3, s2, u2, o3, r3, i3, v3]), R3 = y3[0], b3 = y3[1], S3 = y3[2], C2 = h2(g3);
      w2(function() {
        C2() && f3({ type: l2.resetGlobalFilter });
      }, [f3, c3 ? null : n3]), Object.assign(e3, { preGlobalFilteredRows: o3, preGlobalFilteredFlatRows: r3, preGlobalFilteredRowsById: i3, globalFilteredRows: R3, globalFilteredFlatRows: b3, globalFilteredRowsById: S3, rows: R3, flatRows: b3, rowsById: S3, setGlobalFilter: m3, disableGlobalFilter: v3 });
    }
    function Ae2(e3, t3) {
      return t3.reduce(function(e4, t4) {
        return e4 + (typeof t4 == "number" ? t4 : 0);
      }, 0);
    }
    Ie2.pluginName = "useGlobalFilter";
    var ke2 = Object.freeze({ __proto__: null, sum: Ae2, min: function(e3) {
      var t3 = e3[0] || 0;
      return e3.forEach(function(e4) {
        typeof e4 == "number" && (t3 = Math.min(t3, e4));
      }), t3;
    }, max: function(e3) {
      var t3 = e3[0] || 0;
      return e3.forEach(function(e4) {
        typeof e4 == "number" && (t3 = Math.max(t3, e4));
      }), t3;
    }, minMax: function(e3) {
      var t3 = e3[0] || 0, n3 = e3[0] || 0;
      return e3.forEach(function(e4) {
        typeof e4 == "number" && (t3 = Math.min(t3, e4), n3 = Math.max(n3, e4));
      }), t3 + ".." + n3;
    }, average: function(e3) {
      return Ae2(0, e3) / e3.length;
    }, median: function(e3) {
      if (!e3.length)
        return null;
      var t3 = Math.floor(e3.length / 2), n3 = [].concat(e3).sort(function(e4, t4) {
        return e4 - t4;
      });
      return e3.length % 2 != 0 ? n3[t3] : (n3[t3 - 1] + n3[t3]) / 2;
    }, unique: function(e3) {
      return Array.from(new Set(e3).values());
    }, uniqueCount: function(e3) {
      return new Set(e3).size;
    }, count: function(e3) {
      return e3.length;
    } }), He2 = [], Te2 = {};
    l2.resetGroupBy = "resetGroupBy", l2.setGroupBy = "setGroupBy", l2.toggleGroupBy = "toggleGroupBy";
    var ze = function(e3) {
      e3.getGroupByToggleProps = [We], e3.stateReducers.push(Oe2), e3.visibleColumnsDeps.push(function(e4, t3) {
        var n3 = t3.instance;
        return [].concat(e4, [n3.state.groupBy]);
      }), e3.visibleColumns.push(Me2), e3.useInstance.push(Ne2), e3.prepareRow.push(Le2);
    };
    ze.pluginName = "useGroupBy";
    var We = function(e3, t3) {
      var n3 = t3.header;
      return [e3, { onClick: n3.canGroupBy ? function(e4) {
        e4.persist(), n3.toggleGroupBy();
      } : void 0, style: { cursor: n3.canGroupBy ? "pointer" : void 0 }, title: "Toggle GroupBy" }];
    };
    function Oe2(e3, t3, n3, o3) {
      if (t3.type === l2.init)
        return r2({ groupBy: [] }, e3);
      if (t3.type === l2.resetGroupBy)
        return r2({}, e3, { groupBy: o3.initialState.groupBy || [] });
      if (t3.type === l2.setGroupBy)
        return r2({}, e3, { groupBy: t3.value });
      if (t3.type === l2.toggleGroupBy) {
        var i3 = t3.columnId, u2 = t3.value, s2 = u2 !== void 0 ? u2 : !e3.groupBy.includes(i3);
        return r2({}, e3, s2 ? { groupBy: [].concat(e3.groupBy, [i3]) } : { groupBy: e3.groupBy.filter(function(e4) {
          return e4 !== i3;
        }) });
      }
    }
    function Me2(e3, t3) {
      var n3 = t3.instance.state.groupBy, o3 = n3.map(function(t4) {
        return e3.find(function(e4) {
          return e4.id === t4;
        });
      }).filter(Boolean), r3 = e3.filter(function(e4) {
        return !n3.includes(e4.id);
      });
      return (e3 = [].concat(o3, r3)).forEach(function(e4) {
        e4.isGrouped = n3.includes(e4.id), e4.groupedIndex = n3.indexOf(e4.id);
      }), e3;
    }
    var je2 = {};
    function Ne2(e3) {
      var n3 = e3.data, o3 = e3.rows, r3 = e3.flatRows, i3 = e3.rowsById, u2 = e3.allColumns, s2 = e3.flatHeaders, a3 = e3.groupByFn, c3 = a3 === void 0 ? De2 : a3, d3 = e3.manualGroupBy, p3 = e3.aggregations, g3 = p3 === void 0 ? je2 : p3, m3 = e3.plugins, y3 = e3.state.groupBy, R3 = e3.dispatch, b3 = e3.autoResetGroupBy, S3 = b3 === void 0 || b3, C2 = e3.disableGroupBy, x3 = e3.defaultCanGroupBy, P3 = e3.getHooks;
      v2(m3, ["useColumnOrder", "useFilters"], "useGroupBy");
      var B3 = h2(e3);
      u2.forEach(function(t3) {
        var n4 = t3.accessor, o4 = t3.defaultGroupBy, r4 = t3.disableGroupBy;
        t3.canGroupBy = n4 ? I2(t3.canGroupBy, r4 !== true && void 0, C2 !== true && void 0, true) : I2(t3.canGroupBy, o4, x3, false), t3.canGroupBy && (t3.toggleGroupBy = function() {
          return e3.toggleGroupBy(t3.id);
        }), t3.Aggregated = t3.Aggregated || t3.Cell;
      });
      var E2 = t2.useCallback(function(e4, t3) {
        R3({ type: l2.toggleGroupBy, columnId: e4, value: t3 });
      }, [R3]), F3 = t2.useCallback(function(e4) {
        R3({ type: l2.setGroupBy, value: e4 });
      }, [R3]);
      s2.forEach(function(e4) {
        e4.getGroupByToggleProps = f2(P3().getGroupByToggleProps, { instance: B3(), header: e4 });
      });
      var A3 = t2.useMemo(function() {
        if (d3 || !y3.length)
          return [o3, r3, i3, He2, Te2, r3, i3];
        var e4 = y3.filter(function(e5) {
          return u2.find(function(t4) {
            return t4.id === e5;
          });
        }), t3 = [], n4 = {}, l3 = [], s3 = {}, a4 = [], f3 = {}, p4 = function o4(r4, i4, d4) {
          if (i4 === void 0 && (i4 = 0), i4 === e4.length)
            return r4;
          var p5 = e4[i4], v3 = c3(r4, p5);
          return Object.entries(v3).map(function(r5, c4) {
            var v4 = r5[0], m4 = r5[1], h3 = p5 + ":" + v4, y4 = o4(m4, i4 + 1, h3 = d4 ? d4 + ">" + h3 : h3), w3 = i4 ? G2(m4, "leafRows") : m4, R4 = function(t4, n5, o5) {
              var r6 = {};
              return u2.forEach(function(i5) {
                if (e4.includes(i5.id))
                  r6[i5.id] = n5[0] ? n5[0].values[i5.id] : null;
                else {
                  var u3 = typeof i5.aggregate == "function" ? i5.aggregate : g3[i5.aggregate] || ke2[i5.aggregate];
                  if (u3) {
                    var l4 = n5.map(function(e5) {
                      return e5.values[i5.id];
                    }), s4 = t4.map(function(e5) {
                      var t5 = e5.values[i5.id];
                      if (!o5 && i5.aggregateValue) {
                        var n6 = typeof i5.aggregateValue == "function" ? i5.aggregateValue : g3[i5.aggregateValue] || ke2[i5.aggregateValue];
                        if (!n6)
                          throw console.info({ column: i5 }), new Error("React Table: Invalid column.aggregateValue option for column listed above");
                        t5 = n6(t5, e5, i5);
                      }
                      return t5;
                    });
                    r6[i5.id] = u3(s4, l4);
                  } else {
                    if (i5.aggregate)
                      throw console.info({ column: i5 }), new Error("React Table: Invalid column.aggregate option for column listed above");
                    r6[i5.id] = null;
                  }
                }
              }), r6;
            }(w3, m4, i4), b4 = { id: h3, isGrouped: true, groupByID: p5, groupByVal: v4, values: R4, subRows: y4, leafRows: w3, depth: i4, index: c4 };
            return y4.forEach(function(e5) {
              t3.push(e5), n4[e5.id] = e5, e5.isGrouped ? (l3.push(e5), s3[e5.id] = e5) : (a4.push(e5), f3[e5.id] = e5);
            }), b4;
          });
        }(o3);
        return p4.forEach(function(e5) {
          t3.push(e5), n4[e5.id] = e5, e5.isGrouped ? (l3.push(e5), s3[e5.id] = e5) : (a4.push(e5), f3[e5.id] = e5);
        }), [p4, t3, n4, l3, s3, a4, f3];
      }, [d3, y3, o3, r3, i3, u2, g3, c3]), k3 = A3[0], H3 = A3[1], T3 = A3[2], z3 = A3[3], W3 = A3[4], O3 = A3[5], M3 = A3[6], j2 = h2(S3);
      w2(function() {
        j2() && R3({ type: l2.resetGroupBy });
      }, [R3, d3 ? null : n3]), Object.assign(e3, { preGroupedRows: o3, preGroupedFlatRow: r3, preGroupedRowsById: i3, groupedRows: k3, groupedFlatRows: H3, groupedRowsById: T3, onlyGroupedFlatRows: z3, onlyGroupedRowsById: W3, nonGroupedFlatRows: O3, nonGroupedRowsById: M3, rows: k3, flatRows: H3, rowsById: T3, toggleGroupBy: E2, setGroupBy: F3 });
    }
    function Le2(e3) {
      e3.allCells.forEach(function(t3) {
        var n3;
        t3.isGrouped = t3.column.isGrouped && t3.column.id === e3.groupByID, t3.isPlaceholder = !t3.isGrouped && t3.column.isGrouped, t3.isAggregated = !t3.isGrouped && !t3.isPlaceholder && ((n3 = e3.subRows) == null ? void 0 : n3.length);
      });
    }
    function De2(e3, t3) {
      return e3.reduce(function(e4, n3, o3) {
        var r3 = "" + n3.values[t3];
        return e4[r3] = Array.isArray(e4[r3]) ? e4[r3] : [], e4[r3].push(n3), e4;
      }, {});
    }
    var Ve = /([0-9]+)/gm;
    function _e2(e3, t3) {
      return e3 === t3 ? 0 : e3 > t3 ? 1 : -1;
    }
    function Xe2(e3, t3, n3) {
      return [e3.values[n3], t3.values[n3]];
    }
    function qe2(e3) {
      return typeof e3 == "number" ? isNaN(e3) || e3 === 1 / 0 || e3 === -1 / 0 ? "" : String(e3) : typeof e3 == "string" ? e3 : "";
    }
    var Ke2 = Object.freeze({ __proto__: null, alphanumeric: function(e3, t3, n3) {
      var o3 = Xe2(e3, t3, n3), r3 = o3[0], i3 = o3[1];
      for (r3 = qe2(r3), i3 = qe2(i3), r3 = r3.split(Ve).filter(Boolean), i3 = i3.split(Ve).filter(Boolean); r3.length && i3.length; ) {
        var u2 = r3.shift(), l3 = i3.shift(), s2 = parseInt(u2, 10), a3 = parseInt(l3, 10), c3 = [s2, a3].sort();
        if (isNaN(c3[0])) {
          if (u2 > l3)
            return 1;
          if (l3 > u2)
            return -1;
        } else {
          if (isNaN(c3[1]))
            return isNaN(s2) ? -1 : 1;
          if (s2 > a3)
            return 1;
          if (a3 > s2)
            return -1;
        }
      }
      return r3.length - i3.length;
    }, datetime: function(e3, t3, n3) {
      var o3 = Xe2(e3, t3, n3), r3 = o3[0], i3 = o3[1];
      return _e2(r3 = r3.getTime(), i3 = i3.getTime());
    }, basic: function(e3, t3, n3) {
      var o3 = Xe2(e3, t3, n3);
      return _e2(o3[0], o3[1]);
    }, string: function(e3, t3, n3) {
      var o3 = Xe2(e3, t3, n3), r3 = o3[0], i3 = o3[1];
      for (r3 = r3.split("").filter(Boolean), i3 = i3.split("").filter(Boolean); r3.length && i3.length; ) {
        var u2 = r3.shift(), l3 = i3.shift(), s2 = u2.toLowerCase(), a3 = l3.toLowerCase();
        if (s2 > a3)
          return 1;
        if (a3 > s2)
          return -1;
        if (u2 > l3)
          return 1;
        if (l3 > u2)
          return -1;
      }
      return r3.length - i3.length;
    }, number: function(e3, t3, n3) {
      var o3 = Xe2(e3, t3, n3), r3 = o3[0], i3 = o3[1], u2 = /[^0-9.]/gi;
      return _e2(r3 = Number(String(r3).replace(u2, "")), i3 = Number(String(i3).replace(u2, "")));
    } });
    l2.resetSortBy = "resetSortBy", l2.setSortBy = "setSortBy", l2.toggleSortBy = "toggleSortBy", l2.clearSortBy = "clearSortBy", c2.sortType = "alphanumeric", c2.sortDescFirst = false;
    var Ue2 = function(e3) {
      e3.getSortByToggleProps = [$e2], e3.stateReducers.push(Je2), e3.useInstance.push(Ye2);
    };
    Ue2.pluginName = "useSortBy";
    var $e2 = function(e3, t3) {
      var n3 = t3.instance, o3 = t3.column, r3 = n3.isMultiSortEvent, i3 = r3 === void 0 ? function(e4) {
        return e4.shiftKey;
      } : r3;
      return [e3, { onClick: o3.canSort ? function(e4) {
        e4.persist(), o3.toggleSortBy(void 0, !n3.disableMultiSort && i3(e4));
      } : void 0, style: { cursor: o3.canSort ? "pointer" : void 0 }, title: o3.canSort ? "Toggle SortBy" : void 0 }];
    };
    function Je2(e3, t3, n3, o3) {
      if (t3.type === l2.init)
        return r2({ sortBy: [] }, e3);
      if (t3.type === l2.resetSortBy)
        return r2({}, e3, { sortBy: o3.initialState.sortBy || [] });
      if (t3.type === l2.clearSortBy)
        return r2({}, e3, { sortBy: e3.sortBy.filter(function(e4) {
          return e4.id !== t3.columnId;
        }) });
      if (t3.type === l2.setSortBy)
        return r2({}, e3, { sortBy: t3.sortBy });
      if (t3.type === l2.toggleSortBy) {
        var i3, u2 = t3.columnId, s2 = t3.desc, a3 = t3.multi, c3 = o3.allColumns, d3 = o3.disableMultiSort, f3 = o3.disableSortRemove, p3 = o3.disableMultiRemove, g3 = o3.maxMultiSortColCount, v3 = g3 === void 0 ? Number.MAX_SAFE_INTEGER : g3, m3 = e3.sortBy, h3 = c3.find(function(e4) {
          return e4.id === u2;
        }).sortDescFirst, y3 = m3.find(function(e4) {
          return e4.id === u2;
        }), w3 = m3.findIndex(function(e4) {
          return e4.id === u2;
        }), R3 = s2 != null, b3 = [];
        return (i3 = !d3 && a3 ? y3 ? "toggle" : "add" : w3 !== m3.length - 1 || m3.length !== 1 ? "replace" : y3 ? "toggle" : "replace") !== "toggle" || f3 || R3 || a3 && p3 || !(y3 && y3.desc && !h3 || !y3.desc && h3) || (i3 = "remove"), i3 === "replace" ? b3 = [{ id: u2, desc: R3 ? s2 : h3 }] : i3 === "add" ? (b3 = [].concat(m3, [{ id: u2, desc: R3 ? s2 : h3 }])).splice(0, b3.length - v3) : i3 === "toggle" ? b3 = m3.map(function(e4) {
          return e4.id === u2 ? r2({}, e4, { desc: R3 ? s2 : !y3.desc }) : e4;
        }) : i3 === "remove" && (b3 = m3.filter(function(e4) {
          return e4.id !== u2;
        })), r2({}, e3, { sortBy: b3 });
      }
    }
    function Ye2(e3) {
      var n3 = e3.data, o3 = e3.rows, r3 = e3.flatRows, i3 = e3.allColumns, u2 = e3.orderByFn, s2 = u2 === void 0 ? Qe2 : u2, a3 = e3.sortTypes, c3 = e3.manualSortBy, d3 = e3.defaultCanSort, p3 = e3.disableSortBy, g3 = e3.flatHeaders, m3 = e3.state.sortBy, y3 = e3.dispatch, R3 = e3.plugins, b3 = e3.getHooks, S3 = e3.autoResetSortBy, C2 = S3 === void 0 || S3;
      v2(R3, ["useFilters", "useGlobalFilter", "useGroupBy", "usePivotColumns"], "useSortBy");
      var x3 = t2.useCallback(function(e4) {
        y3({ type: l2.setSortBy, sortBy: e4 });
      }, [y3]), P3 = t2.useCallback(function(e4, t3, n4) {
        y3({ type: l2.toggleSortBy, columnId: e4, desc: t3, multi: n4 });
      }, [y3]), B3 = h2(e3);
      g3.forEach(function(e4) {
        var t3 = e4.accessor, n4 = e4.canSort, o4 = e4.disableSortBy, r4 = e4.id, i4 = t3 ? I2(o4 !== true && void 0, p3 !== true && void 0, true) : I2(d3, n4, false);
        e4.canSort = i4, e4.canSort && (e4.toggleSortBy = function(t4, n5) {
          return P3(e4.id, t4, n5);
        }, e4.clearSortBy = function() {
          y3({ type: l2.clearSortBy, columnId: e4.id });
        }), e4.getSortByToggleProps = f2(b3().getSortByToggleProps, { instance: B3(), column: e4 });
        var u3 = m3.find(function(e5) {
          return e5.id === r4;
        });
        e4.isSorted = !!u3, e4.sortedIndex = m3.findIndex(function(e5) {
          return e5.id === r4;
        }), e4.isSortedDesc = e4.isSorted ? u3.desc : void 0;
      });
      var E2 = t2.useMemo(function() {
        if (c3 || !m3.length)
          return [o3, r3];
        var e4 = [], t3 = m3.filter(function(e5) {
          return i3.find(function(t4) {
            return t4.id === e5.id;
          });
        });
        return [function n4(o4) {
          var r4 = s2(o4, t3.map(function(e5) {
            var t4 = i3.find(function(t5) {
              return t5.id === e5.id;
            });
            if (!t4)
              throw new Error("React-Table: Could not find a column with id: " + e5.id + " while sorting");
            var n5 = t4.sortType, o5 = F2(n5) || (a3 || {})[n5] || Ke2[n5];
            if (!o5)
              throw new Error("React-Table: Could not find a valid sortType of '" + n5 + "' for column '" + e5.id + "'.");
            return function(t5, n6) {
              return o5(t5, n6, e5.id, e5.desc);
            };
          }), t3.map(function(e5) {
            var t4 = i3.find(function(t5) {
              return t5.id === e5.id;
            });
            return t4 && t4.sortInverted ? e5.desc : !e5.desc;
          }));
          return r4.forEach(function(t4) {
            e4.push(t4), t4.subRows && t4.subRows.length !== 0 && (t4.subRows = n4(t4.subRows));
          }), r4;
        }(o3), e4];
      }, [c3, m3, o3, r3, i3, s2, a3]), G3 = E2[0], A3 = E2[1], k3 = h2(C2);
      w2(function() {
        k3() && y3({ type: l2.resetSortBy });
      }, [c3 ? null : n3]), Object.assign(e3, { preSortedRows: o3, preSortedFlatRows: r3, sortedRows: G3, sortedFlatRows: A3, rows: G3, flatRows: A3, setSortBy: x3, toggleSortBy: P3 });
    }
    function Qe2(e3, t3, n3) {
      return [].concat(e3).sort(function(e4, o3) {
        for (var r3 = 0; r3 < t3.length; r3 += 1) {
          var i3 = t3[r3], u2 = n3[r3] === false || n3[r3] === "desc", l3 = i3(e4, o3);
          if (l3 !== 0)
            return u2 ? -l3 : l3;
        }
        return n3[0] ? e4.index - o3.index : o3.index - e4.index;
      });
    }
    l2.resetPage = "resetPage", l2.gotoPage = "gotoPage", l2.setPageSize = "setPageSize";
    var Ze2 = function(e3) {
      e3.stateReducers.push(et), e3.useInstance.push(tt);
    };
    function et(e3, t3, n3, o3) {
      if (t3.type === l2.init)
        return r2({ pageSize: 10, pageIndex: 0 }, e3);
      if (t3.type === l2.resetPage)
        return r2({}, e3, { pageIndex: o3.initialState.pageIndex || 0 });
      if (t3.type === l2.gotoPage) {
        var i3 = o3.pageCount, u2 = o3.page, s2 = m2(t3.pageIndex, e3.pageIndex), a3 = false;
        return s2 > e3.pageIndex ? a3 = i3 === -1 ? u2.length >= e3.pageSize : s2 < i3 : s2 < e3.pageIndex && (a3 = s2 > -1), a3 ? r2({}, e3, { pageIndex: s2 }) : e3;
      }
      if (t3.type === l2.setPageSize) {
        var c3 = t3.pageSize, d3 = e3.pageSize * e3.pageIndex;
        return r2({}, e3, { pageIndex: Math.floor(d3 / c3), pageSize: c3 });
      }
    }
    function tt(e3) {
      var n3 = e3.rows, o3 = e3.autoResetPage, r3 = o3 === void 0 || o3, i3 = e3.manualExpandedKey, u2 = i3 === void 0 ? "expanded" : i3, s2 = e3.plugins, a3 = e3.pageCount, c3 = e3.paginateExpandedRows, d3 = c3 === void 0 || c3, f3 = e3.expandSubRows, p3 = f3 === void 0 || f3, g3 = e3.state, m3 = g3.pageSize, y3 = g3.pageIndex, R3 = g3.expanded, b3 = g3.globalFilter, S3 = g3.filters, C2 = g3.groupBy, x3 = g3.sortBy, P3 = e3.dispatch, B3 = e3.data, E2 = e3.manualPagination;
      v2(s2, ["useGlobalFilter", "useFilters", "useGroupBy", "useSortBy", "useExpanded"], "usePagination");
      var I3 = h2(r3);
      w2(function() {
        I3() && P3({ type: l2.resetPage });
      }, [P3, E2 ? null : B3, b3, S3, C2, x3]);
      var F3 = E2 ? a3 : Math.ceil(n3.length / m3), G3 = t2.useMemo(function() {
        return F3 > 0 ? [].concat(new Array(F3)).fill(null).map(function(e4, t3) {
          return t3;
        }) : [];
      }, [F3]), k3 = t2.useMemo(function() {
        var e4;
        if (E2)
          e4 = n3;
        else {
          var t3 = m3 * y3, o4 = t3 + m3;
          e4 = n3.slice(t3, o4);
        }
        return d3 ? e4 : A2(e4, { manualExpandedKey: u2, expanded: R3, expandSubRows: p3 });
      }, [p3, R3, u2, E2, y3, m3, d3, n3]), H3 = y3 > 0, T3 = F3 === -1 ? k3.length >= m3 : y3 < F3 - 1, z3 = t2.useCallback(function(e4) {
        P3({ type: l2.gotoPage, pageIndex: e4 });
      }, [P3]), W3 = t2.useCallback(function() {
        return z3(function(e4) {
          return e4 - 1;
        });
      }, [z3]), O3 = t2.useCallback(function() {
        return z3(function(e4) {
          return e4 + 1;
        });
      }, [z3]), M3 = t2.useCallback(function(e4) {
        P3({ type: l2.setPageSize, pageSize: e4 });
      }, [P3]);
      Object.assign(e3, { pageOptions: G3, pageCount: F3, page: k3, canPreviousPage: H3, canNextPage: T3, gotoPage: z3, previousPage: W3, nextPage: O3, setPageSize: M3 });
    }
    Ze2.pluginName = "usePagination", l2.resetPivot = "resetPivot", l2.togglePivot = "togglePivot";
    var nt = function(e3) {
      e3.getPivotToggleProps = [rt], e3.stateReducers.push(it), e3.useInstanceAfterData.push(ut), e3.allColumns.push(lt), e3.accessValue.push(st), e3.materializedColumns.push(at), e3.materializedColumnsDeps.push(ct), e3.visibleColumns.push(dt), e3.visibleColumnsDeps.push(ft), e3.useInstance.push(pt), e3.prepareRow.push(gt);
    };
    nt.pluginName = "usePivotColumns";
    var ot = [], rt = function(e3, t3) {
      var n3 = t3.header;
      return [e3, { onClick: n3.canPivot ? function(e4) {
        e4.persist(), n3.togglePivot();
      } : void 0, style: { cursor: n3.canPivot ? "pointer" : void 0 }, title: "Toggle Pivot" }];
    };
    function it(e3, t3, n3, o3) {
      if (t3.type === l2.init)
        return r2({ pivotColumns: ot }, e3);
      if (t3.type === l2.resetPivot)
        return r2({}, e3, { pivotColumns: o3.initialState.pivotColumns || ot });
      if (t3.type === l2.togglePivot) {
        var i3 = t3.columnId, u2 = t3.value, s2 = u2 !== void 0 ? u2 : !e3.pivotColumns.includes(i3);
        return r2({}, e3, s2 ? { pivotColumns: [].concat(e3.pivotColumns, [i3]) } : { pivotColumns: e3.pivotColumns.filter(function(e4) {
          return e4 !== i3;
        }) });
      }
    }
    function ut(e3) {
      e3.allColumns.forEach(function(t3) {
        t3.isPivotSource = e3.state.pivotColumns.includes(t3.id);
      });
    }
    function lt(e3, t3) {
      var n3 = t3.instance;
      return e3.forEach(function(e4) {
        e4.isPivotSource = n3.state.pivotColumns.includes(e4.id), e4.uniqueValues = new Set();
      }), e3;
    }
    function st(e3, t3) {
      var n3 = t3.column;
      return n3.uniqueValues && e3 !== void 0 && n3.uniqueValues.add(e3), e3;
    }
    function at(e3, t3) {
      var n3 = t3.instance, o3 = n3.allColumns, i3 = n3.state;
      if (!i3.pivotColumns.length || !i3.groupBy || !i3.groupBy.length)
        return e3;
      var u2 = i3.pivotColumns.map(function(e4) {
        return o3.find(function(t4) {
          return t4.id === e4;
        });
      }).filter(Boolean), l3 = o3.filter(function(e4) {
        return !e4.isPivotSource && !i3.groupBy.includes(e4.id) && !i3.pivotColumns.includes(e4.id);
      }), s2 = C(function e4(t4, n4, o4) {
        t4 === void 0 && (t4 = 0), o4 === void 0 && (o4 = []);
        var i4 = u2[t4];
        return i4 ? Array.from(i4.uniqueValues).sort().map(function(u3) {
          var l4 = r2({}, i4, { Header: i4.PivotHeader || typeof i4.header == "string" ? i4.Header + ": " + u3 : u3, isPivotGroup: true, parent: n4, depth: t4, id: n4 ? n4.id + "." + i4.id + "." + u3 : i4.id + "." + u3, pivotValue: u3 });
          return l4.columns = e4(t4 + 1, l4, [].concat(o4, [function(e5) {
            return e5.values[i4.id] === u3;
          }])), l4;
        }) : l3.map(function(e5) {
          return r2({}, e5, { canPivot: false, isPivoted: true, parent: n4, depth: t4, id: "" + (n4 ? n4.id + "." + e5.id : e5.id), accessor: function(t5, n5, r3) {
            if (o4.every(function(e6) {
              return e6(r3);
            }))
              return r3.values[e5.id];
          } });
        });
      }());
      return [].concat(e3, s2);
    }
    function ct(e3, t3) {
      var n3 = t3.instance.state, o3 = n3.pivotColumns, r3 = n3.groupBy;
      return [].concat(e3, [o3, r3]);
    }
    function dt(e3, t3) {
      var n3 = t3.instance.state;
      return e3 = e3.filter(function(e4) {
        return !e4.isPivotSource;
      }), n3.pivotColumns.length && n3.groupBy && n3.groupBy.length && (e3 = e3.filter(function(e4) {
        return e4.isGrouped || e4.isPivoted;
      })), e3;
    }
    function ft(e3, t3) {
      var n3 = t3.instance;
      return [].concat(e3, [n3.state.pivotColumns, n3.state.groupBy]);
    }
    function pt(e3) {
      var t3 = e3.columns, n3 = e3.allColumns, o3 = e3.flatHeaders, r3 = e3.getHooks, i3 = e3.plugins, u2 = e3.dispatch, s2 = e3.autoResetPivot, a3 = s2 === void 0 || s2, c3 = e3.manaulPivot, d3 = e3.disablePivot, p3 = e3.defaultCanPivot;
      v2(i3, ["useGroupBy"], "usePivotColumns");
      var g3 = h2(e3);
      n3.forEach(function(t4) {
        var n4 = t4.accessor, o4 = t4.defaultPivot, r4 = t4.disablePivot;
        t4.canPivot = n4 ? I2(t4.canPivot, r4 !== true && void 0, d3 !== true && void 0, true) : I2(t4.canPivot, o4, p3, false), t4.canPivot && (t4.togglePivot = function() {
          return e3.togglePivot(t4.id);
        }), t4.Aggregated = t4.Aggregated || t4.Cell;
      });
      o3.forEach(function(e4) {
        e4.getPivotToggleProps = f2(r3().getPivotToggleProps, { instance: g3(), header: e4 });
      });
      var m3 = h2(a3);
      w2(function() {
        m3() && u2({ type: l2.resetPivot });
      }, [u2, c3 ? null : t3]), Object.assign(e3, { togglePivot: function(e4, t4) {
        u2({ type: l2.togglePivot, columnId: e4, value: t4 });
      } });
    }
    function gt(e3) {
      e3.allCells.forEach(function(e4) {
        e4.isPivoted = e4.column.isPivoted;
      });
    }
    l2.resetSelectedRows = "resetSelectedRows", l2.toggleAllRowsSelected = "toggleAllRowsSelected", l2.toggleRowSelected = "toggleRowSelected", l2.toggleAllPageRowsSelected = "toggleAllPageRowsSelected";
    var vt = function(e3) {
      e3.getToggleRowSelectedProps = [mt], e3.getToggleAllRowsSelectedProps = [ht], e3.getToggleAllPageRowsSelectedProps = [yt], e3.stateReducers.push(wt), e3.useInstance.push(Rt), e3.prepareRow.push(bt);
    };
    vt.pluginName = "useRowSelect";
    var mt = function(e3, t3) {
      var n3 = t3.instance, o3 = t3.row, r3 = n3.manualRowSelectedKey, i3 = r3 === void 0 ? "isSelected" : r3;
      return [e3, { onChange: function(e4) {
        o3.toggleRowSelected(e4.target.checked);
      }, style: { cursor: "pointer" }, checked: !(!o3.original || !o3.original[i3]) || o3.isSelected, title: "Toggle Row Selected", indeterminate: o3.isSomeSelected }];
    }, ht = function(e3, t3) {
      var n3 = t3.instance;
      return [e3, { onChange: function(e4) {
        n3.toggleAllRowsSelected(e4.target.checked);
      }, style: { cursor: "pointer" }, checked: n3.isAllRowsSelected, title: "Toggle All Rows Selected", indeterminate: Boolean(!n3.isAllRowsSelected && Object.keys(n3.state.selectedRowIds).length) }];
    }, yt = function(e3, t3) {
      var n3 = t3.instance;
      return [e3, { onChange: function(e4) {
        n3.toggleAllPageRowsSelected(e4.target.checked);
      }, style: { cursor: "pointer" }, checked: n3.isAllPageRowsSelected, title: "Toggle All Current Page Rows Selected", indeterminate: Boolean(!n3.isAllPageRowsSelected && n3.page.some(function(e4) {
        var t4 = e4.id;
        return n3.state.selectedRowIds[t4];
      })) }];
    };
    function wt(e3, t3, n3, o3) {
      if (t3.type === l2.init)
        return r2({ selectedRowIds: {} }, e3);
      if (t3.type === l2.resetSelectedRows)
        return r2({}, e3, { selectedRowIds: o3.initialState.selectedRowIds || {} });
      if (t3.type === l2.toggleAllRowsSelected) {
        var i3 = t3.value, u2 = o3.isAllRowsSelected, s2 = o3.rowsById, a3 = o3.nonGroupedRowsById, c3 = a3 === void 0 ? s2 : a3, d3 = i3 !== void 0 ? i3 : !u2, f3 = Object.assign({}, e3.selectedRowIds);
        return d3 ? Object.keys(c3).forEach(function(e4) {
          f3[e4] = true;
        }) : Object.keys(c3).forEach(function(e4) {
          delete f3[e4];
        }), r2({}, e3, { selectedRowIds: f3 });
      }
      if (t3.type === l2.toggleRowSelected) {
        var p3 = t3.id, g3 = t3.value, v3 = o3.rowsById, m3 = o3.selectSubRows, h3 = m3 === void 0 || m3, y3 = o3.getSubRows, w3 = e3.selectedRowIds[p3], R3 = g3 !== void 0 ? g3 : !w3;
        if (w3 === R3)
          return e3;
        var b3 = r2({}, e3.selectedRowIds);
        return function e4(t4) {
          var n4 = v3[t4];
          if (n4.isGrouped || (R3 ? b3[t4] = true : delete b3[t4]), h3 && y3(n4))
            return y3(n4).forEach(function(t5) {
              return e4(t5.id);
            });
        }(p3), r2({}, e3, { selectedRowIds: b3 });
      }
      if (t3.type === l2.toggleAllPageRowsSelected) {
        var S3 = t3.value, C2 = o3.page, x3 = o3.rowsById, P3 = o3.selectSubRows, B3 = P3 === void 0 || P3, E2 = o3.isAllPageRowsSelected, I3 = o3.getSubRows, F3 = S3 !== void 0 ? S3 : !E2, G3 = r2({}, e3.selectedRowIds);
        return C2.forEach(function(e4) {
          return function e5(t4) {
            var n4 = x3[t4];
            if (n4.isGrouped || (F3 ? G3[t4] = true : delete G3[t4]), B3 && I3(n4))
              return I3(n4).forEach(function(t5) {
                return e5(t5.id);
              });
          }(e4.id);
        }), r2({}, e3, { selectedRowIds: G3 });
      }
      return e3;
    }
    function Rt(e3) {
      var n3 = e3.data, o3 = e3.rows, r3 = e3.getHooks, i3 = e3.plugins, u2 = e3.rowsById, s2 = e3.nonGroupedRowsById, a3 = s2 === void 0 ? u2 : s2, c3 = e3.autoResetSelectedRows, d3 = c3 === void 0 || c3, p3 = e3.state.selectedRowIds, g3 = e3.selectSubRows, m3 = g3 === void 0 || g3, y3 = e3.dispatch, R3 = e3.page, b3 = e3.getSubRows;
      v2(i3, ["useFilters", "useGroupBy", "useSortBy", "useExpanded", "usePagination"], "useRowSelect");
      var S3 = t2.useMemo(function() {
        var e4 = [];
        return o3.forEach(function(t3) {
          var n4 = m3 ? function e5(t4, n5, o4) {
            if (n5[t4.id])
              return true;
            var r4 = o4(t4);
            if (r4 && r4.length) {
              var i4 = true, u3 = false;
              return r4.forEach(function(t5) {
                u3 && !i4 || (e5(t5, n5, o4) ? u3 = true : i4 = false);
              }), !!i4 || !!u3 && null;
            }
            return false;
          }(t3, p3, b3) : !!p3[t3.id];
          t3.isSelected = !!n4, t3.isSomeSelected = n4 === null, n4 && e4.push(t3);
        }), e4;
      }, [o3, m3, p3, b3]), C2 = Boolean(Object.keys(a3).length && Object.keys(p3).length), x3 = C2;
      C2 && Object.keys(a3).some(function(e4) {
        return !p3[e4];
      }) && (C2 = false), C2 || R3 && R3.length && R3.some(function(e4) {
        var t3 = e4.id;
        return !p3[t3];
      }) && (x3 = false);
      var P3 = h2(d3);
      w2(function() {
        P3() && y3({ type: l2.resetSelectedRows });
      }, [y3, n3]);
      var B3 = t2.useCallback(function(e4) {
        return y3({ type: l2.toggleAllRowsSelected, value: e4 });
      }, [y3]), E2 = t2.useCallback(function(e4) {
        return y3({ type: l2.toggleAllPageRowsSelected, value: e4 });
      }, [y3]), I3 = t2.useCallback(function(e4, t3) {
        return y3({ type: l2.toggleRowSelected, id: e4, value: t3 });
      }, [y3]), F3 = h2(e3), G3 = f2(r3().getToggleAllRowsSelectedProps, { instance: F3() }), A3 = f2(r3().getToggleAllPageRowsSelectedProps, { instance: F3() });
      Object.assign(e3, { selectedFlatRows: S3, isAllRowsSelected: C2, isAllPageRowsSelected: x3, toggleRowSelected: I3, toggleAllRowsSelected: B3, getToggleAllRowsSelectedProps: G3, getToggleAllPageRowsSelectedProps: A3, toggleAllPageRowsSelected: E2 });
    }
    function bt(e3, t3) {
      var n3 = t3.instance;
      e3.toggleRowSelected = function(t4) {
        return n3.toggleRowSelected(e3.id, t4);
      }, e3.getToggleRowSelectedProps = f2(n3.getHooks().getToggleRowSelectedProps, { instance: n3, row: e3 });
    }
    var St = function(e3) {
      return {};
    }, Ct = function(e3) {
      return {};
    };
    l2.setRowState = "setRowState", l2.setCellState = "setCellState", l2.resetRowState = "resetRowState";
    var xt = function(e3) {
      e3.stateReducers.push(Pt), e3.useInstance.push(Bt), e3.prepareRow.push(Et);
    };
    function Pt(e3, t3, n3, o3) {
      var i3 = o3.initialRowStateAccessor, u2 = i3 === void 0 ? St : i3, s2 = o3.initialCellStateAccessor, a3 = s2 === void 0 ? Ct : s2, c3 = o3.rowsById;
      if (t3.type === l2.init)
        return r2({ rowState: {} }, e3);
      if (t3.type === l2.resetRowState)
        return r2({}, e3, { rowState: o3.initialState.rowState || {} });
      if (t3.type === l2.setRowState) {
        var d3, f3 = t3.rowId, p3 = t3.value, g3 = e3.rowState[f3] !== void 0 ? e3.rowState[f3] : u2(c3[f3]);
        return r2({}, e3, { rowState: r2({}, e3.rowState, (d3 = {}, d3[f3] = m2(p3, g3), d3)) });
      }
      if (t3.type === l2.setCellState) {
        var v3, h3, y3, w3, R3, b3 = t3.rowId, S3 = t3.columnId, C2 = t3.value, x3 = e3.rowState[b3] !== void 0 ? e3.rowState[b3] : u2(c3[b3]), P3 = (x3 == null ? void 0 : (v3 = x3.cellState) == null ? void 0 : v3[S3]) !== void 0 ? x3.cellState[S3] : a3((h3 = c3[b3]) == null ? void 0 : (y3 = h3.cells) == null ? void 0 : y3.find(function(e4) {
          return e4.column.id === S3;
        }));
        return r2({}, e3, { rowState: r2({}, e3.rowState, (R3 = {}, R3[b3] = r2({}, x3, { cellState: r2({}, x3.cellState || {}, (w3 = {}, w3[S3] = m2(C2, P3), w3)) }), R3)) });
      }
    }
    function Bt(e3) {
      var n3 = e3.autoResetRowState, o3 = n3 === void 0 || n3, r3 = e3.data, i3 = e3.dispatch, u2 = t2.useCallback(function(e4, t3) {
        return i3({ type: l2.setRowState, rowId: e4, value: t3 });
      }, [i3]), s2 = t2.useCallback(function(e4, t3, n4) {
        return i3({ type: l2.setCellState, rowId: e4, columnId: t3, value: n4 });
      }, [i3]), a3 = h2(o3);
      w2(function() {
        a3() && i3({ type: l2.resetRowState });
      }, [r3]), Object.assign(e3, { setRowState: u2, setCellState: s2 });
    }
    function Et(e3, t3) {
      var n3 = t3.instance, o3 = n3.initialRowStateAccessor, r3 = o3 === void 0 ? St : o3, i3 = n3.initialCellStateAccessor, u2 = i3 === void 0 ? Ct : i3, l3 = n3.state.rowState;
      e3 && (e3.state = l3[e3.id] !== void 0 ? l3[e3.id] : r3(e3), e3.setState = function(t4) {
        return n3.setRowState(e3.id, t4);
      }, e3.cells.forEach(function(t4) {
        e3.state.cellState || (e3.state.cellState = {}), t4.state = e3.state.cellState[t4.column.id] !== void 0 ? e3.state.cellState[t4.column.id] : u2(t4), t4.setState = function(o4) {
          return n3.setCellState(e3.id, t4.column.id, o4);
        };
      }));
    }
    xt.pluginName = "useRowState", l2.resetColumnOrder = "resetColumnOrder", l2.setColumnOrder = "setColumnOrder";
    var It = function(e3) {
      e3.stateReducers.push(Ft), e3.visibleColumnsDeps.push(function(e4, t3) {
        var n3 = t3.instance;
        return [].concat(e4, [n3.state.columnOrder]);
      }), e3.visibleColumns.push(Gt), e3.useInstance.push(At);
    };
    function Ft(e3, t3, n3, o3) {
      return t3.type === l2.init ? r2({ columnOrder: [] }, e3) : t3.type === l2.resetColumnOrder ? r2({}, e3, { columnOrder: o3.initialState.columnOrder || [] }) : t3.type === l2.setColumnOrder ? r2({}, e3, { columnOrder: m2(t3.columnOrder, e3.columnOrder) }) : void 0;
    }
    function Gt(e3, t3) {
      var n3 = t3.instance.state.columnOrder;
      if (!n3 || !n3.length)
        return e3;
      for (var o3 = [].concat(n3), r3 = [].concat(e3), i3 = [], u2 = function() {
        var e4 = o3.shift(), t4 = r3.findIndex(function(t5) {
          return t5.id === e4;
        });
        t4 > -1 && i3.push(r3.splice(t4, 1)[0]);
      }; r3.length && o3.length; )
        u2();
      return [].concat(i3, r3);
    }
    function At(e3) {
      var n3 = e3.dispatch;
      e3.setColumnOrder = t2.useCallback(function(e4) {
        return n3({ type: l2.setColumnOrder, columnOrder: e4 });
      }, [n3]);
    }
    It.pluginName = "useColumnOrder", c2.canResize = true, l2.columnStartResizing = "columnStartResizing", l2.columnResizing = "columnResizing", l2.columnDoneResizing = "columnDoneResizing", l2.resetResize = "resetResize";
    var kt = function(e3) {
      e3.getResizerProps = [Ht], e3.getHeaderProps.push({ style: { position: "relative" } }), e3.stateReducers.push(Tt), e3.useInstance.push(Wt), e3.useInstanceBeforeDimensions.push(zt);
    }, Ht = function(e3, t3) {
      var n3 = t3.instance, o3 = t3.header, r3 = n3.dispatch, i3 = function(e4, t4) {
        var n4 = false;
        if (e4.type === "touchstart") {
          if (e4.touches && e4.touches.length > 1)
            return;
          n4 = true;
        }
        var o4 = function(e5) {
          var t5 = [];
          return function e6(n5) {
            n5.columns && n5.columns.length && n5.columns.map(e6);
            t5.push(n5);
          }(e5), t5;
        }(t4).map(function(e5) {
          return [e5.id, e5.totalWidth];
        }), i4 = n4 ? Math.round(e4.touches[0].clientX) : e4.clientX, u2 = function(e5) {
          r3({ type: l2.columnResizing, clientX: e5 });
        }, s2 = function() {
          return r3({ type: l2.columnDoneResizing });
        }, a3 = { mouse: { moveEvent: "mousemove", moveHandler: function(e5) {
          return u2(e5.clientX);
        }, upEvent: "mouseup", upHandler: function(e5) {
          document.removeEventListener("mousemove", a3.mouse.moveHandler), document.removeEventListener("mouseup", a3.mouse.upHandler), s2();
        } }, touch: { moveEvent: "touchmove", moveHandler: function(e5) {
          return e5.cancelable && (e5.preventDefault(), e5.stopPropagation()), u2(e5.touches[0].clientX), false;
        }, upEvent: "touchend", upHandler: function(e5) {
          document.removeEventListener(a3.touch.moveEvent, a3.touch.moveHandler), document.removeEventListener(a3.touch.upEvent, a3.touch.moveHandler), s2();
        } } }, c3 = n4 ? a3.touch : a3.mouse, d3 = !!function() {
          if (typeof z2 == "boolean")
            return z2;
          var e5 = false;
          try {
            var t5 = { get passive() {
              return e5 = true, false;
            } };
            window.addEventListener("test", null, t5), window.removeEventListener("test", null, t5);
          } catch (t6) {
            e5 = false;
          }
          return z2 = e5;
        }() && { passive: false };
        document.addEventListener(c3.moveEvent, c3.moveHandler, d3), document.addEventListener(c3.upEvent, c3.upHandler, d3), r3({ type: l2.columnStartResizing, columnId: t4.id, columnWidth: t4.totalWidth, headerIdWidths: o4, clientX: i4 });
      };
      return [e3, { onMouseDown: function(e4) {
        return e4.persist() || i3(e4, o3);
      }, onTouchStart: function(e4) {
        return e4.persist() || i3(e4, o3);
      }, style: { cursor: "col-resize" }, draggable: false, role: "separator" }];
    };
    function Tt(e3, t3) {
      if (t3.type === l2.init)
        return r2({ columnResizing: { columnWidths: {} } }, e3);
      if (t3.type === l2.resetResize)
        return r2({}, e3, { columnResizing: { columnWidths: {} } });
      if (t3.type === l2.columnStartResizing) {
        var n3 = t3.clientX, o3 = t3.columnId, i3 = t3.columnWidth, u2 = t3.headerIdWidths;
        return r2({}, e3, { columnResizing: r2({}, e3.columnResizing, { startX: n3, headerIdWidths: u2, columnWidth: i3, isResizingColumn: o3 }) });
      }
      if (t3.type === l2.columnResizing) {
        var s2 = t3.clientX, a3 = e3.columnResizing, c3 = a3.startX, d3 = a3.columnWidth, f3 = a3.headerIdWidths, p3 = (s2 - c3) / d3, g3 = {};
        return (f3 === void 0 ? [] : f3).forEach(function(e4) {
          var t4 = e4[0], n4 = e4[1];
          g3[t4] = Math.max(n4 + n4 * p3, 0);
        }), r2({}, e3, { columnResizing: r2({}, e3.columnResizing, { columnWidths: r2({}, e3.columnResizing.columnWidths, {}, g3) }) });
      }
      return t3.type === l2.columnDoneResizing ? r2({}, e3, { columnResizing: r2({}, e3.columnResizing, { startX: null, isResizingColumn: null }) }) : void 0;
    }
    kt.pluginName = "useResizeColumns";
    var zt = function(e3) {
      var t3 = e3.flatHeaders, n3 = e3.disableResizing, o3 = e3.getHooks, r3 = e3.state.columnResizing, i3 = h2(e3);
      t3.forEach(function(e4) {
        var t4 = I2(e4.disableResizing !== true && void 0, n3 !== true && void 0, true);
        e4.canResize = t4, e4.width = r3.columnWidths[e4.id] || e4.originalWidth || e4.width, e4.isResizing = r3.isResizingColumn === e4.id, t4 && (e4.getResizerProps = f2(o3().getResizerProps, { instance: i3(), header: e4 }));
      });
    };
    function Wt(e3) {
      var n3 = e3.plugins, o3 = e3.dispatch, r3 = e3.autoResetResize, i3 = r3 === void 0 || r3, u2 = e3.columns;
      v2(n3, ["useAbsoluteLayout"], "useResizeColumns");
      var s2 = h2(i3);
      w2(function() {
        s2() && o3({ type: l2.resetResize });
      }, [u2]);
      var a3 = t2.useCallback(function() {
        return o3({ type: l2.resetResize });
      }, [o3]);
      Object.assign(e3, { resetResizing: a3 });
    }
    var Ot = { position: "absolute", top: 0 }, Mt = function(e3) {
      e3.getTableBodyProps.push(jt), e3.getRowProps.push(jt), e3.getHeaderGroupProps.push(jt), e3.getFooterGroupProps.push(jt), e3.getHeaderProps.push(function(e4, t3) {
        var n3 = t3.column;
        return [e4, { style: r2({}, Ot, { left: n3.totalLeft + "px", width: n3.totalWidth + "px" }) }];
      }), e3.getCellProps.push(function(e4, t3) {
        var n3 = t3.cell;
        return [e4, { style: r2({}, Ot, { left: n3.column.totalLeft + "px", width: n3.column.totalWidth + "px" }) }];
      }), e3.getFooterProps.push(function(e4, t3) {
        var n3 = t3.column;
        return [e4, { style: r2({}, Ot, { left: n3.totalLeft + "px", width: n3.totalWidth + "px" }) }];
      });
    };
    Mt.pluginName = "useAbsoluteLayout";
    var jt = function(e3, t3) {
      return [e3, { style: { position: "relative", width: t3.instance.totalColumnsWidth + "px" } }];
    }, Nt = { display: "inline-block", boxSizing: "border-box" }, Lt = function(e3, t3) {
      return [e3, { style: { display: "flex", width: t3.instance.totalColumnsWidth + "px" } }];
    }, Dt = function(e3) {
      e3.getRowProps.push(Lt), e3.getHeaderGroupProps.push(Lt), e3.getFooterGroupProps.push(Lt), e3.getHeaderProps.push(function(e4, t3) {
        var n3 = t3.column;
        return [e4, { style: r2({}, Nt, { width: n3.totalWidth + "px" }) }];
      }), e3.getCellProps.push(function(e4, t3) {
        var n3 = t3.cell;
        return [e4, { style: r2({}, Nt, { width: n3.column.totalWidth + "px" }) }];
      }), e3.getFooterProps.push(function(e4, t3) {
        var n3 = t3.column;
        return [e4, { style: r2({}, Nt, { width: n3.totalWidth + "px" }) }];
      });
    };
    function Vt(e3) {
      e3.getTableProps.push(_t), e3.getRowProps.push(Xt), e3.getHeaderGroupProps.push(Xt), e3.getFooterGroupProps.push(Xt), e3.getHeaderProps.push(qt), e3.getCellProps.push(Kt), e3.getFooterProps.push(Ut);
    }
    Dt.pluginName = "useBlockLayout", Vt.pluginName = "useFlexLayout";
    var _t = function(e3, t3) {
      return [e3, { style: { minWidth: t3.instance.totalColumnsMinWidth + "px" } }];
    }, Xt = function(e3, t3) {
      return [e3, { style: { display: "flex", flex: "1 0 auto", minWidth: t3.instance.totalColumnsMinWidth + "px" } }];
    }, qt = function(e3, t3) {
      var n3 = t3.column;
      return [e3, { style: { boxSizing: "border-box", flex: n3.totalFlexWidth ? n3.totalFlexWidth + " 0 auto" : void 0, minWidth: n3.totalMinWidth + "px", width: n3.totalWidth + "px" } }];
    }, Kt = function(e3, t3) {
      var n3 = t3.cell;
      return [e3, { style: { boxSizing: "border-box", flex: n3.column.totalFlexWidth + " 0 auto", minWidth: n3.column.totalMinWidth + "px", width: n3.column.totalWidth + "px" } }];
    }, Ut = function(e3, t3) {
      var n3 = t3.column;
      return [e3, { style: { boxSizing: "border-box", flex: n3.totalFlexWidth ? n3.totalFlexWidth + " 0 auto" : void 0, minWidth: n3.totalMinWidth + "px", width: n3.totalWidth + "px" } }];
    };
    function $t(e3) {
      e3.stateReducers.push(Qt), e3.getTableProps.push(Jt), e3.getHeaderProps.push(Yt);
    }
    $t.pluginName = "useGridLayout";
    var Jt = function(e3, t3) {
      return [e3, { style: { display: "grid", gridTemplateColumns: t3.instance.state.gridLayout.columnWidths.map(function(e4) {
        return e4;
      }).join(" ") } }];
    }, Yt = function(e3, t3) {
      return [e3, { id: "header-cell-" + t3.column.id, style: { position: "sticky" } }];
    };
    function Qt(e3, t3, n3, o3) {
      if (t3.type === "init")
        return r2({ gridLayout: { columnWidths: o3.columns.map(function() {
          return "auto";
        }) } }, e3);
      if (t3.type === "columnStartResizing") {
        var i3 = t3.columnId, u2 = o3.visibleColumns.findIndex(function(e4) {
          return e4.id === i3;
        }), l3 = function(e4) {
          var t4, n4 = (t4 = document.getElementById("header-cell-" + e4)) == null ? void 0 : t4.offsetWidth;
          if (n4 !== void 0)
            return n4;
        }(i3);
        return l3 !== void 0 ? r2({}, e3, { gridLayout: r2({}, e3.gridLayout, { columnId: i3, columnIndex: u2, startingWidth: l3 }) }) : e3;
      }
      if (t3.type === "columnResizing") {
        var s2 = e3.gridLayout, a3 = s2.columnIndex, c3 = s2.startingWidth, d3 = s2.columnWidths, f3 = c3 - (e3.columnResizing.startX - t3.clientX), p3 = [].concat(d3);
        return p3[a3] = f3 + "px", r2({}, e3, { gridLayout: r2({}, e3.gridLayout, { columnWidths: p3 }) });
      }
    }
    e2._UNSTABLE_usePivotColumns = nt, e2.actions = l2, e2.defaultColumn = c2, e2.defaultGroupByFn = De2, e2.defaultOrderByFn = Qe2, e2.defaultRenderer = s, e2.emptyRenderer = a2, e2.ensurePluginOrder = v2, e2.flexRender = b2, e2.functionalUpdate = m2, e2.loopHooks = g2, e2.makePropGetter = f2, e2.makeRenderer = R2, e2.reduceHooks = p2, e2.safeUseLayoutEffect = y2, e2.useAbsoluteLayout = Mt, e2.useAsyncDebounce = function(e3, n3) {
      n3 === void 0 && (n3 = 0);
      var r3 = t2.useRef({}), i3 = h2(e3), u2 = h2(n3);
      return t2.useCallback(function() {
        var e4 = o2(regeneratorRuntime.mark(function e5() {
          var t3, n4, l3, s2 = arguments;
          return regeneratorRuntime.wrap(function(e6) {
            for (; ; )
              switch (e6.prev = e6.next) {
                case 0:
                  for (t3 = s2.length, n4 = new Array(t3), l3 = 0; l3 < t3; l3++)
                    n4[l3] = s2[l3];
                  return r3.current.promise || (r3.current.promise = new Promise(function(e7, t4) {
                    r3.current.resolve = e7, r3.current.reject = t4;
                  })), r3.current.timeout && clearTimeout(r3.current.timeout), r3.current.timeout = setTimeout(o2(regeneratorRuntime.mark(function e7() {
                    return regeneratorRuntime.wrap(function(e8) {
                      for (; ; )
                        switch (e8.prev = e8.next) {
                          case 0:
                            return delete r3.current.timeout, e8.prev = 1, e8.t0 = r3.current, e8.next = 5, i3().apply(void 0, n4);
                          case 5:
                            e8.t1 = e8.sent, e8.t0.resolve.call(e8.t0, e8.t1), e8.next = 12;
                            break;
                          case 9:
                            e8.prev = 9, e8.t2 = e8.catch(1), r3.current.reject(e8.t2);
                          case 12:
                            return e8.prev = 12, delete r3.current.promise, e8.finish(12);
                          case 15:
                          case "end":
                            return e8.stop();
                        }
                    }, e7, null, [[1, 9, 12, 15]]);
                  })), u2()), e6.abrupt("return", r3.current.promise);
                case 5:
                case "end":
                  return e6.stop();
              }
          }, e5);
        }));
        return function() {
          return e4.apply(this, arguments);
        };
      }(), [i3, u2]);
    }, e2.useBlockLayout = Dt, e2.useColumnOrder = It, e2.useExpanded = se2, e2.useFilters = Pe2, e2.useFlexLayout = Vt, e2.useGetLatest = h2, e2.useGlobalFilter = Ie2, e2.useGridLayout = $t, e2.useGroupBy = ze, e2.useMountedLayoutEffect = w2, e2.usePagination = Ze2, e2.useResizeColumns = kt, e2.useRowSelect = vt, e2.useRowState = xt, e2.useSortBy = Ue2, e2.useTable = function(e3) {
      for (var n3 = arguments.length, o3 = new Array(n3 > 1 ? n3 - 1 : 0), i3 = 1; i3 < n3; i3++)
        o3[i3 - 1] = arguments[i3];
      e3 = ie2(e3), o3 = [K].concat(o3);
      var u2 = t2.useRef({}), s2 = h2(u2.current);
      Object.assign(s2(), r2({}, e3, { plugins: o3, hooks: q2() })), o3.filter(Boolean).forEach(function(e4) {
        e4(s2().hooks);
      });
      var a3 = h2(s2().hooks);
      s2().getHooks = a3, delete s2().hooks, Object.assign(s2(), p2(a3().useOptions, ie2(e3)));
      var c3 = s2(), d3 = c3.data, v3 = c3.columns, m3 = c3.initialState, y3 = c3.defaultColumn, w3 = c3.getSubRows, b3 = c3.getRowId, E2 = c3.stateReducer, I3 = c3.useControlledState, F3 = h2(E2), G3 = t2.useCallback(function(e4, t3) {
        if (!t3.type)
          throw console.info({ action: t3 }), new Error("Unknown Action \u{1F446}");
        return [].concat(a3().stateReducers, Array.isArray(F3()) ? F3() : [F3()]).reduce(function(n4, o4) {
          return o4(n4, t3, e4, s2()) || n4;
        }, e4);
      }, [a3, F3, s2]), A3 = t2.useReducer(G3, void 0, function() {
        return G3(m3, { type: l2.init });
      }), k3 = A3[0], H3 = A3[1], T3 = p2([].concat(a3().useControlledState, [I3]), k3, { instance: s2() });
      Object.assign(s2(), { state: T3, dispatch: H3 });
      var z3 = t2.useMemo(function() {
        return S2(p2(a3().columns, v3, { instance: s2() }));
      }, [a3, s2, v3].concat(p2(a3().columnsDeps, [], { instance: s2() })));
      s2().columns = z3;
      var W3 = t2.useMemo(function() {
        return p2(a3().allColumns, C(z3), { instance: s2() }).map(x2);
      }, [z3, a3, s2].concat(p2(a3().allColumnsDeps, [], { instance: s2() })));
      s2().allColumns = W3;
      var O3 = t2.useMemo(function() {
        for (var e4 = [], t3 = [], n4 = {}, o4 = [].concat(W3); o4.length; ) {
          var r3 = o4.shift();
          le2({ data: d3, rows: e4, flatRows: t3, rowsById: n4, column: r3, getRowId: b3, getSubRows: w3, accessValueHooks: a3().accessValue, getInstance: s2 });
        }
        return [e4, t3, n4];
      }, [W3, d3, b3, w3, a3, s2]), M3 = O3[0], j2 = O3[1], N3 = O3[2];
      Object.assign(s2(), { rows: M3, initialRows: [].concat(M3), flatRows: j2, rowsById: N3 }), g2(a3().useInstanceAfterData, s2());
      var L2 = t2.useMemo(function() {
        return p2(a3().visibleColumns, W3, { instance: s2() }).map(function(e4) {
          return P2(e4, y3);
        });
      }, [a3, W3, s2, y3].concat(p2(a3().visibleColumnsDeps, [], { instance: s2() })));
      W3 = t2.useMemo(function() {
        var e4 = [].concat(L2);
        return W3.forEach(function(t3) {
          e4.find(function(e5) {
            return e5.id === t3.id;
          }) || e4.push(t3);
        }), e4;
      }, [W3, L2]), s2().allColumns = W3;
      var D3 = t2.useMemo(function() {
        return p2(a3().headerGroups, B2(L2, y3), s2());
      }, [a3, L2, y3, s2].concat(p2(a3().headerGroupsDeps, [], { instance: s2() })));
      s2().headerGroups = D3;
      var V3 = t2.useMemo(function() {
        return D3.length ? D3[0].headers : [];
      }, [D3]);
      s2().headers = V3, s2().flatHeaders = D3.reduce(function(e4, t3) {
        return [].concat(e4, t3.headers);
      }, []), g2(a3().useInstanceBeforeDimensions, s2());
      var _24 = L2.filter(function(e4) {
        return e4.isVisible;
      }).map(function(e4) {
        return e4.id;
      }).sort().join("_");
      L2 = t2.useMemo(function() {
        return L2.filter(function(e4) {
          return e4.isVisible;
        });
      }, [L2, _24]), s2().visibleColumns = L2;
      var X3 = ue2(V3), U3 = X3[0], $3 = X3[1], J2 = X3[2];
      return s2().totalColumnsMinWidth = U3, s2().totalColumnsWidth = $3, s2().totalColumnsMaxWidth = J2, g2(a3().useInstance, s2()), [].concat(s2().flatHeaders, s2().allColumns).forEach(function(e4) {
        e4.render = R2(s2(), e4), e4.getHeaderProps = f2(a3().getHeaderProps, { instance: s2(), column: e4 }), e4.getFooterProps = f2(a3().getFooterProps, { instance: s2(), column: e4 });
      }), s2().headerGroups = t2.useMemo(function() {
        return D3.filter(function(e4, t3) {
          return e4.headers = e4.headers.filter(function(e5) {
            return e5.headers ? function e6(t4) {
              return t4.filter(function(t5) {
                return t5.headers ? e6(t5.headers) : t5.isVisible;
              }).length;
            }(e5.headers) : e5.isVisible;
          }), !!e4.headers.length && (e4.getHeaderGroupProps = f2(a3().getHeaderGroupProps, { instance: s2(), headerGroup: e4, index: t3 }), e4.getFooterGroupProps = f2(a3().getFooterGroupProps, { instance: s2(), headerGroup: e4, index: t3 }), true);
        });
      }, [D3, s2, a3]), s2().footerGroups = [].concat(s2().headerGroups).reverse(), s2().prepareRow = t2.useCallback(function(e4) {
        e4.getRowProps = f2(a3().getRowProps, { instance: s2(), row: e4 }), e4.allCells = W3.map(function(t3) {
          var n4 = e4.values[t3.id], o4 = { column: t3, row: e4, value: n4 };
          return o4.getCellProps = f2(a3().getCellProps, { instance: s2(), cell: o4 }), o4.render = R2(s2(), t3, { row: e4, cell: o4, value: n4 }), o4;
        }), e4.cells = L2.map(function(t3) {
          return e4.allCells.find(function(e5) {
            return e5.column.id === t3.id;
          });
        }), g2(a3().prepareRow, e4, { instance: s2() });
      }, [a3, s2, W3, L2]), s2().getTableProps = f2(a3().getTableProps, { instance: s2() }), s2().getTableBodyProps = f2(a3().getTableBodyProps, { instance: s2() }), g2(a3().useFinalInstance, s2()), s2();
    }, Object.defineProperty(e2, "__esModule", { value: true });
  });
})(reactTable_production_min, reactTable_production_min.exports);
{
  reactTable.exports = reactTable_production_min.exports;
}
const Table = ({
  data: data2 = [],
  columns = [],
  className,
  handleClickRow
}) => {
  const tableData = useMemo(() => data2, [data2]);
  const tableColumns = useMemo(() => columns, [columns]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = reactTable.exports.useTable({
    columns: tableColumns,
    data: tableData
  });
  const defaultHeaderClass = "tw-p-4";
  return /* @__PURE__ */ jsxs("table", __spreadProps(__spreadValues({}, getTableProps()), {
    className: classNames$1("tw-mb-6 tw-w-full", className),
    children: [/* @__PURE__ */ jsx$1("thead", {
      children: headerGroups.map((headerGroup) => {
        return /* @__PURE__ */ createElement("tr", __spreadProps(__spreadValues({}, headerGroup.getHeaderGroupProps()), {
          key: headerGroup.id
        }), headerGroup.headers.map((column2) => {
          const {
            headerClassName: headerClassName2
          } = column2;
          return /* @__PURE__ */ createElement("th", __spreadProps(__spreadValues({}, column2.getHeaderProps()), {
            key: column2.id,
            className: classNames$1(headerClassName2, defaultHeaderClass)
          }), column2.render("Header"));
        }));
      })
    }), /* @__PURE__ */ jsx$1("tbody", __spreadProps(__spreadValues({}, getTableBodyProps()), {
      className: "tw-my-4",
      children: rows.map((row) => {
        prepareRow(row);
        return /* @__PURE__ */ createElement("tr", __spreadProps(__spreadValues({}, row.getRowProps()), {
          key: row.id,
          onClick: () => handleClickRow && handleClickRow(row.id)
        }), row.cells.map((cell) => {
          var _a2;
          const columnClassName2 = (_a2 = cell == null ? void 0 : cell.column) == null ? void 0 : _a2.columnClassName;
          return /* @__PURE__ */ createElement("td", __spreadProps(__spreadValues({}, cell.getCellProps()), {
            key: cell.getCellProps().key,
            className: classNames$1(columnClassName2)
          }), cell.render("Cell"));
        }));
      })
    }))]
  }));
};
var _excluded = ["allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "options", "onChange"];
var compareOption = function compareOption2() {
  var inputValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var option = arguments.length > 1 ? arguments[1] : void 0;
  var accessors = arguments.length > 2 ? arguments[2] : void 0;
  var candidate = String(inputValue).toLowerCase();
  var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
  var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
  return optionValue === candidate || optionLabel === candidate;
};
var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return 'Create "'.concat(inputValue, '"');
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
    return !(!inputValue || selectValue.some(function(option) {
      return compareOption(inputValue, option, accessors);
    }) || selectOptions.some(function(option) {
      return compareOption(inputValue, option, accessors);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};
function useCreatable(_ref3) {
  var _ref$allowCreateWhile = _ref3.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref3.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? "last" : _ref$createOptionPosi, _ref$formatCreateLabe = _ref3.formatCreateLabel, formatCreateLabel2 = _ref$formatCreateLabe === void 0 ? builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref3.isValidNewOption, isValidNewOption2 = _ref$isValidNewOption === void 0 ? builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref3.getNewOptionData, getNewOptionData2 = _ref$getNewOptionData === void 0 ? builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref3.onCreateOption, _ref$options = _ref3.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref3.onChange, restSelectProps = _objectWithoutProperties$1(_ref3, _excluded);
  var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1$1 = _restSelectProps$getO === void 0 ? getOptionValue$1 : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1$1 = _restSelectProps$getO2 === void 0 ? getOptionLabel$1 : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
  var newOption = useMemo(function() {
    return isValidNewOption2(inputValue, cleanValue(value), propsOptions, {
      getOptionValue: getOptionValue$1$1,
      getOptionLabel: getOptionLabel$1$1
    }) ? getNewOptionData2(inputValue, formatCreateLabel2(inputValue)) : void 0;
  }, [formatCreateLabel2, getNewOptionData2, getOptionLabel$1$1, getOptionValue$1$1, inputValue, isValidNewOption2, propsOptions, value]);
  var options2 = useMemo(function() {
    return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === "first" ? [newOption].concat(_toConsumableArray$1(propsOptions)) : [].concat(_toConsumableArray$1(propsOptions), [newOption]) : propsOptions;
  }, [allowCreateWhileLoading, createOptionPosition, isLoading, newOption, propsOptions]);
  var onChange2 = useCallback(function(newValue, actionMeta) {
    if (actionMeta.action !== "select-option") {
      return propsOnChange(newValue, actionMeta);
    }
    var valueArray = Array.isArray(newValue) ? newValue : [newValue];
    if (valueArray[valueArray.length - 1] === newOption) {
      if (onCreateOption)
        onCreateOption(inputValue);
      else {
        var newOptionData = getNewOptionData2(inputValue, inputValue);
        var newActionMeta = {
          action: "create-option",
          name,
          option: newOptionData
        };
        propsOnChange(valueTernary(isMulti, [].concat(_toConsumableArray$1(cleanValue(value)), [newOptionData]), newOptionData), newActionMeta);
      }
      return;
    }
    propsOnChange(newValue, actionMeta);
  }, [getNewOptionData2, inputValue, isMulti, name, newOption, onCreateOption, propsOnChange, value]);
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    options: options2,
    onChange: onChange2
  });
}
var CreatableSelect = /* @__PURE__ */ React__default.forwardRef(function(props, ref) {
  var creatableProps = useStateManager(props);
  var selectProps = useCreatable(creatableProps);
  return /* @__PURE__ */ React__default.createElement(Select$1, _extends$4({
    ref
  }, selectProps));
});
const MultipleTagInput = ({
  options: options2,
  handleChangeOption,
  placeholder,
  isDisabled = false,
  isInvalid = false,
  hasDuplicatedValue = false,
  handleSetInputValue,
  value
}) => {
  const {
    t: t2
  } = useTranslation();
  const [optionData, setOptionData] = useState(options2 || []);
  const [inputValue, setInputValue] = useState("");
  const colorStyle = {
    control: (styles2) => __spreadProps(__spreadValues({}, styles2), {
      backgroundColor: "White",
      padding: "16px",
      boxShadow: "none",
      borderColor: isInvalid ? "#FE4040" : "hsl(0, 0%, 80%)",
      ":hover": {
        backgroundColor: "White",
        borderColor: isInvalid ? "#FE4040" : "hsl(0, 0%, 80%)",
        boxShadow: "none"
      }
    }),
    input: (styles2) => __spreadProps(__spreadValues({}, styles2), {
      fontFamily: "Graphik, sans-serif",
      fontWeight: "400",
      fontSize: "1rem",
      lineHeight: "1.5rem"
    }),
    multiValue: (styles2) => {
      return __spreadProps(__spreadValues({}, styles2), {
        backgroundColor: "#E4E0FF",
        padding: "4px 8px 4px 12px",
        borderRadius: "14px 16px"
      });
    },
    multiValueLabel: (styles2) => __spreadProps(__spreadValues({}, styles2), {
      color: "#6353EA",
      fontFamily: "Graphik, sans-serif",
      fontWeight: "500",
      fontSize: "0.625rem",
      lineHeight: "0.875rem"
    }),
    multiValueRemove: (styles2) => __spreadProps(__spreadValues({}, styles2), {
      color: "#6353EA",
      ":hover": {
        backgroundColor: "#E4E0FF",
        color: "#6353EA"
      }
    })
  };
  const createOption = (label) => ({
    key: label.trim(),
    label: label.trim(),
    value: label.trim()
  });
  const handleChangeInput = (value2) => {
    setInputValue(value2);
    handleSetInputValue(value2);
  };
  const handleChange = (value2) => {
    setOptionData(value2);
    handleChangeOption(value2);
  };
  const handleAddNewItem = (value2) => {
    const isDuplicatedValue = optionData.find(({
      label
    }) => label.toLowerCase() === value2.toLowerCase());
    if (!isDuplicatedValue || hasDuplicatedValue) {
      const newItem = [...optionData, createOption(value2)];
      setOptionData(newItem);
      setInputValue("");
      handleChangeOption(newItem);
    }
  };
  const handleKeyDown = (event) => {
    if (!inputValue)
      return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        handleAddNewItem(inputValue);
        event.preventDefault();
        break;
    }
  };
  useEffect(() => {
    setOptionData(value || []);
  }, [value]);
  return /* @__PURE__ */ jsx$1(CreatableSelect, {
    components: {
      DropdownIndicator: null
    },
    isClearable: false,
    isDisabled,
    isMulti: true,
    menuIsOpen: false,
    inputValue,
    value: optionData,
    onCreateOption: handleAddNewItem,
    onChange: (value2) => handleChange(value2),
    onInputChange: handleChangeInput,
    onKeyDown: handleKeyDown,
    placeholder,
    noOptionsMessage: () => t2("already exist"),
    styles: colorStyle
  });
};
const FormMultipleTagInput = (_D) => {
  var _E = _D, {
    handleChange,
    label,
    info,
    isOptional,
    error: error2 = "",
    value,
    placeholder,
    duplicatedValueMessage = "",
    options: options2
  } = _E, props = __objRest(_E, [
    "handleChange",
    "label",
    "info",
    "isOptional",
    "error",
    "value",
    "placeholder",
    "duplicatedValueMessage",
    "options"
  ]);
  const {
    t: t2
  } = useTranslation();
  const [isDuplicatedValue, setIsDuplicatedValue] = useState(false);
  const handleSetInputValue = (data2) => {
    const isDuplicated = !lodash.exports.isNil(value == null ? void 0 : value.find(({
      value: value2
    }) => value2.toLowerCase() === (data2 == null ? void 0 : data2.toLocaleLowerCase())));
    setIsDuplicatedValue(isDuplicated);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [label && /* @__PURE__ */ jsx$1("div", {
      className: "tw-inline-flex tw-pb-1 tw-w-full",
      children: /* @__PURE__ */ jsxs("div", {
        className: "tw-inline-flex tw-w-full tw-max-w-full tw-truncate",
        children: [/* @__PURE__ */ jsx$1(Typography, {
          className: "tw-pr-1 tw-w-fit tw-truncate",
          variant: "title-9",
          color: error2 ? COLORS.Red : COLORS.Gray[600],
          children: label
        }), info && /* @__PURE__ */ jsx$1(Tooltip, {
          description: /* @__PURE__ */ jsx$1("p", {
            children: info
          }),
          variant: "default",
          position: "right",
          arrow: "left-center",
          children: /* @__PURE__ */ jsx$1(Icon, {
            name: IconName.INFO,
            viewBox: "0 0 32 32",
            size: IconSize.MEDIUM,
            className: "tw-pr-1 tw-fill-Gray-400"
          })
        }), isOptional && /* @__PURE__ */ jsx$1(Typography, {
          className: "tw-pr-1",
          variant: "title-9",
          color: COLORS.Gray[500],
          children: t2("createStore.optional")
        })]
      })
    }), /* @__PURE__ */ jsx$1(MultipleTagInput, __spreadValues({
      options: options2,
      value,
      placeholder,
      handleChangeOption: handleChange,
      handleSetInputValue,
      isInvalid: !lodash.exports.isEmpty(error2) || isDuplicatedValue
    }, props)), (error2 || isDuplicatedValue) && /* @__PURE__ */ jsx$1(Typography, {
      className: "tw-pt-1 tw-pb-2 tw-w-full tw-text-left",
      variant: "body-3",
      color: COLORS.Red,
      children: isDuplicatedValue ? t2(duplicatedValueMessage) : t2(error2)
    })]
  });
};
const AddProductSKUModal = ({
  isOpen,
  handleCloseModal,
  value,
  handleVariantData,
  variationListData,
  allSKUValue,
  productSKUs = []
}) => {
  var _a2;
  const {
    t: t2
  } = useTranslation();
  const initialSKU = {
    name: "",
    value: []
  };
  const [skuData, setSKUdata] = useState(initialSKU);
  const {
    register,
    handleSubmit,
    formState: {
      errors
    },
    setValue,
    getValues,
    clearErrors
  } = useForm({
    reValidateMode: "onChange"
  });
  const allSKUValueHaveInventory = (value == null ? void 0 : value.value.filter((value2) => {
    return productSKUs.find(({
      productType,
      inventory
    }) => {
      var _a3, _b;
      return (((_a3 = productType[0]) == null ? void 0 : _a3.value) === value2 || ((_b = productType[1]) == null ? void 0 : _b.value) === value2) && (inventory || 0) > 0;
    });
  })) || [];
  const submit = () => {
    handleVariantData((value == null ? void 0 : value.nanoid) || "", getValues("name"), getValues("value"));
    setSKUdata(initialSKU);
  };
  const cancelCreateSKUs = () => {
    setSKUdata(initialSKU);
    clearErrors();
    handleCloseModal();
  };
  const handleSetName = (name) => {
    setSKUdata(__spreadProps(__spreadValues({}, skuData), {
      name
    }));
    setValue("name", name);
  };
  const handleSetValue = (value2) => {
    setSKUdata(__spreadProps(__spreadValues({}, skuData), {
      value: value2
    }));
    setValue("value", value2);
  };
  const getErrorsValueText = () => {
    var _a3, _b;
    if (((_a3 = errors == null ? void 0 : errors.value) == null ? void 0 : _a3.type) === "isOverThanLimit")
      return "product.productSKU.error.maximumProductSKU";
    if (((_b = errors == null ? void 0 : errors.value) == null ? void 0 : _b.type) === "isItemValueOverThanLimit")
      return "product.productSKU.error.itemValueOverThanLimit";
    return errors == null ? void 0 : errors.value.message;
  };
  register("name", {
    required: "product.error.required",
    validate: {
      isDuplicatedSKUName: (data2) => {
        const isNotDuplicateWithVariant = variationListData.filter(({
          key
        }) => {
          return key.toLowerCase() === data2.toLowerCase();
        }).length === 0;
        if (value == null ? void 0 : value.key) {
          return isNotDuplicateWithVariant || (value == null ? void 0 : value.key.toLowerCase()) === data2.toLowerCase();
        }
        return isNotDuplicateWithVariant;
      }
    }
  });
  register("value", {
    required: "product.error.required",
    validate: {
      isOverThanLimit: (val) => {
        if (value == null ? void 0 : value.value) {
          const uniqSKUValue = variationListData.filter((data2) => data2.nanoid !== value.nanoid).flatMap((data2) => data2.value);
          return uniqSKUValue.length + val.length < 55;
        }
        return allSKUValue.length + val.length < 55;
      },
      isItemValueOverThanLimit: (value2) => value2.find(({
        key
      }) => key.length > 50) === void 0,
      isRemovedSKUHaveInventory: (value2) => {
        const skuValue = value2 ? value2.map(({
          value: value3
        }) => value3) : {};
        const removedSKUHaveInventory = allSKUValueHaveInventory == null ? void 0 : allSKUValueHaveInventory.filter((data2) => {
          return skuValue.includes(data2);
        });
        if (removedSKUHaveInventory.length < (allSKUValueHaveInventory == null ? void 0 : allSKUValueHaveInventory.length)) {
          return t2("product.productSKU.error.productVariantInventoryNotEmpty", {
            value: allSKUValueHaveInventory.filter((value3) => !removedSKUHaveInventory.includes(value3)).join(", ")
          });
        }
        return void 0;
      }
    }
  });
  useEffect(() => {
    setValue("name", value == null ? void 0 : value.key);
    setValue("value", ((value == null ? void 0 : value.value) || []).map((value2) => ({
      key: value2,
      label: value2,
      value: value2
    })));
    setSKUdata({
      name: (value == null ? void 0 : value.key) || "",
      value: ((value == null ? void 0 : value.value) || []).map((value2) => ({
        key: value2,
        label: value2,
        value: value2
      }))
    });
  }, [value, variationListData, allSKUValue]);
  return /* @__PURE__ */ jsx$1(Modal, {
    size: "medium",
    onClose: cancelCreateSKUs,
    isOpen,
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-box-border tw-overflow-y-scroll tw-pt-2 tw-pb-6 mobile:tw-px-4 mobile:tw-min-w-[200px] tablet:tw-px-6 tablet:tw-min-w-[612px]",
      children: [/* @__PURE__ */ jsx$1(Typography, {
        variant: "title-5",
        children: t2("product.productSKU.addSKUPopup.title")
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-mt-6",
        children: /* @__PURE__ */ jsx$1(FormInput, {
          value: skuData == null ? void 0 : skuData.name,
          maxLength: 25,
          label: t2("product.productSKU.addSKUPopup.skuName.label"),
          placeholder: t2("product.productSKU.addSKUPopup.skuName.placeholder"),
          error: (errors == null ? void 0 : errors.name) && t2(((_a2 = errors == null ? void 0 : errors.name) == null ? void 0 : _a2.type) === "isDuplicatedSKUName" ? "product.productSKU.error.duplicatedSKUName" : errors == null ? void 0 : errors.value.message),
          handleChange: handleSetName
        })
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-mt-6",
        children: /* @__PURE__ */ jsx$1(FormMultipleTagInput, {
          value: skuData == null ? void 0 : skuData.value,
          duplicatedValueMessage: "product.productSKU.error.duplicateSKUValue",
          label: t2("product.productSKU.addSKUPopup.skuValue.label"),
          placeholder: t2("product.productSKU.addSKUPopup.skuValue.placeholder"),
          error: (errors == null ? void 0 : errors.value) && t2(getErrorsValueText()),
          handleChange: handleSetValue
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-grid tw-gap-2 tw-justify-items-end tw-mt-10 mobile:tw-grid-cols-1 tablet:tw-grid-cols-12",
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "mobile:tw-hidden tablet:tw-block tablet:tw-col-span-4"
        }), /* @__PURE__ */ jsx$1(Button, {
          size: "large",
          onClick: cancelCreateSKUs,
          className: "mobile:tw-w-full tablet:tw-col-span-4 tablet:tw-w-fit",
          variant: "text",
          children: t2("product.productSKU.addSKUPopup.cancel")
        }), /* @__PURE__ */ jsx$1(Button, {
          size: "large",
          onClick: handleSubmit(submit),
          className: "mobile:tw-mt-4 mobile:tw-w-full tablet:tw-col-span-4 tablet:tw-mt-0 tablet:tw-w-fit",
          variant: "primary",
          children: t2("product.productSKU.addSKUPopup.add")
        })]
      })]
    })
  });
};
const MiniUploader = ({
  acceptFileTypes,
  maxSize,
  isDisabled,
  onDrop,
  value,
  onRemove
}) => {
  const [previewImage, setPreviewImage] = React__default.useState(value || "");
  const [isOpenErrorModal, setIsOpenErrorModal] = useState(false);
  const handleRemove = () => {
    if (previewImage) {
      if (onRemove) {
        onRemove(previewImage);
      }
      setPreviewImage("");
    }
  };
  const handleDrop = (acceptFiles, fileRejections, event) => {
    if (!isEmpty_1(fileRejections)) {
      setIsOpenErrorModal(true);
    }
    onDrop(acceptFiles[0], fileRejections, event);
    const tmpPreviewImage = acceptFiles[0] ? URL.createObjectURL(acceptFiles[0]) : "";
    setPreviewImage(tmpPreviewImage);
  };
  useEffect(() => {
    if (value)
      setPreviewImage(value);
  }, [value]);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs(Dropzone, {
      className: classNames$1(`tw-w-12 tw-h-12 tw-relative tw-border tw-border-solid tw-border-DarkNudePrimary  tw-bg-cover tw-bg-center tw-rounded`, {
        "tw-bg-Tertiary": !isDisabled,
        "tw-bg-Gray-200": isDisabled
      }),
      isDisabled: isDisabled || !!previewImage,
      maxSize,
      acceptFileTypes,
      onDrop: handleDrop,
      children: [/* @__PURE__ */ jsx$1("div", {
        className: "tw-flex tw-absolute tw-inset-0 tw-z-0 tw-justify-center tw-items-center tw-rounded",
        children: previewImage ? /* @__PURE__ */ jsx$1("img", {
          className: "tw-w-full tw-h-full tw-rounded",
          src: previewImage,
          alt: "preview"
        }) : /* @__PURE__ */ jsx$1(Icon, {
          name: IconName.PLUS,
          className: classNames$1({
            "tw-fill-DarkPrimary": !isDisabled,
            "tw-fill-Gray-400": isDisabled
          })
        })
      }), previewImage && /* @__PURE__ */ jsx$1("div", {
        className: "tw-flex tw-absolute tw-inset-0 tw--top-[1px] tw--left-[1px] tw-z-10 tw-justify-center tw-items-center tw-w-12 tw-h-12 tw-bg-DarkPrimary tw-bg-opacity-90 tw-rounded tw-opacity-0 hover:tw-opacity-100 tw-duration-300",
        onClick: handleRemove,
        children: /* @__PURE__ */ jsx$1(Icon, {
          name: IconName.TRASH,
          size: IconSize.LARGE,
          className: "tw-fill-White"
        })
      })]
    }), /* @__PURE__ */ jsx$1(UploadErrorModal, {
      isOpen: isOpenErrorModal,
      handleClose: () => setIsOpenErrorModal(false)
    })]
  });
};
MiniUploader.displayName = "MiniUploader";
MiniUploader.defaultProps = {
  isDisabled: false,
  maxSize: 2097152,
  acceptFileTypes: ["image/png", "image/jpeg", "image/jpg"]
};
const EditAllProductSKUValueModal = ({
  isOpen,
  handleSubmitValue,
  onClose
}) => {
  var _a2;
  const [t2] = useTranslation();
  const editProductSKUFields = [{
    key: "price",
    label: t2(`product.productSKU.manageSKU.price`),
    value: "price",
    type: "number"
  }, {
    key: "costPrice",
    label: t2(`product.productSKU.manageSKU.costPrice`),
    value: "costPrice",
    type: "number"
  }, {
    key: "weight",
    label: t2(`product.productSKU.manageSKU.weight`),
    value: "weight",
    type: "number"
  }, {
    key: "dimension",
    label: t2(`product.productSKU.manageSKU.dimension`),
    value: "dimension",
    type: "number"
  }];
  const initialFormValue = {
    price: void 0,
    isFree: false,
    costPrice: void 0,
    weight: void 0,
    width: void 0,
    height: void 0,
    length: void 0
  };
  const [selectedType, setSelectedType] = useState((_a2 = editProductSKUFields[0]) == null ? void 0 : _a2.value);
  const [formValue, setFormValue] = useState(initialFormValue);
  const {
    isMobile
  } = useScreenSize();
  const {
    register,
    handleSubmit,
    formState: {
      errors
    },
    setValue,
    unregister
  } = useForm();
  const clearEditModalData = () => {
    var _a3;
    setSelectedType((_a3 = editProductSKUFields[0]) == null ? void 0 : _a3.value);
    setFormValue(initialFormValue);
    unregister();
    onClose();
  };
  const submit = () => {
    const value = selectedType === "dimension" ? [formValue == null ? void 0 : formValue.width, formValue == null ? void 0 : formValue.length, formValue == null ? void 0 : formValue.height] : formValue[selectedType];
    let updatedValue = {
      [selectedType]: value
    };
    if (selectedType === "price") {
      updatedValue = __spreadProps(__spreadValues({}, updatedValue), {
        isFree: (formValue == null ? void 0 : formValue.isFree) || false
      });
    }
    handleSubmitValue(updatedValue);
    clearEditModalData();
  };
  register("price", {
    required: selectedType === "price" && !(formValue == null ? void 0 : formValue.isFree) && "product.error.required",
    validate: (value) => {
      if (value <= 0) {
        return "product.error.pricingLowerThanZero";
      }
      return void 0;
    }
  });
  register("costPrice", {
    required: selectedType === "costPrice" && "product.error.required",
    validate: (value) => {
      if (value <= 0) {
        return "product.error.valueLowerThanZero";
      }
      return void 0;
    }
  });
  register("weight", {
    required: selectedType === "weight" && "product.error.required",
    validate: (value) => {
      if (value <= 0) {
        return "product.error.valueLowerThanZero";
      }
      return void 0;
    }
  });
  register("width", {
    required: selectedType === "dimension" && "product.error.required",
    validate: (value) => {
      if (value <= 0) {
        return "product.error.valueLowerThanZero";
      }
      return void 0;
    }
  });
  register("height", {
    required: selectedType === "dimension" && "product.error.required",
    validate: (value) => {
      if (value <= 0) {
        return "product.error.valueLowerThanZero";
      }
      return void 0;
    }
  });
  register("length", {
    required: selectedType === "dimension" && "product.error.required",
    validate: (value) => {
      if (value <= 0) {
        return "product.error.valueLowerThanZero";
      }
      return void 0;
    }
  });
  const getSelectedField = () => {
    var _a3, _b, _c, _d, _e2;
    switch (selectedType) {
      case "costPrice":
      case "weight":
      case "price": {
        return /* @__PURE__ */ jsxs(Fragment, {
          children: [/* @__PURE__ */ jsx$1(FormInput, {
            type: "number",
            thousandSeparator: true,
            decimal: 2,
            label: t2(`product.productSKU.manageSKU.${selectedType}`),
            error: (_a3 = errors == null ? void 0 : errors[selectedType]) == null ? void 0 : _a3.message,
            disabled: (formValue == null ? void 0 : formValue.isFree) && selectedType === "price",
            handleChange: (value) => {
              setFormValue(__spreadProps(__spreadValues({}, formValue), {
                [selectedType]: value
              }));
              setValue(selectedType, value);
            }
          }), selectedType === "price" && /* @__PURE__ */ jsxs("div", {
            className: "tw-inline-flex  tw-items-center tw-mt-4 ",
            children: [/* @__PURE__ */ jsx$1(Checkbox, {
              checked: formValue == null ? void 0 : formValue.isFree,
              handleChange: () => {
                setFormValue(__spreadProps(__spreadValues({}, formValue), {
                  isFree: !(formValue == null ? void 0 : formValue.isFree)
                }));
              }
            }), /* @__PURE__ */ jsx$1(Typography, {
              className: "tw-pl-1",
              variant: "body-3",
              children: t2("product.pricing.freeProduct")
            })]
          })]
        });
      }
      case "dimension": {
        return /* @__PURE__ */ jsxs(Fragment, {
          children: [/* @__PURE__ */ jsx$1("div", {
            className: "tw-flex tw-w-fit tw-max-w-[70%] tw-truncate mobile:tw-block tablet:tw-hidden",
            children: /* @__PURE__ */ jsx$1(Typography, {
              className: "tw-pr-1 tw-w-fit",
              variant: "title-9",
              color: t2((_b = errors == null ? void 0 : errors.width) == null ? void 0 : _b.message) ? COLORS.Red : COLORS.Gray[600],
              children: t2("product.advanceDetail.dimension")
            })
          }), /* @__PURE__ */ jsxs("div", {
            className: "tw-grid tw-grid-cols-3 tw-gap-2",
            children: [/* @__PURE__ */ jsx$1("div", {
              className: isMobile ? "mobile:tw-pt-4 tablet:tw-pt-6" : "",
              children: /* @__PURE__ */ jsx$1(FormInput, {
                type: "number",
                decimal: 2,
                value: formValue == null ? void 0 : formValue.width,
                min: 0,
                max: 9999,
                label: !isMobile ? t2("product.advanceDetail.dimension") : void 0,
                placeholder: t2("product.productSKU.manageSKU.width"),
                error: t2((_c = errors == null ? void 0 : errors.width) == null ? void 0 : _c.message),
                handleChange: (value) => {
                  setValue("width", value);
                  setFormValue(__spreadProps(__spreadValues({}, formValue), {
                    width: value
                  }));
                }
              })
            }), /* @__PURE__ */ jsx$1("div", {
              className: "mobile:tw-pt-4 tablet:tw-pt-6",
              children: /* @__PURE__ */ jsx$1(FormInput, {
                type: "number",
                value: formValue == null ? void 0 : formValue.length,
                decimal: 2,
                min: 0,
                max: 9999,
                placeholder: t2("product.productSKU.manageSKU.length"),
                error: t2((_d = errors == null ? void 0 : errors.length) == null ? void 0 : _d.message),
                handleChange: (value) => {
                  setValue("length", value);
                  setFormValue(__spreadProps(__spreadValues({}, formValue), {
                    length: value
                  }));
                }
              })
            }), /* @__PURE__ */ jsx$1("div", {
              className: "mobile:tw-pt-4 tablet:tw-pt-6",
              children: /* @__PURE__ */ jsx$1(FormInput, {
                type: "number",
                value: formValue == null ? void 0 : formValue.height,
                decimal: 2,
                min: 0,
                max: 9999,
                error: t2((_e2 = errors == null ? void 0 : errors.height) == null ? void 0 : _e2.message),
                placeholder: t2("product.productSKU.manageSKU.height"),
                handleChange: (value) => {
                  setValue("height", value);
                  setFormValue(__spreadProps(__spreadValues({}, formValue), {
                    height: value
                  }));
                }
              })
            })]
          })]
        });
      }
      default:
        return null;
    }
  };
  return /* @__PURE__ */ jsx$1(Modal, {
    size: "medium",
    onClose,
    isOpen,
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-box-border tw-overflow-y-scroll tw-pt-2 tw-pb-6 mobile:tw-px-4 mobile:tw-min-w-[200px] tablet:tw-px-6 tablet:tw-min-w-[612px]",
      children: [/* @__PURE__ */ jsx$1(Typography, {
        variant: "title-5",
        children: t2("product.productSKU.manageSKU.editAllSKU")
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-mt-6",
        children: /* @__PURE__ */ jsx$1(FormDropdown, {
          options: editProductSKUFields,
          value: editProductSKUFields.find(({
            value
          }) => value === selectedType),
          label: t2("product.productSKU.manageSKU.field"),
          handleChange: (value) => {
            setSelectedType(value);
            setFormValue(initialFormValue);
          }
        })
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-mt-9 tw-w-full",
        children: getSelectedField()
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-grid tw-gap-2 tw-justify-items-end tw-mt-10 mobile:tw-grid-cols-1 tablet:tw-grid-cols-12",
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "mobile:tw-hidden tablet:tw-block tablet:tw-col-span-4"
        }), /* @__PURE__ */ jsx$1(Button, {
          size: "large",
          onClick: clearEditModalData,
          className: "mobile:tw-hidden mobile:tw-w-full tablet:tw-block tablet:tw-col-span-4 tablet:tw-w-fit",
          variant: "text",
          children: t2("product.productSKU.addSKUPopup.cancel")
        }), /* @__PURE__ */ jsx$1(Button, {
          size: "large",
          onClick: handleSubmit(submit),
          className: "mobile:tw-mt-4 mobile:tw-w-full tablet:tw-col-span-4 tablet:tw-mt-0 tablet:tw-w-fit",
          variant: "primary",
          children: t2("product.save")
        }), /* @__PURE__ */ jsx$1(Button, {
          size: "large",
          onClick: clearEditModalData,
          className: "mobile:tw-block mobile:tw-w-full tablet:tw-hidden tablet:tw-col-span-4 tablet:tw-w-fit",
          variant: "text",
          children: t2("product.productSKU.addSKUPopup.cancel")
        })]
      })]
    })
  });
};
const useManageProductSKU = ({
  handleProductSKUValue,
  handleCloseModal,
  productSKUs
}) => {
  const [searchData, setSearchData] = useState("");
  const { isMobile } = useScreenSize();
  const [productSKUValue, setProductSKUValue] = useState([]);
  const [isOpenConfirmCancelModal, setIsOpenConfirmCancelModal] = useState(false);
  const searchValue = (productSKUValue || []).filter(({ productType }) => {
    return !lodash.exports.isNil(productType.find(({ value }) => value.includes(searchData)));
  });
  const productSKUData = isMobile ? searchValue : productSKUValue;
  const {
    register,
    handleSubmit,
    unregister,
    formState: { errors, isValid: isValid2 },
    setValue
  } = useForm();
  const handleSetValue = ({
    productSKUId,
    nanoId,
    field,
    value
  }) => {
    const result = productSKUValue == null ? void 0 : productSKUValue.map((data2) => {
      if (productSKUId && (data2 == null ? void 0 : data2.id) === productSKUId || nanoId && (data2 == null ? void 0 : data2.nanoid) === nanoId) {
        return __spreadProps(__spreadValues({}, data2), {
          [field]: value
        });
      }
      return data2;
    });
    setProductSKUValue(result);
  };
  const handleSetFieldToAllProductSKU = (value) => {
    const result = productSKUValue == null ? void 0 : productSKUValue.map((data2) => {
      return __spreadValues(__spreadValues({}, data2), value);
    });
    setProductSKUValue(result);
  };
  const handleChangeProductSKUImage = (file, index2) => {
    if (file) {
      const value = window.URL.createObjectURL(file);
      const result = productSKUValue.map((data2, i2) => {
        if (index2 === i2) {
          return __spreadProps(__spreadValues({}, data2), {
            image: { src: value, file }
          });
        }
        return data2;
      });
      setProductSKUValue(result);
    }
  };
  const handleRemoveImage = (index2) => {
    const result = productSKUValue.map((data2, i2) => {
      if (index2 === i2) {
        return __spreadProps(__spreadValues({}, data2), {
          image: { src: "" }
        });
      }
      return data2;
    });
    setProductSKUValue(result);
  };
  const productSKUTableData = (productSKUData || []).map(({
    image,
    productCode = "",
    productType = [],
    inventory,
    price,
    selected,
    id: id2,
    nanoid: nanoid2,
    cfCode,
    costPrice,
    weight,
    dimension,
    isFree,
    reserved
  }) => {
    var _a2, _b, _c;
    return {
      image: (image == null ? void 0 : image.src) || "",
      isActive: selected,
      id: id2,
      nanoid: nanoid2,
      productCode,
      skuName: `${(_a2 = productType[0]) == null ? void 0 : _a2.value.trim()}${((_b = productType[1]) == null ? void 0 : _b.value) ? `, ${(_c = productType[1]) == null ? void 0 : _c.value.trim()}` : ""}`.trim() || "",
      inventory,
      price,
      cfCode,
      weight,
      dimension: dimension || [],
      costPrice,
      isFree,
      reserved
    };
  });
  productSKUValue.forEach((data2, i2) => {
    var _a2;
    const dimensionData = (_a2 = data2 == null ? void 0 : data2.dimension) == null ? void 0 : _a2.filter(Boolean);
    register(`productCode.${i2}`, {
      required: !(data2 == null ? void 0 : data2.productCode) && "Error(1)",
      minLength: {
        value: 3,
        message: "Error(2)"
      },
      maxLength: {
        value: 50,
        message: "Error(2)"
      },
      pattern: {
        value: REGEX_PRODUCT_CODE_SUPPORT_CHARACTER,
        message: "Error(2)"
      }
    });
    register(`inventory.${i2}`, {
      required: !(data2 == null ? void 0 : data2.inventory) && "Error(1)",
      validate: (value) => {
        if (value < lodash.exports.get(productSKUValue, `${i2}.reserved`) || 0) {
          return "Error(5)";
        }
        return void 0;
      }
    });
    register(`price.${i2}`, {
      validate: (value) => {
        if (!(data2 == null ? void 0 : data2.isFree) && lodash.exports.isNil(value))
          return "Error(1)";
        if (!(data2 == null ? void 0 : data2.isFree) && value <= 0)
          return "Error(4)";
        return void 0;
      }
    });
    register(`cfCode.${i2}`, {
      required: (data2 == null ? void 0 : data2.cfCode) && "Error(1)",
      minLength: {
        value: 3,
        message: "Error(3)"
      },
      pattern: {
        value: REGEX_CF_CODE_SUPPORT_CHARACTER,
        message: "Error(3)"
      }
    });
    register(`width.${i2}`, {
      required: !lodash.exports.isNil(dimensionData) && !lodash.exports.isEmpty(dimensionData) && "Error(1)",
      validate: (value) => {
        if (value <= 0) {
          return "Error(4)";
        }
        return void 0;
      }
    });
    register(`length.${i2}`, {
      required: !lodash.exports.isNil(dimensionData) && !lodash.exports.isEmpty(dimensionData) && "Error(1)",
      validate: (value) => {
        if (value <= 0) {
          return "Error(4)";
        }
        return void 0;
      }
    });
    register(`height.${i2}`, {
      required: !lodash.exports.isNil(dimensionData) && !lodash.exports.isEmpty(dimensionData) && "Error(1)",
      validate: (value) => {
        if (value <= 0) {
          return "Error(4)";
        }
        return void 0;
      }
    });
  });
  const closeModal = () => {
    setProductSKUValue(productSKUs);
    unregister();
    handleCloseModal();
    setIsOpenConfirmCancelModal(false);
  };
  const handleSaveProductSKU = () => {
    handleProductSKUValue(productSKUValue || []);
    unregister();
    handleCloseModal();
    setIsOpenConfirmCancelModal(false);
  };
  const handleCancelModal = () => {
    if (!lodash.exports.isEqual(productSKUs, productSKUValue)) {
      setIsOpenConfirmCancelModal(true);
      return;
    }
    closeModal();
  };
  useEffect(() => {
    setProductSKUValue(productSKUs);
  }, [productSKUs]);
  useEffect(() => {
    productSKUValue.forEach(({ dimension, productCode, inventory, price, cfCode }, i2) => {
      setValue(`productCode.${i2}`, productCode);
      setValue(`inventory.${i2}`, inventory);
      setValue(`price.${i2}`, price);
      setValue(`cfCode.${i2}`, cfCode);
      setValue(`width.${i2}`, lodash.exports.get(dimension, "0"));
      setValue(`length.${i2}`, lodash.exports.get(dimension, "1"));
      setValue(`height.${i2}`, lodash.exports.get(dimension, "2"));
    });
  }, [productSKUValue, isValid2]);
  return {
    closeModal,
    handleSaveProductSKU,
    productSKUTableData,
    handleSetValue,
    handleSetFieldToAllProductSKU,
    isOpenConfirmCancelModal,
    setIsOpenConfirmCancelModal,
    setSearchData,
    searchData,
    errors,
    setValue,
    handleSubmit,
    productSKUData,
    handleRemoveImage,
    handleChangeProductSKUImage,
    handleCancelModal
  };
};
const ManageProductSKUModal = ({
  isOpen,
  handleProductSKUValue,
  handleCloseModal,
  productSKUs
}) => {
  const {
    t: t2
  } = useTranslation();
  const [isOpenEditAllSKUModal, setIsOpenEditAllSKUModal] = useState(false);
  const {
    closeModal,
    handleSaveProductSKU,
    productSKUTableData,
    handleSetValue,
    isOpenConfirmCancelModal,
    setIsOpenConfirmCancelModal,
    setSearchData,
    errors,
    handleSubmit,
    handleSetFieldToAllProductSKU,
    handleChangeProductSKUImage,
    handleRemoveImage,
    handleCancelModal
  } = useManageProductSKU({
    handleProductSKUValue,
    handleCloseModal,
    productSKUs
  });
  const columnData = [{
    header: t2("product.isActive"),
    accessor: "isActive",
    headerClassName: "tw-rounded-tl tw-bg-Primary-200 tw-p-4 tw-text-left",
    columnClassName: "tw-min-h-[70px] tw-p-4 tw-text-left"
  }, {
    header: t2("product.productSKU.manageSKU.sku"),
    accessor: "skuName",
    headerClassName: "tw-w-fit tw-rounded-tl tw-bg-Primary-200 tw-p-4 tw-text-left",
    columnClassName: "tw-min-h-[70px] tw-min-w-[128px] tw-w-fit tw-p-4 tw-text-left"
  }, {
    header: t2("product.productSKU.manageSKU.image"),
    accessor: "image",
    headerClassName: "tw-bg-Primary-200 tw-text-center tw-p-4",
    columnClassName: "tw-min-h-[70px] tw-min-w-[128px] tw-p-4 tw-flex tw-text-center tw-justify-center"
  }, {
    header: t2("product.productSKU.manageSKU.price"),
    accessor: "price",
    headerClassName: "tw-w-fit tw-rounded-tr tw-bg-Primary-200 tw-p-4",
    columnClassName: "tw-min-h-[70px] tw-min-w-[240px] tw-p-4"
  }, {
    header: t2("product.productSKU.manageSKU.inventory"),
    accessor: "inventory",
    headerClassName: "tw-bg-Primary-200 tw-p-4",
    columnClassName: "tw-min-h-[70px] tw-min-w-[120px] tw-p-4"
  }, {
    header: t2("product.productSKU.manageSKU.skuCode"),
    accessor: "productCode",
    headerClassName: "tw-bg-Primary-200 tw-p-4",
    columnClassName: "tw-min-h-[70px] tw-min-w-[200px] tw-p-4"
  }, {
    header: t2("product.productDetail.cfCode.label"),
    accessor: "cfCode",
    description: t2("product.productSKU.manageSKU.optional"),
    headerClassName: "tw-bg-Primary-200 tw-p-4",
    columnClassName: "tw-min-h-[70px] tw-min-w-[148px] tw-p-4"
  }, {
    header: t2("product.productSKU.manageSKU.costPrice"),
    description: t2("product.productSKU.manageSKU.optional"),
    accessor: "costPrice",
    headerClassName: "tw-bg-Primary-200 tw-p-4",
    columnClassName: "tw-min-h-[70px] tw-min-w-[168px] tw-p-4"
  }, {
    header: t2("product.productSKU.manageSKU.weight"),
    description: t2("product.productSKU.manageSKU.optional"),
    accessor: "weight",
    headerClassName: "tw-bg-Primary-200 tw-p-4",
    columnClassName: "tw-min-h-[70px] tw-min-w-[148px] tw-p-4"
  }, {
    header: t2("product.productSKU.manageSKU.dimension"),
    description: t2("product.productSKU.manageSKU.optional"),
    accessor: "dimension",
    headerClassName: "tw-bg-Primary-200 tw-text-left tw-p-4",
    columnClassName: "tw-min-h-[70px] tw-min-w-[350px] tw-p-4 "
  }];
  const getColumnClassName = (accessorValue) => {
    var _a2;
    return ((_a2 = columnData.find(({
      accessor
    }) => accessor === accessorValue)) == null ? void 0 : _a2.columnClassName) || "";
  };
  const errorList = mappingValidationErrorsList(Object.keys(errors).map((v2) => errors[v2].map((data2) => data2 == null ? void 0 : data2.message)).flatMap((value) => value));
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs(Modal, {
      size: "full",
      className: "mobile:tw-overflow-auto mobile:tw-h-full tablet:tw-overflow-hidden tablet:tw-h-fit",
      isOpen,
      onClose: closeModal,
      children: [/* @__PURE__ */ jsxs("div", {
        className: "tw-inline-flex tw-overflow-y-auto tw-justify-between tw-w-full tablet:tw-px-6",
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "tw-w-fit",
          children: /* @__PURE__ */ jsx$1(Typography, {
            variant: "title-5",
            children: t2("product.productSKU.manageSKU.title")
          })
        }), /* @__PURE__ */ jsx$1(Button, {
          onClick: () => setIsOpenEditAllSKUModal(true),
          variant: "tertiary",
          children: t2("product.productSKU.manageSKU.editAllSKU")
        })]
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-pt-4 mobile:tw-block tablet:tw-hidden",
        children: /* @__PURE__ */ jsx$1(TextField$2, {
          LeftIcon: /* @__PURE__ */ jsx$1(Icon, {
            name: IconName.SEARCH,
            className: "tw-mr-2"
          }),
          className: "tw-w-full tw-border-none",
          placeholder: "Search",
          handleChange: setSearchData || ""
        })
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-flex tw-overflow-scroll tw-mt-4 tw-w-full tw-rounded tw-border tw-border-Primary-200 tablet:tw-overflow-y-scroll tablet:tw-h-full tablet:tw-max-h-[60vh] show-scrollbar",
        children: /* @__PURE__ */ jsxs("table", {
          className: "tw-mb-0",
          children: [/* @__PURE__ */ jsx$1("tr", {
            children: columnData.map(({
              header,
              headerClassName: headerClassName2,
              description
            }) => /* @__PURE__ */ jsxs("td", {
              className: headerClassName2,
              children: [/* @__PURE__ */ jsx$1(Typography, {
                variant: "title-8",
                color: COLORS.Gray[800],
                children: header
              }), description && /* @__PURE__ */ jsx$1(Typography, {
                variant: "body-4",
                color: COLORS.Gray[500],
                children: description
              })]
            }, header))
          }), productSKUTableData.map((data2, i2) => /* @__PURE__ */ jsxs("tr", {
            children: [/* @__PURE__ */ jsx$1("td", {
              valign: "top",
              className: getColumnClassName("isActive"),
              children: /* @__PURE__ */ jsx$1("div", {
                className: "tw-flex tw-items-center tw-h-12",
                children: /* @__PURE__ */ jsx$1(Switch$1, {
                  checked: data2 == null ? void 0 : data2.isActive,
                  handleChange: (value) => handleSetValue({
                    productSKUId: data2 == null ? void 0 : data2.id,
                    nanoId: data2 == null ? void 0 : data2.nanoid,
                    field: "selected",
                    value
                  })
                })
              })
            }), /* @__PURE__ */ jsx$1("td", {
              valign: "top",
              className: getColumnClassName("skuName"),
              children: /* @__PURE__ */ jsx$1("div", {
                className: "tw-flex tw-items-center tw-h-12",
                children: /* @__PURE__ */ jsx$1(Typography, {
                  variant: "body-3",
                  color: COLORS.Gray[600],
                  children: data2 == null ? void 0 : data2.skuName
                })
              })
            }), /* @__PURE__ */ jsx$1("td", {
              valign: "top",
              className: getColumnClassName("image"),
              children: /* @__PURE__ */ jsx$1("div", {
                className: "tw-flex tw-justify-center tw-items-center tw-w-12 tw-h-12 tw-cursor-pointer",
                children: /* @__PURE__ */ jsx$1(MiniUploader, {
                  onDrop: (file) => handleChangeProductSKUImage(file, i2),
                  onRemove: () => handleRemoveImage(i2),
                  value: data2 == null ? void 0 : data2.image
                })
              })
            }), /* @__PURE__ */ jsx$1("td", {
              valign: "top",
              className: getColumnClassName("price"),
              children: /* @__PURE__ */ jsxs("div", {
                className: "tw-inline-flex tw-w-full tw-truncate",
                children: [/* @__PURE__ */ jsx$1(FormInput, {
                  type: "number",
                  min: 0,
                  decimal: 2,
                  disabled: data2 == null ? void 0 : data2.isFree,
                  thousandSeparator: true,
                  error: get_1(errors, `price.${i2}.message`),
                  value: data2 == null ? void 0 : data2.price,
                  handleChange: (value) => handleSetValue({
                    productSKUId: data2 == null ? void 0 : data2.id,
                    nanoId: data2 == null ? void 0 : data2.nanoid,
                    field: "price",
                    value
                  })
                }), /* @__PURE__ */ jsxs("div", {
                  className: "tw-inline-flex tw-items-center tw-py-4 tw-pl-2",
                  children: [/* @__PURE__ */ jsx$1(Checkbox, {
                    checked: data2 == null ? void 0 : data2.isFree,
                    handleChange: () => handleSetValue({
                      productSKUId: data2 == null ? void 0 : data2.id,
                      nanoId: data2 == null ? void 0 : data2.nanoid,
                      field: "isFree",
                      value: !(data2 == null ? void 0 : data2.isFree)
                    })
                  }), /* @__PURE__ */ jsx$1(Typography, {
                    className: "tw-pl-1",
                    variant: "body-3",
                    children: t2("product.pricing.freeProduct")
                  })]
                })]
              })
            }), /* @__PURE__ */ jsx$1("td", {
              valign: "top",
              className: getColumnClassName("inventory"),
              children: /* @__PURE__ */ jsxs("div", {
                className: "tw-w-full tw-truncate",
                children: [/* @__PURE__ */ jsx$1(FormInput, {
                  type: "number",
                  min: 0,
                  decimal: 0,
                  thousandSeparator: true,
                  error: get_1(errors, `inventory.${i2}.message`),
                  value: (data2 == null ? void 0 : data2.inventory) || 0,
                  handleChange: (value) => handleSetValue({
                    productSKUId: data2 == null ? void 0 : data2.id,
                    nanoId: data2 == null ? void 0 : data2.nanoid,
                    field: "inventory",
                    value
                  })
                }), !get_1(errors, `inventory.${i2}.message`) && (data2 == null ? void 0 : data2.reserved) > 0 && /* @__PURE__ */ jsx$1("div", {
                  className: "tw-truncate",
                  children: /* @__PURE__ */ jsx$1(Typography, {
                    className: "tw-pt-1 tw-truncate",
                    color: COLORS.Gray[400],
                    variant: "body-4",
                    children: t2("product.inventory.reserve", {
                      value: data2 == null ? void 0 : data2.reserved
                    })
                  })
                })]
              })
            }), /* @__PURE__ */ jsx$1("td", {
              valign: "top",
              className: getColumnClassName("productCode"),
              children: /* @__PURE__ */ jsx$1("div", {
                className: "tw-w-full tw-truncate",
                children: /* @__PURE__ */ jsx$1(FormInput, {
                  value: data2 == null ? void 0 : data2.productCode,
                  error: get_1(errors, `productCode.${i2}.message`),
                  maxLength: 50,
                  placeholder: t2("product.productSKU.manageSKU.skuCode"),
                  handleChange: (value) => handleSetValue({
                    productSKUId: data2 == null ? void 0 : data2.id,
                    nanoId: data2 == null ? void 0 : data2.nanoid,
                    field: "productCode",
                    value
                  })
                })
              })
            }), /* @__PURE__ */ jsxs("td", {
              valign: "top",
              className: getColumnClassName("cfCode"),
              children: [/* @__PURE__ */ jsx$1(FormInput, {
                value: data2 == null ? void 0 : data2.cfCode,
                maxLength: 50,
                error: get_1(errors, `cfCode.${i2}.message`),
                placeholder: t2("product.productDetail.cfCode.label"),
                handleChange: (value) => handleSetValue({
                  productSKUId: data2 == null ? void 0 : data2.id,
                  nanoId: data2 == null ? void 0 : data2.nanoid,
                  field: "cfCode",
                  value
                })
              }), !get_1(errors, `cfCode.${i2}.message`) && /* @__PURE__ */ jsx$1("div", {
                className: "tw-truncate",
                children: /* @__PURE__ */ jsx$1(Typography, {
                  className: "tw-pt-1 tw-truncate",
                  color: COLORS.Gray[400],
                  variant: "body-4",
                  children: t2("product.productDetail.cfCode.tooltip")
                })
              })]
            }), /* @__PURE__ */ jsx$1("td", {
              valign: "top",
              className: getColumnClassName("costPrice"),
              children: /* @__PURE__ */ jsx$1(FormInput, {
                type: "number",
                decimal: 2,
                min: 0,
                thousandSeparator: true,
                value: data2 == null ? void 0 : data2.costPrice,
                placeholder: t2("product.productSKU.manageSKU.costPrice"),
                handleChange: (value) => handleSetValue({
                  productSKUId: data2 == null ? void 0 : data2.id,
                  nanoId: data2 == null ? void 0 : data2.nanoid,
                  field: "costPrice",
                  value
                })
              })
            }), /* @__PURE__ */ jsx$1("td", {
              valign: "top",
              className: getColumnClassName("weight"),
              children: /* @__PURE__ */ jsx$1(FormInput, {
                type: "number",
                min: 0,
                decimal: 2,
                value: data2 == null ? void 0 : data2.weight,
                placeholder: t2("product.productSKU.manageSKU.weight"),
                handleChange: (value) => handleSetValue({
                  productSKUId: data2 == null ? void 0 : data2.id,
                  nanoId: data2 == null ? void 0 : data2.nanoid,
                  field: "weight",
                  value
                })
              })
            }), /* @__PURE__ */ jsx$1("td", {
              valign: "top",
              className: getColumnClassName("dimension"),
              children: /* @__PURE__ */ jsxs("div", {
                className: "tw-grid tw-grid-cols-3 tw-gap-2",
                children: [/* @__PURE__ */ jsx$1(FormInput, {
                  type: "number",
                  min: 0,
                  decimal: 2,
                  value: (data2 == null ? void 0 : data2.dimension[0]) || void 0,
                  error: get_1(errors, `width.${i2}.message`),
                  placeholder: t2("product.productSKU.manageSKU.width"),
                  handleChange: (value) => handleSetValue({
                    productSKUId: data2 == null ? void 0 : data2.id,
                    nanoId: data2 == null ? void 0 : data2.nanoid,
                    field: "dimension",
                    value: [value, data2 == null ? void 0 : data2.dimension[1], data2 == null ? void 0 : data2.dimension[2]]
                  })
                }), /* @__PURE__ */ jsx$1(FormInput, {
                  type: "number",
                  min: 0,
                  decimal: 2,
                  value: (data2 == null ? void 0 : data2.dimension[1]) || void 0,
                  placeholder: t2("product.productSKU.manageSKU.length"),
                  error: get_1(errors, `length.${i2}.message`),
                  handleChange: (value) => handleSetValue({
                    productSKUId: data2 == null ? void 0 : data2.id,
                    nanoId: data2 == null ? void 0 : data2.nanoid,
                    field: "dimension",
                    value: [data2 == null ? void 0 : data2.dimension[0], value, data2 == null ? void 0 : data2.dimension[2]]
                  })
                }), /* @__PURE__ */ jsx$1(FormInput, {
                  type: "number",
                  min: 0,
                  decimal: 2,
                  value: (data2 == null ? void 0 : data2.dimension[2]) || void 0,
                  error: get_1(errors, `height.${i2}.message`),
                  placeholder: t2("product.productSKU.manageSKU.height"),
                  handleChange: (value) => handleSetValue({
                    productSKUId: data2 == null ? void 0 : data2.id,
                    nanoId: data2 == null ? void 0 : data2.nanoid,
                    field: "dimension",
                    value: [data2 == null ? void 0 : data2.dimension[0], data2 == null ? void 0 : data2.dimension[1], value]
                  })
                })]
              })
            })]
          }, data2 == null ? void 0 : data2.id))]
        })
      }), !isEmpty_1(errorList) && /* @__PURE__ */ jsx$1("div", {
        className: "tw-px-6 tw-pt-4 tw-w-full",
        children: errorList.map((value) => /* @__PURE__ */ jsx$1(Typography, {
          variant: "body-4",
          color: COLORS.Red,
          children: t2(value)
        }, value))
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-justify-end tw-pt-9 tw-w-full",
        children: [/* @__PURE__ */ jsx$1(Button, {
          size: "large",
          variant: "text",
          className: "tw-mr-2 tw-text-Primary-600 mobile:tw-w-full tablet:tw-w-fit",
          onClick: handleCancelModal,
          children: t2("product.productSKU.modal.deleteSKU.cancel")
        }), /* @__PURE__ */ jsx$1(Button, {
          size: "large",
          variant: "primary",
          className: "tw-bg-Primary-600 mobile:tw-w-full tablet:tw-w-fit ",
          onClick: handleSubmit(handleSaveProductSKU),
          children: t2("product.save")
        })]
      })]
    }), /* @__PURE__ */ jsx$1(Modal, {
      size: "small",
      isOpen: isOpenConfirmCancelModal,
      children: /* @__PURE__ */ jsxs("div", {
        className: "tw-h-fit tablet:tw-w-full",
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "tw-flex tw-justify-center tw-w-full",
          children: /* @__PURE__ */ jsx$1(Icon, {
            name: IconName.CLOSE_CIRCLE,
            size: IconSize.LARGE
          })
        }), /* @__PURE__ */ jsx$1(Typography, {
          className: "tw-py-6 tw-text-center",
          variant: "title-2",
          color: COLORS.Gray[800],
          children: t2("product.modal.cancel.title")
        }), /* @__PURE__ */ jsx$1(Typography, {
          className: "tw-pb-10 tw-text-center",
          variant: "body-3",
          color: COLORS.Gray[500],
          children: t2("product.modal.cancel.detail")
        }), /* @__PURE__ */ jsxs("div", {
          className: "tw-grid tw-justify-items-center mobile:tw-grid-cols-1 tablet:tw-grid-cols-2",
          children: [/* @__PURE__ */ jsx$1(Button, {
            size: "large",
            onClick: () => setIsOpenConfirmCancelModal(false),
            className: "mobile:tw-mt-4 mobile:tw-w-full tablet:tw-mt-0 tablet:tw-w-fit",
            variant: "secondary",
            children: t2("product.category.cancel")
          }), /* @__PURE__ */ jsx$1(Button, {
            size: "large",
            onClick: closeModal,
            className: "mobile:tw-mt-4 mobile:tw-w-full tablet:tw-mt-0 tablet:tw-w-fit",
            variant: "primary",
            children: t2("product.modal.cancel.confirm")
          })]
        })]
      })
    }), /* @__PURE__ */ jsx$1(EditAllProductSKUValueModal, {
      onClose: () => setIsOpenEditAllSKUModal(false),
      isOpen: isOpenEditAllSKUModal,
      handleSubmitValue: handleSetFieldToAllProductSKU
    })]
  });
};
const ProductSKUSection = ({
  productSKUs = [],
  isProductWithShadowSKU,
  variationListData = [],
  handleVariantData,
  isOpenAddSKUModal,
  setIsOpenAddSKUModal,
  removeVariantData,
  handleProductSKUValue,
  isClientStore = false
}) => {
  const {
    t: t2
  } = useTranslation();
  const [selectedNanoId, setSelectedNanoId] = useState("");
  const [deletedKey, setDeletedKey] = useState("");
  const [isOpenDeleteSKUModal, setIsOpenDeleteSKUModal] = useState(false);
  const [isOpenManageSKUModal, setIsOpenManageSKUModal] = useState(false);
  const [isErrorOpenAddSKUModal, setIsErrorOpenAddSKUModal] = useState(false);
  const allSKUValue = variationListData.reduce((acc, value) => {
    return [...acc, ...(value == null ? void 0 : value.value) || []];
  }, []);
  const isAllSKUNotHaveInventory = productSKUs.filter(({
    inventory
  }) => inventory > 0).length <= 0;
  const columnData = [{
    Header: t2("product.productSKU.manageSKU.sku"),
    accessor: "skuName",
    headerClassName: "tw-rounded-tl tw-bg-Primary-200  tw-text-left",
    columnClassName: "tw-p-4 tw-text-left",
    Cell: ({
      row
    }) => {
      var _a2;
      return /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-3",
        color: COLORS.Gray[600],
        children: (_a2 = row == null ? void 0 : row.values) == null ? void 0 : _a2.skuName
      });
    }
  }, {
    Header: t2("product.productSKU.manageSKU.image"),
    accessor: "image",
    headerClassName: "tw-bg-Primary-200  tw-text-left",
    columnClassName: "tw-p-4 tw-text-left",
    Cell: ({
      row
    }) => {
      var _a2, _b;
      return ((_a2 = row == null ? void 0 : row.values) == null ? void 0 : _a2.image) ? /* @__PURE__ */ jsx$1("img", {
        alt: "sku-img",
        className: "tw-object-cover tw-w-12 tw-h-12 tw-rounded",
        src: (_b = row == null ? void 0 : row.values) == null ? void 0 : _b.image
      }) : /* @__PURE__ */ jsx$1("div", {
        className: "tw-flex tw-justify-center tw-items-center tw-w-12 tw-h-12 tw-rounded tw-border tw-border-Gray-400",
        children: /* @__PURE__ */ jsx$1(Icon, {
          name: IconName.IMAGE,
          size: IconSize.DEFAULT,
          className: "tw-fill-Gray-400"
        })
      });
    }
  }, {
    Header: t2("product.productSKU.manageSKU.skuCode"),
    accessor: "productCode",
    headerClassName: "tw-bg-Primary-200  tw-text-left",
    columnClassName: "tw-p-4 tw-text-left",
    Cell: ({
      row
    }) => {
      var _a2;
      return /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-3",
        color: COLORS.Gray[600],
        children: (_a2 = row == null ? void 0 : row.values) == null ? void 0 : _a2.productCode
      });
    }
  }, {
    Header: t2("product.productSKU.manageSKU.inventory"),
    accessor: "inventory",
    headerClassName: "tw-bg-Primary-200 tw-text-left",
    columnClassName: "tw-p-4 tw-text-left",
    Cell: ({
      row
    }) => {
      var _a2, _b, _c;
      return /* @__PURE__ */ jsxs("div", {
        className: "tw-inline-flex tw-w-fit",
        children: [/* @__PURE__ */ jsx$1(Typography, {
          variant: "body-3",
          color: COLORS.Gray[600],
          children: (_a2 = row == null ? void 0 : row.values) == null ? void 0 : _a2.inventory
        }), ((_b = row == null ? void 0 : row.original) == null ? void 0 : _b.reserved) > 0 && /* @__PURE__ */ jsxs(Typography, {
          className: "tw-self-center tw-pl-1",
          variant: "body-4",
          color: COLORS.Gray[500],
          children: ["(", t2("product.inventory.reserve", {
            value: (_c = row == null ? void 0 : row.original) == null ? void 0 : _c.reserved
          }), ")"]
        })]
      });
    }
  }, {
    Header: t2("product.productSKU.manageSKU.price"),
    accessor: "price",
    headerClassName: "tw-rounded-tr tw-bg-Primary-200 tw-text-right",
    columnClassName: "tw-p-4 tw-text-right",
    Cell: ({
      row
    }) => {
      var _a2;
      return /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-3",
        color: COLORS.Gray[600],
        children: (_a2 = row == null ? void 0 : row.values) == null ? void 0 : _a2.price
      });
    }
  }];
  const productSKUTableData = productSKUs.map(({
    image,
    productCode = "",
    productType = [],
    inventory = 0,
    price,
    isFree,
    reserved
  }) => {
    var _a2, _b, _c;
    return {
      image: (image == null ? void 0 : image.src) || "",
      productCode,
      skuName: `${(_a2 = productType[0]) == null ? void 0 : _a2.value.trim()}${((_b = productType[1]) == null ? void 0 : _b.value) ? `, ${(_c = productType[1]) == null ? void 0 : _c.value.trim()}` : ""}`.trim() || "",
      inventory,
      price: price && !isFree ? price : "-",
      reserved
    };
  });
  const removeSKU = () => {
    removeVariantData(deletedKey, setIsOpenDeleteSKUModal);
    setIsOpenDeleteSKUModal(false);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs(Card, {
      contentSize: ContentSize.MEDIUM_3,
      className: "tw-p-6 tw-mt-6 tw-bg-White",
      children: [/* @__PURE__ */ jsx$1(Typography, {
        variant: "title-5",
        className: "tw-pb-4",
        children: t2("product.productSKU.title")
      }), productSKUs && !isEmpty_1(productSKUs) && !isProductWithShadowSKU ? /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "tw-w-full tw-border-y tw-border-Gray-200 tw-divide-y tw-divide-Gray-200",
          children: variationListData.map(({
            nanoid: nanoid2,
            key,
            value
          }) => /* @__PURE__ */ jsxs("div", {
            className: "tw-grid tw-grid-cols-12 tw-gap-2 tw-p-4 tw-w-full",
            children: [/* @__PURE__ */ jsx$1("div", {
              className: "tw-flex tw-col-span-3 tw-items-center tw-w-full tw-break-all",
              children: key
            }), /* @__PURE__ */ jsx$1("div", {
              className: "tw-flex tw-col-span-6 tw-items-center tw-w-full tw-break-all",
              children: value.join(", ")
            }), /* @__PURE__ */ jsx$1("div", {
              className: "tw-flex tw-col-span-3 tw-gap-2 tw-justify-end",
              children: !isClientStore && /* @__PURE__ */ jsxs(Fragment, {
                children: [/* @__PURE__ */ jsx$1("div", {
                  className: "tw-p-1 tw-w-fit tw-h-fit tw-bg-Gray-100 tw-rounded tw-cursor-pointer",
                  onClick: () => {
                    setSelectedNanoId(nanoid2);
                    setIsOpenAddSKUModal(true);
                  },
                  children: /* @__PURE__ */ jsx$1(Icon, {
                    name: IconName.EDIT
                  })
                }), /* @__PURE__ */ jsx$1("div", {
                  className: "tw-p-1 tw-w-fit tw-h-fit tw-bg-Gray-100 tw-rounded tw-cursor-pointer",
                  onClick: () => {
                    setDeletedKey(key);
                    setIsOpenDeleteSKUModal(true);
                  },
                  children: /* @__PURE__ */ jsx$1(Icon, {
                    name: IconName.TRASH
                  })
                })]
              })
            })]
          }, key))
        }), variationListData.length < 2 && allSKUValue.length < 25 && !isClientStore && /* @__PURE__ */ jsx$1("div", {
          className: "tw-p-4 tw-mb-4 tw-w-full tw-border-b tw-border-Gray-200",
          children: /* @__PURE__ */ jsxs("div", {
            className: "tw-inline-flex tw-items-center tw-w-fit tw-cursor-pointer",
            onClick: () => {
              if (isAllSKUNotHaveInventory) {
                setIsOpenAddSKUModal(true);
              } else {
                setIsErrorOpenAddSKUModal(true);
              }
            },
            children: [/* @__PURE__ */ jsx$1(Icon, {
              name: IconName.PLUS,
              className: "tw-mr-2 tw-fill-Primary-500",
              size: IconSize.SMALL
            }), /* @__PURE__ */ jsx$1(Typography, {
              color: COLORS.Primary[500],
              variant: "title-9",
              children: t2("product.productSKU.addOption")
            })]
          })
        }), productSKUs && /* @__PURE__ */ jsxs("div", {
          className: "tw-w-full",
          children: [!isClientStore && /* @__PURE__ */ jsx$1("div", {
            className: "tw-flex tw-justify-end tw-pt-4 tw-w-full tw-text-right",
            children: /* @__PURE__ */ jsx$1(Button, {
              className: "mobile:tw-w-full tablet:tw-w-fit",
              variant: "tertiary",
              size: "large",
              onClick: () => setIsOpenManageSKUModal(!isOpenManageSKUModal),
              children: t2("product.productSKU.manageSKU.title")
            })
          }), /* @__PURE__ */ jsx$1("div", {
            className: "tw-flex tw-overflow-x-scroll tw-mt-4 tw-w-full tw-rounded tw-border tw-border-Primary-200",
            children: /* @__PURE__ */ jsx$1(Table, {
              className: "tw-mb-0",
              data: productSKUTableData,
              columns: columnData
            })
          })]
        })]
      }) : /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx$1(Typography, {
          variant: "body-3",
          color: COLORS.Gray[500],
          className: "tw-pb-4",
          children: t2("product.productSKU.noSKUDescription")
        }), !isClientStore && /* @__PURE__ */ jsx$1(Button, {
          variant: "primary",
          className: "mobile:tw-w-full tablet:tw-w-fit",
          onClick: () => setIsOpenAddSKUModal(!isOpenAddSKUModal),
          children: t2("product.productSKU.addSKUButton")
        })]
      })]
    }), /* @__PURE__ */ jsx$1(AddProductSKUModal, {
      allSKUValue,
      productSKUs,
      handleVariantData: (nanoId, name, value) => {
        setSelectedNanoId("");
        handleVariantData(nanoId, name, value);
      },
      variationListData,
      value: variationListData.find(({
        nanoid: nanoid2
      }) => nanoid2 === selectedNanoId),
      handleCloseModal: () => {
        setSelectedNanoId("");
        setIsOpenAddSKUModal(!isOpenAddSKUModal);
      },
      isOpen: isOpenAddSKUModal
    }), /* @__PURE__ */ jsx$1(ManageProductSKUModal, {
      handleCloseModal: () => setIsOpenManageSKUModal(false),
      isOpen: isOpenManageSKUModal,
      handleProductSKUValue,
      productSKUs
    }), /* @__PURE__ */ jsx$1(Modal, {
      size: "small",
      onClose: () => setIsOpenDeleteSKUModal(false),
      isOpen: isOpenDeleteSKUModal,
      children: /* @__PURE__ */ jsxs("div", {
        className: "tw-h-fit mobile:tw-w-full tablet:tw-w-fit",
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "tw-flex tw-justify-center tw-w-full",
          children: /* @__PURE__ */ jsx$1(Icon, {
            name: IconName.TRASH,
            size: IconSize.LARGE
          })
        }), /* @__PURE__ */ jsx$1(Typography, {
          className: "tw-py-6 tw-text-center",
          variant: "title-2",
          color: COLORS.Gray[800],
          children: t2("product.productSKU.modal.deleteSKU.title")
        }), /* @__PURE__ */ jsx$1(Typography, {
          className: "tw-pb-10 tw-text-center",
          variant: "body-3",
          color: COLORS.Gray[500],
          children: t2("product.productSKU.modal.deleteSKU.description")
        }), /* @__PURE__ */ jsxs("div", {
          className: "tw-flex tw-justify-between",
          children: [/* @__PURE__ */ jsx$1(Button, {
            size: "large",
            variant: "text",
            className: "tw-text-Primary-600 mobile:tw-w-full tablet:tw-w-fit",
            onClick: () => setIsOpenDeleteSKUModal(false),
            children: t2("product.productSKU.modal.deleteSKU.cancel")
          }), /* @__PURE__ */ jsx$1(Button, {
            size: "large",
            variant: "primary",
            className: "tw-bg-Primary-600 mobile:tw-w-full tablet:tw-w-fit ",
            onClick: () => removeSKU(),
            children: t2("product.productSKU.modal.deleteSKU.delete")
          })]
        })]
      })
    }), /* @__PURE__ */ jsx$1(Modal, {
      size: "small",
      isOpen: isErrorOpenAddSKUModal,
      onClose: () => setIsErrorOpenAddSKUModal(false),
      children: /* @__PURE__ */ jsxs("div", {
        className: "tw-h-fit tablet:tw-w-full",
        children: [/* @__PURE__ */ jsx$1(Typography, {
          className: "tw-pb-6 tw-text-center",
          variant: "body-3",
          color: COLORS.Gray[500],
          children: t2("product.productSKU.error.inventoryNotEmpty")
        }), /* @__PURE__ */ jsx$1("div", {
          className: "tw-w-full",
          children: /* @__PURE__ */ jsx$1(Button, {
            size: "large",
            variant: "primary",
            className: "tw-w-full",
            onClick: () => setIsErrorOpenAddSKUModal(false),
            children: t2("product.productSKU.modal.cannotDeleteSKU.ok")
          })
        })]
      })
    })]
  });
};
const ProductForm = ({
  projectId,
  isEditMode = false,
  notifySuccess: notifySuccess2,
  notifyFailed,
  closeProductForm,
  selectedProductId,
  refetchProducts,
  refetchGuideline,
  onClickClose,
  isClientStore = false,
  isMasterStore = false
}) => {
  var _a2;
  const {
    t: t2
  } = useTranslation();
  const [isOpenAddSKUModal, setIsOpenAddSKUModal] = useState(false);
  const [isOpenErrorDeleteSKU, setOpenErrorDeleteSKU] = useState(false);
  const {
    handleSubmit,
    submitForm,
    setValue,
    handleDeleteProduct,
    errors,
    image: {
      handleSetCoverImage,
      handleRemoveImage,
      handleChangeImage
    },
    product: {
      isProductWithShadowSKU,
      loadingGetProductData,
      loadingSubmitAddProduct,
      loadingSubmitEditProduct,
      productValue,
      productData,
      setProduct,
      addNewProperty,
      removeProperty,
      setFreeProduct,
      setActiveProduct,
      setPropertyValue,
      variationListData,
      setVariationListData,
      loadingDeleteProduct
    },
    category: {
      categoryData,
      setVariantAndCategory,
      confirmCreateCategoryModal
    },
    ui: {
      isOpenCancelModal,
      isOpenCategoryModal,
      confirmCancelModal,
      setIsOpenCategoryModal,
      isOpenExpandProperty,
      cancelModal,
      setIsOpenCancelModal,
      deleteProductErrorMessage,
      setDeleteProductErrorMessage,
      isOpenDeleteProductModal,
      setIsOpenDeleteProductModal
    }
  } = useProductData({
    projectId,
    isEditMode,
    notifySuccess: notifySuccess2,
    notifyFailed,
    closeProductForm,
    selectedProductId,
    refetchProducts,
    refetchGuideline
  });
  const categoryOption = categoryData.map(({
    id: id2,
    name
  }) => ({
    key: id2,
    label: name,
    value: id2
  }));
  const isNotShowProductSKUSection = isEditMode && isProductWithShadowSKU && ((_a2 = productValue == null ? void 0 : productValue.productSKUs[0]) == null ? void 0 : _a2.reserved) > 0;
  const setProductValue = (field) => (value) => {
    setProduct(__spreadProps(__spreadValues({}, productValue), {
      [field]: value
    }));
  };
  const handleVariantData = (nanoId, name, value) => {
    const newVariations = nanoId ? variationListData.map((data2) => {
      if ((data2 == null ? void 0 : data2.nanoid) === nanoId) {
        return __spreadProps(__spreadValues({}, data2), {
          key: name,
          value: value ? value.map(({
            value: value2
          }) => {
            return value2;
          }) : []
        });
      }
      return data2;
    }) : [...variationListData, {
      nanoid: nanoid(),
      key: name,
      value: value ? value.map(({
        value: value2
      }) => {
        return value2;
      }) : []
    }];
    const productSKUShadowId = "";
    const outputType = void 0;
    setVariationListData(newVariations);
    setProduct(__spreadProps(__spreadValues({}, productValue), {
      inventory: 0,
      productSKUs: constructSKUsData(productValue, productValue == null ? void 0 : productValue.productSKUs, selectedProductId || "", productValue == null ? void 0 : productValue.isActive, productValue == null ? void 0 : productValue.isFreeProduct, newVariations, productSKUShadowId, outputType)
    }));
    setIsOpenAddSKUModal(false);
  };
  const removeVariantData = (key, setIsOpenDeleteSKUModal) => {
    var _a3;
    const selectedData = (_a3 = productValue == null ? void 0 : productValue.productSKUs) == null ? void 0 : _a3.filter((data2) => {
      return data2 == null ? void 0 : data2.productType.find((value) => {
        var _a4;
        return ((_a4 = value == null ? void 0 : value.key) == null ? void 0 : _a4.key) === key;
      });
    });
    const isSKUHasInventoryOverZero = selectedData.filter((value) => (value == null ? void 0 : value.inventory) > 0).length > 0;
    if (isSKUHasInventoryOverZero) {
      setOpenErrorDeleteSKU(true);
      if (setIsOpenDeleteSKUModal) {
        setIsOpenDeleteSKUModal(false);
      }
      return;
    }
    const newVariations = variationListData.filter((data2) => (data2 == null ? void 0 : data2.key) !== key);
    const productSKUShadowId = "";
    const outputType = void 0;
    setVariationListData(newVariations);
    setProductValue("productSKUs")(constructSKUsData(productValue, productValue == null ? void 0 : productValue.productSKUs, selectedProductId || "", productValue == null ? void 0 : productValue.isActive, productValue == null ? void 0 : productValue.isFreeProduct, newVariations, productSKUShadowId, outputType));
    setIsOpenAddSKUModal(false);
  };
  const handleBackToProductList = () => {
    if (typeof onClickClose === "function") {
      onClickClose();
    }
    const isProductDataChanged = getIsProductDataChanged(isProductWithShadowSKU, productData, productValue);
    if (isProductDataChanged) {
      setIsOpenCancelModal(true);
    } else {
      confirmCancelModal();
    }
  };
  useEffect(() => {
    if (isProductWithShadowSKU) {
      setProductValue("inventory")((productValue == null ? void 0 : productValue.inventory) || 0);
      setValue("inventory", (productValue == null ? void 0 : productValue.inventory) || 0);
    }
  }, [isProductWithShadowSKU, productValue == null ? void 0 : productValue.productSKUs]);
  if (loadingGetProductData || loadingSubmitAddProduct || loadingSubmitEditProduct || loadingDeleteProduct)
    return /* @__PURE__ */ jsx$1(LoadingPopup$1, {
      isOpen: true
    });
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "tw-box-border tw-flex tw-justify-between tw-items-center tw-pb-6 tw-w-full mobile:tw-px-4 tablet:tw-px-0",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "tw-inline-flex tw-items-center",
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "tw-p-3 tw-mr-2 tw-w-fit tw-h-fit tw-bg-Primary-200 tw-rounded-full tw-cursor-pointer mobile:tw-hidden tablet:tw-block",
          onClick: handleBackToProductList,
          children: /* @__PURE__ */ jsx$1(Icon, {
            name: IconName.ARROW_LEFT,
            size: IconSize.DEFAULT,
            className: "tw-fill-Primary-600"
          })
        }), /* @__PURE__ */ jsx$1(Typography, {
          variant: "title-2",
          children: t2(isEditMode ? "product.title.edit" : "product.title.add")
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-inline-flex tw-items-center",
        children: [/* @__PURE__ */ jsx$1(Switch$1, {
          checked: productValue == null ? void 0 : productValue.isActive,
          handleChange: setActiveProduct
        }), /* @__PURE__ */ jsx$1(Typography, {
          className: "tw-pl-2",
          variant: "body-3",
          children: t2("product.isActive")
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-w-full tw-h-full",
      children: [/* @__PURE__ */ jsx$1(ProductDetailSection, {
        images: productValue == null ? void 0 : productValue.images,
        handleChangeImage,
        handleSetCoverImage,
        handleRemoveImage,
        setValue,
        setCfCode: setProductValue("cfCode"),
        setProductName: setProductValue("productName"),
        productName: productValue == null ? void 0 : productValue.productName,
        errors,
        categoryOption,
        description: productValue == null ? void 0 : productValue.description,
        category: productValue == null ? void 0 : productValue.category,
        brand: productValue == null ? void 0 : productValue.brand,
        setProductCode: setProductValue("productCode"),
        setVariantAndCategory,
        setIsOpenCategoryModal,
        setBrand: setProductValue("brand"),
        cfCode: productValue == null ? void 0 : productValue.cfCode,
        productCode: productValue == null ? void 0 : productValue.productCode,
        setDescription: setProductValue("description"),
        isEditMode,
        isClientStore,
        isMasterStore
      }), /* @__PURE__ */ jsx$1(ProductPricingSection, {
        isFreeProduct: productValue == null ? void 0 : productValue.isFreeProduct,
        setFreeProduct,
        setValue,
        setPrice: setProductValue("price"),
        setCostPrice: setProductValue("costPrice"),
        costPrice: productValue == null ? void 0 : productValue.costPrice,
        price: productValue == null ? void 0 : productValue.price,
        errors,
        isClientStore
      }), /* @__PURE__ */ jsx$1(ProductAdvanceDetailSection, {
        setProductUnit: setProductValue("productUnit"),
        setWeightPerUnit: setProductValue("weightPerUnit"),
        productUnit: productValue == null ? void 0 : productValue.productUnit,
        weightPerUnit: productValue == null ? void 0 : productValue.weightPerUnit,
        setValue,
        width: productValue == null ? void 0 : productValue.width,
        height: productValue == null ? void 0 : productValue.height,
        length: productValue == null ? void 0 : productValue.length,
        setWidth: setProductValue("width"),
        setLength: setProductValue("length"),
        setHeight: setProductValue("height"),
        errors,
        isClientStore
      }), /* @__PURE__ */ jsx$1(ProductPropertySection, {
        property: productValue == null ? void 0 : productValue.property,
        removeProperty,
        isOpenExpandProperty,
        setPropertyValue,
        addNewProperty,
        errors,
        isClientStore
      }), !isNotShowProductSKUSection && /* @__PURE__ */ jsx$1(ProductSKUSection, {
        isOpenAddSKUModal,
        setIsOpenAddSKUModal,
        variationListData,
        handleVariantData,
        isProductWithShadowSKU,
        productSKUs: productValue == null ? void 0 : productValue.productSKUs,
        handleProductSKUValue: setProductValue("productSKUs"),
        removeVariantData,
        isClientStore
      }), isProductWithShadowSKU && /* @__PURE__ */ jsx$1(InventorySection, {
        inventory: productValue == null ? void 0 : productValue.inventory,
        reserved: lodash.exports.get(productValue == null ? void 0 : productValue.productSKUs, "0.reserved") || 0,
        handleSetInventory: (value) => {
          setProductValue("inventory")(value);
          setValue("inventory", value);
        },
        errors,
        isClientStore
      }), !isClientStore && /* @__PURE__ */ jsx$1(ProductFooter, {
        isOpenDeleteProductModal,
        setIsOpenDeleteProductModal,
        handleDeleteProduct,
        handleBackToProductList,
        handleSubmit,
        submitForm,
        isEditMode
      })]
    }), /* @__PURE__ */ jsx$1(CancelProductModal, {
      handleClose: () => setIsOpenCancelModal(false),
      cancel: cancelModal,
      isOpenCancelModal,
      confirm: confirmCancelModal
    }), /* @__PURE__ */ jsx$1(CreateCategoryModal, {
      handleClose: () => setIsOpenCategoryModal(false),
      cancel: cancelModal,
      isOpenCategoryModal,
      confirm: confirmCreateCategoryModal
    }), /* @__PURE__ */ jsx$1(ErrorSKUModal, {
      isOpen: isOpenErrorDeleteSKU,
      handleCloseModal: () => setOpenErrorDeleteSKU(false)
    }), /* @__PURE__ */ jsx$1(ErrorDeleteProductModal, {
      isOpen: !isEmpty_1(deleteProductErrorMessage),
      description: deleteProductErrorMessage,
      handleCloseModal: () => setDeleteProductErrorMessage("")
    })]
  });
};
const useProductList = (projectId) => {
  var _a2, _b, _c;
  const [pageNo, setPageNo] = useState(1);
  const [filterWord, setFilterWord] = useState("");
  const [selectedFilterCategoryId, setSelectedFilterCategoryId] = useState([]);
  const [limit, setLimit] = useState(10);
  const {
    loading: loadingGetProductList,
    data: productData,
    refetch: refetchProductList
  } = useQuery(PRODUCTS, {
    variables: {
      projectId,
      limit,
      offset: pageNo - 1,
      filter: {
        productName: filterWord,
        productCode: filterWord,
        categoryIds: selectedFilterCategoryId,
        sortBy: "desc"
      }
    },
    fetchPolicy: "network-only"
  });
  const { data: categoryDataResponse, loading: loadingCategoryData } = useQuery(ALL_CATEGORY_WITH_HIGHLIGHT_PRODUCTS, {
    variables: {
      projectId
    }
  });
  const productList = ((_a2 = productData == null ? void 0 : productData.products) == null ? void 0 : _a2.results) || [];
  const categoryResults = ((_b = categoryDataResponse == null ? void 0 : categoryDataResponse.categories) == null ? void 0 : _b.results) || [];
  const categoryData = categoryResults.filter(({ isHomePageCategory }) => !isHomePageCategory);
  const handleSetFilterWord = lodash.exports.debounce((value) => {
    setPageNo(1);
    setFilterWord(value);
  }, 500);
  useEffect(() => {
    void refetchProductList();
  }, [limit, pageNo]);
  return {
    productList,
    total: (_c = productData == null ? void 0 : productData.products) == null ? void 0 : _c.total,
    loadingGetProductList,
    refetchProductList,
    category: categoryData,
    loadingCategoryData,
    pageNo,
    setPageNo,
    filterWord,
    setFilterWord: handleSetFilterWord,
    selectedFilterCategoryId,
    setSelectedFilterCategoryId,
    limit,
    setLimit
  };
};
function isNil(value) {
  return value == null;
}
var isNil_1 = isNil;
const Filter = ({
  options: options2 = [],
  value = [],
  handleSetValue,
  placeholder,
  allItemLabel,
  searchPlaceholder
}) => {
  const {
    t: t2
  } = useTranslation();
  const {
    isMobile
  } = useScreenSize();
  const [isOpenDetail, setIsOpenDetail] = useState(false);
  const [optionValues, setOptionValues] = useState(options2 || []);
  const [searchText, setSearchText] = useState("");
  const searchItems = !lodash.exports.isEmpty(searchText) ? options2.filter(({
    label
  }) => label.includes(searchText)) : options2;
  const isSelectedAllItems = (options2 == null ? void 0 : options2.length) > 0 && (optionValues == null ? void 0 : optionValues.length) === (options2 == null ? void 0 : options2.length);
  const handleClickShowDetail = () => {
    if (isOpenDetail) {
      setSearchText("");
    }
    setIsOpenDetail(!isOpenDetail);
  };
  const handleSelectValue = (opt) => {
    const duplicatedItem = optionValues.find(({
      value: value3
    }) => value3 === (opt == null ? void 0 : opt.value));
    const value2 = duplicatedItem ? optionValues.filter(({
      value: value3
    }) => value3 !== (duplicatedItem == null ? void 0 : duplicatedItem.value)) : [...optionValues, opt];
    setOptionValues(value2);
    if (!isMobile) {
      handleSetValue(value2);
    }
  };
  const handleRemoveValue = (val) => {
    const result = optionValues.filter(({
      value: value2
    }) => value2 !== val);
    setOptionValues(result);
    if (!isMobile) {
      handleSetValue(result);
    }
  };
  const handleSelectAllItem = () => {
    const value2 = isSelectedAllItems ? [] : options2;
    setOptionValues(value2);
    if (!isMobile) {
      handleSetValue(value2);
    }
  };
  const handleClearSelectItem = () => {
    setOptionValues([]);
    if (!isMobile) {
      handleSetValue([]);
    }
  };
  const handleSubmit = () => {
    handleSetValue(optionValues);
    setIsOpenDetail(false);
  };
  const handleClose = () => {
    setIsOpenDetail(false);
    setOptionValues(value);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx$1("div", {
      className: "tw-relative tw-h-full tw-min-h-[48px]",
      children: /* @__PURE__ */ jsxs("div", {
        className: "tw-absolute tw-z-[1000] tw-w-fit tw-h-full",
        children: [/* @__PURE__ */ jsxs(Button, {
          variant: "custom",
          className: "tw-inline-flex tw-items-center tw-p-4 tw-w-full tw-min-w-[40px] tw-h-full tw-max-h-[50px] tw-bg-Gray-200 tw-rounded tw-border tw-border-Gray-400",
          onClick: handleClickShowDetail,
          children: [/* @__PURE__ */ jsx$1(Icon, {
            className: (value == null ? void 0 : value.length) <= 0 && isMobile ? "" : "tw-mr-2",
            name: IconName.FILTER,
            size: IconSize.MEDIUM
          }), /* @__PURE__ */ jsx$1(Typography, {
            className: "mobile:tw-hidden tablet:tw-block",
            variant: "title-8",
            color: COLORS.Gray[800],
            children: t2(placeholder || "Filter")
          }), (value == null ? void 0 : value.length) > 0 && /* @__PURE__ */ jsx$1("div", {
            className: "tw-flex tw-justify-center tw-items-center tw-p-1 tw-w-fit tw-min-w-[20px] tw-h-5 tw-bg-Primary-500 tw-rounded-xl mobile:tw-ml-0 tablet:tw-ml-2",
            children: /* @__PURE__ */ jsx$1(Typography, {
              variant: "title-10",
              color: COLORS.White,
              children: (value == null ? void 0 : value.length) > 99 ? "99+" : value == null ? void 0 : value.length
            })
          })]
        }), isOpenDetail && !isMobile && /* @__PURE__ */ jsxs(Fragment, {
          children: [/* @__PURE__ */ jsx$1("div", {
            className: "tw-fixed tw-top-0 tw-left-0 tw-z-[1000] tw-w-screen tw-h-screen",
            onClick: handleClickShowDetail
          }), /* @__PURE__ */ jsxs("div", {
            className: "tw-block tw-absolute tw-right-0 tw-z-[2000] tw-mt-2 tw-min-w-[400px] tw-max-w-sm tw-bg-White tw-rounded tw-border tw-border-Gray-200",
            children: [/* @__PURE__ */ jsx$1("div", {
              className: "tw-items-center tw-p-4",
              children: /* @__PURE__ */ jsx$1(TextField$2, {
                value: searchText,
                placeholder: t2(searchPlaceholder || "Search"),
                LeftIcon: /* @__PURE__ */ jsx$1(Icon, {
                  name: IconName.SEARCH,
                  size: IconSize.DEFAULT,
                  className: "tw-stroke-Gray-800"
                }),
                RightIcon: !lodash.exports.isEmpty(searchText) && /* @__PURE__ */ jsx$1("div", {
                  className: "tw-flex tw-items-center tw-h-full tw-cursor-pointer",
                  onClick: () => setSearchText(""),
                  children: /* @__PURE__ */ jsx$1(Icon, {
                    name: IconName.CLOSE,
                    size: IconSize.EXTRA_SMALL,
                    className: "tw-stroke-Gray-800"
                  })
                }),
                handleChange: (value2) => setSearchText(value2)
              })
            }), (optionValues == null ? void 0 : optionValues.length) > 0 && /* @__PURE__ */ jsxs("div", {
              className: "tw-grid tw-grid-cols-12 tw-gap-2 tw-items-center tw-px-4 tw-pb-4 tw-w-fit",
              children: [/* @__PURE__ */ jsx$1(Typography, {
                className: "tw-inline-flex tw-col-span-2 tw-w-fit tw-min-w-[60px]",
                variant: "title-11",
                color: COLORS.Primary[500],
                children: t2("product.productList.filter.selected", {
                  value: optionValues == null ? void 0 : optionValues.length
                })
              }), /* @__PURE__ */ jsx$1("div", {
                className: "tw-inline-flex tw-col-span-9 tw-ml-2 tw-w-full tw-h-[35px]",
                children: /* @__PURE__ */ jsx$1("div", {
                  className: "tw-inline-flex tw-overflow-x-scroll tw-overflow-y-hidden tw-w-full show-scrollbar",
                  children: optionValues.map(({
                    label,
                    key,
                    value: value2
                  }) => /* @__PURE__ */ jsxs("div", {
                    className: "tw-inline-flex tw-py-1 tw-px-3 tw-ml-2 tw-w-fit tw-min-w-fit tw-text-Primary-500 tw-align-middle tw-bg-Primary-200 tw-rounded-xl",
                    children: [/* @__PURE__ */ jsxs(Typography, {
                      className: "tw-inline-flex tw-items-center tw-w-fit",
                      variant: "title-11",
                      color: COLORS.Primary[500],
                      children: [label, " "]
                    }), /* @__PURE__ */ jsx$1("span", {
                      className: "tw-flex tw-justify-center tw-items-center tw-w-fit tw-cursor-pointer",
                      onClick: () => handleRemoveValue(value2),
                      children: /* @__PURE__ */ jsx$1(Icon, {
                        className: "tw-ml-2 tw-fill-Primary-500",
                        name: IconName.CLOSE,
                        size: IconSize.EXTRA_SMALL
                      })
                    })]
                  }, key))
                })
              }), /* @__PURE__ */ jsx$1("div", {
                className: "tw-flex tw-col-span-1 tw-justify-center tw-items-center tw-w-fit tw-cursor-pointer",
                onClick: handleClearSelectItem,
                children: /* @__PURE__ */ jsx$1(Icon, {
                  className: "tw-ml-2 tw-fill-Gray-800",
                  name: IconName.CLOSE,
                  size: IconSize.EXTRA_SMALL
                })
              })]
            }), /* @__PURE__ */ jsxs("div", {
              className: "tw-w-full tw-divide-y tw-divide-Gray-200",
              children: [/* @__PURE__ */ jsxs("div", {
                onClick: handleSelectAllItem,
                className: "tw-inline-flex tw-justify-between tw-items-center tw-py-3 tw-px-4 tw-w-full tw-cursor-pointer",
                children: [/* @__PURE__ */ jsxs("div", {
                  className: "tw-inline-flex tw-items-center tw-w-fit",
                  children: [/* @__PURE__ */ jsx$1(Checkbox, {
                    checked: isSelectedAllItems
                  }), /* @__PURE__ */ jsx$1(Typography, {
                    className: "tw-ml-2",
                    variant: "body-3",
                    children: t2(allItemLabel || "All item")
                  })]
                }), /* @__PURE__ */ jsx$1(Typography, {
                  variant: "body-3",
                  children: (options2 == null ? void 0 : options2.length) || 0
                })]
              }), /* @__PURE__ */ jsx$1("div", {
                className: "tw-overflow-y-auto tw-w-full tablet:tw-max-h-[300px]",
                children: searchItems.map((value2) => /* @__PURE__ */ jsx$1("div", {
                  onClick: () => handleSelectValue(value2),
                  className: "tw-inline-flex tw-justify-between tw-py-3 tw-px-4 tw-w-full tw-cursor-pointer",
                  children: /* @__PURE__ */ jsxs("div", {
                    className: "tw-inline-flex tw-items-center tw-w-fit",
                    children: [/* @__PURE__ */ jsx$1(Checkbox, {
                      checked: !isNil_1(optionValues.find((option) => (option == null ? void 0 : option.value) === (value2 == null ? void 0 : value2.value)))
                    }), /* @__PURE__ */ jsx$1(Typography, {
                      className: "tw-ml-2",
                      variant: "body-3",
                      children: value2 == null ? void 0 : value2.label
                    })]
                  })
                }, value2 == null ? void 0 : value2.key))
              })]
            })]
          })]
        })]
      })
    }), /* @__PURE__ */ jsxs(Modal, {
      className: "tw-px-0 mobile:tw-overflow-auto mobile:tw-h-full tablet:tw-overflow-hidden tablet:tw-h-fit",
      size: "full",
      isOpen: isMobile && isOpenDetail,
      children: [/* @__PURE__ */ jsxs("div", {
        className: "tw-box-border tw-inline-flex tw-items-center tw-p-4 tw-w-full",
        children: [/* @__PURE__ */ jsx$1("div", {
          onClick: handleClose,
          className: "tw-p-2 tw-mr-2 tw-bg-Gray-200 tw-rounded-full tw-cursor-pointer",
          children: /* @__PURE__ */ jsx$1(Icon, {
            name: IconName.BACK,
            size: IconSize.DEFAULT,
            className: "tw-stroke-Gray-800"
          })
        }), /* @__PURE__ */ jsx$1("div", {
          className: "tw-w-full",
          children: /* @__PURE__ */ jsx$1(TextField$2, {
            value: searchText,
            RightIcon: !lodash.exports.isEmpty(searchText) && /* @__PURE__ */ jsx$1("div", {
              className: "tw-flex tw-items-center tw-h-full tw-cursor-pointer",
              onClick: () => setSearchText(""),
              children: /* @__PURE__ */ jsx$1(Icon, {
                name: IconName.CLOSE,
                size: IconSize.EXTRA_SMALL,
                className: "tw-stroke-Gray-800"
              })
            }),
            handleChange: (value2) => setSearchText(value2)
          })
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-mb-20 tw-w-full tw-divide-y tw-divide-Gray-200",
        children: [/* @__PURE__ */ jsxs("div", {
          onClick: handleSelectAllItem,
          className: "tw-inline-flex tw-justify-between tw-items-center tw-py-3 tw-px-4 tw-w-full tw-cursor-pointer",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "tw-inline-flex tw-items-center tw-w-fit",
            children: [/* @__PURE__ */ jsx$1(Checkbox, {
              checked: isSelectedAllItems
            }), /* @__PURE__ */ jsx$1(Typography, {
              className: "tw-ml-2",
              variant: "body-3",
              children: t2("All item")
            })]
          }), /* @__PURE__ */ jsx$1(Typography, {
            variant: "body-3",
            children: (options2 == null ? void 0 : options2.length) || 0
          })]
        }), /* @__PURE__ */ jsx$1("div", {
          className: "tw-box-border tw-overflow-y-auto tw-w-full tablet:tw-max-h-[300px]",
          children: searchItems.map((value2) => /* @__PURE__ */ jsx$1("div", {
            onClick: () => handleSelectValue(value2),
            className: "tw-inline-flex tw-justify-between tw-py-3 tw-px-4 tw-w-full tw-cursor-pointer",
            children: /* @__PURE__ */ jsxs("div", {
              className: "tw-inline-flex tw-items-center tw-w-fit",
              children: [/* @__PURE__ */ jsx$1(Checkbox, {
                checked: !isNil_1(optionValues.find((option) => (option == null ? void 0 : option.value) === (value2 == null ? void 0 : value2.value)))
              }), /* @__PURE__ */ jsx$1(Typography, {
                className: "tw-ml-2",
                variant: "body-3",
                children: value2 == null ? void 0 : value2.label
              })]
            })
          }, value2 == null ? void 0 : value2.key))
        }), /* @__PURE__ */ jsxs("div", {
          className: "tw-inline-flex tw-fixed tw-bottom-0 tw-justify-between tw-py-6 tw-px-4 tw-w-full tw-bg-White",
          children: [/* @__PURE__ */ jsx$1(Button, {
            variant: "text",
            onClick: () => handleClearSelectItem(),
            children: t2("product.productList.clear")
          }), /* @__PURE__ */ jsx$1(Button, {
            variant: "primary",
            onClick: () => handleSubmit(),
            children: t2("gettingStarted.done")
          })]
        })]
      })]
    })]
  });
};
const Pagination = ({
  total,
  pageNo,
  limit,
  pageOptions = [],
  limitOptions = [],
  handlePageNoChange,
  handleLimitChange,
  className = ""
}) => {
  const {
    t: t2
  } = useTranslation();
  const [page, setPage] = useState(1);
  const [limitData, setLimitData] = useState(0);
  const range = `${limitData * page - limitData + 1} - ${total <= limitData || page === pageOptions.length ? total : limitData * page}`;
  const firstPage = pageOptions[0];
  const lastPage = pageOptions[pageOptions.length - 1];
  useEffect(() => {
    if (pageNo && page !== pageNo) {
      setPage(pageNo);
    }
    if (limit && limit !== limitData) {
      setLimitData(limit);
    }
  }, [pageNo, limit, setLimitData, setPage, page, limitData]);
  return /* @__PURE__ */ jsxs("div", {
    className: `${className} mobile:tw-inline-flex tablet:tw-inline-flex tw-justify-between tw-position-absolute tw-px-6 tw-bottom-0 tw-w-full`,
    children: [/* @__PURE__ */ jsx$1(Typography, {
      className: "tw-w-fit mobile:tw-hidden tablet:tw-block",
      variant: "body-3",
      color: COLORS.Gray[600],
      children: t2("product.productList.pagination.total", {
        range,
        total
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-inline-flex tw-justify-between tw-items-baseline mobile:tw-flex-row-reverse mobile:tw-w-full tablet:tw-flex-row tablet:tw-w-fit",
      children: [/* @__PURE__ */ jsxs(Typography, {
        className: "tw-inline-flex tw-items-center",
        variant: "body-3",
        color: COLORS.Gray[600],
        children: [t2("product.productList.pagination.page"), ":", /* @__PURE__ */ jsx$1("div", {
          className: `${page === firstPage ? "tw-bg-Gray-200 tw-border-Gray-400 hover:tw-bg-Gray-200 hover:tw-border-Gray-400" : "tw-border-Gray-400 hover:tw-bg-Primary-200  hover:tw-border-Primary-500"} tw-flex tw-items-center tw-p-1 tw-ml-3 tw-min-h-[26px] tw-bg-White tw-rounded tw-border  tw-cursor-pointer`,
          onClick: () => {
            if (page > 1) {
              setPage(page - 1);
              if (handlePageNoChange)
                handlePageNoChange(page - 1);
            }
          },
          children: /* @__PURE__ */ jsx$1(Icon, {
            name: IconName.BACK,
            size: IconSize.EXTRA_SMALL
          })
        }), /* @__PURE__ */ jsx$1("select", {
          value: page,
          className: "tw-p-1 tw-mx-1 tw-bg-White tw-rounded tw-border tw-border-Gray-400",
          onChange: (e2) => {
            if (+e2.target.value !== pageNo) {
              setPage(+e2.target.value);
              if (handlePageNoChange)
                handlePageNoChange(+e2.target.value);
            }
          },
          children: pageOptions.map((value) => /* @__PURE__ */ jsx$1("option", {
            selected: value === pageNo,
            value,
            children: value
          }, value))
        }), /* @__PURE__ */ jsx$1("div", {
          className: `${page >= lastPage ? "tw-bg-Gray-200 tw-border-Gray-400 hover:tw-bg-Gray-200 hover:tw-border-Gray-400" : "tw-border-Gray-400 hover:tw-bg-Primary-200  hover:tw-border-Primary-500"} tw-flex tw-items-center tw-p-1 tw-mr-3 tw-min-h-[26px] tw-bg-White tw-rounded tw-border  tw-cursor-pointer`,
          onClick: () => {
            if (page < Math.max(...pageOptions || [])) {
              setPage(page + 1);
              if (handlePageNoChange)
                handlePageNoChange(page + 1 || 1);
            }
          },
          children: /* @__PURE__ */ jsx$1(Icon, {
            name: IconName.NEXT,
            size: IconSize.SMALL
          })
        })]
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-items-center",
        children: /* @__PURE__ */ jsxs(Typography, {
          className: "tw-items-center",
          variant: "body-3",
          color: COLORS.Gray[600],
          children: [t2("product.productList.pagination.show"), ":", " ", /* @__PURE__ */ jsx$1("select", {
            value: limitData,
            className: "tw-items-center tw-p-1 tw-mx-3 tw-bg-White tw-rounded tw-border tw-border-Gray-400",
            onChange: (e2) => {
              if (+e2.target.value !== pageNo) {
                setLimitData(+e2.target.value);
                if (handleLimitChange)
                  handleLimitChange(+e2.target.value);
              }
            },
            children: limitOptions.map((value) => /* @__PURE__ */ jsx$1("option", {
              value,
              children: value
            }, value))
          }), " ", t2("product.productList.pagination.perPage")]
        })
      })]
    })]
  });
};
const MobileProductTable = ({
  showDetailedId,
  isClientStore = false,
  tableData,
  setShowDetailedId,
  handleSelectProduct
}) => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx$1("div", {
      className: "tw-box-border tw-py-2 tw-px-4 tw-w-full tw-text-left tw-bg-Primary-200",
      children: /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-3",
        color: COLORS.Gray[800],
        children: t2("product.productDetail.name")
      })
    }), tableData.map(({
      id: id2,
      type,
      image,
      isActive,
      name,
      category,
      price,
      variantList
    }) => {
      const isSelected = showDetailedId === id2;
      return /* @__PURE__ */ jsxs("div", {
        className: `tw-px-4 tw-py-2 tw-cursor-pointer ${isSelected ? "tw-bg-Primary-100" : ""}`,
        children: [/* @__PURE__ */ jsxs("div", {
          onClick: () => setShowDetailedId(isSelected ? void 0 : id2),
          className: "tw-grid tw-grid-cols-12 tw-gap-x-2 tw-justify-center tw-items-center",
          children: [/* @__PURE__ */ jsx$1("div", {
            className: "tw-box-border tw-flex tw-col-span-2 tw-justify-center",
            children: image ? /* @__PURE__ */ jsx$1("img", {
              className: "tw-w-10 tw-h-10 tw-rounded",
              src: image,
              alt: name
            }) : /* @__PURE__ */ jsx$1("div", {
              className: "tw-flex tw-justify-center tw-items-center tw-w-10 tw-h-10 tw-rounded tw-border tw-border-Gray-400",
              children: /* @__PURE__ */ jsx$1(Icon, {
                name: IconName.IMAGE,
                size: IconSize.DEFAULT,
                className: "tw-fill-Gray-400"
              })
            })
          }), /* @__PURE__ */ jsx$1("div", {
            className: "tw-col-span-1 tw-justify-center",
            children: isActive ? /* @__PURE__ */ jsx$1("div", {
              className: "tw-w-[6px] tw-h-[6px] tw-bg-Green-500 tw-rounded"
            }) : /* @__PURE__ */ jsx$1("div", {
              className: "tw-w-[6px] tw-h-[6px] tw-bg-Gray-300 tw-rounded"
            })
          }), /* @__PURE__ */ jsxs("div", {
            className: "tw-inline-flex tw-col-span-7 tw-items-center tw-truncate",
            children: [type === ProductType.DIGITAL_CONTENT && /* @__PURE__ */ jsx$1("div", {
              className: "tw-py-1 tw-px-2 tw-mr-2 tw-w-fit tw-h-fit tw-bg-Green-500 tw-rounded-xl",
              children: /* @__PURE__ */ jsx$1(Typography, {
                variant: "body-4",
                color: COLORS.White,
                children: t2("Digital")
              })
            }), /* @__PURE__ */ jsx$1(Typography, {
              className: "tw-truncate",
              variant: "title-9",
              color: COLORS.Gray[800],
              children: name
            })]
          }), /* @__PURE__ */ jsx$1("div", {
            className: "tw-flex tw-col-span-2 tw-justify-center",
            children: /* @__PURE__ */ jsx$1(Icon, {
              name: isSelected ? IconName.UP : IconName.DOWN,
              size: IconSize.MEDIUM
            })
          })]
        }), isSelected && /* @__PURE__ */ jsxs("div", {
          className: "tw-w-full tw-h-fit",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "tw-flex tw-justify-between tw-pt-2 tw-w-full",
            children: [/* @__PURE__ */ jsx$1(Typography, {
              variant: "title-9",
              color: COLORS.Gray[800],
              children: t2("product.productList.category")
            }), /* @__PURE__ */ jsx$1(Typography, {
              variant: "body-3",
              color: COLORS.Gray[800],
              children: category
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: "tw-flex tw-justify-between tw-pt-2 tw-w-full",
            children: [/* @__PURE__ */ jsx$1(Typography, {
              variant: "title-9",
              color: COLORS.Gray[800],
              children: t2("product.productList.price")
            }), /* @__PURE__ */ jsx$1(Typography, {
              variant: "body-3",
              color: COLORS.Gray[800],
              children: price
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: "tw-flex tw-justify-between tw-pt-2 tw-w-full",
            children: [/* @__PURE__ */ jsx$1(Typography, {
              variant: "title-9",
              color: COLORS.Gray[800],
              children: t2("product.productList.variantList")
            }), /* @__PURE__ */ jsx$1("div", {
              className: "tw-block",
              children: variantList.length > 0 ? variantList.map(({
                key,
                value
              }) => /* @__PURE__ */ jsxs(Typography, {
                variant: "title-9",
                color: COLORS.Gray[800],
                children: [key, ":", " ", /* @__PURE__ */ jsx$1("span", {
                  className: "tw-font-normal",
                  children: value.join(", ").trim()
                })]
              }, key)) : "-"
            })]
          }), !isClientStore && /* @__PURE__ */ jsx$1("div", {
            className: "tw-flex tw-justify-end tw-mt-5 tw-mb-1 tw-w-full",
            children: /* @__PURE__ */ jsxs(Button, {
              className: "tw-inline-flex tw-justify-center tw-border-Primary-300",
              variant: "tertiary",
              size: "small",
              onClick: () => handleSelectProduct(type, id2),
              children: [/* @__PURE__ */ jsx$1(Icon, {
                className: "tw-mr-1 tw-fill-Primary-600",
                name: IconName.EDIT,
                size: IconSize.MEDIUM
              }), t2("product.productList.edit")]
            })
          })]
        })]
      }, name);
    })]
  });
};
const ProductNotFound = () => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx$1("div", {
    className: "tw-flex tw-justify-center tw-items-center tw-py-20 tw-w-full tw-h-full",
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-block tw-text-center",
      children: [/* @__PURE__ */ jsx$1("img", {
        src: PRODUCT_NOT_FOUND_GRAPHIC,
        alt: "product-not-found"
      }), /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-pt-6",
        variant: "title-6",
        color: COLORS.Gray[800],
        children: t2("product.productList.productNotFound.title")
      }), /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-pt-2",
        variant: "title-9",
        color: COLORS.Gray[800],
        children: t2("product.productList.productNotFound.description")
      })]
    })
  });
};
const getProductPriceRangeText = (productSKUs) => {
  const productSKUPrice = productSKUs.map(({ price }) => price);
  const min2 = Math.min(...productSKUPrice);
  const max2 = Math.max(...productSKUPrice);
  return min2 === max2 ? min2 : `${min2} - ${max2}`;
};
const ProductTable = ({
  products,
  total,
  pageNo,
  setPageNo,
  limit,
  setLimit,
  setFilterWord,
  handleSelectProduct,
  selectedFilterCategoryId,
  setSelectedFilterCategoryId,
  filterWord,
  isLoadingFetchData,
  category,
  isClientStore = false
}) => {
  const {
    t: t2
  } = useTranslation();
  const {
    isMobile
  } = useScreenSize();
  const [showDetailedId, setShowDetailedId] = useState();
  const pageOptions = Array.from({
    length: Math.ceil(total / limit)
  }, (v2, i2) => i2 + 1);
  const limitOptions = [10, 25, 50];
  const scrollToTable = () => {
    const element = document.getElementById("table");
    if (element) {
      element.scrollIntoView();
    }
  };
  const isShowPagination = !filterWord && products.length > 0;
  const categoryOptions = category.map(({
    id: id2,
    name
  }) => ({
    key: id2,
    value: id2,
    label: name
  }));
  const categoryValue = categoryOptions.filter(({
    value
  }) => selectedFilterCategoryId == null ? void 0 : selectedFilterCategoryId.includes(value));
  const handlePageNoChange = (value) => {
    setPageNo(value);
    scrollToTable();
  };
  const handleLimitChange = (value) => {
    setLimit(value);
    handlePageNoChange(1);
  };
  const columnData = [{
    Header: "",
    accessor: "image",
    headerClassName: "tw-bg-Primary-200 tw-min-w-[80px]  tw-text-left",
    columnClassName: "tw-p-4 tw-min-w-[80px] tw-justify-center tw-text-left",
    Cell: ({
      row
    }) => {
      var _a2, _b;
      return ((_a2 = row == null ? void 0 : row.values) == null ? void 0 : _a2.image) ? /* @__PURE__ */ jsx$1("img", {
        alt: "sku-img",
        className: "tw-object-cover tw-w-12 tw-h-12 tw-rounded",
        src: (_b = row == null ? void 0 : row.values) == null ? void 0 : _b.image
      }) : /* @__PURE__ */ jsx$1("div", {
        className: "tw-flex tw-justify-center tw-items-center tw-w-12 tw-h-12 tw-rounded tw-border tw-border-Gray-400",
        children: /* @__PURE__ */ jsx$1(Icon, {
          name: IconName.IMAGE,
          size: IconSize.DEFAULT,
          className: "tw-fill-Gray-400"
        })
      });
    }
  }, {
    Header: t2("product.productList.status"),
    accessor: "isActive",
    headerClassName: "tw-rounded-tl tw-bg-Primary-200  tw-text-left",
    columnClassName: "tw-p-4 tw-min-w-[140px] tw-text-left",
    Cell: ({
      row
    }) => {
      var _a2;
      return /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-inline-flex tw-items-center",
        variant: "body-3",
        color: COLORS.Gray[800],
        children: ((_a2 = row == null ? void 0 : row.values) == null ? void 0 : _a2.isActive) ? /* @__PURE__ */ jsxs(Fragment, {
          children: [/* @__PURE__ */ jsx$1("div", {
            className: "tw-mr-2 tw-w-[6px] tw-h-[6px] tw-bg-Green-500 tw-rounded"
          }), /* @__PURE__ */ jsx$1(Typography, {
            variant: "body-3",
            color: COLORS.Gray[800],
            children: t2("product.isActive")
          })]
        }) : /* @__PURE__ */ jsxs(Fragment, {
          children: [/* @__PURE__ */ jsx$1("div", {
            className: "tw-mr-2 tw-w-[6px] tw-h-[6px] tw-bg-Gray-300 tw-rounded"
          }), /* @__PURE__ */ jsx$1(Typography, {
            variant: "body-3",
            color: COLORS.Gray[800],
            children: t2("product.isInactive")
          })]
        })
      });
    }
  }, {
    Header: t2("product.productDetail.name"),
    accessor: "name",
    headerClassName: "tw-rounded-tl tw-bg-Primary-200  tw-text-left",
    columnClassName: "tw-p-4 tw-min-w-[300px] tw-text-left",
    Cell: ({
      row
    }) => {
      var _a2, _b;
      return /* @__PURE__ */ jsxs("div", {
        className: "tw-inline-flex tw-items-center tw-cursor-pointer",
        onClick: () => {
          var _a3, _b2;
          return handleSelectProduct((_a3 = row == null ? void 0 : row.original) == null ? void 0 : _a3.type, (_b2 = row == null ? void 0 : row.original) == null ? void 0 : _b2.id);
        },
        children: [((_a2 = row == null ? void 0 : row.original) == null ? void 0 : _a2.type) === ProductType.DIGITAL_CONTENT && /* @__PURE__ */ jsx$1("div", {
          className: "tw-py-1 tw-px-2 tw-mr-2 tw-w-fit tw-h-fit tw-bg-Green-500 tw-rounded-xl",
          children: /* @__PURE__ */ jsx$1(Typography, {
            variant: "body-4",
            color: COLORS.White,
            children: t2("Digital")
          })
        }), /* @__PURE__ */ jsx$1(Typography, {
          className: "tw-inline-flex tw-overflow-hidden tw-max-w-[260px]",
          variant: "title-9",
          color: COLORS.Primary[600],
          children: /* @__PURE__ */ jsx$1("p", {
            className: "tw-truncate",
            children: (_b = row == null ? void 0 : row.values) == null ? void 0 : _b.name
          })
        }), !isClientStore && /* @__PURE__ */ jsx$1(Icon, {
          className: "tw-ml-1 tw-fill-Primary-600",
          name: IconName.EDIT,
          size: IconSize.DEFAULT
        })]
      });
    }
  }, {
    Header: t2("product.productList.category"),
    accessor: "category",
    headerClassName: "tw-rounded-tl tw-bg-Primary-200  tw-text-left",
    columnClassName: "tw-p-4 tw-min-w-[200px] tw-text-left",
    Cell: ({
      row
    }) => {
      var _a2;
      return /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-3",
        color: COLORS.Gray[800],
        children: (_a2 = row == null ? void 0 : row.values) == null ? void 0 : _a2.category
      });
    }
  }, {
    Header: t2("product.productList.price"),
    accessor: "price",
    headerClassName: "tw-rounded-tl tw-bg-Primary-200  tw-text-left",
    columnClassName: "tw-p-4 tw-min-w-[200px] tw-text-left",
    Cell: ({
      row
    }) => {
      var _a2;
      return /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-3",
        color: COLORS.Gray[800],
        children: (_a2 = row == null ? void 0 : row.values) == null ? void 0 : _a2.price
      });
    }
  }, {
    Header: t2("product.productList.variantList"),
    accessor: "variantList",
    headerClassName: "tw-rounded-tl tw-bg-Primary-200  tw-text-left",
    columnClassName: "tw-p-4 tw-min-w-[200px] tw-text-left",
    Cell: ({
      row
    }) => {
      var _a2, _b;
      return ((_a2 = row == null ? void 0 : row.values) == null ? void 0 : _a2.variantList.length) > 0 ? (_b = row == null ? void 0 : row.values) == null ? void 0 : _b.variantList.map(({
        key,
        value
      }) => /* @__PURE__ */ jsxs(Typography, {
        variant: "title-9",
        color: COLORS.Gray[800],
        children: [key, ":", " ", /* @__PURE__ */ jsx$1("span", {
          className: "tw-font-normal",
          children: value.join(", ").trim()
        })]
      }, key)) : "-";
    }
  }];
  const tableData = products.map(({
    id: id2,
    images: images2,
    name,
    productSKUs,
    categories,
    type
  }) => {
    var _a2;
    return {
      id: id2,
      type,
      image: images2 ? (_a2 = images2[0]) == null ? void 0 : _a2.src : void 0,
      isActive: productSKUs.find(({
        selected
      }) => selected),
      name,
      category: categories && !lodash.exports.isEmpty(categories) ? categories[0].name : "-",
      price: getProductPriceRangeText(productSKUs),
      variantList: getInitAllTypesFromProductSKUs(productSKUs)
    };
  });
  return /* @__PURE__ */ jsxs("div", {
    className: "mobile:tw-mb-20 tablet:tw-mb-0",
    children: [/* @__PURE__ */ jsx$1("div", {
      id: "table"
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-box-border tw-w-full tw-bg-White mobile:tw-py-4 mobile:tw-my-4 mobile:tw-rounded-none tablet:tw-py-12 tablet:tw-my-6 tablet:tw-rounded",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "tw-items-center tw-w-full mobile:tw-block mobile:tw-px-4 tablet:tw-inline-flex tablet:tw-justify-between tablet:tw-px-5",
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "mobile:tw-inline-flex tablet:tw-block",
          children: /* @__PURE__ */ jsx$1(Typography, {
            variant: "title-7",
            color: COLORS.Gray[800],
            children: t2("product.productList.items", {
              value: products.length
            })
          })
        }), /* @__PURE__ */ jsxs("div", {
          className: "tw-box-border  tw-grid tw-grid-cols-12 tw-gap-x-2 mobile:tw-mt-4 mobile:tw-w-full tablet:tw-pr-4 tablet:tw-mt-0 tablet:tw-w-fit tablet:tw-min-w-[600px]",
          children: [/* @__PURE__ */ jsx$1("div", {
            className: "tw-w-full mobile:tw-col-span-8 tablet:tw-col-span-7",
            children: /* @__PURE__ */ jsx$1(TextField$2, {
              LeftIcon: /* @__PURE__ */ jsx$1(Icon, {
                name: IconName.SEARCH,
                className: "tw-mr-2 tw-stroke-Gray-400"
              }),
              placeholder: t2("product.productList.search.productName"),
              handleChange: (value) => setFilterWord(value)
            })
          }), /* @__PURE__ */ jsx$1("div", {
            className: "tw-w-full mobile:tw-col-span-4 tablet:tw-col-span-5 tablet:tw-ml-4 tablet:tw-h-full",
            children: /* @__PURE__ */ jsx$1(Filter, {
              options: categoryOptions,
              placeholder: t2("product.productList.search.category"),
              searchPlaceholder: t2("product.productList.filter.search"),
              allItemLabel: t2("product.productList.filter.allItem"),
              value: categoryValue,
              handleSetValue: (option) => {
                const value = (option || []).map(({
                  value: value2
                }) => value2);
                setPageNo(1);
                setSelectedFilterCategoryId(value);
              }
            })
          })]
        })]
      }), /* @__PURE__ */ jsx$1("div", {
        className: "mobile:tw-overflow-auto mobile:tw-mt-4 tablet:tw-mt-6",
        children: products.length > 0 ? /* @__PURE__ */ jsx$1(Fragment, {
          children: isMobile ? /* @__PURE__ */ jsx$1(MobileProductTable, {
            showDetailedId,
            isClientStore,
            tableData,
            setShowDetailedId,
            handleSelectProduct
          }) : /* @__PURE__ */ jsx$1(Table, {
            className: "tw-mb-0",
            data: tableData,
            columns: columnData
          })
        }) : !isMobile && !isLoadingFetchData && /* @__PURE__ */ jsx$1(ProductNotFound, {})
      }), isShowPagination && /* @__PURE__ */ jsx$1(Pagination, {
        className: "tw-mt-4",
        total,
        pageNo,
        limit,
        handlePageNoChange,
        handleLimitChange,
        pageOptions,
        limitOptions
      })]
    }), isMobile && products.length <= 0 && !isLoadingFetchData && /* @__PURE__ */ jsx$1(ProductNotFound, {})]
  });
};
const ProductList = ({
  projectId,
  isClientStore = false,
  handleImportProduct,
  handleAddProduct,
  handleDownloadExample,
  handleSelectProduct
}) => {
  const {
    t: t2
  } = useTranslation();
  const {
    productList,
    loadingGetProductList,
    category,
    loadingCategoryData,
    filterWord,
    setFilterWord,
    total,
    pageNo,
    setPageNo,
    limit,
    setLimit,
    setSelectedFilterCategoryId,
    selectedFilterCategoryId
  } = useProductList(projectId);
  const isLoadingFetchData = loadingGetProductList || loadingCategoryData;
  const handleClick = () => {
    const input = document.getElementById("upload-product");
    if (input) {
      input.click();
    }
  };
  const handleChange = (event) => {
    const file = get_1(event.target.files, 0);
    if (file) {
      handleImportProduct(file);
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-justify-between tw-h-full",
      children: [/* @__PURE__ */ jsx$1(Typography, {
        className: "mobile:tw-px-4 tablet:tw-p-0",
        variant: "title-2",
        color: COLORS.Gray[800],
        children: t2("product.header")
      }), !isClientStore && /* @__PURE__ */ jsxs("div", {
        className: "tw-box-border mobile:tw-hidden tablet:tw-flex tablet:tw-justify-between",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "tw-text-left tablet:tw-w-40",
          children: [/* @__PURE__ */ jsx$1(Button, {
            size: "medium",
            variant: "tertiary",
            className: "tw-items-center tw-cursor-pointer mobile:tw-w-full",
            onClick: handleClick,
            children: /* @__PURE__ */ jsxs("div", {
              className: "tw-inline-flex tw-justify-center tw-items-center tw-w-full tw-text-center",
              children: [/* @__PURE__ */ jsx$1(Icon, {
                className: "tw-pr-2 tw-fill-Primary-600",
                name: IconName.DOWNLOAD,
                size: IconSize.LARGE
              }), /* @__PURE__ */ jsxs("div", {
                children: [/* @__PURE__ */ jsx$1(Typography, {
                  variant: "title-10",
                  color: COLORS.Primary[600],
                  children: t2("product.import.button.label")
                }), /* @__PURE__ */ jsx$1(Typography, {
                  variant: "body-5",
                  color: COLORS.Primary[600],
                  children: t2("product.import.button.subLabel")
                })]
              })]
            })
          }), /* @__PURE__ */ jsx$1("input", {
            name: "import-products",
            type: "file",
            id: "upload-product",
            accept: ".csv, .xlsx",
            onChange: handleChange,
            className: "tw-hidden"
          }), /* @__PURE__ */ jsx$1(Typography, {
            className: "tw-cursor-pointer mobile:tw-pt-4 tablet:tw-pt-1",
            variant: "body-4",
            color: COLORS.Accent,
            onClick: handleDownloadExample,
            children: t2("product.import.button.download")
          })]
        }), /* @__PURE__ */ jsxs(Button, {
          className: "tw-inline-flex tw-justify-center tw-cursor-pointer mobile:tw-w-full tablet:tw-ml-4 tablet:tw-w-52 tablet:tw-max-h-12",
          variant: "primary",
          size: "medium",
          onClick: handleAddProduct,
          children: [/* @__PURE__ */ jsx$1(Icon, {
            className: "tw-pr-2 tw-fill-White",
            name: IconName.PLUS,
            size: IconSize.LARGE
          }), t2("product.default.add")]
        })]
      })]
    }), /* @__PURE__ */ jsx$1(ProductTable, {
      total,
      pageNo,
      setPageNo,
      limit,
      setLimit,
      filterWord,
      setFilterWord,
      products: productList,
      category,
      handleSelectProduct,
      isLoadingFetchData,
      setSelectedFilterCategoryId,
      selectedFilterCategoryId,
      isClientStore
    }), !isClientStore && /* @__PURE__ */ jsx$1("div", {
      className: "tw-box-border tw-fixed tw-bottom-0 tw-py-4 tw-w-full mobile:tw-block mobile:tw-px-4 tablet:tw-hidden",
      children: /* @__PURE__ */ jsxs(Button, {
        className: "tw-inline-flex tw-justify-center tw-cursor-pointer mobile:tw-w-full tablet:tw-ml-4 tablet:tw-w-52 tablet:tw-max-h-12",
        variant: "primary",
        size: "medium",
        onClick: handleAddProduct,
        children: [/* @__PURE__ */ jsx$1(Icon, {
          className: "tw-pr-2 tw-fill-White",
          name: IconName.PLUS,
          size: IconSize.LARGE
        }), t2("product.default.add")]
      })
    }), /* @__PURE__ */ jsx$1(LoadingPopup$1, {
      isOpen: isLoadingFetchData
    })]
  });
};
const Product = (_F) => {
  var _G = _F, {
    isDigitalContentEnabled,
    isAddFoodProductEnable,
    handleToggleProductTypeSelectorModal,
    isOpenAddProductPage,
    handleToggleProductDigitalContentTypeModal,
    setSelectedOldProductId,
    isOpenNewProductForm,
    closeNewProductForm,
    isClientStore = false,
    isMasterStore = false
  } = _G, props = __objRest(_G, [
    "isDigitalContentEnabled",
    "isAddFoodProductEnable",
    "handleToggleProductTypeSelectorModal",
    "isOpenAddProductPage",
    "handleToggleProductDigitalContentTypeModal",
    "setSelectedOldProductId",
    "isOpenNewProductForm",
    "closeNewProductForm",
    "isClientStore",
    "isMasterStore"
  ]);
  const {
    t: t2
  } = useTranslation();
  const [selectedProductId, setSelectedProductId] = useState();
  const [isOpenProductForm, setIsOpenProductForm] = useState(false);
  const handleAddProduct = () => {
    if (isAddFoodProductEnable || isDigitalContentEnabled) {
      handleToggleProductTypeSelectorModal();
    } else {
      setIsOpenProductForm(true);
    }
  };
  const closeProductForm = () => {
    setSelectedProductId("");
    setIsOpenProductForm(false);
    closeNewProductForm();
  };
  const handleSelectProduct = (type, id2) => {
    if (isDigitalContentEnabled && type === ProductType.DIGITAL_CONTENT) {
      setSelectedOldProductId(id2);
      handleToggleProductDigitalContentTypeModal();
    } else {
      setSelectedProductId(id2);
    }
  };
  useEffect(() => {
    if (isOpenNewProductForm) {
      setIsOpenProductForm(isOpenNewProductForm);
    }
  }, [isOpenNewProductForm]);
  if (isOpenAddProductPage && !isOpenProductForm && !isClientStore) {
    return /* @__PURE__ */ jsx$1("div", {
      className: "tw-box-border tw-justify-center tw-items-center tw-w-full tw-h-fit mobile:tw-p-0 tablet:tw-py-10 tablet:tw-px-28",
      children: /* @__PURE__ */ jsx$1("div", {
        className: "tw-flex tw-flex-wrap tw-justify-center tw-w-full",
        children: /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx$1("div", {
            className: "tw-py-4 mobile:tw-pl-4 tablet:tw-pl-0",
            children: /* @__PURE__ */ jsx$1(Typography, {
              variant: "title-4",
              color: COLORS.Gray[800],
              children: t2("product.header")
            })
          }), /* @__PURE__ */ jsx$1(AddProductCard, __spreadProps(__spreadValues({}, props), {
            handleAddProduct
          }))]
        })
      })
    });
  }
  return selectedProductId || isOpenProductForm ? /* @__PURE__ */ jsx$1("div", {
    className: "tw-box-border tw-w-full tw-h-full tw-bg-Gray-100 mobile:tw-py-6 tablet:tw-p-12 desktop:tw-py-12 desktop:tw-px-36",
    children: /* @__PURE__ */ jsx$1(ProductForm, __spreadProps(__spreadValues({}, props), {
      selectedProductId,
      isEditMode: Boolean(selectedProductId),
      closeProductForm,
      isClientStore,
      isMasterStore
    }))
  }) : /* @__PURE__ */ jsx$1("div", {
    className: "tw-box-border tw-w-full tw-h-full tw-bg-Gray-100 mobile:tw-py-6  tablet:tw-p-12",
    children: /* @__PURE__ */ jsx$1(ProductList, __spreadProps(__spreadValues({}, props), {
      isClientStore,
      handleAddProduct,
      handleSelectProduct
    }))
  });
};
const Page$4 = (props) => {
  return /* @__PURE__ */ jsx$1(ContextProviders, {
    children: /* @__PURE__ */ jsx$1(Product, __spreadValues({}, props))
  });
};
const CreateProduct = (props) => {
  return /* @__PURE__ */ jsx$1("div", {
    className: "tw-box-border tw-w-full tw-h-full tw-bg-Gray-100 mobile:tw-py-6 tablet:tw-p-12 desktop:tw-py-12 desktop:tw-px-36 web-console ",
    children: /* @__PURE__ */ jsx$1(ProductForm, __spreadValues({}, props))
  });
};
const Page$3 = (props) => {
  return /* @__PURE__ */ jsx$1(ContextProviders, {
    children: /* @__PURE__ */ jsx$1(CreateProduct, __spreadValues({}, props))
  });
};
const ConfirmationModal = ({
  onClose = () => {
  },
  onSubmit = () => {
  },
  isOpen = false,
  title = "Title",
  description = "Description"
}) => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx$1(Modal, {
    size: "small",
    onClose,
    isOpen,
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-w-full tw-h-fit",
      children: [/* @__PURE__ */ jsx$1("div", {
        className: "tw-flex tw-justify-center tw-w-full",
        children: /* @__PURE__ */ jsx$1(Icon, {
          name: IconName.TRASH,
          size: IconSize.LARGE
        })
      }), /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-py-6 tw-text-center",
        variant: "title-2",
        color: COLORS.Gray[800],
        children: title
      }), /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-pb-10 tw-text-center",
        variant: "body-3",
        color: COLORS.Gray[500],
        children: description
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-justify-between",
        children: [/* @__PURE__ */ jsx$1(Button, {
          size: "large",
          variant: "text",
          className: "tw-text-Primary-600 mobile:tw-w-full tablet:tw-w-fit",
          onClick: onClose,
          children: t2("common.modal.confirmationModal.cancel")
        }), /* @__PURE__ */ jsx$1(Button, {
          size: "large",
          variant: "primary",
          className: "tw-bg-Primary-600 mobile:tw-w-full tablet:tw-w-fit ",
          onClick: onSubmit,
          children: t2("common.modal.confirmationModal.confirm")
        })]
      })]
    })
  });
};
var ConfirmationModal$1 = memo(ConfirmationModal);
const ExampleModal = ({
  isOpen = false,
  onClose = () => {
  }
}) => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx$1(Modal, {
    size: "medium",
    onClose,
    isOpen,
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-text-center",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-justify-evenly",
        children: [/* @__PURE__ */ jsx$1("img", {
          className: "tw-w-32 tablet:tw-w-52",
          src: `${IMAGE_PATH}/example-mobile-1.svg`,
          alt: "mobile-example-1"
        }), /* @__PURE__ */ jsx$1("img", {
          className: "tw-w-32 tablet:tw-w-52",
          src: `${IMAGE_PATH}/example-mobile-2.svg`,
          alt: "mobile-example-2"
        })]
      }), /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-py-6 tw-text-center",
        variant: "body-3",
        color: COLORS.Gray[500],
        children: t2("shipping.shippingMethod.confirmationModal.example.description")
      }), /* @__PURE__ */ jsx$1(Button, {
        className: "tw-text-center",
        onClick: onClose,
        children: t2("shipping.shippingMethod.confirmationModal.example.okay")
      })]
    })
  });
};
var ShippingType;
(function(ShippingType2) {
  ShippingType2["FIXED_PRICE"] = "FIXED_PRICE";
  ShippingType2["POSTAL_CODE"] = "POSTAL_CODE";
  ShippingType2["MANUAL"] = "MANUAL";
  ShippingType2["SHIPPOP"] = "SHIPPOP";
  ShippingType2["LALAMOVE"] = "LALAMOVE";
  ShippingType2["PICKUP"] = "PICKUP";
})(ShippingType || (ShippingType = {}));
var PriceCalculationType;
(function(PriceCalculationType2) {
  PriceCalculationType2["NONE"] = "NONE";
  PriceCalculationType2["PERCENTAGE"] = "PERCENTAGE";
  PriceCalculationType2["FIXED_PRICE"] = "FIXED_PRICE";
})(PriceCalculationType || (PriceCalculationType = {}));
var Carrier;
(function(Carrier2) {
  Carrier2["BEST_EXPRESS"] = "BEST express";
  Carrier2["CJ"] = "CJ logistics";
  Carrier2["DHL"] = "DHL";
  Carrier2["FLASH_EXPRESS"] = "Flash express";
  Carrier2["INTER_EXPRESS"] = "Inter express";
  Carrier2["J_AND_T"] = "J&T";
  Carrier2["KERRY"] = "Kerry";
  Carrier2["NIM_EXPRESS"] = "NIM express";
  Carrier2["NIM_EXPRESS_CHILLED"] = "NIM express chilled";
  Carrier2["NINJAVAN"] = "Ninjavan";
  Carrier2["OTHER"] = "Other";
  Carrier2["PORLOR_EXPRESS"] = "Porlor express";
  Carrier2["SCG"] = "SCG yamato express";
  Carrier2["SENDIT"] = "Sendit";
  Carrier2["THAI_POST_EMS"] = "Thaipost-EMS";
  Carrier2["THAI_POST_REGISTER"] = "Thaipost-Register";
  Carrier2["TNT"] = "TNT";
  Carrier2["ZTO"] = "ZTO";
  Carrier2["TPTRACK"] = "TP Logistics";
})(Carrier || (Carrier = {}));
const OfflinePickUp = ({
  id: id2,
  isActive = false,
  isNonScheduledPickUp = false,
  onToggleOfflinePickUp = () => {
  },
  onToggleNonScheduledPickUp = () => {
  },
  onClickManageStores = () => {
  }
}) => {
  const {
    t: t2
  } = useTranslation();
  const handleOnToggleOfflinePickUp = () => {
    onToggleOfflinePickUp(id2, !isActive);
  };
  const handleToggleNonScheduledPickUp = () => {
    onToggleNonScheduledPickUp(id2, ShippingType.PICKUP, !isNonScheduledPickUp);
  };
  return /* @__PURE__ */ jsxs(Card, {
    className: "tw-bg-White",
    contentSize: ContentSize.MEDIUM_3,
    children: [/* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-justify-between tw-justify-items-center tw-mb-3",
      children: [/* @__PURE__ */ jsx$1(Typography, {
        variant: "title-7",
        children: t2("shipping.shippingMethod.offlinePickUp.title")
      }), /* @__PURE__ */ jsx$1(Switch$1, {
        checked: isActive,
        handleChange: handleOnToggleOfflinePickUp
      })]
    }), /* @__PURE__ */ jsx$1(Typography, {
      variant: "body-3",
      color: "Gray-500",
      className: "tw-mb-4",
      children: t2("shipping.shippingMethod.offlinePickUp.subTitle")
    }), isActive && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-p-4 tw-mb-3 tw-bg-LightNudePrimary tw-rounded-lg",
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "tw-flex tw-justify-between tw-justify-items-center tw-items-center tw-pr-4",
          children: /* @__PURE__ */ jsx$1(Checkbox, {
            checked: isNonScheduledPickUp,
            handleChange: handleToggleNonScheduledPickUp
          })
        }), /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx$1(Typography, {
            variant: "title-8",
            children: t2("shipping.shippingMethod.offlinePickUp.pickupTitle")
          }), /* @__PURE__ */ jsx$1(Typography, {
            variant: "body-3",
            color: "Gray-500",
            children: t2("shipping.shippingMethod.offlinePickUp.pickupSubTitle")
          })]
        })]
      }), /* @__PURE__ */ jsxs(Button, {
        variant: "tertiary",
        size: "large",
        onClick: onClickManageStores,
        children: [/* @__PURE__ */ jsx$1(Icon, {
          name: IconName.STORE,
          size: IconSize.DEFAULT,
          color: "Primary-600",
          className: "tw-inline tw-mr-2 tw-align-baseline"
        }), /* @__PURE__ */ jsx$1(Typography, {
          variant: "title-8",
          color: "Primary-600",
          className: "tw-inline",
          children: t2("shipping.shippingMethod.offlinePickUp.manageStoresButton")
        })]
      })]
    })]
  });
};
var OfflinePickUp$1 = memo(OfflinePickUp);
const Loading = () => /* @__PURE__ */ jsx$1("img", {
  className: "mobile:tw-w-16 tablet:tw-w-24",
  src: LOADING,
  alt: "loading"
});
const ShippingInfoGraphic = ({
  imageUrl,
  isUploadLoading = false,
  isImageUrlLoading = false,
  onClickExample = () => {
  },
  onUpload = () => {
  },
  onRemove = () => {
  }
}) => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(Card, {
    className: "tw-bg-White",
    contentSize: ContentSize.MEDIUM_3,
    children: [/* @__PURE__ */ jsxs("div", {
      className: "tw-block tw-justify-between tw-justify-items-center tw-mb-4  tablet:tw-flex",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "tw-mb-3",
          children: [/* @__PURE__ */ jsxs(Typography, {
            variant: "title-7",
            className: "tw-inline",
            children: [t2("shipping.shippingMethod.shippingInfoGraphic.title"), " "]
          }), /* @__PURE__ */ jsxs(Typography, {
            variant: "body-3",
            color: "Gray-200",
            className: "tw-inline",
            children: ["- ", t2("shipping.shippingMethod.shippingInfoGraphic.optional")]
          })]
        }), /* @__PURE__ */ jsx$1(Typography, {
          variant: "body-3",
          color: "Gray-500",
          children: t2("shipping.shippingMethod.shippingInfoGraphic.subTitle")
        })]
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-mt-4 tablet:tw-mt-0",
        children: /* @__PURE__ */ jsxs(Button, {
          isLoading: isUploadLoading,
          disabled: isUploadLoading,
          variant: "text",
          size: "none",
          className: "tw-mr-4 tw-align-super",
          onClick: onClickExample,
          children: [/* @__PURE__ */ jsx$1(Icon, {
            name: IconName.EYE,
            size: IconSize.DEFAULT,
            color: "Primary-600",
            className: "tw-inline tw-mr-2 tw-align-text-bottom"
          }), /* @__PURE__ */ jsx$1(Typography, {
            variant: "body-3",
            className: "tw-inline",
            color: "Primary-600",
            children: t2("shipping.shippingMethod.shippingInfoGraphic.example")
          })]
        })
      })]
    }), Boolean(isImageUrlLoading) && /* @__PURE__ */ jsx$1("div", {
      className: "tw-flex tw-justify-center",
      children: /* @__PURE__ */ jsx$1(Loading, {})
    }), Boolean(imageUrl && !isImageUrlLoading) && /* @__PURE__ */ jsx$1("div", {
      className: "tw-flex tw-justify-center tw-items-center",
      children: /* @__PURE__ */ jsxs("div", {
        className: "tw-relative",
        children: [/* @__PURE__ */ jsx$1("div", {
          onClick: onRemove,
          className: "tw-flex tw-absolute tw-top-1 tw-right-1 tw-justify-center tw-items-center tw-w-8 tw-h-8 tw-bg-Tertiary tw-rounded-full tw-cursor-pointer",
          children: /* @__PURE__ */ jsx$1(Icon, {
            name: IconName.CLOSE,
            size: IconSize.SMALL
          })
        }), /* @__PURE__ */ jsx$1("img", {
          className: "tw-max-h-80",
          src: imageUrl,
          alt: "shipping-info-graphic"
        })]
      })
    }), Boolean(!imageUrl && !isImageUrlLoading) && /* @__PURE__ */ jsx$1(UploadPanel, {
      onDrop: onUpload,
      labelButton: t2("shipping.shippingMethod.shippingInfoGraphic.uploadButton")
    })]
  });
};
var ShippingInfoGraphic$1 = memo(ShippingInfoGraphic);
const Dropdown = (_H, ref) => {
  var _I = _H, {
    children: children2,
    style,
    isOpen
  } = _I, rest = __objRest(_I, [
    "children",
    "style",
    "isOpen"
  ]);
  return /* @__PURE__ */ jsx$1("div", __spreadProps(__spreadValues({}, rest), {
    ref,
    style,
    className: `tw-pt-2 tw-bg-White tw-shadow-sm tw-rounded ${isOpen ? "tw-block" : "tw-hidden"}`,
    children: children2
  }));
};
var Dropdown$1 = forwardRef(Dropdown);
var fromEntries = function fromEntries2(entries) {
  return entries.reduce(function(acc, _ref3) {
    var key = _ref3[0], value = _ref3[1];
    acc[key] = value;
    return acc;
  }, {});
};
var useIsomorphicLayoutEffect = typeof window !== "undefined" && window.document && window.document.createElement ? React$2.useLayoutEffect : React$2.useEffect;
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}
function getWindow(node2) {
  if (node2 == null) {
    return window;
  }
  if (node2.toString() !== "[object Window]") {
    var ownerDocument = node2.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node2;
}
function isElement(node2) {
  var OwnElement = getWindow(node2).Element;
  return node2 instanceof OwnElement || node2 instanceof Element;
}
function isHTMLElement(node2) {
  var OwnElement = getWindow(node2).HTMLElement;
  return node2 instanceof OwnElement || node2 instanceof HTMLElement;
}
function isShadowRoot(node2) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow(node2).ShadowRoot;
  return node2 instanceof OwnElement || node2 instanceof ShadowRoot;
}
function applyStyles(_ref3) {
  var state = _ref3.state;
  Object.keys(state.elements).forEach(function(name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function(name2) {
      var value = attributes[name2];
      if (value === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value === true ? "" : value);
      }
    });
  });
}
function effect$2(_ref22) {
  var state = _ref22.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function() {
    Object.keys(state.elements).forEach(function(name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style = styleProperties.reduce(function(style2, property2) {
        style2[property2] = "";
        return style2;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function(attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
var applyStyles$1 = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(placement) {
  return placement.split("-")[0];
}
var max = Math.max;
var min = Math.min;
var round = Math.round;
function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (isHTMLElement(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth;
    if (offsetWidth > 0) {
      scaleX = round(rect.width) / offsetWidth || 1;
    }
    if (offsetHeight > 0) {
      scaleY = round(rect.height) / offsetHeight || 1;
    }
  }
  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}
function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width,
    height
  };
}
function contains(parent2, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent2.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    var next2 = child;
    do {
      if (next2 && parent2.isSameNode(next2)) {
        return true;
      }
      next2 = next2.parentNode || next2.host;
    } while (next2);
  }
  return false;
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}
function getDocumentElement(element) {
  return ((isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}
function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return element.assignedSlot || element.parentNode || (isShadowRoot(element) ? element.host : null) || getDocumentElement(element);
}
function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1;
  var isIE = navigator.userAgent.indexOf("Trident") !== -1;
  if (isIE && isHTMLElement(element)) {
    var elementCss = getComputedStyle$1(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css4 = getComputedStyle$1(currentNode);
    if (css4.transform !== "none" || css4.perspective !== "none" || css4.contain === "paint" || ["transform", "perspective"].indexOf(css4.willChange) !== -1 || isFirefox && css4.willChange === "filter" || isFirefox && css4.filter && css4.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle$1(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}
function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min2, value, max2) {
  var v2 = within(min2, value, max2);
  return v2 > max2 ? max2 : v2;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
function expandToHashMap(value, keys2) {
  return keys2.reduce(function(hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
var toPaddingObject = function toPaddingObject2(padding, state) {
  padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref3) {
  var _state$modifiersData$;
  var state = _ref3.state, name = _ref3.name, options2 = _ref3.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";
  if (!arrowElement || !popperOffsets2) {
    return;
  }
  var paddingObject = toPaddingObject(options2.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top : left;
  var maxProp = axis === "y" ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min2 = paddingObject[minProp];
  var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset2 = within(min2, center, max2);
  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
}
function effect$1(_ref22) {
  var state = _ref22.state, options2 = _ref22.options;
  var _options$element = options2.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
}
var arrow$1 = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(placement) {
  return placement.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref3) {
  var x2 = _ref3.x, y2 = _ref3.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x2 * dpr) / dpr || 0,
    y: round(y2 * dpr) / dpr || 0
  };
}
function mapToStyles(_ref22) {
  var _Object$assign2;
  var popper2 = _ref22.popper, popperRect = _ref22.popperRect, placement = _ref22.placement, variation = _ref22.variation, offsets = _ref22.offsets, position2 = _ref22.position, gpuAcceleration = _ref22.gpuAcceleration, adaptive = _ref22.adaptive, roundOffsets = _ref22.roundOffsets, isFixed = _ref22.isFixed;
  var _offsets$x = offsets.x, x2 = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y2 = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x: x2,
    y: y2
  }) : {
    x: x2,
    y: y2
  };
  x2 = _ref3.x;
  y2 = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow(popper2)) {
      offsetParent = getDocumentElement(popper2);
      if (getComputedStyle$1(offsetParent).position !== "static" && position2 === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
      y2 -= offsetY - popperRect.height;
      y2 *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
      x2 -= offsetX - popperRect.width;
      x2 *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position: position2
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x2,
    y: y2
  }) : {
    x: x2,
    y: y2
  };
  x2 = _ref4.x;
  y2 = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x2 + "px, " + y2 + "px)" : "translate3d(" + x2 + "px, " + y2 + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y2 + "px" : "", _Object$assign2[sideX] = hasX ? x2 + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state, options2 = _ref5.options;
  var _options$gpuAccelerat = options2.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options2.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options2.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive,
      roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
var computeStyles$1 = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: true
};
function effect(_ref3) {
  var state = _ref3.state, instance = _ref3.instance, options2 = _ref3.options;
  var _options$scroll = options2.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options2.resize, resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function(scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function() {
    if (scroll) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
var eventListeners = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash$1[matched];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function(matched) {
    return hash[matched];
  });
}
function getWindowScroll(node2) {
  var win = getWindow(node2);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft,
    scrollTop
  };
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
function getViewportRect(element) {
  var win = getWindow(element);
  var html2 = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html2.clientWidth;
  var height = html2.clientHeight;
  var x2 = 0;
  var y2 = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x2 = visualViewport.offsetLeft;
      y2 = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x2 + getWindowScrollBarX(element),
    y: y2
  };
}
function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html2 = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html2.scrollWidth, html2.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html2.scrollHeight, html2.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x2 = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y2 = -winScroll.scrollTop;
  if (getComputedStyle$1(body || html2).direction === "rtl") {
    x2 += max(html2.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle$1(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getScrollParent(node2) {
  if (["html", "body", "#document"].indexOf(getNodeName(node2)) >= 0) {
    return node2.ownerDocument.body;
  }
  if (isHTMLElement(node2) && isScrollParent(node2)) {
    return node2;
  }
  return getScrollParent(getParentNode(node2));
}
function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
}
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  }
  return clippingParents2.filter(function(clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body";
  });
}
function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
function computeOffsets(_ref3) {
  var reference2 = _ref3.reference, element = _ref3.element, placement = _ref3.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case right:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}
function detectOverflow(state, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var _options = options2, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: "absolute",
    placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset2 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function(key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset2[axis] * multiply;
    });
  }
  return overflowOffsets;
}
function computeAutoPlacement(state, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var _options = options2, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function(placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  }
  var overflows = allowedPlacements.reduce(function(acc, placement2) {
    acc[placement2] = detectOverflow(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding
    })[getBasePlacement(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function(a2, b2) {
    return overflows[a2] - overflows[b2];
  });
}
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref3) {
  var state = _ref3.state, options2 = _ref3.options, name = _ref3.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options2.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options2.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options2.fallbackPlacements, padding = options2.padding, boundary = options2.boundary, rootBoundary = options2.rootBoundary, altBoundary = options2.altBoundary, _options$flipVariatio = options2.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options2.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
    return acc.concat(getBasePlacement(placement2) === auto ? computeAutoPlacement(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding,
      flipVariations,
      allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];
  for (var i2 = 0; i2 < placements2.length; i2++) {
    var placement = placements2[i2];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow(state, {
      placement,
      boundary,
      rootBoundary,
      altBoundary,
      padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function(check2) {
      return check2;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop2(_i2) {
      var fittingPlacement = placements2.find(function(placement2) {
        var checks2 = checksMap.get(placement2);
        if (checks2) {
          return checks2.slice(0, _i2).every(function(check2) {
            return check2;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break")
        break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
var flip$1 = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function(side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref3) {
  var state = _ref3.state, name = _ref3.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets,
    popperEscapeOffsets,
    isReferenceHidden,
    hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}
var hide$1 = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref3 = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
    placement
  })) : offset2, skidding = _ref3[0], distance = _ref3[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref22) {
  var state = _ref22.state, options2 = _ref22.options, name = _ref22.name;
  var _options$offset = options2.offset, offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data2 = placements.reduce(function(acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data2[state.placement], x2 = _data$state$placement.x, y2 = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x2;
    state.modifiersData.popperOffsets.y += y2;
  }
  state.modifiersData[name] = data2;
}
var offset$1 = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(_ref3) {
  var state = _ref3.state, name = _ref3.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}
var popperOffsets$1 = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function preventOverflow(_ref3) {
  var state = _ref3.state, options2 = _ref3.options, name = _ref3.name;
  var _options$mainAxis = options2.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options2.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options2.boundary, rootBoundary = options2.rootBoundary, altBoundary = options2.altBoundary, padding = options2.padding, _options$tether = options2.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options2.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary,
    rootBoundary,
    padding,
    altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data2 = {
    x: 0,
    y: 0
  };
  if (!popperOffsets2) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === "y" ? top : left;
    var altSide = mainAxis === "y" ? bottom : right;
    var len = mainAxis === "y" ? "height" : "width";
    var offset2 = popperOffsets2[mainAxis];
    var min$1 = offset2 + overflow[mainSide];
    var max$1 = offset2 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset2 + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset2, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets2[mainAxis] = preventedOffset;
    data2[mainAxis] = preventedOffset - offset2;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === "x" ? top : left;
    var _altSide = mainAxis === "x" ? bottom : right;
    var _offset = popperOffsets2[altAxis];
    var _len = altAxis === "y" ? "height" : "width";
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets2[altAxis] = _preventedOffset;
    data2[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data2;
}
var preventOverflow$1 = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
function getNodeScroll(node2) {
  if (node2 === getWindow(node2) || !isHTMLElement(node2)) {
    return getWindowScroll(node2);
  } else {
    return getHTMLElementScroll(node2);
  }
}
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function order(modifiers) {
  var map2 = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function(modifier) {
    map2.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function(dep) {
      if (!visited.has(dep)) {
        var depModifier = map2.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function(modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function(acc, phase) {
    return acc.concat(orderedModifiers.filter(function(modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
function debounce(fn2) {
  var pending;
  return function() {
    if (!pending) {
      pending = new Promise(function(resolve) {
        Promise.resolve().then(function() {
          pending = void 0;
          resolve(fn2());
        });
      });
    }
    return pending;
  };
}
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function(merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function(key) {
    return merged[key];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function(element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions2 = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options2) {
    if (options2 === void 0) {
      options2 = defaultOptions2;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions2),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state,
      setOptions: function setOptions(setOptionsAction) {
        var options3 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions2, state.options, options3);
        state.scrollParents = {
          reference: isElement(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function(m2) {
          return m2.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
        if (!areValidElements(reference3, popper3)) {
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function(modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index2 = 0; index2 < state.orderedModifiers.length; index2++) {
          if (state.reset === true) {
            state.reset = false;
            index2 = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index2], fn2 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state,
              options: _options,
              name,
              instance
            }) || state;
          }
        }
      },
      update: debounce(function() {
        return new Promise(function(resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference2, popper2)) {
      return instance;
    }
    instance.setOptions(options2).then(function(state2) {
      if (!isDestroyed && options2.onFirstUpdate) {
        options2.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function(_ref3) {
        var name = _ref3.name, _ref3$options = _ref3.options, options3 = _ref3$options === void 0 ? {} : _ref3$options, effect2 = _ref3.effect;
        if (typeof effect2 === "function") {
          var cleanupFn = effect2({
            state,
            name,
            instance,
            options: options3
          });
          var noopFn = function noopFn2() {
          };
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function(fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
var hasElementType = typeof Element !== "undefined";
var hasMap = typeof Map === "function";
var hasSet = typeof Set === "function";
var hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
function equal(a2, b2) {
  if (a2 === b2)
    return true;
  if (a2 && b2 && typeof a2 == "object" && typeof b2 == "object") {
    if (a2.constructor !== b2.constructor)
      return false;
    var length2, i2, keys2;
    if (Array.isArray(a2)) {
      length2 = a2.length;
      if (length2 != b2.length)
        return false;
      for (i2 = length2; i2-- !== 0; )
        if (!equal(a2[i2], b2[i2]))
          return false;
      return true;
    }
    var it;
    if (hasMap && a2 instanceof Map && b2 instanceof Map) {
      if (a2.size !== b2.size)
        return false;
      it = a2.entries();
      while (!(i2 = it.next()).done)
        if (!b2.has(i2.value[0]))
          return false;
      it = a2.entries();
      while (!(i2 = it.next()).done)
        if (!equal(i2.value[1], b2.get(i2.value[0])))
          return false;
      return true;
    }
    if (hasSet && a2 instanceof Set && b2 instanceof Set) {
      if (a2.size !== b2.size)
        return false;
      it = a2.entries();
      while (!(i2 = it.next()).done)
        if (!b2.has(i2.value[0]))
          return false;
      return true;
    }
    if (hasArrayBuffer && ArrayBuffer.isView(a2) && ArrayBuffer.isView(b2)) {
      length2 = a2.length;
      if (length2 != b2.length)
        return false;
      for (i2 = length2; i2-- !== 0; )
        if (a2[i2] !== b2[i2])
          return false;
      return true;
    }
    if (a2.constructor === RegExp)
      return a2.source === b2.source && a2.flags === b2.flags;
    if (a2.valueOf !== Object.prototype.valueOf)
      return a2.valueOf() === b2.valueOf();
    if (a2.toString !== Object.prototype.toString)
      return a2.toString() === b2.toString();
    keys2 = Object.keys(a2);
    length2 = keys2.length;
    if (length2 !== Object.keys(b2).length)
      return false;
    for (i2 = length2; i2-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(b2, keys2[i2]))
        return false;
    if (hasElementType && a2 instanceof Element)
      return false;
    for (i2 = length2; i2-- !== 0; ) {
      if ((keys2[i2] === "_owner" || keys2[i2] === "__v" || keys2[i2] === "__o") && a2.$$typeof) {
        continue;
      }
      if (!equal(a2[keys2[i2]], b2[keys2[i2]]))
        return false;
    }
    return true;
  }
  return a2 !== a2 && b2 !== b2;
}
var reactFastCompare = function isEqual2(a2, b2) {
  try {
    return equal(a2, b2);
  } catch (error2) {
    if ((error2.message || "").match(/stack|recursion/i)) {
      console.warn("react-fast-compare cannot handle circular refs");
      return false;
    }
    throw error2;
  }
};
var EMPTY_MODIFIERS = [];
var usePopper = function usePopper2(referenceElement, popperElement, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var prevOptions = React$2.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options2.onFirstUpdate,
    placement: options2.placement || "bottom",
    strategy: options2.strategy || "absolute",
    modifiers: options2.modifiers || EMPTY_MODIFIERS
  };
  var _React$useState = React$2.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), state = _React$useState[0], setState = _React$useState[1];
  var updateStateModifier = React$2.useMemo(function() {
    return {
      name: "updateState",
      enabled: true,
      phase: "write",
      fn: function fn2(_ref3) {
        var state2 = _ref3.state;
        var elements = Object.keys(state2.elements);
        setState({
          styles: fromEntries(elements.map(function(element) {
            return [element, state2.styles[element] || {}];
          })),
          attributes: fromEntries(elements.map(function(element) {
            return [element, state2.attributes[element]];
          }))
        });
      },
      requires: ["computeStyles"]
    };
  }, []);
  var popperOptions = React$2.useMemo(function() {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: "applyStyles",
        enabled: false
      }])
    };
    if (reactFastCompare(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React$2.useRef();
  useIsomorphicLayoutEffect(function() {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function() {
    if (referenceElement == null || popperElement == null) {
      return;
    }
    var createPopper$1 = options2.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function() {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options2.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};
const useDropDown = () => {
  const [referenceElement, setReferenceElement] = useState(null);
  const dropdownElementRef = useRef(null);
  const { styles: styles2, attributes } = usePopper(referenceElement, dropdownElementRef.current);
  const closeDropdown = useCallback(() => setReferenceElement(null), []);
  useClickOutside(dropdownElementRef.current, closeDropdown);
  const openDropdown = useCallback((event) => {
    if (event == null ? void 0 : event.target) {
      setReferenceElement(event.target);
    }
  }, []);
  const isOpenDropdown = Boolean(referenceElement);
  return {
    dropdownElementRef,
    dropdownProps: attributes.popper,
    dropdownStyles: styles2.popper,
    isOpenDropdown,
    openDropdown,
    closeDropdown
  };
};
const useToggleSwitch = () => {
  const [isToggleOn, setIsToggleOn] = useState(false);
  const toggleSwitch = useCallback(() => {
    setIsToggleOn(!isToggleOn);
  }, [isToggleOn]);
  const toggleSwitchOn = useCallback(() => {
    setIsToggleOn(true);
  }, []);
  const toggleSwitchOff = useCallback(() => {
    setIsToggleOn(false);
  }, []);
  return {
    isToggleOn,
    toggleSwitch,
    toggleSwitchOff,
    toggleSwitchOn
  };
};
const ShippingMethodCard = ({
  id: id2,
  logo,
  name,
  isActive,
  shippingType,
  description,
  priceCalculationLabel = "",
  estimatedDelivery,
  onOpenMenu = () => {
  }
}) => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(Card, {
    shadowSize: ElevationShadowType.NONE,
    contentSize: ContentSize.SMALL_2,
    children: [/* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-justify-between tw-mb-4",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "tw-flex",
        children: [Boolean(logo) && /* @__PURE__ */ jsx$1("img", {
          src: logo,
          width: 40,
          height: 40,
          className: "tw-rounded-md",
          alt: "shipping-logo"
        }), /* @__PURE__ */ jsxs("div", {
          className: "tw-ml-2",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "tw-flex",
            children: [/* @__PURE__ */ jsx$1(Typography, {
              variant: "title-8",
              className: "tw-mr-2",
              children: name
            }), /* @__PURE__ */ jsx$1(Status, {
              label: isActive ? t2("shipping.shippingMethod.shippingMethodCard.active") : t2("shipping.shippingMethod.shippingMethodCard.inactive"),
              color: isActive ? "bg-Green-500" : "bg-Gray-400"
            })]
          }), /* @__PURE__ */ jsx$1(Typography, {
            variant: "body-4",
            color: "Gray-500",
            children: description
          })]
        })]
      }), /* @__PURE__ */ jsx$1("div", {
        children: /* @__PURE__ */ jsx$1(Button, {
          onClick: (event) => onOpenMenu(event, {
            id: id2,
            type: shippingType,
            isActive,
            name
          }),
          variant: "text",
          size: "none",
          className: "tw-p-2",
          children: /* @__PURE__ */ jsx$1(Icon, {
            name: IconName.OPTIONS,
            size: IconSize.MEDIUM,
            color: "Gray-400"
          })
        })
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-p-3 tw-bg-Gray-100 tw-rounded-lg",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "tw-flex-1",
        children: [/* @__PURE__ */ jsx$1(Typography, {
          variant: "body-4",
          color: "Gray-500",
          className: "tw-mb-1",
          children: t2("shipping.shippingMethod.shippingMethodCard.priceCalculation")
        }), /* @__PURE__ */ jsx$1(Typography, {
          variant: "body-3",
          children: priceCalculationLabel
        })]
      }), !!estimatedDelivery && /* @__PURE__ */ jsxs("div", {
        className: "tw-flex-1",
        children: [/* @__PURE__ */ jsx$1(Typography, {
          variant: "body-4",
          color: "Gray-500",
          className: "tw-mb-1",
          children: t2("shipping.shippingMethod.shippingMethodCard.estimatedDelivery")
        }), /* @__PURE__ */ jsx$1(Typography, {
          variant: "body-3",
          children: `${estimatedDelivery} ${t2("common.date.days")}`
        })]
      })]
    })]
  });
};
var ShippingMethodCard$1 = memo(ShippingMethodCard);
const ShippingMethodPlaceholder = ({
  onClickAdd = () => {
  }
}) => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs("div", {
    className: "tw-flex tw-flex-col tablet:tw-flex-row",
    children: [/* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsx$1(Typography, {
        variant: "title-2",
        className: "tw-mb-4",
        children: t2("shipping.shippingMethod.placeholder.title")
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-2",
        color: "Gray-500",
        className: "tw-mx-auto tw-mb-4",
        children: t2("shipping.shippingMethod.placeholder.subTitle")
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-flex-wrap",
        children: [/* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx$1(Icon, {
            color: "Green-300",
            name: IconName.CIRCLE_CHECK,
            size: IconSize.LARGE,
            className: "tw-inline"
          }), /* @__PURE__ */ jsx$1(Typography, {
            variant: "title-9",
            color: "Gray-500",
            className: "tw-inline",
            children: t2("shipping.shippingMethod.placeholder.list1")
          })]
        }), /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx$1(Icon, {
            color: "Green-300",
            name: IconName.CIRCLE_CHECK,
            size: IconSize.LARGE,
            className: "tw-inline"
          }), /* @__PURE__ */ jsx$1(Typography, {
            variant: "title-9",
            color: "Gray-500",
            className: "tw-inline",
            children: t2("shipping.shippingMethod.placeholder.list2")
          })]
        }), /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx$1(Icon, {
            color: "Green-300",
            name: IconName.CIRCLE_CHECK,
            size: IconSize.LARGE,
            className: "tw-inline"
          }), /* @__PURE__ */ jsx$1(Typography, {
            variant: "title-9",
            color: "Gray-500",
            className: "tw-inline",
            children: t2("shipping.shippingMethod.placeholder.list3")
          })]
        }), /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx$1(Icon, {
            color: "Green-300",
            name: IconName.CIRCLE_CHECK,
            size: IconSize.LARGE,
            className: "tw-inline"
          }), /* @__PURE__ */ jsx$1(Typography, {
            variant: "title-9",
            color: "Gray-500",
            className: "tw-inline",
            children: t2("shipping.shippingMethod.placeholder.list4")
          })]
        }), /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx$1(Icon, {
            color: "Green-300",
            name: IconName.CIRCLE_CHECK,
            size: IconSize.LARGE,
            className: "tw-inline"
          }), /* @__PURE__ */ jsx$1(Typography, {
            variant: "title-9",
            color: "Gray-500",
            className: "tw-inline",
            children: t2("shipping.shippingMethod.placeholder.list5")
          })]
        }), /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx$1(Icon, {
            color: "Green-300",
            name: IconName.CIRCLE_CHECK,
            size: IconSize.LARGE,
            className: "tw-inline"
          }), /* @__PURE__ */ jsx$1(Typography, {
            variant: "title-9",
            color: "Gray-500",
            className: "tw-inline",
            children: t2("shipping.shippingMethod.placeholder.list6")
          })]
        })]
      }), /* @__PURE__ */ jsxs(Button, {
        variant: "primary",
        size: "large",
        onClick: onClickAdd,
        className: "tw-block tw-m-auto tw-my-4",
        children: [/* @__PURE__ */ jsx$1(Icon, {
          color: "White",
          name: IconName.PLUS,
          size: IconSize.MEDIUM,
          className: "tw-inline"
        }), /* @__PURE__ */ jsx$1(Typography, {
          variant: "title-8",
          color: "White",
          className: "tw-inline",
          children: t2("shipping.shippingMethod.placeholder.addButton")
        })]
      })]
    }), /* @__PURE__ */ jsx$1("div", {
      children: /* @__PURE__ */ jsx$1("img", {
        src: SHIPPING_METHOD,
        className: "tw-mx-auto tw-mb-4 tw-w-full",
        alt: "shipping-method"
      })
    })]
  });
};
const MAX_NUMBER_OF_SHIPPINGS = 4;
const ShippingMethod = ({
  isLoading = false,
  shippingMethods = [],
  onAdd = () => {
  },
  onToogleActive = () => {
  },
  onDelete = () => {
  },
  onDuplicate = () => {
  }
}) => {
  const {
    t: t2
  } = useTranslation();
  const [selectedShipping, setSelectedShipping] = useState();
  const {
    dropdownElementRef,
    dropdownProps,
    dropdownStyles,
    isOpenDropdown,
    openDropdown,
    closeDropdown
  } = useDropDown();
  const {
    isToggleOn: isOpenDeleteShippingConfirmationModal,
    toggleSwitchOn: openDeleteShippingConfirmationModal,
    toggleSwitchOff: closeDeleteShippingConfirmationModal
  } = useToggleSwitch();
  const handleOpenDropdown = useCallback((event, newSelectedShipping) => {
    setSelectedShipping(newSelectedShipping);
    openDropdown(event);
  }, [openDropdown]);
  const handleToogleActive = () => {
    if (!selectedShipping)
      return;
    const {
      id: id2,
      isActive
    } = selectedShipping;
    onToogleActive(id2, !isActive);
    closeDropdown();
  };
  const handleDuplicate = () => {
    if (!selectedShipping)
      return;
    const {
      id: id2
    } = selectedShipping;
    onDuplicate(id2);
    closeDropdown();
  };
  const handleDelete = () => {
    openDeleteShippingConfirmationModal();
  };
  const handleDeleteConfirmation = () => {
    if (selectedShipping) {
      const {
        id: id2
      } = selectedShipping;
      onDelete(id2);
    }
    closeDeleteShippingConfirmationModal();
    closeDropdown();
  };
  const dropdownMenuItems = [{
    id: 1,
    name: t2("shipping.shippingMethod.duplicate"),
    onClick: handleDuplicate
  }, {
    id: 2,
    name: (selectedShipping == null ? void 0 : selectedShipping.isActive) ? t2("shipping.shippingMethod.setInactive") : t2("shipping.shippingMethod.setActive"),
    onClick: handleToogleActive
  }, {
    id: 3,
    name: t2("shipping.shippingMethod.delete"),
    onClick: handleDelete
  }];
  const hasShippingMethodsData = !!(shippingMethods == null ? void 0 : shippingMethods.length);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx$1(Dropdown$1, __spreadProps(__spreadValues({}, dropdownProps), {
      isOpen: isOpenDropdown,
      ref: dropdownElementRef,
      style: dropdownStyles,
      children: dropdownMenuItems.map((item) => /* @__PURE__ */ jsx$1(Button, {
        variant: "custom",
        className: "tw-block tw-p-4 tw-w-full tw-text-left hover:tw-bg-LightNudePrimary tw-rounded",
        size: "none",
        onClick: item.onClick,
        children: /* @__PURE__ */ jsx$1(Typography, {
          variant: "body-3",
          children: item.name
        })
      }, item.id))
    })), /* @__PURE__ */ jsxs(Card, {
      className: "tw-bg-White",
      contentSize: hasShippingMethodsData ? ContentSize.MEDIUM_3 : ContentSize.HUGE_5,
      children: [Boolean(isLoading || hasShippingMethodsData) && /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-7",
        className: "tw-mb-4",
        children: t2("shipping.shippingMethod.title")
      }), Boolean(isLoading) && /* @__PURE__ */ jsx$1("div", {
        className: "tw-flex tw-justify-center",
        children: /* @__PURE__ */ jsx$1(Loading, {})
      }), Boolean(!isLoading && hasShippingMethodsData) && /* @__PURE__ */ jsx$1(Fragment, {
        children: /* @__PURE__ */ jsxs("div", {
          className: "tw-grid tw-gap-4 mobile:tw-grid-cols-1 tablet:tw-grid-cols-2",
          children: [shippingMethods.map((shippingMethod) => {
            const priceCalculationLabel = `${t2(shippingMethod.shippingTypeLabel)} ${shippingMethod.priceLabel}`;
            return /* @__PURE__ */ jsx$1(ShippingMethodCard$1, {
              onOpenMenu: handleOpenDropdown,
              estimatedDelivery: shippingMethod.estimatedDelivery,
              id: shippingMethod.id,
              logo: shippingMethod.logo,
              name: shippingMethod.name,
              priceCalculationLabel,
              description: t2(shippingMethod.description),
              shippingType: shippingMethod.shippingType,
              isActive: shippingMethod.isActive
            }, shippingMethod.id);
          }), (shippingMethods == null ? void 0 : shippingMethods.length) < MAX_NUMBER_OF_SHIPPINGS && /* @__PURE__ */ jsx$1("div", {
            onClick: onAdd,
            children: /* @__PURE__ */ jsx$1(ImageUpload, {
              iconName: IconName.PLUS,
              iconSize: IconSize.LARGE,
              iconColor: "Primary",
              label: t2("shipping.shippingMethod.addButton")
            })
          })]
        })
      }), Boolean(!isLoading && !hasShippingMethodsData) && /* @__PURE__ */ jsx$1(ShippingMethodPlaceholder, {
        onClickAdd: onAdd
      })]
    }), /* @__PURE__ */ jsx$1(ConfirmationModal$1, {
      title: t2("shipping.shippingMethod.confirmationModal.deleteShipping.title", {
        name: selectedShipping == null ? void 0 : selectedShipping.name
      }),
      description: t2("shipping.shippingMethod.confirmationModal.deleteShipping.subTitle"),
      onClose: closeDeleteShippingConfirmationModal,
      onSubmit: handleDeleteConfirmation,
      isOpen: isOpenDeleteShippingConfirmationModal
    })]
  });
};
var ShippingMethod$1 = memo(ShippingMethod);
const UPSERT_SHIPPING_INFOGRAPHIC = gql$1`
  mutation upsertShippingInfographic($projectId: ID!, $imageUrl: String!) {
    upsertShippingInfographic(projectId: $projectId, imageUrl: $imageUrl) {
      imageUrl
    }
  }
`;
const DELETE_SHIPPING = gql$1`
  mutation deleteShipping($projectId: ID!, $shippingId: ID!) {
    deleteShipping(projectId: $projectId, shippingId: $shippingId) {
      id
    }
  }
`;
const DULICATE_SHIPPING = gql$1`
  mutation duplicateShipping($projectId: ID!, $shippingId: ID!) {
    duplicateShipping(projectId: $projectId, shippingId: $shippingId) {
      id
      type
      duration {
        max
        min
        isActive
      }
      thDisplayName
      enDisplayName
      name
      iconUrl
      description
      isCod
      code
      isCod
      isActive
      isDeleted
      ... on ShippingShippop {
        setting {
          isDisabledSchedulePickUp
          price
        }
      }
      ... on ShippingLalamove {
        setting {
          price
        }
      }
      ... on ShippingFixedPrice {
        setting {
          price
        }
      }
      ... on ShippingPostalCode {
        setting {
          price
        }
      }
      ... on ShippingPickup {
        setting {
          isDisabledSchedulePickUp
        }
      }
    }
  }
`;
const UPDATE_SHIPPING = gql$1`
  mutation updateShipping(
    $projectId: ID!
    $shippingId: ID!
    $shipping: NewShippingInput!
  ) {
    updateShipping(
      projectId: $projectId
      shippingId: $shippingId
      shipping: $shipping
    ) {
      id
      type
      duration {
        max
        min
        isActive
      }
      thDisplayName
      enDisplayName
      name
      iconUrl
      description
      isCod
      code
      isCod
      isActive
      isDeleted
      ... on ShippingShippop {
        setting {
          isDisabledSchedulePickUp
          price
        }
      }
      ... on ShippingLalamove {
        setting {
          price
        }
      }
      ... on ShippingFixedPrice {
        setting {
          price
        }
      }
      ... on ShippingPostalCode {
        setting {
          price
        }
      }
      ... on ShippingPickup {
        setting {
          isDisabledSchedulePickUp
        }
      }
    }
  }
`;
const UPDATE_SHIPPING_STATUS = gql$1`
  mutation updateShippingStatus(
    $projectId: ID!
    $shippingId: ID!
    $isActive: Boolean
  ) {
    updateShippingStatus(
      projectId: $projectId
      shippingId: $shippingId
      isActive: $isActive
    ) {
      id
      type
      duration {
        max
        min
        isActive
      }
      name
      thDisplayName
      enDisplayName
      description
      isCod
      iconUrl
      code
      isCod
      isActive
      isDeleted
      ... on ShippingShippop {
        setting {
          isDisabledSchedulePickUp
          price
        }
      }
      ... on ShippingLalamove {
        setting {
          price
        }
      }
      ... on ShippingFixedPrice {
        setting {
          price
        }
      }
      ... on ShippingPostalCode {
        setting {
          price
        }
      }
      ... on ShippingPickup {
        setting {
          isDisabledSchedulePickUp
        }
      }
    }
  }
`;
const CREATE_SHIPPING = gql$1`
  mutation createShipping($projectId: ID!, $shipping: NewShippingInput!) {
    createShipping(projectId: $projectId, shipping: $shipping) {
      id
      type
      iconUrl
      duration {
        max
        min
        isActive
      }
      name
      description
      isCod
      code
      isCod
      isActive
      isDeleted
      thDisplayName
      enDisplayName
      ... on ShippingShippop {
        setting {
          isDisabledSchedulePickUp
          price
        }
      }
      ... on ShippingLalamove {
        setting {
          price
        }
      }
      ... on ShippingFixedPrice {
        setting {
          price
        }
      }
      ... on ShippingPostalCode {
        setting {
          price
        }
      }
      ... on ShippingPickup {
        setting {
          isDisabledSchedulePickUp
        }
      }
    }
  }
`;
const SHIPPINGS = gql$1`
  query shippings($projectId: ID!, $filter: ShippingFilterInput) {
    shippings(projectId: $projectId, filter: $filter) {
      total
      shippingInfographic {
        imageUrl
      }
      results {
        id
        type
        iconUrl
        duration {
          max
          min
          isActive
        }
        name
        description
        isCod
        code
        isCod
        isActive
        isDeleted
        thDisplayName
        enDisplayName
        ... on ShippingShippop {
          setting {
            isDisabledSchedulePickUp
            price
          }
        }
        ... on ShippingLalamove {
          setting {
            price
          }
        }
        ... on ShippingFixedPrice {
          setting {
            price
          }
        }
        ... on ShippingPostalCode {
          setting {
            price
          }
        }
        ... on ShippingPickup {
          setting {
            isDisabledSchedulePickUp
          }
        }
      }
    }
  }
`;
const DEFAULT_CARRIERS = gql$1`
  query couriers($projectId: ID!) {
    couriers(projectId: $projectId) {
      results {
        code
        iconUrl
        isActive
        thDisplayName
        enDisplayName
      }
    }
  }
`;
const useDeleteShipping = (projectId) => {
  const [deleteShipping, { loading, data: data2 }] = useMutation(DELETE_SHIPPING);
  const handleDeleteShipping = useCallback((shippingId) => {
    return deleteShipping({
      variables: { projectId, shippingId },
      update(cache2) {
        var _a2, _b;
        const shippingsCache = cache2.readQuery({
          query: SHIPPINGS,
          variables: { projectId }
        });
        cache2.writeQuery({
          query: SHIPPINGS,
          variables: { projectId },
          data: {
            shippings: __spreadProps(__spreadValues({}, shippingsCache == null ? void 0 : shippingsCache.shippings), {
              results: (_b = (_a2 = shippingsCache == null ? void 0 : shippingsCache.shippings) == null ? void 0 : _a2.results) == null ? void 0 : _b.filter((shipping) => shipping.id !== shippingId)
            })
          }
        });
      }
    });
  }, [deleteShipping, projectId]);
  return {
    deleteShipping: handleDeleteShipping,
    isLoading: loading,
    data: data2 == null ? void 0 : data2.deleteShipping
  };
};
const useDuplicateShipping = (projectId) => {
  const [duplicateShipping, { loading }] = useMutation(DULICATE_SHIPPING);
  const handleDuplicateShipping = useCallback((shippingId) => {
    return duplicateShipping({
      variables: { projectId, shippingId },
      update(cache2, { data: updatedData }) {
        var _a2;
        const shippingsCache = cache2.readQuery({
          query: SHIPPINGS,
          variables: { projectId }
        });
        cache2.writeQuery({
          query: SHIPPINGS,
          variables: { projectId },
          data: {
            shippings: __spreadProps(__spreadValues({}, shippingsCache == null ? void 0 : shippingsCache.shippings), {
              results: [
                ...((_a2 = shippingsCache == null ? void 0 : shippingsCache.shippings) == null ? void 0 : _a2.results) || [],
                updatedData == null ? void 0 : updatedData.duplicateShipping
              ]
            })
          }
        });
      }
    });
  }, [duplicateShipping, projectId]);
  return {
    duplicateShipping: handleDuplicateShipping,
    isLoading: loading
  };
};
const useShippings = (projectId) => {
  const { loading: isLoading, data: data2 } = useQuery(SHIPPINGS, {
    variables: { projectId }
  });
  return {
    data: data2 == null ? void 0 : data2.shippings,
    isLoading
  };
};
const useUpdateShipping = () => {
  const [updateShipping, { loading }] = useMutation(UPDATE_SHIPPING);
  return {
    updateShipping,
    isLoading: loading
  };
};
const useToggleSchedulePickUp = (projectId) => {
  const { updateShipping, isLoading } = useUpdateShipping();
  const toggleSchedulePickUp = useCallback((shippingId, type, isDisabledSchedulePickUp) => {
    return updateShipping({
      variables: {
        projectId,
        shippingId,
        shipping: { type, setting: { isDisabledSchedulePickUp } }
      }
    });
  }, [projectId, updateShipping]);
  return {
    toggleSchedulePickUp,
    isLoading
  };
};
const useUpdateShippingStatus = (projectId) => {
  const [updateShippingStatus, { loading }] = useMutation(UPDATE_SHIPPING_STATUS);
  const handleUpdateShippingStatus = useCallback((shippingId, isActive) => {
    return updateShippingStatus({
      variables: { projectId, shippingId, isActive }
    });
  }, [projectId, updateShippingStatus]);
  return {
    updateShippingStatus: handleUpdateShippingStatus,
    isLoading: loading
  };
};
const getTotalActiveShipping = (shippings) => {
  return (shippings == null ? void 0 : shippings.reduce((total, shipping) => (shipping == null ? void 0 : shipping.isActive) ? total + 1 : total, 0)) || 0;
};
const useFilterPickUp = (shippings) => {
  const filterPickUp = useCallback(() => {
    let filteredResults = [];
    const filteringResults = (shippings == null ? void 0 : shippings.filter((shipping) => {
      const isTypePickUp = shipping.type === ShippingType.PICKUP;
      if (isTypePickUp) {
        filteredResults = [...filteredResults, shipping];
      }
      return !isTypePickUp;
    })) || [];
    return [filteringResults, filteredResults];
  }, [shippings]);
  return useMemo(filterPickUp, [filterPickUp]);
};
const MAP_CALCULATION_TYPE = {
  FIXED_PRICE: "shipping.calculationType.flatPrice",
  POSTAL_CODE: "shipping.calculationType.postalCode",
  MANUAL: "shipping.calculationType.mannual",
  SHIPPOP: "shipping.calculationType.shippop",
  LALAMOVE: "shipping.calculationType.lalamove",
  PICKUP: "shipping.calculationType.pickup"
};
const useFormatShippings = (shippings) => {
  const { i18n } = useTranslation();
  const formatShippingShippings = useCallback(() => {
    if (!shippings)
      return [];
    return shippings.map((shipping) => {
      var _a2, _b, _c;
      const price = (_a2 = shipping == null ? void 0 : shipping.setting) == null ? void 0 : _a2.price;
      const priceLabel = price != null ? `(\u0E3F${price})` : "";
      const name = i18n.language === "th" ? shipping.thDisplayName : shipping.enDisplayName;
      return {
        id: shipping.id,
        logo: shipping.iconUrl,
        name,
        description: shipping.isCod ? "shipping.shippingMethod.shippingMethodCard.COD" : "",
        shippingType: shipping.type,
        isActive: Boolean(shipping == null ? void 0 : shipping.isActive),
        shippingTypeLabel: MAP_CALCULATION_TYPE[shipping.type],
        priceLabel,
        estimatedDelivery: (shipping == null ? void 0 : shipping.duration) ? `${(_b = shipping == null ? void 0 : shipping.duration) == null ? void 0 : _b.min} - ${(_c = shipping == null ? void 0 : shipping.duration) == null ? void 0 : _c.max}` : ""
      };
    });
  }, [i18n.language, shippings]);
  const formattingResult = useMemo(formatShippingShippings, [
    formatShippingShippings
  ]);
  return formattingResult;
};
const useUpdateShippingInfoGraphic = (projectId) => {
  var _a2;
  const [updateShippingInfoGraphic, { loading, data: data2 }] = useMutation(UPSERT_SHIPPING_INFOGRAPHIC, {
    update(cache2, { data: updatedData }) {
      var _a3;
      const shippingsCache = cache2.readQuery({
        query: SHIPPINGS,
        variables: { projectId }
      });
      cache2.writeQuery({
        query: SHIPPINGS,
        variables: { projectId },
        data: {
          shippings: __spreadProps(__spreadValues({}, shippingsCache == null ? void 0 : shippingsCache.shippings), {
            shippingInfographic: {
              imageUrl: ((_a3 = updatedData == null ? void 0 : updatedData.upsertShippingInfographic) == null ? void 0 : _a3.imageUrl) || "",
              __typename: "ShippingInfographic"
            }
          })
        }
      });
    }
  });
  return {
    updateShippingInfoGraphic,
    isLoading: loading,
    data: (_a2 = data2 == null ? void 0 : data2.upsertShippingInfographic) == null ? void 0 : _a2.imageUrl
  };
};
const useHandleUpdateShippingInfoGraphic = (projectId) => {
  const { t: t2 } = useTranslation();
  const { uploadImage, isLoading: isUploadImageLoading } = useUploadImage();
  const {
    updateShippingInfoGraphic,
    data: data2,
    isLoading: isUpdatedImageUrlLoading
  } = useUpdateShippingInfoGraphic(projectId);
  const handleUpdateShippingInfoGraphic = useCallback(async (files) => {
    try {
      const uploadedImage = await uploadImage(projectId, files == null ? void 0 : files[0]);
      if (uploadedImage == null ? void 0 : uploadedImage.publicUrl) {
        await updateShippingInfoGraphic({
          variables: { projectId, imageUrl: uploadedImage == null ? void 0 : uploadedImage.publicUrl }
        });
      }
      notifySuccess(t2("notify.update.success"));
    } catch (error2) {
      notifyError(t2("notify.update.fail"));
    }
  }, [projectId, t2, updateShippingInfoGraphic, uploadImage]);
  const handleRemoveShippingInfoGraphic = useCallback(async () => {
    return updateShippingInfoGraphic({
      variables: { projectId, imageUrl: "" }
    });
  }, [projectId, updateShippingInfoGraphic]);
  return {
    data: data2,
    handleUpdateShippingInfoGraphic,
    handleRemoveShippingInfoGraphic,
    isLoading: isUploadImageLoading || isUpdatedImageUrlLoading
  };
};
const Shipping = ({
  projectId
}) => {
  var _a2, _b;
  const {
    t: t2
  } = useTranslation();
  const useHistory = (_a2 = window == null ? void 0 : window.getParentUseHistory) == null ? void 0 : _a2.call(window);
  const history = useHistory == null ? void 0 : useHistory();
  const {
    data: shippings,
    isLoading: isShippingDataLoading
  } = useShippings(projectId);
  const {
    toggleSchedulePickUp
  } = useToggleSchedulePickUp(projectId);
  const {
    updateShippingStatus
  } = useUpdateShippingStatus(projectId);
  const {
    duplicateShipping
  } = useDuplicateShipping(projectId);
  const {
    deleteShipping
  } = useDeleteShipping(projectId);
  const {
    isToggleOn: isOpenRemovingImageConfirmationModal,
    toggleSwitchOn: openRemovingImageConfirmationModal,
    toggleSwitchOff: closeRemovingImageConfirmationModal
  } = useToggleSwitch();
  const {
    isToggleOn: isOpenExampleModal,
    toggleSwitchOn: openExampleModal,
    toggleSwitchOff: closeExampleModal
  } = useToggleSwitch();
  const [filteringResults, filteredResults] = useFilterPickUp(shippings == null ? void 0 : shippings.results);
  const formattedShippings = useFormatShippings(filteringResults);
  const {
    handleUpdateShippingInfoGraphic,
    handleRemoveShippingInfoGraphic,
    isLoading: isUpdateShippingInfoGraphic
  } = useHandleUpdateShippingInfoGraphic(projectId);
  const handleRemoveImageUrl = async () => {
    try {
      await handleRemoveShippingInfoGraphic();
      notifySuccess(t2("notify.update.success"));
    } catch (error2) {
      notifyError(t2("notify.update.fail"));
    }
    closeRemovingImageConfirmationModal();
  };
  const redirectToManageBranchs = useCallback(() => {
    if (history) {
      history == null ? void 0 : history.push(`/project/${projectId}/store-settings/offline-store`);
    }
  }, [history, projectId]);
  const redirectToForm = useCallback(() => {
    if (history) {
      history.push(`/project/${projectId}/${SHIPPING}/${SHIPPING_FORM}`);
    }
  }, [history, projectId]);
  const handleToggleActive = useCallback(async (shippingId, isActive) => {
    var _a3;
    const numberOfShipmentsAreActive = getTotalActiveShipping(shippings == null ? void 0 : shippings.results);
    const foundShipping = (_a3 = shippings == null ? void 0 : shippings.results) == null ? void 0 : _a3.find((shipping) => shipping.id === shippingId);
    if (isActive === false && numberOfShipmentsAreActive === 1 && !!(foundShipping == null ? void 0 : foundShipping.isActive)) {
      notifyError(t2("shipping.noShippingActive"));
      return;
    }
    try {
      await updateShippingStatus(shippingId, isActive);
      notifySuccess(t2("notify.update.success"));
    } catch (error2) {
      notifyError(t2("notify.update.fail"));
    }
  }, [shippings == null ? void 0 : shippings.results, t2, updateShippingStatus]);
  const handleDuplicateShipping = useCallback(async (shippingId) => {
    if (filteringResults.length >= 4) {
      notifyError(t2("shipping.reachLimit"));
      return;
    }
    try {
      await duplicateShipping(shippingId);
      notifySuccess(t2("notify.update.success"));
    } catch (error2) {
      notifyError(t2("notify.update.fail"));
    }
  }, [duplicateShipping, filteringResults.length, t2]);
  const handleDeleteShipping = useCallback(async (shippingId) => {
    var _a3;
    if (filteringResults.length === 1) {
      notifyError(t2("shipping.noShippingActive"));
      return;
    }
    const deletedShippings = ((_a3 = shippings == null ? void 0 : shippings.results) == null ? void 0 : _a3.filter((shipping) => shipping.id !== shippingId)) || [];
    const numberOfShipmentsAreActive = getTotalActiveShipping(deletedShippings);
    if (!numberOfShipmentsAreActive) {
      notifyError(t2("shipping.noShippingActive"));
      return;
    }
    try {
      await deleteShipping(shippingId);
      notifySuccess(t2("notify.update.success"));
    } catch (error2) {
      notifyError(t2("notify.update.fail"));
    }
  }, [deleteShipping, filteringResults.length, shippings == null ? void 0 : shippings.results, t2]);
  const handleToggleSchedulePickUp = useCallback(async (shippingId, type, isNonScheduledPickUp) => {
    try {
      await toggleSchedulePickUp(shippingId, type, isNonScheduledPickUp);
      notifySuccess(t2("notify.update.success"));
    } catch (error2) {
      notifyError(t2("notify.update.fail"));
    }
  }, [t2, toggleSchedulePickUp]);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "tw-my-6 tablet:tw-mx-5",
      children: [/* @__PURE__ */ jsx$1(Typography, {
        className: "tw-mb-6 tw-ml-4 tablet:tw-ml-0",
        color: "Gray-800",
        variant: "title-4",
        children: t2("shipping.title")
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-mb-6",
        children: /* @__PURE__ */ jsx$1(ShippingMethod$1, {
          isLoading: isShippingDataLoading,
          shippingMethods: formattedShippings,
          onAdd: redirectToForm,
          onToogleActive: handleToggleActive,
          onDuplicate: handleDuplicateShipping,
          onDelete: handleDeleteShipping
        })
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-mb-6",
        children: filteredResults == null ? void 0 : filteredResults.map((filteredResult) => {
          var _a3;
          return /* @__PURE__ */ jsx$1(OfflinePickUp$1, {
            id: filteredResult.id,
            isActive: filteredResult.isActive,
            isNonScheduledPickUp: Boolean((_a3 = filteredResult == null ? void 0 : filteredResult.setting) == null ? void 0 : _a3.isDisabledSchedulePickUp),
            onToggleOfflinePickUp: handleToggleActive,
            onToggleNonScheduledPickUp: handleToggleSchedulePickUp,
            onClickManageStores: redirectToManageBranchs
          }, filteredResult.id);
        })
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-mb-6",
        children: /* @__PURE__ */ jsx$1(ShippingInfoGraphic$1, {
          onClickExample: openExampleModal,
          onRemove: openRemovingImageConfirmationModal,
          isUploadLoading: isUpdateShippingInfoGraphic,
          isImageUrlLoading: isShippingDataLoading,
          onUpload: handleUpdateShippingInfoGraphic,
          imageUrl: (_b = shippings == null ? void 0 : shippings.shippingInfographic) == null ? void 0 : _b.imageUrl
        })
      })]
    }), /* @__PURE__ */ jsx$1(ConfirmationModal$1, {
      title: t2("shipping.shippingMethod.confirmationModal.removeShippingInfoGraphic.title"),
      description: "",
      onClose: closeRemovingImageConfirmationModal,
      onSubmit: handleRemoveImageUrl,
      isOpen: isOpenRemovingImageConfirmationModal
    }), /* @__PURE__ */ jsx$1(ExampleModal, {
      isOpen: isOpenExampleModal,
      onClose: closeExampleModal
    })]
  });
};
const Page$2 = (props) => {
  return /* @__PURE__ */ jsx$1(ContextProviders, {
    children: /* @__PURE__ */ jsx$1(Shipping, __spreadValues({}, props))
  });
};
function ArrowLeftIcon(_J, svgRef) {
  var _K = _J, {
    title,
    titleId
  } = _K, props = __objRest(_K, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ React$2.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */ React$2.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */ React$2.createElement("path", {
    fillRule: "evenodd",
    d: "M17 10a.75.75 0 01-.75.75H5.612l4.158 3.96a.75.75 0 11-1.04 1.08l-5.5-5.25a.75.75 0 010-1.08l5.5-5.25a.75.75 0 111.04 1.08L5.612 9.25H16.25A.75.75 0 0117 10z",
    clipRule: "evenodd"
  }));
}
const ForwardRef$2 = React$2.forwardRef(ArrowLeftIcon);
var ArrowLeftIcon$1 = ForwardRef$2;
const carrierLogoUrl = "https://storage.googleapis.com/kanda-ai-core/static/carriers-logo/";
[
  {
    value: Carrier.BEST_EXPRESS,
    label: Carrier.BEST_EXPRESS,
    logo: `${carrierLogoUrl}best_express.png`
  },
  {
    value: Carrier.CJ,
    label: Carrier.CJ,
    logo: `${carrierLogoUrl}cj_logistics.png`
  },
  {
    value: Carrier.DHL,
    label: Carrier.DHL,
    logo: `${carrierLogoUrl}dhl.png`
  },
  {
    value: Carrier.FLASH_EXPRESS,
    label: Carrier.FLASH_EXPRESS,
    logo: `${carrierLogoUrl}flash_express.png`
  },
  {
    value: Carrier.INTER_EXPRESS,
    label: Carrier.INTER_EXPRESS,
    logo: `${carrierLogoUrl}inter_express.png`
  },
  {
    value: Carrier.J_AND_T,
    label: Carrier.J_AND_T,
    logo: `${carrierLogoUrl}j_and_t.png`
  },
  {
    value: Carrier.KERRY,
    label: Carrier.KERRY,
    logo: `${carrierLogoUrl}kerry.png`
  },
  {
    value: Carrier.NIM_EXPRESS,
    label: Carrier.NIM_EXPRESS,
    logo: `${carrierLogoUrl}nim.png`
  },
  {
    value: Carrier.NIM_EXPRESS_CHILLED,
    label: Carrier.NIM_EXPRESS_CHILLED,
    logo: `${carrierLogoUrl}nim.png`
  },
  {
    value: Carrier.NINJAVAN,
    label: Carrier.NINJAVAN,
    logo: `${carrierLogoUrl}ninjavan.png`
  },
  {
    value: Carrier.PORLOR_EXPRESS,
    label: Carrier.PORLOR_EXPRESS,
    logo: `${carrierLogoUrl}porlor.png`
  },
  {
    value: Carrier.SCG,
    label: Carrier.SCG,
    logo: `${carrierLogoUrl}scg_express.png`
  },
  {
    value: Carrier.SENDIT,
    label: Carrier.SENDIT,
    logo: `${carrierLogoUrl}sendit.png`
  },
  {
    value: Carrier.THAI_POST_EMS,
    label: Carrier.THAI_POST_EMS,
    logo: `${carrierLogoUrl}thaipost_ems.png`
  },
  {
    value: Carrier.THAI_POST_REGISTER,
    label: Carrier.THAI_POST_REGISTER,
    logo: `${carrierLogoUrl}thaipost.png`
  },
  {
    value: Carrier.TNT,
    label: Carrier.TNT,
    logo: `${carrierLogoUrl}tnt.png`
  },
  {
    value: Carrier.ZTO,
    label: Carrier.ZTO,
    logo: `${carrierLogoUrl}zto.png`
  },
  {
    value: Carrier.TPTRACK,
    label: Carrier.TPTRACK,
    logo: `${carrierLogoUrl}tptrack.png`
  },
  {
    value: Carrier.OTHER,
    label: "shipping.shippingMethod.other",
    logo: ""
  }
];
const MAX_PRICE = 1e6;
const DEPOSIT_OPTIONS = [
  {
    label: "shipping.shippingMethod.shippingForm.noDepositFee",
    value: PriceCalculationType.NONE
  },
  {
    label: "shipping.shippingMethod.shippingForm.percentage",
    value: PriceCalculationType.PERCENTAGE
  },
  {
    label: "shipping.shippingMethod.shippingForm.customPrice",
    value: PriceCalculationType.FIXED_PRICE
  }
];
const MANAGEMENT_OPTIONS = [
  {
    label: "shipping.shippingMethod.shippingForm.noManagementFee",
    value: PriceCalculationType.NONE
  },
  {
    label: "shipping.shippingMethod.shippingForm.percentage",
    value: PriceCalculationType.PERCENTAGE
  },
  {
    label: "shipping.shippingMethod.shippingForm.customPrice",
    value: PriceCalculationType.FIXED_PRICE
  }
];
const SHIPPING_OPTIONS = [
  {
    key: "1",
    name: "shipping.shippingMethod.selectShippingMethod.customizeShipping.title",
    description: "shipping.shippingMethod.selectShippingMethod.customizeShipping.description",
    logo: SHIPPING_LOGO,
    value: ShippingType.FIXED_PRICE
  },
  {
    key: "2",
    name: "shipping.shippingMethod.selectShippingMethod.connectShippop.title",
    description: "shipping.shippingMethod.selectShippingMethod.connectShippop.description",
    logo: SHIPPOP_LOGO,
    value: ShippingType.SHIPPOP,
    isCommingSoon: true
  },
  {
    key: "3",
    name: "shipping.shippingMethod.selectShippingMethod.connectLalamove.title",
    description: "shipping.shippingMethod.selectShippingMethod.connectLalamove.description",
    logo: LALAMOVE_LOGO,
    value: ShippingType.LALAMOVE,
    isCommingSoon: true
  }
];
const ShippingMethodOption = ({
  logo,
  name,
  description = "",
  className = "",
  onClickNext = () => {
  },
  leanMoreLinkUrl = "",
  isCommingSoon = false
}) => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(Card, {
    onClick: onClickNext,
    className: classNames$1(`tw-flex tw-bg-White ${className}`, {
      "tw-cursor-pointer": !isCommingSoon,
      "hover:tw-bg-NudePrimary": !isCommingSoon
    }),
    contentSize: ContentSize.MEDIUM_3,
    shadowSize: ElevationShadowType.NONE,
    children: [/* @__PURE__ */ jsx$1("img", {
      alt: "shippingLogo",
      className: "tw-w-14 tw-h-14",
      src: logo
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-flex-1 tw-mx-8",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "tw-mb-1",
        children: [/* @__PURE__ */ jsx$1(Typography, {
          variant: "title-7",
          className: "tw-inline",
          children: name
        }), isCommingSoon && /* @__PURE__ */ jsx$1(Typography, {
          variant: "title-10",
          color: "Gray-500",
          className: "tw-inline tw-p-1 tw-ml-3 tw-bg-Secondary tw-rounded",
          children: t2("shipping.shippingMethod.selectShippingMethod.comingSoon")
        })]
      }), Boolean(description) && /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-3",
        color: "Gray-500",
        className: "tw-mb-1",
        children: description
      }), Boolean(leanMoreLinkUrl) && /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-10",
        color: "Primary-600",
        className: "tw-mb-1",
        children: /* @__PURE__ */ jsx$1("a", {
          href: leanMoreLinkUrl,
          target: "_blank",
          rel: "noreferrer",
          children: t2("shipping.shippingMethod.selectShippingMethod.learnMore")
        })
      })]
    }), !isCommingSoon && /* @__PURE__ */ jsx$1(Icon, {
      name: IconName.NEXT,
      viewBox: "-4 -3 32 32",
      size: IconSize.LARGE,
      className: "tw-my-auto tw-fill-Gray-400"
    })]
  });
};
const SelectShippingMethod = ({
  onSelect = () => {
  }
}) => {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(Card, {
    className: "tw-bg-White",
    contentSize: ContentSize.MEDIUM_3,
    children: [/* @__PURE__ */ jsx$1(Typography, {
      variant: "title-7",
      className: "tw-mb-6",
      children: t2("shipping.shippingMethod.selectShippingMethod.title")
    }), SHIPPING_OPTIONS.map(({
      logo,
      key,
      name,
      description,
      isCommingSoon,
      value
    }) => /* @__PURE__ */ jsx$1(ShippingMethodOption, {
      name: t2(name),
      logo,
      description: t2(description),
      isCommingSoon,
      className: "tw-mb-6",
      onClickNext: () => {
        onSelect(value);
      }
    }, key))]
  });
};
var SelectShippingMethod$1 = memo(SelectShippingMethod);
const useCreateShipping = (projectId) => {
  const [createShipping, { loading }] = useMutation(CREATE_SHIPPING, {
    update(cache2, { data: updatedData }) {
      var _a2;
      if (!(updatedData == null ? void 0 : updatedData.createShipping))
        return;
      const shippingsCache = cache2.readQuery({
        query: SHIPPINGS,
        variables: { projectId }
      });
      cache2.writeQuery({
        query: SHIPPINGS,
        variables: { projectId },
        data: {
          shippings: __spreadProps(__spreadValues({}, shippingsCache == null ? void 0 : shippingsCache.shippings), {
            results: [
              ...((_a2 = shippingsCache == null ? void 0 : shippingsCache.shippings) == null ? void 0 : _a2.results) || [],
              updatedData == null ? void 0 : updatedData.createShipping
            ]
          })
        }
      });
    }
  });
  return {
    createShipping,
    isLoading: loading
  };
};
const ControllerSwitch = (props) => {
  const {
    onChange: onChange2,
    isReadOnly,
    value
  } = props;
  const {
    field
  } = useController(props);
  const handleChange = (event) => {
    field.onChange(event.target.checked);
    if (onChange2) {
      onChange2(event);
    }
  };
  return /* @__PURE__ */ jsx$1(Switch$1, {
    checked: value == null ? !!field.value : !!value,
    onChange: handleChange,
    disabled: isReadOnly
  });
};
const ControllerSelect = (props) => {
  const _a2 = props, {
    name,
    onChange: onChange2,
    value,
    defaultValue,
    options: options2,
    isDisabled,
    isReadOnly,
    control
  } = _a2, rest = __objRest(_a2, [
    "name",
    "onChange",
    "value",
    "defaultValue",
    "options",
    "isDisabled",
    "isReadOnly",
    "control"
  ]);
  const {
    field
  } = useController({
    name,
    control
  });
  const handleChange = (option) => {
    if (!option)
      return;
    field.onChange(option == null ? void 0 : option.value);
    if (onChange2) {
      onChange2(option, {
        action: "select-option",
        option
      });
    }
  };
  return /* @__PURE__ */ jsx$1(ReactSelect, __spreadProps(__spreadValues({}, rest), {
    defaultValue,
    options: options2,
    value,
    onChange: handleChange,
    isDisabled: isReadOnly || isDisabled,
    classNamePrefix: "react-select"
  }));
};
const CustomOption = (optionProps) => {
  const {
    t: t2
  } = useTranslation();
  const {
    data: data2
  } = optionProps;
  return /* @__PURE__ */ jsx$1(components.Option, __spreadProps(__spreadValues({}, optionProps), {
    children: /* @__PURE__ */ jsxs("span", {
      className: "tw-flex tw-items-center",
      children: [data2.logo && /* @__PURE__ */ jsx$1("img", {
        height: "45",
        width: "45",
        src: data2.logo,
        alt: t2(data2.value)
      }), /* @__PURE__ */ jsx$1("span", {
        className: "tw-ml-2",
        children: t2(data2.label)
      })]
    })
  }));
};
const CustomSingleValue = (singleValueProps) => {
  const {
    t: t2
  } = useTranslation();
  const {
    data: data2
  } = singleValueProps;
  return /* @__PURE__ */ jsx$1(components.SingleValue, __spreadProps(__spreadValues({}, singleValueProps), {
    children: /* @__PURE__ */ jsxs("span", {
      className: "tw-flex tw-items-center",
      children: [data2.logo && /* @__PURE__ */ jsx$1("img", {
        height: "45",
        width: "45",
        src: data2.logo,
        alt: t2(data2.value)
      }), /* @__PURE__ */ jsx$1("span", {
        className: "tw-ml-2",
        children: t2(data2.label)
      })]
    })
  }));
};
const CODForm = () => {
  var _a2, _b;
  const {
    t: t2
  } = useTranslation();
  const {
    setValue,
    control,
    watch,
    formState: {
      errors
    }
  } = useFormContext();
  const depositType = watch("depositType");
  const managementFeeType = watch("managementFeeType");
  const isPercentageDepositType = depositType === PriceCalculationType.PERCENTAGE;
  const isPercentageManagementFeeType = managementFeeType === PriceCalculationType.PERCENTAGE;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "tw-mb-4",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "tw-flex",
        children: [/* @__PURE__ */ jsx$1(Typography, {
          className: "tw-mr-1",
          variant: "title-9",
          color: (errors == null ? void 0 : errors.price) ? COLORS.Red : COLORS.Gray[600],
          children: t2("shipping.shippingMethod.shippingForm.minimumOrder")
        }), /* @__PURE__ */ jsxs(Typography, {
          className: "tw-w-fit tw-truncate",
          variant: "body-3",
          color: COLORS.Gray[400],
          children: ["- ", t2("shipping.shippingMethod.shippingForm.optional")]
        })]
      }), /* @__PURE__ */ jsx$1(Controller, {
        name: "minPriceOrder",
        control,
        render: ({
          field
        }) => /* @__PURE__ */ jsx$1(TextField$2, {
          defaultValue: field.value,
          onChange: (event) => {
            const value = Number(event.target.value.replace(",", ""));
            field.onChange(value);
          },
          placeholder: t2("shipping.shippingMethod.shippingForm.enterPrice"),
          thousandSeparator: true,
          type: "number",
          LeftIcon: /* @__PURE__ */ jsx$1("div", {
            className: "tw-flex tw-items-center",
            children: "\u0E3F"
          })
        })
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-mb-4",
      children: [/* @__PURE__ */ jsx$1(Typography, {
        className: "tw-mr-1",
        variant: "title-9",
        color: (errors == null ? void 0 : errors.price) ? COLORS.Red : COLORS.Gray[600],
        children: t2("shipping.shippingMethod.shippingForm.depositFee")
      }), /* @__PURE__ */ jsx$1(ControllerSelect, {
        onChange: () => {
          setValue("deposit", 0);
        },
        className: "tw-mb-3",
        name: "depositType",
        control,
        isSearchable: false,
        options: DEPOSIT_OPTIONS,
        styles: {
          control: (provided) => __spreadProps(__spreadValues({}, provided), {
            height: 50
          })
        },
        components: {
          SingleValue: CustomSingleValue,
          Option: CustomOption
        },
        defaultValue: DEPOSIT_OPTIONS[0]
      }), depositType !== PriceCalculationType.NONE && /* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx$1(Controller, {
          name: "deposit",
          control,
          render: ({
            field
          }) => /* @__PURE__ */ jsx$1(TextField$2, {
            decimal: isPercentageDepositType ? 2 : 0,
            defaultValue: field.value,
            onChange: (event) => {
              const value = Number(event.target.value.replace(",", ""));
              field.onChange(value);
            },
            placeholder: t2("shipping.shippingMethod.shippingForm.enterPrice"),
            thousandSeparator: true,
            type: "number",
            maxValue: isPercentageDepositType ? 100 : MAX_PRICE,
            LeftIcon: /* @__PURE__ */ jsx$1("div", {
              className: "tw-flex tw-items-center",
              children: isPercentageDepositType ? "%" : "\u0E3F"
            })
          })
        }), Boolean(errors == null ? void 0 : errors.deposit) && /* @__PURE__ */ jsx$1(Typography, {
          className: "tw-w-fit tw-truncate",
          variant: "body-3",
          color: COLORS.Red,
          children: t2((_a2 = errors == null ? void 0 : errors.deposit) == null ? void 0 : _a2.message)
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-mb-4",
      children: [/* @__PURE__ */ jsx$1(Typography, {
        className: "tw-mr-1",
        variant: "title-9",
        color: (errors == null ? void 0 : errors.price) ? COLORS.Red : COLORS.Gray[600],
        children: t2("shipping.shippingMethod.shippingForm.managementFee")
      }), /* @__PURE__ */ jsx$1(ControllerSelect, {
        onChange: () => {
          setValue("managementFee", 0);
        },
        name: "managementFeeType",
        className: "tw-mb-3",
        control,
        isSearchable: false,
        options: MANAGEMENT_OPTIONS,
        styles: {
          control: (provided) => __spreadProps(__spreadValues({}, provided), {
            height: 50
          })
        },
        components: {
          SingleValue: CustomSingleValue,
          Option: CustomOption
        },
        defaultValue: MANAGEMENT_OPTIONS[0]
      }), managementFeeType !== PriceCalculationType.NONE && /* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx$1(Controller, {
          name: "managementFee",
          control,
          render: ({
            field
          }) => /* @__PURE__ */ jsx$1(TextField$2, {
            defaultValue: field.value,
            onChange: (event) => {
              const value = Number(event.target.value.replace(",", ""));
              field.onChange(value);
            },
            placeholder: t2("shipping.shippingMethod.shippingForm.enterPrice"),
            thousandSeparator: true,
            type: "number",
            LeftIcon: /* @__PURE__ */ jsx$1("div", {
              className: "tw-flex tw-items-center",
              children: isPercentageManagementFeeType ? "%" : "\u0E3F"
            }),
            maxValue: isPercentageManagementFeeType ? 100 : MAX_PRICE,
            decimal: isPercentageManagementFeeType ? 2 : 0
          })
        }), Boolean(errors == null ? void 0 : errors.managementFee) && /* @__PURE__ */ jsx$1(Typography, {
          className: "tw-w-fit tw-truncate",
          variant: "body-3",
          color: COLORS.Red,
          children: t2((_b = errors == null ? void 0 : errors.managementFee) == null ? void 0 : _b.message)
        })]
      })]
    })]
  });
};
const FlatPriceForm = () => {
  const {
    t: t2
  } = useTranslation();
  const {
    control,
    watch,
    formState: {
      errors
    }
  } = useFormContext();
  const isCod = watch("isCOD");
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-p-4 tw-mb-4 tw-bg-NudeDarkBlue tw-rounded-lg",
      children: [/* @__PURE__ */ jsx$1(Icon, {
        name: IconName.INFO,
        size: IconSize.LARGE,
        className: "tw-fill-DarkBlue"
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-3",
        className: "tw-leading-8",
        children: t2("shipping.shippingMethod.shippingForm.flatPriceAlert")
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-mb-4",
      children: [/* @__PURE__ */ jsx$1(Typography, {
        className: "tw-w-fit tw-truncate",
        variant: "title-9",
        color: (errors == null ? void 0 : errors.price) ? COLORS.Red : COLORS.Gray[600],
        children: t2("shipping.shippingMethod.shippingForm.price")
      }), /* @__PURE__ */ jsx$1(Controller, {
        name: "price",
        control,
        render: ({
          field
        }) => /* @__PURE__ */ jsx$1(TextField$2, {
          defaultValue: field.value,
          onChange: (event) => {
            const value = Number(event.target.value.replace(",", ""));
            field.onChange(value);
          },
          placeholder: t2("shipping.shippingMethod.shippingForm.enterPrice"),
          thousandSeparator: true,
          type: "number",
          LeftIcon: /* @__PURE__ */ jsx$1("div", {
            className: "tw-flex tw-items-center",
            children: "\u0E3F"
          })
        })
      })]
    }), /* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsx$1(ControllerSwitch, {
        name: "isCOD",
        control
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-9",
        className: "tw-inline tw-ml-2 tw-align-super",
        children: t2("shipping.shippingMethod.shippingForm.cod")
      })]
    }), isCod && /* @__PURE__ */ jsx$1("div", {
      className: "tw-mt-4",
      children: /* @__PURE__ */ jsx$1(CODForm, {})
    })]
  });
};
const ManualForm = () => {
  const {
    t: t2
  } = useTranslation();
  const {
    watch,
    control
  } = useFormContext();
  const isCod = watch("isCOD");
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-p-4 tw-mb-5 tw-bg-NudeDarkBlue tw-rounded-lg",
      children: [/* @__PURE__ */ jsx$1(Icon, {
        name: IconName.INFO,
        size: IconSize.LARGE,
        className: "tw-fill-DarkBlue"
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-3",
        className: "tw-leading-8",
        children: t2("shipping.shippingMethod.shippingForm.manualPriceAlert")
      })]
    }), /* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsx$1(ControllerSwitch, {
        name: "isCOD",
        control
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-9",
        className: "tw-inline tw-ml-2 tw-align-super",
        children: t2("shipping.shippingMethod.shippingForm.cod")
      })]
    }), isCod && /* @__PURE__ */ jsx$1("div", {
      className: "tw-mt-4",
      children: /* @__PURE__ */ jsx$1(CODForm, {})
    })]
  });
};
const ShippingDetailFormSchema = create({
  isActive: create$3().required(),
  carrierName: create$2().required("shipping.shippingMethod.shippingForm.carrierNameIsRequired"),
  hasEstimatedTime: create$3().required(),
  otherCarrierName: create$2().when("carrierName", (value, schema2) => {
    if (value === Carrier.OTHER)
      return schema2.required("shipping.shippingMethod.shippingForm.carrierNameIsRequired");
    return schema2;
  }),
  price: create$1().required(),
  isCOD: create$3().required(),
  shippingType: create$2().required(),
  estimatedTimeStart: create$1().test("invalid", "shipping.shippingMethod.shippingForm.maxCannotZero", function(value = 0) {
    if (this.parent.hasEstimatedTime && value === 0) {
      return false;
    }
    return true;
  }).test("required", "shipping.shippingMethod.shippingForm.minLessThanMax", function(value = 0) {
    if (this.parent.hasEstimatedTime && value >= this.parent.estimatedTimeEnd) {
      return false;
    }
    return true;
  }),
  estimatedTimeEnd: create$1().test("invalid", "shipping.shippingMethod.shippingForm.maxCannotZero", function(value = 0) {
    if (this.parent.hasEstimatedTime && value === 0) {
      return false;
    }
    return true;
  }).test("required", "shipping.shippingMethod.shippingForm.maxMoreThanMin", function(value = 0) {
    if (this.parent.hasEstimatedTime && value <= this.parent.estimatedTimeStart) {
      return false;
    }
    return true;
  }),
  depositType: create$2(),
  deposit: create$1().test("required", "shipping.shippingMethod.shippingForm.depositCannotZero", function(value = 0) {
    if (this.parent.isCOD && this.parent.depositType !== PriceCalculationType.NONE && value === 0) {
      return false;
    }
    return true;
  }),
  managementFeeType: create$2(),
  managementFee: create$1().test("required", "shipping.shippingMethod.shippingForm.managementFeeCannotZero", function(value = 0) {
    if (this.parent.isCOD && this.parent.managementFeeType !== PriceCalculationType.NONE && value === 0) {
      return false;
    }
    return true;
  }),
  minPriceOrder: create$1()
});
const Counter = ({
  defaultValue = 0,
  value,
  onIncrease,
  onDecrease,
  onChange: onChange2
}, ref) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "tw-flex tw-h-9",
    children: [/* @__PURE__ */ jsx$1(Button, {
      variant: "secondary",
      size: "none",
      className: "tw-w-9",
      onClick: onDecrease,
      children: "-"
    }), /* @__PURE__ */ jsx$1(NumberFormat, {
      thousandSeparator: true,
      className: "tw-w-16 tw-text-center tw-border tw-border-Gray-200 tw-border-solid",
      defaultValue,
      value,
      ref,
      onChange: onChange2
    }), /* @__PURE__ */ jsx$1(Button, {
      variant: "secondary",
      size: "none",
      className: "tw-w-9",
      onClick: onIncrease,
      children: "+"
    })]
  });
};
var Counter$1 = forwardRef(Counter);
const ShippingDetailForm = ({
  carrierOptions = []
}) => {
  var _a2, _b, _c, _d;
  const {
    t: t2
  } = useTranslation();
  const {
    register,
    control,
    watch,
    formState: {
      errors
    }
  } = useFormContext();
  const hasEstimatedTime = watch("hasEstimatedTime");
  const carrierName = watch("carrierName");
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx$1(Typography, {
      variant: "title-5",
      className: "tw-mb-5",
      children: t2("shipping.shippingMethod.shippingForm.shippingDetail")
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-mb-6",
      children: [/* @__PURE__ */ jsx$1(Typography, {
        className: "tw-w-fit tw-truncate",
        variant: "title-9",
        color: (errors == null ? void 0 : errors.carrierName) ? COLORS.Red : COLORS.Gray[600],
        children: t2("shipping.shippingMethod.shippingForm.carrier")
      }), /* @__PURE__ */ jsx$1(ControllerSelect, {
        name: "carrierName",
        control,
        isSearchable: false,
        options: carrierOptions,
        components: {
          SingleValue: CustomSingleValue,
          Option: CustomOption
        },
        styles: {
          control: (provided) => __spreadProps(__spreadValues({}, provided), {
            height: 50
          })
        },
        placeholder: t2("shipping.shippingMethod.shippingForm.selectCarrier")
      }), Boolean(errors == null ? void 0 : errors.carrierName) && /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-w-fit tw-truncate",
        variant: "body-3",
        color: COLORS.Red,
        children: t2((_a2 = errors == null ? void 0 : errors.carrierName) == null ? void 0 : _a2.message)
      })]
    }), carrierName === Carrier.OTHER && /* @__PURE__ */ jsxs("div", {
      className: "tw-mb-3",
      children: [/* @__PURE__ */ jsx$1(TextField$2, __spreadProps(__spreadValues({}, register("otherCarrierName")), {
        placeholder: t2("shipping.shippingMethod.shippingForm.name")
      })), Boolean(errors == null ? void 0 : errors.otherCarrierName) && /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-w-fit tw-truncate",
        variant: "body-3",
        color: COLORS.Red,
        children: t2((_b = errors == null ? void 0 : errors.otherCarrierName) == null ? void 0 : _b.message)
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-mb-5",
      children: [/* @__PURE__ */ jsx$1(ControllerSwitch, {
        name: "hasEstimatedTime",
        control
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-9",
        className: "tw-inline tw-ml-2 tw-align-super",
        children: t2("shipping.shippingMethod.shippingForm.estimatedTime")
      })]
    }), hasEstimatedTime && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-items-center tw-mb-3",
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "tw-mr-2",
          children: /* @__PURE__ */ jsx$1(Controller, {
            name: "estimatedTimeStart",
            control,
            rules: {
              required: true
            },
            defaultValue: 0,
            render: ({
              field
            }) => /* @__PURE__ */ jsx$1(Counter$1, {
              value: field.value,
              defaultValue: 0,
              onDecrease: () => {
                field.onChange(field.value > 0 ? field.value - 1 : 0);
              },
              onIncrease: () => {
                field.onChange(field.value + 1);
              },
              onChange: (event) => {
                field.onChange(event.target.value);
              }
            })
          })
        }), t2("shipping.shippingMethod.shippingForm.to"), /* @__PURE__ */ jsx$1("div", {
          className: "tw-mx-2",
          children: /* @__PURE__ */ jsx$1(Controller, {
            name: "estimatedTimeEnd",
            control,
            rules: {
              required: true
            },
            render: ({
              field
            }) => /* @__PURE__ */ jsx$1(Counter$1, {
              value: field.value,
              defaultValue: 0,
              onDecrease: () => {
                field.onChange(field.value > 0 ? field.value - 1 : 0);
              },
              onIncrease: () => {
                field.onChange(field.value + 1);
              },
              onChange: (event) => {
                field.onChange(event.target.value);
              }
            })
          })
        }), t2("common.date.days")]
      }), Boolean(errors == null ? void 0 : errors.estimatedTimeStart) && /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-w-fit tw-truncate",
        variant: "body-3",
        color: COLORS.Red,
        children: t2((_c = errors == null ? void 0 : errors.estimatedTimeStart) == null ? void 0 : _c.message)
      }), Boolean(errors == null ? void 0 : errors.estimatedTimeEnd) && /* @__PURE__ */ jsx$1(Typography, {
        className: "tw-w-fit tw-truncate",
        variant: "body-3",
        color: COLORS.Red,
        children: t2((_d = errors == null ? void 0 : errors.estimatedTimeEnd) == null ? void 0 : _d.message)
      })]
    })]
  });
};
var RadioButton$1 = "";
const RadioButton = (props) => {
  const _a2 = props, {
    label,
    className = ""
  } = _a2, rest = __objRest(_a2, [
    "label",
    "className"
  ]);
  return /* @__PURE__ */ jsxs("div", {
    className: `tw-inline-block tw-relative ${className}`,
    children: [/* @__PURE__ */ jsx$1("input", __spreadValues({
      type: "radio",
      className: `
          tw-cursor-pointer
          radio-button
          checked:disabled:tw-bg-LightNudePrimary
          checked:disabled:tw-border-DarkNudePrimary
          checked:tw-bg-NudePrimary
          checked:tw-border-Primary
          disabled:tw-bg-Gray-200
          disabled:tw-border-Gray-400
          tw-bg-White
          tw-border-Gray-400
          tw-border  
          tw-rounded
          tw-text-Gray-600
          tw-appearance-none
          tw-h-9
          tw-absolute tw-top-0 tw-left-0 tw-right-0 tw-bottom-0
          tw-w-full`
    }, rest)), /* @__PURE__ */ jsx$1("div", {
      className: "tw-relative tw-py-2 tw-px-4 tw-m-0 tw-pointer-events-none check-1",
      children: label
    })]
  });
};
RadioButton.displayName = "RadioButton";
const ShippingTypeButtonGroup = () => {
  const {
    t: t2
  } = useTranslation();
  const {
    control,
    watch
  } = useFormContext();
  const shippingType = watch("shippingType");
  return /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1(Controller, {
      name: "shippingType",
      control,
      rules: {
        required: true
      },
      render: ({
        field
      }) => /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx$1(RadioButton, {
          defaultChecked: shippingType === ShippingType.FIXED_PRICE,
          label: t2("shipping.shippingMethod.shippingForm.flatPrice"),
          name: "shippingType",
          value: ShippingType.FIXED_PRICE,
          onClick: () => field.onChange(ShippingType.FIXED_PRICE),
          className: "tw-m-2 tw-ml-0"
        }), /* @__PURE__ */ jsx$1(RadioButton, {
          defaultChecked: shippingType === ShippingType.MANUAL,
          label: t2("shipping.shippingMethod.shippingForm.manual"),
          name: "shippingType",
          value: ShippingType.MANUAL,
          onClick: () => field.onChange(ShippingType.MANUAL),
          className: "tw-m-2"
        }), /* @__PURE__ */ jsx$1(RadioButton, {
          defaultChecked: shippingType === ShippingType.POSTAL_CODE,
          label: t2("shipping.shippingMethod.shippingForm.postcodeBased"),
          name: "shippingType",
          value: ShippingType.POSTAL_CODE,
          onClick: () => field.onChange(ShippingType.POSTAL_CODE),
          className: "tw-m-2",
          disabled: true
        })]
      })
    })
  });
};
const ShippingForm = ({
  isLoading = false,
  onSubmit = () => {
  },
  onCancel = () => {
  },
  onBack = () => {
  },
  carrierOptions = []
}) => {
  const {
    t: t2
  } = useTranslation();
  const {
    isTablet,
    isDesktop,
    isFullScreen
  } = useScreenSize();
  const isLargeScreen = isTablet || isDesktop || isFullScreen;
  const defaultValues = {
    isActive: true,
    carrierName: "",
    hasEstimatedTime: false,
    otherCarrierName: "",
    price: 0,
    isCOD: false,
    shippingType: ShippingType.FIXED_PRICE,
    estimatedTimeStart: 0,
    estimatedTimeEnd: 0,
    minPriceOrder: 0,
    depositType: PriceCalculationType.NONE,
    deposit: 0,
    managementFeeType: PriceCalculationType.NONE,
    managementFee: 0
  };
  const methods = useForm({
    defaultValues,
    resolver: o(ShippingDetailFormSchema)
  });
  const {
    control,
    watch,
    handleSubmit
  } = methods;
  const isActive = watch("isActive");
  const shippingType = watch("shippingType");
  return /* @__PURE__ */ jsx$1(FormProvider, __spreadProps(__spreadValues({}, methods), {
    children: /* @__PURE__ */ jsx$1("form", {
      onSubmit: handleSubmit(onSubmit),
      children: /* @__PURE__ */ jsxs("div", {
        className: "tw-my-6",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "tw-flex tw-flex-col tw-mx-4 tw-mb-5 tablet:tw-flex-row tablet:tw-justify-between tablet:tw-mx-0",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "tw-inline-flex tw-items-center",
            children: [/* @__PURE__ */ jsx$1(Button, {
              variant: "custom",
              size: "none",
              onClick: onBack,
              className: "tw-mr-4 tw-bg-primary-200 hover:tw-bg-primary-300 active:tw-bg-primary-300 tw-rounded-full",
              children: /* @__PURE__ */ jsx$1("span", {
                className: "tw-inline-flex tw-justify-center tw-items-center tw-w-9 tw-h-9 tw-rounded-full",
                children: /* @__PURE__ */ jsx$1(ArrowLeftIcon$1, {
                  className: "tw-w-5 tw-h-5 tw-text-Primary-500"
                })
              })
            }), /* @__PURE__ */ jsx$1(Typography, {
              variant: "title-4",
              children: t2("shipping.shippingMethod.shippingForm.addShipping")
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: "tw-flex tw-items-center tw-mt-6 tw-ml-auto tw-w-auto tablet:tw-mt-0 tablet:tw-ml-0",
            children: [/* @__PURE__ */ jsx$1(ControllerSwitch, {
              name: "isActive",
              control
            }), /* @__PURE__ */ jsx$1(Typography, {
              variant: "body-3",
              className: "tw-ml-2",
              children: isActive ? t2("shipping.shippingMethod.shippingForm.active") : t2("shipping.shippingMethod.shippingForm.inactive")
            })]
          })]
        }), /* @__PURE__ */ jsx$1(Card, {
          className: "tw-mb-6 tw-bg-White",
          contentSize: ContentSize.MEDIUM_3,
          children: /* @__PURE__ */ jsx$1(ShippingDetailForm, {
            carrierOptions
          })
        }), /* @__PURE__ */ jsxs(Card, {
          className: "tw-bg-White",
          contentSize: ContentSize.MEDIUM_3,
          children: [/* @__PURE__ */ jsx$1(Typography, {
            variant: "title-5",
            className: "tw-mb-5",
            children: t2("shipping.shippingMethod.shippingForm.selectPriceCalculation")
          }), /* @__PURE__ */ jsx$1("div", {
            className: "tw-mb-4",
            children: /* @__PURE__ */ jsx$1(ShippingTypeButtonGroup, {})
          }), shippingType === ShippingType.FIXED_PRICE && /* @__PURE__ */ jsx$1(FlatPriceForm, {}), shippingType === ShippingType.MANUAL && /* @__PURE__ */ jsx$1(ManualForm, {})]
        }), /* @__PURE__ */ jsxs("div", {
          className: "tw-flex tw-flex-col-reverse tw-my-6 tw-mx-4 tablet:tw-flex-row tablet:tw-justify-end tablet:tw-mx-0",
          children: [/* @__PURE__ */ jsx$1(Button, {
            className: "tw-mt-4 tablet:tw-mt-0 tablet:tw-mr-6",
            type: "button",
            isLoading,
            size: isLargeScreen ? "large" : "fullWidth",
            variant: "text",
            onClick: onCancel,
            children: t2("shipping.shippingMethod.shippingForm.cancel")
          }), /* @__PURE__ */ jsx$1(Button, {
            type: "submit",
            isLoading,
            size: isLargeScreen ? "large" : "fullWidth",
            variant: "primary",
            children: t2("shipping.shippingMethod.shippingForm.save")
          })]
        })]
      })
    })
  }));
};
var ShippingForm$1 = memo(ShippingForm);
const useCarriers = (projectId) => {
  const { data: data2, loading } = useQuery(DEFAULT_CARRIERS, {
    skip: !projectId,
    variables: {
      projectId
    }
  });
  return {
    data: data2 == null ? void 0 : data2.couriers,
    isLoading: loading
  };
};
const useCarrierOptions = (projectId) => {
  const { i18n, t: t2 } = useTranslation();
  const { data: data2, isLoading } = useCarriers(projectId);
  const carriers = data2 == null ? void 0 : data2.results;
  const carrierOptions = useMemo(() => carriers ? [
    ...carriers.filter(({ isActive }) => isActive).map(({ code, iconUrl, thDisplayName, enDisplayName }) => ({
      logo: iconUrl || "",
      value: code,
      label: i18n.language === "en" ? enDisplayName : thDisplayName
    })),
    {
      value: Carrier.OTHER,
      label: t2("shipping.shippingMethod.other"),
      logo: ""
    }
  ] : [], [carriers, i18n.language, t2]);
  return { carrierOptions, isLoading };
};
const ShippingFormPage = ({
  projectId
}) => {
  var _a2;
  const {
    t: t2
  } = useTranslation();
  const useHistory = (_a2 = window == null ? void 0 : window.getParentUseHistory) == null ? void 0 : _a2.call(window);
  const history = useHistory == null ? void 0 : useHistory();
  const [selectedShippingType, setSelectedShippingType] = useState();
  const [formStep, setFormStep] = useState(1);
  const {
    createShipping,
    isLoading
  } = useCreateShipping(projectId);
  const {
    carrierOptions
  } = useCarrierOptions(projectId);
  const next2 = useCallback(() => {
    setFormStep(2);
  }, []);
  const onSelectShippingType = useCallback((value) => {
    setSelectedShippingType(value);
    next2();
  }, [next2]);
  const backToDefaultShipping = useCallback(() => {
    if (history) {
      history.push(`/project/${projectId}/${SHIPPING}/${SHIPPING_DEFAULT}`);
    }
  }, [history, projectId]);
  const backToStepOne = useCallback(() => {
    setFormStep(1);
    setSelectedShippingType(void 0);
  }, []);
  const onSubmitFlatPrice = useCallback(async (data2) => {
    const getFeeByPriceCalculationType = (fieldname, priceCalculationType) => {
      switch (priceCalculationType) {
        case PriceCalculationType.FIXED_PRICE:
          return {
            fee: data2[fieldname]
          };
        case PriceCalculationType.PERCENTAGE:
          return {
            percent: data2[fieldname]
          };
        default:
          return {};
      }
    };
    const getSettingByShippingType = () => {
      if (data2.shippingType === ShippingType.MANUAL)
        return {};
      return {
        setting: {
          price: data2.price
        }
      };
    };
    const managementFee = getFeeByPriceCalculationType("managementFee", data2.managementFeeType);
    const deposit = getFeeByPriceCalculationType("deposit", data2.depositType);
    const setting = getSettingByShippingType();
    const codInformation = data2.isCOD ? {
      codInformation: {
        paymentType: "ALL",
        minTotalPriceOrder: data2.minPriceOrder,
        managementFee: __spreadValues({
          type: data2.managementFeeType
        }, managementFee),
        deposit: __spreadValues({
          type: data2.depositType
        }, deposit)
      }
    } : {};
    const shippingData = __spreadValues(__spreadValues({
      type: data2.shippingType,
      duration: data2.hasEstimatedTime ? {
        max: data2.estimatedTimeEnd,
        min: data2.estimatedTimeStart,
        isActive: data2.hasEstimatedTime
      } : void 0,
      name: data2.carrierName === Carrier.OTHER ? data2.otherCarrierName : data2.carrierName,
      isActive: data2.isActive,
      isCod: data2.isCOD
    }, setting), codInformation);
    try {
      await createShipping({
        variables: {
          projectId,
          shipping: shippingData
        }
      });
      backToDefaultShipping();
      notifySuccess(t2("notify.update.success"));
    } catch (error2) {
      notifyError(t2("notify.update.fail"));
    }
  }, [backToDefaultShipping, createShipping, projectId, t2]);
  if (formStep === 2 && selectedShippingType === ShippingType.FIXED_PRICE) {
    return /* @__PURE__ */ jsx$1("div", {
      className: "tw-mt-6 tablet:tw-mx-5",
      children: /* @__PURE__ */ jsx$1(ShippingForm$1, {
        carrierOptions,
        onSubmit: onSubmitFlatPrice,
        isLoading,
        onBack: backToStepOne,
        onCancel: backToDefaultShipping
      })
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "tw-mt-6 tablet:tw-mx-5",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-mx-4 tw-mb-5 tablet:tw-mx-0",
      children: [/* @__PURE__ */ jsx$1(Button, {
        variant: "custom",
        size: "none",
        onClick: backToDefaultShipping,
        className: "tw-mr-4 tw-bg-primary-200 hover:tw-bg-primary-300 active:tw-bg-primary-300 tw-rounded-full",
        children: /* @__PURE__ */ jsx$1("span", {
          className: "tw-inline-flex tw-justify-center tw-items-center tw-w-9 tw-h-9 tw-rounded-full",
          children: /* @__PURE__ */ jsx$1(ArrowLeftIcon$1, {
            className: "tw-w-5 tw-h-5 tw-text-Primary-500"
          })
        })
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-4",
        children: t2("shipping.shippingMethod.shippingForm.addShipping")
      })]
    }), /* @__PURE__ */ jsx$1(SelectShippingMethod$1, {
      onSelect: onSelectShippingType
    })]
  });
};
const Page$1 = (props) => {
  return /* @__PURE__ */ jsx$1(ContextProviders, {
    children: /* @__PURE__ */ jsx$1(ShippingFormPage, __spreadValues({}, props))
  });
};
const useScrollTo = () => {
  const ref = useRef(null);
  const [shouldScrollTo, setShouldScrollTo] = useState(false);
  useEffect(() => {
    if (ref.current && shouldScrollTo) {
      ref.current.scrollIntoView({ behavior: "smooth" });
      setShouldScrollTo(false);
    }
  }, [shouldScrollTo]);
  return [ref, () => setShouldScrollTo(true)];
};
const headerClassName = "tw-text-center tw-text-Dark tw-bg-LightNudePrimary tw-px-4 tw-w-1/12 title-8 tw-font-medium";
const columnClassName = "tw-text-center tw-bg-White tw-pt-6 tw-w-1/12";
const data = {
  manualApprovalOrders: {
    FREE: "50",
    STARTER_1: "40",
    STARTER_2: "100",
    STARTER_3: "200",
    STANDARD: "300",
    PROFESSIONAL: "1,500",
    PREMIUM: "5,000"
  },
  bankTransferFee: {
    FREE: "Free",
    STARTER_1: "Free",
    STARTER_2: "Free",
    STARTER_3: "Free",
    STANDARD: "Free",
    PROFESSIONAL: "Free",
    PREMIUM: "Free"
  }
};
function DataCell(cell) {
  const {
    t: t2
  } = useTranslation();
  const {
    row,
    column: column2
  } = cell;
  const columnType = column2.type;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx$1(Typography, {
      variant: "title-9",
      color: COLORS.Gray[500],
      children: data[row.original.key][columnType]
    }), row.original.key === "manualApprovalOrders" && /* @__PURE__ */ jsx$1(Typography, {
      variant: "title-9",
      color: COLORS.Gray[500],
      children: t2("plan.upgradePlan.table.feature.manualOrders")
    })]
  });
}
function HeaderCell({
  row
}) {
  const {
    title,
    tooltips
  } = row.original;
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsxs(Typography, {
    variant: "title-8",
    color: COLORS.Gray[500],
    children: [title, Array.isArray(tooltips) && /* @__PURE__ */ jsx$1(Tooltip, {
      description: /* @__PURE__ */ jsx$1("ul", {
        className: "tw-list-disc",
        children: tooltips.map((tooltip) => /* @__PURE__ */ jsx$1("li", {
          children: t2(`plan.upgradePlan.table.titleInfo.${tooltip}`)
        }, tooltip))
      }),
      arrow: "left-center",
      position: "right",
      children: /* @__PURE__ */ jsx$1(Icon, {
        name: IconName.QUESTION_MARK,
        size: IconSize.MEDIUM,
        className: "tw-ml-1",
        color: COLORS.Gray[500]
      })
    })]
  });
}
const convertPriceFormat = (price, minimumFractionDigits = 2, maximumFractionDigits = 2) => {
  var _a2;
  return (_a2 = price == null ? void 0 : price.toLocaleString) == null ? void 0 : _a2.call(price, "en-US", {
    minimumFractionDigits,
    maximumFractionDigits
  });
};
function Cell({
  value
}) {
  const {
    t: t2
  } = useTranslation();
  if (typeof value === "number" && value === -1) {
    return i18next.t("plan.upgradePlan.table.unlimited");
  }
  if (typeof value === "string" && value === "custom") {
    return /* @__PURE__ */ jsx$1("div", {
      className: "tw-flex tw-justify-center tw-items-center tw-w-5 tw-h-5 tw-bg-Primary-200 tw-rounded-full",
      children: /* @__PURE__ */ jsx$1(Icon, {
        name: IconName.SETTING,
        size: IconSize.SMALL,
        style: {
          margin: "auto"
        },
        color: COLORS.Primary[600]
      })
    });
  }
  if (typeof value === "boolean") {
    return /* @__PURE__ */ jsx$1(Icon, {
      name: value ? IconName.OUTLINE_CHECK_CIRCLE : IconName.OUTLINE_X_CIRCLE,
      size: IconSize.MEDIUM,
      style: {
        margin: "auto"
      }
    });
  }
  if (typeof value === "number") {
    return convertPriceFormat(value, 0, 2);
  }
  return t2(value);
}
function generateData$1(columnKeys2, plans, renderCell2) {
  return columnKeys2.map((columnKey) => {
    var _a2, _b, _c, _d, _e2, _f, _g;
    const key = columnKey == null ? void 0 : columnKey.key;
    const free = renderCell2({
      value: (_a2 = plans == null ? void 0 : plans.FREE) == null ? void 0 : _a2[key]
    });
    const starter_1 = renderCell2({ value: (_b = plans == null ? void 0 : plans.STARTER_1) == null ? void 0 : _b[key] });
    const starter_2 = renderCell2({ value: (_c = plans == null ? void 0 : plans.STARTER_2) == null ? void 0 : _c[key] });
    const starter_3 = renderCell2({ value: (_d = plans == null ? void 0 : plans.STARTER_3) == null ? void 0 : _d[key] });
    const standard = renderCell2({ value: (_e2 = plans == null ? void 0 : plans.STANDARD) == null ? void 0 : _e2[key] });
    const premium = renderCell2({ value: (_f = plans == null ? void 0 : plans.PREMIUM) == null ? void 0 : _f[key] });
    const profession = renderCell2({
      value: (_g = plans == null ? void 0 : plans.PROFESSIONAL) == null ? void 0 : _g[key]
    });
    return __spreadProps(__spreadValues({}, columnKey), {
      title: i18next.t(`plan.upgradePlan.table.feature.${key}`),
      free,
      starter_1,
      starter_2,
      starter_3,
      standard,
      premium,
      profession
    });
  });
}
function useTable(plans, headerColumn, packageColumns, columnKeys2) {
  if (isEmpty_1(plans)) {
    return {
      columns: [],
      data: []
    };
  }
  const existsPlans = Object.keys(plans);
  const filterPackageColumns = packageColumns.filter(({
    type
  }) => existsPlans.includes(type));
  const columns = [headerColumn, ...filterPackageColumns];
  const data2 = generateData$1(columnKeys2, plans, Cell);
  return {
    columns,
    data: data2
  };
}
const columnKeys = [{
  key: "bankTransferFee",
  tooltips: ["zeroFee", "limitOrder"]
}, {
  key: "manualApprovalOrders"
}];
function BankTransferTable({
  plans
}) {
  const {
    t: t2
  } = useTranslation();
  const headerColumn = {
    Header: t2(`plan.upgradePlan.table.title.bankTransferTable`),
    headerClassName: "tw-text-left tw-text-Primary-600 tw-bg-LightNudePrimary tw-px-8 tw-py-4 tw-max-w-[20px] tw-w-3/12 tw-rounded-bl tw-rounded-tl title-8 tw-font-medium",
    columnClassName: "tw-text-left tw-pl-16 tw-bg-White  tw-max-w-[200px] tw-w-1/12 tw-pt-6",
    Cell: HeaderCell
  };
  const packageColumns = [{
    type: "FREE",
    Header: t2(`plan.upgradePlan.common.freePlan`),
    headerClassName,
    columnClassName,
    Cell: DataCell
  }, {
    type: "STARTER_1",
    Header: t2(`plan.upgradePlan.common.starter_1`),
    headerClassName,
    columnClassName,
    Cell: DataCell
  }, {
    type: "STARTER_2",
    Header: t2(`plan.upgradePlan.common.starter_2`),
    headerClassName,
    columnClassName,
    Cell: DataCell
  }, {
    type: "STARTER_3",
    Header: t2(`plan.upgradePlan.common.starter_3`),
    headerClassName,
    columnClassName,
    Cell: DataCell
  }, {
    type: "STANDARD",
    Header: t2(`plan.upgradePlan.common.basicPlan`),
    headerClassName,
    columnClassName,
    Cell: DataCell
  }, {
    type: "PROFESSIONAL",
    Header: t2(`plan.upgradePlan.common.standardPlan`),
    headerClassName: classNames$1(headerClassName, "tw-w-2/12"),
    columnClassName: classNames$1(columnClassName, "tw-w-2/12"),
    Cell: DataCell
  }, {
    type: "PREMIUM",
    Header: t2(`plan.upgradePlan.common.advancedPlan`),
    headerClassName: classNames$1(headerClassName, "tw-rounded-br tw-rounded-tr tw-w-2/12"),
    columnClassName: "tw-text-center tw-bg-White tw-pt-6 tw-w-2/12",
    Cell: DataCell
  }];
  const {
    data: data2,
    columns
  } = useTable(plans, headerColumn, packageColumns, columnKeys);
  return /* @__PURE__ */ jsx$1(Table, {
    data: data2,
    columns
  });
}
var EntityLevel;
(function(EntityLevel2) {
  EntityLevel2["FREE"] = "FREE";
  EntityLevel2["STARTER_1"] = "STARTER_1";
  EntityLevel2["STARTER_2"] = "STARTER_2";
  EntityLevel2["STARTER_3"] = "STARTER_3";
  EntityLevel2["STANDARD"] = "STANDARD";
  EntityLevel2["PROFESSIONAL"] = "PROFESSIONAL";
  EntityLevel2["PREMIUM"] = "PREMIUM";
  EntityLevel2["CUSTOM"] = "CUSTOM";
})(EntityLevel || (EntityLevel = {}));
var CreditCardBrandName;
(function(CreditCardBrandName2) {
  CreditCardBrandName2["VISA"] = "Visa";
  CreditCardBrandName2["AMERICAN_EXPRESS"] = "American express";
  CreditCardBrandName2["MASTERCARD"] = "Mastercard";
  CreditCardBrandName2["JCB"] = "JCB";
})(CreditCardBrandName || (CreditCardBrandName = {}));
var CreditCardError;
(function(CreditCardError2) {
  CreditCardError2["APPROVED"] = "APPROVED";
  CreditCardError2["CUSTOMER_CANCELLATION"] = "CUSTOMER_CANCELLATION";
  CreditCardError2["DO_NOT_HONOUR"] = "DO_NOT_HONOUR";
  CreditCardError2["DUPLICATE_TRANSMISSION"] = "DUPLICATE_TRANSMISSION";
  CreditCardError2["EXPIRED_CARD"] = "EXPIRED_CARD";
  CreditCardError2["FORMAT_ERROR"] = "FORMAT_ERROR";
  CreditCardError2["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
  CreditCardError2["INVALID_AMOUNT"] = "INVALID_AMOUNT";
  CreditCardError2["INVALID_CARD_NUMBER"] = "INVALID_CARD_NUMBER";
  CreditCardError2["INVALID_MERCHANT_ID"] = "INVALID_MERCHANT_ID";
  CreditCardError2["INVALID_PAYMENT_CONDITION"] = "INVALID_PAYMENT_CONDITION";
  CreditCardError2["INVALID_TRANSACTION"] = "INVALID_TRANSACTION";
  CreditCardError2["ISSUER_OR_SWITCH_IS_INOPERATIVE"] = "ISSUER_OR_SWITCH_IS_INOPERATIVE";
  CreditCardError2["LOST_CARD_PICK_UP"] = "LOST_CARD_PICK_UP";
  CreditCardError2["RE_ENTER_TRANSACTION"] = "RE_ENTER_TRANSACTION";
  CreditCardError2["REFER_TO_CARD_ISSUER"] = "REFER_TO_CARD_ISSUER";
  CreditCardError2["REQUIRE_CREDIT_CARD_TO_BUY_ADD_ON"] = "REQUIRE_CREDIT_CARD_TO_BUY_ADD_ON";
  CreditCardError2["REQUIRE_CREDIT_CARD_TO_UPGRADE_PLAN"] = "REQUIRE_CREDIT_CARD_TO_UPGRADE_PLAN";
  CreditCardError2["STOLEN_CARD_PICK_UP"] = "STOLEN_CARD_PICK_UP";
  CreditCardError2["SYSTEM_MALFUNCTION"] = "SYSTEM_MALFUNCTION";
  CreditCardError2["TRANSACTION_NOT_PERMITTED_TO_TERMINAL"] = "TRANSACTION_NOT_PERMITTED_TO_TERMINAL";
  CreditCardError2["TRANSACTION_TIMEOUT"] = "TRANSACTION_TIMEOUT";
  CreditCardError2["WRONG_CVV"] = "WRONG_CVV";
})(CreditCardError || (CreditCardError = {}));
const deepleFreeRate = {
  creditCard: 3.25,
  qrCash: 1.25,
  mobileBanking: 1.25,
  rabbitLinePay: 3.55,
  trueMoneyWallet: 2.95
};
const extraFeature = {
  free: {
    adminCount: 2,
    openAPI: false,
    support: "Live Chat, Phone"
  },
  starter_1: {
    adminCount: 2,
    openAPI: false,
    support: "Live Chat, Phone"
  },
  starter_2: {
    adminCount: 2,
    openAPI: false,
    support: "Live Chat, Phone"
  },
  starter_3: {
    adminCount: 2,
    openAPI: false,
    support: "Live Chat, Phone"
  },
  standard: {
    adminCount: 5,
    openAPI: false,
    support: "Live Chat, Phone"
  },
  professional: {
    adminCount: 10,
    openAPI: "Standard",
    support: "Live Chat, Phone"
  },
  premium: {
    adminCount: 15,
    openAPI: "Standard",
    support: "Live Chat, Phone"
  },
  custom: {}
};
const customPlan = {
  id: "CUSTOM",
  index: 8,
  type: "PACKAGE",
  entityLevel: "CUSTOM",
  pricePerMonth: -1,
  pricePerYear: -1,
  subscriberQuota: "custom",
  messageQuota: -1,
  orderQuota: "custom",
  faqQuota: "custom",
  productQuota: "custom",
  memberQuota: 10,
  channelQuota: 2,
  imageSearchQuota: 0,
  isAddonEnabled: false,
  extraChargeRate: 0,
  broadcastQuota: "custom",
  subscriptionType: "MONTHLY",
  deeplePayFeeRate: {
    qrCash: {
      rate: 0.55
    },
    creditCard: {
      rate: 2.55
    },
    foreignCreditCard: {
      rate: 2.55
    },
    mobileBanking: {
      min: 15,
      rate: 0.55
    },
    rabbitLinePay: {
      rate: 2.75
    },
    trueMoneyWallet: {
      rate: 2.25
    },
    withdrawal: {
      fix: 15
    },
    realTimeWithdrawal: true
  },
  aiProductSearch: false,
  aiAddress: true,
  aiUpsell: true,
  chat: true,
  facebookCommentToChat: true,
  facebookLiveToChat: true,
  chatIntegration: "3(LINE, FB, IG)",
  openAPI: "Standard",
  logistic: "Lalamove, SHIPPOP",
  adminCount: 15,
  consoleApp: true,
  support: "Live Chat, Phone",
  extraAdmin: false,
  zortIntegration: 290,
  title: "custom",
  totalPrice: -1,
  digitalProduct: true,
  customTheme: true,
  cod: true,
  saleReport: true,
  saleReportExport: true,
  customerReport: true,
  customerReportExport: true,
  consignmentReport: true,
  consignmentReportExport: true,
  promotion: true,
  delivery: true,
  orderPickup: true,
  flatRate: true,
  postcodeBase: true,
  manualCalculation: true,
  pickupStore: true,
  aiProductSearchAddon: true,
  realTimeWithdrawal: true,
  offlineOrder: true,
  fileUploadViaChat: true
};
const mapKeyFeaturePlanCard = (plan) => {
  return [{
    feature: "faqQuota",
    quota: plan.faqQuota,
    isDisabled: false
  }, {
    feature: "productQuota",
    quota: plan.productQuota,
    isDisabled: false
  }, {
    feature: "admin",
    quota: extraFeature[plan.title].adminCount,
    isDisabled: false
  }, {
    feature: "subscriberQuota",
    quota: plan.subscriberQuota,
    isDisabled: false
  }, {
    feature: "saleReport",
    isDisabled: false
  }, {
    feature: "customerReport",
    isDisabled: !plan.customerReport
  }, {
    feature: "consignmentReport",
    isDisabled: false
  }];
};
const renderCell = (value) => {
  if (value === -1) {
    return i18next.t("plan.upgradePlan.table.unlimited");
  }
  if (value === "custom") {
    return /* @__PURE__ */ jsx$1("div", {
      className: "tw-flex tw-justify-center tw-items-center tw-w-5 tw-h-5 tw-bg-Primary-200 tw-rounded-full",
      children: /* @__PURE__ */ jsx$1(Icon, {
        name: IconName.SETTING,
        size: IconSize.SMALL,
        style: {
          margin: "auto"
        },
        color: COLORS.Primary[600]
      })
    });
  }
  if (typeof value === "string" && value.includes("fileUploadViaChat")) {
    return /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-flex-col tw-items-center tw-justify-center",
      children: [/* @__PURE__ */ jsx$1("span", {
        children: i18next.t(`plan.upgradePlan.table.${value}`)
      }), /* @__PURE__ */ jsx$1("span", {
        children: i18next.t("plan.upgradePlan.table.fileUploadViaChat.platform")
      })]
    });
  }
  if (typeof value === "boolean") {
    return /* @__PURE__ */ jsx$1(Icon, {
      name: value ? IconName.OUTLINE_CHECK_CIRCLE : IconName.OUTLINE_X_CIRCLE,
      size: IconSize.MEDIUM,
      style: {
        margin: "auto"
      }
    });
  }
  if (typeof value === "number") {
    return convertPriceFormat(value, 0, 2);
  }
  return i18next.t(value);
};
const generateColumns = (plans, tableTitle) => {
  const headerClassName2 = "tw-text-center tw-text-Dark tw-bg-LightNudePrimary tw-px-4 tw-w-1/12 title-8 tw-font-medium";
  const columnClassName2 = "tw-text-center tw-bg-White tw-pt-6 tw-w-1/12";
  const columnByPackage = {
    FREE: {
      index: 1,
      Header: i18next.t(`plan.upgradePlan.common.freePlan`),
      headerClassName: headerClassName2,
      columnClassName: columnClassName2,
      Cell: (cell) => {
        var _a2, _b, _c, _d, _e2, _f;
        return /* @__PURE__ */ jsxs(Typography, {
          variant: "title-8",
          color: COLORS.Gray[500],
          children: [(_b = (_a2 = cell == null ? void 0 : cell.row) == null ? void 0 : _a2.original) == null ? void 0 : _b.free, ((_d = (_c = cell == null ? void 0 : cell.row) == null ? void 0 : _c.original) == null ? void 0 : _d.freeInfo) && /* @__PURE__ */ jsx$1(Tooltip, {
            description: i18next.t(`plan.upgradePlan.table.freeInfo.${(_f = (_e2 = cell == null ? void 0 : cell.row) == null ? void 0 : _e2.original) == null ? void 0 : _f.freeInfo}`),
            arrow: "left-center",
            position: "right",
            children: /* @__PURE__ */ jsx$1(Icon, {
              name: IconName.INFO,
              size: IconSize.MEDIUM,
              className: "tw-ml-1",
              color: COLORS.Gray[500]
            })
          })]
        });
      }
    },
    STARTER_1: {
      index: 2,
      Header: i18next.t(`plan.upgradePlan.common.starter_1`),
      headerClassName: headerClassName2,
      columnClassName: columnClassName2,
      Cell: (cell) => {
        var _a2, _b, _c, _d, _e2, _f;
        return /* @__PURE__ */ jsxs(Typography, {
          variant: "title-8",
          color: COLORS.Gray[500],
          children: [(_b = (_a2 = cell == null ? void 0 : cell.row) == null ? void 0 : _a2.original) == null ? void 0 : _b.starter_1, ((_d = (_c = cell == null ? void 0 : cell.row) == null ? void 0 : _c.original) == null ? void 0 : _d.starter_1Info) && /* @__PURE__ */ jsx$1(Tooltip, {
            description: i18next.t(`plan.upgradePlan.table.starter_1.${(_f = (_e2 = cell == null ? void 0 : cell.row) == null ? void 0 : _e2.original) == null ? void 0 : _f.starter_1}`),
            arrow: "left-center",
            position: "right",
            children: /* @__PURE__ */ jsx$1(Icon, {
              name: IconName.INFO,
              size: IconSize.MEDIUM,
              className: "tw-ml-1",
              color: COLORS.Gray[500]
            })
          })]
        });
      }
    },
    STARTER_2: {
      index: 3,
      Header: i18next.t(`plan.upgradePlan.common.starter_2`),
      headerClassName: headerClassName2,
      columnClassName: columnClassName2,
      Cell: (cell) => {
        var _a2, _b, _c, _d, _e2, _f;
        return /* @__PURE__ */ jsxs(Typography, {
          variant: "title-8",
          color: COLORS.Gray[500],
          children: [(_b = (_a2 = cell == null ? void 0 : cell.row) == null ? void 0 : _a2.original) == null ? void 0 : _b.starter_2, ((_d = (_c = cell == null ? void 0 : cell.row) == null ? void 0 : _c.original) == null ? void 0 : _d.starter_2Info) && /* @__PURE__ */ jsx$1(Tooltip, {
            description: i18next.t(`plan.upgradePlan.table.starter_2.${(_f = (_e2 = cell == null ? void 0 : cell.row) == null ? void 0 : _e2.original) == null ? void 0 : _f.starter_2}`),
            arrow: "left-center",
            position: "right",
            children: /* @__PURE__ */ jsx$1(Icon, {
              name: IconName.INFO,
              size: IconSize.MEDIUM,
              className: "tw-ml-1",
              color: COLORS.Gray[500]
            })
          })]
        });
      }
    },
    STARTER_3: {
      index: 4,
      Header: i18next.t(`plan.upgradePlan.common.starter_3`),
      headerClassName: headerClassName2,
      columnClassName: columnClassName2,
      Cell: (cell) => {
        var _a2, _b, _c, _d, _e2, _f;
        return /* @__PURE__ */ jsxs(Typography, {
          variant: "title-8",
          color: COLORS.Gray[500],
          children: [(_b = (_a2 = cell == null ? void 0 : cell.row) == null ? void 0 : _a2.original) == null ? void 0 : _b.starter_3, ((_d = (_c = cell == null ? void 0 : cell.row) == null ? void 0 : _c.original) == null ? void 0 : _d.starter_3Info) && /* @__PURE__ */ jsx$1(Tooltip, {
            description: i18next.t(`plan.upgradePlan.table.starter_3.${(_f = (_e2 = cell == null ? void 0 : cell.row) == null ? void 0 : _e2.original) == null ? void 0 : _f.starter_3}`),
            arrow: "left-center",
            position: "right",
            children: /* @__PURE__ */ jsx$1(Icon, {
              name: IconName.INFO,
              size: IconSize.MEDIUM,
              className: "tw-ml-1",
              color: COLORS.Gray[500]
            })
          })]
        });
      }
    },
    STANDARD: {
      index: 5,
      Header: i18next.t(`plan.upgradePlan.common.basicPlan`),
      headerClassName: headerClassName2,
      columnClassName: columnClassName2,
      Cell: (cell) => {
        var _a2, _b, _c, _d, _e2, _f;
        return /* @__PURE__ */ jsxs(Typography, {
          variant: "title-8",
          color: COLORS.Gray[500],
          children: [(_b = (_a2 = cell == null ? void 0 : cell.row) == null ? void 0 : _a2.original) == null ? void 0 : _b.standard, ((_d = (_c = cell == null ? void 0 : cell.row) == null ? void 0 : _c.original) == null ? void 0 : _d.standardInfo) && /* @__PURE__ */ jsx$1(Tooltip, {
            description: i18next.t(`plan.upgradePlan.table.standardInfo.${(_f = (_e2 = cell == null ? void 0 : cell.row) == null ? void 0 : _e2.original) == null ? void 0 : _f.standardInfo}`),
            arrow: "left-center",
            position: "right",
            children: /* @__PURE__ */ jsx$1(Icon, {
              name: IconName.INFO,
              size: IconSize.MEDIUM,
              className: "tw-ml-1",
              color: COLORS.Gray[500]
            })
          })]
        });
      }
    },
    PROFESSIONAL: {
      index: 6,
      Header: i18next.t(`plan.upgradePlan.common.standardPlan`),
      headerClassName: classNames$1(headerClassName2, "tw-w-2/12"),
      columnClassName: classNames$1(columnClassName2, "tw-w-2/12"),
      Cell: (cell) => {
        var _a2, _b, _c, _d, _e2, _f;
        return /* @__PURE__ */ jsxs(Typography, {
          variant: "title-8",
          color: COLORS.Gray[500],
          children: [(_b = (_a2 = cell == null ? void 0 : cell.row) == null ? void 0 : _a2.original) == null ? void 0 : _b.profession, ((_d = (_c = cell == null ? void 0 : cell.row) == null ? void 0 : _c.original) == null ? void 0 : _d.professionInfo) && /* @__PURE__ */ jsx$1(Tooltip, {
            description: i18next.t(`plan.upgradePlan.table.professionInfo.${(_f = (_e2 = cell == null ? void 0 : cell.row) == null ? void 0 : _e2.original) == null ? void 0 : _f.professionInfo}`),
            arrow: "left-center",
            position: "right",
            children: /* @__PURE__ */ jsx$1(Icon, {
              name: IconName.INFO,
              size: IconSize.MEDIUM,
              className: "tw-ml-1",
              color: COLORS.Gray[500]
            })
          })]
        });
      }
    },
    PREMIUM: {
      index: 7,
      Header: i18next.t(`plan.upgradePlan.common.advancedPlan`),
      headerClassName: classNames$1(headerClassName2, "tw-rounded-br tw-rounded-tr tw-w-2/12"),
      columnClassName: "tw-text-center tw-bg-White tw-pt-6 tw-w-2/12",
      Cell: (cell) => {
        var _a2, _b, _c, _d, _e2, _f;
        return /* @__PURE__ */ jsxs(Typography, {
          variant: "title-8",
          color: COLORS.Gray[500],
          children: [(_b = (_a2 = cell == null ? void 0 : cell.row) == null ? void 0 : _a2.original) == null ? void 0 : _b.premium, ((_d = (_c = cell == null ? void 0 : cell.row) == null ? void 0 : _c.original) == null ? void 0 : _d.premiumInfo) && /* @__PURE__ */ jsx$1(Tooltip, {
            description: i18next.t(`plan.upgradePlan.table.premiumInfo.${(_f = (_e2 = cell == null ? void 0 : cell.row) == null ? void 0 : _e2.original) == null ? void 0 : _f.premiumInfo}`),
            arrow: "right-center",
            position: "left",
            children: /* @__PURE__ */ jsx$1(Icon, {
              name: IconName.INFO,
              size: IconSize.MEDIUM,
              className: "tw-ml-1",
              color: COLORS.Gray[500]
            })
          })]
        });
      }
    }
  };
  const filterColumns = Object.keys(plans).filter((plan) => plan !== "CUSTOM").map((planName) => columnByPackage[planName]);
  const sortFilterColumns = sortBy_1(filterColumns, "index");
  return [{
    Header: i18next.t(`plan.upgradePlan.table.title.${tableTitle}`),
    headerClassName: "tw-text-left tw-text-Primary-600 tw-bg-LightNudePrimary tw-px-8 tw-py-4 tw-max-w-[20px] tw-w-3/12 tw-rounded-bl tw-rounded-tl title-8 tw-font-medium",
    columnClassName: "tw-text-left tw-pl-16 tw-bg-White  tw-max-w-[200px] tw-w-3/12 tw-pt-6",
    Cell: (cell) => {
      var _a2, _b, _c, _d, _e2, _f;
      return /* @__PURE__ */ jsxs(Typography, {
        variant: "title-8",
        color: COLORS.Gray[500],
        children: [(_b = (_a2 = cell == null ? void 0 : cell.row) == null ? void 0 : _a2.original) == null ? void 0 : _b.title, ((_d = (_c = cell == null ? void 0 : cell.row) == null ? void 0 : _c.original) == null ? void 0 : _d.titleInfo) && /* @__PURE__ */ jsx$1(Tooltip, {
          description: /* @__PURE__ */ jsx$1(Fragment, {
            children: /* @__PURE__ */ jsx$1("div", {
              className: "tw-relative",
              dangerouslySetInnerHTML: {
                __html: i18next.t(`plan.upgradePlan.table.titleInfo.${(_f = (_e2 = cell == null ? void 0 : cell.row) == null ? void 0 : _e2.original) == null ? void 0 : _f.titleInfo}`)
              }
            })
          }),
          arrow: "left-center",
          position: "right",
          children: /* @__PURE__ */ jsx$1(Icon, {
            name: IconName.QUESTION_MARK,
            size: IconSize.MEDIUM,
            className: "tw-ml-1",
            color: COLORS.Gray[500]
          })
        })]
      });
    }
  }, ...sortFilterColumns];
};
const generateData = (columnKey, plans) => {
  return columnKey.map((column2) => {
    if (column2.key === "orderQuota") {
      return __spreadProps(__spreadValues({}, column2), {
        title: i18next.t(`plan.upgradePlan.table.feature.${column2.key}`),
        free: renderCell(-1),
        starter_1: renderCell(-1),
        starter_2: renderCell(-1),
        starter_3: renderCell(-1),
        standard: renderCell(-1),
        premium: renderCell(-1),
        profession: renderCell(-1)
      });
    }
    if (column2.key === "fileUploadViaChat") {
      return __spreadProps(__spreadValues({}, column2), {
        title: i18next.t(`plan.upgradePlan.table.feature.${column2.key}`),
        free: renderCell(false),
        starter_1: renderCell(false),
        starter_2: renderCell(false),
        starter_3: renderCell(false),
        standard: renderCell("fileUploadViaChat.standard"),
        premium: renderCell("fileUploadViaChat.premium"),
        profession: renderCell("fileUploadViaChat.profession")
      });
    }
    return __spreadProps(__spreadValues({}, column2), {
      title: i18next.t(`plan.upgradePlan.table.feature.${column2.key}`),
      free: renderCell(get_1(plans, `FREE.${column2.key}`)),
      starter_1: renderCell(get_1(plans, `STARTER_1.${column2.key}`)),
      starter_2: renderCell(get_1(plans, `STARTER_2.${column2.key}`)),
      starter_3: renderCell(get_1(plans, `STARTER_3.${column2.key}`)),
      standard: renderCell(get_1(plans, `STANDARD.${column2.key}`)),
      premium: renderCell(get_1(plans, `PREMIUM.${column2.key}`)),
      profession: renderCell(get_1(plans, `PROFESSIONAL.${column2.key}`))
    });
  });
};
const chatColumnKeys = [{
  key: "aiProductSearch",
  titleInfo: "aiProductSearch"
}, {
  key: "faqQuota",
  titleInfo: "faqQuota"
}, {
  key: "aiAddress"
}, {
  key: "aiUpsell"
}, {
  key: "chat"
}, {
  key: "broadcastQuota"
}, {
  key: "facebookCommentToChat"
}, {
  key: "facebookLiveToChat"
}, {
  key: "subscriberQuota"
}, {
  key: "orderQuota",
  titleInfo: "onlyDeeplePayOrders"
}, {
  key: "offlineOrder",
  titleInfo: "offlineOrder"
}, {
  key: "fileUploadViaChat",
  titleInfo: "fileUploadViaChat"
}];
const getChatAndShopFeatureTable = (plans) => {
  if (isEmpty_1(plans)) {
    return {
      columns: [],
      data: []
    };
  }
  const columns = generateColumns(plans, "chatTable");
  const data2 = generateData(chatColumnKeys, plans);
  return {
    columns,
    data: data2
  };
};
const storeManagementColumnKeys = [{
  key: "productQuota"
}, {
  key: "digitalProduct"
}, {
  key: "customTheme"
}, {
  key: "cod"
}, {
  key: "saleReport"
}, {
  key: "saleReportExport"
}, {
  key: "customerReport"
}, {
  key: "customerReportExport"
}, {
  key: "consignmentReport"
}, {
  key: "consignmentReportExport"
}, {
  key: "promotion"
}];
const getStoreManagementFeatureTable = (plans) => {
  if (isEmpty_1(plans)) {
    return {
      columns: [],
      data: []
    };
  }
  const columns = generateColumns(plans, "storeTable");
  const data2 = generateData(storeManagementColumnKeys, plans);
  return {
    columns,
    data: data2
  };
};
const shippingColumnKeys = [{
  key: "delivery"
}, {
  key: "orderPickup"
}, {
  key: "flatRate"
}, {
  key: "postcodeBase"
}, {
  key: "manualCalculation"
}, {
  key: "pickupStore"
}];
const getShippingFeatureTable = (plans) => {
  if (isEmpty_1(plans)) {
    return {
      columns: [],
      data: []
    };
  }
  const columns = generateColumns(plans, "shipping");
  const data2 = generateData(shippingColumnKeys, plans);
  return {
    columns,
    data: data2
  };
};
const integrationColumnKeys = [{
  key: "chatIntegration"
}, {
  key: "openAPI"
}, {
  key: "logistic"
}];
const getIntegrationFeatureTable = (plans) => {
  if (isEmpty_1(plans)) {
    return {
      columns: [],
      data: []
    };
  }
  const columns = generateColumns(plans, "integrationTable");
  const data2 = generateData(integrationColumnKeys, plans);
  return {
    columns,
    data: data2
  };
};
const consoleColumnKeys = [{
  key: "adminCount"
}, {
  key: "consoleApp"
}, {
  key: "support"
}];
const getConsoleFeatureTable = (plans) => {
  if (isEmpty_1(plans)) {
    return {
      columns: [],
      data: []
    };
  }
  const columns = generateColumns(plans, "consoleTable");
  const data2 = generateData(consoleColumnKeys, plans);
  return {
    columns,
    data: data2
  };
};
const addonColumnKeys = [{
  key: "zortIntegration"
}, {
  key: "aiProductSearchAddon"
}];
const getAddonFeatureTable = (plans) => {
  if (isEmpty_1(plans)) {
    return {
      columns: [],
      data: []
    };
  }
  const columns = generateColumns(plans, "addonTable");
  const data2 = generateData(addonColumnKeys, plans);
  return {
    columns,
    data: data2
  };
};
const deeplePayColumnKeys = [{
  key: "deeplePayFeeRate.creditCard.rate",
  titleInfo: "deeplePayFeeRate.creditCard.rate",
  fullPrice: deepleFreeRate.creditCard
}, {
  key: "deeplePayFeeRate.qrCash.rate",
  titleInfo: "deeplePayFeeRate.qrCash.rate",
  fullPrice: deepleFreeRate.qrCash
}, {
  key: "deeplePayFeeRate.mobileBanking.rate",
  titleInfo: "deeplePayFeeRate.mobileBanking.rate",
  fullPrice: deepleFreeRate.mobileBanking
}, {
  key: "deeplePayFeeRate.rabbitLinePay.rate",
  titleInfo: "deeplePayFeeRate.rabbitLinePay.rate",
  fullPrice: deepleFreeRate.rabbitLinePay
}, {
  key: "deeplePayFeeRate.trueMoneyWallet.rate",
  titleInfo: "deeplePayFeeRate.trueMoneyWallet.rate",
  fullPrice: deepleFreeRate.trueMoneyWallet
}, {
  key: "deeplePayFeeRate.withdrawal.fix",
  titleInfo: "deeplePayFeeRate.withdrawal.fix"
}, {
  key: "realTimeWithdrawal"
}];
const getDeeplePayFeatureTable = (plans) => {
  if (isEmpty_1(plans)) {
    return {
      columns: [],
      data: []
    };
  }
  const renderCellDeeplePayTable = (value, fullPrice) => {
    const isNumber2 = new RegExp(/^\d*\.?\d*$/);
    if (isNumber2.test(`${value}`)) {
      if (value % 1 !== 0) {
        return /* @__PURE__ */ jsxs("div", {
          className: "tw-flex tw-relative tw-items-end tw-m-auto tw-w-fit",
          children: [fullPrice && /* @__PURE__ */ jsx$1("span", {
            className: "tw-mr-1 tw-text-[8px] tw-leading-[1.3rem]",
            children: "Up to"
          }), value, "%", fullPrice && Number(value) !== Number(fullPrice) && /* @__PURE__ */ jsxs("span", {
            className: "tw-box-border tw-absolute tw-top-0 tw-right-0 tw-px-[4px] tw-text-[10px] tw-leading-4 tw-text-White tw-bg-LightPrimary tw-rounded tw--translate-y-[80%]",
            children: [fullPrice, "%", /* @__PURE__ */ jsx$1("div", {
              className: "tw-absolute tw-top-1/2 tw-w-3/4 tw-h-0 tw-rounded tw-border-t-[2px] tw-border-White tw--rotate-12 tw--translate-y-[50%]"
            })]
          })]
        });
      }
      return value;
    }
    return value;
  };
  const headerClassName2 = "tw-text-center tw-text-Dark tw-bg-LightNudePrimary tw-px-4 tw-w-1/12 title-8 tw-font-medium";
  const columnClassName2 = "tw-text-center tw-bg-White tw-pt-6 tw-w-1/12";
  const headerColumn = {
    Header: i18next.t(`plan.upgradePlan.table.title.deeplePayTable`),
    headerClassName: "tw-text-left tw-text-Primary-600 tw-bg-LightNudePrimary tw-px-8 tw-py-4 tw-max-w-[20px] tw-w-3/12 tw-rounded-bl tw-rounded-tl title-8 tw-font-medium",
    columnClassName: "tw-text-left tw-pl-16 tw-bg-White  tw-max-w-[200px] tw-w-3/12 tw-pt-6",
    Cell: (cell) => {
      var _a2, _b, _c, _d, _e2, _f;
      return /* @__PURE__ */ jsxs(Typography, {
        variant: "title-8",
        color: COLORS.Gray[500],
        children: [(_b = (_a2 = cell == null ? void 0 : cell.row) == null ? void 0 : _a2.original) == null ? void 0 : _b.title, ((_d = (_c = cell == null ? void 0 : cell.row) == null ? void 0 : _c.original) == null ? void 0 : _d.titleInfo) && /* @__PURE__ */ jsx$1(Tooltip, {
          description: i18next.t(`plan.upgradePlan.table.titleInfo.${(_f = (_e2 = cell == null ? void 0 : cell.row) == null ? void 0 : _e2.original) == null ? void 0 : _f.titleInfo}`),
          arrow: "left-center",
          position: "right",
          children: /* @__PURE__ */ jsx$1(Icon, {
            name: IconName.QUESTION_MARK,
            size: IconSize.MEDIUM,
            className: "tw-ml-1",
            color: COLORS.Gray[500]
          })
        })]
      });
    }
  };
  const packageColumns = [{
    type: "FREE",
    Header: i18next.t(`plan.upgradePlan.common.freePlan`),
    headerClassName: headerClassName2,
    columnClassName: columnClassName2,
    Cell: (cell) => {
      var _a2, _b;
      return /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-8",
        color: COLORS.Gray[500],
        children: renderCellDeeplePayTable((_b = (_a2 = cell == null ? void 0 : cell.row) == null ? void 0 : _a2.original) == null ? void 0 : _b.free)
      });
    }
  }, {
    type: "STARTER_1",
    Header: i18next.t(`plan.upgradePlan.common.starter_1`),
    headerClassName: headerClassName2,
    columnClassName: columnClassName2,
    Cell: (cell) => {
      var _a2, _b, _c, _d;
      return /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-8",
        color: COLORS.Gray[500],
        children: renderCellDeeplePayTable((_b = (_a2 = cell == null ? void 0 : cell.row) == null ? void 0 : _a2.original) == null ? void 0 : _b.starter_1, (_d = (_c = cell == null ? void 0 : cell.row) == null ? void 0 : _c.original) == null ? void 0 : _d.fullPrice)
      });
    }
  }, {
    type: "STARTER_2",
    Header: i18next.t(`plan.upgradePlan.common.starter_2`),
    headerClassName: headerClassName2,
    columnClassName: columnClassName2,
    Cell: (cell) => {
      var _a2, _b, _c, _d;
      return /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-8",
        color: COLORS.Gray[500],
        children: renderCellDeeplePayTable((_b = (_a2 = cell == null ? void 0 : cell.row) == null ? void 0 : _a2.original) == null ? void 0 : _b.starter_2, (_d = (_c = cell == null ? void 0 : cell.row) == null ? void 0 : _c.original) == null ? void 0 : _d.fullPrice)
      });
    }
  }, {
    type: "STARTER_3",
    Header: i18next.t(`plan.upgradePlan.common.starter_3`),
    headerClassName: headerClassName2,
    columnClassName: columnClassName2,
    Cell: (cell) => {
      var _a2, _b, _c, _d;
      return /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-8",
        color: COLORS.Gray[500],
        children: renderCellDeeplePayTable((_b = (_a2 = cell == null ? void 0 : cell.row) == null ? void 0 : _a2.original) == null ? void 0 : _b.starter_3, (_d = (_c = cell == null ? void 0 : cell.row) == null ? void 0 : _c.original) == null ? void 0 : _d.fullPrice)
      });
    }
  }, {
    type: "STANDARD",
    Header: i18next.t(`plan.upgradePlan.common.basicPlan`),
    headerClassName: headerClassName2,
    columnClassName: columnClassName2,
    Cell: (cell) => {
      var _a2, _b, _c, _d;
      return /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-8",
        color: COLORS.Gray[500],
        children: renderCellDeeplePayTable((_b = (_a2 = cell == null ? void 0 : cell.row) == null ? void 0 : _a2.original) == null ? void 0 : _b.standard, (_d = (_c = cell == null ? void 0 : cell.row) == null ? void 0 : _c.original) == null ? void 0 : _d.fullPrice)
      });
    }
  }, {
    type: "PROFESSIONAL",
    Header: i18next.t(`plan.upgradePlan.common.standardPlan`),
    headerClassName: classNames$1(headerClassName2, "tw-w-2/12"),
    columnClassName: classNames$1(columnClassName2, "tw-w-2/12"),
    Cell: (cell) => {
      var _a2, _b, _c, _d;
      return /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-8",
        color: COLORS.Gray[500],
        children: renderCellDeeplePayTable((_b = (_a2 = cell == null ? void 0 : cell.row) == null ? void 0 : _a2.original) == null ? void 0 : _b.profession, (_d = (_c = cell == null ? void 0 : cell.row) == null ? void 0 : _c.original) == null ? void 0 : _d.fullPrice)
      });
    }
  }, {
    type: "PREMIUM",
    Header: i18next.t(`plan.upgradePlan.common.advancedPlan`),
    headerClassName: classNames$1(headerClassName2, "tw-rounded-br tw-rounded-tr tw-w-2/12"),
    columnClassName: "tw-text-center tw-bg-White tw-pt-6 tw-w-2/12",
    Cell: (cell) => {
      var _a2, _b, _c, _d;
      return /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-8",
        color: COLORS.Gray[500],
        children: renderCellDeeplePayTable((_b = (_a2 = cell == null ? void 0 : cell.row) == null ? void 0 : _a2.original) == null ? void 0 : _b.premium, (_d = (_c = cell == null ? void 0 : cell.row) == null ? void 0 : _c.original) == null ? void 0 : _d.fullPrice)
      });
    }
  }];
  const existsPlans = Object.keys(plans);
  const filterPackageColumns = packageColumns.filter((column2) => {
    return existsPlans.includes(column2.type);
  });
  const columns = [headerColumn, ...filterPackageColumns];
  const data2 = generateData(deeplePayColumnKeys, plans);
  return {
    columns,
    data: data2
  };
};
const pickFeatureByKey = (plan, columnKeys2) => {
  const getFileUploadViaChatValue = () => {
    if (plan.entityLevel === EntityLevel.FREE) {
      return false;
    }
    if (plan.entityLevel === EntityLevel.STANDARD) {
      return "fileUploadViaChat.standard";
    }
    if (plan.entityLevel === EntityLevel.PREMIUM) {
      return "fileUploadViaChat.premium";
    }
    if (plan.entityLevel === EntityLevel.PROFESSIONAL) {
      return "fileUploadViaChat.profession";
    }
    return true;
  };
  return columnKeys2.map((column2) => {
    if (column2.key === "orderQuota") {
      return __spreadProps(__spreadValues({}, column2), {
        value: -1
      });
    }
    if (column2.key === "fileUploadViaChat") {
      return __spreadProps(__spreadValues({}, column2), {
        value: getFileUploadViaChatValue()
      });
    }
    return __spreadProps(__spreadValues({}, column2), {
      value: get_1(plan, column2.key)
    });
  });
};
const getExpandFeature = (plan) => {
  if (!plan) {
    return null;
  }
  const chatFeature = pickFeatureByKey(plan, chatColumnKeys);
  const integrationFeature = pickFeatureByKey(plan, integrationColumnKeys);
  const storeFeature = pickFeatureByKey(plan, storeManagementColumnKeys);
  const shippingFeature = pickFeatureByKey(plan, shippingColumnKeys);
  const consoleFeature = pickFeatureByKey(plan, consoleColumnKeys);
  const addonFeature = pickFeatureByKey(plan, addonColumnKeys);
  const deeplePayFeature = pickFeatureByKey(plan, deeplePayColumnKeys);
  return [{
    title: i18next.t(`plan.upgradePlan.table.title.chatTable`),
    features: chatFeature,
    prefix: "%"
  }, {
    title: i18next.t(`plan.upgradePlan.table.title.storeTable`),
    features: storeFeature,
    prefix: "%"
  }, {
    title: i18next.t(`plan.upgradePlan.table.title.shipping`),
    features: shippingFeature,
    prefix: "%"
  }, {
    title: i18next.t(`plan.upgradePlan.table.title.integrationTable`),
    features: integrationFeature,
    prefix: "%"
  }, {
    title: i18next.t(`plan.upgradePlan.table.title.consoleTable`),
    features: consoleFeature,
    prefix: "%"
  }, {
    title: i18next.t(`plan.upgradePlan.table.title.addonTable`),
    features: addonFeature,
    prefix: "%"
  }, {
    title: i18next.t(`plan.upgradePlan.table.title.deeplePayTable`),
    features: deeplePayFeature
  }];
};
function FeatureList({
  plans,
  activePlan,
  isUsingNotSupportedPackage = false
}) {
  const {
    t: t2
  } = useTranslation();
  const [isShowDesktopFeature, setIsShowDesktopFeature] = useState(false);
  const {
    isMobile
  } = useDevice();
  const [scrollToRef, scrollTo2] = useScrollTo();
  const handleClickExpandFeatureDetail = () => {
    setIsShowDesktopFeature(!isShowDesktopFeature);
    if (typeof scrollTo2 === "function") {
      scrollTo2();
    }
  };
  if (isUsingNotSupportedPackage) {
    return null;
  }
  if (isMobile) {
    if (!activePlan) {
      return null;
    }
    const expandData = getExpandFeature(plans[activePlan]);
    if (!expandData) {
      return null;
    }
    return /* @__PURE__ */ jsx$1(Card, {
      className: "tw-px-2 tw-pt-2 tw-pb-4 tw-w-full tw-bg-White",
      children: expandData.map((detail) => {
        return /* @__PURE__ */ jsx$1(Expand, {
          title: /* @__PURE__ */ jsx$1(Typography, {
            variant: "title-7",
            color: COLORS.Primary[600],
            children: detail.title
          }),
          className: "tw-mt-2 tw-bg-LightNudePrimary",
          children: detail.features.map(({
            key,
            value,
            titleInfo
          }) => {
            return /* @__PURE__ */ jsxs("div", {
              className: "tw-flex tw-justify-between tw-items-center tw-pb-4",
              children: [/* @__PURE__ */ jsxs(Typography, {
                variant: "title-9",
                className: "tw-max-w-[60%]",
                color: COLORS.Gray[500],
                children: [t2(`plan.upgradePlan.table.feature.${key}`), titleInfo && /* @__PURE__ */ jsx$1(Tooltip, {
                  description: /* @__PURE__ */ jsx$1(Fragment, {
                    children: /* @__PURE__ */ jsx$1("div", {
                      className: "tw-relative",
                      dangerouslySetInnerHTML: {
                        __html: t2(`plan.upgradePlan.table.titleInfo.${titleInfo}`)
                      }
                    })
                  }),
                  arrow: "left-center",
                  position: "right",
                  children: /* @__PURE__ */ jsx$1(Icon, {
                    name: IconName.QUESTION_MARK,
                    size: IconSize.MEDIUM,
                    className: "tw-ml-1",
                    color: COLORS.Gray[500]
                  })
                })]
              }), /* @__PURE__ */ jsx$1(Typography, {
                variant: "title-9",
                color: COLORS.Gray[500],
                children: renderCell(value)
              })]
            }, key);
          })
        }, detail.title);
      })
    });
  }
  const {
    columns: chatColumns,
    data: chatData
  } = getChatAndShopFeatureTable(plans);
  const {
    columns: integrationColumns,
    data: integrationData
  } = getIntegrationFeatureTable(plans);
  const {
    columns: storeColumns,
    data: storeData
  } = getStoreManagementFeatureTable(plans);
  const {
    columns: shippingColumns,
    data: shippingData
  } = getShippingFeatureTable(plans);
  const {
    columns: consoleColumns,
    data: consoleData
  } = getConsoleFeatureTable(plans);
  const {
    columns: addonColumns,
    data: addonData
  } = getAddonFeatureTable(plans);
  const {
    columns: deeplePayColumns,
    data: deeplePayData
  } = getDeeplePayFeatureTable(plans);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx$1("div", {
      ref: scrollToRef,
      children: /* @__PURE__ */ jsxs(Button, {
        className: "tw-flex tw-justify-center tw-items-center tw-my-6 tw-w-full tw-text-Primary-600 tw-bg-White tw-shadow-md",
        onClick: handleClickExpandFeatureDetail,
        variant: "text",
        size: "large",
        children: [t2(isShowDesktopFeature ? "plan.upgradePlan.featureList.buttonHideFeature" : "plan.upgradePlan.featureList.buttonShowFeature"), " ", /* @__PURE__ */ jsx$1(Icon, {
          name: isShowDesktopFeature ? IconName.UP : IconName.DOWN,
          size: IconSize.LARGE,
          className: "tw-inline-block"
        })]
      })
    }), isShowDesktopFeature && /* @__PURE__ */ jsxs(Card, {
      className: "tw-py-4 tw-px-6 tw-w-full tw-bg-White",
      children: [/* @__PURE__ */ jsx$1(Table, {
        columns: chatColumns,
        data: chatData
      }), /* @__PURE__ */ jsx$1(Table, {
        columns: storeColumns,
        data: storeData
      }), /* @__PURE__ */ jsx$1(Table, {
        columns: shippingColumns,
        data: shippingData
      }), /* @__PURE__ */ jsx$1(Table, {
        columns: integrationColumns,
        data: integrationData
      }), /* @__PURE__ */ jsx$1(Table, {
        columns: consoleColumns,
        data: consoleData
      }), /* @__PURE__ */ jsx$1(Table, {
        columns: addonColumns,
        data: addonData
      }), /* @__PURE__ */ jsx$1(Table, {
        columns: deeplePayColumns,
        data: deeplePayData
      }), /* @__PURE__ */ jsx$1(BankTransferTable, {
        plans
      })]
    })]
  });
}
var SubscriptionType$1;
(function(SubscriptionType2) {
  SubscriptionType2["MONTHLY"] = "MONTHLY";
  SubscriptionType2["ANNUALLY"] = "ANNUALLY";
})(SubscriptionType$1 || (SubscriptionType$1 = {}));
var PackageEntityType$1;
(function(PackageEntityType2) {
  PackageEntityType2["BASIC"] = "BASIC";
  PackageEntityType2["C_COMMERCE"] = "C_COMMERCE";
  PackageEntityType2["IMAGE_SEARCH"] = "IMAGE_SEARCH";
  PackageEntityType2["MAIN"] = "MAIN";
})(PackageEntityType$1 || (PackageEntityType$1 = {}));
var PackagePricing;
(function(PackagePricing2) {
  PackagePricing2["FREE"] = "free";
  PackagePricing2["PROFESSIONAL"] = "professional";
  PackagePricing2["PREMIUM"] = "premium";
  PackagePricing2["ENTERPRISE"] = "enterprise";
  PackagePricing2["STANDARD"] = "standard";
})(PackagePricing || (PackagePricing = {}));
var PackageTypes$1;
(function(PackageTypes2) {
  PackageTypes2["PACKAGE"] = "PACKAGE";
  PackageTypes2["ADDON"] = "ADDON";
})(PackageTypes$1 || (PackageTypes$1 = {}));
var PackagePricingType$1;
(function(PackagePricingType2) {
  PackagePricingType2["FREE"] = "free";
  PackagePricingType2["STARTER_1"] = "starter_1";
  PackagePricingType2["STARTER_2"] = "starter_2";
  PackagePricingType2["STARTER_3"] = "starter_3";
  PackagePricingType2["PROFESSIONAL"] = "professional";
  PackagePricingType2["PREMIUM"] = "premium";
  PackagePricingType2["ENTERPRISE"] = "enterprise";
  PackagePricingType2["STANDARD"] = "standard";
})(PackagePricingType$1 || (PackagePricingType$1 = {}));
const PlanCard = ({
  title = "",
  price,
  keyFeatures = [],
  isSelected,
  onSelectPackage,
  plan,
  isUsingNotSupportedPackage,
  buttonText,
  isUsingCustomPackage,
  packagePromotion
}) => {
  const {
    t: t2
  } = useTranslation();
  const isShowPrice = price >= 0;
  const isShowPriceUnit = price > 0;
  const isAnnuallySubscription = plan.subscriptionType === SubscriptionType$1.ANNUALLY;
  const unitPrice = isAnnuallySubscription ? "pricePerYear" : "pricePerMonth";
  const isShowDiscountPrice = !!(plan == null ? void 0 : plan.defaultPricePerYear) && (packagePromotion == null ? void 0 : packagePromotion.discountPercent);
  const usingCustomPackageTitle = isSelected ? t2(`plan.upgradePlan.card.usingCustom.title`) : t2(`plan.upgradePlan.card.needMore.title`);
  const usingCustomPackageSubTitle = isSelected ? t2(`plan.upgradePlan.card.usingCustom.subTitle`) : t2(`plan.upgradePlan.card.needMore.subTitle`);
  const defaultButtonText = plan.entityLevel === EntityLevel.CUSTOM ? t2("plan.upgradePlan.card.contactUs") : isSelected ? t2("plan.upgradePlan.card.selectedButtonText") : t2("plan.upgradePlan.card.chooseButtonText");
  const cardTitle = isUsingCustomPackage ? usingCustomPackageTitle : t2(`plan.upgradePlan.card.${title}.title`);
  const cardSubTitle = isUsingCustomPackage ? usingCustomPackageSubTitle : t2(`plan.upgradePlan.card.${title}.subTitle`);
  return /* @__PURE__ */ jsxs(Card, {
    className: "tw-group tw-py-6 tw-px-4 tw-w-[264px] tw-text-center hover:tw-bg-LightNudePrimary hover:tw-border hover:tw-border-Primary-600",
    children: [/* @__PURE__ */ jsx$1(Typography, {
      variant: "heading-5",
      children: cardTitle
    }), /* @__PURE__ */ jsx$1(Typography, {
      variant: "body-3",
      className: "tw-mb-4 tw-h-10",
      color: COLORS.Gray[500],
      children: cardSubTitle
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-h-24",
      children: [isShowDiscountPrice && /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-justify-center tw-items-center",
        children: [/* @__PURE__ */ jsx$1(Typography, {
          variant: "title-10",
          className: "tw-mr-1",
          color: COLORS.Green[500],
          children: t2("plan.upgradePlan.save", {
            discountPercent: packagePromotion.discountPercent
          })
        }), /* @__PURE__ */ jsx$1("div", {
          className: "tw-relative tw-px-1 tw-bg-Primary-400 tw-rounded-sm",
          children: /* @__PURE__ */ jsxs(Typography, {
            variant: "body-5",
            color: COLORS.White,
            children: [t2("plan.upgradePlan.defaultPricePerYear", {
              defaultPricePerYear: convertPriceFormat(Number(plan.defaultPricePerYear), 0, 2)
            }), /* @__PURE__ */ jsx$1("div", {
              className: "tw-absolute tw-top-1/2 tw-w-3/4 tw-h-0 tw-rounded tw-border-t-[2px] tw-border-White tw--rotate-12 tw--translate-y-[50%]"
            })]
          })
        })]
      }), /* @__PURE__ */ jsxs(Typography, {
        variant: "heading-4",
        className: "tw-mb-4 group-hover:tw-text-Primary-600",
        children: [isShowPrice ? convertPriceFormat(Number(price), 0, 0) : "Let\u2019s Talk", isShowPriceUnit && /* @__PURE__ */ jsx$1("span", {
          className: "tw-text-Gray-500 body-2",
          children: t2(`plan.upgradePlan.card.${unitPrice}`)
        })]
      })]
    }), /* @__PURE__ */ jsx$1("div", {
      className: "tw-mb-4",
      children: keyFeatures.map((keyFeature) => /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-justify-between tw-items-center tw-my-1 tw-mb-3 tw-text-Red",
        children: [/* @__PURE__ */ jsxs(Typography, {
          variant: "body-4",
          color: keyFeature.isDisabled ? COLORS.Gray[300] : COLORS.Gray[500],
          children: [/* @__PURE__ */ jsx$1(Icon, {
            name: keyFeature.isDisabled ? IconName.CLEAR : IconName.CHECK,
            size: IconSize.MEDIUM,
            className: classNames$1("tw-inline-block tw-mr-2", {
              "tw-fill-green-500": !keyFeature.isDisabled,
              "tw-fill-red-500": keyFeature.isDisabled
            })
          }), " ", t2(`plan.upgradePlan.card.features.${keyFeature.feature}`)]
        }), typeof keyFeature.quota === "number" && /* @__PURE__ */ jsx$1(Typography, {
          variant: "body-4",
          color: keyFeature.isDisabled ? COLORS.Gray[300] : COLORS.Gray[500],
          children: convertPriceFormat(Number(keyFeature.quota), 0, 0)
        })]
      }, keyFeature.feature))
    }), /* @__PURE__ */ jsx$1(Button, {
      size: "medium",
      className: "tw-min-w-[216px]",
      disabled: isSelected || isUsingNotSupportedPackage,
      onClick: () => onSelectPackage(plan),
      children: buttonText || defaultButtonText
    })]
  });
};
const PlanList = ({
  plans,
  onSlidePlan,
  onSelectPackage,
  isUsingNotSupportedPackage,
  isUsingCustomPackage,
  packagePromotion
}) => {
  const {
    isMobile
  } = useDevice();
  const sortPlans = sortBy_1(Object.values(plans).filter(Boolean), (plan) => [plan.index, plan.totalPrice]);
  return /* @__PURE__ */ jsx$1("div", {
    children: /* @__PURE__ */ jsx$1(Carousel, {
      className: "tw-cursor-grab active:tw-cursor-grabbing",
      onSlideChange: (swiper) => {
        var _a2;
        if (onSlidePlan) {
          onSlidePlan(((_a2 = sortPlans[swiper.activeIndex]) == null ? void 0 : _a2.entityLevel) || "CUSTOM", swiper.activeIndex);
        }
      },
      isShowPagination: isMobile,
      initialSlide: -1,
      slidesPerView: 1,
      spaceBetween: 2,
      centeredSlidesBounds: true,
      centerInsufficientSlides: true,
      centeredSlides: true,
      preloadImages: true,
      freeMode: true,
      breakpoints: {
        200: {
          slidesPerView: 1.2,
          spaceBetween: 3
        },
        420: {
          slidesPerView: 1.3,
          spaceBetween: 1
        },
        500: {
          slidesPerView: 1.5,
          spaceBetween: 1
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 2
        },
        960: {
          slidesPerView: 3.2,
          spaceBetween: 2
        },
        1200: {
          slidesPerView: 3.4,
          spaceBetween: 2
        },
        1440: {
          slidesPerView: 3.7,
          spaceBetween: 2
        },
        1660: {
          slidesPerView: 5,
          spaceBetween: 2
        }
      },
      children: sortPlans.map((plan) => {
        return /* @__PURE__ */ jsx$1("div", {
          className: "tw-flex tw-justify-center tw-items-center",
          children: /* @__PURE__ */ jsx$1(PlanCard, {
            title: plan.title,
            price: plan.totalPrice,
            keyFeatures: mapKeyFeaturePlanCard(plan),
            isSelected: plan.isSelected,
            onSelectPackage,
            isUsingNotSupportedPackage,
            plan,
            isUsingCustomPackage,
            packagePromotion
          })
        }, plan.id);
      })
    })
  });
};
const PACKAGES = gql$1`
  query packages($projectId: ID!, $subscriptionType: SubscriptionType) {
    packages(projectId: $projectId, subscriptionType: $subscriptionType) {
      starter_1 {
        id
        name
        type
        entityType
        entityLevel
        isTrial
        isSelected
        pricePerMonth
        subscriberQuota
        messageQuota
        orderQuota
        faqQuota
        productQuota
        memberQuota
        channelQuota
        imageSearchQuota
        isAddonEnabled
        extraChargeRate
        broadcastQuota
        pricePerYear
        subscriptionType
        deeplePayFeeRate {
          qrCash {
            fix
            min
            rate
          }
          creditCard {
            fix
            min
            rate
          }
          foreignCreditCard {
            fix
            min
            rate
          }
          mobileBanking {
            fix
            min
            rate
          }
          rabbitLinePay {
            fix
            min
            rate
          }
          trueMoneyWallet {
            fix
            min
            rate
          }
          withdrawal {
            fix
            min
            rate
          }
        }
      }
      starter_2 {
        id
        name
        type
        entityType
        entityLevel
        isTrial
        isSelected
        pricePerMonth
        subscriberQuota
        messageQuota
        orderQuota
        faqQuota
        productQuota
        memberQuota
        channelQuota
        imageSearchQuota
        isAddonEnabled
        extraChargeRate
        broadcastQuota
        pricePerYear
        subscriptionType
        deeplePayFeeRate {
          qrCash {
            fix
            min
            rate
          }
          creditCard {
            fix
            min
            rate
          }
          foreignCreditCard {
            fix
            min
            rate
          }
          mobileBanking {
            fix
            min
            rate
          }
          rabbitLinePay {
            fix
            min
            rate
          }
          trueMoneyWallet {
            fix
            min
            rate
          }
          withdrawal {
            fix
            min
            rate
          }
        }
      }
      starter_3 {
        id
        name
        type
        entityType
        entityLevel
        isTrial
        isSelected
        pricePerMonth
        subscriberQuota
        messageQuota
        orderQuota
        faqQuota
        productQuota
        memberQuota
        channelQuota
        imageSearchQuota
        isAddonEnabled
        extraChargeRate
        broadcastQuota
        pricePerYear
        subscriptionType
        deeplePayFeeRate {
          qrCash {
            fix
            min
            rate
          }
          creditCard {
            fix
            min
            rate
          }
          foreignCreditCard {
            fix
            min
            rate
          }
          mobileBanking {
            fix
            min
            rate
          }
          rabbitLinePay {
            fix
            min
            rate
          }
          trueMoneyWallet {
            fix
            min
            rate
          }
          withdrawal {
            fix
            min
            rate
          }
        }
      }
      free {
        id
        name
        type
        entityType
        entityLevel
        isTrial
        isSelected
        pricePerMonth
        subscriberQuota
        messageQuota
        orderQuota
        faqQuota
        productQuota
        memberQuota
        channelQuota
        imageSearchQuota
        isAddonEnabled
        extraChargeRate
        broadcastQuota
        pricePerYear
        defaultPricePerYear
        subscriptionType
        deeplePayFeeRate {
          qrCash {
            fix
            min
            rate
          }
          creditCard {
            fix
            min
            rate
          }
          foreignCreditCard {
            fix
            min
            rate
          }
          mobileBanking {
            fix
            min
            rate
          }
          rabbitLinePay {
            fix
            min
            rate
          }
          trueMoneyWallet {
            fix
            min
            rate
          }
          withdrawal {
            fix
            min
            rate
          }
        }
      }
      standard {
        id
        name
        type
        entityType
        entityLevel
        isTrial
        isSelected
        pricePerMonth
        subscriberQuota
        messageQuota
        orderQuota
        faqQuota
        productQuota
        memberQuota
        channelQuota
        imageSearchQuota
        isAddonEnabled
        extraChargeRate
        broadcastQuota
        pricePerYear
        defaultPricePerYear
        subscriptionType
        deeplePayFeeRate {
          qrCash {
            fix
            min
            rate
          }
          creditCard {
            fix
            min
            rate
          }
          foreignCreditCard {
            fix
            min
            rate
          }
          mobileBanking {
            fix
            min
            rate
          }
          rabbitLinePay {
            fix
            min
            rate
          }
          trueMoneyWallet {
            fix
            min
            rate
          }
          withdrawal {
            fix
            min
            rate
          }
        }
      }
      premium {
        id
        name
        type
        entityType
        entityLevel
        isTrial
        isSelected
        pricePerMonth
        subscriberQuota
        messageQuota
        orderQuota
        faqQuota
        productQuota
        memberQuota
        channelQuota
        imageSearchQuota
        isAddonEnabled
        extraChargeRate
        broadcastQuota
        pricePerYear
        defaultPricePerYear
        subscriptionType
        deeplePayFeeRate {
          qrCash {
            fix
            min
            rate
          }
          creditCard {
            fix
            min
            rate
          }
          foreignCreditCard {
            fix
            min
            rate
          }
          mobileBanking {
            fix
            min
            rate
          }
          rabbitLinePay {
            fix
            min
            rate
          }
          trueMoneyWallet {
            fix
            min
            rate
          }
          withdrawal {
            fix
            min
            rate
          }
        }
      }
      professional {
        id
        name
        type
        entityType
        entityLevel
        isTrial
        isSelected
        pricePerMonth
        subscriberQuota
        messageQuota
        orderQuota
        faqQuota
        productQuota
        memberQuota
        channelQuota
        imageSearchQuota
        isAddonEnabled
        extraChargeRate
        broadcastQuota
        pricePerYear
        defaultPricePerYear
        subscriptionType
        deeplePayFeeRate {
          qrCash {
            fix
            min
            rate
          }
          creditCard {
            fix
            min
            rate
          }
          foreignCreditCard {
            fix
            min
            rate
          }
          mobileBanking {
            fix
            min
            rate
          }
          rabbitLinePay {
            fix
            min
            rate
          }
          trueMoneyWallet {
            fix
            min
            rate
          }
          withdrawal {
            fix
            min
            rate
          }
        }
      }
    }
  }
`;
const PACKAGE_PROMOTION = gql$1`
  query packagePromotion($projectId: ID!) {
    packagePromotion(projectId: $projectId) {
      start
      end
      discountPercent
    }
  }
`;
gql$1`
  query credit($projectId: ID!) {
    credit(projectId: $projectId, type: MAIN)
  }
`;
const CREDIT_CARD = gql$1`
  query creditCard($projectId: ID!) {
    creditCard(projectId: $projectId) {
      id
      name
      number
      brand
      expirationYear
      expirationMonth
    }
  }
`;
const CHANGE_PACKAGE_SUMMARY = gql$1`
  query changePackageSummary(
    $projectId: ID!
    $packageIds: [ID!]!
    $promotionCode: String
  ) {
    changePackageSummary(
      projectId: $projectId
      packageIds: $packageIds
      promotionCode: $promotionCode
    ) {
      proratedPriceSummary {
        totalProratedPrice
      }
      currentPackages {
        subscriptionType
      }
      newPackages {
        subscriptionType
        entityType
        pricePerMonth
        pricePerYear
      }
      creditSummary {
        totalCredit
      }
      totalDiscount
      monthlyBillingSummary {
        newPackage {
          package
          addon
          imageSearchPackage
        }
      }
      currentAddons {
        id
        name
        type
        entityType
        entityLevel
        pricePerMonth
        imageSearchQuota
        memberQuota
        customResponseMessageQuota
        offlineOrderQuota
        extraChargeRate
        isSelected
        isSelectable
        amount
      }
      newAddons {
        id
        name
        type
        entityType
        entityLevel
        pricePerMonth
        imageSearchQuota
        memberQuota
        customResponseMessageQuota
        offlineOrderQuota
        extraChargeRate
        isSelected
        isSelectable
        amount
        broadcastQuota
      }
      nextBillingDate
      totalPrice
      isDuringFreeTrialPeriod
      invoiceDateInfo {
        startBillingDate
        endBillingDate
      }
      updateDateInfo {
        currentMonthlyBilling
        nextMonthlyBilling
        currentYearlyBilling
      }
      defaultPromotions {
        packageDiscount
        totalDiscount
        promotions {
          id
          name
          description
          isDeleted
          isActive
          type
          discount
          createdAt
          updatedAt
        }
      }
      totalUpgradePackageCompensation
      promotionCode {
        info {
          id
          name
          description
          code
          isActive
          discountType
          conditionType
          discountAmount
          quota
          startDate
          endDate
          createdAt
          updatedAt
        }
        totalDiscount
        error
      }
    }
  }
`;
const CURRENT_USAGE = gql$1`
  query currentUsage($projectId: ID!) {
    currentUsage(projectId: $projectId) {
      projectId
      usagePeriod
      currentBillingDate
      nextBillingDate
      lineMessageUsage
      lineMessageQuota
      lineLastFetchMessageTimestamp
      manualApproveOrderUsage
      # billingDate
      ccommercePackage {
        id
        name
        type
        entityType
        entityLevel
        pricePerMonth
        orderQuota
        orderUsage
        productQuota
        productUsage
        subscriptionType
      }
      imageSearchPackage {
        id
        name
        type
        entityType
        isTrial
        pricePerMonth
        imageSearchQuota
        imageSearchUsage
      }
      mainPackage {
        id
        name
        type
        entityType
        entityLevel
        isAddonEnabled
        pricePerMonth
        subscriberQuota
        subscriberUsage
        messageQuota
        messageUsage
        orderQuota
        orderUsage
        productQuota
        productUsage
        faqQuota
        faqUsage
        broadcastQuota
        broadcastUsage
        memberQuota
        memberUsage
        members {
          id
          email
          user {
            id
            email
            displayName
          }
        }
        channelQuota
        channelUsage
        channels {
          platform
          name
        }
        subscriptionType
      }
      addons {
        id
        name
        type
        entityType
        pricePerMonth
        memberQuota
      }
    }
  }
`;
const PAYMENT_SUMMARY = gql$1`
  query paymentSummary($projectId: ID!) {
    paymentSummary(projectId: $projectId) {
      projectId
      nextBillingDate
      usagePeriod
      items {
        type
        entityType
        entityLevel
        name
        price
        amount
        totalPrice
        productQuota
        subscriberQuota
      }
      extras {
        type
        entityType
        entityLevel
        name
        price
        amount
        totalPrice
      }
      totalPrice
      subtotal
      vatOptions
      vatPrice
      mainPackagePeriod {
        startBillingDate
        endBillingDate
        subscriptionType
      }
    }
  }
`;
const HAS_CHANGES_ON_NEXT_CYCLE = gql$1`
  query hasChangesOnNextCycle($projectId: ID!) {
    hasChangesOnNextCycle(projectId: $projectId) {
      hasPackageChangesOnNextCycle
      hasAddonChangesOnNextCycle
    }
  }
`;
const formatData = (packages, index2) => {
  var _a2;
  if (packages.length === 0) {
    return null;
  }
  const combineKeyPackage = Array.from(new Set(packages.flatMap((plan) => Object.keys(plan))));
  const mainPackage = packages.find((plan) => plan.entityType === "MAIN" || plan.entityType === "BASIC");
  const cComPackage = packages.find((plan) => plan.entityType === "C_COMMERCE");
  const isFreePackage = (mainPackage == null ? void 0 : mainPackage.entityType) === "BASIC";
  const isStarter1Package = (mainPackage == null ? void 0 : mainPackage.entityLevel) === "STARTER_1";
  const combinePackage = combineKeyPackage.reduce((result, key) => {
    const packageKey = key;
    if (typeof (mainPackage == null ? void 0 : mainPackage[packageKey]) === typeof (cComPackage == null ? void 0 : cComPackage[packageKey])) {
      if ((mainPackage == null ? void 0 : mainPackage[packageKey]) === (cComPackage == null ? void 0 : cComPackage[packageKey])) {
        return __spreadProps(__spreadValues({}, result), {
          [packageKey]: mainPackage == null ? void 0 : mainPackage[packageKey]
        });
      }
      if (typeof (mainPackage == null ? void 0 : mainPackage[packageKey]) === "number") {
        return __spreadProps(__spreadValues({}, result), {
          [packageKey]: mainPackage[packageKey] + cComPackage[packageKey]
        });
      }
      if (typeof (mainPackage == null ? void 0 : mainPackage[packageKey]) === "string") {
        return __spreadProps(__spreadValues({}, result), {
          [`main_${packageKey}`]: mainPackage[packageKey],
          [`c_commerce_${packageKey}`]: cComPackage == null ? void 0 : cComPackage[packageKey],
          [packageKey]: mainPackage[packageKey]
        });
      }
      if (typeof (mainPackage == null ? void 0 : mainPackage[packageKey]) === "boolean") {
        return __spreadProps(__spreadValues({}, result), {
          [packageKey]: mainPackage[packageKey] && (cComPackage == null ? void 0 : cComPackage[packageKey])
        });
      }
      if (packageKey === "deeplePayFeeRate") {
        return __spreadProps(__spreadValues({}, result), {
          [packageKey]: __spreadProps(__spreadValues({}, cComPackage == null ? void 0 : cComPackage[packageKey]), {
            realTimeWithdrawal: true
          })
        });
      }
    }
    return __spreadProps(__spreadValues({}, result), {
      [packageKey]: typeof (mainPackage == null ? void 0 : mainPackage[packageKey]) !== "undefined" ? mainPackage == null ? void 0 : mainPackage[packageKey] : cComPackage == null ? void 0 : cComPackage[packageKey]
    });
  }, {});
  const title = (_a2 = mainPackage == null ? void 0 : mainPackage.entityLevel) == null ? void 0 : _a2.toLowerCase();
  return __spreadProps(__spreadValues({}, combinePackage), {
    index: index2,
    packages: [mainPackage == null ? void 0 : mainPackage.id, cComPackage == null ? void 0 : cComPackage.id].filter(Boolean).map((id2) => ({ id: id2 })),
    aiProductSearch: !isFreePackage,
    aiAddress: true,
    aiUpsell: true,
    chat: true,
    facebookCommentToChat: true,
    facebookLiveToChat: true,
    chatIntegration: "3(LINE, FB, IG)",
    openAPI: extraFeature[title].openAPI,
    logistic: "Lalamove, SHIPPOP",
    externalPaymentGateway: extraFeature[title].externalPaymentGateway,
    adminCount: extraFeature[title].adminCount,
    consoleApp: true,
    support: extraFeature[title].support,
    extraAdmin: false,
    zortIntegration: isFreePackage ? false : 290,
    title,
    totalPrice: combinePackage.subscriptionType === SubscriptionType$1.ANNUALLY ? combinePackage.pricePerYear : combinePackage.pricePerMonth,
    digitalProduct: true,
    customTheme: true,
    cod: true,
    saleReport: true,
    saleReportExport: !(isFreePackage || isStarter1Package),
    customerReport: true,
    customerReportExport: !(isFreePackage || isStarter1Package),
    consignmentReport: true,
    consignmentReportExport: true,
    promotion: true,
    delivery: true,
    orderPickup: true,
    flatRate: true,
    postcodeBase: true,
    manualCalculation: true,
    pickupStore: true,
    aiProductSearchAddon: !isFreePackage,
    realTimeWithdrawal: true,
    offlineOrder: true
  });
};
const usePlanData$1 = () => {
  const [getPackages, { loading: isLoading, data: packagesData }] = useLazyQuery(PACKAGES, {
    fetchPolicy: "no-cache"
  });
  let packages = {};
  if (packagesData && packagesData.packages) {
    const {
      free,
      premium,
      professional,
      standard,
      starter_1,
      starter_2,
      starter_3
    } = packagesData.packages;
    const allPackages = {
      FREE: formatData(free, 1),
      STARTER_1: formatData(starter_1, 2),
      STARTER_2: formatData(starter_2, 3),
      STARTER_3: formatData(starter_3, 4),
      STANDARD: formatData(standard, 5),
      PROFESSIONAL: formatData(professional, 6),
      PREMIUM: formatData(premium, 7),
      CUSTOM: customPlan
    };
    packages = Object.entries(allPackages).reduce((acc, [key, value]) => {
      if (value) {
        return __spreadProps(__spreadValues({}, acc), {
          [key]: value
        });
      }
      return acc;
    }, {});
  }
  return {
    getPackages,
    packages,
    isLoading
  };
};
const usePlanPromotion = (projectId) => {
  const { loading: isLoadingPackagePromotion, data: data2 } = useQuery(PACKAGE_PROMOTION, {
    variables: { projectId }
  });
  return {
    packagePromotionData: data2 == null ? void 0 : data2.packagePromotion,
    isLoadingPackagePromotion
  };
};
var th$1 = { exports: {} };
var dayjs_min = { exports: {} };
(function(module, exports) {
  !function(t2, e2) {
    module.exports = e2();
  }(commonjsGlobal, function() {
    var t2 = 1e3, e2 = 6e4, n2 = 36e5, r2 = "millisecond", i2 = "second", s = "minute", u = "hour", a2 = "day", o2 = "week", f2 = "month", h2 = "quarter", c2 = "year", d2 = "date", $2 = "Invalid Date", l2 = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y2 = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M2 = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") }, m2 = function(t3, e3, n3) {
      var r3 = String(t3);
      return !r3 || r3.length >= e3 ? t3 : "" + Array(e3 + 1 - r3.length).join(n3) + t3;
    }, g2 = { s: m2, z: function(t3) {
      var e3 = -t3.utcOffset(), n3 = Math.abs(e3), r3 = Math.floor(n3 / 60), i3 = n3 % 60;
      return (e3 <= 0 ? "+" : "-") + m2(r3, 2, "0") + ":" + m2(i3, 2, "0");
    }, m: function t3(e3, n3) {
      if (e3.date() < n3.date())
        return -t3(n3, e3);
      var r3 = 12 * (n3.year() - e3.year()) + (n3.month() - e3.month()), i3 = e3.clone().add(r3, f2), s2 = n3 - i3 < 0, u2 = e3.clone().add(r3 + (s2 ? -1 : 1), f2);
      return +(-(r3 + (n3 - i3) / (s2 ? i3 - u2 : u2 - i3)) || 0);
    }, a: function(t3) {
      return t3 < 0 ? Math.ceil(t3) || 0 : Math.floor(t3);
    }, p: function(t3) {
      return { M: f2, y: c2, w: o2, d: a2, D: d2, h: u, m: s, s: i2, ms: r2, Q: h2 }[t3] || String(t3 || "").toLowerCase().replace(/s$/, "");
    }, u: function(t3) {
      return t3 === void 0;
    } }, D2 = "en", v2 = {};
    v2[D2] = M2;
    var p2 = function(t3) {
      return t3 instanceof _23;
    }, S2 = function(t3, e3, n3) {
      var r3;
      if (!t3)
        return D2;
      if (typeof t3 == "string")
        v2[t3] && (r3 = t3), e3 && (v2[t3] = e3, r3 = t3);
      else {
        var i3 = t3.name;
        v2[i3] = t3, r3 = i3;
      }
      return !n3 && r3 && (D2 = r3), r3 || !n3 && D2;
    }, w2 = function(t3, e3) {
      if (p2(t3))
        return t3.clone();
      var n3 = typeof e3 == "object" ? e3 : {};
      return n3.date = t3, n3.args = arguments, new _23(n3);
    }, O2 = g2;
    O2.l = S2, O2.i = p2, O2.w = function(t3, e3) {
      return w2(t3, { locale: e3.$L, utc: e3.$u, x: e3.$x, $offset: e3.$offset });
    };
    var _23 = function() {
      function M3(t3) {
        this.$L = S2(t3.locale, null, true), this.parse(t3);
      }
      var m3 = M3.prototype;
      return m3.parse = function(t3) {
        this.$d = function(t4) {
          var e3 = t4.date, n3 = t4.utc;
          if (e3 === null)
            return new Date(NaN);
          if (O2.u(e3))
            return new Date();
          if (e3 instanceof Date)
            return new Date(e3);
          if (typeof e3 == "string" && !/Z$/i.test(e3)) {
            var r3 = e3.match(l2);
            if (r3) {
              var i3 = r3[2] - 1 || 0, s2 = (r3[7] || "0").substring(0, 3);
              return n3 ? new Date(Date.UTC(r3[1], i3, r3[3] || 1, r3[4] || 0, r3[5] || 0, r3[6] || 0, s2)) : new Date(r3[1], i3, r3[3] || 1, r3[4] || 0, r3[5] || 0, r3[6] || 0, s2);
            }
          }
          return new Date(e3);
        }(t3), this.$x = t3.x || {}, this.init();
      }, m3.init = function() {
        var t3 = this.$d;
        this.$y = t3.getFullYear(), this.$M = t3.getMonth(), this.$D = t3.getDate(), this.$W = t3.getDay(), this.$H = t3.getHours(), this.$m = t3.getMinutes(), this.$s = t3.getSeconds(), this.$ms = t3.getMilliseconds();
      }, m3.$utils = function() {
        return O2;
      }, m3.isValid = function() {
        return !(this.$d.toString() === $2);
      }, m3.isSame = function(t3, e3) {
        var n3 = w2(t3);
        return this.startOf(e3) <= n3 && n3 <= this.endOf(e3);
      }, m3.isAfter = function(t3, e3) {
        return w2(t3) < this.startOf(e3);
      }, m3.isBefore = function(t3, e3) {
        return this.endOf(e3) < w2(t3);
      }, m3.$g = function(t3, e3, n3) {
        return O2.u(t3) ? this[e3] : this.set(n3, t3);
      }, m3.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, m3.valueOf = function() {
        return this.$d.getTime();
      }, m3.startOf = function(t3, e3) {
        var n3 = this, r3 = !!O2.u(e3) || e3, h3 = O2.p(t3), $3 = function(t4, e4) {
          var i3 = O2.w(n3.$u ? Date.UTC(n3.$y, e4, t4) : new Date(n3.$y, e4, t4), n3);
          return r3 ? i3 : i3.endOf(a2);
        }, l3 = function(t4, e4) {
          return O2.w(n3.toDate()[t4].apply(n3.toDate("s"), (r3 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e4)), n3);
        }, y3 = this.$W, M4 = this.$M, m4 = this.$D, g3 = "set" + (this.$u ? "UTC" : "");
        switch (h3) {
          case c2:
            return r3 ? $3(1, 0) : $3(31, 11);
          case f2:
            return r3 ? $3(1, M4) : $3(0, M4 + 1);
          case o2:
            var D3 = this.$locale().weekStart || 0, v3 = (y3 < D3 ? y3 + 7 : y3) - D3;
            return $3(r3 ? m4 - v3 : m4 + (6 - v3), M4);
          case a2:
          case d2:
            return l3(g3 + "Hours", 0);
          case u:
            return l3(g3 + "Minutes", 1);
          case s:
            return l3(g3 + "Seconds", 2);
          case i2:
            return l3(g3 + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, m3.endOf = function(t3) {
        return this.startOf(t3, false);
      }, m3.$set = function(t3, e3) {
        var n3, o3 = O2.p(t3), h3 = "set" + (this.$u ? "UTC" : ""), $3 = (n3 = {}, n3[a2] = h3 + "Date", n3[d2] = h3 + "Date", n3[f2] = h3 + "Month", n3[c2] = h3 + "FullYear", n3[u] = h3 + "Hours", n3[s] = h3 + "Minutes", n3[i2] = h3 + "Seconds", n3[r2] = h3 + "Milliseconds", n3)[o3], l3 = o3 === a2 ? this.$D + (e3 - this.$W) : e3;
        if (o3 === f2 || o3 === c2) {
          var y3 = this.clone().set(d2, 1);
          y3.$d[$3](l3), y3.init(), this.$d = y3.set(d2, Math.min(this.$D, y3.daysInMonth())).$d;
        } else
          $3 && this.$d[$3](l3);
        return this.init(), this;
      }, m3.set = function(t3, e3) {
        return this.clone().$set(t3, e3);
      }, m3.get = function(t3) {
        return this[O2.p(t3)]();
      }, m3.add = function(r3, h3) {
        var d3, $3 = this;
        r3 = Number(r3);
        var l3 = O2.p(h3), y3 = function(t3) {
          var e3 = w2($3);
          return O2.w(e3.date(e3.date() + Math.round(t3 * r3)), $3);
        };
        if (l3 === f2)
          return this.set(f2, this.$M + r3);
        if (l3 === c2)
          return this.set(c2, this.$y + r3);
        if (l3 === a2)
          return y3(1);
        if (l3 === o2)
          return y3(7);
        var M4 = (d3 = {}, d3[s] = e2, d3[u] = n2, d3[i2] = t2, d3)[l3] || 1, m4 = this.$d.getTime() + r3 * M4;
        return O2.w(m4, this);
      }, m3.subtract = function(t3, e3) {
        return this.add(-1 * t3, e3);
      }, m3.format = function(t3) {
        var e3 = this, n3 = this.$locale();
        if (!this.isValid())
          return n3.invalidDate || $2;
        var r3 = t3 || "YYYY-MM-DDTHH:mm:ssZ", i3 = O2.z(this), s2 = this.$H, u2 = this.$m, a3 = this.$M, o3 = n3.weekdays, f3 = n3.months, h3 = function(t4, n4, i4, s3) {
          return t4 && (t4[n4] || t4(e3, r3)) || i4[n4].substr(0, s3);
        }, c3 = function(t4) {
          return O2.s(s2 % 12 || 12, t4, "0");
        }, d3 = n3.meridiem || function(t4, e4, n4) {
          var r4 = t4 < 12 ? "AM" : "PM";
          return n4 ? r4.toLowerCase() : r4;
        }, l3 = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: a3 + 1, MM: O2.s(a3 + 1, 2, "0"), MMM: h3(n3.monthsShort, a3, f3, 3), MMMM: h3(f3, a3), D: this.$D, DD: O2.s(this.$D, 2, "0"), d: String(this.$W), dd: h3(n3.weekdaysMin, this.$W, o3, 2), ddd: h3(n3.weekdaysShort, this.$W, o3, 3), dddd: o3[this.$W], H: String(s2), HH: O2.s(s2, 2, "0"), h: c3(1), hh: c3(2), a: d3(s2, u2, true), A: d3(s2, u2, false), m: String(u2), mm: O2.s(u2, 2, "0"), s: String(this.$s), ss: O2.s(this.$s, 2, "0"), SSS: O2.s(this.$ms, 3, "0"), Z: i3 };
        return r3.replace(y2, function(t4, e4) {
          return e4 || l3[t4] || i3.replace(":", "");
        });
      }, m3.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m3.diff = function(r3, d3, $3) {
        var l3, y3 = O2.p(d3), M4 = w2(r3), m4 = (M4.utcOffset() - this.utcOffset()) * e2, g3 = this - M4, D3 = O2.m(this, M4);
        return D3 = (l3 = {}, l3[c2] = D3 / 12, l3[f2] = D3, l3[h2] = D3 / 3, l3[o2] = (g3 - m4) / 6048e5, l3[a2] = (g3 - m4) / 864e5, l3[u] = g3 / n2, l3[s] = g3 / e2, l3[i2] = g3 / t2, l3)[y3] || g3, $3 ? D3 : O2.a(D3);
      }, m3.daysInMonth = function() {
        return this.endOf(f2).$D;
      }, m3.$locale = function() {
        return v2[this.$L];
      }, m3.locale = function(t3, e3) {
        if (!t3)
          return this.$L;
        var n3 = this.clone(), r3 = S2(t3, e3, true);
        return r3 && (n3.$L = r3), n3;
      }, m3.clone = function() {
        return O2.w(this.$d, this);
      }, m3.toDate = function() {
        return new Date(this.valueOf());
      }, m3.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, m3.toISOString = function() {
        return this.$d.toISOString();
      }, m3.toString = function() {
        return this.$d.toUTCString();
      }, M3;
    }(), b2 = _23.prototype;
    return w2.prototype = b2, [["$ms", r2], ["$s", i2], ["$m", s], ["$H", u], ["$W", a2], ["$M", f2], ["$y", c2], ["$D", d2]].forEach(function(t3) {
      b2[t3[1]] = function(e3) {
        return this.$g(e3, t3[0], t3[1]);
      };
    }), w2.extend = function(t3, e3) {
      return t3.$i || (t3(e3, _23, w2), t3.$i = true), w2;
    }, w2.locale = S2, w2.isDayjs = p2, w2.unix = function(t3) {
      return w2(1e3 * t3);
    }, w2.en = v2[D2], w2.Ls = v2, w2.p = {}, w2;
  });
})(dayjs_min);
var dayjs = dayjs_min.exports;
(function(module, exports) {
  !function(_23, e2) {
    module.exports = e2(dayjs_min.exports);
  }(commonjsGlobal, function(_23) {
    function e2(_24) {
      return _24 && typeof _24 == "object" && "default" in _24 ? _24 : { default: _24 };
    }
    var t2 = e2(_23), d2 = { name: "th", weekdays: "\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C_\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C_\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23_\u0E1E\u0E38\u0E18_\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35_\u0E28\u0E38\u0E01\u0E23\u0E4C_\u0E40\u0E2A\u0E32\u0E23\u0E4C".split("_"), weekdaysShort: "\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C_\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C_\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23_\u0E1E\u0E38\u0E18_\u0E1E\u0E24\u0E2B\u0E31\u0E2A_\u0E28\u0E38\u0E01\u0E23\u0E4C_\u0E40\u0E2A\u0E32\u0E23\u0E4C".split("_"), weekdaysMin: "\u0E2D\u0E32._\u0E08._\u0E2D._\u0E1E._\u0E1E\u0E24._\u0E28._\u0E2A.".split("_"), months: "\u0E21\u0E01\u0E23\u0E32\u0E04\u0E21_\u0E01\u0E38\u0E21\u0E20\u0E32\u0E1E\u0E31\u0E19\u0E18\u0E4C_\u0E21\u0E35\u0E19\u0E32\u0E04\u0E21_\u0E40\u0E21\u0E29\u0E32\u0E22\u0E19_\u0E1E\u0E24\u0E29\u0E20\u0E32\u0E04\u0E21_\u0E21\u0E34\u0E16\u0E38\u0E19\u0E32\u0E22\u0E19_\u0E01\u0E23\u0E01\u0E0E\u0E32\u0E04\u0E21_\u0E2A\u0E34\u0E07\u0E2B\u0E32\u0E04\u0E21_\u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19_\u0E15\u0E38\u0E25\u0E32\u0E04\u0E21_\u0E1E\u0E24\u0E28\u0E08\u0E34\u0E01\u0E32\u0E22\u0E19_\u0E18\u0E31\u0E19\u0E27\u0E32\u0E04\u0E21".split("_"), monthsShort: "\u0E21.\u0E04._\u0E01.\u0E1E._\u0E21\u0E35.\u0E04._\u0E40\u0E21.\u0E22._\u0E1E.\u0E04._\u0E21\u0E34.\u0E22._\u0E01.\u0E04._\u0E2A.\u0E04._\u0E01.\u0E22._\u0E15.\u0E04._\u0E1E.\u0E22._\u0E18.\u0E04.".split("_"), formats: { LT: "H:mm", LTS: "H:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY \u0E40\u0E27\u0E25\u0E32 H:mm", LLLL: "\u0E27\u0E31\u0E19dddd\u0E17\u0E35\u0E48 D MMMM YYYY \u0E40\u0E27\u0E25\u0E32 H:mm" }, relativeTime: { future: "\u0E2D\u0E35\u0E01 %s", past: "%s\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27", s: "\u0E44\u0E21\u0E48\u0E01\u0E35\u0E48\u0E27\u0E34\u0E19\u0E32\u0E17\u0E35", m: "1 \u0E19\u0E32\u0E17\u0E35", mm: "%d \u0E19\u0E32\u0E17\u0E35", h: "1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07", hh: "%d \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07", d: "1 \u0E27\u0E31\u0E19", dd: "%d \u0E27\u0E31\u0E19", M: "1 \u0E40\u0E14\u0E37\u0E2D\u0E19", MM: "%d \u0E40\u0E14\u0E37\u0E2D\u0E19", y: "1 \u0E1B\u0E35", yy: "%d \u0E1B\u0E35" }, ordinal: function(_24) {
      return _24 + ".";
    } };
    return t2.default.locale(d2, null, true), d2;
  });
})(th$1);
const formatDate = (dateString) => {
  return dayjs(dateString).locale(i18next.language).format("DD MMM YYYY");
};
function UpgradePlanComponent({
  projectId,
  onSelectPackage,
  isUsingNotSupportedPackage = false,
  isAllowAnnuallyPackage = false,
  isPermissionToMonthlySubscription,
  isUsingCustomPackage = false
}) {
  const {
    t: t2
  } = useTranslation();
  const {
    getPackages,
    packages,
    isLoading
  } = usePlanData$1();
  const {
    packagePromotionData
  } = usePlanPromotion(projectId);
  const [activePlan, setActivePlan] = useState(null);
  const [subscriptionType, setSubscriptionType] = useState(isPermissionToMonthlySubscription || !isAllowAnnuallyPackage ? SubscriptionType$1.MONTHLY : SubscriptionType$1.ANNUALLY);
  useEffect(() => {
    if (!isEmpty_1(packages) && !activePlan) {
      setActivePlan(Object.values(packages)[0].entityLevel);
    }
  }, [packages, activePlan]);
  const handleSlidePlan = (entityLevel) => setActivePlan(entityLevel);
  useEffect(() => {
    getPackages({
      variables: {
        projectId,
        subscriptionType
      }
    });
  }, [subscriptionType, getPackages, projectId]);
  const handleChangeSubscriptionType = (checked) => {
    if (checked) {
      return setSubscriptionType(SubscriptionType$1.ANNUALLY);
    }
    return setSubscriptionType(SubscriptionType$1.MONTHLY);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "tw-m-auto tw-max-w-[1500px]",
    children: [/* @__PURE__ */ jsx$1(Typography, {
      variant: "heading-6",
      className: "tw-p-4 tw-m-auto tw-mt-4 tw-w-full tw-max-w-[480px] tw-text-center",
      children: t2("plan.upgradePlan.pageTitle")
    }), /* @__PURE__ */ jsx$1(Typography, {
      variant: "body-2",
      className: "tw-m-auto tw-mb-3 tw-w-full tw-max-w-[456px] tw-text-center",
      color: COLORS.Gray[500],
      children: t2("plan.upgradePlan.pageSubTitle")
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-mb-8",
      children: [isAllowAnnuallyPackage && isPermissionToMonthlySubscription && !isUsingCustomPackage && /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-justify-center tw-items-center",
        children: [/* @__PURE__ */ jsx$1(Typography, {
          variant: "title-8",
          className: "tw-mr-3.5",
          children: t2("plan.upgradePlan.billMonthly")
        }), /* @__PURE__ */ jsx$1(Switch$1, {
          handleChange: handleChangeSubscriptionType,
          defaultChecked: subscriptionType === SubscriptionType$1.ANNUALLY
        }), /* @__PURE__ */ jsx$1(Typography, {
          variant: "title-8",
          className: "tw-mr-2 tw-ml-3.5",
          children: t2("plan.upgradePlan.billAnnually")
        }), /* @__PURE__ */ jsx$1("div", {
          className: "tw-group tw-py-1 tw-px-2 tw-w-32 tw-text-center tw-bg-gradient-to-r tw-from-[#EC008C] tw-to-[#FF4E00] tw-rounded",
          children: /* @__PURE__ */ jsxs(Typography, {
            variant: "title-9",
            color: COLORS.White,
            children: [/* @__PURE__ */ jsx$1("span", {
              className: "group-hover:tw-hidden",
              children: (packagePromotionData == null ? void 0 : packagePromotionData.discountPercent) ? t2("plan.upgradePlan.discount", {
                discountPercent: packagePromotionData == null ? void 0 : packagePromotionData.discountPercent
              }) : t2("plan.upgradePlan.useFree2Month")
            }), /* @__PURE__ */ jsx$1("span", {
              className: "tw-hidden group-hover:tw-block",
              children: t2("plan.upgradePlan.forAnnually")
            })]
          })
        })]
      }), (packagePromotionData == null ? void 0 : packagePromotionData.end) && /* @__PURE__ */ jsx$1("div", {
        className: "tw-mt-3 tw-text-center",
        children: /* @__PURE__ */ jsxs(Typography, {
          variant: "title-8",
          children: [/* @__PURE__ */ jsx$1("span", {
            className: "tw-mr-1 body-2",
            children: t2("plan.upgradePlan.promotionEnd")
          }), formatDate(packagePromotionData.end)]
        })
      })]
    }), !isLoading && /* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsx$1(PlanList, {
        plans: packages,
        onSlidePlan: handleSlidePlan,
        onSelectPackage,
        isUsingNotSupportedPackage,
        isUsingCustomPackage,
        packagePromotion: packagePromotionData
      }), /* @__PURE__ */ jsx$1(FeatureList, {
        plans: packages,
        activePlan,
        isUsingNotSupportedPackage
      })]
    })]
  });
}
const UpgradePlan = (props) => {
  return /* @__PURE__ */ jsx$1(ContextProviders, {
    children: /* @__PURE__ */ jsx$1(UpgradePlanComponent, __spreadValues({}, props))
  });
};
const ICON_SIZE_MAP = {
  none: IconSize.DEFAULT,
  small: IconSize.SMALL,
  medium: IconSize.MEDIUM,
  large: IconSize.LARGE,
  fullWidth: IconSize.LARGE
};
function ButtonIcon(_L) {
  var _M = _L, {
    variant = "primary",
    size = "medium",
    isLoading = false,
    children: children2,
    iconName,
    className
  } = _M, rest = __objRest(_M, [
    "variant",
    "size",
    "isLoading",
    "children",
    "iconName",
    "className"
  ]);
  const iconSize = ICON_SIZE_MAP[size] || IconSize.DEFAULT;
  return /* @__PURE__ */ jsx$1("button", __spreadProps(__spreadValues({
    className: classNames$1("tw-rounded-full tw-transition-all disabled:tw-cursor-not-allowed", {
      "tw-bg-Primary-500 tw-fill-White hover:tw-bg-Primary-600 active:tw-bg-Primary-400 disabled:tw-bg-Gray-200 disabled:tw-fill-Gray-400": variant === "primary",
      "tw-bg-Gray-200 tw-fill-Black hover:tw-bg-Gray-300 active:tw-bg-Gray-100 disabled:tw-bg-Gray-200 disabled:tw-fill-Gray-400": variant === "secondary",
      "tw-bg-Tertiary tw-fill-Primary-500 tw-border tw-border-Primary-300 hover:tw-bg-Primary-300 active:tw-bg-Primary-100 disabled:tw-bg-Primary-100 disabled:tw-fill-Primary-300": variant === "tertiary",
      "tw-bg-White tw-fill-Primary-500 hover:tw-bg-Primary-200 active:tw-bg-Primary-100 disabled:tw-fill-Gray-400 disabled:hover:tw-bg-Transparent": variant === "text"
    }, {
      "tw-p-3": size === "large",
      "tw-p-2": size === "medium",
      "tw-p-1": size === "small"
    }, className)
  }, rest), {
    children: /* @__PURE__ */ jsx$1("div", {
      className: "tw-flex tw-relative tw-items-center tw-w-full",
      children: /* @__PURE__ */ jsx$1("div", {
        className: "tw-flex tw-relative tw-justify-center tw-items-center tw-w-full",
        children: isLoading ? /* @__PURE__ */ jsx$1(Icon, {
          name: IconName.LOADING,
          className: "tw-animate-spin",
          size: iconSize
        }) : /* @__PURE__ */ jsx$1(Icon, {
          name: iconName,
          size: iconSize
        })
      })
    })
  }));
}
function PageTitle({
  onClickBack,
  title,
  description,
  tooltip,
  tooltipIconName
}) {
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-items-start",
      children: [onClickBack && /* @__PURE__ */ jsx$1(ButtonIcon, {
        iconName: IconName.ARROW_LEFT,
        variant: "tertiary",
        className: "tw-border-none",
        onClick: onClickBack
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-ml-4",
        children: [/* @__PURE__ */ jsx$1(Typography, {
          variant: "title-4",
          children: title
        }), tooltip && /* @__PURE__ */ jsx$1("div", {
          className: "tw-ml-4",
          children: /* @__PURE__ */ jsx$1(Tooltip, {
            description: tooltip,
            position: "right",
            children: /* @__PURE__ */ jsx$1(Icon, {
              name: tooltipIconName || IconName.INFO,
              className: "tw-fill-Gray-400"
            })
          })
        })]
      })]
    }), description && /* @__PURE__ */ jsx$1(Typography, {
      variant: "body-2",
      className: "tw-mt-4 tw-text-Gray-600",
      children: description
    })]
  });
}
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number2 = Number(dirtyNumber);
  if (isNaN(number2)) {
    return number2;
  }
  return number2 < 0 ? Math.ceil(number2) : Math.floor(number2);
}
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
  }
}
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") {
    return new Date(argument.getTime());
  } else if (typeof argument === "number" || argStr === "[object Number]") {
    return new Date(argument);
  } else {
    if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule");
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
function getTimezoneOffsetInMilliseconds(date2) {
  var utcDate = new Date(Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate(), date2.getHours(), date2.getMinutes(), date2.getSeconds(), date2.getMilliseconds()));
  utcDate.setUTCFullYear(date2.getFullYear());
  return date2.getTime() - utcDate.getTime();
}
function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== "number") {
    return false;
  }
  var date2 = toDate(dirtyDate);
  return !isNaN(Number(date2));
}
var formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
var formatDistance$1 = function(token2, count, options2) {
  var result;
  var tokenValue = formatDistanceLocale$1[token2];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options2 !== null && options2 !== void 0 && options2.addSuffix) {
    if (options2.comparison && options2.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
var formatDistance$2 = formatDistance$1;
function buildFormatLongFn(args) {
  return function() {
    var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var width = options2.width ? String(options2.width) : args.defaultWidth;
    var format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
var dateFormats$1 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
var timeFormats$1 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats$1 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong$2 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: "full"
  })
};
var formatLong$3 = formatLong$2;
var formatRelativeLocale$1 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
var formatRelative$1 = function(token2, _date, _baseDate, _options) {
  return formatRelativeLocale$1[token2];
};
var formatRelative$2 = formatRelative$1;
function buildLocalizeFn(args) {
  return function(dirtyIndex, dirtyOptions) {
    var options2 = dirtyOptions || {};
    var context = options2.context ? String(options2.context) : "standalone";
    var valuesArray;
    if (context === "formatting" && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options2.width ? String(options2.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options2.width ? String(options2.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index2 = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index2];
  };
}
var eraValues$1 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
var quarterValues$1 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
var monthValues$1 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
var dayValues$1 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
var dayPeriodValues$1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
var formattingDayPeriodValues$1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
var ordinalNumber$1 = function(dirtyNumber, _options) {
  var number2 = Number(dirtyNumber);
  var rem100 = number2 % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number2 + "st";
      case 2:
        return number2 + "nd";
      case 3:
        return number2 + "rd";
    }
  }
  return number2 + "th";
};
var localize$2 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn({
    values: eraValues$1,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1,
    defaultWidth: "wide",
    argumentCallback: function(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: "wide"
  })
};
var localize$3 = localize$2;
function buildMatchFn(args) {
  return function(string2) {
    var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var width = options2.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string2.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options2.valueCallback ? options2.valueCallback(value) : value;
    var rest = string2.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
function findKey(object2, predicate) {
  for (var key in object2) {
    if (object2.hasOwnProperty(key) && predicate(object2[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array2, predicate) {
  for (var key = 0; key < array2.length; key++) {
    if (predicate(array2[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return function(string2) {
    var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var matchResult = string2.match(args.matchPattern);
    if (!matchResult)
      return null;
    var matchedString = matchResult[0];
    var parseResult = string2.match(args.parsePattern);
    if (!parseResult)
      return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options2.valueCallback ? options2.valueCallback(value) : value;
    var rest = string2.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
var matchOrdinalNumberPattern$1 = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern$1 = /\d+/i;
var matchEraPatterns$1 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns$1 = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$1 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns$1 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$1 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns$1 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns$1 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns$1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match$2 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: function(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: "any",
    valueCallback: function(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: "any"
  })
};
var match$3 = match$2;
var locale$1 = {
  code: "en-US",
  formatDistance: formatDistance$2,
  formatLong: formatLong$3,
  formatRelative: formatRelative$2,
  localize: localize$3,
  match: match$3,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
var enUS = locale$1;
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
var MILLISECONDS_IN_DAY = 864e5;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var timestamp = date2.getTime();
  date2.setUTCMonth(0, 1);
  date2.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date2.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date2 = toDate(dirtyDate);
  var day = date2.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date2.setUTCDate(date2.getUTCDate() - diff);
  date2.setUTCHours(0, 0, 0, 0);
  return date2;
}
function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var year = date2.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date2.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date2.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date2 = startOfUTCISOWeek(fourthOfJanuary);
  return date2;
}
var MILLISECONDS_IN_WEEK$1 = 6048e5;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date2).getTime() - startOfUTCISOWeekYear(date2).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}
function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options2 = dirtyOptions || {};
  var locale2 = options2.locale;
  var localeWeekStartsOn = locale2 && locale2.options && locale2.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options2.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options2.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date2 = toDate(dirtyDate);
  var day = date2.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date2.setUTCDate(date2.getUTCDate() - diff);
  date2.setUTCHours(0, 0, 0, 0);
  return date2;
}
function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var year = date2.getUTCFullYear();
  var options2 = dirtyOptions || {};
  var locale2 = options2.locale;
  var localeFirstWeekContainsDate = locale2 && locale2.options && locale2.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options2.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options2.firstWeekContainsDate);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);
  if (date2.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date2.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options2 = dirtyOptions || {};
  var locale2 = options2.locale;
  var localeFirstWeekContainsDate = locale2 && locale2.options && locale2.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options2.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options2.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date2 = startOfUTCWeek(firstWeek, dirtyOptions);
  return date2;
}
var MILLISECONDS_IN_WEEK = 6048e5;
function getUTCWeek(dirtyDate, options2) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var diff = startOfUTCWeek(date2, options2).getTime() - startOfUTCWeekYear(date2, options2).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
function addLeadingZeros(number2, targetLength) {
  var sign = number2 < 0 ? "-" : "";
  var output2 = Math.abs(number2).toString();
  while (output2.length < targetLength) {
    output2 = "0" + output2;
  }
  return sign + output2;
}
var formatters$2 = {
  y: function(date2, token2) {
    var signedYear = date2.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token2 === "yy" ? year % 100 : year, token2.length);
  },
  M: function(date2, token2) {
    var month = date2.getUTCMonth();
    return token2 === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  d: function(date2, token2) {
    return addLeadingZeros(date2.getUTCDate(), token2.length);
  },
  a: function(date2, token2) {
    var dayPeriodEnumValue = date2.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (token2) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  h: function(date2, token2) {
    return addLeadingZeros(date2.getUTCHours() % 12 || 12, token2.length);
  },
  H: function(date2, token2) {
    return addLeadingZeros(date2.getUTCHours(), token2.length);
  },
  m: function(date2, token2) {
    return addLeadingZeros(date2.getUTCMinutes(), token2.length);
  },
  s: function(date2, token2) {
    return addLeadingZeros(date2.getUTCSeconds(), token2.length);
  },
  S: function(date2, token2) {
    var numberOfDigits = token2.length;
    var milliseconds = date2.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token2.length);
  }
};
var formatters$3 = formatters$2;
var dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
var formatters = {
  G: function(date2, token2, localize2) {
    var era = date2.getUTCFullYear() > 0 ? 1 : 0;
    switch (token2) {
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, {
          width: "abbreviated"
        });
      case "GGGGG":
        return localize2.era(era, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return localize2.era(era, {
          width: "wide"
        });
    }
  },
  y: function(date2, token2, localize2) {
    if (token2 === "yo") {
      var signedYear = date2.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, {
        unit: "year"
      });
    }
    return formatters$3.y(date2, token2);
  },
  Y: function(date2, token2, localize2, options2) {
    var signedWeekYear = getUTCWeekYear(date2, options2);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token2 === "YY") {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token2 === "Yo") {
      return localize2.ordinalNumber(weekYear, {
        unit: "year"
      });
    }
    return addLeadingZeros(weekYear, token2.length);
  },
  R: function(date2, token2) {
    var isoWeekYear = getUTCISOWeekYear(date2);
    return addLeadingZeros(isoWeekYear, token2.length);
  },
  u: function(date2, token2) {
    var year = date2.getUTCFullYear();
    return addLeadingZeros(year, token2.length);
  },
  Q: function(date2, token2, localize2) {
    var quarter = Math.ceil((date2.getUTCMonth() + 1) / 3);
    switch (token2) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  q: function(date2, token2, localize2) {
    var quarter = Math.ceil((date2.getUTCMonth() + 1) / 3);
    switch (token2) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros(quarter, 2);
      case "qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  M: function(date2, token2, localize2) {
    var month = date2.getUTCMonth();
    switch (token2) {
      case "M":
      case "MM":
        return formatters$3.M(date2, token2);
      case "Mo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  L: function(date2, token2, localize2) {
    var month = date2.getUTCMonth();
    switch (token2) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros(month + 1, 2);
      case "Lo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  w: function(date2, token2, localize2, options2) {
    var week = getUTCWeek(date2, options2);
    if (token2 === "wo") {
      return localize2.ordinalNumber(week, {
        unit: "week"
      });
    }
    return addLeadingZeros(week, token2.length);
  },
  I: function(date2, token2, localize2) {
    var isoWeek = getUTCISOWeek(date2);
    if (token2 === "Io") {
      return localize2.ordinalNumber(isoWeek, {
        unit: "week"
      });
    }
    return addLeadingZeros(isoWeek, token2.length);
  },
  d: function(date2, token2, localize2) {
    if (token2 === "do") {
      return localize2.ordinalNumber(date2.getUTCDate(), {
        unit: "date"
      });
    }
    return formatters$3.d(date2, token2);
  },
  D: function(date2, token2, localize2) {
    var dayOfYear = getUTCDayOfYear(date2);
    if (token2 === "Do") {
      return localize2.ordinalNumber(dayOfYear, {
        unit: "dayOfYear"
      });
    }
    return addLeadingZeros(dayOfYear, token2.length);
  },
  E: function(date2, token2, localize2) {
    var dayOfWeek = date2.getUTCDay();
    switch (token2) {
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  e: function(date2, token2, localize2, options2) {
    var dayOfWeek = date2.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options2.weekStartsOn + 8) % 7 || 7;
    switch (token2) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  c: function(date2, token2, localize2, options2) {
    var dayOfWeek = date2.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options2.weekStartsOn + 8) % 7 || 7;
    switch (token2) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros(localDayOfWeek, token2.length);
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  i: function(date2, token2, localize2) {
    var dayOfWeek = date2.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token2) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token2.length);
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, {
          unit: "day"
        });
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  a: function(date2, token2, localize2) {
    var hours = date2.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token2) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  b: function(date2, token2, localize2) {
    var hours = date2.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token2) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  B: function(date2, token2, localize2) {
    var hours = date2.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token2) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  h: function(date2, token2, localize2) {
    if (token2 === "ho") {
      var hours = date2.getUTCHours() % 12;
      if (hours === 0)
        hours = 12;
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return formatters$3.h(date2, token2);
  },
  H: function(date2, token2, localize2) {
    if (token2 === "Ho") {
      return localize2.ordinalNumber(date2.getUTCHours(), {
        unit: "hour"
      });
    }
    return formatters$3.H(date2, token2);
  },
  K: function(date2, token2, localize2) {
    var hours = date2.getUTCHours() % 12;
    if (token2 === "Ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token2.length);
  },
  k: function(date2, token2, localize2) {
    var hours = date2.getUTCHours();
    if (hours === 0)
      hours = 24;
    if (token2 === "ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token2.length);
  },
  m: function(date2, token2, localize2) {
    if (token2 === "mo") {
      return localize2.ordinalNumber(date2.getUTCMinutes(), {
        unit: "minute"
      });
    }
    return formatters$3.m(date2, token2);
  },
  s: function(date2, token2, localize2) {
    if (token2 === "so") {
      return localize2.ordinalNumber(date2.getUTCSeconds(), {
        unit: "second"
      });
    }
    return formatters$3.s(date2, token2);
  },
  S: function(date2, token2) {
    return formatters$3.S(date2, token2);
  },
  X: function(date2, token2, _localize, options2) {
    var originalDate = options2._originalDate || date2;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token2) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  x: function(date2, token2, _localize, options2) {
    var originalDate = options2._originalDate || date2;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  O: function(date2, token2, _localize, options2) {
    var originalDate = options2._originalDate || date2;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  z: function(date2, token2, _localize, options2) {
    var originalDate = options2._originalDate || date2;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  t: function(date2, token2, _localize, options2) {
    var originalDate = options2._originalDate || date2;
    var timestamp = Math.floor(originalDate.getTime() / 1e3);
    return addLeadingZeros(timestamp, token2.length);
  },
  T: function(date2, token2, _localize, options2) {
    var originalDate = options2._originalDate || date2;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token2.length);
  }
};
function formatTimezoneShort(offset2, dirtyDelimiter) {
  var sign = offset2 > 0 ? "-" : "+";
  var absOffset = Math.abs(offset2);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter2 = dirtyDelimiter || "";
  return sign + String(hours) + delimiter2 + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset2, dirtyDelimiter) {
  if (offset2 % 60 === 0) {
    var sign = offset2 > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset2) / 60, 2);
  }
  return formatTimezone(offset2, dirtyDelimiter);
}
function formatTimezone(offset2, dirtyDelimiter) {
  var delimiter2 = dirtyDelimiter || "";
  var sign = offset2 > 0 ? "-" : "+";
  var absOffset = Math.abs(offset2);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter2 + minutes;
}
var formatters$1 = formatters;
function dateLongFormatter(pattern, formatLong2) {
  switch (pattern) {
    case "P":
      return formatLong2.date({
        width: "short"
      });
    case "PP":
      return formatLong2.date({
        width: "medium"
      });
    case "PPP":
      return formatLong2.date({
        width: "long"
      });
    case "PPPP":
    default:
      return formatLong2.date({
        width: "full"
      });
  }
}
function timeLongFormatter(pattern, formatLong2) {
  switch (pattern) {
    case "p":
      return formatLong2.time({
        width: "short"
      });
    case "pp":
      return formatLong2.time({
        width: "medium"
      });
    case "ppp":
      return formatLong2.time({
        width: "long"
      });
    case "pppp":
    default:
      return formatLong2.time({
        width: "full"
      });
  }
}
function dateTimeLongFormatter(pattern, formatLong2) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong2);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({
        width: "short"
      });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({
        width: "full"
      });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
}
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$1 = longFormatters;
var protectedDayOfYearTokens = ["D", "DD"];
var protectedWeekYearTokens = ["YY", "YYYY"];
function isProtectedDayOfYearToken(token2) {
  return protectedDayOfYearTokens.indexOf(token2) !== -1;
}
function isProtectedWeekYearToken(token2) {
  return protectedWeekYearTokens.indexOf(token2) !== -1;
}
function throwProtectedError(token2, format2, input) {
  if (token2 === "YYYY") {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token2 === "YY") {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token2 === "D") {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token2 === "DD") {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options2 = dirtyOptions || {};
  var locale2 = options2.locale || enUS;
  var localeFirstWeekContainsDate = locale2.options && locale2.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options2.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options2.firstWeekContainsDate);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var localeWeekStartsOn = locale2.options && locale2.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options2.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options2.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (!locale2.localize) {
    throw new RangeError("locale must contain localize property");
  }
  if (!locale2.formatLong) {
    throw new RangeError("locale must contain formatLong property");
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale2.formatLong, formatterOptions);
    }
    return substring;
  }).join("").match(formattingTokensRegExp).map(function(substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!options2.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }
      if (!options2.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }
      return formatter(utcDate, substring, locale2.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
    other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
  },
  xSeconds: {
    one: "1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
    other: "{{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
  },
  halfAMinute: "\u0E04\u0E23\u0E36\u0E48\u0E07\u0E19\u0E32\u0E17\u0E35",
  lessThanXMinutes: {
    one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E19\u0E32\u0E17\u0E35",
    other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E19\u0E32\u0E17\u0E35"
  },
  xMinutes: {
    one: "1 \u0E19\u0E32\u0E17\u0E35",
    other: "{{count}} \u0E19\u0E32\u0E17\u0E35"
  },
  aboutXHours: {
    one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
    other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
  },
  xHours: {
    one: "1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
    other: "{{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
  },
  xDays: {
    one: "1 \u0E27\u0E31\u0E19",
    other: "{{count}} \u0E27\u0E31\u0E19"
  },
  aboutXWeeks: {
    one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
    other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
  },
  xWeeks: {
    one: "1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
    other: "{{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
  },
  aboutXMonths: {
    one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
    other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
  },
  xMonths: {
    one: "1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
    other: "{{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
  },
  aboutXYears: {
    one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E1B\u0E35",
    other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E1B\u0E35"
  },
  xYears: {
    one: "1 \u0E1B\u0E35",
    other: "{{count}} \u0E1B\u0E35"
  },
  overXYears: {
    one: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 1 \u0E1B\u0E35",
    other: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E1B\u0E35"
  },
  almostXYears: {
    one: "\u0E40\u0E01\u0E37\u0E2D\u0E1A 1 \u0E1B\u0E35",
    other: "\u0E40\u0E01\u0E37\u0E2D\u0E1A {{count}} \u0E1B\u0E35"
  }
};
function formatDistance(token2, count, options2) {
  options2 = options2 || {};
  var result;
  if (typeof formatDistanceLocale[token2] === "string") {
    result = formatDistanceLocale[token2];
  } else if (count === 1) {
    result = formatDistanceLocale[token2].one;
  } else {
    result = formatDistanceLocale[token2].other.replace("{{count}}", count);
  }
  if (options2.addSuffix) {
    if (options2.comparison > 0) {
      if (token2 === "halfAMinute") {
        return "\u0E43\u0E19" + result;
      } else {
        return "\u0E43\u0E19 " + result;
      }
    } else {
      return result + "\u0E17\u0E35\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E21\u0E32";
    }
  }
  return result;
}
var dateFormats = {
  full: "\u0E27\u0E31\u0E19EEEE\u0E17\u0E35\u0E48 do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
};
var timeFormats = {
  full: "H:mm:ss \u0E19. zzzz",
  long: "H:mm:ss \u0E19. z",
  medium: "H:mm:ss \u0E19.",
  short: "H:mm \u0E19."
};
var dateTimeFormats = {
  full: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
  long: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "medium"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
var formatLong$1 = formatLong;
var formatRelativeLocale = {
  lastWeek: "eeee'\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27\u0E40\u0E27\u0E25\u0E32' p",
  yesterday: "'\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
  today: "'\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
  tomorrow: "'\u0E1E\u0E23\u0E38\u0E48\u0E07\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
  nextWeek: "eeee '\u0E40\u0E27\u0E25\u0E32' p",
  other: "P"
};
function formatRelative(token2, _date, _baseDate, _options) {
  return formatRelativeLocale[token2];
}
var eraValues = {
  narrow: ["B", "\u0E04\u0E28"],
  abbreviated: ["BC", "\u0E04.\u0E28."],
  wide: ["\u0E1B\u0E35\u0E01\u0E48\u0E2D\u0E19\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E01\u0E32\u0E25", "\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E4C\u0E28\u0E31\u0E01\u0E23\u0E32\u0E0A"]
};
var quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E41\u0E23\u0E01", "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E2D\u0E07", "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21", "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E35\u0E48"]
};
var dayValues = {
  narrow: ["\u0E2D\u0E32.", "\u0E08.", "\u0E2D.", "\u0E1E.", "\u0E1E\u0E24.", "\u0E28.", "\u0E2A."],
  short: ["\u0E2D\u0E32.", "\u0E08.", "\u0E2D.", "\u0E1E.", "\u0E1E\u0E24.", "\u0E28.", "\u0E2A."],
  abbreviated: ["\u0E2D\u0E32.", "\u0E08.", "\u0E2D.", "\u0E1E.", "\u0E1E\u0E24.", "\u0E28.", "\u0E2A."],
  wide: ["\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C", "\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C", "\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23", "\u0E1E\u0E38\u0E18", "\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35", "\u0E28\u0E38\u0E01\u0E23\u0E4C", "\u0E40\u0E2A\u0E32\u0E23\u0E4C"]
};
var monthValues = {
  narrow: ["\u0E21.\u0E04.", "\u0E01.\u0E1E.", "\u0E21\u0E35.\u0E04.", "\u0E40\u0E21.\u0E22.", "\u0E1E.\u0E04.", "\u0E21\u0E34.\u0E22.", "\u0E01.\u0E04.", "\u0E2A.\u0E04.", "\u0E01.\u0E22.", "\u0E15.\u0E04.", "\u0E1E.\u0E22.", "\u0E18.\u0E04."],
  abbreviated: ["\u0E21.\u0E04.", "\u0E01.\u0E1E.", "\u0E21\u0E35.\u0E04.", "\u0E40\u0E21.\u0E22.", "\u0E1E.\u0E04.", "\u0E21\u0E34.\u0E22.", "\u0E01.\u0E04.", "\u0E2A.\u0E04.", "\u0E01.\u0E22.", "\u0E15.\u0E04.", "\u0E1E.\u0E22.", "\u0E18.\u0E04."],
  wide: ["\u0E21\u0E01\u0E23\u0E32\u0E04\u0E21", "\u0E01\u0E38\u0E21\u0E20\u0E32\u0E1E\u0E31\u0E19\u0E18\u0E4C", "\u0E21\u0E35\u0E19\u0E32\u0E04\u0E21", "\u0E40\u0E21\u0E29\u0E32\u0E22\u0E19", "\u0E1E\u0E24\u0E29\u0E20\u0E32\u0E04\u0E21", "\u0E21\u0E34\u0E16\u0E38\u0E19\u0E32\u0E22\u0E19", "\u0E01\u0E23\u0E01\u0E0E\u0E32\u0E04\u0E21", "\u0E2A\u0E34\u0E07\u0E2B\u0E32\u0E04\u0E21", "\u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19", "\u0E15\u0E38\u0E25\u0E32\u0E04\u0E21", "\u0E1E\u0E24\u0E28\u0E08\u0E34\u0E01\u0E32\u0E22\u0E19", "\u0E18\u0E31\u0E19\u0E27\u0E32\u0E04\u0E21"]
};
var dayPeriodValues = {
  narrow: {
    am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
    pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
    midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
    noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
    morning: "\u0E40\u0E0A\u0E49\u0E32",
    afternoon: "\u0E1A\u0E48\u0E32\u0E22",
    evening: "\u0E40\u0E22\u0E47\u0E19",
    night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
  },
  abbreviated: {
    am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
    pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
    midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
    noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
    morning: "\u0E40\u0E0A\u0E49\u0E32",
    afternoon: "\u0E1A\u0E48\u0E32\u0E22",
    evening: "\u0E40\u0E22\u0E47\u0E19",
    night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
  },
  wide: {
    am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
    pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
    midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
    noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
    morning: "\u0E40\u0E0A\u0E49\u0E32",
    afternoon: "\u0E1A\u0E48\u0E32\u0E22",
    evening: "\u0E40\u0E22\u0E47\u0E19",
    night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
    pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
    midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
    noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
    morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
    afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
    evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
    night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
  },
  abbreviated: {
    am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
    pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
    midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
    noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
    morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
    afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
    evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
    night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
  },
  wide: {
    am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
    pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
    midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
    noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
    morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
    afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
    evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
    night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
  }
};
function ordinalNumber(dirtyNumber) {
  var number2 = Number(dirtyNumber);
  return number2;
}
var localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: function(quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
var localize$1 = localize;
var matchOrdinalNumberPattern = /^\d+/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^([bB]|[aA]|คศ)/i,
  abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
  wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
};
var parseEraPatterns = {
  any: [/^[bB]/i, /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^ไตรมาส(ที่)? ?[1234]/i
};
var parseQuarterPatterns = {
  any: [/(1|แรก|หนึ่ง)/i, /(2|สอง)/i, /(3|สาม)/i, /(4|สี่)/i]
};
var matchMonthPatterns = {
  narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
  abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
  wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
};
var parseMonthPatterns = {
  wide: [/^มก/i, /^กุม/i, /^มี/i, /^เม/i, /^พฤษ/i, /^มิ/i, /^กรก/i, /^ส/i, /^กัน/i, /^ต/i, /^พฤศ/i, /^ธ/i],
  any: [/^ม\.?ค\.?/i, /^ก\.?พ\.?/i, /^มี\.?ค\.?/i, /^เม\.?ย\.?/i, /^พ\.?ค\.?/i, /^มิ\.?ย\.?/i, /^ก\.?ค\.?/i, /^ส\.?ค\.?/i, /^ก\.?ย\.?/i, /^ต\.?ค\.?/i, /^พ\.?ย\.?/i, /^ธ\.?ค\.?/i]
};
var matchDayPatterns = {
  narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
};
var parseDayPatterns = {
  wide: [/^อา/i, /^จั/i, /^อั/i, /^พุธ/i, /^พฤ/i, /^ศ/i, /^เส/i],
  any: [/^อา/i, /^จ/i, /^อ/i, /^พ(?!ฤ)/i, /^พฤ/i, /^ศ/i, /^ส/i]
};
var matchDayPeriodPatterns = {
  any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^ก่อนเที่ยง/i,
    pm: /^หลังเที่ยง/i,
    midnight: /^เที่ยงคืน/i,
    noon: /^เที่ยง/i,
    morning: /เช้า/i,
    afternoon: /บ่าย/i,
    evening: /เย็น/i,
    night: /กลางคืน/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: function(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
var match$1 = match;
var locale = {
  code: "th",
  formatDistance,
  formatLong: formatLong$1,
  formatRelative,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
var th = locale;
var PackageEntityType;
(function(PackageEntityType2) {
  PackageEntityType2["BASIC"] = "BASIC";
  PackageEntityType2["C_COMMERCE"] = "C_COMMERCE";
  PackageEntityType2["IMAGE_SEARCH"] = "IMAGE_SEARCH";
  PackageEntityType2["MAIN"] = "MAIN";
})(PackageEntityType || (PackageEntityType = {}));
var PackagePricingType;
(function(PackagePricingType2) {
  PackagePricingType2["FREE"] = "free";
  PackagePricingType2["PROFESSIONAL"] = "professional";
  PackagePricingType2["PREMIUM"] = "premium";
  PackagePricingType2["ENTERPRISE"] = "enterprise";
  PackagePricingType2["STANDARD"] = "standard";
})(PackagePricingType || (PackagePricingType = {}));
var PlanUsagePackagesType;
(function(PlanUsagePackagesType2) {
  PlanUsagePackagesType2["C_COMMERCE"] = "cCommercePackage";
  PlanUsagePackagesType2["IMAGE_SEARCH"] = "imageSearchPackage";
  PlanUsagePackagesType2["MAIN"] = "mainPackage";
})(PlanUsagePackagesType || (PlanUsagePackagesType = {}));
var PlanUsagePackageGroupType;
(function(PlanUsagePackageGroupType2) {
  PlanUsagePackageGroupType2["MAIN"] = "mainPackage";
  PlanUsagePackageGroupType2["IMAGE_SEARCH"] = "imageSearchAddon";
  PlanUsagePackageGroupType2["LINE_MESSAGE"] = "lineMessage";
  PlanUsagePackageGroupType2["MANUAL_APPROVE_ORDER"] = "manualApproveOrder";
})(PlanUsagePackageGroupType || (PlanUsagePackageGroupType = {}));
var PackageTypes;
(function(PackageTypes2) {
  PackageTypes2["PACKAGE"] = "PACKAGE";
  PackageTypes2["ADDON"] = "ADDON";
})(PackageTypes || (PackageTypes = {}));
var PackagePromotionDiscountType;
(function(PackagePromotionDiscountType2) {
  PackagePromotionDiscountType2["PERCENTAGE_DISCOUNT"] = "PERCENTAGE_DISCOUNT";
  PackagePromotionDiscountType2["AMOUNT_DISCOUNT"] = "AMOUNT_DISCOUNT";
})(PackagePromotionDiscountType || (PackagePromotionDiscountType = {}));
var PackagePromotionConditionType;
(function(PackagePromotionConditionType2) {
  PackagePromotionConditionType2["FROM_FREEMIUM"] = "FROM_FREEMIUM";
  PackagePromotionConditionType2["FROM_MONTHLY"] = "FROM_MONTHLY";
  PackagePromotionConditionType2["FROM_ANNUALLY"] = "FROM_ANNUALLY";
  PackagePromotionConditionType2["TO_MONTHLY"] = "TO_MONTHLY";
  PackagePromotionConditionType2["TO_ANNUALLY"] = "TO_ANNUALLY";
  PackagePromotionConditionType2["ONLY_ADDONS"] = "ONLY_ADDONS";
})(PackagePromotionConditionType || (PackagePromotionConditionType = {}));
var SubscriptionType;
(function(SubscriptionType2) {
  SubscriptionType2["MONTHLY"] = "MONTHLY";
  SubscriptionType2["ANNUALLY"] = "ANNUALLY";
})(SubscriptionType || (SubscriptionType = {}));
function CodeItem({
  onClose,
  title,
  code,
  expiredDate,
  className
}) {
  var _a2;
  const {
    t: t2
  } = useTranslation();
  const isDefaultPromotion = typeof onClose !== "function";
  return /* @__PURE__ */ jsxs("div", {
    className: classNames$1("tw-flex tw-justify-between tw-items-start tw-p-3 tw-rounded-lg tw-shadow-sm", className),
    children: [/* @__PURE__ */ jsx$1("div", {
      className: "tw-flex",
      children: /* @__PURE__ */ jsxs("div", {
        children: [isDefaultPromotion ? /* @__PURE__ */ jsx$1(Typography, {
          variant: "title-9",
          color: "Gray-500",
          children: t2("planUpgrade.codeItem.defaultPromotion")
        }) : /* @__PURE__ */ jsx$1(Typography, {
          variant: "title-9",
          color: "Primary-600",
          children: title || "-"
        }), /* @__PURE__ */ jsxs(Typography, {
          variant: "title-11",
          color: "Gray-500",
          children: [t2("planUpgrade.codeItem.code"), ": ", code || "-"]
        }), /* @__PURE__ */ jsxs(Typography, {
          variant: "title-11",
          color: "Gray-500",
          children: [t2("planUpgrade.codeItem.expiredDate"), ":", " ", ((_a2 = expiredDate == null ? void 0 : expiredDate.toDateString) == null ? void 0 : _a2.call(expiredDate)) || "-"]
        }), isDefaultPromotion && /* @__PURE__ */ jsx$1(Typography, {
          variant: "title-11",
          color: "Gray-500",
          children: t2("planUpgrade.codeItem.remark", {
            name: title
          })
        })]
      })
    }), !isDefaultPromotion && /* @__PURE__ */ jsx$1("button", {
      type: "button",
      onClick: onClose,
      children: "\xD7"
    })]
  });
}
memo(CodeItem);
const getInputStyle = (hasError, isDisabled) => {
  const baseStyle = "tw-flex tw-px-4 tw-py-3.5 tw-mb-1 tw-rounded tw-border tw-border-solid";
  if (isDisabled) {
    return `${baseStyle} tw-border-Gray-400 tw-bg-Gray-200 tw-text-Gray-400`;
  }
  if (hasError) {
    return `${baseStyle} tw-border-Red tw-bg-White tw-text-Gray-800`;
  }
  return `${baseStyle} tw-border-Gray-400 focus-within:tw-border-Primary-600 tw-bg-White tw-text-Gray-800`;
};
const InputContainer = (props) => {
  const {
    children: children2,
    hasError = false,
    disabled = false
  } = props;
  const inputVariantStyle = getInputStyle(hasError, disabled);
  return /* @__PURE__ */ jsx$1("div", {
    className: inputVariantStyle,
    children: children2
  });
};
InputContainer.displayName = "InputContainer";
const NumberFormatInput = forwardRef((_N, ref) => {
  var _O = _N, {
    children: children2,
    hasError,
    disabled,
    LeftAdornment
  } = _O, rest = __objRest(_O, [
    "children",
    "hasError",
    "disabled",
    "LeftAdornment"
  ]);
  return /* @__PURE__ */ jsxs(InputContainer, {
    hasError,
    disabled,
    children: [LeftAdornment && /* @__PURE__ */ jsx$1("div", {
      className: "tw-mr-3",
      children: LeftAdornment
    }), /* @__PURE__ */ jsx$1(NumberFormat, __spreadProps(__spreadValues({
      className: "tw-p-0 tw-m-0 tw-w-full tw-text-sm placeholder:tw-text-Gray-400 tw-text-Gray-800 tw-border-none focus-visible:tw-outline-none",
      getInputRef: ref
    }, rest), {
      children: children2
    }))]
  });
});
NumberFormatInput.displayName = "NumberFormatInput";
const Textarea = forwardRef((props, ref) => {
  const _a2 = props, {
    disabled = false,
    hasError = false,
    rows = 4,
    id: id2,
    name
  } = _a2, rest = __objRest(_a2, [
    "disabled",
    "hasError",
    "rows",
    "id",
    "name"
  ]);
  const inputVariantStyle = getInputStyle(hasError, disabled);
  return /* @__PURE__ */ jsx$1("textarea", __spreadValues({
    id: id2 || name,
    name,
    rows,
    className: classNames$1("tw-py-3.5 tw-px-4 tw-mb-1 tw-w-full tw-text-sm tw-text-Gray-800 placeholder:tw-text-Gray-400 tw-rounded tw-border focus-visible:tw-outline-none", inputVariantStyle),
    disabled,
    ref
  }, rest));
});
Textarea.displayName = "Textarea";
const TextField = forwardRef((props, ref) => {
  const _a2 = props, {
    disabled = false,
    id: id2,
    LeftAdornment,
    name,
    RightAdornment,
    hasError = false
  } = _a2, rest = __objRest(_a2, [
    "disabled",
    "id",
    "LeftAdornment",
    "name",
    "RightAdornment",
    "hasError"
  ]);
  return /* @__PURE__ */ jsxs(InputContainer, {
    hasError,
    disabled,
    children: [!!LeftAdornment && /* @__PURE__ */ jsx$1("div", {
      className: "tw-px-1",
      children: LeftAdornment
    }), /* @__PURE__ */ jsx$1("input", __spreadValues({
      className: "tw-flex-1 tw-p-0 tw-m-0 tw-w-full tw-text-sm tw-leading-4 placeholder:tw-text-Gray-400 tw-border-none focus-visible:tw-outline-none",
      disabled,
      id: id2 || name,
      name,
      ref
    }, rest)), !!RightAdornment && /* @__PURE__ */ jsx$1("div", {
      className: "tw-px-1",
      children: RightAdornment
    })]
  });
});
TextField.displayName = "TextField";
var CheckConditionError;
(function(CheckConditionError2) {
  CheckConditionError2["PROMOTION_NOT_FOUND"] = "PROMOTION_NOT_FOUND";
  CheckConditionError2["PROMOTION_NOT_ACTIVE"] = "PROMOTION_NOT_ACTIVE";
  CheckConditionError2["PROMOTION_EXPIRED"] = "PROMOTION_EXPIRED";
  CheckConditionError2["PROMOTION_QUOTA_REACHED"] = "PROMOTION_QUOTA_REACHED";
  CheckConditionError2["PROMOTION_CONDITION_NOT_MATCH"] = "PROMOTION_CONDITION_NOT_MATCH";
})(CheckConditionError || (CheckConditionError = {}));
function CodeTextField({
  onSubmit,
  error: error2,
  className
}) {
  const [isOpen, setIsOpen] = useState(false);
  const codeTextFieldRef = useRef(null);
  const {
    t: t2
  } = useTranslation();
  const handleClickUseCodeBtn = (e2) => {
    setIsOpen(true);
    e2.preventDefault();
  };
  const handleClickRedeemCodeBtn = (e2) => {
    var _a2;
    const code = (_a2 = codeTextFieldRef == null ? void 0 : codeTextFieldRef.current) == null ? void 0 : _a2.value;
    if (!code) {
      return;
    }
    onSubmit(code);
    e2.preventDefault();
  };
  useEffect(() => {
    var _a2, _b;
    if (isOpen) {
      try {
        (_b = (_a2 = codeTextFieldRef == null ? void 0 : codeTextFieldRef.current) == null ? void 0 : _a2.focus) == null ? void 0 : _b.call(_a2);
      } catch {
      }
    }
  }, [isOpen]);
  const getErrorMessage = () => {
    switch (error2) {
      case CheckConditionError.PROMOTION_CONDITION_NOT_MATCH:
        return t2("planUpgrade.codeTextField.error.promotionCoditionNotMatch");
      case CheckConditionError.PROMOTION_EXPIRED:
        return t2("planUpgrade.codeTextField.error.promotionExipred");
      case CheckConditionError.PROMOTION_NOT_ACTIVE:
        return t2("planUpgrade.codeTextField.error.promotionNotActive");
      case CheckConditionError.PROMOTION_NOT_FOUND:
        return t2("planUpgrade.codeTextField.error.promotionNotFound");
      case CheckConditionError.PROMOTION_QUOTA_REACHED:
        return t2("planUpgrade.codeTextField.error.promotionQuotaReached");
      default:
        return null;
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className,
    children: [/* @__PURE__ */ jsx$1("div", {
      className: "tw-flex tw-items-center tw-h-[48px]",
      children: /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-items-center tw-w-full",
        children: [/* @__PURE__ */ jsx$1("div", {
          className: `tw-transition-all ${isOpen ? "tw-w-full tw-mr-[14px] tw-visible" : "tw-w-0 tw-invisible"}`,
          children: /* @__PURE__ */ jsx$1(TextField, {
            name: "code",
            placeholder: t2("planUpgrade.codeTextField.placeholder"),
            hasError: !!error2,
            ref: codeTextFieldRef
          })
        }), /* @__PURE__ */ jsx$1(Typography, {
          variant: "title-9",
          color: "Primary-600",
          onClick: isOpen ? handleClickRedeemCodeBtn : handleClickUseCodeBtn,
          className: "tw-min-w-[42px] tw-cursor-pointer",
          children: isOpen ? t2("planUpgrade.codeTextField.redeem") : t2("planUpgrade.codeTextField.useCode")
        })]
      })
    }), error2 && /* @__PURE__ */ jsx$1(Typography, {
      variant: "body-4",
      color: COLORS.Red,
      className: "tw-text-red-500",
      children: getErrorMessage()
    })]
  });
}
memo(CodeTextField);
const ADD_CREDIT_CARD = gql$1`
  mutation addCreditCard($projectId: ID!, $creditCard: CreditCardInput!) {
    addCreditCard(projectId: $projectId, creditCard: $creditCard) {
      id
      name
      number
      brand
      expirationYear
      expirationMonth
      issue
      issuedAt
    }
  }
`;
const REMOVE_CREDIT_CARD = gql$1`
  mutation removeCreditCard($projectId: ID!, $id: ID!) {
    removeCreditCard(projectId: $projectId, id: $id) {
      id
    }
  }
`;
const CHANGE_PACKAGES = gql$1`
  mutation changePackages(
    $projectId: ID!
    $packageIds: [ID!]!
    $promotionCode: String
  ) {
    changePackages(
      projectId: $projectId
      packageIds: $packageIds
      promotionCode: $promotionCode
    ) {
      id
      name
      type
      entityType
      isTrial
      isSelected
      pricePerMonth
      subscriberQuota
      messageQuota
      orderQuota
      faqQuota
      productQuota
      memberQuota
      channelQuota
      imageSearchQuota
      isAddonEnabled
    }
  }
`;
const CHANGE_PACKAGES_FROM_BASIC = gql$1`
  mutation changeFromBasicPackageToMainPackage(
    $projectId: ID!
    $packageIds: [ID!]!
    $token: String
    $promotionCode: String
  ) {
    changeFromBasicPackageToMainPackage(
      projectId: $projectId
      packageIds: $packageIds
      token: $token
      promotionCode: $promotionCode
    )
  }
`;
const useChangePackageSummary = (projectId, packageIds = [], isSelectedBasicPackage = false) => {
  const defaultRefetchQueries = [
    { query: CURRENT_USAGE, variables: { projectId } },
    { query: PACKAGES, variables: { projectId } },
    { query: PAYMENT_SUMMARY, variables: { projectId } },
    { query: HAS_CHANGES_ON_NEXT_CYCLE, variables: { projectId } }
  ];
  const gqlMutation = isSelectedBasicPackage ? CHANGE_PACKAGES_FROM_BASIC : CHANGE_PACKAGES;
  const {
    data: packageSummaryData,
    refetch,
    loading: isLoadingPackageSummary
  } = useQuery(CHANGE_PACKAGE_SUMMARY, {
    skip: !projectId || packageIds.length < 1,
    variables: {
      packageIds,
      projectId,
      promotionCode: ""
    }
  });
  const refetchQueries = isSelectedBasicPackage ? [
    ...defaultRefetchQueries,
    { query: PROJECT_INFO, variables: { projectId } }
  ] : defaultRefetchQueries;
  const [change, { loading: isLoadingChange }] = useMutation(gqlMutation, {
    refetchQueries
  });
  const refetchPackageSummary = (newPackageIds, newPromoCode) => {
    return refetch({
      projectId,
      packageIds: newPackageIds,
      promotionCode: newPromoCode
    });
  };
  const changePackages = (promotionCode) => {
    return change({
      variables: {
        projectId,
        packageIds,
        promotionCode
      }
    });
  };
  return {
    refetchPackageSummary,
    packageSummaryData: packageSummaryData == null ? void 0 : packageSummaryData.changePackageSummary,
    isLoadingPackageSummary,
    changePackages,
    isLoadingChangePackageSummary: isLoadingChange
  };
};
async function getToken(body, options2) {
  const res = await axios.create({
    baseURL: options2.gbPrimeUrl,
    headers: {
      Authorization: `Basic ${btoa(`${options2.gbPrimePublicKey}:`)}`
    }
  }).post("/v2/tokens", body);
  const { data: data2 } = res;
  if (data2.resultCode !== "00") {
    throw new Error(data2.resultCode);
  }
  return data2;
}
function useCreditCard({
  projectId,
  gbPrimeUrl,
  gbPrimePublicKey
}) {
  const { data: creditCardData, loading: isCreditCardQueryLoading } = useQuery(CREDIT_CARD, {
    variables: { projectId }
  });
  const creditCard = creditCardData == null ? void 0 : creditCardData.creditCard;
  const [addCreditCard, { loading: isLoadingAddCreditCard }] = useMutation(ADD_CREDIT_CARD, {
    update(cache2, { data: data2 }) {
      cache2.writeQuery({
        query: CREDIT_CARD,
        variables: {
          projectId
        },
        data: {
          creditCard: __spreadValues({}, data2 == null ? void 0 : data2.addCreditCard)
        }
      });
    }
  });
  const [removeCreditCard, { loading: isLoadingRemoveCreditCard }] = useMutation(REMOVE_CREDIT_CARD, {
    update(cache2) {
      const cacheCreditCard = cache2.readQuery({
        query: CREDIT_CARD,
        variables: {
          projectId
        }
      });
      if (cacheCreditCard) {
        cache2.writeQuery({
          query: CREDIT_CARD,
          variables: {
            projectId
          },
          data: {
            creditCard: null
          }
        });
      }
    }
  });
  const add = async (newCreditCard) => {
    const _a2 = newCreditCard, { securityCode } = _a2, restNewCreditCard = __objRest(_a2, ["securityCode"]);
    const tokenData = await getToken({
      card: {
        number: restNewCreditCard.number,
        expirationMonth: restNewCreditCard.expirationMonth,
        expirationYear: restNewCreditCard.expirationYear,
        securityCode,
        name: restNewCreditCard.name
      },
      rememberCard: true
    }, { gbPrimePublicKey, gbPrimeUrl });
    return addCreditCard({
      variables: {
        creditCard: __spreadProps(__spreadValues({}, restNewCreditCard), {
          token: tokenData.card.token
        }),
        projectId
      }
    });
  };
  const remove2 = () => {
    if (!(creditCard == null ? void 0 : creditCard.id)) {
      throw new Error("invalid credit card id");
    }
    return removeCreditCard({
      variables: {
        id: creditCard == null ? void 0 : creditCard.id,
        projectId
      }
    });
  };
  return {
    creditCardData,
    isCreditCardQueryLoading,
    add,
    isLoadingAddCreditCard,
    remove: remove2,
    isLoadingRemoveCreditCard
  };
}
function arrayAggregator$1(array2, setter, iteratee, accumulator) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length;
  while (++index2 < length2) {
    var value = array2[index2];
    setter(accumulator, value, iteratee(value), array2);
  }
  return accumulator;
}
var _arrayAggregator = arrayAggregator$1;
var baseEach = _baseEach;
function baseAggregator$1(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection2) {
    setter(accumulator, value, iteratee(value), collection2);
  });
  return accumulator;
}
var _baseAggregator = baseAggregator$1;
var arrayAggregator = _arrayAggregator, baseAggregator = _baseAggregator, baseIteratee = _baseIteratee, isArray = isArray_1;
function createAggregator$1(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
    return func(collection, setter, baseIteratee(iteratee), accumulator);
  };
}
var _createAggregator = createAggregator$1;
var baseAssignValue = _baseAssignValue, createAggregator = _createAggregator;
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});
var groupBy_1 = groupBy;
const formatMainPackageDetail = ({
  subscriberQuota,
  faqQuota,
  memberQuota,
  messageQuota,
  channelQuota,
  entityType,
  entityLevel,
  broadcastQuota
}, title) => {
  const isFreePackage = entityType === PackageEntityType$1.BASIC;
  const incomingMsgQuotaText = messageQuota === -1 ? `${i18next.t("planUpgrade.quota.unlimited")}` : convertPriceFormat(messageQuota || 0, 0);
  return [
    {
      type: "subscriber",
      quota: convertPriceFormat(subscriberQuota, 0)
    },
    {
      type: "incomingMsg",
      quota: incomingMsgQuotaText
    },
    {
      type: "intent",
      isOverCustomPackage: title === PackagePricingType$1.ENTERPRISE,
      quota: faqQuota.toString()
    },
    {
      type: "member",
      isOverCustomPackage: title === PackagePricingType$1.ENTERPRISE,
      quota: memberQuota.toString(),
      isAddon: !isFreePackage
    },
    {
      type: "channel",
      quota: channelQuota.toString(),
      isAddon: !isFreePackage
    },
    {
      type: "imageSearch",
      quota: "100",
      isDisabled: isFreePackage,
      isAddon: !isFreePackage
    },
    {
      type: "broadcast",
      isOverCustomPackage: title === PackagePricingType$1.ENTERPRISE,
      quota: convertPriceFormat(broadcastQuota || 0, 0),
      isAddon: entityLevel === EntityLevel.PROFESSIONAL
    }
  ];
};
const formatCcommercePackageDetail = ({
  orderQuota,
  productQuota
}) => [
  {
    type: "order",
    quota: convertPriceFormat(orderQuota, 0)
  },
  {
    type: "sku",
    quota: convertPriceFormat(productQuota, 0)
  }
];
const addOverPackage = (plans) => {
  if (!plans || !plans.length) {
    return [];
  }
  const lastPlan = plans[plans.length - 1];
  const overPackageDetail = lastPlan.planDetails.map((detail) => {
    const { type, quota } = detail;
    if (["subscriber", "member", "order", "sku"].includes(type)) {
      const isFreePackage = lastPlan.entityType === PackageEntityType$1.BASIC;
      return {
        type,
        quota: quota === "-1" ? i18next.t("planUsage.label.unlimited") : `${i18next.t("planUpgrade.label.prefix.over")} ${quota}`,
        isAddon: type === "member" && !isFreePackage
      };
    }
    return detail;
  });
  const overPackage = {
    id: "0",
    entityType: lastPlan.entityType,
    name: `${i18next.t("planUpgrade.label.prefix.over")} ${lastPlan.name}`,
    price: -1,
    markLabel: `${lastPlan.markLabel}+`,
    isActive: false,
    planDetails: overPackageDetail,
    isContactSale: true,
    extraChargeRate: -1
  };
  return [...plans, overPackage];
};
const formatPackage = (packages, title) => packages.map((plan) => {
  const {
    id: id2,
    name,
    pricePerMonth,
    pricePerYear,
    isSelected,
    isTrial,
    entityType,
    orderQuota,
    subscriberQuota,
    extraChargeRate,
    deeplePayFeeRate,
    subscriptionType
  } = plan;
  let planDetails = [];
  let markLabel = "";
  switch (entityType) {
    case PackageEntityType$1.C_COMMERCE:
      planDetails = formatCcommercePackageDetail(plan);
      markLabel = convertPriceFormat(orderQuota, 0);
      break;
    case PackageEntityType$1.MAIN:
      planDetails = formatMainPackageDetail(plan, title);
      markLabel = convertPriceFormat(subscriberQuota, 0);
      break;
    case PackageEntityType$1.BASIC:
      planDetails = [
        ...formatMainPackageDetail(plan, title),
        ...formatCcommercePackageDetail(plan)
      ];
      break;
    default:
      planDetails = [];
      break;
  }
  return {
    id: id2,
    name,
    entityType,
    price: subscriptionType === SubscriptionType$1.MONTHLY ? pricePerMonth : pricePerYear,
    markLabel,
    isActive: isSelected,
    planDetails,
    isOneTimeTrial: isTrial,
    extraChargeRate,
    deeplePayFeeRate
  };
});
function usePlanData(projectId, subscriptionType = SubscriptionType$1.MONTHLY) {
  const {
    loading: isLoading,
    data: packagesData,
    refetch: refetchPackages
  } = useQuery(PACKAGES, {
    variables: {
      projectId,
      subscriptionType
    }
  });
  if (packagesData && packagesData.packages) {
    const {
      free,
      professional,
      premium,
      standard,
      starter_1,
      starter_2,
      starter_3
    } = packagesData.packages;
    const combinePackages = [
      { title: PackagePricingType$1.FREE, packages: free },
      { title: PackagePricingType$1.STARTER_1, packages: starter_1 },
      { title: PackagePricingType$1.STARTER_2, packages: starter_2 },
      { title: PackagePricingType$1.STARTER_3, packages: starter_3 },
      { title: PackagePricingType$1.STANDARD, packages: standard },
      { title: PackagePricingType$1.PROFESSIONAL, packages: professional },
      { title: PackagePricingType$1.PREMIUM, packages: premium },
      { title: PackagePricingType$1.ENTERPRISE, packages: premium }
    ].filter(({ packages: packages2 }) => packages2.length);
    const formattedCombinePackages = combinePackages.map(({ title, packages: packages2 }) => {
      var _a2, _b, _c, _d;
      const formattedPackages = formatPackage(packages2, title);
      const groupPackages = groupBy_1(formattedPackages, "entityType");
      const deeplePayFeeRate = (groupPackages == null ? void 0 : groupPackages.C_COMMERCE) ? (_a2 = groupPackages == null ? void 0 : groupPackages.C_COMMERCE[groupPackages.C_COMMERCE.length - 1]) == null ? void 0 : _a2.deeplePayFeeRate : (_b = groupPackages.BASIC[0]) == null ? void 0 : _b.deeplePayFeeRate;
      if (title === PackagePricingType$1.FREE) {
        return {
          title,
          mainPackages: groupPackages.BASIC[0],
          cCommercePackages: groupPackages.BASIC[0],
          isSelected: (_c = groupPackages.BASIC[0]) == null ? void 0 : _c.isActive,
          deeplePayFeeRate
        };
      }
      if (title === PackagePricingType$1.ENTERPRISE) {
        const mainPackages = addOverPackage(groupPackages.MAIN);
        const cCommercePackages = addOverPackage(groupPackages.C_COMMERCE);
        const lastMainPackages = mainPackages[mainPackages.length - 1];
        const lastCCommercePackages = cCommercePackages[cCommercePackages.length - 1];
        return {
          title,
          mainPackages: lastMainPackages,
          cCommercePackages: lastCCommercePackages,
          isSelected: lastCCommercePackages == null ? void 0 : lastCCommercePackages.isActive
        };
      }
      return {
        title,
        mainPackages: groupPackages.MAIN[0],
        cCommercePackages: groupPackages.C_COMMERCE[0],
        isSelected: (_d = groupPackages.C_COMMERCE[0]) == null ? void 0 : _d.isActive,
        deeplePayFeeRate
      };
    });
    const isSelectedBasicPackage = formattedCombinePackages.some(({ title, isSelected }) => title === PackagePricingType$1.FREE && isSelected);
    let packages = formattedCombinePackages;
    if (formattedCombinePackages.length === 4) {
      packages = formattedCombinePackages;
    }
    return {
      packages,
      isLoading,
      isSelectedBasicPackage
    };
  }
  return {
    packages: [],
    isLoading,
    isSelectedBasicPackage: false,
    refetchPackages
  };
}
const ADD_BILLING = gql$1`
  mutation addBilling($projectId: ID!, $billingInput: BillingInput!) {
    addBilling(projectId: $projectId, billingInput: $billingInput) {
      id
      projectId
      name
      address
      email
      taxId
      phoneNumber
      documentVerificationCertificatePath
      contactPerson
      isVerified
      type
      subDistrict
      district
      province
      postalCode
      titleName
    }
  }
`;
const UPDATE_BILLING = gql$1`
  mutation updateBilling(
    $projectId: ID!
    $billingId: ID!
    $billingInput: BillingInput!
  ) {
    updateBilling(
      projectId: $projectId
      billingId: $billingId
      billingInput: $billingInput
    ) {
      id
      projectId
      name
      address
      email
      taxId
      phoneNumber
      documentVerificationCertificatePath
      contactPerson
      isVerified
      type
      subDistrict
      district
      province
      postalCode
      titleName
    }
  }
`;
gql$1`
  mutation addCreditCard($projectId: ID!, $creditCard: CreditCardInput!) {
    addCreditCard(projectId: $projectId, creditCard: $creditCard) {
      id
      name
      number
      brand
      expirationYear
      expirationMonth
      issue
      issuedAt
    }
  }
`;
gql$1`
  mutation removeCreditCard($projectId: ID!, $id: ID!) {
    removeCreditCard(projectId: $projectId, id: $id) {
      id
    }
  }
`;
gql$1`
  mutation repayMonthlyBilling($projectId: ID!) {
    repayMonthlyBilling(projectId: $projectId)
  }
`;
const BILLING = gql$1`
  query billing($projectId: ID!) {
    billing(projectId: $projectId) {
      id
      projectId
      name
      address
      email
      taxId
      phoneNumber
      isVerified
      documentVerificationCertificatePath
      contactPerson
      type
      subDistrict
      district
      province
      postalCode
      titleName
    }
  }
`;
gql$1`
  query billingOverdue($projectId: ID!) {
    billingOverdue(projectId: $projectId) {
      isOverdue
      billingDate
      amount
    }
  }
`;
gql$1`
  query invoices($projectId: ID!, $offset: Int, $limit: Int) {
    invoices(projectId: $projectId, offset: $offset, limit: $limit) {
      results {
        id
        startBillingDate
        endBillingDate
        paidAt
        invoiceNumber
        totalPrice
        vatPrice
        paymentType
        cardBrand
        lastFourDigitCardNumber
      }
      total
    }
  }
`;
gql$1`
  query invoiceUsage($projectId: ID!, $invoiceId: ID!) {
    invoiceUsage(projectId: $projectId, invoiceId: $invoiceId) {
      projectId
      items {
        type
        entityType
        entityLevel
        name
        price
        amount
        totalPrice
        subscriptionType
      }
      extras {
        type
        entityType
        entityLevel
        name
        price
        amount
        totalPrice
      }
      totalPrice
      subtotal
      vatOptions
      vatPrice
      discount {
        type
        total
      }
    }
  }
`;
function useBilling(projectId) {
  var _a2;
  const { loading: isLoadingBilling, data: billingData } = useQuery(BILLING, {
    skip: !projectId,
    variables: {
      projectId
    }
  });
  const isUpdateBilling = !!((_a2 = billingData == null ? void 0 : billingData.billing) == null ? void 0 : _a2.id);
  const [add, { loading: isLoadingAdd }] = useMutation(ADD_BILLING, {
    refetchQueries: [
      {
        query: BILLING,
        variables: {
          projectId
        }
      }
    ]
  });
  const [update2, { loading: isLoadingUpdate }] = useMutation(UPDATE_BILLING, {
    refetchQueries: [
      {
        query: BILLING,
        variables: {
          projectId
        }
      }
    ]
  });
  const upsertBilling = async (data2) => {
    const _a3 = data2, { id: billingId, isVerified } = _a3, billingInput = __objRest(_a3, ["id", "isVerified"]);
    if (billingId) {
      await update2({
        variables: {
          projectId,
          billingId,
          billingInput
        }
      });
    } else {
      await add({
        variables: {
          projectId,
          billingInput
        }
      });
    }
  };
  const isLoadingUpsertBilling = isUpdateBilling ? isLoadingUpdate : isLoadingAdd;
  return {
    billingData,
    isLoadingBilling,
    upsertBilling,
    isLoadingUpsertBilling
  };
}
function usePromotionCode(changePackageSummary) {
  var _a2, _b, _c, _d, _e2, _f;
  const promotionCode = changePackageSummary == null ? void 0 : changePackageSummary.promotionCode;
  const defaultPromotion = (_a2 = changePackageSummary == null ? void 0 : changePackageSummary.defaultPromotions) == null ? void 0 : _a2[0];
  const isApplied = !!(promotionCode == null ? void 0 : promotionCode.info);
  const isDefaultPromotionAvailable = !!defaultPromotion;
  const title = isApplied ? (_b = promotionCode == null ? void 0 : promotionCode.info) == null ? void 0 : _b.name : ((_c = defaultPromotion == null ? void 0 : defaultPromotion.promotions) == null ? void 0 : _c.name) || void 0;
  const code = isApplied ? (_d = promotionCode == null ? void 0 : promotionCode.info) == null ? void 0 : _d.code : void 0;
  const expiredDate = ((_e2 = promotionCode == null ? void 0 : promotionCode.info) == null ? void 0 : _e2.endDate) ? new Date((_f = promotionCode == null ? void 0 : promotionCode.info) == null ? void 0 : _f.endDate) : void 0;
  const totalDiscount = (promotionCode == null ? void 0 : promotionCode.totalDiscount) || (defaultPromotion == null ? void 0 : defaultPromotion.totalDiscount) || 0;
  const error2 = promotionCode == null ? void 0 : promotionCode.error;
  return {
    isApplied,
    isDefaultPromotionAvailable,
    title,
    code,
    expiredDate,
    totalDiscount,
    error: error2
  };
}
function PaymentSummary({
  projectId,
  subscriptionType,
  packageType,
  isChangePackageDisabled = true,
  onSuccess
}) {
  var _a2, _b, _c, _d, _e2;
  const {
    t: t2,
    i18n
  } = useTranslation("");
  const {
    packages,
    isSelectedBasicPackage
  } = usePlanData(projectId, subscriptionType);
  const selectedPackage = packages.find(({
    title
  }) => title === packageType.toLowerCase());
  const selectedPackageIds = [(_a2 = selectedPackage == null ? void 0 : selectedPackage.mainPackages) == null ? void 0 : _a2.id, (_b = selectedPackage == null ? void 0 : selectedPackage.cCommercePackages) == null ? void 0 : _b.id].filter(Boolean);
  const {
    packageSummaryData,
    refetchPackageSummary,
    changePackages,
    isLoadingChangePackageSummary
  } = useChangePackageSummary(projectId, selectedPackageIds, isSelectedBasicPackage);
  const [isShowChangePackageSuccessModal, setIsShowChangePackageSuccessModal] = useState(false);
  const nextBillingDate = (packageSummaryData == null ? void 0 : packageSummaryData.nextBillingDate) ? new Date(packageSummaryData.nextBillingDate) : new Date();
  const handleSubmitCode = async (newCode) => {
    if (!newCode) {
      return;
    }
    try {
      await refetchPackageSummary(selectedPackageIds, newCode);
    } catch (error2) {
      notifyError(error2.message);
    }
  };
  const handleClearCode = async () => {
    try {
      await refetchPackageSummary(selectedPackageIds, "");
    } catch (error2) {
      notifyError(error2.message);
    }
  };
  const handleSubmit = async (e2) => {
    var _a3, _b2;
    e2.preventDefault();
    const promotionCode2 = (_b2 = (_a3 = e2.target) == null ? void 0 : _a3.code) == null ? void 0 : _b2.value;
    try {
      await changePackages(promotionCode2);
      setIsShowChangePackageSuccessModal(true);
    } catch (error2) {
      notifyError(t2("planUpgrade.paymentSummary.changePackageError"));
    }
  };
  const newPackageSubscriptionType = (_d = (_c = packageSummaryData == null ? void 0 : packageSummaryData.newPackages) == null ? void 0 : _c[0]) == null ? void 0 : _d.subscriptionType;
  const newPackageSubscriptionTypeText = t2(`planUpgrade.subscriptionType.${((_e2 = newPackageSubscriptionType == null ? void 0 : newPackageSubscriptionType.toLocaleLowerCase) == null ? void 0 : _e2.call(newPackageSubscriptionType)) || "monthly"}`);
  const getTotalPriceBeforeDiscount = () => {
    if (!newPackageSubscriptionType || ![SubscriptionType.MONTHLY, SubscriptionType.ANNUALLY].includes(newPackageSubscriptionType)) {
      return 0;
    }
    const targetPrice = newPackageSubscriptionType === SubscriptionType.MONTHLY ? "pricePerMonth" : "pricePerYear";
    return (packageSummaryData == null ? void 0 : packageSummaryData.newPackages.reduce((prev2, curr) => prev2 + curr[targetPrice], 0)) || 0;
  };
  const totalPrice = convertPriceFormat((packageSummaryData == null ? void 0 : packageSummaryData.totalPrice) || 0);
  const totalUpgradePackageCompensation = (packageSummaryData == null ? void 0 : packageSummaryData.totalUpgradePackageCompensation) || 0;
  const promotionCode = usePromotionCode(packageSummaryData);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx$1(LoadingPopup$1, {
      isOpen: isLoadingChangePackageSummary
    }), /* @__PURE__ */ jsx$1(UpgradePlanSuccessModal, {
      isOpen: isShowChangePackageSuccessModal,
      lang: i18n.language === "th" ? "th" : "en",
      billingDate: format(nextBillingDate, "d MMM yyy"),
      isDuringFreeTrialPeriod: false,
      packageName: t2(`planUpgrade.packageType.${packageType}`),
      onClickDone: onSuccess
    }), /* @__PURE__ */ jsxs("form", {
      onSubmit: handleSubmit,
      className: "tw-flex tw-flex-col tw-items-center tw-py-6 tw-px-8 tw-font-sans tw-bg-White tw-rounded-lg tw-border tw-border-Gray-200 desktop:tw-w-[408px]",
      children: [/* @__PURE__ */ jsx$1(Typography, {
        variant: "title-4",
        children: t2("planUpgrade.paymentSummary.title")
      }), /* @__PURE__ */ jsx$1("img", {
        src: PAYMENT_SUMMARY_IMAGE,
        alt: "payment-summary",
        className: "tw-mb-4 tw-w-[192px] tw-h-[160px]"
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-mb-6 tw-w-full tw-rounded-lg tw-shadow-sm",
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "tw-p-4 tw-w-full tw-bg-Gray-100 tw-rounded-t-lg",
          children: /* @__PURE__ */ jsx$1(Typography, {
            variant: "title-9",
            className: "tw-text-left",
            children: t2("planUpgrade.paymentSummary.detail")
          })
        }), /* @__PURE__ */ jsxs("div", {
          className: "tw-p-4",
          children: [/* @__PURE__ */ jsx$1(Typography, {
            variant: "title-11",
            color: "Gray-500",
            className: "tw-mb-4",
            children: t2("planUpgrade.paymentSummary.upgradeTo")
          }), /* @__PURE__ */ jsxs("div", {
            className: "tw-flex tw-justify-between tw-mb-4",
            children: [/* @__PURE__ */ jsxs(Typography, {
              variant: "title-9",
              color: "Gray-800",
              children: [t2(`planUpgrade.packageType.${packageType}`), " (", newPackageSubscriptionTypeText, ")"]
            }), /* @__PURE__ */ jsxs(Typography, {
              variant: "title-9",
              color: "Gray-800",
              children: ["\u0E3F ", convertPriceFormat(getTotalPriceBeforeDiscount())]
            })]
          }), /* @__PURE__ */ jsx$1("div", {
            className: classNames$1("tw-py-2", {
              "tw-hidden": !promotionCode.isApplied && !promotionCode.isDefaultPromotionAvailable
            }),
            children: /* @__PURE__ */ jsx$1(CodeItem, {
              title: promotionCode.title,
              code: promotionCode.code,
              onClose: promotionCode.isApplied ? handleClearCode : void 0,
              expiredDate: promotionCode.expiredDate
            })
          }), /* @__PURE__ */ jsx$1(CodeTextField, {
            className: classNames$1({
              "tw-hidden": promotionCode.isApplied
            }),
            error: promotionCode == null ? void 0 : promotionCode.error,
            onSubmit: handleSubmitCode
          })]
        }), promotionCode.totalDiscount > 0 && /* @__PURE__ */ jsxs("div", {
          className: "tw-flex tw-justify-between tw-p-4",
          children: [/* @__PURE__ */ jsx$1(Typography, {
            variant: "title-9",
            children: t2("planUpgrade.paymentSummary.discount")
          }), /* @__PURE__ */ jsxs(Typography, {
            variant: "title-9",
            color: COLORS.Red,
            className: "tw-text-red-500",
            children: ["\u0E3F -", convertPriceFormat(promotionCode.totalDiscount)]
          })]
        }), totalUpgradePackageCompensation > 0 && /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx$1("div", {
            className: "tw-border-t tw-border-Gray-100 tw-border-dashed"
          }), /* @__PURE__ */ jsxs("div", {
            className: "tw-flex tw-justify-between tw-p-4",
            children: [/* @__PURE__ */ jsx$1(Typography, {
              variant: "title-9",
              color: "Gray-800",
              children: t2("planUpgrade.paymentSummary.credit")
            }), /* @__PURE__ */ jsxs(Typography, {
              variant: "title-9",
              color: "Gray-800",
              children: ["\u0E3F -", convertPriceFormat(totalUpgradePackageCompensation)]
            })]
          }), /* @__PURE__ */ jsx$1("div", {
            className: "tw-px-4 tw-pb-4",
            children: /* @__PURE__ */ jsx$1(Typography, {
              variant: "body-3",
              color: "Gray-600",
              children: t2("planUpgrade.paymentSummary.creditDescription")
            })
          })]
        }), /* @__PURE__ */ jsx$1("div", {
          className: "tw-border-t tw-border-Gray-100 tw-border-dashed"
        }), /* @__PURE__ */ jsx$1("div", {
          className: "tw-p-4",
          children: /* @__PURE__ */ jsxs("div", {
            className: "tw-flex tw-justify-between",
            children: [/* @__PURE__ */ jsx$1(Typography, {
              variant: "title-9",
              color: "Gray-800",
              children: t2("planUpgrade.paymentSummary.total")
            }), /* @__PURE__ */ jsxs(Typography, {
              variant: "title-9",
              color: "Gray-800",
              children: ["\u0E3F ", totalPrice]
            })]
          })
        })]
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-9",
        className: "tw-mb-6 tw-text-center tw-whitespace-pre-wrap",
        color: "Gray-600",
        children: t2("planUpgrade.paymentSummary.description", {
          effectiveDate: format(nextBillingDate, "d MMM yyy", {
            locale: i18n.language === "th" ? th : enUS
          })
        })
      }), /* @__PURE__ */ jsx$1(Button, {
        size: "fullWidth",
        disabled: isChangePackageDisabled,
        type: "submit",
        isLoading: isLoadingChangePackageSummary,
        children: t2("planUpgrade.paymentSummary.submitText")
      })]
    })]
  });
}
var PaymentSummary$1 = memo(PaymentSummary);
function getCreditCardBrandNameFromCardNo(cardNo) {
  if (!cardNo) {
    return void 0;
  }
  if (cardNo.match(/^4/)) {
    return CreditCardBrandName.VISA;
  }
  if (cardNo.match(/^5[1-5]/)) {
    return CreditCardBrandName.MASTERCARD;
  }
  if (cardNo.match(/^[34|37]/)) {
    return CreditCardBrandName.AMERICAN_EXPRESS;
  }
  if (cardNo.match(/^35/)) {
    return CreditCardBrandName.JCB;
  }
  return void 0;
}
function getCreditCardBrandFromCardNo(cardNo) {
  switch (getCreditCardBrandNameFromCardNo(cardNo)) {
    case CreditCardBrandName.VISA:
      return "VISA";
    case CreditCardBrandName.AMERICAN_EXPRESS:
      return "AMERICAN_EXPRESS";
    case CreditCardBrandName.JCB:
      return "JCB";
    case CreditCardBrandName.MASTERCARD:
      return "MASTERCARD";
    default:
      return void 0;
  }
}
function getCreditCardIcon(creditCardBrandName) {
  switch (creditCardBrandName) {
    case CreditCardBrandName.AMERICAN_EXPRESS:
      return AMERICAN_EXPRESS_ICON_PATH;
    case CreditCardBrandName.JCB:
      return JCB_ICON_PATH;
    case CreditCardBrandName.MASTERCARD:
      return MASTERCARD_ICON_PATH;
    case CreditCardBrandName.VISA:
      return VISA_ICON_PATH;
    default:
      return void 0;
  }
}
function CardCreditCard({
  cardNo,
  brand,
  onClick: onClick2,
  imgSrc
}) {
  return /* @__PURE__ */ jsxs(Card, {
    className: "tw-relative",
    children: [/* @__PURE__ */ jsx$1(ButtonIcon, {
      onClick: onClick2,
      size: "small",
      variant: "secondary",
      iconName: IconName.CLOSE,
      className: "tw-absolute tw-top-[-8px] tw-right-[-8px]"
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-items-center tw-py-4 tw-px-6",
      children: [/* @__PURE__ */ jsx$1("img", {
        src: imgSrc,
        alt: brand,
        className: "tw-mr-1 tw-w-6"
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-3",
        className: "tw-mr-1",
        children: brand
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "body-1",
        children: cardNo
      })]
    })]
  });
}
function CustomExpand({
  isSuccessful,
  stepNo,
  onClick: onClick2,
  isExpand,
  title,
  children: children2
}) {
  const handleClick = useCallback(() => onClick2(stepNo), [onClick2, stepNo]);
  return /* @__PURE__ */ jsx$1(ControlledExpand, {
    className: "tw-bg-White",
    closeIconName: IconName.PENCIL_OUTLINE,
    title: /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-items-center tw-pt-[2px]",
      children: [isSuccessful ? /* @__PURE__ */ jsx$1(Icon, {
        name: IconName.CHECK_CIRCLE_ICON,
        size: IconSize.MEDIUM,
        className: "tw-mr-4"
      }) : /* @__PURE__ */ jsx$1("div", {
        className: classNames$1("tw-rounded-full tw-bg-Gray-100 tw-text-Gray-500 tw-h-6 tw-w-6 tw-flex tw-items-center tw-justify-center tw-mr-4", {}),
        children: /* @__PURE__ */ jsx$1(Typography, {
          variant: "title-9",
          className: "tw-text-Gray-500",
          children: stepNo
        })
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-6",
        className: "tw-text-Gray-800",
        children: title
      })]
    }),
    isOpen: isExpand,
    onClick: handleClick,
    children: children2
  });
}
function ModalRemoveCreditCard({
  isOpen,
  onSubmit,
  onClose,
  brand,
  cardNo
}) {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx$1(Modal, {
    size: "medium",
    onClose,
    isOpen,
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-pb-6 tw-w-full tw-h-fit desktop:tw-p-6",
      children: [/* @__PURE__ */ jsx$1(Typography, {
        className: "tw-py-6 tw-text-center",
        variant: "title-2",
        color: COLORS.Gray[800],
        children: t2("planUpgrade.modalRemmoveCreditCard.title")
      }), /* @__PURE__ */ jsxs(Typography, {
        className: "tw-text-center",
        variant: "title-8",
        color: COLORS.Gray[800],
        children: [brand, " ", cardNo]
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-justify-between tw-mt-10",
        children: [/* @__PURE__ */ jsx$1(Button, {
          size: "large",
          variant: "text",
          className: "tw-w-full tw-text-Primary-600",
          onClick: onClose,
          children: t2("planUpgrade.modalRemmoveCreditCard.cancel")
        }), /* @__PURE__ */ jsx$1("div", {
          className: "tw-w-8"
        }), /* @__PURE__ */ jsx$1(Button, {
          size: "large",
          variant: "primary",
          className: "tw-w-full tw-bg-Primary-600",
          onClick: onSubmit,
          children: t2("planUpgrade.modalRemmoveCreditCard.confirm")
        })]
      })]
    })
  });
}
var require$$0 = /* @__PURE__ */ getAugmentedNamespace(jsxRuntime);
var _jsx$1 = require$$0.jsx;
var _jsxs$1 = require$$0.jsxs;
const React$1 = React__default;
function CreditCardIcon(_P, svgRef) {
  var _Q = _P, {
    title,
    titleId
  } = _Q, props = __objRest(_Q, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ _jsxs$1("svg", __spreadProps(__spreadValues({}, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props)), {
    children: [title ? /* @__PURE__ */ _jsx$1("title", {
      id: titleId,
      children: title
    }) : null, /* @__PURE__ */ _jsx$1("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"
    })]
  }));
}
const ForwardRef$1 = React$1.forwardRef(CreditCardIcon);
var CreditCardIcon_1 = ForwardRef$1;
var CreditCardIcon$1 = CreditCardIcon_1;
const Form = (props) => {
  const _a2 = props, {
    watch,
    getValues,
    setError,
    clearErrors,
    setValue,
    trigger: trigger2,
    formState,
    resetField,
    reset,
    handleSubmit,
    unregister,
    control,
    register,
    setFocus,
    getFieldState,
    children: children2
  } = _a2, rest = __objRest(_a2, [
    "watch",
    "getValues",
    "setError",
    "clearErrors",
    "setValue",
    "trigger",
    "formState",
    "resetField",
    "reset",
    "handleSubmit",
    "unregister",
    "control",
    "register",
    "setFocus",
    "getFieldState",
    "children"
  ]);
  return /* @__PURE__ */ jsx$1(FormProvider, {
    watch,
    getValues,
    setError,
    clearErrors,
    setValue,
    trigger: trigger2,
    formState,
    resetField,
    getFieldState,
    reset,
    handleSubmit,
    unregister,
    control,
    register,
    setFocus,
    children: /* @__PURE__ */ jsx$1("form", __spreadProps(__spreadValues({}, rest), {
      children: children2
    }))
  });
};
Form.displayName = "Form";
const Label = (props) => {
  const {
    children: children2
  } = props;
  return /* @__PURE__ */ jsx$1("label", __spreadProps(__spreadValues({
    className: "tw-flex tw-mb-1 tw-w-full"
  }, props), {
    children: children2
  }));
};
const MaxLengthLabel = (props) => {
  const {
    maxLength,
    name
  } = props;
  const value = useWatch({
    name
  });
  const currentLength = (value == null ? void 0 : value.length) || 0;
  return /* @__PURE__ */ jsxs("span", {
    className: "tw-flex-1 tw-text-sm tw-text-right tw-text-Gray-400",
    children: [currentLength, "/", maxLength]
  });
};
function FormLabel({
  children: children2,
  name,
  primaryLabel,
  secondaryLabel,
  maxLength,
  isRequired = false
}) {
  return /* @__PURE__ */ jsxs(Label, {
    htmlFor: name,
    children: [!!primaryLabel && /* @__PURE__ */ jsx$1(Typography, {
      variant: "title-9",
      className: "tw-mr-1 tw-text-Gray-600",
      children: primaryLabel
    }), !!primaryLabel && !!isRequired && /* @__PURE__ */ jsx$1("span", {
      className: "tw-text-sm tw-text-Red",
      children: "*"
    }), !!primaryLabel && !!secondaryLabel && /* @__PURE__ */ jsx$1("span", {
      className: "tw-ml-1 tw-text-sm tw-text-Gray-400",
      children: secondaryLabel
    }), !!maxLength && /* @__PURE__ */ jsx$1(MaxLengthLabel, {
      name,
      maxLength
    }), children2]
  });
}
const getHintStyle = (variant = "error") => {
  if (variant === "info") {
    return "tw-text-sm tw-text-Gray-500";
  }
  return "tw-text-sm tw-text-Red";
};
const Hint = memo((props) => {
  const {
    message,
    variant = "error"
  } = props;
  if (!message) {
    return /* @__PURE__ */ jsx$1(Fragment, {});
  }
  const className = getHintStyle(variant);
  return /* @__PURE__ */ jsx$1("div", {
    className: `tw-mb-2 ${className}`,
    children: message
  });
});
Hint.displayName = "Hint";
const FormField = (props) => {
  const {
    children: children2,
    infos = [],
    isRequired,
    maxLength,
    name,
    primaryLabel,
    secondaryLabel,
    isUseTranslation
  } = props;
  const {
    getFieldState
  } = useFormContext();
  const {
    t: t2
  } = useTranslation();
  const {
    error: error2
  } = getFieldState(name);
  const areInfosShown = !!infos.length && !error2;
  const isLabelShown = !!primaryLabel || !!maxLength;
  const getErrorMessage = () => {
    if (!(error2 == null ? void 0 : error2.message)) {
      return void 0;
    }
    if (isUseTranslation) {
      return t2(error2.message);
    }
    return error2.message;
  };
  return /* @__PURE__ */ jsxs("div", {
    children: [isLabelShown && /* @__PURE__ */ jsx$1(FormLabel, {
      name,
      primaryLabel,
      secondaryLabel,
      isRequired,
      maxLength
    }), children2, /* @__PURE__ */ jsx$1(Hint, {
      variant: "error",
      message: getErrorMessage()
    }), areInfosShown && infos.map((info, index2) => /* @__PURE__ */ jsx$1(Hint, {
      variant: "info",
      message: info
    }, [index2, info].join()))]
  });
};
const FormNumberFormatInput = (props) => {
  var _b;
  const _a2 = props, {
    name,
    primaryLabel,
    secondaryLabel,
    isRequired,
    maxLength,
    disabled = false,
    infos = [],
    rules,
    LeftAdornment,
    isUseTranslation
  } = _a2, rest = __objRest(_a2, [
    "name",
    "primaryLabel",
    "secondaryLabel",
    "isRequired",
    "maxLength",
    "disabled",
    "infos",
    "rules",
    "LeftAdornment",
    "isUseTranslation"
  ]);
  const {
    getFieldState,
    formState: {
      errors
    }
  } = useFormContext();
  const fieldState = getFieldState(name);
  const hasError = !!((_b = fieldState.error) == null ? void 0 : _b.message);
  return /* @__PURE__ */ jsx$1(FormField, {
    name,
    primaryLabel,
    secondaryLabel,
    isRequired,
    maxLength,
    infos,
    isUseTranslation,
    children: /* @__PURE__ */ jsx$1(Controller, {
      name,
      rules,
      render: (_c) => {
        var {
          field: _d
        } = _c, _e2 = _d, {
          onChange: onChange2
        } = _e2, restField = __objRest(_e2, [
          "onChange"
        ]);
        return /* @__PURE__ */ jsx$1(NumberFormatInput, __spreadValues(__spreadProps(__spreadValues({
          LeftAdornment,
          onValueChange: (numberFormatValue, sourceInfo) => {
            if (!sourceInfo.event) {
              return;
            }
            const event = Object.assign(sourceInfo.event, __spreadProps(__spreadValues({}, sourceInfo.event), {
              target: __spreadProps(__spreadValues({}, sourceInfo.event.target), {
                value: numberFormatValue.value
              })
            }));
            onChange2(event);
          }
        }, restField), {
          maxLength,
          disabled,
          hasError
        }), rest));
      }
    })
  });
};
const FormTextField = (props) => {
  var _b;
  const _a2 = props, {
    isRequired = false,
    infos = [],
    name,
    primaryLabel,
    secondaryLabel,
    maxLength,
    registerOptions,
    isUseTranslation
  } = _a2, rest = __objRest(_a2, [
    "isRequired",
    "infos",
    "name",
    "primaryLabel",
    "secondaryLabel",
    "maxLength",
    "registerOptions",
    "isUseTranslation"
  ]);
  const {
    register,
    getFieldState,
    formState: {
      errors
    }
  } = useFormContext();
  const fieldState = getFieldState(name);
  const hasError = !!((_b = fieldState.error) == null ? void 0 : _b.message);
  return /* @__PURE__ */ jsx$1(FormField, {
    name,
    infos,
    primaryLabel,
    secondaryLabel,
    isRequired,
    maxLength,
    isUseTranslation,
    children: /* @__PURE__ */ jsx$1(TextField, __spreadValues(__spreadValues({
      maxLength,
      hasError
    }, rest), register(name, registerOptions)))
  });
};
FormTextField.displayName = "FormTextField";
const schema$1 = create({
  cardNo: create$2().required("planUpgrade.paymentMethodForm.validation.cardNo.required").min(15, "planUpgrade.paymentMethodForm.validation.cardNo.min").max(16, "planUpgrade.paymentMethodForm.validation.cardNo.max"),
  cvv: create$2().required("planUpgrade.paymentMethodForm.validation.cvv.required").length(3, "planUpgrade.paymentMethodForm.validation.cvv.length"),
  expireDate: create$2().required("planUpgrade.paymentMethodForm.validation.expireDate.required").length(4, "planUpgrade.paymentMethodForm.validation.expireDate.length").test({
    name: "invalidDate",
    test(value, ctx) {
      if (!value) {
        return ctx.createError({
          message: "planUpgrade.paymentMethodForm.validation.expireDate.required"
        });
      }
      const month = value == null ? void 0 : value.substring(0, 2);
      const year = value == null ? void 0 : value.substring(2);
      const expireDate = new Date(`${month}/01/20${year}`);
      if (expireDate.toString() === "Invalid Date" || new Date() > expireDate) {
        return ctx.createError({
          message: "planUpgrade.paymentMethodForm.validation.expireDate.invalidDate"
        });
      }
      return true;
    }
  }),
  cardholderName: create$2().matches(/^\D+/, {
    message: "planUpgrade.paymentMethodForm.validation.cardholderName.containNumber"
  }).required("planUpgrade.paymentMethodForm.validation.cardholderName.required"),
  isPrimary: create$3().optional()
});
function PaymentMethodForm({
  onSubmit,
  onClickTermAndCondition
}) {
  const [isLoading, setIsLoading] = useState(false);
  const methods = useForm({
    resolver: o(schema$1),
    mode: "onChange"
  });
  const {
    t: t2
  } = useTranslation();
  const brand = getCreditCardBrandFromCardNo(methods.watch("cardNo") || "");
  const handleSubmit = async (newData) => {
    if (!brand) {
      return;
    }
    setIsLoading(true);
    try {
      await onSubmit(__spreadProps(__spreadValues({}, newData), {
        brand
      }));
    } finally {
      setIsLoading(false);
    }
  };
  return /* @__PURE__ */ jsxs(Form, __spreadProps(__spreadValues({}, methods), {
    onSubmit: methods.handleSubmit(handleSubmit),
    children: [/* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-justify-between tw-items-end tw-mb-2",
        children: [/* @__PURE__ */ jsx$1(Typography, {
          variant: "title-9",
          className: "tw-text-Gray-600",
          children: t2("planUpgrade.paymentMethodForm.cardNo")
        }), /* @__PURE__ */ jsxs("div", {
          className: "tw-flex tw-justify-end",
          children: [/* @__PURE__ */ jsx$1("img", {
            src: VISA_ICON_PATH,
            alt: "visa",
            style: brand && brand !== "VISA" ? {
              filter: "grayscale(100%)"
            } : {},
            className: "tw-mr-1 tw-w-6"
          }), /* @__PURE__ */ jsx$1("img", {
            src: MASTERCARD_ICON_PATH,
            alt: "mastercard",
            className: "tw-mr-1 tw-w-6",
            style: brand && brand !== "MASTERCARD" ? {
              filter: "grayscale(100%)"
            } : {}
          }), /* @__PURE__ */ jsx$1("img", {
            src: JCB_ICON_PATH,
            alt: "jcb",
            className: "tw-mr-1 tw-w-6",
            style: brand && brand !== "JCB" ? {
              filter: "grayscale(100%)"
            } : {}
          }), /* @__PURE__ */ jsx$1("img", {
            src: AMERICAN_EXPRESS_ICON_PATH,
            alt: "american-express",
            className: "tw-mr-1 tw-w-6",
            style: brand && brand !== "AMERICAN_EXPRESS" ? {
              filter: "grayscale(100%)"
            } : {}
          })]
        })]
      }), /* @__PURE__ */ jsx$1(FormNumberFormatInput, {
        name: "cardNo",
        placeholder: "XXXX XXXX XXXX XXXX",
        format: "#### #### #### ####",
        isUseTranslation: true,
        LeftAdornment: /* @__PURE__ */ jsx$1(CreditCardIcon$1, {
          className: "tw-h-4 tw-text-Black"
        })
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-grid tw-grid-cols-1 tw-gap-4 tw-mt-8 desktop:tw-grid-cols-2",
      children: [/* @__PURE__ */ jsx$1("div", {
        children: /* @__PURE__ */ jsx$1(FormNumberFormatInput, {
          name: "expireDate",
          primaryLabel: t2("planUpgrade.paymentMethodForm.expireDate"),
          format: "## / ##",
          isUseTranslation: true,
          placeholder: "MM / YY"
        })
      }), /* @__PURE__ */ jsx$1("div", {
        children: /* @__PURE__ */ jsx$1(FormNumberFormatInput, {
          name: "cvv",
          type: "password",
          maxLength: 3,
          isUseTranslation: true,
          allowLeadingZeros: true,
          primaryLabel: t2("planUpgrade.paymentMethodForm.cvv")
        })
      })]
    }), /* @__PURE__ */ jsx$1("div", {
      className: "tw-mt-9",
      children: /* @__PURE__ */ jsx$1(FormTextField, {
        name: "cardholderName",
        primaryLabel: t2("planUpgrade.paymentMethodForm.cardHolderNameLabel"),
        isUseTranslation: true,
        placeholder: t2("planUpgrade.paymentMethodForm.cardHolderNamePlaceholder")
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-mt-9",
      children: [/* @__PURE__ */ jsxs(Typography, {
        variant: "body-4",
        className: "tw-mt-4 tw-text-Gray-500",
        children: [t2("planUpgrade.paymentMethodForm.description1"), " ", /* @__PURE__ */ jsx$1("span", {
          className: "tw-ml-1 tw-text-Primary-600 tw-cursor-pointer",
          onClick: onClickTermAndCondition,
          children: t2("planUpgrade.paymentMethodForm.termAndCondition")
        })]
      }), /* @__PURE__ */ jsx$1(Button, {
        type: "submit",
        size: "large",
        className: "tw-mt-2 tw-w-full",
        isLoading,
        disabled: !!Object.keys(methods.formState.errors).length,
        children: t2("planUpgrade.paymentMethodForm.submit")
      })]
    })]
  }));
}
const MemorizedPaymentMethodForm = memo(PaymentMethodForm);
function PaymentSection({
  isExpand,
  isSuccessful,
  stepNo,
  title,
  onClick: onClick2,
  projectId,
  gbPrimePublicKey,
  gbPrimeUrl,
  onSuccessful,
  onClickTermAndCondition
}) {
  var _a2, _b;
  const {
    creditCardData,
    add: addCreditCard,
    remove: removeCreditCard
  } = useCreditCard({
    projectId,
    gbPrimePublicKey,
    gbPrimeUrl
  });
  const {
    t: t2
  } = useTranslation();
  const cardNo = (_a2 = creditCardData == null ? void 0 : creditCardData.creditCard) == null ? void 0 : _a2.number;
  const creditCardBrandName = getCreditCardBrandNameFromCardNo(cardNo);
  const imgSrc = getCreditCardIcon(creditCardBrandName);
  const splitedCardNo = (_b = cardNo == null ? void 0 : cardNo.split) == null ? void 0 : _b.call(cardNo, "X");
  const formattedCardNo = splitedCardNo == null ? void 0 : splitedCardNo[(splitedCardNo == null ? void 0 : splitedCardNo.length) - 1];
  const creditCard = creditCardData == null ? void 0 : creditCardData.creditCard;
  const isHasCreditCard = !!(creditCard == null ? void 0 : creditCard.number);
  const [isShowModalRemoveCreditCard, setIsShowModalRemoveCreditCard] = useState(false);
  const handleAddCreditCard = useCallback(async (data2) => {
    try {
      await addCreditCard({
        name: data2.cardholderName,
        number: data2.cardNo,
        expirationMonth: data2.expireDate.substring(0, 2),
        expirationYear: data2.expireDate.substring(2),
        brand: data2.brand,
        securityCode: data2.cvv
      });
      onSuccessful(stepNo);
      notifySuccess(t2("planUpgrade.paymentSection.addCreditCardSuccess"));
    } catch (error2) {
      notifyError(t2("planUpgrade.paymentSection.addCreditCardError"));
    }
  }, [addCreditCard, onSuccessful, stepNo, t2]);
  const handleRemoveCreditCard = async () => {
    setIsShowModalRemoveCreditCard(false);
    if (!(creditCardData == null ? void 0 : creditCardData.creditCard)) {
      return;
    }
    const cardData = {
      brand: creditCard == null ? void 0 : creditCard.brand,
      cardNo: creditCard == null ? void 0 : creditCard.number
    };
    try {
      await removeCreditCard();
      notifySuccess(t2("planUpgrade.paymentSection.removeCreditCardSuccess", cardData));
    } catch (error2) {
      notifyError(t2("planUpgrade.paymentSection.removeCreditCardError", cardData));
    }
  };
  useEffect(() => {
    if (!isHasCreditCard) {
      return;
    }
    onSuccessful(stepNo);
  }, [isHasCreditCard, onSuccessful, stepNo]);
  const formData = {
    cardNo: creditCard == null ? void 0 : creditCard.number,
    brand: creditCard == null ? void 0 : creditCard.brand,
    expireDate: [creditCard == null ? void 0 : creditCard.expirationMonth, creditCard == null ? void 0 : creditCard.expirationYear].join(""),
    cardholderName: creditCard == null ? void 0 : creditCard.name,
    isPrimary: false
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx$1(ModalRemoveCreditCard, {
      isOpen: isShowModalRemoveCreditCard,
      onClose: () => setIsShowModalRemoveCreditCard(false),
      onSubmit: handleRemoveCreditCard,
      brand: creditCardBrandName,
      cardNo: formattedCardNo
    }), /* @__PURE__ */ jsx$1(CustomExpand, {
      isExpand,
      isSuccessful,
      onClick: onClick2,
      stepNo,
      title,
      children: formattedCardNo && creditCardBrandName ? /* @__PURE__ */ jsx$1(CardCreditCard, {
        cardNo: formattedCardNo,
        brand: creditCardBrandName,
        imgSrc,
        onClick: () => setIsShowModalRemoveCreditCard(true)
      }) : /* @__PURE__ */ jsx$1(MemorizedPaymentMethodForm, {
        data: formData,
        onSubmit: handleAddCreditCard,
        onClickTermAndCondition
      })
    })]
  });
}
var PaymentSection$1 = memo(PaymentSection);
function Tab$1({
  children: children2,
  name,
  value,
  checked,
  onChange: onChange2
}, ref) {
  const id2 = [name, value].map((s) => s.toLocaleLowerCase()).join("-");
  return /* @__PURE__ */ jsxs(Typography, {
    variant: "title-9",
    children: [/* @__PURE__ */ jsx$1("input", {
      type: "radio",
      className: "tw-peer",
      hidden: true,
      name,
      id: id2,
      value,
      ref,
      checked,
      onChange: onChange2
    }), /* @__PURE__ */ jsx$1("label", {
      htmlFor: id2,
      className: "tw-py-2 tw-px-4 tw-w-full peer-checked:tw-bg-Primary-200 hover:tw-bg-Gray-200 tw-rounded tw-transition-all tw-cursor-pointer",
      children: children2
    })]
  });
}
var Tab$2 = forwardRef(Tab$1);
function Tab({
  children: children2
}, ref) {
  return /* @__PURE__ */ jsx$1("div", {
    className: "tw-flex",
    ref,
    children: children2
  });
}
var Tabs = forwardRef(Tab);
function ImageUploader({
  label,
  image,
  onDrop,
  onChange: onChange2,
  onRemove,
  maxSize = 2097152,
  acceptFileTypes = ["image/png", "image/jpeg", "image/jpg"]
}) {
  const [isOpenErrorModal, setIsOpenErrorModal] = useState(false);
  const handleDrop = (acceptFiles, fileRejections, event) => {
    if (!isEmpty_1(fileRejections)) {
      setIsOpenErrorModal(true);
      return;
    }
    onDrop(acceptFiles, fileRejections, event);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [image ? /* @__PURE__ */ jsx$1(ImagePanel, {
      src: image,
      isSelected: true,
      onChange: onChange2,
      onRemove
    }) : /* @__PURE__ */ jsx$1(Dropzone, {
      onDrop: handleDrop,
      maxSize,
      acceptFileTypes,
      children: /* @__PURE__ */ jsx$1(ImageUpload, {
        iconName: IconName.ADD_PHOTO,
        label
      })
    }), /* @__PURE__ */ jsx$1(UploadErrorModal, {
      isOpen: isOpenErrorModal,
      handleClose: () => setIsOpenErrorModal(false)
    })]
  });
}
function getFormNamesFromSchema(schema2) {
  return Object.keys(schema2.fields).reduce((prev2, curr) => __spreadProps(__spreadValues({}, prev2), {
    [curr]: curr
  }), {});
}
var isFunction = function isFunction2(value) {
  return typeof value === "function";
};
var isDev = false;
var isDev$1 = isDev;
function depsAreSame(oldDeps, deps) {
  if (oldDeps === deps)
    return true;
  for (var i2 = 0; i2 < oldDeps.length; i2++) {
    if (!Object.is(oldDeps[i2], deps[i2]))
      return false;
  }
  return true;
}
function useLatest(value) {
  var ref = useRef(value);
  ref.current = value;
  return ref;
}
var useUnmount = function useUnmount2(fn2) {
  if (isDev$1) {
    if (!isFunction(fn2)) {
      console.error("useUnmount expected parameter is a function, got " + typeof fn2);
    }
  }
  var fnRef = useLatest(fn2);
  useEffect(function() {
    return function() {
      fnRef.current();
    };
  }, []);
};
var useUnmount$1 = useUnmount;
var isBrowser = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var isBrowser$1 = isBrowser;
function getTargetElement(target, defaultElement) {
  if (!isBrowser$1) {
    return void 0;
  }
  if (!target) {
    return defaultElement;
  }
  var targetElement;
  if (isFunction(target)) {
    targetElement = target();
  } else if ("current" in target) {
    targetElement = target.current;
  } else {
    targetElement = target;
  }
  return targetElement;
}
var checkIfAllInShadow = function checkIfAllInShadow2(targets) {
  return targets.every(function(item) {
    var targetElement = getTargetElement(item);
    if (!targetElement)
      return false;
    if (targetElement.getRootNode() instanceof ShadowRoot)
      return true;
  });
};
var getShadow = function getShadow2(node2) {
  if (!node2) {
    return document;
  }
  return node2.getRootNode();
};
var getDocumentOrShadow = function getDocumentOrShadow2(target) {
  if (!target || !document.getRootNode) {
    return document;
  }
  var targets = Array.isArray(target) ? target : [target];
  if (checkIfAllInShadow(targets)) {
    return getShadow(getTargetElement(targets[0]));
  }
  return document;
};
var getDocumentOrShadow$1 = getDocumentOrShadow;
var createEffectWithTarget = function createEffectWithTarget2(useEffectType) {
  var useEffectWithTarget2 = function useEffectWithTarget3(effect2, deps, target) {
    var hasInitRef = useRef(false);
    var lastElementRef = useRef([]);
    var lastDepsRef = useRef([]);
    var unLoadRef = useRef();
    useEffectType(function() {
      var _a2;
      var targets = Array.isArray(target) ? target : [target];
      var els = targets.map(function(item) {
        return getTargetElement(item);
      });
      if (!hasInitRef.current) {
        hasInitRef.current = true;
        lastElementRef.current = els;
        lastDepsRef.current = deps;
        unLoadRef.current = effect2();
        return;
      }
      if (els.length !== lastElementRef.current.length || !depsAreSame(els, lastElementRef.current) || !depsAreSame(deps, lastDepsRef.current)) {
        (_a2 = unLoadRef.current) === null || _a2 === void 0 ? void 0 : _a2.call(unLoadRef);
        lastElementRef.current = els;
        lastDepsRef.current = deps;
        unLoadRef.current = effect2();
      }
    });
    useUnmount$1(function() {
      var _a2;
      (_a2 = unLoadRef.current) === null || _a2 === void 0 ? void 0 : _a2.call(unLoadRef);
      hasInitRef.current = false;
    });
  };
  return useEffectWithTarget2;
};
var createEffectWithTarget$1 = createEffectWithTarget;
var useEffectWithTarget = createEffectWithTarget$1(useEffect);
var useEffectWithTarget$1 = useEffectWithTarget;
function useClickAway(onClickAway, target, eventName) {
  if (eventName === void 0) {
    eventName = "click";
  }
  var onClickAwayRef = useLatest(onClickAway);
  useEffectWithTarget$1(function() {
    var handler = function handler2(event) {
      var targets = Array.isArray(target) ? target : [target];
      if (targets.some(function(item) {
        var targetElement = getTargetElement(item);
        return !targetElement || targetElement.contains(event.target);
      })) {
        return;
      }
      onClickAwayRef.current(event);
    };
    var documentOrShadow = getDocumentOrShadow$1(target);
    var eventNames = Array.isArray(eventName) ? eventName : [eventName];
    eventNames.forEach(function(event) {
      return documentOrShadow.addEventListener(event, handler);
    });
    return function() {
      eventNames.forEach(function(event) {
        return documentOrShadow.removeEventListener(event, handler);
      });
    };
  }, Array.isArray(eventName) ? eventName : [eventName], target);
}
const Elevation = (_R) => {
  var _S = _R, {
    type,
    children: children2,
    className
  } = _S, props = __objRest(_S, [
    "type",
    "children",
    "className"
  ]);
  return /* @__PURE__ */ jsx$1("div", __spreadProps(__spreadValues({
    className: classNames$1(shadowClasses[type], className)
  }, props), {
    children: children2
  }));
};
Elevation.displayName = "Elevation";
var src = { exports: {} };
(function(module) {
  /**
    * @name JQL.js
    * @version 1.0.3
    * @update Apr 16, 2017
    * @author Earthchie http://www.earthchie.com/
    * @license WTFPL v.2 - http://www.wtfpl.net/
    **/
  function JQL2(obj) {
    if (typeof obj === "string") {
      obj = JSON.parse(obj);
    }
    this.data_source = obj;
    this.buffer = obj;
    this.focused_field = "";
    this.options = [];
    this.size = false;
    for (const key in obj) {
      for (const field in obj[key]) {
        this.options.push(field);
      }
      break;
    }
    this.fetch = function() {
      if (typeof this.options === "object") {
        const obj2 = {};
        for (var i2 in this.buffer) {
          obj2[i2] = {};
          for (const j in this.options) {
            const field = this.options[j];
            if (this.buffer[i2][field]) {
              obj2[i2][field] = this.buffer[i2][field];
            }
          }
        }
        this.buffer = obj2;
      }
      if (this.size) {
        const temp = this.size.toString().split(",");
        let start2 = 0;
        let end2 = this.size;
        if (temp.length > 1 && temp[0] < temp[1]) {
          start2 = parseInt(temp[0]);
          end2 = start2 + parseInt(temp[1]);
        }
        const results2 = {};
        for (var i2 = start2; i2 < end2; i2++) {
          if (this.buffer[i2]) {
            results2[i2] = this.buffer[i2];
          } else {
            break;
          }
        }
        this.buffer = results2;
      }
      return this.buffer;
    };
    this.new = function(obj2) {
      this.data_source = obj2;
      this.buffer = obj2;
    };
    this.limit = function(limit) {
      this.size = limit;
      return this;
    };
    this.select = function(filters) {
      this.options = filters;
      if (typeof filters === "string" && filters !== "*") {
        this.options = filters.split(",");
      }
      this.buffer = this.data_source;
      this.size = false;
      return this;
    };
    this.where = function(field) {
      this.focused_field = field;
      return this;
    };
    this.contains = function(str, caseSensitive) {
      const obj2 = this.buffer;
      this.buffer = [];
      for (const i2 in obj2) {
        if (caseSensitive) {
          if (~obj2[i2][this.focused_field].indexOf(str)) {
            this.buffer.push(obj2[i2]);
          }
        } else if (~obj2[i2][this.focused_field].toLowerCase().indexOf(str.toLowerCase())) {
          this.buffer.push(obj2[i2]);
        }
      }
      return this;
    };
    this.match = function(regex, options2) {
      if (typeof regex === "string" && regex !== "") {
        options2 = options2 || "ig";
        regex = new RegExp(regex, options2);
        const obj2 = this.buffer;
        this.buffer = [];
        for (const i2 in obj2) {
          regex.lastIndex = 0;
          if (regex.exec(obj2[i2][this.focused_field])) {
            this.buffer.push(obj2[i2]);
          }
        }
      }
      return this;
    };
    this.equalTo = function(val) {
      const obj2 = this.buffer;
      this.buffer = [];
      for (const i2 in obj2) {
        if (obj2[i2][this.focused_field] == val) {
          this.buffer.push(obj2[i2]);
        }
      }
      return this;
    };
    this.in = function(vals) {
      const obj2 = this.buffer;
      this.buffer = [];
      for (const i2 in obj2) {
        if (this.in_array(obj2[i2][this.focused_field], vals)) {
          this.buffer.push(obj2[i2]);
        }
      }
      return this;
    };
    this.moreThan = function(val) {
      const obj2 = this.buffer;
      this.buffer = [];
      for (const i2 in obj2) {
        if (parseFloat(obj2[i2][this.focused_field]) > parseFloat(val)) {
          this.buffer.push(obj2[i2]);
        }
      }
      return this;
    };
    this.moreThanOrEqualTo = function(val) {
      const obj2 = this.buffer;
      this.buffer = [];
      for (const i2 in obj2) {
        if (parseFloat(obj2[i2][this.focused_field]) >= parseFloat(val)) {
          this.buffer.push(obj2[i2]);
        }
      }
      return this;
    };
    this.lessThan = function(val) {
      const obj2 = this.buffer;
      this.buffer = [];
      for (const i2 in obj2) {
        if (parseFloat(obj2[i2][this.focused_field]) < parseFloat(val)) {
          this.buffer.push(obj2[i2]);
        }
      }
      return this;
    };
    this.lessThanOrEqualTo = function(val) {
      const obj2 = this.buffer;
      this.buffer = [];
      for (const i2 in obj2) {
        if (parseFloat(obj2[i2][this.focused_field]) <= parseFloat(val)) {
          this.buffer.push(obj2[i2]);
        }
      }
      return this;
    };
    this.orderBy = function(field, mode) {
      let sequence = "asc";
      const target = field.split(" ");
      const temp = target.pop();
      if (temp && temp.toLowerCase() == "desc") {
        sequence = "desc";
        field = target.join(" ");
      }
      const obj2 = [];
      for (var i2 in this.buffer) {
        obj2.push([i2, this.buffer[i2][field]]);
      }
      if (obj2.length < 2) {
        return this;
      }
      if (mode == void 0 && isNaN(obj2[0][1])) {
        mode = "string";
      } else {
        mode = "numeric";
      }
      if (mode == "string") {
        obj2.sort((a2, b2) => {
          if (a2[1] < b2[1])
            return -1;
          if (a2[1] > b2[1])
            return 1;
          return 0;
        });
      } else {
        obj2.sort((a2, b2) => a2[1] - b2[1]);
      }
      results = [];
      for (var i2 in obj2) {
        results.push(this.buffer[obj2[i2][0]]);
      }
      this.buffer = results;
      if (sequence == "desc") {
        this.buffer = this.buffer.reverse();
      }
      return this;
    };
    this.and = this.where;
    this.is = this.equalTo;
    this.in_array = function(val, list) {
      for (const i2 in list) {
        if (val == list[i2]) {
          return true;
        }
      }
      return false;
    };
  }
  if (module.exports) {
    module.exports = JQL2;
  }
})(src);
var JQL = src.exports;
var thailandAddressData = [
  [
    "\u0E01\u0E23\u0E30\u0E1A\u0E35\u0E48",
    [
      [
        "\u0E04\u0E25\u0E2D\u0E07\u0E17\u0E48\u0E2D\u0E21",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E17\u0E48\u0E2D\u0E21\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              81120
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E17\u0E48\u0E2D\u0E21\u0E43\u0E15\u0E49",
            [
              81120
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E1E\u0E19",
            [
              81170
            ]
          ],
          [
            "\u0E17\u0E23\u0E32\u0E22\u0E02\u0E32\u0E27",
            [
              81170
            ]
          ],
          [
            "\u0E1E\u0E23\u0E38\u0E14\u0E34\u0E19\u0E19\u0E32",
            [
              81120
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E19\u0E49\u0E33\u0E02\u0E32\u0E27",
            [
              81120
            ]
          ],
          [
            "\u0E40\u0E1E\u0E2B\u0E25\u0E32",
            [
              81120
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E25\u0E32\u0E22\u0E1E\u0E23\u0E30\u0E22\u0E32",
        [
          [
            "\u0E04\u0E35\u0E23\u0E35\u0E27\u0E07",
            [
              81160
            ]
          ],
          [
            "\u0E1B\u0E25\u0E32\u0E22\u0E1E\u0E23\u0E30\u0E22\u0E32",
            [
              81160
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E15\u0E48\u0E2D",
            [
              81160
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E40\u0E02\u0E19",
            [
              81160
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E33\u0E17\u0E31\u0E1A",
        [
          [
            "\u0E14\u0E34\u0E19\u0E2D\u0E38\u0E14\u0E21",
            [
              81190
            ]
          ],
          [
            "\u0E14\u0E34\u0E19\u0E41\u0E14\u0E07",
            [
              81190
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E44\u0E17\u0E23\u0E17\u0E2D\u0E07",
            [
              81190
            ]
          ],
          [
            "\u0E25\u0E33\u0E17\u0E31\u0E1A",
            [
              81190
            ]
          ]
        ]
      ],
      [
        "\u0E2D\u0E48\u0E32\u0E27\u0E25\u0E36\u0E01",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E22\u0E32",
            [
              81110
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2B\u0E34\u0E19",
            [
              81110
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              81110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E25\u0E32\u0E07",
            [
              81110
            ]
          ],
          [
            "\u0E2D\u0E48\u0E32\u0E27\u0E25\u0E36\u0E01\u0E19\u0E49\u0E2D\u0E22",
            [
              81110
            ]
          ],
          [
            "\u0E2D\u0E48\u0E32\u0E27\u0E25\u0E36\u0E01\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              81110
            ]
          ],
          [
            "\u0E2D\u0E48\u0E32\u0E27\u0E25\u0E36\u0E01\u0E43\u0E15\u0E49",
            [
              81110
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E43\u0E2B\u0E0D\u0E48",
            [
              81110
            ]
          ],
          [
            "\u0E41\u0E2B\u0E25\u0E21\u0E2A\u0E31\u0E01",
            [
              81110
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E01\u0E32\u0E30\u0E25\u0E31\u0E19\u0E15\u0E32",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E22\u0E32\u0E07",
            [
              81120
            ]
          ],
          [
            "\u0E28\u0E32\u0E25\u0E32\u0E14\u0E48\u0E32\u0E19",
            [
              81150
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E01\u0E25\u0E32\u0E07",
            [
              81120
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E25\u0E31\u0E19\u0E15\u0E32\u0E19\u0E49\u0E2D\u0E22",
            [
              81150
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E25\u0E31\u0E19\u0E15\u0E32\u0E43\u0E2B\u0E0D\u0E48",
            [
              81150
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E02\u0E32\u0E1E\u0E19\u0E21",
        [
          [
            "\u0E1E\u0E23\u0E38\u0E40\u0E15\u0E35\u0E22\u0E27",
            [
              81140
            ]
          ],
          [
            "\u0E2A\u0E34\u0E19\u0E1B\u0E38\u0E19",
            [
              80240
            ]
          ],
          [
            "\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E02\u0E32",
            [
              81140
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E14\u0E34\u0E19",
            [
              81140
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E1E\u0E19\u0E21",
            [
              81140
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2B\u0E32\u0E23",
            [
              80240
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E1A\u0E35\u0E48",
        [
          [
            "\u0E01\u0E23\u0E30\u0E1A\u0E35\u0E48\u0E19\u0E49\u0E2D\u0E22",
            [
              81e3
            ]
          ],
          [
            "\u0E01\u0E23\u0E30\u0E1A\u0E35\u0E48\u0E43\u0E2B\u0E0D\u0E48",
            [
              81e3
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C",
            [
              81e3
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E1B\u0E23\u0E34\u0E01",
            [
              81e3
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E19\u0E49\u0E33",
            [
              81e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E17\u0E30\u0E40\u0E25",
            [
              81180
            ]
          ],
          [
            "\u0E2D\u0E48\u0E32\u0E27\u0E19\u0E32\u0E07",
            [
              81180
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E04\u0E23\u0E32\u0E21",
            [
              81e3
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E17\u0E2D\u0E07",
            [
              81e3
            ]
          ],
          [
            "\u0E44\u0E2A\u0E44\u0E17\u0E22",
            [
              81e3
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E2B\u0E19\u0E37\u0E2D\u0E04\u0E25\u0E2D\u0E07",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E02\u0E19\u0E32\u0E19",
            [
              81130
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E40\u0E02\u0E21\u0E49\u0E32",
            [
              81130
            ]
          ],
          [
            "\u0E15\u0E25\u0E34\u0E48\u0E07\u0E0A\u0E31\u0E19",
            [
              81130
            ]
          ],
          [
            "\u0E1B\u0E01\u0E32\u0E2A\u0E31\u0E22",
            [
              81130
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E22\u0E39\u0E07",
            [
              81130
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E28\u0E23\u0E35\u0E1A\u0E2D\u0E22\u0E32",
            [
              81130
            ]
          ],
          [
            "\u0E40\u0E2B\u0E19\u0E37\u0E2D\u0E04\u0E25\u0E2D\u0E07",
            [
              81130
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E22\u0E32\u0E07",
            [
              81130
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E\u0E21\u0E2B\u0E32\u0E19\u0E04\u0E23",
    [
      [
        "\u0E04\u0E25\u0E2D\u0E07\u0E2A\u0E32\u0E19",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E15\u0E49\u0E19\u0E44\u0E17\u0E23",
            [
              10600
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2A\u0E32\u0E19",
            [
              10600
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E25\u0E33\u0E20\u0E39\u0E25\u0E48\u0E32\u0E07",
            [
              10600
            ]
          ],
          [
            "\u0E2A\u0E21\u0E40\u0E14\u0E47\u0E08\u0E40\u0E08\u0E49\u0E32\u0E1E\u0E23\u0E30\u0E22\u0E32",
            [
              10600
            ]
          ]
        ]
      ],
      [
        "\u0E04\u0E25\u0E2D\u0E07\u0E2A\u0E32\u0E21\u0E27\u0E32",
        [
          [
            "\u0E17\u0E23\u0E32\u0E22\u0E01\u0E2D\u0E07\u0E14\u0E34\u0E19",
            [
              10510
            ]
          ],
          [
            "\u0E17\u0E23\u0E32\u0E22\u0E01\u0E2D\u0E07\u0E14\u0E34\u0E19\u0E43\u0E15\u0E49",
            [
              10510
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E0A\u0E31\u0E19",
            [
              10510
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E27\u0E32\u0E15\u0E30\u0E27\u0E31\u0E19\u0E15\u0E01",
            [
              10510
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E27\u0E32\u0E15\u0E30\u0E27\u0E31\u0E19\u0E2D\u0E2D\u0E01",
            [
              10510
            ]
          ]
        ]
      ],
      [
        "\u0E04\u0E25\u0E2D\u0E07\u0E40\u0E15\u0E22",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E15\u0E31\u0E19",
            [
              10110
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E40\u0E15\u0E22",
            [
              10110
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E42\u0E02\u0E19\u0E07",
            [
              10110
            ]
          ]
        ]
      ],
      [
        "\u0E04\u0E31\u0E19\u0E19\u0E32\u0E22\u0E32\u0E27",
        [
          [
            "\u0E04\u0E31\u0E19\u0E19\u0E32\u0E22\u0E32\u0E27",
            [
              10230
            ]
          ],
          [
            "\u0E23\u0E32\u0E21\u0E2D\u0E34\u0E19\u0E17\u0E23\u0E32",
            [
              10230
            ]
          ]
        ]
      ],
      [
        "\u0E08\u0E15\u0E38\u0E08\u0E31\u0E01\u0E23",
        [
          [
            "\u0E08\u0E15\u0E38\u0E08\u0E31\u0E01\u0E23",
            [
              10900
            ]
          ],
          [
            "\u0E08\u0E2D\u0E21\u0E1E\u0E25",
            [
              10900
            ]
          ],
          [
            "\u0E08\u0E31\u0E19\u0E17\u0E23\u0E40\u0E01\u0E29\u0E21",
            [
              10900
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E22\u0E32\u0E27",
            [
              10900
            ]
          ],
          [
            "\u0E40\u0E2A\u0E19\u0E32\u0E19\u0E34\u0E04\u0E21",
            [
              10900
            ]
          ]
        ]
      ],
      [
        "\u0E08\u0E2D\u0E21\u0E17\u0E2D\u0E07",
        [
          [
            "\u0E08\u0E2D\u0E21\u0E17\u0E2D\u0E07",
            [
              10150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E02\u0E38\u0E19\u0E40\u0E17\u0E35\u0E22\u0E19",
            [
              10150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E04\u0E49\u0E2D",
            [
              10150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E21\u0E14",
            [
              10150
            ]
          ]
        ]
      ],
      [
        "\u0E14\u0E2D\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              10210
            ]
          ],
          [
            "\u0E2A\u0E19\u0E32\u0E21\u0E1A\u0E34\u0E19",
            [
              10210
            ]
          ],
          [
            "\u0E2A\u0E35\u0E01\u0E31\u0E19",
            [
              10210
            ]
          ]
        ]
      ],
      [
        "\u0E14\u0E34\u0E19\u0E41\u0E14\u0E07",
        [
          [
            "\u0E14\u0E34\u0E19\u0E41\u0E14\u0E07",
            [
              10400
            ]
          ]
        ]
      ],
      [
        "\u0E14\u0E38\u0E2A\u0E34\u0E15",
        [
          [
            "\u0E14\u0E38\u0E2A\u0E34\u0E15",
            [
              10300
            ]
          ],
          [
            "\u0E16\u0E19\u0E19\u0E19\u0E04\u0E23\u0E44\u0E0A\u0E22\u0E28\u0E23\u0E35",
            [
              10300
            ]
          ],
          [
            "\u0E27\u0E0A\u0E34\u0E23\u0E1E\u0E22\u0E32\u0E1A\u0E32\u0E25",
            [
              10300
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E08\u0E34\u0E15\u0E23\u0E25\u0E14\u0E32",
            [
              10300
            ]
          ],
          [
            "\u0E2A\u0E35\u0E48\u0E41\u0E22\u0E01\u0E21\u0E2B\u0E32\u0E19\u0E32\u0E04",
            [
              10300
            ]
          ]
        ]
      ],
      [
        "\u0E15\u0E25\u0E34\u0E48\u0E07\u0E0A\u0E31\u0E19",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E0A\u0E31\u0E01\u0E1E\u0E23\u0E30",
            [
              10170
            ]
          ],
          [
            "\u0E09\u0E34\u0E21\u0E1E\u0E25\u0E35",
            [
              10170
            ]
          ],
          [
            "\u0E15\u0E25\u0E34\u0E48\u0E07\u0E0A\u0E31\u0E19",
            [
              10170
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E23\u0E21",
            [
              10170
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E23\u0E30\u0E21\u0E32\u0E14",
            [
              10170
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E0A\u0E37\u0E2D\u0E01\u0E2B\u0E19\u0E31\u0E07",
            [
              10170
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E27\u0E35\u0E27\u0E31\u0E12\u0E19\u0E32",
        [
          [
            "\u0E17\u0E27\u0E35\u0E27\u0E31\u0E12\u0E19\u0E32",
            [
              10170
            ]
          ],
          [
            "\u0E28\u0E32\u0E25\u0E32\u0E18\u0E23\u0E23\u0E21\u0E2A\u0E1E\u0E19\u0E4C",
            [
              10170
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E38\u0E48\u0E07\u0E04\u0E23\u0E38",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E04\u0E23\u0E38",
            [
              10140
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E21\u0E14",
            [
              10140
            ]
          ]
        ]
      ],
      [
        "\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E14\u0E32\u0E27\u0E04\u0E30\u0E19\u0E2D\u0E07",
            [
              10600
            ]
          ],
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E1E\u0E25\u0E39",
            [
              10600
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E22\u0E35\u0E48\u0E40\u0E23\u0E37\u0E2D",
            [
              10600
            ]
          ],
          [
            "\u0E1A\u0E38\u0E04\u0E04\u0E42\u0E25",
            [
              10600
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E01\u0E31\u0E25\u0E22\u0E32\u0E13\u0E4C",
            [
              10600
            ]
          ],
          [
            "\u0E2A\u0E33\u0E40\u0E2B\u0E23\u0E48",
            [
              10600
            ]
          ],
          [
            "\u0E2B\u0E34\u0E23\u0E31\u0E0D\u0E23\u0E39\u0E08\u0E35",
            [
              10600
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E01\u0E2D\u0E01\u0E19\u0E49\u0E2D\u0E22",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E02\u0E38\u0E19\u0E19\u0E19\u0E17\u0E4C",
            [
              10700
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E02\u0E38\u0E19\u0E28\u0E23\u0E35",
            [
              10700
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E0A\u0E48\u0E32\u0E07\u0E2B\u0E25\u0E48\u0E2D",
            [
              10700
            ]
          ],
          [
            "\u0E28\u0E34\u0E23\u0E34\u0E23\u0E32\u0E0A",
            [
              10700
            ]
          ],
          [
            "\u0E2D\u0E23\u0E38\u0E13\u0E2D\u0E31\u0E21\u0E23\u0E34\u0E19\u0E17\u0E23\u0E4C",
            [
              10700
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E01\u0E2D\u0E01\u0E43\u0E2B\u0E0D\u0E48",
        [
          [
            "\u0E27\u0E31\u0E14\u0E17\u0E48\u0E32\u0E1E\u0E23\u0E30",
            [
              10600
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E2D\u0E23\u0E38\u0E13",
            [
              10600
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E01\u0E30\u0E1B\u0E34",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E08\u0E31\u0E48\u0E19",
            [
              10240
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E2B\u0E21\u0E32\u0E01",
            [
              10240
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E02\u0E38\u0E19\u0E40\u0E17\u0E35\u0E22\u0E19",
        [
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E49\u0E32\u0E21",
            [
              10150
            ]
          ],
          [
            "\u0E41\u0E2A\u0E21\u0E14\u0E33",
            [
              10150
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E04\u0E2D\u0E41\u0E2B\u0E25\u0E21",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E04\u0E2D\u0E41\u0E2B\u0E25\u0E21",
            [
              10120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E42\u0E04\u0E25\u0E48",
            [
              10120
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E1E\u0E23\u0E30\u0E22\u0E32\u0E44\u0E01\u0E23",
            [
              10120
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E0B\u0E37\u0E48\u0E2D",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E0B\u0E37\u0E48\u0E2D",
            [
              10800
            ]
          ],
          [
            "\u0E27\u0E07\u0E28\u0E4C\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              10800
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E19\u0E32",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E19\u0E32",
            [
              10260
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E1A\u0E2D\u0E19",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E1A\u0E2D\u0E19",
            [
              10150
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E1E\u0E25\u0E31\u0E14",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E1A\u0E33\u0E2B\u0E23\u0E38",
            [
              10700
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E25\u0E31\u0E14",
            [
              10700
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E22\u0E35\u0E48\u0E02\u0E31\u0E19",
            [
              10700
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2D\u0E49\u0E2D",
            [
              10700
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E23\u0E31\u0E01",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E23\u0E31\u0E01",
            [
              10500
            ]
          ],
          [
            "\u0E21\u0E2B\u0E32\u0E1E\u0E24\u0E12\u0E32\u0E23\u0E32\u0E21",
            [
              10500
            ]
          ],
          [
            "\u0E2A\u0E35\u0E25\u0E21",
            [
              10500
            ]
          ],
          [
            "\u0E2A\u0E35\u0E48\u0E1E\u0E23\u0E30\u0E22\u0E32",
            [
              10500
            ]
          ],
          [
            "\u0E2A\u0E38\u0E23\u0E34\u0E22\u0E27\u0E07\u0E28\u0E4C",
            [
              10500
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E40\u0E02\u0E19",
        [
          [
            "\u0E17\u0E48\u0E32\u0E41\u0E23\u0E49\u0E07",
            [
              10220
            ]
          ],
          [
            "\u0E2D\u0E19\u0E38\u0E2A\u0E32\u0E27\u0E23\u0E35\u0E22\u0E4C",
            [
              10220
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E41\u0E04",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E41\u0E04",
            [
              10160
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E41\u0E04\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              10160
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E44\u0E1C\u0E48",
            [
              10160
            ]
          ],
          [
            "\u0E2B\u0E25\u0E31\u0E01\u0E2A\u0E2D\u0E07",
            [
              10160
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E36\u0E07\u0E01\u0E38\u0E48\u0E21",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E01\u0E38\u0E48\u0E21",
            [
              10230
            ]
          ],
          [
            "\u0E19\u0E27\u0E21\u0E34\u0E19\u0E17\u0E23\u0E4C",
            [
              10230
            ]
          ],
          [
            "\u0E19\u0E27\u0E21\u0E34\u0E19\u0E17\u0E23\u0E4C",
            [
              10240
            ]
          ],
          [
            "\u0E19\u0E27\u0E25\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
            [
              10230
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E17\u0E38\u0E21\u0E27\u0E31\u0E19",
        [
          [
            "\u0E1B\u0E17\u0E38\u0E21\u0E27\u0E31\u0E19",
            [
              10330
            ]
          ],
          [
            "\u0E23\u0E2D\u0E07\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              10330
            ]
          ],
          [
            "\u0E25\u0E38\u0E21\u0E1E\u0E34\u0E19\u0E35",
            [
              10330
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E43\u0E2B\u0E21\u0E48",
            [
              10330
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E23\u0E30\u0E40\u0E27\u0E28",
        [
          [
            "\u0E14\u0E2D\u0E01\u0E44\u0E21\u0E49",
            [
              10250
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E40\u0E27\u0E28",
            [
              10250
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E2D\u0E19",
            [
              10250
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E49\u0E2D\u0E21\u0E1B\u0E23\u0E32\u0E1A\u0E28\u0E31\u0E15\u0E23\u0E39\u0E1E\u0E48\u0E32\u0E22",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E21\u0E2B\u0E32\u0E19\u0E32\u0E04",
            [
              10100
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1A\u0E32\u0E15\u0E23",
            [
              10100
            ]
          ],
          [
            "\u0E1B\u0E49\u0E2D\u0E21\u0E1B\u0E23\u0E32\u0E1A",
            [
              10100
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E40\u0E17\u0E1E\u0E28\u0E34\u0E23\u0E34\u0E19\u0E17\u0E23\u0E4C",
            [
              10100
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E42\u0E2A\u0E21\u0E19\u0E31\u0E2A",
            [
              10100
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E0D\u0E32\u0E44\u0E17",
        [
          [
            "\u0E2A\u0E32\u0E21\u0E40\u0E2A\u0E19\u0E43\u0E19",
            [
              10400
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E23\u0E30\u0E19\u0E04\u0E23",
        [
          [
            "\u0E0A\u0E19\u0E30\u0E2A\u0E07\u0E04\u0E23\u0E32\u0E21",
            [
              10200
            ]
          ],
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E22\u0E2D\u0E14",
            [
              10200
            ]
          ],
          [
            "\u0E1A\u0E27\u0E23\u0E19\u0E34\u0E40\u0E27\u0E28",
            [
              10200
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E02\u0E38\u0E19\u0E1E\u0E23\u0E2B\u0E21",
            [
              10200
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1E\u0E32\u0E19\u0E16\u0E21",
            [
              10200
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E1A\u0E23\u0E21\u0E21\u0E2B\u0E32\u0E23\u0E32\u0E0A\u0E27\u0E31\u0E07",
            [
              10200
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E1A\u0E39\u0E23\u0E1E\u0E32\u0E20\u0E34\u0E23\u0E21\u0E22\u0E4C",
            [
              10200
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E23\u0E32\u0E0A\u0E1A\u0E1E\u0E34\u0E18",
            [
              10200
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E2A\u0E32\u0E21\u0E1E\u0E23\u0E30\u0E22\u0E32",
            [
              10200
            ]
          ],
          [
            "\u0E28\u0E32\u0E25\u0E40\u0E08\u0E49\u0E32\u0E1E\u0E48\u0E2D\u0E40\u0E2A\u0E37\u0E2D",
            [
              10200
            ]
          ],
          [
            "\u0E2A\u0E33\u0E23\u0E32\u0E0D\u0E23\u0E32\u0E29\u0E0E\u0E23\u0E4C",
            [
              10200
            ]
          ],
          [
            "\u0E40\u0E2A\u0E32\u0E0A\u0E34\u0E07\u0E0A\u0E49\u0E32",
            [
              10200
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E23\u0E30\u0E42\u0E02\u0E19\u0E07",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E08\u0E32\u0E01",
            [
              10260
            ]
          ]
        ]
      ],
      [
        "\u0E20\u0E32\u0E29\u0E35\u0E40\u0E08\u0E23\u0E34\u0E0D",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E02\u0E27\u0E32\u0E07",
            [
              10160
            ]
          ],
          [
            "\u0E04\u0E39\u0E2B\u0E32\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
            [
              10160
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E08\u0E32\u0E01",
            [
              10160
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E14\u0E49\u0E27\u0E19",
            [
              10160
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2B\u0E27\u0E49\u0E32",
            [
              10160
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E41\u0E27\u0E01",
            [
              10160
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E04\u0E25\u0E2D\u0E07\u0E20\u0E32\u0E29\u0E35\u0E40\u0E08\u0E23\u0E34\u0E0D",
            [
              10160
            ]
          ]
        ]
      ],
      [
        "\u0E21\u0E35\u0E19\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E21\u0E35\u0E19\u0E1A\u0E38\u0E23\u0E35",
            [
              10510
            ]
          ],
          [
            "\u0E41\u0E2A\u0E19\u0E41\u0E2A\u0E1A",
            [
              10510
            ]
          ]
        ]
      ],
      [
        "\u0E22\u0E32\u0E19\u0E19\u0E32\u0E27\u0E32",
        [
          [
            "\u0E0A\u0E48\u0E2D\u0E07\u0E19\u0E19\u0E17\u0E23\u0E35",
            [
              10120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E42\u0E1E\u0E07\u0E1E\u0E32\u0E07",
            [
              10120
            ]
          ]
        ]
      ],
      [
        "\u0E23\u0E32\u0E0A\u0E40\u0E17\u0E27\u0E35",
        [
          [
            "\u0E16\u0E19\u0E19\u0E1E\u0E0D\u0E32\u0E44\u0E17",
            [
              10400
            ]
          ],
          [
            "\u0E16\u0E19\u0E19\u0E40\u0E1E\u0E0A\u0E23\u0E1A\u0E38\u0E23\u0E35",
            [
              10400
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E1E\u0E0D\u0E32\u0E44\u0E17",
            [
              10400
            ]
          ],
          [
            "\u0E21\u0E31\u0E01\u0E01\u0E30\u0E2A\u0E31\u0E19",
            [
              10400
            ]
          ]
        ]
      ],
      [
        "\u0E23\u0E32\u0E29\u0E0E\u0E23\u0E4C\u0E1A\u0E39\u0E23\u0E13\u0E30",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E1B\u0E30\u0E01\u0E2D\u0E01",
            [
              10140
            ]
          ],
          [
            "\u0E23\u0E32\u0E29\u0E0E\u0E23\u0E4C\u0E1A\u0E39\u0E23\u0E13\u0E30",
            [
              10140
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E32\u0E14\u0E01\u0E23\u0E30\u0E1A\u0E31\u0E07",
        [
          [
            "\u0E02\u0E38\u0E21\u0E17\u0E2D\u0E07",
            [
              10520
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2A\u0E2D\u0E07\u0E15\u0E49\u0E19\u0E19\u0E38\u0E48\u0E19",
            [
              10520
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2A\u0E32\u0E21\u0E1B\u0E23\u0E30\u0E40\u0E27\u0E28",
            [
              10520
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E22\u0E32\u0E27",
            [
              10520
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E01\u0E23\u0E30\u0E1A\u0E31\u0E07",
            [
              10520
            ]
          ],
          [
            "\u0E25\u0E33\u0E1B\u0E25\u0E32\u0E17\u0E34\u0E27",
            [
              10520
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E32\u0E14\u0E1E\u0E23\u0E49\u0E32\u0E27",
        [
          [
            "\u0E08\u0E23\u0E40\u0E02\u0E49\u0E1A\u0E31\u0E27",
            [
              10230
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E1E\u0E23\u0E49\u0E32\u0E27",
            [
              10230
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E07\u0E17\u0E2D\u0E07\u0E2B\u0E25\u0E32\u0E07",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E40\u0E08\u0E49\u0E32\u0E04\u0E38\u0E13\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
            [
              10310
            ]
          ],
          [
            "\u0E1E\u0E25\u0E31\u0E1A\u0E1E\u0E25\u0E32",
            [
              10310
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E17\u0E2D\u0E07\u0E2B\u0E25\u0E32\u0E07",
            [
              10310
            ]
          ],
          [
            "\u0E2A\u0E30\u0E1E\u0E32\u0E19\u0E2A\u0E2D\u0E07",
            [
              10310
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E12\u0E19\u0E32",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E15\u0E31\u0E19\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              10110
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E40\u0E15\u0E22\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              10110
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E42\u0E02\u0E19\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              10110
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E27\u0E19\u0E2B\u0E25\u0E27\u0E07",
        [
          [
            "\u0E2A\u0E27\u0E19\u0E2B\u0E25\u0E27\u0E07",
            [
              10250
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E30\u0E1E\u0E32\u0E19\u0E2A\u0E39\u0E07",
        [
          [
            "\u0E2A\u0E30\u0E1E\u0E32\u0E19\u0E2A\u0E39\u0E07",
            [
              10240
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E31\u0E21\u0E1E\u0E31\u0E19\u0E18\u0E27\u0E07\u0E28\u0E4C",
        [
          [
            "\u0E08\u0E31\u0E01\u0E23\u0E27\u0E23\u0E23\u0E14\u0E34\u0E4C",
            [
              10100
            ]
          ],
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E19\u0E49\u0E2D\u0E22",
            [
              10100
            ]
          ],
          [
            "\u0E2A\u0E31\u0E21\u0E1E\u0E31\u0E19\u0E18\u0E27\u0E07\u0E28\u0E4C",
            [
              10100
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E32\u0E17\u0E23",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E21\u0E2B\u0E32\u0E40\u0E21\u0E06",
            [
              10120
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E27\u0E31\u0E14\u0E14\u0E2D\u0E19",
            [
              10120
            ]
          ],
          [
            "\u0E22\u0E32\u0E19\u0E19\u0E32\u0E27\u0E32",
            [
              10120
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E32\u0E22\u0E44\u0E2B\u0E21",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E16\u0E19\u0E19",
            [
              10220
            ]
          ],
          [
            "\u0E2A\u0E32\u0E22\u0E44\u0E2B\u0E21",
            [
              10220
            ]
          ],
          [
            "\u0E2D\u0E2D\u0E40\u0E07\u0E34\u0E19",
            [
              10220
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E08\u0E2D\u0E01",
        [
          [
            "\u0E01\u0E23\u0E30\u0E17\u0E38\u0E48\u0E21\u0E23\u0E32\u0E22",
            [
              10530
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2A\u0E34\u0E1A",
            [
              10530
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2A\u0E34\u0E1A\u0E2A\u0E2D\u0E07",
            [
              10530
            ]
          ],
          [
            "\u0E04\u0E39\u0E49\u0E1D\u0E31\u0E48\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              10530
            ]
          ],
          [
            "\u0E25\u0E33\u0E15\u0E49\u0E2D\u0E22\u0E15\u0E34\u0E48\u0E07",
            [
              10530
            ]
          ],
          [
            "\u0E25\u0E33\u0E1C\u0E31\u0E01\u0E0A\u0E35",
            [
              10530
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E08\u0E2D\u0E01",
            [
              10530
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E41\u0E1D\u0E14",
            [
              10530
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E02\u0E21",
        [
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E04\u0E49\u0E32\u0E07\u0E1E\u0E25\u0E39",
            [
              10160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E02\u0E21",
            [
              10160
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E25\u0E31\u0E01\u0E2A\u0E35\u0E48",
        [
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E1A\u0E32\u0E07\u0E40\u0E02\u0E19",
            [
              10210
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2A\u0E2D\u0E07\u0E2B\u0E49\u0E2D\u0E07",
            [
              10210
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E49\u0E27\u0E22\u0E02\u0E27\u0E32\u0E07",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E30\u0E1B\u0E34",
            [
              10310
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E40\u0E2A\u0E19\u0E19\u0E2D\u0E01",
            [
              10310
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E02\u0E27\u0E32\u0E07",
            [
              10310
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E01\u0E32\u0E0D\u0E08\u0E19\u0E1A\u0E38\u0E23\u0E35",
    [
      [
        "\u0E14\u0E48\u0E32\u0E19\u0E21\u0E30\u0E02\u0E32\u0E21\u0E40\u0E15\u0E35\u0E49\u0E22",
        [
          [
            "\u0E01\u0E25\u0E2D\u0E19\u0E42\u0E14",
            [
              71260
            ]
          ],
          [
            "\u0E08\u0E23\u0E40\u0E02\u0E49\u0E40\u0E1C\u0E37\u0E2D\u0E01",
            [
              71260
            ]
          ],
          [
            "\u0E14\u0E48\u0E32\u0E19\u0E21\u0E30\u0E02\u0E32\u0E21\u0E40\u0E15\u0E35\u0E49\u0E22",
            [
              71260
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E1C\u0E48",
            [
              71260
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E2D\u0E07\u0E1C\u0E32\u0E20\u0E39\u0E21\u0E34",
        [
          [
            "\u0E0A\u0E30\u0E41\u0E25",
            [
              71180
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E19\u0E38\u0E19",
            [
              71180
            ]
          ],
          [
            "\u0E1B\u0E34\u0E25\u0E4A\u0E2D\u0E01",
            [
              71180
            ]
          ],
          [
            "\u0E25\u0E34\u0E48\u0E19\u0E16\u0E34\u0E48\u0E19",
            [
              71180
            ]
          ],
          [
            "\u0E2A\u0E2B\u0E01\u0E23\u0E13\u0E4C\u0E19\u0E34\u0E04\u0E21",
            [
              71180
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E14\u0E32\u0E14",
            [
              71180
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E40\u0E02\u0E22\u0E48\u0E07",
            [
              71180
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E48\u0E32\u0E21\u0E30\u0E01\u0E32",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E02\u0E21\u0E34\u0E49\u0E19",
            [
              71120
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E0A\u0E30\u0E40\u0E2D\u0E21",
            [
              71130
            ]
          ],
          [
            "\u0E15\u0E30\u0E04\u0E23\u0E49\u0E33\u0E40\u0E2D\u0E19",
            [
              71130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E21\u0E30\u0E01\u0E32",
            [
              71120
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E23\u0E37\u0E2D",
            [
              71130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E2A\u0E32",
            [
              71120
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E44\u0E21\u0E49",
            [
              71120
            ]
          ],
          [
            "\u0E1E\u0E07\u0E15\u0E36\u0E01",
            [
              71120
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E41\u0E17\u0E48\u0E19",
            [
              71130
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E21\u0E48\u0E27\u0E07",
            [
              71120
            ]
          ],
          [
            "\u0E2A\u0E19\u0E32\u0E21\u0E41\u0E22\u0E49",
            [
              70190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E25\u0E32\u0E19",
            [
              71130
            ]
          ],
          [
            "\u0E2B\u0E27\u0E32\u0E22\u0E40\u0E2B\u0E19\u0E35\u0E22\u0E27",
            [
              71120
            ]
          ],
          [
            "\u0E2D\u0E38\u0E42\u0E25\u0E01\u0E2A\u0E35\u0E48\u0E2B\u0E21\u0E37\u0E48\u0E19",
            [
              71130
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E2A\u0E32\u0E21\u0E2A\u0E34\u0E1A\u0E2B\u0E32\u0E1A",
            [
              71120
            ]
          ],
          [
            "\u0E41\u0E2A\u0E19\u0E15\u0E2D",
            [
              71130
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E15\u0E30\u0E1A\u0E2D\u0E07",
            [
              71120
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E48\u0E32\u0E21\u0E48\u0E27\u0E07",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E17\u0E2D\u0E07",
            [
              71110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E15\u0E30\u0E04\u0E23\u0E49\u0E2D",
            [
              71130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E21\u0E48\u0E27\u0E07",
            [
              71110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E25\u0E49\u0E2D",
            [
              71e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48",
            [
              71110
            ]
          ],
          [
            "\u0E1E\u0E31\u0E07\u0E15\u0E23\u0E38",
            [
              71110
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E0A\u0E38\u0E21",
            [
              71110
            ]
          ],
          [
            "\u0E23\u0E32\u0E07\u0E2A\u0E32\u0E25\u0E35\u0E48",
            [
              71110
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E02\u0E19\u0E32\u0E22",
            [
              71110
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E28\u0E32\u0E25\u0E32",
            [
              71110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E32\u0E27",
            [
              71110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E15\u0E32\u0E01\u0E22\u0E32",
            [
              71110
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E19\u0E49\u0E2D\u0E22",
            [
              71110
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E48\u0E2D\u0E1E\u0E25\u0E2D\u0E22",
        [
          [
            "\u0E0A\u0E48\u0E2D\u0E07\u0E14\u0E48\u0E32\u0E19",
            [
              71160
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E1E\u0E25\u0E2D\u0E22",
            [
              71160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E23\u0E48\u0E32\u0E07",
            [
              71220
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E38\u0E48\u0E21",
            [
              71160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E23\u0E35",
            [
              71220
            ]
          ],
          [
            "\u0E2B\u0E25\u0E38\u0E21\u0E23\u0E31\u0E07",
            [
              71160
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E19\u0E21\u0E17\u0E27\u0E19",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E15\u0E32\u0E40\u0E1E\u0E0A\u0E23",
            [
              71140
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E40\u0E08\u0E14\u0E35\u0E22\u0E4C",
            [
              71140
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2A\u0E21\u0E2D",
            [
              71140
            ]
          ],
          [
            "\u0E1E\u0E19\u0E21\u0E17\u0E27\u0E19",
            [
              71140
            ]
          ],
          [
            "\u0E1E\u0E31\u0E07\u0E15\u0E23\u0E38",
            [
              71140
            ]
          ],
          [
            "\u0E23\u0E32\u0E07\u0E2B\u0E27\u0E32\u0E22",
            [
              71170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E32\u0E2B\u0E23\u0E48\u0E32\u0E22",
            [
              71140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E23\u0E07",
            [
              71140
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E2A\u0E27\u0E31\u0E2A\u0E14\u0E34\u0E4C",
        [
          [
            "\u0E14\u0E48\u0E32\u0E19\u0E41\u0E21\u0E48\u0E41\u0E09\u0E25\u0E1A",
            [
              71250
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E01\u0E23\u0E30\u0E14\u0E32\u0E19",
            [
              71250
            ]
          ],
          [
            "\u0E19\u0E32\u0E2A\u0E27\u0E19",
            [
              71250
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E14",
            [
              71250
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E42\u0E08\u0E14",
            [
              71220
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E01\u0E23\u0E30\u0E1A\u0E38\u0E07",
            [
              71250
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E31\u0E07\u0E02\u0E25\u0E30\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E1B\u0E23\u0E31\u0E07\u0E40\u0E1C\u0E25",
            [
              71240
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E25\u0E39",
            [
              71240
            ]
          ],
          [
            "\u0E44\u0E25\u0E48\u0E42\u0E27\u0E48",
            [
              71240
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E23\u0E37\u0E2D",
        [
          [
            "\u0E2A\u0E21\u0E40\u0E14\u0E47\u0E08\u0E40\u0E08\u0E23\u0E34\u0E0D",
            [
              71220
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E23\u0E37\u0E2D",
            [
              71220
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E25\u0E32\u0E44\u0E2B\u0E25",
            [
              71220
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E49\u0E27\u0E22\u0E01\u0E23\u0E30\u0E40\u0E08\u0E32",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E41\u0E2A\u0E25\u0E1A",
            [
              71170
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E44\u0E1C\u0E48",
            [
              71170
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E25\u0E07\u0E40\u0E23\u0E37\u0E2D",
            [
              71170
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E01\u0E23\u0E30\u0E40\u0E08\u0E32",
            [
              71170
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E01\u0E32\u0E0D\u0E08\u0E19\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E0A\u0E48\u0E2D\u0E07\u0E2A\u0E30\u0E40\u0E14\u0E32",
            [
              71190
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E21\u0E30\u0E02\u0E32\u0E21",
            [
              71e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E01\u0E48\u0E32",
            [
              71e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              71e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E15\u0E49",
            [
              71e3
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E41\u0E1E\u0E23\u0E01",
            [
              71e3
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E2B\u0E0D\u0E49\u0E32",
            [
              71190
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E14\u0E49\u0E07",
            [
              71190
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E40\u0E22\u0E47\u0E19",
            [
              71e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              71190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E0D\u0E49\u0E32",
            [
              71e3
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E2A\u0E33\u0E42\u0E23\u0E07",
            [
              71e3
            ]
          ],
          [
            "\u0E41\u0E01\u0E48\u0E07\u0E40\u0E2A\u0E35\u0E49\u0E22\u0E19",
            [
              71e3
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E25\u0E32\u0E02\u0E27\u0E31\u0E0D",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E01\u0E23\u0E30\u0E1A\u0E48\u0E33",
            [
              71210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E19\u0E01\u0E41\u0E01\u0E49\u0E27",
            [
              71210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E23\u0E30\u0E14\u0E39\u0E48",
            [
              71210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E25\u0E34\u0E07",
            [
              71210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1D\u0E49\u0E32\u0E22",
            [
              71210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E2A\u0E19",
            [
              71210
            ]
          ],
          [
            "\u0E40\u0E25\u0E32\u0E02\u0E27\u0E31\u0E0D",
            [
              71210
            ]
          ]
        ]
      ],
      [
        "\u0E44\u0E17\u0E23\u0E42\u0E22\u0E04",
        [
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E2A\u0E32",
            [
              71150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E2D\u0E07\u0E15\u0E35\u0E49",
            [
              71150
            ]
          ],
          [
            "\u0E25\u0E38\u0E48\u0E21\u0E2A\u0E38\u0E48\u0E21",
            [
              71150
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E01\u0E23\u0E30\u0E41\u0E08\u0E30",
            [
              71150
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E21\u0E07\u0E04\u0E25",
            [
              71150
            ]
          ],
          [
            "\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
            [
              71150
            ]
          ],
          [
            "\u0E44\u0E17\u0E23\u0E42\u0E22\u0E04",
            [
              71150
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E01\u0E32\u0E2C\u0E2A\u0E34\u0E19\u0E18\u0E38\u0E4C",
    [
      [
        "\u0E01\u0E21\u0E25\u0E32\u0E44\u0E2A\u0E22",
        [
          [
            "\u0E01\u0E21\u0E25\u0E32\u0E44\u0E2A\u0E22",
            [
              46130
            ]
          ],
          [
            "\u0E14\u0E07\u0E25\u0E34\u0E07",
            [
              46130
            ]
          ],
          [
            "\u0E18\u0E31\u0E0D\u0E0D\u0E32",
            [
              46130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E1B\u0E19",
            [
              46130
            ]
          ],
          [
            "\u0E2B\u0E25\u0E31\u0E01\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              46130
            ]
          ],
          [
            "\u0E40\u0E08\u0E49\u0E32\u0E17\u0E48\u0E32",
            [
              46130
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              46130
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E07\u0E32\u0E21",
            [
              46130
            ]
          ]
        ]
      ],
      [
        "\u0E01\u0E38\u0E09\u0E34\u0E19\u0E32\u0E23\u0E32\u0E22\u0E13\u0E4C",
        [
          [
            "\u0E01\u0E38\u0E14\u0E04\u0E49\u0E32\u0E27",
            [
              46110
            ]
          ],
          [
            "\u0E01\u0E38\u0E14\u0E2B\u0E27\u0E49\u0E32",
            [
              46110
            ]
          ],
          [
            "\u0E08\u0E38\u0E21\u0E08\u0E31\u0E07",
            [
              46110
            ]
          ],
          [
            "\u0E19\u0E32\u0E02\u0E32\u0E21",
            [
              46110
            ]
          ],
          [
            "\u0E19\u0E32\u0E42\u0E01",
            [
              46110
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E02\u0E32\u0E27",
            [
              46110
            ]
          ],
          [
            "\u0E2A\u0E21\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              46110
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E02\u0E32",
            [
              46110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E49\u0E32\u0E07",
            [
              46110
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E43\u0E2B\u0E0D\u0E48",
            [
              46110
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E44\u0E2E\u0E07\u0E32\u0E21",
            [
              46110
            ]
          ],
          [
            "\u0E41\u0E08\u0E19\u0E41\u0E25\u0E19",
            [
              46110
            ]
          ]
        ]
      ],
      [
        "\u0E04\u0E33\u0E21\u0E48\u0E27\u0E07",
        [
          [
            "\u0E14\u0E34\u0E19\u0E08\u0E35\u0E48",
            [
              46180
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E04\u0E25\u0E2D\u0E07",
            [
              46180
            ]
          ],
          [
            "\u0E19\u0E32\u0E17\u0E31\u0E19",
            [
              46180
            ]
          ],
          [
            "\u0E19\u0E32\u0E1A\u0E2D\u0E19",
            [
              46180
            ]
          ],
          [
            "\u0E40\u0E19\u0E34\u0E19\u0E22\u0E32\u0E07",
            [
              46180
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19",
            [
              46180
            ]
          ]
        ]
      ],
      [
        "\u0E06\u0E49\u0E2D\u0E07\u0E0A\u0E31\u0E22",
        [
          [
            "\u0E06\u0E49\u0E2D\u0E07\u0E0A\u0E31\u0E22\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              46130
            ]
          ],
          [
            "\u0E25\u0E33\u0E0A\u0E35",
            [
              46130
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E01\u0E25\u0E32\u0E07",
            [
              46130
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              46130
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E28\u0E34\u0E25\u0E32\u0E40\u0E25\u0E34\u0E07",
            [
              46130
            ]
          ]
        ]
      ],
      [
        "\u0E14\u0E2D\u0E19\u0E08\u0E32\u0E19",
        [
          [
            "\u0E14\u0E07\u0E1E\u0E22\u0E38\u0E07",
            [
              46e3
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E08\u0E32\u0E19",
            [
              46e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E08\u0E33\u0E1B\u0E32",
            [
              46e3
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E19\u0E32",
            [
              46e3
            ]
          ],
          [
            "\u0E2A\u0E30\u0E2D\u0E32\u0E14\u0E44\u0E0A\u0E22\u0E28\u0E23\u0E35",
            [
              46e3
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E48\u0E32\u0E04\u0E31\u0E19\u0E42\u0E17",
        [
          [
            "\u0E01\u0E38\u0E07\u0E40\u0E01\u0E48\u0E32",
            [
              46190
            ]
          ],
          [
            "\u0E01\u0E38\u0E14\u0E08\u0E34\u0E01",
            [
              46190
            ]
          ],
          [
            "\u0E14\u0E07\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              46190
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E04\u0E31\u0E19\u0E42\u0E17",
            [
              46190
            ]
          ],
          [
            "\u0E19\u0E32\u0E15\u0E32\u0E25",
            [
              46190
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E2D\u0E39\u0E49\u0E21",
            [
              46190
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E04\u0E39",
        [
          [
            "\u0E19\u0E32\u0E04\u0E39",
            [
              46160
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E41\u0E01\u0E49\u0E27",
            [
              46160
            ]
          ],
          [
            "\u0E20\u0E39\u0E41\u0E25\u0E48\u0E19\u0E0A\u0E49\u0E32\u0E07",
            [
              46160
            ]
          ],
          [
            "\u0E2A\u0E32\u0E22\u0E19\u0E32\u0E27\u0E31\u0E07",
            [
              46160
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E19\u0E32\u0E08\u0E32\u0E19",
            [
              46160
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E21\u0E19",
        [
          [
            "\u0E19\u0E32\u0E21\u0E19",
            [
              46230
            ]
          ],
          [
            "\u0E22\u0E2D\u0E14\u0E41\u0E01\u0E07",
            [
              46230
            ]
          ],
          [
            "\u0E2A\u0E07\u0E40\u0E1B\u0E25\u0E37\u0E2D\u0E22",
            [
              46230
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              46230
            ]
          ],
          [
            "\u0E2B\u0E25\u0E31\u0E01\u0E40\u0E2B\u0E25\u0E35\u0E48\u0E22\u0E21",
            [
              46230
            ]
          ]
        ]
      ],
      [
        "\u0E22\u0E32\u0E07\u0E15\u0E25\u0E32\u0E14",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E02\u0E32\u0E21",
            [
              46120
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              46120
            ]
          ],
          [
            "\u0E19\u0E32\u0E14\u0E35",
            [
              46120
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E0A\u0E37\u0E2D\u0E01",
            [
              46120
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E1A\u0E32\u0E19",
            [
              46120
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E15\u0E25\u0E32\u0E14",
            [
              46120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E15\u0E2D\u0E01\u0E41\u0E1B\u0E49\u0E19",
            [
              46120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2D\u0E34\u0E40\u0E12\u0E48\u0E32",
            [
              46120
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E07\u0E31\u0E27",
            [
              46120
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E19\u0E32\u0E04\u0E33",
            [
              46120
            ]
          ],
          [
            "\u0E2D\u0E34\u0E15\u0E37\u0E49\u0E2D",
            [
              46120
            ]
          ],
          [
            "\u0E2D\u0E38\u0E48\u0E21\u0E40\u0E21\u0E48\u0E32",
            [
              46120
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E1E\u0E23\u0E30\u0E19\u0E2D\u0E19",
            [
              46120
            ]
          ],
          [
            "\u0E40\u0E27\u0E48\u0E2D",
            [
              46120
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E39\u0E07",
            [
              46120
            ]
          ]
        ]
      ],
      [
        "\u0E23\u0E48\u0E2D\u0E07\u0E04\u0E33",
        [
          [
            "\u0E23\u0E48\u0E2D\u0E07\u0E04\u0E33",
            [
              46210
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E31\u0E04\u0E04\u0E35",
            [
              46210
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E2D\u0E49\u0E2D\u0E22",
            [
              46210
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E21\u0E40\u0E14\u0E47\u0E08",
        [
          [
            "\u0E1C\u0E32\u0E40\u0E2A\u0E27\u0E22",
            [
              46150
            ]
          ],
          [
            "\u0E21\u0E2B\u0E32\u0E44\u0E0A\u0E22",
            [
              46150
            ]
          ],
          [
            "\u0E25\u0E33\u0E2B\u0E49\u0E27\u0E22\u0E2B\u0E25\u0E31\u0E27",
            [
              46150
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E21\u0E40\u0E14\u0E47\u0E08",
            [
              46150
            ]
          ],
          [
            "\u0E2A\u0E21\u0E40\u0E14\u0E47\u0E08",
            [
              46150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07",
            [
              46150
            ]
          ],
          [
            "\u0E2B\u0E21\u0E39\u0E21\u0E48\u0E19",
            [
              46150
            ]
          ],
          [
            "\u0E41\u0E0B\u0E07\u0E1A\u0E32\u0E14\u0E32\u0E25",
            [
              46150
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E2B\u0E31\u0E2A\u0E02\u0E31\u0E19\u0E18\u0E4C",
        [
          [
            "\u0E19\u0E32\u0E21\u0E30\u0E40\u0E02\u0E37\u0E2D",
            [
              46140
            ]
          ],
          [
            "\u0E19\u0E34\u0E04\u0E21",
            [
              46140
            ]
          ],
          [
            "\u0E20\u0E39\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
            [
              46140
            ]
          ],
          [
            "\u0E2A\u0E2B\u0E31\u0E2A\u0E02\u0E31\u0E19\u0E18\u0E4C",
            [
              46140
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E19\u0E49\u0E33\u0E40\u0E01\u0E25\u0E35\u0E49\u0E22\u0E07",
            [
              46140
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E1A\u0E38\u0E23\u0E35",
            [
              46140
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E28\u0E34\u0E25\u0E32",
            [
              46140
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E41\u0E2B\u0E25\u0E21\u0E17\u0E2D\u0E07",
            [
              46140
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E32\u0E21\u0E0A\u0E31\u0E22",
        [
          [
            "\u0E04\u0E33\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
            [
              46180
            ]
          ],
          [
            "\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              46180
            ]
          ],
          [
            "\u0E2A\u0E33\u0E23\u0E32\u0E0D\u0E43\u0E15\u0E49",
            [
              46180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E0A\u0E49\u0E32\u0E07",
            [
              46180
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E38\u0E07\u0E28\u0E23\u0E35",
        [
          [
            "\u0E14\u0E07\u0E21\u0E39\u0E25",
            [
              46220
            ]
          ],
          [
            "\u0E25\u0E33\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E2A\u0E19",
            [
              46220
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E38\u0E07\u0E28\u0E23\u0E35",
            [
              46220
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              46220
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E23\u0E27\u0E07",
            [
              46220
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E34\u0E19",
            [
              46220
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              46220
            ]
          ],
          [
            "\u0E40\u0E2A\u0E32\u0E40\u0E25\u0E49\u0E32",
            [
              46220
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E40\u0E04\u0E23\u0E37\u0E2D",
            [
              46220
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E49\u0E27\u0E22\u0E1C\u0E36\u0E49\u0E07",
        [
          [
            "\u0E04\u0E33\u0E1A\u0E07",
            [
              46240
            ]
          ],
          [
            "\u0E19\u0E34\u0E04\u0E21\u0E2B\u0E49\u0E27\u0E22\u0E1C\u0E36\u0E49\u0E07",
            [
              46240
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2D\u0E35\u0E1A\u0E38\u0E15\u0E23",
            [
              46240
            ]
          ],
          [
            "\u0E44\u0E04\u0E49\u0E19\u0E38\u0E48\u0E19",
            [
              46240
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E49\u0E27\u0E22\u0E40\u0E21\u0E47\u0E01",
        [
          [
            "\u0E01\u0E38\u0E14\u0E42\u0E14\u0E19",
            [
              46170
            ]
          ],
          [
            "\u0E04\u0E33\u0E40\u0E2B\u0E21\u0E37\u0E2D\u0E14\u0E41\u0E01\u0E49\u0E27",
            [
              46170
            ]
          ],
          [
            "\u0E04\u0E33\u0E43\u0E2B\u0E0D\u0E48",
            [
              46170
            ]
          ],
          [
            "\u0E17\u0E23\u0E32\u0E22\u0E17\u0E2D\u0E07",
            [
              46170
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E19\u0E32\u0E40\u0E23\u0E35\u0E22\u0E07",
            [
              46170
            ]
          ],
          [
            "\u0E1E\u0E34\u0E21\u0E39\u0E25",
            [
              46170
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E2B\u0E34\u0E19",
            [
              46170
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E40\u0E21\u0E47\u0E01",
            [
              46170
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              46170
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E02\u0E32\u0E27\u0E07",
        [
          [
            "\u0E01\u0E38\u0E14\u0E1B\u0E25\u0E32\u0E04\u0E49\u0E32\u0E27",
            [
              46160
            ]
          ],
          [
            "\u0E01\u0E38\u0E14\u0E2A\u0E34\u0E21\u0E04\u0E38\u0E49\u0E21\u0E43\u0E2B\u0E21\u0E48",
            [
              46160
            ]
          ],
          [
            "\u0E04\u0E38\u0E49\u0E21\u0E40\u0E01\u0E48\u0E32",
            [
              46160
            ]
          ],
          [
            "\u0E2A\u0E07\u0E40\u0E1B\u0E25\u0E37\u0E2D\u0E22",
            [
              46160
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E1E\u0E31\u0E07\u0E17\u0E2D\u0E07",
            [
              46160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1C\u0E37\u0E2D",
            [
              46160
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E01\u0E32\u0E2C\u0E2A\u0E34\u0E19\u0E18\u0E38\u0E4C",
        [
          [
            "\u0E01\u0E25\u0E32\u0E07\u0E2B\u0E21\u0E37\u0E48\u0E19",
            [
              46e3
            ]
          ],
          [
            "\u0E01\u0E32\u0E2C\u0E2A\u0E34\u0E19\u0E18\u0E38\u0E4C",
            [
              46e3
            ]
          ],
          [
            "\u0E02\u0E21\u0E34\u0E49\u0E19",
            [
              46e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E08\u0E32\u0E23\u0E22\u0E4C",
            [
              46e3
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E27\u0E34\u0E0A\u0E31\u0E22",
            [
              46e3
            ]
          ],
          [
            "\u0E20\u0E39\u0E14\u0E34\u0E19",
            [
              46e3
            ]
          ],
          [
            "\u0E20\u0E39\u0E1B\u0E2D",
            [
              46e3
            ]
          ],
          [
            "\u0E25\u0E33\u0E04\u0E25\u0E2D\u0E07",
            [
              46e3
            ]
          ],
          [
            "\u0E25\u0E33\u0E1B\u0E32\u0E27",
            [
              46e3
            ]
          ],
          [
            "\u0E25\u0E33\u0E1E\u0E32\u0E19",
            [
              46e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E38\u0E07",
            [
              46e3
            ]
          ],
          [
            "\u0E2B\u0E25\u0E38\u0E1A",
            [
              46e3
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              46e3
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E40\u0E04\u0E23\u0E37\u0E2D",
            [
              46e3
            ]
          ],
          [
            "\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              46e3
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E17\u0E2D\u0E07",
            [
              46e3
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48",
            [
              46e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E01\u0E33\u0E41\u0E1E\u0E07\u0E40\u0E1E\u0E0A\u0E23",
    [
      [
        "\u0E02\u0E32\u0E13\u0E38\u0E27\u0E23\u0E25\u0E31\u0E01\u0E29\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E41\u0E15\u0E07",
            [
              62140
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E16\u0E49\u0E33",
            [
              62140
            ]
          ],
          [
            "\u0E1B\u0E32\u0E07\u0E21\u0E30\u0E04\u0E48\u0E32",
            [
              62140
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E1E\u0E38\u0E17\u0E23\u0E32",
            [
              62130
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E2A\u0E39\u0E07",
            [
              62130
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E0A\u0E30\u0E1E\u0E25\u0E39",
            [
              62140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2B\u0E32\u0E21\u0E41\u0E2B",
            [
              62140
            ]
          ],
          [
            "\u0E2A\u0E25\u0E01\u0E1A\u0E32\u0E15\u0E23",
            [
              62140
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E15\u0E32\u0E25",
            [
              62130
            ]
          ],
          [
            "\u0E41\u0E2A\u0E19\u0E15\u0E2D",
            [
              62130
            ]
          ],
          [
            "\u0E42\u0E04\u0E49\u0E07\u0E44\u0E1C\u0E48",
            [
              62140
            ]
          ]
        ]
      ],
      [
        "\u0E04\u0E25\u0E2D\u0E07\u0E02\u0E25\u0E38\u0E07",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E02\u0E25\u0E38\u0E07",
            [
              62120
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              62120
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E1E\u0E38\u0E17\u0E23\u0E32",
            [
              62120
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E21\u0E30\u0E40\u0E02\u0E37\u0E2D",
            [
              62120
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E1A\u0E31\u0E27",
            [
              62120
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E22\u0E32\u0E07",
            [
              62120
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E41\u0E02\u0E21",
            [
              62120
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E44\u0E17\u0E23",
            [
              62120
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E16\u0E19\u0E19",
            [
              62120
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E25\u0E32\u0E14",
            [
              62120
            ]
          ]
        ]
      ],
      [
        "\u0E04\u0E25\u0E2D\u0E07\u0E25\u0E32\u0E19",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E19\u0E49\u0E33\u0E44\u0E2B\u0E25",
            [
              62180
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E25\u0E32\u0E19\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              62180
            ]
          ],
          [
            "\u0E2A\u0E31\u0E01\u0E07\u0E32\u0E21",
            [
              62180
            ]
          ],
          [
            "\u0E42\u0E1B\u0E48\u0E07\u0E19\u0E49\u0E33\u0E23\u0E49\u0E2D\u0E19",
            [
              62180
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E23\u0E32\u0E22\u0E17\u0E2D\u0E07\u0E27\u0E31\u0E12\u0E19\u0E32",
        [
          [
            "\u0E16\u0E32\u0E27\u0E23\u0E27\u0E31\u0E12\u0E19\u0E32",
            [
              62190
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E17\u0E23\u0E32\u0E22",
            [
              62190
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E17\u0E2D\u0E07",
            [
              62190
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E36\u0E07\u0E2A\u0E32\u0E21\u0E31\u0E04\u0E04\u0E35",
        [
          [
            "\u0E1A\u0E36\u0E07\u0E2A\u0E32\u0E21\u0E31\u0E04\u0E04\u0E35",
            [
              62210
            ]
          ],
          [
            "\u0E23\u0E30\u0E2B\u0E32\u0E19",
            [
              62210
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E0A\u0E30\u0E42\u0E2D\u0E19",
            [
              62210
            ]
          ],
          [
            "\u0E40\u0E17\u0E1E\u0E19\u0E34\u0E21\u0E34\u0E15",
            [
              62210
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E32\u0E07\u0E28\u0E34\u0E25\u0E32\u0E17\u0E2D\u0E07",
        [
          [
            "\u0E1B\u0E32\u0E07\u0E15\u0E32\u0E44\u0E27",
            [
              62120
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E14\u0E32\u0E15",
            [
              62120
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E17\u0E2D\u0E07",
            [
              62120
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E23\u0E32\u0E19\u0E01\u0E23\u0E30\u0E15\u0E48\u0E32\u0E22",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E1E\u0E34\u0E44\u0E01\u0E23",
            [
              62110
            ]
          ],
          [
            "\u0E04\u0E38\u0E22\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E2D\u0E07",
            [
              62110
            ]
          ],
          [
            "\u0E16\u0E49\u0E33\u0E01\u0E23\u0E30\u0E15\u0E48\u0E32\u0E22\u0E17\u0E2D\u0E07",
            [
              62110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E44\u0E21\u0E49",
            [
              62110
            ]
          ],
          [
            "\u0E1E\u0E23\u0E32\u0E19\u0E01\u0E23\u0E30\u0E15\u0E48\u0E32\u0E22",
            [
              62110
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E04\u0E27\u0E07",
            [
              62110
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E15\u0E30\u0E41\u0E1A\u0E01",
            [
              62110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E31\u0E27\u0E27\u0E31\u0E27",
            [
              62110
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E22\u0E31\u0E49\u0E07",
            [
              62110
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E04\u0E35\u0E23\u0E34\u0E2A",
            [
              62110
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E32\u0E19\u0E01\u0E23\u0E30\u0E1A\u0E37\u0E2D",
        [
          [
            "\u0E08\u0E31\u0E19\u0E17\u0E34\u0E21\u0E32",
            [
              62170
            ]
          ],
          [
            "\u0E0A\u0E48\u0E2D\u0E07\u0E25\u0E21",
            [
              62170
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E17\u0E31\u0E1A\u0E41\u0E23\u0E15",
            [
              62170
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E0A\u0E32\u0E2A\u0E38\u0E02\u0E2A\u0E31\u0E19\u0E15\u0E4C",
            [
              62170
            ]
          ],
          [
            "\u0E25\u0E32\u0E19\u0E01\u0E23\u0E30\u0E1A\u0E37\u0E2D",
            [
              62170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              62170
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E1E\u0E25\u0E27\u0E07",
            [
              62170
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E01\u0E33\u0E41\u0E1E\u0E07\u0E40\u0E1E\u0E0A\u0E23",
        [
          [
            "\u0E04\u0E13\u0E11\u0E35",
            [
              62e3
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E41\u0E21\u0E48\u0E25\u0E32\u0E22",
            [
              62e3
            ]
          ],
          [
            "\u0E17\u0E23\u0E07\u0E18\u0E23\u0E23\u0E21",
            [
              62e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E38\u0E19\u0E23\u0E32\u0E21",
            [
              62e3
            ]
          ],
          [
            "\u0E18\u0E33\u0E21\u0E23\u0E07\u0E04\u0E4C",
            [
              62160
            ]
          ],
          [
            "\u0E19\u0E04\u0E23\u0E0A\u0E38\u0E21",
            [
              62e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E1A\u0E48\u0E2D\u0E04\u0E33",
            [
              62e3
            ]
          ],
          [
            "\u0E19\u0E34\u0E04\u0E21\u0E17\u0E38\u0E48\u0E07\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E17\u0E30\u0E40\u0E25",
            [
              62e3
            ]
          ],
          [
            "\u0E25\u0E32\u0E19\u0E14\u0E2D\u0E01\u0E44\u0E21\u0E49",
            [
              62e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E17\u0E2D\u0E07",
            [
              62e3
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E41\u0E01\u0E49\u0E27",
            [
              62e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E25\u0E34\u0E07",
            [
              62e3
            ]
          ],
          [
            "\u0E2D\u0E48\u0E32\u0E07\u0E17\u0E2D\u0E07",
            [
              62e3
            ]
          ],
          [
            "\u0E40\u0E17\u0E1E\u0E19\u0E04\u0E23",
            [
              62e3
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              62e3
            ]
          ],
          [
            "\u0E44\u0E15\u0E23\u0E15\u0E23\u0E36\u0E07\u0E29\u0E4C",
            [
              62160
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E01\u0E2A\u0E31\u0E21\u0E1E\u0E35\u0E19\u0E04\u0E23",
        [
          [
            "\u0E25\u0E32\u0E19\u0E14\u0E2D\u0E01\u0E44\u0E21\u0E49\u0E15\u0E01",
            [
              62e3
            ]
          ],
          [
            "\u0E40\u0E1E\u0E0A\u0E23\u0E0A\u0E21\u0E20\u0E39",
            [
              62e3
            ]
          ],
          [
            "\u0E42\u0E01\u0E2A\u0E31\u0E21\u0E1E\u0E35",
            [
              62e3
            ]
          ]
        ]
      ],
      [
        "\u0E44\u0E17\u0E23\u0E07\u0E32\u0E21",
        [
          [
            "\u0E1E\u0E32\u0E19\u0E17\u0E2D\u0E07",
            [
              62150
            ]
          ],
          [
            "\u0E21\u0E2B\u0E32\u0E0A\u0E31\u0E22",
            [
              62150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E04\u0E25\u0E49\u0E32",
            [
              62150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E17\u0E2D\u0E07",
            [
              62150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E21\u0E48\u0E41\u0E15\u0E07",
            [
              62150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E21\u0E49\u0E01\u0E2D\u0E07",
            [
              62150
            ]
          ],
          [
            "\u0E44\u0E17\u0E23\u0E07\u0E32\u0E21",
            [
              62150
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E02\u0E2D\u0E19\u0E41\u0E01\u0E48\u0E19",
    [
      [
        "\u0E01\u0E23\u0E30\u0E19\u0E27\u0E19",
        [
          [
            "\u0E14\u0E39\u0E19\u0E2A\u0E32\u0E14",
            [
              40170
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E2D\u0E49\u0E2D\u0E21",
            [
              40170
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1D\u0E32\u0E07",
            [
              40170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E38\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              40170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E01",
            [
              40170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E19",
            [
              40170
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E19\u0E32\u0E04\u0E33",
            [
              40170
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E22\u0E32\u0E07",
            [
              40170
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E42\u0E08\u0E14",
            [
              40170
            ]
          ]
        ]
      ],
      [
        "\u0E0A\u0E19\u0E1A\u0E17",
        [
          [
            "\u0E01\u0E38\u0E14\u0E40\u0E1E\u0E35\u0E22\u0E02\u0E2D\u0E21",
            [
              40180
            ]
          ],
          [
            "\u0E0A\u0E19\u0E1A\u0E17",
            [
              40180
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E17\u0E48\u0E19",
            [
              40180
            ]
          ],
          [
            "\u0E1B\u0E2D\u0E41\u0E14\u0E07",
            [
              40180
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E41\u0E2A\u0E07",
            [
              40180
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E1A\u0E38\u0E0D\u0E40\u0E23\u0E37\u0E2D\u0E07",
            [
              40180
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E41\u0E01",
            [
              40180
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E1E\u0E30\u0E22\u0E2D\u0E21",
            [
              40180
            ]
          ]
        ]
      ],
      [
        "\u0E0A\u0E38\u0E21\u0E41\u0E1E",
        [
          [
            "\u0E02\u0E31\u0E27\u0E40\u0E23\u0E35\u0E22\u0E07",
            [
              40130
            ]
          ],
          [
            "\u0E0A\u0E38\u0E21\u0E41\u0E1E",
            [
              40130
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E19\u0E2D\u0E07\u0E17\u0E38\u0E48\u0E21",
            [
              40290
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E1E\u0E35\u0E22\u0E07",
            [
              40130
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2B\u0E34\u0E19\u0E25\u0E32\u0E14",
            [
              40130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E02\u0E35\u0E22\u0E14",
            [
              40290
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E2A\u0E32\u0E40\u0E25\u0E49\u0E32",
            [
              40130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E1C\u0E48",
            [
              40130
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              40290
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2B\u0E31\u0E19",
            [
              40290
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2D\u0E38\u0E14\u0E21",
            [
              40130
            ]
          ],
          [
            "\u0E44\u0E0A\u0E22\u0E2A\u0E2D",
            [
              40130
            ]
          ]
        ]
      ],
      [
        "\u0E0B\u0E33\u0E2A\u0E39\u0E07",
        [
          [
            "\u0E01\u0E23\u0E30\u0E19\u0E27\u0E19",
            [
              40170
            ]
          ],
          [
            "\u0E04\u0E33\u0E41\u0E21\u0E14",
            [
              40170
            ]
          ],
          [
            "\u0E04\u0E39\u0E04\u0E33",
            [
              40170
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E19\u0E19",
            [
              40170
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E40\u0E15\u0E22",
            [
              40170
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E49\u0E33\u0E1E\u0E2D\u0E07",
        [
          [
            "\u0E01\u0E38\u0E14\u0E19\u0E49\u0E33\u0E43\u0E2A",
            [
              40310
            ]
          ],
          [
            "\u0E17\u0E23\u0E32\u0E22\u0E21\u0E39\u0E25",
            [
              40140
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E01\u0E23\u0E30\u0E40\u0E2A\u0E23\u0E34\u0E21",
            [
              40140
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E1E\u0E2D\u0E07",
            [
              40140
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E40\u0E07\u0E34\u0E19",
            [
              40140
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E43\u0E2B\u0E0D\u0E48",
            [
              40140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E02\u0E32\u0E21",
            [
              40140
            ]
          ],
          [
            "\u0E1E\u0E31\u0E07\u0E17\u0E38\u0E22",
            [
              40140
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E2B\u0E27\u0E32\u0E19",
            [
              40310
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E0A\u0E31\u0E22",
            [
              40140
            ]
          ],
          [
            "\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              40310
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E38\u0E07",
            [
              40140
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E1D\u0E32\u0E07",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1D\u0E32\u0E07",
            [
              40270
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E2B\u0E25\u0E48\u0E32",
            [
              40270
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E21\u0E30\u0E19\u0E32\u0E27",
            [
              40270
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E2B\u0E27\u0E32\u0E22\u0E19\u0E31\u0E48\u0E07",
            [
              40270
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              40270
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E07\u0E32\u0E21",
            [
              40270
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E06\u0E49\u0E2D\u0E07",
            [
              40270
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E2E\u0E14",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E2E\u0E14",
            [
              40110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E0B\u0E07",
            [
              40110
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              40110
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              40110
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E44\u0E1C\u0E48",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E25\u0E32\u0E19",
            [
              40110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E44\u0E1C\u0E48",
            [
              40110
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E1B\u0E2D",
            [
              40110
            ]
          ],
          [
            "\u0E20\u0E39\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              40110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E19\u0E49\u0E33\u0E43\u0E2A",
            [
              40110
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E2B\u0E19\u0E2D\u0E07",
            [
              40110
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E15\u0E31\u0E49\u0E07",
            [
              40110
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E1E\u0E35\u0E22",
            [
              40110
            ]
          ],
          [
            "\u0E41\u0E04\u0E19\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              40110
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              40110
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E23\u0E30\u0E22\u0E37\u0E19",
        [
          [
            "\u0E02\u0E32\u0E21\u0E1B\u0E49\u0E2D\u0E21",
            [
              40320
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E15\u0E49\u0E19",
            [
              40320
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E1A\u0E38",
            [
              40320
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E22\u0E37\u0E19",
            [
              40320
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07",
            [
              40320
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E25",
        [
          [
            "\u0E25\u0E2D\u0E21\u0E04\u0E2D\u0E21",
            [
              40120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E21\u0E30\u0E40\u0E02\u0E37\u0E2D",
            [
              40120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07\u0E19\u0E32\u0E07\u0E40\u0E1A\u0E49\u0E32",
            [
              40120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07\u0E42\u0E2A\u0E01\u0E1E\u0E23\u0E30",
            [
              40120
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E17\u0E38\u0E48\u0E07",
            [
              40120
            ]
          ],
          [
            "\u0E40\u0E01\u0E48\u0E32\u0E07\u0E34\u0E49\u0E27",
            [
              40120
            ]
          ],
          [
            "\u0E40\u0E1E\u0E47\u0E01\u0E43\u0E2B\u0E0D\u0E48",
            [
              40120
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1E\u0E25",
            [
              40120
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E07\u0E48\u0E32",
            [
              40120
            ]
          ],
          [
            "\u0E42\u0E08\u0E14\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E01",
            [
              40120
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E02\u0E48\u0E32",
            [
              40120
            ]
          ],
          [
            "\u0E42\u0E2A\u0E01\u0E19\u0E01\u0E40\u0E15\u0E47\u0E19",
            [
              40120
            ]
          ]
        ]
      ],
      [
        "\u0E20\u0E39\u0E1C\u0E32\u0E21\u0E48\u0E32\u0E19",
        [
          [
            "\u0E19\u0E32\u0E1D\u0E32\u0E22",
            [
              40350
            ]
          ],
          [
            "\u0E20\u0E39\u0E1C\u0E32\u0E21\u0E48\u0E32\u0E19",
            [
              40350
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2A\u0E27\u0E32\u0E1A",
            [
              40350
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E21\u0E48\u0E27\u0E07",
            [
              40350
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E04\u0E2D\u0E21",
            [
              40350
            ]
          ]
        ]
      ],
      [
        "\u0E20\u0E39\u0E40\u0E27\u0E35\u0E22\u0E07",
        [
          [
            "\u0E01\u0E38\u0E14\u0E02\u0E2D\u0E19\u0E41\u0E01\u0E48\u0E19",
            [
              40150
            ]
          ],
          [
            "\u0E14\u0E34\u0E19\u0E14\u0E33",
            [
              40150
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E0A\u0E21\u0E1E\u0E39",
            [
              40150
            ]
          ],
          [
            "\u0E19\u0E32\u0E0A\u0E38\u0E21\u0E41\u0E2A\u0E07",
            [
              40150
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E27\u0E49\u0E32",
            [
              40150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E23\u0E37\u0E2D",
            [
              40150
            ]
          ],
          [
            "\u0E20\u0E39\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              40150
            ]
          ],
          [
            "\u0E2A\u0E07\u0E40\u0E1B\u0E37\u0E2D\u0E22",
            [
              40150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E38\u0E07\u0E18\u0E19\u0E2A\u0E32\u0E23",
            [
              40150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E38\u0E07\u0E40\u0E0B\u0E34\u0E19",
            [
              40150
            ]
          ],
          [
            "\u0E2B\u0E27\u0E49\u0E32\u0E17\u0E2D\u0E07",
            [
              40150
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E19\u0E49\u0E2D\u0E22",
            [
              40150
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E01\u0E48\u0E32\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              40150
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              40150
            ]
          ]
        ]
      ],
      [
        "\u0E21\u0E31\u0E0D\u0E08\u0E32\u0E04\u0E35\u0E23\u0E35",
        [
          [
            "\u0E01\u0E38\u0E14\u0E40\u0E04\u0E49\u0E32",
            [
              40160
            ]
          ],
          [
            "\u0E04\u0E33\u0E41\u0E04\u0E19",
            [
              40160
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E28\u0E32\u0E25\u0E32",
            [
              40160
            ]
          ],
          [
            "\u0E19\u0E32\u0E02\u0E48\u0E32",
            [
              40160
            ]
          ],
          [
            "\u0E19\u0E32\u0E07\u0E32\u0E21",
            [
              40160
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E2B\u0E21\u0E48\u0E2D\u0E19",
            [
              40160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E1B\u0E19",
            [
              40160
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E40\u0E1E\u0E47\u0E01",
            [
              40160
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E35\u0E0A\u0E21\u0E1E\u0E39",
        [
          [
            "\u0E0B\u0E33\u0E22\u0E32\u0E07",
            [
              40220
            ]
          ],
          [
            "\u0E14\u0E07\u0E25\u0E32\u0E19",
            [
              40220
            ]
          ],
          [
            "\u0E19\u0E32\u0E08\u0E32\u0E19",
            [
              40220
            ]
          ],
          [
            "\u0E1A\u0E23\u0E34\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              40220
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48",
            [
              40220
            ]
          ],
          [
            "\u0E20\u0E39\u0E2B\u0E48\u0E32\u0E19",
            [
              40220
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E40\u0E1E\u0E34\u0E48\u0E21",
            [
              40220
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E38\u0E02",
            [
              40220
            ]
          ],
          [
            "\u0E2A\u0E35\u0E0A\u0E21\u0E1E\u0E39",
            [
              40220
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E14\u0E07",
            [
              40220
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E19\u0E32\u0E04\u0E33",
        [
          [
            "\u0E01\u0E38\u0E14\u0E18\u0E32\u0E15\u0E38",
            [
              40150
            ]
          ],
          [
            "\u0E02\u0E19\u0E27\u0E19",
            [
              40150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E04\u0E01",
            [
              40150
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E2D\u0E07\u0E2B\u0E49\u0E2D\u0E07",
        [
          [
            "\u0E04\u0E36\u0E21\u0E0A\u0E32\u0E14",
            [
              40190
            ]
          ],
          [
            "\u0E14\u0E07\u0E40\u0E04\u0E47\u0E07",
            [
              40190
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E14\u0E31\u0E48\u0E07",
            [
              40190
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E14\u0E39\u0E48",
            [
              40190
            ]
          ],
          [
            "\u0E15\u0E30\u0E01\u0E31\u0E48\u0E27\u0E1B\u0E48\u0E32",
            [
              40190
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2B\u0E34\u0E19",
            [
              40190
            ]
          ],
          [
            "\u0E2A\u0E33\u0E42\u0E23\u0E07",
            [
              40190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E2D\u0E07\u0E2B\u0E49\u0E2D\u0E07",
            [
              40190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E21\u0E47\u0E01",
            [
              40190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E1C\u0E48\u0E25\u0E49\u0E2D\u0E21",
            [
              40190
            ]
          ],
          [
            "\u0E2B\u0E31\u0E19\u0E42\u0E08\u0E14",
            [
              40190
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E18\u0E32\u0E15\u0E38",
            [
              40190
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E23\u0E37\u0E2D",
        [
          [
            "\u0E01\u0E38\u0E14\u0E01\u0E27\u0E49\u0E32\u0E07",
            [
              40210
            ]
          ],
          [
            "\u0E08\u0E23\u0E30\u0E40\u0E02\u0E49",
            [
              40240
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E07",
            [
              40240
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1C\u0E37\u0E2D",
            [
              40240
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E21\u0E47\u0E07",
            [
              40210
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E04\u0E33",
            [
              40240
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E23\u0E37\u0E2D",
            [
              40210
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E17\u0E2D\u0E07",
            [
              40210
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E17\u0E31\u0E19",
            [
              40210
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              40210
            ]
          ]
        ]
      ],
      [
        "\u0E2D\u0E38\u0E1A\u0E25\u0E23\u0E31\u0E15\u0E19\u0E4C",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E42\u0E1B\u0E48\u0E07",
            [
              40250
            ]
          ],
          [
            "\u0E19\u0E32\u0E04\u0E33",
            [
              40250
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E14\u0E07",
            [
              40250
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E38\u0E02\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              40250
            ]
          ],
          [
            "\u0E40\u0E02\u0E37\u0E48\u0E2D\u0E19\u0E2D\u0E38\u0E1A\u0E25\u0E23\u0E31\u0E15\u0E19\u0E4C",
            [
              40250
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E39\u0E07",
            [
              40250
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E02\u0E32\u0E2A\u0E27\u0E19\u0E01\u0E27\u0E32\u0E07",
        [
          [
            "\u0E04\u0E33\u0E21\u0E48\u0E27\u0E07",
            [
              40280
            ]
          ],
          [
            "\u0E14\u0E07\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E41\u0E2D\u0E21",
            [
              40280
            ]
          ],
          [
            "\u0E19\u0E32\u0E07\u0E34\u0E49\u0E27",
            [
              40280
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E2A\u0E27\u0E19\u0E01\u0E27\u0E32\u0E07",
            [
              40280
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              40280
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E1B\u0E37\u0E2D\u0E22\u0E19\u0E49\u0E2D\u0E22",
        [
          [
            "\u0E02\u0E32\u0E21\u0E1B\u0E49\u0E2D\u0E21",
            [
              40340
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E21\u0E48\u0E27\u0E07",
            [
              40340
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E41\u0E01\u0E49\u0E27",
            [
              40340
            ]
          ],
          [
            "\u0E40\u0E1B\u0E37\u0E2D\u0E22\u0E19\u0E49\u0E2D\u0E22",
            [
              40340
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E02\u0E2D\u0E19\u0E41\u0E01\u0E48\u0E19",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E0A\u0E49\u0E32\u0E07",
            [
              4e4
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E2B\u0E31\u0E19",
            [
              40260
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E1E\u0E23\u0E30",
            [
              40260
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E40\u0E19\u0E35\u0E22\u0E21",
            [
              4e4
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E04\u0E49\u0E2D",
            [
              4e4
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E17\u0E38\u0E48\u0E21",
            [
              4e4
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E27\u0E49\u0E32",
            [
              4e4
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E1B\u0E47\u0E14",
            [
              4e4
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E25\u0E31\u0E1A",
            [
              4e4
            ]
          ],
          [
            "\u0E28\u0E34\u0E25\u0E32",
            [
              4e4
            ]
          ],
          [
            "\u0E2A\u0E32\u0E27\u0E30\u0E16\u0E35",
            [
              4e4
            ]
          ],
          [
            "\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              4e4
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E15\u0E39\u0E21",
            [
              4e4
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E01\u0E48\u0E32",
            [
              4e4
            ]
          ],
          [
            "\u0E41\u0E14\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              4e4
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E35",
            [
              4e4
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E17\u0E48\u0E2D\u0E19",
            [
              4e4
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              4e4
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E27\u0E07\u0E19\u0E49\u0E2D\u0E22",
        [
          [
            "\u0E01\u0E49\u0E32\u0E19\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E07",
            [
              40230
            ]
          ],
          [
            "\u0E17\u0E32\u0E07\u0E02\u0E27\u0E32\u0E07",
            [
              40230
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E19\u0E32\u0E07\u0E41\u0E19\u0E27",
            [
              40230
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E27\u0E31\u0E14",
            [
              40230
            ]
          ],
          [
            "\u0E25\u0E30\u0E2B\u0E32\u0E19\u0E19\u0E32",
            [
              40230
            ]
          ],
          [
            "\u0E41\u0E27\u0E07\u0E19\u0E49\u0E2D\u0E22",
            [
              40230
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E27\u0E07\u0E43\u0E2B\u0E0D\u0E48",
        [
          [
            "\u0E04\u0E2D\u0E19\u0E09\u0E34\u0E21",
            [
              40330
            ]
          ],
          [
            "\u0E41\u0E27\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              40330
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E17\u0E2D\u0E07",
            [
              40330
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              40330
            ]
          ],
          [
            "\u0E43\u0E2B\u0E21\u0E48\u0E19\u0E32\u0E40\u0E1E\u0E35\u0E22\u0E07",
            [
              40330
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E04\u0E01\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E44\u0E0A\u0E22",
        [
          [
            "\u0E0B\u0E31\u0E1A\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              40160
            ]
          ],
          [
            "\u0E19\u0E32\u0E41\u0E1E\u0E07",
            [
              40160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E04\u0E01",
            [
              40160
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E44\u0E0A\u0E22",
            [
              40160
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E19\u0E19\u0E28\u0E34\u0E25\u0E32",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E31\u0E19",
            [
              40110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E25\u0E32\u0E2B\u0E21\u0E2D",
            [
              40110
            ]
          ],
          [
            "\u0E40\u0E1B\u0E37\u0E2D\u0E22\u0E43\u0E2B\u0E0D\u0E48",
            [
              40110
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E28\u0E34\u0E25\u0E32",
            [
              40110
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E41\u0E14\u0E07",
            [
              40110
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E08\u0E31\u0E19\u0E17\u0E1A\u0E38\u0E23\u0E35",
    [
      [
        "\u0E02\u0E25\u0E38\u0E07",
        [
          [
            "\u0E02\u0E25\u0E38\u0E07",
            [
              22110
            ]
          ],
          [
            "\u0E0B\u0E36\u0E49\u0E07",
            [
              22110
            ]
          ],
          [
            "\u0E15\u0E01\u0E1E\u0E23\u0E21",
            [
              22110
            ]
          ],
          [
            "\u0E15\u0E23\u0E2D\u0E01\u0E19\u0E2D\u0E07",
            [
              22110
            ]
          ],
          [
            "\u0E15\u0E30\u0E1B\u0E2D\u0E19",
            [
              22110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E0A\u0E31\u0E19",
            [
              22110
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D",
            [
              22110
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E40\u0E27\u0E2C\u0E38",
            [
              22150
            ]
          ],
          [
            "\u0E21\u0E32\u0E1A\u0E44\u0E1E",
            [
              22110
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2A\u0E23\u0E23\u0E1E\u0E23\u0E2A",
            [
              22110
            ]
          ],
          [
            "\u0E27\u0E31\u0E19\u0E22\u0E32\u0E27",
            [
              22110
            ]
          ],
          [
            "\u0E40\u0E01\u0E27\u0E35\u0E22\u0E19\u0E2B\u0E31\u0E01",
            [
              22110
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E48\u0E32\u0E43\u0E2B\u0E21\u0E48",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E02\u0E38\u0E14",
            [
              22120
            ]
          ],
          [
            "\u0E15\u0E30\u0E01\u0E32\u0E14\u0E40\u0E07\u0E49\u0E32",
            [
              22120
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E40\u0E1A\u0E0D\u0E08\u0E32",
            [
              22170
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E43\u0E2B\u0E21\u0E48",
            [
              22120
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E1E\u0E38",
            [
              22120
            ]
          ],
          [
            "\u0E1E\u0E25\u0E2D\u0E22\u0E41\u0E2B\u0E27\u0E19",
            [
              22120
            ]
          ],
          [
            "\u0E22\u0E32\u0E22\u0E23\u0E49\u0E32",
            [
              22120
            ]
          ],
          [
            "\u0E23\u0E33\u0E1E\u0E31\u0E19",
            [
              22170
            ]
          ],
          [
            "\u0E2A\u0E2D\u0E07\u0E1E\u0E35\u0E48\u0E19\u0E49\u0E2D\u0E07",
            [
              22120
            ]
          ],
          [
            "\u0E2A\u0E35\u0E1E\u0E22\u0E32",
            [
              22120
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E1A\u0E32\u0E22\u0E28\u0E23\u0E35",
            [
              22120
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E27\u0E31\u0E27",
            [
              22120
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E41\u0E01\u0E49\u0E27",
            [
              22170
            ]
          ],
          [
            "\u0E42\u0E02\u0E21\u0E07",
            [
              22170
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E22\u0E32\u0E22\u0E2D\u0E32\u0E21",
        [
          [
            "\u0E01\u0E23\u0E30\u0E41\u0E08\u0E30",
            [
              22170
            ]
          ],
          [
            "\u0E0A\u0E49\u0E32\u0E07\u0E02\u0E49\u0E32\u0E21",
            [
              22160
            ]
          ],
          [
            "\u0E19\u0E32\u0E22\u0E32\u0E22\u0E2D\u0E32\u0E21",
            [
              22160
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E42\u0E15\u0E19\u0E14",
            [
              22170
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E43\u0E2B\u0E21\u0E48",
            [
              22170
            ]
          ],
          [
            "\u0E2A\u0E19\u0E32\u0E21\u0E44\u0E0A\u0E22",
            [
              22170
            ]
          ]
        ]
      ],
      [
        "\u0E21\u0E30\u0E02\u0E32\u0E21",
        [
          [
            "\u0E09\u0E21\u0E31\u0E19",
            [
              22150
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2B\u0E25\u0E27\u0E07",
            [
              22150
            ]
          ],
          [
            "\u0E1B\u0E31\u0E16\u0E27\u0E35",
            [
              22150
            ]
          ],
          [
            "\u0E21\u0E30\u0E02\u0E32\u0E21",
            [
              22150
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E41\u0E0B\u0E49\u0E21",
            [
              22150
            ]
          ],
          [
            "\u0E2D\u0E48\u0E32\u0E07\u0E04\u0E35\u0E23\u0E35",
            [
              22150
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E2D\u0E22\u0E14\u0E32\u0E27",
        [
          [
            "\u0E17\u0E23\u0E32\u0E22\u0E02\u0E32\u0E27",
            [
              22180
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E0A\u0E49\u0E32\u0E07",
            [
              22180
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E02\u0E19\u0E32\u0E19",
            [
              22180
            ]
          ],
          [
            "\u0E1B\u0E30\u0E15\u0E07",
            [
              22180
            ]
          ],
          [
            "\u0E2A\u0E30\u0E15\u0E2D\u0E19",
            [
              22180
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E02\u0E32\u0E04\u0E34\u0E0A\u0E0C\u0E01\u0E39\u0E0F",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E1E\u0E25\u0E39",
            [
              22210
            ]
          ],
          [
            "\u0E08\u0E31\u0E19\u0E17\u0E40\u0E02\u0E25\u0E21",
            [
              22210
            ]
          ],
          [
            "\u0E0A\u0E32\u0E01\u0E44\u0E17\u0E22",
            [
              22210
            ]
          ],
          [
            "\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19\u0E17\u0E2D\u0E07",
            [
              22210
            ]
          ],
          [
            "\u0E1E\u0E25\u0E27\u0E07",
            [
              22210
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E08\u0E31\u0E19\u0E17\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E04\u0E21\u0E1A\u0E32\u0E07",
            [
              22e3
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E19\u0E32\u0E23\u0E32\u0E22\u0E13\u0E4C",
            [
              22e3
            ]
          ],
          [
            "\u0E08\u0E31\u0E19\u0E17\u0E19\u0E34\u0E21\u0E34\u0E15",
            [
              22e3
            ]
          ],
          [
            "\u0E15\u0E25\u0E32\u0E14",
            [
              22e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E0A\u0E49\u0E32\u0E07",
            [
              22e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E30\u0E08\u0E30",
            [
              22e3
            ]
          ],
          [
            "\u0E1E\u0E25\u0E31\u0E1A\u0E1E\u0E25\u0E32",
            [
              22e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E43\u0E2B\u0E21\u0E48",
            [
              22e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              22e3
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E02\u0E27\u0E32\u0E07",
            [
              22e3
            ]
          ],
          [
            "\u0E41\u0E2A\u0E25\u0E07",
            [
              22e3
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E01\u0E48\u0E07\u0E2B\u0E32\u0E07\u0E41\u0E21\u0E27",
        [
          [
            "\u0E02\u0E38\u0E19\u0E0B\u0E48\u0E2D\u0E07",
            [
              22220
            ]
          ],
          [
            "\u0E1E\u0E27\u0E32",
            [
              22220
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E1E\u0E35\u0E48\u0E19\u0E49\u0E2D\u0E07",
            [
              22220
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E27\u0E07\u0E01\u0E15",
            [
              22220
            ]
          ],
          [
            "\u0E41\u0E01\u0E48\u0E07\u0E2B\u0E32\u0E07\u0E41\u0E21\u0E27",
            [
              22220
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E2B\u0E25\u0E21\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E19\u0E49\u0E33\u0E40\u0E04\u0E47\u0E21",
            [
              22190
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E30\u0E44\u0E0A\u0E22",
            [
              22120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2A\u0E23\u0E30\u0E40\u0E01\u0E49\u0E32",
            [
              22190
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E19\u0E49\u0E33\u0E41\u0E2B\u0E25\u0E21\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
            [
              22130
            ]
          ],
          [
            "\u0E1E\u0E25\u0E34\u0E49\u0E27",
            [
              22190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E0A\u0E34\u0E48\u0E21",
            [
              22130
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E40\u0E1B\u0E23\u0E34\u0E14",
            [
              22130
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E1B\u0E48\u0E07\u0E19\u0E49\u0E33\u0E23\u0E49\u0E2D\u0E19",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              22140
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E44\u0E17\u0E23",
            [
              22140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E15\u0E32\u0E04\u0E07",
            [
              22140
            ]
          ],
          [
            "\u0E40\u0E17\u0E1E\u0E19\u0E34\u0E21\u0E34\u0E15",
            [
              22140
            ]
          ],
          [
            "\u0E42\u0E1B\u0E48\u0E07\u0E19\u0E49\u0E33\u0E23\u0E49\u0E2D\u0E19",
            [
              22140
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E09\u0E30\u0E40\u0E0A\u0E34\u0E07\u0E40\u0E17\u0E23\u0E32",
    [
      [
        "\u0E04\u0E25\u0E2D\u0E07\u0E40\u0E02\u0E37\u0E48\u0E2D\u0E19",
        [
          [
            "\u0E01\u0E49\u0E2D\u0E19\u0E41\u0E01\u0E49\u0E27",
            [
              24e3
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E40\u0E02\u0E37\u0E48\u0E2D\u0E19",
            [
              24e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E15\u0E25\u0E32\u0E14",
            [
              24110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E25\u0E48\u0E32",
            [
              24e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E42\u0E23\u0E07",
            [
              24e3
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E48\u0E32\u0E15\u0E30\u0E40\u0E01\u0E35\u0E22\u0E1A",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E15\u0E30\u0E40\u0E01\u0E23\u0E32",
            [
              24160
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E15\u0E30\u0E40\u0E01\u0E35\u0E22\u0E1A",
            [
              24160
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E04\u0E25\u0E49\u0E32",
        [
          [
            "\u0E17\u0E48\u0E32\u0E17\u0E2D\u0E07\u0E2B\u0E25\u0E32\u0E07",
            [
              24110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E23\u0E30\u0E40\u0E08\u0E47\u0E14",
            [
              24110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E04\u0E25\u0E49\u0E32",
            [
              24110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2A\u0E27\u0E19",
            [
              24110
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E19\u0E49\u0E33",
            [
              24110
            ]
          ],
          [
            "\u0E2A\u0E32\u0E27\u0E0A\u0E30\u0E42\u0E07\u0E01",
            [
              24110
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E44\u0E17\u0E23",
            [
              24110
            ]
          ],
          [
            "\u0E40\u0E2A\u0E21\u0E47\u0E14\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              24110
            ]
          ],
          [
            "\u0E40\u0E2A\u0E21\u0E47\u0E14\u0E43\u0E15\u0E49",
            [
              24110
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E19\u0E49\u0E33\u0E40\u0E1B\u0E23\u0E35\u0E49\u0E22\u0E27",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E09\u0E34\u0E21\u0E1E\u0E25\u0E35",
            [
              24170
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E40\u0E01\u0E32\u0E30\u0E01\u0E32",
            [
              24170
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E02\u0E19\u0E32\u0E01",
            [
              24150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E19\u0E49\u0E33\u0E40\u0E1B\u0E23\u0E35\u0E49\u0E22\u0E27",
            [
              24150
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E19\u0E49\u0E33\u0E23\u0E31\u0E01\u0E29\u0E4C",
            [
              24170
            ]
          ],
          [
            "\u0E28\u0E32\u0E25\u0E32\u0E41\u0E14\u0E07",
            [
              24e3
            ]
          ],
          [
            "\u0E2A\u0E34\u0E07\u0E42\u0E15\u0E17\u0E2D\u0E07",
            [
              24150
            ]
          ],
          [
            "\u0E2B\u0E21\u0E2D\u0E19\u0E17\u0E2D\u0E07",
            [
              24150
            ]
          ],
          [
            "\u0E42\u0E1E\u0E23\u0E07\u0E2D\u0E32\u0E01\u0E32\u0E28",
            [
              24150
            ]
          ],
          [
            "\u0E42\u0E22\u0E18\u0E30\u0E01\u0E32",
            [
              24150
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E1B\u0E30\u0E01\u0E07",
        [
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E49\u0E32\u0E21",
            [
              24130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2A\u0E30\u0E2D\u0E49\u0E32\u0E19",
            [
              24130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1B\u0E30\u0E01\u0E07",
            [
              24130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1C\u0E36\u0E49\u0E07",
            [
              24130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E27\u0E31\u0E27",
            [
              24180
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2A\u0E21\u0E31\u0E04\u0E23",
            [
              24180
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E01\u0E25\u0E37\u0E2D",
            [
              24180
            ]
          ],
          [
            "\u0E1E\u0E34\u0E21\u0E1E\u0E32",
            [
              24180
            ]
          ],
          [
            "\u0E2A\u0E2D\u0E07\u0E04\u0E25\u0E2D\u0E07",
            [
              24130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E08\u0E2D\u0E01",
            [
              24130
            ]
          ],
          [
            "\u0E2B\u0E2D\u0E21\u0E28\u0E35\u0E25",
            [
              24180
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E14\u0E34\u0E19",
            [
              24130
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E1E\u0E18\u0E34\u0E4C",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E02\u0E38\u0E14",
            [
              24140
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              24140
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E1B\u0E23\u0E30\u0E40\u0E27\u0E28",
            [
              24140
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E17\u0E23\u0E32\u0E22",
            [
              24140
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E1E\u0E25\u0E31\u0E1A",
            [
              24140
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E23\u0E39\u0E14",
            [
              24140
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E0B\u0E48\u0E2D\u0E19",
            [
              24140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              24140
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E02\u0E27\u0E32\u0E07",
            [
              24140
            ]
          ],
          [
            "\u0E2A\u0E19\u0E32\u0E21\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
            [
              24140
            ]
          ],
          [
            "\u0E2A\u0E34\u0E1A\u0E40\u0E2D\u0E47\u0E14\u0E28\u0E2D\u0E01",
            [
              24140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E15\u0E35\u0E19\u0E19\u0E01",
            [
              24140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              24140
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E44\u0E23\u0E48",
            [
              24140
            ]
          ],
          [
            "\u0E40\u0E17\u0E1E\u0E23\u0E32\u0E0A",
            [
              24140
            ]
          ],
          [
            "\u0E41\u0E2A\u0E19\u0E20\u0E39\u0E14\u0E32\u0E29",
            [
              24140
            ]
          ],
          [
            "\u0E41\u0E2B\u0E25\u0E21\u0E1B\u0E23\u0E30\u0E14\u0E39\u0E48",
            [
              24140
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E19\u0E21\u0E2A\u0E32\u0E23\u0E04\u0E32\u0E21",
        [
          [
            "\u0E17\u0E48\u0E32\u0E16\u0E48\u0E32\u0E19",
            [
              24120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E0B\u0E48\u0E2D\u0E07",
            [
              24120
            ]
          ],
          [
            "\u0E1E\u0E19\u0E21\u0E2A\u0E32\u0E23\u0E04\u0E32\u0E21",
            [
              24120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E22\u0E32\u0E27",
            [
              24120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E2B\u0E19",
            [
              24120
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E02\u0E19\u0E38\u0E19",
            [
              24120
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E2B\u0E34\u0E19\u0E0B\u0E49\u0E2D\u0E19",
            [
              24120
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E01\u0E48\u0E32",
            [
              24120
            ]
          ]
        ]
      ],
      [
        "\u0E23\u0E32\u0E0A\u0E2A\u0E32\u0E2A\u0E4C\u0E19",
        [
          [
            "\u0E14\u0E07\u0E19\u0E49\u0E2D\u0E22",
            [
              24120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E04\u0E32",
            [
              24120
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48",
            [
              24120
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E19\u0E32\u0E21\u0E0A\u0E31\u0E22\u0E40\u0E02\u0E15",
        [
          [
            "\u0E04\u0E39\u0E49\u0E22\u0E32\u0E22\u0E2B\u0E21\u0E35",
            [
              24160
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E1E\u0E23\u0E30\u0E22\u0E32",
            [
              24160
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E01\u0E23\u0E30\u0E14\u0E32\u0E19",
            [
              24160
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E01\u0E23\u0E30\u0E17\u0E34\u0E07",
            [
              24160
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E09\u0E30\u0E40\u0E0A\u0E34\u0E07\u0E40\u0E17\u0E23\u0E32",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E08\u0E38\u0E01\u0E01\u0E23\u0E30\u0E40\u0E0C\u0E2D",
            [
              24e3
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E19\u0E04\u0E23\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E40\u0E02\u0E15",
            [
              24e3
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E19\u0E32",
            [
              24e3
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2B\u0E25\u0E27\u0E07\u0E41\u0E1E\u0E48\u0E07",
            [
              24e3
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2D\u0E38\u0E14\u0E21\u0E0A\u0E25\u0E08\u0E23",
            [
              24e3
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E40\u0E1B\u0E23\u0E07",
            [
              24e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E44\u0E02\u0E48",
            [
              24e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E30\u0E44\u0E2B",
            [
              24e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E02\u0E27\u0E31\u0E0D",
            [
              24e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E15\u0E35\u0E19\u0E40\u0E1B\u0E47\u0E14",
            [
              24e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E23\u0E30",
            [
              24e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E15\u0E22",
            [
              24e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              24e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E44\u0E1C\u0E48",
            [
              24e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48",
            [
              24e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              24e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E32\u0E21\u0E41\u0E14\u0E07",
            [
              24e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              24e3
            ]
          ],
          [
            "\u0E42\u0E2A\u0E18\u0E23",
            [
              24e3
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E1B\u0E25\u0E07\u0E22\u0E32\u0E27",
        [
          [
            "\u0E27\u0E31\u0E07\u0E40\u0E22\u0E47\u0E19",
            [
              24190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E21\u0E49\u0E41\u0E01\u0E48\u0E19",
            [
              24190
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E2A\u0E33\u0E42\u0E23\u0E07",
            [
              24190
            ]
          ],
          [
            "\u0E41\u0E1B\u0E25\u0E07\u0E22\u0E32\u0E27",
            [
              24190
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E0A\u0E25\u0E1A\u0E38\u0E23\u0E35",
    [
      [
        "\u0E1A\u0E32\u0E07\u0E25\u0E30\u0E21\u0E38\u0E07",
        [
          [
            "\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19\u0E40\u0E15\u0E35\u0E49\u0E22",
            [
              20150
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E01\u0E25\u0E37\u0E2D",
            [
              20150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E25\u0E30\u0E21\u0E38\u0E07",
            [
              20150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E23\u0E37\u0E2D",
            [
              20150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E25\u0E32\u0E44\u0E2B\u0E25",
            [
              20150
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E43\u0E2B\u0E0D\u0E48",
            [
              20150
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E44\u0E21\u0E49\u0E41\u0E01\u0E49\u0E27",
            [
              20150
            ]
          ],
          [
            "\u0E42\u0E1B\u0E48\u0E07",
            [
              20150
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E48\u0E2D\u0E17\u0E2D\u0E07",
        [
          [
            "\u0E18\u0E32\u0E15\u0E38\u0E17\u0E2D\u0E07",
            [
              20270
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E01\u0E27\u0E32\u0E07\u0E17\u0E2D\u0E07",
            [
              20270
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E17\u0E2D\u0E07",
            [
              20270
            ]
          ],
          [
            "\u0E1E\u0E25\u0E27\u0E07\u0E17\u0E2D\u0E07",
            [
              20270
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E2A\u0E38\u0E27\u0E23\u0E23\u0E13",
            [
              20270
            ]
          ],
          [
            "\u0E40\u0E01\u0E29\u0E15\u0E23\u0E2A\u0E38\u0E27\u0E23\u0E23\u0E13",
            [
              20270
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E1A\u0E36\u0E07",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E01\u0E34\u0E48\u0E27",
            [
              20220
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1A\u0E36\u0E07",
            [
              20170
            ]
          ],
          [
            "\u0E21\u0E32\u0E1A\u0E44\u0E1C\u0E48",
            [
              20170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E0A\u0E32\u0E01",
            [
              20170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E0B\u0E49\u0E33\u0E0B\u0E32\u0E01",
            [
              20170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E2D\u0E19\u0E41\u0E14\u0E07",
            [
              20170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2D\u0E34\u0E23\u0E38\u0E13",
            [
              20220
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E1C\u0E48\u0E41\u0E01\u0E49\u0E27",
            [
              20220
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E19\u0E31\u0E2A\u0E19\u0E34\u0E04\u0E21",
        [
          [
            "\u0E01\u0E38\u0E0E\u0E42\u0E07\u0E49\u0E07",
            [
              20140
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E02\u0E27\u0E32\u0E07",
            [
              20140
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E49\u0E32\u0E21",
            [
              20140
            ]
          ],
          [
            "\u0E19\u0E32\u0E21\u0E30\u0E15\u0E39\u0E21",
            [
              20140
            ]
          ],
          [
            "\u0E19\u0E32\u0E27\u0E31\u0E07\u0E2B\u0E34\u0E19",
            [
              20140
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E23\u0E34\u0E01",
            [
              20140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E0A\u0E49\u0E32\u0E07",
            [
              20140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E0B\u0E34\u0E14",
            [
              20140
            ]
          ],
          [
            "\u0E1E\u0E19\u0E31\u0E2A\u0E19\u0E34\u0E04\u0E21",
            [
              20140
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E2B\u0E25\u0E27\u0E07",
            [
              20140
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E42\u0E1A\u0E2A\u0E16\u0E4C",
            [
              20140
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E2A\u0E35\u0E48\u0E40\u0E2B\u0E25\u0E35\u0E48\u0E22\u0E21",
            [
              20140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E22\u0E32\u0E14",
            [
              20140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E23\u0E37\u0E2D",
            [
              20140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E2B\u0E35\u0E22\u0E07",
            [
              20140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E23\u0E30\u0E18\u0E32\u0E15\u0E38",
            [
              20140
            ]
          ],
          [
            "\u0E2B\u0E21\u0E2D\u0E19\u0E19\u0E32\u0E07",
            [
              20140
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E16\u0E19\u0E19",
            [
              20140
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E40\u0E1E\u0E25\u0E32\u0E30",
            [
              20140
            ]
          ],
          [
            "\u0E44\u0E23\u0E48\u0E2B\u0E25\u0E31\u0E01\u0E17\u0E2D\u0E07",
            [
              20140
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E32\u0E19\u0E17\u0E2D\u0E07",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E19\u0E32\u0E07",
            [
              20160
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2B\u0E31\u0E01",
            [
              20160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E01\u0E48\u0E32",
            [
              20160
            ]
          ],
          [
            "\u0E1E\u0E32\u0E19\u0E17\u0E2D\u0E07",
            [
              20160
            ]
          ],
          [
            "\u0E21\u0E32\u0E1A\u0E42\u0E1B\u0E48\u0E07",
            [
              20160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E30\u0E02\u0E30",
            [
              20160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E15\u0E33\u0E25\u0E36\u0E07",
            [
              20160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E07\u0E29\u0E4C",
            [
              20160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E49\u0E32\u0E1B\u0E23\u0E30\u0E14\u0E39\u0E48",
            [
              20160
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E25\u0E2D\u0E22",
            [
              20160
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E02\u0E35\u0E49\u0E2B\u0E19\u0E2D\u0E19",
            [
              20160
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E23\u0E32\u0E0A\u0E32",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2A\u0E38\u0E02\u0E25\u0E32",
            [
              20230
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E23\u0E30",
            [
              20110
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07",
            [
              20230
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E27\u0E34\u0E19",
            [
              20230
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E23\u0E32\u0E0A\u0E32",
            [
              20110
            ]
          ],
          [
            "\u0E2A\u0E38\u0E23\u0E28\u0E31\u0E01\u0E14\u0E34\u0E4C",
            [
              20110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E32\u0E21",
            [
              20230
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E04\u0E31\u0E19\u0E17\u0E23\u0E07",
            [
              20110
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E31\u0E15\u0E2B\u0E35\u0E1A",
        [
          [
            "\u0E19\u0E32\u0E08\u0E2D\u0E21\u0E40\u0E17\u0E35\u0E22\u0E19",
            [
              20250
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E2A\u0E23\u0E48",
            [
              20250
            ]
          ],
          [
            "\u0E1E\u0E25\u0E39\u0E15\u0E32\u0E2B\u0E25\u0E27\u0E07",
            [
              20180
            ]
          ],
          [
            "\u0E2A\u0E31\u0E15\u0E2B\u0E35\u0E1A",
            [
              20180
            ]
          ],
          [
            "\u0E41\u0E2A\u0E21\u0E2A\u0E32\u0E23",
            [
              20180
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E43\u0E2B\u0E0D\u0E48",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E1E\u0E25\u0E39",
            [
              20190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E2A\u0E37\u0E2D\u0E0A\u0E49\u0E32\u0E07",
            [
              20190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              20190
            ]
          ],
          [
            "\u0E2B\u0E49\u0E32\u0E07\u0E2A\u0E39\u0E07",
            [
              20190
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E0B\u0E01",
            [
              20190
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E01\u0E32\u0E30\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
        [
          [
            "\u0E17\u0E48\u0E32\u0E1A\u0E38\u0E0D\u0E21\u0E35",
            [
              20240
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
            [
              20240
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E01\u0E32\u0E30\u0E2A\u0E35\u0E0A\u0E31\u0E07",
        [
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E17\u0E27\u0E27\u0E07\u0E29\u0E4C",
            [
              20120
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E0A\u0E25\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E15\u0E33\u0E2B\u0E23\u0E38",
            [
              2e4
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E2B\u0E31\u0E27\u0E2C\u0E48\u0E2D",
            [
              2e4
            ]
          ],
          [
            "\u0E19\u0E32\u0E1B\u0E48\u0E32",
            [
              2e4
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E17\u0E23\u0E32\u0E22",
            [
              2e4
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1B\u0E25\u0E32\u0E2A\u0E23\u0E49\u0E2D\u0E22",
            [
              2e4
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1B\u0E36\u0E01",
            [
              20130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2A\u0E27\u0E19",
            [
              2e4
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E02\u0E14",
            [
              2e4
            ]
          ],
          [
            "\u0E21\u0E30\u0E02\u0E32\u0E21\u0E2B\u0E22\u0E48\u0E07",
            [
              2e4
            ]
          ],
          [
            "\u0E2A\u0E33\u0E19\u0E31\u0E01\u0E1A\u0E01",
            [
              2e4
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E49\u0E32\u0E07\u0E04\u0E2D\u0E01",
            [
              2e4
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E23\u0E35",
            [
              2e4
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E21\u0E49\u0E41\u0E14\u0E07",
            [
              2e4
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E01\u0E30\u0E1B\u0E34",
            [
              2e4
            ]
          ],
          [
            "\u0E2D\u0E48\u0E32\u0E07\u0E28\u0E34\u0E25\u0E32",
            [
              2e4
            ]
          ],
          [
            "\u0E40\u0E2A\u0E21\u0E47\u0E14",
            [
              2e4
            ]
          ],
          [
            "\u0E40\u0E2B\u0E21\u0E37\u0E2D\u0E07",
            [
              20130
            ]
          ],
          [
            "\u0E41\u0E2A\u0E19\u0E2A\u0E38\u0E02",
            [
              20130
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E0A\u0E31\u0E22\u0E19\u0E32\u0E17",
    [
      [
        "\u0E21\u0E42\u0E19\u0E23\u0E21\u0E22\u0E4C",
        [
          [
            "\u0E04\u0E38\u0E49\u0E07\u0E2A\u0E33\u0E40\u0E20\u0E32",
            [
              17110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E09\u0E19\u0E27\u0E19",
            [
              17110
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E42\u0E04\u0E01",
            [
              17110
            ]
          ],
          [
            "\u0E28\u0E34\u0E25\u0E32\u0E14\u0E32\u0E19",
            [
              17110
            ]
          ],
          [
            "\u0E2B\u0E32\u0E07\u0E19\u0E49\u0E33\u0E2A\u0E32\u0E04\u0E23",
            [
              17170
            ]
          ],
          [
            "\u0E2D\u0E39\u0E48\u0E15\u0E30\u0E40\u0E20\u0E32",
            [
              17170
            ]
          ],
          [
            "\u0E44\u0E23\u0E48\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              17170
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E14\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
        [
          [
            "\u0E1A\u0E48\u0E2D\u0E41\u0E23\u0E48",
            [
              17120
            ]
          ],
          [
            "\u0E21\u0E30\u0E02\u0E32\u0E21\u0E40\u0E12\u0E48\u0E32",
            [
              17120
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2B\u0E21\u0E31\u0E19",
            [
              17120
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
            [
              17120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E38\u0E48\u0E19",
            [
              17120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E19\u0E49\u0E2D\u0E22",
            [
              17120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              17120
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E23\u0E23\u0E04\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E14\u0E07\u0E04\u0E2D\u0E19",
            [
              17140
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E01\u0E33",
            [
              17140
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E02\u0E38\u0E14",
            [
              17140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E01\u0E23\u0E14",
            [
              17140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E01\u0E23\u0E14\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              17140
            ]
          ],
          [
            "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E41\u0E17\u0E49",
            [
              17140
            ]
          ],
          [
            "\u0E41\u0E1E\u0E23\u0E01\u0E28\u0E23\u0E35\u0E23\u0E32\u0E0A\u0E32",
            [
              17140
            ]
          ],
          [
            "\u0E42\u0E1E\u0E07\u0E32\u0E21",
            [
              17140
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E23\u0E23\u0E1E\u0E22\u0E32",
        [
          [
            "\u0E15\u0E25\u0E38\u0E01",
            [
              17150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              17150
            ]
          ],
          [
            "\u0E2A\u0E23\u0E23\u0E1E\u0E22\u0E32",
            [
              17150
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E2D\u0E32\u0E29\u0E32",
            [
              17150
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E41\u0E01\u0E49\u0E27",
            [
              17150
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E32\u0E07\u0E14\u0E33\u0E15\u0E01",
            [
              17150
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E32\u0E07\u0E14\u0E33\u0E2D\u0E2D\u0E01",
            [
              17150
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E21\u0E30\u0E42\u0E21\u0E07",
        [
          [
            "\u0E01\u0E38\u0E14\u0E08\u0E2D\u0E01",
            [
              17120
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              17120
            ]
          ],
          [
            "\u0E2A\u0E30\u0E1E\u0E32\u0E19\u0E2B\u0E34\u0E19",
            [
              17120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E21\u0E30\u0E42\u0E21\u0E07",
            [
              17120
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E31\u0E19\u0E04\u0E32",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E0A\u0E35\u0E48\u0E22\u0E19",
            [
              17130
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E44\u0E01\u0E48\u0E40\u0E16\u0E37\u0E48\u0E2D\u0E19",
            [
              17130
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E07\u0E48\u0E32\u0E21\u0E17\u0E48\u0E32\u0E42\u0E1A\u0E2A\u0E16\u0E4C",
            [
              17160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E0B\u0E07",
            [
              17160
            ]
          ],
          [
            "\u0E2B\u0E31\u0E19\u0E04\u0E32",
            [
              17130
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E07\u0E39",
            [
              17160
            ]
          ],
          [
            "\u0E40\u0E14\u0E48\u0E19\u0E43\u0E2B\u0E0D\u0E48",
            [
              17130
            ]
          ],
          [
            "\u0E44\u0E1E\u0E23\u0E19\u0E01\u0E22\u0E39\u0E07",
            [
              17130
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E19\u0E34\u0E19\u0E02\u0E32\u0E21",
        [
          [
            "\u0E01\u0E30\u0E1A\u0E01\u0E40\u0E15\u0E35\u0E49\u0E22",
            [
              17130
            ]
          ],
          [
            "\u0E2A\u0E38\u0E02\u0E40\u0E14\u0E37\u0E2D\u0E19\u0E2B\u0E49\u0E32",
            [
              17130
            ]
          ],
          [
            "\u0E40\u0E19\u0E34\u0E19\u0E02\u0E32\u0E21",
            [
              17130
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E0A\u0E31\u0E22\u0E19\u0E32\u0E17",
        [
          [
            "\u0E0A\u0E31\u0E22\u0E19\u0E32\u0E17",
            [
              17e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E0A\u0E31\u0E22",
            [
              17e3
            ]
          ],
          [
            "\u0E18\u0E23\u0E23\u0E21\u0E32\u0E21\u0E39\u0E25",
            [
              17e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E07\u0E25\u0E37\u0E2D",
            [
              17e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E25\u0E49\u0E27\u0E22",
            [
              17e3
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E17\u0E48\u0E32\u0E40\u0E2A\u0E32",
            [
              17120
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E17\u0E48\u0E32\u0E1E\u0E23\u0E30",
            [
              17e3
            ]
          ],
          [
            "\u0E40\u0E2A\u0E37\u0E2D\u0E42\u0E2E\u0E01",
            [
              17e3
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              17e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E0A\u0E31\u0E22\u0E20\u0E39\u0E21\u0E34",
    [
      [
        "\u0E04\u0E2D\u0E19\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
        [
          [
            "\u0E04\u0E2D\u0E19\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
            [
              36140
            ]
          ],
          [
            "\u0E0A\u0E48\u0E2D\u0E07\u0E2A\u0E32\u0E21\u0E2B\u0E21\u0E2D",
            [
              36140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E2A\u0E01",
            [
              36140
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E2B\u0E27\u0E32\u0E22",
            [
              36140
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              36140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E32\u0E21",
            [
              36140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E44\u0E23\u0E48",
            [
              36140
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E21\u0E31\u0E48\u0E07\u0E07\u0E2D\u0E22",
            [
              36140
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              36140
            ]
          ]
        ]
      ],
      [
        "\u0E04\u0E2D\u0E19\u0E2A\u0E32\u0E23",
        [
          [
            "\u0E04\u0E2D\u0E19\u0E2A\u0E32\u0E23",
            [
              36180
            ]
          ],
          [
            "\u0E14\u0E07\u0E01\u0E25\u0E32\u0E07",
            [
              36180
            ]
          ],
          [
            "\u0E14\u0E07\u0E1A\u0E31\u0E07",
            [
              36180
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E19\u0E32\u0E40\u0E25\u0E32",
            [
              36180
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E1E\u0E23\u0E30",
            [
              36180
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E25\u0E38\u0E22\u0E25\u0E32\u0E22",
            [
              36180
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E22\u0E32\u0E07",
            [
              36180
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E04\u0E39\u0E13",
            [
              36180
            ]
          ]
        ]
      ],
      [
        "\u0E08\u0E31\u0E15\u0E38\u0E23\u0E31\u0E2A",
        [
          [
            "\u0E01\u0E38\u0E14\u0E19\u0E49\u0E33\u0E43\u0E2A",
            [
              36130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E2D\u0E01",
            [
              36130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E02\u0E32\u0E21",
            [
              36130
            ]
          ],
          [
            "\u0E25\u0E30\u0E2B\u0E32\u0E19",
            [
              36130
            ]
          ],
          [
            "\u0E2A\u0E49\u0E21\u0E1B\u0E48\u0E2D\u0E22",
            [
              36130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E1A\u0E32\u0E19",
            [
              36130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E42\u0E04\u0E01",
            [
              36220
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E43\u0E2B\u0E0D\u0E48",
            [
              36130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E14\u0E19",
            [
              36130
            ]
          ]
        ]
      ],
      [
        "\u0E0B\u0E31\u0E1A\u0E43\u0E2B\u0E0D\u0E48",
        [
          [
            "\u0E0B\u0E31\u0E1A\u0E43\u0E2B\u0E0D\u0E48",
            [
              36130
            ]
          ],
          [
            "\u0E15\u0E30\u0E42\u0E01\u0E17\u0E2D\u0E07",
            [
              36130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E01\u0E39\u0E1A",
            [
              36130
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E33\u0E40\u0E2B\u0E19\u0E47\u0E08\u0E13\u0E23\u0E07\u0E04\u0E4C",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E0A\u0E27\u0E19",
            [
              36160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E15\u0E32\u0E25",
            [
              36220
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E1E\u0E0A\u0E23",
            [
              36160
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E17\u0E30\u0E40\u0E25",
            [
              36220
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E21\u0E30\u0E19\u0E32\u0E27",
            [
              36160
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E40\u0E1E\u0E0A\u0E23\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              36160
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E40\u0E23\u0E34\u0E07\u0E23\u0E21\u0E22\u0E4C",
            [
              36160
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E02\u0E27\u0E49\u0E32",
        [
          [
            "\u0E0A\u0E35\u0E1A\u0E19",
            [
              36170
            ]
          ],
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E41\u0E23\u0E49\u0E07",
            [
              36170
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E02\u0E27\u0E49\u0E32",
            [
              36170
            ]
          ],
          [
            "\u0E20\u0E39\u0E41\u0E25\u0E19\u0E04\u0E32",
            [
              36170
            ]
          ],
          [
            "\u0E25\u0E38\u0E48\u0E21\u0E25\u0E33\u0E0A\u0E35",
            [
              36170
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E41\u0E14\u0E07",
            [
              36170
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E17\u0E48\u0E19",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E15\u0E48\u0E32",
            [
              36190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E17\u0E48\u0E19",
            [
              36190
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E1E\u0E31\u0E07",
            [
              36190
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E2A\u0E27\u0E19",
            [
              36190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E04\u0E39",
            [
              36190
            ]
          ]
        ]
      ],
      [
        "\u0E20\u0E31\u0E01\u0E14\u0E35\u0E0A\u0E38\u0E21\u0E1E\u0E25",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E08\u0E35\u0E22\u0E07",
            [
              36260
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E17\u0E2D\u0E07",
            [
              36260
            ]
          ],
          [
            "\u0E40\u0E08\u0E32\u0E17\u0E2D\u0E07",
            [
              36260
            ]
          ],
          [
            "\u0E41\u0E2B\u0E25\u0E21\u0E17\u0E2D\u0E07",
            [
              36260
            ]
          ]
        ]
      ],
      [
        "\u0E20\u0E39\u0E40\u0E02\u0E35\u0E22\u0E27",
        [
          [
            "\u0E01\u0E27\u0E32\u0E07\u0E42\u0E08\u0E19",
            [
              36110
            ]
          ],
          [
            "\u0E01\u0E38\u0E14\u0E22\u0E21",
            [
              36110
            ]
          ],
          [
            "\u0E18\u0E32\u0E15\u0E38\u0E17\u0E2D\u0E07",
            [
              36110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E14\u0E2D\u0E19",
            [
              36110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E1E\u0E0A\u0E23",
            [
              36110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E01\u0E49\u0E07",
            [
              36110
            ]
          ],
          [
            "\u0E1C\u0E31\u0E01\u0E1B\u0E31\u0E07",
            [
              36110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E04\u0E2D\u0E19\u0E44\u0E17\u0E22",
            [
              36110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E15\u0E39\u0E21",
            [
              36110
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              36110
            ]
          ],
          [
            "\u0E42\u0E2D\u0E42\u0E25",
            [
              36110
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E23\u0E30\u0E40\u0E2B\u0E27",
        [
          [
            "\u0E27\u0E31\u0E07\u0E15\u0E30\u0E40\u0E06\u0E48",
            [
              36250
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E23\u0E30\u0E40\u0E2B\u0E27",
            [
              36250
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E41\u0E22\u0E49",
            [
              36250
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              36250
            ]
          ],
          [
            "\u0E42\u0E2A\u0E01\u0E1B\u0E25\u0E32\u0E14\u0E38\u0E01",
            [
              36250
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E41\u0E14\u0E07",
        [
          [
            "\u0E01\u0E38\u0E14\u0E0A\u0E38\u0E21\u0E41\u0E2A\u0E07",
            [
              36210
            ]
          ],
          [
            "\u0E04\u0E39\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              36210
            ]
          ],
          [
            "\u0E16\u0E49\u0E33\u0E27\u0E31\u0E27\u0E41\u0E14\u0E07",
            [
              36210
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E43\u0E2B\u0E0D\u0E48",
            [
              36210
            ]
          ],
          [
            "\u0E19\u0E32\u0E07\u0E41\u0E14\u0E14",
            [
              36210
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E0A\u0E21\u0E20\u0E39",
            [
              36210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E41\u0E14\u0E07",
            [
              36210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07",
            [
              36210
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E01\u0E29\u0E15\u0E23\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
        [
          [
            "\u0E01\u0E38\u0E14\u0E40\u0E25\u0E32\u0E30",
            [
              36120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1A\u0E31\u0E27",
            [
              36120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E22\u0E32\u0E07",
            [
              36120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E31\u0E19",
            [
              36120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E14\u0E37\u0E48\u0E2D",
            [
              36120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E1B\u0E49\u0E32",
            [
              36120
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E42\u0E1E\u0E19\u0E17\u0E2D\u0E07",
            [
              36120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E48\u0E32",
            [
              36120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E1E\u0E19\u0E07\u0E32\u0E21",
            [
              36120
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E01\u0E2D\u0E01",
            [
              36120
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E17\u0E2D\u0E07",
            [
              36120
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E17\u0E1E\u0E2A\u0E16\u0E34\u0E15",
        [
          [
            "\u0E19\u0E32\u0E22\u0E32\u0E07\u0E01\u0E25\u0E31\u0E01",
            [
              36230
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E44\u0E23\u0E48",
            [
              36230
            ]
          ],
          [
            "\u0E27\u0E30\u0E15\u0E30\u0E41\u0E1A\u0E01",
            [
              36230
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E22\u0E32\u0E22\u0E08\u0E34\u0E4B\u0E27",
            [
              36230
            ]
          ],
          [
            "\u0E42\u0E1B\u0E48\u0E07\u0E19\u0E01",
            [
              36230
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E19\u0E34\u0E19\u0E2A\u0E07\u0E48\u0E32",
        [
          [
            "\u0E01\u0E30\u0E2E\u0E32\u0E14",
            [
              36130
            ]
          ],
          [
            "\u0E15\u0E32\u0E40\u0E19\u0E34\u0E19",
            [
              36130
            ]
          ],
          [
            "\u0E23\u0E31\u0E07\u0E07\u0E32\u0E21",
            [
              36130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E09\u0E34\u0E21",
            [
              36130
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E0A\u0E31\u0E22\u0E20\u0E39\u0E21\u0E34",
        [
          [
            "\u0E01\u0E38\u0E14\u0E15\u0E38\u0E49\u0E21",
            [
              36e3
            ]
          ],
          [
            "\u0E0A\u0E35\u0E25\u0E2D\u0E07",
            [
              36e3
            ]
          ],
          [
            "\u0E0B\u0E31\u0E1A\u0E2A\u0E35\u0E17\u0E2D\u0E07",
            [
              36e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2B\u0E34\u0E19\u0E42\u0E07\u0E21",
            [
              36e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E1D\u0E32\u0E22",
            [
              36e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E2A\u0E35\u0E22\u0E27",
            [
              36e3
            ]
          ],
          [
            "\u0E1A\u0E38\u0E48\u0E07\u0E04\u0E25\u0E49\u0E32",
            [
              36e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E04\u0E48\u0E32\u0E22",
            [
              36240
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E25\u0E48\u0E32",
            [
              36e3
            ]
          ],
          [
            "\u0E23\u0E2D\u0E1A\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              36e3
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E43\u0E2B\u0E0D\u0E48",
            [
              36e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E19\u0E32\u0E41\u0E0B\u0E07",
            [
              36e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E1C\u0E48",
            [
              36240
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E15\u0E49\u0E2D\u0E19",
            [
              36e3
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E1A\u0E07",
            [
              36e3
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E39\u0E07",
            [
              36e3
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              36240
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E17\u0E2D\u0E07",
            [
              36e3
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              36e3
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E01\u0E49\u0E07\u0E04\u0E23\u0E49\u0E2D",
        [
          [
            "\u0E0A\u0E48\u0E2D\u0E07\u0E2A\u0E32\u0E21\u0E2B\u0E21\u0E2D",
            [
              36150
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E21\u0E30\u0E44\u0E1F\u0E2B\u0E27\u0E32\u0E19",
            [
              36150
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E19\u0E2D\u0E07\u0E17\u0E38\u0E48\u0E21",
            [
              36150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E01\u0E49\u0E07",
            [
              36150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E32\u0E21",
            [
              36150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E31\u0E07\u0E02\u0E4C",
            [
              36150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E1C\u0E48",
            [
              36150
            ]
          ],
          [
            "\u0E2B\u0E25\u0E38\u0E1A\u0E04\u0E32",
            [
              36150
            ]
          ],
          [
            "\u0E40\u0E01\u0E48\u0E32\u0E22\u0E48\u0E32\u0E14\u0E35",
            [
              36150
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E01\u0E38\u0E07",
            [
              36150
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E0A\u0E38\u0E21\u0E1E\u0E23",
    [
      [
        "\u0E17\u0E38\u0E48\u0E07\u0E15\u0E30\u0E42\u0E01",
        [
          [
            "\u0E0A\u0E48\u0E2D\u0E07\u0E44\u0E21\u0E49\u0E41\u0E01\u0E49\u0E27",
            [
              86220
            ]
          ],
          [
            "\u0E15\u0E30\u0E42\u0E01",
            [
              86220
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E15\u0E30\u0E44\u0E04\u0E23",
            [
              86220
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E15\u0E30\u0E42\u0E01",
            [
              86220
            ]
          ],
          [
            "\u0E2B\u0E21\u0E39\u0E48\u0E40\u0E01\u0E32\u0E30\u0E28\u0E23\u0E35\u0E2D\u0E1A\u0E22\u0E32",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E02\u0E35\u0E49\u0E19\u0E01",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E04\u0E23\u0E32\u0E21",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E04\u0E32\u0E07\u0E2A\u0E37\u0E2D",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E21\u0E30\u0E1E\u0E23\u0E49\u0E32\u0E27",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E21\u0E38\u0E01",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E22\u0E2D",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E23\u0E32\u0E07\u0E1A\u0E23\u0E23\u0E17\u0E31\u0E14",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E2A\u0E39\u0E1A",
            [
              ""
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E48\u0E32\u0E41\u0E0B\u0E30",
        [
          [
            "\u0E04\u0E38\u0E23\u0E34\u0E07",
            [
              86140
            ]
          ],
          [
            "\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C\u0E2D\u0E19\u0E31\u0E19\u0E15\u0E4C",
            [
              86140
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E49\u0E32\u0E21",
            [
              86140
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E41\u0E0B\u0E30",
            [
              86140
            ]
          ],
          [
            "\u0E19\u0E32\u0E01\u0E23\u0E30\u0E15\u0E32\u0E21",
            [
              86140
            ]
          ],
          [
            "\u0E23\u0E31\u0E1A\u0E23\u0E48\u0E2D",
            [
              86190
            ]
          ],
          [
            "\u0E2A\u0E25\u0E38\u0E22",
            [
              86140
            ]
          ],
          [
            "\u0E2A\u0E2D\u0E07\u0E1E\u0E35\u0E48\u0E19\u0E49\u0E2D\u0E07",
            [
              86140
            ]
          ],
          [
            "\u0E2B\u0E07\u0E29\u0E4C\u0E40\u0E08\u0E23\u0E34\u0E0D",
            [
              86140
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E41\u0E01\u0E49\u0E27",
            [
              86190
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E30\u0E17\u0E34\u0E27",
        [
          [
            "\u0E0A\u0E38\u0E21\u0E42\u0E04",
            [
              86160
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E22\u0E32\u0E07",
            [
              86210
            ]
          ],
          [
            "\u0E17\u0E30\u0E40\u0E25\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C",
            [
              86160
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2A\u0E19",
            [
              86160
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E04\u0E25\u0E2D\u0E07",
            [
              86210
            ]
          ],
          [
            "\u0E2A\u0E30\u0E1E\u0E25\u0E35",
            [
              86230
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E0B\u0E35\u0E01\u0E07",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E1E\u0E23\u0E30",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E22\u0E2D",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E23\u0E31\u0E07",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E23\u0E49\u0E32\u0E19\u0E40\u0E1B\u0E47\u0E14",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E23\u0E49\u0E32\u0E19\u0E44\u0E01\u0E48",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E07",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E44\u0E02\u0E48",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E44\u0E0A\u0E22\u0E23\u0E32\u0E0A",
            [
              86210
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E30\u0E42\u0E15\u0E4A\u0E30",
        [
          [
            "\u0E1B\u0E31\u0E07\u0E2B\u0E27\u0E32\u0E19",
            [
              86180
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E17\u0E23\u0E07",
            [
              86180
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E23\u0E31\u0E01\u0E29\u0E4C",
            [
              86180
            ]
          ],
          [
            "\u0E1E\u0E30\u0E42\u0E15\u0E4A\u0E30",
            [
              86180
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E30\u0E41\u0E21",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E04\u0E32\u0E27\u0E31\u0E14",
            [
              86170
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              86170
            ]
          ],
          [
            "\u0E25\u0E30\u0E41\u0E21",
            [
              86170
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E41\u0E15\u0E07",
            [
              86170
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E27\u0E35",
        [
          [
            "\u0E04\u0E23\u0E19",
            [
              86130
            ]
          ],
          [
            "\u0E14\u0E48\u0E32\u0E19\u0E2A\u0E27\u0E35",
            [
              86130
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E23\u0E30\u0E22\u0E30",
            [
              86130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2B\u0E34\u0E19",
            [
              86130
            ]
          ],
          [
            "\u0E19\u0E32\u0E2A\u0E31\u0E01",
            [
              86130
            ]
          ],
          [
            "\u0E19\u0E32\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              86130
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E41\u0E1E\u0E23\u0E01",
            [
              86130
            ]
          ],
          [
            "\u0E27\u0E34\u0E2A\u0E31\u0E22\u0E43\u0E15\u0E49",
            [
              86130
            ]
          ],
          [
            "\u0E2A\u0E27\u0E35",
            [
              86130
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E01\u0E23\u0E30",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E01\u0E38\u0E25\u0E32",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E17\u0E2D\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E1A\u0E32\u0E15\u0E23\u0E4C",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E1E\u0E31\u0E14\u0E2B\u0E27\u0E32\u0E22\u0E40\u0E25\u0E47\u0E01",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E1E\u0E31\u0E14\u0E2B\u0E27\u0E32\u0E22\u0E43\u0E2B\u0E0D\u0E48",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E22\u0E39\u0E07",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E2B\u0E19\u0E39",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E41\u0E21\u0E27",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E41\u0E23\u0E14",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E04\u0E48\u0E32\u0E22",
            [
              86130
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E17\u0E30\u0E25\u0E38",
            [
              86130
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E25\u0E31\u0E07\u0E2A\u0E27\u0E19",
        [
          [
            "\u0E02\u0E31\u0E19\u0E40\u0E07\u0E34\u0E19",
            [
              86110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E21\u0E30\u0E1E\u0E25\u0E32",
            [
              86110
            ]
          ],
          [
            "\u0E19\u0E32\u0E02\u0E32",
            [
              86110
            ]
          ],
          [
            "\u0E19\u0E32\u0E1E\u0E0D\u0E32",
            [
              86110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E19\u0E49\u0E33\u0E08\u0E37\u0E14",
            [
              86150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E21\u0E30\u0E1E\u0E23\u0E49\u0E32\u0E27",
            [
              86110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E04\u0E27\u0E19",
            [
              86110
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E19\u0E49\u0E33",
            [
              86150
            ]
          ],
          [
            "\u0E1E\u0E49\u0E2D\u0E41\u0E14\u0E07",
            [
              86110
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E15\u0E30\u0E01\u0E2D",
            [
              86110
            ]
          ],
          [
            "\u0E2B\u0E25\u0E31\u0E07\u0E2A\u0E27\u0E19",
            [
              86110
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E22\u0E32\u0E22",
            [
              86110
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E1E\u0E34\u0E17\u0E31\u0E01\u0E29\u0E4C",
            [
              ""
            ]
          ],
          [
            "\u0E41\u0E2B\u0E25\u0E21\u0E17\u0E23\u0E32\u0E22",
            [
              86110
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E0A\u0E38\u0E21\u0E1E\u0E23",
        [
          [
            "\u0E02\u0E38\u0E19\u0E01\u0E23\u0E30\u0E17\u0E34\u0E07",
            [
              86190
            ]
          ],
          [
            "\u0E15\u0E32\u0E01\u0E41\u0E14\u0E14",
            [
              86e3
            ]
          ],
          [
            "\u0E16\u0E49\u0E33\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
            [
              86100
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E04\u0E32",
            [
              86100
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E15\u0E30\u0E40\u0E20\u0E32",
            [
              86e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E22\u0E32\u0E07",
            [
              86e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E0A\u0E30\u0E2D\u0E31\u0E07",
            [
              86e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E17\u0E38\u0E48\u0E07",
            [
              86e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E25\u0E36\u0E01",
            [
              86e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2B\u0E21\u0E32\u0E01",
            [
              86e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E32",
            [
              86190
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E19\u0E49\u0E33",
            [
              86120
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E43\u0E2B\u0E21\u0E48",
            [
              86190
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E44\u0E1C\u0E48",
            [
              86e3
            ]
          ],
          [
            "\u0E27\u0E34\u0E2A\u0E31\u0E22\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              86100
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E17\u0E23\u0E32\u0E22\u0E23\u0E35",
            [
              86120
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E1E\u0E31\u0E19\u0E44\u0E01\u0E23",
            [
              86e3
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E01\u0E32",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E01\u0E34\u0E19\u0E2B\u0E25\u0E31\u0E01\u0E07\u0E49\u0E33",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E07\u0E32\u0E21\u0E40\u0E25\u0E47\u0E01",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E07\u0E32\u0E21\u0E43\u0E2B\u0E0D\u0E48",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E17\u0E2D\u0E07\u0E2B\u0E25\u0E32\u0E07",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E17\u0E30\u0E25\u0E38",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E21\u0E30\u0E1E\u0E23\u0E49\u0E32\u0E27",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E21\u0E31\u0E15\u0E42\u0E1E\u0E19",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E21\u0E32\u0E15\u0E23\u0E32",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E23\u0E31\u0E07\u0E01\u0E32\u0E08\u0E34\u0E27",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E25\u0E30\u0E27\u0E30",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E2A\u0E32\u0E01",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E2B\u0E25\u0E31\u0E01\u0E41\u0E23\u0E14",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E2D\u0E35\u0E41\u0E23\u0E14",
            [
              ""
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E40\u0E2A\u0E21\u0E47\u0E14",
            [
              ""
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E15\u0E23\u0E31\u0E07",
    [
      [
        "\u0E01\u0E31\u0E19\u0E15\u0E31\u0E07",
        [
          [
            "\u0E01\u0E31\u0E19\u0E15\u0E31\u0E07",
            [
              92110
            ]
          ],
          [
            "\u0E01\u0E31\u0E19\u0E15\u0E31\u0E07\u0E43\u0E15\u0E49",
            [
              92110
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E0A\u0E35\u0E25\u0E49\u0E2D\u0E21",
            [
              92110
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E25\u0E38",
            [
              92110
            ]
          ],
          [
            "\u0E04\u0E27\u0E19\u0E18\u0E32\u0E19\u0E35",
            [
              92110
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E01\u0E25\u0E37\u0E2D",
            [
              92110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2A\u0E31\u0E01",
            [
              92110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2B\u0E21\u0E32\u0E01",
            [
              92110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E1B\u0E49\u0E32",
            [
              92110
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E19\u0E49\u0E33\u0E23\u0E49\u0E2D\u0E19",
            [
              92110
            ]
          ],
          [
            "\u0E22\u0E48\u0E32\u0E19\u0E0B\u0E37\u0E48\u0E2D",
            [
              92110
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E27\u0E19",
            [
              92110
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E25\u0E34\u0E1A\u0E07",
            [
              92110
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E22\u0E32\u0E07",
            [
              92110
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E42\u0E22\u0E07",
        [
          [
            "\u0E0A\u0E48\u0E2D\u0E07",
            [
              92170
            ]
          ],
          [
            "\u0E19\u0E32\u0E02\u0E49\u0E32\u0E27\u0E40\u0E2A\u0E35\u0E22",
            [
              92170
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E21\u0E37\u0E48\u0E19\u0E28\u0E23\u0E35",
            [
              92170
            ]
          ],
          [
            "\u0E19\u0E32\u0E42\u0E22\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              92170
            ]
          ],
          [
            "\u0E25\u0E30\u0E21\u0E2D",
            [
              92170
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E30\u0E1A\u0E49\u0E32",
            [
              92170
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E30\u0E40\u0E2B\u0E25\u0E35\u0E22\u0E19",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E22\u0E32\u0E27",
            [
              92180
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E49\u0E32\u0E21",
            [
              92120
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E1E\u0E0D\u0E32",
            [
              92140
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E14\u0E49\u0E27\u0E19",
            [
              92140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E32",
            [
              92140
            ]
          ],
          [
            "\u0E1B\u0E30\u0E40\u0E2B\u0E25\u0E35\u0E22\u0E19",
            [
              92180
            ]
          ],
          [
            "\u0E25\u0E34\u0E1E\u0E31\u0E07",
            [
              92180
            ]
          ],
          [
            "\u0E2A\u0E38\u0E42\u0E2A\u0E30",
            [
              92120
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E2A\u0E38\u0E01\u0E23",
            [
              92120
            ]
          ],
          [
            "\u0E41\u0E2B\u0E25\u0E21\u0E2A\u0E2D\u0E21",
            [
              92180
            ]
          ]
        ]
      ],
      [
        "\u0E22\u0E48\u0E32\u0E19\u0E15\u0E32\u0E02\u0E32\u0E27",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E01\u0E23\u0E30\u0E1A\u0E37\u0E2D",
            [
              92140
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E04\u0E48\u0E32\u0E22",
            [
              92140
            ]
          ],
          [
            "\u0E19\u0E32\u0E0A\u0E38\u0E21\u0E40\u0E2B\u0E47\u0E14",
            [
              92140
            ]
          ],
          [
            "\u0E22\u0E48\u0E32\u0E19\u0E15\u0E32\u0E02\u0E32\u0E27",
            [
              92140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E48\u0E2D",
            [
              92140
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E40\u0E1B\u0E35\u0E22\u0E30",
            [
              92140
            ]
          ],
          [
            "\u0E42\u0E1E\u0E23\u0E07\u0E08\u0E23\u0E30\u0E40\u0E02\u0E49",
            [
              92140
            ]
          ],
          [
            "\u0E43\u0E19\u0E04\u0E27\u0E19",
            [
              92140
            ]
          ]
        ]
      ],
      [
        "\u0E23\u0E31\u0E29\u0E0E\u0E32",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E1B\u0E32\u0E07",
            [
              92160
            ]
          ],
          [
            "\u0E04\u0E27\u0E19\u0E40\u0E21\u0E32",
            [
              92160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              92160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E23\u0E37\u0E2D",
            [
              92130
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E44\u0E1E\u0E23",
            [
              92160
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E07\u0E27\u0E34\u0E40\u0E28\u0E29",
        [
          [
            "\u0E17\u0E48\u0E32\u0E2A\u0E30\u0E1A\u0E49\u0E32",
            [
              92e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E21\u0E30\u0E1B\u0E23\u0E32\u0E07",
            [
              92220
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E21\u0E30\u0E1B\u0E23\u0E32\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              92220
            ]
          ],
          [
            "\u0E2D\u0E48\u0E32\u0E27\u0E15\u0E07",
            [
              92220
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E27\u0E34\u0E40\u0E28\u0E29",
            [
              92220
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E34\u0E40\u0E01\u0E32",
        [
          [
            "\u0E01\u0E30\u0E25\u0E32\u0E40\u0E2A",
            [
              92150
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E1E\u0E0A\u0E23",
            [
              92e3
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E2B\u0E34\u0E19",
            [
              92150
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E44\u0E21\u0E49\u0E41\u0E01\u0E49\u0E27",
            [
              92150
            ]
          ],
          [
            "\u0E44\u0E21\u0E49\u0E1D\u0E32\u0E14",
            [
              92150
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E32\u0E14\u0E2A\u0E33\u0E23\u0E32\u0E0D",
        [
          [
            "\u0E15\u0E30\u0E40\u0E2A\u0E30",
            [
              92120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E2B\u0E27\u0E35",
            [
              92120
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              92120
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E49\u0E27\u0E22\u0E22\u0E2D\u0E14",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E15\u0E48\u0E2D",
            [
              92130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E07\u0E34\u0E49\u0E27",
            [
              92130
            ]
          ],
          [
            "\u0E19\u0E32\u0E27\u0E07",
            [
              92210
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E38\u0E49\u0E07",
            [
              92210
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E14\u0E35",
            [
              92210
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E04\u0E21",
            [
              92130
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E41\u0E08\u0E48\u0E21",
            [
              92190
            ]
          ],
          [
            "\u0E25\u0E33\u0E20\u0E39\u0E23\u0E32",
            [
              92190
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E04\u0E35\u0E23\u0E35",
            [
              92210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E0A\u0E49\u0E32\u0E07\u0E41\u0E25\u0E48\u0E19",
            [
              92130
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E19\u0E32\u0E07",
            [
              92130
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E22\u0E2D\u0E14",
            [
              92130
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E01\u0E2D\u0E1A",
            [
              92130
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E02\u0E32\u0E27",
            [
              92130
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E1B\u0E39\u0E19",
            [
              92130
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E15\u0E32",
            [
              92130
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E15\u0E23\u0E31\u0E07",
        [
          [
            "\u0E04\u0E27\u0E19\u0E1B\u0E23\u0E34\u0E07",
            [
              92e3
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
            [
              92e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E15\u0E32\u0E25\u0E48\u0E27\u0E07",
            [
              92e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E17\u0E48\u0E32\u0E21\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              92190
            ]
          ],
          [
            "\u0E19\u0E32\u0E17\u0E48\u0E32\u0E21\u0E43\u0E15\u0E49",
            [
              92190
            ]
          ],
          [
            "\u0E19\u0E32\u0E1A\u0E34\u0E19\u0E2B\u0E25\u0E32",
            [
              92170
            ]
          ],
          [
            "\u0E19\u0E32\u0E1E\u0E25\u0E30",
            [
              92e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E42\u0E15\u0E4A\u0E30\u0E2B\u0E21\u0E34\u0E07",
            [
              92e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E42\u0E22\u0E07\u0E43\u0E15\u0E49",
            [
              92170
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E1C\u0E38\u0E14",
            [
              92e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E23\u0E31\u0E01",
            [
              92e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E04\u0E27\u0E19",
            [
              92e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              92e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E15\u0E23\u0E38\u0E14",
            [
              92e3
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2B\u0E25\u0E48\u0E2D",
            [
              92e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E15\u0E23\u0E32\u0E14",
    [
      [
        "\u0E04\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E0D\u0E48",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              23110
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E40\u0E25\u0E47\u0E01",
            [
              23110
            ]
          ],
          [
            "\u0E44\u0E21\u0E49\u0E23\u0E39\u0E14",
            [
              23110
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E48\u0E2D\u0E44\u0E23\u0E48",
        [
          [
            "\u0E0A\u0E49\u0E32\u0E07\u0E17\u0E39\u0E19",
            [
              23140
            ]
          ],
          [
            "\u0E14\u0E48\u0E32\u0E19\u0E0A\u0E38\u0E21\u0E1E\u0E25",
            [
              23140
            ]
          ],
          [
            "\u0E19\u0E19\u0E17\u0E23\u0E35\u0E22\u0E4C",
            [
              23140
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E1E\u0E25\u0E2D\u0E22",
            [
              23140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E2D\u0E19",
            [
              23140
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E01\u0E32\u0E30\u0E01\u0E39\u0E14",
        [
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E01\u0E39\u0E14",
            [
              23e3
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E2B\u0E21\u0E32\u0E01",
            [
              23e3
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E01\u0E32\u0E30\u0E0A\u0E49\u0E32\u0E07",
        [
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E0A\u0E49\u0E32\u0E07",
            [
              23170
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E0A\u0E49\u0E32\u0E07\u0E43\u0E15\u0E49",
            [
              23170
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E02\u0E32\u0E2A\u0E21\u0E34\u0E07",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E19\u0E19\u0E17\u0E23\u0E35",
            [
              23130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E42\u0E2A\u0E21",
            [
              23150
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E13\u0E35\u0E15",
            [
              23150
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              23130
            ]
          ],
          [
            "\u0E2A\u0E30\u0E15\u0E2D",
            [
              23150
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E2A\u0E21\u0E34\u0E07",
            [
              23130
            ]
          ],
          [
            "\u0E40\u0E17\u0E1E\u0E19\u0E34\u0E21\u0E34\u0E15",
            [
              23150
            ]
          ],
          [
            "\u0E41\u0E2A\u0E19\u0E15\u0E38\u0E49\u0E07",
            [
              23150
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E15\u0E23\u0E32\u0E14",
        [
          [
            "\u0E0A\u0E33\u0E23\u0E32\u0E01",
            [
              23e3
            ]
          ],
          [
            "\u0E15\u0E30\u0E01\u0E32\u0E07",
            [
              23e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E01\u0E38\u0E48\u0E21",
            [
              23e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E1E\u0E23\u0E34\u0E01",
            [
              23e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E23\u0E30",
            [
              23e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E01\u0E23\u0E30\u0E41\u0E08\u0E30",
            [
              23e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E04\u0E31\u0E19\u0E17\u0E23\u0E07",
            [
              23e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E2A\u0E21\u0E47\u0E14",
            [
              23e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E2A\u0E19",
            [
              23e3
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E07\u0E19\u0E49\u0E33\u0E02\u0E32\u0E27",
            [
              23e3
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E41\u0E23\u0E49\u0E07",
            [
              23e3
            ]
          ],
          [
            "\u0E2D\u0E48\u0E32\u0E27\u0E43\u0E2B\u0E0D\u0E48",
            [
              23e3
            ]
          ],
          [
            "\u0E40\u0E19\u0E34\u0E19\u0E17\u0E23\u0E32\u0E22",
            [
              23e3
            ]
          ],
          [
            "\u0E41\u0E2B\u0E25\u0E21\u0E01\u0E25\u0E31\u0E14",
            [
              23e3
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E2B\u0E25\u0E21\u0E07\u0E2D\u0E1A",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              23120
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E40\u0E0A\u0E35\u0E48\u0E22\u0E27",
            [
              23120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1B\u0E34\u0E14",
            [
              23120
            ]
          ],
          [
            "\u0E41\u0E2B\u0E25\u0E21\u0E07\u0E2D\u0E1A",
            [
              23120
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E15\u0E32\u0E01",
    [
      [
        "\u0E17\u0E48\u0E32\u0E2A\u0E2D\u0E07\u0E22\u0E32\u0E07",
        [
          [
            "\u0E17\u0E48\u0E32\u0E2A\u0E2D\u0E07\u0E22\u0E32\u0E07",
            [
              63150
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E15\u0E49\u0E32\u0E19",
            [
              63150
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E27\u0E30\u0E2B\u0E25\u0E27\u0E07",
            [
              63150
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E2D\u0E07",
            [
              63150
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2B\u0E25\u0E30",
            [
              63150
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2D\u0E38\u0E2A\u0E38",
            [
              63150
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E15\u0E32\u0E01",
        [
          [
            "\u0E15\u0E32\u0E01\u0E15\u0E01",
            [
              63120
            ]
          ],
          [
            "\u0E15\u0E32\u0E01\u0E2D\u0E2D\u0E01",
            [
              63120
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E01\u0E23\u0E30\u0E40\u0E0A\u0E32\u0E30",
            [
              63120
            ]
          ],
          [
            "\u0E17\u0E49\u0E2D\u0E07\u0E1F\u0E49\u0E32",
            [
              63120
            ]
          ],
          [
            "\u0E2A\u0E21\u0E2D\u0E42\u0E04\u0E19",
            [
              63120
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E15\u0E30\u0E40\u0E20\u0E32",
            [
              63120
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E25\u0E34\u0E14",
            [
              63120
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E1A\u0E1E\u0E23\u0E30",
        [
          [
            "\u0E04\u0E35\u0E23\u0E35\u0E23\u0E32\u0E29\u0E0E\u0E23\u0E4C",
            [
              63160
            ]
          ],
          [
            "\u0E0A\u0E48\u0E2D\u0E07\u0E41\u0E04\u0E1A",
            [
              63160
            ]
          ],
          [
            "\u0E1E\u0E1A\u0E1E\u0E23\u0E30",
            [
              63160
            ]
          ],
          [
            "\u0E23\u0E27\u0E21\u0E44\u0E17\u0E22\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              63160
            ]
          ],
          [
            "\u0E27\u0E32\u0E40\u0E25\u0E48\u0E22\u0E4C",
            [
              63160
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E07\u0E40\u0E08\u0E49\u0E32",
        [
          [
            "\u0E19\u0E32\u0E42\u0E1A\u0E2A\u0E16\u0E4C",
            [
              63e3
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E14\u0E32\u0E07",
            [
              63e3
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E17\u0E2D\u0E07",
            [
              63e3
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E32\u0E21\u0E40\u0E07\u0E32",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E32",
            [
              63130
            ]
          ],
          [
            "\u0E22\u0E01\u0E01\u0E23\u0E30\u0E1A\u0E31\u0E15\u0E23",
            [
              63130
            ]
          ],
          [
            "\u0E22\u0E48\u0E32\u0E19\u0E23\u0E35",
            [
              63130
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
            [
              63130
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2B\u0E21\u0E31\u0E19",
            [
              63130
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E40\u0E07\u0E32",
            [
              63130
            ]
          ]
        ]
      ],
      [
        "\u0E2D\u0E38\u0E49\u0E21\u0E1C\u0E32\u0E07",
        [
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              63170
            ]
          ],
          [
            "\u0E2D\u0E38\u0E49\u0E21\u0E1C\u0E32\u0E07",
            [
              63170
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E01\u0E25\u0E2D\u0E07",
            [
              63170
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E08\u0E31\u0E19",
            [
              63170
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E25\u0E30\u0E21\u0E38\u0E49\u0E07",
            [
              63170
            ]
          ],
          [
            "\u0E42\u0E21\u0E42\u0E01\u0E23",
            [
              63170
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E15\u0E32\u0E01",
        [
          [
            "\u0E15\u0E25\u0E38\u0E01\u0E01\u0E25\u0E32\u0E07\u0E17\u0E38\u0E48\u0E07",
            [
              63e3
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E23\u0E36\u0E21",
            [
              63e3
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E21\u0E30\u0E21\u0E48\u0E27\u0E07",
            [
              63e3
            ]
          ],
          [
            "\u0E23\u0E30\u0E41\u0E2B\u0E07",
            [
              63e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E1B\u0E23\u0E30\u0E08\u0E1A",
            [
              63e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2B\u0E34\u0E19",
            [
              63e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              63e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E43\u0E15\u0E49",
            [
              63e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              63e3
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E40\u0E14\u0E35\u0E22\u0E14",
            [
              63e3
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E40\u0E07\u0E34\u0E19",
            [
              63e3
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E17\u0E49\u0E2D",
            [
              63e3
            ]
          ],
          [
            "\u0E42\u0E1B\u0E48\u0E07\u0E41\u0E14\u0E07",
            [
              63e3
            ]
          ],
          [
            "\u0E44\u0E21\u0E49\u0E07\u0E32\u0E21",
            [
              63e3
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E23\u0E30\u0E21\u0E32\u0E14",
        [
          [
            "\u0E02\u0E30\u0E40\u0E19\u0E08\u0E37\u0E49\u0E2D",
            [
              63140
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E18\u0E32\u0E15\u0E38",
            [
              63140
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E2B\u0E21\u0E37\u0E48\u0E19",
            [
              63140
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E08\u0E30\u0E40\u0E23\u0E32",
            [
              63140
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E15\u0E37\u0E48\u0E19",
            [
              63140
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E23\u0E30\u0E21\u0E32\u0E14",
            [
              63140
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E2A\u0E2D\u0E14",
        [
          [
            "\u0E14\u0E48\u0E32\u0E19\u0E41\u0E21\u0E48\u0E25\u0E30\u0E40\u0E21\u0E32",
            [
              63110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2A\u0E32\u0E22\u0E25\u0E27\u0E14",
            [
              63110
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E18\u0E32\u0E15\u0E38\u0E1C\u0E32\u0E41\u0E14\u0E07",
            [
              63110
            ]
          ],
          [
            "\u0E1E\u0E30\u0E27\u0E2D",
            [
              63110
            ]
          ],
          [
            "\u0E21\u0E2B\u0E32\u0E27\u0E31\u0E19",
            [
              63110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E01\u0E32\u0E29\u0E32",
            [
              63110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E01\u0E38",
            [
              63110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E15\u0E32\u0E27",
            [
              63110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E1B\u0E30",
            [
              63110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E2D\u0E14",
            [
              63110
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E19\u0E04\u0E23\u0E19\u0E32\u0E22\u0E01",
    [
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E32",
        [
          [
            "\u0E17\u0E2D\u0E07\u0E2B\u0E25\u0E32\u0E07",
            [
              26110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2D\u0E49\u0E2D",
            [
              26110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E32",
            [
              26110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1E\u0E23\u0E34\u0E01",
            [
              26110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1E\u0E23\u0E49\u0E32\u0E27",
            [
              26110
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E02\u0E30",
            [
              26110
            ]
          ],
          [
            "\u0E1E\u0E34\u0E01\u0E38\u0E25\u0E2D\u0E2D\u0E01",
            [
              26110
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E01\u0E30\u0E2D\u0E32\u0E07",
            [
              26110
            ]
          ],
          [
            "\u0E2D\u0E32\u0E29\u0E32",
            [
              26110
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E40\u0E1E\u0E34\u0E48\u0E21",
            [
              26110
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E32\u0E01\u0E1E\u0E25\u0E35",
        [
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E23\u0E37\u0E2D",
            [
              26130
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E34\u0E19\u0E25\u0E32\u0E14",
            [
              26130
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E1E\u0E25\u0E35",
            [
              26130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E2A\u0E07",
            [
              26130
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E2B\u0E27\u0E32\u0E22",
            [
              26130
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              26130
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E01\u0E23\u0E27\u0E14",
            [
              26130
            ]
          ]
        ]
      ],
      [
        "\u0E2D\u0E07\u0E04\u0E23\u0E31\u0E01\u0E29\u0E4C",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              26120
            ]
          ],
          [
            "\u0E0A\u0E38\u0E21\u0E1E\u0E25",
            [
              26120
            ]
          ],
          [
            "\u0E17\u0E23\u0E32\u0E22\u0E21\u0E39\u0E25",
            [
              26120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1B\u0E25\u0E32\u0E01\u0E14",
            [
              26120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E25\u0E39\u0E01\u0E40\u0E2A\u0E37\u0E2D",
            [
              26120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              26120
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E28\u0E32\u0E25",
            [
              26120
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E2D\u0E32\u0E08\u0E32\u0E23\u0E22\u0E4C",
            [
              26120
            ]
          ],
          [
            "\u0E28\u0E35\u0E23\u0E29\u0E30\u0E01\u0E23\u0E30\u0E1A\u0E37\u0E2D",
            [
              26120
            ]
          ],
          [
            "\u0E2D\u0E07\u0E04\u0E23\u0E31\u0E01\u0E29\u0E4C",
            [
              26120
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E41\u0E17\u0E19",
            [
              26120
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E19\u0E04\u0E23\u0E19\u0E32\u0E22\u0E01",
        [
          [
            "\u0E14\u0E07\u0E25\u0E30\u0E04\u0E23",
            [
              26e3
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E22\u0E2D",
            [
              26e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E0A\u0E49\u0E32\u0E07",
            [
              26e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E17\u0E23\u0E32\u0E22",
            [
              26e3
            ]
          ],
          [
            "\u0E19\u0E04\u0E23\u0E19\u0E32\u0E22\u0E01",
            [
              26e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E0D\u0E48",
            [
              26e3
            ]
          ],
          [
            "\u0E1E\u0E23\u0E2B\u0E21\u0E13\u0E35",
            [
              26e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E01\u0E23\u0E30\u0E42\u0E08\u0E21",
            [
              26e3
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E08\u0E38\u0E2C\u0E32",
            [
              26e3
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E19\u0E32\u0E27\u0E32",
            [
              26e3
            ]
          ],
          [
            "\u0E2A\u0E32\u0E23\u0E34\u0E01\u0E32",
            [
              26e3
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E15\u0E31\u0E49\u0E07",
            [
              26e3
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E1E\u0E23\u0E30",
            [
              26e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E19\u0E04\u0E23\u0E1B\u0E10\u0E21",
    [
      [
        "\u0E01\u0E33\u0E41\u0E1E\u0E07\u0E41\u0E2A\u0E19",
        [
          [
            "\u0E01\u0E23\u0E30\u0E15\u0E35\u0E1A",
            [
              73180
            ]
          ],
          [
            "\u0E01\u0E33\u0E41\u0E1E\u0E07\u0E41\u0E2A\u0E19",
            [
              73140
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E02\u0E48\u0E2D\u0E22",
            [
              73140
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E01\u0E23\u0E30\u0E1E\u0E31\u0E07\u0E42\u0E2B\u0E21",
            [
              73140
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E02\u0E27\u0E32\u0E07",
            [
              73140
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E1A\u0E31\u0E27",
            [
              73140
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E25\u0E39\u0E01\u0E19\u0E01",
            [
              73140
            ]
          ],
          [
            "\u0E23\u0E32\u0E07\u0E1E\u0E34\u0E01\u0E38\u0E25",
            [
              73140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E19\u0E49\u0E33\u0E40\u0E02\u0E35\u0E22\u0E27",
            [
              73140
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              73180
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E2A\u0E35\u0E48\u0E21\u0E38\u0E21",
            [
              73140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E17\u0E38\u0E48\u0E21",
            [
              73140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E02\u0E27\u0E32\u0E07",
            [
              73140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E21\u0E48\u0E27\u0E07",
            [
              73180
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E2B\u0E21\u0E2D\u0E19\u0E17\u0E2D\u0E07",
            [
              73140
            ]
          ]
        ]
      ],
      [
        "\u0E14\u0E2D\u0E19\u0E15\u0E39\u0E21",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E1E\u0E38\u0E17\u0E23\u0E32",
            [
              73150
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E23\u0E27\u0E01",
            [
              73150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E25\u0E27\u0E07",
            [
              73150
            ]
          ],
          [
            "\u0E25\u0E33\u0E25\u0E39\u0E01\u0E1A\u0E31\u0E27",
            [
              73150
            ]
          ],
          [
            "\u0E25\u0E33\u0E40\u0E2B\u0E22",
            [
              73150
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E07\u0E48\u0E32\u0E21",
            [
              73150
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E14\u0E49\u0E27\u0E19",
            [
              73150
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E1E\u0E23\u0E30",
            [
              73150
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E04\u0E23\u0E0A\u0E31\u0E22\u0E28\u0E23\u0E35",
        [
          [
            "\u0E02\u0E38\u0E19\u0E41\u0E01\u0E49\u0E27",
            [
              73120
            ]
          ],
          [
            "\u0E07\u0E34\u0E49\u0E27\u0E23\u0E32\u0E22",
            [
              73120
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E41\u0E1D\u0E01",
            [
              73120
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E01\u0E23\u0E30\u0E0A\u0E31\u0E1A",
            [
              73120
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E15\u0E33\u0E2B\u0E19\u0E31\u0E01",
            [
              73120
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E1E\u0E23\u0E30\u0E22\u0E32",
            [
              73120
            ]
          ],
          [
            "\u0E19\u0E04\u0E23\u0E0A\u0E31\u0E22\u0E28\u0E23\u0E35",
            [
              73120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1A\u0E32",
            [
              73120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E23\u0E30",
            [
              73120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E23\u0E30\u0E01\u0E33",
            [
              73120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              73120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E41\u0E01\u0E49\u0E27\u0E1F\u0E49\u0E32",
            [
              73120
            ]
          ],
          [
            "\u0E1E\u0E30\u0E40\u0E19\u0E35\u0E22\u0E14",
            [
              73120
            ]
          ],
          [
            "\u0E25\u0E32\u0E19\u0E15\u0E32\u0E01\u0E1F\u0E49\u0E32",
            [
              73120
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E25\u0E30\u0E21\u0E38\u0E14",
            [
              73120
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E2A\u0E33\u0E42\u0E23\u0E07",
            [
              73120
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E41\u0E04",
            [
              73120
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E21\u0E2B\u0E32\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              73120
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E29\u0E30\u0E17\u0E2D\u0E07",
            [
              73120
            ]
          ],
          [
            "\u0E2A\u0E31\u0E21\u0E1B\u0E17\u0E27\u0E19",
            [
              73120
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E1E\u0E25\u0E39",
            [
              73120
            ]
          ],
          [
            "\u0E41\u0E2B\u0E25\u0E21\u0E1A\u0E31\u0E27",
            [
              73120
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E1E\u0E23\u0E30\u0E40\u0E08\u0E14\u0E35\u0E22\u0E4C",
            [
              73120
            ]
          ],
          [
            "\u0E44\u0E17\u0E22\u0E32\u0E27\u0E32\u0E2A",
            [
              73120
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E40\u0E25\u0E19",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E19\u0E01\u0E01\u0E23\u0E30\u0E17\u0E38\u0E07",
            [
              73130
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E15\u0E39\u0E21",
            [
              73130
            ]
          ],
          [
            "\u0E19\u0E23\u0E32\u0E20\u0E34\u0E23\u0E21\u0E22\u0E4C",
            [
              73130
            ]
          ],
          [
            "\u0E19\u0E34\u0E25\u0E40\u0E1E\u0E0A\u0E23",
            [
              73130
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E1B\u0E32\u0E01\u0E17\u0E48\u0E32",
            [
              73130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1B\u0E25\u0E32",
            [
              73130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E20\u0E32\u0E29\u0E35",
            [
              73130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E23\u0E30\u0E01\u0E33",
            [
              73130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              73190
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E25\u0E19",
            [
              73130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E44\u0E17\u0E23\u0E1B\u0E48\u0E32",
            [
              73130
            ]
          ],
          [
            "\u0E25\u0E33\u0E1E\u0E0D\u0E32",
            [
              73130
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E21\u0E39\u0E25",
            [
              73190
            ]
          ],
          [
            "\u0E44\u0E17\u0E23\u0E07\u0E32\u0E21",
            [
              73130
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E2B\u0E39\u0E0A\u0E49\u0E32\u0E07",
            [
              73130
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E38\u0E17\u0E18\u0E21\u0E13\u0E11\u0E25",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E42\u0E22\u0E07",
            [
              73170
            ]
          ],
          [
            "\u0E21\u0E2B\u0E32\u0E2A\u0E27\u0E31\u0E2A\u0E14\u0E34\u0E4C",
            [
              73170
            ]
          ],
          [
            "\u0E28\u0E32\u0E25\u0E32\u0E22\u0E32",
            [
              73170
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E32\u0E21\u0E1E\u0E23\u0E32\u0E19",
        [
          [
            "\u0E01\u0E23\u0E30\u0E17\u0E38\u0E48\u0E21\u0E25\u0E49\u0E21",
            [
              73220
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E08\u0E34\u0E19\u0E14\u0E32",
            [
              73110
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48",
            [
              73110
            ]
          ],
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E08\u0E34\u0E19\u0E14\u0E32",
            [
              73110
            ]
          ],
          [
            "\u0E17\u0E23\u0E07\u0E04\u0E19\u0E2D\u0E07",
            [
              73210
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E49\u0E32\u0E21",
            [
              73110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E15\u0E25\u0E32\u0E14",
            [
              73110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E23\u0E30\u0E17\u0E36\u0E01",
            [
              73210
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E0A\u0E49\u0E32\u0E07",
            [
              73110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E15\u0E22",
            [
              73210
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48",
            [
              73110
            ]
          ],
          [
            "\u0E22\u0E32\u0E22\u0E0A\u0E32",
            [
              73110
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E1E\u0E23\u0E32\u0E19",
            [
              73110
            ]
          ],
          [
            "\u0E2B\u0E2D\u0E21\u0E40\u0E01\u0E23\u0E47\u0E14",
            [
              73110
            ]
          ],
          [
            "\u0E2D\u0E49\u0E2D\u0E21\u0E43\u0E2B\u0E0D\u0E48",
            [
              73160
            ]
          ],
          [
            "\u0E44\u0E23\u0E48\u0E02\u0E34\u0E07",
            [
              73210
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E19\u0E04\u0E23\u0E1B\u0E10\u0E21",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E22\u0E32\u0E22\u0E2B\u0E2D\u0E21",
            [
              73e3
            ]
          ],
          [
            "\u0E15\u0E32\u0E01\u0E49\u0E2D\u0E07",
            [
              73e3
            ]
          ],
          [
            "\u0E16\u0E19\u0E19\u0E02\u0E32\u0E14",
            [
              73e3
            ]
          ],
          [
            "\u0E17\u0E31\u0E1E\u0E2B\u0E25\u0E27\u0E07",
            [
              73e3
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E19\u0E49\u0E2D\u0E22",
            [
              73e3
            ]
          ],
          [
            "\u0E18\u0E23\u0E23\u0E21\u0E28\u0E32\u0E25\u0E32",
            [
              73e3
            ]
          ],
          [
            "\u0E19\u0E04\u0E23\u0E1B\u0E10\u0E21",
            [
              73e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E41\u0E02\u0E21",
            [
              73e3
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E1E\u0E25\u0E31\u0E1A",
            [
              73e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E22\u0E32\u0E07",
            [
              73e3
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E1B\u0E10\u0E21\u0E40\u0E08\u0E14\u0E35\u0E22\u0E4C",
            [
              73e3
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E1B\u0E23\u0E30\u0E42\u0E17\u0E19",
            [
              73e3
            ]
          ],
          [
            "\u0E21\u0E32\u0E1A\u0E41\u0E04",
            [
              73e3
            ]
          ],
          [
            "\u0E25\u0E33\u0E1E\u0E22\u0E32",
            [
              73e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E15\u0E30\u0E01\u0E39",
            [
              73e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E40\u0E22\u0E47\u0E19",
            [
              73e3
            ]
          ],
          [
            "\u0E2A\u0E19\u0E32\u0E21\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
            [
              73e3
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E01\u0E30\u0E40\u0E17\u0E35\u0E22\u0E21",
            [
              73e3
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E1B\u0E48\u0E32\u0E19",
            [
              73e3
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E04\u0E27\u0E32\u0E22\u0E40\u0E1C\u0E37\u0E2D\u0E01",
            [
              73e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E07\u0E39\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E21",
            [
              73e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E14\u0E34\u0E19\u0E41\u0E14\u0E07",
            [
              73e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E32\u0E01\u0E42\u0E25\u0E07",
            [
              73e3
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E08\u0E23\u0E40\u0E02\u0E49",
            [
              73e3
            ]
          ],
          [
            "\u0E42\u0E1E\u0E23\u0E07\u0E21\u0E30\u0E40\u0E14\u0E37\u0E48\u0E2D",
            [
              73e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E19\u0E04\u0E23\u0E1E\u0E19\u0E21",
    [
      [
        "\u0E17\u0E48\u0E32\u0E2D\u0E38\u0E40\u0E17\u0E19",
        [
          [
            "\u0E17\u0E48\u0E32\u0E08\u0E33\u0E1B\u0E32",
            [
              48120
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2D\u0E38\u0E40\u0E17\u0E19",
            [
              48120
            ]
          ],
          [
            "\u0E1E\u0E19\u0E2D\u0E21",
            [
              48120
            ]
          ],
          [
            "\u0E1E\u0E30\u0E17\u0E32\u0E22",
            [
              48120
            ]
          ],
          [
            "\u0E23\u0E32\u0E21\u0E23\u0E32\u0E0A",
            [
              48120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E17\u0E32",
            [
              48120
            ]
          ],
          [
            "\u0E40\u0E27\u0E34\u0E19\u0E1E\u0E23\u0E30\u0E1A\u0E32\u0E17",
            [
              48120
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E15\u0E32\u0E25",
            [
              48120
            ]
          ],
          [
            "\u0E44\u0E0A\u0E22\u0E1A\u0E38\u0E23\u0E35",
            [
              48120
            ]
          ]
        ]
      ],
      [
        "\u0E18\u0E32\u0E15\u0E38\u0E1E\u0E19\u0E21",
        [
          [
            "\u0E01\u0E38\u0E14\u0E09\u0E34\u0E21",
            [
              48110
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E19\u0E32\u0E07\u0E2B\u0E07\u0E2A\u0E4C",
            [
              48110
            ]
          ],
          [
            "\u0E18\u0E32\u0E15\u0E38\u0E1E\u0E19\u0E21",
            [
              48110
            ]
          ],
          [
            "\u0E18\u0E32\u0E15\u0E38\u0E1E\u0E19\u0E21\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              48110
            ]
          ],
          [
            "\u0E19\u0E32\u0E16\u0E48\u0E2D\u0E19",
            [
              48110
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E19\u0E32\u0E14",
            [
              48110
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E01\u0E48\u0E33",
            [
              48110
            ]
          ],
          [
            "\u0E1D\u0E31\u0E48\u0E07\u0E41\u0E14\u0E07",
            [
              48110
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E01\u0E25\u0E32\u0E07\u0E17\u0E38\u0E48\u0E07",
            [
              48110
            ]
          ],
          [
            "\u0E2D\u0E38\u0E48\u0E21\u0E40\u0E2B\u0E21\u0E49\u0E32",
            [
              48110
            ]
          ],
          [
            "\u0E41\u0E2A\u0E19\u0E1E\u0E31\u0E19",
            [
              48110
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E41\u0E1E\u0E07",
            [
              48110
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E17\u0E21",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E40\u0E15\u0E22",
            [
              48140
            ]
          ],
          [
            "\u0E19\u0E32\u0E17\u0E21",
            [
              48140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E0B\u0E19",
            [
              48140
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E2B\u0E27\u0E49\u0E32",
        [
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E23\u0E37\u0E2D",
            [
              48180
            ]
          ],
          [
            "\u0E19\u0E32\u0E04\u0E39\u0E13\u0E43\u0E2B\u0E0D\u0E48",
            [
              48180
            ]
          ],
          [
            "\u0E19\u0E32\u0E07\u0E31\u0E27",
            [
              48180
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E27\u0E49\u0E32",
            [
              48180
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E2A\u0E35\u0E22\u0E27",
            [
              48180
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              48180
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E41\u0E01",
        [
          [
            "\u0E01\u0E49\u0E32\u0E19\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E07",
            [
              48130
            ]
          ],
          [
            "\u0E04\u0E33\u0E1E\u0E35\u0E49",
            [
              48130
            ]
          ],
          [
            "\u0E19\u0E32\u0E04\u0E39\u0E48",
            [
              48130
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E25\u0E35\u0E22\u0E07",
            [
              48130
            ]
          ],
          [
            "\u0E19\u0E32\u0E41\u0E01",
            [
              48130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E01\u0E49\u0E07",
            [
              48130
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E0B\u0E2D\u0E07",
            [
              48130
            ]
          ],
          [
            "\u0E1E\u0E34\u0E21\u0E32\u0E19",
            [
              48130
            ]
          ],
          [
            "\u0E1E\u0E38\u0E48\u0E21\u0E41\u0E01",
            [
              48130
            ]
          ],
          [
            "\u0E2A\u0E35\u0E0A\u0E21\u0E1E\u0E39",
            [
              48130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E48\u0E2D",
            [
              48130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E31\u0E07\u0E02\u0E4C",
            [
              48130
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E1E\u0E07",
        [
          [
            "\u0E19\u0E32\u0E07\u0E31\u0E27",
            [
              48140
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E02",
            [
              48140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E1E\u0E07",
            [
              48140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07",
            [
              48140
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E17\u0E2D\u0E07",
            [
              48140
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E25\u0E49\u0E2D\u0E21",
            [
              48140
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E25\u0E32\u0E1B\u0E32\u0E01",
        [
          [
            "\u0E01\u0E38\u0E15\u0E32\u0E44\u0E01\u0E49",
            [
              48160
            ]
          ],
          [
            "\u0E19\u0E32\u0E21\u0E30\u0E40\u0E02\u0E37\u0E2D",
            [
              48160
            ]
          ],
          [
            "\u0E1B\u0E25\u0E32\u0E1B\u0E32\u0E01",
            [
              48160
            ]
          ],
          [
            "\u0E21\u0E2B\u0E32\u0E0A\u0E31\u0E22",
            [
              48160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2E\u0E35",
            [
              48160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E17\u0E32\u0E43\u0E2B\u0E0D\u0E48",
            [
              48160
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              48160
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E39\u0E07",
            [
              48160
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E07\u0E22\u0E32\u0E07",
        [
          [
            "\u0E22\u0E2D\u0E14\u0E0A\u0E32\u0E14",
            [
              48130
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E22\u0E32\u0E07",
            [
              48130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              48130
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E35",
            [
              48130
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E2A\u0E07\u0E04\u0E23\u0E32\u0E21",
        [
          [
            "\u0E17\u0E48\u0E32\u0E1A\u0E48\u0E2D\u0E2A\u0E07\u0E04\u0E23\u0E32\u0E21",
            [
              48150
            ]
          ],
          [
            "\u0E19\u0E32\u0E04\u0E33",
            [
              48150
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E14\u0E37\u0E48\u0E2D",
            [
              48150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E02\u0E48\u0E32",
            [
              48150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E2D\u0E37\u0E49\u0E2D\u0E07",
            [
              48150
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E07\u0E04\u0E23\u0E32\u0E21",
            [
              48150
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E1C\u0E07",
            [
              48150
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E41\u0E1E\u0E07",
            [
              48150
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              48150
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E19\u0E04\u0E23\u0E1E\u0E19\u0E21",
        [
          [
            "\u0E01\u0E38\u0E23\u0E38\u0E04\u0E38",
            [
              48e3
            ]
          ],
          [
            "\u0E02\u0E32\u0E21\u0E40\u0E12\u0E48\u0E32",
            [
              48e3
            ]
          ],
          [
            "\u0E04\u0E33\u0E40\u0E15\u0E22",
            [
              48e3
            ]
          ],
          [
            "\u0E14\u0E07\u0E02\u0E27\u0E32\u0E07",
            [
              48e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E04\u0E49\u0E2D",
            [
              48e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E17\u0E23\u0E32\u0E22",
            [
              48e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E23\u0E32\u0E0A\u0E04\u0E27\u0E32\u0E22",
            [
              48e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E25\u0E32\u0E07",
            [
              48e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1C\u0E36\u0E49\u0E07",
            [
              48e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E15\u0E32\u0E21\u0E31\u0E27",
            [
              48e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E0D\u0E32\u0E15\u0E34",
            [
              48e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E2A\u0E07",
            [
              48e3
            ]
          ],
          [
            "\u0E2D\u0E32\u0E08\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16",
            [
              48e3
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E15\u0E32\u0E01",
            [
              48e3
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              48e3
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E23\u0E13\u0E39\u0E19\u0E04\u0E23",
        [
          [
            "\u0E17\u0E48\u0E32\u0E25\u0E32\u0E14",
            [
              48170
            ]
          ],
          [
            "\u0E19\u0E32\u0E02\u0E32\u0E21",
            [
              48170
            ]
          ],
          [
            "\u0E19\u0E32\u0E07\u0E32\u0E21",
            [
              48170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E22\u0E48\u0E32\u0E07\u0E0A\u0E34\u0E49\u0E19",
            [
              48170
            ]
          ],
          [
            "\u0E40\u0E23\u0E13\u0E39",
            [
              48170
            ]
          ],
          [
            "\u0E40\u0E23\u0E13\u0E39\u0E43\u0E15\u0E49",
            [
              48170
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2B\u0E34\u0E19\u0E41\u0E2E\u0E48",
            [
              48170
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E17\u0E2D\u0E07",
            [
              48170
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E1E\u0E19\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
        [
          [
            "\u0E19\u0E32\u0E02\u0E21\u0E34\u0E49\u0E19",
            [
              48190
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E31\u0E27\u0E1A\u0E48\u0E2D",
            [
              48190
            ]
          ],
          [
            "\u0E19\u0E32\u0E43\u0E19",
            [
              48190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E04\u0E49\u0E2D",
            [
              48190
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E08\u0E32\u0E19",
            [
              48190
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E1A\u0E01",
            [
              48190
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
            [
              48190
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E19\u0E04\u0E23\u0E23\u0E32\u0E0A\u0E2A\u0E35\u0E21\u0E32",
    [
      [
        "\u0E02\u0E32\u0E21\u0E17\u0E30\u0E40\u0E25\u0E2A\u0E2D",
        [
          [
            "\u0E02\u0E32\u0E21\u0E17\u0E30\u0E40\u0E25\u0E2A\u0E2D",
            [
              30280
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E2D\u0E49\u0E2D",
            [
              30280
            ]
          ],
          [
            "\u0E1E\u0E31\u0E19\u0E14\u0E38\u0E07",
            [
              30280
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E23\u0E27\u0E07",
            [
              30280
            ]
          ],
          [
            "\u0E42\u0E1B\u0E48\u0E07\u0E41\u0E14\u0E07",
            [
              30280
            ]
          ]
        ]
      ],
      [
        "\u0E02\u0E32\u0E21\u0E2A\u0E30\u0E41\u0E01\u0E41\u0E2A\u0E07",
        [
          [
            "\u0E02\u0E32\u0E21\u0E2A\u0E30\u0E41\u0E01\u0E41\u0E2A\u0E07",
            [
              30290
            ]
          ],
          [
            "\u0E0A\u0E35\u0E27\u0E36\u0E01",
            [
              30290
            ]
          ],
          [
            "\u0E1E\u0E30\u0E07\u0E32\u0E14",
            [
              30290
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E31\u0E27\u0E1F\u0E32\u0E19",
            [
              30290
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E19\u0E32\u0E17",
            [
              30290
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E01\u0E29\u0E15\u0E23",
            [
              30290
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              30290
            ]
          ]
        ]
      ],
      [
        "\u0E04\u0E07",
        [
          [
            "\u0E02\u0E32\u0E21\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              30260
            ]
          ],
          [
            "\u0E04\u0E39\u0E02\u0E32\u0E14",
            [
              30260
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E43\u0E2B\u0E0D\u0E48",
            [
              30260
            ]
          ],
          [
            "\u0E15\u0E32\u0E08\u0E31\u0E48\u0E19",
            [
              30260
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1B\u0E23\u0E32\u0E07\u0E04\u0E4C",
            [
              30260
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              30260
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E21\u0E30\u0E19\u0E32\u0E27",
            [
              30260
            ]
          ],
          [
            "\u0E40\u0E17\u0E1E\u0E32\u0E25\u0E31\u0E22",
            [
              30260
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E04\u0E07",
            [
              30260
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E40\u0E15\u0E47\u0E07",
            [
              30260
            ]
          ]
        ]
      ],
      [
        "\u0E04\u0E23\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E04\u0E23\u0E1A\u0E38\u0E23\u0E35",
            [
              30250
            ]
          ],
          [
            "\u0E04\u0E23\u0E1A\u0E38\u0E23\u0E35\u0E43\u0E15\u0E49",
            [
              30250
            ]
          ],
          [
            "\u0E08\u0E23\u0E30\u0E40\u0E02\u0E49\u0E2B\u0E34\u0E19",
            [
              30250
            ]
          ],
          [
            "\u0E15\u0E30\u0E41\u0E1A\u0E01\u0E1A\u0E32\u0E19",
            [
              30250
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48",
            [
              30250
            ]
          ],
          [
            "\u0E21\u0E32\u0E1A\u0E15\u0E30\u0E42\u0E01\u0E40\u0E2D\u0E19",
            [
              30250
            ]
          ],
          [
            "\u0E25\u0E33\u0E40\u0E1E\u0E35\u0E22\u0E01",
            [
              30250
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E27\u0E48\u0E32\u0E19\u0E1E\u0E23\u0E30\u0E22\u0E32",
            [
              30250
            ]
          ],
          [
            "\u0E2D\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C",
            [
              30250
            ]
          ],
          [
            "\u0E40\u0E09\u0E25\u0E35\u0E22\u0E07",
            [
              30250
            ]
          ],
          [
            "\u0E41\u0E0A\u0E30",
            [
              30250
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E01\u0E23\u0E30\u0E0A\u0E32\u0E22",
            [
              30250
            ]
          ]
        ]
      ],
      [
        "\u0E08\u0E31\u0E01\u0E23\u0E32\u0E0A",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              30230
            ]
          ],
          [
            "\u0E08\u0E31\u0E01\u0E23\u0E32\u0E0A",
            [
              30230
            ]
          ],
          [
            "\u0E17\u0E2D\u0E07\u0E2B\u0E25\u0E32\u0E07",
            [
              30230
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E25\u0E30\u0E01\u0E2D",
            [
              30230
            ]
          ],
          [
            "\u0E2A\u0E35\u0E2A\u0E38\u0E01",
            [
              30230
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E32\u0E21",
            [
              30230
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1E\u0E25\u0E27\u0E07",
            [
              30230
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E42\u0E04\u0E19",
            [
              30230
            ]
          ]
        ]
      ],
      [
        "\u0E0A\u0E38\u0E21\u0E1E\u0E27\u0E07",
        [
          [
            "\u0E0A\u0E38\u0E21\u0E1E\u0E27\u0E07",
            [
              30270
            ]
          ],
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E44\u0E17\u0E23",
            [
              30270
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E25\u0E32\u0E14",
            [
              30270
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E2A\u0E38\u0E02",
            [
              30270
            ]
          ],
          [
            "\u0E2A\u0E32\u0E2B\u0E23\u0E48\u0E32\u0E22",
            [
              30270
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E25\u0E31\u0E01",
            [
              30270
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E15\u0E39\u0E21",
            [
              30270
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E22\u0E2D",
            [
              30270
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E23\u0E31\u0E07",
            [
              30270
            ]
          ]
        ]
      ],
      [
        "\u0E14\u0E48\u0E32\u0E19\u0E02\u0E38\u0E19\u0E17\u0E14",
        [
          [
            "\u0E01\u0E38\u0E14\u0E1E\u0E34\u0E21\u0E32\u0E19",
            [
              30210
            ]
          ],
          [
            "\u0E14\u0E48\u0E32\u0E19\u0E02\u0E38\u0E19\u0E17\u0E14",
            [
              30210
            ]
          ],
          [
            "\u0E14\u0E48\u0E32\u0E19\u0E19\u0E2D\u0E01",
            [
              30210
            ]
          ],
          [
            "\u0E14\u0E48\u0E32\u0E19\u0E43\u0E19",
            [
              30210
            ]
          ],
          [
            "\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              30210
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E01\u0E48\u0E32",
            [
              30210
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E1B\u0E23\u0E07",
            [
              36220
            ]
          ],
          [
            "\u0E1E\u0E31\u0E19\u0E0A\u0E19\u0E30",
            [
              30210
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E08\u0E23\u0E40\u0E02\u0E49",
            [
              30210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E23\u0E32\u0E14",
            [
              30210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E15\u0E30\u0E40\u0E01\u0E35\u0E22\u0E14",
            [
              30210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E25\u0E30\u0E04\u0E23",
            [
              30210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E17\u0E23",
            [
              36220
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E14\u0E32\u0E14",
            [
              30210
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E1A\u0E07",
            [
              30210
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              30210
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E31\u0E27\u0E25\u0E32\u0E22",
        [
          [
            "\u0E1A\u0E31\u0E27\u0E25\u0E32\u0E22",
            [
              30120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E27\u0E49\u0E32",
            [
              30120
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1E\u0E30\u0E44\u0E25",
            [
              30120
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E08\u0E32\u0E19",
            [
              30120
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E31\u0E27\u0E43\u0E2B\u0E0D\u0E48",
        [
          [
            "\u0E01\u0E38\u0E14\u0E08\u0E2D\u0E01",
            [
              30120
            ]
          ],
          [
            "\u0E02\u0E38\u0E19\u0E17\u0E2D\u0E07",
            [
              30120
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E15\u0E30\u0E2B\u0E19\u0E34\u0E19",
            [
              30120
            ]
          ],
          [
            "\u0E14\u0E48\u0E32\u0E19\u0E0A\u0E49\u0E32\u0E07",
            [
              30120
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E43\u0E2B\u0E0D\u0E48",
            [
              30120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              30120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E08\u0E49\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              30120
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E22\u0E32\u0E07",
            [
              30120
            ]
          ],
          [
            "\u0E40\u0E2A\u0E21\u0E32\u0E43\u0E2B\u0E0D\u0E48",
            [
              30120
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E17\u0E2D\u0E07\u0E2B\u0E25\u0E32\u0E07",
            [
              30120
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E2B\u0E25\u0E37\u0E48\u0E2D\u0E21",
        [
          [
            "\u0E0A\u0E48\u0E2D\u0E23\u0E30\u0E01\u0E32",
            [
              30350
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E2B\u0E25\u0E37\u0E48\u0E2D\u0E21",
            [
              30350
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              30350
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E01\u0E23\u0E30\u0E40\u0E1A\u0E37\u0E49\u0E2D\u0E07",
            [
              30350
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E23\u0E30\u0E17\u0E32\u0E22",
        [
          [
            "\u0E01\u0E23\u0E30\u0E17\u0E38\u0E48\u0E21\u0E23\u0E32\u0E22",
            [
              30180
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E21\u0E31\u0E19",
            [
              30180
            ]
          ],
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E44\u0E17\u0E23",
            [
              30180
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              30180
            ]
          ],
          [
            "\u0E19\u0E32\u0E07\u0E23\u0E33",
            [
              30180
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E17\u0E32\u0E22",
            [
              30180
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E44\u0E21\u0E49\u0E41\u0E14\u0E07",
            [
              30180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E04\u0E48\u0E32\u0E22",
            [
              30180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1E\u0E25\u0E27\u0E07",
            [
              30180
            ]
          ],
          [
            "\u0E2B\u0E31\u0E19\u0E2B\u0E49\u0E27\u0E22\u0E17\u0E23\u0E32\u0E22",
            [
              30180
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E42\u0E14\u0E19",
            [
              30180
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E01\u0E25\u0E32\u0E07",
            [
              30180
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E40\u0E1E\u0E47\u0E14",
            [
              30180
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E31\u0E01\u0E18\u0E07\u0E0A\u0E31\u0E22",
        [
          [
            "\u0E07\u0E34\u0E49\u0E27",
            [
              30150
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19",
            [
              30150
            ]
          ],
          [
            "\u0E15\u0E30\u0E02\u0E1A",
            [
              30150
            ]
          ],
          [
            "\u0E15\u0E30\u0E04\u0E38",
            [
              30150
            ]
          ],
          [
            "\u0E15\u0E39\u0E21",
            [
              30150
            ]
          ],
          [
            "\u0E18\u0E07\u0E0A\u0E31\u0E22\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              30150
            ]
          ],
          [
            "\u0E19\u0E01\u0E2D\u0E2D\u0E01",
            [
              30150
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E1B\u0E25\u0E32\u0E17\u0E2D\u0E07",
            [
              30150
            ]
          ],
          [
            "\u0E20\u0E39\u0E2B\u0E25\u0E27\u0E07",
            [
              30150
            ]
          ],
          [
            "\u0E25\u0E33\u0E19\u0E32\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              30150
            ]
          ],
          [
            "\u0E2A\u0E30\u0E41\u0E01\u0E23\u0E32\u0E0A",
            [
              30150
            ]
          ],
          [
            "\u0E2A\u0E33\u0E42\u0E23\u0E07",
            [
              30150
            ]
          ],
          [
            "\u0E2A\u0E38\u0E02\u0E40\u0E01\u0E29\u0E21",
            [
              30150
            ]
          ],
          [
            "\u0E40\u0E01\u0E29\u0E21\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C",
            [
              30150
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1B\u0E31\u0E01",
            [
              30150
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E44\u0E17\u0E22",
            [
              30150
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E32\u0E01\u0E0A\u0E48\u0E2D\u0E07",
        [
          [
            "\u0E01\u0E25\u0E32\u0E07\u0E14\u0E07",
            [
              30320
            ]
          ],
          [
            "\u0E02\u0E19\u0E07\u0E1E\u0E23\u0E30",
            [
              30450
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E21\u0E48\u0E27\u0E07",
            [
              30130
            ]
          ],
          [
            "\u0E08\u0E31\u0E19\u0E17\u0E36\u0E01",
            [
              30130
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E0A\u0E48\u0E2D\u0E07",
            [
              30130
            ]
          ],
          [
            "\u0E1E\u0E0D\u0E32\u0E40\u0E22\u0E47\u0E19",
            [
              30320
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E01\u0E30\u0E17\u0E30",
            [
              30130
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E44\u0E17\u0E23",
            [
              30130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E19\u0E49\u0E33\u0E41\u0E14\u0E07",
            [
              30450
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E32\u0E2B\u0E23\u0E48\u0E32\u0E22",
            [
              30130
            ]
          ],
          [
            "\u0E2B\u0E21\u0E39\u0E2A\u0E35",
            [
              30450
            ]
          ],
          [
            "\u0E42\u0E1B\u0E48\u0E07\u0E15\u0E32\u0E25\u0E2D\u0E07",
            [
              30450
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E23\u0E30\u0E17\u0E2D\u0E07\u0E04\u0E33",
        [
          [
            "\u0E17\u0E31\u0E1E\u0E23\u0E31\u0E49\u0E07",
            [
              30220
            ]
          ],
          [
            "\u0E1E\u0E31\u0E07\u0E40\u0E17\u0E35\u0E22\u0E21",
            [
              30220
            ]
          ],
          [
            "\u0E21\u0E32\u0E1A\u0E01\u0E23\u0E32\u0E14",
            [
              30220
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E1E\u0E23\u0E30",
            [
              30220
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E2D\u0E22",
            [
              30220
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E34\u0E21\u0E32\u0E22",
        [
          [
            "\u0E01\u0E23\u0E30\u0E0A\u0E2D\u0E19",
            [
              30110
            ]
          ],
          [
            "\u0E01\u0E23\u0E30\u0E40\u0E1A\u0E37\u0E49\u0E2D\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              30110
            ]
          ],
          [
            "\u0E0A\u0E35\u0E27\u0E32\u0E19",
            [
              30110
            ]
          ],
          [
            "\u0E14\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              30110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2B\u0E25\u0E27\u0E07",
            [
              30110
            ]
          ],
          [
            "\u0E18\u0E32\u0E23\u0E25\u0E30\u0E2B\u0E25\u0E2D\u0E14",
            [
              30110
            ]
          ],
          [
            "\u0E19\u0E34\u0E04\u0E21\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E15\u0E19\u0E40\u0E2D\u0E07",
            [
              30110
            ]
          ],
          [
            "\u0E23\u0E31\u0E07\u0E01\u0E32\u0E43\u0E2B\u0E0D\u0E48",
            [
              30110
            ]
          ],
          [
            "\u0E2A\u0E31\u0E21\u0E24\u0E17\u0E18\u0E34\u0E4C",
            [
              30110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E23\u0E30\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              30110
            ]
          ],
          [
            "\u0E42\u0E1A\u0E2A\u0E16\u0E4C",
            [
              30110
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              30110
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E33\u0E17\u0E30\u0E40\u0E21\u0E19\u0E0A\u0E31\u0E22",
        [
          [
            "\u0E02\u0E38\u0E22",
            [
              30270
            ]
          ],
          [
            "\u0E0A\u0E48\u0E2D\u0E07\u0E41\u0E21\u0E27",
            [
              30270
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E22\u0E32\u0E07",
            [
              30270
            ]
          ],
          [
            "\u0E44\u0E1E\u0E25",
            [
              30270
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E07\u0E19\u0E49\u0E33\u0E40\u0E02\u0E35\u0E22\u0E27",
        [
          [
            "\u0E23\u0E30\u0E40\u0E23\u0E34\u0E07",
            [
              30150
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E19\u0E49\u0E33\u0E40\u0E02\u0E35\u0E22\u0E27",
            [
              30370
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2B\u0E21\u0E35",
            [
              30370
            ]
          ],
          [
            "\u0E2D\u0E38\u0E14\u0E21\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C",
            [
              30370
            ]
          ],
          [
            "\u0E44\u0E17\u0E22\u0E2A\u0E32\u0E21\u0E31\u0E04\u0E04\u0E35",
            [
              30370
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E35\u0E04\u0E34\u0E49\u0E27",
        [
          [
            "\u0E01\u0E24\u0E29\u0E13\u0E32",
            [
              30140
            ]
          ],
          [
            "\u0E01\u0E38\u0E14\u0E19\u0E49\u0E2D\u0E22",
            [
              30140
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E44\u0E1C\u0E48",
            [
              30340
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              30140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E31\u0E19",
            [
              30140
            ]
          ],
          [
            "\u0E21\u0E34\u0E15\u0E23\u0E20\u0E32\u0E1E",
            [
              30140
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E1A\u0E31\u0E27\u0E02\u0E32\u0E27",
            [
              30340
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E42\u0E23\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              30140
            ]
          ],
          [
            "\u0E2A\u0E35\u0E04\u0E34\u0E49\u0E27",
            [
              30140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E19\u0E49\u0E33\u0E43\u0E2A",
            [
              30140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E19\u0E49\u0E2D\u0E22",
            [
              30140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E0D\u0E49\u0E32\u0E02\u0E32\u0E27",
            [
              30140
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E35\u0E14\u0E32",
        [
          [
            "\u0E2A\u0E32\u0E21\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              30430
            ]
          ],
          [
            "\u0E2A\u0E35\u0E14\u0E32",
            [
              30430
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E15\u0E32\u0E14\u0E43\u0E2B\u0E0D\u0E48",
            [
              30430
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E1B\u0E23\u0E30\u0E14\u0E39\u0E48",
            [
              30430
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E17\u0E2D\u0E07",
            [
              30430
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E39\u0E07\u0E40\u0E19\u0E34\u0E19",
        [
          [
            "\u0E01\u0E38\u0E14\u0E08\u0E34\u0E01",
            [
              30380
            ]
          ],
          [
            "\u0E19\u0E32\u0E01\u0E25\u0E32\u0E07",
            [
              30380
            ]
          ],
          [
            "\u0E1A\u0E38\u0E48\u0E07\u0E02\u0E35\u0E49\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              30170
            ]
          ],
          [
            "\u0E21\u0E30\u0E40\u0E01\u0E25\u0E37\u0E2D\u0E40\u0E01\u0E48\u0E32",
            [
              30170
            ]
          ],
          [
            "\u0E21\u0E30\u0E40\u0E01\u0E25\u0E37\u0E2D\u0E43\u0E2B\u0E21\u0E48",
            [
              30170
            ]
          ],
          [
            "\u0E2A\u0E39\u0E07\u0E40\u0E19\u0E34\u0E19",
            [
              30170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E15\u0E30\u0E44\u0E01\u0E49",
            [
              30380
            ]
          ],
          [
            "\u0E40\u0E2A\u0E21\u0E32",
            [
              30170
            ]
          ],
          [
            "\u0E42\u0E04\u0E23\u0E32\u0E0A",
            [
              30170
            ]
          ],
          [
            "\u0E42\u0E04\u0E49\u0E07\u0E22\u0E32\u0E07",
            [
              30170
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E04\u0E48\u0E32",
            [
              30170
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E38\u0E0D\u0E21\u0E32\u0E01",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48",
            [
              30410
            ]
          ],
          [
            "\u0E25\u0E38\u0E07\u0E40\u0E02\u0E27\u0E49\u0E32",
            [
              30410
            ]
          ],
          [
            "\u0E2A\u0E32\u0E23\u0E20\u0E35",
            [
              30410
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E15\u0E30\u0E44\u0E01\u0E49",
            [
              30410
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E38\u0E19\u0E19\u0E32\u0E01",
            [
              30410
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E31\u0E27\u0E41\u0E23\u0E15",
            [
              30410
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E21\u0E49\u0E44\u0E1C\u0E48",
            [
              30410
            ]
          ],
          [
            "\u0E41\u0E2B\u0E25\u0E21\u0E17\u0E2D\u0E07",
            [
              30410
            ]
          ],
          [
            "\u0E44\u0E17\u0E22\u0E40\u0E08\u0E23\u0E34\u0E0D",
            [
              30410
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E49\u0E27\u0E22\u0E41\u0E16\u0E25\u0E07",
        [
          [
            "\u0E01\u0E07\u0E23\u0E16",
            [
              30240
            ]
          ],
          [
            "\u0E07\u0E34\u0E49\u0E27",
            [
              30240
            ]
          ],
          [
            "\u0E15\u0E30\u0E42\u0E01",
            [
              30240
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E2A\u0E27\u0E32\u0E22",
            [
              30240
            ]
          ],
          [
            "\u0E2B\u0E25\u0E38\u0E48\u0E07\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              30240
            ]
          ],
          [
            "\u0E2B\u0E25\u0E38\u0E48\u0E07\u0E1B\u0E23\u0E30\u0E14\u0E39\u0E48",
            [
              30240
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E14\u0E32\u0E14",
            [
              30240
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E41\u0E04\u0E19",
            [
              30240
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E41\u0E16\u0E25\u0E07",
            [
              30240
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1E\u0E25\u0E31\u0E1A\u0E1E\u0E25\u0E32",
            [
              30240
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E09\u0E25\u0E34\u0E21\u0E1E\u0E23\u0E30\u0E40\u0E01\u0E35\u0E22\u0E23\u0E15\u0E34",
        [
          [
            "\u0E0A\u0E49\u0E32\u0E07\u0E17\u0E2D\u0E07",
            [
              30230
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E0A\u0E49\u0E32\u0E07",
            [
              30230
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E1E\u0E38\u0E17\u0E18",
            [
              30230
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E07\u0E39\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E21",
            [
              3e4
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E22\u0E32\u0E07",
            [
              30230
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E17\u0E1E\u0E32\u0E23\u0E31\u0E01\u0E29\u0E4C",
        [
          [
            "\u0E1A\u0E36\u0E07\u0E1B\u0E23\u0E37\u0E2D",
            [
              30210
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E22\u0E32\u0E22\u0E17\u0E2D\u0E07",
            [
              30210
            ]
          ],
          [
            "\u0E2A\u0E33\u0E19\u0E31\u0E01\u0E15\u0E30\u0E04\u0E23\u0E49\u0E2D",
            [
              30210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07",
            [
              30210
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E19\u0E04\u0E23\u0E23\u0E32\u0E0A\u0E2A\u0E35\u0E21\u0E32",
        [
          [
            "\u0E08\u0E2D\u0E2B\u0E2D",
            [
              30310
            ]
          ],
          [
            "\u0E15\u0E25\u0E32\u0E14",
            [
              30310
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E01\u0E32\u0E30",
            [
              3e4
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              30310
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48",
            [
              3e4
            ]
          ],
          [
            "\u0E1B\u0E23\u0E38\u0E43\u0E2B\u0E0D\u0E48",
            [
              3e4
            ]
          ],
          [
            "\u0E1E\u0E25\u0E01\u0E23\u0E31\u0E07",
            [
              3e4
            ]
          ],
          [
            "\u0E1E\u0E30\u0E40\u0E19\u0E32",
            [
              3e4
            ]
          ],
          [
            "\u0E1E\u0E38\u0E14\u0E0B\u0E32",
            [
              3e4
            ]
          ],
          [
            "\u0E21\u0E30\u0E40\u0E23\u0E34\u0E07",
            [
              3e4
            ]
          ],
          [
            "\u0E2A\u0E35\u0E21\u0E38\u0E21",
            [
              3e4
            ]
          ],
          [
            "\u0E2A\u0E38\u0E23\u0E19\u0E32\u0E23\u0E35",
            [
              3e4
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E17\u0E38\u0E48\u0E21",
            [
              3e4
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E08\u0E30\u0E1A\u0E01",
            [
              3e4
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E28\u0E32\u0E25\u0E32",
            [
              3e4
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E23\u0E30\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              3e4
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E02\u0E48\u0E19\u0E49\u0E33",
            [
              30310
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E1C\u0E48\u0E25\u0E49\u0E2D\u0E21",
            [
              3e4
            ]
          ],
          [
            "\u0E2B\u0E21\u0E37\u0E48\u0E19\u0E44\u0E27\u0E22",
            [
              3e4
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E17\u0E30\u0E40\u0E25",
            [
              3e4
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E01\u0E23\u0E27\u0E14",
            [
              30280
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E39\u0E07",
            [
              30310
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E01\u0E25\u0E32\u0E07",
            [
              3e4
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              3e4
            ]
          ],
          [
            "\u0E44\u0E0A\u0E22\u0E21\u0E07\u0E04\u0E25",
            [
              3e4
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E22\u0E32\u0E07",
        [
          [
            "\u0E01\u0E23\u0E30\u0E40\u0E1A\u0E37\u0E49\u0E2D\u0E07\u0E19\u0E2D\u0E01",
            [
              30270
            ]
          ],
          [
            "\u0E25\u0E30\u0E2B\u0E32\u0E19\u0E1B\u0E25\u0E32\u0E04\u0E49\u0E32\u0E27",
            [
              30270
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E22\u0E32\u0E07",
            [
              30270
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2D\u0E38\u0E14\u0E21",
            [
              30270
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E2A\u0E34\u0E07\u0E2A\u0E32\u0E07",
        [
          [
            "\u0E01\u0E38\u0E14\u0E42\u0E1A\u0E2A\u0E16\u0E4C",
            [
              30330
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E23\u0E32\u0E29\u0E0E\u0E23\u0E4C",
            [
              30330
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              30330
            ]
          ],
          [
            "\u0E2A\u0E38\u0E02\u0E44\u0E1E\u0E1A\u0E39\u0E25\u0E22\u0E4C",
            [
              30330
            ]
          ],
          [
            "\u0E40\u0E2A\u0E34\u0E07\u0E2A\u0E32\u0E07",
            [
              30330
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              30330
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E01\u0E49\u0E07\u0E2A\u0E19\u0E32\u0E21\u0E19\u0E32\u0E07",
        [
          [
            "\u0E1A\u0E36\u0E07\u0E1E\u0E30\u0E44\u0E25",
            [
              30440
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E2A\u0E33\u0E42\u0E23\u0E07",
            [
              30440
            ]
          ],
          [
            "\u0E2A\u0E35\u0E2A\u0E38\u0E01",
            [
              30440
            ]
          ],
          [
            "\u0E41\u0E01\u0E49\u0E07\u0E2A\u0E19\u0E32\u0E21\u0E19\u0E32\u0E07",
            [
              30440
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              30440
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E0A\u0E04\u0E0A\u0E31\u0E22",
        [
          [
            "\u0E01\u0E23\u0E30\u0E42\u0E17\u0E01",
            [
              30190
            ]
          ],
          [
            "\u0E14\u0E48\u0E32\u0E19\u0E40\u0E01\u0E27\u0E35\u0E22\u0E19",
            [
              30190
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2D\u0E23\u0E38\u0E13",
            [
              30190
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E08\u0E30\u0E2B\u0E25\u0E38\u0E07",
            [
              30190
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E25\u0E32\u0E14\u0E02\u0E32\u0E27",
            [
              30190
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2D\u0E48\u0E32\u0E07",
            [
              30190
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E22\u0E35\u0E48\u0E22\u0E21",
            [
              30190
            ]
          ],
          [
            "\u0E1E\u0E25\u0E31\u0E1A\u0E1E\u0E25\u0E32",
            [
              30190
            ]
          ],
          [
            "\u0E25\u0E30\u0E25\u0E21\u0E43\u0E2B\u0E21\u0E48\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              30190
            ]
          ],
          [
            "\u0E42\u0E0A\u0E04\u0E0A\u0E31\u0E22",
            [
              30190
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E19\u0E19\u0E2A\u0E39\u0E07",
        [
          [
            "\u0E02\u0E32\u0E21\u0E40\u0E12\u0E48\u0E32",
            [
              30160
            ]
          ],
          [
            "\u0E08\u0E31\u0E19\u0E2D\u0E31\u0E14",
            [
              30160
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E0A\u0E21\u0E1E\u0E39",
            [
              30160
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E2B\u0E27\u0E32\u0E22",
            [
              30160
            ]
          ],
          [
            "\u0E14\u0E48\u0E32\u0E19\u0E04\u0E25\u0E49\u0E32",
            [
              30160
            ]
          ],
          [
            "\u0E18\u0E32\u0E23\u0E1B\u0E23\u0E32\u0E2A\u0E32\u0E17",
            [
              30420
            ]
          ],
          [
            "\u0E1A\u0E34\u0E07",
            [
              30160
            ]
          ],
          [
            "\u0E1E\u0E25\u0E2A\u0E07\u0E04\u0E23\u0E32\u0E21",
            [
              30160
            ]
          ],
          [
            "\u0E21\u0E30\u0E04\u0E48\u0E32",
            [
              30160
            ]
          ],
          [
            "\u0E25\u0E33\u0E04\u0E2D\u0E2B\u0E07\u0E29\u0E4C",
            [
              30160
            ]
          ],
          [
            "\u0E25\u0E33\u0E21\u0E39\u0E25",
            [
              30160
            ]
          ],
          [
            "\u0E2B\u0E25\u0E38\u0E21\u0E02\u0E49\u0E32\u0E27",
            [
              30160
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1B\u0E23\u0E32\u0E2A\u0E32\u0E17",
            [
              30160
            ]
          ],
          [
            "\u0E42\u0E15\u0E19\u0E14",
            [
              30160
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E39\u0E07",
            [
              30160
            ]
          ],
          [
            "\u0E43\u0E2B\u0E21\u0E48",
            [
              30160
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E19\u0E19\u0E41\u0E14\u0E07",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E22\u0E32\u0E27\u0E43\u0E2B\u0E0D\u0E48",
            [
              30360
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2B\u0E34\u0E19",
            [
              30360
            ]
          ],
          [
            "\u0E2A\u0E33\u0E1E\u0E30\u0E40\u0E19\u0E35\u0E22\u0E07",
            [
              30360
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E15\u0E32\u0E40\u0E16\u0E23",
            [
              30360
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E41\u0E14\u0E07",
            [
              30360
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E19\u0E19\u0E44\u0E17\u0E22",
        [
          [
            "\u0E01\u0E33\u0E1B\u0E31\u0E07",
            [
              30220
            ]
          ],
          [
            "\u0E04\u0E49\u0E32\u0E07\u0E1E\u0E25\u0E39",
            [
              30220
            ]
          ],
          [
            "\u0E14\u0E48\u0E32\u0E19\u0E08\u0E32\u0E01",
            [
              30220
            ]
          ],
          [
            "\u0E16\u0E19\u0E19\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              30220
            ]
          ],
          [
            "\u0E1A\u0E31\u0E25\u0E25\u0E31\u0E07\u0E01\u0E4C",
            [
              30220
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E27\u0E31\u0E07",
            [
              30220
            ]
          ],
          [
            "\u0E21\u0E30\u0E04\u0E48\u0E32",
            [
              30220
            ]
          ],
          [
            "\u0E2A\u0E32\u0E22\u0E2D\u0E2D",
            [
              30220
            ]
          ],
          [
            "\u0E2A\u0E33\u0E42\u0E23\u0E07",
            [
              30220
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E44\u0E17\u0E22",
            [
              30220
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E19\u0E04\u0E23\u0E28\u0E23\u0E35\u0E18\u0E23\u0E23\u0E21\u0E23\u0E32\u0E0A",
    [
      [
        "\u0E02\u0E19\u0E2D\u0E21",
        [
          [
            "\u0E02\u0E19\u0E2D\u0E21",
            [
              80210
            ]
          ],
          [
            "\u0E04\u0E27\u0E19\u0E17\u0E2D\u0E07",
            [
              80210
            ]
          ],
          [
            "\u0E17\u0E49\u0E2D\u0E07\u0E40\u0E19\u0E35\u0E22\u0E19",
            [
              80210
            ]
          ]
        ]
      ],
      [
        "\u0E08\u0E38\u0E2C\u0E32\u0E20\u0E23\u0E13\u0E4C",
        [
          [
            "\u0E04\u0E27\u0E19\u0E2B\u0E19\u0E2D\u0E07\u0E04\u0E27\u0E49\u0E32",
            [
              80130
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              80130
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E21\u0E2D\u0E1A\u0E38\u0E0D",
            [
              80130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E04\u0E27\u0E19\u0E21\u0E38\u0E14",
            [
              80180
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E0A\u0E30\u0E2D\u0E27\u0E14",
            [
              80180
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E15\u0E33\u0E1A\u0E25",
            [
              80130
            ]
          ]
        ]
      ],
      [
        "\u0E09\u0E27\u0E32\u0E07",
        [
          [
            "\u0E01\u0E30\u0E40\u0E1B\u0E35\u0E22\u0E14",
            [
              80260
            ]
          ],
          [
            "\u0E08\u0E31\u0E19\u0E14\u0E35",
            [
              80250
            ]
          ],
          [
            "\u0E09\u0E27\u0E32\u0E07",
            [
              80150
            ]
          ],
          [
            "\u0E19\u0E32\u0E01\u0E30\u0E0A\u0E30",
            [
              80150
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E02\u0E25\u0E35\u0E22\u0E07",
            [
              80260
            ]
          ],
          [
            "\u0E19\u0E32\u0E41\u0E27",
            [
              80260
            ]
          ],
          [
            "\u0E25\u0E30\u0E2D\u0E32\u0E22",
            [
              80250
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E1B\u0E23\u0E34\u0E01",
            [
              80260
            ]
          ],
          [
            "\u0E44\u0E21\u0E49\u0E40\u0E23\u0E35\u0E22\u0E07",
            [
              80260
            ]
          ],
          [
            "\u0E44\u0E2A\u0E2B\u0E23\u0E49\u0E32",
            [
              80150
            ]
          ]
        ]
      ],
      [
        "\u0E0A\u0E30\u0E2D\u0E27\u0E14",
        [
          [
            "\u0E02\u0E2D\u0E19\u0E2B\u0E32\u0E14",
            [
              80180
            ]
          ],
          [
            "\u0E04\u0E27\u0E19\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E07\u0E29\u0E4C",
            [
              80180
            ]
          ],
          [
            "\u0E0A\u0E30\u0E2D\u0E27\u0E14",
            [
              80180
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E1B\u0E23\u0E30\u0E08\u0E30",
            [
              80180
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E2A\u0E21\u0E47\u0E14",
            [
              80180
            ]
          ],
          [
            "\u0E19\u0E32\u0E07\u0E2B\u0E25\u0E07",
            [
              80180
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E15\u0E39\u0E25",
            [
              80180
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2D\u0E48\u0E32\u0E07",
            [
              80180
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E02\u0E31\u0E19\u0E18\u0E4C",
            [
              80180
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E1E\u0E23\u0E30\u0E17\u0E2D\u0E07",
            [
              80180
            ]
          ],
          [
            "\u0E40\u0E04\u0E23\u0E47\u0E07",
            [
              80180
            ]
          ]
        ]
      ],
      [
        "\u0E0A\u0E49\u0E32\u0E07\u0E01\u0E25\u0E32\u0E07",
        [
          [
            "\u0E0A\u0E49\u0E32\u0E07\u0E01\u0E25\u0E32\u0E07",
            [
              80250
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E02\u0E31\u0E19",
            [
              80250
            ]
          ],
          [
            "\u0E2B\u0E25\u0E31\u0E01\u0E0A\u0E49\u0E32\u0E07",
            [
              80250
            ]
          ]
        ]
      ],
      [
        "\u0E16\u0E49\u0E33\u0E1E\u0E23\u0E23\u0E13\u0E23\u0E32",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E40\u0E2A",
            [
              80260
            ]
          ],
          [
            "\u0E14\u0E38\u0E2A\u0E34\u0E15",
            [
              80260
            ]
          ],
          [
            "\u0E16\u0E49\u0E33\u0E1E\u0E23\u0E23\u0E13\u0E23\u0E32",
            [
              80260
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E38\u0E48\u0E07\u0E2A\u0E07",
        [
          [
            "\u0E01\u0E30\u0E1B\u0E32\u0E07",
            [
              80310
            ]
          ],
          [
            "\u0E04\u0E27\u0E19\u0E01\u0E23\u0E14",
            [
              80110
            ]
          ],
          [
            "\u0E0A\u0E30\u0E21\u0E32\u0E22",
            [
              80110
            ]
          ],
          [
            "\u0E16\u0E49\u0E33\u0E43\u0E2B\u0E0D\u0E48",
            [
              80110
            ]
          ],
          [
            "\u0E17\u0E35\u0E48\u0E27\u0E31\u0E07",
            [
              80110
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E25\u0E27\u0E07\u0E40\u0E2A\u0E19",
            [
              80110
            ]
          ],
          [
            "\u0E19\u0E32\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              80110
            ]
          ],
          [
            "\u0E19\u0E32\u0E44\u0E21\u0E49\u0E44\u0E1C\u0E48",
            [
              80110
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E15\u0E01",
            [
              80110
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E41\u0E1E\u0E23\u0E01",
            [
              80110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E07\u0E2A\u0E4C",
            [
              80110
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E02\u0E32\u0E27",
            [
              80110
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E42\u0E23",
            [
              80110
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E38\u0E48\u0E07\u0E43\u0E2B\u0E0D\u0E48",
        [
          [
            "\u0E01\u0E23\u0E38\u0E07\u0E2B\u0E22\u0E31\u0E19",
            [
              80240
            ]
          ],
          [
            "\u0E01\u0E38\u0E41\u0E2B\u0E23\u0E30",
            [
              80240
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2A\u0E31\u0E07",
            [
              80240
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              80240
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E22\u0E32\u0E07",
            [
              80240
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E23\u0E39\u0E1B",
            [
              80240
            ]
          ],
          [
            "\u0E1B\u0E23\u0E34\u0E01",
            [
              80240
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E48\u0E32\u0E28\u0E32\u0E25\u0E32",
        [
          [
            "\u0E01\u0E25\u0E32\u0E22",
            [
              80160
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E15\u0E30\u0E42\u0E01",
            [
              80160
            ]
          ],
          [
            "\u0E15\u0E25\u0E34\u0E48\u0E07\u0E0A\u0E31\u0E19",
            [
              80160
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E36\u0E49\u0E19",
            [
              80160
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E28\u0E32\u0E25\u0E32",
            [
              80160
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E41\u0E01\u0E49\u0E27",
            [
              80160
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E15\u0E30\u0E1E\u0E32\u0E19",
            [
              80160
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E17\u0E2D\u0E07",
            [
              80160
            ]
          ],
          [
            "\u0E42\u0E21\u0E04\u0E25\u0E32\u0E19",
            [
              80160
            ]
          ],
          [
            "\u0E44\u0E17\u0E22\u0E1A\u0E38\u0E23\u0E35",
            [
              80160
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E1A\u0E1E\u0E34\u0E15\u0E33",
        [
          [
            "\u0E01\u0E23\u0E38\u0E07\u0E0A\u0E34\u0E07",
            [
              80160
            ]
          ],
          [
            "\u0E01\u0E30\u0E2B\u0E23\u0E2D",
            [
              80160
            ]
          ],
          [
            "\u0E19\u0E1A\u0E1E\u0E34\u0E15\u0E33",
            [
              80160
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E2B\u0E23\u0E07",
            [
              80160
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E1A\u0E2D\u0E19",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2A\u0E07",
            [
              80220
            ]
          ],
          [
            "\u0E19\u0E32\u0E1A\u0E2D\u0E19",
            [
              80220
            ]
          ],
          [
            "\u0E41\u0E01\u0E49\u0E27\u0E41\u0E2A\u0E19",
            [
              80220
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E02\u0E31\u0E19",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E02\u0E31\u0E19",
            [
              80360
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E34\u0E04\u0E21",
            [
              80360
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E25\u0E33\u0E19\u0E32\u0E27",
            [
              80360
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2B\u0E34\u0E19",
            [
              80360
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E32\u0E01\u0E1E\u0E19\u0E31\u0E07",
        [
          [
            "\u0E02\u0E19\u0E32\u0E1A\u0E19\u0E32\u0E01",
            [
              80140
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E1A\u0E37\u0E2D",
            [
              80370
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E19\u0E49\u0E2D\u0E22",
            [
              80330
            ]
          ],
          [
            "\u0E0A\u0E30\u0E40\u0E21\u0E32",
            [
              80330
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E1E\u0E22\u0E32",
            [
              80140
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E15\u0E30\u0E1E\u0E07",
            [
              80370
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E23\u0E30",
            [
              80140
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E28\u0E32\u0E25\u0E32",
            [
              80370
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E1E\u0E34\u0E07",
            [
              80140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48",
            [
              80370
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E1E\u0E19\u0E31\u0E07",
            [
              80140
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E1E\u0E19\u0E31\u0E07\u0E1D\u0E31\u0E48\u0E07\u0E15\u0E30\u0E27\u0E31\u0E19\u0E15\u0E01",
            [
              80370
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E1E\u0E19\u0E31\u0E07\u0E1D\u0E31\u0E48\u0E07\u0E15\u0E30\u0E27\u0E31\u0E19\u0E2D\u0E2D\u0E01",
            [
              80140
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E41\u0E1E\u0E23\u0E01",
            [
              80140
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E23\u0E30\u0E01\u0E33",
            [
              80370
            ]
          ],
          [
            "\u0E2B\u0E39\u0E25\u0E48\u0E2D\u0E07",
            [
              80370
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E17\u0E27\u0E14",
            [
              80330
            ]
          ],
          [
            "\u0E41\u0E2B\u0E25\u0E21\u0E15\u0E30\u0E25\u0E38\u0E21\u0E1E\u0E38\u0E01",
            [
              80140
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E23\u0E2B\u0E21\u0E04\u0E35\u0E23\u0E35",
        [
          [
            "\u0E17\u0E2D\u0E19\u0E2B\u0E07\u0E2A\u0E4C",
            [
              80320
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E23\u0E35\u0E22\u0E07",
            [
              80320
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E01\u0E32\u0E30",
            [
              80320
            ]
          ],
          [
            "\u0E1E\u0E23\u0E2B\u0E21\u0E42\u0E25\u0E01",
            [
              80320
            ]
          ],
          [
            "\u0E2D\u0E34\u0E19\u0E04\u0E35\u0E23\u0E35",
            [
              80320
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E23\u0E30\u0E1E\u0E23\u0E2B\u0E21",
        [
          [
            "\u0E0A\u0E49\u0E32\u0E07\u0E0B\u0E49\u0E32\u0E22",
            [
              8e4
            ]
          ],
          [
            "\u0E17\u0E49\u0E32\u0E22\u0E2A\u0E33\u0E40\u0E20\u0E32",
            [
              8e4
            ]
          ],
          [
            "\u0E19\u0E32\u0E1E\u0E23\u0E38",
            [
              8e4
            ]
          ],
          [
            "\u0E19\u0E32\u0E2A\u0E32\u0E23",
            [
              8e4
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E34\u0E1B\u0E39\u0E19",
        [
          [
            "\u0E01\u0E30\u0E17\u0E39\u0E19",
            [
              80270
            ]
          ],
          [
            "\u0E04\u0E27\u0E19\u0E01\u0E25\u0E32\u0E07",
            [
              80270
            ]
          ],
          [
            "\u0E1E\u0E34\u0E1B\u0E39\u0E19",
            [
              80270
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E04\u0E49\u0E2D\u0E21",
            [
              80270
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E1E\u0E23\u0E30",
            [
              80270
            ]
          ]
        ]
      ],
      [
        "\u0E23\u0E48\u0E2D\u0E19\u0E1E\u0E34\u0E1A\u0E39\u0E25\u0E22\u0E4C",
        [
          [
            "\u0E04\u0E27\u0E19\u0E0A\u0E38\u0E21",
            [
              80130
            ]
          ],
          [
            "\u0E04\u0E27\u0E19\u0E1E\u0E31\u0E07",
            [
              80130
            ]
          ],
          [
            "\u0E04\u0E27\u0E19\u0E40\u0E01\u0E22",
            [
              80130
            ]
          ],
          [
            "\u0E23\u0E48\u0E2D\u0E19\u0E1E\u0E34\u0E1A\u0E39\u0E25\u0E22\u0E4C",
            [
              80130
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E15\u0E01",
            [
              80350
            ]
          ],
          [
            "\u0E40\u0E2A\u0E32\u0E18\u0E07",
            [
              80350
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E32\u0E19\u0E2A\u0E01\u0E32",
        [
          [
            "\u0E01\u0E33\u0E42\u0E25\u0E19",
            [
              80230
            ]
          ],
          [
            "\u0E02\u0E38\u0E19\u0E17\u0E30\u0E40\u0E25",
            [
              80230
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E14\u0E35",
            [
              80230
            ]
          ],
          [
            "\u0E25\u0E32\u0E19\u0E2A\u0E01\u0E32",
            [
              80230
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E41\u0E01\u0E49\u0E27",
            [
              80230
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E34\u0E0A\u0E25",
        [
          [
            "\u0E09\u0E25\u0E2D\u0E07",
            [
              80120
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E1B\u0E23\u0E31\u0E07",
            [
              80120
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E43\u0E2A",
            [
              80120
            ]
          ],
          [
            "\u0E2A\u0E34\u0E0A\u0E25",
            [
              80120
            ]
          ],
          [
            "\u0E2A\u0E35\u0E48\u0E02\u0E35\u0E14",
            [
              80120
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E19\u0E49\u0E2D\u0E22",
            [
              80120
            ]
          ],
          [
            "\u0E40\u0E17\u0E1E\u0E23\u0E32\u0E0A",
            [
              80340
            ]
          ],
          [
            "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19",
            [
              80120
            ]
          ],
          [
            "\u0E40\u0E2A\u0E32\u0E40\u0E20\u0E32",
            [
              80340
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E31\u0E27\u0E44\u0E17\u0E23",
        [
          [
            "\u0E04\u0E27\u0E19\u0E0A\u0E30\u0E25\u0E34\u0E01",
            [
              80170
            ]
          ],
          [
            "\u0E17\u0E23\u0E32\u0E22\u0E02\u0E32\u0E27",
            [
              80170
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E0B\u0E2D\u0E21",
            [
              80170
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E19\u0E1A",
            [
              80170
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E23\u0E32\u0E21",
            [
              80170
            ]
          ],
          [
            "\u0E23\u0E32\u0E21\u0E41\u0E01\u0E49\u0E27",
            [
              80170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E49\u0E32\u0E2A\u0E15\u0E19",
            [
              80170
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E44\u0E17\u0E23",
            [
              80170
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E40\u0E1E\u0E0A\u0E23",
            [
              80170
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E1E\u0E31\u0E07\u0E44\u0E01\u0E23",
            [
              80170
            ]
          ],
          [
            "\u0E41\u0E2B\u0E25\u0E21",
            [
              80170
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E09\u0E25\u0E34\u0E21\u0E1E\u0E23\u0E30\u0E40\u0E01\u0E35\u0E22\u0E23\u0E15\u0E34",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E15\u0E23\u0E2D",
            [
              80290
            ]
          ],
          [
            "\u0E17\u0E32\u0E07\u0E1E\u0E39\u0E19",
            [
              80290
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E2B\u0E25\u0E27\u0E07",
            [
              80190
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E23\u0E40\u0E02\u0E32",
            [
              80190
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E0A\u0E35\u0E22\u0E23\u0E43\u0E2B\u0E0D\u0E48",
        [
          [
            "\u0E01\u0E32\u0E23\u0E30\u0E40\u0E01\u0E14",
            [
              80190
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E19\u0E32\u0E19",
            [
              80190
            ]
          ],
          [
            "\u0E17\u0E49\u0E2D\u0E07\u0E25\u0E33\u0E40\u0E08\u0E35\u0E22\u0E01",
            [
              80190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E25\u0E32\u0E07",
            [
              80190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E19\u0E34\u0E19",
            [
              80190
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E1E\u0E23\u0E30\u0E1A\u0E32\u0E17",
            [
              80190
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E23\u0E43\u0E2B\u0E0D\u0E48",
            [
              80190
            ]
          ],
          [
            "\u0E40\u0E2A\u0E37\u0E2D\u0E2B\u0E36\u0E07",
            [
              80190
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E40\u0E08\u0E49\u0E32\u0E2D\u0E22\u0E39\u0E48\u0E2B\u0E31\u0E27",
            [
              80190
            ]
          ],
          [
            "\u0E44\u0E2A\u0E2B\u0E21\u0E32\u0E01",
            [
              80190
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E19\u0E04\u0E23\u0E28\u0E23\u0E35\u0E18\u0E23\u0E23\u0E21\u0E23\u0E32\u0E0A",
        [
          [
            "\u0E01\u0E33\u0E41\u0E1E\u0E07\u0E40\u0E0B\u0E32",
            [
              80280
            ]
          ],
          [
            "\u0E04\u0E25\u0E31\u0E07",
            [
              8e4
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E07\u0E34\u0E49\u0E27",
            [
              80280
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E0B\u0E31\u0E01",
            [
              8e4
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E27\u0E31\u0E07",
            [
              8e4
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E23\u0E37\u0E2D",
            [
              8e4
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E44\u0E23\u0E48",
            [
              8e4
            ]
          ],
          [
            "\u0E19\u0E32\u0E17\u0E23\u0E32\u0E22",
            [
              80280
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              8e4
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E08\u0E32\u0E01",
            [
              80330
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E19\u0E04\u0E23",
            [
              8e4
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E1E\u0E39\u0E19",
            [
              8e4
            ]
          ],
          [
            "\u0E21\u0E30\u0E21\u0E48\u0E27\u0E07\u0E2A\u0E2D\u0E07\u0E15\u0E49\u0E19",
            [
              8e4
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E40\u0E2A\u0E14\u0E47\u0E08",
            [
              8e4
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              8e4
            ]
          ],
          [
            "\u0E44\u0E0A\u0E22\u0E21\u0E19\u0E15\u0E23\u0E35",
            [
              8e4
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E19\u0E04\u0E23\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
    [
      [
        "\u0E0A\u0E38\u0E21\u0E15\u0E32\u0E1A\u0E07",
        [
          [
            "\u0E0A\u0E38\u0E21\u0E15\u0E32\u0E1A\u0E07",
            [
              60150
            ]
          ],
          [
            "\u0E1B\u0E32\u0E07\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
            [
              60150
            ]
          ]
        ]
      ],
      [
        "\u0E0A\u0E38\u0E21\u0E41\u0E2A\u0E07",
        [
          [
            "\u0E06\u0E30\u0E21\u0E31\u0E07",
            [
              60120
            ]
          ],
          [
            "\u0E0A\u0E38\u0E21\u0E41\u0E2A\u0E07",
            [
              60120
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E01\u0E24\u0E0A",
            [
              60250
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E01\u0E24\u0E0A\u0E43\u0E15\u0E49",
            [
              60250
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E44\u0E21\u0E49",
            [
              60120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              60120
            ]
          ],
          [
            "\u0E1E\u0E31\u0E19\u0E25\u0E32\u0E19",
            [
              60250
            ]
          ],
          [
            "\u0E1E\u0E34\u0E01\u0E38\u0E25",
            [
              60120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E40\u0E08\u0E32",
            [
              60120
            ]
          ],
          [
            "\u0E40\u0E01\u0E22\u0E44\u0E0A\u0E22",
            [
              60120
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2B\u0E21\u0E49\u0E2D",
            [
              60120
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
            [
              60120
            ]
          ]
        ]
      ],
      [
        "\u0E15\u0E32\u0E01\u0E1F\u0E49\u0E32",
        [
          [
            "\u0E15\u0E32\u0E01\u0E1F\u0E49\u0E32",
            [
              60190
            ]
          ],
          [
            "\u0E1E\u0E38\u0E19\u0E01\u0E22\u0E39\u0E07",
            [
              60190
            ]
          ],
          [
            "\u0E25\u0E33\u0E1E\u0E22\u0E19\u0E15\u0E4C",
            [
              60190
            ]
          ],
          [
            "\u0E2A\u0E38\u0E02\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              60190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1E\u0E34\u0E01\u0E38\u0E25",
            [
              60190
            ]
          ],
          [
            "\u0E2D\u0E38\u0E14\u0E21\u0E18\u0E31\u0E0D\u0E0D\u0E32",
            [
              60190
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E0A\u0E32\u0E22\u0E18\u0E07",
            [
              60190
            ]
          ]
        ]
      ],
      [
        "\u0E15\u0E32\u0E04\u0E25\u0E35",
        [
          [
            "\u0E08\u0E31\u0E19\u0E40\u0E2A\u0E19",
            [
              60260
            ]
          ],
          [
            "\u0E0A\u0E48\u0E2D\u0E07\u0E41\u0E04",
            [
              60210
            ]
          ],
          [
            "\u0E15\u0E32\u0E04\u0E25\u0E35",
            [
              60140
            ]
          ],
          [
            "\u0E1E\u0E23\u0E2B\u0E21\u0E19\u0E34\u0E21\u0E34\u0E15",
            [
              60210
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E17\u0E34\u0E1E\u0E23\u0E2A",
            [
              60260
            ]
          ],
          [
            "\u0E2A\u0E23\u0E49\u0E2D\u0E22\u0E17\u0E2D\u0E07",
            [
              60210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E21\u0E49\u0E2D",
            [
              60140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E1E",
            [
              60140
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E2B\u0E27\u0E32\u0E22",
            [
              60140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E2B\u0E2D\u0E21",
            [
              60210
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E48\u0E32\u0E15\u0E30\u0E42\u0E01",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E04\u0E32",
            [
              60160
            ]
          ],
          [
            "\u0E17\u0E33\u0E19\u0E1A",
            [
              60160
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E15\u0E30\u0E42\u0E01",
            [
              60160
            ]
          ],
          [
            "\u0E1E\u0E19\u0E21\u0E23\u0E2D\u0E01",
            [
              60160
            ]
          ],
          [
            "\u0E1E\u0E19\u0E21\u0E40\u0E28\u0E29",
            [
              60160
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E21\u0E2B\u0E32\u0E01\u0E23",
            [
              60160
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              60160
            ]
          ],
          [
            "\u0E2A\u0E32\u0E22\u0E25\u0E33\u0E42\u0E1E\u0E07",
            [
              60160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              60160
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E16\u0E19\u0E19",
            [
              60160
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E23\u0E23\u0E1E\u0E15\u0E1E\u0E34\u0E2A\u0E31\u0E22",
        [
          [
            "\u0E14\u0E48\u0E32\u0E19\u0E0A\u0E49\u0E32\u0E07",
            [
              60180
            ]
          ],
          [
            "\u0E15\u0E32\u0E02\u0E35\u0E14",
            [
              60180
            ]
          ],
          [
            "\u0E15\u0E32\u0E2A\u0E31\u0E07",
            [
              60180
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E07\u0E34\u0E49\u0E27",
            [
              60180
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E15\u0E32\u0E2B\u0E07\u0E32\u0E22",
            [
              60180
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              60180
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E1B\u0E25\u0E32\u0E17\u0E39",
            [
              60180
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E14\u0E19",
            [
              60180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E23\u0E14",
            [
              60180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E15\u0E32\u0E07\u0E39",
            [
              60180
            ]
          ],
          [
            "\u0E2B\u0E39\u0E01\u0E27\u0E32\u0E07",
            [
              60180
            ]
          ],
          [
            "\u0E2D\u0E48\u0E32\u0E07\u0E17\u0E2D\u0E07",
            [
              60180
            ]
          ],
          [
            "\u0E40\u0E08\u0E23\u0E34\u0E0D\u0E1C\u0E25",
            [
              60180
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E22\u0E38\u0E2B\u0E30\u0E04\u0E35\u0E23\u0E35",
        [
          [
            "\u0E17\u0E48\u0E32\u0E19\u0E49\u0E33\u0E2D\u0E49\u0E2D\u0E22",
            [
              60130
            ]
          ],
          [
            "\u0E19\u0E34\u0E04\u0E21\u0E40\u0E02\u0E32\u0E1A\u0E48\u0E2D\u0E41\u0E01\u0E49\u0E27",
            [
              60130
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E17\u0E23\u0E07",
            [
              60130
            ]
          ],
          [
            "\u0E1E\u0E22\u0E38\u0E2B\u0E30",
            [
              60130
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E2B\u0E31\u0E01",
            [
              60130
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E02\u0E32\u0E27",
            [
              60130
            ]
          ],
          [
            "\u0E22\u0E48\u0E32\u0E19\u0E21\u0E31\u0E17\u0E23\u0E35",
            [
              60130
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E17\u0E30\u0E40\u0E25",
            [
              60130
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E01\u0E30\u0E25\u0E32",
            [
              60130
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E17\u0E2D\u0E07",
            [
              60130
            ]
          ],
          [
            "\u0E40\u0E19\u0E34\u0E19\u0E21\u0E30\u0E01\u0E2D\u0E01",
            [
              60130
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E32\u0E14\u0E22\u0E32\u0E27",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E44\u0E23\u0E48",
            [
              60150
            ]
          ],
          [
            "\u0E21\u0E32\u0E1A\u0E41\u0E01",
            [
              60150
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E22\u0E32\u0E27",
            [
              60150
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E21\u0E49\u0E32",
            [
              60150
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              60150
            ]
          ],
          [
            "\u0E28\u0E32\u0E25\u0E40\u0E08\u0E49\u0E32\u0E44\u0E01\u0E48\u0E15\u0E48\u0E2D",
            [
              60150
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E41\u0E01\u0E49\u0E27",
            [
              60150
            ]
          ],
          [
            "\u0E2A\u0E23\u0E49\u0E2D\u0E22\u0E25\u0E30\u0E04\u0E23",
            [
              60150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E19\u0E21\u0E27\u0E31\u0E27",
            [
              60150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E22\u0E32\u0E27",
            [
              60150
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E19\u0E49\u0E33\u0E2B\u0E2D\u0E21",
            [
              60150
            ]
          ],
          [
            "\u0E40\u0E19\u0E34\u0E19\u0E02\u0E35\u0E49\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              60150
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E17\u0E2D\u0E07",
            [
              60110
            ]
          ],
          [
            "\u0E18\u0E32\u0E23\u0E17\u0E2B\u0E32\u0E23",
            [
              60110
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E1A\u0E48\u0E2D",
            [
              60110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E25\u0E31\u0E1A",
            [
              60110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              60110
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E16\u0E31\u0E48\u0E27\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              60110
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E16\u0E31\u0E48\u0E27\u0E43\u0E15\u0E49",
            [
              60110
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E23\u0E48\u0E27\u0E21",
            [
              60110
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E43\u0E2B\u0E0D\u0E48",
            [
              60110
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E01\u0E49\u0E32\u0E40\u0E25\u0E35\u0E49\u0E22\u0E27",
        [
          [
            "\u0E21\u0E2B\u0E32\u0E42\u0E1E\u0E18\u0E34",
            [
              60230
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E15\u0E48\u0E32",
            [
              60230
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E14\u0E07",
            [
              60230
            ]
          ],
          [
            "\u0E40\u0E01\u0E49\u0E32\u0E40\u0E25\u0E35\u0E49\u0E22\u0E27",
            [
              60230
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E14\u0E34\u0E19",
            [
              60230
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E19\u0E04\u0E23\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
        [
          [
            "\u0E01\u0E25\u0E32\u0E07\u0E41\u0E14\u0E14",
            [
              6e4
            ]
          ],
          [
            "\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19",
            [
              6e4
            ]
          ],
          [
            "\u0E19\u0E04\u0E23\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C\u0E15\u0E01",
            [
              6e4
            ]
          ],
          [
            "\u0E19\u0E04\u0E23\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C\u0E2D\u0E2D\u0E01",
            [
              6e4
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E23\u0E30\u0E2B\u0E25\u0E27\u0E07",
            [
              6e4
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E21\u0E48\u0E27\u0E07",
            [
              6e4
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E40\u0E2A\u0E19\u0E32\u0E17",
            [
              6e4
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E21\u0E30\u0E40\u0E01\u0E25\u0E37\u0E2D",
            [
              6e4
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E01\u0E48\u0E07",
            [
              6e4
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E19\u0E49\u0E33\u0E42\u0E1E",
            [
              6e4
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E19\u0E2D\u0E19",
            [
              6e4
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E44\u0E17\u0E23\u0E22\u0E4C",
            [
              6e4
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E23\u0E14",
            [
              60240
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E42\u0E14\u0E19",
            [
              60240
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E25\u0E34\u0E07",
            [
              6e4
            ]
          ],
          [
            "\u0E40\u0E01\u0E23\u0E35\u0E22\u0E07\u0E44\u0E01\u0E23",
            [
              6e4
            ]
          ],
          [
            "\u0E41\u0E04\u0E27\u0E43\u0E2B\u0E0D\u0E48",
            [
              6e4
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E27\u0E07\u0E01\u0E4C",
        [
          [
            "\u0E27\u0E31\u0E07\u0E0B\u0E48\u0E32\u0E19",
            [
              60150
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E0A\u0E19\u0E01\u0E31\u0E19",
            [
              60150
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E27\u0E07\u0E01\u0E4C",
            [
              60150
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E40\u0E25\u0E48\u0E22\u0E4C",
            [
              60150
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E40\u0E1B\u0E34\u0E19",
        [
          [
            "\u0E41\u0E21\u0E48\u0E40\u0E1B\u0E34\u0E19",
            [
              60150
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E01\u0E23\u0E01\u0E1E\u0E23\u0E30",
        [
          [
            "\u0E19\u0E32\u0E01\u0E25\u0E32\u0E07",
            [
              60170
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1B\u0E23\u0E30\u0E21\u0E38\u0E07",
            [
              60170
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E21\u0E30\u0E1D\u0E48\u0E2D",
            [
              60170
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E15\u0E32\u0E25",
            [
              60170
            ]
          ],
          [
            "\u0E28\u0E32\u0E25\u0E32\u0E41\u0E14\u0E07",
            [
              60170
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E2A\u0E39\u0E07",
            [
              60170
            ]
          ],
          [
            "\u0E40\u0E19\u0E34\u0E19\u0E01\u0E27\u0E49\u0E32\u0E27",
            [
              60170
            ]
          ],
          [
            "\u0E40\u0E19\u0E34\u0E19\u0E28\u0E32\u0E25\u0E32",
            [
              60170
            ]
          ],
          [
            "\u0E42\u0E01\u0E23\u0E01\u0E1E\u0E23\u0E30",
            [
              60170
            ]
          ]
        ]
      ],
      [
        "\u0E44\u0E1E\u0E28\u0E32\u0E25\u0E35",
        [
          [
            "\u0E15\u0E30\u0E04\u0E23\u0E49\u0E2D",
            [
              60220
            ]
          ],
          [
            "\u0E19\u0E32\u0E02\u0E2D\u0E21",
            [
              60220
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E02\u0E48\u0E2D\u0E22",
            [
              60220
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E19\u0E49\u0E33\u0E25\u0E31\u0E14",
            [
              60220
            ]
          ],
          [
            "\u0E2A\u0E33\u0E42\u0E23\u0E07\u0E0A\u0E31\u0E22",
            [
              60220
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E40\u0E14\u0E37\u0E48\u0E2D",
            [
              60220
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E1B\u0E23\u0E30\u0E2A\u0E32\u0E17",
            [
              60220
            ]
          ],
          [
            "\u0E44\u0E1E\u0E28\u0E32\u0E25\u0E35",
            [
              60220
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E19\u0E19\u0E17\u0E1A\u0E38\u0E23\u0E35",
    [
      [
        "\u0E1A\u0E32\u0E07\u0E01\u0E23\u0E27\u0E22",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E23\u0E27\u0E22",
            [
              11130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E02\u0E19\u0E38\u0E19",
            [
              11130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E02\u0E38\u0E19\u0E01\u0E2D\u0E07",
            [
              11130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E04\u0E39\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              11130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2A\u0E35\u0E17\u0E2D\u0E07",
            [
              11130
            ]
          ],
          [
            "\u0E1B\u0E25\u0E32\u0E22\u0E1A\u0E32\u0E07",
            [
              11130
            ]
          ],
          [
            "\u0E21\u0E2B\u0E32\u0E2A\u0E27\u0E31\u0E2A\u0E14\u0E34\u0E4C",
            [
              11130
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E0A\u0E25\u0E2D",
            [
              11130
            ]
          ],
          [
            "\u0E28\u0E32\u0E25\u0E32\u0E01\u0E25\u0E32\u0E07",
            [
              11130
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E1A\u0E31\u0E27\u0E17\u0E2D\u0E07",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E04\u0E39\u0E23\u0E31\u0E14",
            [
              11110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1A\u0E31\u0E27\u0E17\u0E2D\u0E07",
            [
              11110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E23\u0E31\u0E01\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              11110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E23\u0E31\u0E01\u0E43\u0E2B\u0E0D\u0E48",
            [
              11110
            ]
          ],
          [
            "\u0E1E\u0E34\u0E21\u0E25\u0E23\u0E32\u0E0A",
            [
              11110
            ]
          ],
          [
            "\u0E25\u0E30\u0E2B\u0E32\u0E23",
            [
              11110
            ]
          ],
          [
            "\u0E25\u0E33\u0E42\u0E1E",
            [
              11110
            ]
          ],
          [
            "\u0E42\u0E2A\u0E19\u0E25\u0E2D\u0E22",
            [
              11110
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E43\u0E2B\u0E0D\u0E48",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E21\u0E48\u0E27\u0E07",
            [
              11140
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E25\u0E19",
            [
              11140
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E41\u0E21\u0E48\u0E19\u0E32\u0E07",
            [
              11140
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              11140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48",
            [
              11140
            ]
          ],
          [
            "\u0E40\u0E2A\u0E32\u0E18\u0E07\u0E2B\u0E34\u0E19",
            [
              11140
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E32\u0E01\u0E40\u0E01\u0E23\u0E47\u0E14",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E02\u0E48\u0E2D\u0E22",
            [
              11120
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E1E\u0E23\u0E30\u0E2D\u0E38\u0E14\u0E21",
            [
              11120
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E40\u0E01\u0E25\u0E37\u0E2D",
            [
              11120
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2D\u0E34\u0E10",
            [
              11120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E15\u0E25\u0E32\u0E14",
            [
              11120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E15\u0E30\u0E44\u0E19\u0E22\u0E4C",
            [
              11120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E25\u0E31\u0E1A",
            [
              11120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E39\u0E14",
            [
              11120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48",
            [
              11120
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E40\u0E01\u0E23\u0E47\u0E14",
            [
              11120
            ]
          ],
          [
            "\u0E2D\u0E49\u0E2D\u0E21\u0E40\u0E01\u0E23\u0E47\u0E14",
            [
              11120
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E40\u0E01\u0E23\u0E47\u0E14",
            [
              11120
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E19\u0E19\u0E17\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E02\u0E27\u0E31\u0E0D",
            [
              11e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E17\u0E23\u0E32\u0E22",
            [
              11e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E23\u0E30\u0E2A\u0E2D",
            [
              11e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E23\u0E48\u0E32\u0E07",
            [
              11e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E23\u0E31\u0E01\u0E19\u0E49\u0E2D\u0E22",
            [
              11e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E28\u0E23\u0E35\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              11e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E02\u0E19",
            [
              11e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E44\u0E1C\u0E48",
            [
              11e3
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E43\u0E2B\u0E0D\u0E48",
            [
              11e3
            ]
          ],
          [
            "\u0E44\u0E17\u0E23\u0E21\u0E49\u0E32",
            [
              11e3
            ]
          ]
        ]
      ],
      [
        "\u0E44\u0E17\u0E23\u0E19\u0E49\u0E2D\u0E22",
        [
          [
            "\u0E02\u0E38\u0E19\u0E28\u0E23\u0E35",
            [
              11150
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E02\u0E27\u0E32\u0E07",
            [
              11150
            ]
          ],
          [
            "\u0E17\u0E27\u0E35\u0E27\u0E31\u0E12\u0E19\u0E32",
            [
              11150
            ]
          ],
          [
            "\u0E23\u0E32\u0E29\u0E0E\u0E23\u0E4C\u0E19\u0E34\u0E22\u0E21",
            [
              11150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E1E\u0E23\u0E32\u0E07\u0E32\u0E22",
            [
              11150
            ]
          ],
          [
            "\u0E44\u0E17\u0E23\u0E19\u0E49\u0E2D\u0E22",
            [
              11150
            ]
          ],
          [
            "\u0E44\u0E17\u0E23\u0E43\u0E2B\u0E0D\u0E48",
            [
              11150
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E19\u0E23\u0E32\u0E18\u0E34\u0E27\u0E32\u0E2A",
    [
      [
        "\u0E08\u0E30\u0E41\u0E19\u0E30",
        [
          [
            "\u0E08\u0E30\u0E41\u0E19\u0E30",
            [
              96220
            ]
          ],
          [
            "\u0E0A\u0E49\u0E32\u0E07\u0E40\u0E1C\u0E37\u0E2D\u0E01",
            [
              96220
            ]
          ],
          [
            "\u0E14\u0E38\u0E0B\u0E07\u0E0D\u0E2D",
            [
              96220
            ]
          ],
          [
            "\u0E1C\u0E14\u0E38\u0E07\u0E21\u0E32\u0E15\u0E23",
            [
              96220
            ]
          ]
        ]
      ],
      [
        "\u0E15\u0E32\u0E01\u0E43\u0E1A",
        [
          [
            "\u0E19\u0E32\u0E19\u0E32\u0E04",
            [
              96110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E02\u0E38\u0E19\u0E17\u0E2D\u0E07",
            [
              96110
            ]
          ],
          [
            "\u0E1E\u0E23\u0E48\u0E2D\u0E19",
            [
              96110
            ]
          ],
          [
            "\u0E28\u0E32\u0E25\u0E32\u0E43\u0E2B\u0E21\u0E48",
            [
              96110
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E2A\u0E30\u0E17\u0E49\u0E2D\u0E19",
            [
              96110
            ]
          ],
          [
            "\u0E40\u0E08\u0E4A\u0E30\u0E40\u0E2B",
            [
              96110
            ]
          ],
          [
            "\u0E42\u0E06\u0E29\u0E34\u0E15",
            [
              96110
            ]
          ],
          [
            "\u0E44\u0E1E\u0E23\u0E27\u0E31\u0E19",
            [
              96110
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E40\u0E08\u0E32\u0E30",
        [
          [
            "\u0E01\u0E32\u0E40\u0E22\u0E32\u0E30\u0E21\u0E32\u0E15\u0E35",
            [
              96170
            ]
          ],
          [
            "\u0E1A\u0E32\u0E40\u0E08\u0E32\u0E30",
            [
              96170
            ]
          ],
          [
            "\u0E1A\u0E32\u0E40\u0E23\u0E30\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              96170
            ]
          ],
          [
            "\u0E1A\u0E32\u0E40\u0E23\u0E30\u0E43\u0E15\u0E49",
            [
              96170
            ]
          ],
          [
            "\u0E1B\u0E30\u0E25\u0E38\u0E01\u0E32\u0E2A\u0E32\u0E40\u0E21\u0E32\u0E30",
            [
              96170
            ]
          ],
          [
            "\u0E25\u0E38\u0E42\u0E1A\u0E30\u0E2A\u0E32\u0E27\u0E2D",
            [
              96170
            ]
          ]
        ]
      ],
      [
        "\u0E22\u0E35\u0E48\u0E07\u0E2D",
        [
          [
            "\u0E08\u0E2D\u0E40\u0E1A\u0E32\u0E30",
            [
              96180
            ]
          ],
          [
            "\u0E15\u0E30\u0E1B\u0E2D\u0E40\u0E22\u0E32\u0E30",
            [
              96180
            ]
          ],
          [
            "\u0E22\u0E35\u0E48\u0E07\u0E2D",
            [
              96180
            ]
          ],
          [
            "\u0E25\u0E30\u0E2B\u0E32\u0E23",
            [
              96180
            ]
          ],
          [
            "\u0E25\u0E38\u0E42\u0E1A\u0E30\u0E1A\u0E32\u0E22\u0E30",
            [
              96180
            ]
          ],
          [
            "\u0E25\u0E38\u0E42\u0E1A\u0E30\u0E1A\u0E37\u0E2D\u0E0B\u0E32",
            [
              96180
            ]
          ]
        ]
      ],
      [
        "\u0E23\u0E30\u0E41\u0E07\u0E30",
        [
          [
            "\u0E01\u0E32\u0E25\u0E34\u0E0B\u0E32",
            [
              96130
            ]
          ],
          [
            "\u0E15\u0E31\u0E19\u0E2B\u0E22\u0E07\u0E21\u0E31\u0E2A",
            [
              96130
            ]
          ],
          [
            "\u0E15\u0E31\u0E19\u0E2B\u0E22\u0E07\u0E25\u0E34\u0E21\u0E2D",
            [
              96130
            ]
          ],
          [
            "\u0E1A\u0E2D\u0E07\u0E2D",
            [
              96220
            ]
          ],
          [
            "\u0E1A\u0E32\u0E42\u0E07\u0E2A\u0E30\u0E42\u0E15",
            [
              96130
            ]
          ],
          [
            "\u0E21\u0E30\u0E23\u0E37\u0E2D\u0E42\u0E1A\u0E15\u0E01",
            [
              96130
            ]
          ],
          [
            "\u0E40\u0E09\u0E25\u0E34\u0E21",
            [
              96130
            ]
          ]
        ]
      ],
      [
        "\u0E23\u0E37\u0E2D\u0E40\u0E2A\u0E32\u0E30",
        [
          [
            "\u0E1A\u0E32\u0E15\u0E07",
            [
              96150
            ]
          ],
          [
            "\u0E23\u0E37\u0E2D\u0E40\u0E2A\u0E32\u0E30",
            [
              96150
            ]
          ],
          [
            "\u0E23\u0E37\u0E2D\u0E40\u0E2A\u0E32\u0E30\u0E2D\u0E2D\u0E01",
            [
              96150
            ]
          ],
          [
            "\u0E25\u0E32\u0E42\u0E25\u0E30",
            [
              96150
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E31\u0E04\u0E04\u0E35",
            [
              96150
            ]
          ],
          [
            "\u0E2A\u0E32\u0E27\u0E2D",
            [
              96150
            ]
          ],
          [
            "\u0E2A\u0E38\u0E27\u0E32\u0E23\u0E35",
            [
              96150
            ]
          ],
          [
            "\u0E40\u0E23\u0E35\u0E22\u0E07",
            [
              96150
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E30\u0E15\u0E2D",
            [
              96150
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E2A\u0E32\u0E04\u0E23",
        [
          [
            "\u0E01\u0E32\u0E2B\u0E25\u0E07",
            [
              96210
            ]
          ],
          [
            "\u0E0B\u0E32\u0E01\u0E2D",
            [
              96210
            ]
          ],
          [
            "\u0E15\u0E30\u0E21\u0E30\u0E22\u0E39\u0E07",
            [
              96210
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E1A\u0E23\u0E23\u0E1E\u0E15",
            [
              96210
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E32\u0E04\u0E23",
            [
              96210
            ]
          ],
          [
            "\u0E40\u0E0A\u0E34\u0E07\u0E04\u0E35\u0E23\u0E35",
            [
              96210
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E38\u0E04\u0E34\u0E23\u0E34\u0E19",
        [
          [
            "\u0E20\u0E39\u0E40\u0E02\u0E32\u0E17\u0E2D\u0E07",
            [
              96190
            ]
          ],
          [
            "\u0E21\u0E32\u0E42\u0E21\u0E07",
            [
              96190
            ]
          ],
          [
            "\u0E23\u0E48\u0E21\u0E44\u0E17\u0E23",
            [
              96190
            ]
          ],
          [
            "\u0E2A\u0E38\u0E04\u0E34\u0E23\u0E34\u0E19",
            [
              96190
            ]
          ],
          [
            "\u0E40\u0E01\u0E35\u0E22\u0E23\u0E4C",
            [
              96190
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E38\u0E44\u0E2B\u0E07\u0E1B\u0E32\u0E14\u0E35",
        [
          [
            "\u0E01\u0E32\u0E27\u0E30",
            [
              96140
            ]
          ],
          [
            "\u0E1B\u0E30\u0E25\u0E38\u0E23\u0E39",
            [
              96140
            ]
          ],
          [
            "\u0E23\u0E34\u0E42\u0E01\u0E4B",
            [
              96140
            ]
          ],
          [
            "\u0E2A\u0E32\u0E01\u0E2D",
            [
              96140
            ]
          ],
          [
            "\u0E2A\u0E38\u0E44\u0E2B\u0E07\u0E1B\u0E32\u0E14\u0E35",
            [
              96140
            ]
          ],
          [
            "\u0E42\u0E15\u0E4A\u0E30\u0E40\u0E14\u0E47\u0E07",
            [
              96140
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E38\u0E44\u0E2B\u0E07\u0E42\u0E01-\u0E25\u0E01",
        [
          [
            "\u0E1B\u0E32\u0E40\u0E2A\u0E21\u0E31\u0E2A",
            [
              96120
            ]
          ],
          [
            "\u0E1B\u0E39\u0E42\u0E22\u0E30",
            [
              96120
            ]
          ],
          [
            "\u0E21\u0E39\u0E42\u0E19\u0E30",
            [
              96120
            ]
          ],
          [
            "\u0E2A\u0E38\u0E44\u0E2B\u0E07\u0E42\u0E01-\u0E25\u0E01",
            [
              96120
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E08\u0E32\u0E30\u0E44\u0E2D\u0E23\u0E49\u0E2D\u0E07",
        [
          [
            "\u0E08\u0E27\u0E1A",
            [
              96130
            ]
          ],
          [
            "\u0E1A\u0E39\u0E01\u0E34\u0E15",
            [
              96130
            ]
          ],
          [
            "\u0E21\u0E30\u0E23\u0E37\u0E2D\u0E42\u0E1A\u0E2D\u0E2D\u0E01",
            [
              96130
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E19\u0E23\u0E32\u0E18\u0E34\u0E27\u0E32\u0E2A",
        [
          [
            "\u0E01\u0E30\u0E25\u0E38\u0E27\u0E2D",
            [
              96e3
            ]
          ],
          [
            "\u0E01\u0E30\u0E25\u0E38\u0E27\u0E2D\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              96e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E19\u0E32\u0E04",
            [
              96e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1B\u0E2D",
            [
              96e3
            ]
          ],
          [
            "\u0E21\u0E30\u0E19\u0E31\u0E07\u0E15\u0E32\u0E22\u0E2D",
            [
              96e3
            ]
          ],
          [
            "\u0E25\u0E33\u0E20\u0E39",
            [
              96e3
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              96e3
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E27\u0E49\u0E07",
        [
          [
            "\u0E01\u0E32\u0E22\u0E39\u0E04\u0E25\u0E30",
            [
              96160
            ]
          ],
          [
            "\u0E06\u0E2D\u0E40\u0E25\u0E32\u0E30",
            [
              96160
            ]
          ],
          [
            "\u0E40\u0E2D\u0E23\u0E32\u0E27\u0E31\u0E13",
            [
              96160
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E14\u0E07",
            [
              96160
            ]
          ],
          [
            "\u0E41\u0E27\u0E49\u0E07",
            [
              96160
            ]
          ],
          [
            "\u0E42\u0E25\u0E30\u0E08\u0E39\u0E14",
            [
              96160
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E19\u0E48\u0E32\u0E19",
    [
      [
        "\u0E17\u0E38\u0E48\u0E07\u0E0A\u0E49\u0E32\u0E07",
        [
          [
            "\u0E07\u0E2D\u0E1A",
            [
              55130
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E0A\u0E49\u0E32\u0E07",
            [
              55130
            ]
          ],
          [
            "\u0E1B\u0E2D\u0E19",
            [
              55130
            ]
          ],
          [
            "\u0E41\u0E25\u0E30",
            [
              55130
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E48\u0E32\u0E27\u0E31\u0E07\u0E1C\u0E32",
        [
          [
            "\u0E08\u0E2D\u0E21\u0E1E\u0E23\u0E30",
            [
              55140
            ]
          ],
          [
            "\u0E15\u0E32\u0E25\u0E0A\u0E38\u0E21",
            [
              55140
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E27\u0E31\u0E07\u0E1C\u0E32",
            [
              55140
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E04\u0E32",
            [
              55140
            ]
          ],
          [
            "\u0E1C\u0E32\u0E15\u0E2D",
            [
              55140
            ]
          ],
          [
            "\u0E1C\u0E32\u0E17\u0E2D\u0E07",
            [
              55140
            ]
          ],
          [
            "\u0E22\u0E21",
            [
              55140
            ]
          ],
          [
            "\u0E23\u0E34\u0E21",
            [
              55140
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E20\u0E39\u0E21\u0E34",
            [
              55140
            ]
          ],
          [
            "\u0E41\u0E2A\u0E19\u0E17\u0E2D\u0E07",
            [
              55140
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E19\u0E49\u0E2D\u0E22",
        [
          [
            "\u0E19\u0E32\u0E19\u0E49\u0E2D\u0E22",
            [
              55150
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E15\u0E01",
            [
              55150
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E43\u0E2B\u0E0D\u0E48",
            [
              55150
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E29\u0E30\u0E40\u0E01\u0E29",
            [
              55150
            ]
          ],
          [
            "\u0E2A\u0E16\u0E32\u0E19",
            [
              55150
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E17\u0E30",
            [
              55150
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E02\u0E2D\u0E07",
            [
              55150
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E2B\u0E21\u0E37\u0E48\u0E19",
        [
          [
            "\u0E19\u0E32\u0E17\u0E30\u0E19\u0E38\u0E07",
            [
              55180
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E41\u0E01\u0E49\u0E27",
            [
              55180
            ]
          ],
          [
            "\u0E1B\u0E34\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              55180
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E25\u0E35",
            [
              55180
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E48\u0E2D\u0E40\u0E01\u0E25\u0E37\u0E2D",
        [
          [
            "\u0E14\u0E07\u0E1E\u0E0D\u0E32",
            [
              55220
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E40\u0E01\u0E25\u0E37\u0E2D\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              55220
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E40\u0E01\u0E25\u0E37\u0E2D\u0E43\u0E15\u0E49",
            [
              55220
            ]
          ],
          [
            "\u0E20\u0E39\u0E1F\u0E49\u0E32",
            [
              55220
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E25\u0E27\u0E07",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1E\u0E35\u0E49",
            [
              55190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1F\u0E49\u0E32",
            [
              55190
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E04\u0E32\u0E2B\u0E25\u0E27\u0E07",
            [
              55190
            ]
          ],
          [
            "\u0E2A\u0E27\u0E14",
            [
              55190
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E31\u0E27",
        [
          [
            "\u0E1B\u0E31\u0E27",
            [
              55120
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E01\u0E25\u0E32\u0E07",
            [
              55120
            ]
          ],
          [
            "\u0E20\u0E39\u0E04\u0E32",
            [
              55120
            ]
          ],
          [
            "\u0E27\u0E23\u0E19\u0E04\u0E23",
            [
              55120
            ]
          ],
          [
            "\u0E28\u0E34\u0E25\u0E32\u0E40\u0E1E\u0E0A\u0E23",
            [
              55120
            ]
          ],
          [
            "\u0E28\u0E34\u0E25\u0E32\u0E41\u0E25\u0E07",
            [
              55120
            ]
          ],
          [
            "\u0E2A\u0E01\u0E32\u0E14",
            [
              55120
            ]
          ],
          [
            "\u0E2A\u0E16\u0E32\u0E19",
            [
              55120
            ]
          ],
          [
            "\u0E2D\u0E27\u0E19",
            [
              55120
            ]
          ],
          [
            "\u0E40\u0E08\u0E14\u0E35\u0E22\u0E4C\u0E0A\u0E31\u0E22",
            [
              55120
            ]
          ],
          [
            "\u0E41\u0E07\u0E07",
            [
              55120
            ]
          ],
          [
            "\u0E44\u0E0A\u0E22\u0E27\u0E31\u0E12\u0E19\u0E32",
            [
              55120
            ]
          ]
        ]
      ],
      [
        "\u0E20\u0E39\u0E40\u0E1E\u0E35\u0E22\u0E07",
        [
          [
            "\u0E17\u0E48\u0E32\u0E19\u0E49\u0E32\u0E27",
            [
              55e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E1B\u0E31\u0E07",
            [
              55e3
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E40\u0E01\u0E35\u0E4B\u0E22\u0E19",
            [
              55e3
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E41\u0E01\u0E48\u0E19",
            [
              55e3
            ]
          ],
          [
            "\u0E1D\u0E32\u0E22\u0E41\u0E01\u0E49\u0E27",
            [
              55e3
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E15\u0E36\u0E4A\u0E14",
            [
              55e3
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E08\u0E31\u0E07",
            [
              55e3
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E2D\u0E07\u0E41\u0E04\u0E27",
        [
          [
            "\u0E0A\u0E19\u0E41\u0E14\u0E19",
            [
              55160
            ]
          ],
          [
            "\u0E19\u0E32\u0E44\u0E23\u0E48\u0E2B\u0E25\u0E27\u0E07",
            [
              55160
            ]
          ],
          [
            "\u0E22\u0E2D\u0E14",
            [
              55160
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E31\u0E19\u0E15\u0E34\u0E2A\u0E38\u0E02",
        [
          [
            "\u0E14\u0E39\u0E48\u0E1E\u0E07\u0E29\u0E4C",
            [
              55210
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E41\u0E25\u0E27\u0E2B\u0E25\u0E27\u0E07",
            [
              55210
            ]
          ],
          [
            "\u0E1E\u0E07\u0E29\u0E4C",
            [
              55210
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E09\u0E25\u0E34\u0E21\u0E1E\u0E23\u0E30\u0E40\u0E01\u0E35\u0E22\u0E23\u0E15\u0E34",
        [
          [
            "\u0E02\u0E38\u0E19\u0E19\u0E48\u0E32\u0E19",
            [
              55130
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E42\u0E01\u0E4B\u0E19",
            [
              55130
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E01\u0E25\u0E32\u0E07",
        [
          [
            "\u0E1E\u0E0D\u0E32\u0E41\u0E01\u0E49\u0E27",
            [
              55160
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E18\u0E32\u0E15\u0E38",
            [
              55160
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E1E\u0E38\u0E17\u0E18\u0E1A\u0E32\u0E17",
            [
              55160
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E01\u0E25\u0E32\u0E07",
            [
              55160
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E04\u0E32\u0E19",
            [
              55160
            ]
          ],
          [
            "\u0E40\u0E1B\u0E37\u0E2D",
            [
              55160
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E19\u0E48\u0E32\u0E19",
        [
          [
            "\u0E01\u0E2D\u0E07\u0E04\u0E27\u0E32\u0E22",
            [
              55e3
            ]
          ],
          [
            "\u0E14\u0E39\u0E48\u0E43\u0E15\u0E49",
            [
              55e3
            ]
          ],
          [
            "\u0E16\u0E37\u0E21\u0E15\u0E2D\u0E07",
            [
              55e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E0B\u0E32\u0E27",
            [
              55e3
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D",
            [
              55e3
            ]
          ],
          [
            "\u0E1C\u0E32\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
            [
              55e3
            ]
          ],
          [
            "\u0E2A\u0E27\u0E01",
            [
              55e3
            ]
          ],
          [
            "\u0E2A\u0E30\u0E40\u0E19\u0E35\u0E22\u0E19",
            [
              55e3
            ]
          ],
          [
            "\u0E40\u0E23\u0E37\u0E2D\u0E07",
            [
              55e3
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              55e3
            ]
          ],
          [
            "\u0E44\u0E0A\u0E22\u0E2A\u0E16\u0E32\u0E19",
            [
              55e3
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E2A\u0E32",
        [
          [
            "\u0E01\u0E25\u0E32\u0E07\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              55110
            ]
          ],
          [
            "\u0E02\u0E36\u0E48\u0E07",
            [
              55110
            ]
          ],
          [
            "\u0E08\u0E2D\u0E21\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
            [
              55110
            ]
          ],
          [
            "\u0E15\u0E32\u0E25\u0E0A\u0E38\u0E21",
            [
              55110
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E28\u0E23\u0E35\u0E17\u0E2D\u0E07",
            [
              55110
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E07",
            [
              55110
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E1B\u0E31\u0E49\u0E27",
            [
              55110
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E21\u0E27\u0E1A",
            [
              55110
            ]
          ],
          [
            "\u0E1B\u0E07\u0E2A\u0E19\u0E38\u0E01",
            [
              55110
            ]
          ],
          [
            "\u0E22\u0E32\u0E1A\u0E2B\u0E31\u0E27\u0E19\u0E32",
            [
              55110
            ]
          ],
          [
            "\u0E2A\u0E49\u0E32\u0E19",
            [
              55110
            ]
          ],
          [
            "\u0E2A\u0E49\u0E32\u0E19\u0E19\u0E32\u0E2B\u0E19\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48",
            [
              55110
            ]
          ],
          [
            "\u0E2D\u0E48\u0E32\u0E22\u0E19\u0E32\u0E44\u0E25\u0E22",
            [
              55110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E02\u0E30\u0E19\u0E34\u0E07",
            [
              55110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E32",
            [
              55110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E32\u0E04\u0E23",
            [
              55110
            ]
          ],
          [
            "\u0E44\u0E2B\u0E25\u0E48\u0E19\u0E48\u0E32\u0E19",
            [
              55110
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E08\u0E23\u0E34\u0E21",
        [
          [
            "\u0E19\u0E49\u0E33\u0E1B\u0E32\u0E22",
            [
              55170
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E1E\u0E32\u0E07",
            [
              55170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E14\u0E07",
            [
              55170
            ]
          ],
          [
            "\u0E2B\u0E21\u0E2D\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              55170
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E08\u0E23\u0E34\u0E21",
            [
              55170
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E1A\u0E36\u0E07\u0E01\u0E32\u0E2C",
    [
      [
        "\u0E1A\u0E36\u0E07\u0E42\u0E02\u0E07\u0E2B\u0E25\u0E07",
        [
          [
            "\u0E14\u0E07\u0E1A\u0E31\u0E07",
            [
              38220
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E14\u0E2D\u0E01\u0E04\u0E33",
            [
              38220
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E42\u0E02\u0E07\u0E2B\u0E25\u0E07",
            [
              38220
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E2B\u0E21\u0E32\u0E01\u0E41\u0E02\u0E49\u0E07",
            [
              38220
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E38\u0E48\u0E07\u0E04\u0E25\u0E49\u0E32",
        [
          [
            "\u0E1A\u0E38\u0E48\u0E07\u0E04\u0E25\u0E49\u0E32",
            [
              38e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E14\u0E34\u0E48\u0E19",
            [
              38e3
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E01\u0E27\u0E49\u0E32\u0E07",
            [
              38e3
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E32\u0E01\u0E04\u0E32\u0E14",
        [
          [
            "\u0E19\u0E32\u0E01\u0E31\u0E49\u0E07",
            [
              38190
            ]
          ],
          [
            "\u0E19\u0E32\u0E14\u0E07",
            [
              38190
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E04\u0E32\u0E14",
            [
              38190
            ]
          ],
          [
            "\u0E2A\u0E21\u0E2A\u0E19\u0E38\u0E01",
            [
              38190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E22\u0E2D\u0E07",
            [
              38190
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E28\u0E34\u0E25\u0E32",
            [
              38190
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E23\u0E40\u0E08\u0E23\u0E34\u0E0D",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E2B\u0E0D\u0E49\u0E32\u0E19\u0E32\u0E07",
            [
              38180
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E41\u0E1D\u0E01",
            [
              38180
            ]
          ],
          [
            "\u0E1E\u0E23\u0E40\u0E08\u0E23\u0E34\u0E0D",
            [
              38180
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E0A\u0E21\u0E20\u0E39",
            [
              38180
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E0A\u0E21\u0E20\u0E39",
            [
              38180
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              38180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E31\u0E27\u0E0A\u0E49\u0E32\u0E07",
            [
              38180
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E27\u0E34\u0E44\u0E25",
        [
          [
            "\u0E0A\u0E38\u0E21\u0E20\u0E39\u0E1E\u0E23",
            [
              38210
            ]
          ],
          [
            "\u0E19\u0E32\u0E2A\u0E30\u0E41\u0E1A\u0E07",
            [
              38210
            ]
          ],
          [
            "\u0E19\u0E32\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
            [
              38210
            ]
          ],
          [
            "\u0E19\u0E32\u0E41\u0E2A\u0E07",
            [
              38210
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E27\u0E34\u0E44\u0E25",
            [
              38210
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E0B\u0E01\u0E32",
        [
          [
            "\u0E0B\u0E32\u0E07",
            [
              38150
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E01\u0E01\u0E41\u0E14\u0E07",
            [
              38150
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              38150
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E08\u0E31\u0E49\u0E19",
            [
              38150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E15\u0E49\u0E2D\u0E07",
            [
              38150
            ]
          ],
          [
            "\u0E1B\u0E48\u0E07\u0E44\u0E2E",
            [
              38150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E17\u0E38\u0E48\u0E21",
            [
              38150
            ]
          ],
          [
            "\u0E40\u0E0B\u0E01\u0E32",
            [
              38150
            ]
          ],
          [
            "\u0E42\u0E2A\u0E01\u0E01\u0E48\u0E32\u0E21",
            [
              38150
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1A\u0E36\u0E07\u0E01\u0E32\u0E2C",
        [
          [
            "\u0E04\u0E33\u0E19\u0E32\u0E14\u0E35",
            [
              38e3
            ]
          ],
          [
            "\u0E0A\u0E31\u0E22\u0E1E\u0E23",
            [
              38e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
            [
              38e3
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E01\u0E32\u0E2C",
            [
              38e3
            ]
          ],
          [
            "\u0E27\u0E34\u0E28\u0E34\u0E29\u0E10\u0E4C",
            [
              38e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E02\u0E47\u0E07",
            [
              38e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E25\u0E34\u0E07",
            [
              38e3
            ]
          ],
          [
            "\u0E2B\u0E2D\u0E04\u0E33",
            [
              38e3
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E01\u0E48\u0E2D\u0E07",
            [
              38e3
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              38e3
            ]
          ],
          [
            "\u0E42\u0E1B\u0E48\u0E07\u0E40\u0E1B\u0E37\u0E2D\u0E22",
            [
              38e3
            ]
          ],
          [
            "\u0E44\u0E04\u0E2A\u0E35",
            [
              38e3
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E0B\u0E48\u0E1E\u0E34\u0E2A\u0E31\u0E22",
        [
          [
            "\u0E04\u0E33\u0E41\u0E01\u0E49\u0E27",
            [
              38170
            ]
          ],
          [
            "\u0E16\u0E49\u0E33\u0E40\u0E08\u0E23\u0E34\u0E0D",
            [
              38170
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E15\u0E39\u0E21",
            [
              38170
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E0A\u0E21\u0E20\u0E39",
            [
              38170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1E\u0E31\u0E19\u0E17\u0E32",
            [
              38170
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E17\u0E2D\u0E07",
            [
              38170
            ]
          ],
          [
            "\u0E42\u0E0B\u0E48",
            [
              38170
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E1A\u0E38\u0E23\u0E35\u0E23\u0E31\u0E21\u0E22\u0E4C",
    [
      [
        "\u0E01\u0E23\u0E30\u0E2A\u0E31\u0E07",
        [
          [
            "\u0E01\u0E23\u0E30\u0E2A\u0E31\u0E07",
            [
              31160
            ]
          ],
          [
            "\u0E01\u0E31\u0E19\u0E17\u0E23\u0E32\u0E23\u0E21\u0E22\u0E4C",
            [
              31160
            ]
          ],
          [
            "\u0E0A\u0E38\u0E21\u0E41\u0E2A\u0E07",
            [
              31160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1B\u0E23\u0E37\u0E2D",
            [
              31160
            ]
          ],
          [
            "\u0E25\u0E33\u0E14\u0E27\u0E19",
            [
              31160
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E20\u0E39\u0E21\u0E34",
            [
              31160
            ]
          ],
          [
            "\u0E2A\u0E2D\u0E07\u0E0A\u0E31\u0E49\u0E19",
            [
              31160
            ]
          ],
          [
            "\u0E2A\u0E39\u0E07\u0E40\u0E19\u0E34\u0E19",
            [
              31160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E15\u0E47\u0E07",
            [
              31160
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              31160
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E44\u0E1C\u0E48",
            [
              31160
            ]
          ]
        ]
      ],
      [
        "\u0E04\u0E39\u0E40\u0E21\u0E37\u0E2D\u0E07",
        [
          [
            "\u0E04\u0E39\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              31190
            ]
          ],
          [
            "\u0E15\u0E39\u0E21\u0E43\u0E2B\u0E0D\u0E48",
            [
              31190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E1E",
            [
              31190
            ]
          ],
          [
            "\u0E1B\u0E30\u0E40\u0E04\u0E35\u0E22\u0E1A",
            [
              31190
            ]
          ],
          [
            "\u0E1E\u0E23\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              31190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E21\u0E32\u0E23",
            [
              31190
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E40\u0E2B\u0E25\u0E47\u0E01\u0E44\u0E1F",
            [
              31190
            ]
          ]
        ]
      ],
      [
        "\u0E0A\u0E33\u0E19\u0E34",
        [
          [
            "\u0E0A\u0E33\u0E19\u0E34",
            [
              31110
            ]
          ],
          [
            "\u0E0A\u0E48\u0E2D\u0E1C\u0E01\u0E32",
            [
              31110
            ]
          ],
          [
            "\u0E25\u0E30\u0E25\u0E27\u0E14",
            [
              31110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E25\u0E48\u0E2D\u0E07",
            [
              31110
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E22\u0E32\u0E07",
            [
              31110
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E19\u0E27\u0E19",
            [
              31110
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E07\u0E23\u0E2D\u0E07",
        [
          [
            "\u0E01\u0E49\u0E32\u0E19\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E07",
            [
              31110
            ]
          ],
          [
            "\u0E0A\u0E38\u0E21\u0E41\u0E2A\u0E07",
            [
              31110
            ]
          ],
          [
            "\u0E16\u0E19\u0E19\u0E2B\u0E31\u0E01",
            [
              31110
            ]
          ],
          [
            "\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C\u0E1E\u0E23\u0E30\u0E22\u0E32",
            [
              31110
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E41\u0E2A\u0E07\u0E17\u0E2D\u0E07",
            [
              31110
            ]
          ],
          [
            "\u0E19\u0E32\u0E07\u0E23\u0E2D\u0E07",
            [
              31110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
            [
              31110
            ]
          ],
          [
            "\u0E25\u0E33\u0E44\u0E17\u0E23\u0E42\u0E22\u0E07",
            [
              31110
            ]
          ],
          [
            "\u0E2A\u0E30\u0E40\u0E14\u0E32",
            [
              31110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E07",
            [
              31110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E22\u0E32\u0E22\u0E1E\u0E34\u0E21\u0E1E\u0E4C",
            [
              31110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E1A\u0E2A\u0E16\u0E4C",
            [
              31110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E2A\u0E19",
            [
              31110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E17\u0E23",
            [
              31110
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E16\u0E19\u0E19",
            [
              31110
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E42\u0E1E\u0E18\u0E34\u0E4C",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E01\u0E2D\u0E01",
            [
              31230
            ]
          ],
          [
            "\u0E19\u0E32\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              31230
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E04\u0E39",
            [
              31230
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E14\u0E39\u0E48",
            [
              31230
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              31230
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E23\u0E27\u0E14",
        [
          [
            "\u0E08\u0E31\u0E19\u0E17\u0E1A\u0E40\u0E1E\u0E0A\u0E23",
            [
              31180
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E40\u0E08\u0E23\u0E34\u0E0D",
            [
              31180
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E23\u0E27\u0E14",
            [
              31180
            ]
          ],
          [
            "\u0E1B\u0E23\u0E32\u0E2A\u0E32\u0E17",
            [
              31180
            ]
          ],
          [
            "\u0E2A\u0E32\u0E22\u0E15\u0E30\u0E01\u0E39",
            [
              31180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E21\u0E49\u0E07\u0E32\u0E21",
            [
              31180
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E25\u0E32\u0E14",
            [
              31180
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E14\u0E34\u0E19\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              31180
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E40\u0E08\u0E23\u0E34\u0E0D",
            [
              31180
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E14\u0E48\u0E32\u0E19",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E14\u0E48\u0E32\u0E19",
            [
              31e3
            ]
          ],
          [
            "\u0E1B\u0E23\u0E32\u0E2A\u0E32\u0E17",
            [
              31e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              31e3
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E02\u0E27\u0E32\u0E07",
            [
              31e3
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48\u0E44\u0E0A\u0E22\u0E1E\u0E08\u0E19\u0E4C",
        [
          [
            "\u0E01\u0E39\u0E48\u0E2A\u0E27\u0E19\u0E41\u0E15\u0E07",
            [
              31120
            ]
          ],
          [
            "\u0E17\u0E2D\u0E07\u0E2B\u0E25\u0E32\u0E07",
            [
              31120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E22\u0E37\u0E2D\u0E07",
            [
              31120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07",
            [
              31120
            ]
          ],
          [
            "\u0E41\u0E14\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              31120
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E23\u0E30\u0E42\u0E04\u0E19\u0E0A\u0E31\u0E22",
        [
          [
            "\u0E08\u0E23\u0E40\u0E02\u0E49\u0E21\u0E32\u0E01",
            [
              31140
            ]
          ],
          [
            "\u0E15\u0E30\u0E42\u0E01\u0E15\u0E32\u0E1E\u0E34",
            [
              31140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E44\u0E17\u0E23",
            [
              31140
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E17\u0E31\u0E14\u0E1A\u0E38",
            [
              31140
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E42\u0E04\u0E19\u0E0A\u0E31\u0E22",
            [
              31140
            ]
          ],
          [
            "\u0E1B\u0E31\u0E07\u0E01\u0E39",
            [
              31140
            ]
          ],
          [
            "\u0E25\u0E30\u0E40\u0E27\u0E35\u0E49\u0E22",
            [
              31140
            ]
          ],
          [
            "\u0E2A\u0E35\u0E48\u0E40\u0E2B\u0E25\u0E35\u0E48\u0E22\u0E21",
            [
              31140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E2D\u0E19",
            [
              31140
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E04\u0E2D\u0E01",
            [
              31140
            ]
          ],
          [
            "\u0E41\u0E2A\u0E25\u0E07\u0E42\u0E17\u0E19",
            [
              31140
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E15\u0E39\u0E21",
            [
              31140
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E21\u0E30\u0E02\u0E32\u0E21",
            [
              31140
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E21\u0E49\u0E32",
            [
              31140
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E22\u0E48\u0E32\u0E07",
            [
              31140
            ]
          ],
          [
            "\u0E44\u0E1E\u0E28\u0E32\u0E25",
            [
              31140
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E30\u0E04\u0E33",
        [
          [
            "\u0E1B\u0E30\u0E04\u0E33",
            [
              31220
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              31220
            ]
          ],
          [
            "\u0E2B\u0E39\u0E17\u0E33\u0E19\u0E1A",
            [
              31220
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E21\u0E30\u0E21\u0E48\u0E27\u0E07",
            [
              31220
            ]
          ],
          [
            "\u0E44\u0E17\u0E22\u0E40\u0E08\u0E23\u0E34\u0E0D",
            [
              31220
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E25\u0E31\u0E1A\u0E1E\u0E25\u0E32\u0E0A\u0E31\u0E22",
        [
          [
            "\u0E08\u0E31\u0E19\u0E14\u0E38\u0E21",
            [
              31250
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E0A\u0E31\u0E19",
            [
              31250
            ]
          ],
          [
            "\u0E2A\u0E30\u0E40\u0E14\u0E32",
            [
              31250
            ]
          ],
          [
            "\u0E2A\u0E33\u0E42\u0E23\u0E07",
            [
              31250
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E02\u0E21\u0E34\u0E49\u0E19",
            [
              31250
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E38\u0E17\u0E44\u0E18\u0E2A\u0E07",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E08\u0E32\u0E19",
            [
              31120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E22\u0E32\u0E07",
            [
              31120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E1B\u0E49\u0E32",
            [
              31120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E27\u0E07",
            [
              31120
            ]
          ],
          [
            "\u0E1E\u0E38\u0E17\u0E44\u0E18\u0E2A\u0E07",
            [
              31120
            ]
          ],
          [
            "\u0E21\u0E30\u0E40\u0E1F\u0E37\u0E2D\u0E07",
            [
              31120
            ]
          ],
          [
            "\u0E2B\u0E32\u0E22\u0E42\u0E28\u0E01",
            [
              31120
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E30\u0E2B\u0E32\u0E19\u0E17\u0E23\u0E32\u0E22",
        [
          [
            "\u0E15\u0E32\u0E08\u0E07",
            [
              31170
            ]
          ],
          [
            "\u0E25\u0E30\u0E2B\u0E32\u0E19\u0E17\u0E23\u0E32\u0E22",
            [
              31170
            ]
          ],
          [
            "\u0E2A\u0E33\u0E42\u0E23\u0E07\u0E43\u0E2B\u0E21\u0E48",
            [
              31170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E15\u0E30\u0E04\u0E23\u0E2D\u0E07",
            [
              31170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07",
            [
              31170
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E27\u0E48\u0E32\u0E19",
            [
              31170
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E33\u0E1B\u0E25\u0E32\u0E22\u0E21\u0E32\u0E28",
        [
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              31130
            ]
          ],
          [
            "\u0E17\u0E30\u0E40\u0E21\u0E19\u0E0A\u0E31\u0E22",
            [
              31130
            ]
          ],
          [
            "\u0E1A\u0E38\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              31130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E22\u0E32\u0E07",
            [
              31130
            ]
          ],
          [
            "\u0E1C\u0E44\u0E17\u0E23\u0E34\u0E19\u0E17\u0E23\u0E4C",
            [
              31130
            ]
          ],
          [
            "\u0E25\u0E33\u0E1B\u0E25\u0E32\u0E22\u0E21\u0E32\u0E28",
            [
              31130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E30\u0E17\u0E34\u0E07",
            [
              31130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E04\u0E39",
            [
              31130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E42\u0E04\u0E01",
            [
              31130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E14\u0E19",
            [
              31130
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E42\u0E04\u0E19",
            [
              31130
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E41\u0E1D\u0E01",
            [
              31130
            ]
          ],
          [
            "\u0E41\u0E2A\u0E25\u0E07\u0E1E\u0E31\u0E19",
            [
              31130
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E01\u0E25\u0E32\u0E07",
            [
              31130
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E25\u0E48\u0E32\u0E21",
            [
              31130
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              31130
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E15\u0E36\u0E01",
        [
          [
            "\u0E01\u0E23\u0E30\u0E2A\u0E31\u0E07",
            [
              31150
            ]
          ],
          [
            "\u0E0A\u0E38\u0E21\u0E41\u0E2A\u0E07",
            [
              31150
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E21\u0E19\u0E15\u0E4C",
            [
              31150
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E27\u0E31\u0E07",
            [
              31150
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E21\u0E48\u0E27\u0E07",
            [
              31150
            ]
          ],
          [
            "\u0E19\u0E34\u0E04\u0E21",
            [
              31150
            ]
          ],
          [
            "\u0E23\u0E48\u0E2D\u0E19\u0E17\u0E2D\u0E07",
            [
              31150
            ]
          ],
          [
            "\u0E2A\u0E15\u0E36\u0E01",
            [
              31150
            ]
          ],
          [
            "\u0E2A\u0E19\u0E32\u0E21\u0E0A\u0E31\u0E22",
            [
              31150
            ]
          ],
          [
            "\u0E2A\u0E30\u0E41\u0E01",
            [
              31150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              31150
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E41\u0E01",
            [
              31150
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E35\u0E48",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E2D\u0E30\u0E23\u0E32\u0E07",
            [
              31210
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E01\u0E23\u0E30\u0E15\u0E32\u0E14\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              31210
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E01\u0E23\u0E30\u0E40\u0E15\u0E47\u0E19",
            [
              31210
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E0A\u0E31\u0E22",
            [
              31210
            ]
          ],
          [
            "\u0E1A\u0E38\u0E01\u0E23\u0E30\u0E2A\u0E31\u0E07",
            [
              31210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E35\u0E48",
            [
              31210
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E44\u0E1C\u0E48",
            [
              31210
            ]
          ],
          [
            "\u0E40\u0E22\u0E49\u0E22\u0E1B\u0E23\u0E32\u0E2A\u0E32\u0E17",
            [
              31210
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              31210
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E39\u0E07",
            [
              31210
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E07\u0E2A\u0E4C",
        [
          [
            "\u0E2A\u0E23\u0E30\u0E17\u0E2D\u0E07",
            [
              31240
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E41\u0E01\u0E49\u0E27",
            [
              31240
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E0A\u0E31\u0E22\u0E28\u0E23\u0E35",
            [
              31240
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E2B\u0E34\u0E19",
            [
              31240
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1D\u0E49\u0E32\u0E22",
            [
              31240
            ]
          ],
          [
            "\u0E40\u0E2A\u0E32\u0E40\u0E14\u0E35\u0E22\u0E27",
            [
              31240
            ]
          ],
          [
            "\u0E44\u0E17\u0E22\u0E2A\u0E32\u0E21\u0E31\u0E04\u0E04\u0E35",
            [
              31240
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E49\u0E27\u0E22\u0E23\u0E32\u0E0A",
        [
          [
            "\u0E15\u0E32\u0E40\u0E2A\u0E32",
            [
              31e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E15\u0E30\u0E42\u0E01",
            [
              31e3
            ]
          ],
          [
            "\u0E2A\u0E19\u0E27\u0E19",
            [
              31e3
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E41\u0E27\u0E07",
            [
              31e3
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E23\u0E32\u0E0A",
            [
              31e3
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E23\u0E32\u0E0A\u0E32",
            [
              31e3
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              31e3
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              31e3
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E09\u0E25\u0E34\u0E21\u0E1E\u0E23\u0E30\u0E40\u0E01\u0E35\u0E22\u0E23\u0E15\u0E34",
        [
          [
            "\u0E15\u0E32\u0E40\u0E1B\u0E4A\u0E01",
            [
              31110
            ]
          ],
          [
            "\u0E16\u0E32\u0E27\u0E23",
            [
              31170
            ]
          ],
          [
            "\u0E22\u0E32\u0E22\u0E41\u0E22\u0E49\u0E21\u0E27\u0E31\u0E12\u0E19\u0E32",
            [
              31170
            ]
          ],
          [
            "\u0E2D\u0E35\u0E2A\u0E32\u0E19\u0E40\u0E02\u0E15",
            [
              31110
            ]
          ],
          [
            "\u0E40\u0E08\u0E23\u0E34\u0E0D\u0E2A\u0E38\u0E02",
            [
              31110
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1A\u0E38\u0E23\u0E35\u0E23\u0E31\u0E21\u0E22\u0E4C",
        [
          [
            "\u0E01\u0E23\u0E30\u0E2A\u0E31\u0E07",
            [
              31e3
            ]
          ],
          [
            "\u0E01\u0E25\u0E31\u0E19\u0E17\u0E32",
            [
              31e3
            ]
          ],
          [
            "\u0E0A\u0E38\u0E21\u0E40\u0E2B\u0E47\u0E14",
            [
              31e3
            ]
          ],
          [
            "\u0E16\u0E25\u0E38\u0E07\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              31e3
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E17\u0E2D\u0E07",
            [
              31e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1A\u0E31\u0E27",
            [
              31e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E22\u0E32\u0E07",
            [
              31e3
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E04\u0E23\u0E39",
            [
              31e3
            ]
          ],
          [
            "\u0E25\u0E38\u0E21\u0E1B\u0E38\u0E4A\u0E01",
            [
              31e3
            ]
          ],
          [
            "\u0E2A\u0E27\u0E32\u0E22\u0E08\u0E35\u0E01",
            [
              31e3
            ]
          ],
          [
            "\u0E2A\u0E2D\u0E07\u0E2B\u0E49\u0E2D\u0E07",
            [
              31e3
            ]
          ],
          [
            "\u0E2A\u0E30\u0E41\u0E01\u0E0B\u0E33",
            [
              31e3
            ]
          ],
          [
            "\u0E2A\u0E30\u0E41\u0E01\u0E42\u0E1E\u0E23\u0E07",
            [
              31e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E15\u0E32\u0E14",
            [
              31e3
            ]
          ],
          [
            "\u0E2B\u0E25\u0E31\u0E01\u0E40\u0E02\u0E15",
            [
              31e3
            ]
          ],
          [
            "\u0E2D\u0E34\u0E2A\u0E32\u0E13",
            [
              31e3
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1D\u0E32\u0E07",
            [
              31e3
            ]
          ],
          [
            "\u0E40\u0E2A\u0E21\u0E47\u0E14",
            [
              31e3
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              31e3
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E04\u0E19\u0E14\u0E07",
        [
          [
            "\u0E14\u0E07\u0E1E\u0E25\u0E2D\u0E07",
            [
              31150
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E1A\u0E31\u0E27",
            [
              31150
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E1D\u0E32\u0E22",
            [
              31150
            ]
          ],
          [
            "\u0E41\u0E04\u0E19\u0E14\u0E07",
            [
              31150
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E19\u0E19\u0E14\u0E34\u0E19\u0E41\u0E14\u0E07",
        [
          [
            "\u0E25\u0E33\u0E19\u0E32\u0E07\u0E23\u0E2D\u0E07",
            [
              31260
            ]
          ],
          [
            "\u0E2A\u0E49\u0E21\u0E1B\u0E48\u0E2D\u0E22",
            [
              31260
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E14\u0E34\u0E19\u0E41\u0E14\u0E07",
            [
              31260
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E19\u0E19\u0E2A\u0E38\u0E27\u0E23\u0E23\u0E13",
        [
          [
            "\u0E14\u0E07\u0E2D\u0E35\u0E08\u0E32\u0E19",
            [
              31110
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E08\u0E31\u0E07\u0E2B\u0E31\u0E19",
            [
              31110
            ]
          ],
          [
            "\u0E42\u0E01\u0E23\u0E01\u0E41\u0E01\u0E49\u0E27",
            [
              31110
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E38\u0E27\u0E23\u0E23\u0E13",
            [
              31110
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E1B\u0E17\u0E38\u0E21\u0E18\u0E32\u0E19\u0E35",
    [
      [
        "\u0E04\u0E25\u0E2D\u0E07\u0E2B\u0E25\u0E27\u0E07",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2A\u0E2D\u0E07",
            [
              12120
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2A\u0E32\u0E21",
            [
              12120
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2A\u0E35\u0E48",
            [
              12120
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2B\u0E01",
            [
              12120
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2B\u0E19\u0E36\u0E48\u0E07",
            [
              12120
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2B\u0E49\u0E32",
            [
              12120
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E40\u0E08\u0E47\u0E14",
            [
              12120
            ]
          ]
        ]
      ],
      [
        "\u0E18\u0E31\u0E0D\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E1A\u0E36\u0E07\u0E19\u0E49\u0E33\u0E23\u0E31\u0E01\u0E29\u0E4C",
            [
              12110
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E22\u0E35\u0E48\u0E42\u0E16",
            [
              12130
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E2A\u0E19\u0E31\u0E48\u0E19",
            [
              12110
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E0A\u0E32\u0E18\u0E34\u0E1B\u0E31\u0E15\u0E22\u0E4C",
            [
              12130
            ]
          ],
          [
            "\u0E23\u0E31\u0E07\u0E2A\u0E34\u0E15",
            [
              12110
            ]
          ],
          [
            "\u0E25\u0E33\u0E1C\u0E31\u0E01\u0E01\u0E39\u0E14",
            [
              12110
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E32\u0E14\u0E2B\u0E25\u0E38\u0E21\u0E41\u0E01\u0E49\u0E27",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E1E\u0E23\u0E30\u0E2D\u0E38\u0E14\u0E21",
            [
              12140
            ]
          ],
          [
            "\u0E04\u0E39\u0E02\u0E27\u0E32\u0E07",
            [
              12140
            ]
          ],
          [
            "\u0E04\u0E39\u0E1A\u0E32\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              12140
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E40\u0E07\u0E34\u0E19",
            [
              12140
            ]
          ],
          [
            "\u0E23\u0E30\u0E41\u0E2B\u0E07",
            [
              12140
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E2B\u0E25\u0E38\u0E21\u0E41\u0E01\u0E49\u0E27",
            [
              12140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E49\u0E32\u0E44\u0E21\u0E49",
            [
              12140
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E33\u0E25\u0E39\u0E01\u0E01\u0E32",
        [
          [
            "\u0E04\u0E39\u0E04\u0E15",
            [
              12130
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E04\u0E2D\u0E44\u0E2B",
            [
              12150
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E04\u0E33\u0E1E\u0E23\u0E49\u0E2D\u0E22",
            [
              12150
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E17\u0E2D\u0E07\u0E2B\u0E25\u0E32\u0E07",
            [
              12150
            ]
          ],
          [
            "\u0E1E\u0E37\u0E0A\u0E2D\u0E38\u0E14\u0E21",
            [
              12150
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E2A\u0E27\u0E32\u0E22",
            [
              12150
            ]
          ],
          [
            "\u0E25\u0E33\u0E25\u0E39\u0E01\u0E01\u0E32",
            [
              12150
            ]
          ],
          [
            "\u0E25\u0E33\u0E44\u0E17\u0E23",
            [
              12150
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E32\u0E21\u0E42\u0E04\u0E01",
        [
          [
            "\u0E01\u0E23\u0E30\u0E41\u0E0A\u0E07",
            [
              12160
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E04\u0E27\u0E32\u0E22",
            [
              12160
            ]
          ],
          [
            "\u0E17\u0E49\u0E32\u0E22\u0E40\u0E01\u0E32\u0E30",
            [
              12160
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E23\u0E30\u0E1A\u0E37\u0E2D",
            [
              12160
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E15\u0E22",
            [
              12160
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              12160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E07\u0E34\u0E49\u0E27",
            [
              12160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1B\u0E17\u0E38\u0E21",
            [
              12160
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E42\u0E04\u0E01",
            [
              12160
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E23\u0E32\u0E01\u0E19\u0E49\u0E2D\u0E22",
            [
              12160
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E23\u0E32\u0E01\u0E43\u0E2B\u0E0D\u0E48",
            [
              12160
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E2A\u0E37\u0E2D",
        [
          [
            "\u0E19\u0E1E\u0E23\u0E31\u0E15\u0E19\u0E4C",
            [
              12170
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E01\u0E32\u0E2A\u0E32\u0E21",
            [
              12170
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E0A\u0E33\u0E2D\u0E49\u0E2D",
            [
              12170
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E1A\u0E2D\u0E19",
            [
              12170
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E1A\u0E32",
            [
              12170
            ]
          ],
          [
            "\u0E28\u0E32\u0E25\u0E32\u0E04\u0E23\u0E38",
            [
              12170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E32\u0E21\u0E27\u0E31\u0E07",
            [
              12170
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1B\u0E17\u0E38\u0E21\u0E18\u0E32\u0E19\u0E35",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E30\u0E14\u0E35",
            [
              12e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E02\u0E30\u0E41\u0E22\u0E07",
            [
              12e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E04\u0E39\u0E27\u0E31\u0E14",
            [
              12e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1B\u0E23\u0E2D\u0E01",
            [
              12e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E39\u0E14",
            [
              12e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E39\u0E19",
            [
              12e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              12e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E14\u0E37\u0E48\u0E2D",
            [
              12e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E23\u0E30\u0E41\u0E0A\u0E07",
            [
              12e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E25\u0E32\u0E07",
            [
              12e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E09\u0E32\u0E07",
            [
              12e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48",
            [
              12e3
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E1E\u0E23\u0E34\u0E01\u0E44\u0E17\u0E22",
            [
              12e3
            ]
          ],
          [
            "\u0E2B\u0E25\u0E31\u0E01\u0E2B\u0E01",
            [
              12e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E1B\u0E23\u0E30\u0E08\u0E27\u0E1A\u0E04\u0E35\u0E23\u0E35\u0E02\u0E31\u0E19\u0E18\u0E4C",
    [
      [
        "\u0E01\u0E38\u0E22\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E01\u0E38\u0E22\u0E1A\u0E38\u0E23\u0E35",
            [
              77150
            ]
          ],
          [
            "\u0E01\u0E38\u0E22\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              77150
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E22\u0E32\u0E22\u0E2B\u0E19\u0E39",
            [
              77150
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E01\u0E23\u0E30\u0E17\u0E32\u0E22",
            [
              77150
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E02\u0E32\u0E21",
            [
              77150
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E41\u0E14\u0E07",
            [
              77150
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E31\u0E1A\u0E2A\u0E30\u0E41\u0E01",
        [
          [
            "\u0E17\u0E31\u0E1A\u0E2A\u0E30\u0E41\u0E01",
            [
              77130
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E39\u0E01\u0E27\u0E32\u0E07",
            [
              77130
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E22\u0E32\u0E07",
            [
              77130
            ]
          ],
          [
            "\u0E2D\u0E48\u0E32\u0E07\u0E17\u0E2D\u0E07",
            [
              77130
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E25\u0E49\u0E32\u0E19",
            [
              77130
            ]
          ],
          [
            "\u0E41\u0E2A\u0E07\u0E2D\u0E23\u0E38\u0E13",
            [
              77130
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E2A\u0E30\u0E1E\u0E32\u0E19",
        [
          [
            "\u0E01\u0E33\u0E40\u0E19\u0E34\u0E14\u0E19\u0E1E\u0E04\u0E38\u0E13",
            [
              77140
            ]
          ],
          [
            "\u0E0A\u0E31\u0E22\u0E40\u0E01\u0E29\u0E21",
            [
              77190
            ]
          ],
          [
            "\u0E17\u0E2D\u0E07\u0E21\u0E07\u0E04\u0E25",
            [
              77230
            ]
          ],
          [
            "\u0E18\u0E07\u0E0A\u0E31\u0E22",
            [
              77190
            ]
          ],
          [
            "\u0E1E\u0E07\u0E28\u0E4C\u0E1B\u0E23\u0E30\u0E28\u0E32\u0E2A\u0E19\u0E4C",
            [
              77140
            ]
          ],
          [
            "\u0E23\u0E48\u0E2D\u0E19\u0E17\u0E2D\u0E07",
            [
              77230
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E23\u0E33\u0E1E\u0E36\u0E07",
            [
              77140
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E2A\u0E30\u0E1E\u0E32\u0E19\u0E19\u0E49\u0E2D\u0E22",
        [
          [
            "\u0E0A\u0E49\u0E32\u0E07\u0E41\u0E23\u0E01",
            [
              77170
            ]
          ],
          [
            "\u0E17\u0E23\u0E32\u0E22\u0E17\u0E2D\u0E07",
            [
              77170
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2A\u0E30\u0E1E\u0E32\u0E19",
            [
              77170
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E41\u0E1E\u0E23\u0E01",
            [
              77170
            ]
          ],
          [
            "\u0E44\u0E0A\u0E22\u0E23\u0E32\u0E0A",
            [
              77170
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E23\u0E32\u0E13\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E1B\u0E23\u0E32\u0E13\u0E1A\u0E38\u0E23\u0E35",
            [
              77120,
              77160
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E19\u0E49\u0E33\u0E1B\u0E23\u0E32\u0E13",
            [
              77220
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E01\u0E4C\u0E1E\u0E07",
            [
              77120,
              77160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E15\u0E32\u0E41\u0E15\u0E49\u0E21",
            [
              77120,
              77160
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E08\u0E49\u0E32\u0E27",
            [
              77120,
              77160
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E19\u0E49\u0E2D\u0E22",
            [
              77120,
              77160
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E32\u0E21\u0E23\u0E49\u0E2D\u0E22\u0E22\u0E2D\u0E14",
        [
          [
            "\u0E28\u0E32\u0E25\u0E32\u0E25\u0E31\u0E22",
            [
              77180
            ]
          ],
          [
            "\u0E28\u0E34\u0E25\u0E32\u0E25\u0E2D\u0E22",
            [
              77180
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E23\u0E49\u0E2D\u0E22\u0E22\u0E2D\u0E14",
            [
              77120,
              77160
            ]
          ],
          [
            "\u0E44\u0E23\u0E48\u0E40\u0E01\u0E48\u0E32",
            [
              77180
            ]
          ],
          [
            "\u0E44\u0E23\u0E48\u0E43\u0E2B\u0E21\u0E48",
            [
              77180
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E31\u0E27\u0E2B\u0E34\u0E19",
        [
          [
            "\u0E17\u0E31\u0E1A\u0E43\u0E15\u0E49",
            [
              77110
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E19\u0E04\u0E23",
            [
              77110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1E\u0E25\u0E31\u0E1A",
            [
              77110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E01",
            [
              77110
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E2B\u0E34\u0E19",
            [
              77110
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E40\u0E2B\u0E25\u0E47\u0E01\u0E44\u0E1F",
            [
              77110
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E2A\u0E31\u0E15\u0E27\u0E4C\u0E43\u0E2B\u0E0D\u0E48",
            [
              77110
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1B\u0E23\u0E30\u0E08\u0E27\u0E1A\u0E04\u0E35\u0E23\u0E35\u0E02\u0E31\u0E19\u0E18\u0E4C",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E27\u0E32\u0E2C",
            [
              77e3
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E19\u0E2D\u0E01",
            [
              77210
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E08\u0E27\u0E1A\u0E04\u0E35\u0E23\u0E35\u0E02\u0E31\u0E19\u0E18\u0E4C",
            [
              77e3
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E17\u0E23\u0E32\u0E22",
            [
              77e3
            ]
          ],
          [
            "\u0E2D\u0E48\u0E32\u0E27\u0E19\u0E49\u0E2D\u0E22",
            [
              77210
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E2B\u0E25\u0E31\u0E01",
            [
              77e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E1B\u0E23\u0E32\u0E08\u0E35\u0E19\u0E1A\u0E38\u0E23\u0E35",
    [
      [
        "\u0E01\u0E1A\u0E34\u0E19\u0E17\u0E23\u0E4C\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E01\u0E1A\u0E34\u0E19\u0E17\u0E23\u0E4C",
            [
              25110
            ]
          ],
          [
            "\u0E19\u0E19\u0E17\u0E23\u0E35",
            [
              25110
            ]
          ],
          [
            "\u0E19\u0E32\u0E41\u0E02\u0E21",
            [
              25110
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E17\u0E2D\u0E07",
            [
              25110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E32",
            [
              25110
            ]
          ],
          [
            "\u0E22\u0E48\u0E32\u0E19\u0E23\u0E35",
            [
              25110
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              25110
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E14\u0E32\u0E25",
            [
              25110
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              25110
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E17\u0E48\u0E32\u0E0A\u0E49\u0E32\u0E07",
            [
              25110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E35\u0E48",
            [
              25110
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E19\u0E32\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              25110
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E44\u0E21\u0E49\u0E41\u0E01\u0E49\u0E27",
            [
              25110
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E01\u0E48\u0E32",
            [
              25240
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E14\u0E35",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              25220
            ]
          ],
          [
            "\u0E19\u0E32\u0E14\u0E35",
            [
              25220
            ]
          ],
          [
            "\u0E1A\u0E38\u0E1E\u0E23\u0E32\u0E2B\u0E21\u0E13\u0E4C",
            [
              25220
            ]
          ],
          [
            "\u0E2A\u0E30\u0E1E\u0E32\u0E19\u0E2B\u0E34\u0E19",
            [
              25220
            ]
          ],
          [
            "\u0E2A\u0E33\u0E1E\u0E31\u0E19\u0E15\u0E32",
            [
              25220
            ]
          ],
          [
            "\u0E41\u0E01\u0E48\u0E07\u0E14\u0E34\u0E19\u0E2A\u0E2D",
            [
              25220
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E2A\u0E23\u0E49\u0E32\u0E07",
        [
          [
            "\u0E01\u0E23\u0E30\u0E17\u0E38\u0E48\u0E21\u0E41\u0E1E\u0E49\u0E27",
            [
              25150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1A\u0E32",
            [
              25150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E02\u0E32\u0E21",
            [
              25150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1B\u0E25\u0E32\u0E23\u0E49\u0E32",
            [
              25150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E25\u0E27\u0E07",
            [
              25150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E22\u0E32\u0E07",
            [
              25150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E15\u0E22",
            [
              25150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E41\u0E15\u0E19",
            [
              25150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2A\u0E23\u0E49\u0E32\u0E07",
            [
              25150
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E23\u0E30\u0E08\u0E31\u0E19\u0E15\u0E04\u0E32\u0E21",
        [
          [
            "\u0E04\u0E33\u0E42\u0E15\u0E19\u0E14",
            [
              25130
            ]
          ],
          [
            "\u0E14\u0E07\u0E1A\u0E31\u0E07",
            [
              25130
            ]
          ],
          [
            "\u0E1A\u0E38\u0E1D\u0E49\u0E32\u0E22",
            [
              25130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E2D\u0E22",
            [
              25130
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E08\u0E31\u0E19\u0E15\u0E04\u0E32\u0E21",
            [
              25130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              25130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E2A\u0E07",
            [
              25130
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E25\u0E2D\u0E22",
            [
              25130
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E07\u0E32\u0E21",
            [
              25130
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E21\u0E2B\u0E32\u0E42\u0E1E\u0E18\u0E34",
        [
          [
            "\u0E01\u0E23\u0E2D\u0E01\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              25140
            ]
          ],
          [
            "\u0E14\u0E07\u0E01\u0E23\u0E30\u0E17\u0E07\u0E22\u0E32\u0E21",
            [
              25140
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E15\u0E39\u0E21",
            [
              25140
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E38\u0E49\u0E07",
            [
              25140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E17\u0E32\u0E21",
            [
              25140
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E21\u0E2B\u0E32\u0E42\u0E1E\u0E18\u0E34",
            [
              25140
            ]
          ],
          [
            "\u0E2A\u0E31\u0E21\u0E1E\u0E31\u0E19\u0E18\u0E4C",
            [
              25140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E1E\u0E23\u0E07",
            [
              25140
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E2B\u0E27\u0E49\u0E32",
            [
              25140
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E22\u0E32\u0E07",
            [
              25140
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E21\u0E42\u0E2B\u0E2A\u0E16",
        [
          [
            "\u0E04\u0E39\u0E49\u0E25\u0E33\u0E1E\u0E31\u0E19",
            [
              25190
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E1B\u0E35\u0E1A",
            [
              25190
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E44\u0E17\u0E22",
            [
              25190
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E0A\u0E30\u0E40\u0E25\u0E37\u0E2D\u0E14",
            [
              25190
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1B\u0E23\u0E32\u0E08\u0E35\u0E19\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E14\u0E07\u0E02\u0E35\u0E49\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              25e3
            ]
          ],
          [
            "\u0E14\u0E07\u0E1E\u0E23\u0E30\u0E23\u0E32\u0E21",
            [
              25e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E07\u0E32\u0E21",
            [
              25e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1A\u0E23\u0E34\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              25e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E14\u0E0A\u0E30",
            [
              25e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1E\u0E23\u0E30",
            [
              25230
            ]
          ],
          [
            "\u0E23\u0E2D\u0E1A\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              25e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E42\u0E1A\u0E2A\u0E16\u0E4C",
            [
              25e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              25e3
            ]
          ],
          [
            "\u0E40\u0E19\u0E34\u0E19\u0E2B\u0E2D\u0E21",
            [
              25230
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E44\u0E21\u0E49\u0E25\u0E32\u0E22",
            [
              25230
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2B\u0E49\u0E2D\u0E21",
            [
              25e3
            ]
          ],
          [
            "\u0E44\u0E21\u0E49\u0E40\u0E04\u0E47\u0E14",
            [
              25230
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E1B\u0E31\u0E15\u0E15\u0E32\u0E19\u0E35",
    [
      [
        "\u0E01\u0E30\u0E1E\u0E49\u0E2D",
        [
          [
            "\u0E01\u0E30\u0E23\u0E38\u0E1A\u0E35",
            [
              94230
            ]
          ],
          [
            "\u0E15\u0E30\u0E42\u0E25\u0E30\u0E14\u0E37\u0E2D\u0E23\u0E32\u0E21\u0E31\u0E19",
            [
              94230
            ]
          ],
          [
            "\u0E1B\u0E25\u0E48\u0E2D\u0E07\u0E2B\u0E2D\u0E22",
            [
              94230
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E38\u0E48\u0E07\u0E22\u0E32\u0E07\u0E41\u0E14\u0E07",
        [
          [
            "\u0E15\u0E30\u0E42\u0E25\u0E30\u0E41\u0E21\u0E30\u0E19\u0E32",
            [
              94140
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E14\u0E33",
            [
              94140
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E39",
            [
              94140
            ]
          ],
          [
            "\u0E1E\u0E34\u0E40\u0E17\u0E19",
            [
              94140
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E30\u0E19\u0E32\u0E40\u0E23\u0E30",
        [
          [
            "\u0E04\u0E27\u0E19",
            [
              94190
            ]
          ],
          [
            "\u0E04\u0E2D\u0E01\u0E01\u0E23\u0E30\u0E1A\u0E37\u0E2D",
            [
              94130
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19",
            [
              94190
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E49\u0E32\u0E21",
            [
              94130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E19\u0E49\u0E33",
            [
              94130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E25\u0E32\u0E07",
            [
              94130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E2D\u0E01",
            [
              94130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E49\u0E33\u0E1A\u0E48\u0E2D",
            [
              94130
            ]
          ],
          [
            "\u0E1B\u0E30\u0E19\u0E32\u0E40\u0E23\u0E30",
            [
              94130
            ]
          ],
          [
            "\u0E1E\u0E48\u0E2D\u0E21\u0E34\u0E48\u0E07",
            [
              94130
            ]
          ]
        ]
      ],
      [
        "\u0E21\u0E32\u0E22\u0E2D",
        [
          [
            "\u0E01\u0E23\u0E30\u0E2B\u0E27\u0E30",
            [
              94190
            ]
          ],
          [
            "\u0E01\u0E23\u0E30\u0E40\u0E2A\u0E32\u0E30",
            [
              94140
            ]
          ],
          [
            "\u0E15\u0E23\u0E31\u0E07",
            [
              94140
            ]
          ],
          [
            "\u0E16\u0E19\u0E19",
            [
              94140
            ]
          ],
          [
            "\u0E1B\u0E30\u0E42\u0E14",
            [
              94140
            ]
          ],
          [
            "\u0E1B\u0E32\u0E19\u0E31\u0E19",
            [
              94140
            ]
          ],
          [
            "\u0E21\u0E32\u0E22\u0E2D",
            [
              94140
            ]
          ],
          [
            "\u0E25\u0E32\u0E07\u0E32",
            [
              94190
            ]
          ],
          [
            "\u0E25\u0E38\u0E42\u0E1A\u0E30\u0E22\u0E34\u0E44\u0E23",
            [
              94140
            ]
          ],
          [
            "\u0E2A\u0E30\u0E01\u0E33",
            [
              94140
            ]
          ],
          [
            "\u0E2A\u0E32\u0E04\u0E2D\u0E1A\u0E19",
            [
              94140
            ]
          ],
          [
            "\u0E2A\u0E32\u0E04\u0E2D\u0E43\u0E15\u0E49",
            [
              94140
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E08\u0E31\u0E19",
            [
              94140
            ]
          ]
        ]
      ],
      [
        "\u0E22\u0E30\u0E23\u0E31\u0E07",
        [
          [
            "\u0E01\u0E23\u0E30\u0E42\u0E14",
            [
              94160
            ]
          ],
          [
            "\u0E01\u0E2D\u0E25\u0E33",
            [
              94160
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48",
            [
              94160
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E08\u0E31\u0E19",
            [
              94160
            ]
          ],
          [
            "\u0E1B\u0E34\u0E15\u0E39\u0E21\u0E38\u0E14\u0E35",
            [
              94160
            ]
          ],
          [
            "\u0E22\u0E30\u0E23\u0E31\u0E07",
            [
              94160
            ]
          ],
          [
            "\u0E23\u0E30\u0E41\u0E27\u0E49\u0E07",
            [
              94160
            ]
          ],
          [
            "\u0E27\u0E31\u0E14",
            [
              94160
            ]
          ],
          [
            "\u0E2A\u0E30\u0E14\u0E32\u0E27\u0E32",
            [
              94160
            ]
          ],
          [
            "\u0E2A\u0E30\u0E19\u0E2D",
            [
              94160
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E15\u0E39\u0E21",
            [
              94160
            ]
          ],
          [
            "\u0E40\u0E21\u0E32\u0E30\u0E21\u0E32\u0E27\u0E35",
            [
              94160
            ]
          ]
        ]
      ],
      [
        "\u0E22\u0E30\u0E2B\u0E23\u0E34\u0E48\u0E07",
        [
          [
            "\u0E08\u0E30\u0E23\u0E31\u0E07",
            [
              94150
            ]
          ],
          [
            "\u0E15\u0E2D\u0E2B\u0E25\u0E31\u0E07",
            [
              94150
            ]
          ],
          [
            "\u0E15\u0E30\u0E42\u0E25\u0E30",
            [
              94150
            ]
          ],
          [
            "\u0E15\u0E30\u0E42\u0E25\u0E30\u0E01\u0E32\u0E42\u0E1B\u0E23\u0E4C",
            [
              94150
            ]
          ],
          [
            "\u0E15\u0E31\u0E19\u0E2B\u0E22\u0E07\u0E08\u0E36\u0E07\u0E07\u0E32",
            [
              94190
            ]
          ],
          [
            "\u0E15\u0E31\u0E19\u0E2B\u0E22\u0E07\u0E14\u0E32\u0E25\u0E2D",
            [
              94150
            ]
          ],
          [
            "\u0E15\u0E32\u0E25\u0E35\u0E2D\u0E32\u0E22\u0E23\u0E4C",
            [
              94150
            ]
          ],
          [
            "\u0E15\u0E32\u0E41\u0E01\u0E30",
            [
              94150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1B\u0E39",
            [
              94150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E42\u0E25\u0E22",
            [
              94190
            ]
          ],
          [
            "\u0E1B\u0E34\u0E22\u0E32\u0E21\u0E38\u0E21\u0E31\u0E07",
            [
              94150
            ]
          ],
          [
            "\u0E1B\u0E38\u0E25\u0E32\u0E01\u0E07",
            [
              94150
            ]
          ],
          [
            "\u0E21\u0E30\u0E19\u0E31\u0E07\u0E22\u0E07",
            [
              94150
            ]
          ],
          [
            "\u0E22\u0E32\u0E21\u0E39",
            [
              94150
            ]
          ],
          [
            "\u0E23\u0E32\u0E15\u0E32\u0E1B\u0E31\u0E19\u0E22\u0E31\u0E07",
            [
              94150
            ]
          ],
          [
            "\u0E2A\u0E32\u0E1A\u0E31\u0E19",
            [
              94150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E23\u0E15",
            [
              94150
            ]
          ],
          [
            "\u0E41\u0E2B\u0E25\u0E21\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              94150
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E32\u0E22\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E01\u0E30\u0E14\u0E38\u0E19\u0E07",
            [
              94110
            ]
          ],
          [
            "\u0E15\u0E30\u0E1A\u0E34\u0E49\u0E07",
            [
              94110
            ]
          ],
          [
            "\u0E15\u0E30\u0E25\u0E38\u0E1A\u0E31\u0E19",
            [
              94110
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E04\u0E25\u0E49\u0E32",
            [
              94190
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E01\u0E48\u0E32",
            [
              94110
            ]
          ],
          [
            "\u0E1A\u0E37\u0E2D\u0E40\u0E23\u0E30",
            [
              94110
            ]
          ],
          [
            "\u0E1B\u0E30\u0E40\u0E2A\u0E22\u0E30\u0E27\u0E2D",
            [
              94110
            ]
          ],
          [
            "\u0E21\u0E30\u0E19\u0E31\u0E07\u0E14\u0E32\u0E25\u0E33",
            [
              94110
            ]
          ],
          [
            "\u0E25\u0E30\u0E2B\u0E32\u0E23",
            [
              94110
            ]
          ],
          [
            "\u0E40\u0E15\u0E23\u0E32\u0E30\u0E1A\u0E2D\u0E19",
            [
              94110
            ]
          ],
          [
            "\u0E41\u0E1B\u0E49\u0E19",
            [
              94110
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E08\u0E34\u0E01",
        [
          [
            "\u0E04\u0E2D\u0E25\u0E2D\u0E15\u0E31\u0E19\u0E2B\u0E22\u0E07",
            [
              94170
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E23\u0E31\u0E01",
            [
              94170
            ]
          ],
          [
            "\u0E14\u0E32\u0E42\u0E15\u0E4A\u0E30",
            [
              94170
            ]
          ],
          [
            "\u0E15\u0E38\u0E22\u0E07",
            [
              94170
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E01\u0E33\u0E0A\u0E33",
            [
              94170
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E15\u0E32\u0E27\u0E32",
            [
              94170
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E02\u0E32",
            [
              94170
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E17\u0E2D\u0E07",
            [
              94170
            ]
          ],
          [
            "\u0E1B\u0E38\u0E42\u0E25\u0E30\u0E1B\u0E38\u0E42\u0E22",
            [
              94170
            ]
          ],
          [
            "\u0E22\u0E32\u0E1A\u0E35",
            [
              94170
            ]
          ],
          [
            "\u0E25\u0E34\u0E1B\u0E30\u0E2A\u0E30\u0E42\u0E07",
            [
              94170
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E40\u0E1B\u0E32\u0E30",
            [
              94170
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1B\u0E31\u0E15\u0E15\u0E32\u0E19\u0E35",
        [
          [
            "\u0E01\u0E30\u0E21\u0E34\u0E22\u0E2D",
            [
              94e3
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E21\u0E32\u0E19\u0E34\u0E07",
            [
              94e3
            ]
          ],
          [
            "\u0E08\u0E30\u0E1A\u0E31\u0E07\u0E15\u0E34\u0E01\u0E2D",
            [
              94e3
            ]
          ],
          [
            "\u0E15\u0E30\u0E25\u0E38\u0E42\u0E1A\u0E30",
            [
              94e3
            ]
          ],
          [
            "\u0E15\u0E31\u0E19\u0E2B\u0E22\u0E07\u0E25\u0E38\u0E42\u0E25\u0E30",
            [
              94e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E19\u0E32",
            [
              94e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E23\u0E32\u0E40\u0E2E\u0E32\u0E30",
            [
              94e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E23\u0E32\u0E42\u0E2B\u0E21",
            [
              94e3
            ]
          ],
          [
            "\u0E1B\u0E30\u0E01\u0E32\u0E2E\u0E30\u0E23\u0E31\u0E07",
            [
              94e3
            ]
          ],
          [
            "\u0E1B\u0E38\u0E22\u0E38\u0E14",
            [
              94e3
            ]
          ],
          [
            "\u0E23\u0E39\u0E2A\u0E30\u0E21\u0E34\u0E41\u0E25",
            [
              94e3
            ]
          ],
          [
            "\u0E2A\u0E30\u0E1A\u0E32\u0E23\u0E31\u0E07",
            [
              94e3
            ]
          ],
          [
            "\u0E2D\u0E32\u0E40\u0E19\u0E32\u0E30\u0E23\u0E39",
            [
              94e3
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E25\u0E32\u0E19",
        [
          [
            "\u0E1B\u0E48\u0E32\u0E44\u0E23\u0E48",
            [
              94180
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E40\u0E15\u0E35\u0E49\u0E22",
            [
              94180
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E25\u0E32\u0E19",
            [
              94180
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E04\u0E01\u0E42\u0E1E\u0E18\u0E34\u0E4C",
        [
          [
            "\u0E04\u0E27\u0E19\u0E42\u0E19\u0E23\u0E35",
            [
              94180
            ]
          ],
          [
            "\u0E0A\u0E49\u0E32\u0E07\u0E43\u0E2B\u0E49\u0E15\u0E01",
            [
              94120
            ]
          ],
          [
            "\u0E17\u0E23\u0E32\u0E22\u0E02\u0E32\u0E27",
            [
              94120
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E1E\u0E25\u0E32",
            [
              94180
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E23\u0E37\u0E2D",
            [
              94120
            ]
          ],
          [
            "\u0E19\u0E32\u0E1B\u0E23\u0E30\u0E14\u0E39\u0E48",
            [
              94180
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E01\u0E15\u0E38",
            [
              94120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E42\u0E01\u0E23\u0E30",
            [
              94120
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E25\u0E48\u0E2D",
            [
              94180
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E1A\u0E2D\u0E19",
            [
              94120
            ]
          ],
          [
            "\u0E21\u0E30\u0E01\u0E23\u0E39\u0E14",
            [
              94120
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              94120
            ]
          ]
        ]
      ],
      [
        "\u0E44\u0E21\u0E49\u0E41\u0E01\u0E48\u0E19",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E17\u0E23\u0E32\u0E22",
            [
              94220
            ]
          ],
          [
            "\u0E15\u0E30\u0E42\u0E25\u0E30\u0E44\u0E01\u0E23\u0E17\u0E2D\u0E07",
            [
              94220
            ]
          ],
          [
            "\u0E44\u0E17\u0E23\u0E17\u0E2D\u0E07",
            [
              94220
            ]
          ],
          [
            "\u0E44\u0E21\u0E49\u0E41\u0E01\u0E48\u0E19",
            [
              94220
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E1E\u0E23\u0E30\u0E19\u0E04\u0E23\u0E28\u0E23\u0E35\u0E2D\u0E22\u0E38\u0E18\u0E22\u0E32",
    [
      [
        "\u0E17\u0E48\u0E32\u0E40\u0E23\u0E37\u0E2D",
        [
          [
            "\u0E08\u0E33\u0E1B\u0E32",
            [
              13130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2B\u0E25\u0E27\u0E07",
            [
              18270
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E08\u0E49\u0E32\u0E2A\u0E19\u0E38\u0E01",
            [
              13130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E23\u0E37\u0E2D",
            [
              13130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E23\u0E48\u0E2D\u0E21",
            [
              13130
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E17\u0E48\u0E32",
            [
              13130
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E41\u0E14\u0E07",
            [
              13130
            ]
          ],
          [
            "\u0E28\u0E32\u0E25\u0E32\u0E25\u0E2D\u0E22",
            [
              13130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E19\u0E32\u0E01",
            [
              13130
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E40\u0E2D\u0E19",
            [
              13130
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E04\u0E23\u0E2B\u0E25\u0E27\u0E07",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2A\u0E30\u0E41\u0E01",
            [
              13260
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E0A\u0E49\u0E32\u0E07",
            [
              13260
            ]
          ],
          [
            "\u0E19\u0E04\u0E23\u0E2B\u0E25\u0E27\u0E07",
            [
              13260
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E23\u0E30\u0E04\u0E23\u0E39",
            [
              13260
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E23\u0E30\u0E01\u0E33",
            [
              13260
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E42\u0E1E\u0E07",
            [
              13260
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E0A\u0E38\u0E49\u0E07",
            [
              13260
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E08\u0E31\u0E48\u0E19",
            [
              13260
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E19\u0E2D\u0E19",
            [
              13260
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E44\u0E16",
            [
              13260
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E25\u0E34\u0E07",
            [
              13260
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E25\u0E32",
            [
              13260
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E0B\u0E49\u0E32\u0E22",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E0B\u0E49\u0E32\u0E22",
            [
              13270
            ]
          ],
          [
            "\u0E1B\u0E25\u0E32\u0E22\u0E01\u0E25\u0E31\u0E14",
            [
              13270
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              13270
            ]
          ],
          [
            "\u0E40\u0E15\u0E48\u0E32\u0E40\u0E25\u0E48\u0E32",
            [
              13270
            ]
          ],
          [
            "\u0E40\u0E17\u0E1E\u0E21\u0E07\u0E04\u0E25",
            [
              13270
            ]
          ],
          [
            "\u0E41\u0E01\u0E49\u0E27\u0E1F\u0E49\u0E32",
            [
              13270
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E1A\u0E32\u0E25",
        [
          [
            "\u0E01\u0E1A\u0E40\u0E08\u0E32",
            [
              13250
            ]
          ],
          [
            "\u0E17\u0E32\u0E07\u0E0A\u0E49\u0E32\u0E07",
            [
              13250
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E40\u0E15\u0E49\u0E32",
            [
              13250
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E0A\u0E30\u0E19\u0E35",
            [
              13250
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1A\u0E32\u0E25",
            [
              13250
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              13250
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2B\u0E25\u0E27\u0E07\u0E42\u0E14\u0E14",
            [
              13250
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2B\u0E31\u0E01",
            [
              13250
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E38\u0E48\u0E21",
            [
              13250
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E04\u0E25\u0E31\u0E07",
            [
              13250
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E02\u0E32\u0E27",
            [
              13250
            ]
          ],
          [
            "\u0E21\u0E2B\u0E32\u0E1E\u0E23\u0E32\u0E2B\u0E21\u0E13\u0E4C",
            [
              13250
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E15\u0E30\u0E01\u0E39",
            [
              13250
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E22\u0E21",
            [
              13250
            ]
          ],
          [
            "\u0E2A\u0E30\u0E1E\u0E32\u0E19\u0E44\u0E17\u0E22",
            [
              13250
            ]
          ],
          [
            "\u0E44\u0E17\u0E23\u0E19\u0E49\u0E2D\u0E22",
            [
              13250
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E1B\u0E30\u0E2B\u0E31\u0E19",
        [
          [
            "\u0E02\u0E22\u0E32\u0E22",
            [
              13220
            ]
          ],
          [
            "\u0E02\u0E27\u0E31\u0E0D\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              13220
            ]
          ],
          [
            "\u0E15\u0E32\u0E19\u0E34\u0E21",
            [
              13220
            ]
          ],
          [
            "\u0E15\u0E32\u0E25\u0E40\u0E2D\u0E19",
            [
              13220
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E19\u0E49\u0E33",
            [
              13220
            ]
          ],
          [
            "\u0E17\u0E32\u0E07\u0E01\u0E25\u0E32\u0E07",
            [
              13220
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E19\u0E32\u0E07\u0E23\u0E49\u0E32",
            [
              13220
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1B\u0E30\u0E2B\u0E31\u0E19",
            [
              13220
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E14\u0E37\u0E48\u0E2D",
            [
              13220
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E1E\u0E25\u0E34\u0E07",
            [
              13220
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E02\u0E25\u0E49\u0E2D",
            [
              13220
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E21\u0E49\u0E32",
            [
              13220
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E25\u0E35\u0E48",
            [
              13220
            ]
          ],
          [
            "\u0E1E\u0E38\u0E17\u0E40\u0E25\u0E32",
            [
              13220
            ]
          ],
          [
            "\u0E2B\u0E31\u0E19\u0E2A\u0E31\u0E07",
            [
              13220
            ]
          ],
          [
            "\u0E40\u0E2A\u0E32\u0E18\u0E07",
            [
              13220
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E2A\u0E32\u0E21\u0E15\u0E49\u0E19",
            [
              13220
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E1B\u0E30\u0E2D\u0E34\u0E19",
        [
          [
            "\u0E02\u0E19\u0E2D\u0E19\u0E2B\u0E25\u0E27\u0E07",
            [
              13160
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E08\u0E34\u0E01",
            [
              13160
            ]
          ],
          [
            "\u0E04\u0E38\u0E49\u0E07\u0E25\u0E32\u0E19",
            [
              13160
            ]
          ],
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E40\u0E01\u0E23\u0E35\u0E22\u0E1A",
            [
              13160
            ]
          ],
          [
            "\u0E15\u0E25\u0E34\u0E48\u0E07\u0E0A\u0E31\u0E19",
            [
              13160
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E23\u0E30\u0E2A\u0E31\u0E49\u0E19",
            [
              13160
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1B\u0E23\u0E30\u0E41\u0E14\u0E07",
            [
              13160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E23\u0E14",
            [
              13160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1E\u0E25\u0E31\u0E1A",
            [
              13160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2A\u0E23\u0E49\u0E32\u0E07",
            [
              13170
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E27\u0E49\u0E32",
            [
              13160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E25\u0E19",
            [
              13160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E1B\u0E49\u0E07",
            [
              13160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E1E",
            [
              13160
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E22\u0E21",
            [
              13160
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E40\u0E23\u0E37\u0E2D\u0E19",
            [
              13160
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E40\u0E01\u0E34\u0E14",
            [
              13160
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E23\u0E32\u0E01\u0E19\u0E49\u0E2D\u0E22",
            [
              13180
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E44\u0E17\u0E23",
        [
          [
            "\u0E01\u0E01\u0E41\u0E01\u0E49\u0E27\u0E1A\u0E39\u0E23\u0E1E\u0E32",
            [
              13190
            ]
          ],
          [
            "\u0E01\u0E23\u0E30\u0E41\u0E0A\u0E07",
            [
              13190
            ]
          ],
          [
            "\u0E0A\u0E48\u0E32\u0E07\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              13190
            ]
          ],
          [
            "\u0E0A\u0E49\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22",
            [
              13190
            ]
          ],
          [
            "\u0E0A\u0E49\u0E32\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              13290
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E25\u0E35",
            [
              13190
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E22\u0E35\u0E48\u0E42\u0E17",
            [
              13190
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E44\u0E17\u0E23",
            [
              13190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E25\u0E36\u0E07",
            [
              13190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E21\u0E49\u0E32",
            [
              13190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E01\u0E32\u0E30",
            [
              13190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E1B\u0E49\u0E07",
            [
              13190
            ]
          ],
          [
            "\u0E23\u0E32\u0E0A\u0E04\u0E23\u0E32\u0E21",
            [
              13290
            ]
          ],
          [
            "\u0E2A\u0E19\u0E32\u0E21\u0E0A\u0E31\u0E22",
            [
              13190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E49\u0E32\u0E44\u0E21\u0E49",
            [
              13190
            ]
          ],
          [
            "\u0E2B\u0E48\u0E2D\u0E2B\u0E21\u0E01",
            [
              13190
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E23\u0E32\u0E01\u0E19\u0E49\u0E2D\u0E22",
            [
              13290
            ]
          ],
          [
            "\u0E41\u0E04\u0E15\u0E01",
            [
              13190
            ]
          ],
          [
            "\u0E41\u0E04\u0E2D\u0E2D\u0E01",
            [
              13190
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E0A\u0E49\u0E32\u0E07",
            [
              13190
            ]
          ],
          [
            "\u0E42\u0E1E\u0E41\u0E15\u0E07",
            [
              13290
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E1E\u0E23\u0E30",
            [
              13190
            ]
          ],
          [
            "\u0E44\u0E21\u0E49\u0E15\u0E23\u0E32",
            [
              13190
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E1E\u0E23\u0E01",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E19\u0E49\u0E2D\u0E22",
            [
              13240
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E1E\u0E23\u0E01",
            [
              13240
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48",
            [
              13240
            ]
          ],
          [
            "\u0E2A\u0E2D\u0E07\u0E2B\u0E49\u0E2D\u0E07",
            [
              13240
            ]
          ],
          [
            "\u0E2A\u0E33\u0E1E\u0E30\u0E40\u0E19\u0E35\u0E22\u0E07",
            [
              13240
            ]
          ]
        ]
      ],
      [
        "\u0E1C\u0E31\u0E01\u0E44\u0E2B\u0E48",
        [
          [
            "\u0E01\u0E38\u0E0E\u0E35",
            [
              13120
            ]
          ],
          [
            "\u0E08\u0E31\u0E01\u0E23\u0E32\u0E0A",
            [
              13280
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E25\u0E32\u0E19",
            [
              13280
            ]
          ],
          [
            "\u0E15\u0E32\u0E25\u0E32\u0E19",
            [
              13120
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E14\u0E34\u0E19\u0E41\u0E14\u0E07",
            [
              13120
            ]
          ],
          [
            "\u0E19\u0E32\u0E04\u0E39",
            [
              13280
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E04",
            [
              13120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E0D\u0E48",
            [
              13120
            ]
          ],
          [
            "\u0E1C\u0E31\u0E01\u0E44\u0E2B\u0E48",
            [
              13120
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E0A\u0E34\u0E14",
            [
              13120
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E19\u0E49\u0E33\u0E40\u0E04\u0E47\u0E21",
            [
              13120
            ]
          ],
          [
            "\u0E25\u0E33\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              13280
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E19\u0E49\u0E33\u0E43\u0E2B\u0E0D\u0E48",
            [
              13280
            ]
          ],
          [
            "\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E04\u0E01",
            [
              13120
            ]
          ],
          [
            "\u0E2D\u0E21\u0E24\u0E15",
            [
              13120
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E0A\u0E49\u0E32\u0E07",
            [
              13120
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E23\u0E30\u0E19\u0E04\u0E23\u0E28\u0E23\u0E35\u0E2D\u0E22\u0E38\u0E18\u0E22\u0E32",
        [
          [
            "\u0E01\u0E30\u0E21\u0E31\u0E07",
            [
              13e3
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              13e3
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2A\u0E23\u0E30\u0E1A\u0E31\u0E27",
            [
              13e3
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2A\u0E27\u0E19\u0E1E\u0E25\u0E39",
            [
              13e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E27\u0E32\u0E2A\u0E38\u0E01\u0E23\u0E35",
            [
              13e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1B\u0E49\u0E2D\u0E21",
            [
              13e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E23\u0E38\u0E19",
            [
              13e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E01\u0E32\u0E30",
            [
              13e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48",
            [
              13e3
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E15\u0E39\u0E0A\u0E31\u0E22",
            [
              13e3
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E01\u0E23\u0E32\u0E19",
            [
              13e3
            ]
          ],
          [
            "\u0E20\u0E39\u0E40\u0E02\u0E32\u0E17\u0E2D\u0E07",
            [
              13e3
            ]
          ],
          [
            "\u0E25\u0E38\u0E21\u0E1E\u0E25\u0E35",
            [
              13e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E15\u0E39\u0E21",
            [
              13e3
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E1E\u0E23\u0E34\u0E01",
            [
              13e3
            ]
          ],
          [
            "\u0E2A\u0E33\u0E40\u0E20\u0E32\u0E25\u0E48\u0E21",
            [
              13e3
            ]
          ],
          [
            "\u0E2B\u0E2D\u0E23\u0E31\u0E15\u0E19\u0E44\u0E0A\u0E22",
            [
              13e3
            ]
          ],
          [
            "\u0E2B\u0E31\u0E19\u0E15\u0E23\u0E32",
            [
              13e3
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E23\u0E2D",
            [
              13e3
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E40\u0E23\u0E35\u0E22\u0E19",
            [
              13e3
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E25\u0E34\u0E07",
            [
              13e3
            ]
          ]
        ]
      ],
      [
        "\u0E20\u0E32\u0E0A\u0E35",
        [
          [
            "\u0E01\u0E23\u0E30\u0E08\u0E34\u0E27",
            [
              13140
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E2B\u0E0D\u0E49\u0E32\u0E19\u0E32\u0E07",
            [
              13140
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E41\u0E01\u0E49\u0E27",
            [
              13140
            ]
          ],
          [
            "\u0E20\u0E32\u0E0A\u0E35",
            [
              13140
            ]
          ],
          [
            "\u0E23\u0E30\u0E42\u0E2A\u0E21",
            [
              13140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E19\u0E49\u0E33\u0E43\u0E2A",
            [
              13140
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E21\u0E48\u0E27\u0E07",
            [
              13140
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E25\u0E49\u0E2D\u0E21",
            [
              13140
            ]
          ]
        ]
      ],
      [
        "\u0E21\u0E2B\u0E32\u0E23\u0E32\u0E0A",
        [
          [
            "\u0E01\u0E30\u0E17\u0E38\u0E48\u0E21",
            [
              13150
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E15\u0E2D",
            [
              13150
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E40\u0E15\u0E49\u0E32",
            [
              13150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E19\u0E32",
            [
              13150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E02\u0E27\u0E32\u0E07",
            [
              13150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E32",
            [
              13150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48",
            [
              13150
            ]
          ],
          [
            "\u0E1E\u0E34\u0E15\u0E40\u0E1E\u0E35\u0E22\u0E19",
            [
              13150
            ]
          ],
          [
            "\u0E21\u0E2B\u0E32\u0E23\u0E32\u0E0A",
            [
              13150
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E44\u0E1C\u0E48",
            [
              13150
            ]
          ],
          [
            "\u0E40\u0E08\u0E49\u0E32\u0E1B\u0E25\u0E38\u0E01",
            [
              13150
            ]
          ],
          [
            "\u0E42\u0E23\u0E07\u0E0A\u0E49\u0E32\u0E07",
            [
              13150
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E32\u0E14\u0E1A\u0E31\u0E27\u0E2B\u0E25\u0E27\u0E07",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E1E\u0E23\u0E30\u0E22\u0E32\u0E1A\u0E31\u0E19\u0E25\u0E37\u0E2D",
            [
              13230
            ]
          ],
          [
            "\u0E04\u0E39\u0E49\u0E2A\u0E25\u0E2D\u0E14",
            [
              13230
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E22\u0E32\u0E1A\u0E31\u0E19\u0E25\u0E37\u0E2D",
            [
              13230
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E1A\u0E31\u0E27\u0E2B\u0E25\u0E27\u0E07",
            [
              13230
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              13230
            ]
          ],
          [
            "\u0E2A\u0E34\u0E07\u0E2B\u0E19\u0E32\u0E17",
            [
              13230
            ]
          ],
          [
            "\u0E2B\u0E25\u0E31\u0E01\u0E0A\u0E31\u0E22",
            [
              13230
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E07\u0E19\u0E49\u0E2D\u0E22",
        [
          [
            "\u0E02\u0E49\u0E32\u0E27\u0E07\u0E32\u0E21",
            [
              13170
            ]
          ],
          [
            "\u0E0A\u0E30\u0E41\u0E21\u0E1A",
            [
              13170
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E15\u0E32\u0E42\u0E25\u0E48",
            [
              13170
            ]
          ],
          [
            "\u0E1E\u0E22\u0E2D\u0E21",
            [
              13170
            ]
          ],
          [
            "\u0E25\u0E33\u0E15\u0E32\u0E40\u0E2A\u0E32",
            [
              13170
            ]
          ],
          [
            "\u0E25\u0E33\u0E44\u0E17\u0E23",
            [
              13170
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E08\u0E38\u0E2C\u0E32",
            [
              13170
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E19\u0E49\u0E2D\u0E22",
            [
              13170
            ]
          ],
          [
            "\u0E2A\u0E19\u0E31\u0E1A\u0E17\u0E36\u0E1A",
            [
              13170
            ]
          ],
          [
            "\u0E2B\u0E31\u0E19\u0E15\u0E30\u0E40\u0E20\u0E32",
            [
              13170
            ]
          ]
        ]
      ],
      [
        "\u0E2D\u0E38\u0E17\u0E31\u0E22",
        [
          [
            "\u0E02\u0E49\u0E32\u0E27\u0E40\u0E21\u0E48\u0E32",
            [
              13210
            ]
          ],
          [
            "\u0E04\u0E32\u0E19\u0E2B\u0E32\u0E21",
            [
              13210
            ]
          ],
          [
            "\u0E18\u0E19\u0E39",
            [
              13210
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E0A\u0E49\u0E32\u0E07",
            [
              13210
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E35\u0E1A",
            [
              13210
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E1A\u0E31\u0E13\u0E11\u0E34\u0E15",
            [
              13210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E19\u0E49\u0E33\u0E2A\u0E49\u0E21",
            [
              13210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E21\u0E49\u0E0B\u0E38\u0E07",
            [
              13210
            ]
          ],
          [
            "\u0E2D\u0E38\u0E17\u0E31\u0E22",
            [
              13210
            ]
          ],
          [
            "\u0E40\u0E2A\u0E19\u0E32",
            [
              13210
            ]
          ],
          [
            "\u0E42\u0E1E\u0E2A\u0E32\u0E27\u0E2B\u0E32\u0E0D",
            [
              13210
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E2A\u0E19\u0E32",
        [
          [
            "\u0E0A\u0E32\u0E22\u0E19\u0E32",
            [
              13110
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E17\u0E2D\u0E07",
            [
              13110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E19\u0E21\u0E42\u0E04",
            [
              13110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E23\u0E30\u0E17\u0E38\u0E48\u0E21",
            [
              13110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E25\u0E27\u0E07",
            [
              13110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E16\u0E27",
            [
              13110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E1E\u0E19",
            [
              13110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              13110
            ]
          ],
          [
            "\u0E21\u0E32\u0E23\u0E27\u0E34\u0E0A\u0E31\u0E22",
            [
              13110
            ]
          ],
          [
            "\u0E23\u0E32\u0E07\u0E08\u0E23\u0E40\u0E02\u0E49",
            [
              13110
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E07\u0E32",
            [
              13110
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E01\u0E2D",
            [
              13110
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E15\u0E38\u0E48\u0E21",
            [
              13110
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              13110
            ]
          ],
          [
            "\u0E40\u0E08\u0E49\u0E32\u0E40\u0E08\u0E47\u0E14",
            [
              13110
            ]
          ],
          [
            "\u0E40\u0E08\u0E49\u0E32\u0E40\u0E2A\u0E14\u0E47\u0E08",
            [
              13110
            ]
          ],
          [
            "\u0E40\u0E2A\u0E19\u0E32",
            [
              13110
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E1E\u0E30\u0E40\u0E22\u0E32",
    [
      [
        "\u0E08\u0E38\u0E19",
        [
          [
            "\u0E08\u0E38\u0E19",
            [
              56150
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E23\u0E27\u0E07\u0E17\u0E2D\u0E07",
            [
              56150
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E18\u0E32\u0E15\u0E38\u0E02\u0E34\u0E07\u0E41\u0E01\u0E07",
            [
              56150
            ]
          ],
          [
            "\u0E25\u0E2D",
            [
              56150
            ]
          ],
          [
            "\u0E2B\u0E07\u0E2A\u0E4C\u0E2B\u0E34\u0E19",
            [
              56150
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E02\u0E49\u0E32\u0E27\u0E01\u0E48\u0E33",
            [
              56150
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E22\u0E32\u0E07\u0E02\u0E32\u0E21",
            [
              56150
            ]
          ]
        ]
      ],
      [
        "\u0E14\u0E2D\u0E01\u0E04\u0E33\u0E43\u0E15\u0E49",
        [
          [
            "\u0E04\u0E37\u0E2D\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              56120
            ]
          ],
          [
            "\u0E14\u0E07\u0E2A\u0E38\u0E27\u0E23\u0E23\u0E13",
            [
              56120
            ]
          ],
          [
            "\u0E14\u0E2D\u0E01\u0E04\u0E33\u0E43\u0E15\u0E49",
            [
              56120
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E28\u0E23\u0E35\u0E0A\u0E38\u0E21",
            [
              56120
            ]
          ],
          [
            "\u0E1A\u0E38\u0E0D\u0E40\u0E01\u0E34\u0E14",
            [
              56120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E16\u0E49\u0E33",
            [
              56120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1B\u0E34\u0E19",
            [
              56120
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E0B\u0E32\u0E07",
            [
              56120
            ]
          ],
          [
            "\u0E2A\u0E27\u0E48\u0E32\u0E07\u0E2D\u0E32\u0E23\u0E21\u0E13\u0E4C",
            [
              56120
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E42\u0E04\u0E49\u0E07",
            [
              56120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E25\u0E48\u0E21",
            [
              56120
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E25\u0E32\u0E19",
            [
              56120
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E07",
        [
          [
            "\u0E02\u0E38\u0E19\u0E04\u0E27\u0E23",
            [
              56140
            ]
          ],
          [
            "\u0E04\u0E27\u0E23",
            [
              56140
            ]
          ],
          [
            "\u0E07\u0E34\u0E21",
            [
              56140
            ]
          ],
          [
            "\u0E19\u0E32\u0E1B\u0E23\u0E31\u0E07",
            [
              56140
            ]
          ],
          [
            "\u0E1B\u0E07",
            [
              56140
            ]
          ],
          [
            "\u0E1C\u0E32\u0E0A\u0E49\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22",
            [
              56140
            ]
          ],
          [
            "\u0E2D\u0E2D\u0E22",
            [
              56140
            ]
          ]
        ]
      ],
      [
        "\u0E20\u0E39\u0E01\u0E32\u0E21\u0E22\u0E32\u0E27",
        [
          [
            "\u0E14\u0E07\u0E40\u0E08\u0E19",
            [
              56e3
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E41\u0E01\u0E49\u0E27",
            [
              56e3
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2D\u0E34\u0E07",
            [
              56e3
            ]
          ]
        ]
      ],
      [
        "\u0E20\u0E39\u0E0B\u0E32\u0E07",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E01\u0E25\u0E49\u0E27\u0E22",
            [
              56110
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E2A\u0E31\u0E01",
            [
              56110
            ]
          ],
          [
            "\u0E20\u0E39\u0E0B\u0E32\u0E07",
            [
              56110
            ]
          ],
          [
            "\u0E2A\u0E1A\u0E1A\u0E07",
            [
              56110
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E41\u0E23\u0E07",
            [
              56110
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E04\u0E33",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E1C\u0E32\u0E2A\u0E38\u0E02",
            [
              56110
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E41\u0E27\u0E19",
            [
              56110
            ]
          ],
          [
            "\u0E1D\u0E32\u0E22\u0E01\u0E27\u0E32\u0E07",
            [
              56110
            ]
          ],
          [
            "\u0E23\u0E48\u0E21\u0E40\u0E22\u0E47\u0E19",
            [
              56110
            ]
          ],
          [
            "\u0E2B\u0E22\u0E48\u0E27\u0E19",
            [
              56110
            ]
          ],
          [
            "\u0E2D\u0E48\u0E32\u0E07\u0E17\u0E2D\u0E07",
            [
              56110
            ]
          ],
          [
            "\u0E40\u0E08\u0E14\u0E35\u0E22\u0E4C\u0E04\u0E33",
            [
              56110
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E1A\u0E32\u0E19",
            [
              56110
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              56110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E25\u0E32\u0E27",
            [
              56110
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E21\u0E48\u0E27\u0E19",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E21\u0E32\u0E07",
            [
              56160
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30",
            [
              56160
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E21\u0E48\u0E27\u0E19",
            [
              56160
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1E\u0E30\u0E40\u0E22\u0E32",
        [
          [
            "\u0E08\u0E33\u0E1B\u0E48\u0E32\u0E2B\u0E27\u0E32\u0E22",
            [
              56e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E08\u0E33\u0E1B\u0E35",
            [
              56e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E27\u0E31\u0E07\u0E17\u0E2D\u0E07",
            [
              56e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E15\u0E38\u0E48\u0E19",
            [
              56e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E15\u0E4A\u0E33",
            [
              56e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E15\u0E4B\u0E2D\u0E21",
            [
              56e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2A\u0E32\u0E07",
            [
              56e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48",
            [
              56e3
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E1B\u0E48\u0E32\u0E21\u0E48\u0E27\u0E07",
            [
              56e3
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              56e3
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E01\u0E32",
            [
              56e3
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E15\u0E4B\u0E33",
            [
              56e3
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E19\u0E32\u0E40\u0E23\u0E37\u0E2D",
            [
              56e3
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E1B\u0E37\u0E21",
            [
              56e3
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E43\u0E2A",
            [
              56e3
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E43\u0E08",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E2B\u0E25\u0E48\u0E32",
            [
              56130
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E41\u0E1D\u0E01",
            [
              56130
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E16\u0E49\u0E2D\u0E22",
            [
              56130
            ]
          ],
          [
            "\u0E40\u0E08\u0E23\u0E34\u0E0D\u0E23\u0E32\u0E29\u0E0E\u0E23\u0E4C",
            [
              56130
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E38\u0E01",
            [
              56130
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E43\u0E08",
            [
              56130
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E1E\u0E31\u0E07\u0E07\u0E32",
    [
      [
        "\u0E01\u0E30\u0E1B\u0E07",
        [
          [
            "\u0E01\u0E30\u0E1B\u0E07",
            [
              82170
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E19\u0E32",
            [
              82170
            ]
          ],
          [
            "\u0E23\u0E21\u0E13\u0E35\u0E22\u0E4C",
            [
              82170
            ]
          ],
          [
            "\u0E40\u0E2B\u0E21\u0E32\u0E30",
            [
              82170
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25",
            [
              82170
            ]
          ]
        ]
      ],
      [
        "\u0E04\u0E38\u0E23\u0E30\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E04\u0E38\u0E23\u0E30",
            [
              82150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E27\u0E31\u0E19",
            [
              82150
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E1E\u0E23\u0E30\u0E17\u0E2D\u0E07",
            [
              82150
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E19\u0E32\u0E07\u0E02\u0E32\u0E27",
            [
              82150
            ]
          ]
        ]
      ],
      [
        "\u0E15\u0E30\u0E01\u0E31\u0E48\u0E27\u0E17\u0E38\u0E48\u0E07",
        [
          [
            "\u0E01\u0E23\u0E30\u0E42\u0E2A\u0E21",
            [
              82130
            ]
          ],
          [
            "\u0E01\u0E30\u0E44\u0E2B\u0E25",
            [
              82130
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              82130
            ]
          ],
          [
            "\u0E16\u0E49\u0E33",
            [
              82130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2D\u0E22\u0E39\u0E48",
            [
              82130
            ]
          ],
          [
            "\u0E2B\u0E25\u0E48\u0E2D\u0E22\u0E39\u0E07",
            [
              82140
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E01\u0E25\u0E2D\u0E22",
            [
              82140
            ]
          ]
        ]
      ],
      [
        "\u0E15\u0E30\u0E01\u0E31\u0E48\u0E27\u0E1B\u0E48\u0E32",
        [
          [
            "\u0E04\u0E36\u0E01\u0E04\u0E31\u0E01",
            [
              82220
            ]
          ],
          [
            "\u0E15\u0E30\u0E01\u0E31\u0E48\u0E27\u0E1B\u0E48\u0E32",
            [
              82110
            ]
          ],
          [
            "\u0E15\u0E33\u0E15\u0E31\u0E27",
            [
              82110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E19\u0E32\u0E22\u0E2A\u0E35",
            [
              82110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E21\u0E48\u0E27\u0E07",
            [
              82190
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E44\u0E17\u0E23",
            [
              82110
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E04\u0E2D\u0E40\u0E02\u0E32",
            [
              82190
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              82110
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E31\u0E1A\u0E1B\u0E38\u0E14",
        [
          [
            "\u0E16\u0E49\u0E33\u0E17\u0E2D\u0E07\u0E2B\u0E25\u0E32\u0E07",
            [
              82180
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E1B\u0E38\u0E14",
            [
              82180
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E2B\u0E23\u0E35\u0E22\u0E07",
            [
              82180
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E41\u0E2A\u0E19",
            [
              82180
            ]
          ],
          [
            "\u0E21\u0E30\u0E23\u0E38\u0E48\u0E22",
            [
              82180
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E40\u0E08\u0E23\u0E34\u0E0D",
            [
              82180
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E49\u0E32\u0E22\u0E40\u0E2B\u0E21\u0E37\u0E2D\u0E07",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E21\u0E30\u0E1E\u0E23\u0E49\u0E32\u0E27",
            [
              82120
            ]
          ],
          [
            "\u0E17\u0E49\u0E32\u0E22\u0E40\u0E2B\u0E21\u0E37\u0E2D\u0E07",
            [
              82120
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E15\u0E22",
            [
              82120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E17\u0E2D\u0E07",
            [
              82120
            ]
          ],
          [
            "\u0E25\u0E33\u0E20\u0E35",
            [
              82120
            ]
          ],
          [
            "\u0E25\u0E33\u0E41\u0E01\u0E48\u0E19",
            [
              82210
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E01\u0E32\u0E30\u0E22\u0E32\u0E27",
        [
          [
            "\u0E1E\u0E23\u0E38\u0E43\u0E19",
            [
              83e3
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E22\u0E32\u0E27\u0E19\u0E49\u0E2D\u0E22",
            [
              82160
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E22\u0E32\u0E27\u0E43\u0E2B\u0E0D\u0E48",
            [
              82160
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1E\u0E31\u0E07\u0E07\u0E32",
        [
          [
            "\u0E15\u0E32\u0E01\u0E41\u0E14\u0E14",
            [
              82e3
            ]
          ],
          [
            "\u0E16\u0E49\u0E33\u0E19\u0E49\u0E33\u0E1C\u0E38\u0E14",
            [
              82e3
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E04\u0E32\u0E42\u0E07\u0E01",
            [
              82e3
            ]
          ],
          [
            "\u0E17\u0E49\u0E32\u0E22\u0E0A\u0E49\u0E32\u0E07",
            [
              82e3
            ]
          ],
          [
            "\u0E19\u0E1A\u0E1B\u0E23\u0E34\u0E07",
            [
              82e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E15\u0E22",
            [
              82e3
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E01\u0E2D",
            [
              82e3
            ]
          ],
          [
            "\u0E2A\u0E2D\u0E07\u0E41\u0E1E\u0E23\u0E01",
            [
              82e3
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E1B\u0E31\u0E19\u0E2B\u0E22\u0E35",
            [
              82e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E1E\u0E31\u0E17\u0E25\u0E38\u0E07",
    [
      [
        "\u0E01\u0E07\u0E2B\u0E23\u0E32",
        [
          [
            "\u0E01\u0E07\u0E2B\u0E23\u0E32",
            [
              93180
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E17\u0E23\u0E32\u0E22\u0E02\u0E32\u0E27",
            [
              93180
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E40\u0E09\u0E25\u0E34\u0E21",
            [
              93180
            ]
          ],
          [
            "\u0E0A\u0E30\u0E23\u0E31\u0E14",
            [
              93e3
            ]
          ],
          [
            "\u0E2A\u0E21\u0E2B\u0E27\u0E31\u0E07",
            [
              93e3
            ]
          ]
        ]
      ],
      [
        "\u0E04\u0E27\u0E19\u0E02\u0E19\u0E38\u0E19",
        [
          [
            "\u0E04\u0E27\u0E19\u0E02\u0E19\u0E38\u0E19",
            [
              93110
            ]
          ],
          [
            "\u0E0A\u0E30\u0E21\u0E27\u0E07",
            [
              93110
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E17\u0E23\u0E32\u0E22",
            [
              93110
            ]
          ],
          [
            "\u0E17\u0E30\u0E40\u0E25\u0E19\u0E49\u0E2D\u0E22",
            [
              93150
            ]
          ],
          [
            "\u0E19\u0E32\u0E02\u0E22\u0E32\u0E14",
            [
              93110
            ]
          ],
          [
            "\u0E1B\u0E31\u0E19\u0E41\u0E15",
            [
              93110
            ]
          ],
          [
            "\u0E1E\u0E19\u0E21\u0E27\u0E31\u0E07\u0E01\u0E4C",
            [
              93110
            ]
          ],
          [
            "\u0E1E\u0E19\u0E32\u0E07\u0E15\u0E38\u0E07",
            [
              93150
            ]
          ],
          [
            "\u0E21\u0E30\u0E01\u0E2D\u0E01\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              93150
            ]
          ],
          [
            "\u0E41\u0E1E\u0E23\u0E01\u0E2B\u0E32",
            [
              93110
            ]
          ],
          [
            "\u0E41\u0E2B\u0E25\u0E21\u0E42\u0E15\u0E19\u0E14",
            [
              93110
            ]
          ],
          [
            "\u0E42\u0E15\u0E19\u0E14\u0E14\u0E49\u0E27\u0E19",
            [
              93110
            ]
          ]
        ]
      ],
      [
        "\u0E15\u0E30\u0E42\u0E2B\u0E21\u0E14",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              93160
            ]
          ],
          [
            "\u0E15\u0E30\u0E42\u0E2B\u0E21\u0E14",
            [
              93160
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E02\u0E23\u0E35",
            [
              93160
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E41\u0E01\u0E49\u0E27",
        [
          [
            "\u0E17\u0E48\u0E32\u0E21\u0E30\u0E40\u0E14\u0E37\u0E48\u0E2D",
            [
              93140
            ]
          ],
          [
            "\u0E19\u0E32\u0E1B\u0E30\u0E02\u0E2D",
            [
              93140
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E31\u0E01",
            [
              93140
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E32\u0E01\u0E1E\u0E30\u0E22\u0E39\u0E19",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E17\u0E23\u0E32\u0E22",
            [
              93120
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E1B\u0E23\u0E30\u0E14\u0E39\u0E48",
            [
              93120
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E1E\u0E30\u0E22\u0E39\u0E19",
            [
              93120
            ]
          ],
          [
            "\u0E1D\u0E32\u0E25\u0E30\u0E21\u0E35",
            [
              93120
            ]
          ],
          [
            "\u0E2B\u0E32\u0E23\u0E40\u0E17\u0E32",
            [
              93120
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E19\u0E32\u0E07\u0E04\u0E33",
            [
              93120
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E2B\u0E21\u0E32\u0E01",
            [
              93120
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E48\u0E32\u0E1A\u0E2D\u0E19",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E19\u0E32\u0E23\u0E35",
            [
              93170
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E1A\u0E2D\u0E19",
            [
              93170
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E43\u0E2B\u0E21\u0E48",
            [
              93170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E18\u0E07",
            [
              93170
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E17\u0E23\u0E32\u0E22",
            [
              93170
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E48\u0E32\u0E1E\u0E30\u0E22\u0E2D\u0E21",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1E\u0E23\u0E49\u0E32\u0E27",
            [
              93210
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E1E\u0E30\u0E22\u0E2D\u0E21",
            [
              93110
            ]
          ],
          [
            "\u0E25\u0E32\u0E19\u0E02\u0E48\u0E2D\u0E22",
            [
              93110
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E40\u0E15\u0E48\u0E32",
            [
              93110
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E19\u0E04\u0E23\u0E34\u0E19\u0E17\u0E23\u0E4C",
        [
          [
            "\u0E0A\u0E38\u0E21\u0E1E\u0E25",
            [
              93e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E32",
            [
              93e3
            ]
          ],
          [
            "\u0E25\u0E33\u0E2A\u0E34\u0E19\u0E18\u0E38\u0E4C",
            [
              93e3
            ]
          ],
          [
            "\u0E2D\u0E48\u0E32\u0E07\u0E17\u0E2D\u0E07",
            [
              93e3
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E1A\u0E23\u0E23\u0E1E\u0E15",
        [
          [
            "\u0E15\u0E30\u0E41\u0E1E\u0E19",
            [
              93190
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E1B\u0E39\u0E48",
            [
              93190
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E22\u0E48\u0E32",
            [
              93190
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E02\u0E32\u0E0A\u0E31\u0E22\u0E2A\u0E19",
        [
          [
            "\u0E04\u0E27\u0E19\u0E02\u0E19\u0E38\u0E19",
            [
              93130
            ]
          ],
          [
            "\u0E08\u0E2D\u0E07\u0E16\u0E19\u0E19",
            [
              93130
            ]
          ],
          [
            "\u0E2B\u0E32\u0E19\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              93130
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E0A\u0E31\u0E22\u0E2A\u0E19",
            [
              93130
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E21\u0E48\u0E27\u0E07",
            [
              93130
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1E\u0E31\u0E17\u0E25\u0E38\u0E07",
        [
          [
            "\u0E04\u0E27\u0E19\u0E21\u0E30\u0E1E\u0E23\u0E49\u0E32\u0E27",
            [
              93e3
            ]
          ],
          [
            "\u0E04\u0E39\u0E2B\u0E32\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
            [
              93e3
            ]
          ],
          [
            "\u0E0A\u0E31\u0E22\u0E1A\u0E38\u0E23\u0E35",
            [
              93e3
            ]
          ],
          [
            "\u0E15\u0E33\u0E19\u0E32\u0E19",
            [
              93e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E21\u0E34\u0E2B\u0E23\u0E33",
            [
              93e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E41\u0E04",
            [
              93e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E17\u0E48\u0E2D\u0E21",
            [
              93e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E42\u0E2B\u0E19\u0E14",
            [
              93e3
            ]
          ],
          [
            "\u0E1B\u0E23\u0E32\u0E07\u0E2B\u0E21\u0E39\u0E48",
            [
              93e3
            ]
          ],
          [
            "\u0E1E\u0E0D\u0E32\u0E02\u0E31\u0E19",
            [
              93e3
            ]
          ],
          [
            "\u0E23\u0E48\u0E21\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              93e3
            ]
          ],
          [
            "\u0E25\u0E33\u0E1B\u0E33",
            [
              93e3
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E40\u0E08\u0E35\u0E22\u0E01",
            [
              93e3
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E0A\u0E30\u0E07\u0E32\u0E22",
            [
              93e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E1E\u0E34\u0E08\u0E34\u0E15\u0E23",
    [
      [
        "\u0E14\u0E07\u0E40\u0E08\u0E23\u0E34\u0E0D",
        [
          [
            "\u0E27\u0E31\u0E07\u0E07\u0E34\u0E49\u0E27",
            [
              66210
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E07\u0E34\u0E49\u0E27\u0E43\u0E15\u0E49",
            [
              66210
            ]
          ],
          [
            "\u0E2A\u0E33\u0E19\u0E31\u0E01\u0E02\u0E38\u0E19\u0E40\u0E13\u0E23",
            [
              66210
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E1E\u0E38\u0E01",
            [
              66210
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E23\u0E48\u0E27\u0E21",
            [
              66210
            ]
          ]
        ]
      ],
      [
        "\u0E15\u0E30\u0E1E\u0E32\u0E19\u0E2B\u0E34\u0E19",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E04\u0E39\u0E13",
            [
              66110
            ]
          ],
          [
            "\u0E07\u0E34\u0E49\u0E27\u0E23\u0E32\u0E22",
            [
              66110
            ]
          ],
          [
            "\u0E14\u0E07\u0E15\u0E30\u0E02\u0E1A",
            [
              66110
            ]
          ],
          [
            "\u0E15\u0E30\u0E1E\u0E32\u0E19\u0E2B\u0E34\u0E19",
            [
              66110
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E2B\u0E21\u0E31\u0E19",
            [
              66110
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              66150
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2A\u0E33\u0E42\u0E23\u0E07",
            [
              66110
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2B\u0E25\u0E38\u0E21",
            [
              66150
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2B\u0E27\u0E49\u0E32",
            [
              66110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1E\u0E22\u0E2D\u0E21",
            [
              66110
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E40\u0E01\u0E15\u0E38",
            [
              66110
            ]
          ],
          [
            "\u0E44\u0E17\u0E23\u0E42\u0E23\u0E07\u0E42\u0E02\u0E19",
            [
              66110
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E2B\u0E25\u0E27\u0E07",
            [
              66110
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E31\u0E1A\u0E04\u0E25\u0E49\u0E2D",
        [
          [
            "\u0E17\u0E31\u0E1A\u0E04\u0E25\u0E49\u0E2D",
            [
              66150
            ]
          ],
          [
            "\u0E17\u0E49\u0E32\u0E22\u0E17\u0E38\u0E48\u0E07",
            [
              66150
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E17\u0E23\u0E32\u0E22",
            [
              66230
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E40\u0E08\u0E47\u0E14\u0E25\u0E39\u0E01",
            [
              66230
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E21\u0E39\u0E25\u0E19\u0E32\u0E01",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E21\u0E39\u0E25\u0E19\u0E32\u0E01",
            [
              66120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E44\u0E1C\u0E48",
            [
              66120
            ]
          ],
          [
            "\u0E20\u0E39\u0E21\u0E34",
            [
              66120
            ]
          ],
          [
            "\u0E25\u0E33\u0E1B\u0E23\u0E30\u0E14\u0E32",
            [
              66120
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E01\u0E23\u0E14",
            [
              66120
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E15\u0E30\u0E01\u0E39",
            [
              66210
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2A\u0E33\u0E42\u0E23\u0E07",
            [
              66120
            ]
          ],
          [
            "\u0E2B\u0E2D\u0E44\u0E01\u0E23",
            [
              66120
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E40\u0E02\u0E19",
            [
              66120
            ]
          ],
          [
            "\u0E40\u0E19\u0E34\u0E19\u0E21\u0E30\u0E01\u0E2D\u0E01",
            [
              66120
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E36\u0E07\u0E19\u0E32\u0E23\u0E32\u0E07",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E25\u0E32\u0E22",
            [
              66130
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E19\u0E32\u0E23\u0E32\u0E07",
            [
              66130
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E41\u0E01\u0E49\u0E27",
            [
              66130
            ]
          ],
          [
            "\u0E41\u0E2B\u0E25\u0E21\u0E23\u0E31\u0E07",
            [
              66130
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E44\u0E17\u0E23\u0E07\u0E32\u0E21",
            [
              66130
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E0A\u0E34\u0E23\u0E1A\u0E32\u0E23\u0E21\u0E35",
        [
          [
            "\u0E1A\u0E36\u0E07\u0E1A\u0E31\u0E27",
            [
              66140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E32",
            [
              66140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E42\u0E21\u0E01\u0E02\u0E4C",
            [
              66140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E25\u0E38\u0E21",
            [
              66220
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E07\u0E17\u0E23\u0E32\u0E22\u0E1E\u0E39\u0E19",
        [
          [
            "\u0E27\u0E31\u0E07\u0E17\u0E23\u0E32\u0E22\u0E1E\u0E39\u0E19",
            [
              66180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E25\u0E32\u0E44\u0E2B\u0E25",
            [
              66180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E25\u0E49\u0E2D\u0E07",
            [
              66180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1E\u0E23\u0E30",
            [
              66180
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E32\u0E01\u0E40\u0E2B\u0E25\u0E47\u0E01",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E17\u0E23\u0E32\u0E22",
            [
              66160
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E22\u0E35\u0E48\u0E22\u0E21",
            [
              66160
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E17\u0E31\u0E1A\u0E44\u0E17\u0E23",
            [
              66160
            ]
          ],
          [
            "\u0E2A\u0E32\u0E01\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              66160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E0D\u0E49\u0E32\u0E44\u0E17\u0E23",
            [
              66160
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E32\u0E21\u0E07\u0E48\u0E32\u0E21",
        [
          [
            "\u0E01\u0E33\u0E41\u0E1E\u0E07\u0E14\u0E34\u0E19",
            [
              66220
            ]
          ],
          [
            "\u0E23\u0E31\u0E07\u0E19\u0E01",
            [
              66140
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E07\u0E48\u0E32\u0E21",
            [
              66140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E2A\u0E19",
            [
              66140
            ]
          ],
          [
            "\u0E40\u0E19\u0E34\u0E19\u0E1B\u0E2D",
            [
              66140
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1E\u0E34\u0E08\u0E34\u0E15\u0E23",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E04\u0E30\u0E40\u0E0A\u0E19\u0E17\u0E23\u0E4C",
            [
              66e3
            ]
          ],
          [
            "\u0E06\u0E30\u0E21\u0E31\u0E07",
            [
              66e3
            ]
          ],
          [
            "\u0E14\u0E07\u0E01\u0E25\u0E32\u0E07",
            [
              66170
            ]
          ],
          [
            "\u0E14\u0E07\u0E1B\u0E48\u0E32\u0E04\u0E33",
            [
              66170
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2B\u0E25\u0E27\u0E07",
            [
              66e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2C\u0E48\u0E2D",
            [
              66e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1A\u0E38\u0E48\u0E07",
            [
              66e3
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E17\u0E32\u0E07",
            [
              66e3
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E21\u0E30\u0E04\u0E32\u0E1A",
            [
              66e3
            ]
          ],
          [
            "\u0E22\u0E48\u0E32\u0E19\u0E22\u0E32\u0E27",
            [
              66e3
            ]
          ],
          [
            "\u0E2A\u0E32\u0E22\u0E04\u0E33\u0E42\u0E2B\u0E49",
            [
              66e3
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E14\u0E07",
            [
              66170
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E01\u0E48\u0E32",
            [
              66e3
            ]
          ],
          [
            "\u0E42\u0E23\u0E07\u0E0A\u0E49\u0E32\u0E07",
            [
              66e3
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              66e3
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E02\u0E27\u0E32\u0E07",
            [
              66e3
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E1E\u0E17\u0E30\u0E40\u0E25",
        [
          [
            "\u0E17\u0E30\u0E19\u0E07",
            [
              66130
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E19\u0E49\u0E2D\u0E22",
            [
              66130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E21\u0E34\u0E49\u0E19",
            [
              66130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E19\u0E31\u0E48\u0E07",
            [
              66130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E1A\u0E31\u0E27",
            [
              66130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E2A\u0E32",
            [
              66130
            ]
          ],
          [
            "\u0E17\u0E49\u0E32\u0E22\u0E19\u0E49\u0E33",
            [
              66130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E04\u0E25\u0E32\u0E19",
            [
              66130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E49\u0E2D\u0E22",
            [
              66130
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E02\u0E27\u0E32\u0E07",
            [
              66130
            ]
          ],
          [
            "\u0E42\u0E1E\u0E17\u0E30\u0E40\u0E25",
            [
              66130
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E1B\u0E23\u0E30\u0E17\u0E31\u0E1A\u0E0A\u0E49\u0E32\u0E07",
        [
          [
            "\u0E14\u0E07\u0E40\u0E2A\u0E37\u0E2D\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E07",
            [
              66190
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              66190
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E08\u0E34\u0E01",
            [
              66190
            ]
          ],
          [
            "\u0E40\u0E19\u0E34\u0E19\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              66190
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E1B\u0E23\u0E30\u0E17\u0E31\u0E1A\u0E0A\u0E49\u0E32\u0E07",
            [
              66190
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E17\u0E48\u0E32\u0E42\u0E1E",
            [
              66190
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E23\u0E2D\u0E1A",
            [
              66190
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E1E\u0E34\u0E29\u0E13\u0E38\u0E42\u0E25\u0E01",
    [
      [
        "\u0E0A\u0E32\u0E15\u0E34\u0E15\u0E23\u0E30\u0E01\u0E32\u0E23",
        [
          [
            "\u0E0A\u0E32\u0E15\u0E34\u0E15\u0E23\u0E30\u0E01\u0E32\u0E23",
            [
              65170
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2A\u0E30\u0E41\u0E01",
            [
              65170
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E20\u0E32\u0E04",
            [
              65170
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E14\u0E07",
            [
              65170
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E41\u0E14\u0E07",
            [
              65170
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E40\u0E21\u0E35\u0E48\u0E22\u0E07",
            [
              65170
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E04\u0E23\u0E44\u0E17\u0E22",
        [
          [
            "\u0E19\u0E04\u0E23\u0E0A\u0E38\u0E21",
            [
              65120
            ]
          ],
          [
            "\u0E19\u0E04\u0E23\u0E44\u0E17\u0E22",
            [
              65120
            ]
          ],
          [
            "\u0E19\u0E32\u0E1A\u0E31\u0E27",
            [
              65120
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E01\u0E38\u0E48\u0E21",
            [
              65120
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              65120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1E\u0E23\u0E49\u0E32\u0E27",
            [
              65120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E22\u0E07",
            [
              65120
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E42\u0E01\u0E25\u0E19",
            [
              65120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E30\u0E17\u0E49\u0E32\u0E27",
            [
              65120
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E40\u0E2E\u0E35\u0E49\u0E22",
            [
              65120
            ]
          ],
          [
            "\u0E40\u0E19\u0E34\u0E19\u0E40\u0E1E\u0E34\u0E48\u0E21",
            [
              65120
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E01\u0E23\u0E30\u0E17\u0E38\u0E48\u0E21",
        [
          [
            "\u0E17\u0E48\u0E32\u0E15\u0E32\u0E25",
            [
              65110
            ]
          ],
          [
            "\u0E19\u0E04\u0E23\u0E1B\u0E48\u0E32\u0E2B\u0E21\u0E32\u0E01",
            [
              65110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E23\u0E30\u0E17\u0E38\u0E48\u0E21",
            [
              65110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E44\u0E23\u0E48",
            [
              65110
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E15\u0E32\u0E22\u0E21",
            [
              65210
            ]
          ],
          [
            "\u0E2A\u0E19\u0E32\u0E21\u0E04\u0E25\u0E35",
            [
              65110
            ]
          ],
          [
            "\u0E40\u0E19\u0E34\u0E19\u0E01\u0E38\u0E48\u0E21",
            [
              65210
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E25\u0E38\u0E14",
            [
              65110
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E25\u0E49\u0E2D\u0E21",
            [
              65110
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E23\u0E30\u0E01\u0E33",
        [
          [
            "\u0E04\u0E38\u0E22\u0E21\u0E48\u0E27\u0E07",
            [
              65240
            ]
          ],
          [
            "\u0E0A\u0E38\u0E21\u0E41\u0E2A\u0E07\u0E2A\u0E07\u0E04\u0E23\u0E32\u0E21",
            [
              65240
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E19\u0E32\u0E07\u0E07\u0E32\u0E21",
            [
              65140
            ]
          ],
          [
            "\u0E19\u0E34\u0E04\u0E21\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              65140
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E23\u0E30\u0E01\u0E33",
            [
              65140
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E01\u0E2D\u0E01",
            [
              65140
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E17\u0E2D\u0E07",
            [
              65140
            ]
          ],
          [
            "\u0E1B\u0E25\u0E31\u0E01\u0E41\u0E23\u0E14",
            [
              65140
            ]
          ],
          [
            "\u0E1E\u0E31\u0E19\u0E40\u0E2A\u0E32",
            [
              65140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2D\u0E34\u0E17\u0E01",
            [
              65140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E38\u0E25\u0E32",
            [
              65140
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E23\u0E2B\u0E21\u0E1E\u0E34\u0E23\u0E32\u0E21",
        [
          [
            "\u0E14\u0E07\u0E1B\u0E23\u0E30\u0E04\u0E33",
            [
              65180
            ]
          ],
          [
            "\u0E15\u0E25\u0E38\u0E01\u0E40\u0E17\u0E35\u0E22\u0E21",
            [
              65180
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E22\u0E32\u0E22\u0E40\u0E0A\u0E35\u0E22\u0E07",
            [
              65150
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E0A\u0E49\u0E32\u0E07",
            [
              65150
            ]
          ],
          [
            "\u0E1E\u0E23\u0E2B\u0E21\u0E1E\u0E34\u0E23\u0E32\u0E21",
            [
              65150
            ]
          ],
          [
            "\u0E21\u0E30\u0E15\u0E39\u0E21",
            [
              65150
            ]
          ],
          [
            "\u0E21\u0E30\u0E15\u0E49\u0E2D\u0E07",
            [
              65180
            ]
          ],
          [
            "\u0E27\u0E07\u0E06\u0E49\u0E2D\u0E07",
            [
              65180
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E27\u0E19",
            [
              65150
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E20\u0E34\u0E23\u0E21\u0E22\u0E4C",
            [
              65180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E02\u0E21",
            [
              65150
            ]
          ],
          [
            "\u0E2B\u0E2D\u0E01\u0E25\u0E2D\u0E07",
            [
              65150
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E07\u0E17\u0E2D\u0E07",
        [
          [
            "\u0E0A\u0E31\u0E22\u0E19\u0E32\u0E21",
            [
              65130
            ]
          ],
          [
            "\u0E14\u0E34\u0E19\u0E17\u0E2D\u0E07",
            [
              65130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2B\u0E21\u0E37\u0E48\u0E19\u0E23\u0E32\u0E21",
            [
              65130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E25\u0E32\u0E07",
            [
              65220
            ]
          ],
          [
            "\u0E1E\u0E31\u0E19\u0E0A\u0E32\u0E25\u0E35",
            [
              65130
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E17\u0E2D\u0E07",
            [
              65130
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E19\u0E01\u0E41\u0E2D\u0E48\u0E19",
            [
              65130
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E1E\u0E34\u0E01\u0E38\u0E25",
            [
              65130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1E\u0E23\u0E30",
            [
              65130
            ]
          ],
          [
            "\u0E41\u0E01\u0E48\u0E07\u0E42\u0E2A\u0E20\u0E32",
            [
              65220
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E23\u0E30\u0E01\u0E32",
            [
              65130
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E14\u0E42\u0E1A\u0E2A\u0E16\u0E4C",
        [
          [
            "\u0E04\u0E31\u0E19\u0E42\u0E0A\u0E49\u0E07",
            [
              65160
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E07\u0E32\u0E21",
            [
              65160
            ]
          ],
          [
            "\u0E17\u0E49\u0E2D\u0E41\u0E17\u0E49",
            [
              65160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E22\u0E32\u0E07",
            [
              65160
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E42\u0E1A\u0E2A\u0E16\u0E4C",
            [
              65160
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E25\u0E32\u0E14",
            [
              65160
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E19\u0E34\u0E19\u0E21\u0E30\u0E1B\u0E23\u0E32\u0E07",
        [
          [
            "\u0E0A\u0E21\u0E1E\u0E39",
            [
              65190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E49\u0E2D\u0E22\u0E0B\u0E38\u0E49\u0E21\u0E02\u0E35\u0E49\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              65190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E21\u0E38\u0E07",
            [
              65190
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E22\u0E32\u0E07",
            [
              65190
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E42\u0E1E\u0E23\u0E07",
            [
              65190
            ]
          ],
          [
            "\u0E40\u0E19\u0E34\u0E19\u0E21\u0E30\u0E1B\u0E23\u0E32\u0E07",
            [
              65190
            ]
          ],
          [
            "\u0E44\u0E17\u0E23\u0E22\u0E49\u0E2D\u0E22",
            [
              65190
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1E\u0E34\u0E29\u0E13\u0E38\u0E42\u0E25\u0E01",
        [
          [
            "\u0E07\u0E34\u0E49\u0E27\u0E07\u0E32\u0E21",
            [
              65230
            ]
          ],
          [
            "\u0E08\u0E2D\u0E21\u0E17\u0E2D\u0E07",
            [
              65e3
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E17\u0E2D\u0E07",
            [
              65e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E17\u0E2D\u0E07",
            [
              65e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              65e3
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E1E\u0E23\u0E30",
            [
              65e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E23\u0E48\u0E32\u0E07",
            [
              65e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E04\u0E25\u0E2D\u0E07",
            [
              65e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1B\u0E48\u0E32",
            [
              65e3
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E42\u0E17\u0E01",
            [
              65e3
            ]
          ],
          [
            "\u0E1E\u0E25\u0E32\u0E22\u0E0A\u0E38\u0E21\u0E1E\u0E25",
            [
              65e3
            ]
          ],
          [
            "\u0E21\u0E30\u0E02\u0E32\u0E21\u0E2A\u0E39\u0E07",
            [
              65e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E19\u0E49\u0E33\u0E04\u0E39\u0E49",
            [
              65230
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
            [
              65e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E1E\u0E23\u0E34\u0E01",
            [
              65230
            ]
          ],
          [
            "\u0E2A\u0E21\u0E2D\u0E41\u0E02",
            [
              65e3
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E23\u0E2D",
            [
              65e3
            ]
          ],
          [
            "\u0E2D\u0E23\u0E31\u0E0D\u0E0D\u0E34\u0E01",
            [
              65e3
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              65e3
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E02\u0E2D\u0E14\u0E2D\u0E19",
            [
              65e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E20\u0E39\u0E40\u0E01\u0E47\u0E15",
    [
      [
        "\u0E01\u0E30\u0E17\u0E39\u0E49",
        [
          [
            "\u0E01\u0E21\u0E25\u0E32",
            [
              83120
            ]
          ],
          [
            "\u0E01\u0E30\u0E17\u0E39\u0E49",
            [
              83120
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E15\u0E2D\u0E07",
            [
              83150
            ]
          ]
        ]
      ],
      [
        "\u0E16\u0E25\u0E32\u0E07",
        [
          [
            "\u0E1B\u0E48\u0E32\u0E04\u0E25\u0E2D\u0E01",
            [
              83110
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E38\u0E19\u0E17\u0E23",
            [
              83110
            ]
          ],
          [
            "\u0E2A\u0E32\u0E04\u0E39",
            [
              83110
            ]
          ],
          [
            "\u0E40\u0E0A\u0E34\u0E07\u0E17\u0E30\u0E40\u0E25",
            [
              83110
            ]
          ],
          [
            "\u0E40\u0E17\u0E1E\u0E01\u0E23\u0E30\u0E29\u0E31\u0E15\u0E23\u0E35",
            [
              83110
            ]
          ],
          [
            "\u0E44\u0E21\u0E49\u0E02\u0E32\u0E27",
            [
              83110
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E20\u0E39\u0E40\u0E01\u0E47\u0E15",
        [
          [
            "\u0E01\u0E30\u0E23\u0E19",
            [
              83100
            ]
          ],
          [
            "\u0E09\u0E25\u0E2D\u0E07",
            [
              83e3
            ]
          ],
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              83e3
            ]
          ],
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E43\u0E2B\u0E0D\u0E48",
            [
              83e3
            ]
          ],
          [
            "\u0E23\u0E31\u0E29\u0E0E\u0E32",
            [
              83e3
            ]
          ],
          [
            "\u0E23\u0E32\u0E44\u0E27\u0E22\u0E4C",
            [
              83100
            ]
          ],
          [
            "\u0E27\u0E34\u0E0A\u0E34\u0E15",
            [
              83e3
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E41\u0E01\u0E49\u0E27",
            [
              83e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E21\u0E2B\u0E32\u0E2A\u0E32\u0E23\u0E04\u0E32\u0E21",
    [
      [
        "\u0E01\u0E31\u0E19\u0E17\u0E23\u0E27\u0E34\u0E0A\u0E31\u0E22",
        [
          [
            "\u0E01\u0E38\u0E14\u0E43\u0E2A\u0E49\u0E08\u0E48\u0E2D",
            [
              44150
            ]
          ],
          [
            "\u0E02\u0E32\u0E21\u0E40\u0E12\u0E48\u0E32\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              44150
            ]
          ],
          [
            "\u0E02\u0E32\u0E21\u0E40\u0E23\u0E35\u0E22\u0E07",
            [
              44150
            ]
          ],
          [
            "\u0E04\u0E31\u0E19\u0E18\u0E32\u0E23\u0E23\u0E32\u0E29\u0E0E\u0E23\u0E4C",
            [
              44150
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E2D\u0E19\u0E22\u0E32\u0E07",
            [
              44150
            ]
          ],
          [
            "\u0E19\u0E32\u0E2A\u0E35\u0E19\u0E27\u0E19",
            [
              44150
            ]
          ],
          [
            "\u0E21\u0E30\u0E04\u0E48\u0E32",
            [
              44150
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E38\u0E02",
            [
              44150
            ]
          ],
          [
            "\u0E40\u0E02\u0E27\u0E32\u0E43\u0E2B\u0E0D\u0E48",
            [
              44150
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E1E\u0E23\u0E30",
            [
              44150
            ]
          ]
        ]
      ],
      [
        "\u0E01\u0E38\u0E14\u0E23\u0E31\u0E07",
        [
          [
            "\u0E01\u0E38\u0E14\u0E23\u0E31\u0E07",
            [
              44130
            ]
          ],
          [
            "\u0E19\u0E32\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              44130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07",
            [
              44130
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E40\u0E15\u0E22",
            [
              44130
            ]
          ],
          [
            "\u0E40\u0E25\u0E34\u0E07\u0E41\u0E1D\u0E01",
            [
              44130
            ]
          ]
        ]
      ],
      [
        "\u0E0A\u0E37\u0E48\u0E19\u0E0A\u0E21",
        [
          [
            "\u0E01\u0E38\u0E14\u0E1B\u0E25\u0E32\u0E14\u0E38\u0E01",
            [
              44160
            ]
          ],
          [
            "\u0E0A\u0E37\u0E48\u0E19\u0E0A\u0E21",
            [
              44160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E38\u0E07",
            [
              44160
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E14\u0E2D\u0E01\u0E44\u0E21\u0E49",
            [
              44160
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E14\u0E39\u0E19",
        [
          [
            "\u0E01\u0E39\u0E48\u0E2A\u0E31\u0E19\u0E15\u0E23\u0E31\u0E15\u0E19\u0E4C",
            [
              44180
            ]
          ],
          [
            "\u0E14\u0E07\u0E14\u0E27\u0E19",
            [
              44180
            ]
          ],
          [
            "\u0E14\u0E07\u0E1A\u0E31\u0E07",
            [
              44180
            ]
          ],
          [
            "\u0E14\u0E07\u0E22\u0E32\u0E07",
            [
              44180
            ]
          ],
          [
            "\u0E19\u0E32\u0E14\u0E39\u0E19",
            [
              44180
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E18\u0E32\u0E15\u0E38",
            [
              44180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E04\u0E39",
            [
              44180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E1C\u0E48",
            [
              44180
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E14\u0E07",
            [
              44180
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E40\u0E0A\u0E37\u0E2D\u0E01",
        [
          [
            "\u0E19\u0E32\u0E40\u0E0A\u0E37\u0E2D\u0E01",
            [
              44170
            ]
          ],
          [
            "\u0E1B\u0E2D\u0E1E\u0E32\u0E19",
            [
              44170
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E1B\u0E48\u0E32\u0E15\u0E2D\u0E07",
            [
              44170
            ]
          ],
          [
            "\u0E2A\u0E33\u0E42\u0E23\u0E07",
            [
              44170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E38\u0E07",
            [
              44170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E21\u0E47\u0E01",
            [
              44170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E23\u0E37\u0E2D",
            [
              44170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E14\u0E07",
            [
              44170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              44170
            ]
          ],
          [
            "\u0E40\u0E02\u0E27\u0E32\u0E44\u0E23\u0E48",
            [
              44170
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E23\u0E1A\u0E37\u0E2D",
        [
          [
            "\u0E01\u0E33\u0E1E\u0E35\u0E49",
            [
              44130
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E07\u0E31\u0E27",
            [
              44130
            ]
          ],
          [
            "\u0E1A\u0E23\u0E1A\u0E37\u0E2D",
            [
              44130
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E21\u0E32\u0E28",
            [
              44130
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E43\u0E2B\u0E0D\u0E48",
            [
              44130
            ]
          ],
          [
            "\u0E22\u0E32\u0E07",
            [
              44130
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E43\u0E2B\u0E21\u0E48",
            [
              44130
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E44\u0E0A\u0E22",
            [
              44130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E04\u0E39\u0E02\u0E32\u0E14",
            [
              44130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E08\u0E34\u0E01",
            [
              44130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E21\u0E48\u0E27\u0E07",
            [
              44130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E34\u0E21",
            [
              44130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E01",
            [
              44130
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E23\u0E32\u0E29\u0E35",
            [
              44130
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E41\u0E14\u0E07",
            [
              44130
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E22\u0E31\u0E04\u0E06\u0E20\u0E39\u0E21\u0E34\u0E1E\u0E34\u0E2A\u0E31\u0E22",
        [
          [
            "\u0E01\u0E49\u0E32\u0E21\u0E1B\u0E39",
            [
              44110
            ]
          ],
          [
            "\u0E19\u0E32\u0E2A\u0E35\u0E19\u0E27\u0E25",
            [
              44110
            ]
          ],
          [
            "\u0E1B\u0E30\u0E2B\u0E25\u0E32\u0E19",
            [
              44110
            ]
          ],
          [
            "\u0E20\u0E32\u0E23\u0E41\u0E2D\u0E48\u0E19",
            [
              44110
            ]
          ],
          [
            "\u0E23\u0E32\u0E29\u0E0E\u0E23\u0E4C\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              44110
            ]
          ],
          [
            "\u0E23\u0E32\u0E29\u0E0E\u0E23\u0E4C\u0E40\u0E08\u0E23\u0E34\u0E0D",
            [
              44110
            ]
          ],
          [
            "\u0E25\u0E32\u0E19\u0E2A\u0E30\u0E41\u0E01",
            [
              44110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              44110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E41\u0E01\u0E49\u0E27",
            [
              44110
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E15\u0E32",
            [
              44110
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E2A\u0E37\u0E2D",
            [
              44110
            ]
          ],
          [
            "\u0E40\u0E21\u0E47\u0E01\u0E14\u0E33",
            [
              44110
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E0A\u0E31\u0E22",
            [
              44110
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              44110
            ]
          ]
        ]
      ],
      [
        "\u0E22\u0E32\u0E07\u0E2A\u0E35\u0E2A\u0E38\u0E23\u0E32\u0E0A",
        [
          [
            "\u0E02\u0E32\u0E21\u0E40\u0E23\u0E35\u0E22\u0E19",
            [
              44210
            ]
          ],
          [
            "\u0E14\u0E07\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              44210
            ]
          ],
          [
            "\u0E19\u0E32\u0E20\u0E39",
            [
              44210
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E39\u0E48",
            [
              44210
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E2A\u0E35\u0E2A\u0E38\u0E23\u0E32\u0E0A",
            [
              44210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E2A\u0E31\u0E19\u0E15\u0E38",
            [
              44210
            ]
          ],
          [
            "\u0E41\u0E27\u0E07\u0E14\u0E07",
            [
              44210
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E32\u0E1B\u0E35\u0E1B\u0E17\u0E38\u0E21",
        [
          [
            "\u0E02\u0E32\u0E21\u0E1B\u0E49\u0E2D\u0E21",
            [
              44120
            ]
          ],
          [
            "\u0E07\u0E31\u0E27\u0E1A\u0E32",
            [
              44120
            ]
          ],
          [
            "\u0E14\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              44120
            ]
          ],
          [
            "\u0E19\u0E32\u0E02\u0E48\u0E32",
            [
              44120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E27\u0E32\u0E22",
            [
              44120
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E0A\u0E32\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              44120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E17\u0E38\u0E48\u0E21",
            [
              44120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E2A\u0E07",
            [
              44120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E2A\u0E19",
            [
              44120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E2E",
            [
              44120
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E40\u0E23\u0E37\u0E2D",
            [
              44120
            ]
          ],
          [
            "\u0E40\u0E2A\u0E37\u0E2D\u0E42\u0E01\u0E49\u0E01",
            [
              44120
            ]
          ],
          [
            "\u0E41\u0E04\u0E19",
            [
              44120
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E35\u0E17\u0E2D\u0E07\u0E2B\u0E25\u0E32\u0E07",
            [
              44120
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E0A\u0E31\u0E22",
            [
              44120
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E22\u0E37\u0E19",
        [
          [
            "\u0E01\u0E39\u0E48\u0E17\u0E2D\u0E07",
            [
              44160
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E40\u0E07\u0E34\u0E19",
            [
              44160
            ]
          ],
          [
            "\u0E19\u0E32\u0E17\u0E2D\u0E07",
            [
              44160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E0B\u0E2D\u0E19",
            [
              44160
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E22\u0E37\u0E19",
            [
              44160
            ]
          ],
          [
            "\u0E40\u0E2A\u0E37\u0E2D\u0E40\u0E12\u0E48\u0E32",
            [
              44160
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E1A\u0E31\u0E27\u0E1A\u0E32\u0E19",
            [
              44160
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E17\u0E2D\u0E07",
            [
              44160
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E21\u0E2B\u0E32\u0E2A\u0E32\u0E23\u0E04\u0E32\u0E21",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E2B\u0E27\u0E48\u0E32\u0E19",
            [
              44e3
            ]
          ],
          [
            "\u0E15\u0E25\u0E32\u0E14",
            [
              44e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E15\u0E39\u0E21",
            [
              44e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2A\u0E2D\u0E07\u0E04\u0E2D\u0E19",
            [
              44e3
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E04\u0E49\u0E2D",
            [
              44e3
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              44e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E25\u0E34\u0E07",
            [
              44e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E19",
            [
              44e3
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E41\u0E2D\u0E48\u0E07",
            [
              44e3
            ]
          ],
          [
            "\u0E40\u0E01\u0E34\u0E49\u0E07",
            [
              44e3
            ]
          ],
          [
            "\u0E40\u0E02\u0E27\u0E32",
            [
              44e3
            ]
          ],
          [
            "\u0E41\u0E01\u0E48\u0E07\u0E40\u0E25\u0E34\u0E07\u0E08\u0E32\u0E19",
            [
              44e3
            ]
          ],
          [
            "\u0E41\u0E27\u0E07\u0E19\u0E48\u0E32\u0E07",
            [
              44e3
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E01\u0E48\u0E2D",
            [
              44e3
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E01\u0E14\u0E33",
        [
          [
            "\u0E21\u0E34\u0E15\u0E23\u0E20\u0E32\u0E1E",
            [
              44190
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E41\u0E2A\u0E07",
            [
              44190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E38\u0E07",
            [
              44190
            ]
          ],
          [
            "\u0E41\u0E01\u0E14\u0E33",
            [
              44190
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E20\u0E34\u0E1A\u0E32\u0E25",
            [
              44190
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E01\u0E2A\u0E38\u0E21\u0E1E\u0E34\u0E2A\u0E31\u0E22",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07",
            [
              44140
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E17\u0E48\u0E32\u0E41\u0E08\u0E49\u0E07",
            [
              44140
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22",
            [
              44140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E22\u0E32\u0E27",
            [
              44140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E38\u0E07\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
            [
              44140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E2D\u0E19",
            [
              44140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              44140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              44140
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E02\u0E27\u0E32\u0E07",
            [
              44140
            ]
          ],
          [
            "\u0E40\u0E02\u0E27\u0E32\u0E44\u0E23\u0E48",
            [
              44140
            ]
          ],
          [
            "\u0E40\u0E02\u0E37\u0E48\u0E2D\u0E19",
            [
              44140
            ]
          ],
          [
            "\u0E40\u0E25\u0E34\u0E07\u0E43\u0E15\u0E49",
            [
              44140
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32",
            [
              44140
            ]
          ],
          [
            "\u0E41\u0E01\u0E49\u0E07\u0E41\u0E01",
            [
              44140
            ]
          ],
          [
            "\u0E41\u0E1E\u0E07",
            [
              44140
            ]
          ],
          [
            "\u0E41\u0E2B\u0E48\u0E43\u0E15\u0E49",
            [
              44140
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E07\u0E32\u0E21",
            [
              44140
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E21\u0E38\u0E01\u0E14\u0E32\u0E2B\u0E32\u0E23",
    [
      [
        "\u0E04\u0E33\u0E0A\u0E30\u0E2D\u0E35",
        [
          [
            "\u0E04\u0E33\u0E0A\u0E30\u0E2D\u0E35",
            [
              49110
            ]
          ],
          [
            "\u0E04\u0E33\u0E1A\u0E01",
            [
              49110
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
            [
              49110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E04\u0E49\u0E2D",
            [
              49110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E0B\u0E48\u0E07",
            [
              49110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E2B\u0E25\u0E48\u0E32",
            [
              49110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E2D\u0E35\u0E48\u0E22\u0E19",
            [
              49110
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E16\u0E48\u0E2D",
            [
              49110
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E07\u0E32\u0E21",
            [
              49110
            ]
          ]
        ]
      ],
      [
        "\u0E14\u0E07\u0E2B\u0E25\u0E27\u0E07",
        [
          [
            "\u0E01\u0E01\u0E15\u0E39\u0E21",
            [
              49140
            ]
          ],
          [
            "\u0E0A\u0E30\u0E42\u0E19\u0E14\u0E19\u0E49\u0E2D\u0E22",
            [
              49140
            ]
          ],
          [
            "\u0E14\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              49140
            ]
          ],
          [
            "\u0E1E\u0E31\u0E07\u0E41\u0E14\u0E07",
            [
              49140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              49140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E04\u0E19",
            [
              49140
            ]
          ]
        ]
      ],
      [
        "\u0E14\u0E2D\u0E19\u0E15\u0E32\u0E25",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E15\u0E32\u0E25",
            [
              49120
            ]
          ],
          [
            "\u0E19\u0E32\u0E2A\u0E30\u0E40\u0E21\u0E47\u0E07",
            [
              49120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1A\u0E32\u0E01",
            [
              49120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E01\u0E49\u0E07",
            [
              49120
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E44\u0E23\u0E48",
            [
              49120
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E2B\u0E21\u0E35",
            [
              49120
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E44\u0E17\u0E23",
            [
              49120
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E34\u0E04\u0E21\u0E04\u0E33\u0E2A\u0E23\u0E49\u0E2D\u0E22",
        [
          [
            "\u0E01\u0E01\u0E41\u0E14\u0E07",
            [
              49130
            ]
          ],
          [
            "\u0E19\u0E32\u0E01\u0E2D\u0E01",
            [
              49130
            ]
          ],
          [
            "\u0E19\u0E32\u0E2D\u0E38\u0E14\u0E21",
            [
              49130
            ]
          ],
          [
            "\u0E19\u0E34\u0E04\u0E21\u0E04\u0E33\u0E2A\u0E23\u0E49\u0E2D\u0E22",
            [
              49130
            ]
          ],
          [
            "\u0E23\u0E48\u0E21\u0E40\u0E01\u0E25\u0E49\u0E32",
            [
              49130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07",
            [
              49130
            ]
          ],
          [
            "\u0E42\u0E0A\u0E04\u0E0A\u0E31\u0E22",
            [
              49130
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E39\u0E07",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E1B\u0E49\u0E32",
            [
              49160
            ]
          ],
          [
            "\u0E20\u0E39\u0E27\u0E07",
            [
              49160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E39\u0E07",
            [
              49160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E39\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              49160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E39\u0E07\u0E43\u0E15\u0E49",
            [
              49160
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E22\u0E32\u0E07",
            [
              49160
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E27\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E0D\u0E48",
        [
          [
            "\u0E0A\u0E30\u0E42\u0E19\u0E14",
            [
              49150
            ]
          ],
          [
            "\u0E14\u0E07\u0E2B\u0E21\u0E39",
            [
              49150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E17\u0E23\u0E32\u0E22\u0E19\u0E49\u0E2D\u0E22",
            [
              49150
            ]
          ],
          [
            "\u0E1B\u0E48\u0E07\u0E02\u0E32\u0E21",
            [
              49150
            ]
          ],
          [
            "\u0E2B\u0E27\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E0D\u0E48",
            [
              49150
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E21\u0E38\u0E01\u0E14\u0E32\u0E2B\u0E32\u0E23",
        [
          [
            "\u0E01\u0E38\u0E14\u0E41\u0E02\u0E49",
            [
              49e3
            ]
          ],
          [
            "\u0E04\u0E33\u0E1B\u0E48\u0E32\u0E2B\u0E25\u0E32\u0E22",
            [
              49e3
            ]
          ],
          [
            "\u0E04\u0E33\u0E2D\u0E32\u0E2E\u0E27\u0E19",
            [
              49e3
            ]
          ],
          [
            "\u0E14\u0E07\u0E21\u0E2D\u0E19",
            [
              49e3
            ]
          ],
          [
            "\u0E14\u0E07\u0E40\u0E22\u0E47\u0E19",
            [
              49e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E2A\u0E35\u0E19\u0E27\u0E19",
            [
              49e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E42\u0E2A\u0E01",
            [
              49e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E17\u0E23\u0E32\u0E22\u0E43\u0E2B\u0E0D\u0E48",
            [
              49e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E04\u0E01",
            [
              49e3
            ]
          ],
          [
            "\u0E1C\u0E36\u0E48\u0E07\u0E41\u0E14\u0E14",
            [
              49e3
            ]
          ],
          [
            "\u0E21\u0E38\u0E01\u0E14\u0E32\u0E2B\u0E32\u0E23",
            [
              49e3
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E1A\u0E38\u0E0D\u0E40\u0E23\u0E37\u0E2D\u0E07",
            [
              49e3
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E17\u0E23\u0E32\u0E22",
            [
              49e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E22\u0E30\u0E25\u0E32",
    [
      [
        "\u0E01\u0E23\u0E07\u0E1B\u0E34\u0E19\u0E31\u0E07",
        [
          [
            "\u0E01\u0E23\u0E07\u0E1B\u0E34\u0E19\u0E31\u0E07",
            [
              95e3
            ]
          ],
          [
            "\u0E1B\u0E38\u0E42\u0E23\u0E07",
            [
              95e3
            ]
          ],
          [
            "\u0E2A\u0E30\u0E40\u0E2D\u0E30",
            [
              95e3
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E01\u0E23\u0E30\u0E17\u0E34\u0E07",
            [
              95e3
            ]
          ]
        ]
      ],
      [
        "\u0E01\u0E32\u0E1A\u0E31\u0E07",
        [
          [
            "\u0E01\u0E32\u0E1A\u0E31\u0E07",
            [
              95120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E25\u0E30",
            [
              95120
            ]
          ]
        ]
      ],
      [
        "\u0E18\u0E32\u0E23\u0E42\u0E15",
        [
          [
            "\u0E04\u0E35\u0E23\u0E35\u0E40\u0E02\u0E15",
            [
              95150
            ]
          ],
          [
            "\u0E18\u0E32\u0E23\u0E42\u0E15",
            [
              95150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E2B\u0E23",
            [
              95150
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2B\u0E27\u0E32\u0E14",
            [
              95170
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E31\u0E19\u0E19\u0E31\u0E07\u0E2A\u0E15\u0E32",
        [
          [
            "\u0E15\u0E25\u0E34\u0E48\u0E07\u0E0A\u0E31\u0E19",
            [
              95130
            ]
          ],
          [
            "\u0E15\u0E32\u0E40\u0E19\u0E32\u0E30\u0E1B\u0E39\u0E40\u0E15\u0E4A\u0E30",
            [
              95130
            ]
          ],
          [
            "\u0E16\u0E49\u0E33\u0E17\u0E30\u0E25\u0E38",
            [
              95130
            ]
          ],
          [
            "\u0E1A\u0E31\u0E19\u0E19\u0E31\u0E07\u0E2A\u0E15\u0E32",
            [
              95130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E40\u0E08\u0E32\u0E30",
            [
              95130
            ]
          ],
          [
            "\u0E40\u0E02\u0E37\u0E48\u0E2D\u0E19\u0E1A\u0E32\u0E07\u0E25\u0E32\u0E07",
            [
              95130
            ]
          ]
        ]
      ],
      [
        "\u0E22\u0E30\u0E2B\u0E32",
        [
          [
            "\u0E01\u0E32\u0E15\u0E2D\u0E07",
            [
              95120
            ]
          ],
          [
            "\u0E15\u0E32\u0E0A\u0E35",
            [
              95120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E42\u0E07\u0E22\u0E0B\u0E34\u0E41\u0E19",
            [
              95120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E42\u0E23\u0E4A\u0E30",
            [
              95120
            ]
          ],
          [
            "\u0E1B\u0E30\u0E41\u0E15",
            [
              95120
            ]
          ],
          [
            "\u0E22\u0E30\u0E2B\u0E32",
            [
              95120
            ]
          ],
          [
            "\u0E25\u0E30\u0E41\u0E2D",
            [
              95120
            ]
          ]
        ]
      ],
      [
        "\u0E23\u0E32\u0E21\u0E31\u0E19",
        [
          [
            "\u0E01\u0E2D\u0E15\u0E2D\u0E15\u0E37\u0E2D\u0E23\u0E4A\u0E30",
            [
              95140
            ]
          ],
          [
            "\u0E01\u0E32\u0E22\u0E39\u0E1A\u0E2D\u0E40\u0E01\u0E32\u0E30",
            [
              95140
            ]
          ],
          [
            "\u0E01\u0E32\u0E25\u0E2D",
            [
              95140
            ]
          ],
          [
            "\u0E01\u0E32\u0E25\u0E39\u0E1B\u0E31\u0E07",
            [
              95140
            ]
          ],
          [
            "\u0E08\u0E30\u0E01\u0E27\u0E4A\u0E30",
            [
              95140
            ]
          ],
          [
            "\u0E15\u0E30\u0E42\u0E25\u0E4A\u0E30\u0E2B\u0E30\u0E25\u0E2D",
            [
              95140
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E18\u0E07",
            [
              95140
            ]
          ],
          [
            "\u0E1A\u0E32\u0E25\u0E2D",
            [
              95140
            ]
          ],
          [
            "\u0E1A\u0E32\u0E42\u0E07\u0E22",
            [
              95140
            ]
          ],
          [
            "\u0E1A\u0E37\u0E2D\u0E21\u0E31\u0E07",
            [
              95140
            ]
          ],
          [
            "\u0E22\u0E30\u0E15\u0E4A\u0E30",
            [
              95140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E1E\u0E0D\u0E32",
            [
              95140
            ]
          ],
          [
            "\u0E2D\u0E32\u0E0B\u0E48\u0E2D\u0E07",
            [
              95140
            ]
          ],
          [
            "\u0E40\u0E01\u0E30\u0E23\u0E2D",
            [
              95140
            ]
          ],
          [
            "\u0E40\u0E19\u0E34\u0E19\u0E07\u0E32\u0E21",
            [
              95140
            ]
          ],
          [
            "\u0E42\u0E01\u0E15\u0E32\u0E1A\u0E32\u0E23\u0E39",
            [
              95140
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E1A\u0E15\u0E07",
        [
          [
            "\u0E15\u0E32\u0E40\u0E19\u0E32\u0E30\u0E41\u0E21\u0E40\u0E23\u0E32\u0E30",
            [
              95110
            ]
          ],
          [
            "\u0E18\u0E32\u0E23\u0E19\u0E49\u0E33\u0E17\u0E34\u0E1E\u0E22\u0E4C",
            [
              95110
            ]
          ],
          [
            "\u0E22\u0E30\u0E23\u0E21",
            [
              95110
            ]
          ],
          [
            "\u0E2D\u0E31\u0E22\u0E40\u0E22\u0E2D\u0E23\u0E4C\u0E40\u0E27\u0E07",
            [
              95110
            ]
          ],
          [
            "\u0E40\u0E1A\u0E15\u0E07",
            [
              95110
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E22\u0E30\u0E25\u0E32",
        [
          [
            "\u0E15\u0E32\u0E40\u0E0B\u0E30",
            [
              95e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2A\u0E32\u0E1B",
            [
              95e3
            ]
          ],
          [
            "\u0E1A\u0E31\u0E19\u0E19\u0E31\u0E07\u0E2A\u0E32\u0E40\u0E23\u0E07",
            [
              95e3
            ]
          ],
          [
            "\u0E1A\u0E38\u0E14\u0E35",
            [
              95e3
            ]
          ],
          [
            "\u0E1E\u0E23\u0E48\u0E2D\u0E19",
            [
              95160
            ]
          ],
          [
            "\u0E22\u0E30\u0E25\u0E32",
            [
              95e3
            ]
          ],
          [
            "\u0E22\u0E38\u0E42\u0E1B",
            [
              95e3
            ]
          ],
          [
            "\u0E25\u0E33\u0E1E\u0E30\u0E22\u0E32",
            [
              95160
            ]
          ],
          [
            "\u0E25\u0E33\u0E43\u0E2B\u0E21\u0E48",
            [
              95160
            ]
          ],
          [
            "\u0E25\u0E34\u0E14\u0E25",
            [
              95160
            ]
          ],
          [
            "\u0E2A\u0E30\u0E40\u0E15\u0E07",
            [
              95e3
            ]
          ],
          [
            "\u0E2A\u0E30\u0E40\u0E15\u0E07\u0E19\u0E2D\u0E01",
            [
              95e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E49\u0E32\u0E16\u0E49\u0E33",
            [
              95e3
            ]
          ],
          [
            "\u0E40\u0E1B\u0E32\u0E30\u0E40\u0E2A\u0E49\u0E07",
            [
              95e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E22\u0E42\u0E2A\u0E18\u0E23",
    [
      [
        "\u0E01\u0E38\u0E14\u0E0A\u0E38\u0E21",
        [
          [
            "\u0E01\u0E33\u0E41\u0E21\u0E14",
            [
              35140
            ]
          ],
          [
            "\u0E01\u0E38\u0E14\u0E0A\u0E38\u0E21",
            [
              35140
            ]
          ],
          [
            "\u0E04\u0E33\u0E19\u0E49\u0E33\u0E2A\u0E23\u0E49\u0E32\u0E07",
            [
              35140
            ]
          ],
          [
            "\u0E19\u0E32\u0E42\u0E2A\u0E48",
            [
              35140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E21\u0E35",
            [
              35140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E2B\u0E19",
            [
              35140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E41\u0E01\u0E49\u0E07",
            [
              35140
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E40\u0E1B\u0E37\u0E2D\u0E22",
            [
              35140
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E07\u0E32\u0E21",
            [
              35140
            ]
          ]
        ]
      ],
      [
        "\u0E04\u0E33\u0E40\u0E02\u0E37\u0E48\u0E2D\u0E19\u0E41\u0E01\u0E49\u0E27",
        [
          [
            "\u0E01\u0E38\u0E14\u0E01\u0E38\u0E07",
            [
              35110
            ]
          ],
          [
            "\u0E01\u0E39\u0E48\u0E08\u0E32\u0E19",
            [
              35110
            ]
          ],
          [
            "\u0E14\u0E07\u0E40\u0E08\u0E23\u0E34\u0E0D",
            [
              35110
            ]
          ],
          [
            "\u0E14\u0E07\u0E41\u0E04\u0E19\u0E43\u0E2B\u0E0D\u0E48",
            [
              35180
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E21\u0E19",
            [
              35110
            ]
          ],
          [
            "\u0E19\u0E32\u0E04\u0E33",
            [
              35180
            ]
          ],
          [
            "\u0E19\u0E32\u0E41\u0E01",
            [
              35180
            ]
          ],
          [
            "\u0E22\u0E48\u0E2D",
            [
              35110
            ]
          ],
          [
            "\u0E25\u0E38\u0E21\u0E1E\u0E38\u0E01",
            [
              35110
            ]
          ],
          [
            "\u0E2A\u0E07\u0E40\u0E1B\u0E37\u0E2D\u0E22",
            [
              35110
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E44\u0E2E",
            [
              35110
            ]
          ],
          [
            "\u0E41\u0E04\u0E19\u0E19\u0E49\u0E2D\u0E22",
            [
              35180
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E17\u0E31\u0E19",
            [
              35110
            ]
          ]
        ]
      ],
      [
        "\u0E04\u0E49\u0E2D\u0E27\u0E31\u0E07",
        [
          [
            "\u0E01\u0E38\u0E14\u0E19\u0E49\u0E33\u0E43\u0E2A",
            [
              35160
            ]
          ],
          [
            "\u0E04\u0E49\u0E2D\u0E27\u0E31\u0E07",
            [
              35160
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E2D\u0E49\u0E2D\u0E21",
            [
              35160
            ]
          ],
          [
            "\u0E1F\u0E49\u0E32\u0E2B\u0E48\u0E27\u0E19",
            [
              35160
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E23\u0E32\u0E22\u0E21\u0E39\u0E25",
        [
          [
            "\u0E14\u0E07\u0E21\u0E30\u0E44\u0E1F",
            [
              35170
            ]
          ],
          [
            "\u0E14\u0E39\u0E48\u0E25\u0E32\u0E14",
            [
              35170
            ]
          ],
          [
            "\u0E17\u0E23\u0E32\u0E22\u0E21\u0E39\u0E25",
            [
              35170
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              35170
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48",
            [
              35170
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E48\u0E32\u0E15\u0E34\u0E49\u0E27",
        [
          [
            "\u0E01\u0E23\u0E30\u0E08\u0E32\u0E22",
            [
              35150
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E10\u0E32\u0E19",
            [
              35150
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E40\u0E1E\u0E47\u0E07",
            [
              35150
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E19\u0E32\u0E42\u0E01",
            [
              35150
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E44\u0E17\u0E23",
            [
              35150
            ]
          ]
        ]
      ],
      [
        "\u0E21\u0E2B\u0E32\u0E0A\u0E19\u0E30\u0E0A\u0E31\u0E22",
        [
          [
            "\u0E04\u0E39\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              35130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E01\u0E40\u0E23\u0E37\u0E2D",
            [
              35130
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E41\u0E01",
            [
              35130
            ]
          ],
          [
            "\u0E1C\u0E37\u0E2D\u0E2E\u0E35",
            [
              35130
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E40\u0E2A\u0E32\u0E23\u0E4C",
            [
              35130
            ]
          ],
          [
            "\u0E1F\u0E49\u0E32\u0E2B\u0E22\u0E32\u0E14",
            [
              35130
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07",
            [
              35130
            ]
          ],
          [
            "\u0E2A\u0E07\u0E22\u0E32\u0E07",
            [
              35130
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              35130
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E17\u0E23\u0E32\u0E22",
            [
              35130
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E22\u0E42\u0E2A\u0E18\u0E23",
        [
          [
            "\u0E02\u0E31\u0E49\u0E19\u0E44\u0E14\u0E43\u0E2B\u0E0D\u0E48",
            [
              35e3
            ]
          ],
          [
            "\u0E02\u0E38\u0E21\u0E40\u0E07\u0E34\u0E19",
            [
              35e3
            ]
          ],
          [
            "\u0E04\u0E49\u0E2D\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              35e3
            ]
          ],
          [
            "\u0E14\u0E39\u0E48\u0E17\u0E38\u0E48\u0E07",
            [
              35e3
            ]
          ],
          [
            "\u0E15\u0E32\u0E14\u0E17\u0E2D\u0E07",
            [
              35e3
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E19\u0E32\u0E07\u0E42\u0E2D\u0E01",
            [
              35e3
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E41\u0E15\u0E49",
            [
              35e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E2A\u0E30\u0E44\u0E21\u0E22\u0E4C",
            [
              35e3
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E04\u0E33\u0E43\u0E2B\u0E0D\u0E48",
            [
              35e3
            ]
          ],
          [
            "\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              35e3
            ]
          ],
          [
            "\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
            [
              35e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E04\u0E39",
            [
              35e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E34\u0E19",
            [
              35e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E14",
            [
              35e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E23\u0E37\u0E2D",
            [
              35e3
            ]
          ],
          [
            "\u0E40\u0E02\u0E37\u0E48\u0E2D\u0E07\u0E04\u0E33",
            [
              35e3
            ]
          ],
          [
            "\u0E40\u0E14\u0E34\u0E14",
            [
              35e3
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              35e3
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E25\u0E34\u0E07\u0E19\u0E01\u0E17\u0E32",
        [
          [
            "\u0E01\u0E38\u0E14\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E2B\u0E21\u0E35",
            [
              35120
            ]
          ],
          [
            "\u0E01\u0E38\u0E14\u0E41\u0E2B\u0E48",
            [
              35120
            ]
          ],
          [
            "\u0E1A\u0E38\u0E48\u0E07\u0E04\u0E49\u0E32",
            [
              35120
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E41\u0E01\u0E49\u0E27",
            [
              35120
            ]
          ],
          [
            "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E21\u0E34\u0E48\u0E07",
            [
              35120
            ]
          ],
          [
            "\u0E2A\u0E27\u0E32\u0E17",
            [
              35120
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E31\u0E04\u0E04\u0E35",
            [
              35120
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E41\u0E22\u0E01",
            [
              35120
            ]
          ],
          [
            "\u0E2B\u0E49\u0E2D\u0E07\u0E41\u0E0B\u0E07",
            [
              35120
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              35120
            ]
          ]
        ]
      ],
      [
        "\u0E44\u0E17\u0E22\u0E40\u0E08\u0E23\u0E34\u0E0D",
        [
          [
            "\u0E04\u0E33\u0E40\u0E15\u0E22",
            [
              35120
            ]
          ],
          [
            "\u0E04\u0E33\u0E44\u0E1C\u0E48",
            [
              35120
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E04\u0E33",
            [
              35120
            ]
          ],
          [
            "\u0E2A\u0E49\u0E21\u0E1C\u0E48\u0E2D",
            [
              35120
            ]
          ],
          [
            "\u0E44\u0E17\u0E22\u0E40\u0E08\u0E23\u0E34\u0E0D",
            [
              35120
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E23\u0E30\u0E19\u0E2D\u0E07",
    [
      [
        "\u0E01\u0E23\u0E30\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E08.\u0E1B.\u0E23.",
            [
              85110
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E08\u0E37\u0E14",
            [
              85110
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E08\u0E37\u0E14\u0E19\u0E49\u0E2D\u0E22",
            [
              85110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              85110
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E08\u0E31\u0E48\u0E19",
            [
              85110
            ]
          ],
          [
            "\u0E21\u0E30\u0E21\u0E38",
            [
              85110
            ]
          ],
          [
            "\u0E25\u0E33\u0E40\u0E25\u0E35\u0E22\u0E07",
            [
              85110
            ]
          ]
        ]
      ],
      [
        "\u0E01\u0E30\u0E40\u0E1B\u0E2D\u0E23\u0E4C",
        [
          [
            "\u0E01\u0E30\u0E40\u0E1B\u0E2D\u0E23\u0E4C",
            [
              85120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2B\u0E34\u0E19",
            [
              85120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E32",
            [
              85120
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E01\u0E25\u0E27\u0E07",
            [
              85120
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E48\u0E22\u0E27\u0E40\u0E2B\u0E25\u0E35\u0E22\u0E07",
            [
              85120
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E30\u0E2D\u0E38\u0E48\u0E19",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E23\u0E30\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              85130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E23\u0E30\u0E43\u0E15\u0E49",
            [
              85130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              85130
            ]
          ],
          [
            "\u0E25\u0E30\u0E2D\u0E38\u0E48\u0E19\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              85130
            ]
          ],
          [
            "\u0E25\u0E30\u0E2D\u0E38\u0E48\u0E19\u0E43\u0E15\u0E49",
            [
              85130
            ]
          ],
          [
            "\u0E43\u0E19\u0E27\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              85130
            ]
          ],
          [
            "\u0E43\u0E19\u0E27\u0E07\u0E43\u0E15\u0E49",
            [
              85130
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E38\u0E02\u0E2A\u0E33\u0E23\u0E32\u0E0D",
        [
          [
            "\u0E01\u0E33\u0E1E\u0E27\u0E19",
            [
              85120
            ]
          ],
          [
            "\u0E19\u0E32\u0E04\u0E32",
            [
              85120
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E23\u0E30\u0E19\u0E2D\u0E07",
        [
          [
            "\u0E17\u0E23\u0E32\u0E22\u0E41\u0E14\u0E07",
            [
              85130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E19\u0E2D\u0E19",
            [
              85e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E23\u0E34\u0E49\u0E19",
            [
              85e3
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E19\u0E49\u0E33",
            [
              85e3
            ]
          ],
          [
            "\u0E23\u0E32\u0E0A\u0E01\u0E23\u0E39\u0E14",
            [
              85e3
            ]
          ],
          [
            "\u0E2B\u0E07\u0E32\u0E27",
            [
              85e3
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E2A\u0E49\u0E21\u0E41\u0E1B\u0E49\u0E19",
            [
              85e3
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E1E\u0E22\u0E32\u0E21",
            [
              85e3
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E19\u0E34\u0E40\u0E27\u0E28\u0E19\u0E4C",
            [
              85e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E23\u0E30\u0E22\u0E2D\u0E07",
    [
      [
        "\u0E19\u0E34\u0E04\u0E21\u0E1E\u0E31\u0E12\u0E19\u0E32",
        [
          [
            "\u0E19\u0E34\u0E04\u0E21\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              21180
            ]
          ],
          [
            "\u0E1E\u0E19\u0E32\u0E19\u0E34\u0E04\u0E21",
            [
              21180
            ]
          ],
          [
            "\u0E21\u0E30\u0E02\u0E32\u0E21\u0E04\u0E39\u0E48",
            [
              21180
            ]
          ],
          [
            "\u0E21\u0E32\u0E1A\u0E02\u0E48\u0E32",
            [
              21180
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E04\u0E48\u0E32\u0E22",
        [
          [
            "\u0E0A\u0E32\u0E01\u0E1A\u0E01",
            [
              21120
            ]
          ],
          [
            "\u0E15\u0E32\u0E02\u0E31\u0E19",
            [
              21120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1A\u0E38\u0E15\u0E23",
            [
              21120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E04\u0E48\u0E32\u0E22",
            [
              21120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E15\u0E30\u0E1E\u0E32\u0E19",
            [
              21120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              21120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E25\u0E30\u0E25\u0E2D\u0E01",
            [
              21120
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E09\u0E32\u0E07",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E09\u0E32\u0E07",
            [
              21130
            ]
          ],
          [
            "\u0E1E\u0E25\u0E32",
            [
              21130
            ]
          ],
          [
            "\u0E2A\u0E33\u0E19\u0E31\u0E01\u0E17\u0E49\u0E2D\u0E19",
            [
              21130
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E25\u0E27\u0E01\u0E41\u0E14\u0E07",
        [
          [
            "\u0E15\u0E32\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C",
            [
              21140
            ]
          ],
          [
            "\u0E1B\u0E25\u0E27\u0E01\u0E41\u0E14\u0E07",
            [
              21140
            ]
          ],
          [
            "\u0E21\u0E32\u0E1A\u0E22\u0E32\u0E07\u0E1E\u0E23",
            [
              21140
            ]
          ],
          [
            "\u0E25\u0E30\u0E2B\u0E32\u0E23",
            [
              21140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E23\u0E48",
            [
              21140
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E19\u0E49\u0E33\u0E04\u0E39\u0E49",
            [
              21140
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E07\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
        [
          [
            "\u0E0A\u0E38\u0E21\u0E41\u0E2A\u0E07",
            [
              21210
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E22\u0E38\u0E1A\u0E43\u0E19",
            [
              21210
            ]
          ],
          [
            "\u0E1E\u0E25\u0E07\u0E15\u0E32\u0E40\u0E2D\u0E35\u0E48\u0E22\u0E21",
            [
              21210
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
            [
              21210
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E02\u0E32\u0E0A\u0E30\u0E40\u0E21\u0E32",
        [
          [
            "\u0E0A\u0E33\u0E06\u0E49\u0E2D",
            [
              21110
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E40\u0E1B\u0E47\u0E19",
            [
              21110
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E17\u0E31\u0E1A\u0E21\u0E2D\u0E0D",
            [
              21110
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E19\u0E49\u0E2D\u0E22",
            [
              21110
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E23\u0E30\u0E22\u0E2D\u0E07",
        [
          [
            "\u0E01\u0E30\u0E40\u0E09\u0E14",
            [
              21100
            ]
          ],
          [
            "\u0E15\u0E30\u0E1E\u0E07",
            [
              21e3
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E21\u0E32",
            [
              21e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E1B\u0E23\u0E30\u0E14\u0E39\u0E48",
            [
              21e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E15\u0E32\u0E02\u0E27\u0E31\u0E0D",
            [
              21e3
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E04\u0E2D\u0E01",
            [
              21e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E25\u0E07",
            [
              21e3
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E19\u0E49\u0E33",
            [
              21e3
            ]
          ],
          [
            "\u0E21\u0E32\u0E1A\u0E15\u0E32\u0E1E\u0E38\u0E14",
            [
              21150
            ]
          ],
          [
            "\u0E2A\u0E33\u0E19\u0E31\u0E01\u0E17\u0E2D\u0E07",
            [
              21100
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E42\u0E1B\u0E48\u0E07",
            [
              21150
            ]
          ],
          [
            "\u0E40\u0E0A\u0E34\u0E07\u0E40\u0E19\u0E34\u0E19",
            [
              21e3
            ]
          ],
          [
            "\u0E40\u0E19\u0E34\u0E19\u0E1E\u0E23\u0E30",
            [
              21e3
            ]
          ],
          [
            "\u0E40\u0E19\u0E34\u0E19\u0E1E\u0E23\u0E30",
            [
              21150
            ]
          ],
          [
            "\u0E40\u0E1E",
            [
              21160
            ]
          ],
          [
            "\u0E41\u0E01\u0E25\u0E07",
            [
              21160
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E01\u0E25\u0E07",
        [
          [
            "\u0E01\u0E23\u0E30\u0E41\u0E2A\u0E1A\u0E19",
            [
              21110
            ]
          ],
          [
            "\u0E01\u0E23\u0E48\u0E33",
            [
              21190
            ]
          ],
          [
            "\u0E01\u0E2D\u0E07\u0E14\u0E34\u0E19",
            [
              22160
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E1B\u0E39\u0E19",
            [
              21170
            ]
          ],
          [
            "\u0E0A\u0E32\u0E01\u0E1E\u0E07",
            [
              21190
            ]
          ],
          [
            "\u0E0A\u0E32\u0E01\u0E42\u0E14\u0E19",
            [
              21110
            ]
          ],
          [
            "\u0E17\u0E32\u0E07\u0E40\u0E01\u0E27\u0E35\u0E22\u0E19",
            [
              21110
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E04\u0E27\u0E32\u0E22\u0E01\u0E34\u0E19",
            [
              21110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E32",
            [
              21110
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E19\u0E49\u0E33\u0E01\u0E23\u0E30\u0E41\u0E2A",
            [
              21170
            ]
          ],
          [
            "\u0E1E\u0E31\u0E07\u0E23\u0E32\u0E14",
            [
              21170
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2B\u0E27\u0E49\u0E32",
            [
              21110
            ]
          ],
          [
            "\u0E2A\u0E2D\u0E07\u0E2A\u0E25\u0E36\u0E07",
            [
              21110
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E22\u0E32\u0E07",
            [
              21110
            ]
          ],
          [
            "\u0E40\u0E19\u0E34\u0E19\u0E06\u0E49\u0E2D",
            [
              21110
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E23\u0E32\u0E0A\u0E1A\u0E38\u0E23\u0E35",
    [
      [
        "\u0E08\u0E2D\u0E21\u0E1A\u0E36\u0E07",
        [
          [
            "\u0E08\u0E2D\u0E21\u0E1A\u0E36\u0E07",
            [
              70150
            ]
          ],
          [
            "\u0E14\u0E48\u0E32\u0E19\u0E17\u0E31\u0E1A\u0E15\u0E30\u0E42\u0E01",
            [
              70150
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E0A\u0E48\u0E2D\u0E07",
            [
              70150
            ]
          ],
          [
            "\u0E23\u0E32\u0E07\u0E1A\u0E31\u0E27",
            [
              70150
            ]
          ],
          [
            "\u0E40\u0E1A\u0E34\u0E01\u0E44\u0E1E\u0E23",
            [
              70150
            ]
          ],
          [
            "\u0E41\u0E01\u0E49\u0E21\u0E2D\u0E49\u0E19",
            [
              70150
            ]
          ]
        ]
      ],
      [
        "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E2A\u0E30\u0E14\u0E27\u0E01",
        [
          [
            "\u0E02\u0E38\u0E19\u0E1E\u0E34\u0E17\u0E31\u0E01\u0E29\u0E4C",
            [
              70130
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E01\u0E23\u0E27\u0E22",
            [
              70130
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E04\u0E25\u0E31\u0E07",
            [
              70130
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E44\u0E1C\u0E48",
            [
              70130
            ]
          ],
          [
            "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E2A\u0E30\u0E14\u0E27\u0E01",
            [
              70130
            ]
          ],
          [
            "\u0E15\u0E32\u0E2B\u0E25\u0E27\u0E07",
            [
              70130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E19\u0E31\u0E14",
            [
              70130
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E07\u0E32\u0E21",
            [
              70210
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E44\u0E23\u0E48",
            [
              70130
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E2A\u0E32\u0E17\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C",
            [
              70210
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E38\u0E23\u0E32\u0E29\u0E0E\u0E23\u0E4C",
            [
              70130
            ]
          ],
          [
            "\u0E2A\u0E35\u0E48\u0E2B\u0E21\u0E37\u0E48\u0E19",
            [
              70130
            ]
          ],
          [
            "\u0E41\u0E1E\u0E07\u0E1E\u0E27\u0E22",
            [
              70130
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E41\u0E1E",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E04\u0E32",
            [
              70160
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E43\u0E2B\u0E0D\u0E48",
            [
              70160
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E41\u0E1E",
            [
              70160
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E40\u0E22\u0E47\u0E19",
            [
              70160
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E41\u0E01\u0E49\u0E27",
            [
              70160
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E42\u0E1E",
            [
              70160
            ]
          ],
          [
            "\u0E42\u0E1E\u0E2B\u0E31\u0E01",
            [
              70160
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E04\u0E32",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E04\u0E32",
            [
              70180
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1A\u0E36\u0E07",
            [
              70180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1E\u0E31\u0E19\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
            [
              70180
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E1B\u0E48\u0E07",
        [
          [
            "\u0E01\u0E23\u0E31\u0E1A\u0E43\u0E2B\u0E0D\u0E48",
            [
              70190
            ]
          ],
          [
            "\u0E04\u0E38\u0E49\u0E07\u0E1E\u0E22\u0E2D\u0E21",
            [
              70110
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E01\u0E23\u0E30\u0E40\u0E1A\u0E37\u0E49\u0E2D\u0E07",
            [
              70110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E1C\u0E32",
            [
              70110
            ]
          ],
          [
            "\u0E19\u0E04\u0E23\u0E0A\u0E38\u0E21\u0E19\u0E4C",
            [
              70110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E21\u0E48\u0E27\u0E07",
            [
              70110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E1B\u0E48\u0E07",
            [
              70110
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E41\u0E23\u0E15",
            [
              70110
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E1A\u0E31\u0E27\u0E02\u0E32\u0E27",
            [
              70110
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E01\u0E25\u0E49\u0E27\u0E22",
            [
              70110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E1A",
            [
              70110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E25\u0E32\u0E2B\u0E21\u0E2D",
            [
              70110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2D\u0E49\u0E2D",
            [
              70110
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E02\u0E25\u0E38\u0E07",
            [
              70110
            ]
          ],
          [
            "\u0E40\u0E1A\u0E34\u0E01\u0E44\u0E1E\u0E23",
            [
              70110
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E32\u0E01\u0E17\u0E48\u0E2D",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E17\u0E23\u0E32\u0E22",
            [
              70140
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              70140
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E01\u0E23\u0E30\u0E14\u0E32\u0E19",
            [
              70140
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E17\u0E48\u0E2D",
            [
              70140
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E44\u0E01\u0E48",
            [
              70140
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E2B\u0E31\u0E01",
            [
              70140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E21\u0E30\u0E19\u0E32\u0E27",
            [
              70140
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E22\u0E32\u0E07\u0E07\u0E32\u0E21",
            [
              70140
            ]
          ],
          [
            "\u0E27\u0E31\u0E19\u0E14\u0E32\u0E27",
            [
              70140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E17\u0E38\u0E48\u0E21",
            [
              70140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E22\u0E32\u0E07\u0E42\u0E17\u0E19",
            [
              70140
            ]
          ],
          [
            "\u0E2D\u0E48\u0E32\u0E07\u0E2B\u0E34\u0E19",
            [
              70140
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E14\u0E40\u0E1E\u0E25\u0E07",
        [
          [
            "\u0E08\u0E2D\u0E21\u0E1B\u0E23\u0E30\u0E17\u0E31\u0E14",
            [
              70170
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E40\u0E1E\u0E25\u0E07",
            [
              70170
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E28\u0E32\u0E25\u0E1E\u0E23\u0E30",
            [
              70170
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E27\u0E19\u0E1C\u0E36\u0E49\u0E07",
        [
          [
            "\u0E15\u0E30\u0E19\u0E32\u0E27\u0E28\u0E23\u0E35",
            [
              70180
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E04\u0E22",
            [
              70180
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E2B\u0E27\u0E32\u0E22",
            [
              70180
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E1C\u0E36\u0E49\u0E07",
            [
              70180
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E23\u0E32\u0E0A\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E04\u0E38\u0E49\u0E07\u0E01\u0E23\u0E30\u0E16\u0E34\u0E19",
            [
              7e4
            ]
          ],
          [
            "\u0E04\u0E38\u0E49\u0E07\u0E19\u0E49\u0E33\u0E27\u0E19",
            [
              7e4
            ]
          ],
          [
            "\u0E04\u0E39\u0E1A\u0E31\u0E27",
            [
              7e4
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E15\u0E30\u0E42\u0E01",
            [
              7e4
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E41\u0E23\u0E48",
            [
              7e4
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E23\u0E32\u0E1A",
            [
              7e4
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E1E\u0E38",
            [
              7e4
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1B\u0E48\u0E32",
            [
              7e4
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E44\u0E23\u0E48",
            [
              7e4
            ]
          ],
          [
            "\u0E1E\u0E07\u0E2A\u0E27\u0E32\u0E22",
            [
              7e4
            ]
          ],
          [
            "\u0E1E\u0E34\u0E01\u0E38\u0E25\u0E17\u0E2D\u0E07",
            [
              7e4
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E40\u0E23\u0E37\u0E2D\u0E19",
            [
              7e4
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E25\u0E32\u0E07\u0E19\u0E32",
            [
              7e4
            ]
          ],
          [
            "\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              7e4
            ]
          ],
          [
            "\u0E2B\u0E25\u0E38\u0E21\u0E14\u0E34\u0E19",
            [
              7e4
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E01\u0E2D\u0E07",
            [
              7e4
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E44\u0E1C\u0E48",
            [
              7e4
            ]
          ],
          [
            "\u0E2D\u0E48\u0E32\u0E07\u0E17\u0E2D\u0E07",
            [
              7e4
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E1E\u0E25\u0E31\u0E1A\u0E1E\u0E25\u0E32",
            [
              7e4
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E41\u0E23\u0E49\u0E07",
            [
              7e4
            ]
          ],
          [
            "\u0E40\u0E08\u0E14\u0E35\u0E22\u0E4C\u0E2B\u0E31\u0E01",
            [
              7e4
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2B\u0E21\u0E49\u0E2D",
            [
              7e4
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E1E\u0E18\u0E32\u0E23\u0E32\u0E21",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E02\u0E48\u0E2D\u0E22",
            [
              70120
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E15\u0E32\u0E04\u0E15",
            [
              70120
            ]
          ],
          [
            "\u0E0A\u0E33\u0E41\u0E23\u0E30",
            [
              70120
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E01\u0E23\u0E30\u0E40\u0E1A\u0E37\u0E49\u0E2D\u0E07",
            [
              70120
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E17\u0E23\u0E32\u0E22",
            [
              70120
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E0A\u0E38\u0E21\u0E1E\u0E25",
            [
              70120
            ]
          ],
          [
            "\u0E18\u0E23\u0E23\u0E21\u0E40\u0E2A\u0E19",
            [
              70120
            ]
          ],
          [
            "\u0E19\u0E32\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              70120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E42\u0E15\u0E19\u0E14",
            [
              70120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E06\u0E49\u0E2D\u0E07",
            [
              70120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
            [
              70120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E25\u0E37\u0E2D\u0E01",
            [
              70120
            ]
          ],
          [
            "\u0E2A\u0E23\u0E49\u0E2D\u0E22\u0E1F\u0E49\u0E32",
            [
              70120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E27\u0E32\u0E07",
            [
              70120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E1E",
            [
              70120
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E0A\u0E30\u0E07\u0E38\u0E49\u0E21",
            [
              70120
            ]
          ],
          [
            "\u0E40\u0E08\u0E47\u0E14\u0E40\u0E2A\u0E21\u0E35\u0E22\u0E19",
            [
              70120
            ]
          ],
          [
            "\u0E40\u0E15\u0E32\u0E1B\u0E39\u0E19",
            [
              70120
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E32\u0E23\u0E32\u0E21",
            [
              70120
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E23\u0E49\u0E2D\u0E22\u0E40\u0E2D\u0E47\u0E14",
    [
      [
        "\u0E08\u0E15\u0E38\u0E23\u0E1E\u0E31\u0E01\u0E15\u0E23\u0E4C\u0E1E\u0E34\u0E21\u0E32\u0E19",
        [
          [
            "\u0E14\u0E07\u0E01\u0E25\u0E32\u0E07",
            [
              45180
            ]
          ],
          [
            "\u0E14\u0E07\u0E41\u0E14\u0E07",
            [
              45180
            ]
          ],
          [
            "\u0E14\u0E39\u0E48\u0E19\u0E49\u0E2D\u0E22",
            [
              45180
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E43\u0E2A",
            [
              45180
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E2A\u0E31\u0E07\u0E02\u0E4C",
            [
              45180
            ]
          ],
          [
            "\u0E25\u0E34\u0E49\u0E19\u0E1F\u0E49\u0E32",
            [
              45180
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E42\u0E04\u0E15\u0E23",
            [
              45180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1C\u0E37\u0E2D",
            [
              45180
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E0A\u0E49\u0E32\u0E07",
            [
              45180
            ]
          ],
          [
            "\u0E2D\u0E35\u0E07\u0E48\u0E2D\u0E07",
            [
              45180
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2B\u0E07\u0E2A\u0E4C",
            [
              45180
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E25\u0E48\u0E32\u0E21",
            [
              45180
            ]
          ]
        ]
      ],
      [
        "\u0E08\u0E31\u0E07\u0E2B\u0E32\u0E23",
        [
          [
            "\u0E08\u0E31\u0E07\u0E2B\u0E32\u0E23",
            [
              45e3
            ]
          ],
          [
            "\u0E14\u0E07\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
            [
              45e3
            ]
          ],
          [
            "\u0E14\u0E34\u0E19\u0E14\u0E33",
            [
              45e3
            ]
          ],
          [
            "\u0E1B\u0E32\u0E1D\u0E32",
            [
              45e3
            ]
          ],
          [
            "\u0E1C\u0E31\u0E01\u0E41\u0E27\u0E48\u0E19",
            [
              45e3
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E25\u0E32\u0E14",
            [
              45e3
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              45e3
            ]
          ],
          [
            "\u0E41\u0E2A\u0E19\u0E0A\u0E32\u0E15\u0E34",
            [
              45e3
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E38\u0E48\u0E07\u0E40\u0E02\u0E32\u0E2B\u0E25\u0E27\u0E07",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E40\u0E02\u0E32\u0E2B\u0E25\u0E27\u0E07",
            [
              45170
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E07\u0E32\u0E21",
            [
              45170
            ]
          ],
          [
            "\u0E21\u0E30\u0E1A\u0E49\u0E32",
            [
              45170
            ]
          ],
          [
            "\u0E40\u0E17\u0E2D\u0E14\u0E44\u0E17\u0E22",
            [
              45170
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32",
            [
              45170
            ]
          ]
        ]
      ],
      [
        "\u0E18\u0E27\u0E31\u0E0A\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E18\u0E07\u0E18\u0E32\u0E19\u0E35",
            [
              45170
            ]
          ],
          [
            "\u0E18\u0E27\u0E31\u0E0A\u0E1A\u0E38\u0E23\u0E35",
            [
              45170
            ]
          ],
          [
            "\u0E19\u0E34\u0E40\u0E27\u0E28\u0E19\u0E4C",
            [
              45170
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E19\u0E04\u0E23",
            [
              45170
            ]
          ],
          [
            "\u0E21\u0E30\u0E2D\u0E36",
            [
              45170
            ]
          ],
          [
            "\u0E23\u0E32\u0E0A\u0E18\u0E32\u0E19\u0E35",
            [
              45170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1E\u0E2D\u0E01",
            [
              45170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E1C\u0E48",
            [
              45170
            ]
          ],
          [
            "\u0E2D\u0E38\u0E48\u0E21\u0E40\u0E21\u0E49\u0E32",
            [
              45170
            ]
          ],
          [
            "\u0E40\u0E02\u0E27\u0E32\u0E17\u0E38\u0E48\u0E07",
            [
              45170
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E19\u0E49\u0E2D\u0E22",
            [
              45170
            ]
          ],
          [
            "\u0E44\u0E1E\u0E28\u0E32\u0E25",
            [
              45170
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E17\u0E38\u0E21\u0E23\u0E31\u0E15\u0E15\u0E4C",
        [
          [
            "\u0E02\u0E35\u0E49\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              45190
            ]
          ],
          [
            "\u0E14\u0E2D\u0E01\u0E25\u0E49\u0E33",
            [
              45190
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E41\u0E14\u0E07",
            [
              45190
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E1A\u0E31\u0E27",
            [
              45190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E04\u0E19",
            [
              45190
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E07\u0E48\u0E32",
            [
              45190
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
            [
              45190
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E2A\u0E39\u0E07",
            [
              45190
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E19\u0E21\u0E44\u0E1E\u0E23",
        [
          [
            "\u0E01\u0E38\u0E14\u0E19\u0E49\u0E33\u0E43\u0E2A",
            [
              45140
            ]
          ],
          [
            "\u0E04\u0E33\u0E44\u0E2E",
            [
              45140
            ]
          ],
          [
            "\u0E04\u0E49\u0E2D\u0E43\u0E2B\u0E0D\u0E48",
            [
              45140
            ]
          ],
          [
            "\u0E0A\u0E32\u0E19\u0E38\u0E27\u0E23\u0E23\u0E13",
            [
              45140
            ]
          ],
          [
            "\u0E19\u0E32\u0E19\u0E27\u0E25",
            [
              45140
            ]
          ],
          [
            "\u0E1E\u0E19\u0E21\u0E44\u0E1E\u0E23",
            [
              45140
            ]
          ],
          [
            "\u0E27\u0E32\u0E23\u0E35\u0E2A\u0E27\u0E31\u0E2A\u0E14\u0E34\u0E4C",
            [
              45140
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E41\u0E01\u0E49\u0E27",
            [
              45140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E17\u0E31\u0E1E\u0E44\u0E17\u0E22",
            [
              45140
            ]
          ],
          [
            "\u0E41\u0E2A\u0E19\u0E2A\u0E38\u0E02",
            [
              45140
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              45140
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E0A\u0E31\u0E22",
            [
              45140
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E43\u0E2B\u0E0D\u0E48",
            [
              45140
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E2A\u0E21\u0E40\u0E14\u0E47\u0E08",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1A\u0E32\u0E01",
            [
              45e3
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E21\u0E40\u0E14\u0E47\u0E08",
            [
              45e3
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E08\u0E34\u0E01",
            [
              45280
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07\u0E04\u0E27\u0E07",
            [
              45e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              45e3
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E1B\u0E25\u0E37\u0E2D\u0E22",
            [
              45e3
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E17\u0E2D\u0E07",
            [
              45e3
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E2A\u0E31\u0E22",
            [
              45280
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E38\u0E27\u0E23\u0E23\u0E13\u0E20\u0E39\u0E21\u0E34",
        [
          [
            "\u0E08\u0E33\u0E1B\u0E32\u0E02\u0E31\u0E19",
            [
              45130
            ]
          ],
          [
            "\u0E0A\u0E49\u0E32\u0E07\u0E40\u0E1C\u0E37\u0E2D\u0E01",
            [
              45130
            ]
          ],
          [
            "\u0E14\u0E2D\u0E01\u0E44\u0E21\u0E49",
            [
              45130
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E01\u0E38\u0E25\u0E32",
            [
              45130
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E28\u0E23\u0E35\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              45130
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              45130
            ]
          ],
          [
            "\u0E19\u0E32\u0E43\u0E2B\u0E0D\u0E48",
            [
              45130
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E04\u0E33",
            [
              45130
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E1E\u0E31\u0E19\u0E02\u0E31\u0E19",
            [
              45130
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E04\u0E39",
            [
              45130
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E0A\u0E49\u0E32\u0E07",
            [
              45130
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E42\u0E17\u0E19",
            [
              45130
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E01\u0E2D\u0E07",
            [
              45130
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E2B\u0E34\u0E19\u0E25\u0E32\u0E14",
            [
              45130
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E17\u0E38\u0E48\u0E07",
            [
              45130
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E1E\u0E2D\u0E01",
        [
          [
            "\u0E01\u0E01\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              45210
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2A\u0E35\u0E14\u0E32",
            [
              45210
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E07\u0E32\u0E21",
            [
              45210
            ]
          ],
          [
            "\u0E1C\u0E32\u0E19\u0E49\u0E33\u0E22\u0E49\u0E2D\u0E22",
            [
              45210
            ]
          ],
          [
            "\u0E20\u0E39\u0E40\u0E02\u0E32\u0E17\u0E2D\u0E07",
            [
              45210
            ]
          ],
          [
            "\u0E23\u0E2D\u0E1A\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              45210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E38\u0E48\u0E19\u0E43\u0E2B\u0E0D\u0E48",
            [
              45210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1E\u0E2D\u0E01",
            [
              45210
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              45210
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E2E\u0E35",
        [
          [
            "\u0E14\u0E39\u0E01\u0E2D\u0E36\u0E48\u0E07",
            [
              45140
            ]
          ],
          [
            "\u0E2A\u0E32\u0E27\u0E41\u0E2B",
            [
              45140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2E\u0E35",
            [
              45140
            ]
          ],
          [
            "\u0E40\u0E14\u0E48\u0E19\u0E23\u0E32\u0E29\u0E0E\u0E23\u0E4C",
            [
              45140
            ]
          ]
        ]
      ],
      [
        "\u0E2D\u0E32\u0E08\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16",
        [
          [
            "\u0E02\u0E35\u0E49\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              45160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E14\u0E39\u0E48",
            [
              45160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E08\u0E49\u0E07",
            [
              45160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E32\u0E21",
            [
              45160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              45160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E21\u0E37\u0E48\u0E19\u0E16\u0E48\u0E32\u0E19",
            [
              45160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E48\u0E2D\u0E21",
            [
              45160
            ]
          ],
          [
            "\u0E2D\u0E32\u0E08\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16",
            [
              45160
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              45160
            ]
          ],
          [
            "\u0E42\u0E2B\u0E23\u0E32",
            [
              45160
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E01\u0E29\u0E15\u0E23\u0E27\u0E34\u0E2A\u0E31\u0E22",
        [
          [
            "\u0E01\u0E33\u0E41\u0E1E\u0E07",
            [
              45150
            ]
          ],
          [
            "\u0E01\u0E39\u0E48\u0E01\u0E32\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
            [
              45150
            ]
          ],
          [
            "\u0E14\u0E07\u0E04\u0E23\u0E31\u0E48\u0E07\u0E19\u0E49\u0E2D\u0E22",
            [
              45150
            ]
          ],
          [
            "\u0E14\u0E07\u0E04\u0E23\u0E31\u0E48\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              45150
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E17\u0E2D\u0E07",
            [
              45150
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E2D\u0E49\u0E2D\u0E21",
            [
              45150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1D\u0E32\u0E07",
            [
              45150
            ]
          ],
          [
            "\u0E2A\u0E34\u0E07\u0E2B\u0E4C\u0E42\u0E04\u0E01",
            [
              45150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07",
            [
              45150
            ]
          ],
          [
            "\u0E40\u0E01\u0E29\u0E15\u0E23\u0E27\u0E34\u0E2A\u0E31\u0E22",
            [
              45150
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              45150
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E2B\u0E25\u0E27\u0E07",
            [
              45150
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              45150
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E02\u0E27\u0E31\u0E0D",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E02\u0E37\u0E2D\u0E07",
            [
              45e3
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E18\u0E32\u0E15\u0E38",
            [
              45e3
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E40\u0E08\u0E49\u0E32",
            [
              45e3
            ]
          ],
          [
            "\u0E1E\u0E25\u0E31\u0E1A\u0E1E\u0E25\u0E32",
            [
              45170
            ]
          ],
          [
            "\u0E2B\u0E21\u0E39\u0E21\u0E49\u0E19",
            [
              45170
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E02\u0E27\u0E31\u0E0D",
            [
              45e3
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E22\u0E27\u0E14\u0E35",
        [
          [
            "\u0E0A\u0E21\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              45250
            ]
          ],
          [
            "\u0E0A\u0E38\u0E21\u0E1E\u0E23",
            [
              45250
            ]
          ],
          [
            "\u0E1A\u0E38\u0E48\u0E07\u0E40\u0E25\u0E34\u0E28",
            [
              45250
            ]
          ],
          [
            "\u0E40\u0E21\u0E22\u0E27\u0E14\u0E35",
            [
              45250
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E23\u0E49\u0E2D\u0E22\u0E40\u0E2D\u0E47\u0E14",
        [
          [
            "\u0E02\u0E2D\u0E19\u0E41\u0E01\u0E48\u0E19",
            [
              45e3
            ]
          ],
          [
            "\u0E14\u0E07\u0E25\u0E32\u0E19",
            [
              45e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              45e3
            ]
          ],
          [
            "\u0E1B\u0E2D\u0E20\u0E32\u0E23",
            [
              45e3
            ]
          ],
          [
            "\u0E23\u0E2D\u0E1A\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              45e3
            ]
          ],
          [
            "\u0E2A\u0E30\u0E2D\u0E32\u0E14\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              45e3
            ]
          ],
          [
            "\u0E2A\u0E35\u0E41\u0E01\u0E49\u0E27",
            [
              45e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              45e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07",
            [
              45e3
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E17\u0E2D\u0E07",
            [
              45e3
            ]
          ],
          [
            "\u0E40\u0E2B\u0E19\u0E37\u0E2D\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              45e3
            ]
          ],
          [
            "\u0E41\u0E04\u0E19\u0E43\u0E2B\u0E0D\u0E48",
            [
              45e3
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E15\u0E32\u0E25",
            [
              45e3
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E23\u0E31\u0E07",
            [
              45e3
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              45e3
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2A\u0E23\u0E27\u0E07",
        [
          [
            "\u0E01\u0E01\u0E01\u0E38\u0E07",
            [
              45220
            ]
          ],
          [
            "\u0E04\u0E39\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              45220
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1C\u0E37\u0E2D",
            [
              45220
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E34\u0E19",
            [
              45220
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2A\u0E23\u0E27\u0E07",
            [
              45220
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E2A\u0E25\u0E20\u0E39\u0E21\u0E34",
        [
          [
            "\u0E01\u0E25\u0E32\u0E07",
            [
              45120
            ]
          ],
          [
            "\u0E02\u0E27\u0E31\u0E0D\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              45120
            ]
          ],
          [
            "\u0E02\u0E27\u0E32\u0E27",
            [
              45120
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E21\u0E48\u0E27\u0E07",
            [
              45120
            ]
          ],
          [
            "\u0E19\u0E32\u0E07\u0E32\u0E21",
            [
              45120
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              45120
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E25\u0E34\u0E07",
            [
              45120
            ]
          ],
          [
            "\u0E19\u0E32\u0E41\u0E0B\u0E07",
            [
              45120
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E40\u0E01\u0E25\u0E37\u0E2D",
            [
              45120
            ]
          ],
          [
            "\u0E1E\u0E23\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
            [
              45120
            ]
          ],
          [
            "\u0E20\u0E39\u0E40\u0E07\u0E34\u0E19",
            [
              45120
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              45120
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E27\u0E34\u0E25\u0E31\u0E22",
            [
              45120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              45120
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E41\u0E01\u0E49\u0E27",
            [
              45120
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E44\u0E1E\u0E23",
            [
              45120
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E49\u0E2D\u0E22",
            [
              45120
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E17\u0E2D\u0E07",
            [
              45120
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E0A\u0E31\u0E22",
        [
          [
            "\u0E02\u0E32\u0E21\u0E40\u0E1B\u0E35\u0E49\u0E22",
            [
              45230
            ]
          ],
          [
            "\u0E04\u0E33\u0E1E\u0E2D\u0E38\u0E07",
            [
              45230
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E42\u0E2D\u0E07",
            [
              45230
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E04\u0E33",
            [
              45230
            ]
          ],
          [
            "\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              45230
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E15\u0E32\u0E44\u0E01\u0E49",
            [
              45230
            ]
          ],
          [
            "\u0E2D\u0E31\u0E04\u0E04\u0E30\u0E04\u0E33",
            [
              45230
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E43\u0E2B\u0E21\u0E48",
            [
              45230
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E28\u0E23\u0E35",
            [
              45230
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E1E\u0E19\u0E17\u0E23\u0E32\u0E22",
        [
          [
            "\u0E17\u0E48\u0E32\u0E2B\u0E32\u0E14\u0E22\u0E32\u0E27",
            [
              45240
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E04\u0E33",
            [
              45240
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              45240
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E02\u0E32",
            [
              45240
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E17\u0E23\u0E32\u0E22",
            [
              45240
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E1E\u0E19\u0E17\u0E2D\u0E07",
        [
          [
            "\u0E04\u0E33\u0E19\u0E32\u0E14\u0E35",
            [
              45110
            ]
          ],
          [
            "\u0E19\u0E32\u0E2D\u0E38\u0E14\u0E21",
            [
              45110
            ]
          ],
          [
            "\u0E1E\u0E23\u0E21\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
            [
              45110
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2A\u0E32\u0E21\u0E31\u0E04\u0E04\u0E35",
            [
              45110
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E19\u0E01\u0E41\u0E01\u0E49\u0E27",
            [
              45110
            ]
          ],
          [
            "\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              45110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              45110
            ]
          ],
          [
            "\u0E2D\u0E38\u0E48\u0E21\u0E40\u0E21\u0E48\u0E32",
            [
              45110
            ]
          ],
          [
            "\u0E41\u0E27\u0E07",
            [
              45110
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E01\u0E01\u0E21\u0E48\u0E27\u0E07",
            [
              45110
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E39\u0E07",
            [
              45110
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E0A\u0E31\u0E22\u0E28\u0E23\u0E35",
            [
              45110
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E17\u0E2D\u0E07",
            [
              45110
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E28\u0E23\u0E35\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              45110
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E25\u0E1E\u0E1A\u0E38\u0E23\u0E35",
    [
      [
        "\u0E0A\u0E31\u0E22\u0E1A\u0E32\u0E14\u0E32\u0E25",
        [
          [
            "\u0E0A\u0E31\u0E22\u0E19\u0E32\u0E23\u0E32\u0E22\u0E13\u0E4C",
            [
              15130
            ]
          ],
          [
            "\u0E0A\u0E31\u0E22\u0E1A\u0E32\u0E14\u0E32\u0E25",
            [
              15230
            ]
          ],
          [
            "\u0E0B\u0E31\u0E1A\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              15130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E14\u0E34\u0E19\u0E14\u0E33",
            [
              15130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E21\u0E30\u0E19\u0E32\u0E27",
            [
              15130
            ]
          ],
          [
            "\u0E19\u0E32\u0E42\u0E2A\u0E21",
            [
              15190
            ]
          ],
          [
            "\u0E19\u0E34\u0E04\u0E21\u0E25\u0E33\u0E19\u0E32\u0E23\u0E32\u0E22\u0E13\u0E4C",
            [
              15130
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E0A\u0E38\u0E21",
            [
              15130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E31\u0E04\u0E04\u0E35",
            [
              15130
            ]
          ],
          [
            "\u0E21\u0E30\u0E01\u0E2D\u0E01\u0E2B\u0E27\u0E32\u0E19",
            [
              15230
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E04\u0E48\u0E2D\u0E21",
            [
              15230
            ]
          ],
          [
            "\u0E25\u0E33\u0E19\u0E32\u0E23\u0E32\u0E22\u0E13\u0E4C",
            [
              15130
            ]
          ],
          [
            "\u0E28\u0E34\u0E25\u0E32\u0E17\u0E34\u0E1E\u0E22\u0E4C",
            [
              15130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E22\u0E32\u0E22\u0E42\u0E15\u0E4A\u0E30",
            [
              15130
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E2B\u0E34\u0E19",
            [
              15130
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E23\u0E31\u0E07",
            [
              15130
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E41\u0E2B\u0E25\u0E21",
            [
              15130
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E48\u0E32\u0E27\u0E38\u0E49\u0E07",
        [
          [
            "\u0E17\u0E48\u0E32\u0E27\u0E38\u0E49\u0E07",
            [
              15150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E04\u0E39\u0E49",
            [
              15150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E07\u0E32",
            [
              15150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E25\u0E35\u0E48",
            [
              15150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E1A\u0E34\u0E01",
            [
              15150
            ]
          ],
          [
            "\u0E21\u0E38\u0E08\u0E25\u0E34\u0E19\u0E17\u0E4C",
            [
              15150
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E2A\u0E32\u0E25\u0E35\u0E48",
            [
              15150
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E2A\u0E33\u0E42\u0E23\u0E07",
            [
              15150
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E2A\u0E21\u0E2D\u0E04\u0E2D\u0E19",
            [
              15180
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E25\u0E38\u0E14",
            [
              15150
            ]
          ],
          [
            "\u0E42\u0E1E\u0E15\u0E25\u0E32\u0E14\u0E41\u0E01\u0E49\u0E27",
            [
              15150
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E48\u0E32\u0E2B\u0E25\u0E27\u0E07",
        [
          [
            "\u0E0B\u0E31\u0E1A\u0E08\u0E33\u0E1B\u0E32",
            [
              15230
            ]
          ],
          [
            "\u0E17\u0E30\u0E40\u0E25\u0E27\u0E31\u0E07\u0E27\u0E31\u0E14",
            [
              15230
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2B\u0E25\u0E27\u0E07",
            [
              15230
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1C\u0E31\u0E01\u0E41\u0E27\u0E48\u0E19",
            [
              15230
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E25\u0E33",
            [
              15230
            ]
          ],
          [
            "\u0E41\u0E01\u0E48\u0E07\u0E1C\u0E31\u0E01\u0E01\u0E39\u0E14",
            [
              15230
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E21\u0E35\u0E48",
        [
          [
            "\u0E0A\u0E2D\u0E19\u0E21\u0E48\u0E27\u0E07",
            [
              15110
            ]
          ],
          [
            "\u0E14\u0E07\u0E1E\u0E25\u0E31\u0E1A",
            [
              15110
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E14\u0E36\u0E07",
            [
              15110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E30\u0E1E\u0E35\u0E49",
            [
              15110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E02\u0E32\u0E21",
            [
              15180
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E36\u0E48\u0E07",
            [
              15110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E25\u0E49\u0E27\u0E22",
            [
              15110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E0A\u0E35",
            [
              15180
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E17\u0E23\u0E32\u0E22",
            [
              15110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E21\u0E35\u0E48",
            [
              15110
            ]
          ],
          [
            "\u0E1E\u0E38\u0E04\u0E32",
            [
              15110
            ]
          ],
          [
            "\u0E21\u0E2B\u0E32\u0E2A\u0E2D\u0E19",
            [
              15110
            ]
          ],
          [
            "\u0E2A\u0E19\u0E32\u0E21\u0E41\u0E08\u0E07",
            [
              15110
            ]
          ],
          [
            "\u0E2A\u0E32\u0E22\u0E2B\u0E49\u0E27\u0E22\u0E41\u0E01\u0E49\u0E27",
            [
              15110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19",
            [
              15110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E17\u0E23\u0E32\u0E22\u0E02\u0E32\u0E27",
            [
              15110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E15\u0E48\u0E32",
            [
              15110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              15110
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E1B\u0E31\u0E01",
            [
              15110
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E07\u0E32",
            [
              15110
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E17\u0E2D\u0E07",
            [
              15110
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E43\u0E2B\u0E0D\u0E48",
            [
              15110
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E19\u0E34\u0E04\u0E21",
        [
          [
            "\u0E0A\u0E2D\u0E19\u0E19\u0E49\u0E2D\u0E22",
            [
              15140
            ]
          ],
          [
            "\u0E0A\u0E48\u0E2D\u0E07\u0E2A\u0E32\u0E23\u0E34\u0E01\u0E32",
            [
              15220
            ]
          ],
          [
            "\u0E14\u0E35\u0E25\u0E31\u0E07",
            [
              15220
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E2A\u0E38\u0E14",
            [
              15140
            ]
          ],
          [
            "\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E19\u0E34\u0E04\u0E21",
            [
              15140
            ]
          ],
          [
            "\u0E21\u0E30\u0E19\u0E32\u0E27\u0E2B\u0E27\u0E32\u0E19",
            [
              15140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              15140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E02\u0E38\u0E19\u0E23\u0E32\u0E21",
            [
              18220
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E25\u0E38\u0E07",
            [
              15140
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E33\u0E2A\u0E19\u0E18\u0E34",
        [
          [
            "\u0E01\u0E38\u0E14\u0E15\u0E32\u0E40\u0E1E\u0E0A\u0E23",
            [
              15190
            ]
          ],
          [
            "\u0E0B\u0E31\u0E1A\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              15190
            ]
          ],
          [
            "\u0E25\u0E33\u0E2A\u0E19\u0E18\u0E34",
            [
              15190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E23\u0E35",
            [
              15190
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E19\u0E49\u0E2D\u0E22",
            [
              15130
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E23\u0E27\u0E01",
            [
              15190
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E23\u0E30\u0E42\u0E1A\u0E2A\u0E16\u0E4C",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E17\u0E48\u0E32\u0E0A\u0E49\u0E32\u0E07",
            [
              15240
            ]
          ],
          [
            "\u0E19\u0E34\u0E22\u0E21\u0E0A\u0E31\u0E22",
            [
              15240
            ]
          ],
          [
            "\u0E21\u0E2B\u0E32\u0E42\u0E1E\u0E18\u0E34",
            [
              15240
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E42\u0E1A\u0E2A\u0E16\u0E4C",
            [
              15240
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E43\u0E2B\u0E0D\u0E48",
            [
              15240
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E21\u0E48\u0E27\u0E07",
        [
          [
            "\u0E0A\u0E2D\u0E19\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              15170
            ]
          ],
          [
            "\u0E0A\u0E2D\u0E19\u0E2A\u0E32\u0E23\u0E40\u0E14\u0E0A",
            [
              15170
            ]
          ],
          [
            "\u0E14\u0E07\u0E14\u0E34\u0E19\u0E41\u0E14\u0E07",
            [
              15170
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E17\u0E2D\u0E07",
            [
              15170
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E42\u0E17\u0E19",
            [
              15170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E21\u0E48\u0E27\u0E07",
            [
              15170
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E25\u0E1E\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E01\u0E01\u0E42\u0E01",
            [
              15e3
            ]
          ],
          [
            "\u0E07\u0E34\u0E49\u0E27\u0E23\u0E32\u0E22",
            [
              15e3
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              15e3
            ]
          ],
          [
            "\u0E15\u0E30\u0E25\u0E38\u0E07",
            [
              15e3
            ]
          ],
          [
            "\u0E16\u0E19\u0E19\u0E43\u0E2B\u0E0D\u0E48",
            [
              15e3
            ]
          ],
          [
            "\u0E17\u0E30\u0E40\u0E25\u0E0A\u0E38\u0E1A\u0E28\u0E23",
            [
              15e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E28\u0E32\u0E25\u0E32",
            [
              15e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2B\u0E34\u0E19",
            [
              15e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E41\u0E04",
            [
              15e3
            ]
          ],
          [
            "\u0E17\u0E49\u0E32\u0E22\u0E15\u0E25\u0E32\u0E14",
            [
              15e3
            ]
          ],
          [
            "\u0E19\u0E34\u0E04\u0E21\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E15\u0E19\u0E40\u0E2D\u0E07",
            [
              15e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E02\u0E31\u0E19\u0E2B\u0E21\u0E32\u0E01",
            [
              15e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E02\u0E48\u0E2D\u0E22",
            [
              15e3
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E15\u0E32\u0E25",
            [
              15e3
            ]
          ],
          [
            "\u0E1E\u0E23\u0E2B\u0E21\u0E21\u0E32\u0E2A\u0E15\u0E23\u0E4C",
            [
              15e3
            ]
          ],
          [
            "\u0E2A\u0E35\u0E48\u0E04\u0E25\u0E2D\u0E07",
            [
              15e3
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E1E\u0E23\u0E30\u0E07\u0E32\u0E21",
            [
              15160
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E2A\u0E32\u0E21\u0E22\u0E2D\u0E14",
            [
              15e3
            ]
          ],
          [
            "\u0E42\u0E01\u0E48\u0E07\u0E18\u0E19\u0E39",
            [
              13240
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E01\u0E30\u0E40\u0E17\u0E35\u0E22\u0E21",
            [
              15160
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E15\u0E39\u0E21",
            [
              15210
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E25\u0E33\u0E1E\u0E32\u0E19",
            [
              15e3
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E15\u0E23\u0E38",
            [
              15e3
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E40\u0E01\u0E49\u0E32\u0E15\u0E49\u0E19",
            [
              15e3
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E04\u0E01\u0E2A\u0E33\u0E42\u0E23\u0E07",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E40\u0E01\u0E15\u0E38",
            [
              15120
            ]
          ],
          [
            "\u0E14\u0E07\u0E21\u0E30\u0E23\u0E38\u0E21",
            [
              15120
            ]
          ],
          [
            "\u0E16\u0E25\u0E38\u0E07\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              15120
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E02\u0E2D\u0E19\u0E02\u0E27\u0E49\u0E32\u0E07",
            [
              15120
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E08\u0E31\u0E48\u0E19",
            [
              15120
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E40\u0E1E\u0E25\u0E34\u0E07",
            [
              15120
            ]
          ],
          [
            "\u0E2A\u0E30\u0E41\u0E01\u0E23\u0E32\u0E1A",
            [
              15120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E02\u0E21",
            [
              15120
            ]
          ],
          [
            "\u0E2B\u0E25\u0E38\u0E21\u0E02\u0E49\u0E32\u0E27",
            [
              15120
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E42\u0E1B\u0E48\u0E07",
            [
              15120
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E41\u0E01\u0E49\u0E27",
            [
              15120
            ]
          ],
          [
            "\u0E40\u0E1E\u0E19\u0E35\u0E22\u0E14",
            [
              15120
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E33\u0E42\u0E23\u0E07",
            [
              15120
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E04\u0E01\u0E40\u0E08\u0E23\u0E34\u0E0D",
        [
          [
            "\u0E22\u0E32\u0E07\u0E23\u0E32\u0E01",
            [
              15250
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E17\u0E2D\u0E07",
            [
              15250
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E21\u0E30\u0E04\u0E48\u0E32",
            [
              15250
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E40\u0E08\u0E23\u0E34\u0E0D",
            [
              15250
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E41\u0E2A\u0E21\u0E2A\u0E32\u0E23",
            [
              15250
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E25\u0E33\u0E1B\u0E32\u0E07",
    [
      [
        "\u0E07\u0E32\u0E27",
        [
          [
            "\u0E19\u0E32\u0E41\u0E01",
            [
              52110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E23\u0E49\u0E2D\u0E07",
            [
              52110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E27\u0E14",
            [
              52110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2D\u0E49\u0E2D\u0E19",
            [
              52110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E2B\u0E07",
            [
              52110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E1B\u0E48\u0E07",
            [
              52110
            ]
          ],
          [
            "\u0E1B\u0E07\u0E40\u0E15\u0E32",
            [
              52110
            ]
          ],
          [
            "\u0E2B\u0E25\u0E27\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              52110
            ]
          ],
          [
            "\u0E2B\u0E25\u0E27\u0E07\u0E43\u0E15\u0E49",
            [
              52110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E15\u0E35\u0E1A",
            [
              52110
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2E\u0E31\u0E49\u0E27",
            [
              52140
            ]
          ],
          [
            "\u0E23\u0E48\u0E2D\u0E07\u0E40\u0E04\u0E32\u0E30",
            [
              52140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E0B\u0E49\u0E32\u0E22",
            [
              52140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E17\u0E23\u0E32\u0E22\u0E04\u0E33",
            [
              52140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E17\u0E2D\u0E07",
            [
              52140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              52140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              52140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E43\u0E15\u0E49",
            [
              52140
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E1A\u0E1B\u0E23\u0E32\u0E1A",
        [
          [
            "\u0E19\u0E32\u0E22\u0E32\u0E07",
            [
              52170
            ]
          ],
          [
            "\u0E2A\u0E1A\u0E1B\u0E23\u0E32\u0E1A",
            [
              52170
            ]
          ],
          [
            "\u0E2A\u0E21\u0E31\u0E22",
            [
              52170
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E01\u0E31\u0E27\u0E30",
            [
              52170
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E49\u0E32\u0E07\u0E09\u0E31\u0E15\u0E23",
        [
          [
            "\u0E1B\u0E07\u0E22\u0E32\u0E07\u0E04\u0E01",
            [
              52190
            ]
          ],
          [
            "\u0E27\u0E2D\u0E41\u0E01\u0E49\u0E27",
            [
              52190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E25\u0E48\u0E21",
            [
              52190
            ]
          ],
          [
            "\u0E2B\u0E49\u0E32\u0E07\u0E09\u0E31\u0E15\u0E23",
            [
              52190
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E22\u0E32\u0E27",
            [
              52190
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E15\u0E32\u0E25",
            [
              52190
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E31\u0E19",
            [
              52190
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E01\u0E32\u0E30\u0E04\u0E32",
        [
          [
            "\u0E17\u0E48\u0E32\u0E1C\u0E32",
            [
              52130
            ]
          ],
          [
            "\u0E19\u0E32\u0E41\u0E01\u0E49\u0E27",
            [
              52130
            ]
          ],
          [
            "\u0E19\u0E32\u0E41\u0E2A\u0E48\u0E07",
            [
              52130
            ]
          ],
          [
            "\u0E25\u0E33\u0E1B\u0E32\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              52130
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E1E\u0E23\u0E49\u0E32\u0E27",
            [
              52130
            ]
          ],
          [
            "\u0E28\u0E32\u0E25\u0E32",
            [
              52130
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E04\u0E32",
            [
              52130
            ]
          ],
          [
            "\u0E43\u0E2B\u0E21\u0E48\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              52130
            ]
          ],
          [
            "\u0E44\u0E2B\u0E25\u0E48\u0E2B\u0E34\u0E19",
            [
              52130
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E16\u0E34\u0E19",
        [
          [
            "\u0E19\u0E32\u0E42\u0E1B\u0E48\u0E07",
            [
              52160
            ]
          ],
          [
            "\u0E25\u0E49\u0E2D\u0E21\u0E41\u0E23\u0E14",
            [
              52160
            ]
          ],
          [
            "\u0E40\u0E16\u0E34\u0E19\u0E1A\u0E38\u0E23\u0E35",
            [
              52160
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E21\u0E2D\u0E01",
            [
              52160
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E16\u0E2D\u0E14",
            [
              52160
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E1B\u0E30",
            [
              52160
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E21\u0E2D\u0E01",
            [
              52160
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E27\u0E30",
            [
              52230
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1B\u0E32\u0E19",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E01\u0E27\u0E4B\u0E32\u0E27",
            [
              52240
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E02\u0E2D",
            [
              52240
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              52240
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1B\u0E32\u0E19",
            [
              52240
            ]
          ],
          [
            "\u0E41\u0E08\u0E49\u0E0B\u0E49\u0E2D\u0E19",
            [
              52240
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E25\u0E33\u0E1B\u0E32\u0E07",
        [
          [
            "\u0E01\u0E25\u0E49\u0E27\u0E22\u0E41\u0E1E\u0E30",
            [
              52e3
            ]
          ],
          [
            "\u0E0A\u0E21\u0E1E\u0E39",
            [
              52100
            ]
          ],
          [
            "\u0E15\u0E49\u0E19\u0E18\u0E07\u0E0A\u0E31\u0E22",
            [
              52e3
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E1D\u0E32\u0E22",
            [
              52e3
            ]
          ],
          [
            "\u0E19\u0E34\u0E04\u0E21\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              52e3
            ]
          ],
          [
            "\u0E1A\u0E38\u0E0D\u0E19\u0E32\u0E04\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              52e3
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E41\u0E2E\u0E49\u0E27",
            [
              52100
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E04\u0E48\u0E32",
            [
              52100
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E1B\u0E49\u0E32",
            [
              52100
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E2A\u0E14\u0E47\u0E08",
            [
              52e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E2D\u0E37\u0E49\u0E2D\u0E21",
            [
              52100
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E25\u0E07",
            [
              52e3
            ]
          ],
          [
            "\u0E1B\u0E07\u0E41\u0E2A\u0E19\u0E17\u0E2D\u0E07",
            [
              52100
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E1A\u0E32\u0E17",
            [
              52e3
            ]
          ],
          [
            "\u0E1E\u0E34\u0E0A\u0E31\u0E22",
            [
              52e3
            ]
          ],
          [
            "\u0E2A\u0E1A\u0E15\u0E38\u0E4B\u0E22",
            [
              52100
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E14\u0E2D\u0E01",
            [
              52100
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              52e3
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              52e3
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E2A\u0E23\u0E34\u0E21\u0E07\u0E32\u0E21",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E07\u0E32\u0E21",
            [
              52210
            ]
          ],
          [
            "\u0E40\u0E2A\u0E23\u0E34\u0E21\u0E01\u0E25\u0E32\u0E07",
            [
              52210
            ]
          ],
          [
            "\u0E40\u0E2A\u0E23\u0E34\u0E21\u0E02\u0E27\u0E32",
            [
              52210
            ]
          ],
          [
            "\u0E40\u0E2A\u0E23\u0E34\u0E21\u0E0B\u0E49\u0E32\u0E22",
            [
              52210
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E08\u0E49\u0E2B\u0E48\u0E21",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E1C\u0E36\u0E49\u0E07",
            [
              52120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2A\u0E32",
            [
              52120
            ]
          ],
          [
            "\u0E1B\u0E07\u0E14\u0E2D\u0E19",
            [
              52120
            ]
          ],
          [
            "\u0E27\u0E34\u0E40\u0E0A\u0E15\u0E19\u0E04\u0E23",
            [
              52120
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E21\u0E32\u0E22",
            [
              52120
            ]
          ],
          [
            "\u0E41\u0E08\u0E49\u0E2B\u0E48\u0E21",
            [
              52120
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E38\u0E01",
            [
              52120
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E17\u0E30",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E44\u0E1F",
            [
              52150
            ]
          ],
          [
            "\u0E19\u0E32\u0E04\u0E23\u0E31\u0E27",
            [
              52150
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E42\u0E08\u0E49",
            [
              52150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E34\u0E48\u0E27",
            [
              52150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1A\u0E2D\u0E21",
            [
              52150
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E15\u0E31\u0E19",
            [
              52150
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E40\u0E07\u0E34\u0E19",
            [
              52150
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E14\u0E2D\u0E19\u0E41\u0E01\u0E49\u0E27",
            [
              52150
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E40\u0E2A\u0E37\u0E2D",
            [
              52150
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E17\u0E30",
            [
              52150
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E1E\u0E23\u0E34\u0E01",
        [
          [
            "\u0E1C\u0E32\u0E1B\u0E31\u0E07",
            [
              52180
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E1A\u0E32\u0E17\u0E27\u0E31\u0E07\u0E15\u0E27\u0E07",
            [
              52230
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E1B\u0E38",
            [
              52180
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E1E\u0E23\u0E34\u0E01",
            [
              52180
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E40\u0E21\u0E32\u0E30",
        [
          [
            "\u0E08\u0E32\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              52220
            ]
          ],
          [
            "\u0E19\u0E32\u0E2A\u0E31\u0E01",
            [
              52220
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E14\u0E07",
            [
              52220
            ]
          ],
          [
            "\u0E2A\u0E1A\u0E1B\u0E49\u0E32\u0E14",
            [
              52220
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E40\u0E21\u0E32\u0E30",
            [
              52220
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E25\u0E33\u0E1E\u0E39\u0E19",
    [
      [
        "\u0E17\u0E38\u0E48\u0E07\u0E2B\u0E31\u0E27\u0E0A\u0E49\u0E32\u0E07",
        [
          [
            "\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19\u0E1B\u0E21",
            [
              51160
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2B\u0E31\u0E27\u0E0A\u0E49\u0E32\u0E07",
            [
              51160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1B\u0E27\u0E07",
            [
              51160
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E18\u0E34",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E18\u0E34",
            [
              51180
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E22\u0E32\u0E1A",
            [
              51180
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E2E\u0E48\u0E07",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E2E\u0E48\u0E07",
            [
              51130
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E1E\u0E25\u0E39",
            [
              51130
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E40\u0E15\u0E35\u0E49\u0E22",
            [
              51130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E25\u0E32\u0E2A\u0E30\u0E27\u0E32\u0E22",
            [
              51130
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E22\u0E32\u0E27",
            [
              51130
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E48\u0E32\u0E0B\u0E32\u0E07",
        [
          [
            "\u0E17\u0E48\u0E32\u0E15\u0E38\u0E49\u0E21",
            [
              51120
            ]
          ],
          [
            "\u0E19\u0E04\u0E23\u0E40\u0E08\u0E14\u0E35\u0E22\u0E4C",
            [
              51120
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E14\u0E34\u0E1A",
            [
              51120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E23\u0E37\u0E2D\u0E19",
            [
              51120
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E1A\u0E48\u0E2D\u0E07",
            [
              51120
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E0B\u0E32\u0E07",
            [
              51120
            ]
          ],
          [
            "\u0E21\u0E30\u0E01\u0E2D\u0E01",
            [
              51120
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E19\u0E49\u0E2D\u0E22",
            [
              51120
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E41\u0E23\u0E07",
            [
              51120
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E35\u0E49",
        [
          [
            "\u0E01\u0E49\u0E2D",
            [
              51110
            ]
          ],
          [
            "\u0E14\u0E07\u0E14\u0E33",
            [
              51110
            ]
          ],
          [
            "\u0E19\u0E32\u0E17\u0E23\u0E32\u0E22",
            [
              51110
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E44\u0E1C\u0E48",
            [
              51110
            ]
          ],
          [
            "\u0E25\u0E35\u0E49",
            [
              51110
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E27\u0E34\u0E0A\u0E31\u0E22",
            [
              51110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E15\u0E37\u0E19",
            [
              51110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E25\u0E32\u0E19",
            [
              51110
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E25\u0E33\u0E1E\u0E39\u0E19",
        [
          [
            "\u0E15\u0E49\u0E19\u0E18\u0E07",
            [
              51e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E25\u0E32\u0E07",
            [
              51e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E1B\u0E49\u0E19",
            [
              51e3
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E15\u0E39\u0E1B\u0E48\u0E32",
            [
              51e3
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E2A\u0E31\u0E01",
            [
              51e3
            ]
          ],
          [
            "\u0E21\u0E30\u0E40\u0E02\u0E37\u0E2D\u0E41\u0E08\u0E49",
            [
              51e3
            ]
          ],
          [
            "\u0E23\u0E34\u0E21\u0E1B\u0E34\u0E07",
            [
              51e3
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E1A\u0E31\u0E27\u0E1A\u0E32\u0E19",
            [
              51e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E0A\u0E49\u0E32\u0E07\u0E04\u0E37\u0E19",
            [
              51150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E19\u0E32\u0E21",
            [
              51e3
            ]
          ],
          [
            "\u0E2D\u0E38\u0E42\u0E21\u0E07\u0E04\u0E4C",
            [
              51150
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E22\u0E2D\u0E07",
            [
              51e3
            ]
          ],
          [
            "\u0E40\u0E2B\u0E21\u0E37\u0E2D\u0E07\u0E07\u0E48\u0E32",
            [
              51e3
            ]
          ],
          [
            "\u0E40\u0E2B\u0E21\u0E37\u0E2D\u0E07\u0E08\u0E35\u0E49",
            [
              51e3
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              51e3
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E2B\u0E19\u0E2D\u0E07\u0E25\u0E48\u0E2D\u0E07",
        [
          [
            "\u0E27\u0E31\u0E07\u0E1C\u0E32\u0E07",
            [
              51120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E22\u0E27\u0E07",
            [
              51120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E25\u0E48\u0E2D\u0E07",
            [
              51120
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E17\u0E32",
        [
          [
            "\u0E17\u0E32\u0E01\u0E32\u0E28",
            [
              51170
            ]
          ],
          [
            "\u0E17\u0E32\u0E02\u0E38\u0E21\u0E40\u0E07\u0E34\u0E19",
            [
              51170
            ]
          ],
          [
            "\u0E17\u0E32\u0E17\u0E38\u0E48\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              51170
            ]
          ],
          [
            "\u0E17\u0E32\u0E1B\u0E25\u0E32\u0E14\u0E38\u0E01",
            [
              51140
            ]
          ],
          [
            "\u0E17\u0E32\u0E2A\u0E1A\u0E40\u0E2A\u0E49\u0E32",
            [
              51140
            ]
          ],
          [
            "\u0E17\u0E32\u0E41\u0E21\u0E48\u0E25\u0E2D\u0E1A",
            [
              51170
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E28\u0E23\u0E35\u0E2A\u0E30\u0E40\u0E01\u0E29",
    [
      [
        "\u0E01\u0E31\u0E19\u0E17\u0E23\u0E25\u0E31\u0E01\u0E29\u0E4C",
        [
          [
            "\u0E01\u0E23\u0E30\u0E41\u0E0A\u0E07",
            [
              33110
            ]
          ],
          [
            "\u0E01\u0E38\u0E14\u0E40\u0E2A\u0E25\u0E32",
            [
              33110
            ]
          ],
          [
            "\u0E02\u0E19\u0E38\u0E19",
            [
              33110
            ]
          ],
          [
            "\u0E08\u0E32\u0E19\u0E43\u0E2B\u0E0D\u0E48",
            [
              33110
            ]
          ],
          [
            "\u0E0A\u0E33",
            [
              33110
            ]
          ],
          [
            "\u0E15\u0E23\u0E30\u0E01\u0E32\u0E08",
            [
              33110
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              33110
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E2D\u0E49\u0E2D\u0E21",
            [
              33110
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E21\u0E30\u0E25\u0E39",
            [
              33110
            ]
          ],
          [
            "\u0E20\u0E39\u0E1C\u0E32\u0E2B\u0E21\u0E2D\u0E01",
            [
              33110
            ]
          ],
          [
            "\u0E20\u0E39\u0E40\u0E07\u0E34\u0E19",
            [
              33110
            ]
          ],
          [
            "\u0E23\u0E38\u0E07",
            [
              33110
            ]
          ],
          [
            "\u0E25\u0E30\u0E25\u0E32\u0E22",
            [
              33110
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E01\u0E25\u0E49\u0E27\u0E22",
            [
              33110
            ]
          ],
          [
            "\u0E2A\u0E31\u0E07\u0E40\u0E21\u0E47\u0E01",
            [
              33110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E0D\u0E49\u0E32\u0E25\u0E32\u0E14",
            [
              33110
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              33110
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              33110
            ]
          ],
          [
            "\u0E40\u0E2A\u0E32\u0E18\u0E07\u0E0A\u0E31\u0E22",
            [
              33110
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              33110
            ]
          ]
        ]
      ],
      [
        "\u0E01\u0E31\u0E19\u0E17\u0E23\u0E32\u0E23\u0E21\u0E22\u0E4C",
        [
          [
            "\u0E04\u0E33\u0E40\u0E19\u0E35\u0E22\u0E21",
            [
              33130
            ]
          ],
          [
            "\u0E08\u0E32\u0E19",
            [
              33130
            ]
          ],
          [
            "\u0E14\u0E39\u0E19",
            [
              33130
            ]
          ],
          [
            "\u0E14\u0E39\u0E48",
            [
              33130
            ]
          ],
          [
            "\u0E17\u0E32\u0E21",
            [
              33130
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E19\u0E49\u0E2D\u0E22",
            [
              33130
            ]
          ],
          [
            "\u0E1C\u0E31\u0E01\u0E41\u0E1E\u0E27",
            [
              33130
            ]
          ],
          [
            "\u0E22\u0E32\u0E07",
            [
              33130
            ]
          ],
          [
            "\u0E25\u0E30\u0E17\u0E32\u0E22",
            [
              33130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              33130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E31\u0E27\u0E0A\u0E49\u0E32\u0E07",
            [
              33130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              33130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07",
            [
              33130
            ]
          ],
          [
            "\u0E2D\u0E35\u0E1B\u0E32\u0E14",
            [
              33130
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E19\u0E49\u0E2D\u0E22",
            [
              33130
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E31\u0E07",
            [
              33130
            ]
          ]
        ]
      ],
      [
        "\u0E02\u0E38\u0E02\u0E31\u0E19\u0E18\u0E4C",
        [
          [
            "\u0E01\u0E24\u0E29\u0E13\u0E32",
            [
              33140
            ]
          ],
          [
            "\u0E01\u0E31\u0E19\u0E17\u0E23\u0E32\u0E23\u0E21\u0E22\u0E4C",
            [
              33140
            ]
          ],
          [
            "\u0E08\u0E30\u0E01\u0E07",
            [
              33140
            ]
          ],
          [
            "\u0E14\u0E2D\u0E07\u0E01\u0E33\u0E40\u0E21\u0E47\u0E14",
            [
              33140
            ]
          ],
          [
            "\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              33140
            ]
          ],
          [
            "\u0E15\u0E32\u0E2D\u0E38\u0E14",
            [
              33140
            ]
          ],
          [
            "\u0E19\u0E34\u0E04\u0E21\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              33140
            ]
          ],
          [
            "\u0E1B\u0E23\u0E32\u0E2A\u0E32\u0E17",
            [
              33140
            ]
          ],
          [
            "\u0E1B\u0E23\u0E37\u0E2D\u0E43\u0E2B\u0E0D\u0E48",
            [
              33140
            ]
          ],
          [
            "\u0E25\u0E21\u0E28\u0E31\u0E01\u0E14\u0E34\u0E4C",
            [
              33140
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E15\u0E23\u0E30\u0E01\u0E39\u0E25",
            [
              33140
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              33140
            ]
          ],
          [
            "\u0E2A\u0E30\u0E40\u0E14\u0E32\u0E43\u0E2B\u0E0D\u0E48",
            [
              33140
            ]
          ],
          [
            "\u0E2A\u0E33\u0E42\u0E23\u0E07\u0E15\u0E32\u0E40\u0E08\u0E47\u0E19",
            [
              33140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E09\u0E25\u0E2D\u0E07",
            [
              33140
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E40\u0E2A\u0E37\u0E2D",
            [
              33140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              33140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              33140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E43\u0E15\u0E49",
            [
              33140
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E40\u0E1E\u0E0A\u0E23",
            [
              33140
            ]
          ],
          [
            "\u0E42\u0E2A\u0E19",
            [
              33140
            ]
          ],
          [
            "\u0E43\u0E08\u0E14\u0E35",
            [
              33140
            ]
          ]
        ]
      ],
      [
        "\u0E02\u0E38\u0E19\u0E2B\u0E32\u0E0D",
        [
          [
            "\u0E01\u0E23\u0E30\u0E2B\u0E27\u0E31\u0E19",
            [
              33150
            ]
          ],
          [
            "\u0E01\u0E31\u0E19\u0E17\u0E23\u0E2D\u0E21",
            [
              33150
            ]
          ],
          [
            "\u0E02\u0E38\u0E19\u0E2B\u0E32\u0E0D",
            [
              33150
            ]
          ],
          [
            "\u0E1A\u0E31\u0E01\u0E14\u0E2D\u0E07",
            [
              33150
            ]
          ],
          [
            "\u0E1E\u0E23\u0E32\u0E19",
            [
              33150
            ]
          ],
          [
            "\u0E20\u0E39\u0E1D\u0E49\u0E32\u0E22",
            [
              33150
            ]
          ],
          [
            "\u0E2A\u0E34",
            [
              33150
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
            [
              33150
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E39\u0E07",
            [
              33150
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E01\u0E23\u0E30\u0E2A\u0E31\u0E07\u0E02\u0E4C",
            [
              33150
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E27\u0E07\u0E28\u0E4C",
            [
              33150
            ]
          ],
          [
            "\u0E44\u0E1E\u0E23",
            [
              33150
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E49\u0E33\u0E40\u0E01\u0E25\u0E35\u0E49\u0E22\u0E07",
        [
          [
            "\u0E04\u0E39\u0E1A",
            [
              33130
            ]
          ],
          [
            "\u0E15\u0E2D\u0E07\u0E1B\u0E34\u0E14",
            [
              33130
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E40\u0E01\u0E25\u0E35\u0E49\u0E22\u0E07",
            [
              33130
            ]
          ],
          [
            "\u0E23\u0E38\u0E48\u0E07\u0E23\u0E30\u0E27\u0E35",
            [
              33130
            ]
          ],
          [
            "\u0E25\u0E30\u0E40\u0E2D\u0E32\u0E30",
            [
              33130
            ]
          ],
          [
            "\u0E40\u0E02\u0E34\u0E19",
            [
              33130
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E36\u0E07\u0E1A\u0E39\u0E23\u0E1E\u0E4C",
        [
          [
            "\u0E1A\u0E36\u0E07\u0E1A\u0E39\u0E23\u0E1E\u0E4C",
            [
              33220
            ]
          ],
          [
            "\u0E40\u0E1B\u0E4A\u0E32\u0E30",
            [
              33220
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E23\u0E32\u0E07\u0E04\u0E4C\u0E01\u0E39\u0E48",
        [
          [
            "\u0E01\u0E39\u0E48",
            [
              33170
            ]
          ],
          [
            "\u0E14\u0E39\u0E48",
            [
              33170
            ]
          ],
          [
            "\u0E15\u0E39\u0E21",
            [
              33170
            ]
          ],
          [
            "\u0E1E\u0E34\u0E21\u0E32\u0E22",
            [
              33170
            ]
          ],
          [
            "\u0E1E\u0E34\u0E21\u0E32\u0E22\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              33170
            ]
          ],
          [
            "\u0E2A\u0E21\u0E2D",
            [
              33170
            ]
          ],
          [
            "\u0E2A\u0E27\u0E32\u0E22",
            [
              33170
            ]
          ],
          [
            "\u0E2A\u0E33\u0E42\u0E23\u0E07\u0E1B\u0E23\u0E32\u0E2A\u0E32\u0E17",
            [
              33170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E17\u0E39\u0E19",
            [
              33170
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E28\u0E23\u0E35",
            [
              33170
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E22\u0E38\u0E2B\u0E4C",
        [
          [
            "\u0E15\u0E33\u0E41\u0E22",
            [
              33230
            ]
          ],
          [
            "\u0E1E\u0E22\u0E38\u0E2B\u0E4C",
            [
              33230
            ]
          ],
          [
            "\u0E1E\u0E23\u0E2B\u0E21\u0E2A\u0E27\u0E31\u0E2A\u0E14\u0E34\u0E4C",
            [
              33230
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E04\u0E49\u0E32",
            [
              33230
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E40\u0E1E\u0E47\u0E01",
            [
              33230
            ]
          ]
        ]
      ],
      [
        "\u0E20\u0E39\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
        [
          [
            "\u0E14\u0E07\u0E23\u0E31\u0E01",
            [
              33140
            ]
          ],
          [
            "\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19\u0E23\u0E32\u0E21",
            [
              33140
            ]
          ],
          [
            "\u0E25\u0E30\u0E25\u0E21",
            [
              33140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E15\u0E32\u0E21\u0E2D\u0E0D",
            [
              33140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E15\u0E36\u0E4A\u0E01\u0E0A\u0E39",
            [
              33140
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E15\u0E32\u0E25",
            [
              33140
            ]
          ],
          [
            "\u0E44\u0E1E\u0E23\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              33140
            ]
          ]
        ]
      ],
      [
        "\u0E22\u0E32\u0E07\u0E0A\u0E38\u0E21\u0E19\u0E49\u0E2D\u0E22",
        [
          [
            "\u0E01\u0E38\u0E14\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2E\u0E32\u0E21",
            [
              33190
            ]
          ],
          [
            "\u0E04\u0E2D\u0E19\u0E01\u0E32\u0E21",
            [
              33190
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E1A\u0E2D\u0E19",
            [
              33190
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E0A\u0E38\u0E21\u0E19\u0E49\u0E2D\u0E22",
            [
              33190
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E0A\u0E38\u0E21\u0E43\u0E2B\u0E0D\u0E48",
            [
              33190
            ]
          ],
          [
            "\u0E25\u0E34\u0E49\u0E19\u0E1F\u0E49\u0E32",
            [
              33190
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E04\u0E39\u0E13",
            [
              33190
            ]
          ]
        ]
      ],
      [
        "\u0E23\u0E32\u0E29\u0E35\u0E44\u0E28\u0E25",
        [
          [
            "\u0E08\u0E34\u0E01\u0E2A\u0E31\u0E07\u0E02\u0E4C\u0E17\u0E2D\u0E07",
            [
              33160
            ]
          ],
          [
            "\u0E14\u0E39\u0E48",
            [
              33160
            ]
          ],
          [
            "\u0E14\u0E48\u0E32\u0E19",
            [
              33160
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E2B\u0E38\u0E48\u0E07",
            [
              33160
            ]
          ],
          [
            "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1B\u0E35\u0E48",
            [
              33160
            ]
          ],
          [
            "\u0E2A\u0E49\u0E21\u0E1B\u0E48\u0E2D\u0E22",
            [
              33160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E21\u0E35",
            [
              33160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2D\u0E36\u0E48\u0E07",
            [
              33160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E04",
            [
              33160
            ]
          ],
          [
            "\u0E2B\u0E27\u0E49\u0E32\u0E19\u0E04\u0E33",
            [
              33160
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E04\u0E07",
            [
              33160
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E41\u0E04\u0E19",
            [
              33160
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48",
            [
              33160
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E07\u0E2B\u0E34\u0E19",
        [
          [
            "\u0E14\u0E27\u0E19\u0E43\u0E2B\u0E0D\u0E48",
            [
              33270
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              33270
            ]
          ],
          [
            "\u0E18\u0E32\u0E15\u0E38",
            [
              33270
            ]
          ],
          [
            "\u0E1A\u0E38\u0E2A\u0E39\u0E07",
            [
              33270
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E41\u0E01\u0E49\u0E27",
            [
              33270
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2B\u0E34\u0E19",
            [
              33270
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              33270
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E22\u0E32\u0E07",
            [
              33270
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E23\u0E31\u0E15\u0E19\u0E30",
        [
          [
            "\u0E15\u0E39\u0E21",
            [
              33240
            ]
          ],
          [
            "\u0E1E\u0E34\u0E07\u0E1E\u0E27\u0E22",
            [
              33240
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E41\u0E01\u0E49\u0E27",
            [
              33240
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E42\u0E19\u0E19\u0E07\u0E32\u0E21",
            [
              33240
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E40\u0E22\u0E32\u0E27\u0E4C",
            [
              33240
            ]
          ],
          [
            "\u0E2A\u0E30\u0E1E\u0E38\u0E07",
            [
              33240
            ]
          ],
          [
            "\u0E40\u0E2A\u0E37\u0E48\u0E2D\u0E07\u0E02\u0E49\u0E32\u0E27",
            [
              33240
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E34\u0E25\u0E32\u0E25\u0E32\u0E14",
        [
          [
            "\u0E01\u0E38\u0E07",
            [
              33160
            ]
          ],
          [
            "\u0E04\u0E25\u0E35\u0E01\u0E25\u0E34\u0E49\u0E07",
            [
              33160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E14\u0E07",
            [
              33160
            ]
          ],
          [
            "\u0E42\u0E08\u0E14\u0E21\u0E48\u0E27\u0E07",
            [
              33160
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E49\u0E27\u0E22\u0E17\u0E31\u0E1A\u0E17\u0E31\u0E19",
        [
          [
            "\u0E01\u0E25\u0E49\u0E27\u0E22\u0E01\u0E27\u0E49\u0E32\u0E07",
            [
              33210
            ]
          ],
          [
            "\u0E08\u0E32\u0E19\u0E41\u0E2A\u0E19\u0E44\u0E0A\u0E22",
            [
              33210
            ]
          ],
          [
            "\u0E1B\u0E23\u0E32\u0E2A\u0E32\u0E17",
            [
              33210
            ]
          ],
          [
            "\u0E1C\u0E31\u0E01\u0E44\u0E2B\u0E21",
            [
              33210
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E17\u0E31\u0E1A\u0E17\u0E31\u0E19",
            [
              33210
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              33210
            ]
          ]
        ]
      ],
      [
        "\u0E2D\u0E38\u0E17\u0E38\u0E21\u0E1E\u0E23\u0E1E\u0E34\u0E2A\u0E31\u0E22",
        [
          [
            "\u0E01\u0E33\u0E41\u0E1E\u0E07",
            [
              33120
            ]
          ],
          [
            "\u0E01\u0E49\u0E32\u0E19\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E07",
            [
              33120
            ]
          ],
          [
            "\u0E02\u0E30\u0E22\u0E39\u0E07",
            [
              33120
            ]
          ],
          [
            "\u0E15\u0E32\u0E40\u0E01\u0E29",
            [
              33120
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E44\u0E0A\u0E22",
            [
              33120
            ]
          ],
          [
            "\u0E1B\u0E30\u0E2D\u0E32\u0E27",
            [
              33120
            ]
          ],
          [
            "\u0E23\u0E31\u0E07\u0E41\u0E23\u0E49\u0E07",
            [
              33120
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E01\u0E33\u0E41\u0E1E\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              33120
            ]
          ],
          [
            "\u0E2A\u0E33\u0E42\u0E23\u0E07",
            [
              33120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E49\u0E32\u0E07",
            [
              33120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E2E",
            [
              33120
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E0A\u0E49\u0E32\u0E07",
            [
              33120
            ]
          ],
          [
            "\u0E2D\u0E35\u0E48\u0E2B\u0E25\u0E48\u0E33",
            [
              33120
            ]
          ],
          [
            "\u0E41\u0E02\u0E21",
            [
              33120
            ]
          ],
          [
            "\u0E41\u0E02\u0E49",
            [
              33120
            ]
          ],
          [
            "\u0E41\u0E15\u0E49",
            [
              33120
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E08\u0E32\u0E19",
            [
              33120
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2B\u0E25\u0E48\u0E32\u0E21",
            [
              33120
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E0A\u0E31\u0E22",
            [
              33120
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E1A\u0E0D\u0E08\u0E25\u0E31\u0E01\u0E29\u0E4C",
        [
          [
            "\u0E17\u0E48\u0E32\u0E04\u0E25\u0E49\u0E2D",
            [
              33110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E07\u0E39\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E21",
            [
              33110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E27\u0E49\u0E32",
            [
              33110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2E\u0E32\u0E07",
            [
              33110
            ]
          ],
          [
            "\u0E40\u0E2A\u0E35\u0E22\u0E27",
            [
              33110
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
        [
          [
            "\u0E15\u0E32\u0E42\u0E01\u0E19",
            [
              33120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              33120
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
            [
              33120
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E28\u0E23\u0E35\u0E2A\u0E30\u0E40\u0E01\u0E29",
        [
          [
            "\u0E04\u0E39\u0E0B\u0E2D\u0E14",
            [
              33e3
            ]
          ],
          [
            "\u0E08\u0E32\u0E19",
            [
              33e3
            ]
          ],
          [
            "\u0E0B\u0E33",
            [
              33e3
            ]
          ],
          [
            "\u0E15\u0E30\u0E14\u0E2D\u0E1A",
            [
              33e3
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E21",
            [
              33e3
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E04\u0E33",
            [
              33e3
            ]
          ],
          [
            "\u0E2B\u0E0D\u0E49\u0E32\u0E1B\u0E25\u0E49\u0E2D\u0E07",
            [
              33e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E04\u0E23\u0E01",
            [
              33e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              33e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E1C\u0E48",
            [
              33e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E2E",
            [
              33e3
            ]
          ],
          [
            "\u0E2B\u0E21\u0E32\u0E01\u0E40\u0E02\u0E35\u0E22\u0E1A",
            [
              33e3
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              33e3
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E43\u0E15\u0E49",
            [
              33e3
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              33e3
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E02\u0E48\u0E32",
            [
              33e3
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E04\u0E49\u0E2D",
            [
              33e3
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E40\u0E02\u0E27\u0E32",
            [
              33e3
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E19\u0E19\u0E04\u0E39\u0E13",
        [
          [
            "\u0E1A\u0E01",
            [
              33250
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E38\u0E07",
            [
              33250
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E01\u0E27\u0E32\u0E07",
            [
              33250
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E04\u0E49\u0E2D",
            [
              33250
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              33250
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E28\u0E23\u0E35\u0E2A\u0E38\u0E27\u0E23\u0E23\u0E13",
        [
          [
            "\u0E1C\u0E37\u0E2D\u0E43\u0E2B\u0E0D\u0E48",
            [
              33120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E21\u0E49\u0E32",
            [
              33120
            ]
          ],
          [
            "\u0E2D\u0E35\u0E40\u0E0B",
            [
              33120
            ]
          ],
          [
            "\u0E40\u0E2A\u0E35\u0E22\u0E27",
            [
              33120
            ]
          ],
          [
            "\u0E42\u0E14\u0E14",
            [
              33120
            ]
          ]
        ]
      ],
      [
        "\u0E44\u0E1E\u0E23\u0E1A\u0E36\u0E07",
        [
          [
            "\u0E14\u0E34\u0E19\u0E41\u0E14\u0E07",
            [
              33180
            ]
          ],
          [
            "\u0E1B\u0E23\u0E32\u0E2A\u0E32\u0E17\u0E40\u0E22\u0E2D",
            [
              33180
            ]
          ],
          [
            "\u0E2A\u0E33\u0E42\u0E23\u0E07\u0E1E\u0E25\u0E31\u0E19",
            [
              33180
            ]
          ],
          [
            "\u0E2A\u0E38\u0E02\u0E2A\u0E27\u0E31\u0E2A\u0E14\u0E34\u0E4C",
            [
              33180
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E1B\u0E39\u0E19",
            [
              33180
            ]
          ],
          [
            "\u0E44\u0E1E\u0E23\u0E1A\u0E36\u0E07",
            [
              33180
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2A\u0E01\u0E25\u0E19\u0E04\u0E23",
    [
      [
        "\u0E01\u0E38\u0E14\u0E1A\u0E32\u0E01",
        [
          [
            "\u0E01\u0E38\u0E14\u0E1A\u0E32\u0E01",
            [
              47180
            ]
          ],
          [
            "\u0E01\u0E38\u0E14\u0E44\u0E2B",
            [
              47180
            ]
          ],
          [
            "\u0E19\u0E32\u0E21\u0E48\u0E2D\u0E07",
            [
              47180
            ]
          ]
        ]
      ],
      [
        "\u0E01\u0E38\u0E2A\u0E38\u0E21\u0E32\u0E25\u0E22\u0E4C",
        [
          [
            "\u0E01\u0E38\u0E2A\u0E38\u0E21\u0E32\u0E25\u0E22\u0E4C",
            [
              47210
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E1E\u0E35\u0E22\u0E07",
            [
              47230
            ]
          ],
          [
            "\u0E19\u0E32\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              47210
            ]
          ],
          [
            "\u0E2D\u0E38\u0E48\u0E21\u0E08\u0E32\u0E19",
            [
              47230
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E44\u0E1E\u0E28\u0E32\u0E25",
            [
              47210
            ]
          ]
        ]
      ],
      [
        "\u0E04\u0E33\u0E15\u0E32\u0E01\u0E25\u0E49\u0E32",
        [
          [
            "\u0E04\u0E33\u0E15\u0E32\u0E01\u0E25\u0E49\u0E32",
            [
              47250
            ]
          ],
          [
            "\u0E19\u0E32\u0E41\u0E15\u0E49",
            [
              47250
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E2A\u0E34\u0E21",
            [
              47250
            ]
          ],
          [
            "\u0E41\u0E1E\u0E14",
            [
              47250
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E34\u0E04\u0E21\u0E19\u0E49\u0E33\u0E2D\u0E39\u0E19",
        [
          [
            "\u0E19\u0E34\u0E04\u0E21\u0E19\u0E49\u0E33\u0E2D\u0E39\u0E19",
            [
              47270
            ]
          ],
          [
            "\u0E2A\u0E38\u0E27\u0E23\u0E23\u0E13\u0E04\u0E32\u0E21",
            [
              47270
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              47270
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E25\u0E34\u0E07",
            [
              47270
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E21\u0E48\u0E27\u0E07",
        [
          [
            "\u0E14\u0E07\u0E2B\u0E21\u0E49\u0E2D\u0E17\u0E2D\u0E07",
            [
              47140
            ]
          ],
          [
            "\u0E14\u0E07\u0E2B\u0E21\u0E49\u0E2D\u0E17\u0E2D\u0E07\u0E43\u0E15\u0E49",
            [
              47140
            ]
          ],
          [
            "\u0E14\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              47140
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E41\u0E01\u0E49\u0E27",
            [
              47140
            ]
          ],
          [
            "\u0E21\u0E32\u0E22",
            [
              47140
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07",
            [
              47140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E27\u0E31\u0E48\u0E07",
            [
              47140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E2B\u0E25\u0E31\u0E27",
            [
              47140
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              47140
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E23\u0E23\u0E13\u0E32\u0E19\u0E34\u0E04\u0E21",
        [
          [
            "\u0E0A\u0E49\u0E32\u0E07\u0E21\u0E34\u0E48\u0E07",
            [
              47130
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E31\u0E27\u0E1A\u0E48\u0E2D",
            [
              47220
            ]
          ],
          [
            "\u0E19\u0E32\u0E43\u0E19",
            [
              47130
            ]
          ],
          [
            "\u0E1A\u0E30\u0E2E\u0E35",
            [
              47130
            ]
          ],
          [
            "\u0E1E\u0E23\u0E23\u0E13\u0E32",
            [
              47130
            ]
          ],
          [
            "\u0E1E\u0E2D\u0E01\u0E19\u0E49\u0E2D\u0E22",
            [
              47220
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E22\u0E32\u0E07",
            [
              47130
            ]
          ],
          [
            "\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              47130
            ]
          ],
          [
            "\u0E40\u0E0A\u0E34\u0E07\u0E0A\u0E38\u0E21",
            [
              47130
            ]
          ],
          [
            "\u0E44\u0E23\u0E48",
            [
              47130
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E31\u0E07\u0E42\u0E04\u0E19",
        [
          [
            "\u0E15\u0E49\u0E19\u0E1C\u0E36\u0E49\u0E07",
            [
              47160
            ]
          ],
          [
            "\u0E1E\u0E31\u0E07\u0E42\u0E04\u0E19",
            [
              47160
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E44\u0E02\u0E48",
            [
              47160
            ]
          ],
          [
            "\u0E41\u0E23\u0E48",
            [
              47160
            ]
          ],
          [
            "\u0E44\u0E2E\u0E2B\u0E22\u0E48\u0E2D\u0E07",
            [
              47160
            ]
          ]
        ]
      ],
      [
        "\u0E20\u0E39\u0E1E\u0E32\u0E19",
        [
          [
            "\u0E01\u0E01\u0E1B\u0E25\u0E32\u0E0B\u0E34\u0E27",
            [
              47180
            ]
          ],
          [
            "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E04\u0E49\u0E2D",
            [
              47180
            ]
          ],
          [
            "\u0E2B\u0E25\u0E38\u0E1A\u0E40\u0E25\u0E32",
            [
              47180
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E20\u0E39",
            [
              47180
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E32\u0E19\u0E23\u0E19\u0E34\u0E27\u0E32\u0E2A",
        [
          [
            "\u0E01\u0E38\u0E14\u0E40\u0E23\u0E37\u0E2D\u0E04\u0E33",
            [
              47120
            ]
          ],
          [
            "\u0E02\u0E31\u0E27\u0E01\u0E48\u0E32\u0E22",
            [
              47120
            ]
          ],
          [
            "\u0E04\u0E2D\u0E19\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
            [
              47120
            ]
          ],
          [
            "\u0E04\u0E39\u0E2A\u0E30\u0E04\u0E32\u0E21",
            [
              47120
            ]
          ],
          [
            "\u0E18\u0E32\u0E15\u0E38",
            [
              47120
            ]
          ],
          [
            "\u0E19\u0E32\u0E04\u0E33",
            [
              47120
            ]
          ],
          [
            "\u0E19\u0E32\u0E0B\u0E2D",
            [
              47120
            ]
          ],
          [
            "\u0E27\u0E32\u0E19\u0E23\u0E19\u0E34\u0E27\u0E32\u0E2A",
            [
              47120
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E27\u0E34\u0E0A\u0E31\u0E22",
            [
              47120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E19\u0E21",
            [
              47120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07",
            [
              47120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07\u0E43\u0E15\u0E49",
            [
              47120
            ]
          ],
          [
            "\u0E2D\u0E34\u0E19\u0E17\u0E23\u0E4C\u0E41\u0E1B\u0E25\u0E07",
            [
              47120
            ]
          ],
          [
            "\u0E40\u0E14\u0E37\u0E48\u0E2D\u0E28\u0E23\u0E35\u0E04\u0E31\u0E19\u0E44\u0E0A\u0E22",
            [
              47120
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E32\u0E23\u0E34\u0E0A\u0E20\u0E39\u0E21\u0E34",
        [
          [
            "\u0E04\u0E33\u0E1A\u0E48\u0E2D",
            [
              47150
            ]
          ],
          [
            "\u0E04\u0E49\u0E2D\u0E40\u0E02\u0E35\u0E22\u0E27",
            [
              47150
            ]
          ],
          [
            "\u0E1B\u0E25\u0E32\u0E42\u0E2B\u0E25",
            [
              47150
            ]
          ],
          [
            "\u0E27\u0E32\u0E23\u0E34\u0E0A\u0E20\u0E39\u0E21\u0E34",
            [
              47150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E25\u0E32\u0E14",
            [
              47150
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E27\u0E48\u0E32\u0E07\u0E41\u0E14\u0E19\u0E14\u0E34\u0E19",
        [
          [
            "\u0E04\u0E33\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              47110
            ]
          ],
          [
            "\u0E04\u0E49\u0E2D\u0E43\u0E15\u0E49",
            [
              47110
            ]
          ],
          [
            "\u0E15\u0E32\u0E25\u0E40\u0E19\u0E34\u0E49\u0E07",
            [
              47240
            ]
          ],
          [
            "\u0E15\u0E32\u0E25\u0E42\u0E01\u0E19",
            [
              47240
            ]
          ],
          [
            "\u0E17\u0E23\u0E32\u0E22\u0E21\u0E39\u0E25",
            [
              47110
            ]
          ],
          [
            "\u0E18\u0E32\u0E15\u0E38\u0E17\u0E2D\u0E07",
            [
              47240
            ]
          ],
          [
            "\u0E1A\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              47110
            ]
          ],
          [
            "\u0E1A\u0E07\u0E43\u0E15\u0E49",
            [
              47110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E15\u0E49\u0E32\u0E22",
            [
              47110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E16\u0E48\u0E2D\u0E19",
            [
              47110
            ]
          ],
          [
            "\u0E1E\u0E31\u0E19\u0E19\u0E32",
            [
              47240
            ]
          ],
          [
            "\u0E2A\u0E27\u0E48\u0E32\u0E07\u0E41\u0E14\u0E19\u0E14\u0E34\u0E19",
            [
              47110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              47110
            ]
          ],
          [
            "\u0E41\u0E27\u0E07",
            [
              47240
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E35",
            [
              47110
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E2A\u0E39\u0E07",
            [
              47110
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E48\u0E2D\u0E07\u0E14\u0E32\u0E27",
        [
          [
            "\u0E17\u0E48\u0E32\u0E28\u0E34\u0E25\u0E32",
            [
              47190
            ]
          ],
          [
            "\u0E1B\u0E17\u0E38\u0E21\u0E27\u0E32\u0E1B\u0E35",
            [
              47190
            ]
          ],
          [
            "\u0E27\u0E31\u0E12\u0E19\u0E32",
            [
              47190
            ]
          ],
          [
            "\u0E2A\u0E48\u0E2D\u0E07\u0E14\u0E32\u0E27",
            [
              47190
            ]
          ]
        ]
      ],
      [
        "\u0E2D\u0E32\u0E01\u0E32\u0E28\u0E2D\u0E33\u0E19\u0E27\u0E22",
        [
          [
            "\u0E17\u0E48\u0E32\u0E01\u0E49\u0E2D\u0E19",
            [
              47170
            ]
          ],
          [
            "\u0E19\u0E32\u0E2E\u0E35",
            [
              47170
            ]
          ],
          [
            "\u0E1A\u0E30\u0E2B\u0E27\u0E49\u0E32",
            [
              47170
            ]
          ],
          [
            "\u0E27\u0E32\u0E43\u0E2B\u0E0D\u0E48",
            [
              47170
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E31\u0E04\u0E04\u0E35\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              47170
            ]
          ],
          [
            "\u0E2D\u0E32\u0E01\u0E32\u0E28",
            [
              47170
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E07\u0E32\u0E21",
            [
              47170
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E41\u0E1E\u0E07",
            [
              47170
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E08\u0E23\u0E34\u0E0D\u0E28\u0E34\u0E25\u0E1B\u0E4C",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E41\u0E01",
            [
              47290
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E2B\u0E25\u0E48\u0E32",
            [
              47290
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E1B\u0E19",
            [
              47290
            ]
          ],
          [
            "\u0E40\u0E08\u0E23\u0E34\u0E0D\u0E28\u0E34\u0E25\u0E1B\u0E4C",
            [
              47290
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E28\u0E34\u0E25\u0E32",
            [
              47290
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E15\u0E48\u0E32\u0E07\u0E2D\u0E22",
        [
          [
            "\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C\u0E40\u0E1E\u0E47\u0E0D",
            [
              47260
            ]
          ],
          [
            "\u0E19\u0E32\u0E15\u0E32\u0E25",
            [
              47260
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E17\u0E27\u0E32\u0E22",
            [
              47260
            ]
          ],
          [
            "\u0E40\u0E15\u0E48\u0E32\u0E07\u0E2D\u0E22",
            [
              47260
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2A\u0E01\u0E25\u0E19\u0E04\u0E23",
        [
          [
            "\u0E02\u0E21\u0E34\u0E49\u0E19",
            [
              47220
            ]
          ],
          [
            "\u0E07\u0E34\u0E49\u0E27\u0E14\u0E48\u0E2D\u0E19",
            [
              47e3
            ]
          ],
          [
            "\u0E14\u0E07\u0E0A\u0E19",
            [
              47e3
            ]
          ],
          [
            "\u0E14\u0E07\u0E21\u0E30\u0E44\u0E1F",
            [
              47e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E41\u0E23\u0E48",
            [
              47230
            ]
          ],
          [
            "\u0E18\u0E32\u0E15\u0E38\u0E19\u0E32\u0E40\u0E27\u0E07",
            [
              47e3
            ]
          ],
          [
            "\u0E18\u0E32\u0E15\u0E38\u0E40\u0E0A\u0E34\u0E07\u0E0A\u0E38\u0E21",
            [
              47e3
            ]
          ],
          [
            "\u0E1E\u0E31\u0E07\u0E02\u0E27\u0E49\u0E32\u0E07",
            [
              47e3
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E25\u0E32\u0E22",
            [
              47e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E25\u0E32\u0E14",
            [
              47220
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E22\u0E32\u0E07",
            [
              47e3
            ]
          ],
          [
            "\u0E2E\u0E32\u0E07\u0E42\u0E2E\u0E07",
            [
              47e3
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E40\u0E04\u0E23\u0E37\u0E2D",
            [
              47e3
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E1B\u0E2D\u0E41\u0E14\u0E07",
            [
              47e3
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E01\u0E48\u0E2D\u0E07",
            [
              47e3
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2B\u0E2D\u0E21",
            [
              47e3
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E04\u0E01\u0E28\u0E23\u0E35\u0E2A\u0E38\u0E1E\u0E23\u0E23\u0E13",
        [
          [
            "\u0E14\u0E48\u0E32\u0E19\u0E21\u0E48\u0E27\u0E07\u0E04\u0E33",
            [
              47280
            ]
          ],
          [
            "\u0E15\u0E2D\u0E07\u0E42\u0E02\u0E1A",
            [
              47280
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E42\u0E1E\u0E19\u0E04\u0E49\u0E2D",
            [
              47280
            ]
          ],
          [
            "\u0E41\u0E21\u0E14\u0E19\u0E32\u0E17\u0E48\u0E21",
            [
              47280
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E1E\u0E19\u0E19\u0E32\u0E41\u0E01\u0E49\u0E27",
        [
          [
            "\u0E19\u0E32\u0E15\u0E07\u0E27\u0E31\u0E12\u0E19\u0E32",
            [
              47230
            ]
          ],
          [
            "\u0E19\u0E32\u0E41\u0E01\u0E49\u0E27",
            [
              47230
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E1B\u0E49\u0E19",
            [
              47230
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E1E\u0E19",
            [
              47230
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E2A\u0E37\u0E2D",
            [
              47230
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2A\u0E07\u0E02\u0E25\u0E32",
    [
      [
        "\u0E01\u0E23\u0E30\u0E41\u0E2A\u0E2A\u0E34\u0E19\u0E18\u0E38\u0E4C",
        [
          [
            "\u0E01\u0E23\u0E30\u0E41\u0E2A\u0E2A\u0E34\u0E19\u0E18\u0E38\u0E4C",
            [
              90270
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E43\u0E2B\u0E0D\u0E48",
            [
              90270
            ]
          ],
          [
            "\u0E40\u0E0A\u0E34\u0E07\u0E41\u0E2A",
            [
              90270
            ]
          ],
          [
            "\u0E42\u0E23\u0E07",
            [
              90270
            ]
          ]
        ]
      ],
      [
        "\u0E04\u0E25\u0E2D\u0E07\u0E2B\u0E2D\u0E22\u0E42\u0E02\u0E48\u0E07",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2B\u0E25\u0E32",
            [
              90115
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2B\u0E2D\u0E22\u0E42\u0E02\u0E48\u0E07",
            [
              90230
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E25\u0E32\u0E19",
            [
              90230
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E21\u0E48\u0E27\u0E07",
            [
              90230
            ]
          ]
        ]
      ],
      [
        "\u0E04\u0E27\u0E19\u0E40\u0E19\u0E35\u0E22\u0E07",
        [
          [
            "\u0E04\u0E27\u0E19\u0E42\u0E2A",
            [
              90220
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E2B\u0E23\u0E35\u0E22\u0E07",
            [
              90220
            ]
          ],
          [
            "\u0E23\u0E31\u0E15\u0E20\u0E39\u0E21\u0E34",
            [
              90220
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E25\u0E36\u0E01",
            [
              90220
            ]
          ]
        ]
      ],
      [
        "\u0E08\u0E30\u0E19\u0E30",
        [
          [
            "\u0E02\u0E38\u0E19\u0E15\u0E31\u0E14\u0E2B\u0E27\u0E32\u0E22",
            [
              90130
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E40\u0E1B\u0E35\u0E22\u0E30",
            [
              90130
            ]
          ],
          [
            "\u0E04\u0E39",
            [
              90130
            ]
          ],
          [
            "\u0E08\u0E30\u0E42\u0E2B\u0E19\u0E07",
            [
              90130
            ]
          ],
          [
            "\u0E15\u0E25\u0E34\u0E48\u0E07\u0E0A\u0E31\u0E19",
            [
              90130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2B\u0E21\u0E2D\u0E44\u0E17\u0E23",
            [
              90130
            ]
          ],
          [
            "\u0E19\u0E32\u0E17\u0E31\u0E1A",
            [
              90130
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E27\u0E49\u0E32",
            [
              90130
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E02\u0E32\u0E27",
            [
              90130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E32",
            [
              90130
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E0A\u0E34\u0E07",
            [
              90130
            ]
          ],
          [
            "\u0E2A\u0E30\u0E01\u0E2D\u0E21",
            [
              90130
            ]
          ],
          [
            "\u0E2A\u0E30\u0E1E\u0E32\u0E19\u0E44\u0E21\u0E49\u0E41\u0E01\u0E48\u0E19",
            [
              90130
            ]
          ],
          [
            "\u0E41\u0E04",
            [
              90130
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E17\u0E27\u0E35",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E01\u0E27\u0E32\u0E07",
            [
              90160
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E17\u0E23\u0E32\u0E22",
            [
              90160
            ]
          ],
          [
            "\u0E09\u0E32\u0E07",
            [
              90160
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E0A\u0E49\u0E32\u0E07",
            [
              90160
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E1B\u0E23\u0E30\u0E14\u0E39\u0E48",
            [
              90160
            ]
          ],
          [
            "\u0E19\u0E32\u0E17\u0E27\u0E35",
            [
              90160
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E21\u0E2D\u0E28\u0E23\u0E35",
            [
              90160
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A",
            [
              90160
            ]
          ],
          [
            "\u0E1B\u0E25\u0E31\u0E01\u0E2B\u0E19\u0E39",
            [
              90160
            ]
          ],
          [
            "\u0E2A\u0E30\u0E17\u0E49\u0E2D\u0E19",
            [
              90160
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E2B\u0E21\u0E48\u0E2D\u0E21",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2B\u0E23\u0E31\u0E07",
            [
              90310
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E02\u0E21\u0E34\u0E49\u0E19",
            [
              90310
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E21\u0E48\u0E2D\u0E21",
            [
              90310
            ]
          ],
          [
            "\u0E1E\u0E34\u0E08\u0E34\u0E15\u0E23",
            [
              90310
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E01\u0E25\u0E48\u0E33",
        [
          [
            "\u0E17\u0E48\u0E32\u0E0A\u0E49\u0E32\u0E07",
            [
              90110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E25\u0E48\u0E33",
            [
              90110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E32\u0E23",
            [
              90110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E17\u0E2D\u0E21",
            [
              90110
            ]
          ]
        ]
      ],
      [
        "\u0E23\u0E30\u0E42\u0E19\u0E14",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E41\u0E14\u0E19",
            [
              90140
            ]
          ],
          [
            "\u0E15\u0E30\u0E40\u0E04\u0E23\u0E35\u0E22\u0E30",
            [
              90140
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E1A\u0E2D\u0E19",
            [
              90140
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E15\u0E23\u0E38",
            [
              90140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E02\u0E32\u0E27",
            [
              90140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48",
            [
              90140
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E41\u0E15\u0E23\u0E30",
            [
              90140
            ]
          ],
          [
            "\u0E1E\u0E31\u0E07\u0E22\u0E32\u0E07",
            [
              90140
            ]
          ],
          [
            "\u0E23\u0E30\u0E27\u0E30",
            [
              90140
            ]
          ],
          [
            "\u0E23\u0E30\u0E42\u0E19\u0E14",
            [
              90140
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E2A\u0E19",
            [
              90140
            ]
          ],
          [
            "\u0E41\u0E14\u0E19\u0E2A\u0E07\u0E27\u0E19",
            [
              90140
            ]
          ]
        ]
      ],
      [
        "\u0E23\u0E31\u0E15\u0E20\u0E39\u0E21\u0E34",
        [
          [
            "\u0E01\u0E33\u0E41\u0E1E\u0E07\u0E40\u0E1E\u0E0A\u0E23",
            [
              90180
            ]
          ],
          [
            "\u0E04\u0E27\u0E19\u0E23\u0E39",
            [
              90220
            ]
          ],
          [
            "\u0E04\u0E39\u0E2B\u0E32\u0E43\u0E15\u0E49",
            [
              90180
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E0A\u0E30\u0E21\u0E27\u0E07",
            [
              90180
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E1E\u0E23\u0E30",
            [
              90180
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E17\u0E34\u0E07\u0E1E\u0E23\u0E30",
        [
          [
            "\u0E01\u0E23\u0E30\u0E14\u0E31\u0E07\u0E07\u0E32",
            [
              90190
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E23\u0E35",
            [
              90190
            ]
          ],
          [
            "\u0E04\u0E39\u0E02\u0E38\u0E14",
            [
              90190
            ]
          ],
          [
            "\u0E08\u0E30\u0E17\u0E34\u0E49\u0E07\u0E1E\u0E23\u0E30",
            [
              90190
            ]
          ],
          [
            "\u0E0A\u0E38\u0E21\u0E1E\u0E25",
            [
              90190
            ]
          ],
          [
            "\u0E14\u0E35\u0E2B\u0E25\u0E27\u0E07",
            [
              90190
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2B\u0E34\u0E19",
            [
              90190
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E14\u0E32\u0E19",
            [
              90190
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E41\u0E14\u0E07",
            [
              90190
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
            [
              90190
            ]
          ],
          [
            "\u0E2A\u0E19\u0E32\u0E21\u0E0A\u0E31\u0E22",
            [
              90190
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E30\u0E1A\u0E49\u0E32\u0E22\u0E49\u0E2D\u0E22",
        [
          [
            "\u0E04\u0E39\u0E2B\u0E32",
            [
              90210
            ]
          ],
          [
            "\u0E08\u0E30\u0E41\u0E2B\u0E19",
            [
              90210
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E1E\u0E2D",
            [
              90210
            ]
          ],
          [
            "\u0E18\u0E32\u0E23\u0E04\u0E35\u0E23\u0E35",
            [
              90210
            ]
          ],
          [
            "\u0E1A\u0E32\u0E42\u0E2B\u0E22",
            [
              90210
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E2B\u0E19\u0E14",
            [
              90210
            ]
          ],
          [
            "\u0E2A\u0E30\u0E1A\u0E49\u0E32\u0E22\u0E49\u0E2D\u0E22",
            [
              90210
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E41\u0E14\u0E07",
            [
              90210
            ]
          ],
          [
            "\u0E40\u0E1B\u0E35\u0E22\u0E19",
            [
              90210
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E30\u0E40\u0E14\u0E32",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2B\u0E21\u0E2D",
            [
              90240
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              90170
            ]
          ],
          [
            "\u0E1B\u0E23\u0E34\u0E01",
            [
              90120
            ]
          ],
          [
            "\u0E1B\u0E32\u0E14\u0E31\u0E07\u0E40\u0E1A\u0E0B\u0E32\u0E23\u0E4C",
            [
              90240
            ]
          ],
          [
            "\u0E1E\u0E31\u0E07\u0E25\u0E32",
            [
              90170
            ]
          ],
          [
            "\u0E2A\u0E30\u0E40\u0E14\u0E32",
            [
              90120
            ]
          ],
          [
            "\u0E2A\u0E33\u0E19\u0E31\u0E01\u0E02\u0E32\u0E21",
            [
              90320
            ]
          ],
          [
            "\u0E2A\u0E33\u0E19\u0E31\u0E01\u0E41\u0E15\u0E49\u0E27",
            [
              90120
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E21\u0E35\u0E40\u0E01\u0E35\u0E22\u0E23\u0E15\u0E34",
            [
              90170
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E34\u0E07\u0E2B\u0E19\u0E04\u0E23",
        [
          [
            "\u0E0A\u0E30\u0E41\u0E25\u0E49",
            [
              90330
            ]
          ],
          [
            "\u0E0A\u0E34\u0E07\u0E42\u0E04",
            [
              90280
            ]
          ],
          [
            "\u0E17\u0E33\u0E19\u0E1A",
            [
              90280
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E02\u0E35\u0E22\u0E14",
            [
              90330
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E23\u0E2D",
            [
              90330
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E02\u0E32\u0E14",
            [
              90330
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E07\u0E32\u0E21",
            [
              90330
            ]
          ],
          [
            "\u0E23\u0E33\u0E41\u0E14\u0E07",
            [
              90330
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E02\u0E19\u0E38\u0E19",
            [
              90330
            ]
          ],
          [
            "\u0E2A\u0E17\u0E34\u0E07\u0E2B\u0E21\u0E49\u0E2D",
            [
              90280
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E40\u0E02\u0E32",
            [
              90280
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E32\u0E14\u0E43\u0E2B\u0E0D\u0E48",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2D\u0E39\u0E48\u0E15\u0E30\u0E40\u0E20\u0E32",
            [
              90110
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E41\u0E2B",
            [
              90110
            ]
          ],
          [
            "\u0E04\u0E27\u0E19\u0E25\u0E31\u0E07",
            [
              90110
            ]
          ],
          [
            "\u0E04\u0E2D\u0E2B\u0E07\u0E2A\u0E4C",
            [
              90110
            ]
          ],
          [
            "\u0E04\u0E39\u0E40\u0E15\u0E48\u0E32",
            [
              90110
            ]
          ],
          [
            "\u0E09\u0E25\u0E38\u0E07",
            [
              90110
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E15\u0E33\u0E40\u0E2A\u0E32",
            [
              90110
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              90110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E49\u0E32\u0E21",
            [
              90110
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E19\u0E49\u0E2D\u0E22",
            [
              90110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1E\u0E23\u0E38",
            [
              90250
            ]
          ],
          [
            "\u0E1E\u0E30\u0E15\u0E07",
            [
              90230
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E43\u0E2B\u0E0D\u0E48",
            [
              90110
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E17\u0E1E\u0E32",
        [
          [
            "\u0E17\u0E48\u0E32\u0E21\u0E48\u0E27\u0E07",
            [
              90150
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E1A\u0E32\u0E07",
            [
              90150
            ]
          ],
          [
            "\u0E25\u0E33\u0E44\u0E1E\u0E25",
            [
              90260
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              90260
            ]
          ],
          [
            "\u0E2A\u0E30\u0E01\u0E2D\u0E21",
            [
              90150
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E2A\u0E30\u0E1A\u0E49\u0E32",
            [
              90150
            ]
          ],
          [
            "\u0E40\u0E17\u0E1E\u0E32",
            [
              90150
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2A\u0E07\u0E02\u0E25\u0E32",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2B\u0E27\u0E31\u0E07",
            [
              9e4
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E22\u0E32\u0E07",
            [
              9e4
            ]
          ],
          [
            "\u0E1E\u0E30\u0E27\u0E07",
            [
              90100
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E22\u0E2D",
            [
              90100
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E41\u0E15\u0E49\u0E27",
            [
              9e4
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E23\u0E39\u0E1B\u0E0A\u0E49\u0E32\u0E07",
            [
              9e4
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2A\u0E15\u0E39\u0E25",
    [
      [
        "\u0E04\u0E27\u0E19\u0E01\u0E32\u0E2B\u0E25\u0E07",
        [
          [
            "\u0E04\u0E27\u0E19\u0E01\u0E32\u0E2B\u0E25\u0E07",
            [
              91130
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E19\u0E38\u0E49\u0E22",
            [
              91130
            ]
          ],
          [
            "\u0E2D\u0E38\u0E44\u0E14\u0E40\u0E08\u0E23\u0E34\u0E0D",
            [
              91130
            ]
          ]
        ]
      ],
      [
        "\u0E04\u0E27\u0E19\u0E42\u0E14\u0E19",
        [
          [
            "\u0E04\u0E27\u0E19\u0E2A\u0E15\u0E2D",
            [
              91160
            ]
          ],
          [
            "\u0E04\u0E27\u0E19\u0E42\u0E14\u0E19",
            [
              91160
            ]
          ],
          [
            "\u0E22\u0E48\u0E32\u0E19\u0E0B\u0E37\u0E48\u0E2D",
            [
              91160
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E1B\u0E23\u0E30\u0E08\u0E31\u0E19",
            [
              91160
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E38\u0E48\u0E07\u0E2B\u0E27\u0E49\u0E32",
        [
          [
            "\u0E02\u0E2D\u0E19\u0E04\u0E25\u0E32\u0E19",
            [
              91120
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E1A\u0E38\u0E2B\u0E25\u0E31\u0E07",
            [
              91120
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2B\u0E27\u0E49\u0E32",
            [
              91120
            ]
          ],
          [
            "\u0E19\u0E32\u0E17\u0E2D\u0E19",
            [
              91120
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E41\u0E01\u0E48\u0E1A\u0E48\u0E2D\u0E2B\u0E34\u0E19",
            [
              91120
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E48\u0E32\u0E41\u0E1E",
        [
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E23\u0E37\u0E2D",
            [
              91150
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E41\u0E1E",
            [
              91150
            ]
          ],
          [
            "\u0E2A\u0E32\u0E04\u0E23",
            [
              91150
            ]
          ],
          [
            "\u0E41\u0E1B-\u0E23\u0E30",
            [
              91150
            ]
          ]
        ]
      ],
      [
        "\u0E21\u0E30\u0E19\u0E31\u0E07",
        [
          [
            "\u0E19\u0E34\u0E04\u0E21\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              91130
            ]
          ],
          [
            "\u0E1B\u0E32\u0E25\u0E4C\u0E21\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              91130
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E30\u0E07\u0E39",
        [
          [
            "\u0E01\u0E33\u0E41\u0E1E\u0E07",
            [
              91110
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E1C\u0E38\u0E14",
            [
              91110
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E19\u0E49\u0E33",
            [
              91110
            ]
          ],
          [
            "\u0E25\u0E30\u0E07\u0E39",
            [
              91110
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E02\u0E32\u0E27",
            [
              91110
            ]
          ],
          [
            "\u0E41\u0E2B\u0E25\u0E21\u0E2A\u0E19",
            [
              91110
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2A\u0E15\u0E39\u0E25",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E02\u0E38\u0E14",
            [
              91e3
            ]
          ],
          [
            "\u0E04\u0E27\u0E19\u0E02\u0E31\u0E19",
            [
              91e3
            ]
          ],
          [
            "\u0E04\u0E27\u0E19\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              91140
            ]
          ],
          [
            "\u0E09\u0E25\u0E38\u0E07",
            [
              91140
            ]
          ],
          [
            "\u0E15\u0E31\u0E19\u0E2B\u0E22\u0E07\u0E42\u0E1B",
            [
              91e3
            ]
          ],
          [
            "\u0E15\u0E33\u0E21\u0E30\u0E25\u0E31\u0E07",
            [
              91e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E04\u0E27\u0E19",
            [
              91140
            ]
          ],
          [
            "\u0E1B\u0E39\u0E22\u0E39",
            [
              91e3
            ]
          ],
          [
            "\u0E1E\u0E34\u0E21\u0E32\u0E19",
            [
              91e3
            ]
          ],
          [
            "\u0E40\u0E01\u0E15\u0E23\u0E35",
            [
              91140
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E2A\u0E32\u0E2B\u0E23\u0E48\u0E32\u0E22",
            [
              91e3
            ]
          ],
          [
            "\u0E40\u0E08\u0E4A\u0E30\u0E1A\u0E34\u0E25\u0E31\u0E07",
            [
              91e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2A\u0E21\u0E38\u0E17\u0E23\u0E1B\u0E23\u0E32\u0E01\u0E32\u0E23",
    [
      [
        "\u0E1A\u0E32\u0E07\u0E1A\u0E48\u0E2D",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E14\u0E48\u0E32\u0E19",
            [
              10550
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E19\u0E34\u0E22\u0E21\u0E22\u0E32\u0E15\u0E23\u0E32",
            [
              10560
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2A\u0E27\u0E19",
            [
              10560
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1A\u0E48\u0E2D",
            [
              10560
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E25\u0E35\u0E19\u0E49\u0E2D\u0E22",
            [
              10560
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E1E\u0E23\u0E35\u0E22\u0E07",
            [
              10560
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E23\u0E30\u0E01\u0E32\u0E28",
            [
              10560
            ]
          ],
          [
            "\u0E40\u0E1B\u0E23\u0E47\u0E07",
            [
              10560
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E1E\u0E25\u0E35",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E1B\u0E25\u0E32",
            [
              10540
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E25\u0E35\u0E43\u0E2B\u0E0D\u0E48",
            [
              10540
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              10540
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E42\u0E09\u0E25\u0E07",
            [
              10540
            ]
          ],
          [
            "\u0E23\u0E32\u0E0A\u0E32\u0E40\u0E17\u0E27\u0E30",
            [
              10540
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E23\u0E37\u0E2D",
            [
              10540
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E40\u0E2A\u0E32\u0E18\u0E07",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E2A\u0E32\u0E18\u0E07",
            [
              10540
            ]
          ],
          [
            "\u0E28\u0E35\u0E23\u0E29\u0E30\u0E08\u0E23\u0E40\u0E02\u0E49\u0E19\u0E49\u0E2D\u0E22",
            [
              10540
            ]
          ],
          [
            "\u0E28\u0E35\u0E23\u0E29\u0E30\u0E08\u0E23\u0E40\u0E02\u0E49\u0E43\u0E2B\u0E0D\u0E48",
            [
              10540
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E23\u0E30\u0E1B\u0E23\u0E30\u0E41\u0E14\u0E07",
        [
          [
            "\u0E15\u0E25\u0E32\u0E14",
            [
              10130
            ]
          ],
          [
            "\u0E17\u0E23\u0E07\u0E04\u0E19\u0E2D\u0E07",
            [
              10130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E23\u0E30\u0E2A\u0E2D\u0E1A",
            [
              10130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E2D\u0E1A\u0E31\u0E27",
            [
              10130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E30\u0E40\u0E08\u0E49\u0E32",
            [
              10130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E04\u0E23\u0E38",
            [
              10130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E08\u0E32\u0E01",
            [
              10130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E19\u0E49\u0E33\u0E1C\u0E36\u0E49\u0E07",
            [
              10130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E36\u0E48\u0E07",
            [
              10130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E22\u0E2D",
            [
              10130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2B\u0E0D\u0E49\u0E32\u0E41\u0E1E\u0E23\u0E01",
            [
              10130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2B\u0E31\u0E27\u0E40\u0E2A\u0E37\u0E2D",
            [
              10130
            ]
          ],
          [
            "\u0E2A\u0E33\u0E42\u0E23\u0E07",
            [
              10130
            ]
          ],
          [
            "\u0E2A\u0E33\u0E42\u0E23\u0E07\u0E01\u0E25\u0E32\u0E07",
            [
              10130
            ]
          ],
          [
            "\u0E2A\u0E33\u0E42\u0E23\u0E07\u0E43\u0E15\u0E49",
            [
              10130
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E23\u0E30\u0E2A\u0E21\u0E38\u0E17\u0E23\u0E40\u0E08\u0E14\u0E35\u0E22\u0E4C",
        [
          [
            "\u0E19\u0E32\u0E40\u0E01\u0E25\u0E37\u0E2D",
            [
              10290
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E04\u0E25\u0E2D\u0E07\u0E2A\u0E27\u0E19",
            [
              10290
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E04\u0E25\u0E2D\u0E07\u0E1A\u0E32\u0E07\u0E1B\u0E25\u0E32\u0E01\u0E14",
            [
              10290
            ]
          ],
          [
            "\u0E41\u0E2B\u0E25\u0E21\u0E1F\u0E49\u0E32\u0E1C\u0E48\u0E32",
            [
              10290
            ]
          ],
          [
            "\u0E43\u0E19\u0E04\u0E25\u0E2D\u0E07\u0E1A\u0E32\u0E07\u0E1B\u0E25\u0E32\u0E01\u0E14",
            [
              10290
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2A\u0E21\u0E38\u0E17\u0E23\u0E1B\u0E23\u0E32\u0E01\u0E32\u0E23",
        [
          [
            "\u0E17\u0E49\u0E32\u0E22\u0E1A\u0E49\u0E32\u0E19",
            [
              10280
            ]
          ],
          [
            "\u0E17\u0E49\u0E32\u0E22\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48",
            [
              10280
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E14\u0E49\u0E27\u0E19",
            [
              10270
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1B\u0E39",
            [
              10280
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1B\u0E39\u0E43\u0E2B\u0E21\u0E48",
            [
              10280
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              10270
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48",
            [
              10270
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E42\u0E1B\u0E23\u0E07",
            [
              10270
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E19\u0E49\u0E33",
            [
              10270
            ]
          ],
          [
            "\u0E2A\u0E33\u0E42\u0E23\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              10270
            ]
          ],
          [
            "\u0E40\u0E17\u0E1E\u0E32\u0E23\u0E31\u0E01\u0E29\u0E4C",
            [
              10270
            ]
          ],
          [
            "\u0E41\u0E1E\u0E23\u0E01\u0E29\u0E32",
            [
              10280
            ]
          ],
          [
            "\u0E41\u0E1E\u0E23\u0E01\u0E29\u0E32\u0E43\u0E2B\u0E21\u0E48",
            [
              10280
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2A\u0E21\u0E38\u0E17\u0E23\u0E2A\u0E07\u0E04\u0E23\u0E32\u0E21",
    [
      [
        "\u0E1A\u0E32\u0E07\u0E04\u0E19\u0E17\u0E35",
        [
          [
            "\u0E01\u0E23\u0E30\u0E14\u0E31\u0E07\u0E07\u0E32",
            [
              75120
            ]
          ],
          [
            "\u0E08\u0E2D\u0E21\u0E1B\u0E25\u0E27\u0E01",
            [
              75120
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E21\u0E30\u0E42\u0E19\u0E23\u0E32",
            [
              75120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E23\u0E30\u0E1A\u0E37\u0E2D",
            [
              75120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E38\u0E49\u0E07",
            [
              75120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E04\u0E19\u0E17\u0E35",
            [
              75120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E19\u0E01\u0E41\u0E02\u0E27\u0E01",
            [
              75120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E23\u0E21",
            [
              75120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E22\u0E35\u0E48\u0E23\u0E07\u0E04\u0E4C",
            [
              75120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2A\u0E30\u0E41\u0E01",
            [
              75120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1B\u0E23\u0E32\u0E42\u0E21\u0E17\u0E22\u0E4C",
            [
              75120
            ]
          ],
          [
            "\u0E22\u0E32\u0E22\u0E41\u0E1E\u0E07",
            [
              75120
            ]
          ],
          [
            "\u0E42\u0E23\u0E07\u0E2B\u0E35\u0E1A",
            [
              75120
            ]
          ]
        ]
      ],
      [
        "\u0E2D\u0E31\u0E21\u0E1E\u0E27\u0E32",
        [
          [
            "\u0E17\u0E48\u0E32\u0E04\u0E32",
            [
              75110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E0A\u0E49\u0E32\u0E07",
            [
              75110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E19\u0E32\u0E07\u0E25\u0E35\u0E48",
            [
              75110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E41\u0E04",
            [
              75110
            ]
          ],
          [
            "\u0E1B\u0E25\u0E32\u0E22\u0E42\u0E1E\u0E07\u0E1E\u0E32\u0E07",
            [
              75110
            ]
          ],
          [
            "\u0E22\u0E35\u0E48\u0E2A\u0E32\u0E23",
            [
              75110
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E1B\u0E23\u0E30\u0E14\u0E39\u0E48",
            [
              75110
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E2B\u0E25\u0E27\u0E07",
            [
              75110
            ]
          ],
          [
            "\u0E2D\u0E31\u0E21\u0E1E\u0E27\u0E32",
            [
              75110
            ]
          ],
          [
            "\u0E40\u0E2B\u0E21\u0E37\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48",
            [
              75110
            ]
          ],
          [
            "\u0E41\u0E04\u0E27\u0E2D\u0E49\u0E2D\u0E21",
            [
              75110
            ]
          ],
          [
            "\u0E41\u0E1E\u0E23\u0E01\u0E2B\u0E19\u0E32\u0E21\u0E41\u0E14\u0E07",
            [
              75110
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2A\u0E21\u0E38\u0E17\u0E23\u0E2A\u0E07\u0E04\u0E23\u0E32\u0E21",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E40\u0E02\u0E34\u0E19",
            [
              75e3
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E42\u0E04\u0E19",
            [
              75e3
            ]
          ],
          [
            "\u0E17\u0E49\u0E32\u0E22\u0E2B\u0E32\u0E14",
            [
              75e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E07\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              75e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E02\u0E31\u0E19\u0E41\u0E15\u0E01",
            [
              75e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E08\u0E30\u0E40\u0E01\u0E23\u0E47\u0E07",
            [
              75e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              75e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1B\u0E23\u0E01",
            [
              75e3
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E43\u0E2B\u0E0D\u0E48",
            [
              75e3
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E01\u0E25\u0E2D\u0E07",
            [
              75e3
            ]
          ],
          [
            "\u0E41\u0E2B\u0E25\u0E21\u0E43\u0E2B\u0E0D\u0E48",
            [
              75e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2A\u0E21\u0E38\u0E17\u0E23\u0E2A\u0E32\u0E04\u0E23",
    [
      [
        "\u0E01\u0E23\u0E30\u0E17\u0E38\u0E48\u0E21\u0E41\u0E1A\u0E19",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E21\u0E30\u0E40\u0E14\u0E37\u0E48\u0E2D",
            [
              74110
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E44\u0E01\u0E48\u0E14\u0E35",
            [
              74110
            ]
          ],
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E01\u0E23\u0E30\u0E17\u0E38\u0E48\u0E21\u0E41\u0E1A\u0E19",
            [
              74110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E2A\u0E32",
            [
              74110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E44\u0E21\u0E49",
            [
              74110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E22\u0E32\u0E07",
            [
              74110
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E2B\u0E25\u0E27\u0E07",
            [
              74110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E19\u0E01\u0E44\u0E02\u0E48",
            [
              74110
            ]
          ],
          [
            "\u0E2D\u0E49\u0E2D\u0E21\u0E19\u0E49\u0E2D\u0E22",
            [
              74130
            ]
          ],
          [
            "\u0E41\u0E04\u0E23\u0E32\u0E22",
            [
              74110
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E1E\u0E49\u0E27",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E15\u0E31\u0E19",
            [
              74120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E1E\u0E49\u0E27",
            [
              74120
            ]
          ],
          [
            "\u0E22\u0E01\u0E01\u0E23\u0E30\u0E1A\u0E31\u0E15\u0E23",
            [
              74120
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E2A\u0E49\u0E21",
            [
              74120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              74120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E2D\u0E07\u0E2B\u0E49\u0E2D\u0E07",
            [
              74120
            ]
          ],
          [
            "\u0E2B\u0E25\u0E31\u0E01\u0E2A\u0E2D\u0E07",
            [
              74120
            ]
          ],
          [
            "\u0E2B\u0E25\u0E31\u0E01\u0E2A\u0E32\u0E21",
            [
              74120
            ]
          ],
          [
            "\u0E2D\u0E33\u0E41\u0E1E\u0E07",
            [
              74120
            ]
          ],
          [
            "\u0E40\u0E01\u0E29\u0E15\u0E23\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              74120
            ]
          ],
          [
            "\u0E40\u0E08\u0E47\u0E14\u0E23\u0E34\u0E49\u0E27",
            [
              74120
            ]
          ],
          [
            "\u0E42\u0E23\u0E07\u0E40\u0E02\u0E49",
            [
              74120
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2A\u0E21\u0E38\u0E17\u0E23\u0E2A\u0E32\u0E04\u0E23",
        [
          [
            "\u0E01\u0E32\u0E2B\u0E25\u0E07",
            [
              74e3
            ]
          ],
          [
            "\u0E04\u0E2D\u0E01\u0E01\u0E23\u0E30\u0E1A\u0E37\u0E2D",
            [
              74e3
            ]
          ],
          [
            "\u0E0A\u0E31\u0E22\u0E21\u0E07\u0E04\u0E25",
            [
              74e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E08\u0E35\u0E19",
            [
              74e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E09\u0E25\u0E2D\u0E21",
            [
              74e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E17\u0E23\u0E32\u0E22",
            [
              74e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E14\u0E35",
            [
              74e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E42\u0E04\u0E01",
            [
              74e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E23\u0E30\u0E40\u0E08\u0E49\u0E32",
            [
              74e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E19\u0E49\u0E33\u0E08\u0E37\u0E14",
            [
              74e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E2B\u0E0D\u0E49\u0E32\u0E41\u0E1E\u0E23\u0E01",
            [
              74e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E42\u0E17\u0E23\u0E31\u0E14",
            [
              74e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1A\u0E48\u0E2D",
            [
              74e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E01\u0E32\u0E30",
            [
              74e3
            ]
          ],
          [
            "\u0E1E\u0E31\u0E19\u0E17\u0E49\u0E32\u0E22\u0E19\u0E23\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
            [
              74e3
            ]
          ],
          [
            "\u0E21\u0E2B\u0E32\u0E0A\u0E31\u0E22",
            [
              74e3
            ]
          ],
          [
            "\u0E42\u0E01\u0E23\u0E01\u0E01\u0E23\u0E32\u0E01",
            [
              74e3
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E02\u0E32\u0E21",
            [
              74e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2A\u0E23\u0E30\u0E1A\u0E38\u0E23\u0E35",
    [
      [
        "\u0E14\u0E2D\u0E19\u0E1E\u0E38\u0E14",
        [
          [
            "\u0E14\u0E07\u0E15\u0E30\u0E07\u0E32\u0E27",
            [
              18210
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E1E\u0E38\u0E14",
            [
              18210
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E25\u0E27\u0E07",
            [
              18210
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E2B\u0E25\u0E34\u0E48\u0E27",
            [
              18210
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E21\u0E2D",
        [
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E19\u0E49\u0E2D\u0E22",
            [
              18130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E42\u0E02\u0E21\u0E14",
            [
              18130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E04\u0E23\u0E31\u0E27",
            [
              18270
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E21\u0E2D",
            [
              18130
            ]
          ],
          [
            "\u0E2A\u0E23\u0E48\u0E32\u0E07\u0E42\u0E28\u0E01",
            [
              18130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              18130
            ]
          ],
          [
            "\u0E2B\u0E23\u0E40\u0E17\u0E1E",
            [
              18130
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E43\u0E2B\u0E0D\u0E48",
            [
              18130
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E02\u0E27\u0E32\u0E07",
            [
              18130
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E23\u0E30\u0E1E\u0E38\u0E17\u0E18\u0E1A\u0E32\u0E17",
        [
          [
            "\u0E02\u0E38\u0E19\u0E42\u0E02\u0E25\u0E19",
            [
              18120
            ]
          ],
          [
            "\u0E18\u0E32\u0E23\u0E40\u0E01\u0E29\u0E21",
            [
              18120
            ]
          ],
          [
            "\u0E19\u0E32\u0E22\u0E32\u0E27",
            [
              18120
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E1E\u0E38\u0E17\u0E18\u0E1A\u0E32\u0E17",
            [
              18120
            ]
          ],
          [
            "\u0E1E\u0E38\u0E01\u0E23\u0E48\u0E32\u0E07",
            [
              18120
            ]
          ],
          [
            "\u0E1E\u0E38\u0E04\u0E33\u0E08\u0E32\u0E19",
            [
              18120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E01",
            [
              18120
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E1B\u0E48\u0E32\u0E2B\u0E27\u0E32\u0E22",
            [
              18120
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E27\u0E07",
            [
              18120
            ]
          ]
        ]
      ],
      [
        "\u0E21\u0E27\u0E01\u0E40\u0E2B\u0E25\u0E47\u0E01",
        [
          [
            "\u0E0B\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E48\u0E19",
            [
              18220
            ]
          ],
          [
            "\u0E21\u0E27\u0E01\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              18180
            ]
          ],
          [
            "\u0E21\u0E34\u0E15\u0E23\u0E20\u0E32\u0E1E",
            [
              18180
            ]
          ],
          [
            "\u0E25\u0E33\u0E1E\u0E0D\u0E32\u0E01\u0E25\u0E32\u0E07",
            [
              30130
            ]
          ],
          [
            "\u0E25\u0E33\u0E2A\u0E21\u0E1E\u0E38\u0E07",
            [
              30130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E22\u0E48\u0E32\u0E07\u0E40\u0E2A\u0E37\u0E2D",
            [
              18180
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E07\u0E21\u0E48\u0E27\u0E07",
        [
          [
            "\u0E04\u0E33\u0E1E\u0E23\u0E32\u0E19",
            [
              18220
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E21\u0E48\u0E27\u0E07",
            [
              18220
            ]
          ],
          [
            "\u0E41\u0E2A\u0E25\u0E07\u0E1E\u0E31\u0E19",
            [
              18220
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E34\u0E2B\u0E32\u0E23\u0E41\u0E14\u0E07",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E40\u0E23\u0E37\u0E2D",
            [
              18150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E25\u0E33",
            [
              18150
            ]
          ],
          [
            "\u0E27\u0E34\u0E2B\u0E32\u0E23\u0E41\u0E14\u0E07",
            [
              18150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E23\u0E27\u0E07",
            [
              18150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E21\u0E39",
            [
              18150
            ]
          ],
          [
            "\u0E40\u0E08\u0E23\u0E34\u0E0D\u0E18\u0E23\u0E23\u0E21",
            [
              18150
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E04",
        [
          [
            "\u0E01\u0E38\u0E48\u0E21\u0E2B\u0E31\u0E01",
            [
              18140
            ]
          ],
          [
            "\u0E04\u0E0A\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C",
            [
              18250
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E25\u0E2D\u0E22",
            [
              18230
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E08\u0E23\u0E40\u0E02\u0E49",
            [
              18140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E08\u0E34\u0E01",
            [
              18230
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E19\u0E32\u0E01",
            [
              18230
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E25\u0E32\u0E2B\u0E21\u0E2D",
            [
              18140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E25\u0E34\u0E07",
            [
              18140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E02\u0E21",
            [
              18140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E04",
            [
              18140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E23\u0E07",
            [
              18140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E02\u0E48\u0E19\u0E49\u0E33",
            [
              18140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E02\u0E21\u0E34\u0E49\u0E19",
            [
              18230
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E17\u0E23\u0E32\u0E22",
            [
              18230
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E15\u0E39\u0E21",
            [
              18250
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E41\u0E22\u0E49",
            [
              18230
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E17\u0E2D\u0E07",
            [
              18250
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E15\u0E48\u0E33",
            [
              18140
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E0B\u0E07",
        [
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E2B\u0E27\u0E32\u0E19",
            [
              18170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E1A",
            [
              18170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E04\u0E27\u0E32\u0E22\u0E42\u0E0B",
            [
              18170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E35\u0E14\u0E32",
            [
              18170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E31\u0E27\u0E42\u0E1E",
            [
              18170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E0B\u0E07",
            [
              18170
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E14\u0E34\u0E19",
            [
              18170
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              18170
            ]
          ],
          [
            "\u0E44\u0E01\u0E48\u0E40\u0E2A\u0E48\u0E32",
            [
              18170
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E14\u0E19",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E17\u0E2D\u0E07",
            [
              18190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E25\u0E31\u0E1A",
            [
              18190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E1B\u0E23\u0E48\u0E07",
            [
              18190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E14\u0E19",
            [
              18190
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E09\u0E25\u0E34\u0E21\u0E1E\u0E23\u0E30\u0E40\u0E01\u0E35\u0E22\u0E23\u0E15\u0E34",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E01\u0E49\u0E07",
            [
              18e3
            ]
          ],
          [
            "\u0E1C\u0E36\u0E49\u0E07\u0E23\u0E27\u0E07",
            [
              18e3
            ]
          ],
          [
            "\u0E1E\u0E38\u0E41\u0E04",
            [
              18240
            ]
          ],
          [
            "\u0E2B\u0E19\u0E49\u0E32\u0E1E\u0E23\u0E30\u0E25\u0E32\u0E19",
            [
              18240
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E1A\u0E07",
            [
              18e3
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E14\u0E34\u0E19\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              18e3
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2A\u0E23\u0E30\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E01\u0E38\u0E14\u0E19\u0E01\u0E40\u0E1B\u0E25\u0E49\u0E32",
            [
              18e3
            ]
          ],
          [
            "\u0E14\u0E32\u0E27\u0E40\u0E23\u0E37\u0E2D\u0E07",
            [
              18e3
            ]
          ],
          [
            "\u0E15\u0E25\u0E34\u0E48\u0E07\u0E0A\u0E31\u0E19",
            [
              18e3
            ]
          ],
          [
            "\u0E15\u0E30\u0E01\u0E38\u0E14",
            [
              18e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E42\u0E09\u0E07",
            [
              18e3
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E02\u0E49\u0E32\u0E27\u0E2A\u0E32\u0E23",
            [
              18e3
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E40\u0E1E\u0E23\u0E35\u0E22\u0E27",
            [
              18e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E25\u0E32\u0E44\u0E2B\u0E25",
            [
              18e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E22\u0E32\u0E27",
            [
              18e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E19",
            [
              18e3
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              18e3
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E2A\u0E32\u0E44\u0E2B\u0E49",
        [
          [
            "\u0E07\u0E34\u0E49\u0E27\u0E07\u0E32\u0E21",
            [
              18160
            ]
          ],
          [
            "\u0E15\u0E49\u0E19\u0E15\u0E32\u0E25",
            [
              18160
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E0A\u0E49\u0E32\u0E07",
            [
              18160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E22\u0E32\u0E07",
            [
              18160
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E22\u0E32\u0E17\u0E14",
            [
              18160
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E07\u0E32\u0E21",
            [
              18160
            ]
          ],
          [
            "\u0E28\u0E32\u0E25\u0E32\u0E23\u0E35\u0E44\u0E17\u0E22",
            [
              18160
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E14\u0E2D\u0E01\u0E44\u0E21\u0E49",
            [
              18160
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E1B\u0E25\u0E27\u0E01",
            [
              18160
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E01\u0E48\u0E32",
            [
              18160
            ]
          ],
          [
            "\u0E40\u0E23\u0E34\u0E07\u0E23\u0E32\u0E07",
            [
              18160
            ]
          ],
          [
            "\u0E40\u0E2A\u0E32\u0E44\u0E2B\u0E49",
            [
              18160
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E01\u0E48\u0E07\u0E04\u0E2D\u0E22",
        [
          [
            "\u0E0A\u0E30\u0E2D\u0E21",
            [
              18110
            ]
          ],
          [
            "\u0E0A\u0E33\u0E1C\u0E31\u0E01\u0E41\u0E1E\u0E27",
            [
              18110
            ]
          ],
          [
            "\u0E15\u0E32\u0E25\u0E40\u0E14\u0E35\u0E48\u0E22\u0E27",
            [
              18110
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E01\u0E27\u0E32\u0E07",
            [
              18260
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E04\u0E25\u0E49\u0E2D",
            [
              18110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E15\u0E39\u0E21",
            [
              18110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E21\u0E30\u0E1B\u0E23\u0E32\u0E07",
            [
              18110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E18\u0E32\u0E15\u0E38",
            [
              18110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1B\u0E48\u0E32",
            [
              18110
            ]
          ],
          [
            "\u0E2A\u0E2D\u0E07\u0E04\u0E2D\u0E19",
            [
              18110
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E0B\u0E49\u0E2D\u0E19",
            [
              18110
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E41\u0E2B\u0E49\u0E07",
            [
              18110
            ]
          ],
          [
            "\u0E40\u0E15\u0E32\u0E1B\u0E39\u0E19",
            [
              18110
            ]
          ],
          [
            "\u0E41\u0E01\u0E48\u0E07\u0E04\u0E2D\u0E22",
            [
              18110
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2A\u0E23\u0E30\u0E41\u0E01\u0E49\u0E27",
    [
      [
        "\u0E04\u0E25\u0E2D\u0E07\u0E2B\u0E32\u0E14",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2B\u0E32\u0E14",
            [
              27260
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E44\u0E01\u0E48\u0E40\u0E16\u0E37\u0E48\u0E2D\u0E19",
            [
              27260
            ]
          ],
          [
            "\u0E0B\u0E31\u0E1A\u0E21\u0E30\u0E01\u0E23\u0E39\u0E14",
            [
              27260
            ]
          ],
          [
            "\u0E40\u0E1A\u0E0D\u0E08\u0E02\u0E23",
            [
              27260
            ]
          ],
          [
            "\u0E44\u0E17\u0E22\u0E2D\u0E38\u0E14\u0E21",
            [
              27260
            ]
          ],
          [
            "\u0E44\u0E17\u0E23\u0E17\u0E2D\u0E07",
            [
              27260
            ]
          ],
          [
            "\u0E44\u0E17\u0E23\u0E40\u0E14\u0E35\u0E48\u0E22\u0E27",
            [
              27260
            ]
          ]
        ]
      ],
      [
        "\u0E15\u0E32\u0E1E\u0E23\u0E30\u0E22\u0E32",
        [
          [
            "\u0E15\u0E32\u0E1E\u0E23\u0E30\u0E22\u0E32",
            [
              27180
            ]
          ],
          [
            "\u0E17\u0E31\u0E1E\u0E23\u0E32\u0E0A",
            [
              27180
            ]
          ],
          [
            "\u0E17\u0E31\u0E1E\u0E40\u0E2A\u0E14\u0E47\u0E08",
            [
              27180
            ]
          ],
          [
            "\u0E17\u0E31\u0E1E\u0E44\u0E17\u0E22",
            [
              27180
            ]
          ],
          [
            "\u0E42\u0E04\u0E04\u0E25\u0E32\u0E19",
            [
              27180
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E07\u0E19\u0E49\u0E33\u0E40\u0E22\u0E47\u0E19",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2B\u0E34\u0E19\u0E1B\u0E39\u0E19",
            [
              27210
            ]
          ],
          [
            "\u0E15\u0E32\u0E2B\u0E25\u0E31\u0E07\u0E43\u0E19",
            [
              27210
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E21\u0E2B\u0E32\u0E40\u0E08\u0E23\u0E34\u0E0D",
            [
              27210
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E19\u0E49\u0E33\u0E40\u0E22\u0E47\u0E19",
            [
              27210
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E07\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
        [
          [
            "\u0E27\u0E31\u0E07\u0E17\u0E2D\u0E07",
            [
              27250
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              27250
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E43\u0E2B\u0E21\u0E48",
            [
              27250
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E12\u0E19\u0E32\u0E19\u0E04\u0E23",
        [
          [
            "\u0E0A\u0E48\u0E2D\u0E07\u0E01\u0E38\u0E48\u0E21",
            [
              27160
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E01\u0E27\u0E35\u0E22\u0E19",
            [
              27160
            ]
          ],
          [
            "\u0E1C\u0E31\u0E01\u0E02\u0E30",
            [
              27160
            ]
          ],
          [
            "\u0E27\u0E31\u0E12\u0E19\u0E32\u0E19\u0E04\u0E23",
            [
              27160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19\u0E1A\u0E2D\u0E19",
            [
              27160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E19\u0E49\u0E33\u0E43\u0E2A",
            [
              27160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E01\u0E1D\u0E49\u0E32\u0E22",
            [
              27160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07",
            [
              27160
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E42\u0E08\u0E14",
            [
              27160
            ]
          ],
          [
            "\u0E41\u0E0B\u0E23\u0E4C\u0E2D\u0E2D",
            [
              27160
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2B\u0E21\u0E32\u0E01\u0E40\u0E04\u0E47\u0E07",
            [
              27160
            ]
          ]
        ]
      ],
      [
        "\u0E2D\u0E23\u0E31\u0E0D\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E17\u0E31\u0E1A\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
            [
              27120
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E19\u0E49\u0E33\u0E43\u0E2A",
            [
              27120
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E1E\u0E23\u0E34\u0E01",
            [
              27120
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E49\u0E32\u0E21",
            [
              27120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E14\u0E48\u0E32\u0E19",
            [
              27120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E17\u0E23",
            [
              27120
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E44\u0E23\u0E48",
            [
              27120
            ]
          ],
          [
            "\u0E1C\u0E48\u0E32\u0E19\u0E28\u0E36\u0E01",
            [
              27120
            ]
          ],
          [
            "\u0E1F\u0E32\u0E01\u0E2B\u0E49\u0E27\u0E22",
            [
              27120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E31\u0E07\u0E02\u0E4C",
            [
              27120
            ]
          ],
          [
            "\u0E2B\u0E31\u0E19\u0E17\u0E23\u0E32\u0E22",
            [
              27120
            ]
          ],
          [
            "\u0E2D\u0E23\u0E31\u0E0D\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28",
            [
              27120
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E44\u0E1C\u0E48",
            [
              27120
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E02\u0E32\u0E09\u0E01\u0E23\u0E23\u0E08\u0E4C",
        [
          [
            "\u0E1E\u0E23\u0E30\u0E40\u0E1E\u0E25\u0E34\u0E07",
            [
              27e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E27\u0E49\u0E32",
            [
              27e3
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E09\u0E01\u0E23\u0E23\u0E08\u0E4C",
            [
              27e3
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E2A\u0E32\u0E21\u0E2A\u0E34\u0E1A",
            [
              27e3
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2A\u0E23\u0E30\u0E41\u0E01\u0E49\u0E27",
        [
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E01\u0E29\u0E21",
            [
              27e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E41\u0E22\u0E01",
            [
              27e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E01\u0E49\u0E07",
            [
              27e3
            ]
          ],
          [
            "\u0E28\u0E32\u0E25\u0E32\u0E25\u0E33\u0E14\u0E27\u0E19",
            [
              27e3
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E02\u0E27\u0E31\u0E0D",
            [
              27e3
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E41\u0E01\u0E49\u0E27",
            [
              27e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E2D\u0E19",
            [
              27e3
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E1B\u0E35\u0E48\u0E06\u0E49\u0E2D\u0E07",
            [
              27e3
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E04\u0E01\u0E2A\u0E39\u0E07",
        [
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E21\u0E48\u0E27\u0E07",
            [
              27180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07",
            [
              27180
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E39\u0E07",
            [
              27120
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2B\u0E21\u0E32\u0E01\u0E21\u0E38\u0E48\u0E19",
            [
              27120
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2A\u0E34\u0E07\u0E2B\u0E4C\u0E1A\u0E38\u0E23\u0E35",
    [
      [
        "\u0E04\u0E48\u0E32\u0E22\u0E1A\u0E32\u0E07\u0E23\u0E30\u0E08\u0E31\u0E19",
        [
          [
            "\u0E04\u0E2D\u0E17\u0E23\u0E32\u0E22",
            [
              16150
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E49\u0E32\u0E21",
            [
              16150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E23\u0E30\u0E08\u0E31\u0E19",
            [
              16150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E17\u0E38\u0E48\u0E21",
            [
              16150
            ]
          ],
          [
            "\u0E42\u0E1E\u0E17\u0E30\u0E40\u0E25",
            [
              16150
            ]
          ],
          [
            "\u0E42\u0E1E\u0E2A\u0E31\u0E07\u0E42\u0E06",
            [
              16150
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E48\u0E32\u0E0A\u0E49\u0E32\u0E07",
        [
          [
            "\u0E16\u0E2D\u0E19\u0E2A\u0E21\u0E2D",
            [
              16140
            ]
          ],
          [
            "\u0E1E\u0E34\u0E01\u0E38\u0E25\u0E17\u0E2D\u0E07",
            [
              16140
            ]
          ],
          [
            "\u0E27\u0E34\u0E2B\u0E32\u0E23\u0E02\u0E32\u0E27",
            [
              16140
            ]
          ],
          [
            "\u0E42\u0E1E\u0E1B\u0E23\u0E30\u0E08\u0E31\u0E01\u0E29\u0E4C",
            [
              16140
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E23\u0E30\u0E08\u0E31\u0E19",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E08\u0E48\u0E32",
            [
              16130
            ]
          ],
          [
            "\u0E1E\u0E31\u0E01\u0E17\u0E31\u0E19",
            [
              16130
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E41\u0E08\u0E07",
            [
              16130
            ]
          ],
          [
            "\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
            [
              16130
            ]
          ],
          [
            "\u0E40\u0E0A\u0E34\u0E07\u0E01\u0E25\u0E31\u0E14",
            [
              16130
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E25\u0E32",
            [
              16130
            ]
          ],
          [
            "\u0E42\u0E1E\u0E0A\u0E19\u0E44\u0E01\u0E48",
            [
              16130
            ]
          ],
          [
            "\u0E44\u0E21\u0E49\u0E14\u0E31\u0E14",
            [
              16130
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E23\u0E2B\u0E21\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E19\u0E49\u0E33\u0E40\u0E0A\u0E35\u0E48\u0E22\u0E27",
            [
              16120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E21\u0E49\u0E2D",
            [
              16120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E1B\u0E49\u0E07",
            [
              16120
            ]
          ],
          [
            "\u0E1E\u0E23\u0E2B\u0E21\u0E1A\u0E38\u0E23\u0E35",
            [
              16160
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E07\u0E32\u0E21",
            [
              16120
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E1B\u0E48\u0E32",
            [
              16120
            ]
          ],
          [
            "\u0E42\u0E23\u0E07\u0E0A\u0E49\u0E32\u0E07",
            [
              16120
            ]
          ]
        ]
      ],
      [
        "\u0E2D\u0E34\u0E19\u0E17\u0E23\u0E4C\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E07\u0E34\u0E49\u0E27\u0E23\u0E32\u0E22",
            [
              16110
            ]
          ],
          [
            "\u0E0A\u0E35\u0E19\u0E49\u0E33\u0E23\u0E49\u0E32\u0E22",
            [
              16110
            ]
          ],
          [
            "\u0E17\u0E2D\u0E07\u0E40\u0E2D\u0E19",
            [
              16110
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E22\u0E32",
            [
              16110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E07\u0E32\u0E21",
            [
              16110
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E15\u0E32\u0E25",
            [
              16110
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E28\u0E38\u0E01",
            [
              16110
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E0A\u0E31\u0E19",
            [
              16110
            ]
          ],
          [
            "\u0E2D\u0E34\u0E19\u0E17\u0E23\u0E4C\u0E1A\u0E38\u0E23\u0E35",
            [
              16110
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E0A\u0E31\u0E22",
            [
              16110
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2A\u0E34\u0E07\u0E2B\u0E4C\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E08\u0E31\u0E01\u0E23\u0E2A\u0E35\u0E2B\u0E4C",
            [
              16e3
            ]
          ],
          [
            "\u0E15\u0E49\u0E19\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              16e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E23\u0E30\u0E1A\u0E37\u0E2D",
            [
              16e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E38\u0E17\u0E23\u0E32",
            [
              16e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E21\u0E31\u0E0D",
            [
              16e3
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E2B\u0E21\u0E39\u0E48",
            [
              16e3
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E44\u0E1C\u0E48",
            [
              16e3
            ]
          ],
          [
            "\u0E42\u0E1E\u0E01\u0E23\u0E27\u0E21",
            [
              16e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2A\u0E38\u0E1E\u0E23\u0E23\u0E13\u0E1A\u0E38\u0E23\u0E35",
    [
      [
        "\u0E14\u0E2D\u0E19\u0E40\u0E08\u0E14\u0E35\u0E22\u0E4C",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E40\u0E08\u0E14\u0E35\u0E22\u0E4C",
            [
              72170
            ]
          ],
          [
            "\u0E17\u0E30\u0E40\u0E25\u0E1A\u0E01",
            [
              72250
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E01\u0E23\u0E30\u0E42\u0E08\u0E21",
            [
              72250
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E32\u0E2B\u0E23\u0E48\u0E32\u0E22",
            [
              72170
            ]
          ],
          [
            "\u0E44\u0E23\u0E48\u0E23\u0E16",
            [
              72170
            ]
          ]
        ]
      ],
      [
        "\u0E14\u0E48\u0E32\u0E19\u0E0A\u0E49\u0E32\u0E07",
        [
          [
            "\u0E14\u0E48\u0E32\u0E19\u0E0A\u0E49\u0E32\u0E07",
            [
              72180
            ]
          ],
          [
            "\u0E19\u0E34\u0E04\u0E21\u0E01\u0E23\u0E30\u0E40\u0E2A\u0E35\u0E22\u0E27",
            [
              72180
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E04\u0E31\u0E19",
            [
              72180
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E22\u0E32\u0E27",
            [
              72180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E21\u0E30\u0E04\u0E48\u0E32\u0E42\u0E21\u0E07",
            [
              72180
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E02\u0E21\u0E34\u0E49\u0E19",
            [
              72180
            ]
          ],
          [
            "\u0E2D\u0E07\u0E04\u0E4C\u0E1E\u0E23\u0E30",
            [
              72180
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E32\u0E07\u0E1B\u0E25\u0E32\u0E21\u0E49\u0E32",
        [
          [
            "\u0E01\u0E24\u0E29\u0E13\u0E32",
            [
              72150
            ]
          ],
          [
            "\u0E08\u0E23\u0E40\u0E02\u0E49\u0E43\u0E2B\u0E0D\u0E48",
            [
              72150
            ]
          ],
          [
            "\u0E15\u0E30\u0E04\u0E48\u0E32",
            [
              72150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1B\u0E25\u0E32\u0E21\u0E49\u0E32",
            [
              72150
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              72150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E2B\u0E25\u0E21",
            [
              72150
            ]
          ],
          [
            "\u0E21\u0E30\u0E02\u0E32\u0E21\u0E25\u0E49\u0E21",
            [
              72150
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E19\u0E49\u0E33\u0E40\u0E22\u0E47\u0E19",
            [
              72150
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E14\u0E32\u0E27",
            [
              72150
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E42\u0E1A\u0E2A\u0E16\u0E4C",
            [
              72150
            ]
          ],
          [
            "\u0E2A\u0E32\u0E25\u0E35",
            [
              72150
            ]
          ],
          [
            "\u0E2D\u0E07\u0E04\u0E23\u0E31\u0E01\u0E29\u0E4C",
            [
              72150
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E04\u0E23\u0E32\u0E21",
            [
              72150
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E01\u0E2D\u0E07\u0E14\u0E34\u0E19",
            [
              72150
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E1B\u0E23\u0E30\u0E08\u0E31\u0E19\u0E15\u0E4C",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E1B\u0E23\u0E39",
            [
              72140
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E07\u0E32\u0E21",
            [
              72140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E23\u0E48\u0E32\u0E07",
            [
              72140
            ]
          ],
          [
            "\u0E1B\u0E25\u0E32\u0E22\u0E19\u0E32",
            [
              72140
            ]
          ],
          [
            "\u0E21\u0E14\u0E41\u0E14\u0E07",
            [
              72140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E19\u0E49\u0E33\u0E0B\u0E31\u0E1A",
            [
              72140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E22\u0E32\u0E07",
            [
              72140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2B\u0E27\u0E49\u0E32",
            [
              72140
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E1B\u0E23\u0E30\u0E08\u0E31\u0E19\u0E15\u0E4C",
            [
              72140
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E2D\u0E07\u0E1E\u0E35\u0E48\u0E19\u0E49\u0E2D\u0E07",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E21\u0E30\u0E19\u0E32\u0E27",
            [
              72110
            ]
          ],
          [
            "\u0E15\u0E49\u0E19\u0E15\u0E32\u0E25",
            [
              72110
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E04\u0E2D\u0E01",
            [
              72110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              72110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E15\u0E32\u0E40\u0E16\u0E23",
            [
              72110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E25\u0E31\u0E1A",
            [
              72110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E25\u0E19",
            [
              72110
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E2A\u0E38\u0E1E\u0E23\u0E23\u0E13",
            [
              72190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E38\u0E48\u0E21",
            [
              72110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E0A\u0E49\u0E32\u0E07",
            [
              72110
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              72110
            ]
          ],
          [
            "\u0E2A\u0E2D\u0E07\u0E1E\u0E35\u0E48\u0E19\u0E49\u0E2D\u0E07",
            [
              72110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E48\u0E2D",
            [
              72190
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              72110
            ]
          ],
          [
            "\u0E40\u0E19\u0E34\u0E19\u0E1E\u0E23\u0E30\u0E1B\u0E23\u0E32\u0E07\u0E04\u0E4C",
            [
              72110
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E32\u0E21\u0E0A\u0E38\u0E01",
        [
          [
            "\u0E01\u0E23\u0E30\u0E40\u0E2A\u0E35\u0E22\u0E27",
            [
              72130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2A\u0E23\u0E30",
            [
              72130
            ]
          ],
          [
            "\u0E22\u0E48\u0E32\u0E19\u0E22\u0E32\u0E27",
            [
              72130
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E25\u0E36\u0E01",
            [
              72130
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E0A\u0E38\u0E01",
            [
              72130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1C\u0E31\u0E01\u0E19\u0E32\u0E01",
            [
              72130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E30\u0E40\u0E14\u0E32",
            [
              72130
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E0D\u0E49\u0E32\u0E44\u0E0B",
        [
          [
            "\u0E17\u0E31\u0E1E\u0E2B\u0E25\u0E27\u0E07",
            [
              72240
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E32\u0E21",
            [
              72240
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E23\u0E32\u0E0A\u0E27\u0E31\u0E15\u0E23",
            [
              72240
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E0D\u0E49\u0E32\u0E44\u0E0B",
            [
              72240
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              72240
            ]
          ],
          [
            "\u0E41\u0E08\u0E07\u0E07\u0E32\u0E21",
            [
              72240
            ]
          ]
        ]
      ],
      [
        "\u0E2D\u0E39\u0E48\u0E17\u0E2D\u0E07",
        [
          [
            "\u0E01\u0E23\u0E30\u0E08\u0E31\u0E19",
            [
              72160
            ]
          ],
          [
            "\u0E08\u0E23\u0E40\u0E02\u0E49\u0E2A\u0E32\u0E21\u0E1E\u0E31\u0E19",
            [
              71170
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E04\u0E32",
            [
              72160
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E21\u0E30\u0E40\u0E01\u0E25\u0E37\u0E2D",
            [
              72220
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E14\u0E2D\u0E19",
            [
              72160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E02\u0E49\u0E07",
            [
              72160
            ]
          ],
          [
            "\u0E1E\u0E25\u0E31\u0E1A\u0E1E\u0E25\u0E32\u0E44\u0E0A\u0E22",
            [
              72160
            ]
          ],
          [
            "\u0E22\u0E38\u0E49\u0E07\u0E17\u0E30\u0E25\u0E32\u0E22",
            [
              72160
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E1E\u0E31\u0E07\u0E25\u0E32\u0E19",
            [
              72220
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E22\u0E32\u0E22\u0E42\u0E2A\u0E21",
            [
              72220
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E2D\u0E48\u0E07",
            [
              72160
            ]
          ],
          [
            "\u0E2D\u0E39\u0E48\u0E17\u0E2D\u0E07",
            [
              72160
            ]
          ],
          [
            "\u0E40\u0E08\u0E14\u0E35\u0E22\u0E4C",
            [
              72160
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E14\u0E34\u0E21\u0E1A\u0E32\u0E07\u0E19\u0E32\u0E07\u0E1A\u0E27\u0E0A",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E04\u0E25\u0E35",
            [
              72120
            ]
          ],
          [
            "\u0E19\u0E32\u0E07\u0E1A\u0E27\u0E0A",
            [
              72120
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E01\u0E23\u0E38",
            [
              72120
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E19\u0E49\u0E33",
            [
              72120
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E2A\u0E30\u0E41\u0E01",
            [
              72120
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E19\u0E2D\u0E19",
            [
              72120
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E28\u0E23\u0E35\u0E23\u0E32\u0E0A",
            [
              72120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E17\u0E38\u0E48\u0E21",
            [
              72120
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E19\u0E32",
            [
              72120
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E40\u0E02\u0E32",
            [
              72120
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E14\u0E34\u0E19",
            [
              72120
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E1E\u0E23\u0E30",
            [
              72120
            ]
          ],
          [
            "\u0E40\u0E14\u0E34\u0E21\u0E1A\u0E32\u0E07",
            [
              72120
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E0A\u0E49\u0E32\u0E07",
            [
              72120
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2A\u0E38\u0E1E\u0E23\u0E23\u0E13\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E01\u0E33\u0E22\u0E32\u0E19",
            [
              72e3
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E15\u0E32\u0E25",
            [
              72e3
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E21\u0E30\u0E2A\u0E31\u0E07\u0E02\u0E4C",
            [
              72e3
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E17\u0E2D\u0E07",
            [
              72e3
            ]
          ],
          [
            "\u0E15\u0E25\u0E34\u0E48\u0E07\u0E0A\u0E31\u0E19",
            [
              72230
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E15\u0E35\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              72e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E1E\u0E35\u0E48\u0E40\u0E25\u0E35\u0E49\u0E22\u0E07",
            [
              72e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E23\u0E30\u0E2B\u0E31\u0E14",
            [
              72e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E38\u0E49\u0E07",
            [
              72210
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              72e3
            ]
          ],
          [
            "\u0E1E\u0E34\u0E2B\u0E32\u0E23\u0E41\u0E14\u0E07",
            [
              72e3
            ]
          ],
          [
            "\u0E23\u0E31\u0E49\u0E27\u0E43\u0E2B\u0E0D\u0E48",
            [
              72e3
            ]
          ],
          [
            "\u0E28\u0E32\u0E25\u0E32\u0E02\u0E32\u0E27",
            [
              72210
            ]
          ],
          [
            "\u0E2A\u0E19\u0E32\u0E21\u0E04\u0E25\u0E35",
            [
              72230
            ]
          ],
          [
            "\u0E2A\u0E19\u0E32\u0E21\u0E0A\u0E31\u0E22",
            [
              72e3
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E41\u0E01\u0E49\u0E27",
            [
              72230
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E41\u0E15\u0E07",
            [
              72210
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E42\u0E04\u0E40\u0E12\u0E48\u0E32",
            [
              72e3
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E1E\u0E23\u0E30\u0E22\u0E32",
            [
              72e3
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E02\u0E27\u0E32\u0E07",
            [
              72e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2A\u0E38\u0E23\u0E32\u0E29\u0E0E\u0E23\u0E4C\u0E18\u0E32\u0E19\u0E35",
    [
      [
        "\u0E01\u0E32\u0E0D\u0E08\u0E19\u0E14\u0E34\u0E29\u0E10\u0E4C",
        [
          [
            "\u0E01\u0E23\u0E39\u0E14",
            [
              84160
            ]
          ],
          [
            "\u0E01\u0E30\u0E41\u0E14\u0E30",
            [
              84160
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E2A\u0E23\u0E30",
            [
              84160
            ]
          ],
          [
            "\u0E0A\u0E49\u0E32\u0E07\u0E02\u0E27\u0E32",
            [
              84160
            ]
          ],
          [
            "\u0E0A\u0E49\u0E32\u0E07\u0E0B\u0E49\u0E32\u0E22",
            [
              84160
            ]
          ],
          [
            "\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19\u0E17\u0E2D\u0E07",
            [
              84160
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E01\u0E07",
            [
              84290
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E23\u0E31\u0E07",
            [
              84290
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E17\u0E2D\u0E07",
            [
              84160
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E17\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48",
            [
              84290
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2D\u0E38\u0E41\u0E17",
            [
              84160
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E23\u0E48\u0E2D\u0E19",
            [
              84160
            ]
          ],
          [
            "\u0E1E\u0E25\u0E32\u0E22\u0E27\u0E32\u0E2A",
            [
              84160
            ]
          ]
        ]
      ],
      [
        "\u0E04\u0E35\u0E23\u0E35\u0E23\u0E31\u0E10\u0E19\u0E34\u0E04\u0E21",
        [
          [
            "\u0E01\u0E30\u0E40\u0E1B\u0E32",
            [
              84180
            ]
          ],
          [
            "\u0E16\u0E49\u0E33\u0E2A\u0E34\u0E07\u0E02\u0E23",
            [
              84180
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E01\u0E23\u0E30\u0E14\u0E32\u0E19",
            [
              84180
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E19\u0E2D\u0E19",
            [
              84180
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E2B\u0E31\u0E01",
            [
              84180
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E17\u0E33\u0E40\u0E19\u0E35\u0E22\u0E1A",
            [
              84180
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E22\u0E32\u0E07",
            [
              84180
            ]
          ],
          [
            "\u0E22\u0E48\u0E32\u0E19\u0E22\u0E32\u0E27",
            [
              84180
            ]
          ]
        ]
      ],
      [
        "\u0E0A\u0E31\u0E22\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E19\u0E49\u0E2D\u0E22",
            [
              84350
            ]
          ],
          [
            "\u0E0A\u0E31\u0E22\u0E1A\u0E38\u0E23\u0E35",
            [
              84350
            ]
          ],
          [
            "\u0E2A\u0E2D\u0E07\u0E41\u0E1E\u0E23\u0E01",
            [
              84350
            ]
          ],
          [
            "\u0E44\u0E17\u0E23\u0E17\u0E2D\u0E07",
            [
              84350
            ]
          ]
        ]
      ],
      [
        "\u0E14\u0E2D\u0E19\u0E2A\u0E31\u0E01",
        [
          [
            "\u0E0A\u0E25\u0E04\u0E23\u0E32\u0E21",
            [
              84160
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E2A\u0E31\u0E01",
            [
              84220
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E41\u0E1E\u0E23\u0E01",
            [
              84340
            ]
          ],
          [
            "\u0E44\u0E0A\u0E22\u0E04\u0E23\u0E32\u0E21",
            [
              84220
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E48\u0E32\u0E09\u0E32\u0E07",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E44\u0E17\u0E23",
            [
              84150
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E09\u0E32\u0E07",
            [
              84150
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E04\u0E22",
            [
              84150
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E09\u0E25\u0E38\u0E22",
            [
              84150
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E16\u0E48\u0E32\u0E19",
            [
              84150
            ]
          ],
          [
            "\u0E40\u0E2A\u0E27\u0E35\u0E22\u0E14",
            [
              84150
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E48\u0E32\u0E0A\u0E19\u0E30",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E1E\u0E32",
            [
              84170
            ]
          ],
          [
            "\u0E04\u0E31\u0E19\u0E18\u0E38\u0E25\u0E35",
            [
              84170
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E0A\u0E19\u0E30",
            [
              84170
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C",
            [
              84170
            ]
          ],
          [
            "\u0E27\u0E31\u0E07",
            [
              84170
            ]
          ],
          [
            "\u0E2A\u0E21\u0E2D\u0E17\u0E2D\u0E07",
            [
              84170
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E15\u0E32\u0E02\u0E38\u0E19",
        [
          [
            "\u0E1E\u0E23\u0E38\u0E44\u0E17\u0E22",
            [
              84230
            ]
          ],
          [
            "\u0E1E\u0E30\u0E41\u0E2A\u0E07",
            [
              84230
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E1E\u0E31\u0E07",
            [
              84230
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E27\u0E07",
            [
              84230
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E32\u0E2A\u0E32\u0E23",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E1B\u0E23\u0E32\u0E1A",
            [
              84120
            ]
          ],
          [
            "\u0E04\u0E27\u0E19\u0E28\u0E23\u0E35",
            [
              84270
            ]
          ],
          [
            "\u0E04\u0E27\u0E19\u0E2A\u0E38\u0E1A\u0E23\u0E23\u0E13",
            [
              84120
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E40\u0E15\u0E32",
            [
              84120
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E40\u0E15\u0E32\u0E43\u0E2B\u0E21\u0E48",
            [
              84120
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E0A\u0E35",
            [
              84120
            ]
          ],
          [
            "\u0E19\u0E32\u0E2A\u0E32\u0E23",
            [
              84120
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E1E\u0E38",
            [
              84120
            ]
          ],
          [
            "\u0E1E\u0E23\u0E38\u0E1E\u0E35",
            [
              84270
            ]
          ],
          [
            "\u0E25\u0E33\u0E1E\u0E39\u0E19",
            [
              84120
            ]
          ],
          [
            "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1E\u0E39\u0E19\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C",
            [
              84120
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E32\u0E40\u0E14\u0E34\u0E21",
        [
          [
            "\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C\u0E17\u0E27\u0E35",
            [
              84240
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E23\u0E37\u0E2D",
            [
              84240
            ]
          ],
          [
            "\u0E19\u0E32\u0E43\u0E15\u0E49",
            [
              84240
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E32",
            [
              84240
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E19\u0E21",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E0A\u0E30\u0E2D\u0E38\u0E48\u0E19",
            [
              84250
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E28\u0E01",
            [
              84250
            ]
          ],
          [
            "\u0E15\u0E49\u0E19\u0E22\u0E27\u0E19",
            [
              84250
            ]
          ],
          [
            "\u0E1E\u0E19\u0E21",
            [
              84250
            ]
          ],
          [
            "\u0E1E\u0E25\u0E39\u0E40\u0E16\u0E37\u0E48\u0E2D\u0E19",
            [
              84250
            ]
          ],
          [
            "\u0E1E\u0E31\u0E07\u0E01\u0E32\u0E0D\u0E08\u0E19\u0E4C",
            [
              84250
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E23\u0E30\u0E41\u0E2A\u0E07",
        [
          [
            "\u0E1A\u0E32\u0E07\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
            [
              84210
            ]
          ],
          [
            "\u0E2A\u0E32\u0E04\u0E39",
            [
              84210
            ]
          ],
          [
            "\u0E2A\u0E34\u0E19\u0E1B\u0E38\u0E19",
            [
              84210
            ]
          ],
          [
            "\u0E2A\u0E34\u0E19\u0E40\u0E08\u0E23\u0E34\u0E0D",
            [
              84210
            ]
          ],
          [
            "\u0E2D\u0E34\u0E1B\u0E31\u0E19",
            [
              84210
            ]
          ],
          [
            "\u0E44\u0E17\u0E23\u0E02\u0E36\u0E07",
            [
              84210
            ]
          ],
          [
            "\u0E44\u0E17\u0E23\u0E42\u0E2A\u0E20\u0E32",
            [
              84210
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E38\u0E19\u0E1E\u0E34\u0E19",
        [
          [
            "\u0E01\u0E23\u0E39\u0E14",
            [
              84130
            ]
          ],
          [
            "\u0E15\u0E30\u0E1B\u0E32\u0E19",
            [
              84130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E49\u0E32\u0E21",
            [
              84130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2A\u0E30\u0E17\u0E49\u0E2D\u0E19",
            [
              84130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E42\u0E23\u0E07\u0E0A\u0E49\u0E32\u0E07",
            [
              84130
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E23\u0E2D\u0E1A",
            [
              84130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E07\u0E2D\u0E19",
            [
              84130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E21\u0E30\u0E40\u0E14\u0E37\u0E48\u0E2D",
            [
              84130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E14\u0E37\u0E2D\u0E19",
            [
              84130
            ]
          ],
          [
            "\u0E1E\u0E38\u0E19\u0E1E\u0E34\u0E19",
            [
              84130
            ]
          ],
          [
            "\u0E21\u0E30\u0E25\u0E27\u0E19",
            [
              84130
            ]
          ],
          [
            "\u0E25\u0E35\u0E40\u0E25\u0E47\u0E14",
            [
              84130
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E27\u0E34\u0E0A\u0E31\u0E22",
            [
              84130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E17\u0E23",
            [
              84130
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E40\u0E15\u0E22",
            [
              84130
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E2B\u0E31\u0E27\u0E04\u0E27\u0E32\u0E22",
            [
              84130
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E34\u0E20\u0E32\u0E27\u0E14\u0E35",
        [
          [
            "\u0E15\u0E30\u0E01\u0E38\u0E01\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              84180
            ]
          ],
          [
            "\u0E15\u0E30\u0E01\u0E38\u0E01\u0E43\u0E15\u0E49",
            [
              84180
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E01\u0E32\u0E30\u0E1E\u0E30\u0E07\u0E31\u0E19",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E15\u0E49",
            [
              84280
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E1E\u0E30\u0E07\u0E31\u0E19",
            [
              84280
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E40\u0E15\u0E48\u0E32",
            [
              84360
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E01\u0E32\u0E30\u0E2A\u0E21\u0E38\u0E22",
        [
          [
            "\u0E15\u0E25\u0E34\u0E48\u0E07\u0E07\u0E32\u0E21",
            [
              84140
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E1C\u0E38\u0E14",
            [
              84320
            ]
          ],
          [
            "\u0E21\u0E30\u0E40\u0E23\u0E47\u0E15",
            [
              84310
            ]
          ],
          [
            "\u0E25\u0E34\u0E1B\u0E30\u0E19\u0E49\u0E2D\u0E22",
            [
              84140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              84140
            ]
          ],
          [
            "\u0E2D\u0E48\u0E32\u0E07\u0E17\u0E2D\u0E07",
            [
              84140
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E19\u0E49\u0E33",
            [
              84330
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E04\u0E35\u0E22\u0E19\u0E0B\u0E32",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E2A\u0E14\u0E47\u0E08",
            [
              84260
            ]
          ],
          [
            "\u0E1E\u0E48\u0E27\u0E07\u0E1E\u0E23\u0E21\u0E04\u0E23",
            [
              84210
            ]
          ],
          [
            "\u0E2D\u0E23\u0E31\u0E0D\u0E04\u0E32\u0E21\u0E27\u0E32\u0E23\u0E35",
            [
              84260
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E15\u0E2D\u0E01",
            [
              84260
            ]
          ],
          [
            "\u0E40\u0E04\u0E35\u0E22\u0E19\u0E0B\u0E32",
            [
              84260
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2A\u0E38\u0E23\u0E32\u0E29\u0E0E\u0E23\u0E4C\u0E18\u0E32\u0E19\u0E35",
        [
          [
            "\u0E02\u0E38\u0E19\u0E17\u0E30\u0E40\u0E25",
            [
              84100
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E09\u0E19\u0E32\u0E01",
            [
              84e3
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E19\u0E49\u0E2D\u0E22",
            [
              84e3
            ]
          ],
          [
            "\u0E15\u0E25\u0E32\u0E14",
            [
              84e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E01\u0E38\u0E49\u0E07",
            [
              84e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E0A\u0E19\u0E30",
            [
              84e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              84e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E43\u0E1A\u0E44\u0E21\u0E49",
            [
              84e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E44\u0E17\u0E23",
            [
              84e3
            ]
          ],
          [
            "\u0E21\u0E30\u0E02\u0E32\u0E21\u0E40\u0E15\u0E35\u0E49\u0E22",
            [
              84e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E1B\u0E23\u0E30\u0E14\u0E39\u0E48",
            [
              84e3
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E2A\u0E23\u0E30",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E09\u0E19\u0E27\u0E19",
            [
              84190
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              84190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2A\u0E49\u0E2D\u0E07",
            [
              84190
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E19\u0E34\u0E1E\u0E31\u0E19\u0E18\u0E4C",
            [
              84190
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E2A\u0E23\u0E30",
            [
              84190
            ]
          ]
        ]
      ],
      [
        "\u0E44\u0E0A\u0E22\u0E32",
        [
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E44\u0E0A\u0E22\u0E32",
            [
              84110
            ]
          ],
          [
            "\u0E15\u0E30\u0E01\u0E23\u0E1A",
            [
              84110
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07",
            [
              84110
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E2B\u0E21\u0E32\u0E01",
            [
              84110
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E40\u0E27",
            [
              84110
            ]
          ],
          [
            "\u0E1E\u0E38\u0E21\u0E40\u0E23\u0E35\u0E22\u0E07",
            [
              84110
            ]
          ],
          [
            "\u0E40\u0E25\u0E21\u0E47\u0E14",
            [
              84110
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              84110
            ]
          ],
          [
            "\u0E42\u0E21\u0E16\u0E48\u0E32\u0E22",
            [
              84110
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2A\u0E38\u0E23\u0E34\u0E19\u0E17\u0E23\u0E4C",
    [
      [
        "\u0E01\u0E32\u0E1A\u0E40\u0E0A\u0E34\u0E07",
        [
          [
            "\u0E01\u0E32\u0E1A\u0E40\u0E0A\u0E34\u0E07",
            [
              32210
            ]
          ],
          [
            "\u0E04\u0E39\u0E15\u0E31\u0E19",
            [
              32210
            ]
          ],
          [
            "\u0E14\u0E48\u0E32\u0E19",
            [
              32210
            ]
          ],
          [
            "\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              32210
            ]
          ],
          [
            "\u0E41\u0E19\u0E07\u0E21\u0E38\u0E14",
            [
              32210
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E15\u0E30\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              32210
            ]
          ]
        ]
      ],
      [
        "\u0E08\u0E2D\u0E21\u0E1E\u0E23\u0E30",
        [
          [
            "\u0E01\u0E23\u0E30\u0E2B\u0E32\u0E14",
            [
              32180
            ]
          ],
          [
            "\u0E08\u0E2D\u0E21\u0E1E\u0E23\u0E30",
            [
              32180
            ]
          ],
          [
            "\u0E0A\u0E38\u0E21\u0E41\u0E2A\u0E07",
            [
              32180
            ]
          ],
          [
            "\u0E1A\u0E38\u0E41\u0E01\u0E23\u0E07",
            [
              32180
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1C\u0E37\u0E2D",
            [
              32180
            ]
          ],
          [
            "\u0E25\u0E38\u0E48\u0E21\u0E23\u0E30\u0E27\u0E35",
            [
              32180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E19\u0E34\u0E17",
            [
              32180
            ]
          ],
          [
            "\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E38\u0E02",
            [
              32180
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E25\u0E35\u0E07",
            [
              32180
            ]
          ]
        ]
      ],
      [
        "\u0E0A\u0E38\u0E21\u0E1E\u0E25\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E01\u0E23\u0E30\u0E40\u0E1A\u0E37\u0E49\u0E2D\u0E07",
            [
              32190
            ]
          ],
          [
            "\u0E0A\u0E38\u0E21\u0E1E\u0E25\u0E1A\u0E38\u0E23\u0E35",
            [
              32190
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E1C\u0E48",
            [
              32190
            ]
          ],
          [
            "\u0E22\u0E30\u0E27\u0E36\u0E01",
            [
              32190
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E13\u0E23\u0E07\u0E04\u0E4C",
            [
              32190
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E02\u0E38\u0E14",
            [
              32190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E23\u0E37\u0E2D",
            [
              32190
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              32190
            ]
          ],
          [
            "\u0E44\u0E1E\u0E23\u0E02\u0E25\u0E32",
            [
              32190
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E48\u0E32\u0E15\u0E39\u0E21",
        [
          [
            "\u0E01\u0E23\u0E30\u0E42\u0E1E",
            [
              32120
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E01\u0E38\u0E25\u0E32",
            [
              32120
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E15\u0E39\u0E21",
            [
              32120
            ]
          ],
          [
            "\u0E1A\u0E30",
            [
              32120
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E42\u0E04\u0E01",
            [
              32120
            ]
          ],
          [
            "\u0E1E\u0E23\u0E21\u0E40\u0E17\u0E1E",
            [
              32120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              32120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E21\u0E18\u0E35",
            [
              32120
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E41\u0E01",
            [
              32120
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E04\u0E23\u0E01",
            [
              32120
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E31\u0E27\u0E40\u0E0A\u0E14",
        [
          [
            "\u0E08\u0E23\u0E31\u0E2A",
            [
              32230
            ]
          ],
          [
            "\u0E15\u0E32\u0E27\u0E31\u0E07",
            [
              32230
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E40\u0E0A\u0E14",
            [
              32230
            ]
          ],
          [
            "\u0E2A\u0E30\u0E40\u0E14\u0E32",
            [
              32230
            ]
          ],
          [
            "\u0E2A\u0E33\u0E40\u0E20\u0E32\u0E25\u0E39\u0E19",
            [
              32230
            ]
          ],
          [
            "\u0E2D\u0E32\u0E42\u0E1E\u0E19",
            [
              32230
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E23\u0E32\u0E2A\u0E32\u0E17",
        [
          [
            "\u0E01\u0E31\u0E07\u0E41\u0E2D\u0E19",
            [
              32140
            ]
          ],
          [
            "\u0E01\u0E31\u0E19\u0E15\u0E27\u0E08\u0E23\u0E30\u0E21\u0E27\u0E25",
            [
              32140
            ]
          ],
          [
            "\u0E15\u0E32\u0E19\u0E35",
            [
              32140
            ]
          ],
          [
            "\u0E15\u0E32\u0E40\u0E1A\u0E32",
            [
              32140
            ]
          ],
          [
            "\u0E17\u0E21\u0E2D",
            [
              32140
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E21\u0E19",
            [
              32140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1E\u0E25\u0E27\u0E07",
            [
              32140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E44\u0E17\u0E23",
            [
              32140
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E17\u0E31\u0E14\u0E1A\u0E38",
            [
              32140
            ]
          ],
          [
            "\u0E1B\u0E23\u0E32\u0E2A\u0E32\u0E17\u0E17\u0E19\u0E07",
            [
              32140
            ]
          ],
          [
            "\u0E1B\u0E23\u0E37\u0E2D",
            [
              32140
            ]
          ],
          [
            "\u0E2A\u0E21\u0E38\u0E14",
            [
              32140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              32140
            ]
          ],
          [
            "\u0E40\u0E0A\u0E37\u0E49\u0E2D\u0E40\u0E1E\u0E25\u0E34\u0E07",
            [
              32140
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E22\u0E32\u0E07",
            [
              32140
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              32140
            ]
          ],
          [
            "\u0E42\u0E0A\u0E04\u0E19\u0E32\u0E2A\u0E32\u0E21",
            [
              32140
            ]
          ],
          [
            "\u0E44\u0E1E\u0E25",
            [
              32140
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E19\u0E21\u0E14\u0E07\u0E23\u0E31\u0E01",
        [
          [
            "\u0E08\u0E35\u0E01\u0E41\u0E14\u0E01",
            [
              32140
            ]
          ],
          [
            "\u0E15\u0E32\u0E40\u0E21\u0E35\u0E22\u0E07",
            [
              32140
            ]
          ],
          [
            "\u0E1A\u0E31\u0E01\u0E44\u0E14",
            [
              32140
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E01\u0E25\u0E32\u0E07",
            [
              32140
            ]
          ]
        ]
      ],
      [
        "\u0E23\u0E31\u0E15\u0E19\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E01\u0E38\u0E14\u0E02\u0E32\u0E04\u0E35\u0E21",
            [
              32130
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E41\u0E23\u0E14",
            [
              32130
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E43\u0E2B\u0E0D\u0E48",
            [
              32130
            ]
          ],
          [
            "\u0E18\u0E32\u0E15\u0E38",
            [
              32130
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E40\u0E02\u0E35\u0E22\u0E27",
            [
              32130
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              32130
            ]
          ],
          [
            "\u0E23\u0E31\u0E15\u0E19\u0E1A\u0E38\u0E23\u0E35",
            [
              32130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E17\u0E2D\u0E07",
            [
              32130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E1A\u0E32\u0E19",
            [
              32130
            ]
          ],
          [
            "\u0E40\u0E1A\u0E34\u0E14",
            [
              32130
            ]
          ],
          [
            "\u0E41\u0E01",
            [
              32130
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48",
            [
              32130
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E33\u0E14\u0E27\u0E19",
        [
          [
            "\u0E15\u0E23\u0E30\u0E40\u0E1B\u0E35\u0E22\u0E07\u0E40\u0E15\u0E35\u0E22",
            [
              32220
            ]
          ],
          [
            "\u0E15\u0E23\u0E33\u0E14\u0E21",
            [
              32220
            ]
          ],
          [
            "\u0E25\u0E33\u0E14\u0E27\u0E19",
            [
              32220
            ]
          ],
          [
            "\u0E2D\u0E39\u0E48\u0E42\u0E25\u0E01",
            [
              32220
            ]
          ],
          [
            "\u0E42\u0E0A\u0E04\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              32220
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E13\u0E23\u0E07\u0E04\u0E4C",
        [
          [
            "\u0E13\u0E23\u0E07\u0E04\u0E4C",
            [
              32150
            ]
          ],
          [
            "\u0E15\u0E23\u0E27\u0E08",
            [
              32150
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E38\u0E02",
            [
              32150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07",
            [
              32150
            ]
          ],
          [
            "\u0E41\u0E08\u0E19\u0E41\u0E27\u0E19",
            [
              32150
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E35\u0E02\u0E23\u0E20\u0E39\u0E21\u0E34",
        [
          [
            "\u0E01\u0E38\u0E14\u0E2B\u0E27\u0E32\u0E22",
            [
              32110
            ]
          ],
          [
            "\u0E02\u0E27\u0E32\u0E27\u0E43\u0E2B\u0E0D\u0E48",
            [
              32110
            ]
          ],
          [
            "\u0E04\u0E32\u0E25\u0E30\u0E41\u0E21\u0E30",
            [
              32110
            ]
          ],
          [
            "\u0E08\u0E32\u0E23\u0E1E\u0E31\u0E15",
            [
              32110
            ]
          ],
          [
            "\u0E0A\u0E48\u0E32\u0E07\u0E1B\u0E35\u0E48",
            [
              32110
            ]
          ],
          [
            "\u0E15\u0E23\u0E21\u0E44\u0E1E\u0E23",
            [
              32110
            ]
          ],
          [
            "\u0E15\u0E23\u0E36\u0E21",
            [
              32110
            ]
          ],
          [
            "\u0E19\u0E32\u0E23\u0E38\u0E48\u0E07",
            [
              32110
            ]
          ],
          [
            "\u0E1C\u0E31\u0E01\u0E44\u0E2B\u0E21",
            [
              32110
            ]
          ],
          [
            "\u0E22\u0E32\u0E07",
            [
              32110
            ]
          ],
          [
            "\u0E23\u0E30\u0E41\u0E07\u0E07",
            [
              32110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E27\u0E32\u0E27",
            [
              32110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              32110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              32110
            ]
          ],
          [
            "\u0E41\u0E15\u0E25",
            [
              32110
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E19\u0E21",
        [
          [
            "\u0E19\u0E32\u0E19\u0E27\u0E19",
            [
              32160
            ]
          ],
          [
            "\u0E2A\u0E19\u0E21",
            [
              32160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E23\u0E30\u0E06\u0E31\u0E07",
            [
              32160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2D\u0E35\u0E22\u0E2D",
            [
              32160
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E07\u0E31\u0E27",
            [
              32160
            ]
          ],
          [
            "\u0E41\u0E04\u0E19",
            [
              32160
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E42\u0E01",
            [
              32160
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E31\u0E07\u0E02\u0E30",
        [
          [
            "\u0E01\u0E23\u0E30\u0E40\u0E17\u0E35\u0E22\u0E21",
            [
              32150
            ]
          ],
          [
            "\u0E02\u0E2D\u0E19\u0E41\u0E15\u0E01",
            [
              32150
            ]
          ],
          [
            "\u0E14\u0E21",
            [
              32150
            ]
          ],
          [
            "\u0E15\u0E32\u0E04\u0E07",
            [
              32150
            ]
          ],
          [
            "\u0E15\u0E32\u0E15\u0E38\u0E21",
            [
              32150
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E17\u0E31\u0E19",
            [
              32150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E08\u0E32\u0E23\u0E22\u0E4C",
            [
              32150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E0A\u0E1A",
            [
              32150
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E41\u0E01\u0E49\u0E27",
            [
              32150
            ]
          ],
          [
            "\u0E2A\u0E30\u0E01\u0E32\u0E14",
            [
              32150
            ]
          ],
          [
            "\u0E2A\u0E31\u0E07\u0E02\u0E30",
            [
              32150
            ]
          ],
          [
            "\u0E40\u0E17\u0E1E\u0E23\u0E31\u0E01\u0E29\u0E32",
            [
              32150
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E33\u0E42\u0E23\u0E07\u0E17\u0E32\u0E1A",
        [
          [
            "\u0E01\u0E23\u0E30\u0E2D\u0E2D\u0E21",
            [
              32170
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E14\u0E39\u0E48",
            [
              32170
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E38\u0E02",
            [
              32170
            ]
          ],
          [
            "\u0E2A\u0E30\u0E42\u0E19",
            [
              32170
            ]
          ],
          [
            "\u0E2A\u0E33\u0E42\u0E23\u0E07\u0E17\u0E32\u0E1A",
            [
              32170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2E\u0E30",
            [
              32170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E1C\u0E48\u0E25\u0E49\u0E2D\u0E21",
            [
              32170
            ]
          ],
          [
            "\u0E2B\u0E21\u0E37\u0E48\u0E19\u0E28\u0E23\u0E35",
            [
              32170
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E41\u0E01\u0E49\u0E27",
            [
              32170
            ]
          ],
          [
            "\u0E40\u0E2A\u0E21\u0E47\u0E08",
            [
              32170
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E02\u0E27\u0E32\u0E2A\u0E34\u0E19\u0E23\u0E34\u0E19\u0E17\u0E23\u0E4C",
        [
          [
            "\u0E15\u0E32\u0E01\u0E39\u0E01",
            [
              32e3
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07",
            [
              32e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E23\u0E48",
            [
              32e3
            ]
          ],
          [
            "\u0E1B\u0E23\u0E32\u0E2A\u0E32\u0E17\u0E17\u0E2D\u0E07",
            [
              32e3
            ]
          ],
          [
            "\u0E40\u0E02\u0E27\u0E32\u0E2A\u0E34\u0E19\u0E23\u0E34\u0E19\u0E17\u0E23\u0E4C",
            [
              32e3
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2A\u0E38\u0E23\u0E34\u0E19\u0E17\u0E23\u0E4C",
        [
          [
            "\u0E01\u0E32\u0E40\u0E01\u0E32\u0E30",
            [
              32e3
            ]
          ],
          [
            "\u0E04\u0E2D\u0E42\u0E04",
            [
              32e3
            ]
          ],
          [
            "\u0E15\u0E23\u0E30\u0E41\u0E2A\u0E07",
            [
              32e3
            ]
          ],
          [
            "\u0E15\u0E31\u0E49\u0E07\u0E43\u0E08",
            [
              32e3
            ]
          ],
          [
            "\u0E15\u0E32\u0E2D\u0E47\u0E2D\u0E07",
            [
              32e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              32e3
            ]
          ],
          [
            "\u0E19\u0E2D\u0E01\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              32e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E14\u0E35",
            [
              32e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E1A\u0E31\u0E27",
            [
              32e3
            ]
          ],
          [
            "\u0E1A\u0E38\u0E24\u0E32\u0E29\u0E35",
            [
              32e3
            ]
          ],
          [
            "\u0E23\u0E32\u0E21",
            [
              32e3
            ]
          ],
          [
            "\u0E2A\u0E25\u0E31\u0E01\u0E44\u0E14",
            [
              32e3
            ]
          ],
          [
            "\u0E2A\u0E27\u0E32\u0E22",
            [
              32e3
            ]
          ],
          [
            "\u0E2A\u0E33\u0E42\u0E23\u0E07",
            [
              32e3
            ]
          ],
          [
            "\u0E40\u0E09\u0E19\u0E35\u0E22\u0E07",
            [
              32e3
            ]
          ],
          [
            "\u0E40\u0E17\u0E19\u0E21\u0E35\u0E22\u0E4C",
            [
              32e3
            ]
          ],
          [
            "\u0E40\u0E1E\u0E35\u0E49\u0E22\u0E23\u0E32\u0E21",
            [
              32e3
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E17\u0E35",
            [
              32e3
            ]
          ],
          [
            "\u0E41\u0E01\u0E43\u0E2B\u0E0D\u0E48",
            [
              32e3
            ]
          ],
          [
            "\u0E41\u0E2A\u0E25\u0E07\u0E1E\u0E31\u0E19\u0E18\u0E4C",
            [
              32e3
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              32e3
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E19\u0E19\u0E19\u0E32\u0E23\u0E32\u0E22\u0E13\u0E4C",
        [
          [
            "\u0E04\u0E33\u0E1C\u0E07",
            [
              32130
            ]
          ],
          [
            "\u0E23\u0E30\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              32130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              32130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E17\u0E1E",
            [
              32130
            ]
          ],
          [
            "\u0E42\u0E19\u0E19",
            [
              32130
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2A\u0E38\u0E42\u0E02\u0E17\u0E31\u0E22",
    [
      [
        "\u0E01\u0E07\u0E44\u0E01\u0E23\u0E25\u0E32\u0E28",
        [
          [
            "\u0E01\u0E01\u0E41\u0E23\u0E15",
            [
              64170
            ]
          ],
          [
            "\u0E01\u0E07",
            [
              64170
            ]
          ],
          [
            "\u0E14\u0E07\u0E40\u0E14\u0E37\u0E2D\u0E22",
            [
              64170
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E09\u0E19\u0E27\u0E19",
            [
              64170
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E23\u0E48\u0E32\u0E07",
            [
              64170
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48\u0E2A\u0E38\u0E02\u0E40\u0E01\u0E29\u0E21",
            [
              64170
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E41\u0E1D\u0E01",
            [
              64170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E15\u0E39\u0E21",
            [
              64170
            ]
          ],
          [
            "\u0E44\u0E01\u0E23\u0E01\u0E25\u0E32\u0E07",
            [
              64170
            ]
          ],
          [
            "\u0E44\u0E01\u0E23\u0E19\u0E2D\u0E01",
            [
              64170
            ]
          ],
          [
            "\u0E44\u0E01\u0E23\u0E43\u0E19",
            [
              64170
            ]
          ]
        ]
      ],
      [
        "\u0E04\u0E35\u0E23\u0E35\u0E21\u0E32\u0E28",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E22\u0E32\u0E07\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              64160
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              64160
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E0A\u0E34\u0E07\u0E04\u0E35\u0E23\u0E35",
            [
              64160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E49\u0E33\u0E1E\u0E38",
            [
              64160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1B\u0E49\u0E2D\u0E21",
            [
              64160
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E04\u0E35\u0E23\u0E35\u0E21\u0E32\u0E28",
            [
              64160
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E1E\u0E27\u0E07",
            [
              64160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E14\u0E34\u0E48\u0E07",
            [
              64160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E08\u0E34\u0E01",
            [
              64160
            ]
          ],
          [
            "\u0E42\u0E15\u0E19\u0E14",
            [
              64160
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E38\u0E48\u0E07\u0E40\u0E2A\u0E25\u0E35\u0E48\u0E22\u0E21",
        [
          [
            "\u0E01\u0E25\u0E32\u0E07\u0E14\u0E07",
            [
              64150
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E40\u0E2A\u0E25\u0E35\u0E48\u0E22\u0E21",
            [
              64150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48\u0E44\u0E0A\u0E22\u0E21\u0E07\u0E04\u0E25",
            [
              64230
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E41\u0E01\u0E49\u0E27\u0E28\u0E23\u0E35\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              64230
            ]
          ],
          [
            "\u0E44\u0E17\u0E22\u0E0A\u0E19\u0E30\u0E28\u0E36\u0E01",
            [
              64150
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E14\u0E48\u0E32\u0E19\u0E25\u0E32\u0E19\u0E2B\u0E2D\u0E22",
        [
          [
            "\u0E15\u0E25\u0E34\u0E48\u0E07\u0E0A\u0E31\u0E19",
            [
              64140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E14\u0E48\u0E32\u0E19",
            [
              64140
            ]
          ],
          [
            "\u0E25\u0E32\u0E19\u0E2B\u0E2D\u0E22",
            [
              64140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E15\u0E30\u0E04\u0E23\u0E49\u0E2D",
            [
              64140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E19\u0E49\u0E33\u0E02\u0E32\u0E27",
            [
              64140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E25\u0E36\u0E01",
            [
              64140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E0D\u0E49\u0E32\u0E1B\u0E25\u0E49\u0E2D\u0E07",
            [
              64140
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E19\u0E04\u0E23",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E21\u0E30\u0E1E\u0E25\u0E31\u0E1A",
            [
              64180
            ]
          ],
          [
            "\u0E19\u0E04\u0E23\u0E40\u0E14\u0E34\u0E10",
            [
              64180
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E02\u0E38\u0E21",
            [
              64180
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E19\u0E04\u0E23",
            [
              64180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              64180
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E2A\u0E31\u0E0A\u0E19\u0E32\u0E25\u0E31\u0E22",
        [
          [
            "\u0E14\u0E07\u0E04\u0E39\u0E48",
            [
              64130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E0A\u0E31\u0E22",
            [
              64190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E15\u0E36\u0E01",
            [
              64130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E01\u0E48\u0E07",
            [
              64130
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E07\u0E34\u0E49\u0E27",
            [
              64130
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E31\u0E0A\u0E19\u0E32\u0E25\u0E31\u0E22",
            [
              64190
            ]
          ],
          [
            "\u0E2A\u0E32\u0E23\u0E08\u0E34\u0E15\u0E23",
            [
              64130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2D\u0E49\u0E2D",
            [
              64130
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E40\u0E2A\u0E35\u0E49\u0E22\u0E27",
            [
              64130
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E33",
            [
              64130
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E34\u0E19",
            [
              64130
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E2A\u0E33\u0E42\u0E23\u0E07",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E15\u0E32\u0E25",
            [
              64120
            ]
          ],
          [
            "\u0E17\u0E31\u0E1A\u0E1C\u0E36\u0E49\u0E07",
            [
              64120
            ]
          ],
          [
            "\u0E19\u0E32\u0E02\u0E38\u0E19\u0E44\u0E01\u0E23",
            [
              64120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E0B\u0E48\u0E32\u0E19",
            [
              64120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E19\u0E32",
            [
              64120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E44\u0E23\u0E48",
            [
              64120
            ]
          ],
          [
            "\u0E23\u0E32\u0E27\u0E15\u0E49\u0E19\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
            [
              64120
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E17\u0E2D\u0E07",
            [
              64120
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E25\u0E36\u0E01",
            [
              64120
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              64120
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E40\u0E01\u0E32\u0E30",
            [
              64120
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E40\u0E23\u0E37\u0E2D\u0E19",
            [
              64120
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E15\u0E32\u0E40\u0E25\u0E35\u0E49\u0E22\u0E07",
            [
              64120
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E42\u0E25\u0E01",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E08\u0E07",
            [
              64110
            ]
          ],
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E22\u0E32\u0E07",
            [
              64110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E17\u0E2D\u0E07",
            [
              64110
            ]
          ],
          [
            "\u0E19\u0E32\u0E17\u0E38\u0E48\u0E07",
            [
              64110
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E19\u0E49\u0E33",
            [
              64110
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E01\u0E38\u0E21\u0E40\u0E01\u0E32\u0E30",
            [
              64110
            ]
          ],
          [
            "\u0E22\u0E48\u0E32\u0E19\u0E22\u0E32\u0E27",
            [
              64110
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E1E\u0E34\u0E13\u0E1E\u0E32\u0E17\u0E22\u0E4C",
            [
              64110
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E44\u0E21\u0E49\u0E02\u0E2D\u0E19",
            [
              64110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E25\u0E31\u0E1A",
            [
              64110
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1A\u0E32\u0E07\u0E02\u0E25\u0E31\u0E07",
            [
              64110
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1A\u0E32\u0E07\u0E22\u0E21",
            [
              64110
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E42\u0E25\u0E01",
            [
              64110
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              64110
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2A\u0E38\u0E42\u0E02\u0E17\u0E31\u0E22",
        [
          [
            "\u0E15\u0E32\u0E25\u0E40\u0E15\u0E35\u0E49\u0E22",
            [
              64220
            ]
          ],
          [
            "\u0E18\u0E32\u0E19\u0E35",
            [
              64e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E25\u0E49\u0E27\u0E22",
            [
              64e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2A\u0E27\u0E19",
            [
              64220
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E25\u0E38\u0E21",
            [
              64e3
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E1E\u0E23\u0E30",
            [
              64e3
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E41\u0E04\u0E27",
            [
              64e3
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E0B\u0E49\u0E32\u0E22",
            [
              64e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E17\u0E2D\u0E07\u0E41\u0E14\u0E07",
            [
              64210
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E01\u0E48\u0E32",
            [
              64210
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2B\u0E19\u0E2D\u0E07\u0E04\u0E32\u0E22",
    [
      [
        "\u0E17\u0E48\u0E32\u0E1A\u0E48\u0E2D",
        [
          [
            "\u0E01\u0E2D\u0E07\u0E19\u0E32\u0E07",
            [
              43110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E1A\u0E48\u0E2D",
            [
              43110
            ]
          ],
          [
            "\u0E19\u0E32\u0E02\u0E48\u0E32",
            [
              43110
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E42\u0E21\u0E07",
            [
              43110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E16\u0E48\u0E2D\u0E19",
            [
              43110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E27\u0E48\u0E32\u0E19",
            [
              43110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E14\u0E37\u0E48\u0E2D",
            [
              43110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E19\u0E32\u0E07",
            [
              43110
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E04\u0E2D\u0E19",
            [
              43110
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E2A\u0E32",
            [
              43110
            ]
          ]
        ]
      ],
      [
        "\u0E23\u0E31\u0E15\u0E19\u0E27\u0E32\u0E1B\u0E35",
        [
          [
            "\u0E19\u0E32\u0E17\u0E31\u0E1A\u0E44\u0E2E",
            [
              43120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E15\u0E49\u0E2D\u0E19",
            [
              43120
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E1A\u0E32\u0E17\u0E19\u0E32\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
            [
              43120
            ]
          ],
          [
            "\u0E23\u0E31\u0E15\u0E19\u0E27\u0E32\u0E1B\u0E35",
            [
              43120
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E41\u0E1E\u0E07",
            [
              43120
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E43\u0E2B\u0E21\u0E48",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E21\u0E49\u0E2D",
            [
              43130
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E1E\u0E38\u0E17\u0E18\u0E1A\u0E32\u0E17",
            [
              43130
            ]
          ],
          [
            "\u0E1E\u0E32\u0E19\u0E1E\u0E23\u0E49\u0E32\u0E27",
            [
              43130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E25\u0E32\u0E1B\u0E32\u0E01",
            [
              43130
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E23\u0E30\u0E43\u0E04\u0E23",
        [
          [
            "\u0E04\u0E2D\u0E01\u0E0A\u0E49\u0E32\u0E07",
            [
              43100
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1D\u0E32\u0E07",
            [
              43100
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E43\u0E04\u0E23",
            [
              43100
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E31\u0E07\u0E04\u0E21",
        [
          [
            "\u0E19\u0E32\u0E07\u0E34\u0E49\u0E27",
            [
              43160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E21\u0E48\u0E27\u0E07",
            [
              43160
            ]
          ],
          [
            "\u0E1C\u0E32\u0E15\u0E31\u0E49\u0E07",
            [
              43160
            ]
          ],
          [
            "\u0E2A\u0E31\u0E07\u0E04\u0E21",
            [
              43160
            ]
          ],
          [
            "\u0E41\u0E01\u0E49\u0E07\u0E44\u0E01\u0E48",
            [
              43160
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E1D\u0E49\u0E32\u0E44\u0E23\u0E48",
        [
          [
            "\u0E19\u0E32\u0E14\u0E35",
            [
              43120
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              43120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              43120
            ]
          ],
          [
            "\u0E2D\u0E38\u0E14\u0E21\u0E1E\u0E23",
            [
              43120
            ]
          ],
          [
            "\u0E40\u0E1D\u0E49\u0E32\u0E44\u0E23\u0E48",
            [
              43120
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2B\u0E19\u0E2D\u0E07\u0E04\u0E32\u0E22",
        [
          [
            "\u0E01\u0E27\u0E19\u0E27\u0E31\u0E19",
            [
              43e3
            ]
          ],
          [
            "\u0E04\u0E48\u0E32\u0E22\u0E1A\u0E01\u0E2B\u0E27\u0E32\u0E19",
            [
              43100
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E14\u0E37\u0E48\u0E2D",
            [
              43e3
            ]
          ],
          [
            "\u0E1B\u0E30\u0E42\u0E04",
            [
              43e3
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E18\u0E32\u0E15\u0E38\u0E1A\u0E31\u0E07\u0E1E\u0E27\u0E19",
            [
              43100
            ]
          ],
          [
            "\u0E21\u0E35\u0E0A\u0E31\u0E22",
            [
              43e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E18\u0E32\u0E15\u0E38",
            [
              43e3
            ]
          ],
          [
            "\u0E2A\u0E2D\u0E07\u0E2B\u0E49\u0E2D\u0E07",
            [
              43100
            ]
          ],
          [
            "\u0E2A\u0E35\u0E01\u0E32\u0E22",
            [
              43e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E2D\u0E21\u0E40\u0E01\u0E32\u0E30",
            [
              43e3
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E04\u0E33",
            [
              43e3
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E42\u0E07\u0E21",
            [
              43e3
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2B\u0E21\u0E35",
            [
              43e3
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E04\u0E38\u0E01",
            [
              43e3
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E0A\u0E31\u0E22",
            [
              43e3
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              43e3
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E15\u0E32\u0E01",
        [
          [
            "\u0E14\u0E48\u0E32\u0E19\u0E28\u0E23\u0E35\u0E2A\u0E38\u0E02",
            [
              43130
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E15\u0E32\u0E01",
            [
              43130
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E17\u0E2D\u0E07",
            [
              43130
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E1E\u0E19\u0E1E\u0E34\u0E2A\u0E31\u0E22",
        [
          [
            "\u0E01\u0E38\u0E14\u0E1A\u0E07",
            [
              43120
            ]
          ],
          [
            "\u0E08\u0E38\u0E21\u0E1E\u0E25",
            [
              43120
            ]
          ],
          [
            "\u0E0A\u0E38\u0E21\u0E0A\u0E49\u0E32\u0E07",
            [
              43120
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              43120
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E19\u0E31\u0E07",
            [
              43120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1C\u0E37\u0E2D",
            [
              43120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              43120
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E2B\u0E25\u0E27\u0E07",
            [
              43120
            ]
          ],
          [
            "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E19\u0E32\u0E07\u0E02\u0E32\u0E27",
            [
              43120
            ]
          ],
          [
            "\u0E40\u0E0B\u0E34\u0E21",
            [
              43120
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E15\u0E48\u0E32\u0E07\u0E04\u0E33",
            [
              43120
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E25\u0E33\u0E20\u0E39",
    [
      [
        "\u0E19\u0E32\u0E01\u0E25\u0E32\u0E07",
        [
          [
            "\u0E01\u0E38\u0E14\u0E14\u0E34\u0E19\u0E08\u0E35\u0E48",
            [
              39350
            ]
          ],
          [
            "\u0E01\u0E38\u0E14\u0E41\u0E2B\u0E48",
            [
              39170
            ]
          ],
          [
            "\u0E14\u0E07\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
            [
              39350
            ]
          ],
          [
            "\u0E14\u0E48\u0E32\u0E19\u0E0A\u0E49\u0E32\u0E07",
            [
              39170
            ]
          ],
          [
            "\u0E19\u0E32\u0E01\u0E25\u0E32\u0E07",
            [
              39170
            ]
          ],
          [
            "\u0E1D\u0E31\u0E48\u0E07\u0E41\u0E14\u0E07",
            [
              39170
            ]
          ],
          [
            "\u0E2D\u0E38\u0E17\u0E31\u0E22\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
            [
              39170
            ]
          ],
          [
            "\u0E40\u0E01\u0E48\u0E32\u0E01\u0E25\u0E2D\u0E22",
            [
              39350
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              39170
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E27\u0E31\u0E07",
        [
          [
            "\u0E19\u0E32\u0E40\u0E2B\u0E25\u0E48\u0E32",
            [
              39170
            ]
          ],
          [
            "\u0E19\u0E32\u0E41\u0E01",
            [
              39170
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E17\u0E2D\u0E07",
            [
              39170
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E1B\u0E25\u0E32\u0E1B\u0E49\u0E2D\u0E21",
            [
              39170
            ]
          ],
          [
            "\u0E40\u0E17\u0E1E\u0E04\u0E35\u0E23\u0E35",
            [
              39170
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E1A\u0E38\u0E0D\u0E40\u0E23\u0E37\u0E2D\u0E07",
        [
          [
            "\u0E01\u0E38\u0E14\u0E2A\u0E30\u0E40\u0E17\u0E35\u0E22\u0E19",
            [
              39180
            ]
          ],
          [
            "\u0E17\u0E23\u0E32\u0E22\u0E17\u0E2D\u0E07",
            [
              39180
            ]
          ],
          [
            "\u0E19\u0E32\u0E01\u0E2D\u0E01",
            [
              39180
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E2B\u0E25\u0E48\u0E2D",
            [
              39180
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E1A\u0E38\u0E0D\u0E40\u0E23\u0E37\u0E2D\u0E07",
            [
              39180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E38\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              39180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E43\u0E15\u0E49",
            [
              39180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E01",
            [
              39180
            ]
          ],
          [
            "\u0E2B\u0E31\u0E19\u0E19\u0E32\u0E07\u0E32\u0E21",
            [
              39180
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48",
            [
              39180
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E21\u0E48\u0E27\u0E07",
            [
              39180
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              39180
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E38\u0E27\u0E23\u0E23\u0E13\u0E04\u0E39\u0E2B\u0E32",
        [
          [
            "\u0E01\u0E38\u0E14\u0E1C\u0E36\u0E49\u0E07",
            [
              39270
            ]
          ],
          [
            "\u0E14\u0E07\u0E21\u0E30\u0E44\u0E1F",
            [
              39270
            ]
          ],
          [
            "\u0E19\u0E32\u0E14\u0E35",
            [
              39270
            ]
          ],
          [
            "\u0E19\u0E32\u0E14\u0E48\u0E32\u0E19",
            [
              39270
            ]
          ],
          [
            "\u0E19\u0E32\u0E2A\u0E35",
            [
              39270
            ]
          ],
          [
            "\u0E1A\u0E38\u0E0D\u0E17\u0E31\u0E19",
            [
              39270
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E04\u0E01",
            [
              39270
            ]
          ],
          [
            "\u0E2A\u0E38\u0E27\u0E23\u0E23\u0E13\u0E04\u0E39\u0E2B\u0E32",
            [
              39270
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E25\u0E33\u0E20\u0E39",
        [
          [
            "\u0E01\u0E38\u0E14\u0E08\u0E34\u0E01",
            [
              39e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E04\u0E33\u0E44\u0E2E",
            [
              39e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E21\u0E30\u0E40\u0E1F\u0E37\u0E2D\u0E07",
            [
              39e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E02\u0E32\u0E21",
            [
              39e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1E\u0E23\u0E49\u0E32\u0E27",
            [
              39e3
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E44\u0E21\u0E49\u0E07\u0E32\u0E21",
            [
              39e3
            ]
          ],
          [
            "\u0E25\u0E33\u0E20\u0E39",
            [
              39e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              39e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E20\u0E31\u0E22\u0E28\u0E39\u0E19\u0E22\u0E4C",
            [
              39e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
            [
              39e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E27\u0E49\u0E32",
            [
              39e3
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E19\u0E32",
            [
              39e3
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E02\u0E21\u0E34\u0E49\u0E19",
            [
              39e3
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E17\u0E31\u0E19",
            [
              39e3
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E0A\u0E31\u0E22",
            [
              39e3
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E19\u0E19\u0E2A\u0E31\u0E07",
        [
          [
            "\u0E01\u0E38\u0E14\u0E14\u0E39\u0E48",
            [
              39140
            ]
          ],
          [
            "\u0E19\u0E34\u0E04\u0E21\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              39140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E04\u0E49\u0E2D",
            [
              39140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E16\u0E34\u0E48\u0E19",
            [
              39140
            ]
          ],
          [
            "\u0E1B\u0E32\u0E07\u0E01\u0E39\u0E48",
            [
              39140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E23\u0E37\u0E2D",
            [
              39140
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E21\u0E48\u0E27\u0E07",
            [
              39140
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E43\u0E2B\u0E0D\u0E48",
            [
              39140
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E31\u0E07",
            [
              39140
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              39140
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2D\u0E33\u0E19\u0E32\u0E08\u0E40\u0E08\u0E23\u0E34\u0E0D",
    [
      [
        "\u0E0A\u0E32\u0E19\u0E38\u0E21\u0E32\u0E19",
        [
          [
            "\u0E04\u0E33\u0E40\u0E02\u0E37\u0E48\u0E2D\u0E19\u0E41\u0E01\u0E49\u0E27",
            [
              37210
            ]
          ],
          [
            "\u0E0A\u0E32\u0E19\u0E38\u0E21\u0E32\u0E19",
            [
              37210
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E01\u0E48\u0E2D",
            [
              37210
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E01\u0E48\u0E07",
            [
              37210
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E32\u0E23",
            [
              37210
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E17\u0E38\u0E21\u0E23\u0E32\u0E0A\u0E27\u0E07\u0E28\u0E32",
        [
          [
            "\u0E04\u0E33\u0E42\u0E1E\u0E19",
            [
              37110
            ]
          ],
          [
            "\u0E19\u0E32\u0E1B\u0E48\u0E32\u0E41\u0E0B\u0E07",
            [
              37110
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E27\u0E49\u0E32",
            [
              37110
            ]
          ],
          [
            "\u0E25\u0E37\u0E2D",
            [
              37110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E48\u0E32",
            [
              37110
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22",
            [
              37110
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E07\u0E32\u0E21",
            [
              37110
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E19\u0E32",
        [
          [
            "\u0E08\u0E32\u0E19\u0E25\u0E32\u0E19",
            [
              37180
            ]
          ],
          [
            "\u0E1E\u0E19\u0E32",
            [
              37180
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E40\u0E2B\u0E25\u0E32",
            [
              37180
            ]
          ],
          [
            "\u0E44\u0E21\u0E49\u0E01\u0E25\u0E2D\u0E19",
            [
              37180
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E37\u0E2D\u0E2D\u0E33\u0E19\u0E32\u0E08",
        [
          [
            "\u0E14\u0E07\u0E1A\u0E31\u0E07",
            [
              37120
            ]
          ],
          [
            "\u0E14\u0E07\u0E21\u0E30\u0E22\u0E32\u0E07",
            [
              37120
            ]
          ],
          [
            "\u0E2D\u0E33\u0E19\u0E32\u0E08",
            [
              37120
            ]
          ],
          [
            "\u0E40\u0E1B\u0E37\u0E2D\u0E22",
            [
              37120
            ]
          ],
          [
            "\u0E41\u0E21\u0E14",
            [
              37120
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E01\u0E25\u0E32\u0E07",
            [
              37120
            ]
          ],
          [
            "\u0E44\u0E23\u0E48\u0E02\u0E35",
            [
              37120
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E31\u0E27\u0E15\u0E30\u0E1E\u0E32\u0E19",
        [
          [
            "\u0E04\u0E33\u0E1E\u0E23\u0E30",
            [
              37240
            ]
          ],
          [
            "\u0E08\u0E34\u0E01\u0E14\u0E39\u0E48",
            [
              37240
            ]
          ],
          [
            "\u0E23\u0E31\u0E15\u0E19\u0E27\u0E32\u0E23\u0E35",
            [
              37240
            ]
          ],
          [
            "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E16\u0E48\u0E2D\u0E19\u0E49\u0E2D\u0E22",
            [
              37240
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              37240
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E15\u0E30\u0E1E\u0E32\u0E19",
            [
              37240
            ]
          ],
          [
            "\u0E40\u0E04\u0E47\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              37240
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E19\u0E49\u0E2D\u0E22",
            [
              37240
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2D\u0E33\u0E19\u0E32\u0E08\u0E40\u0E08\u0E23\u0E34\u0E0D",
        [
          [
            "\u0E01\u0E38\u0E14\u0E1B\u0E25\u0E32\u0E14\u0E38\u0E01",
            [
              37e3
            ]
          ],
          [
            "\u0E04\u0E36\u0E21\u0E43\u0E2B\u0E0D\u0E48",
            [
              37e3
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E40\u0E21\u0E22",
            [
              37e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E08\u0E34\u0E01",
            [
              37e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E1C\u0E37\u0E2D",
            [
              37e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E22\u0E21",
            [
              37e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E27\u0E31\u0E07",
            [
              37e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E21\u0E2D\u0E21\u0E49\u0E32",
            [
              37e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E41\u0E15\u0E49",
            [
              37e3
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E1B\u0E25\u0E35\u0E01",
            [
              37e3
            ]
          ],
          [
            "\u0E1A\u0E38\u0E48\u0E07",
            [
              37e3
            ]
          ],
          [
            "\u0E1B\u0E25\u0E32\u0E04\u0E49\u0E32\u0E27",
            [
              37e3
            ]
          ],
          [
            "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E19\u0E01\u0E17\u0E32",
            [
              37e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E21\u0E30\u0E41\u0E0B\u0E27",
            [
              37e3
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E44\u0E23\u0E48",
            [
              37e3
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E1E\u0E23\u0E27\u0E19",
            [
              37e3
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2B\u0E19\u0E32\u0E21\u0E41\u0E17\u0E48\u0E07",
            [
              37e3
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              37e3
            ]
          ],
          [
            "\u0E44\u0E01\u0E48\u0E04\u0E33",
            [
              37e3
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E2A\u0E19\u0E32\u0E07\u0E04\u0E19\u0E34\u0E04\u0E21",
        [
          [
            "\u0E19\u0E32\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              37290
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E32\u0E21\u0E2A\u0E35",
            [
              37290
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E2E",
            [
              37290
            ]
          ],
          [
            "\u0E40\u0E2A\u0E19\u0E32\u0E07\u0E04\u0E19\u0E34\u0E04\u0E21",
            [
              37290
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E17\u0E2D\u0E07",
            [
              37290
            ]
          ],
          [
            "\u0E44\u0E23\u0E48\u0E2A\u0E35\u0E2A\u0E38\u0E01",
            [
              37290
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2D\u0E38\u0E14\u0E23\u0E18\u0E32\u0E19\u0E35",
    [
      [
        "\u0E01\u0E38\u0E14\u0E08\u0E31\u0E1A",
        [
          [
            "\u0E01\u0E38\u0E14\u0E08\u0E31\u0E1A",
            [
              41250
            ]
          ],
          [
            "\u0E02\u0E2D\u0E19\u0E22\u0E39\u0E07",
            [
              41250
            ]
          ],
          [
            "\u0E15\u0E32\u0E25\u0E40\u0E25\u0E35\u0E22\u0E19",
            [
              41250
            ]
          ],
          [
            "\u0E1B\u0E30\u0E42\u0E04",
            [
              41250
            ]
          ],
          [
            "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E01\u0E48\u0E2D",
            [
              41250
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E40\u0E1E\u0E47\u0E07",
            [
              41250
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E1E\u0E35\u0E22",
            [
              41250
            ]
          ]
        ]
      ],
      [
        "\u0E01\u0E38\u0E21\u0E20\u0E27\u0E32\u0E1B\u0E35",
        [
          [
            "\u0E01\u0E38\u0E21\u0E20\u0E27\u0E32\u0E1B\u0E35",
            [
              41110
            ]
          ],
          [
            "\u0E15\u0E39\u0E21\u0E43\u0E15\u0E49",
            [
              41110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E25\u0E35\u0E48",
            [
              41110
            ]
          ],
          [
            "\u0E1B\u0E30\u0E42\u0E04",
            [
              41370
            ]
          ],
          [
            "\u0E1C\u0E32\u0E2A\u0E38\u0E01",
            [
              41370
            ]
          ],
          [
            "\u0E1E\u0E31\u0E19\u0E14\u0E2D\u0E19",
            [
              41370
            ]
          ],
          [
            "\u0E2A\u0E35\u0E2D\u0E2D",
            [
              41110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E27\u0E49\u0E32",
            [
              41110
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E40\u0E01\u0E34\u0E49\u0E07",
            [
              41110
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E41\u0E2B\u0E27",
            [
              41110
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E04\u0E33",
            [
              41110
            ]
          ],
          [
            "\u0E40\u0E2A\u0E2D\u0E40\u0E1E\u0E25\u0E2D",
            [
              41370
            ]
          ],
          [
            "\u0E41\u0E0A\u0E41\u0E25",
            [
              41110
            ]
          ]
        ]
      ],
      [
        "\u0E01\u0E39\u0E48\u0E41\u0E01\u0E49\u0E27",
        [
          [
            "\u0E04\u0E2D\u0E19\u0E2A\u0E32\u0E22",
            [
              41130
            ]
          ],
          [
            "\u0E04\u0E49\u0E2D\u0E43\u0E2B\u0E0D\u0E48",
            [
              41130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E08\u0E35\u0E15",
            [
              41130
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E17\u0E2D\u0E07\u0E2D\u0E34\u0E19\u0E17\u0E23\u0E4C",
            [
              41130
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E38\u0E48\u0E07\u0E1D\u0E19",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E1D\u0E19",
            [
              41310
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              41310
            ]
          ],
          [
            "\u0E19\u0E32\u0E0A\u0E38\u0E21\u0E41\u0E2A\u0E07",
            [
              41310
            ]
          ],
          [
            "\u0E19\u0E32\u0E17\u0E21",
            [
              41310
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E22\u0E39\u0E07",
        [
          [
            "\u0E19\u0E32\u0E22\u0E39\u0E07",
            [
              41380
            ]
          ],
          [
            "\u0E19\u0E32\u0E41\u0E04",
            [
              41380
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E49\u0E2D\u0E07",
            [
              41380
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E17\u0E2D\u0E07",
            [
              41380
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E49\u0E33\u0E42\u0E2A\u0E21",
        [
          [
            "\u0E19\u0E32\u0E07\u0E31\u0E27",
            [
              41210
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E42\u0E2A\u0E21",
            [
              41210
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E22\u0E27\u0E01",
            [
              41210
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              41210
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E31\u0E04\u0E04\u0E35",
            [
              41210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07",
            [
              41210
            ]
          ],
          [
            "\u0E42\u0E2A\u0E21\u0E40\u0E22\u0E35\u0E48\u0E22\u0E21",
            [
              41210
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E14\u0E38\u0E07",
        [
          [
            "\u0E14\u0E07\u0E40\u0E22\u0E47\u0E19",
            [
              41190
            ]
          ],
          [
            "\u0E16\u0E48\u0E2D\u0E19\u0E19\u0E32\u0E25\u0E31\u0E1A",
            [
              41190
            ]
          ],
          [
            "\u0E19\u0E32\u0E04\u0E33",
            [
              41190
            ]
          ],
          [
            "\u0E19\u0E32\u0E44\u0E2B\u0E21",
            [
              41190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
            [
              41190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E0A\u0E31\u0E22",
            [
              41190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E14\u0E38\u0E07",
            [
              41190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E15\u0E32\u0E14",
            [
              41190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E21\u0E48\u0E27\u0E07",
            [
              41190
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E17\u0E2D\u0E07",
            [
              41190
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E38\u0E17\u0E42\u0E18",
            [
              41190
            ]
          ],
          [
            "\u0E2D\u0E49\u0E2D\u0E21\u0E01\u0E2D",
            [
              41190
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E2A\u0E39\u0E07",
            [
              41190
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E1C\u0E37\u0E2D",
        [
          [
            "\u0E01\u0E25\u0E32\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              41160
            ]
          ],
          [
            "\u0E02\u0E49\u0E32\u0E27\u0E2A\u0E32\u0E23",
            [
              41160
            ]
          ],
          [
            "\u0E04\u0E33\u0E14\u0E49\u0E27\u0E07",
            [
              41160
            ]
          ],
          [
            "\u0E04\u0E33\u0E1A\u0E07",
            [
              41160
            ]
          ],
          [
            "\u0E08\u0E33\u0E1B\u0E32\u0E42\u0E21\u0E07",
            [
              41160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E04\u0E49\u0E2D",
            [
              41160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1C\u0E37\u0E2D",
            [
              41160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E31\u0E27\u0E04\u0E39",
            [
              41160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E27\u0E07",
            [
              41160
            ]
          ],
          [
            "\u0E2B\u0E32\u0E22\u0E42\u0E28\u0E01",
            [
              41160
            ]
          ],
          [
            "\u0E40\u0E02\u0E37\u0E2D\u0E19\u0E49\u0E33",
            [
              41160
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1E\u0E32\u0E19",
            [
              41160
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E17\u0E2D\u0E07",
            [
              41160
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E23\u0E30\u0E08\u0E31\u0E01\u0E29\u0E4C\u0E28\u0E34\u0E25\u0E1B\u0E32\u0E04\u0E21",
        [
          [
            "\u0E19\u0E32\u0E21\u0E48\u0E27\u0E07",
            [
              41110
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E2A\u0E32\u0E21\u0E1E\u0E32\u0E14",
            [
              41110
            ]
          ],
          [
            "\u0E2D\u0E38\u0E48\u0E21\u0E08\u0E32\u0E19",
            [
              41110
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E34\u0E1A\u0E39\u0E25\u0E22\u0E4C\u0E23\u0E31\u0E01\u0E29\u0E4C",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E01\u0E25\u0E2D\u0E22",
            [
              41130
            ]
          ],
          [
            "\u0E19\u0E32\u0E17\u0E23\u0E32\u0E22",
            [
              41130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E14\u0E07",
            [
              41130
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E07\u0E2A\u0E32\u0E21\u0E2B\u0E21\u0E2D",
        [
          [
            "\u0E04\u0E33\u0E42\u0E04\u0E01\u0E2A\u0E39\u0E07",
            [
              41280
            ]
          ],
          [
            "\u0E1A\u0E30\u0E22\u0E32\u0E27",
            [
              41280
            ]
          ],
          [
            "\u0E1C\u0E32\u0E2A\u0E38\u0E01",
            [
              41280
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2A\u0E32\u0E21\u0E2B\u0E21\u0E2D",
            [
              41280
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E38\u0E07\u0E17\u0E31\u0E1A\u0E21\u0E49\u0E32",
            [
              41280
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E0D\u0E49\u0E32\u0E44\u0E0B",
            [
              41280
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E18\u0E32\u0E15\u0E38",
        [
          [
            "\u0E08\u0E33\u0E1B\u0E35",
            [
              41230
            ]
          ],
          [
            "\u0E15\u0E32\u0E14\u0E17\u0E2D\u0E07",
            [
              41230
            ]
          ],
          [
            "\u0E19\u0E32\u0E22\u0E39\u0E07",
            [
              41230
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E1B\u0E23\u0E48\u0E07",
            [
              41230
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E18\u0E32\u0E15\u0E38",
            [
              41230
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E19\u0E01\u0E40\u0E02\u0E35\u0E22\u0E19",
            [
              41230
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E19\u0E32\u0E04\u0E33",
            [
              41230
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E04\u0E2D\u0E21",
        [
          [
            "\u0E19\u0E32\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              41260
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E22\u0E27\u0E14",
            [
              41260
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E34\u0E19\u0E42\u0E07\u0E21",
            [
              41260
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E04\u0E01",
            [
              41260
            ]
          ],
          [
            "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E04\u0E2D\u0E21",
            [
              41260
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E14\u0E32",
            [
              41260
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E27\u0E31\u0E27\u0E0B\u0E2D",
        [
          [
            "\u0E01\u0E38\u0E14\u0E2B\u0E21\u0E32\u0E01\u0E44\u0E1F",
            [
              41220
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E1E\u0E48\u0E19",
            [
              41360
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E1A\u0E32\u0E19",
            [
              41360
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E27\u0E31\u0E27\u0E0B\u0E2D",
            [
              41360
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2D\u0E49\u0E2D",
            [
              41220
            ]
          ],
          [
            "\u0E2B\u0E21\u0E32\u0E01\u0E2B\u0E0D\u0E49\u0E32",
            [
              41360
            ]
          ],
          [
            "\u0E2D\u0E39\u0E1A\u0E21\u0E38\u0E07",
            [
              41220
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2B\u0E27\u0E32\u0E22",
            [
              41220
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E32\u0E19",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E2B\u0E32\u0E22\u0E42\u0E28\u0E01",
            [
              41130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E22\u0E32",
            [
              41320
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E0A\u0E35\u0E22\u0E07",
            [
              41320
            ]
          ],
          [
            "\u0E1C\u0E31\u0E01\u0E15\u0E1A",
            [
              41130
            ]
          ],
          [
            "\u0E1E\u0E31\u0E07\u0E07\u0E39",
            [
              41130
            ]
          ],
          [
            "\u0E2A\u0E23\u0E49\u0E2D\u0E22\u0E1E\u0E23\u0E49\u0E32\u0E27",
            [
              41130
            ]
          ],
          [
            "\u0E2A\u0E30\u0E41\u0E1A\u0E07",
            [
              41130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E23\u0E30\u0E1B\u0E25\u0E32",
            [
              41320
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E32\u0E19",
            [
              41130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E21\u0E47\u0E01",
            [
              41130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E1C\u0E48",
            [
              41130
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E07\u0E32\u0E21",
            [
              41130
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E2A\u0E07",
        [
          [
            "\u0E17\u0E31\u0E1A\u0E01\u0E38\u0E07",
            [
              41340
            ]
          ],
          [
            "\u0E19\u0E32\u0E14\u0E35",
            [
              41340
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E2A\u0E07",
            [
              41340
            ]
          ],
          [
            "\u0E41\u0E2A\u0E07\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              41340
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E1E\u0E47\u0E0D",
        [
          [
            "\u0E08\u0E2D\u0E21\u0E28\u0E23\u0E35",
            [
              41150
            ]
          ],
          [
            "\u0E19\u0E32\u0E1A\u0E31\u0E27",
            [
              41150
            ]
          ],
          [
            "\u0E19\u0E32\u0E1E\u0E39\u0E48",
            [
              41150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E18\u0E32\u0E15\u0E38",
            [
              41150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E2B\u0E25\u0E48\u0E32",
            [
              41150
            ]
          ],
          [
            "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E41\u0E1B\u0E49\u0E19",
            [
              41150
            ]
          ],
          [
            "\u0E2A\u0E38\u0E21\u0E40\u0E2A\u0E49\u0E32",
            [
              41150
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E2B\u0E27\u0E32\u0E07",
            [
              41150
            ]
          ],
          [
            "\u0E40\u0E15\u0E32\u0E44\u0E2B",
            [
              41150
            ]
          ],
          [
            "\u0E40\u0E1E\u0E47\u0E0D",
            [
              41150
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E01\u0E25\u0E32\u0E07",
            [
              41150
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2D\u0E38\u0E14\u0E23\u0E18\u0E32\u0E19\u0E35",
        [
          [
            "\u0E01\u0E38\u0E14\u0E2A\u0E23\u0E30",
            [
              41e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E01\u0E27\u0E49\u0E32\u0E07",
            [
              41e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E02\u0E48\u0E32",
            [
              41e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E14\u0E35",
            [
              41e3
            ]
          ],
          [
            "\u0E19\u0E34\u0E04\u0E21\u0E2A\u0E07\u0E40\u0E04\u0E23\u0E32\u0E30\u0E2B\u0E4C",
            [
              41e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E02\u0E32\u0E27",
            [
              41e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E08\u0E31\u0E48\u0E19",
            [
              41e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E15\u0E32\u0E14",
            [
              41e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E21",
            [
              41e3
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E1E\u0E23\u0E49\u0E32\u0E27",
            [
              41e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E2D\u0E19\u0E01\u0E27\u0E49\u0E32\u0E07",
            [
              41e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E19\u0E32\u0E04\u0E33",
            [
              41e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              41e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E1C\u0E48",
            [
              41330
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E2E",
            [
              41e3
            ]
          ],
          [
            "\u0E2B\u0E21\u0E32\u0E01\u0E41\u0E02\u0E49\u0E07",
            [
              41e3
            ]
          ],
          [
            "\u0E2B\u0E21\u0E39\u0E21\u0E48\u0E19",
            [
              41e3
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E1E\u0E34\u0E13",
            [
              41e3
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E22\u0E37\u0E19",
            [
              41e3
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              41e3
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E39\u0E07",
            [
              41330
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E19\u0E19\u0E2A\u0E30\u0E2D\u0E32\u0E14",
        [
          [
            "\u0E17\u0E21\u0E19\u0E32\u0E07\u0E32\u0E21",
            [
              41240
            ]
          ],
          [
            "\u0E1A\u0E38\u0E48\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              41240
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E38\u0E07\u0E28\u0E23\u0E35",
            [
              41240
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E01\u0E25\u0E32\u0E07",
            [
              41240
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              41240
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E28\u0E23\u0E35\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              41240
            ]
          ]
        ]
      ],
      [
        "\u0E44\u0E0A\u0E22\u0E27\u0E32\u0E19",
        [
          [
            "\u0E04\u0E33\u0E40\u0E25\u0E32\u0E30",
            [
              41290
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E25\u0E31\u0E01",
            [
              41290
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E2A\u0E39\u0E07",
            [
              41290
            ]
          ],
          [
            "\u0E44\u0E0A\u0E22\u0E27\u0E32\u0E19",
            [
              41290
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2D\u0E38\u0E15\u0E23\u0E14\u0E34\u0E15\u0E16\u0E4C",
    [
      [
        "\u0E15\u0E23\u0E2D\u0E19",
        [
          [
            "\u0E02\u0E48\u0E2D\u0E22\u0E2A\u0E39\u0E07",
            [
              53140
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E2D\u0E48\u0E32\u0E07",
            [
              53140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E01\u0E48\u0E07",
            [
              53140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E41\u0E14\u0E07",
            [
              53140
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E2A\u0E2D\u0E07\u0E41\u0E04\u0E27",
            [
              53140
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E2D\u0E07\u0E41\u0E2A\u0E19\u0E02\u0E31\u0E19",
        [
          [
            "\u0E19\u0E49\u0E33\u0E1E\u0E35\u0E49",
            [
              53230
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E17\u0E2D\u0E07",
            [
              53230
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E04\u0E32\u0E22",
            [
              53230
            ]
          ],
          [
            "\u0E1C\u0E31\u0E01\u0E02\u0E27\u0E07",
            [
              53230
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E48\u0E32\u0E1B\u0E25\u0E32",
        [
          [
            "\u0E08\u0E23\u0E34\u0E21",
            [
              53150
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E1B\u0E25\u0E32",
            [
              53150
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E41\u0E1D\u0E01",
            [
              53110
            ]
          ],
          [
            "\u0E19\u0E32\u0E07\u0E1E\u0E0D\u0E32",
            [
              53150
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E2B\u0E21\u0E31\u0E19",
            [
              53150
            ]
          ],
          [
            "\u0E1C\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E14",
            [
              53190
            ]
          ],
          [
            "\u0E23\u0E48\u0E27\u0E21\u0E08\u0E34\u0E15",
            [
              53190
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E25\u0E49\u0E32",
            [
              53190
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E49\u0E33\u0E1B\u0E32\u0E14",
        [
          [
            "\u0E19\u0E49\u0E33\u0E44\u0E04\u0E23\u0E49",
            [
              53110
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E44\u0E1C\u0E48",
            [
              53110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1D\u0E32\u0E22",
            [
              53110
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E21\u0E38\u0E48\u0E19",
            [
              53110
            ]
          ],
          [
            "\u0E40\u0E14\u0E48\u0E19\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              53110
            ]
          ],
          [
            "\u0E41\u0E2A\u0E19\u0E15\u0E2D",
            [
              53110
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E04\u0E01",
        [
          [
            "\u0E19\u0E32\u0E02\u0E38\u0E21",
            [
              53180
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E40\u0E1A\u0E35\u0E49\u0E22",
            [
              53180
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E04\u0E01",
            [
              53180
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E40\u0E08\u0E47\u0E14\u0E15\u0E49\u0E19",
            [
              53180
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E34\u0E0A\u0E31\u0E22",
        [
          [
            "\u0E04\u0E2D\u0E23\u0E38\u0E21",
            [
              53120
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E21\u0E30\u0E40\u0E1F\u0E37\u0E2D\u0E07",
            [
              53120
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2A\u0E31\u0E01",
            [
              53220
            ]
          ],
          [
            "\u0E19\u0E32\u0E22\u0E32\u0E07",
            [
              53120
            ]
          ],
          [
            "\u0E19\u0E32\u0E2D\u0E34\u0E19",
            [
              53120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E14\u0E32\u0E23\u0E32",
            [
              53220
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E21\u0E49\u0E2D",
            [
              53120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E04\u0E19",
            [
              53120
            ]
          ],
          [
            "\u0E1E\u0E0D\u0E32\u0E41\u0E21\u0E19",
            [
              53120
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              53120
            ]
          ],
          [
            "\u0E44\u0E23\u0E48\u0E2D\u0E49\u0E2D\u0E22",
            [
              53120
            ]
          ]
        ]
      ],
      [
        "\u0E1F\u0E32\u0E01\u0E17\u0E48\u0E32",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E2A\u0E35\u0E49\u0E22\u0E27",
            [
              53160
            ]
          ],
          [
            "\u0E1F\u0E32\u0E01\u0E17\u0E48\u0E32",
            [
              53160
            ]
          ],
          [
            "\u0E2A\u0E2D\u0E07\u0E04\u0E2D\u0E19",
            [
              53160
            ]
          ],
          [
            "\u0E2A\u0E2D\u0E07\u0E2B\u0E49\u0E2D\u0E07",
            [
              53160
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E31\u0E1A\u0E41\u0E25",
        [
          [
            "\u0E0A\u0E31\u0E22\u0E08\u0E38\u0E21\u0E1E\u0E25",
            [
              53130
            ]
          ],
          [
            "\u0E14\u0E48\u0E32\u0E19\u0E41\u0E21\u0E48\u0E04\u0E33\u0E21\u0E31\u0E19",
            [
              53210
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E22\u0E31\u0E49\u0E07",
            [
              53210
            ]
          ],
          [
            "\u0E19\u0E32\u0E19\u0E01\u0E01\u0E01",
            [
              53130
            ]
          ],
          [
            "\u0E1D\u0E32\u0E22\u0E2B\u0E25\u0E27\u0E07",
            [
              53130
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E1E\u0E19\u0E21\u0E21\u0E32\u0E28",
            [
              53130
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E1E\u0E39\u0E25",
            [
              53130
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E25\u0E49\u0E2D\u0E21",
            [
              53210
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2D\u0E38\u0E15\u0E23\u0E14\u0E34\u0E15\u0E16\u0E4C",
        [
          [
            "\u0E02\u0E38\u0E19\u0E1D\u0E32\u0E07",
            [
              53e3
            ]
          ],
          [
            "\u0E04\u0E38\u0E49\u0E07\u0E15\u0E30\u0E40\u0E20\u0E32",
            [
              53e3
            ]
          ],
          [
            "\u0E07\u0E34\u0E49\u0E27\u0E07\u0E32\u0E21",
            [
              53e3
            ]
          ],
          [
            "\u0E16\u0E49\u0E33\u0E09\u0E25\u0E2D\u0E07",
            [
              53e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2D\u0E34\u0E10",
            [
              53e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E2A\u0E32",
            [
              53e3
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E23\u0E34\u0E14",
            [
              53e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E14\u0E48\u0E32\u0E19",
            [
              53e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E14\u0E48\u0E32\u0E19\u0E19\u0E32\u0E02\u0E32\u0E21",
            [
              53e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E01\u0E32\u0E30",
            [
              53e3
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E40\u0E0B\u0E48\u0E32",
            [
              53e3
            ]
          ],
          [
            "\u0E1C\u0E32\u0E08\u0E38\u0E01",
            [
              53e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E01\u0E30\u0E1E\u0E35\u0E49",
            [
              53170
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E14\u0E34\u0E19",
            [
              53e3
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E01\u0E23\u0E27\u0E14",
            [
              53e3
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E07\u0E34\u0E49\u0E27",
            [
              53e3
            ]
          ],
          [
            "\u0E41\u0E2A\u0E19\u0E15\u0E2D",
            [
              53e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2D\u0E38\u0E17\u0E31\u0E22\u0E18\u0E32\u0E19\u0E35",
    [
      [
        "\u0E17\u0E31\u0E1E\u0E17\u0E31\u0E19",
        [
          [
            "\u0E15\u0E25\u0E38\u0E01\u0E14\u0E39\u0E48",
            [
              61120
            ]
          ],
          [
            "\u0E17\u0E31\u0E1E\u0E17\u0E31\u0E19",
            [
              61120
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E19\u0E32\u0E44\u0E17\u0E22",
            [
              61120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E17\u0E38\u0E48\u0E21",
            [
              61120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E25\u0E32\u0E07\u0E14\u0E07",
            [
              61120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E22\u0E32\u0E22\u0E14\u0E32",
            [
              61120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E23\u0E30",
            [
              61120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E0D\u0E49\u0E32\u0E1B\u0E25\u0E49\u0E2D\u0E07",
            [
              61120
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E02\u0E35\u0E49\u0E1D\u0E2D\u0E22",
            [
              61120
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2B\u0E21\u0E49\u0E2D",
            [
              61120
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E44\u0E23\u0E48",
        [
          [
            "\u0E04\u0E2D\u0E01\u0E04\u0E27\u0E32\u0E22",
            [
              61140
            ]
          ],
          [
            "\u0E17\u0E31\u0E1E\u0E2B\u0E25\u0E27\u0E07",
            [
              61140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1A\u0E36\u0E07",
            [
              61140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48\u0E04\u0E25\u0E2D\u0E07\u0E40\u0E04\u0E35\u0E22\u0E19",
            [
              61180
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E44\u0E23\u0E48",
            [
              61140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2B\u0E34\u0E19",
            [
              61180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E08\u0E2D\u0E01",
            [
              61180
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E48\u0E21\u0E01\u0E25\u0E49\u0E27\u0E22",
            [
              61180
            ]
          ],
          [
            "\u0E2B\u0E39\u0E0A\u0E49\u0E32\u0E07",
            [
              61180
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E41\u0E2B\u0E49\u0E07",
            [
              61140
            ]
          ],
          [
            "\u0E40\u0E08\u0E49\u0E32\u0E27\u0E31\u0E14",
            [
              61150
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E38\u0E49\u0E07",
            [
              61180
            ]
          ],
          [
            "\u0E41\u0E01\u0E48\u0E19\u0E21\u0E30\u0E01\u0E23\u0E39\u0E14",
            [
              61140
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E32\u0E19\u0E2A\u0E31\u0E01",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E19\u0E32\u0E07\u0E32\u0E21",
            [
              61160
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E23\u0E2D\u0E1A",
            [
              61160
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E14\u0E39\u0E48\u0E22\u0E37\u0E19",
            [
              61160
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E2D\u0E49\u0E2D",
            [
              61160
            ]
          ],
          [
            "\u0E23\u0E30\u0E1A\u0E33",
            [
              61160
            ]
          ],
          [
            "\u0E25\u0E32\u0E19\u0E2A\u0E31\u0E01",
            [
              61160
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E27\u0E48\u0E32\u0E07\u0E2D\u0E32\u0E23\u0E21\u0E13\u0E4C",
        [
          [
            "\u0E1A\u0E48\u0E2D\u0E22\u0E32\u0E07",
            [
              61150
            ]
          ],
          [
            "\u0E1E\u0E25\u0E27\u0E07\u0E2A\u0E2D\u0E07\u0E19\u0E32\u0E07",
            [
              61150
            ]
          ],
          [
            "\u0E2A\u0E27\u0E48\u0E32\u0E07\u0E2D\u0E32\u0E23\u0E21\u0E13\u0E4C",
            [
              61150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              61150
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E40\u0E02\u0E35\u0E22\u0E27",
            [
              61150
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E32\u0E2B\u0E22\u0E48\u0E32\u0E07",
        [
          [
            "\u0E14\u0E07\u0E02\u0E27\u0E32\u0E07",
            [
              61130
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E01\u0E25\u0E2D\u0E22",
            [
              61130
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E1E\u0E36\u0E48\u0E07",
            [
              61130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E42\u0E1E",
            [
              61130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E32\u0E2B\u0E22\u0E48\u0E32\u0E07",
            [
              61130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E1C\u0E48",
            [
              61130
            ]
          ],
          [
            "\u0E2B\u0E21\u0E01\u0E41\u0E16\u0E27",
            [
              61130
            ]
          ],
          [
            "\u0E2B\u0E25\u0E38\u0E21\u0E40\u0E02\u0E49\u0E32",
            [
              61130
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E23\u0E2D\u0E1A",
            [
              61130
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E09\u0E32\u0E07",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E1E\u0E07",
            [
              61110
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E42\u0E1E",
            [
              61110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E01\u0E48\u0E32",
            [
              61110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E09\u0E32\u0E07",
            [
              61110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E19\u0E32\u0E07\u0E19\u0E27\u0E25",
            [
              61110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E22\u0E32\u0E07",
            [
              61110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E23\u0E27\u0E07",
            [
              61110
            ]
          ],
          [
            "\u0E2D\u0E38\u0E17\u0E31\u0E22\u0E40\u0E01\u0E48\u0E32",
            [
              61110
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E01\u0E27\u0E32\u0E07\u0E17\u0E2D\u0E07",
            [
              61110
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E1A\u0E32\u0E07\u0E41\u0E01\u0E23\u0E01",
            [
              61170
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E49\u0E27\u0E22\u0E04\u0E15",
        [
          [
            "\u0E17\u0E2D\u0E07\u0E2B\u0E25\u0E32\u0E07",
            [
              61170
            ]
          ],
          [
            "\u0E2A\u0E38\u0E02\u0E24\u0E17\u0E31\u0E22",
            [
              61170
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E04\u0E15",
            [
              61170
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2D\u0E38\u0E17\u0E31\u0E22\u0E18\u0E32\u0E19\u0E35",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E02\u0E27\u0E32\u0E07",
            [
              61e3
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              61e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E0B\u0E38\u0E07",
            [
              61e3
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E0B\u0E36\u0E21",
            [
              61e3
            ]
          ],
          [
            "\u0E2A\u0E30\u0E41\u0E01\u0E01\u0E23\u0E31\u0E07",
            [
              61e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1E\u0E31\u0E07\u0E04\u0E48\u0E32",
            [
              61e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E15\u0E48\u0E32",
            [
              61e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E01",
            [
              61e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E1C\u0E48\u0E41\u0E1A\u0E19",
            [
              61e3
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E17\u0E19\u0E07",
            [
              61e3
            ]
          ],
          [
            "\u0E2D\u0E38\u0E17\u0E31\u0E22\u0E43\u0E2B\u0E21\u0E48",
            [
              61e3
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E40\u0E17\u0E42\u0E1E",
            [
              61e3
            ]
          ],
          [
            "\u0E40\u0E19\u0E34\u0E19\u0E41\u0E08\u0E07",
            [
              61e3
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              61e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2D\u0E38\u0E1A\u0E25\u0E23\u0E32\u0E0A\u0E18\u0E32\u0E19\u0E35",
    [
      [
        "\u0E01\u0E38\u0E14\u0E02\u0E49\u0E32\u0E27\u0E1B\u0E38\u0E49\u0E19",
        [
          [
            "\u0E01\u0E32\u0E1A\u0E34\u0E19",
            [
              34270
            ]
          ],
          [
            "\u0E02\u0E49\u0E32\u0E27\u0E1B\u0E38\u0E49\u0E19",
            [
              34270
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E17\u0E31\u0E19\u0E19\u0E49\u0E33",
            [
              34270
            ]
          ],
          [
            "\u0E41\u0E01\u0E48\u0E07\u0E40\u0E04\u0E47\u0E07",
            [
              34270
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E27\u0E32\u0E07",
            [
              34270
            ]
          ]
        ]
      ],
      [
        "\u0E14\u0E2D\u0E19\u0E21\u0E14\u0E41\u0E14\u0E07",
        [
          [
            "\u0E04\u0E33\u0E44\u0E2E\u0E43\u0E2B\u0E0D\u0E48",
            [
              34e3
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E21\u0E14\u0E41\u0E14\u0E07",
            [
              34e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              34e3
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E41\u0E14\u0E07",
            [
              34e3
            ]
          ]
        ]
      ],
      [
        "\u0E15\u0E23\u0E30\u0E01\u0E32\u0E23\u0E1E\u0E37\u0E0A\u0E1C\u0E25",
        [
          [
            "\u0E01\u0E23\u0E30\u0E40\u0E14\u0E35\u0E22\u0E19",
            [
              34130
            ]
          ],
          [
            "\u0E01\u0E38\u0E14\u0E22\u0E32\u0E25\u0E27\u0E19",
            [
              34130
            ]
          ],
          [
            "\u0E01\u0E38\u0E28\u0E01\u0E23",
            [
              34130
            ]
          ],
          [
            "\u0E02\u0E32\u0E21\u0E40\u0E1B\u0E35\u0E49\u0E22",
            [
              34130
            ]
          ],
          [
            "\u0E02\u0E38\u0E2B\u0E25\u0E38",
            [
              34130
            ]
          ],
          [
            "\u0E04\u0E2D\u0E19\u0E2A\u0E32\u0E22",
            [
              34130
            ]
          ],
          [
            "\u0E04\u0E33\u0E40\u0E08\u0E23\u0E34\u0E0D",
            [
              34130
            ]
          ],
          [
            "\u0E15\u0E23\u0E30\u0E01\u0E32\u0E23",
            [
              34130
            ]
          ],
          [
            "\u0E15\u0E32\u0E01\u0E41\u0E14\u0E14",
            [
              34130
            ]
          ],
          [
            "\u0E16\u0E49\u0E33\u0E41\u0E02\u0E49",
            [
              34130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2B\u0E25\u0E27\u0E07",
            [
              34130
            ]
          ],
          [
            "\u0E19\u0E32\u0E1E\u0E34\u0E19",
            [
              34130
            ]
          ],
          [
            "\u0E19\u0E32\u0E2A\u0E30\u0E44\u0E21",
            [
              34130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E14\u0E07",
            [
              34130
            ]
          ],
          [
            "\u0E2A\u0E30\u0E1E\u0E37\u0E2D",
            [
              34130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E15\u0E48\u0E32",
            [
              34130
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E1D\u0E49\u0E32\u0E22\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              34130
            ]
          ],
          [
            "\u0E40\u0E01\u0E29\u0E21",
            [
              34130
            ]
          ],
          [
            "\u0E40\u0E0B\u0E40\u0E1B\u0E47\u0E14",
            [
              34130
            ]
          ],
          [
            "\u0E40\u0E1B\u0E49\u0E32",
            [
              34130
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E08\u0E32\u0E19",
            [
              34130
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E01\u0E38\u0E07",
            [
              34130
            ]
          ],
          [
            "\u0E44\u0E2B\u0E25\u0E48\u0E17\u0E38\u0E48\u0E07",
            [
              34130
            ]
          ]
        ]
      ],
      [
        "\u0E15\u0E32\u0E25\u0E2A\u0E38\u0E21",
        [
          [
            "\u0E04\u0E33\u0E2B\u0E27\u0E49\u0E32",
            [
              34330
            ]
          ],
          [
            "\u0E08\u0E34\u0E01\u0E40\u0E17\u0E34\u0E07",
            [
              34330
            ]
          ],
          [
            "\u0E15\u0E32\u0E25\u0E2A\u0E38\u0E21",
            [
              34330
            ]
          ],
          [
            "\u0E19\u0E32\u0E04\u0E32\u0E22",
            [
              34330
            ]
          ],
          [
            "\u0E2A\u0E33\u0E42\u0E23\u0E07",
            [
              34330
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E38\u0E07",
            [
              34330
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E38\u0E48\u0E07\u0E28\u0E23\u0E35\u0E2D\u0E38\u0E14\u0E21",
        [
          [
            "\u0E01\u0E38\u0E14\u0E40\u0E23\u0E37\u0E2D",
            [
              34160
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E48\u0E2D\u0E21",
            [
              34160
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E01\u0E29\u0E21",
            [
              34160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2D\u0E49\u0E21",
            [
              34160
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E0A\u0E33\u0E41\u0E23\u0E30",
            [
              34160
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E08\u0E30\u0E2B\u0E25\u0E27\u0E22",
        [
          [
            "\u0E19\u0E32\u0E08\u0E30\u0E2B\u0E25\u0E27\u0E22",
            [
              34280
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E15\u0E39\u0E21",
            [
              34280
            ]
          ],
          [
            "\u0E1E\u0E23\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
            [
              34280
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              34280
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
            [
              34280
            ]
          ],
          [
            "\u0E42\u0E2A\u0E01\u0E41\u0E2A\u0E07",
            [
              34280
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E15\u0E32\u0E25",
        [
          [
            "\u0E01\u0E2D\u0E07\u0E42\u0E1E\u0E19",
            [
              34170
            ]
          ],
          [
            "\u0E19\u0E32\u0E15\u0E32\u0E25",
            [
              34170
            ]
          ],
          [
            "\u0E1E\u0E30\u0E25\u0E32\u0E19",
            [
              34170
            ]
          ],
          [
            "\u0E1E\u0E31\u0E07\u0E40\u0E04\u0E19",
            [
              34170
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E40\u0E22\u0E35\u0E22",
        [
          [
            "\u0E19\u0E32\u0E14\u0E35",
            [
              34160
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E22\u0E35\u0E22",
            [
              34160
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E23\u0E37\u0E2D\u0E07",
            [
              34160
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E49\u0E33\u0E02\u0E38\u0E48\u0E19",
        [
          [
            "\u0E02\u0E35\u0E49\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              34260
            ]
          ],
          [
            "\u0E15\u0E32\u0E40\u0E01\u0E32",
            [
              34260
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              34260
            ]
          ],
          [
            "\u0E44\u0E1E\u0E1A\u0E39\u0E25\u0E22\u0E4C",
            [
              34260
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E49\u0E33\u0E22\u0E37\u0E19",
        [
          [
            "\u0E1A\u0E38\u0E40\u0E1B\u0E37\u0E2D\u0E22",
            [
              34260
            ]
          ],
          [
            "\u0E22\u0E32\u0E07",
            [
              34260
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              34260
            ]
          ],
          [
            "\u0E2A\u0E35\u0E27\u0E34\u0E40\u0E0A\u0E35\u0E22\u0E23",
            [
              34260
            ]
          ],
          [
            "\u0E40\u0E01\u0E48\u0E32\u0E02\u0E32\u0E21",
            [
              34260
            ]
          ],
          [
            "\u0E42\u0E0B\u0E07",
            [
              34260
            ]
          ],
          [
            "\u0E42\u0E14\u0E21\u0E1B\u0E23\u0E30\u0E14\u0E34\u0E29\u0E10\u0E4C",
            [
              34260
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E38\u0E13\u0E11\u0E23\u0E34\u0E01",
        [
          [
            "\u0E04\u0E2D\u0E41\u0E25\u0E19",
            [
              34230
            ]
          ],
          [
            "\u0E19\u0E32\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              34230
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E07\u0E32\u0E21",
            [
              34230
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E21\u0E14",
            [
              34230
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E30\u0E42\u0E19",
            [
              34230
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E02\u0E48\u0E32",
            [
              34230
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E04\u0E49\u0E2D",
            [
              34230
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E07\u0E32\u0E21",
            [
              34230
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E34\u0E1A\u0E39\u0E25\u0E21\u0E31\u0E07\u0E2A\u0E32\u0E2B\u0E32\u0E23",
        [
          [
            "\u0E01\u0E38\u0E14\u0E0A\u0E21\u0E20\u0E39",
            [
              34110
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E08\u0E34\u0E01",
            [
              34110
            ]
          ],
          [
            "\u0E17\u0E23\u0E32\u0E22\u0E21\u0E39\u0E25",
            [
              34110
            ]
          ],
          [
            "\u0E19\u0E32\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              34110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E02\u0E21",
            [
              34110
            ]
          ],
          [
            "\u0E1E\u0E34\u0E1A\u0E39\u0E25",
            [
              34110
            ]
          ],
          [
            "\u0E23\u0E30\u0E40\u0E27",
            [
              34110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27\u0E2E\u0E35",
            [
              34110
            ]
          ],
          [
            "\u0E2D\u0E48\u0E32\u0E07\u0E28\u0E34\u0E25\u0E32",
            [
              34110
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E01\u0E25\u0E32\u0E07",
            [
              34110
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E01\u0E32\u0E2B\u0E25\u0E07",
            [
              34110
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E28\u0E23\u0E35",
            [
              34110
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E44\u0E17\u0E23",
            [
              34110
            ]
          ],
          [
            "\u0E44\u0E23\u0E48\u0E43\u0E15\u0E49",
            [
              34110
            ]
          ]
        ]
      ],
      [
        "\u0E21\u0E48\u0E27\u0E07\u0E2A\u0E32\u0E21\u0E2A\u0E34\u0E1A",
        [
          [
            "\u0E14\u0E38\u0E21\u0E43\u0E2B\u0E0D\u0E48",
            [
              34140
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E25\u0E34\u0E07",
            [
              34140
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E2A\u0E32\u0E21\u0E2A\u0E34\u0E1A",
            [
              34140
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E2A\u0E31\u0E01\u0E01\u0E23\u0E30\u0E42\u0E1E\u0E2B\u0E25\u0E38\u0E48\u0E21",
            [
              34140
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E42\u0E22\u0E20\u0E32\u0E1E",
            [
              34140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E0A\u0E49\u0E32\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              34140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2E\u0E32\u0E07",
            [
              34140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              34140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E2B\u0E25\u0E48\u0E32",
            [
              34140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E02\u0E48\u0E19\u0E01",
            [
              34140
            ]
          ],
          [
            "\u0E40\u0E15\u0E22",
            [
              34140
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E1A\u0E01",
            [
              34140
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E41\u0E1E\u0E07",
            [
              34140
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E43\u0E2B\u0E0D\u0E48",
            [
              34140
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E32\u0E23\u0E34\u0E19\u0E0A\u0E33\u0E23\u0E32\u0E1A",
        [
          [
            "\u0E04\u0E33\u0E02\u0E27\u0E32\u0E07",
            [
              34190
            ]
          ],
          [
            "\u0E04\u0E33\u0E19\u0E49\u0E33\u0E41\u0E0B\u0E1A",
            [
              34190
            ]
          ],
          [
            "\u0E04\u0E39\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              34190
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E25\u0E32\u0E14",
            [
              34310
            ]
          ],
          [
            "\u0E18\u0E32\u0E15\u0E38",
            [
              34190
            ]
          ],
          [
            "\u0E1A\u0E38\u0E48\u0E07\u0E2B\u0E27\u0E32\u0E22",
            [
              34310
            ]
          ],
          [
            "\u0E1A\u0E38\u0E48\u0E07\u0E44\u0E2B\u0E21",
            [
              34190
            ]
          ],
          [
            "\u0E27\u0E32\u0E23\u0E34\u0E19\u0E0A\u0E33\u0E23\u0E32\u0E1A",
            [
              34190
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E2A\u0E21\u0E34\u0E07",
            [
              34190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E34\u0E19\u0E40\u0E1E\u0E25",
            [
              34190
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E02\u0E30\u0E22\u0E39\u0E07",
            [
              34310
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E28\u0E23\u0E35\u0E44\u0E04",
            [
              34190
            ]
          ],
          [
            "\u0E41\u0E2A\u0E19\u0E2A\u0E38\u0E02",
            [
              34190
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E1C\u0E36\u0E49\u0E07",
            [
              34190
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E42\u0E2B\u0E19\u0E19",
            [
              34190
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E43\u0E2B\u0E0D\u0E48",
            [
              34190
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48",
        [
          [
            "\u0E04\u0E33\u0E44\u0E2B\u0E25",
            [
              34250
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E43\u0E2B\u0E0D\u0E48",
            [
              34250
            ]
          ],
          [
            "\u0E15\u0E30\u0E1A\u0E48\u0E32\u0E22",
            [
              34250
            ]
          ],
          [
            "\u0E19\u0E32\u0E04\u0E33",
            [
              34250
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E25\u0E34\u0E19",
            [
              34250
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E04\u0E27\u0E32\u0E22",
            [
              34250
            ]
          ],
          [
            "\u0E27\u0E32\u0E23\u0E34\u0E19",
            [
              34250
            ]
          ],
          [
            "\u0E2A\u0E07\u0E22\u0E32\u0E07",
            [
              34250
            ]
          ],
          [
            "\u0E2B\u0E19\u0E32\u0E21\u0E41\u0E17\u0E48\u0E07",
            [
              34250
            ]
          ],
          [
            "\u0E40\u0E2D\u0E37\u0E2D\u0E14\u0E43\u0E2B\u0E0D\u0E48",
            [
              34250
            ]
          ],
          [
            "\u0E41\u0E01\u0E49\u0E07\u0E01\u0E2D\u0E01",
            [
              34250
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E27\u0E48\u0E32\u0E07\u0E27\u0E35\u0E23\u0E30\u0E27\u0E07\u0E28\u0E4C",
        [
          [
            "\u0E17\u0E48\u0E32\u0E0A\u0E49\u0E32\u0E07",
            [
              34190
            ]
          ],
          [
            "\u0E1A\u0E38\u0E48\u0E07\u0E21\u0E30\u0E41\u0E25\u0E07",
            [
              34190
            ]
          ],
          [
            "\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              34190
            ]
          ],
          [
            "\u0E41\u0E01\u0E48\u0E07\u0E42\u0E14\u0E21",
            [
              34190
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E33\u0E42\u0E23\u0E07",
        [
          [
            "\u0E02\u0E32\u0E21\u0E1B\u0E49\u0E2D\u0E21",
            [
              34360
            ]
          ],
          [
            "\u0E04\u0E49\u0E2D\u0E19\u0E49\u0E2D\u0E22",
            [
              34360
            ]
          ],
          [
            "\u0E1A\u0E2D\u0E19",
            [
              34360
            ]
          ],
          [
            "\u0E2A\u0E33\u0E42\u0E23\u0E07",
            [
              34360
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E2E",
            [
              34360
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E01\u0E48\u0E2D\u0E07",
            [
              34360
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              34360
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E01\u0E25\u0E32\u0E07",
            [
              34360
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E01\u0E32\u0E40\u0E25\u0E47\u0E19",
            [
              34360
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E34\u0E23\u0E34\u0E19\u0E18\u0E23",
        [
          [
            "\u0E04\u0E31\u0E19\u0E44\u0E23\u0E48",
            [
              34350
            ]
          ],
          [
            "\u0E04\u0E33\u0E40\u0E02\u0E37\u0E48\u0E2D\u0E19\u0E41\u0E01\u0E49\u0E27",
            [
              34350
            ]
          ],
          [
            "\u0E0A\u0E48\u0E2D\u0E07\u0E40\u0E21\u0E47\u0E01",
            [
              34350
            ]
          ],
          [
            "\u0E19\u0E34\u0E04\u0E21\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E15\u0E19\u0E40\u0E2D\u0E07\u0E25\u0E33\u0E42\u0E14\u0E21\u0E19\u0E49\u0E2D\u0E22",
            [
              34350
            ]
          ],
          [
            "\u0E1D\u0E32\u0E07\u0E04\u0E33",
            [
              34350
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E01\u0E48\u0E2D",
            [
              34350
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E02\u0E21\u0E23\u0E32\u0E10",
        [
          [
            "\u0E02\u0E32\u0E21\u0E1B\u0E49\u0E2D\u0E21",
            [
              34170
            ]
          ],
          [
            "\u0E19\u0E32\u0E41\u0E27\u0E07",
            [
              34170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E19\u0E01\u0E17\u0E32",
            [
              34170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1C\u0E37\u0E2D",
            [
              34170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E34\u0E21",
            [
              34170
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E19\u0E32",
            [
              34170
            ]
          ],
          [
            "\u0E40\u0E02\u0E21\u0E23\u0E32\u0E10",
            [
              34170
            ]
          ],
          [
            "\u0E40\u0E08\u0E35\u0E22\u0E14",
            [
              34170
            ]
          ],
          [
            "\u0E41\u0E01\u0E49\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              34170
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E02\u0E37\u0E48\u0E2D\u0E07\u0E43\u0E19",
        [
          [
            "\u0E01\u0E25\u0E32\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              34320
            ]
          ],
          [
            "\u0E01\u0E48\u0E2D\u0E40\u0E2D\u0E49",
            [
              34150
            ]
          ],
          [
            "\u0E04\u0E49\u0E2D\u0E17\u0E2D\u0E07",
            [
              34150
            ]
          ],
          [
            "\u0E0A\u0E35\u0E17\u0E27\u0E19",
            [
              34150
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E44\u0E2B",
            [
              34150
            ]
          ],
          [
            "\u0E18\u0E32\u0E15\u0E38\u0E19\u0E49\u0E2D\u0E22",
            [
              34150
            ]
          ],
          [
            "\u0E19\u0E32\u0E04\u0E33\u0E43\u0E2B\u0E0D\u0E48",
            [
              34150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E2D\u0E01",
            [
              34320
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E44\u0E17\u0E22",
            [
              34320
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E02\u0E35\u0E49\u0E19\u0E01",
            [
              34150
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E38\u0E02",
            [
              34150
            ]
          ],
          [
            "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E16\u0E48\u0E2D",
            [
              34150
            ]
          ],
          [
            "\u0E2A\u0E2B\u0E18\u0E32\u0E15\u0E38",
            [
              34150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E40\u0E2B\u0E25\u0E48\u0E32",
            [
              34150
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E14\u0E2D\u0E19",
            [
              34150
            ]
          ],
          [
            "\u0E40\u0E02\u0E37\u0E48\u0E2D\u0E07\u0E43\u0E19",
            [
              34150
            ]
          ],
          [
            "\u0E41\u0E14\u0E07\u0E2B\u0E21\u0E49\u0E2D",
            [
              34150
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E23\u0E31\u0E07",
            [
              34320
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E14\u0E0A\u0E2D\u0E38\u0E14\u0E21",
        [
          [
            "\u0E01\u0E25\u0E32\u0E07",
            [
              34160
            ]
          ],
          [
            "\u0E01\u0E38\u0E14\u0E1B\u0E23\u0E30\u0E17\u0E32\u0E22",
            [
              34160
            ]
          ],
          [
            "\u0E04\u0E33\u0E04\u0E23\u0E31\u0E48\u0E07",
            [
              34160
            ]
          ],
          [
            "\u0E15\u0E1A\u0E2B\u0E39",
            [
              34160
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E40\u0E17\u0E34\u0E07",
            [
              34160
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E28\u0E23\u0E35",
            [
              34160
            ]
          ],
          [
            "\u0E19\u0E32\u0E01\u0E23\u0E30\u0E41\u0E0B\u0E07",
            [
              34160
            ]
          ],
          [
            "\u0E19\u0E32\u0E2A\u0E48\u0E27\u0E07",
            [
              34160
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E08\u0E23\u0E34\u0E0D",
            [
              34160
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E07\u0E32\u0E21",
            [
              34160
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E42\u0E21\u0E07",
            [
              34160
            ]
          ],
          [
            "\u0E2A\u0E21\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              34160
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E14\u0E0A",
            [
              34160
            ]
          ],
          [
            "\u0E41\u0E01\u0E49\u0E07",
            [
              34160
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              34160
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E07\u0E32\u0E21",
            [
              34160
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2D\u0E38\u0E1A\u0E25\u0E23\u0E32\u0E0A\u0E18\u0E32\u0E19\u0E35",
        [
          [
            "\u0E01\u0E23\u0E30\u0E42\u0E2A\u0E1A",
            [
              34e3
            ]
          ],
          [
            "\u0E01\u0E38\u0E14\u0E25\u0E32\u0E14",
            [
              34e3
            ]
          ],
          [
            "\u0E02\u0E32\u0E21\u0E43\u0E2B\u0E0D\u0E48",
            [
              34e3
            ]
          ],
          [
            "\u0E02\u0E35\u0E49\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              34e3
            ]
          ],
          [
            "\u0E1B\u0E17\u0E38\u0E21",
            [
              34e3
            ]
          ],
          [
            "\u0E1B\u0E30\u0E2D\u0E32\u0E27",
            [
              34e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E2D\u0E19",
            [
              34e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E48\u0E2D",
            [
              34e3
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E40\u0E23\u0E37\u0E2D",
            [
              34e3
            ]
          ],
          [
            "\u0E41\u0E08\u0E23\u0E30\u0E41\u0E21",
            [
              34e3
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              34e3
            ]
          ],
          [
            "\u0E44\u0E23\u0E48\u0E19\u0E49\u0E2D\u0E22",
            [
              34e3
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E40\u0E2A\u0E37\u0E2D\u0E42\u0E01\u0E49\u0E01",
        [
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E01",
            [
              34e3
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E40\u0E2A\u0E37\u0E2D\u0E42\u0E01\u0E49\u0E01",
            [
              34e3
            ]
          ],
          [
            "\u0E41\u0E1E\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              34e3
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              34e3
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E02\u0E07\u0E40\u0E08\u0E35\u0E22\u0E21",
        [
          [
            "\u0E19\u0E32\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E01\u0E25\u0E32\u0E07",
            [
              34220
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E2A\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              34220
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E22\u0E32\u0E07",
            [
              34220
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E44\u0E1C\u0E48",
            [
              34220
            ]
          ],
          [
            "\u0E42\u0E02\u0E07\u0E40\u0E08\u0E35\u0E22\u0E21",
            [
              34220
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E44\u0E17\u0E23",
        [
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              34340
            ]
          ],
          [
            "\u0E2A\u0E2D\u0E07\u0E04\u0E2D\u0E19",
            [
              34340
            ]
          ],
          [
            "\u0E2A\u0E32\u0E23\u0E20\u0E35",
            [
              34340
            ]
          ],
          [
            "\u0E2A\u0E33\u0E42\u0E23\u0E07",
            [
              34340
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E07\u0E32\u0E21",
            [
              34340
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E44\u0E17\u0E23",
            [
              34340
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E2D\u0E48\u0E32\u0E07\u0E17\u0E2D\u0E07",
    [
      [
        "\u0E1B\u0E48\u0E32\u0E42\u0E21\u0E01",
        [
          [
            "\u0E19\u0E23\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
            [
              14130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1B\u0E25\u0E32\u0E01\u0E14",
            [
              14130
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E2A\u0E14\u0E47\u0E08",
            [
              14130
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E42\u0E21\u0E01",
            [
              14130
            ]
          ],
          [
            "\u0E2A\u0E32\u0E22\u0E17\u0E2D\u0E07",
            [
              14130
            ]
          ],
          [
            "\u0E40\u0E2D\u0E01\u0E23\u0E32\u0E0A",
            [
              14130
            ]
          ],
          [
            "\u0E42\u0E1C\u0E07\u0E40\u0E1C\u0E07",
            [
              14130
            ]
          ],
          [
            "\u0E42\u0E23\u0E07\u0E0A\u0E49\u0E32\u0E07",
            [
              14130
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E34\u0E40\u0E28\u0E29\u0E0A\u0E31\u0E22\u0E0A\u0E32\u0E0D",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E02\u0E19\u0E32\u0E01",
            [
              14110
            ]
          ],
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E43\u0E2B\u0E21\u0E48",
            [
              14110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E0A\u0E49\u0E32\u0E07",
            [
              14110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E08\u0E31\u0E01",
            [
              14110
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E40\u0E15\u0E35\u0E49\u0E22",
            [
              14110
            ]
          ],
          [
            "\u0E22\u0E35\u0E48\u0E25\u0E49\u0E19",
            [
              14110
            ]
          ],
          [
            "\u0E28\u0E32\u0E25\u0E40\u0E08\u0E49\u0E32\u0E42\u0E23\u0E07\u0E17\u0E2D\u0E07",
            [
              14110
            ]
          ],
          [
            "\u0E2A\u0E32\u0E27\u0E23\u0E49\u0E2D\u0E07\u0E44\u0E2B\u0E49",
            [
              14110
            ]
          ],
          [
            "\u0E2A\u0E35\u0E48\u0E23\u0E49\u0E2D\u0E22",
            [
              14110
            ]
          ],
          [
            "\u0E2B\u0E25\u0E31\u0E01\u0E41\u0E01\u0E49\u0E27",
            [
              14110
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E15\u0E30\u0E1E\u0E32\u0E19",
            [
              14110
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E04\u0E31\u0E19\u0E41\u0E2B\u0E25\u0E19",
            [
              14110
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E08\u0E33\u0E28\u0E35\u0E25",
            [
              14110
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E14\u0E33\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              14110
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E27\u0E07",
            [
              14110
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E32\u0E21\u0E42\u0E01\u0E49",
        [
          [
            "\u0E21\u0E07\u0E04\u0E25\u0E18\u0E23\u0E23\u0E21\u0E19\u0E34\u0E21\u0E34\u0E15",
            [
              14160
            ]
          ],
          [
            "\u0E23\u0E32\u0E29\u0E0E\u0E23\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              14160
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E42\u0E01\u0E49",
            [
              14160
            ]
          ],
          [
            "\u0E2D\u0E1A\u0E17\u0E21",
            [
              14160
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E21\u0E48\u0E27\u0E07\u0E1E\u0E31\u0E19\u0E18\u0E4C",
            [
              14160
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E2D\u0E48\u0E32\u0E07\u0E17\u0E2D\u0E07",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E27\u0E31\u0E27",
            [
              14e3
            ]
          ],
          [
            "\u0E08\u0E33\u0E1B\u0E32\u0E2B\u0E25\u0E48\u0E2D",
            [
              14e3
            ]
          ],
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E01\u0E23\u0E27\u0E14",
            [
              14e3
            ]
          ],
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E2B\u0E25\u0E27\u0E07",
            [
              14e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              14e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E23\u0E35",
            [
              14e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2D\u0E34\u0E10",
            [
              14e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E2B",
            [
              14e3
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E07\u0E34\u0E49\u0E27",
            [
              14e3
            ]
          ],
          [
            "\u0E21\u0E2B\u0E32\u0E14\u0E44\u0E17\u0E22",
            [
              14e3
            ]
          ],
          [
            "\u0E22\u0E48\u0E32\u0E19\u0E0B\u0E37\u0E48\u0E2D",
            [
              14e3
            ]
          ],
          [
            "\u0E28\u0E32\u0E25\u0E32\u0E41\u0E14\u0E07",
            [
              14e3
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E44\u0E1C\u0E48",
            [
              14e3
            ]
          ],
          [
            "\u0E42\u0E1E\u0E2A\u0E30",
            [
              14e3
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E2A\u0E27\u0E07\u0E2B\u0E32",
        [
          [
            "\u0E08\u0E33\u0E25\u0E2D\u0E07",
            [
              14150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1E\u0E23\u0E32\u0E19",
            [
              14150
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E19\u0E49\u0E33\u0E40\u0E22\u0E47\u0E19",
            [
              14150
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E1E\u0E23\u0E32\u0E19",
            [
              14150
            ]
          ],
          [
            "\u0E2A\u0E35\u0E1A\u0E31\u0E27\u0E17\u0E2D\u0E07",
            [
              14150
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E44\u0E1C\u0E48",
            [
              14150
            ]
          ],
          [
            "\u0E41\u0E2A\u0E27\u0E07\u0E2B\u0E32",
            [
              14150
            ]
          ]
        ]
      ],
      [
        "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E17\u0E2D\u0E07",
        [
          [
            "\u0E04\u0E33\u0E2B\u0E22\u0E32\u0E14",
            [
              14120
            ]
          ],
          [
            "\u0E17\u0E32\u0E07\u0E1E\u0E23\u0E30",
            [
              14120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E1E\u0E25\u0E31\u0E1A",
            [
              14120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E23\u0E30\u0E01\u0E33",
            [
              14120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E08\u0E49\u0E32\u0E09\u0E48\u0E32",
            [
              14120
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E41\u0E23\u0E48",
            [
              14120
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E0A\u0E49\u0E32\u0E22",
            [
              14120
            ]
          ],
          [
            "\u0E23\u0E33\u0E21\u0E30\u0E2A\u0E31\u0E01",
            [
              14120
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E07\u0E48\u0E32\u0E21",
            [
              14120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E21\u0E48\u0E44\u0E01\u0E48",
            [
              14120
            ]
          ],
          [
            "\u0E2D\u0E07\u0E04\u0E23\u0E31\u0E01\u0E29\u0E4C",
            [
              14120
            ]
          ],
          [
            "\u0E2D\u0E34\u0E19\u0E17\u0E1B\u0E23\u0E30\u0E21\u0E39\u0E25",
            [
              14120
            ]
          ],
          [
            "\u0E2D\u0E48\u0E32\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              14120
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E1E\u0E38\u0E17\u0E23\u0E32",
            [
              14120
            ]
          ],
          [
            "\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E23\u0E31\u0E07\u0E19\u0E01",
            [
              14120
            ]
          ]
        ]
      ],
      [
        "\u0E44\u0E0A\u0E42\u0E22",
        [
          [
            "\u0E08\u0E23\u0E40\u0E02\u0E49\u0E23\u0E49\u0E2D\u0E07",
            [
              14140
            ]
          ],
          [
            "\u0E0A\u0E30\u0E44\u0E27",
            [
              14140
            ]
          ],
          [
            "\u0E0A\u0E31\u0E22\u0E24\u0E17\u0E18\u0E34\u0E4C",
            [
              14140
            ]
          ],
          [
            "\u0E15\u0E23\u0E35\u0E13\u0E23\u0E07\u0E04\u0E4C",
            [
              14140
            ]
          ],
          [
            "\u0E23\u0E32\u0E0A\u0E2A\u0E16\u0E34\u0E15\u0E22\u0E4C",
            [
              14140
            ]
          ],
          [
            "\u0E2B\u0E25\u0E31\u0E01\u0E1F\u0E49\u0E32",
            [
              14140
            ]
          ],
          [
            "\u0E40\u0E17\u0E27\u0E23\u0E32\u0E0A",
            [
              14140
            ]
          ],
          [
            "\u0E44\u0E0A\u0E22\u0E20\u0E39\u0E21\u0E34",
            [
              14140
            ]
          ],
          [
            "\u0E44\u0E0A\u0E42\u0E22",
            [
              14140
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E23\u0E32\u0E22",
    [
      [
        "\u0E02\u0E38\u0E19\u0E15\u0E32\u0E25",
        [
          [
            "\u0E15\u0E49\u0E32",
            [
              57340
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E15\u0E32\u0E25",
            [
              57340
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E2E\u0E2D\u0E21",
            [
              57340
            ]
          ]
        ]
      ],
      [
        "\u0E14\u0E2D\u0E22\u0E2B\u0E25\u0E27\u0E07",
        [
          [
            "\u0E1B\u0E07\u0E19\u0E49\u0E2D\u0E22",
            [
              57110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E48\u0E32\u0E01\u0E48\u0E2D",
            [
              57110
            ]
          ],
          [
            "\u0E42\u0E0A\u0E04\u0E0A\u0E31\u0E22",
            [
              57110
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E48\u0E32\u0E41\u0E14\u0E14",
        [
          [
            "\u0E1B\u0E48\u0E32\u0E41\u0E07\u0E30",
            [
              57190
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E41\u0E14\u0E14",
            [
              57190
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E42\u0E1E\u0E18\u0E34\u0E4C\u0E40\u0E07\u0E34\u0E19",
            [
              57190
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E21\u0E30\u0E04\u0E48\u0E32",
            [
              57190
            ]
          ],
          [
            "\u0E42\u0E23\u0E07\u0E0A\u0E49\u0E32\u0E07",
            [
              57190
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E0D\u0E32\u0E40\u0E21\u0E47\u0E07\u0E23\u0E32\u0E22",
        [
          [
            "\u0E15\u0E32\u0E14\u0E04\u0E27\u0E31\u0E19",
            [
              57290
            ]
          ],
          [
            "\u0E40\u0E21\u0E47\u0E07\u0E23\u0E32\u0E22",
            [
              57290
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E15\u0E4B\u0E33",
            [
              57290
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E40\u0E1B\u0E32",
            [
              57290
            ]
          ],
          [
            "\u0E44\u0E21\u0E49\u0E22\u0E32",
            [
              57290
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E32\u0E19",
        [
          [
            "\u0E14\u0E2D\u0E22\u0E07\u0E32\u0E21",
            [
              57120
            ]
          ],
          [
            "\u0E17\u0E23\u0E32\u0E22\u0E02\u0E32\u0E27",
            [
              57120
            ]
          ],
          [
            "\u0E17\u0E32\u0E19\u0E15\u0E30\u0E27\u0E31\u0E19",
            [
              57280
            ]
          ],
          [
            "\u0E18\u0E32\u0E23\u0E17\u0E2D\u0E07",
            [
              57250
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E2B\u0E38\u0E48\u0E07",
            [
              57120
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E04\u0E33",
            [
              57120
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E01\u0E25\u0E32\u0E07",
            [
              57120
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E15\u0E34\u0E2A\u0E38\u0E02",
            [
              57120
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E21\u0E30\u0E40\u0E04\u0E47\u0E14",
            [
              57120
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E07\u0E49\u0E21",
            [
              57120
            ]
          ],
          [
            "\u0E40\u0E08\u0E23\u0E34\u0E0D\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              57120
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1E\u0E32\u0E19",
            [
              57120
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E2B\u0E49\u0E32\u0E27",
            [
              57120
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2D\u0E49\u0E2D",
            [
              57120
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E40\u0E22\u0E47\u0E19",
            [
              57280
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E02\u0E2D\u0E07",
        [
          [
            "\u0E04\u0E23\u0E36\u0E48\u0E07",
            [
              57140
            ]
          ],
          [
            "\u0E1A\u0E38\u0E0D\u0E40\u0E23\u0E37\u0E2D\u0E07",
            [
              57140
            ]
          ],
          [
            "\u0E23\u0E34\u0E21\u0E42\u0E02\u0E07",
            [
              57140
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E14\u0E2D\u0E19\u0E0A\u0E31\u0E22",
            [
              57140
            ]
          ],
          [
            "\u0E2A\u0E16\u0E32\u0E19",
            [
              57140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E0B\u0E49\u0E2D",
            [
              57140
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              57140
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E41\u0E2A\u0E19",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E0B\u0E27",
            [
              57150
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E2A\u0E31\u0E01",
            [
              57150
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E14\u0E2D\u0E19\u0E21\u0E39\u0E25",
            [
              57150
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              57150
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E40\u0E07\u0E34\u0E19",
            [
              57150
            ]
          ],
          [
            "\u0E42\u0E22\u0E19\u0E01",
            [
              57150
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E17\u0E34\u0E07",
        [
          [
            "\u0E07\u0E34\u0E49\u0E27",
            [
              57160
            ]
          ],
          [
            "\u0E15\u0E31\u0E1A\u0E40\u0E15\u0E48\u0E32",
            [
              57160
            ]
          ],
          [
            "\u0E1B\u0E25\u0E49\u0E2D\u0E07",
            [
              57230
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E14\u0E2D\u0E19\u0E44\u0E0A\u0E22",
            [
              57230
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E17\u0E23\u0E32\u0E22\u0E07\u0E32\u0E21",
            [
              57160
            ]
          ],
          [
            "\u0E2B\u0E07\u0E32\u0E27",
            [
              57160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E23\u0E14",
            [
              57230
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E40\u0E04\u0E35\u0E48\u0E22\u0E19",
            [
              57230
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              57160
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E25\u0E2D\u0E22",
            [
              57230
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E23\u0E32\u0E22",
        [
          [
            "\u0E14\u0E2D\u0E22\u0E25\u0E32\u0E19",
            [
              57e3
            ]
          ],
          [
            "\u0E14\u0E2D\u0E22\u0E2E\u0E32\u0E07",
            [
              57e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2A\u0E32\u0E22",
            [
              57e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2A\u0E38\u0E14",
            [
              57100
            ]
          ],
          [
            "\u0E19\u0E32\u0E07\u0E41\u0E25",
            [
              57100
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E14\u0E39\u0E48",
            [
              57100
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E2D\u0E49\u0E2D\u0E14\u0E2D\u0E19\u0E0A\u0E31\u0E22",
            [
              57e3
            ]
          ],
          [
            "\u0E23\u0E2D\u0E1A\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              57e3
            ]
          ],
          [
            "\u0E23\u0E34\u0E21\u0E01\u0E01",
            [
              57100
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E17\u0E23\u0E32\u0E22",
            [
              57e3
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E0A\u0E21\u0E20\u0E39",
            [
              57e3
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E2A\u0E31\u0E01",
            [
              57e3
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              57e3
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E01\u0E23\u0E13\u0E4C",
            [
              57e3
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E02\u0E49\u0E32\u0E27\u0E15\u0E49\u0E21",
            [
              57100
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E22\u0E32\u0E27",
            [
              57100
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E0A\u0E31\u0E22",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E28\u0E34\u0E25\u0E32",
            [
              57210
            ]
          ],
          [
            "\u0E1C\u0E32\u0E07\u0E32\u0E21",
            [
              57210
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E0A\u0E38\u0E21",
            [
              57210
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E0A\u0E31\u0E22",
            [
              57210
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              57210
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E1B\u0E48\u0E32\u0E40\u0E1B\u0E49\u0E32",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E1B\u0E48\u0E07",
            [
              57170
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E07\u0E34\u0E49\u0E27",
            [
              57170
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E2A\u0E25\u0E35",
            [
              57170
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              57170
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E01\u0E32\u0E2B\u0E25\u0E07",
            [
              57260
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E40\u0E08\u0E14\u0E35\u0E22\u0E4C",
            [
              57260
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E40\u0E08\u0E14\u0E35\u0E22\u0E4C\u0E43\u0E2B\u0E21\u0E48",
            [
              57260
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E23\u0E38\u0E49\u0E07",
        [
          [
            "\u0E14\u0E07\u0E21\u0E2B\u0E32\u0E27\u0E31\u0E19",
            [
              57210
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E01\u0E48\u0E2D",
            [
              57210
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E0B\u0E32\u0E07",
            [
              57210
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E41\u0E01\u0E48\u0E19",
        [
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E49\u0E32\u0E21",
            [
              57310
            ]
          ],
          [
            "\u0E1B\u0E2D",
            [
              57310
            ]
          ],
          [
            "\u0E21\u0E48\u0E27\u0E07\u0E22\u0E32\u0E22",
            [
              57310
            ]
          ],
          [
            "\u0E2B\u0E25\u0E48\u0E32\u0E22\u0E07\u0E32\u0E27",
            [
              57310
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E08\u0E31\u0E19",
        [
          [
            "\u0E08\u0E2D\u0E21\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
            [
              57110
            ]
          ],
          [
            "\u0E08\u0E31\u0E19\u0E08\u0E27\u0E49\u0E32",
            [
              57270
            ]
          ],
          [
            "\u0E08\u0E31\u0E19\u0E08\u0E27\u0E49\u0E32\u0E43\u0E15\u0E49",
            [
              57270
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E49\u0E32\u0E27\u0E40\u0E1B\u0E25\u0E37\u0E2D\u0E01",
            [
              57110
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E0B\u0E32\u0E07",
            [
              57110
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E15\u0E36\u0E07",
            [
              57110
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E04\u0E49\u0E33",
            [
              57110
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E17\u0E23\u0E32\u0E22",
            [
              57110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E04\u0E33",
            [
              57240
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E08\u0E31\u0E19",
            [
              57110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E44\u0E23\u0E48",
            [
              57240
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E1F\u0E49\u0E32\u0E2B\u0E25\u0E27\u0E07",
        [
          [
            "\u0E40\u0E17\u0E2D\u0E14\u0E44\u0E17\u0E22",
            [
              57240
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E1F\u0E49\u0E32\u0E2B\u0E25\u0E27\u0E07",
            [
              57240
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E25\u0E2D\u0E07\u0E19\u0E2D\u0E01",
            [
              57110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E25\u0E2D\u0E07\u0E43\u0E19",
            [
              57110
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E25\u0E32\u0E27",
        [
          [
            "\u0E08\u0E2D\u0E21\u0E2B\u0E21\u0E2D\u0E01\u0E41\u0E01\u0E49\u0E27",
            [
              57250
            ]
          ],
          [
            "\u0E14\u0E07\u0E21\u0E30\u0E14\u0E30",
            [
              57250
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E2A\u0E25\u0E35",
            [
              57250
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E01\u0E48\u0E2D\u0E14\u0E33",
            [
              57250
            ]
          ],
          [
            "\u0E42\u0E1B\u0E48\u0E07\u0E41\u0E1E\u0E23\u0E48",
            [
              57e3
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E2A\u0E23\u0E27\u0E22",
        [
          [
            "\u0E17\u0E48\u0E32\u0E01\u0E4A\u0E2D",
            [
              57180
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E41\u0E14\u0E14",
            [
              57180
            ]
          ],
          [
            "\u0E27\u0E32\u0E27\u0E35",
            [
              57180
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E16\u0E49\u0E2D\u0E22",
            [
              57180
            ]
          ],
          [
            "\u0E40\u0E08\u0E14\u0E35\u0E22\u0E4C\u0E2B\u0E25\u0E27\u0E07",
            [
              57180
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E1E\u0E23\u0E34\u0E01",
            [
              57180
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E23\u0E27\u0E22",
            [
              57180
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E2A\u0E32\u0E22",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E14\u0E49\u0E32\u0E22",
            [
              57220
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E0A\u0E38\u0E21",
            [
              57130
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E44\u0E04\u0E23\u0E49",
            [
              57220
            ]
          ],
          [
            "\u0E40\u0E01\u0E32\u0E30\u0E0A\u0E49\u0E32\u0E07",
            [
              57130
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E1E\u0E32\u0E07\u0E04\u0E33",
            [
              57130
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E32\u0E22",
            [
              57130
            ]
          ],
          [
            "\u0E42\u0E1B\u0E48\u0E07\u0E07\u0E32\u0E21",
            [
              57130
            ]
          ],
          [
            "\u0E42\u0E1B\u0E48\u0E07\u0E1C\u0E32",
            [
              57130
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E43\u0E2B\u0E21\u0E48",
    [
      [
        "\u0E01\u0E31\u0E25\u0E22\u0E32\u0E13\u0E34\u0E27\u0E31\u0E12\u0E19\u0E32",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
            [
              58130
            ]
          ],
          [
            "\u0E41\u0E08\u0E48\u0E21\u0E2B\u0E25\u0E27\u0E07",
            [
              58130
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E41\u0E14\u0E14",
            [
              58130
            ]
          ]
        ]
      ],
      [
        "\u0E08\u0E2D\u0E21\u0E17\u0E2D\u0E07",
        [
          [
            "\u0E02\u0E48\u0E27\u0E07\u0E40\u0E1B\u0E32",
            [
              50160
            ]
          ],
          [
            "\u0E14\u0E2D\u0E22\u0E41\u0E01\u0E49\u0E27",
            [
              50160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E25\u0E27\u0E07",
            [
              50160
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E1B\u0E30",
            [
              50240
            ]
          ],
          [
            "\u0E2A\u0E1A\u0E40\u0E15\u0E35\u0E4A\u0E22\u0E30",
            [
              50160
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E2D\u0E22",
            [
              50240
            ]
          ]
        ]
      ],
      [
        "\u0E14\u0E2D\u0E22\u0E2A\u0E30\u0E40\u0E01\u0E47\u0E14",
        [
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E02\u0E27\u0E31\u0E0D",
            [
              50220
            ]
          ],
          [
            "\u0E15\u0E25\u0E32\u0E14\u0E43\u0E2B\u0E0D\u0E48",
            [
              50220
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E1B\u0E49\u0E2D\u0E07",
            [
              50220
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E25\u0E32\u0E19",
            [
              50220
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E40\u0E21\u0E35\u0E48\u0E22\u0E07",
            [
              50220
            ]
          ],
          [
            "\u0E25\u0E27\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              50220
            ]
          ],
          [
            "\u0E2A\u0E07\u0E48\u0E32\u0E1A\u0E49\u0E32\u0E19",
            [
              50220
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E1B\u0E39\u0E40\u0E25\u0E22",
            [
              50220
            ]
          ],
          [
            "\u0E2A\u0E33\u0E23\u0E32\u0E0D\u0E23\u0E32\u0E29\u0E0E\u0E23\u0E4C",
            [
              50220
            ]
          ],
          [
            "\u0E40\u0E0A\u0E34\u0E07\u0E14\u0E2D\u0E22",
            [
              50220
            ]
          ],
          [
            "\u0E40\u0E17\u0E1E\u0E40\u0E2A\u0E14\u0E47\u0E08",
            [
              50220
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E04\u0E37\u0E2D",
            [
              50220
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2E\u0E49\u0E2D\u0E22\u0E40\u0E07\u0E34\u0E19",
            [
              50220
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E42\u0E1B\u0E48\u0E07",
            [
              50220
            ]
          ]
        ]
      ],
      [
        "\u0E14\u0E2D\u0E22\u0E2B\u0E25\u0E48\u0E2D",
        [
          [
            "\u0E14\u0E2D\u0E22\u0E2B\u0E25\u0E48\u0E2D",
            [
              50160
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E04\u0E23\u0E32\u0E21",
            [
              50160
            ]
          ],
          [
            "\u0E2A\u0E2D\u0E07\u0E41\u0E04\u0E27",
            [
              50160
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E15\u0E34\u0E2A\u0E38\u0E02",
            [
              50160
            ]
          ]
        ]
      ],
      [
        "\u0E14\u0E2D\u0E22\u0E40\u0E15\u0E48\u0E32",
        [
          [
            "\u0E14\u0E2D\u0E22\u0E40\u0E15\u0E48\u0E32",
            [
              50260
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E14\u0E37\u0E48\u0E2D",
            [
              50260
            ]
          ],
          [
            "\u0E1A\u0E07\u0E15\u0E31\u0E19",
            [
              50260
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E2D\u0E48\u0E19",
            [
              50260
            ]
          ],
          [
            "\u0E21\u0E37\u0E14\u0E01\u0E32",
            [
              50260
            ]
          ],
          [
            "\u0E42\u0E1B\u0E07\u0E17\u0E38\u0E48\u0E07",
            [
              50260
            ]
          ]
        ]
      ],
      [
        "\u0E1D\u0E32\u0E07",
        [
          [
            "\u0E21\u0E48\u0E2D\u0E19\u0E1B\u0E34\u0E48\u0E19",
            [
              50110
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E17\u0E23\u0E32\u0E22",
            [
              50110
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              50110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E02\u0E48\u0E32",
            [
              50320
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E04\u0E30",
            [
              50110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E07\u0E2D\u0E19",
            [
              50320
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E39\u0E19",
            [
              50110
            ]
          ],
          [
            "\u0E42\u0E1B\u0E48\u0E07\u0E19\u0E49\u0E33\u0E23\u0E49\u0E2D\u0E19",
            [
              50110
            ]
          ]
        ]
      ],
      [
        "\u0E1E\u0E23\u0E49\u0E32\u0E27",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              50190
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E41\u0E1E\u0E23\u0E48",
            [
              50190
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E1B\u0E48\u0E07",
            [
              50190
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E15\u0E38\u0E49\u0E21",
            [
              50190
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E44\u0E2B\u0E19\u0E48",
            [
              50190
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E17\u0E23\u0E32\u0E22",
            [
              50190
            ]
          ],
          [
            "\u0E40\u0E02\u0E37\u0E48\u0E2D\u0E19\u0E1C\u0E32\u0E01",
            [
              50190
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              50190
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E1B\u0E31\u0E4B\u0E07",
            [
              50190
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E41\u0E27\u0E19",
            [
              50190
            ]
          ],
          [
            "\u0E42\u0E2B\u0E25\u0E48\u0E07\u0E02\u0E2D\u0E14",
            [
              50190
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E30\u0E40\u0E21\u0E34\u0E07",
        [
          [
            "\u0E1A\u0E48\u0E2D\u0E41\u0E01\u0E49\u0E27",
            [
              50250
            ]
          ],
          [
            "\u0E22\u0E31\u0E49\u0E07\u0E40\u0E21\u0E34\u0E19",
            [
              50250
            ]
          ],
          [
            "\u0E2A\u0E30\u0E40\u0E21\u0E34\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              50250
            ]
          ],
          [
            "\u0E2A\u0E30\u0E40\u0E21\u0E34\u0E07\u0E43\u0E15\u0E49",
            [
              50250
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E32\u0E1A",
            [
              50250
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E31\u0E19\u0E01\u0E33\u0E41\u0E1E\u0E07",
        [
          [
            "\u0E15\u0E49\u0E19\u0E40\u0E1B\u0E32",
            [
              50130
            ]
          ],
          [
            "\u0E17\u0E23\u0E32\u0E22\u0E21\u0E39\u0E25",
            [
              50130
            ]
          ],
          [
            "\u0E1A\u0E27\u0E01\u0E04\u0E49\u0E32\u0E07",
            [
              50130
            ]
          ],
          [
            "\u0E23\u0E49\u0E2D\u0E07\u0E27\u0E31\u0E27\u0E41\u0E14\u0E07",
            [
              50130
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E01\u0E25\u0E32\u0E07",
            [
              50130
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E01\u0E33\u0E41\u0E1E\u0E07",
            [
              50130
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E17\u0E23\u0E32\u0E22",
            [
              50130
            ]
          ],
          [
            "\u0E2D\u0E2D\u0E19\u0E43\u0E15\u0E49",
            [
              50130
            ]
          ],
          [
            "\u0E41\u0E0A\u0E48\u0E0A\u0E49\u0E32\u0E07",
            [
              50130
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E1B\u0E39\u0E04\u0E32",
            [
              50130
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E31\u0E19\u0E17\u0E23\u0E32\u0E22",
        [
          [
            "\u0E1B\u0E48\u0E32\u0E44\u0E1C\u0E48",
            [
              50210
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E17\u0E23\u0E32\u0E22\u0E19\u0E49\u0E2D\u0E22",
            [
              50210
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E17\u0E23\u0E32\u0E22\u0E2B\u0E25\u0E27\u0E07",
            [
              50210
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E19\u0E32\u0E40\u0E21\u0E47\u0E07",
            [
              50210
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E1B\u0E48\u0E32\u0E40\u0E1B\u0E32",
            [
              50210
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E1E\u0E23\u0E30\u0E40\u0E19\u0E15\u0E23",
            [
              50210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E08\u0E4A\u0E2D\u0E21",
            [
              50210
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E32\u0E23",
            [
              50290
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E2B\u0E22\u0E48\u0E07",
            [
              50210
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E25\u0E47\u0E19",
            [
              50210
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E41\u0E1D\u0E01",
            [
              50290
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E41\u0E1D\u0E01\u0E43\u0E2B\u0E21\u0E48",
            [
              50290
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E31\u0E19\u0E1B\u0E48\u0E32\u0E15\u0E2D\u0E07",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E15\u0E49\u0E2D\u0E21",
            [
              50120
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2A\u0E30\u0E42\u0E15\u0E01",
            [
              50120
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E27\u0E31\u0E07\u0E1E\u0E23\u0E49\u0E32\u0E27",
            [
              50120
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E1A\u0E48\u0E2D\u0E2B\u0E25\u0E27\u0E07",
            [
              50120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E25\u0E32\u0E07",
            [
              50120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E21",
            [
              50120
            ]
          ],
          [
            "\u0E21\u0E30\u0E02\u0E32\u0E21\u0E2B\u0E25\u0E27\u0E07",
            [
              50120
            ]
          ],
          [
            "\u0E21\u0E30\u0E02\u0E38\u0E19\u0E2B\u0E27\u0E32\u0E19",
            [
              50120
            ]
          ],
          [
            "\u0E22\u0E38\u0E2B\u0E27\u0E48\u0E32",
            [
              50120
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E01\u0E25\u0E32\u0E07",
            [
              50120
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E01\u0E4A\u0E32",
            [
              50120
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E32\u0E23\u0E20\u0E35",
        [
          [
            "\u0E02\u0E31\u0E27\u0E21\u0E38\u0E07",
            [
              50140
            ]
          ],
          [
            "\u0E0A\u0E21\u0E20\u0E39",
            [
              50140
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E41\u0E01\u0E49\u0E27",
            [
              50140
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E01\u0E27\u0E49\u0E32\u0E07",
            [
              50140
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E27\u0E31\u0E07\u0E15\u0E32\u0E25",
            [
              50140
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E1A\u0E07",
            [
              50140
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E40\u0E19\u0E34\u0E49\u0E07",
            [
              50140
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E17\u0E23\u0E32\u0E22",
            [
              50140
            ]
          ],
          [
            "\u0E2A\u0E32\u0E23\u0E20\u0E35",
            [
              50140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1C\u0E36\u0E49\u0E07",
            [
              50140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E1D\u0E01",
            [
              50140
            ]
          ],
          [
            "\u0E44\u0E0A\u0E22\u0E2A\u0E16\u0E32\u0E19",
            [
              50140
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E32\u0E07\u0E14\u0E07",
        [
          [
            "\u0E02\u0E38\u0E19\u0E04\u0E07",
            [
              50230
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E41\u0E1E\u0E23\u0E48",
            [
              50230
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1B\u0E07",
            [
              50230
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E2B\u0E27\u0E19",
            [
              50230
            ]
          ],
          [
            "\u0E2A\u0E1A\u0E41\u0E21\u0E48\u0E02\u0E48\u0E32",
            [
              50230
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E1C\u0E31\u0E01\u0E2B\u0E27\u0E32\u0E19",
            [
              50230
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E04\u0E27\u0E32\u0E22",
            [
              50230
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E15\u0E2D\u0E07",
            [
              50340
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E01\u0E4B\u0E27",
            [
              50230
            ]
          ],
          [
            "\u0E2B\u0E32\u0E07\u0E14\u0E07",
            [
              50230
            ]
          ],
          [
            "\u0E2B\u0E32\u0E23\u0E41\u0E01\u0E49\u0E27",
            [
              50230
            ]
          ]
        ]
      ],
      [
        "\u0E2D\u0E21\u0E01\u0E4B\u0E2D\u0E22",
        [
          [
            "\u0E19\u0E32\u0E40\u0E01\u0E35\u0E22\u0E19",
            [
              50310
            ]
          ],
          [
            "\u0E21\u0E48\u0E2D\u0E19\u0E08\u0E2D\u0E07",
            [
              50310
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E40\u0E1B\u0E35\u0E22\u0E07",
            [
              50310
            ]
          ],
          [
            "\u0E2A\u0E1A\u0E42\u0E02\u0E07",
            [
              50310
            ]
          ],
          [
            "\u0E2D\u0E21\u0E01\u0E4B\u0E2D\u0E22",
            [
              50310
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E15\u0E37\u0E48\u0E19",
            [
              50310
            ]
          ]
        ]
      ],
      [
        "\u0E2E\u0E2D\u0E14",
        [
          [
            "\u0E19\u0E32\u0E04\u0E2D\u0E40\u0E23\u0E37\u0E2D",
            [
              50240
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E2A\u0E25\u0E35",
            [
              50240
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E2B\u0E25\u0E27\u0E07",
            [
              50240
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E15\u0E32\u0E25",
            [
              50240
            ]
          ],
          [
            "\u0E2B\u0E32\u0E07\u0E14\u0E07",
            [
              50240
            ]
          ],
          [
            "\u0E2E\u0E2D\u0E14",
            [
              50240
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E14\u0E32\u0E27",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E02\u0E49\u0E32\u0E27\u0E1E\u0E27\u0E07",
            [
              50170
            ]
          ],
          [
            "\u0E1B\u0E34\u0E07\u0E42\u0E04\u0E49\u0E07",
            [
              50170
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E14\u0E32\u0E27",
            [
              50170
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E04\u0E2D\u0E07",
            [
              50170
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E07\u0E32\u0E22",
            [
              50170
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E19\u0E30",
            [
              50170
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E19\u0E30",
            [
              50170
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E43\u0E2B\u0E21\u0E48",
        [
          [
            "\u0E0A\u0E49\u0E32\u0E07\u0E04\u0E25\u0E32\u0E19",
            [
              50100
            ]
          ],
          [
            "\u0E0A\u0E49\u0E32\u0E07\u0E21\u0E48\u0E2D\u0E22",
            [
              50300
            ]
          ],
          [
            "\u0E0A\u0E49\u0E32\u0E07\u0E40\u0E1C\u0E37\u0E2D\u0E01",
            [
              50300
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E28\u0E32\u0E25\u0E32",
            [
              5e4
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E15\u0E31\u0E19",
            [
              50300
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E41\u0E14\u0E14",
            [
              50100
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E2A\u0E34\u0E07\u0E2B\u0E4C",
            [
              50200
            ]
          ],
          [
            "\u0E1F\u0E49\u0E32\u0E2E\u0E48\u0E32\u0E21",
            [
              5e4
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E40\u0E01\u0E15",
            [
              5e4
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E20\u0E39\u0E21\u0E34",
            [
              50200
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E1C\u0E35\u0E40\u0E2A\u0E37\u0E49\u0E2D",
            [
              50300
            ]
          ],
          [
            "\u0E2A\u0E38\u0E40\u0E17\u0E1E",
            [
              50200
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E48\u0E32\u0E04\u0E23\u0E31\u0E48\u0E07",
            [
              5e4
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E2D\u0E22",
            [
              5e4
            ]
          ],
          [
            "\u0E2B\u0E32\u0E22\u0E22\u0E32",
            [
              50100
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E40\u0E2B\u0E35\u0E22\u0E30",
            [
              50100
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E41\u0E2B\u0E07",
        [
          [
            "\u0E40\u0E1B\u0E35\u0E22\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              50350
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E41\u0E2B\u0E07",
            [
              50350
            ]
          ],
          [
            "\u0E41\u0E2A\u0E19\u0E44\u0E2B",
            [
              50350
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E23\u0E34\u0E21",
        [
          [
            "\u0E02\u0E35\u0E49\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              50180
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E41\u0E01\u0E49\u0E27",
            [
              50180
            ]
          ],
          [
            "\u0E23\u0E34\u0E21\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              50180
            ]
          ],
          [
            "\u0E23\u0E34\u0E21\u0E43\u0E15\u0E49",
            [
              50180
            ]
          ],
          [
            "\u0E2A\u0E30\u0E25\u0E27\u0E07",
            [
              50330
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E42\u0E1B\u0E48\u0E07",
            [
              50180
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E17\u0E23\u0E32\u0E22",
            [
              50180
            ]
          ],
          [
            "\u0E40\u0E2B\u0E21\u0E37\u0E2D\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              50180
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E32",
            [
              50180
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E41\u0E23\u0E21",
            [
              50180
            ]
          ],
          [
            "\u0E42\u0E1B\u0E48\u0E07\u0E41\u0E22\u0E07",
            [
              50180
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E27\u0E32\u0E07",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E40\u0E1B\u0E32",
            [
              50360
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E1B\u0E35\u0E49",
            [
              50360
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E23\u0E27\u0E07\u0E17\u0E2D\u0E07",
            [
              50360
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E32\u0E14",
            [
              50360
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E27\u0E34\u0E19",
            [
              50360
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E2D\u0E2D\u0E19",
        [
          [
            "\u0E17\u0E32\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              50130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2A\u0E2B\u0E01\u0E23\u0E13\u0E4C",
            [
              50130
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E41\u0E01\u0E49\u0E27",
            [
              50130
            ]
          ],
          [
            "\u0E2D\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07",
            [
              50130
            ]
          ],
          [
            "\u0E2D\u0E2D\u0E19\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              50130
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E17\u0E32",
            [
              50130
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E2D\u0E32\u0E22",
        [
          [
            "\u0E17\u0E48\u0E32\u0E15\u0E2D\u0E19",
            [
              50280
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E25\u0E27\u0E07",
            [
              50280
            ]
          ],
          [
            "\u0E21\u0E30\u0E25\u0E34\u0E01\u0E32",
            [
              50280
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E15\u0E49\u0E19\u0E2B\u0E21\u0E37\u0E49\u0E2D",
            [
              50280
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E19\u0E32\u0E27\u0E32\u0E07",
            [
              50280
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E32\u0E27",
            [
              50280
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2D\u0E32\u0E22",
            [
              50280
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E41\u0E08\u0E48\u0E21",
        [
          [
            "\u0E01\u0E2D\u0E07\u0E41\u0E02\u0E01",
            [
              50270
            ]
          ],
          [
            "\u0E0A\u0E48\u0E32\u0E07\u0E40\u0E04\u0E34\u0E48\u0E07",
            [
              50270
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E1C\u0E32",
            [
              50270
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E17\u0E31\u0E1A",
            [
              50270
            ]
          ],
          [
            "\u0E1B\u0E32\u0E07\u0E2B\u0E34\u0E19\u0E1D\u0E19",
            [
              50270
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E19\u0E32\u0E08\u0E23",
            [
              50270
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E28\u0E36\u0E01",
            [
              50270
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E41\u0E15\u0E07",
        [
          [
            "\u0E01\u0E37\u0E49\u0E14\u0E0A\u0E49\u0E32\u0E07",
            [
              50150
            ]
          ],
          [
            "\u0E02\u0E35\u0E49\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              50150
            ]
          ],
          [
            "\u0E0A\u0E48\u0E2D\u0E41\u0E25",
            [
              50150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E0A\u0E49\u0E32\u0E07",
            [
              50150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E1B\u0E49\u0E32",
            [
              50150
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E41\u0E1B\u0E4B",
            [
              50150
            ]
          ],
          [
            "\u0E2A\u0E1A\u0E40\u0E1B\u0E34\u0E07",
            [
              50150
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E1B\u0E48\u0E32\u0E22\u0E32\u0E07",
            [
              50330
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E21\u0E2B\u0E32\u0E1E\u0E19",
            [
              50150
            ]
          ],
          [
            "\u0E2D\u0E34\u0E19\u0E17\u0E02\u0E34\u0E25",
            [
              50150
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E01\u0E4B\u0E32\u0E22",
            [
              50150
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2B\u0E2D\u0E1E\u0E23\u0E30",
            [
              50150
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E41\u0E15\u0E07",
            [
              50150
            ]
          ]
        ]
      ],
      [
        "\u0E44\u0E0A\u0E22\u0E1B\u0E23\u0E32\u0E01\u0E32\u0E23",
        [
          [
            "\u0E1B\u0E07\u0E15\u0E33",
            [
              50320
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E14\u0E07\u0E40\u0E22\u0E47\u0E19",
            [
              50320
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              50320
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E17\u0E30\u0E25\u0E1A",
            [
              50320
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E40\u0E1E\u0E0A\u0E23\u0E1A\u0E38\u0E23\u0E35",
    [
      [
        "\u0E0A\u0E30\u0E2D\u0E33",
        [
          [
            "\u0E0A\u0E30\u0E2D\u0E33",
            [
              76120
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E02\u0E38\u0E19\u0E2B\u0E49\u0E27\u0E22",
            [
              76120
            ]
          ],
          [
            "\u0E19\u0E32\u0E22\u0E32\u0E07",
            [
              76120
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E01\u0E48\u0E32",
            [
              76120
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E1E\u0E23\u0E30\u0E22\u0E32",
            [
              76120
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E28\u0E32\u0E25\u0E32",
            [
              76120
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E17\u0E23\u0E32\u0E22\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              76120
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E43\u0E2B\u0E0D\u0E48",
            [
              76120
            ]
          ],
          [
            "\u0E44\u0E23\u0E48\u0E43\u0E2B\u0E21\u0E48\u0E1E\u0E31\u0E12\u0E19\u0E32",
            [
              76120
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E48\u0E32\u0E22\u0E32\u0E07",
        [
          [
            "\u0E01\u0E25\u0E31\u0E14\u0E2B\u0E25\u0E27\u0E07",
            [
              76130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E04\u0E2D\u0E22",
            [
              76130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E22\u0E32\u0E07",
            [
              76130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E41\u0E25\u0E07",
            [
              76130
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E44\u0E21\u0E49\u0E23\u0E27\u0E01",
            [
              76130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E43\u0E19\u0E14\u0E07",
            [
              76130
            ]
          ],
          [
            "\u0E1B\u0E36\u0E01\u0E40\u0E15\u0E35\u0E22\u0E19",
            [
              76130
            ]
          ],
          [
            "\u0E21\u0E32\u0E1A\u0E1B\u0E25\u0E32\u0E40\u0E04\u0E49\u0E32",
            [
              76130
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E2B\u0E22\u0E48\u0E2D\u0E07",
            [
              76130
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E44\u0E04\u0E23\u0E49",
            [
              76130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E08\u0E2D\u0E01",
            [
              76130
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E01\u0E23\u0E30\u0E1B\u0E38\u0E01",
            [
              76130
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E25\u0E32\u0E14",
        [
          [
            "\u0E15\u0E33\u0E2B\u0E23\u0E38",
            [
              76150
            ]
          ],
          [
            "\u0E16\u0E49\u0E33\u0E23\u0E07\u0E04\u0E4C",
            [
              76150
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E0A\u0E49\u0E32\u0E07",
            [
              76150
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E40\u0E2A\u0E19",
            [
              76150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E17\u0E32\u0E19",
            [
              76150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E25\u0E32\u0E14",
            [
              76150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E32\u0E14",
            [
              76150
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E42\u0E1E\u0E18\u0E34\u0E4C",
            [
              76150
            ]
          ],
          [
            "\u0E2A\u0E21\u0E2D\u0E1E\u0E25\u0E37\u0E2D",
            [
              76150
            ]
          ],
          [
            "\u0E2A\u0E30\u0E1E\u0E32\u0E19\u0E44\u0E01\u0E23",
            [
              76150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E40\u0E08\u0E47\u0E14",
            [
              76150
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E01\u0E30\u0E1B\u0E38",
            [
              76150
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E02\u0E49\u0E2D\u0E07",
            [
              76150
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E25\u0E36\u0E01",
            [
              76150
            ]
          ],
          [
            "\u0E42\u0E23\u0E07\u0E40\u0E02\u0E49",
            [
              76150
            ]
          ],
          [
            "\u0E44\u0E23\u0E48\u0E21\u0E30\u0E02\u0E32\u0E21",
            [
              76150
            ]
          ],
          [
            "\u0E44\u0E23\u0E48\u0E2A\u0E30\u0E17\u0E49\u0E2D\u0E19",
            [
              76150
            ]
          ],
          [
            "\u0E44\u0E23\u0E48\u0E42\u0E04\u0E01",
            [
              76150
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E2B\u0E25\u0E21",
        [
          [
            "\u0E17\u0E48\u0E32\u0E41\u0E23\u0E49\u0E07",
            [
              76110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E41\u0E23\u0E49\u0E07\u0E2D\u0E2D\u0E01",
            [
              76110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E02\u0E38\u0E19\u0E44\u0E17\u0E23",
            [
              76110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E04\u0E23\u0E01",
            [
              76110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E15\u0E30\u0E1A\u0E39\u0E19",
            [
              76110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E15\u0E30\u0E1A\u0E39\u0E19\u0E2D\u0E2D\u0E01",
            [
              76110
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E41\u0E01\u0E49\u0E27",
            [
              76110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E41\u0E2B\u0E25\u0E21",
            [
              76110
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E17\u0E30\u0E40\u0E25",
            [
              76110
            ]
          ],
          [
            "\u0E41\u0E2B\u0E25\u0E21\u0E1C\u0E31\u0E01\u0E40\u0E1A\u0E35\u0E49\u0E22",
            [
              76100
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E0D\u0E49\u0E32\u0E1B\u0E25\u0E49\u0E2D\u0E07",
        [
          [
            "\u0E17\u0E48\u0E32\u0E15\u0E30\u0E04\u0E23\u0E49\u0E2D",
            [
              76160
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E19\u0E49\u0E33\u0E01\u0E25\u0E31\u0E14\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              76160
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E19\u0E49\u0E33\u0E01\u0E25\u0E31\u0E14\u0E43\u0E15\u0E49",
            [
              76160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E0D\u0E49\u0E32\u0E1B\u0E25\u0E49\u0E2D\u0E07",
            [
              76160
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E02\u0E32\u0E22\u0E49\u0E2D\u0E22",
        [
          [
            "\u0E17\u0E31\u0E1A\u0E04\u0E32\u0E07",
            [
              76140
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E40\u0E04\u0E47\u0E21",
            [
              76140
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E1E\u0E31\u0E07",
            [
              76140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E0A\u0E38\u0E21\u0E1E\u0E25",
            [
              76140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E0A\u0E38\u0E21\u0E1E\u0E25\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              76140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E23\u0E07",
            [
              76140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1B\u0E25\u0E32\u0E44\u0E2B\u0E25",
            [
              76140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E17\u0E48\u0E32\u0E0A\u0E49\u0E32\u0E07",
            [
              76140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E42\u0E23\u0E07",
            [
              76140
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E22\u0E49\u0E2D\u0E22",
            [
              76140
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E1E\u0E0A\u0E23\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E41\u0E0A\u0E07",
            [
              76e3
            ]
          ],
          [
            "\u0E0A\u0E48\u0E2D\u0E07\u0E2A\u0E30\u0E41\u0E01",
            [
              76e3
            ]
          ],
          [
            "\u0E14\u0E2D\u0E19\u0E22\u0E32\u0E07",
            [
              76e3
            ]
          ],
          [
            "\u0E15\u0E49\u0E19\u0E21\u0E30\u0E1E\u0E23\u0E49\u0E32\u0E27",
            [
              76e3
            ]
          ],
          [
            "\u0E15\u0E49\u0E19\u0E21\u0E30\u0E21\u0E48\u0E27\u0E07",
            [
              76e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E23\u0E32\u0E1A",
            [
              76e3
            ]
          ],
          [
            "\u0E18\u0E07\u0E0A\u0E31\u0E22",
            [
              76e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E1E\u0E31\u0E19\u0E2A\u0E32\u0E21",
            [
              76e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E27\u0E38\u0E49\u0E07",
            [
              76e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E08\u0E32\u0E01",
            [
              76e3
            ]
          ],
          [
            "\u0E1A\u0E32\u0E07\u0E08\u0E32\u0E19",
            [
              76e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E38\u0E48\u0E21",
            [
              76e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E21\u0E49\u0E2D",
            [
              76e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E15\u0E30\u0E42\u0E01",
            [
              76e3
            ]
          ],
          [
            "\u0E2A\u0E33\u0E21\u0E30\u0E42\u0E23\u0E07",
            [
              76e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E02\u0E19\u0E32\u0E19",
            [
              76e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1E\u0E25\u0E31\u0E1A",
            [
              76e3
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E42\u0E2A\u0E19",
            [
              76e3
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E2A\u0E30\u0E1E\u0E32\u0E19",
            [
              76e3
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E40\u0E08\u0E49\u0E32\u0E2A\u0E33\u0E23\u0E32\u0E0D",
            [
              76100
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E04\u0E2D\u0E22",
            [
              76e3
            ]
          ],
          [
            "\u0E42\u0E1E\u0E1E\u0E23\u0E30",
            [
              76e3
            ]
          ],
          [
            "\u0E42\u0E1E\u0E44\u0E23\u0E48\u0E2B\u0E27\u0E32\u0E19",
            [
              76e3
            ]
          ],
          [
            "\u0E44\u0E23\u0E48\u0E2A\u0E49\u0E21",
            [
              76e3
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E01\u0E48\u0E07\u0E01\u0E23\u0E30\u0E08\u0E32\u0E19",
        [
          [
            "\u0E1B\u0E48\u0E32\u0E40\u0E14\u0E47\u0E07",
            [
              76170
            ]
          ],
          [
            "\u0E1E\u0E38\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
            [
              76170
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
            [
              76170
            ]
          ],
          [
            "\u0E2A\u0E2D\u0E07\u0E1E\u0E35\u0E48\u0E19\u0E49\u0E2D\u0E07",
            [
              76170
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E41\u0E21\u0E48\u0E40\u0E1E\u0E23\u0E35\u0E22\u0E07",
            [
              76170
            ]
          ],
          [
            "\u0E41\u0E01\u0E48\u0E07\u0E01\u0E23\u0E30\u0E08\u0E32\u0E19",
            [
              76170
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E40\u0E1E\u0E0A\u0E23\u0E1A\u0E39\u0E23\u0E13\u0E4C",
    [
      [
        "\u0E0A\u0E19\u0E41\u0E14\u0E19",
        [
          [
            "\u0E0A\u0E19\u0E41\u0E14\u0E19",
            [
              67150
            ]
          ],
          [
            "\u0E0B\u0E31\u0E1A\u0E1E\u0E38\u0E17\u0E23\u0E32",
            [
              67150
            ]
          ],
          [
            "\u0E14\u0E07\u0E02\u0E38\u0E22",
            [
              67190
            ]
          ],
          [
            "\u0E15\u0E30\u0E01\u0E38\u0E14\u0E44\u0E23",
            [
              67190
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E49\u0E32\u0E21",
            [
              67150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E25\u0E49\u0E27\u0E22",
            [
              67190
            ]
          ],
          [
            "\u0E1E\u0E38\u0E17\u0E18\u0E1A\u0E32\u0E17",
            [
              67150
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E41\u0E04",
            [
              67150
            ]
          ],
          [
            "\u0E28\u0E32\u0E25\u0E32\u0E25\u0E32\u0E22",
            [
              67150
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E49\u0E33\u0E2B\u0E19\u0E32\u0E27",
        [
          [
            "\u0E19\u0E49\u0E33\u0E2B\u0E19\u0E32\u0E27",
            [
              67260
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E01\u0E27\u0E32\u0E07",
            [
              67260
            ]
          ],
          [
            "\u0E2B\u0E25\u0E31\u0E01\u0E14\u0E48\u0E32\u0E19",
            [
              67260
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E21\u0E19",
            [
              67260
            ]
          ]
        ]
      ],
      [
        "\u0E1A\u0E36\u0E07\u0E2A\u0E32\u0E21\u0E1E\u0E31\u0E19",
        [
          [
            "\u0E01\u0E31\u0E19\u0E08\u0E38",
            [
              67160
            ]
          ],
          [
            "\u0E0B\u0E31\u0E1A\u0E2A\u0E21\u0E2D\u0E17\u0E2D\u0E14",
            [
              67160
            ]
          ],
          [
            "\u0E0B\u0E31\u0E1A\u0E44\u0E21\u0E49\u0E41\u0E14\u0E07",
            [
              67160
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E2A\u0E32\u0E21\u0E1E\u0E31\u0E19",
            [
              67160
            ]
          ],
          [
            "\u0E1E\u0E0D\u0E32\u0E27\u0E31\u0E07",
            [
              67160
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E1E\u0E34\u0E01\u0E38\u0E25",
            [
              67230
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E21\u0E07\u0E04\u0E25",
            [
              67160
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E41\u0E01\u0E49\u0E27",
            [
              67160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E08\u0E07",
            [
              67160
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E07\u0E42\u0E1B\u0E48\u0E07",
        [
          [
            "\u0E0B\u0E31\u0E1A\u0E40\u0E1B\u0E34\u0E1A",
            [
              67240
            ]
          ],
          [
            "\u0E17\u0E49\u0E32\u0E22\u0E14\u0E07",
            [
              67240
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E28\u0E32\u0E25",
            [
              67240
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2B\u0E34\u0E19",
            [
              67240
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E42\u0E1B\u0E48\u0E07",
            [
              67240
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E34\u0E40\u0E0A\u0E35\u0E22\u0E23\u0E1A\u0E38\u0E23\u0E35",
        [
          [
            "\u0E0B\u0E31\u0E1A\u0E19\u0E49\u0E2D\u0E22",
            [
              67180
            ]
          ],
          [
            "\u0E0B\u0E31\u0E1A\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
            [
              67180
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E42\u0E23\u0E07",
            [
              67130
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E23\u0E49\u0E2D\u0E19",
            [
              67130
            ]
          ],
          [
            "\u0E1A\u0E36\u0E07\u0E01\u0E23\u0E30\u0E08\u0E31\u0E1A",
            [
              67130
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E23\u0E31\u0E07",
            [
              67130
            ]
          ],
          [
            "\u0E1E\u0E38\u0E02\u0E32\u0E21",
            [
              67180
            ]
          ],
          [
            "\u0E1E\u0E38\u0E40\u0E15\u0E22",
            [
              67180
            ]
          ],
          [
            "\u0E20\u0E39\u0E19\u0E49\u0E33\u0E2B\u0E22\u0E14",
            [
              67180
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E2A\u0E32\u0E27",
            [
              67130
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E43\u0E2B\u0E0D\u0E48",
            [
              67180
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E1B\u0E23\u0E30\u0E14\u0E39\u0E48",
            [
              67130
            ]
          ],
          [
            "\u0E2A\u0E32\u0E21\u0E41\u0E22\u0E01",
            [
              67130
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E1B\u0E23\u0E07",
            [
              67130
            ]
          ]
        ]
      ],
      [
        "\u0E28\u0E23\u0E35\u0E40\u0E17\u0E1E",
        [
          [
            "\u0E04\u0E25\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E08\u0E31\u0E07",
            [
              67170
            ]
          ],
          [
            "\u0E19\u0E32\u0E2A\u0E19\u0E38\u0E48\u0E19",
            [
              67170
            ]
          ],
          [
            "\u0E1B\u0E23\u0E30\u0E14\u0E39\u0E48\u0E07\u0E32\u0E21",
            [
              67170
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E40\u0E17\u0E1E",
            [
              67170
            ]
          ],
          [
            "\u0E2A\u0E23\u0E30\u0E01\u0E23\u0E27\u0E14",
            [
              67170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E22\u0E48\u0E32\u0E07\u0E17\u0E2D\u0E22",
            [
              67170
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              67170
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E1C\u0E48",
        [
          [
            "\u0E01\u0E2D\u0E07\u0E17\u0E39\u0E25",
            [
              67140
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E14\u0E49\u0E27\u0E07",
            [
              67140
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E41\u0E14\u0E07",
            [
              67140
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E09\u0E25\u0E35\u0E22\u0E07",
            [
              67220
            ]
          ],
          [
            "\u0E1A\u0E31\u0E27\u0E27\u0E31\u0E12\u0E19\u0E32",
            [
              67140
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E44\u0E17\u0E22",
            [
              67140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E20\u0E0A\u0E19\u0E4C",
            [
              67140
            ]
          ],
          [
            "\u0E22\u0E32\u0E07\u0E07\u0E32\u0E21",
            [
              67220
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E17\u0E48\u0E32\u0E14\u0E35",
            [
              67140
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E42\u0E1A\u0E2A\u0E16\u0E4C",
            [
              67140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E1C\u0E48",
            [
              67140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E42\u0E1B\u0E48\u0E07",
            [
              67220
            ]
          ],
          [
            "\u0E40\u0E1E\u0E0A\u0E23\u0E25\u0E30\u0E04\u0E23",
            [
              67140
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E25\u0E48\u0E21\u0E2A\u0E31\u0E01",
        [
          [
            "\u0E0A\u0E49\u0E32\u0E07\u0E15\u0E30\u0E25\u0E39\u0E14",
            [
              67110
            ]
          ],
          [
            "\u0E15\u0E32\u0E25\u0E40\u0E14\u0E35\u0E48\u0E22\u0E27",
            [
              67110
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2D\u0E34\u0E1A\u0E38\u0E0D",
            [
              67110
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E01\u0E49\u0E2D",
            [
              67110
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E0A\u0E38\u0E19",
            [
              67110
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E40\u0E2E\u0E35\u0E49\u0E22",
            [
              67110
            ]
          ],
          [
            "\u0E1A\u0E38\u0E48\u0E07\u0E04\u0E25\u0E49\u0E32",
            [
              67110
            ]
          ],
          [
            "\u0E1A\u0E38\u0E48\u0E07\u0E19\u0E49\u0E33\u0E40\u0E15\u0E49\u0E32",
            [
              67110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E25\u0E32\u0E07",
            [
              67110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E15\u0E34\u0E49\u0E27",
            [
              67110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E27\u0E32\u0E22",
            [
              67110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E2A\u0E01",
            [
              67110
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E44\u0E23\u0E48",
            [
              67110
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E0A\u0E48\u0E2D\u0E07",
            [
              67110
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E14\u0E38\u0E01",
            [
              67110
            ]
          ],
          [
            "\u0E1D\u0E32\u0E22\u0E19\u0E32\u0E41\u0E0B\u0E07",
            [
              67110
            ]
          ],
          [
            "\u0E25\u0E32\u0E19\u0E1A\u0E48\u0E32",
            [
              67110
            ]
          ],
          [
            "\u0E27\u0E31\u0E14\u0E1B\u0E48\u0E32",
            [
              67110
            ]
          ],
          [
            "\u0E2A\u0E31\u0E01\u0E2B\u0E25\u0E07",
            [
              67110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2A\u0E27\u0E48\u0E32\u0E07",
            [
              67110
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E44\u0E02\u0E27\u0E48",
            [
              67110
            ]
          ],
          [
            "\u0E2B\u0E25\u0E48\u0E21\u0E2A\u0E31\u0E01",
            [
              67110
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E44\u0E23\u0E48",
            [
              67110
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E25\u0E48\u0E21\u0E40\u0E01\u0E48\u0E32",
        [
          [
            "\u0E15\u0E32\u0E14\u0E01\u0E25\u0E2D\u0E22",
            [
              67120
            ]
          ],
          [
            "\u0E19\u0E32\u0E0B\u0E33",
            [
              67120
            ]
          ],
          [
            "\u0E19\u0E32\u0E40\u0E01\u0E32\u0E30",
            [
              67120
            ]
          ],
          [
            "\u0E19\u0E32\u0E41\u0E0B\u0E07",
            [
              67120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E19\u0E34\u0E19",
            [
              67120
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E1A\u0E32\u0E25",
            [
              67120
            ]
          ],
          [
            "\u0E28\u0E34\u0E25\u0E32",
            [
              67120
            ]
          ],
          [
            "\u0E2B\u0E25\u0E48\u0E21\u0E40\u0E01\u0E48\u0E32",
            [
              67120
            ]
          ],
          [
            "\u0E2B\u0E34\u0E19\u0E2E\u0E32\u0E27",
            [
              67120
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E02\u0E32\u0E04\u0E49\u0E2D",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E2A\u0E21\u0E2D",
            [
              67270
            ]
          ],
          [
            "\u0E23\u0E34\u0E21\u0E2A\u0E35\u0E21\u0E48\u0E27\u0E07",
            [
              67270
            ]
          ],
          [
            "\u0E2A\u0E30\u0E40\u0E14\u0E32\u0E30\u0E1E\u0E07",
            [
              67270
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E41\u0E21\u0E48\u0E19\u0E32",
            [
              67270
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E04\u0E49\u0E2D",
            [
              67270
            ]
          ],
          [
            "\u0E40\u0E02\u0E47\u0E01\u0E19\u0E49\u0E2D\u0E22",
            [
              67280
            ]
          ],
          [
            "\u0E41\u0E04\u0E21\u0E1B\u0E4C\u0E2A\u0E19",
            [
              67280
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E1E\u0E0A\u0E23\u0E1A\u0E39\u0E23\u0E13\u0E4C",
        [
          [
            "\u0E0A\u0E2D\u0E19\u0E44\u0E1E\u0E23",
            [
              67e3
            ]
          ],
          [
            "\u0E14\u0E07\u0E21\u0E39\u0E25\u0E40\u0E2B\u0E25\u0E47\u0E01",
            [
              67e3
            ]
          ],
          [
            "\u0E15\u0E30\u0E40\u0E1A\u0E32\u0E30",
            [
              67e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E1E\u0E25",
            [
              67250
            ]
          ],
          [
            "\u0E19\u0E32\u0E07\u0E31\u0E48\u0E27",
            [
              67e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E1B\u0E48\u0E32",
            [
              67e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E22\u0E21",
            [
              67210
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E23\u0E49\u0E2D\u0E19",
            [
              67e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E04\u0E01",
            [
              67e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E42\u0E15\u0E01",
            [
              67e3
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E40\u0E25\u0E32",
            [
              67e3
            ]
          ],
          [
            "\u0E23\u0E30\u0E27\u0E34\u0E07",
            [
              67210
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E0A\u0E21\u0E20\u0E39",
            [
              67210
            ]
          ],
          [
            "\u0E2A\u0E30\u0E40\u0E14\u0E35\u0E22\u0E07",
            [
              67e3
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E2A\u0E30\u0E41\u0E01",
            [
              67210
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E43\u0E2B\u0E0D\u0E48",
            [
              67e3
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              67e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E40\u0E25\u0E22",
    [
      [
        "\u0E14\u0E48\u0E32\u0E19\u0E0B\u0E49\u0E32\u0E22",
        [
          [
            "\u0E01\u0E01\u0E2A\u0E30\u0E17\u0E2D\u0E19",
            [
              42120
            ]
          ],
          [
            "\u0E14\u0E48\u0E32\u0E19\u0E0B\u0E49\u0E32\u0E22",
            [
              42120
            ]
          ],
          [
            "\u0E19\u0E32\u0E14\u0E35",
            [
              42120
            ]
          ],
          [
            "\u0E19\u0E32\u0E2B\u0E2D",
            [
              42120
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E2B\u0E21\u0E31\u0E19",
            [
              42120
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E22\u0E32\u0E27",
            [
              42120
            ]
          ],
          [
            "\u0E2D\u0E34\u0E1B\u0E38\u0E48\u0E21",
            [
              42120
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E07\u0E32\u0E21",
            [
              42120
            ]
          ],
          [
            "\u0E42\u0E1B\u0E48\u0E07",
            [
              42120
            ]
          ],
          [
            "\u0E42\u0E1E\u0E19\u0E2A\u0E39\u0E07",
            [
              42120
            ]
          ]
        ]
      ],
      [
        "\u0E17\u0E48\u0E32\u0E25\u0E35\u0E48",
        [
          [
            "\u0E17\u0E48\u0E32\u0E25\u0E35\u0E48",
            [
              42140
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E17\u0E39\u0E19",
            [
              42140
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E41\u0E04\u0E21",
            [
              42140
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1C\u0E37\u0E2D",
            [
              42140
            ]
          ],
          [
            "\u0E2D\u0E32\u0E2E\u0E35",
            [
              42140
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E43\u0E2B\u0E0D\u0E48",
            [
              42140
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E14\u0E49\u0E27\u0E07",
        [
          [
            "\u0E17\u0E48\u0E32\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E4C",
            [
              42210
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E2A\u0E30\u0E2D\u0E32\u0E14",
            [
              42210
            ]
          ],
          [
            "\u0E19\u0E32\u0E14\u0E2D\u0E01\u0E04\u0E33",
            [
              42210
            ]
          ],
          [
            "\u0E19\u0E32\u0E14\u0E49\u0E27\u0E07",
            [
              42210
            ]
          ]
        ]
      ],
      [
        "\u0E19\u0E32\u0E41\u0E2B\u0E49\u0E27",
        [
          [
            "\u0E19\u0E32\u0E1E\u0E36\u0E07",
            [
              42170
            ]
          ],
          [
            "\u0E19\u0E32\u0E21\u0E32\u0E25\u0E32",
            [
              42170
            ]
          ],
          [
            "\u0E19\u0E32\u0E41\u0E2B\u0E49\u0E27",
            [
              42170
            ]
          ],
          [
            "\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E01\u0E2D\u0E2B\u0E01",
            [
              42170
            ]
          ],
          [
            "\u0E41\u0E2A\u0E07\u0E20\u0E32",
            [
              42170
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E32\u0E01\u0E0A\u0E21",
        [
          [
            "\u0E0A\u0E21\u0E40\u0E08\u0E23\u0E34\u0E0D",
            [
              42150
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E0A\u0E21",
            [
              42150
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E04\u0E31\u0E21\u0E20\u0E35\u0E23\u0E4C",
            [
              42150
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E1A\u0E48\u0E2D\u0E0B\u0E37\u0E19",
            [
              42150
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E1E\u0E34\u0E0A\u0E31\u0E22",
            [
              42150
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E01\u0E25\u0E21",
            [
              42150
            ]
          ]
        ]
      ],
      [
        "\u0E1C\u0E32\u0E02\u0E32\u0E27",
        [
          [
            "\u0E17\u0E48\u0E32\u0E0A\u0E49\u0E32\u0E07\u0E04\u0E25\u0E49\u0E2D\u0E07",
            [
              42240
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E1E\u0E34\u0E48\u0E21",
            [
              42240
            ]
          ],
          [
            "\u0E1C\u0E32\u0E02\u0E32\u0E27",
            [
              42240
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E1B\u0E2D\u0E41\u0E14\u0E07",
            [
              42240
            ]
          ],
          [
            "\u0E42\u0E19\u0E19\u0E1B\u0E48\u0E32\u0E0B\u0E32\u0E07",
            [
              42240
            ]
          ]
        ]
      ],
      [
        "\u0E20\u0E39\u0E01\u0E23\u0E30\u0E14\u0E36\u0E07",
        [
          [
            "\u0E1C\u0E32\u0E19\u0E01\u0E40\u0E04\u0E49\u0E32",
            [
              42180
            ]
          ],
          [
            "\u0E20\u0E39\u0E01\u0E23\u0E30\u0E14\u0E36\u0E07",
            [
              42180
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E10\u0E32\u0E19",
            [
              42180
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E2A\u0E49\u0E21",
            [
              42180
            ]
          ]
        ]
      ],
      [
        "\u0E20\u0E39\u0E2B\u0E25\u0E27\u0E07",
        [
          [
            "\u0E20\u0E39\u0E2B\u0E2D",
            [
              42230
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E04\u0E31\u0E19",
            [
              42230
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E2A\u0E35\u0E40\u0E2A\u0E35\u0E22\u0E14",
            [
              42230
            ]
          ],
          [
            "\u0E40\u0E25\u0E22\u0E27\u0E31\u0E07\u0E44\u0E2A\u0E22\u0E4C",
            [
              42230
            ]
          ],
          [
            "\u0E41\u0E01\u0E48\u0E07\u0E28\u0E23\u0E35\u0E20\u0E39\u0E21\u0E34",
            [
              42230
            ]
          ]
        ]
      ],
      [
        "\u0E20\u0E39\u0E40\u0E23\u0E37\u0E2D",
        [
          [
            "\u0E17\u0E48\u0E32\u0E28\u0E32\u0E25\u0E32",
            [
              42160
            ]
          ],
          [
            "\u0E1B\u0E25\u0E32\u0E1A\u0E48\u0E32",
            [
              42160
            ]
          ],
          [
            "\u0E23\u0E48\u0E2D\u0E07\u0E08\u0E34\u0E01",
            [
              42160
            ]
          ],
          [
            "\u0E25\u0E32\u0E14\u0E04\u0E48\u0E32\u0E07",
            [
              42160
            ]
          ],
          [
            "\u0E2A\u0E32\u0E19\u0E15\u0E21",
            [
              42160
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E1A\u0E31\u0E27",
            [
              42160
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E07\u0E2A\u0E30\u0E1E\u0E38\u0E07",
        [
          [
            "\u0E17\u0E23\u0E32\u0E22\u0E02\u0E32\u0E27",
            [
              42130
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E1B\u0E27\u0E19",
            [
              42130
            ]
          ],
          [
            "\u0E1C\u0E32\u0E19\u0E49\u0E2D\u0E22",
            [
              42130
            ]
          ],
          [
            "\u0E1C\u0E32\u0E1A\u0E34\u0E49\u0E07",
            [
              42130
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2A\u0E30\u0E1E\u0E38\u0E07",
            [
              42130
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E07\u0E04\u0E23\u0E32\u0E21",
            [
              42130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E07\u0E34\u0E49\u0E27",
            [
              42130
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E0D\u0E49\u0E32\u0E1B\u0E25\u0E49\u0E2D\u0E07",
            [
              42130
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E2B\u0E25\u0E27\u0E07",
            [
              42130
            ]
          ],
          [
            "\u0E42\u0E04\u0E01\u0E02\u0E21\u0E34\u0E49\u0E19",
            [
              42130
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E34\u0E19",
        [
          [
            "\u0E15\u0E32\u0E14\u0E02\u0E48\u0E32",
            [
              42190
            ]
          ],
          [
            "\u0E1B\u0E27\u0E19\u0E1E\u0E38",
            [
              42190
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E2B\u0E34\u0E19",
            [
              42190
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E04\u0E32\u0E19",
        [
          [
            "\u0E08\u0E2D\u0E21\u0E28\u0E23\u0E35",
            [
              42110
            ]
          ],
          [
            "\u0E18\u0E32\u0E15\u0E38",
            [
              42110
            ]
          ],
          [
            "\u0E19\u0E32\u0E0B\u0E48\u0E32\u0E27",
            [
              42110
            ]
          ],
          [
            "\u0E1A\u0E38\u0E2E\u0E21",
            [
              42110
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E15\u0E21",
            [
              42110
            ]
          ],
          [
            "\u0E2B\u0E32\u0E14\u0E17\u0E23\u0E32\u0E22\u0E02\u0E32\u0E27",
            [
              42110
            ]
          ],
          [
            "\u0E40\u0E02\u0E32\u0E41\u0E01\u0E49\u0E27",
            [
              42110
            ]
          ],
          [
            "\u0E40\u0E0A\u0E35\u0E22\u0E07\u0E04\u0E32\u0E19",
            [
              42110
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E40\u0E25\u0E22",
        [
          [
            "\u0E01\u0E01\u0E14\u0E39\u0E48",
            [
              42e3
            ]
          ],
          [
            "\u0E01\u0E01\u0E17\u0E2D\u0E07",
            [
              42e3
            ]
          ],
          [
            "\u0E01\u0E38\u0E14\u0E1B\u0E48\u0E2D\u0E07",
            [
              42e3
            ]
          ],
          [
            "\u0E0A\u0E31\u0E22\u0E1E\u0E24\u0E01\u0E29\u0E4C",
            [
              42e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E14\u0E34\u0E19\u0E14\u0E33",
            [
              42e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E2D\u0E32\u0E19",
            [
              42e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E2D\u0E49\u0E2D",
            [
              42100
            ]
          ],
          [
            "\u0E19\u0E32\u0E41\u0E02\u0E21",
            [
              42e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E42\u0E1B\u0E48\u0E07",
            [
              42e3
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E2A\u0E27\u0E22",
            [
              42e3
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E2B\u0E21\u0E32\u0E19",
            [
              42e3
            ]
          ],
          [
            "\u0E28\u0E23\u0E35\u0E2A\u0E2D\u0E07\u0E23\u0E31\u0E01",
            [
              42100
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              42e3
            ]
          ],
          [
            "\u0E40\u0E2A\u0E35\u0E49\u0E22\u0E27",
            [
              42e3
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E2D\u0E23\u0E32\u0E27\u0E31\u0E13",
        [
          [
            "\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C\u0E44\u0E1E\u0E27\u0E31\u0E25\u0E22\u0E4C",
            [
              42220
            ]
          ],
          [
            "\u0E1C\u0E32\u0E2A\u0E32\u0E21\u0E22\u0E2D\u0E14",
            [
              42220
            ]
          ],
          [
            "\u0E1C\u0E32\u0E2D\u0E34\u0E19\u0E17\u0E23\u0E4C\u0E41\u0E1B\u0E25\u0E07",
            [
              42220
            ]
          ],
          [
            "\u0E40\u0E2D\u0E23\u0E32\u0E27\u0E31\u0E13",
            [
              42220
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E41\u0E1E\u0E23\u0E48",
    [
      [
        "\u0E23\u0E49\u0E2D\u0E07\u0E01\u0E27\u0E32\u0E07",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E28\u0E23\u0E35",
            [
              54140
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E40\u0E25\u0E32",
            [
              54140
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              54140
            ]
          ],
          [
            "\u0E23\u0E49\u0E2D\u0E07\u0E01\u0E27\u0E32\u0E07",
            [
              54140
            ]
          ],
          [
            "\u0E23\u0E49\u0E2D\u0E07\u0E40\u0E02\u0E47\u0E21",
            [
              54140
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E42\u0E23\u0E07",
            [
              54140
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E17\u0E23\u0E32\u0E22",
            [
              54140
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E22\u0E32\u0E07\u0E15\u0E32\u0E25",
            [
              54140
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E22\u0E32\u0E07\u0E23\u0E49\u0E2D\u0E07",
            [
              54140
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E22\u0E32\u0E07\u0E2E\u0E48\u0E2D",
            [
              54140
            ]
          ],
          [
            "\u0E44\u0E1C\u0E48\u0E42\u0E17\u0E19",
            [
              54140
            ]
          ]
        ]
      ],
      [
        "\u0E25\u0E2D\u0E07",
        [
          [
            "\u0E15\u0E49\u0E32\u0E1C\u0E32\u0E21\u0E2D\u0E01",
            [
              54150
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E41\u0E25\u0E49\u0E07",
            [
              54150
            ]
          ],
          [
            "\u0E1A\u0E48\u0E2D\u0E40\u0E2B\u0E25\u0E47\u0E01\u0E25\u0E2D\u0E07",
            [
              54150
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1B\u0E34\u0E19",
            [
              54150
            ]
          ],
          [
            "\u0E1B\u0E32\u0E01\u0E01\u0E32\u0E07",
            [
              54150
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E17\u0E38\u0E48\u0E07",
            [
              54150
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E2D\u0E49\u0E2D",
            [
              54150
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E15\u0E49\u0E32",
            [
              54150
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E1B\u0E32\u0E19",
            [
              54150
            ]
          ]
        ]
      ],
      [
        "\u0E27\u0E31\u0E07\u0E0A\u0E34\u0E49\u0E19",
        [
          [
            "\u0E19\u0E32\u0E1E\u0E39\u0E19",
            [
              54160
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E2A\u0E31\u0E01",
            [
              54160
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E0A\u0E34\u0E49\u0E19",
            [
              54160
            ]
          ],
          [
            "\u0E2A\u0E23\u0E2D\u0E22",
            [
              54160
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E1B\u0E49\u0E32\u0E01",
            [
              54160
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E1E\u0E38\u0E07",
            [
              54160
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E40\u0E01\u0E34\u0E4B\u0E07",
            [
              54160
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E2D\u0E07",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E19\u0E49\u0E32\u0E27",
            [
              54120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E25\u0E32\u0E07",
            [
              54120
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E2B\u0E19\u0E38\u0E19",
            [
              54120
            ]
          ],
          [
            "\u0E2A\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E1A",
            [
              54120
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E40\u0E21\u0E37\u0E2D\u0E07",
            [
              54120
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E2B\u0E21\u0E49\u0E32\u0E22",
            [
              54120
            ]
          ],
          [
            "\u0E40\u0E15\u0E32\u0E1B\u0E39\u0E19",
            [
              54120
            ]
          ],
          [
            "\u0E41\u0E14\u0E19\u0E0A\u0E38\u0E21\u0E1E\u0E25",
            [
              54120
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E39\u0E07\u0E40\u0E21\u0E48\u0E19",
        [
          [
            "\u0E14\u0E2D\u0E19\u0E21\u0E39\u0E25",
            [
              54130
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E0A\u0E33",
            [
              54130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E27\u0E32\u0E07",
            [
              54130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E32\u0E28",
            [
              54130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E1B\u0E07",
            [
              54130
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E40\u0E2B\u0E25\u0E48\u0E32",
            [
              54130
            ]
          ],
          [
            "\u0E1E\u0E23\u0E30\u0E2B\u0E25\u0E27\u0E07",
            [
              54130
            ]
          ],
          [
            "\u0E23\u0E48\u0E2D\u0E07\u0E01\u0E32\u0E28",
            [
              54130
            ]
          ],
          [
            "\u0E2A\u0E1A\u0E2A\u0E32\u0E22",
            [
              54130
            ]
          ],
          [
            "\u0E2A\u0E39\u0E07\u0E40\u0E21\u0E48\u0E19",
            [
              54130
            ]
          ],
          [
            "\u0E2B\u0E31\u0E27\u0E1D\u0E32\u0E22",
            [
              54130
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E17\u0E2D\u0E07",
            [
              54e3
            ]
          ]
        ]
      ],
      [
        "\u0E2B\u0E19\u0E2D\u0E07\u0E21\u0E48\u0E27\u0E07\u0E44\u0E02\u0E48",
        [
          [
            "\u0E15\u0E33\u0E2B\u0E19\u0E31\u0E01\u0E18\u0E23\u0E23\u0E21",
            [
              54170
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E41\u0E04\u0E49\u0E27",
            [
              54170
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E23\u0E31\u0E14",
            [
              54170
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2B\u0E25\u0E27\u0E07",
            [
              54170
            ]
          ],
          [
            "\u0E2B\u0E19\u0E2D\u0E07\u0E21\u0E48\u0E27\u0E07\u0E44\u0E02\u0E48",
            [
              54170
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E04\u0E33\u0E21\u0E35",
            [
              54170
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E14\u0E48\u0E19\u0E0A\u0E31\u0E22",
        [
          [
            "\u0E1B\u0E07\u0E1B\u0E48\u0E32\u0E2B\u0E27\u0E32\u0E22",
            [
              54110
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E44\u0E23\u0E48",
            [
              54110
            ]
          ],
          [
            "\u0E40\u0E14\u0E48\u0E19\u0E0A\u0E31\u0E22",
            [
              54110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E08\u0E31\u0E4A\u0E27\u0E30",
            [
              54110
            ]
          ],
          [
            "\u0E44\u0E17\u0E23\u0E22\u0E49\u0E2D\u0E22",
            [
              54110
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E41\u0E1E\u0E23\u0E48",
        [
          [
            "\u0E01\u0E32\u0E0D\u0E08\u0E19\u0E32",
            [
              54e3
            ]
          ],
          [
            "\u0E0A\u0E48\u0E2D\u0E41\u0E2E",
            [
              54e3
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E01\u0E27\u0E32\u0E27",
            [
              54e3
            ]
          ],
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E42\u0E2E\u0E49\u0E07",
            [
              54e3
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E02\u0E49\u0E32\u0E21",
            [
              54e3
            ]
          ],
          [
            "\u0E19\u0E32\u0E08\u0E31\u0E01\u0E23",
            [
              54e3
            ]
          ],
          [
            "\u0E19\u0E49\u0E33\u0E0A\u0E33",
            [
              54e3
            ]
          ],
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E16\u0E34\u0E48\u0E19",
            [
              54e3
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E41\u0E14\u0E07",
            [
              54e3
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E41\u0E21\u0E15",
            [
              54e3
            ]
          ],
          [
            "\u0E23\u0E48\u0E2D\u0E07\u0E1F\u0E2D\u0E07",
            [
              54e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E18\u0E07",
            [
              54e3
            ]
          ],
          [
            "\u0E27\u0E31\u0E07\u0E2B\u0E07\u0E29\u0E4C",
            [
              54e3
            ]
          ],
          [
            "\u0E2A\u0E27\u0E19\u0E40\u0E02\u0E37\u0E48\u0E2D\u0E19",
            [
              54e3
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E21\u0E49\u0E32",
            [
              54e3
            ]
          ],
          [
            "\u0E40\u0E2B\u0E21\u0E37\u0E2D\u0E07\u0E2B\u0E21\u0E49\u0E2D",
            [
              54e3
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E04\u0E33\u0E21\u0E35",
            [
              54e3
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E22\u0E21",
            [
              54e3
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2B\u0E25\u0E48\u0E32\u0E22",
            [
              54e3
            ]
          ],
          [
            "\u0E43\u0E19\u0E40\u0E27\u0E35\u0E22\u0E07",
            [
              54e3
            ]
          ]
        ]
      ]
    ]
  ],
  [
    "\u0E41\u0E21\u0E48\u0E2E\u0E48\u0E2D\u0E07\u0E2A\u0E2D\u0E19",
    [
      [
        "\u0E02\u0E38\u0E19\u0E22\u0E27\u0E21",
        [
          [
            "\u0E02\u0E38\u0E19\u0E22\u0E27\u0E21",
            [
              58140
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E1B\u0E2D\u0E19",
            [
              58140
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E01\u0E34\u0E4A",
            [
              58140
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E22\u0E27\u0E21\u0E19\u0E49\u0E2D\u0E22",
            [
              58140
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2D\u0E39\u0E04\u0E2D",
            [
              58140
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E40\u0E07\u0E32",
            [
              58140
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E32\u0E07\u0E21\u0E30\u0E1C\u0E49\u0E32",
        [
          [
            "\u0E16\u0E49\u0E33\u0E25\u0E2D\u0E14",
            [
              58150
            ]
          ],
          [
            "\u0E19\u0E32\u0E1B\u0E39\u0E48\u0E1B\u0E49\u0E2D\u0E21",
            [
              58150
            ]
          ],
          [
            "\u0E1B\u0E32\u0E07\u0E21\u0E30\u0E1C\u0E49\u0E32",
            [
              58150
            ]
          ],
          [
            "\u0E2A\u0E1A\u0E1B\u0E48\u0E2D\u0E07",
            [
              58150
            ]
          ]
        ]
      ],
      [
        "\u0E1B\u0E32\u0E22",
        [
          [
            "\u0E17\u0E38\u0E48\u0E07\u0E22\u0E32\u0E27",
            [
              58130
            ]
          ],
          [
            "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E41\u0E1B\u0E07",
            [
              58130
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E40\u0E2B\u0E19\u0E37\u0E2D",
            [
              58130
            ]
          ],
          [
            "\u0E40\u0E27\u0E35\u0E22\u0E07\u0E43\u0E15\u0E49",
            [
              58130
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E19\u0E32\u0E40\u0E15\u0E34\u0E07",
            [
              58130
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2E\u0E35\u0E49",
            [
              58130
            ]
          ],
          [
            "\u0E42\u0E1B\u0E48\u0E07\u0E2A\u0E32",
            [
              58130
            ]
          ]
        ]
      ],
      [
        "\u0E2A\u0E1A\u0E40\u0E21\u0E22",
        [
          [
            "\u0E01\u0E2D\u0E07\u0E01\u0E4B\u0E2D\u0E22",
            [
              58110
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E42\u0E1B\u0E07",
            [
              58110
            ]
          ],
          [
            "\u0E2A\u0E1A\u0E40\u0E21\u0E22",
            [
              58110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E04\u0E30\u0E15\u0E27\u0E19",
            [
              58110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E27\u0E14",
            [
              58110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E41\u0E25\u0E1A",
            [
              58110
            ]
          ]
        ]
      ],
      [
        "\u0E40\u0E21\u0E37\u0E2D\u0E07\u0E41\u0E21\u0E48\u0E2E\u0E48\u0E2D\u0E07\u0E2A\u0E2D\u0E19",
        [
          [
            "\u0E08\u0E2D\u0E07\u0E04\u0E33",
            [
              58e3
            ]
          ],
          [
            "\u0E1B\u0E32\u0E07\u0E2B\u0E21\u0E39",
            [
              58e3
            ]
          ],
          [
            "\u0E1C\u0E32\u0E1A\u0E48\u0E2D\u0E07",
            [
              58e3
            ]
          ],
          [
            "\u0E2B\u0E21\u0E2D\u0E01\u0E08\u0E33\u0E41\u0E1B\u0E48",
            [
              58e3
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E1B\u0E39\u0E25\u0E34\u0E07",
            [
              58e3
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E1C\u0E32",
            [
              58e3
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E42\u0E1B\u0E48\u0E07",
            [
              58e3
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E25\u0E32\u0E19\u0E49\u0E2D\u0E22",
        [
          [
            "\u0E02\u0E38\u0E19\u0E41\u0E21\u0E48\u0E25\u0E32\u0E19\u0E49\u0E2D\u0E22",
            [
              58120
            ]
          ],
          [
            "\u0E17\u0E48\u0E32\u0E1C\u0E32\u0E1B\u0E38\u0E49\u0E21",
            [
              58120
            ]
          ],
          [
            "\u0E2A\u0E31\u0E19\u0E15\u0E34\u0E04\u0E35\u0E23\u0E35",
            [
              58120
            ]
          ],
          [
            "\u0E2B\u0E49\u0E27\u0E22\u0E2B\u0E49\u0E2D\u0E21",
            [
              58120
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E19\u0E32\u0E08\u0E32\u0E07",
            [
              58120
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E25\u0E32\u0E19\u0E49\u0E2D\u0E22",
            [
              58120
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E25\u0E32\u0E2B\u0E25\u0E27\u0E07",
            [
              58120
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E42\u0E16",
            [
              58120
            ]
          ]
        ]
      ],
      [
        "\u0E41\u0E21\u0E48\u0E2A\u0E30\u0E40\u0E23\u0E35\u0E22\u0E07",
        [
          [
            "\u0E1A\u0E49\u0E32\u0E19\u0E01\u0E32\u0E28",
            [
              58110
            ]
          ],
          [
            "\u0E1B\u0E48\u0E32\u0E41\u0E1B\u0E4B",
            [
              58110
            ]
          ],
          [
            "\u0E40\u0E2A\u0E32\u0E2B\u0E34\u0E19",
            [
              58110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E04\u0E07",
            [
              58110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E22\u0E27\u0E21",
            [
              58110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E2A\u0E30\u0E40\u0E23\u0E35\u0E22\u0E07",
            [
              58110
            ]
          ],
          [
            "\u0E41\u0E21\u0E48\u0E40\u0E2B\u0E32\u0E30",
            [
              58110
            ]
          ]
        ]
      ]
    ]
  ]
];
const preprocess = (data2) => {
  if (!data2[0].length) {
    return data2;
  }
  const expanded = [];
  data2.forEach((provinceEntry) => {
    const province = provinceEntry[0];
    const amphurList = provinceEntry[1];
    amphurList.forEach((amphurEntry) => {
      const amphur = amphurEntry[0];
      const districtList = amphurEntry[1];
      districtList.forEach((districtEntry) => {
        const district = districtEntry[0];
        const zipCodeList = districtEntry[1];
        zipCodeList.forEach((zipCode) => {
          var _a2;
          expanded.push({
            d: district,
            a: amphur,
            p: province,
            z: (_a2 = zipCode == null ? void 0 : zipCode.toString) == null ? void 0 : _a2.call(zipCode)
          });
        });
      });
    });
  });
  return expanded;
};
const processedData = preprocess(thailandAddressData);
const DB = new JQL(processedData);
const fieldsEnum = {
  DISTRICT: "d",
  AMPHOE: "a",
  PROVINCE: "p",
  ZIPCODE: "z"
};
const resolveAddressesByField = (type, searchStr, limit) => {
  try {
    const addresses = DB.select("*").where(type).match(`^${searchStr}`).limit(limit).fetch();
    return Object.values(addresses);
  } catch (e2) {
    return [];
  }
};
const MAXIMUM_DISPLAY_SUGGESTION_ITEMS = 20;
const searchAddresses = (search) => {
  if (!search) {
    return [];
  }
  const addresses = Object.values(fieldsEnum).flatMap((field) => resolveAddressesByField(field, search, MAXIMUM_DISPLAY_SUGGESTION_ITEMS));
  return addresses;
};
function AutoCompleteAddressForm({
  name,
  type,
  format: format2,
  primaryLabel,
  placeholder = "",
  subDistrictFieldName = "subDistrict",
  districtFieldName = "district",
  provinceFieldName = "province",
  postalCodeFieldName = "postalCode"
}) {
  const context = useFormContext();
  const {
    t: t2
  } = useTranslation();
  const {
    isDirty
  } = context.formState;
  const search = context.watch(name);
  const [suggestedAddresses, setSuggestedAddresses] = useState([]);
  const autoSuggestRef = useRef(null);
  useClickAway(() => {
    setSuggestedAddresses([]);
  }, autoSuggestRef);
  useEffect(() => {
    const addresses = searchAddresses(search);
    setSuggestedAddresses(addresses);
  }, [search]);
  const handleClick = (address) => {
    context.reset(__spreadProps(__spreadValues({}, context.getValues()), {
      [subDistrictFieldName]: address.d,
      [districtFieldName]: address.a,
      [provinceFieldName]: address.p,
      [postalCodeFieldName]: address.z
    }));
    setSuggestedAddresses([]);
  };
  const isShowAutoSuggest = searchAddresses.length > 0 && isDirty;
  return /* @__PURE__ */ jsxs("div", {
    children: [["number", "postalCode"].includes(type || "") ? /* @__PURE__ */ jsx$1(FormNumberFormatInput, {
      name,
      format: format2,
      primaryLabel,
      placeholder,
      isUseTranslation: true
    }) : /* @__PURE__ */ jsx$1(FormTextField, {
      name,
      primaryLabel,
      placeholder,
      isUseTranslation: true
    }), isShowAutoSuggest && /* @__PURE__ */ jsx$1("div", {
      ref: autoSuggestRef,
      className: "tw-absolute tw-bg-white",
      children: /* @__PURE__ */ jsx$1(Elevation, {
        type: ElevationShadowType.SMALL,
        className: "tw-overflow-hidden",
        children: /* @__PURE__ */ jsx$1("ul", {
          children: suggestedAddresses.map((address) => /* @__PURE__ */ jsx$1("li", {
            children: /* @__PURE__ */ jsxs("div", {
              className: "tw-p-4 hover:tw-text-white hover:tw-bg-primary-400 tw-transition-all tw-cursor-pointer tw-select-none",
              onClick: () => handleClick(address),
              children: [`${address.d} \xBB ${address.a} \xBB ${address.p} \xBB `, address.z || /* @__PURE__ */ jsx$1("span", {
                children: t2("autoSuggest.NoPostalCode")
              })]
            })
          }, `SuggestionItem${address.a}${address.d}${address.p}${address.z}`))
        })
      })
    })]
  });
}
const schema = create({
  name: create$2().required("planUpgrade.billingAddressForm.validation.name.required"),
  address: create$2().required("planUpgrade.billingAddressForm.validation.address.required"),
  email: create$2().email("planUpgrade.billingAddressForm.validation.email.email").required("planUpgrade.billingAddressForm.validation.email.required"),
  taxId: create$2().required("planUpgrade.billingAddressForm.validation.taxId.required").length(13, "planUpgrade.billingAddressForm.validation.taxId.length"),
  phoneNumber: create$2().required("planUpgrade.billingAddressForm.validation.phoneNumber.required").length(10, "planUpgrade.billingAddressForm.validation.phoneNumber.required"),
  documentVerificationCertificatePath: create$2().optional(),
  type: create$2().oneOf(["PERSONAL", "COMPANY"]),
  contactPerson: create$2().optional(),
  subDistrict: create$2().required("planUpgrade.billingAddressForm.validation.subDistrict.required"),
  district: create$2().required("planUpgrade.billingAddressForm.validation.district.required"),
  province: create$2().required("planUpgrade.billingAddressForm.validation.province.required"),
  postalCode: create$2().length(5, "planUpgrade.billingAddressForm.validation.postalCode.length").required("planUpgrade.billingAddressForm.validation.postalCode.required"),
  titleName: create$2().optional().when("type", {
    is: true,
    then: create$2().required("planUpgrade.billingAddressForm.validation.titleName.required")
  })
});
const formNames = getFormNamesFromSchema(schema);
function BillingAddressForm({
  onSubmit,
  onCancel,
  data: data2,
  projectId
}) {
  const methods = useForm({
    resolver: o(schema)
  });
  const {
    reset
  } = methods;
  const {
    t: t2
  } = useTranslation();
  const titleOptions = [{
    label: t2("planUpgrade.billingAddressForm.mr"),
    value: "MR",
    key: "MR"
  }, {
    label: t2("planUpgrade.billingAddressForm.mrs"),
    value: "MRS",
    key: "MRS"
  }, {
    label: t2("planUpgrade.billingAddressForm.miss"),
    value: "MISS",
    key: "MISS"
  }].map(({
    label,
    value,
    key
  }) => ({
    label,
    value,
    key
  }));
  useEffect(() => {
    if (!data2) {
      return;
    }
    const newData = __spreadValues(__spreadValues({}, data2), !data2.type && {
      type: "PERSONAL"
    });
    reset(newData);
  }, [data2, reset]);
  const isCorporate = methods.watch("type") === "COMPANY";
  const {
    uploadImage
  } = useUploadImage();
  return /* @__PURE__ */ jsxs(Form, __spreadProps(__spreadValues({}, methods), {
    onSubmit: methods.handleSubmit(onSubmit),
    children: [/* @__PURE__ */ jsx$1(Controller, {
      name: formNames.type,
      control: methods.control,
      defaultValue: "PERSONAL",
      render: ({
        field
      }) => /* @__PURE__ */ jsxs(Tabs, {
        children: [/* @__PURE__ */ jsx$1(Tab$2, {
          name: field.name,
          value: "PERSONAL",
          checked: field.value === "PERSONAL",
          onChange: field.onChange,
          children: t2("planUpgrade.billingAddressForm.personal")
        }), /* @__PURE__ */ jsx$1("div", {
          className: "tw-w-2"
        }), /* @__PURE__ */ jsx$1(Tab$2, {
          name: field.name,
          value: "COMPANY",
          checked: field.value === "COMPANY",
          onChange: field.onChange,
          children: t2("planUpgrade.billingAddressForm.corporate")
        })]
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-mt-9",
      children: [/* @__PURE__ */ jsx$1(Typography, {
        variant: "title-9",
        className: "tw-mb-4 tw-text-Gray-600",
        children: isCorporate ? t2("planUpgrade.billingAddressForm.corporateDocumentVerificationCertificateLabel") : t2("planUpgrade.billingAddressForm.documentVerificationCertificateLabel")
      }), /* @__PURE__ */ jsx$1(Controller, {
        name: formNames.documentVerificationCertificatePath,
        control: methods.control,
        defaultValue: "",
        render: ({
          field
        }) => {
          var _a2, _b;
          return /* @__PURE__ */ jsxs("div", {
            children: [/* @__PURE__ */ jsx$1(ImageUploader, {
              onDrop: async (files) => {
                const file = files == null ? void 0 : files[0];
                try {
                  const {
                    publicUrl
                  } = await uploadImage(projectId, file);
                  notifySuccess(t2("planUpgrade.billingAddressForm.uploadImageSuccess"));
                  field.onChange(publicUrl);
                } catch (error2) {
                  notifyError(t2("planUpgrade.billingAddressForm.uploadImageError"));
                }
              },
              onRemove: () => {
                field.onChange(null);
              },
              image: field.value,
              label: isCorporate ? t2("planUpgrade.billingAddressForm.corporateDocumentVerificationCertificatePlaceholder") : t2("planUpgrade.billingAddressForm.documentVerificationCertificatePlaceholder")
            }), ((_a2 = methods.formState.errors.documentVerificationCertificatePath) == null ? void 0 : _a2.message) && /* @__PURE__ */ jsx$1(Typography, {
              variant: "title-9",
              color: COLORS.red[500],
              children: t2((_b = methods.formState.errors.documentVerificationCertificatePath) == null ? void 0 : _b.message)
            })]
          });
        }
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-mt-9",
      children: [/* @__PURE__ */ jsx$1(Typography, {
        variant: "title-9",
        className: "tw-w-full tw-text-Gray-600",
        children: isCorporate ? t2("planUpgrade.billingAddressForm.corporateNameLabel") : t2("planUpgrade.billingAddressForm.nameLabel")
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-mt-1 tw-w-full",
        children: [!isCorporate && /* @__PURE__ */ jsx$1(Controller, {
          name: formNames.titleName,
          control: methods.control,
          defaultValue: titleOptions[0].value,
          render: ({
            field
          }) => /* @__PURE__ */ jsx$1(Select, {
            options: titleOptions,
            value: titleOptions.find(({
              key
            }) => key === field.value),
            className: "tw-mr-2 tw-min-w-[120px]",
            placeholder: t2("planUpgrade.billingAddressForm.selectPlaceholder"),
            onChange: (singleValue) => {
              const {
                value
              } = singleValue;
              field.onChange(value);
            }
          })
        }), /* @__PURE__ */ jsx$1("div", {
          className: "tw-w-full",
          children: /* @__PURE__ */ jsx$1(FormTextField, {
            name: formNames.name,
            placeholder: isCorporate ? t2("planUpgrade.billingAddressForm.corporateNamePlaceholder") : t2("planUpgrade.billingAddressForm.namePlaceholder"),
            isUseTranslation: true
          })
        })]
      })]
    }), /* @__PURE__ */ jsx$1("div", {
      className: "tw-mt-9",
      children: /* @__PURE__ */ jsx$1(FormTextField, {
        name: formNames.address,
        primaryLabel: isCorporate ? t2("planUpgrade.billingAddressForm.corporateAddressLabel") : t2("planUpgrade.billingAddressForm.addressLabel"),
        isUseTranslation: true,
        placeholder: t2("planUpgrade.billingAddressForm.addressPlaceholder")
      })
    }), /* @__PURE__ */ jsx$1("div", {
      className: "tw-mt-9",
      children: /* @__PURE__ */ jsx$1(AutoCompleteAddressForm, {
        name: formNames.postalCode,
        primaryLabel: t2("planUpgrade.billingAddressForm.postalCodeLabel"),
        placeholder: t2("planUpgrade.billingAddressForm.postalCodePlaceholder"),
        type: "postalCode",
        format: "#####",
        subDistrictFieldName: formNames.subDistrict,
        districtFieldName: formNames.district,
        provinceFieldName: formNames.province,
        postalCodeFieldName: formNames.postalCode
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-mt-9 tw-w-full",
      children: [/* @__PURE__ */ jsx$1("div", {
        className: "tw-mr-2 tw-w-1/2",
        children: /* @__PURE__ */ jsx$1(FormTextField, {
          name: formNames.subDistrict,
          isUseTranslation: true,
          primaryLabel: t2("planUpgrade.billingAddressForm.subDistrictLabel")
        })
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-w-1/2",
        children: /* @__PURE__ */ jsx$1(FormTextField, {
          name: formNames.district,
          isUseTranslation: true,
          primaryLabel: t2("planUpgrade.billingAddressForm.districtLabel")
        })
      })]
    }), /* @__PURE__ */ jsx$1("div", {
      className: "tw-mt-9",
      children: /* @__PURE__ */ jsx$1(FormTextField, {
        name: formNames.province,
        isUseTranslation: true,
        primaryLabel: t2("planUpgrade.billingAddressForm.provinceLabel")
      })
    }), /* @__PURE__ */ jsx$1("div", {
      className: "tw-mt-9",
      children: /* @__PURE__ */ jsx$1(FormNumberFormatInput, {
        name: formNames.taxId,
        primaryLabel: t2("planUpgrade.billingAddressForm.taxIdLabel"),
        placeholder: t2("planUpgrade.billingAddressForm.taxIdPlaceholder"),
        format: "#############",
        isUseTranslation: true,
        mask: ""
      })
    }), /* @__PURE__ */ jsx$1("div", {
      className: "tw-mt-9",
      children: /* @__PURE__ */ jsx$1(FormTextField, {
        name: formNames.contactPerson,
        primaryLabel: t2("planUpgrade.billingAddressForm.contactPersonLabel"),
        placeholder: t2("planUpgrade.billingAddressForm.contactPersonPlaceholder"),
        isUseTranslation: true
      })
    }), /* @__PURE__ */ jsx$1("div", {
      className: "tw-mt-9",
      children: /* @__PURE__ */ jsx$1(FormNumberFormatInput, {
        name: formNames.phoneNumber,
        primaryLabel: t2("planUpgrade.billingAddressForm.phoneNumberLabel"),
        placeholder: t2("planUpgrade.billingAddressForm.phoneNumberPlaceholder"),
        format: "##########",
        mask: "",
        isUseTranslation: true
      })
    }), /* @__PURE__ */ jsx$1("div", {
      className: "tw-mt-9",
      children: /* @__PURE__ */ jsx$1(FormTextField, {
        name: formNames.email,
        primaryLabel: t2("planUpgrade.billingAddressForm.emailLabel"),
        placeholder: t2("planUpgrade.billingAddressForm.emailPlaceholder"),
        isUseTranslation: true
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-justify-end tw-mt-9",
      children: [/* @__PURE__ */ jsx$1(Button, {
        variant: "text",
        className: "tw-mr-1",
        onClick: onCancel,
        children: t2("planUpgrade.billingAddressForm.cancel")
      }), /* @__PURE__ */ jsx$1(Button, {
        type: "submit",
        disabled: !!Object.keys(methods.formState.errors).length,
        children: t2("planUpgrade.billingAddressForm.submit")
      })]
    })]
  }));
}
function BillingAddressSection({
  title,
  isExpand,
  isSuccessful,
  onClick: onClick2,
  stepNo,
  projectId,
  onSuccessful
}) {
  const {
    t: t2
  } = useTranslation();
  const {
    upsertBilling,
    billingData
  } = useBilling(projectId);
  const billing = billingData == null ? void 0 : billingData.billing;
  const billingId = billing == null ? void 0 : billing.id;
  const isVerified = billing == null ? void 0 : billing.isVerified;
  const handleSubmitBillingAddress = useCallback(async (data2) => {
    try {
      await upsertBilling(__spreadProps(__spreadValues({}, billingId && {
        id: billingId
      }), {
        name: data2.name,
        address: data2.address,
        email: data2.email,
        taxId: data2.taxId || "",
        phoneNumber: data2.phoneNumber,
        documentVerificationCertificatePath: data2.documentVerificationCertificatePath || "",
        contactPerson: data2.contactPerson || "",
        type: data2.type || "",
        subDistrict: data2.subDistrict,
        district: data2.district || "",
        province: data2.province,
        postalCode: data2.postalCode || "",
        titleName: data2.titleName || "",
        isVerified
      }));
      notifySuccess(t2("planUpgrade.billingAddressSection.submitBillingAddressSuccess"));
      onSuccessful(stepNo);
    } catch (error2) {
      notifyError(t2("planUpgrade.billingAddressSection.submitBillingAddressError"));
    }
  }, [billingId, isVerified, onSuccessful, stepNo, upsertBilling, t2]);
  const handleCancel = () => {
    onClick2(stepNo);
  };
  const formData = {
    name: (billing == null ? void 0 : billing.name) || "",
    address: (billing == null ? void 0 : billing.address) || "",
    email: (billing == null ? void 0 : billing.email) || "",
    taxId: (billing == null ? void 0 : billing.taxId) || "",
    phoneNumber: (billing == null ? void 0 : billing.phoneNumber) || "",
    documentVerificationCertificatePath: (billing == null ? void 0 : billing.documentVerificationCertificatePath) || "",
    contactPerson: (billing == null ? void 0 : billing.contactPerson) || "",
    type: (billing == null ? void 0 : billing.type) || "",
    subDistrict: (billing == null ? void 0 : billing.subDistrict) || "",
    district: (billing == null ? void 0 : billing.district) || "",
    province: (billing == null ? void 0 : billing.province) || "",
    postalCode: (billing == null ? void 0 : billing.postalCode) || "",
    titleName: (billing == null ? void 0 : billing.titleName) || ""
  };
  useEffect(() => {
    if (billingId) {
      onSuccessful(stepNo);
    }
  }, [billingId, onSuccessful, stepNo]);
  return /* @__PURE__ */ jsx$1(CustomExpand, {
    title,
    isExpand,
    isSuccessful,
    onClick: onClick2,
    stepNo,
    children: /* @__PURE__ */ jsx$1(BillingAddressForm, {
      data: formData,
      projectId,
      onSubmit: handleSubmitBillingAddress,
      onCancel: handleCancel
    })
  });
}
var BillingAddressSection$1 = memo(BillingAddressSection);
function PlanUpgrade({
  projectId,
  subscriptionType,
  onClickBack = () => {
  },
  gbPrimeUrl,
  gbPrimePublicKey,
  packageType,
  onClickTermAndCondition,
  onSuccess
}) {
  const [state, setState] = useState({
    1: {
      isSuccessful: false,
      isExpand: true
    },
    2: {
      isSuccessful: false,
      isExpand: true
    }
  });
  const {
    t: t2
  } = useTranslation();
  const handleClickExpand = useCallback((step) => {
    setState((prev2) => __spreadProps(__spreadValues({}, prev2), {
      [step]: __spreadProps(__spreadValues({}, prev2[step]), {
        isExpand: !prev2[step].isExpand
      })
    }));
  }, []);
  const handleSuccessful = useCallback((step) => {
    setState((prev2) => __spreadProps(__spreadValues({}, prev2), {
      [step]: {
        isExpand: false,
        isSuccessful: true
      }
    }));
  }, []);
  const isChangePackageDisabled = !state[1].isSuccessful || !state[2].isSuccessful;
  return /* @__PURE__ */ jsx$1("main", {
    className: "tw-min-h-screen tw-bg-Gray-100",
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-pt-8 tw-px-4 desktop:tw-px-[153px] tw-mx-auto tw-max-w-[1440px]",
      children: [/* @__PURE__ */ jsx$1(PageTitle, {
        onClickBack,
        title: t2("planUpgrade.title", {
          packageType: t2(`planUpgrade.packageType.${packageType}`)
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-flex-col tw-mt-12 desktop:tw-flex-row desktop:tw-items-start",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "desktop:tw-min-w-[702px]",
          children: [/* @__PURE__ */ jsx$1("section", {
            children: /* @__PURE__ */ jsx$1(PaymentSection$1, {
              projectId,
              isExpand: state[1].isExpand,
              isSuccessful: state[1].isSuccessful,
              stepNo: 1,
              title: t2("planUpgrade.firstStep"),
              onClick: handleClickExpand,
              onSuccessful: handleSuccessful,
              gbPrimePublicKey,
              gbPrimeUrl,
              onClickTermAndCondition
            })
          }), /* @__PURE__ */ jsx$1("section", {
            className: "tw-mt-6",
            children: /* @__PURE__ */ jsx$1(BillingAddressSection$1, {
              isExpand: state[2].isExpand,
              isSuccessful: state[2].isSuccessful,
              stepNo: 2,
              title: t2("planUpgrade.secondStep"),
              onClick: handleClickExpand,
              onSuccessful: handleSuccessful,
              projectId
            })
          })]
        }), /* @__PURE__ */ jsx$1("div", {
          className: "tw-top-0 tw-order-first tw-pb-4 desktop:tw-sticky desktop:tw-order-last desktop:tw-pb-0 desktop:tw-pl-6",
          children: /* @__PURE__ */ jsx$1(PaymentSummary$1, {
            projectId,
            subscriptionType,
            packageType,
            isChangePackageDisabled,
            onSuccess
          })
        })]
      })]
    })
  });
}
function PlanUpgradeWithContext(props) {
  return /* @__PURE__ */ jsx$1(ContextProviders, {
    children: /* @__PURE__ */ jsx$1(PlanUpgrade, __spreadValues({}, props))
  });
}
function Page(props) {
  return /* @__PURE__ */ jsx$1(ContextProviders, {
    children: /* @__PURE__ */ jsx$1(ProductForm, __spreadValues({}, props))
  });
}
function ThemeProvider({
  children: children2,
  theme = "deeple"
}) {
  const [currentTheme, setTheme] = useState(theme);
  useLayoutEffect(() => {
    const bodyElement = document.body;
    if (!bodyElement) {
      return;
    }
    const className = bodyElement.className.replace(/tw-theme-*/, "");
    bodyElement.setAttribute("class", `${className} tw-theme-${currentTheme}`);
  }, [currentTheme]);
  return /* @__PURE__ */ jsx$1(ThemeContext$1.Provider, {
    value: {
      theme: currentTheme,
      setTheme
    },
    children: children2
  });
}
const changeLanguage = (lang) => {
  void i18next.changeLanguage(lang);
};
function ButtonSyncDeeplePayStatus({
  onClick: onClick2,
  isLoading = false
}) {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx$1(Button, {
    variant: "primary",
    onClick: onClick2,
    isLoading,
    startIcon: /* @__PURE__ */ jsx$1(Icon, {
      name: IconName.REFRESH,
      size: IconSize.SMALL
    }),
    children: /* @__PURE__ */ jsx$1(Typography, {
      variant: "title-9",
      color: COLORS.White,
      children: t2("order.sectionOrderDetailDeeplePay.syncBtn")
    })
  });
}
function ModalSyncDeeplePayStatusSuccess({
  isOpen,
  onClose,
  amount,
  receiptNo
}) {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx$1(Modal, {
    isOpen,
    size: "small",
    onClose,
    isClickOverlayToClose: true,
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-p-6",
      children: [/* @__PURE__ */ jsx$1(Icon, {
        name: IconName.CIRCLE_CHECK_OUTLINE,
        size: IconSize.CUSTOM,
        width: 40,
        height: 40,
        className: "tw-text-Green-500"
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-2",
        className: "tw-mt-6 tw-text-center tw-text-Gray-800",
        children: t2("order.modalSyncDeeplePayStatusSuccess.title")
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-flex tw-flex-col tw-mt-6 tw-mb-8",
        children: [/* @__PURE__ */ jsxs(Typography, {
          variant: "body-3",
          className: "tw-text-center",
          color: COLORS.Gray[500],
          children: [t2("order.modalSyncDeeplePayStatusSuccess.amount"), " \u0E3F", convertPriceFormat(amount)]
        }), /* @__PURE__ */ jsxs(Typography, {
          variant: "body-3",
          className: "tw-text-center",
          color: COLORS.Gray[500],
          children: [t2("order.modalSyncDeeplePayStatusSuccess.receiptNo"), ": ", receiptNo]
        })]
      }), /* @__PURE__ */ jsx$1(Button, {
        variant: "primary",
        className: "tw-w-full",
        size: "large",
        onClick: onClose,
        children: t2("order.modalSyncDeeplePayStatusSuccess.submitBtn")
      })]
    })
  });
}
function ModalSyncDeeplePayStatusFailure({
  isOpen,
  onClose
}) {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx$1(Modal, {
    isOpen,
    size: "small",
    onClose,
    isClickOverlayToClose: true,
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-p-6",
      children: [/* @__PURE__ */ jsx$1(Icon, {
        name: IconName.CIRCLE_EXCLAMATION,
        size: IconSize.CUSTOM,
        width: 40,
        height: 40,
        className: "tw-text-Gray-400"
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-2",
        className: "tw-mt-6 tw-text-center tw-text-Gray-800",
        children: t2("order.modalSyncDeeplePayStatusFailure.title")
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-flex tw-flex-col tw-mt-6 tw-mb-8",
        children: /* @__PURE__ */ jsx$1(Typography, {
          variant: "body-3",
          className: "tw-text-center",
          color: COLORS.Gray[500],
          children: t2("order.modalSyncDeeplePayStatusFailure.description")
        })
      }), /* @__PURE__ */ jsx$1(Button, {
        variant: "primary",
        className: "tw-w-full",
        size: "large",
        onClick: onClose,
        children: t2("order.modalSyncDeeplePayStatusFailure.submitBtn")
      })]
    })
  });
}
function ModalNFTStoreSuccessfullyCreated({
  isOpen,
  onClose
}) {
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx$1(Modal, {
    isOpen,
    size: "small",
    onClose,
    isClickOverlayToClose: true,
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-p-6 tw-text-center",
      children: [/* @__PURE__ */ jsx$1("img", {
        src: NFT_STORE_SUCCESSFULLY_CREATED,
        alt: "successfully-created"
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "title-2",
        className: "tw-mt-4 tw-mb-12",
        children: t2("gettingStarted.modal.storeCreated.title")
      }), /* @__PURE__ */ jsx$1(Button, {
        className: "tw-w-full",
        size: "large",
        onClick: onClose,
        children: t2("gettingStarted.modal.storeCreated.done")
      })]
    })
  });
}
function ModalConnectGuideline({
  isOpen,
  lang = "th",
  onClose,
  onClickTutorial
}) {
  const {
    i18n,
    t: t2
  } = useTranslation();
  useEffect(() => {
    void i18n.changeLanguage(lang);
  }, [lang, i18n]);
  return /* @__PURE__ */ jsxs(Modal, {
    isOpen,
    size: "medium",
    children: [/* @__PURE__ */ jsx$1("img", {
      src: CONNECT_GUIDELINE,
      className: "tw-block tw-mx-auto tw-w-auto tw-h-[200px] tablet:tw-h-[250px]",
      alt: "Connect guideline"
    }), /* @__PURE__ */ jsx$1("h1", {
      className: "tw-mt-2 tw-text-2xl tw-font-medium tw-text-center tw-text-Gray-800 tablet:tw-mt-4 tablet:tw-text-[28px] tablet:tw-leading-10",
      children: t2("modalConnectGuideline.title")
    }), /* @__PURE__ */ jsx$1("p", {
      className: "tw-mt-4 tw-text-sm tw-font-medium tw-text-center tw-text-Gray-500 tw-whitespace-pre-line tablet:tw-mt-6 tablet:tw-text-base",
      children: t2("modalConnectGuideline.description")
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-mt-2 tablet:tw-mt-4",
      children: [/* @__PURE__ */ jsx$1("div", {
        className: "tw-mt-[4px] tw-w-4 tablet:tw-mt-[1px] tablet:tw-w-6",
        children: /* @__PURE__ */ jsx$1("img", {
          src: FACEBOOK_LOGO,
          className: "tw-block tw-w-4 tw-max-w-none tw-h-4 tablet:tw-w-6 tablet:tw-h-6",
          alt: "Facebook logo"
        })
      }), /* @__PURE__ */ jsx$1("p", {
        className: "tw-ml-2 tw-text-sm tw-font-normal tw-text-Gray-500 tablet:tw-text-base",
        children: t2("modalConnectGuideline.brand.facebook.content")
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-mt-2 tablet:tw-mt-4",
      children: [/* @__PURE__ */ jsx$1("div", {
        className: "tw-mt-[4px] tw-w-4 tablet:tw-mt-[1px] tablet:tw-w-6",
        children: /* @__PURE__ */ jsx$1("img", {
          src: INSTAGRAM_LOGO,
          className: "tw-block tw-w-4 tw-max-w-none tw-h-4 tablet:tw-w-6 tablet:tw-h-6",
          alt: "Instagram logo"
        })
      }), /* @__PURE__ */ jsx$1("p", {
        className: "tw-ml-2 tw-text-sm tw-font-normal tw-text-Gray-500 tablet:tw-text-base",
        children: t2("modalConnectGuideline.brand.instagram.content")
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-mt-2 tablet:tw-mt-4",
      children: [/* @__PURE__ */ jsx$1("div", {
        className: "tw-mt-[4px] tw-w-4 tablet:tw-mt-[1px] tablet:tw-w-6",
        children: /* @__PURE__ */ jsx$1("img", {
          src: LINE_LOGO,
          className: "tw-block tw-w-4 tw-max-w-none tw-h-4 tablet:tw-w-6 tablet:tw-h-6",
          alt: "Line logo"
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "tw-ml-2",
        children: [/* @__PURE__ */ jsx$1("p", {
          className: "tw-text-sm tw-font-normal tw-text-Gray-500 tablet:tw-text-base",
          children: t2("modalConnectGuideline.brand.line.content1")
        }), /* @__PURE__ */ jsxs("ul", {
          className: "tw-mt-2 tw-ml-8 tw-list-disc tablet:tw-mt-4",
          children: [/* @__PURE__ */ jsx$1("li", {
            className: "tw-text-sm tw-font-normal tw-text-Gray-500 tablet:tw-text-base",
            children: t2("modalConnectGuideline.brand.line.content2")
          }), /* @__PURE__ */ jsx$1("li", {
            className: "tw-text-sm tw-font-normal tw-text-Gray-500 tablet:tw-text-base",
            children: t2("modalConnectGuideline.brand.line.content3")
          })]
        }), /* @__PURE__ */ jsxs("p", {
          className: "tw-mt-2 tw-text-sm tw-font-normal tw-text-Gray-500 tablet:tw-mt-4 tablet:tw-text-base",
          children: [t2("modalConnectGuideline.brand.line.content4"), " ", /* @__PURE__ */ jsx$1("span", {
            className: "tw-inline-flex tw-text-Primary-400 tw-cursor-pointer",
            onClick: onClickTutorial,
            children: t2("modalConnectGuideline.brand.line.content5")
          })]
        })]
      })]
    }), /* @__PURE__ */ jsx$1(Button, {
      size: "fullWidth",
      className: "tw-mt-10",
      onClick: onClose,
      children: t2("modalConnectGuideline.done")
    })]
  });
}
var _jsx = require$$0.jsx;
var _jsxs = require$$0.jsxs;
const React = React__default;
function XCircleIcon(_T, svgRef) {
  var _U = _T, {
    title,
    titleId
  } = _U, props = __objRest(_U, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ _jsxs("svg", __spreadProps(__spreadValues({}, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props)), {
    children: [title ? /* @__PURE__ */ _jsx("title", {
      id: titleId,
      children: title
    }) : null, /* @__PURE__ */ _jsx("path", {
      fillRule: "evenodd",
      d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z",
      clipRule: "evenodd"
    })]
  }));
}
const ForwardRef = React.forwardRef(XCircleIcon);
var XCircleIcon_1 = ForwardRef;
var XCircleIcon$1 = XCircleIcon_1;
function ModalVideo({
  isOpen,
  onClose,
  title,
  embeddedVideo
}) {
  const iframeRef = useRef(null);
  const dialogRef = useRef(null);
  useClickAway(() => {
    onClose();
  }, dialogRef);
  if (!isOpen) {
    return null;
  }
  return reactDom.exports.createPortal(/* @__PURE__ */ jsx$1("div", {
    className: "web-console tw-fixed tw-top-0 tw-left-0 tw-z-[10000] tw-w-full tw-min-h-screen tw-bg-grayscale-700/70 tw-flex tw-justify-center tw-items-center tw-px-4",
    children: /* @__PURE__ */ jsxs("dialog", {
      open: isOpen,
      ref: dialogRef,
      className: "tw-bg-white tw-rounded-lg tw-max-w-[888px]",
      children: [/* @__PURE__ */ jsx$1("div", {
        className: "tw-flex tw-justify-end",
        children: /* @__PURE__ */ jsx$1("button", {
          className: "tw-w-[20px] tw-h-[20px]",
          type: "button",
          onClick: (e2) => {
            e2.stopPropagation();
            onClose();
          },
          children: /* @__PURE__ */ jsx$1(XCircleIcon$1, {
            className: "tw-fill-grayscale-300"
          })
        })
      }), /* @__PURE__ */ jsx$1(Typography, {
        variant: "heading-5",
        className: "tw-text-center",
        color: COLORS.grayscale[800],
        children: title
      }), /* @__PURE__ */ jsx$1("iframe", {
        ref: iframeRef,
        onLoad: () => {
          var _a2, _b, _c;
          (_c = (_b = (_a2 = iframeRef.current) == null ? void 0 : _a2.classList) == null ? void 0 : _b.remove) == null ? void 0 : _c.call(_b, "tw-bg-grayscale-400", "tw-animate-pulse", "tw-duration-100");
        },
        className: "tw-mt-4 tw-mb-2 tw-bg-grayscale-400 tw-animate-pulse tw-duration-100 tw-w-full tw-h-[188px] desktop:tw-h-[473px]",
        src: embeddedVideo,
        title,
        frameBorder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: true
      })]
    })
  }), document.body);
}
function ModalFacebookRecurringNotification(_V) {
  var _W = _V, {
    buttonComponent = null,
    size = "medium"
  } = _W, modalProps = __objRest(_W, [
    "buttonComponent",
    "size"
  ]);
  const {
    t: t2
  } = useTranslation();
  return /* @__PURE__ */ jsx$1(Modal, __spreadProps(__spreadValues({
    size
  }, modalProps), {
    children: /* @__PURE__ */ jsxs("div", {
      className: "tw-flex tw-flex-col tw-items-center tablet:tw-p-6",
      children: [/* @__PURE__ */ jsx$1("img", {
        src: FACEBOOK_RECURRING_NOTIFICATION_PATH,
        className: "tw-w-full tw-max-w-[326px]",
        alt: "cover"
      }), /* @__PURE__ */ jsx$1("h1", {
        className: "tw-mt-2 tw-text-grayscale-800 tw-text-2xl tw-font-sans tw-font-medium tw-leading-9 tw-text-center tablet:tw-mt-4 tablet:tw-text-[28px] tablet:tw-leading-10",
        dangerouslySetInnerHTML: {
          __html: t2("modalFacebookRecurringNotification.headingHtml")
        }
      }), /* @__PURE__ */ jsx$1("p", {
        className: "tw-mt-4 tw-text-grayscale-400 tw-text-sm tw-font-sans tw-font-normal tw-text-center tablet:tw-mt-6 tablet:tw-w-[512px] tablet:tw-text-base",
        children: t2("modalFacebookRecurringNotification.content")
      }), /* @__PURE__ */ jsx$1("div", {
        className: "tw-mt-6 tw-w-full tablet:tw-mt-10",
        children: buttonComponent
      })]
    })
  }));
}
const Components = {
  AIGuidelineModal,
  AdminModeWarningPopup,
  Alert,
  BannerNFT,
  ButtonSyncDeeplePayStatus,
  CardDeeplePayContactSupport,
  FacebookLiveAlert,
  Modal,
  ModalConnectGuideline,
  ModalFacebookRecurringNotification,
  ModalNFTStoreCreatedSuccessfully: ModalNFTStoreSuccessfullyCreated,
  ModalPaymentPreview,
  ModalPhoneNumber,
  ModalSyncDeeplePayStatusFailure,
  ModalSyncDeeplePayStatusSuccess,
  ModalVideo,
  PaymentGuidelineModal,
  PlanUpgrade: PlanUpgradeWithContext,
  QuickStartCard,
  Status,
  StepperBar,
  Typography
};
const Constants = {
  gtm
};
const Domains = {
  NotAllowThisFeatureModal,
  QuickStartBroadcastBar: QuickStartBroadcastBarWithContext,
  UpgradePlanSuccessModal
};
const Enums = {
  PaymentType
};
const Pages = {
  AddProduct,
  CashbackGettingStarted,
  Connect: Page$6,
  CreateStore: Page$5,
  PlanUpgrade: PlanUpgradeWithContext,
  Product: Page$4,
  ProductForm: Page$3,
  Shipping: Page$2,
  ShippingForm: Page$1,
  UpgradePlan,
  FormProduct: Page
};
const Providers = {
  ThemeProvider
};
const Utilities = {
  addGoogleTagEvent,
  addModalPhoneNumberStore,
  changeLanguage,
  hasModalPhoneNumberStore,
  removeModalPhoneNumberStore
};
export { Components, Constants, Domains, Enums, Pages, Providers, Utilities };
